/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(403);
	module.exports = __webpack_require__(182);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(33);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(17);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(323)();
	}


/***/ },
/* 5 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 6 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};


/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(193), __esModule: true };

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(117);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(184);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(183);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(59);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(59);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMProperty = __webpack_require__(40);
	var ReactDOMComponentFlags = __webpack_require__(150);
	
	var invariant = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(116);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 17 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ },
/* 19 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(83)('wks')
	  , uid        = __webpack_require__(61)
	  , Symbol     = __webpack_require__(26).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(148);
	var PooledClass = __webpack_require__(32);
	var ReactFeatureFlags = __webpack_require__(153);
	var ReactReconciler = __webpack_require__(43);
	var Transaction = __webpack_require__(68);
	
	var invariant = __webpack_require__(2);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(32);
	
	var emptyFunction = __webpack_require__(17);
	var warning = __webpack_require__(3);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 24 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(26)
	  , core      = __webpack_require__(19)
	  , ctx       = __webpack_require__(75)
	  , hide      = __webpack_require__(36)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 26 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(34)
	  , IE8_DOM_DEFINE = __webpack_require__(121)
	  , toPrimitive    = __webpack_require__(85)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(29) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(341);


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(35)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 30 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(122)
	  , defined = __webpack_require__(76);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 32 */
[436, 5],
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactChildren = __webpack_require__(410);
	var ReactComponent = __webpack_require__(112);
	var ReactPureComponent = __webpack_require__(415);
	var ReactClass = __webpack_require__(411);
	var ReactDOMFactories = __webpack_require__(412);
	var ReactElement = __webpack_require__(46);
	var ReactPropTypes = __webpack_require__(414);
	var ReactVersion = __webpack_require__(418);
	
	var onlyChild = __webpack_require__(422);
	var warning = __webpack_require__(3);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	// TODO: Fix tests so that this deprecation warning doesn't cause failures.
	if (false) {
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	  }
	}
	
	module.exports = React;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 35 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(27)
	  , createDesc = __webpack_require__(51);
	module.exports = __webpack_require__(29) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(127)
	  , enumBugKeys = __webpack_require__(77);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedValue;
	function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
	  if (keepUnprefixed) {
	    return [prefixedValue, value];
	  }
	  return prefixedValue;
	}
	module.exports = exports["default"];

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(96);
	var setInnerHTML = __webpack_require__(70);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(104);
	var setTextContent = __webpack_require__(164);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventPluginRegistry = __webpack_require__(97);
	var EventPluginUtils = __webpack_require__(65);
	var ReactErrorUtils = __webpack_require__(101);
	
	var accumulateInto = __webpack_require__(158);
	var forEachAccumulated = __webpack_require__(159);
	var invariant = __webpack_require__(2);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(41);
	var EventPluginUtils = __webpack_require__(65);
	
	var accumulateInto = __webpack_require__(158);
	var forEachAccumulated = __webpack_require__(159);
	var warning = __webpack_require__(3);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(364);
	var ReactInstrumentation = __webpack_require__(20);
	
	var warning = __webpack_require__(3);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(23);
	
	var getEventTarget = __webpack_require__(107);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _props2 = __webpack_require__(111);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEEK_ON_PLAY_EXPIRY = 5000;
	
	var Base = function (_Component) {
	  _inherits(Base, _Component);
	
	  function Base() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Base);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Base.__proto__ || Object.getPrototypeOf(Base)).call.apply(_ref, [this].concat(args))), _this), _this.isReady = false, _this.startOnPlay = true, _this.durationOnPlay = false, _this.seekOnPlay = null, _this.onPlay = function () {
	      var _this$props = _this.props,
	          volume = _this$props.volume,
	          onStart = _this$props.onStart,
	          onPlay = _this$props.onPlay,
	          onDuration = _this$props.onDuration,
	          playbackRate = _this$props.playbackRate;
	
	      if (_this.startOnPlay) {
	        _this.setPlaybackRate(playbackRate);
	        _this.setVolume(volume);
	        onStart();
	        _this.startOnPlay = false;
	      }
	      onPlay();
	      if (_this.seekOnPlay) {
	        _this.seekTo(_this.seekOnPlay);
	        _this.seekOnPlay = null;
	      }
	      if (_this.durationOnPlay) {
	        onDuration(_this.getDuration());
	        _this.durationOnPlay = false;
	      }
	    }, _this.onReady = function () {
	      var _this$props2 = _this.props,
	          onReady = _this$props2.onReady,
	          playing = _this$props2.playing,
	          onDuration = _this$props2.onDuration;
	
	      _this.isReady = true;
	      _this.loadingSDK = false;
	      onReady();
	      if (playing || _this.preloading) {
	        _this.preloading = false;
	        if (_this.loadOnReady) {
	          _this.load(_this.loadOnReady);
	          _this.loadOnReady = null;
	        } else {
	          _this.play();
	        }
	      }
	      var duration = _this.getDuration();
	      if (duration) {
	        onDuration(duration);
	      } else {
	        _this.durationOnPlay = true;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Base, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var url = this.props.url;
	
	      this.mounted = true;
	      if (url) {
	        this.load(url);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	      this.mounted = false;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          url = _props.url,
	          playing = _props.playing,
	          volume = _props.volume,
	          playbackRate = _props.playbackRate;
	      // Invoke player methods based on incoming props
	
	      if (url !== nextProps.url && nextProps.url) {
	        this.seekOnPlay = null;
	        this.startOnPlay = true;
	        this.load(nextProps.url);
	      } else if (url && !nextProps.url) {
	        this.stop();
	        clearTimeout(this.updateTimeout);
	      } else if (!playing && nextProps.playing) {
	        this.play();
	      } else if (playing && !nextProps.playing) {
	        this.pause();
	      } else if (volume !== nextProps.volume) {
	        this.setVolume(nextProps.volume);
	      } else if (playbackRate !== nextProps.playbackRate) {
	        this.setPlaybackRate(nextProps.playbackRate);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.url !== nextProps.url;
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      var _this2 = this;
	
	      // When seeking before player is ready, store value and seek later
	      if (!this.isReady && fraction !== 0) {
	        this.seekOnPlay = fraction;
	        setTimeout(function () {
	          _this2.seekOnPlay = null;
	        }, SEEK_ON_PLAY_EXPIRY);
	      }
	    }
	  }]);
	
	  return Base;
	}(_react.Component);
	
	Base.propTypes = _props2.propTypes;
	Base.defaultProps = _props2.defaultProps;
	exports['default'] = Base;
	module.exports = exports['default'];

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(24);
	
	var warning = __webpack_require__(3);
	var canDefineProperty = __webpack_require__(169);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(168);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 47 */
5,
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(76);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 54 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 55 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 56 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 57 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FlatButton = __webpack_require__(139);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _RaisedButton = __webpack_require__(141);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	__webpack_require__(233);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function ContinueFooter(props) {
	  var disableContinue = props.disableContinue,
	      continueLabel = props.continueLabel,
	      onContinue = props.onContinue,
	      showBack = props.showBack,
	      onBack = props.onBack,
	      disableBack = props.disableBack,
	      backLabel = props.backLabel,
	      stacked = props.stacked,
	      children = props.children;
	
	
	  return _react2.default.createElement(
	    'footer',
	    { className: 'ContinueFooter ' + (stacked && 'ContinueFooter--stacked') },
	    showBack && _react2.default.createElement(_FlatButton2.default, {
	      secondary: true,
	      label: backLabel,
	      disabled: disableBack,
	      onTouchTap: onBack
	    }),
	    children,
	    _react2.default.createElement(_RaisedButton2.default, {
	      primary: true,
	      label: continueLabel,
	      disabled: disableContinue,
	      onTouchTap: onContinue,
	      style: _defineProperty({}, stacked ? 'marginTop' : 'marginLeft', 16)
	    })
	  );
	}
	
	ContinueFooter.propTypes = {
	  onContinue: _propTypes2.default.func.isRequired,
	  onBack: _propTypes2.default.func,
	  continueLabel: _propTypes2.default.string,
	  disableContinue: _propTypes2.default.bool,
	  showBack: _propTypes2.default.bool,
	  disableBack: _propTypes2.default.bool,
	  stacked: _propTypes2.default.bool
	};
	
	ContinueFooter.defaultProps = {
	  continueLabel: 'Continue',
	  backLabel: 'Back',
	  disableContinue: false,
	  showBack: false,
	  disableBack: false,
	  stacked: false
	};
	
	exports.default = ContinueFooter;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(186);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(185);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 60 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 61 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SvgIcon = __webpack_require__(289);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SvgIcon2.default;

/***/ },
/* 63 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red50 = exports.red50 = '#ffebee';
	var red100 = exports.red100 = '#ffcdd2';
	var red200 = exports.red200 = '#ef9a9a';
	var red300 = exports.red300 = '#e57373';
	var red400 = exports.red400 = '#ef5350';
	var red500 = exports.red500 = '#f44336';
	var red600 = exports.red600 = '#e53935';
	var red700 = exports.red700 = '#d32f2f';
	var red800 = exports.red800 = '#c62828';
	var red900 = exports.red900 = '#b71c1c';
	var redA100 = exports.redA100 = '#ff8a80';
	var redA200 = exports.redA200 = '#ff5252';
	var redA400 = exports.redA400 = '#ff1744';
	var redA700 = exports.redA700 = '#d50000';
	
	var pink50 = exports.pink50 = '#fce4ec';
	var pink100 = exports.pink100 = '#f8bbd0';
	var pink200 = exports.pink200 = '#f48fb1';
	var pink300 = exports.pink300 = '#f06292';
	var pink400 = exports.pink400 = '#ec407a';
	var pink500 = exports.pink500 = '#e91e63';
	var pink600 = exports.pink600 = '#d81b60';
	var pink700 = exports.pink700 = '#c2185b';
	var pink800 = exports.pink800 = '#ad1457';
	var pink900 = exports.pink900 = '#880e4f';
	var pinkA100 = exports.pinkA100 = '#ff80ab';
	var pinkA200 = exports.pinkA200 = '#ff4081';
	var pinkA400 = exports.pinkA400 = '#f50057';
	var pinkA700 = exports.pinkA700 = '#c51162';
	
	var purple50 = exports.purple50 = '#f3e5f5';
	var purple100 = exports.purple100 = '#e1bee7';
	var purple200 = exports.purple200 = '#ce93d8';
	var purple300 = exports.purple300 = '#ba68c8';
	var purple400 = exports.purple400 = '#ab47bc';
	var purple500 = exports.purple500 = '#9c27b0';
	var purple600 = exports.purple600 = '#8e24aa';
	var purple700 = exports.purple700 = '#7b1fa2';
	var purple800 = exports.purple800 = '#6a1b9a';
	var purple900 = exports.purple900 = '#4a148c';
	var purpleA100 = exports.purpleA100 = '#ea80fc';
	var purpleA200 = exports.purpleA200 = '#e040fb';
	var purpleA400 = exports.purpleA400 = '#d500f9';
	var purpleA700 = exports.purpleA700 = '#aa00ff';
	
	var deepPurple50 = exports.deepPurple50 = '#ede7f6';
	var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
	var deepPurple200 = exports.deepPurple200 = '#b39ddb';
	var deepPurple300 = exports.deepPurple300 = '#9575cd';
	var deepPurple400 = exports.deepPurple400 = '#7e57c2';
	var deepPurple500 = exports.deepPurple500 = '#673ab7';
	var deepPurple600 = exports.deepPurple600 = '#5e35b1';
	var deepPurple700 = exports.deepPurple700 = '#512da8';
	var deepPurple800 = exports.deepPurple800 = '#4527a0';
	var deepPurple900 = exports.deepPurple900 = '#311b92';
	var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
	var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
	var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
	var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';
	
	var indigo50 = exports.indigo50 = '#e8eaf6';
	var indigo100 = exports.indigo100 = '#c5cae9';
	var indigo200 = exports.indigo200 = '#9fa8da';
	var indigo300 = exports.indigo300 = '#7986cb';
	var indigo400 = exports.indigo400 = '#5c6bc0';
	var indigo500 = exports.indigo500 = '#3f51b5';
	var indigo600 = exports.indigo600 = '#3949ab';
	var indigo700 = exports.indigo700 = '#303f9f';
	var indigo800 = exports.indigo800 = '#283593';
	var indigo900 = exports.indigo900 = '#1a237e';
	var indigoA100 = exports.indigoA100 = '#8c9eff';
	var indigoA200 = exports.indigoA200 = '#536dfe';
	var indigoA400 = exports.indigoA400 = '#3d5afe';
	var indigoA700 = exports.indigoA700 = '#304ffe';
	
	var blue50 = exports.blue50 = '#e3f2fd';
	var blue100 = exports.blue100 = '#bbdefb';
	var blue200 = exports.blue200 = '#90caf9';
	var blue300 = exports.blue300 = '#64b5f6';
	var blue400 = exports.blue400 = '#42a5f5';
	var blue500 = exports.blue500 = '#2196f3';
	var blue600 = exports.blue600 = '#1e88e5';
	var blue700 = exports.blue700 = '#1976d2';
	var blue800 = exports.blue800 = '#1565c0';
	var blue900 = exports.blue900 = '#0d47a1';
	var blueA100 = exports.blueA100 = '#82b1ff';
	var blueA200 = exports.blueA200 = '#448aff';
	var blueA400 = exports.blueA400 = '#2979ff';
	var blueA700 = exports.blueA700 = '#2962ff';
	
	var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
	var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
	var lightBlue200 = exports.lightBlue200 = '#81d4fa';
	var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
	var lightBlue400 = exports.lightBlue400 = '#29b6f6';
	var lightBlue500 = exports.lightBlue500 = '#03a9f4';
	var lightBlue600 = exports.lightBlue600 = '#039be5';
	var lightBlue700 = exports.lightBlue700 = '#0288d1';
	var lightBlue800 = exports.lightBlue800 = '#0277bd';
	var lightBlue900 = exports.lightBlue900 = '#01579b';
	var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
	var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
	var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
	var lightBlueA700 = exports.lightBlueA700 = '#0091ea';
	
	var cyan50 = exports.cyan50 = '#e0f7fa';
	var cyan100 = exports.cyan100 = '#b2ebf2';
	var cyan200 = exports.cyan200 = '#80deea';
	var cyan300 = exports.cyan300 = '#4dd0e1';
	var cyan400 = exports.cyan400 = '#26c6da';
	var cyan500 = exports.cyan500 = '#00bcd4';
	var cyan600 = exports.cyan600 = '#00acc1';
	var cyan700 = exports.cyan700 = '#0097a7';
	var cyan800 = exports.cyan800 = '#00838f';
	var cyan900 = exports.cyan900 = '#006064';
	var cyanA100 = exports.cyanA100 = '#84ffff';
	var cyanA200 = exports.cyanA200 = '#18ffff';
	var cyanA400 = exports.cyanA400 = '#00e5ff';
	var cyanA700 = exports.cyanA700 = '#00b8d4';
	
	var teal50 = exports.teal50 = '#e0f2f1';
	var teal100 = exports.teal100 = '#b2dfdb';
	var teal200 = exports.teal200 = '#80cbc4';
	var teal300 = exports.teal300 = '#4db6ac';
	var teal400 = exports.teal400 = '#26a69a';
	var teal500 = exports.teal500 = '#009688';
	var teal600 = exports.teal600 = '#00897b';
	var teal700 = exports.teal700 = '#00796b';
	var teal800 = exports.teal800 = '#00695c';
	var teal900 = exports.teal900 = '#004d40';
	var tealA100 = exports.tealA100 = '#a7ffeb';
	var tealA200 = exports.tealA200 = '#64ffda';
	var tealA400 = exports.tealA400 = '#1de9b6';
	var tealA700 = exports.tealA700 = '#00bfa5';
	
	var green50 = exports.green50 = '#e8f5e9';
	var green100 = exports.green100 = '#c8e6c9';
	var green200 = exports.green200 = '#a5d6a7';
	var green300 = exports.green300 = '#81c784';
	var green400 = exports.green400 = '#66bb6a';
	var green500 = exports.green500 = '#4caf50';
	var green600 = exports.green600 = '#43a047';
	var green700 = exports.green700 = '#388e3c';
	var green800 = exports.green800 = '#2e7d32';
	var green900 = exports.green900 = '#1b5e20';
	var greenA100 = exports.greenA100 = '#b9f6ca';
	var greenA200 = exports.greenA200 = '#69f0ae';
	var greenA400 = exports.greenA400 = '#00e676';
	var greenA700 = exports.greenA700 = '#00c853';
	
	var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
	var lightGreen100 = exports.lightGreen100 = '#dcedc8';
	var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
	var lightGreen300 = exports.lightGreen300 = '#aed581';
	var lightGreen400 = exports.lightGreen400 = '#9ccc65';
	var lightGreen500 = exports.lightGreen500 = '#8bc34a';
	var lightGreen600 = exports.lightGreen600 = '#7cb342';
	var lightGreen700 = exports.lightGreen700 = '#689f38';
	var lightGreen800 = exports.lightGreen800 = '#558b2f';
	var lightGreen900 = exports.lightGreen900 = '#33691e';
	var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
	var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
	var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
	var lightGreenA700 = exports.lightGreenA700 = '#64dd17';
	
	var lime50 = exports.lime50 = '#f9fbe7';
	var lime100 = exports.lime100 = '#f0f4c3';
	var lime200 = exports.lime200 = '#e6ee9c';
	var lime300 = exports.lime300 = '#dce775';
	var lime400 = exports.lime400 = '#d4e157';
	var lime500 = exports.lime500 = '#cddc39';
	var lime600 = exports.lime600 = '#c0ca33';
	var lime700 = exports.lime700 = '#afb42b';
	var lime800 = exports.lime800 = '#9e9d24';
	var lime900 = exports.lime900 = '#827717';
	var limeA100 = exports.limeA100 = '#f4ff81';
	var limeA200 = exports.limeA200 = '#eeff41';
	var limeA400 = exports.limeA400 = '#c6ff00';
	var limeA700 = exports.limeA700 = '#aeea00';
	
	var yellow50 = exports.yellow50 = '#fffde7';
	var yellow100 = exports.yellow100 = '#fff9c4';
	var yellow200 = exports.yellow200 = '#fff59d';
	var yellow300 = exports.yellow300 = '#fff176';
	var yellow400 = exports.yellow400 = '#ffee58';
	var yellow500 = exports.yellow500 = '#ffeb3b';
	var yellow600 = exports.yellow600 = '#fdd835';
	var yellow700 = exports.yellow700 = '#fbc02d';
	var yellow800 = exports.yellow800 = '#f9a825';
	var yellow900 = exports.yellow900 = '#f57f17';
	var yellowA100 = exports.yellowA100 = '#ffff8d';
	var yellowA200 = exports.yellowA200 = '#ffff00';
	var yellowA400 = exports.yellowA400 = '#ffea00';
	var yellowA700 = exports.yellowA700 = '#ffd600';
	
	var amber50 = exports.amber50 = '#fff8e1';
	var amber100 = exports.amber100 = '#ffecb3';
	var amber200 = exports.amber200 = '#ffe082';
	var amber300 = exports.amber300 = '#ffd54f';
	var amber400 = exports.amber400 = '#ffca28';
	var amber500 = exports.amber500 = '#ffc107';
	var amber600 = exports.amber600 = '#ffb300';
	var amber700 = exports.amber700 = '#ffa000';
	var amber800 = exports.amber800 = '#ff8f00';
	var amber900 = exports.amber900 = '#ff6f00';
	var amberA100 = exports.amberA100 = '#ffe57f';
	var amberA200 = exports.amberA200 = '#ffd740';
	var amberA400 = exports.amberA400 = '#ffc400';
	var amberA700 = exports.amberA700 = '#ffab00';
	
	var orange50 = exports.orange50 = '#fff3e0';
	var orange100 = exports.orange100 = '#ffe0b2';
	var orange200 = exports.orange200 = '#ffcc80';
	var orange300 = exports.orange300 = '#ffb74d';
	var orange400 = exports.orange400 = '#ffa726';
	var orange500 = exports.orange500 = '#ff9800';
	var orange600 = exports.orange600 = '#fb8c00';
	var orange700 = exports.orange700 = '#f57c00';
	var orange800 = exports.orange800 = '#ef6c00';
	var orange900 = exports.orange900 = '#e65100';
	var orangeA100 = exports.orangeA100 = '#ffd180';
	var orangeA200 = exports.orangeA200 = '#ffab40';
	var orangeA400 = exports.orangeA400 = '#ff9100';
	var orangeA700 = exports.orangeA700 = '#ff6d00';
	
	var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
	var deepOrange100 = exports.deepOrange100 = '#ffccbc';
	var deepOrange200 = exports.deepOrange200 = '#ffab91';
	var deepOrange300 = exports.deepOrange300 = '#ff8a65';
	var deepOrange400 = exports.deepOrange400 = '#ff7043';
	var deepOrange500 = exports.deepOrange500 = '#ff5722';
	var deepOrange600 = exports.deepOrange600 = '#f4511e';
	var deepOrange700 = exports.deepOrange700 = '#e64a19';
	var deepOrange800 = exports.deepOrange800 = '#d84315';
	var deepOrange900 = exports.deepOrange900 = '#bf360c';
	var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
	var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
	var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
	var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';
	
	var brown50 = exports.brown50 = '#efebe9';
	var brown100 = exports.brown100 = '#d7ccc8';
	var brown200 = exports.brown200 = '#bcaaa4';
	var brown300 = exports.brown300 = '#a1887f';
	var brown400 = exports.brown400 = '#8d6e63';
	var brown500 = exports.brown500 = '#795548';
	var brown600 = exports.brown600 = '#6d4c41';
	var brown700 = exports.brown700 = '#5d4037';
	var brown800 = exports.brown800 = '#4e342e';
	var brown900 = exports.brown900 = '#3e2723';
	
	var blueGrey50 = exports.blueGrey50 = '#eceff1';
	var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
	var blueGrey200 = exports.blueGrey200 = '#b0bec5';
	var blueGrey300 = exports.blueGrey300 = '#90a4ae';
	var blueGrey400 = exports.blueGrey400 = '#78909c';
	var blueGrey500 = exports.blueGrey500 = '#607d8b';
	var blueGrey600 = exports.blueGrey600 = '#546e7a';
	var blueGrey700 = exports.blueGrey700 = '#455a64';
	var blueGrey800 = exports.blueGrey800 = '#37474f';
	var blueGrey900 = exports.blueGrey900 = '#263238';
	
	var grey50 = exports.grey50 = '#fafafa';
	var grey100 = exports.grey100 = '#f5f5f5';
	var grey200 = exports.grey200 = '#eeeeee';
	var grey300 = exports.grey300 = '#e0e0e0';
	var grey400 = exports.grey400 = '#bdbdbd';
	var grey500 = exports.grey500 = '#9e9e9e';
	var grey600 = exports.grey600 = '#757575';
	var grey700 = exports.grey700 = '#616161';
	var grey800 = exports.grey800 = '#424242';
	var grey900 = exports.grey900 = '#212121';
	
	var black = exports.black = '#000000';
	var white = exports.white = '#ffffff';
	
	var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
	var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
	var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
	var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
	var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
	var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
	var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
	var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
	var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertColorToString = convertColorToString;
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function convertColorToString(color) {
	  var type = color.type,
	      values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    for (var i = 0; i < 3; i++) {
	      values[i] = parseInt(values[i]);
	    }
	  }
	
	  var colorString = void 0;
	
	  if (type.indexOf('hsl') > -1) {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
	  } else {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
	  }
	
	  if (values.length === 4) {
	    colorString += ', ' + color.values[3] + ')';
	  } else {
	    colorString += ')';
	  }
	
	  return colorString;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	function convertHexToRGB(color) {
	  if (color.length === 4) {
	    var extendedColor = '#';
	    for (var i = 1; i < color.length; i++) {
	      extendedColor += color.charAt(i) + color.charAt(i);
	    }
	    color = extendedColor;
	  }
	
	  var values = {
	    r: parseInt(color.substr(1, 2), 16),
	    g: parseInt(color.substr(3, 2), 16),
	    b: parseInt(color.substr(5, 2), 16)
	  };
	
	  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values and color names.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {{type: string, values: number[]}} A MUI color object
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	
	   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;
	
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	
	  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  color = decomposeColor(color);
	
	  if (color.type.indexOf('rgb') > -1) {
	    var rgb = color.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
	  } else if (color.type.indexOf('hsl') > -1) {
	    return color.values[2] / 100;
	  }
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value, 0, 1);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return convertColorToString(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return convertColorToString(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return convertColorToString(color);
	}

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactErrorUtils = __webpack_require__(101);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventPluginRegistry = __webpack_require__(97);
	var ReactEventEmitterMixin = __webpack_require__(356);
	var ViewportMetrics = __webpack_require__(103);
	
	var getVendorPrefixedEventName = __webpack_require__(388);
	var isEventSupported = __webpack_require__(108);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(44);
	var ViewportMetrics = __webpack_require__(103);
	
	var getEventModifierState = __webpack_require__(106);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(16);
	var DOMNamespaces = __webpack_require__(96);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(104);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Base2 = __webpack_require__(45);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
	
	var FilePlayer = function (_Base) {
	  _inherits(FilePlayer, _Base);
	
	  function FilePlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FilePlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.renderSource = function (source) {
	      if (typeof source === 'string') {
	        return _react2['default'].createElement('source', { key: source, src: source });
	      }
	      var src = source.src,
	          type = source.type;
	
	      return _react2['default'].createElement('source', { key: src, src: src, type: type });
	    }, _this.renderSources = function (url) {
	      if (url instanceof Array === false) {
	        return null;
	      }
	      return url.map(_this.renderSource);
	    }, _this.ref = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FilePlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          playsinline = _props.playsinline,
	          onPause = _props.onPause,
	          onEnded = _props.onEnded,
	          onError = _props.onError;
	
	      this.player.addEventListener('canplay', this.onReady);
	      this.player.addEventListener('play', this.onPlay);
	      this.player.addEventListener('pause', function () {
	        if (_this2.mounted) {
	          onPause();
	        }
	      });
	      this.player.addEventListener('ended', onEnded);
	      this.player.addEventListener('error', onError);
	      if (playsinline) {
	        this.player.setAttribute('playsinline', '');
	        this.player.setAttribute('webkit-playsinline', '');
	      }
	      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props2 = this.props,
	          onPause = _props2.onPause,
	          onEnded = _props2.onEnded,
	          onError = _props2.onError;
	
	      this.player.removeEventListener('canplay', this.onReady);
	      this.player.removeEventListener('play', this.onPlay);
	      this.player.removeEventListener('pause', onPause);
	      this.player.removeEventListener('ended', onEnded);
	      this.player.removeEventListener('error', onError);
	      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentWillUnmount', this).call(this);
	    }
	  }, {
	    key: 'load',
	    value: function load() {
	      // Setting the src is handled by render
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.player.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.player.removeAttribute('src');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      if (fraction === 1) {
	        this.pause();
	      }
	      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'seekTo', this).call(this, fraction);
	      this.player.currentTime = this.getDuration() * fraction;
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.player.volume = fraction;
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.player.playbackRate = rate;
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady) return null;
	      return this.player.duration;
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady) return null;
	      return this.player.currentTime / this.getDuration();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      if (!this.isReady || this.player.buffered.length === 0) return null;
	      return this.player.buffered.end(0) / this.getDuration();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          url = _props3.url,
	          loop = _props3.loop,
	          controls = _props3.controls,
	          fileConfig = _props3.fileConfig;
	
	      var Media = AUDIO_EXTENSIONS.test(url) || fileConfig.forceAudio ? 'audio' : 'video';
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement(
	        Media,
	        _extends({
	          ref: this.ref,
	          src: url instanceof Array ? undefined : url,
	          style: style,
	          preload: 'auto',
	          controls: controls,
	          loop: loop
	        }, fileConfig.attributes),
	        this.renderSources(url)
	      );
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return true;
	    }
	  }]);
	
	  return FilePlayer;
	}(_Base3['default']);
	
	FilePlayer.displayName = 'FilePlayer';
	exports['default'] = FilePlayer;
	module.exports = exports['default'];

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(428);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(73);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(171);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = (0, _shouldUpdate2.default)(function (props, nextProps) {
	  return !(0, _shallowEqual2.default)(props, nextProps);
	});
	
	exports.default = (0, _createHelper2.default)(pure, 'pure', true, true);

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(54);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ },
/* 74 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(198);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 76 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 77 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 78 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(34)
	  , dPs         = __webpack_require__(214)
	  , enumBugKeys = __webpack_require__(77)
	  , IE_PROTO    = __webpack_require__(82)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(120)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(204).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 80 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(27).f
	  , has = __webpack_require__(30)
	  , TAG = __webpack_require__(21)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(83)('keys')
	  , uid    = __webpack_require__(61);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(26)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 84 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(49);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(26)
	  , core           = __webpack_require__(19)
	  , LIBRARY        = __webpack_require__(78)
	  , wksExt         = __webpack_require__(87)
	  , defineProperty = __webpack_require__(27).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(21);

/***/ },
/* 88 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ },
/* 89 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _childUtils = __webpack_require__(92);
	
	var _events = __webpack_require__(315);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keycode = __webpack_require__(276);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _FocusRipple = __webpack_require__(299);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(302);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (event) {
	      tabPressed = (0, _keycode2.default)(event) === 'tab';
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = function (_Component) {
	  (0, _inherits3.default)(EnhancedButton, _Component);
	
	  function EnhancedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleKeyDown = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
	          _this.removeKeyboardFocus(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleKeyUp = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	      }
	      _this.props.onKeyUp(event);
	    }, _this.handleBlur = function (event) {
	      _this.cancelFocusTimeout();
	      _this.removeKeyboardFocus(event);
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (event) event.persist();
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        // setTimeout is needed because the focus event fires first
	        // Wait so that we can capture if this was a keyboard focus
	        // or touch focus
	        _this.focusTimeout = setTimeout(function () {
	          if (tabPressed) {
	            _this.setKeyboardFocus(event);
	            tabPressed = false;
	          }
	        }, 150);
	
	        _this.props.onFocus(event);
	      }
	    }, _this.handleClick = function (event) {
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.props.onClick(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      _this.cancelFocusTimeout();
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.removeKeyboardFocus(event);
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          disableKeyboardFocus = _props.disableKeyboardFocus,
	          keyboardFocused = _props.keyboardFocused;
	
	      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
	        this.setState({ isKeyboardFocused: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      injectStyle();
	      listenForTabPresses();
	      if (this.state.isKeyboardFocused) {
	        this.button.focus();
	        this.props.onKeyboardFocus(null, true);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        if (nextProps.onKeyboardFocus) {
	          nextProps.onKeyboardFocus(null, false);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	      }
	    }
	  }, {
	    key: 'isKeyboardFocused',
	    value: function isKeyboardFocused() {
	      return this.state.isKeyboardFocused;
	    }
	  }, {
	    key: 'removeKeyboardFocus',
	    value: function removeKeyboardFocus(event) {
	      if (this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        this.props.onKeyboardFocus(event, false);
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus(event) {
	      if (!this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: true });
	        this.props.onKeyboardFocus(event, true);
	      }
	    }
	  }, {
	    key: 'cancelFocusTimeout',
	    value: function cancelFocusTimeout() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	        this.focusTimeout = null;
	      }
	    }
	  }, {
	    key: 'createButtonChildren',
	    value: function createButtonChildren() {
	      var _props2 = this.props,
	          centerRipple = _props2.centerRipple,
	          children = _props2.children,
	          disabled = _props2.disabled,
	          disableFocusRipple = _props2.disableFocusRipple,
	          disableKeyboardFocus = _props2.disableKeyboardFocus,
	          disableTouchRipple = _props2.disableTouchRipple,
	          focusRippleColor = _props2.focusRippleColor,
	          focusRippleOpacity = _props2.focusRippleOpacity,
	          touchRippleColor = _props2.touchRippleColor,
	          touchRippleOpacity = _props2.touchRippleOpacity;
	      var isKeyboardFocused = this.state.isKeyboardFocused;
	
	      // Focus Ripple
	
	      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
	        color: focusRippleColor,
	        opacity: focusRippleOpacity,
	        show: isKeyboardFocused
	      }) : undefined;
	
	      // Touch Ripple
	      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	        _TouchRipple2.default,
	        {
	          centerRipple: centerRipple,
	          color: touchRippleColor,
	          opacity: touchRippleOpacity
	        },
	        children
	      ) : undefined;
	
	      return (0, _childUtils.createChildFragment)({
	        focusRipple: focusRipple,
	        touchRipple: touchRipple,
	        children: touchRipple ? undefined : children
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          centerRipple = _props3.centerRipple,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          disableTouchRipple = _props3.disableTouchRipple,
	          focusRippleColor = _props3.focusRippleColor,
	          focusRippleOpacity = _props3.focusRippleOpacity,
	          href = _props3.href,
	          keyboardFocused = _props3.keyboardFocused,
	          touchRippleColor = _props3.touchRippleColor,
	          touchRippleOpacity = _props3.touchRippleOpacity,
	          onBlur = _props3.onBlur,
	          onClick = _props3.onClick,
	          onFocus = _props3.onFocus,
	          onKeyUp = _props3.onKeyUp,
	          onKeyDown = _props3.onKeyDown,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          onTouchTap = _props3.onTouchTap,
	          style = _props3.style,
	          tabIndex = _props3.tabIndex,
	          type = _props3.type,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'onTouchTap', 'style', 'tabIndex', 'type']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          enhancedButton = _context$muiTheme.enhancedButton;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        border: 10,
	        boxSizing: 'border-box',
	        display: 'inline-block',
	        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
	        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
	        cursor: disabled ? 'default' : 'pointer',
	        textDecoration: 'none',
	        margin: 0,
	        padding: 0,
	        outline: 'none',
	        fontSize: 'inherit',
	        fontWeight: 'inherit',
	        position: 'relative', // This is needed so that ripples do not bleed past border radius.
	        verticalAlign: href ? 'middle' : null,
	        zIndex: 1 }, style);
	
	      // Passing both background:none & backgroundColor can break due to object iteration order
	      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
	        mergedStyles.background = 'none';
	      }
	
	      if (disabled && href) {
	        return _react2.default.createElement(
	          'span',
	          (0, _extends3.default)({}, other, {
	            style: mergedStyles
	          }),
	          children
	        );
	      }
	
	      var buttonProps = (0, _extends3.default)({}, other, {
	        style: prepareStyles(mergedStyles),
	        ref: function ref(node) {
	          return _this2.button = node;
	        },
	        disabled: disabled,
	        href: href,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onKeyUp: this.handleKeyUp,
	        onKeyDown: this.handleKeyDown,
	        onTouchTap: this.handleTouchTap,
	        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
	      });
	
	      var buttonChildren = this.createButtonChildren();
	
	      if (_react2.default.isValidElement(containerElement)) {
	        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
	      }
	
	      if (!href && containerElement === 'button') {
	        buttonProps.type = type;
	      }
	
	      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
	    }
	  }]);
	  return EnhancedButton;
	}(_react.Component);
	
	EnhancedButton.defaultProps = {
	  containerElement: 'button',
	  onBlur: function onBlur() {},
	  onClick: function onClick() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyUp: function onKeyUp() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onTouchTap: function onTouchTap() {},
	  tabIndex: 0,
	  type: 'button'
	};
	EnhancedButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? EnhancedButton.propTypes = {
	  centerRipple: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  disableFocusRipple: _propTypes2.default.bool,
	  disableKeyboardFocus: _propTypes2.default.bool,
	  disableTouchRipple: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  focusRippleColor: _propTypes2.default.string,
	  focusRippleOpacity: _propTypes2.default.number,
	  href: _propTypes2.default.string,
	  keyboardFocused: _propTypes2.default.bool,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onKeyUp: _propTypes2.default.func,
	  onKeyboardFocus: _propTypes2.default.func,
	  onTouchTap: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  tabIndex: _propTypes2.default.number,
	  touchRippleColor: _propTypes2.default.string,
	  touchRippleOpacity: _propTypes2.default.number,
	  type: _propTypes2.default.string
	} : void 0;
	exports.default = EnhancedButton;

/***/ },
/* 91 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  set: function set(style, key, value) {
	    style[key] = value;
	  }
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createChildFragment = createChildFragment;
	exports.extendChildren = extendChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCreateFragment = __webpack_require__(326);
	
	var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createChildFragment(fragments) {
	  var newFragments = {};
	  var validChildrenCount = 0;
	  var firstKey = void 0;
	
	  // Only create non-empty key fragments
	  for (var key in fragments) {
	    var currentChild = fragments[key];
	
	    if (currentChild) {
	      if (validChildrenCount === 0) firstKey = key;
	      newFragments[key] = currentChild;
	      validChildrenCount++;
	    }
	  }
	
	  if (validChildrenCount === 0) return undefined;
	  if (validChildrenCount === 1) return newFragments[firstKey];
	  return (0, _reactAddonsCreateFragment2.default)(newFragments);
	}
	
	function extendChildren(children, extendedProps, extendedChildren) {
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	    return _react2.default.cloneElement(child, newProps, newChildren);
	  });
	}

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(324);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(417);

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(39);
	var Danger = __webpack_require__(332);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactInstrumentation = __webpack_require__(20);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(104);
	var setInnerHTML = __webpack_require__(70);
	var setTextContent = __webpack_require__(164);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 96 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 98 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactPropTypesSecret = __webpack_require__(362);
	var propTypesFactory = __webpack_require__(93);
	
	var React = __webpack_require__(33);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactInstanceMap = __webpack_require__(57);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(22);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 103 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 104 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 105 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 106 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 107 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(16);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 109 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var emptyFunction = __webpack_require__(17);
	var warning = __webpack_require__(3);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultProps = exports.propTypes = undefined;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var string = _propTypes2['default'].string,
	    bool = _propTypes2['default'].bool,
	    number = _propTypes2['default'].number,
	    array = _propTypes2['default'].array,
	    oneOfType = _propTypes2['default'].oneOfType,
	    shape = _propTypes2['default'].shape,
	    object = _propTypes2['default'].object,
	    func = _propTypes2['default'].func;
	var propTypes = exports.propTypes = {
	  url: oneOfType([string, array]),
	  playing: bool,
	  loop: bool,
	  controls: bool,
	  volume: number,
	  playbackRate: number,
	  width: oneOfType([string, number]),
	  height: oneOfType([string, number]),
	  style: object,
	  progressFrequency: number,
	  playsinline: bool,
	  soundcloudConfig: shape({
	    clientId: string,
	    showArtwork: bool
	  }),
	  youtubeConfig: shape({
	    playerVars: object,
	    preload: bool
	  }),
	  facebookConfig: shape({
	    appId: string
	  }),
	  dailymotionConfig: shape({
	    params: object,
	    preload: bool
	  }),
	  vimeoConfig: shape({
	    iframeParams: object,
	    preload: bool
	  }),
	  vidmeConfig: shape({
	    format: string
	  }),
	  fileConfig: shape({
	    attributes: object,
	    forceAudio: bool
	  }),
	  onReady: func,
	  onStart: func,
	  onPlay: func,
	  onPause: func,
	  onBuffer: func,
	  onEnded: func,
	  onError: func,
	  onDuration: func,
	  onProgress: func
	};
	
	var defaultProps = exports.defaultProps = {
	  playing: false,
	  loop: false,
	  controls: false,
	  volume: 0.8,
	  playbackRate: 1,
	  width: 640,
	  height: 360,
	  hidden: false,
	  progressFrequency: 1000,
	  playsinline: false,
	  soundcloudConfig: {
	    clientId: 'e8b6f84fbcad14c301ca1355cae1dea2',
	    showArtwork: true
	  },
	  youtubeConfig: {
	    playerVars: {},
	    preload: false
	  },
	  facebookConfig: {
	    appId: '1309697205772819'
	  },
	  dailymotionConfig: {
	    params: {},
	    preload: false
	  },
	  vimeoConfig: {
	    iframeParams: {},
	    preload: false
	  },
	  vidmeConfig: {
	    format: null
	  },
	  fileConfig: {
	    attributes: {},
	    forceAudio: false
	  },
	  onReady: function onReady() {},
	  onStart: function onStart() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onBuffer: function onBuffer() {},
	  onEnded: function onEnded() {},
	  onError: function onError() {},
	  onDuration: function onDuration() {},
	  onProgress: function onProgress() {}
	};

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactNoopUpdateQueue = __webpack_require__(114);
	
	var canDefineProperty = __webpack_require__(169);
	var emptyObject = __webpack_require__(53);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactCurrentOwner = __webpack_require__(24);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(3);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(189), __esModule: true };

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(190), __esModule: true };

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(192), __esModule: true };

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(194), __esModule: true };

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(115);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49)
	  , document = __webpack_require__(26).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(29) && !__webpack_require__(35)(function(){
	  return Object.defineProperty(__webpack_require__(120)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(74);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(78)
	  , $export        = __webpack_require__(25)
	  , redefine       = __webpack_require__(129)
	  , hide           = __webpack_require__(36)
	  , has            = __webpack_require__(30)
	  , Iterators      = __webpack_require__(50)
	  , $iterCreate    = __webpack_require__(208)
	  , setToStringTag = __webpack_require__(81)
	  , getPrototypeOf = __webpack_require__(126)
	  , ITERATOR       = __webpack_require__(21)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(60)
	  , createDesc     = __webpack_require__(51)
	  , toIObject      = __webpack_require__(31)
	  , toPrimitive    = __webpack_require__(85)
	  , has            = __webpack_require__(30)
	  , IE8_DOM_DEFINE = __webpack_require__(121)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(29) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(127)
	  , hiddenKeys = __webpack_require__(77).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(30)
	  , toObject    = __webpack_require__(52)
	  , IE_PROTO    = __webpack_require__(82)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(30)
	  , toIObject    = __webpack_require__(31)
	  , arrayIndexOf = __webpack_require__(200)(false)
	  , IE_PROTO     = __webpack_require__(82)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(25)
	  , core    = __webpack_require__(19)
	  , fails   = __webpack_require__(35);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(36);

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(84)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(217)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(123)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(254);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(17);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 134 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 135 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 136 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 137 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}
	module.exports = exports["default"];

/***/ },
/* 138 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FlatButton = __webpack_require__(279);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatButton2.default;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Paper = __webpack_require__(281);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper2.default;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RaisedButton = __webpack_require__(282);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RaisedButton2.default;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _typeof2 = __webpack_require__(59);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _checkCircle = __webpack_require__(144);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _SvgIcon = __webpack_require__(62);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var active = _ref.active,
	      completed = _ref.completed,
	      disabled = _ref.disabled;
	  var muiTheme = _ref2.muiTheme,
	      stepper = _ref2.stepper;
	  var _muiTheme$stepper = muiTheme.stepper,
	      textColor = _muiTheme$stepper.textColor,
	      disabledTextColor = _muiTheme$stepper.disabledTextColor,
	      iconColor = _muiTheme$stepper.iconColor,
	      inactiveIconColor = _muiTheme$stepper.inactiveIconColor;
	  var baseTheme = muiTheme.baseTheme;
	  var orientation = stepper.orientation;
	
	
	  var styles = {
	    root: {
	      height: orientation === 'horizontal' ? 72 : 64,
	      color: textColor,
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: 14,
	      paddingLeft: 14,
	      paddingRight: 14
	    },
	    icon: {
	      color: iconColor,
	      display: 'block',
	      fontSize: 24,
	      width: 24,
	      height: 24
	    },
	    iconContainer: {
	      paddingRight: 8
	    }
	  };
	
	  if (active) {
	    styles.root.fontWeight = 500;
	  }
	
	  if (!completed && !active) {
	    styles.icon.color = inactiveIconColor;
	  }
	
	  if (disabled) {
	    styles.icon.color = inactiveIconColor;
	    styles.root.color = disabledTextColor;
	    styles.root.cursor = 'default';
	  }
	
	  return styles;
	};
	
	var renderIcon = function renderIcon(completed, icon, styles) {
	  var iconType = typeof icon === 'undefined' ? 'undefined' : (0, _typeof3.default)(icon);
	
	  if (iconType === 'number' || iconType === 'string') {
	    if (completed) {
	      return _react2.default.createElement(_checkCircle2.default, {
	        color: styles.icon.color,
	        style: styles.icon
	      });
	    }
	
	    return _react2.default.createElement(
	      _SvgIcon2.default,
	      { color: styles.icon.color, style: styles.icon },
	      _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	      _react2.default.createElement(
	        'text',
	        {
	          x: '12',
	          y: '16',
	          textAnchor: 'middle',
	          fontSize: '12',
	          fill: '#fff'
	        },
	        icon
	      )
	    );
	  }
	
	  return icon;
	};
	
	var StepLabel = function StepLabel(props, context) {
	  var active = props.active,
	      children = props.children,
	      completed = props.completed,
	      userIcon = props.icon,
	      iconContainerStyle = props.iconContainerStyle,
	      last = props.last,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'children', 'completed', 'icon', 'iconContainerStyle', 'last', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	  var icon = renderIcon(completed, userIcon, styles);
	
	  return _react2.default.createElement(
	    'span',
	    (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	    icon && _react2.default.createElement(
	      'span',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.iconContainer, iconContainerStyle)) },
	      icon
	    ),
	    children
	  );
	};
	
	StepLabel.muiName = 'StepLabel';
	
	 false ? StepLabel.propTypes = {
	  /**
	   * Sets active styling. Overrides disabled coloring.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * The label text node
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Sets completed styling. Overrides disabled coloring.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Sets disabled styling.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	
	StepLabel.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	
	exports.default = StepLabel;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(119);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = getMuiTheme;
	
	var _lodash = __webpack_require__(277);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _colorManipulator = __webpack_require__(64);
	
	var _lightBaseTheme = __webpack_require__(304);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(307);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _autoprefixer = __webpack_require__(310);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(313);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(317);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	var _compose = __webpack_require__(423);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _typography = __webpack_require__(306);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _colors = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(muiTheme) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = _lodash2.default.apply(undefined, [{
	    zIndex: _zIndex2.default,
	    isRtl: false,
	    userAgent: undefined
	  }, _lightBaseTheme2.default, muiTheme].concat(more));
	
	  var _muiTheme = muiTheme,
	      spacing = _muiTheme.spacing,
	      fontFamily = _muiTheme.fontFamily,
	      palette = _muiTheme.palette;
	
	  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };
	
	  muiTheme = (0, _lodash2.default)({
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement,
	      titleFontWeight: _typography2.default.fontWeightNormal,
	      padding: spacing.desktopGutter
	    },
	    avatar: {
	      color: palette.canvasColor,
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    bottomNavigation: {
	      backgroundColor: palette.canvasColor,
	      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      selectedColor: palette.primary1Color,
	      height: 56,
	      unselectedFontSize: 12,
	      selectedFontSize: 14
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    card: {
	      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    cardMedia: {
	      color: _colors.darkWhite,
	      overlayContentBackground: _colors.lightBlack,
	      titleColor: _colors.darkWhite,
	      subtitleColor: _colors.lightWhite
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    chip: {
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
	      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
	      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      fontSize: 14,
	      fontWeight: _typography2.default.fontWeightNormal,
	      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor,
	      calendarYearBackgroundColor: palette.canvasColor
	    },
	    dialog: {
	      titleFontSize: 22,
	      bodyFontSize: 16,
	      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    enhancedButton: {
	      tapHighlightColor: _colors.transparent
	    },
	    flatButton: {
	      color: _colors.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.primary1Color,
	      secondaryTextColor: palette.accent1Color,
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.primary1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor,
	      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
	    },
	    gridTile: {
	      textColor: _colors.white
	    },
	    icon: {
	      color: palette.canvasColor,
	      backgroundColor: palette.primary1Color
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    drawer: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18,
	      secondaryTextColor: palette.secondaryTextColor,
	      leftIconColor: _colors.grey600,
	      rightIconColor: _colors.grey600
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color,
	      rightIconDesktopFill: _colors.grey600
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    overlay: {
	      backgroundColor: _colors.lightBlack
	    },
	    paper: {
	      color: palette.textColor,
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    ripple: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    subheader: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    stepper: {
	      backgroundColor: 'transparent',
	      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
	      iconColor: palette.primary1Color,
	      hoveredIconColor: _colors.grey700,
	      inactiveIconColor: _colors.grey500,
	      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
	      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
	      connectorLineColor: _colors.grey400
	    },
	    svgIcon: {
	      color: palette.textColor
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.disabledColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.alternateTextColor,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
	      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
	      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
	    },
	    tooltip: {
	      color: _colors.white,
	      rippleBackgroundColor: _colors.grey700
	    }
	  }, muiTheme, {
	    baseTheme: baseTheme, // To provide backward compatibility.
	    rawTheme: baseTheme });
	
	  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	
	  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));
	
	  return muiTheme;
	}

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(72);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(62);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCheckCircle = function ActionCheckCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
	ActionCheckCircle.displayName = 'ActionCheckCircle';
	ActionCheckCircle.muiName = 'SvgIcon';
	
	exports.default = ActionCheckCircle;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/* Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("pdfjs-dist/build/pdf.worker", [], factory);
		else if(typeof exports === 'object')
			exports["pdfjs-dist/build/pdf.worker"] = factory();
		else
			root["pdfjs-dist/build/pdf.worker"] = root.pdfjsDistBuildPdfWorker = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __w_pdfjs_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__w_pdfjs_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__w_pdfjs_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__w_pdfjs_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
	/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__w_pdfjs_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__w_pdfjs_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 36);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isNodeJS = exports.isSpace = exports.isString = exports.isNum = exports.isInt = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.isArray = exports.info = exports.globalScope = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.error = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.StatTimer = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	__w_pdfjs_require__(37);
	
	var globalScope = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : undefined;
	var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
	var TextRenderingMode = {
	  FILL: 0,
	  STROKE: 1,
	  FILL_STROKE: 2,
	  INVISIBLE: 3,
	  FILL_ADD_TO_PATH: 4,
	  STROKE_ADD_TO_PATH: 5,
	  FILL_STROKE_ADD_TO_PATH: 6,
	  ADD_TO_PATH: 7,
	  FILL_STROKE_MASK: 3,
	  ADD_TO_PATH_FLAG: 4
	};
	var ImageKind = {
	  GRAYSCALE_1BPP: 1,
	  RGB_24BPP: 2,
	  RGBA_32BPP: 3
	};
	var AnnotationType = {
	  TEXT: 1,
	  LINK: 2,
	  FREETEXT: 3,
	  LINE: 4,
	  SQUARE: 5,
	  CIRCLE: 6,
	  POLYGON: 7,
	  POLYLINE: 8,
	  HIGHLIGHT: 9,
	  UNDERLINE: 10,
	  SQUIGGLY: 11,
	  STRIKEOUT: 12,
	  STAMP: 13,
	  CARET: 14,
	  INK: 15,
	  POPUP: 16,
	  FILEATTACHMENT: 17,
	  SOUND: 18,
	  MOVIE: 19,
	  WIDGET: 20,
	  SCREEN: 21,
	  PRINTERMARK: 22,
	  TRAPNET: 23,
	  WATERMARK: 24,
	  THREED: 25,
	  REDACT: 26
	};
	var AnnotationFlag = {
	  INVISIBLE: 0x01,
	  HIDDEN: 0x02,
	  PRINT: 0x04,
	  NOZOOM: 0x08,
	  NOROTATE: 0x10,
	  NOVIEW: 0x20,
	  READONLY: 0x40,
	  LOCKED: 0x80,
	  TOGGLENOVIEW: 0x100,
	  LOCKEDCONTENTS: 0x200
	};
	var AnnotationFieldFlag = {
	  READONLY: 0x0000001,
	  REQUIRED: 0x0000002,
	  NOEXPORT: 0x0000004,
	  MULTILINE: 0x0001000,
	  PASSWORD: 0x0002000,
	  NOTOGGLETOOFF: 0x0004000,
	  RADIO: 0x0008000,
	  PUSHBUTTON: 0x0010000,
	  COMBO: 0x0020000,
	  EDIT: 0x0040000,
	  SORT: 0x0080000,
	  FILESELECT: 0x0100000,
	  MULTISELECT: 0x0200000,
	  DONOTSPELLCHECK: 0x0400000,
	  DONOTSCROLL: 0x0800000,
	  COMB: 0x1000000,
	  RICHTEXT: 0x2000000,
	  RADIOSINUNISON: 0x2000000,
	  COMMITONSELCHANGE: 0x4000000
	};
	var AnnotationBorderStyleType = {
	  SOLID: 1,
	  DASHED: 2,
	  BEVELED: 3,
	  INSET: 4,
	  UNDERLINE: 5
	};
	var StreamType = {
	  UNKNOWN: 0,
	  FLATE: 1,
	  LZW: 2,
	  DCT: 3,
	  JPX: 4,
	  JBIG: 5,
	  A85: 6,
	  AHX: 7,
	  CCF: 8,
	  RL: 9
	};
	var FontType = {
	  UNKNOWN: 0,
	  TYPE1: 1,
	  TYPE1C: 2,
	  CIDFONTTYPE0: 3,
	  CIDFONTTYPE0C: 4,
	  TRUETYPE: 5,
	  CIDFONTTYPE2: 6,
	  TYPE3: 7,
	  OPENTYPE: 8,
	  TYPE0: 9,
	  MMTYPE1: 10
	};
	var VERBOSITY_LEVELS = {
	  errors: 0,
	  warnings: 1,
	  infos: 5
	};
	var CMapCompressionType = {
	  NONE: 0,
	  BINARY: 1,
	  STREAM: 2
	};
	var OPS = {
	  dependency: 1,
	  setLineWidth: 2,
	  setLineCap: 3,
	  setLineJoin: 4,
	  setMiterLimit: 5,
	  setDash: 6,
	  setRenderingIntent: 7,
	  setFlatness: 8,
	  setGState: 9,
	  save: 10,
	  restore: 11,
	  transform: 12,
	  moveTo: 13,
	  lineTo: 14,
	  curveTo: 15,
	  curveTo2: 16,
	  curveTo3: 17,
	  closePath: 18,
	  rectangle: 19,
	  stroke: 20,
	  closeStroke: 21,
	  fill: 22,
	  eoFill: 23,
	  fillStroke: 24,
	  eoFillStroke: 25,
	  closeFillStroke: 26,
	  closeEOFillStroke: 27,
	  endPath: 28,
	  clip: 29,
	  eoClip: 30,
	  beginText: 31,
	  endText: 32,
	  setCharSpacing: 33,
	  setWordSpacing: 34,
	  setHScale: 35,
	  setLeading: 36,
	  setFont: 37,
	  setTextRenderingMode: 38,
	  setTextRise: 39,
	  moveText: 40,
	  setLeadingMoveText: 41,
	  setTextMatrix: 42,
	  nextLine: 43,
	  showText: 44,
	  showSpacedText: 45,
	  nextLineShowText: 46,
	  nextLineSetSpacingShowText: 47,
	  setCharWidth: 48,
	  setCharWidthAndBounds: 49,
	  setStrokeColorSpace: 50,
	  setFillColorSpace: 51,
	  setStrokeColor: 52,
	  setStrokeColorN: 53,
	  setFillColor: 54,
	  setFillColorN: 55,
	  setStrokeGray: 56,
	  setFillGray: 57,
	  setStrokeRGBColor: 58,
	  setFillRGBColor: 59,
	  setStrokeCMYKColor: 60,
	  setFillCMYKColor: 61,
	  shadingFill: 62,
	  beginInlineImage: 63,
	  beginImageData: 64,
	  endInlineImage: 65,
	  paintXObject: 66,
	  markPoint: 67,
	  markPointProps: 68,
	  beginMarkedContent: 69,
	  beginMarkedContentProps: 70,
	  endMarkedContent: 71,
	  beginCompat: 72,
	  endCompat: 73,
	  paintFormXObjectBegin: 74,
	  paintFormXObjectEnd: 75,
	  beginGroup: 76,
	  endGroup: 77,
	  beginAnnotations: 78,
	  endAnnotations: 79,
	  beginAnnotation: 80,
	  endAnnotation: 81,
	  paintJpegXObject: 82,
	  paintImageMaskXObject: 83,
	  paintImageMaskXObjectGroup: 84,
	  paintImageXObject: 85,
	  paintInlineImageXObject: 86,
	  paintInlineImageXObjectGroup: 87,
	  paintImageXObjectRepeat: 88,
	  paintImageMaskXObjectRepeat: 89,
	  paintSolidColorImageMask: 90,
	  constructPath: 91
	};
	var verbosity = VERBOSITY_LEVELS.warnings;
	function setVerbosityLevel(level) {
	  verbosity = level;
	}
	function getVerbosityLevel() {
	  return verbosity;
	}
	function info(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.infos) {
	    console.log('Info: ' + msg);
	  }
	}
	function warn(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.warnings) {
	    console.log('Warning: ' + msg);
	  }
	}
	function deprecated(details) {
	  console.log('Deprecated API usage: ' + details);
	}
	function error(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.errors) {
	    console.log('Error: ' + msg);
	    console.log(backtrace());
	  }
	  throw new Error(msg);
	}
	function backtrace() {
	  try {
	    throw new Error();
	  } catch (e) {
	    return e.stack ? e.stack.split('\n').slice(2).join('\n') : '';
	  }
	}
	function assert(cond, msg) {
	  if (!cond) {
	    error(msg);
	  }
	}
	var UNSUPPORTED_FEATURES = {
	  unknown: 'unknown',
	  forms: 'forms',
	  javaScript: 'javaScript',
	  smask: 'smask',
	  shadingPattern: 'shadingPattern',
	  font: 'font'
	};
	function isSameOrigin(baseUrl, otherUrl) {
	  try {
	    var base = new URL(baseUrl);
	    if (!base.origin || base.origin === 'null') {
	      return false;
	    }
	  } catch (e) {
	    return false;
	  }
	  var other = new URL(otherUrl, base);
	  return base.origin === other.origin;
	}
	function isValidProtocol(url) {
	  if (!url) {
	    return false;
	  }
	  switch (url.protocol) {
	    case 'http:':
	    case 'https:':
	    case 'ftp:':
	    case 'mailto:':
	    case 'tel:':
	      return true;
	    default:
	      return false;
	  }
	}
	function createValidAbsoluteUrl(url, baseUrl) {
	  if (!url) {
	    return null;
	  }
	  try {
	    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
	    if (isValidProtocol(absoluteUrl)) {
	      return absoluteUrl;
	    }
	  } catch (ex) {}
	  return null;
	}
	function shadow(obj, prop, value) {
	  Object.defineProperty(obj, prop, {
	    value: value,
	    enumerable: true,
	    configurable: true,
	    writable: false
	  });
	  return value;
	}
	function getLookupTableFactory(initializer) {
	  var lookup;
	  return function () {
	    if (initializer) {
	      lookup = Object.create(null);
	      initializer(lookup);
	      initializer = null;
	    }
	    return lookup;
	  };
	}
	var PasswordResponses = {
	  NEED_PASSWORD: 1,
	  INCORRECT_PASSWORD: 2
	};
	var PasswordException = function PasswordExceptionClosure() {
	  function PasswordException(msg, code) {
	    this.name = 'PasswordException';
	    this.message = msg;
	    this.code = code;
	  }
	  PasswordException.prototype = new Error();
	  PasswordException.constructor = PasswordException;
	  return PasswordException;
	}();
	var UnknownErrorException = function UnknownErrorExceptionClosure() {
	  function UnknownErrorException(msg, details) {
	    this.name = 'UnknownErrorException';
	    this.message = msg;
	    this.details = details;
	  }
	  UnknownErrorException.prototype = new Error();
	  UnknownErrorException.constructor = UnknownErrorException;
	  return UnknownErrorException;
	}();
	var InvalidPDFException = function InvalidPDFExceptionClosure() {
	  function InvalidPDFException(msg) {
	    this.name = 'InvalidPDFException';
	    this.message = msg;
	  }
	  InvalidPDFException.prototype = new Error();
	  InvalidPDFException.constructor = InvalidPDFException;
	  return InvalidPDFException;
	}();
	var MissingPDFException = function MissingPDFExceptionClosure() {
	  function MissingPDFException(msg) {
	    this.name = 'MissingPDFException';
	    this.message = msg;
	  }
	  MissingPDFException.prototype = new Error();
	  MissingPDFException.constructor = MissingPDFException;
	  return MissingPDFException;
	}();
	var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
	  function UnexpectedResponseException(msg, status) {
	    this.name = 'UnexpectedResponseException';
	    this.message = msg;
	    this.status = status;
	  }
	  UnexpectedResponseException.prototype = new Error();
	  UnexpectedResponseException.constructor = UnexpectedResponseException;
	  return UnexpectedResponseException;
	}();
	var NotImplementedException = function NotImplementedExceptionClosure() {
	  function NotImplementedException(msg) {
	    this.message = msg;
	  }
	  NotImplementedException.prototype = new Error();
	  NotImplementedException.prototype.name = 'NotImplementedException';
	  NotImplementedException.constructor = NotImplementedException;
	  return NotImplementedException;
	}();
	var MissingDataException = function MissingDataExceptionClosure() {
	  function MissingDataException(begin, end) {
	    this.begin = begin;
	    this.end = end;
	    this.message = 'Missing data [' + begin + ', ' + end + ')';
	  }
	  MissingDataException.prototype = new Error();
	  MissingDataException.prototype.name = 'MissingDataException';
	  MissingDataException.constructor = MissingDataException;
	  return MissingDataException;
	}();
	var XRefParseException = function XRefParseExceptionClosure() {
	  function XRefParseException(msg) {
	    this.message = msg;
	  }
	  XRefParseException.prototype = new Error();
	  XRefParseException.prototype.name = 'XRefParseException';
	  XRefParseException.constructor = XRefParseException;
	  return XRefParseException;
	}();
	var NullCharactersRegExp = /\x00/g;
	function removeNullCharacters(str) {
	  if (typeof str !== 'string') {
	    warn('The argument for removeNullCharacters must be a string.');
	    return str;
	  }
	  return str.replace(NullCharactersRegExp, '');
	}
	function bytesToString(bytes) {
	  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
	  var length = bytes.length;
	  var MAX_ARGUMENT_COUNT = 8192;
	  if (length < MAX_ARGUMENT_COUNT) {
	    return String.fromCharCode.apply(null, bytes);
	  }
	  var strBuf = [];
	  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
	    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
	    var chunk = bytes.subarray(i, chunkEnd);
	    strBuf.push(String.fromCharCode.apply(null, chunk));
	  }
	  return strBuf.join('');
	}
	function stringToBytes(str) {
	  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
	  var length = str.length;
	  var bytes = new Uint8Array(length);
	  for (var i = 0; i < length; ++i) {
	    bytes[i] = str.charCodeAt(i) & 0xFF;
	  }
	  return bytes;
	}
	function arrayByteLength(arr) {
	  if (arr.length !== undefined) {
	    return arr.length;
	  }
	  assert(arr.byteLength !== undefined);
	  return arr.byteLength;
	}
	function arraysToBytes(arr) {
	  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
	    return arr[0];
	  }
	  var resultLength = 0;
	  var i,
	      ii = arr.length;
	  var item, itemLength;
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    itemLength = arrayByteLength(item);
	    resultLength += itemLength;
	  }
	  var pos = 0;
	  var data = new Uint8Array(resultLength);
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    if (!(item instanceof Uint8Array)) {
	      if (typeof item === 'string') {
	        item = stringToBytes(item);
	      } else {
	        item = new Uint8Array(item);
	      }
	    }
	    itemLength = item.byteLength;
	    data.set(item, pos);
	    pos += itemLength;
	  }
	  return data;
	}
	function string32(value) {
	  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
	}
	function log2(x) {
	  var n = 1,
	      i = 0;
	  while (x > n) {
	    n <<= 1;
	    i++;
	  }
	  return i;
	}
	function readInt8(data, start) {
	  return data[start] << 24 >> 24;
	}
	function readUint16(data, offset) {
	  return data[offset] << 8 | data[offset + 1];
	}
	function readUint32(data, offset) {
	  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
	}
	function isLittleEndian() {
	  var buffer8 = new Uint8Array(4);
	  buffer8[0] = 1;
	  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
	  return view32[0] === 1;
	}
	function isEvalSupported() {
	  try {
	    new Function('');
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
	var Util = function UtilClosure() {
	  function Util() {}
	  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
	  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
	    rgbBuf[1] = r;
	    rgbBuf[3] = g;
	    rgbBuf[5] = b;
	    return rgbBuf.join('');
	  };
	  Util.transform = function Util_transform(m1, m2) {
	    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
	  };
	  Util.applyTransform = function Util_applyTransform(p, m) {
	    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
	    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
	    return [xt, yt];
	  };
	  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
	    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
	    return [xt, yt];
	  };
	  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
	    var p1 = Util.applyTransform(r, m);
	    var p2 = Util.applyTransform(r.slice(2, 4), m);
	    var p3 = Util.applyTransform([r[0], r[3]], m);
	    var p4 = Util.applyTransform([r[2], r[1]], m);
	    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
	  };
	  Util.inverseTransform = function Util_inverseTransform(m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
	  };
	  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
	    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
	  };
	  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
	    var transpose = [m[0], m[2], m[1], m[3]];
	    var a = m[0] * transpose[0] + m[1] * transpose[2];
	    var b = m[0] * transpose[1] + m[1] * transpose[3];
	    var c = m[2] * transpose[0] + m[3] * transpose[2];
	    var d = m[2] * transpose[1] + m[3] * transpose[3];
	    var first = (a + d) / 2;
	    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
	    var sx = first + second || 1;
	    var sy = first - second || 1;
	    return [Math.sqrt(sx), Math.sqrt(sy)];
	  };
	  Util.normalizeRect = function Util_normalizeRect(rect) {
	    var r = rect.slice(0);
	    if (rect[0] > rect[2]) {
	      r[0] = rect[2];
	      r[2] = rect[0];
	    }
	    if (rect[1] > rect[3]) {
	      r[1] = rect[3];
	      r[3] = rect[1];
	    }
	    return r;
	  };
	  Util.intersect = function Util_intersect(rect1, rect2) {
	    function compare(a, b) {
	      return a - b;
	    }
	    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
	        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
	        result = [];
	    rect1 = Util.normalizeRect(rect1);
	    rect2 = Util.normalizeRect(rect2);
	    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
	      result[0] = orderedX[1];
	      result[2] = orderedX[2];
	    } else {
	      return false;
	    }
	    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
	      result[1] = orderedY[1];
	      result[3] = orderedY[2];
	    } else {
	      return false;
	    }
	    return result;
	  };
	  Util.sign = function Util_sign(num) {
	    return num < 0 ? -1 : 1;
	  };
	  var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
	  Util.toRoman = function Util_toRoman(number, lowerCase) {
	    assert(isInt(number) && number > 0, 'The number should be a positive integer.');
	    var pos,
	        romanBuf = [];
	    while (number >= 1000) {
	      number -= 1000;
	      romanBuf.push('M');
	    }
	    pos = number / 100 | 0;
	    number %= 100;
	    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
	    pos = number / 10 | 0;
	    number %= 10;
	    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
	    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
	    var romanStr = romanBuf.join('');
	    return lowerCase ? romanStr.toLowerCase() : romanStr;
	  };
	  Util.appendToArray = function Util_appendToArray(arr1, arr2) {
	    Array.prototype.push.apply(arr1, arr2);
	  };
	  Util.prependToArray = function Util_prependToArray(arr1, arr2) {
	    Array.prototype.unshift.apply(arr1, arr2);
	  };
	  Util.extendObj = function extendObj(obj1, obj2) {
	    for (var key in obj2) {
	      obj1[key] = obj2[key];
	    }
	  };
	  Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
	    while (dict && !dict.has(name)) {
	      dict = dict.get('Parent');
	    }
	    if (!dict) {
	      return null;
	    }
	    return getArray ? dict.getArray(name) : dict.get(name);
	  };
	  Util.inherit = function Util_inherit(sub, base, prototype) {
	    sub.prototype = Object.create(base.prototype);
	    sub.prototype.constructor = sub;
	    for (var prop in prototype) {
	      sub.prototype[prop] = prototype[prop];
	    }
	  };
	  Util.loadScript = function Util_loadScript(src, callback) {
	    var script = document.createElement('script');
	    var loaded = false;
	    script.setAttribute('src', src);
	    if (callback) {
	      script.onload = function () {
	        if (!loaded) {
	          callback();
	        }
	        loaded = true;
	      };
	    }
	    document.getElementsByTagName('head')[0].appendChild(script);
	  };
	  return Util;
	}();
	var PageViewport = function PageViewportClosure() {
	  function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
	    this.viewBox = viewBox;
	    this.scale = scale;
	    this.rotation = rotation;
	    this.offsetX = offsetX;
	    this.offsetY = offsetY;
	    var centerX = (viewBox[2] + viewBox[0]) / 2;
	    var centerY = (viewBox[3] + viewBox[1]) / 2;
	    var rotateA, rotateB, rotateC, rotateD;
	    rotation = rotation % 360;
	    rotation = rotation < 0 ? rotation + 360 : rotation;
	    switch (rotation) {
	      case 180:
	        rotateA = -1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = 1;
	        break;
	      case 90:
	        rotateA = 0;
	        rotateB = 1;
	        rotateC = 1;
	        rotateD = 0;
	        break;
	      case 270:
	        rotateA = 0;
	        rotateB = -1;
	        rotateC = -1;
	        rotateD = 0;
	        break;
	      default:
	        rotateA = 1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = -1;
	        break;
	    }
	    if (dontFlip) {
	      rotateC = -rotateC;
	      rotateD = -rotateD;
	    }
	    var offsetCanvasX, offsetCanvasY;
	    var width, height;
	    if (rotateA === 0) {
	      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
	      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
	      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
	    } else {
	      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
	      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
	      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
	    }
	    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
	    this.width = width;
	    this.height = height;
	    this.fontScale = scale;
	  }
	  PageViewport.prototype = {
	    clone: function PageViewPort_clone(args) {
	      args = args || {};
	      var scale = 'scale' in args ? args.scale : this.scale;
	      var rotation = 'rotation' in args ? args.rotation : this.rotation;
	      return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
	    },
	    convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
	      return Util.applyTransform([x, y], this.transform);
	    },
	    convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
	      var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
	      var br = Util.applyTransform([rect[2], rect[3]], this.transform);
	      return [tl[0], tl[1], br[0], br[1]];
	    },
	    convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
	      return Util.applyInverseTransform([x, y], this.transform);
	    }
	  };
	  return PageViewport;
	}();
	var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
	function stringToPDFString(str) {
	  var i,
	      n = str.length,
	      strBuf = [];
	  if (str[0] === '\xFE' && str[1] === '\xFF') {
	    for (i = 2; i < n; i += 2) {
	      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
	    }
	  } else {
	    for (i = 0; i < n; ++i) {
	      var code = PDFStringTranslateTable[str.charCodeAt(i)];
	      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
	    }
	  }
	  return strBuf.join('');
	}
	function stringToUTF8String(str) {
	  return decodeURIComponent(escape(str));
	}
	function utf8StringToString(str) {
	  return unescape(encodeURIComponent(str));
	}
	function isEmptyObj(obj) {
	  for (var key in obj) {
	    return false;
	  }
	  return true;
	}
	function isBool(v) {
	  return typeof v === 'boolean';
	}
	function isInt(v) {
	  return typeof v === 'number' && (v | 0) === v;
	}
	function isNum(v) {
	  return typeof v === 'number';
	}
	function isString(v) {
	  return typeof v === 'string';
	}
	function isArray(v) {
	  return v instanceof Array;
	}
	function isArrayBuffer(v) {
	  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
	}
	function isSpace(ch) {
	  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
	}
	function isNodeJS() {
	  if (typeof __pdfjsdev_webpack__ === 'undefined') {
	    return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
	  }
	  return false;
	}
	function createPromiseCapability() {
	  var capability = {};
	  capability.promise = new Promise(function (resolve, reject) {
	    capability.resolve = resolve;
	    capability.reject = reject;
	  });
	  return capability;
	}
	var StatTimer = function StatTimerClosure() {
	  function rpad(str, pad, length) {
	    while (str.length < length) {
	      str += pad;
	    }
	    return str;
	  }
	  function StatTimer() {
	    this.started = Object.create(null);
	    this.times = [];
	    this.enabled = true;
	  }
	  StatTimer.prototype = {
	    time: function StatTimer_time(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (name in this.started) {
	        warn('Timer is already running for ' + name);
	      }
	      this.started[name] = Date.now();
	    },
	    timeEnd: function StatTimer_timeEnd(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (!(name in this.started)) {
	        warn('Timer has not been started for ' + name);
	      }
	      this.times.push({
	        'name': name,
	        'start': this.started[name],
	        'end': Date.now()
	      });
	      delete this.started[name];
	    },
	    toString: function StatTimer_toString() {
	      var i, ii;
	      var times = this.times;
	      var out = '';
	      var longest = 0;
	      for (i = 0, ii = times.length; i < ii; ++i) {
	        var name = times[i]['name'];
	        if (name.length > longest) {
	          longest = name.length;
	        }
	      }
	      for (i = 0, ii = times.length; i < ii; ++i) {
	        var span = times[i];
	        var duration = span.end - span.start;
	        out += rpad(span['name'], ' ', longest) + ' ' + duration + 'ms\n';
	      }
	      return out;
	    }
	  };
	  return StatTimer;
	}();
	var createBlob = function createBlob(data, contentType) {
	  if (typeof Blob !== 'undefined') {
	    return new Blob([data], { type: contentType });
	  }
	  throw new Error('The "Blob" constructor is not supported.');
	};
	var createObjectURL = function createObjectURLClosure() {
	  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	  return function createObjectURL(data, contentType) {
	    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (!forceDataSchema && URL.createObjectURL) {
	      var blob = createBlob(data, contentType);
	      return URL.createObjectURL(blob);
	    }
	    var buffer = 'data:' + contentType + ';base64,';
	    for (var i = 0, ii = data.length; i < ii; i += 3) {
	      var b1 = data[i] & 0xFF;
	      var b2 = data[i + 1] & 0xFF;
	      var b3 = data[i + 2] & 0xFF;
	      var d1 = b1 >> 2,
	          d2 = (b1 & 3) << 4 | b2 >> 4;
	      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
	      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
	    }
	    return buffer;
	  };
	}();
	function MessageHandler(sourceName, targetName, comObj) {
	  var _this = this;
	
	  this.sourceName = sourceName;
	  this.targetName = targetName;
	  this.comObj = comObj;
	  this.callbackIndex = 1;
	  this.postMessageTransfers = true;
	  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
	  var ah = this.actionHandler = Object.create(null);
	  this._onComObjOnMessage = function (event) {
	    var data = event.data;
	    if (data.targetName !== _this.sourceName) {
	      return;
	    }
	    if (data.isReply) {
	      var callbackId = data.callbackId;
	      if (data.callbackId in callbacksCapabilities) {
	        var callback = callbacksCapabilities[callbackId];
	        delete callbacksCapabilities[callbackId];
	        if ('error' in data) {
	          callback.reject(data.error);
	        } else {
	          callback.resolve(data.data);
	        }
	      } else {
	        error('Cannot resolve callback ' + callbackId);
	      }
	    } else if (data.action in ah) {
	      var action = ah[data.action];
	      if (data.callbackId) {
	        var sourceName = _this.sourceName;
	        var targetName = data.sourceName;
	        Promise.resolve().then(function () {
	          return action[0].call(action[1], data.data);
	        }).then(function (result) {
	          comObj.postMessage({
	            sourceName: sourceName,
	            targetName: targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            data: result
	          });
	        }, function (reason) {
	          if (reason instanceof Error) {
	            reason = reason + '';
	          }
	          comObj.postMessage({
	            sourceName: sourceName,
	            targetName: targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            error: reason
	          });
	        });
	      } else {
	        action[0].call(action[1], data.data);
	      }
	    } else {
	      error('Unknown action from worker: ' + data.action);
	    }
	  };
	  comObj.addEventListener('message', this._onComObjOnMessage);
	}
	MessageHandler.prototype = {
	  on: function on(actionName, handler, scope) {
	    var ah = this.actionHandler;
	    if (ah[actionName]) {
	      error('There is already an actionName called "' + actionName + '"');
	    }
	    ah[actionName] = [handler, scope];
	  },
	  send: function send(actionName, data, transfers) {
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data
	    };
	    this.postMessage(message, transfers);
	  },
	  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
	    var callbackId = this.callbackIndex++;
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data,
	      callbackId: callbackId
	    };
	    var capability = createPromiseCapability();
	    this.callbacksCapabilities[callbackId] = capability;
	    try {
	      this.postMessage(message, transfers);
	    } catch (e) {
	      capability.reject(e);
	    }
	    return capability.promise;
	  },
	  postMessage: function postMessage(message, transfers) {
	    if (transfers && this.postMessageTransfers) {
	      this.comObj.postMessage(message, transfers);
	    } else {
	      this.comObj.postMessage(message);
	    }
	  },
	  destroy: function destroy() {
	    this.comObj.removeEventListener('message', this._onComObjOnMessage);
	  }
	};
	function loadJpegStream(id, imageUrl, objs) {
	  var img = new Image();
	  img.onload = function loadJpegStream_onloadClosure() {
	    objs.resolve(id, img);
	  };
	  img.onerror = function loadJpegStream_onerrorClosure() {
	    objs.resolve(id, null);
	    warn('Error during JPEG image loading');
	  };
	  img.src = imageUrl;
	}
	exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
	exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
	exports.OPS = OPS;
	exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
	exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
	exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
	exports.AnnotationFieldFlag = AnnotationFieldFlag;
	exports.AnnotationFlag = AnnotationFlag;
	exports.AnnotationType = AnnotationType;
	exports.FontType = FontType;
	exports.ImageKind = ImageKind;
	exports.CMapCompressionType = CMapCompressionType;
	exports.InvalidPDFException = InvalidPDFException;
	exports.MessageHandler = MessageHandler;
	exports.MissingDataException = MissingDataException;
	exports.MissingPDFException = MissingPDFException;
	exports.NotImplementedException = NotImplementedException;
	exports.PageViewport = PageViewport;
	exports.PasswordException = PasswordException;
	exports.PasswordResponses = PasswordResponses;
	exports.StatTimer = StatTimer;
	exports.StreamType = StreamType;
	exports.TextRenderingMode = TextRenderingMode;
	exports.UnexpectedResponseException = UnexpectedResponseException;
	exports.UnknownErrorException = UnknownErrorException;
	exports.Util = Util;
	exports.XRefParseException = XRefParseException;
	exports.arrayByteLength = arrayByteLength;
	exports.arraysToBytes = arraysToBytes;
	exports.assert = assert;
	exports.bytesToString = bytesToString;
	exports.createBlob = createBlob;
	exports.createPromiseCapability = createPromiseCapability;
	exports.createObjectURL = createObjectURL;
	exports.deprecated = deprecated;
	exports.error = error;
	exports.getLookupTableFactory = getLookupTableFactory;
	exports.getVerbosityLevel = getVerbosityLevel;
	exports.globalScope = globalScope;
	exports.info = info;
	exports.isArray = isArray;
	exports.isArrayBuffer = isArrayBuffer;
	exports.isBool = isBool;
	exports.isEmptyObj = isEmptyObj;
	exports.isInt = isInt;
	exports.isNum = isNum;
	exports.isString = isString;
	exports.isSpace = isSpace;
	exports.isNodeJS = isNodeJS;
	exports.isSameOrigin = isSameOrigin;
	exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
	exports.isLittleEndian = isLittleEndian;
	exports.isEvalSupported = isEvalSupported;
	exports.loadJpegStream = loadJpegStream;
	exports.log2 = log2;
	exports.readInt8 = readInt8;
	exports.readUint16 = readUint16;
	exports.readUint32 = readUint32;
	exports.removeNullCharacters = removeNullCharacters;
	exports.setVerbosityLevel = setVerbosityLevel;
	exports.shadow = shadow;
	exports.string32 = string32;
	exports.stringToBytes = stringToBytes;
	exports.stringToPDFString = stringToPDFString;
	exports.stringToUTF8String = stringToUTF8String;
	exports.utf8StringToString = utf8StringToString;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, __w_pdfjs_require__(9)))
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var sharedUtil = __w_pdfjs_require__(0);
	var isArray = sharedUtil.isArray;
	var EOF = {};
	var Name = function NameClosure() {
	  function Name(name) {
	    this.name = name;
	  }
	  Name.prototype = {};
	  var nameCache = Object.create(null);
	  Name.get = function Name_get(name) {
	    var nameValue = nameCache[name];
	    return nameValue ? nameValue : nameCache[name] = new Name(name);
	  };
	  return Name;
	}();
	var Cmd = function CmdClosure() {
	  function Cmd(cmd) {
	    this.cmd = cmd;
	  }
	  Cmd.prototype = {};
	  var cmdCache = Object.create(null);
	  Cmd.get = function Cmd_get(cmd) {
	    var cmdValue = cmdCache[cmd];
	    return cmdValue ? cmdValue : cmdCache[cmd] = new Cmd(cmd);
	  };
	  return Cmd;
	}();
	var Dict = function DictClosure() {
	  var nonSerializable = function nonSerializableClosure() {
	    return nonSerializable;
	  };
	  function Dict(xref) {
	    this.map = Object.create(null);
	    this.xref = xref;
	    this.objId = null;
	    this.suppressEncryption = false;
	    this.__nonSerializable__ = nonSerializable;
	  }
	  Dict.prototype = {
	    assignXref: function Dict_assignXref(newXref) {
	      this.xref = newXref;
	    },
	    get: function Dict_get(key1, key2, key3) {
	      var value;
	      var xref = this.xref,
	          suppressEncryption = this.suppressEncryption;
	      if (typeof (value = this.map[key1]) !== 'undefined' || key1 in this.map || typeof key2 === 'undefined') {
	        return xref ? xref.fetchIfRef(value, suppressEncryption) : value;
	      }
	      if (typeof (value = this.map[key2]) !== 'undefined' || key2 in this.map || typeof key3 === 'undefined') {
	        return xref ? xref.fetchIfRef(value, suppressEncryption) : value;
	      }
	      value = this.map[key3] || null;
	      return xref ? xref.fetchIfRef(value, suppressEncryption) : value;
	    },
	    getAsync: function Dict_getAsync(key1, key2, key3) {
	      var value;
	      var xref = this.xref,
	          suppressEncryption = this.suppressEncryption;
	      if (typeof (value = this.map[key1]) !== 'undefined' || key1 in this.map || typeof key2 === 'undefined') {
	        if (xref) {
	          return xref.fetchIfRefAsync(value, suppressEncryption);
	        }
	        return Promise.resolve(value);
	      }
	      if (typeof (value = this.map[key2]) !== 'undefined' || key2 in this.map || typeof key3 === 'undefined') {
	        if (xref) {
	          return xref.fetchIfRefAsync(value, suppressEncryption);
	        }
	        return Promise.resolve(value);
	      }
	      value = this.map[key3] || null;
	      if (xref) {
	        return xref.fetchIfRefAsync(value, suppressEncryption);
	      }
	      return Promise.resolve(value);
	    },
	    getArray: function Dict_getArray(key1, key2, key3) {
	      var value = this.get(key1, key2, key3);
	      var xref = this.xref,
	          suppressEncryption = this.suppressEncryption;
	      if (!isArray(value) || !xref) {
	        return value;
	      }
	      value = value.slice();
	      for (var i = 0, ii = value.length; i < ii; i++) {
	        if (!isRef(value[i])) {
	          continue;
	        }
	        value[i] = xref.fetch(value[i], suppressEncryption);
	      }
	      return value;
	    },
	    getRaw: function Dict_getRaw(key) {
	      return this.map[key];
	    },
	    getKeys: function Dict_getKeys() {
	      return Object.keys(this.map);
	    },
	    set: function Dict_set(key, value) {
	      this.map[key] = value;
	    },
	    has: function Dict_has(key) {
	      return key in this.map;
	    },
	    forEach: function Dict_forEach(callback) {
	      for (var key in this.map) {
	        callback(key, this.get(key));
	      }
	    }
	  };
	  Dict.empty = new Dict(null);
	  Dict.merge = function Dict_merge(xref, dictArray) {
	    var mergedDict = new Dict(xref);
	    for (var i = 0, ii = dictArray.length; i < ii; i++) {
	      var dict = dictArray[i];
	      if (!isDict(dict)) {
	        continue;
	      }
	      for (var keyName in dict.map) {
	        if (mergedDict.map[keyName]) {
	          continue;
	        }
	        mergedDict.map[keyName] = dict.map[keyName];
	      }
	    }
	    return mergedDict;
	  };
	  return Dict;
	}();
	var Ref = function RefClosure() {
	  function Ref(num, gen) {
	    this.num = num;
	    this.gen = gen;
	  }
	  Ref.prototype = {
	    toString: function Ref_toString() {
	      var str = this.num + 'R';
	      if (this.gen !== 0) {
	        str += this.gen;
	      }
	      return str;
	    }
	  };
	  return Ref;
	}();
	var RefSet = function RefSetClosure() {
	  function RefSet() {
	    this.dict = Object.create(null);
	  }
	  RefSet.prototype = {
	    has: function RefSet_has(ref) {
	      return ref.toString() in this.dict;
	    },
	    put: function RefSet_put(ref) {
	      this.dict[ref.toString()] = true;
	    },
	    remove: function RefSet_remove(ref) {
	      delete this.dict[ref.toString()];
	    }
	  };
	  return RefSet;
	}();
	var RefSetCache = function RefSetCacheClosure() {
	  function RefSetCache() {
	    this.dict = Object.create(null);
	  }
	  RefSetCache.prototype = {
	    get: function RefSetCache_get(ref) {
	      return this.dict[ref.toString()];
	    },
	    has: function RefSetCache_has(ref) {
	      return ref.toString() in this.dict;
	    },
	    put: function RefSetCache_put(ref, obj) {
	      this.dict[ref.toString()] = obj;
	    },
	    putAlias: function RefSetCache_putAlias(ref, aliasRef) {
	      this.dict[ref.toString()] = this.get(aliasRef);
	    },
	    forEach: function RefSetCache_forEach(fn, thisArg) {
	      for (var i in this.dict) {
	        fn.call(thisArg, this.dict[i]);
	      }
	    },
	    clear: function RefSetCache_clear() {
	      this.dict = Object.create(null);
	    }
	  };
	  return RefSetCache;
	}();
	function isEOF(v) {
	  return v === EOF;
	}
	function isName(v, name) {
	  return v instanceof Name && (name === undefined || v.name === name);
	}
	function isCmd(v, cmd) {
	  return v instanceof Cmd && (cmd === undefined || v.cmd === cmd);
	}
	function isDict(v, type) {
	  return v instanceof Dict && (type === undefined || isName(v.get('Type'), type));
	}
	function isRef(v) {
	  return v instanceof Ref;
	}
	function isRefsEqual(v1, v2) {
	  return v1.num === v2.num && v1.gen === v2.gen;
	}
	function isStream(v) {
	  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.getBytes !== undefined;
	}
	exports.EOF = EOF;
	exports.Cmd = Cmd;
	exports.Dict = Dict;
	exports.Name = Name;
	exports.Ref = Ref;
	exports.RefSet = RefSet;
	exports.RefSetCache = RefSetCache;
	exports.isEOF = isEOF;
	exports.isCmd = isCmd;
	exports.isDict = isDict;
	exports.isName = isName;
	exports.isRef = isRef;
	exports.isRefsEqual = isRefsEqual;
	exports.isStream = isStream;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var coreJbig2 = __w_pdfjs_require__(28);
	var coreJpg = __w_pdfjs_require__(29);
	var coreJpx = __w_pdfjs_require__(15);
	var Util = sharedUtil.Util;
	var error = sharedUtil.error;
	var info = sharedUtil.info;
	var isInt = sharedUtil.isInt;
	var isArray = sharedUtil.isArray;
	var createObjectURL = sharedUtil.createObjectURL;
	var shadow = sharedUtil.shadow;
	var isSpace = sharedUtil.isSpace;
	var Dict = corePrimitives.Dict;
	var isDict = corePrimitives.isDict;
	var isStream = corePrimitives.isStream;
	var Jbig2Image = coreJbig2.Jbig2Image;
	var JpegImage = coreJpg.JpegImage;
	var JpxImage = coreJpx.JpxImage;
	var Stream = function StreamClosure() {
	  function Stream(arrayBuffer, start, length, dict) {
	    this.bytes = arrayBuffer instanceof Uint8Array ? arrayBuffer : new Uint8Array(arrayBuffer);
	    this.start = start || 0;
	    this.pos = this.start;
	    this.end = start + length || this.bytes.length;
	    this.dict = dict;
	  }
	  Stream.prototype = {
	    get length() {
	      return this.end - this.start;
	    },
	    get isEmpty() {
	      return this.length === 0;
	    },
	    getByte: function Stream_getByte() {
	      if (this.pos >= this.end) {
	        return -1;
	      }
	      return this.bytes[this.pos++];
	    },
	    getUint16: function Stream_getUint16() {
	      var b0 = this.getByte();
	      var b1 = this.getByte();
	      if (b0 === -1 || b1 === -1) {
	        return -1;
	      }
	      return (b0 << 8) + b1;
	    },
	    getInt32: function Stream_getInt32() {
	      var b0 = this.getByte();
	      var b1 = this.getByte();
	      var b2 = this.getByte();
	      var b3 = this.getByte();
	      return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
	    },
	    getBytes: function Stream_getBytes(length) {
	      var bytes = this.bytes;
	      var pos = this.pos;
	      var strEnd = this.end;
	      if (!length) {
	        return bytes.subarray(pos, strEnd);
	      }
	      var end = pos + length;
	      if (end > strEnd) {
	        end = strEnd;
	      }
	      this.pos = end;
	      return bytes.subarray(pos, end);
	    },
	    peekByte: function Stream_peekByte() {
	      var peekedByte = this.getByte();
	      this.pos--;
	      return peekedByte;
	    },
	    peekBytes: function Stream_peekBytes(length) {
	      var bytes = this.getBytes(length);
	      this.pos -= bytes.length;
	      return bytes;
	    },
	    skip: function Stream_skip(n) {
	      if (!n) {
	        n = 1;
	      }
	      this.pos += n;
	    },
	    reset: function Stream_reset() {
	      this.pos = this.start;
	    },
	    moveStart: function Stream_moveStart() {
	      this.start = this.pos;
	    },
	    makeSubStream: function Stream_makeSubStream(start, length, dict) {
	      return new Stream(this.bytes.buffer, start, length, dict);
	    }
	  };
	  return Stream;
	}();
	var StringStream = function StringStreamClosure() {
	  function StringStream(str) {
	    var length = str.length;
	    var bytes = new Uint8Array(length);
	    for (var n = 0; n < length; ++n) {
	      bytes[n] = str.charCodeAt(n);
	    }
	    Stream.call(this, bytes);
	  }
	  StringStream.prototype = Stream.prototype;
	  return StringStream;
	}();
	var DecodeStream = function DecodeStreamClosure() {
	  var emptyBuffer = new Uint8Array(0);
	  function DecodeStream(maybeMinBufferLength) {
	    this.pos = 0;
	    this.bufferLength = 0;
	    this.eof = false;
	    this.buffer = emptyBuffer;
	    this.minBufferLength = 512;
	    if (maybeMinBufferLength) {
	      while (this.minBufferLength < maybeMinBufferLength) {
	        this.minBufferLength *= 2;
	      }
	    }
	  }
	  DecodeStream.prototype = {
	    get isEmpty() {
	      while (!this.eof && this.bufferLength === 0) {
	        this.readBlock();
	      }
	      return this.bufferLength === 0;
	    },
	    ensureBuffer: function DecodeStream_ensureBuffer(requested) {
	      var buffer = this.buffer;
	      if (requested <= buffer.byteLength) {
	        return buffer;
	      }
	      var size = this.minBufferLength;
	      while (size < requested) {
	        size *= 2;
	      }
	      var buffer2 = new Uint8Array(size);
	      buffer2.set(buffer);
	      return this.buffer = buffer2;
	    },
	    getByte: function DecodeStream_getByte() {
	      var pos = this.pos;
	      while (this.bufferLength <= pos) {
	        if (this.eof) {
	          return -1;
	        }
	        this.readBlock();
	      }
	      return this.buffer[this.pos++];
	    },
	    getUint16: function DecodeStream_getUint16() {
	      var b0 = this.getByte();
	      var b1 = this.getByte();
	      if (b0 === -1 || b1 === -1) {
	        return -1;
	      }
	      return (b0 << 8) + b1;
	    },
	    getInt32: function DecodeStream_getInt32() {
	      var b0 = this.getByte();
	      var b1 = this.getByte();
	      var b2 = this.getByte();
	      var b3 = this.getByte();
	      return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
	    },
	    getBytes: function DecodeStream_getBytes(length) {
	      var end,
	          pos = this.pos;
	      if (length) {
	        this.ensureBuffer(pos + length);
	        end = pos + length;
	        while (!this.eof && this.bufferLength < end) {
	          this.readBlock();
	        }
	        var bufEnd = this.bufferLength;
	        if (end > bufEnd) {
	          end = bufEnd;
	        }
	      } else {
	        while (!this.eof) {
	          this.readBlock();
	        }
	        end = this.bufferLength;
	      }
	      this.pos = end;
	      return this.buffer.subarray(pos, end);
	    },
	    peekByte: function DecodeStream_peekByte() {
	      var peekedByte = this.getByte();
	      this.pos--;
	      return peekedByte;
	    },
	    peekBytes: function DecodeStream_peekBytes(length) {
	      var bytes = this.getBytes(length);
	      this.pos -= bytes.length;
	      return bytes;
	    },
	    makeSubStream: function DecodeStream_makeSubStream(start, length, dict) {
	      var end = start + length;
	      while (this.bufferLength <= end && !this.eof) {
	        this.readBlock();
	      }
	      return new Stream(this.buffer, start, length, dict);
	    },
	    skip: function DecodeStream_skip(n) {
	      if (!n) {
	        n = 1;
	      }
	      this.pos += n;
	    },
	    reset: function DecodeStream_reset() {
	      this.pos = 0;
	    },
	    getBaseStreams: function DecodeStream_getBaseStreams() {
	      if (this.str && this.str.getBaseStreams) {
	        return this.str.getBaseStreams();
	      }
	      return [];
	    }
	  };
	  return DecodeStream;
	}();
	var StreamsSequenceStream = function StreamsSequenceStreamClosure() {
	  function StreamsSequenceStream(streams) {
	    this.streams = streams;
	    DecodeStream.call(this, null);
	  }
	  StreamsSequenceStream.prototype = Object.create(DecodeStream.prototype);
	  StreamsSequenceStream.prototype.readBlock = function streamSequenceStreamReadBlock() {
	    var streams = this.streams;
	    if (streams.length === 0) {
	      this.eof = true;
	      return;
	    }
	    var stream = streams.shift();
	    var chunk = stream.getBytes();
	    var bufferLength = this.bufferLength;
	    var newLength = bufferLength + chunk.length;
	    var buffer = this.ensureBuffer(newLength);
	    buffer.set(chunk, bufferLength);
	    this.bufferLength = newLength;
	  };
	  StreamsSequenceStream.prototype.getBaseStreams = function StreamsSequenceStream_getBaseStreams() {
	    var baseStreams = [];
	    for (var i = 0, ii = this.streams.length; i < ii; i++) {
	      var stream = this.streams[i];
	      if (stream.getBaseStreams) {
	        Util.appendToArray(baseStreams, stream.getBaseStreams());
	      }
	    }
	    return baseStreams;
	  };
	  return StreamsSequenceStream;
	}();
	var FlateStream = function FlateStreamClosure() {
	  var codeLenCodeMap = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
	  var lengthDecode = new Int32Array([0x00003, 0x00004, 0x00005, 0x00006, 0x00007, 0x00008, 0x00009, 0x0000a, 0x1000b, 0x1000d, 0x1000f, 0x10011, 0x20013, 0x20017, 0x2001b, 0x2001f, 0x30023, 0x3002b, 0x30033, 0x3003b, 0x40043, 0x40053, 0x40063, 0x40073, 0x50083, 0x500a3, 0x500c3, 0x500e3, 0x00102, 0x00102, 0x00102]);
	  var distDecode = new Int32Array([0x00001, 0x00002, 0x00003, 0x00004, 0x10005, 0x10007, 0x20009, 0x2000d, 0x30011, 0x30019, 0x40021, 0x40031, 0x50041, 0x50061, 0x60081, 0x600c1, 0x70101, 0x70181, 0x80201, 0x80301, 0x90401, 0x90601, 0xa0801, 0xa0c01, 0xb1001, 0xb1801, 0xc2001, 0xc3001, 0xd4001, 0xd6001]);
	  var fixedLitCodeTab = [new Int32Array([0x70100, 0x80050, 0x80010, 0x80118, 0x70110, 0x80070, 0x80030, 0x900c0, 0x70108, 0x80060, 0x80020, 0x900a0, 0x80000, 0x80080, 0x80040, 0x900e0, 0x70104, 0x80058, 0x80018, 0x90090, 0x70114, 0x80078, 0x80038, 0x900d0, 0x7010c, 0x80068, 0x80028, 0x900b0, 0x80008, 0x80088, 0x80048, 0x900f0, 0x70102, 0x80054, 0x80014, 0x8011c, 0x70112, 0x80074, 0x80034, 0x900c8, 0x7010a, 0x80064, 0x80024, 0x900a8, 0x80004, 0x80084, 0x80044, 0x900e8, 0x70106, 0x8005c, 0x8001c, 0x90098, 0x70116, 0x8007c, 0x8003c, 0x900d8, 0x7010e, 0x8006c, 0x8002c, 0x900b8, 0x8000c, 0x8008c, 0x8004c, 0x900f8, 0x70101, 0x80052, 0x80012, 0x8011a, 0x70111, 0x80072, 0x80032, 0x900c4, 0x70109, 0x80062, 0x80022, 0x900a4, 0x80002, 0x80082, 0x80042, 0x900e4, 0x70105, 0x8005a, 0x8001a, 0x90094, 0x70115, 0x8007a, 0x8003a, 0x900d4, 0x7010d, 0x8006a, 0x8002a, 0x900b4, 0x8000a, 0x8008a, 0x8004a, 0x900f4, 0x70103, 0x80056, 0x80016, 0x8011e, 0x70113, 0x80076, 0x80036, 0x900cc, 0x7010b, 0x80066, 0x80026, 0x900ac, 0x80006, 0x80086, 0x80046, 0x900ec, 0x70107, 0x8005e, 0x8001e, 0x9009c, 0x70117, 0x8007e, 0x8003e, 0x900dc, 0x7010f, 0x8006e, 0x8002e, 0x900bc, 0x8000e, 0x8008e, 0x8004e, 0x900fc, 0x70100, 0x80051, 0x80011, 0x80119, 0x70110, 0x80071, 0x80031, 0x900c2, 0x70108, 0x80061, 0x80021, 0x900a2, 0x80001, 0x80081, 0x80041, 0x900e2, 0x70104, 0x80059, 0x80019, 0x90092, 0x70114, 0x80079, 0x80039, 0x900d2, 0x7010c, 0x80069, 0x80029, 0x900b2, 0x80009, 0x80089, 0x80049, 0x900f2, 0x70102, 0x80055, 0x80015, 0x8011d, 0x70112, 0x80075, 0x80035, 0x900ca, 0x7010a, 0x80065, 0x80025, 0x900aa, 0x80005, 0x80085, 0x80045, 0x900ea, 0x70106, 0x8005d, 0x8001d, 0x9009a, 0x70116, 0x8007d, 0x8003d, 0x900da, 0x7010e, 0x8006d, 0x8002d, 0x900ba, 0x8000d, 0x8008d, 0x8004d, 0x900fa, 0x70101, 0x80053, 0x80013, 0x8011b, 0x70111, 0x80073, 0x80033, 0x900c6, 0x70109, 0x80063, 0x80023, 0x900a6, 0x80003, 0x80083, 0x80043, 0x900e6, 0x70105, 0x8005b, 0x8001b, 0x90096, 0x70115, 0x8007b, 0x8003b, 0x900d6, 0x7010d, 0x8006b, 0x8002b, 0x900b6, 0x8000b, 0x8008b, 0x8004b, 0x900f6, 0x70103, 0x80057, 0x80017, 0x8011f, 0x70113, 0x80077, 0x80037, 0x900ce, 0x7010b, 0x80067, 0x80027, 0x900ae, 0x80007, 0x80087, 0x80047, 0x900ee, 0x70107, 0x8005f, 0x8001f, 0x9009e, 0x70117, 0x8007f, 0x8003f, 0x900de, 0x7010f, 0x8006f, 0x8002f, 0x900be, 0x8000f, 0x8008f, 0x8004f, 0x900fe, 0x70100, 0x80050, 0x80010, 0x80118, 0x70110, 0x80070, 0x80030, 0x900c1, 0x70108, 0x80060, 0x80020, 0x900a1, 0x80000, 0x80080, 0x80040, 0x900e1, 0x70104, 0x80058, 0x80018, 0x90091, 0x70114, 0x80078, 0x80038, 0x900d1, 0x7010c, 0x80068, 0x80028, 0x900b1, 0x80008, 0x80088, 0x80048, 0x900f1, 0x70102, 0x80054, 0x80014, 0x8011c, 0x70112, 0x80074, 0x80034, 0x900c9, 0x7010a, 0x80064, 0x80024, 0x900a9, 0x80004, 0x80084, 0x80044, 0x900e9, 0x70106, 0x8005c, 0x8001c, 0x90099, 0x70116, 0x8007c, 0x8003c, 0x900d9, 0x7010e, 0x8006c, 0x8002c, 0x900b9, 0x8000c, 0x8008c, 0x8004c, 0x900f9, 0x70101, 0x80052, 0x80012, 0x8011a, 0x70111, 0x80072, 0x80032, 0x900c5, 0x70109, 0x80062, 0x80022, 0x900a5, 0x80002, 0x80082, 0x80042, 0x900e5, 0x70105, 0x8005a, 0x8001a, 0x90095, 0x70115, 0x8007a, 0x8003a, 0x900d5, 0x7010d, 0x8006a, 0x8002a, 0x900b5, 0x8000a, 0x8008a, 0x8004a, 0x900f5, 0x70103, 0x80056, 0x80016, 0x8011e, 0x70113, 0x80076, 0x80036, 0x900cd, 0x7010b, 0x80066, 0x80026, 0x900ad, 0x80006, 0x80086, 0x80046, 0x900ed, 0x70107, 0x8005e, 0x8001e, 0x9009d, 0x70117, 0x8007e, 0x8003e, 0x900dd, 0x7010f, 0x8006e, 0x8002e, 0x900bd, 0x8000e, 0x8008e, 0x8004e, 0x900fd, 0x70100, 0x80051, 0x80011, 0x80119, 0x70110, 0x80071, 0x80031, 0x900c3, 0x70108, 0x80061, 0x80021, 0x900a3, 0x80001, 0x80081, 0x80041, 0x900e3, 0x70104, 0x80059, 0x80019, 0x90093, 0x70114, 0x80079, 0x80039, 0x900d3, 0x7010c, 0x80069, 0x80029, 0x900b3, 0x80009, 0x80089, 0x80049, 0x900f3, 0x70102, 0x80055, 0x80015, 0x8011d, 0x70112, 0x80075, 0x80035, 0x900cb, 0x7010a, 0x80065, 0x80025, 0x900ab, 0x80005, 0x80085, 0x80045, 0x900eb, 0x70106, 0x8005d, 0x8001d, 0x9009b, 0x70116, 0x8007d, 0x8003d, 0x900db, 0x7010e, 0x8006d, 0x8002d, 0x900bb, 0x8000d, 0x8008d, 0x8004d, 0x900fb, 0x70101, 0x80053, 0x80013, 0x8011b, 0x70111, 0x80073, 0x80033, 0x900c7, 0x70109, 0x80063, 0x80023, 0x900a7, 0x80003, 0x80083, 0x80043, 0x900e7, 0x70105, 0x8005b, 0x8001b, 0x90097, 0x70115, 0x8007b, 0x8003b, 0x900d7, 0x7010d, 0x8006b, 0x8002b, 0x900b7, 0x8000b, 0x8008b, 0x8004b, 0x900f7, 0x70103, 0x80057, 0x80017, 0x8011f, 0x70113, 0x80077, 0x80037, 0x900cf, 0x7010b, 0x80067, 0x80027, 0x900af, 0x80007, 0x80087, 0x80047, 0x900ef, 0x70107, 0x8005f, 0x8001f, 0x9009f, 0x70117, 0x8007f, 0x8003f, 0x900df, 0x7010f, 0x8006f, 0x8002f, 0x900bf, 0x8000f, 0x8008f, 0x8004f, 0x900ff]), 9];
	  var fixedDistCodeTab = [new Int32Array([0x50000, 0x50010, 0x50008, 0x50018, 0x50004, 0x50014, 0x5000c, 0x5001c, 0x50002, 0x50012, 0x5000a, 0x5001a, 0x50006, 0x50016, 0x5000e, 0x00000, 0x50001, 0x50011, 0x50009, 0x50019, 0x50005, 0x50015, 0x5000d, 0x5001d, 0x50003, 0x50013, 0x5000b, 0x5001b, 0x50007, 0x50017, 0x5000f, 0x00000]), 5];
	  function FlateStream(str, maybeLength) {
	    this.str = str;
	    this.dict = str.dict;
	    var cmf = str.getByte();
	    var flg = str.getByte();
	    if (cmf === -1 || flg === -1) {
	      error('Invalid header in flate stream: ' + cmf + ', ' + flg);
	    }
	    if ((cmf & 0x0f) !== 0x08) {
	      error('Unknown compression method in flate stream: ' + cmf + ', ' + flg);
	    }
	    if (((cmf << 8) + flg) % 31 !== 0) {
	      error('Bad FCHECK in flate stream: ' + cmf + ', ' + flg);
	    }
	    if (flg & 0x20) {
	      error('FDICT bit set in flate stream: ' + cmf + ', ' + flg);
	    }
	    this.codeSize = 0;
	    this.codeBuf = 0;
	    DecodeStream.call(this, maybeLength);
	  }
	  FlateStream.prototype = Object.create(DecodeStream.prototype);
	  FlateStream.prototype.getBits = function FlateStream_getBits(bits) {
	    var str = this.str;
	    var codeSize = this.codeSize;
	    var codeBuf = this.codeBuf;
	    var b;
	    while (codeSize < bits) {
	      if ((b = str.getByte()) === -1) {
	        error('Bad encoding in flate stream');
	      }
	      codeBuf |= b << codeSize;
	      codeSize += 8;
	    }
	    b = codeBuf & (1 << bits) - 1;
	    this.codeBuf = codeBuf >> bits;
	    this.codeSize = codeSize -= bits;
	    return b;
	  };
	  FlateStream.prototype.getCode = function FlateStream_getCode(table) {
	    var str = this.str;
	    var codes = table[0];
	    var maxLen = table[1];
	    var codeSize = this.codeSize;
	    var codeBuf = this.codeBuf;
	    var b;
	    while (codeSize < maxLen) {
	      if ((b = str.getByte()) === -1) {
	        break;
	      }
	      codeBuf |= b << codeSize;
	      codeSize += 8;
	    }
	    var code = codes[codeBuf & (1 << maxLen) - 1];
	    var codeLen = code >> 16;
	    var codeVal = code & 0xffff;
	    if (codeLen < 1 || codeSize < codeLen) {
	      error('Bad encoding in flate stream');
	    }
	    this.codeBuf = codeBuf >> codeLen;
	    this.codeSize = codeSize - codeLen;
	    return codeVal;
	  };
	  FlateStream.prototype.generateHuffmanTable = function flateStreamGenerateHuffmanTable(lengths) {
	    var n = lengths.length;
	    var maxLen = 0;
	    var i;
	    for (i = 0; i < n; ++i) {
	      if (lengths[i] > maxLen) {
	        maxLen = lengths[i];
	      }
	    }
	    var size = 1 << maxLen;
	    var codes = new Int32Array(size);
	    for (var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1) {
	      for (var val = 0; val < n; ++val) {
	        if (lengths[val] === len) {
	          var code2 = 0;
	          var t = code;
	          for (i = 0; i < len; ++i) {
	            code2 = code2 << 1 | t & 1;
	            t >>= 1;
	          }
	          for (i = code2; i < size; i += skip) {
	            codes[i] = len << 16 | val;
	          }
	          ++code;
	        }
	      }
	    }
	    return [codes, maxLen];
	  };
	  FlateStream.prototype.readBlock = function FlateStream_readBlock() {
	    var buffer, len;
	    var str = this.str;
	    var hdr = this.getBits(3);
	    if (hdr & 1) {
	      this.eof = true;
	    }
	    hdr >>= 1;
	    if (hdr === 0) {
	      var b;
	      if ((b = str.getByte()) === -1) {
	        error('Bad block header in flate stream');
	      }
	      var blockLen = b;
	      if ((b = str.getByte()) === -1) {
	        error('Bad block header in flate stream');
	      }
	      blockLen |= b << 8;
	      if ((b = str.getByte()) === -1) {
	        error('Bad block header in flate stream');
	      }
	      var check = b;
	      if ((b = str.getByte()) === -1) {
	        error('Bad block header in flate stream');
	      }
	      check |= b << 8;
	      if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) {
	        error('Bad uncompressed block length in flate stream');
	      }
	      this.codeBuf = 0;
	      this.codeSize = 0;
	      var bufferLength = this.bufferLength;
	      buffer = this.ensureBuffer(bufferLength + blockLen);
	      var end = bufferLength + blockLen;
	      this.bufferLength = end;
	      if (blockLen === 0) {
	        if (str.peekByte() === -1) {
	          this.eof = true;
	        }
	      } else {
	        for (var n = bufferLength; n < end; ++n) {
	          if ((b = str.getByte()) === -1) {
	            this.eof = true;
	            break;
	          }
	          buffer[n] = b;
	        }
	      }
	      return;
	    }
	    var litCodeTable;
	    var distCodeTable;
	    if (hdr === 1) {
	      litCodeTable = fixedLitCodeTab;
	      distCodeTable = fixedDistCodeTab;
	    } else if (hdr === 2) {
	      var numLitCodes = this.getBits(5) + 257;
	      var numDistCodes = this.getBits(5) + 1;
	      var numCodeLenCodes = this.getBits(4) + 4;
	      var codeLenCodeLengths = new Uint8Array(codeLenCodeMap.length);
	      var i;
	      for (i = 0; i < numCodeLenCodes; ++i) {
	        codeLenCodeLengths[codeLenCodeMap[i]] = this.getBits(3);
	      }
	      var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
	      len = 0;
	      i = 0;
	      var codes = numLitCodes + numDistCodes;
	      var codeLengths = new Uint8Array(codes);
	      var bitsLength, bitsOffset, what;
	      while (i < codes) {
	        var code = this.getCode(codeLenCodeTab);
	        if (code === 16) {
	          bitsLength = 2;
	          bitsOffset = 3;
	          what = len;
	        } else if (code === 17) {
	          bitsLength = 3;
	          bitsOffset = 3;
	          what = len = 0;
	        } else if (code === 18) {
	          bitsLength = 7;
	          bitsOffset = 11;
	          what = len = 0;
	        } else {
	          codeLengths[i++] = len = code;
	          continue;
	        }
	        var repeatLength = this.getBits(bitsLength) + bitsOffset;
	        while (repeatLength-- > 0) {
	          codeLengths[i++] = what;
	        }
	      }
	      litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
	      distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
	    } else {
	      error('Unknown block type in flate stream');
	    }
	    buffer = this.buffer;
	    var limit = buffer ? buffer.length : 0;
	    var pos = this.bufferLength;
	    while (true) {
	      var code1 = this.getCode(litCodeTable);
	      if (code1 < 256) {
	        if (pos + 1 >= limit) {
	          buffer = this.ensureBuffer(pos + 1);
	          limit = buffer.length;
	        }
	        buffer[pos++] = code1;
	        continue;
	      }
	      if (code1 === 256) {
	        this.bufferLength = pos;
	        return;
	      }
	      code1 -= 257;
	      code1 = lengthDecode[code1];
	      var code2 = code1 >> 16;
	      if (code2 > 0) {
	        code2 = this.getBits(code2);
	      }
	      len = (code1 & 0xffff) + code2;
	      code1 = this.getCode(distCodeTable);
	      code1 = distDecode[code1];
	      code2 = code1 >> 16;
	      if (code2 > 0) {
	        code2 = this.getBits(code2);
	      }
	      var dist = (code1 & 0xffff) + code2;
	      if (pos + len >= limit) {
	        buffer = this.ensureBuffer(pos + len);
	        limit = buffer.length;
	      }
	      for (var k = 0; k < len; ++k, ++pos) {
	        buffer[pos] = buffer[pos - dist];
	      }
	    }
	  };
	  return FlateStream;
	}();
	var PredictorStream = function PredictorStreamClosure() {
	  function PredictorStream(str, maybeLength, params) {
	    if (!isDict(params)) {
	      return str;
	    }
	    var predictor = this.predictor = params.get('Predictor') || 1;
	    if (predictor <= 1) {
	      return str;
	    }
	    if (predictor !== 2 && (predictor < 10 || predictor > 15)) {
	      error('Unsupported predictor: ' + predictor);
	    }
	    if (predictor === 2) {
	      this.readBlock = this.readBlockTiff;
	    } else {
	      this.readBlock = this.readBlockPng;
	    }
	    this.str = str;
	    this.dict = str.dict;
	    var colors = this.colors = params.get('Colors') || 1;
	    var bits = this.bits = params.get('BitsPerComponent') || 8;
	    var columns = this.columns = params.get('Columns') || 1;
	    this.pixBytes = colors * bits + 7 >> 3;
	    this.rowBytes = columns * colors * bits + 7 >> 3;
	    DecodeStream.call(this, maybeLength);
	    return this;
	  }
	  PredictorStream.prototype = Object.create(DecodeStream.prototype);
	  PredictorStream.prototype.readBlockTiff = function predictorStreamReadBlockTiff() {
	    var rowBytes = this.rowBytes;
	    var bufferLength = this.bufferLength;
	    var buffer = this.ensureBuffer(bufferLength + rowBytes);
	    var bits = this.bits;
	    var colors = this.colors;
	    var rawBytes = this.str.getBytes(rowBytes);
	    this.eof = !rawBytes.length;
	    if (this.eof) {
	      return;
	    }
	    var inbuf = 0,
	        outbuf = 0;
	    var inbits = 0,
	        outbits = 0;
	    var pos = bufferLength;
	    var i;
	    if (bits === 1 && colors === 1) {
	      for (i = 0; i < rowBytes; ++i) {
	        var c = rawBytes[i] ^ inbuf;
	        c ^= c >> 1;
	        c ^= c >> 2;
	        c ^= c >> 4;
	        inbuf = (c & 1) << 7;
	        buffer[pos++] = c;
	      }
	    } else if (bits === 8) {
	      for (i = 0; i < colors; ++i) {
	        buffer[pos++] = rawBytes[i];
	      }
	      for (; i < rowBytes; ++i) {
	        buffer[pos] = buffer[pos - colors] + rawBytes[i];
	        pos++;
	      }
	    } else {
	      var compArray = new Uint8Array(colors + 1);
	      var bitMask = (1 << bits) - 1;
	      var j = 0,
	          k = bufferLength;
	      var columns = this.columns;
	      for (i = 0; i < columns; ++i) {
	        for (var kk = 0; kk < colors; ++kk) {
	          if (inbits < bits) {
	            inbuf = inbuf << 8 | rawBytes[j++] & 0xFF;
	            inbits += 8;
	          }
	          compArray[kk] = compArray[kk] + (inbuf >> inbits - bits) & bitMask;
	          inbits -= bits;
	          outbuf = outbuf << bits | compArray[kk];
	          outbits += bits;
	          if (outbits >= 8) {
	            buffer[k++] = outbuf >> outbits - 8 & 0xFF;
	            outbits -= 8;
	          }
	        }
	      }
	      if (outbits > 0) {
	        buffer[k++] = (outbuf << 8 - outbits) + (inbuf & (1 << 8 - outbits) - 1);
	      }
	    }
	    this.bufferLength += rowBytes;
	  };
	  PredictorStream.prototype.readBlockPng = function predictorStreamReadBlockPng() {
	    var rowBytes = this.rowBytes;
	    var pixBytes = this.pixBytes;
	    var predictor = this.str.getByte();
	    var rawBytes = this.str.getBytes(rowBytes);
	    this.eof = !rawBytes.length;
	    if (this.eof) {
	      return;
	    }
	    var bufferLength = this.bufferLength;
	    var buffer = this.ensureBuffer(bufferLength + rowBytes);
	    var prevRow = buffer.subarray(bufferLength - rowBytes, bufferLength);
	    if (prevRow.length === 0) {
	      prevRow = new Uint8Array(rowBytes);
	    }
	    var i,
	        j = bufferLength,
	        up,
	        c;
	    switch (predictor) {
	      case 0:
	        for (i = 0; i < rowBytes; ++i) {
	          buffer[j++] = rawBytes[i];
	        }
	        break;
	      case 1:
	        for (i = 0; i < pixBytes; ++i) {
	          buffer[j++] = rawBytes[i];
	        }
	        for (; i < rowBytes; ++i) {
	          buffer[j] = buffer[j - pixBytes] + rawBytes[i] & 0xFF;
	          j++;
	        }
	        break;
	      case 2:
	        for (i = 0; i < rowBytes; ++i) {
	          buffer[j++] = prevRow[i] + rawBytes[i] & 0xFF;
	        }
	        break;
	      case 3:
	        for (i = 0; i < pixBytes; ++i) {
	          buffer[j++] = (prevRow[i] >> 1) + rawBytes[i];
	        }
	        for (; i < rowBytes; ++i) {
	          buffer[j] = (prevRow[i] + buffer[j - pixBytes] >> 1) + rawBytes[i] & 0xFF;
	          j++;
	        }
	        break;
	      case 4:
	        for (i = 0; i < pixBytes; ++i) {
	          up = prevRow[i];
	          c = rawBytes[i];
	          buffer[j++] = up + c;
	        }
	        for (; i < rowBytes; ++i) {
	          up = prevRow[i];
	          var upLeft = prevRow[i - pixBytes];
	          var left = buffer[j - pixBytes];
	          var p = left + up - upLeft;
	          var pa = p - left;
	          if (pa < 0) {
	            pa = -pa;
	          }
	          var pb = p - up;
	          if (pb < 0) {
	            pb = -pb;
	          }
	          var pc = p - upLeft;
	          if (pc < 0) {
	            pc = -pc;
	          }
	          c = rawBytes[i];
	          if (pa <= pb && pa <= pc) {
	            buffer[j++] = left + c;
	          } else if (pb <= pc) {
	            buffer[j++] = up + c;
	          } else {
	            buffer[j++] = upLeft + c;
	          }
	        }
	        break;
	      default:
	        error('Unsupported predictor: ' + predictor);
	    }
	    this.bufferLength += rowBytes;
	  };
	  return PredictorStream;
	}();
	var JpegStream = function JpegStreamClosure() {
	  function JpegStream(stream, maybeLength, dict, params) {
	    var ch;
	    while ((ch = stream.getByte()) !== -1) {
	      if (ch === 0xFF) {
	        stream.skip(-1);
	        break;
	      }
	    }
	    this.stream = stream;
	    this.maybeLength = maybeLength;
	    this.dict = dict;
	    this.params = params;
	    DecodeStream.call(this, maybeLength);
	  }
	  JpegStream.prototype = Object.create(DecodeStream.prototype);
	  Object.defineProperty(JpegStream.prototype, 'bytes', {
	    get: function JpegStream_bytes() {
	      return shadow(this, 'bytes', this.stream.getBytes(this.maybeLength));
	    },
	    configurable: true
	  });
	  JpegStream.prototype.ensureBuffer = function JpegStream_ensureBuffer(req) {
	    if (this.bufferLength) {
	      return;
	    }
	    var jpegImage = new JpegImage();
	    var decodeArr = this.dict.getArray('Decode', 'D');
	    if (this.forceRGB && isArray(decodeArr)) {
	      var bitsPerComponent = this.dict.get('BitsPerComponent') || 8;
	      var decodeArrLength = decodeArr.length;
	      var transform = new Int32Array(decodeArrLength);
	      var transformNeeded = false;
	      var maxValue = (1 << bitsPerComponent) - 1;
	      for (var i = 0; i < decodeArrLength; i += 2) {
	        transform[i] = (decodeArr[i + 1] - decodeArr[i]) * 256 | 0;
	        transform[i + 1] = decodeArr[i] * maxValue | 0;
	        if (transform[i] !== 256 || transform[i + 1] !== 0) {
	          transformNeeded = true;
	        }
	      }
	      if (transformNeeded) {
	        jpegImage.decodeTransform = transform;
	      }
	    }
	    if (isDict(this.params)) {
	      var colorTransform = this.params.get('ColorTransform');
	      if (isInt(colorTransform)) {
	        jpegImage.colorTransform = colorTransform;
	      }
	    }
	    jpegImage.parse(this.bytes);
	    var data = jpegImage.getData(this.drawWidth, this.drawHeight, this.forceRGB);
	    this.buffer = data;
	    this.bufferLength = data.length;
	    this.eof = true;
	  };
	  JpegStream.prototype.getBytes = function JpegStream_getBytes(length) {
	    this.ensureBuffer();
	    return this.buffer;
	  };
	  JpegStream.prototype.getIR = function JpegStream_getIR(forceDataSchema) {
	    return createObjectURL(this.bytes, 'image/jpeg', forceDataSchema);
	  };
	  return JpegStream;
	}();
	var JpxStream = function JpxStreamClosure() {
	  function JpxStream(stream, maybeLength, dict, params) {
	    this.stream = stream;
	    this.maybeLength = maybeLength;
	    this.dict = dict;
	    this.params = params;
	    DecodeStream.call(this, maybeLength);
	  }
	  JpxStream.prototype = Object.create(DecodeStream.prototype);
	  Object.defineProperty(JpxStream.prototype, 'bytes', {
	    get: function JpxStream_bytes() {
	      return shadow(this, 'bytes', this.stream.getBytes(this.maybeLength));
	    },
	    configurable: true
	  });
	  JpxStream.prototype.ensureBuffer = function JpxStream_ensureBuffer(req) {
	    if (this.bufferLength) {
	      return;
	    }
	    var jpxImage = new JpxImage();
	    jpxImage.parse(this.bytes);
	    var width = jpxImage.width;
	    var height = jpxImage.height;
	    var componentsCount = jpxImage.componentsCount;
	    var tileCount = jpxImage.tiles.length;
	    if (tileCount === 1) {
	      this.buffer = jpxImage.tiles[0].items;
	    } else {
	      var data = new Uint8Array(width * height * componentsCount);
	      for (var k = 0; k < tileCount; k++) {
	        var tileComponents = jpxImage.tiles[k];
	        var tileWidth = tileComponents.width;
	        var tileHeight = tileComponents.height;
	        var tileLeft = tileComponents.left;
	        var tileTop = tileComponents.top;
	        var src = tileComponents.items;
	        var srcPosition = 0;
	        var dataPosition = (width * tileTop + tileLeft) * componentsCount;
	        var imgRowSize = width * componentsCount;
	        var tileRowSize = tileWidth * componentsCount;
	        for (var j = 0; j < tileHeight; j++) {
	          var rowBytes = src.subarray(srcPosition, srcPosition + tileRowSize);
	          data.set(rowBytes, dataPosition);
	          srcPosition += tileRowSize;
	          dataPosition += imgRowSize;
	        }
	      }
	      this.buffer = data;
	    }
	    this.bufferLength = this.buffer.length;
	    this.eof = true;
	  };
	  return JpxStream;
	}();
	var Jbig2Stream = function Jbig2StreamClosure() {
	  function Jbig2Stream(stream, maybeLength, dict, params) {
	    this.stream = stream;
	    this.maybeLength = maybeLength;
	    this.dict = dict;
	    this.params = params;
	    DecodeStream.call(this, maybeLength);
	  }
	  Jbig2Stream.prototype = Object.create(DecodeStream.prototype);
	  Object.defineProperty(Jbig2Stream.prototype, 'bytes', {
	    get: function Jbig2Stream_bytes() {
	      return shadow(this, 'bytes', this.stream.getBytes(this.maybeLength));
	    },
	    configurable: true
	  });
	  Jbig2Stream.prototype.ensureBuffer = function Jbig2Stream_ensureBuffer(req) {
	    if (this.bufferLength) {
	      return;
	    }
	    var jbig2Image = new Jbig2Image();
	    var chunks = [];
	    if (isDict(this.params)) {
	      var globalsStream = this.params.get('JBIG2Globals');
	      if (isStream(globalsStream)) {
	        var globals = globalsStream.getBytes();
	        chunks.push({
	          data: globals,
	          start: 0,
	          end: globals.length
	        });
	      }
	    }
	    chunks.push({
	      data: this.bytes,
	      start: 0,
	      end: this.bytes.length
	    });
	    var data = jbig2Image.parseChunks(chunks);
	    var dataLength = data.length;
	    for (var i = 0; i < dataLength; i++) {
	      data[i] ^= 0xFF;
	    }
	    this.buffer = data;
	    this.bufferLength = dataLength;
	    this.eof = true;
	  };
	  return Jbig2Stream;
	}();
	var DecryptStream = function DecryptStreamClosure() {
	  function DecryptStream(str, maybeLength, decrypt) {
	    this.str = str;
	    this.dict = str.dict;
	    this.decrypt = decrypt;
	    this.nextChunk = null;
	    this.initialized = false;
	    DecodeStream.call(this, maybeLength);
	  }
	  var chunkSize = 512;
	  DecryptStream.prototype = Object.create(DecodeStream.prototype);
	  DecryptStream.prototype.readBlock = function DecryptStream_readBlock() {
	    var chunk;
	    if (this.initialized) {
	      chunk = this.nextChunk;
	    } else {
	      chunk = this.str.getBytes(chunkSize);
	      this.initialized = true;
	    }
	    if (!chunk || chunk.length === 0) {
	      this.eof = true;
	      return;
	    }
	    this.nextChunk = this.str.getBytes(chunkSize);
	    var hasMoreData = this.nextChunk && this.nextChunk.length > 0;
	    var decrypt = this.decrypt;
	    chunk = decrypt(chunk, !hasMoreData);
	    var bufferLength = this.bufferLength;
	    var i,
	        n = chunk.length;
	    var buffer = this.ensureBuffer(bufferLength + n);
	    for (i = 0; i < n; i++) {
	      buffer[bufferLength++] = chunk[i];
	    }
	    this.bufferLength = bufferLength;
	  };
	  return DecryptStream;
	}();
	var Ascii85Stream = function Ascii85StreamClosure() {
	  function Ascii85Stream(str, maybeLength) {
	    this.str = str;
	    this.dict = str.dict;
	    this.input = new Uint8Array(5);
	    if (maybeLength) {
	      maybeLength = 0.8 * maybeLength;
	    }
	    DecodeStream.call(this, maybeLength);
	  }
	  Ascii85Stream.prototype = Object.create(DecodeStream.prototype);
	  Ascii85Stream.prototype.readBlock = function Ascii85Stream_readBlock() {
	    var TILDA_CHAR = 0x7E;
	    var Z_LOWER_CHAR = 0x7A;
	    var EOF = -1;
	    var str = this.str;
	    var c = str.getByte();
	    while (isSpace(c)) {
	      c = str.getByte();
	    }
	    if (c === EOF || c === TILDA_CHAR) {
	      this.eof = true;
	      return;
	    }
	    var bufferLength = this.bufferLength,
	        buffer;
	    var i;
	    if (c === Z_LOWER_CHAR) {
	      buffer = this.ensureBuffer(bufferLength + 4);
	      for (i = 0; i < 4; ++i) {
	        buffer[bufferLength + i] = 0;
	      }
	      this.bufferLength += 4;
	    } else {
	      var input = this.input;
	      input[0] = c;
	      for (i = 1; i < 5; ++i) {
	        c = str.getByte();
	        while (isSpace(c)) {
	          c = str.getByte();
	        }
	        input[i] = c;
	        if (c === EOF || c === TILDA_CHAR) {
	          break;
	        }
	      }
	      buffer = this.ensureBuffer(bufferLength + i - 1);
	      this.bufferLength += i - 1;
	      if (i < 5) {
	        for (; i < 5; ++i) {
	          input[i] = 0x21 + 84;
	        }
	        this.eof = true;
	      }
	      var t = 0;
	      for (i = 0; i < 5; ++i) {
	        t = t * 85 + (input[i] - 0x21);
	      }
	      for (i = 3; i >= 0; --i) {
	        buffer[bufferLength + i] = t & 0xFF;
	        t >>= 8;
	      }
	    }
	  };
	  return Ascii85Stream;
	}();
	var AsciiHexStream = function AsciiHexStreamClosure() {
	  function AsciiHexStream(str, maybeLength) {
	    this.str = str;
	    this.dict = str.dict;
	    this.firstDigit = -1;
	    if (maybeLength) {
	      maybeLength = 0.5 * maybeLength;
	    }
	    DecodeStream.call(this, maybeLength);
	  }
	  AsciiHexStream.prototype = Object.create(DecodeStream.prototype);
	  AsciiHexStream.prototype.readBlock = function AsciiHexStream_readBlock() {
	    var UPSTREAM_BLOCK_SIZE = 8000;
	    var bytes = this.str.getBytes(UPSTREAM_BLOCK_SIZE);
	    if (!bytes.length) {
	      this.eof = true;
	      return;
	    }
	    var maxDecodeLength = bytes.length + 1 >> 1;
	    var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
	    var bufferLength = this.bufferLength;
	    var firstDigit = this.firstDigit;
	    for (var i = 0, ii = bytes.length; i < ii; i++) {
	      var ch = bytes[i],
	          digit;
	      if (ch >= 0x30 && ch <= 0x39) {
	        digit = ch & 0x0F;
	      } else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) {
	        digit = (ch & 0x0F) + 9;
	      } else if (ch === 0x3E) {
	        this.eof = true;
	        break;
	      } else {
	        continue;
	      }
	      if (firstDigit < 0) {
	        firstDigit = digit;
	      } else {
	        buffer[bufferLength++] = firstDigit << 4 | digit;
	        firstDigit = -1;
	      }
	    }
	    if (firstDigit >= 0 && this.eof) {
	      buffer[bufferLength++] = firstDigit << 4;
	      firstDigit = -1;
	    }
	    this.firstDigit = firstDigit;
	    this.bufferLength = bufferLength;
	  };
	  return AsciiHexStream;
	}();
	var RunLengthStream = function RunLengthStreamClosure() {
	  function RunLengthStream(str, maybeLength) {
	    this.str = str;
	    this.dict = str.dict;
	    DecodeStream.call(this, maybeLength);
	  }
	  RunLengthStream.prototype = Object.create(DecodeStream.prototype);
	  RunLengthStream.prototype.readBlock = function RunLengthStream_readBlock() {
	    var repeatHeader = this.str.getBytes(2);
	    if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
	      this.eof = true;
	      return;
	    }
	    var buffer;
	    var bufferLength = this.bufferLength;
	    var n = repeatHeader[0];
	    if (n < 128) {
	      buffer = this.ensureBuffer(bufferLength + n + 1);
	      buffer[bufferLength++] = repeatHeader[1];
	      if (n > 0) {
	        var source = this.str.getBytes(n);
	        buffer.set(source, bufferLength);
	        bufferLength += n;
	      }
	    } else {
	      n = 257 - n;
	      var b = repeatHeader[1];
	      buffer = this.ensureBuffer(bufferLength + n + 1);
	      for (var i = 0; i < n; i++) {
	        buffer[bufferLength++] = b;
	      }
	    }
	    this.bufferLength = bufferLength;
	  };
	  return RunLengthStream;
	}();
	var CCITTFaxStream = function CCITTFaxStreamClosure() {
	  var ccittEOL = -2;
	  var ccittEOF = -1;
	  var twoDimPass = 0;
	  var twoDimHoriz = 1;
	  var twoDimVert0 = 2;
	  var twoDimVertR1 = 3;
	  var twoDimVertL1 = 4;
	  var twoDimVertR2 = 5;
	  var twoDimVertL2 = 6;
	  var twoDimVertR3 = 7;
	  var twoDimVertL3 = 8;
	  var twoDimTable = [[-1, -1], [-1, -1], [7, twoDimVertL3], [7, twoDimVertR3], [6, twoDimVertL2], [6, twoDimVertL2], [6, twoDimVertR2], [6, twoDimVertR2], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0]];
	  var whiteTable1 = [[-1, -1], [12, ccittEOL], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [12, 1984], [12, 2048], [12, 2112], [12, 2176], [12, 2240], [12, 2304], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [12, 2368], [12, 2432], [12, 2496], [12, 2560]];
	  var whiteTable2 = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [8, 29], [8, 29], [8, 30], [8, 30], [8, 45], [8, 45], [8, 46], [8, 46], [7, 22], [7, 22], [7, 22], [7, 22], [7, 23], [7, 23], [7, 23], [7, 23], [8, 47], [8, 47], [8, 48], [8, 48], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [7, 20], [7, 20], [7, 20], [7, 20], [8, 33], [8, 33], [8, 34], [8, 34], [8, 35], [8, 35], [8, 36], [8, 36], [8, 37], [8, 37], [8, 38], [8, 38], [7, 19], [7, 19], [7, 19], [7, 19], [8, 31], [8, 31], [8, 32], [8, 32], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [8, 53], [8, 53], [8, 54], [8, 54], [7, 26], [7, 26], [7, 26], [7, 26], [8, 39], [8, 39], [8, 40], [8, 40], [8, 41], [8, 41], [8, 42], [8, 42], [8, 43], [8, 43], [8, 44], [8, 44], [7, 21], [7, 21], [7, 21], [7, 21], [7, 28], [7, 28], [7, 28], [7, 28], [8, 61], [8, 61], [8, 62], [8, 62], [8, 63], [8, 63], [8, 0], [8, 0], [8, 320], [8, 320], [8, 384], [8, 384], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [7, 27], [7, 27], [7, 27], [7, 27], [8, 59], [8, 59], [8, 60], [8, 60], [9, 1472], [9, 1536], [9, 1600], [9, 1728], [7, 18], [7, 18], [7, 18], [7, 18], [7, 24], [7, 24], [7, 24], [7, 24], [8, 49], [8, 49], [8, 50], [8, 50], [8, 51], [8, 51], [8, 52], [8, 52], [7, 25], [7, 25], [7, 25], [7, 25], [8, 55], [8, 55], [8, 56], [8, 56], [8, 57], [8, 57], [8, 58], [8, 58], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [8, 448], [8, 448], [8, 512], [8, 512], [9, 704], [9, 768], [8, 640], [8, 640], [8, 576], [8, 576], [9, 832], [9, 896], [9, 960], [9, 1024], [9, 1088], [9, 1152], [9, 1216], [9, 1280], [9, 1344], [9, 1408], [7, 256], [7, 256], [7, 256], [7, 256], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7]];
	  var blackTable1 = [[-1, -1], [-1, -1], [12, ccittEOL], [12, ccittEOL], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [11, 1792], [11, 1792], [12, 1984], [12, 1984], [12, 2048], [12, 2048], [12, 2112], [12, 2112], [12, 2176], [12, 2176], [12, 2240], [12, 2240], [12, 2304], [12, 2304], [11, 1856], [11, 1856], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [11, 1920], [11, 1920], [12, 2368], [12, 2368], [12, 2432], [12, 2432], [12, 2496], [12, 2496], [12, 2560], [12, 2560], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [12, 52], [12, 52], [13, 640], [13, 704], [13, 768], [13, 832], [12, 55], [12, 55], [12, 56], [12, 56], [13, 1280], [13, 1344], [13, 1408], [13, 1472], [12, 59], [12, 59], [12, 60], [12, 60], [13, 1536], [13, 1600], [11, 24], [11, 24], [11, 24], [11, 24], [11, 25], [11, 25], [11, 25], [11, 25], [13, 1664], [13, 1728], [12, 320], [12, 320], [12, 384], [12, 384], [12, 448], [12, 448], [13, 512], [13, 576], [12, 53], [12, 53], [12, 54], [12, 54], [13, 896], [13, 960], [13, 1024], [13, 1088], [13, 1152], [13, 1216], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64]];
	  var blackTable2 = [[8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [11, 23], [11, 23], [12, 50], [12, 51], [12, 44], [12, 45], [12, 46], [12, 47], [12, 57], [12, 58], [12, 61], [12, 256], [10, 16], [10, 16], [10, 16], [10, 16], [10, 17], [10, 17], [10, 17], [10, 17], [12, 48], [12, 49], [12, 62], [12, 63], [12, 30], [12, 31], [12, 32], [12, 33], [12, 40], [12, 41], [11, 22], [11, 22], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [12, 128], [12, 192], [12, 26], [12, 27], [12, 28], [12, 29], [11, 19], [11, 19], [11, 20], [11, 20], [12, 34], [12, 35], [12, 36], [12, 37], [12, 38], [12, 39], [11, 21], [11, 21], [12, 42], [12, 43], [10, 0], [10, 0], [10, 0], [10, 0], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12]];
	  var blackTable3 = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [6, 9], [6, 8], [5, 7], [5, 7], [4, 6], [4, 6], [4, 6], [4, 6], [4, 5], [4, 5], [4, 5], [4, 5], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2]];
	  function CCITTFaxStream(str, maybeLength, params) {
	    this.str = str;
	    this.dict = str.dict;
	    params = params || Dict.empty;
	    this.encoding = params.get('K') || 0;
	    this.eoline = params.get('EndOfLine') || false;
	    this.byteAlign = params.get('EncodedByteAlign') || false;
	    this.columns = params.get('Columns') || 1728;
	    this.rows = params.get('Rows') || 0;
	    var eoblock = params.get('EndOfBlock');
	    if (eoblock === null || eoblock === undefined) {
	      eoblock = true;
	    }
	    this.eoblock = eoblock;
	    this.black = params.get('BlackIs1') || false;
	    this.codingLine = new Uint32Array(this.columns + 1);
	    this.refLine = new Uint32Array(this.columns + 2);
	    this.codingLine[0] = this.columns;
	    this.codingPos = 0;
	    this.row = 0;
	    this.nextLine2D = this.encoding < 0;
	    this.inputBits = 0;
	    this.inputBuf = 0;
	    this.outputBits = 0;
	    var code1;
	    while ((code1 = this.lookBits(12)) === 0) {
	      this.eatBits(1);
	    }
	    if (code1 === 1) {
	      this.eatBits(12);
	    }
	    if (this.encoding > 0) {
	      this.nextLine2D = !this.lookBits(1);
	      this.eatBits(1);
	    }
	    DecodeStream.call(this, maybeLength);
	  }
	  CCITTFaxStream.prototype = Object.create(DecodeStream.prototype);
	  CCITTFaxStream.prototype.readBlock = function CCITTFaxStream_readBlock() {
	    while (!this.eof) {
	      var c = this.lookChar();
	      this.ensureBuffer(this.bufferLength + 1);
	      this.buffer[this.bufferLength++] = c;
	    }
	  };
	  CCITTFaxStream.prototype.addPixels = function ccittFaxStreamAddPixels(a1, blackPixels) {
	    var codingLine = this.codingLine;
	    var codingPos = this.codingPos;
	    if (a1 > codingLine[codingPos]) {
	      if (a1 > this.columns) {
	        info('row is wrong length');
	        this.err = true;
	        a1 = this.columns;
	      }
	      if (codingPos & 1 ^ blackPixels) {
	        ++codingPos;
	      }
	      codingLine[codingPos] = a1;
	    }
	    this.codingPos = codingPos;
	  };
	  CCITTFaxStream.prototype.addPixelsNeg = function ccittFaxStreamAddPixelsNeg(a1, blackPixels) {
	    var codingLine = this.codingLine;
	    var codingPos = this.codingPos;
	    if (a1 > codingLine[codingPos]) {
	      if (a1 > this.columns) {
	        info('row is wrong length');
	        this.err = true;
	        a1 = this.columns;
	      }
	      if (codingPos & 1 ^ blackPixels) {
	        ++codingPos;
	      }
	      codingLine[codingPos] = a1;
	    } else if (a1 < codingLine[codingPos]) {
	      if (a1 < 0) {
	        info('invalid code');
	        this.err = true;
	        a1 = 0;
	      }
	      while (codingPos > 0 && a1 < codingLine[codingPos - 1]) {
	        --codingPos;
	      }
	      codingLine[codingPos] = a1;
	    }
	    this.codingPos = codingPos;
	  };
	  CCITTFaxStream.prototype.lookChar = function CCITTFaxStream_lookChar() {
	    var refLine = this.refLine;
	    var codingLine = this.codingLine;
	    var columns = this.columns;
	    var refPos, blackPixels, bits, i;
	    if (this.outputBits === 0) {
	      if (this.eof) {
	        return null;
	      }
	      this.err = false;
	      var code1, code2, code3;
	      if (this.nextLine2D) {
	        for (i = 0; codingLine[i] < columns; ++i) {
	          refLine[i] = codingLine[i];
	        }
	        refLine[i++] = columns;
	        refLine[i] = columns;
	        codingLine[0] = 0;
	        this.codingPos = 0;
	        refPos = 0;
	        blackPixels = 0;
	        while (codingLine[this.codingPos] < columns) {
	          code1 = this.getTwoDimCode();
	          switch (code1) {
	            case twoDimPass:
	              this.addPixels(refLine[refPos + 1], blackPixels);
	              if (refLine[refPos + 1] < columns) {
	                refPos += 2;
	              }
	              break;
	            case twoDimHoriz:
	              code1 = code2 = 0;
	              if (blackPixels) {
	                do {
	                  code1 += code3 = this.getBlackCode();
	                } while (code3 >= 64);
	                do {
	                  code2 += code3 = this.getWhiteCode();
	                } while (code3 >= 64);
	              } else {
	                do {
	                  code1 += code3 = this.getWhiteCode();
	                } while (code3 >= 64);
	                do {
	                  code2 += code3 = this.getBlackCode();
	                } while (code3 >= 64);
	              }
	              this.addPixels(codingLine[this.codingPos] + code1, blackPixels);
	              if (codingLine[this.codingPos] < columns) {
	                this.addPixels(codingLine[this.codingPos] + code2, blackPixels ^ 1);
	              }
	              while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                refPos += 2;
	              }
	              break;
	            case twoDimVertR3:
	              this.addPixels(refLine[refPos] + 3, blackPixels);
	              blackPixels ^= 1;
	              if (codingLine[this.codingPos] < columns) {
	                ++refPos;
	                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                  refPos += 2;
	                }
	              }
	              break;
	            case twoDimVertR2:
	              this.addPixels(refLine[refPos] + 2, blackPixels);
	              blackPixels ^= 1;
	              if (codingLine[this.codingPos] < columns) {
	                ++refPos;
	                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                  refPos += 2;
	                }
	              }
	              break;
	            case twoDimVertR1:
	              this.addPixels(refLine[refPos] + 1, blackPixels);
	              blackPixels ^= 1;
	              if (codingLine[this.codingPos] < columns) {
	                ++refPos;
	                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                  refPos += 2;
	                }
	              }
	              break;
	            case twoDimVert0:
	              this.addPixels(refLine[refPos], blackPixels);
	              blackPixels ^= 1;
	              if (codingLine[this.codingPos] < columns) {
	                ++refPos;
	                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                  refPos += 2;
	                }
	              }
	              break;
	            case twoDimVertL3:
	              this.addPixelsNeg(refLine[refPos] - 3, blackPixels);
	              blackPixels ^= 1;
	              if (codingLine[this.codingPos] < columns) {
	                if (refPos > 0) {
	                  --refPos;
	                } else {
	                  ++refPos;
	                }
	                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                  refPos += 2;
	                }
	              }
	              break;
	            case twoDimVertL2:
	              this.addPixelsNeg(refLine[refPos] - 2, blackPixels);
	              blackPixels ^= 1;
	              if (codingLine[this.codingPos] < columns) {
	                if (refPos > 0) {
	                  --refPos;
	                } else {
	                  ++refPos;
	                }
	                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                  refPos += 2;
	                }
	              }
	              break;
	            case twoDimVertL1:
	              this.addPixelsNeg(refLine[refPos] - 1, blackPixels);
	              blackPixels ^= 1;
	              if (codingLine[this.codingPos] < columns) {
	                if (refPos > 0) {
	                  --refPos;
	                } else {
	                  ++refPos;
	                }
	                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                  refPos += 2;
	                }
	              }
	              break;
	            case ccittEOF:
	              this.addPixels(columns, 0);
	              this.eof = true;
	              break;
	            default:
	              info('bad 2d code');
	              this.addPixels(columns, 0);
	              this.err = true;
	          }
	        }
	      } else {
	        codingLine[0] = 0;
	        this.codingPos = 0;
	        blackPixels = 0;
	        while (codingLine[this.codingPos] < columns) {
	          code1 = 0;
	          if (blackPixels) {
	            do {
	              code1 += code3 = this.getBlackCode();
	            } while (code3 >= 64);
	          } else {
	            do {
	              code1 += code3 = this.getWhiteCode();
	            } while (code3 >= 64);
	          }
	          this.addPixels(codingLine[this.codingPos] + code1, blackPixels);
	          blackPixels ^= 1;
	        }
	      }
	      var gotEOL = false;
	      if (this.byteAlign) {
	        this.inputBits &= ~7;
	      }
	      if (!this.eoblock && this.row === this.rows - 1) {
	        this.eof = true;
	      } else {
	        code1 = this.lookBits(12);
	        if (this.eoline) {
	          while (code1 !== ccittEOF && code1 !== 1) {
	            this.eatBits(1);
	            code1 = this.lookBits(12);
	          }
	        } else {
	          while (code1 === 0) {
	            this.eatBits(1);
	            code1 = this.lookBits(12);
	          }
	        }
	        if (code1 === 1) {
	          this.eatBits(12);
	          gotEOL = true;
	        } else if (code1 === ccittEOF) {
	          this.eof = true;
	        }
	      }
	      if (!this.eof && this.encoding > 0) {
	        this.nextLine2D = !this.lookBits(1);
	        this.eatBits(1);
	      }
	      if (this.eoblock && gotEOL && this.byteAlign) {
	        code1 = this.lookBits(12);
	        if (code1 === 1) {
	          this.eatBits(12);
	          if (this.encoding > 0) {
	            this.lookBits(1);
	            this.eatBits(1);
	          }
	          if (this.encoding >= 0) {
	            for (i = 0; i < 4; ++i) {
	              code1 = this.lookBits(12);
	              if (code1 !== 1) {
	                info('bad rtc code: ' + code1);
	              }
	              this.eatBits(12);
	              if (this.encoding > 0) {
	                this.lookBits(1);
	                this.eatBits(1);
	              }
	            }
	          }
	          this.eof = true;
	        }
	      } else if (this.err && this.eoline) {
	        while (true) {
	          code1 = this.lookBits(13);
	          if (code1 === ccittEOF) {
	            this.eof = true;
	            return null;
	          }
	          if (code1 >> 1 === 1) {
	            break;
	          }
	          this.eatBits(1);
	        }
	        this.eatBits(12);
	        if (this.encoding > 0) {
	          this.eatBits(1);
	          this.nextLine2D = !(code1 & 1);
	        }
	      }
	      if (codingLine[0] > 0) {
	        this.outputBits = codingLine[this.codingPos = 0];
	      } else {
	        this.outputBits = codingLine[this.codingPos = 1];
	      }
	      this.row++;
	    }
	    var c;
	    if (this.outputBits >= 8) {
	      c = this.codingPos & 1 ? 0 : 0xFF;
	      this.outputBits -= 8;
	      if (this.outputBits === 0 && codingLine[this.codingPos] < columns) {
	        this.codingPos++;
	        this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
	      }
	    } else {
	      bits = 8;
	      c = 0;
	      do {
	        if (this.outputBits > bits) {
	          c <<= bits;
	          if (!(this.codingPos & 1)) {
	            c |= 0xFF >> 8 - bits;
	          }
	          this.outputBits -= bits;
	          bits = 0;
	        } else {
	          c <<= this.outputBits;
	          if (!(this.codingPos & 1)) {
	            c |= 0xFF >> 8 - this.outputBits;
	          }
	          bits -= this.outputBits;
	          this.outputBits = 0;
	          if (codingLine[this.codingPos] < columns) {
	            this.codingPos++;
	            this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
	          } else if (bits > 0) {
	            c <<= bits;
	            bits = 0;
	          }
	        }
	      } while (bits);
	    }
	    if (this.black) {
	      c ^= 0xFF;
	    }
	    return c;
	  };
	  CCITTFaxStream.prototype.findTableCode = function ccittFaxStreamFindTableCode(start, end, table, limit) {
	    var limitValue = limit || 0;
	    for (var i = start; i <= end; ++i) {
	      var code = this.lookBits(i);
	      if (code === ccittEOF) {
	        return [true, 1, false];
	      }
	      if (i < end) {
	        code <<= end - i;
	      }
	      if (!limitValue || code >= limitValue) {
	        var p = table[code - limitValue];
	        if (p[0] === i) {
	          this.eatBits(i);
	          return [true, p[1], true];
	        }
	      }
	    }
	    return [false, 0, false];
	  };
	  CCITTFaxStream.prototype.getTwoDimCode = function ccittFaxStreamGetTwoDimCode() {
	    var code = 0;
	    var p;
	    if (this.eoblock) {
	      code = this.lookBits(7);
	      p = twoDimTable[code];
	      if (p && p[0] > 0) {
	        this.eatBits(p[0]);
	        return p[1];
	      }
	    } else {
	      var result = this.findTableCode(1, 7, twoDimTable);
	      if (result[0] && result[2]) {
	        return result[1];
	      }
	    }
	    info('Bad two dim code');
	    return ccittEOF;
	  };
	  CCITTFaxStream.prototype.getWhiteCode = function ccittFaxStreamGetWhiteCode() {
	    var code = 0;
	    var p;
	    if (this.eoblock) {
	      code = this.lookBits(12);
	      if (code === ccittEOF) {
	        return 1;
	      }
	      if (code >> 5 === 0) {
	        p = whiteTable1[code];
	      } else {
	        p = whiteTable2[code >> 3];
	      }
	      if (p[0] > 0) {
	        this.eatBits(p[0]);
	        return p[1];
	      }
	    } else {
	      var result = this.findTableCode(1, 9, whiteTable2);
	      if (result[0]) {
	        return result[1];
	      }
	      result = this.findTableCode(11, 12, whiteTable1);
	      if (result[0]) {
	        return result[1];
	      }
	    }
	    info('bad white code');
	    this.eatBits(1);
	    return 1;
	  };
	  CCITTFaxStream.prototype.getBlackCode = function ccittFaxStreamGetBlackCode() {
	    var code, p;
	    if (this.eoblock) {
	      code = this.lookBits(13);
	      if (code === ccittEOF) {
	        return 1;
	      }
	      if (code >> 7 === 0) {
	        p = blackTable1[code];
	      } else if (code >> 9 === 0 && code >> 7 !== 0) {
	        p = blackTable2[(code >> 1) - 64];
	      } else {
	        p = blackTable3[code >> 7];
	      }
	      if (p[0] > 0) {
	        this.eatBits(p[0]);
	        return p[1];
	      }
	    } else {
	      var result = this.findTableCode(2, 6, blackTable3);
	      if (result[0]) {
	        return result[1];
	      }
	      result = this.findTableCode(7, 12, blackTable2, 64);
	      if (result[0]) {
	        return result[1];
	      }
	      result = this.findTableCode(10, 13, blackTable1);
	      if (result[0]) {
	        return result[1];
	      }
	    }
	    info('bad black code');
	    this.eatBits(1);
	    return 1;
	  };
	  CCITTFaxStream.prototype.lookBits = function CCITTFaxStream_lookBits(n) {
	    var c;
	    while (this.inputBits < n) {
	      if ((c = this.str.getByte()) === -1) {
	        if (this.inputBits === 0) {
	          return ccittEOF;
	        }
	        return this.inputBuf << n - this.inputBits & 0xFFFF >> 16 - n;
	      }
	      this.inputBuf = this.inputBuf << 8 | c;
	      this.inputBits += 8;
	    }
	    return this.inputBuf >> this.inputBits - n & 0xFFFF >> 16 - n;
	  };
	  CCITTFaxStream.prototype.eatBits = function CCITTFaxStream_eatBits(n) {
	    if ((this.inputBits -= n) < 0) {
	      this.inputBits = 0;
	    }
	  };
	  return CCITTFaxStream;
	}();
	var LZWStream = function LZWStreamClosure() {
	  function LZWStream(str, maybeLength, earlyChange) {
	    this.str = str;
	    this.dict = str.dict;
	    this.cachedData = 0;
	    this.bitsCached = 0;
	    var maxLzwDictionarySize = 4096;
	    var lzwState = {
	      earlyChange: earlyChange,
	      codeLength: 9,
	      nextCode: 258,
	      dictionaryValues: new Uint8Array(maxLzwDictionarySize),
	      dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
	      dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
	      currentSequence: new Uint8Array(maxLzwDictionarySize),
	      currentSequenceLength: 0
	    };
	    for (var i = 0; i < 256; ++i) {
	      lzwState.dictionaryValues[i] = i;
	      lzwState.dictionaryLengths[i] = 1;
	    }
	    this.lzwState = lzwState;
	    DecodeStream.call(this, maybeLength);
	  }
	  LZWStream.prototype = Object.create(DecodeStream.prototype);
	  LZWStream.prototype.readBits = function LZWStream_readBits(n) {
	    var bitsCached = this.bitsCached;
	    var cachedData = this.cachedData;
	    while (bitsCached < n) {
	      var c = this.str.getByte();
	      if (c === -1) {
	        this.eof = true;
	        return null;
	      }
	      cachedData = cachedData << 8 | c;
	      bitsCached += 8;
	    }
	    this.bitsCached = bitsCached -= n;
	    this.cachedData = cachedData;
	    this.lastCode = null;
	    return cachedData >>> bitsCached & (1 << n) - 1;
	  };
	  LZWStream.prototype.readBlock = function LZWStream_readBlock() {
	    var blockSize = 512;
	    var estimatedDecodedSize = blockSize * 2,
	        decodedSizeDelta = blockSize;
	    var i, j, q;
	    var lzwState = this.lzwState;
	    if (!lzwState) {
	      return;
	    }
	    var earlyChange = lzwState.earlyChange;
	    var nextCode = lzwState.nextCode;
	    var dictionaryValues = lzwState.dictionaryValues;
	    var dictionaryLengths = lzwState.dictionaryLengths;
	    var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
	    var codeLength = lzwState.codeLength;
	    var prevCode = lzwState.prevCode;
	    var currentSequence = lzwState.currentSequence;
	    var currentSequenceLength = lzwState.currentSequenceLength;
	    var decodedLength = 0;
	    var currentBufferLength = this.bufferLength;
	    var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
	    for (i = 0; i < blockSize; i++) {
	      var code = this.readBits(codeLength);
	      var hasPrev = currentSequenceLength > 0;
	      if (code < 256) {
	        currentSequence[0] = code;
	        currentSequenceLength = 1;
	      } else if (code >= 258) {
	        if (code < nextCode) {
	          currentSequenceLength = dictionaryLengths[code];
	          for (j = currentSequenceLength - 1, q = code; j >= 0; j--) {
	            currentSequence[j] = dictionaryValues[q];
	            q = dictionaryPrevCodes[q];
	          }
	        } else {
	          currentSequence[currentSequenceLength++] = currentSequence[0];
	        }
	      } else if (code === 256) {
	        codeLength = 9;
	        nextCode = 258;
	        currentSequenceLength = 0;
	        continue;
	      } else {
	        this.eof = true;
	        delete this.lzwState;
	        break;
	      }
	      if (hasPrev) {
	        dictionaryPrevCodes[nextCode] = prevCode;
	        dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
	        dictionaryValues[nextCode] = currentSequence[0];
	        nextCode++;
	        codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
	      }
	      prevCode = code;
	      decodedLength += currentSequenceLength;
	      if (estimatedDecodedSize < decodedLength) {
	        do {
	          estimatedDecodedSize += decodedSizeDelta;
	        } while (estimatedDecodedSize < decodedLength);
	        buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
	      }
	      for (j = 0; j < currentSequenceLength; j++) {
	        buffer[currentBufferLength++] = currentSequence[j];
	      }
	    }
	    lzwState.nextCode = nextCode;
	    lzwState.codeLength = codeLength;
	    lzwState.prevCode = prevCode;
	    lzwState.currentSequenceLength = currentSequenceLength;
	    this.bufferLength = currentBufferLength;
	  };
	  return LZWStream;
	}();
	var NullStream = function NullStreamClosure() {
	  function NullStream() {
	    Stream.call(this, new Uint8Array(0));
	  }
	  NullStream.prototype = Stream.prototype;
	  return NullStream;
	}();
	exports.Ascii85Stream = Ascii85Stream;
	exports.AsciiHexStream = AsciiHexStream;
	exports.CCITTFaxStream = CCITTFaxStream;
	exports.DecryptStream = DecryptStream;
	exports.DecodeStream = DecodeStream;
	exports.FlateStream = FlateStream;
	exports.Jbig2Stream = Jbig2Stream;
	exports.JpegStream = JpegStream;
	exports.JpxStream = JpxStream;
	exports.NullStream = NullStream;
	exports.PredictorStream = PredictorStream;
	exports.RunLengthStream = RunLengthStream;
	exports.Stream = Stream;
	exports.StreamsSequenceStream = StreamsSequenceStream;
	exports.StringStream = StringStream;
	exports.LZWStream = LZWStream;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var coreFunction = __w_pdfjs_require__(6);
	var error = sharedUtil.error;
	var info = sharedUtil.info;
	var isArray = sharedUtil.isArray;
	var isString = sharedUtil.isString;
	var shadow = sharedUtil.shadow;
	var warn = sharedUtil.warn;
	var isDict = corePrimitives.isDict;
	var isName = corePrimitives.isName;
	var isStream = corePrimitives.isStream;
	var PDFFunction = coreFunction.PDFFunction;
	var ColorSpace = function ColorSpaceClosure() {
	  function resizeRgbImage(src, bpc, w1, h1, w2, h2, alpha01, dest) {
	    var COMPONENTS = 3;
	    alpha01 = alpha01 !== 1 ? 0 : alpha01;
	    var xRatio = w1 / w2;
	    var yRatio = h1 / h2;
	    var i,
	        j,
	        py,
	        newIndex = 0,
	        oldIndex;
	    var xScaled = new Uint16Array(w2);
	    var w1Scanline = w1 * COMPONENTS;
	    for (i = 0; i < w2; i++) {
	      xScaled[i] = Math.floor(i * xRatio) * COMPONENTS;
	    }
	    for (i = 0; i < h2; i++) {
	      py = Math.floor(i * yRatio) * w1Scanline;
	      for (j = 0; j < w2; j++) {
	        oldIndex = py + xScaled[j];
	        dest[newIndex++] = src[oldIndex++];
	        dest[newIndex++] = src[oldIndex++];
	        dest[newIndex++] = src[oldIndex++];
	        newIndex += alpha01;
	      }
	    }
	  }
	  function ColorSpace() {
	    error('should not call ColorSpace constructor');
	  }
	  ColorSpace.prototype = {
	    getRgb: function ColorSpace_getRgb(src, srcOffset) {
	      var rgb = new Uint8Array(3);
	      this.getRgbItem(src, srcOffset, rgb, 0);
	      return rgb;
	    },
	    getRgbItem: function ColorSpace_getRgbItem(src, srcOffset, dest, destOffset) {
	      error('Should not call ColorSpace.getRgbItem');
	    },
	    getRgbBuffer: function ColorSpace_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      error('Should not call ColorSpace.getRgbBuffer');
	    },
	    getOutputLength: function ColorSpace_getOutputLength(inputLength, alpha01) {
	      error('Should not call ColorSpace.getOutputLength');
	    },
	    isPassthrough: function ColorSpace_isPassthrough(bits) {
	      return false;
	    },
	    fillRgb: function ColorSpace_fillRgb(dest, originalWidth, originalHeight, width, height, actualHeight, bpc, comps, alpha01) {
	      var count = originalWidth * originalHeight;
	      var rgbBuf = null;
	      var numComponentColors = 1 << bpc;
	      var needsResizing = originalHeight !== height || originalWidth !== width;
	      var i, ii;
	      if (this.isPassthrough(bpc)) {
	        rgbBuf = comps;
	      } else if (this.numComps === 1 && count > numComponentColors && this.name !== 'DeviceGray' && this.name !== 'DeviceRGB') {
	        var allColors = bpc <= 8 ? new Uint8Array(numComponentColors) : new Uint16Array(numComponentColors);
	        var key;
	        for (i = 0; i < numComponentColors; i++) {
	          allColors[i] = i;
	        }
	        var colorMap = new Uint8Array(numComponentColors * 3);
	        this.getRgbBuffer(allColors, 0, numComponentColors, colorMap, 0, bpc, 0);
	        var destPos, rgbPos;
	        if (!needsResizing) {
	          destPos = 0;
	          for (i = 0; i < count; ++i) {
	            key = comps[i] * 3;
	            dest[destPos++] = colorMap[key];
	            dest[destPos++] = colorMap[key + 1];
	            dest[destPos++] = colorMap[key + 2];
	            destPos += alpha01;
	          }
	        } else {
	          rgbBuf = new Uint8Array(count * 3);
	          rgbPos = 0;
	          for (i = 0; i < count; ++i) {
	            key = comps[i] * 3;
	            rgbBuf[rgbPos++] = colorMap[key];
	            rgbBuf[rgbPos++] = colorMap[key + 1];
	            rgbBuf[rgbPos++] = colorMap[key + 2];
	          }
	        }
	      } else {
	        if (!needsResizing) {
	          this.getRgbBuffer(comps, 0, width * actualHeight, dest, 0, bpc, alpha01);
	        } else {
	          rgbBuf = new Uint8Array(count * 3);
	          this.getRgbBuffer(comps, 0, count, rgbBuf, 0, bpc, 0);
	        }
	      }
	      if (rgbBuf) {
	        if (needsResizing) {
	          resizeRgbImage(rgbBuf, bpc, originalWidth, originalHeight, width, height, alpha01, dest);
	        } else {
	          rgbPos = 0;
	          destPos = 0;
	          for (i = 0, ii = width * actualHeight; i < ii; i++) {
	            dest[destPos++] = rgbBuf[rgbPos++];
	            dest[destPos++] = rgbBuf[rgbPos++];
	            dest[destPos++] = rgbBuf[rgbPos++];
	            destPos += alpha01;
	          }
	        }
	      }
	    },
	    usesZeroToOneRange: true
	  };
	  ColorSpace.parse = function ColorSpace_parse(cs, xref, res) {
	    var IR = ColorSpace.parseToIR(cs, xref, res);
	    if (IR instanceof AlternateCS) {
	      return IR;
	    }
	    return ColorSpace.fromIR(IR);
	  };
	  ColorSpace.fromIR = function ColorSpace_fromIR(IR) {
	    var name = isArray(IR) ? IR[0] : IR;
	    var whitePoint, blackPoint, gamma;
	    switch (name) {
	      case 'DeviceGrayCS':
	        return this.singletons.gray;
	      case 'DeviceRgbCS':
	        return this.singletons.rgb;
	      case 'DeviceCmykCS':
	        return this.singletons.cmyk;
	      case 'CalGrayCS':
	        whitePoint = IR[1];
	        blackPoint = IR[2];
	        gamma = IR[3];
	        return new CalGrayCS(whitePoint, blackPoint, gamma);
	      case 'CalRGBCS':
	        whitePoint = IR[1];
	        blackPoint = IR[2];
	        gamma = IR[3];
	        var matrix = IR[4];
	        return new CalRGBCS(whitePoint, blackPoint, gamma, matrix);
	      case 'PatternCS':
	        var basePatternCS = IR[1];
	        if (basePatternCS) {
	          basePatternCS = ColorSpace.fromIR(basePatternCS);
	        }
	        return new PatternCS(basePatternCS);
	      case 'IndexedCS':
	        var baseIndexedCS = IR[1];
	        var hiVal = IR[2];
	        var lookup = IR[3];
	        return new IndexedCS(ColorSpace.fromIR(baseIndexedCS), hiVal, lookup);
	      case 'AlternateCS':
	        var numComps = IR[1];
	        var alt = IR[2];
	        var tintFnIR = IR[3];
	        return new AlternateCS(numComps, ColorSpace.fromIR(alt), PDFFunction.fromIR(tintFnIR));
	      case 'LabCS':
	        whitePoint = IR[1];
	        blackPoint = IR[2];
	        var range = IR[3];
	        return new LabCS(whitePoint, blackPoint, range);
	      default:
	        error('Unknown name ' + name);
	    }
	    return null;
	  };
	  ColorSpace.parseToIR = function ColorSpace_parseToIR(cs, xref, res) {
	    if (isName(cs)) {
	      var colorSpaces = res.get('ColorSpace');
	      if (isDict(colorSpaces)) {
	        var refcs = colorSpaces.get(cs.name);
	        if (refcs) {
	          cs = refcs;
	        }
	      }
	    }
	    cs = xref.fetchIfRef(cs);
	    if (isName(cs)) {
	      switch (cs.name) {
	        case 'DeviceGray':
	        case 'G':
	          return 'DeviceGrayCS';
	        case 'DeviceRGB':
	        case 'RGB':
	          return 'DeviceRgbCS';
	        case 'DeviceCMYK':
	        case 'CMYK':
	          return 'DeviceCmykCS';
	        case 'Pattern':
	          return ['PatternCS', null];
	        default:
	          error('unrecognized colorspace ' + cs.name);
	      }
	    } else if (isArray(cs)) {
	      var mode = xref.fetchIfRef(cs[0]).name;
	      var numComps, params, alt, whitePoint, blackPoint, gamma;
	      switch (mode) {
	        case 'DeviceGray':
	        case 'G':
	          return 'DeviceGrayCS';
	        case 'DeviceRGB':
	        case 'RGB':
	          return 'DeviceRgbCS';
	        case 'DeviceCMYK':
	        case 'CMYK':
	          return 'DeviceCmykCS';
	        case 'CalGray':
	          params = xref.fetchIfRef(cs[1]);
	          whitePoint = params.getArray('WhitePoint');
	          blackPoint = params.getArray('BlackPoint');
	          gamma = params.get('Gamma');
	          return ['CalGrayCS', whitePoint, blackPoint, gamma];
	        case 'CalRGB':
	          params = xref.fetchIfRef(cs[1]);
	          whitePoint = params.getArray('WhitePoint');
	          blackPoint = params.getArray('BlackPoint');
	          gamma = params.getArray('Gamma');
	          var matrix = params.getArray('Matrix');
	          return ['CalRGBCS', whitePoint, blackPoint, gamma, matrix];
	        case 'ICCBased':
	          var stream = xref.fetchIfRef(cs[1]);
	          var dict = stream.dict;
	          numComps = dict.get('N');
	          alt = dict.get('Alternate');
	          if (alt) {
	            var altIR = ColorSpace.parseToIR(alt, xref, res);
	            var altCS = ColorSpace.fromIR(altIR);
	            if (altCS.numComps === numComps) {
	              return altIR;
	            }
	            warn('ICCBased color space: Ignoring incorrect /Alternate entry.');
	          }
	          if (numComps === 1) {
	            return 'DeviceGrayCS';
	          } else if (numComps === 3) {
	            return 'DeviceRgbCS';
	          } else if (numComps === 4) {
	            return 'DeviceCmykCS';
	          }
	          break;
	        case 'Pattern':
	          var basePatternCS = cs[1] || null;
	          if (basePatternCS) {
	            basePatternCS = ColorSpace.parseToIR(basePatternCS, xref, res);
	          }
	          return ['PatternCS', basePatternCS];
	        case 'Indexed':
	        case 'I':
	          var baseIndexedCS = ColorSpace.parseToIR(cs[1], xref, res);
	          var hiVal = xref.fetchIfRef(cs[2]) + 1;
	          var lookup = xref.fetchIfRef(cs[3]);
	          if (isStream(lookup)) {
	            lookup = lookup.getBytes();
	          }
	          return ['IndexedCS', baseIndexedCS, hiVal, lookup];
	        case 'Separation':
	        case 'DeviceN':
	          var name = xref.fetchIfRef(cs[1]);
	          numComps = isArray(name) ? name.length : 1;
	          alt = ColorSpace.parseToIR(cs[2], xref, res);
	          var tintFnIR = PDFFunction.getIR(xref, xref.fetchIfRef(cs[3]));
	          return ['AlternateCS', numComps, alt, tintFnIR];
	        case 'Lab':
	          params = xref.fetchIfRef(cs[1]);
	          whitePoint = params.getArray('WhitePoint');
	          blackPoint = params.getArray('BlackPoint');
	          var range = params.getArray('Range');
	          return ['LabCS', whitePoint, blackPoint, range];
	        default:
	          error('unimplemented color space object "' + mode + '"');
	      }
	    } else {
	      error('unrecognized color space object: "' + cs + '"');
	    }
	    return null;
	  };
	  ColorSpace.isDefaultDecode = function ColorSpace_isDefaultDecode(decode, n) {
	    if (!isArray(decode)) {
	      return true;
	    }
	    if (n * 2 !== decode.length) {
	      warn('The decode map is not the correct length');
	      return true;
	    }
	    for (var i = 0, ii = decode.length; i < ii; i += 2) {
	      if (decode[i] !== 0 || decode[i + 1] !== 1) {
	        return false;
	      }
	    }
	    return true;
	  };
	  ColorSpace.singletons = {
	    get gray() {
	      return shadow(this, 'gray', new DeviceGrayCS());
	    },
	    get rgb() {
	      return shadow(this, 'rgb', new DeviceRgbCS());
	    },
	    get cmyk() {
	      return shadow(this, 'cmyk', new DeviceCmykCS());
	    }
	  };
	  return ColorSpace;
	}();
	var AlternateCS = function AlternateCSClosure() {
	  function AlternateCS(numComps, base, tintFn) {
	    this.name = 'Alternate';
	    this.numComps = numComps;
	    this.defaultColor = new Float32Array(numComps);
	    for (var i = 0; i < numComps; ++i) {
	      this.defaultColor[i] = 1;
	    }
	    this.base = base;
	    this.tintFn = tintFn;
	    this.tmpBuf = new Float32Array(base.numComps);
	  }
	  AlternateCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function AlternateCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      var tmpBuf = this.tmpBuf;
	      this.tintFn(src, srcOffset, tmpBuf, 0);
	      this.base.getRgbItem(tmpBuf, 0, dest, destOffset);
	    },
	    getRgbBuffer: function AlternateCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var tintFn = this.tintFn;
	      var base = this.base;
	      var scale = 1 / ((1 << bits) - 1);
	      var baseNumComps = base.numComps;
	      var usesZeroToOneRange = base.usesZeroToOneRange;
	      var isPassthrough = (base.isPassthrough(8) || !usesZeroToOneRange) && alpha01 === 0;
	      var pos = isPassthrough ? destOffset : 0;
	      var baseBuf = isPassthrough ? dest : new Uint8Array(baseNumComps * count);
	      var numComps = this.numComps;
	      var scaled = new Float32Array(numComps);
	      var tinted = new Float32Array(baseNumComps);
	      var i, j;
	      for (i = 0; i < count; i++) {
	        for (j = 0; j < numComps; j++) {
	          scaled[j] = src[srcOffset++] * scale;
	        }
	        tintFn(scaled, 0, tinted, 0);
	        if (usesZeroToOneRange) {
	          for (j = 0; j < baseNumComps; j++) {
	            baseBuf[pos++] = tinted[j] * 255;
	          }
	        } else {
	          base.getRgbItem(tinted, 0, baseBuf, pos);
	          pos += baseNumComps;
	        }
	      }
	      if (!isPassthrough) {
	        base.getRgbBuffer(baseBuf, 0, count, dest, destOffset, 8, alpha01);
	      }
	    },
	    getOutputLength: function AlternateCS_getOutputLength(inputLength, alpha01) {
	      return this.base.getOutputLength(inputLength * this.base.numComps / this.numComps, alpha01);
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function AlternateCS_isDefaultDecode(decodeMap) {
	      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
	    },
	    usesZeroToOneRange: true
	  };
	  return AlternateCS;
	}();
	var PatternCS = function PatternCSClosure() {
	  function PatternCS(baseCS) {
	    this.name = 'Pattern';
	    this.base = baseCS;
	  }
	  PatternCS.prototype = {};
	  return PatternCS;
	}();
	var IndexedCS = function IndexedCSClosure() {
	  function IndexedCS(base, highVal, lookup) {
	    this.name = 'Indexed';
	    this.numComps = 1;
	    this.defaultColor = new Uint8Array(this.numComps);
	    this.base = base;
	    this.highVal = highVal;
	    var baseNumComps = base.numComps;
	    var length = baseNumComps * highVal;
	    if (isStream(lookup)) {
	      this.lookup = new Uint8Array(length);
	      var bytes = lookup.getBytes(length);
	      this.lookup.set(bytes);
	    } else if (isString(lookup)) {
	      this.lookup = new Uint8Array(length);
	      for (var i = 0; i < length; ++i) {
	        this.lookup[i] = lookup.charCodeAt(i);
	      }
	    } else if (lookup instanceof Uint8Array || lookup instanceof Array) {
	      this.lookup = lookup;
	    } else {
	      error('Unrecognized lookup table: ' + lookup);
	    }
	  }
	  IndexedCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function IndexedCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      var numComps = this.base.numComps;
	      var start = src[srcOffset] * numComps;
	      this.base.getRgbItem(this.lookup, start, dest, destOffset);
	    },
	    getRgbBuffer: function IndexedCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var base = this.base;
	      var numComps = base.numComps;
	      var outputDelta = base.getOutputLength(numComps, alpha01);
	      var lookup = this.lookup;
	      for (var i = 0; i < count; ++i) {
	        var lookupPos = src[srcOffset++] * numComps;
	        base.getRgbBuffer(lookup, lookupPos, 1, dest, destOffset, 8, alpha01);
	        destOffset += outputDelta;
	      }
	    },
	    getOutputLength: function IndexedCS_getOutputLength(inputLength, alpha01) {
	      return this.base.getOutputLength(inputLength * this.base.numComps, alpha01);
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function IndexedCS_isDefaultDecode(decodeMap) {
	      return true;
	    },
	    usesZeroToOneRange: true
	  };
	  return IndexedCS;
	}();
	var DeviceGrayCS = function DeviceGrayCSClosure() {
	  function DeviceGrayCS() {
	    this.name = 'DeviceGray';
	    this.numComps = 1;
	    this.defaultColor = new Float32Array(this.numComps);
	  }
	  DeviceGrayCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function DeviceGrayCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      var c = src[srcOffset] * 255 | 0;
	      c = c < 0 ? 0 : c > 255 ? 255 : c;
	      dest[destOffset] = dest[destOffset + 1] = dest[destOffset + 2] = c;
	    },
	    getRgbBuffer: function DeviceGrayCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var scale = 255 / ((1 << bits) - 1);
	      var j = srcOffset,
	          q = destOffset;
	      for (var i = 0; i < count; ++i) {
	        var c = scale * src[j++] | 0;
	        dest[q++] = c;
	        dest[q++] = c;
	        dest[q++] = c;
	        q += alpha01;
	      }
	    },
	    getOutputLength: function DeviceGrayCS_getOutputLength(inputLength, alpha01) {
	      return inputLength * (3 + alpha01);
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function DeviceGrayCS_isDefaultDecode(decodeMap) {
	      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
	    },
	    usesZeroToOneRange: true
	  };
	  return DeviceGrayCS;
	}();
	var DeviceRgbCS = function DeviceRgbCSClosure() {
	  function DeviceRgbCS() {
	    this.name = 'DeviceRGB';
	    this.numComps = 3;
	    this.defaultColor = new Float32Array(this.numComps);
	  }
	  DeviceRgbCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function DeviceRgbCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      var r = src[srcOffset] * 255 | 0;
	      var g = src[srcOffset + 1] * 255 | 0;
	      var b = src[srcOffset + 2] * 255 | 0;
	      dest[destOffset] = r < 0 ? 0 : r > 255 ? 255 : r;
	      dest[destOffset + 1] = g < 0 ? 0 : g > 255 ? 255 : g;
	      dest[destOffset + 2] = b < 0 ? 0 : b > 255 ? 255 : b;
	    },
	    getRgbBuffer: function DeviceRgbCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      if (bits === 8 && alpha01 === 0) {
	        dest.set(src.subarray(srcOffset, srcOffset + count * 3), destOffset);
	        return;
	      }
	      var scale = 255 / ((1 << bits) - 1);
	      var j = srcOffset,
	          q = destOffset;
	      for (var i = 0; i < count; ++i) {
	        dest[q++] = scale * src[j++] | 0;
	        dest[q++] = scale * src[j++] | 0;
	        dest[q++] = scale * src[j++] | 0;
	        q += alpha01;
	      }
	    },
	    getOutputLength: function DeviceRgbCS_getOutputLength(inputLength, alpha01) {
	      return inputLength * (3 + alpha01) / 3 | 0;
	    },
	    isPassthrough: function DeviceRgbCS_isPassthrough(bits) {
	      return bits === 8;
	    },
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function DeviceRgbCS_isDefaultDecode(decodeMap) {
	      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
	    },
	    usesZeroToOneRange: true
	  };
	  return DeviceRgbCS;
	}();
	var DeviceCmykCS = function DeviceCmykCSClosure() {
	  function convertToRgb(src, srcOffset, srcScale, dest, destOffset) {
	    var c = src[srcOffset + 0] * srcScale;
	    var m = src[srcOffset + 1] * srcScale;
	    var y = src[srcOffset + 2] * srcScale;
	    var k = src[srcOffset + 3] * srcScale;
	    var r = c * (-4.387332384609988 * c + 54.48615194189176 * m + 18.82290502165302 * y + 212.25662451639585 * k + -285.2331026137004) + m * (1.7149763477362134 * m - 5.6096736904047315 * y + -17.873870861415444 * k - 5.497006427196366) + y * (-2.5217340131683033 * y - 21.248923337353073 * k + 17.5119270841813) + k * (-21.86122147463605 * k - 189.48180835922747) + 255 | 0;
	    var g = c * (8.841041422036149 * c + 60.118027045597366 * m + 6.871425592049007 * y + 31.159100130055922 * k + -79.2970844816548) + m * (-15.310361306967817 * m + 17.575251261109482 * y + 131.35250912493976 * k - 190.9453302588951) + y * (4.444339102852739 * y + 9.8632861493405 * k - 24.86741582555878) + k * (-20.737325471181034 * k - 187.80453709719578) + 255 | 0;
	    var b = c * (0.8842522430003296 * c + 8.078677503112928 * m + 30.89978309703729 * y - 0.23883238689178934 * k + -14.183576799673286) + m * (10.49593273432072 * m + 63.02378494754052 * y + 50.606957656360734 * k - 112.23884253719248) + y * (0.03296041114873217 * y + 115.60384449646641 * k + -193.58209356861505) + k * (-22.33816807309886 * k - 180.12613974708367) + 255 | 0;
	    dest[destOffset] = r > 255 ? 255 : r < 0 ? 0 : r;
	    dest[destOffset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
	    dest[destOffset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
	  }
	  function DeviceCmykCS() {
	    this.name = 'DeviceCMYK';
	    this.numComps = 4;
	    this.defaultColor = new Float32Array(this.numComps);
	    this.defaultColor[3] = 1;
	  }
	  DeviceCmykCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function DeviceCmykCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      convertToRgb(src, srcOffset, 1, dest, destOffset);
	    },
	    getRgbBuffer: function DeviceCmykCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var scale = 1 / ((1 << bits) - 1);
	      for (var i = 0; i < count; i++) {
	        convertToRgb(src, srcOffset, scale, dest, destOffset);
	        srcOffset += 4;
	        destOffset += 3 + alpha01;
	      }
	    },
	    getOutputLength: function DeviceCmykCS_getOutputLength(inputLength, alpha01) {
	      return inputLength / 4 * (3 + alpha01) | 0;
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function DeviceCmykCS_isDefaultDecode(decodeMap) {
	      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
	    },
	    usesZeroToOneRange: true
	  };
	  return DeviceCmykCS;
	}();
	var CalGrayCS = function CalGrayCSClosure() {
	  function CalGrayCS(whitePoint, blackPoint, gamma) {
	    this.name = 'CalGray';
	    this.numComps = 1;
	    this.defaultColor = new Float32Array(this.numComps);
	    if (!whitePoint) {
	      error('WhitePoint missing - required for color space CalGray');
	    }
	    blackPoint = blackPoint || [0, 0, 0];
	    gamma = gamma || 1;
	    this.XW = whitePoint[0];
	    this.YW = whitePoint[1];
	    this.ZW = whitePoint[2];
	    this.XB = blackPoint[0];
	    this.YB = blackPoint[1];
	    this.ZB = blackPoint[2];
	    this.G = gamma;
	    if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) {
	      error('Invalid WhitePoint components for ' + this.name + ', no fallback available');
	    }
	    if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
	      info('Invalid BlackPoint for ' + this.name + ', falling back to default');
	      this.XB = this.YB = this.ZB = 0;
	    }
	    if (this.XB !== 0 || this.YB !== 0 || this.ZB !== 0) {
	      warn(this.name + ', BlackPoint: XB: ' + this.XB + ', YB: ' + this.YB + ', ZB: ' + this.ZB + ', only default values are supported.');
	    }
	    if (this.G < 1) {
	      info('Invalid Gamma: ' + this.G + ' for ' + this.name + ', falling back to default');
	      this.G = 1;
	    }
	  }
	  function convertToRgb(cs, src, srcOffset, dest, destOffset, scale) {
	    var A = src[srcOffset] * scale;
	    var AG = Math.pow(A, cs.G);
	    var L = cs.YW * AG;
	    var val = Math.max(295.8 * Math.pow(L, 0.333333333333333333) - 40.8, 0) | 0;
	    dest[destOffset] = val;
	    dest[destOffset + 1] = val;
	    dest[destOffset + 2] = val;
	  }
	  CalGrayCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function CalGrayCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      convertToRgb(this, src, srcOffset, dest, destOffset, 1);
	    },
	    getRgbBuffer: function CalGrayCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var scale = 1 / ((1 << bits) - 1);
	      for (var i = 0; i < count; ++i) {
	        convertToRgb(this, src, srcOffset, dest, destOffset, scale);
	        srcOffset += 1;
	        destOffset += 3 + alpha01;
	      }
	    },
	    getOutputLength: function CalGrayCS_getOutputLength(inputLength, alpha01) {
	      return inputLength * (3 + alpha01);
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function CalGrayCS_isDefaultDecode(decodeMap) {
	      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
	    },
	    usesZeroToOneRange: true
	  };
	  return CalGrayCS;
	}();
	var CalRGBCS = function CalRGBCSClosure() {
	  var BRADFORD_SCALE_MATRIX = new Float32Array([0.8951, 0.2664, -0.1614, -0.7502, 1.7135, 0.0367, 0.0389, -0.0685, 1.0296]);
	  var BRADFORD_SCALE_INVERSE_MATRIX = new Float32Array([0.9869929, -0.1470543, 0.1599627, 0.4323053, 0.5183603, 0.0492912, -0.0085287, 0.0400428, 0.9684867]);
	  var SRGB_D65_XYZ_TO_RGB_MATRIX = new Float32Array([3.2404542, -1.5371385, -0.4985314, -0.9692660, 1.8760108, 0.0415560, 0.0556434, -0.2040259, 1.0572252]);
	  var FLAT_WHITEPOINT_MATRIX = new Float32Array([1, 1, 1]);
	  var tempNormalizeMatrix = new Float32Array(3);
	  var tempConvertMatrix1 = new Float32Array(3);
	  var tempConvertMatrix2 = new Float32Array(3);
	  var DECODE_L_CONSTANT = Math.pow((8 + 16) / 116, 3) / 8.0;
	  function CalRGBCS(whitePoint, blackPoint, gamma, matrix) {
	    this.name = 'CalRGB';
	    this.numComps = 3;
	    this.defaultColor = new Float32Array(this.numComps);
	    if (!whitePoint) {
	      error('WhitePoint missing - required for color space CalRGB');
	    }
	    blackPoint = blackPoint || new Float32Array(3);
	    gamma = gamma || new Float32Array([1, 1, 1]);
	    matrix = matrix || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]);
	    var XW = whitePoint[0];
	    var YW = whitePoint[1];
	    var ZW = whitePoint[2];
	    this.whitePoint = whitePoint;
	    var XB = blackPoint[0];
	    var YB = blackPoint[1];
	    var ZB = blackPoint[2];
	    this.blackPoint = blackPoint;
	    this.GR = gamma[0];
	    this.GG = gamma[1];
	    this.GB = gamma[2];
	    this.MXA = matrix[0];
	    this.MYA = matrix[1];
	    this.MZA = matrix[2];
	    this.MXB = matrix[3];
	    this.MYB = matrix[4];
	    this.MZB = matrix[5];
	    this.MXC = matrix[6];
	    this.MYC = matrix[7];
	    this.MZC = matrix[8];
	    if (XW < 0 || ZW < 0 || YW !== 1) {
	      error('Invalid WhitePoint components for ' + this.name + ', no fallback available');
	    }
	    if (XB < 0 || YB < 0 || ZB < 0) {
	      info('Invalid BlackPoint for ' + this.name + ' [' + XB + ', ' + YB + ', ' + ZB + '], falling back to default');
	      this.blackPoint = new Float32Array(3);
	    }
	    if (this.GR < 0 || this.GG < 0 || this.GB < 0) {
	      info('Invalid Gamma [' + this.GR + ', ' + this.GG + ', ' + this.GB + '] for ' + this.name + ', falling back to default');
	      this.GR = this.GG = this.GB = 1;
	    }
	    if (this.MXA < 0 || this.MYA < 0 || this.MZA < 0 || this.MXB < 0 || this.MYB < 0 || this.MZB < 0 || this.MXC < 0 || this.MYC < 0 || this.MZC < 0) {
	      info('Invalid Matrix for ' + this.name + ' [' + this.MXA + ', ' + this.MYA + ', ' + this.MZA + this.MXB + ', ' + this.MYB + ', ' + this.MZB + this.MXC + ', ' + this.MYC + ', ' + this.MZC + '], falling back to default');
	      this.MXA = this.MYB = this.MZC = 1;
	      this.MXB = this.MYA = this.MZA = this.MXC = this.MYC = this.MZB = 0;
	    }
	  }
	  function matrixProduct(a, b, result) {
	    result[0] = a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	    result[1] = a[3] * b[0] + a[4] * b[1] + a[5] * b[2];
	    result[2] = a[6] * b[0] + a[7] * b[1] + a[8] * b[2];
	  }
	  function convertToFlat(sourceWhitePoint, LMS, result) {
	    result[0] = LMS[0] * 1 / sourceWhitePoint[0];
	    result[1] = LMS[1] * 1 / sourceWhitePoint[1];
	    result[2] = LMS[2] * 1 / sourceWhitePoint[2];
	  }
	  function convertToD65(sourceWhitePoint, LMS, result) {
	    var D65X = 0.95047;
	    var D65Y = 1;
	    var D65Z = 1.08883;
	    result[0] = LMS[0] * D65X / sourceWhitePoint[0];
	    result[1] = LMS[1] * D65Y / sourceWhitePoint[1];
	    result[2] = LMS[2] * D65Z / sourceWhitePoint[2];
	  }
	  function sRGBTransferFunction(color) {
	    if (color <= 0.0031308) {
	      return adjustToRange(0, 1, 12.92 * color);
	    }
	    return adjustToRange(0, 1, (1 + 0.055) * Math.pow(color, 1 / 2.4) - 0.055);
	  }
	  function adjustToRange(min, max, value) {
	    return Math.max(min, Math.min(max, value));
	  }
	  function decodeL(L) {
	    if (L < 0) {
	      return -decodeL(-L);
	    }
	    if (L > 8.0) {
	      return Math.pow((L + 16) / 116, 3);
	    }
	    return L * DECODE_L_CONSTANT;
	  }
	  function compensateBlackPoint(sourceBlackPoint, XYZ_Flat, result) {
	    if (sourceBlackPoint[0] === 0 && sourceBlackPoint[1] === 0 && sourceBlackPoint[2] === 0) {
	      result[0] = XYZ_Flat[0];
	      result[1] = XYZ_Flat[1];
	      result[2] = XYZ_Flat[2];
	      return;
	    }
	    var zeroDecodeL = decodeL(0);
	    var X_DST = zeroDecodeL;
	    var X_SRC = decodeL(sourceBlackPoint[0]);
	    var Y_DST = zeroDecodeL;
	    var Y_SRC = decodeL(sourceBlackPoint[1]);
	    var Z_DST = zeroDecodeL;
	    var Z_SRC = decodeL(sourceBlackPoint[2]);
	    var X_Scale = (1 - X_DST) / (1 - X_SRC);
	    var X_Offset = 1 - X_Scale;
	    var Y_Scale = (1 - Y_DST) / (1 - Y_SRC);
	    var Y_Offset = 1 - Y_Scale;
	    var Z_Scale = (1 - Z_DST) / (1 - Z_SRC);
	    var Z_Offset = 1 - Z_Scale;
	    result[0] = XYZ_Flat[0] * X_Scale + X_Offset;
	    result[1] = XYZ_Flat[1] * Y_Scale + Y_Offset;
	    result[2] = XYZ_Flat[2] * Z_Scale + Z_Offset;
	  }
	  function normalizeWhitePointToFlat(sourceWhitePoint, XYZ_In, result) {
	    if (sourceWhitePoint[0] === 1 && sourceWhitePoint[2] === 1) {
	      result[0] = XYZ_In[0];
	      result[1] = XYZ_In[1];
	      result[2] = XYZ_In[2];
	      return;
	    }
	    var LMS = result;
	    matrixProduct(BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
	    var LMS_Flat = tempNormalizeMatrix;
	    convertToFlat(sourceWhitePoint, LMS, LMS_Flat);
	    matrixProduct(BRADFORD_SCALE_INVERSE_MATRIX, LMS_Flat, result);
	  }
	  function normalizeWhitePointToD65(sourceWhitePoint, XYZ_In, result) {
	    var LMS = result;
	    matrixProduct(BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
	    var LMS_D65 = tempNormalizeMatrix;
	    convertToD65(sourceWhitePoint, LMS, LMS_D65);
	    matrixProduct(BRADFORD_SCALE_INVERSE_MATRIX, LMS_D65, result);
	  }
	  function convertToRgb(cs, src, srcOffset, dest, destOffset, scale) {
	    var A = adjustToRange(0, 1, src[srcOffset] * scale);
	    var B = adjustToRange(0, 1, src[srcOffset + 1] * scale);
	    var C = adjustToRange(0, 1, src[srcOffset + 2] * scale);
	    var AGR = Math.pow(A, cs.GR);
	    var BGG = Math.pow(B, cs.GG);
	    var CGB = Math.pow(C, cs.GB);
	    var X = cs.MXA * AGR + cs.MXB * BGG + cs.MXC * CGB;
	    var Y = cs.MYA * AGR + cs.MYB * BGG + cs.MYC * CGB;
	    var Z = cs.MZA * AGR + cs.MZB * BGG + cs.MZC * CGB;
	    var XYZ = tempConvertMatrix1;
	    XYZ[0] = X;
	    XYZ[1] = Y;
	    XYZ[2] = Z;
	    var XYZ_Flat = tempConvertMatrix2;
	    normalizeWhitePointToFlat(cs.whitePoint, XYZ, XYZ_Flat);
	    var XYZ_Black = tempConvertMatrix1;
	    compensateBlackPoint(cs.blackPoint, XYZ_Flat, XYZ_Black);
	    var XYZ_D65 = tempConvertMatrix2;
	    normalizeWhitePointToD65(FLAT_WHITEPOINT_MATRIX, XYZ_Black, XYZ_D65);
	    var SRGB = tempConvertMatrix1;
	    matrixProduct(SRGB_D65_XYZ_TO_RGB_MATRIX, XYZ_D65, SRGB);
	    var sR = sRGBTransferFunction(SRGB[0]);
	    var sG = sRGBTransferFunction(SRGB[1]);
	    var sB = sRGBTransferFunction(SRGB[2]);
	    dest[destOffset] = Math.round(sR * 255);
	    dest[destOffset + 1] = Math.round(sG * 255);
	    dest[destOffset + 2] = Math.round(sB * 255);
	  }
	  CalRGBCS.prototype = {
	    getRgb: function CalRGBCS_getRgb(src, srcOffset) {
	      var rgb = new Uint8Array(3);
	      this.getRgbItem(src, srcOffset, rgb, 0);
	      return rgb;
	    },
	    getRgbItem: function CalRGBCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      convertToRgb(this, src, srcOffset, dest, destOffset, 1);
	    },
	    getRgbBuffer: function CalRGBCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var scale = 1 / ((1 << bits) - 1);
	      for (var i = 0; i < count; ++i) {
	        convertToRgb(this, src, srcOffset, dest, destOffset, scale);
	        srcOffset += 3;
	        destOffset += 3 + alpha01;
	      }
	    },
	    getOutputLength: function CalRGBCS_getOutputLength(inputLength, alpha01) {
	      return inputLength * (3 + alpha01) / 3 | 0;
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function CalRGBCS_isDefaultDecode(decodeMap) {
	      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
	    },
	    usesZeroToOneRange: true
	  };
	  return CalRGBCS;
	}();
	var LabCS = function LabCSClosure() {
	  function LabCS(whitePoint, blackPoint, range) {
	    this.name = 'Lab';
	    this.numComps = 3;
	    this.defaultColor = new Float32Array(this.numComps);
	    if (!whitePoint) {
	      error('WhitePoint missing - required for color space Lab');
	    }
	    blackPoint = blackPoint || [0, 0, 0];
	    range = range || [-100, 100, -100, 100];
	    this.XW = whitePoint[0];
	    this.YW = whitePoint[1];
	    this.ZW = whitePoint[2];
	    this.amin = range[0];
	    this.amax = range[1];
	    this.bmin = range[2];
	    this.bmax = range[3];
	    this.XB = blackPoint[0];
	    this.YB = blackPoint[1];
	    this.ZB = blackPoint[2];
	    if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) {
	      error('Invalid WhitePoint components, no fallback available');
	    }
	    if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
	      info('Invalid BlackPoint, falling back to default');
	      this.XB = this.YB = this.ZB = 0;
	    }
	    if (this.amin > this.amax || this.bmin > this.bmax) {
	      info('Invalid Range, falling back to defaults');
	      this.amin = -100;
	      this.amax = 100;
	      this.bmin = -100;
	      this.bmax = 100;
	    }
	  }
	  function fn_g(x) {
	    var result;
	    if (x >= 6 / 29) {
	      result = x * x * x;
	    } else {
	      result = 108 / 841 * (x - 4 / 29);
	    }
	    return result;
	  }
	  function decode(value, high1, low2, high2) {
	    return low2 + value * (high2 - low2) / high1;
	  }
	  function convertToRgb(cs, src, srcOffset, maxVal, dest, destOffset) {
	    var Ls = src[srcOffset];
	    var as = src[srcOffset + 1];
	    var bs = src[srcOffset + 2];
	    if (maxVal !== false) {
	      Ls = decode(Ls, maxVal, 0, 100);
	      as = decode(as, maxVal, cs.amin, cs.amax);
	      bs = decode(bs, maxVal, cs.bmin, cs.bmax);
	    }
	    as = as > cs.amax ? cs.amax : as < cs.amin ? cs.amin : as;
	    bs = bs > cs.bmax ? cs.bmax : bs < cs.bmin ? cs.bmin : bs;
	    var M = (Ls + 16) / 116;
	    var L = M + as / 500;
	    var N = M - bs / 200;
	    var X = cs.XW * fn_g(L);
	    var Y = cs.YW * fn_g(M);
	    var Z = cs.ZW * fn_g(N);
	    var r, g, b;
	    if (cs.ZW < 1) {
	      r = X * 3.1339 + Y * -1.6170 + Z * -0.4906;
	      g = X * -0.9785 + Y * 1.9160 + Z * 0.0333;
	      b = X * 0.0720 + Y * -0.2290 + Z * 1.4057;
	    } else {
	      r = X * 3.2406 + Y * -1.5372 + Z * -0.4986;
	      g = X * -0.9689 + Y * 1.8758 + Z * 0.0415;
	      b = X * 0.0557 + Y * -0.2040 + Z * 1.0570;
	    }
	    dest[destOffset] = r <= 0 ? 0 : r >= 1 ? 255 : Math.sqrt(r) * 255 | 0;
	    dest[destOffset + 1] = g <= 0 ? 0 : g >= 1 ? 255 : Math.sqrt(g) * 255 | 0;
	    dest[destOffset + 2] = b <= 0 ? 0 : b >= 1 ? 255 : Math.sqrt(b) * 255 | 0;
	  }
	  LabCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function LabCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      convertToRgb(this, src, srcOffset, false, dest, destOffset);
	    },
	    getRgbBuffer: function LabCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var maxVal = (1 << bits) - 1;
	      for (var i = 0; i < count; i++) {
	        convertToRgb(this, src, srcOffset, maxVal, dest, destOffset);
	        srcOffset += 3;
	        destOffset += 3 + alpha01;
	      }
	    },
	    getOutputLength: function LabCS_getOutputLength(inputLength, alpha01) {
	      return inputLength * (3 + alpha01) / 3 | 0;
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function LabCS_isDefaultDecode(decodeMap) {
	      return true;
	    },
	    usesZeroToOneRange: false
	  };
	  return LabCS;
	}();
	exports.ColorSpace = ColorSpace;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ExpertEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior', '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '', '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];
	var MacExpertEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', 'centoldstyle', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', '', 'threequartersemdash', '', 'questionsmall', '', '', '', '', 'Ethsmall', '', '', 'onequarter', 'onehalf', 'threequarters', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '', '', '', '', '', '', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hypheninferior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', 'asuperior', 'centsuperior', '', '', '', '', 'Aacutesmall', 'Agravesmall', 'Acircumflexsmall', 'Adieresissmall', 'Atildesmall', 'Aringsmall', 'Ccedillasmall', 'Eacutesmall', 'Egravesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Iacutesmall', 'Igravesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ntildesmall', 'Oacutesmall', 'Ogravesmall', 'Ocircumflexsmall', 'Odieresissmall', 'Otildesmall', 'Uacutesmall', 'Ugravesmall', 'Ucircumflexsmall', 'Udieresissmall', '', 'eightsuperior', 'fourinferior', 'threeinferior', 'sixinferior', 'eightinferior', 'seveninferior', 'Scaronsmall', '', 'centinferior', 'twoinferior', '', 'Dieresissmall', '', 'Caronsmall', 'osuperior', 'fiveinferior', '', 'commainferior', 'periodinferior', 'Yacutesmall', '', 'dollarinferior', '', 'Thornsmall', '', 'nineinferior', 'zeroinferior', 'Zcaronsmall', 'AEsmall', 'Oslashsmall', 'questiondownsmall', 'oneinferior', 'Lslashsmall', '', '', '', '', '', '', 'Cedillasmall', '', '', '', '', '', 'OEsmall', 'figuredash', 'hyphensuperior', '', '', '', '', 'exclamdownsmall', '', 'Ydieresissmall', '', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'ninesuperior', 'zerosuperior', '', 'esuperior', 'rsuperior', 'tsuperior', '', '', 'isuperior', 'ssuperior', 'dsuperior', '', '', '', '', '', 'lsuperior', 'Ogoneksmall', 'Brevesmall', 'Macronsmall', 'bsuperior', 'nsuperior', 'msuperior', 'commasuperior', 'periodsuperior', 'Dotaccentsmall', 'Ringsmall'];
	var MacRomanEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', 'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave', 'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis', 'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis', 'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section', 'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal', 'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation', 'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown', 'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright', 'ellipsis', 'space', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft', 'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction', 'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase', 'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex', 'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron'];
	var StandardEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger', 'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron', 'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '', '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '', 'lslash', 'oslash', 'oe', 'germandbls'];
	var WinAnsiEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'bullet', 'Euro', 'bullet', 'quotesinglbase', 'florin', 'quotedblbase', 'ellipsis', 'dagger', 'daggerdbl', 'circumflex', 'perthousand', 'Scaron', 'guilsinglleft', 'OE', 'bullet', 'Zcaron', 'bullet', 'bullet', 'quoteleft', 'quoteright', 'quotedblleft', 'quotedblright', 'bullet', 'endash', 'emdash', 'tilde', 'trademark', 'scaron', 'guilsinglright', 'oe', 'bullet', 'zcaron', 'Ydieresis', 'space', 'exclamdown', 'cent', 'sterling', 'currency', 'yen', 'brokenbar', 'section', 'dieresis', 'copyright', 'ordfeminine', 'guillemotleft', 'logicalnot', 'hyphen', 'registered', 'macron', 'degree', 'plusminus', 'twosuperior', 'threesuperior', 'acute', 'mu', 'paragraph', 'periodcentered', 'cedilla', 'onesuperior', 'ordmasculine', 'guillemotright', 'onequarter', 'onehalf', 'threequarters', 'questiondown', 'Agrave', 'Aacute', 'Acircumflex', 'Atilde', 'Adieresis', 'Aring', 'AE', 'Ccedilla', 'Egrave', 'Eacute', 'Ecircumflex', 'Edieresis', 'Igrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Eth', 'Ntilde', 'Ograve', 'Oacute', 'Ocircumflex', 'Otilde', 'Odieresis', 'multiply', 'Oslash', 'Ugrave', 'Uacute', 'Ucircumflex', 'Udieresis', 'Yacute', 'Thorn', 'germandbls', 'agrave', 'aacute', 'acircumflex', 'atilde', 'adieresis', 'aring', 'ae', 'ccedilla', 'egrave', 'eacute', 'ecircumflex', 'edieresis', 'igrave', 'iacute', 'icircumflex', 'idieresis', 'eth', 'ntilde', 'ograve', 'oacute', 'ocircumflex', 'otilde', 'odieresis', 'divide', 'oslash', 'ugrave', 'uacute', 'ucircumflex', 'udieresis', 'yacute', 'thorn', 'ydieresis'];
	var SymbolSetEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'universal', 'numbersign', 'existential', 'percent', 'ampersand', 'suchthat', 'parenleft', 'parenright', 'asteriskmath', 'plus', 'comma', 'minus', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'congruent', 'Alpha', 'Beta', 'Chi', 'Delta', 'Epsilon', 'Phi', 'Gamma', 'Eta', 'Iota', 'theta1', 'Kappa', 'Lambda', 'Mu', 'Nu', 'Omicron', 'Pi', 'Theta', 'Rho', 'Sigma', 'Tau', 'Upsilon', 'sigma1', 'Omega', 'Xi', 'Psi', 'Zeta', 'bracketleft', 'therefore', 'bracketright', 'perpendicular', 'underscore', 'radicalex', 'alpha', 'beta', 'chi', 'delta', 'epsilon', 'phi', 'gamma', 'eta', 'iota', 'phi1', 'kappa', 'lambda', 'mu', 'nu', 'omicron', 'pi', 'theta', 'rho', 'sigma', 'tau', 'upsilon', 'omega1', 'omega', 'xi', 'psi', 'zeta', 'braceleft', 'bar', 'braceright', 'similar', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'Euro', 'Upsilon1', 'minute', 'lessequal', 'fraction', 'infinity', 'florin', 'club', 'diamond', 'heart', 'spade', 'arrowboth', 'arrowleft', 'arrowup', 'arrowright', 'arrowdown', 'degree', 'plusminus', 'second', 'greaterequal', 'multiply', 'proportional', 'partialdiff', 'bullet', 'divide', 'notequal', 'equivalence', 'approxequal', 'ellipsis', 'arrowvertex', 'arrowhorizex', 'carriagereturn', 'aleph', 'Ifraktur', 'Rfraktur', 'weierstrass', 'circlemultiply', 'circleplus', 'emptyset', 'intersection', 'union', 'propersuperset', 'reflexsuperset', 'notsubset', 'propersubset', 'reflexsubset', 'element', 'notelement', 'angle', 'gradient', 'registerserif', 'copyrightserif', 'trademarkserif', 'product', 'radical', 'dotmath', 'logicalnot', 'logicaland', 'logicalor', 'arrowdblboth', 'arrowdblleft', 'arrowdblup', 'arrowdblright', 'arrowdbldown', 'lozenge', 'angleleft', 'registersans', 'copyrightsans', 'trademarksans', 'summation', 'parenlefttp', 'parenleftex', 'parenleftbt', 'bracketlefttp', 'bracketleftex', 'bracketleftbt', 'bracelefttp', 'braceleftmid', 'braceleftbt', 'braceex', '', 'angleright', 'integral', 'integraltp', 'integralex', 'integralbt', 'parenrighttp', 'parenrightex', 'parenrightbt', 'bracketrighttp', 'bracketrightex', 'bracketrightbt', 'bracerighttp', 'bracerightmid', 'bracerightbt'];
	var ZapfDingbatsEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'a1', 'a2', 'a202', 'a3', 'a4', 'a5', 'a119', 'a118', 'a117', 'a11', 'a12', 'a13', 'a14', 'a15', 'a16', 'a105', 'a17', 'a18', 'a19', 'a20', 'a21', 'a22', 'a23', 'a24', 'a25', 'a26', 'a27', 'a28', 'a6', 'a7', 'a8', 'a9', 'a10', 'a29', 'a30', 'a31', 'a32', 'a33', 'a34', 'a35', 'a36', 'a37', 'a38', 'a39', 'a40', 'a41', 'a42', 'a43', 'a44', 'a45', 'a46', 'a47', 'a48', 'a49', 'a50', 'a51', 'a52', 'a53', 'a54', 'a55', 'a56', 'a57', 'a58', 'a59', 'a60', 'a61', 'a62', 'a63', 'a64', 'a65', 'a66', 'a67', 'a68', 'a69', 'a70', 'a71', 'a72', 'a73', 'a74', 'a203', 'a75', 'a204', 'a76', 'a77', 'a78', 'a79', 'a81', 'a82', 'a83', 'a84', 'a97', 'a98', 'a99', 'a100', '', 'a89', 'a90', 'a93', 'a94', 'a91', 'a92', 'a205', 'a85', 'a206', 'a86', 'a87', 'a88', 'a95', 'a96', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'a101', 'a102', 'a103', 'a104', 'a106', 'a107', 'a108', 'a112', 'a111', 'a110', 'a109', 'a120', 'a121', 'a122', 'a123', 'a124', 'a125', 'a126', 'a127', 'a128', 'a129', 'a130', 'a131', 'a132', 'a133', 'a134', 'a135', 'a136', 'a137', 'a138', 'a139', 'a140', 'a141', 'a142', 'a143', 'a144', 'a145', 'a146', 'a147', 'a148', 'a149', 'a150', 'a151', 'a152', 'a153', 'a154', 'a155', 'a156', 'a157', 'a158', 'a159', 'a160', 'a161', 'a163', 'a164', 'a196', 'a165', 'a192', 'a166', 'a167', 'a168', 'a169', 'a170', 'a171', 'a172', 'a173', 'a162', 'a174', 'a175', 'a176', 'a177', 'a178', 'a179', 'a193', 'a180', 'a199', 'a181', 'a200', 'a182', '', 'a201', 'a183', 'a184', 'a197', 'a185', 'a194', 'a198', 'a186', 'a195', 'a187', 'a188', 'a189', 'a190', 'a191'];
	function getEncoding(encodingName) {
	  switch (encodingName) {
	    case 'WinAnsiEncoding':
	      return WinAnsiEncoding;
	    case 'StandardEncoding':
	      return StandardEncoding;
	    case 'MacRomanEncoding':
	      return MacRomanEncoding;
	    case 'SymbolSetEncoding':
	      return SymbolSetEncoding;
	    case 'ZapfDingbatsEncoding':
	      return ZapfDingbatsEncoding;
	    case 'ExpertEncoding':
	      return ExpertEncoding;
	    case 'MacExpertEncoding':
	      return MacExpertEncoding;
	    default:
	      return null;
	  }
	}
	exports.WinAnsiEncoding = WinAnsiEncoding;
	exports.StandardEncoding = StandardEncoding;
	exports.MacRomanEncoding = MacRomanEncoding;
	exports.SymbolSetEncoding = SymbolSetEncoding;
	exports.ZapfDingbatsEncoding = ZapfDingbatsEncoding;
	exports.ExpertEncoding = ExpertEncoding;
	exports.getEncoding = getEncoding;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var coreStream = __w_pdfjs_require__(2);
	var MissingDataException = sharedUtil.MissingDataException;
	var StreamType = sharedUtil.StreamType;
	var assert = sharedUtil.assert;
	var error = sharedUtil.error;
	var info = sharedUtil.info;
	var isArray = sharedUtil.isArray;
	var isInt = sharedUtil.isInt;
	var isNum = sharedUtil.isNum;
	var isString = sharedUtil.isString;
	var warn = sharedUtil.warn;
	var EOF = corePrimitives.EOF;
	var Cmd = corePrimitives.Cmd;
	var Dict = corePrimitives.Dict;
	var Name = corePrimitives.Name;
	var Ref = corePrimitives.Ref;
	var isEOF = corePrimitives.isEOF;
	var isCmd = corePrimitives.isCmd;
	var isDict = corePrimitives.isDict;
	var isName = corePrimitives.isName;
	var Ascii85Stream = coreStream.Ascii85Stream;
	var AsciiHexStream = coreStream.AsciiHexStream;
	var CCITTFaxStream = coreStream.CCITTFaxStream;
	var FlateStream = coreStream.FlateStream;
	var Jbig2Stream = coreStream.Jbig2Stream;
	var JpegStream = coreStream.JpegStream;
	var JpxStream = coreStream.JpxStream;
	var LZWStream = coreStream.LZWStream;
	var NullStream = coreStream.NullStream;
	var PredictorStream = coreStream.PredictorStream;
	var RunLengthStream = coreStream.RunLengthStream;
	var MAX_LENGTH_TO_CACHE = 1000;
	var Parser = function ParserClosure() {
	  function Parser(lexer, allowStreams, xref, recoveryMode) {
	    this.lexer = lexer;
	    this.allowStreams = allowStreams;
	    this.xref = xref;
	    this.recoveryMode = recoveryMode || false;
	    this.imageCache = Object.create(null);
	    this.refill();
	  }
	  Parser.prototype = {
	    refill: function Parser_refill() {
	      this.buf1 = this.lexer.getObj();
	      this.buf2 = this.lexer.getObj();
	    },
	    shift: function Parser_shift() {
	      if (isCmd(this.buf2, 'ID')) {
	        this.buf1 = this.buf2;
	        this.buf2 = null;
	      } else {
	        this.buf1 = this.buf2;
	        this.buf2 = this.lexer.getObj();
	      }
	    },
	    tryShift: function Parser_tryShift() {
	      try {
	        this.shift();
	        return true;
	      } catch (e) {
	        if (e instanceof MissingDataException) {
	          throw e;
	        }
	        return false;
	      }
	    },
	    getObj: function Parser_getObj(cipherTransform) {
	      var buf1 = this.buf1;
	      this.shift();
	      if (buf1 instanceof Cmd) {
	        switch (buf1.cmd) {
	          case 'BI':
	            return this.makeInlineImage(cipherTransform);
	          case '[':
	            var array = [];
	            while (!isCmd(this.buf1, ']') && !isEOF(this.buf1)) {
	              array.push(this.getObj(cipherTransform));
	            }
	            if (isEOF(this.buf1)) {
	              if (!this.recoveryMode) {
	                error('End of file inside array');
	              }
	              return array;
	            }
	            this.shift();
	            return array;
	          case '<<':
	            var dict = new Dict(this.xref);
	            while (!isCmd(this.buf1, '>>') && !isEOF(this.buf1)) {
	              if (!isName(this.buf1)) {
	                info('Malformed dictionary: key must be a name object');
	                this.shift();
	                continue;
	              }
	              var key = this.buf1.name;
	              this.shift();
	              if (isEOF(this.buf1)) {
	                break;
	              }
	              dict.set(key, this.getObj(cipherTransform));
	            }
	            if (isEOF(this.buf1)) {
	              if (!this.recoveryMode) {
	                error('End of file inside dictionary');
	              }
	              return dict;
	            }
	            if (isCmd(this.buf2, 'stream')) {
	              return this.allowStreams ? this.makeStream(dict, cipherTransform) : dict;
	            }
	            this.shift();
	            return dict;
	          default:
	            return buf1;
	        }
	      }
	      if (isInt(buf1)) {
	        var num = buf1;
	        if (isInt(this.buf1) && isCmd(this.buf2, 'R')) {
	          var ref = new Ref(num, this.buf1);
	          this.shift();
	          this.shift();
	          return ref;
	        }
	        return num;
	      }
	      if (isString(buf1)) {
	        var str = buf1;
	        if (cipherTransform) {
	          str = cipherTransform.decryptString(str);
	        }
	        return str;
	      }
	      return buf1;
	    },
	    findDefaultInlineStreamEnd: function Parser_findDefaultInlineStreamEnd(stream) {
	      var E = 0x45,
	          I = 0x49,
	          SPACE = 0x20,
	          LF = 0xA,
	          CR = 0xD;
	      var startPos = stream.pos,
	          state = 0,
	          ch,
	          i,
	          n,
	          followingBytes;
	      while ((ch = stream.getByte()) !== -1) {
	        if (state === 0) {
	          state = ch === E ? 1 : 0;
	        } else if (state === 1) {
	          state = ch === I ? 2 : 0;
	        } else {
	          assert(state === 2);
	          if (ch === SPACE || ch === LF || ch === CR) {
	            n = 5;
	            followingBytes = stream.peekBytes(n);
	            for (i = 0; i < n; i++) {
	              ch = followingBytes[i];
	              if (ch !== LF && ch !== CR && (ch < SPACE || ch > 0x7F)) {
	                state = 0;
	                break;
	              }
	            }
	            if (state === 2) {
	              break;
	            }
	          } else {
	            state = 0;
	          }
	        }
	      }
	      return stream.pos - 4 - startPos;
	    },
	    findDCTDecodeInlineStreamEnd: function Parser_findDCTDecodeInlineStreamEnd(stream) {
	      var startPos = stream.pos,
	          foundEOI = false,
	          b,
	          markerLength,
	          length;
	      while ((b = stream.getByte()) !== -1) {
	        if (b !== 0xFF) {
	          continue;
	        }
	        switch (stream.getByte()) {
	          case 0x00:
	            break;
	          case 0xFF:
	            stream.skip(-1);
	            break;
	          case 0xD9:
	            foundEOI = true;
	            break;
	          case 0xC0:
	          case 0xC1:
	          case 0xC2:
	          case 0xC3:
	          case 0xC5:
	          case 0xC6:
	          case 0xC7:
	          case 0xC9:
	          case 0xCA:
	          case 0xCB:
	          case 0xCD:
	          case 0xCE:
	          case 0xCF:
	          case 0xC4:
	          case 0xCC:
	          case 0xDA:
	          case 0xDB:
	          case 0xDC:
	          case 0xDD:
	          case 0xDE:
	          case 0xDF:
	          case 0xE0:
	          case 0xE1:
	          case 0xE2:
	          case 0xE3:
	          case 0xE4:
	          case 0xE5:
	          case 0xE6:
	          case 0xE7:
	          case 0xE8:
	          case 0xE9:
	          case 0xEA:
	          case 0xEB:
	          case 0xEC:
	          case 0xED:
	          case 0xEE:
	          case 0xEF:
	          case 0xFE:
	            markerLength = stream.getUint16();
	            if (markerLength > 2) {
	              stream.skip(markerLength - 2);
	            } else {
	              stream.skip(-2);
	            }
	            break;
	        }
	        if (foundEOI) {
	          break;
	        }
	      }
	      length = stream.pos - startPos;
	      if (b === -1) {
	        warn('Inline DCTDecode image stream: ' + 'EOI marker not found, searching for /EI/ instead.');
	        stream.skip(-length);
	        return this.findDefaultInlineStreamEnd(stream);
	      }
	      this.inlineStreamSkipEI(stream);
	      return length;
	    },
	    findASCII85DecodeInlineStreamEnd: function Parser_findASCII85DecodeInlineStreamEnd(stream) {
	      var TILDE = 0x7E,
	          GT = 0x3E;
	      var startPos = stream.pos,
	          ch,
	          length;
	      while ((ch = stream.getByte()) !== -1) {
	        if (ch === TILDE && stream.peekByte() === GT) {
	          stream.skip();
	          break;
	        }
	      }
	      length = stream.pos - startPos;
	      if (ch === -1) {
	        warn('Inline ASCII85Decode image stream: ' + 'EOD marker not found, searching for /EI/ instead.');
	        stream.skip(-length);
	        return this.findDefaultInlineStreamEnd(stream);
	      }
	      this.inlineStreamSkipEI(stream);
	      return length;
	    },
	    findASCIIHexDecodeInlineStreamEnd: function Parser_findASCIIHexDecodeInlineStreamEnd(stream) {
	      var GT = 0x3E;
	      var startPos = stream.pos,
	          ch,
	          length;
	      while ((ch = stream.getByte()) !== -1) {
	        if (ch === GT) {
	          break;
	        }
	      }
	      length = stream.pos - startPos;
	      if (ch === -1) {
	        warn('Inline ASCIIHexDecode image stream: ' + 'EOD marker not found, searching for /EI/ instead.');
	        stream.skip(-length);
	        return this.findDefaultInlineStreamEnd(stream);
	      }
	      this.inlineStreamSkipEI(stream);
	      return length;
	    },
	    inlineStreamSkipEI: function Parser_inlineStreamSkipEI(stream) {
	      var E = 0x45,
	          I = 0x49;
	      var state = 0,
	          ch;
	      while ((ch = stream.getByte()) !== -1) {
	        if (state === 0) {
	          state = ch === E ? 1 : 0;
	        } else if (state === 1) {
	          state = ch === I ? 2 : 0;
	        } else if (state === 2) {
	          break;
	        }
	      }
	    },
	    makeInlineImage: function Parser_makeInlineImage(cipherTransform) {
	      var lexer = this.lexer;
	      var stream = lexer.stream;
	      var dict = new Dict(this.xref);
	      while (!isCmd(this.buf1, 'ID') && !isEOF(this.buf1)) {
	        if (!isName(this.buf1)) {
	          error('Dictionary key must be a name object');
	        }
	        var key = this.buf1.name;
	        this.shift();
	        if (isEOF(this.buf1)) {
	          break;
	        }
	        dict.set(key, this.getObj(cipherTransform));
	      }
	      var filter = dict.get('Filter', 'F'),
	          filterName;
	      if (isName(filter)) {
	        filterName = filter.name;
	      } else if (isArray(filter)) {
	        var filterZero = this.xref.fetchIfRef(filter[0]);
	        if (isName(filterZero)) {
	          filterName = filterZero.name;
	        }
	      }
	      var startPos = stream.pos,
	          length,
	          i,
	          ii;
	      if (filterName === 'DCTDecode' || filterName === 'DCT') {
	        length = this.findDCTDecodeInlineStreamEnd(stream);
	      } else if (filterName === 'ASCII85Decide' || filterName === 'A85') {
	        length = this.findASCII85DecodeInlineStreamEnd(stream);
	      } else if (filterName === 'ASCIIHexDecode' || filterName === 'AHx') {
	        length = this.findASCIIHexDecodeInlineStreamEnd(stream);
	      } else {
	        length = this.findDefaultInlineStreamEnd(stream);
	      }
	      var imageStream = stream.makeSubStream(startPos, length, dict);
	      var adler32;
	      if (length < MAX_LENGTH_TO_CACHE) {
	        var imageBytes = imageStream.getBytes();
	        imageStream.reset();
	        var a = 1;
	        var b = 0;
	        for (i = 0, ii = imageBytes.length; i < ii; ++i) {
	          a += imageBytes[i] & 0xff;
	          b += a;
	        }
	        adler32 = b % 65521 << 16 | a % 65521;
	        if (this.imageCache.adler32 === adler32) {
	          this.buf2 = Cmd.get('EI');
	          this.shift();
	          this.imageCache[adler32].reset();
	          return this.imageCache[adler32];
	        }
	      }
	      if (cipherTransform) {
	        imageStream = cipherTransform.createStream(imageStream, length);
	      }
	      imageStream = this.filter(imageStream, dict, length);
	      imageStream.dict = dict;
	      if (adler32 !== undefined) {
	        imageStream.cacheKey = 'inline_' + length + '_' + adler32;
	        this.imageCache[adler32] = imageStream;
	      }
	      this.buf2 = Cmd.get('EI');
	      this.shift();
	      return imageStream;
	    },
	    makeStream: function Parser_makeStream(dict, cipherTransform) {
	      var lexer = this.lexer;
	      var stream = lexer.stream;
	      lexer.skipToNextLine();
	      var pos = stream.pos - 1;
	      var length = dict.get('Length');
	      if (!isInt(length)) {
	        info('Bad ' + length + ' attribute in stream');
	        length = 0;
	      }
	      stream.pos = pos + length;
	      lexer.nextChar();
	      if (this.tryShift() && isCmd(this.buf2, 'endstream')) {
	        this.shift();
	      } else {
	        stream.pos = pos;
	        var SCAN_BLOCK_SIZE = 2048;
	        var ENDSTREAM_SIGNATURE_LENGTH = 9;
	        var ENDSTREAM_SIGNATURE = [0x65, 0x6E, 0x64, 0x73, 0x74, 0x72, 0x65, 0x61, 0x6D];
	        var skipped = 0,
	            found = false,
	            i,
	            j;
	        while (stream.pos < stream.end) {
	          var scanBytes = stream.peekBytes(SCAN_BLOCK_SIZE);
	          var scanLength = scanBytes.length - ENDSTREAM_SIGNATURE_LENGTH;
	          if (scanLength <= 0) {
	            break;
	          }
	          found = false;
	          i = 0;
	          while (i < scanLength) {
	            j = 0;
	            while (j < ENDSTREAM_SIGNATURE_LENGTH && scanBytes[i + j] === ENDSTREAM_SIGNATURE[j]) {
	              j++;
	            }
	            if (j >= ENDSTREAM_SIGNATURE_LENGTH) {
	              found = true;
	              break;
	            }
	            i++;
	          }
	          if (found) {
	            skipped += i;
	            stream.pos += i;
	            break;
	          }
	          skipped += scanLength;
	          stream.pos += scanLength;
	        }
	        if (!found) {
	          error('Missing endstream');
	        }
	        length = skipped;
	        lexer.nextChar();
	        this.shift();
	        this.shift();
	      }
	      this.shift();
	      stream = stream.makeSubStream(pos, length, dict);
	      if (cipherTransform) {
	        stream = cipherTransform.createStream(stream, length);
	      }
	      stream = this.filter(stream, dict, length);
	      stream.dict = dict;
	      return stream;
	    },
	    filter: function Parser_filter(stream, dict, length) {
	      var filter = dict.get('Filter', 'F');
	      var params = dict.get('DecodeParms', 'DP');
	      if (isName(filter)) {
	        if (isArray(params)) {
	          params = this.xref.fetchIfRef(params[0]);
	        }
	        return this.makeFilter(stream, filter.name, length, params);
	      }
	      var maybeLength = length;
	      if (isArray(filter)) {
	        var filterArray = filter;
	        var paramsArray = params;
	        for (var i = 0, ii = filterArray.length; i < ii; ++i) {
	          filter = this.xref.fetchIfRef(filterArray[i]);
	          if (!isName(filter)) {
	            error('Bad filter name: ' + filter);
	          }
	          params = null;
	          if (isArray(paramsArray) && i in paramsArray) {
	            params = this.xref.fetchIfRef(paramsArray[i]);
	          }
	          stream = this.makeFilter(stream, filter.name, maybeLength, params);
	          maybeLength = null;
	        }
	      }
	      return stream;
	    },
	    makeFilter: function Parser_makeFilter(stream, name, maybeLength, params) {
	      if (maybeLength === 0) {
	        warn('Empty "' + name + '" stream.');
	        return new NullStream(stream);
	      }
	      try {
	        var xrefStreamStats = this.xref.stats.streamTypes;
	        if (name === 'FlateDecode' || name === 'Fl') {
	          xrefStreamStats[StreamType.FLATE] = true;
	          if (params) {
	            return new PredictorStream(new FlateStream(stream, maybeLength), maybeLength, params);
	          }
	          return new FlateStream(stream, maybeLength);
	        }
	        if (name === 'LZWDecode' || name === 'LZW') {
	          xrefStreamStats[StreamType.LZW] = true;
	          var earlyChange = 1;
	          if (params) {
	            if (params.has('EarlyChange')) {
	              earlyChange = params.get('EarlyChange');
	            }
	            return new PredictorStream(new LZWStream(stream, maybeLength, earlyChange), maybeLength, params);
	          }
	          return new LZWStream(stream, maybeLength, earlyChange);
	        }
	        if (name === 'DCTDecode' || name === 'DCT') {
	          xrefStreamStats[StreamType.DCT] = true;
	          return new JpegStream(stream, maybeLength, stream.dict, params);
	        }
	        if (name === 'JPXDecode' || name === 'JPX') {
	          xrefStreamStats[StreamType.JPX] = true;
	          return new JpxStream(stream, maybeLength, stream.dict, params);
	        }
	        if (name === 'ASCII85Decode' || name === 'A85') {
	          xrefStreamStats[StreamType.A85] = true;
	          return new Ascii85Stream(stream, maybeLength);
	        }
	        if (name === 'ASCIIHexDecode' || name === 'AHx') {
	          xrefStreamStats[StreamType.AHX] = true;
	          return new AsciiHexStream(stream, maybeLength);
	        }
	        if (name === 'CCITTFaxDecode' || name === 'CCF') {
	          xrefStreamStats[StreamType.CCF] = true;
	          return new CCITTFaxStream(stream, maybeLength, params);
	        }
	        if (name === 'RunLengthDecode' || name === 'RL') {
	          xrefStreamStats[StreamType.RL] = true;
	          return new RunLengthStream(stream, maybeLength);
	        }
	        if (name === 'JBIG2Decode') {
	          xrefStreamStats[StreamType.JBIG] = true;
	          return new Jbig2Stream(stream, maybeLength, stream.dict, params);
	        }
	        warn('filter "' + name + '" not supported yet');
	        return stream;
	      } catch (ex) {
	        if (ex instanceof MissingDataException) {
	          throw ex;
	        }
	        warn('Invalid stream: \"' + ex + '\"');
	        return new NullStream(stream);
	      }
	    }
	  };
	  return Parser;
	}();
	var Lexer = function LexerClosure() {
	  function Lexer(stream, knownCommands) {
	    this.stream = stream;
	    this.nextChar();
	    this.strBuf = [];
	    this.knownCommands = knownCommands;
	  }
	  var specialChars = [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	  function toHexDigit(ch) {
	    if (ch >= 0x30 && ch <= 0x39) {
	      return ch & 0x0F;
	    }
	    if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) {
	      return (ch & 0x0F) + 9;
	    }
	    return -1;
	  }
	  Lexer.prototype = {
	    nextChar: function Lexer_nextChar() {
	      return this.currentChar = this.stream.getByte();
	    },
	    peekChar: function Lexer_peekChar() {
	      return this.stream.peekByte();
	    },
	    getNumber: function Lexer_getNumber() {
	      var ch = this.currentChar;
	      var eNotation = false;
	      var divideBy = 0;
	      var sign = 1;
	      if (ch === 0x2D) {
	        sign = -1;
	        ch = this.nextChar();
	        if (ch === 0x2D) {
	          ch = this.nextChar();
	        }
	      } else if (ch === 0x2B) {
	        ch = this.nextChar();
	      }
	      if (ch === 0x2E) {
	        divideBy = 10;
	        ch = this.nextChar();
	      }
	      if (ch === 0x0A || ch === 0x0D) {
	        do {
	          ch = this.nextChar();
	        } while (ch === 0x0A || ch === 0x0D);
	      }
	      if (ch < 0x30 || ch > 0x39) {
	        error('Invalid number: ' + String.fromCharCode(ch) + ' (charCode ' + ch + ')');
	      }
	      var baseValue = ch - 0x30;
	      var powerValue = 0;
	      var powerValueSign = 1;
	      while ((ch = this.nextChar()) >= 0) {
	        if (0x30 <= ch && ch <= 0x39) {
	          var currentDigit = ch - 0x30;
	          if (eNotation) {
	            powerValue = powerValue * 10 + currentDigit;
	          } else {
	            if (divideBy !== 0) {
	              divideBy *= 10;
	            }
	            baseValue = baseValue * 10 + currentDigit;
	          }
	        } else if (ch === 0x2E) {
	          if (divideBy === 0) {
	            divideBy = 1;
	          } else {
	            break;
	          }
	        } else if (ch === 0x2D) {
	          warn('Badly formatted number');
	        } else if (ch === 0x45 || ch === 0x65) {
	          ch = this.peekChar();
	          if (ch === 0x2B || ch === 0x2D) {
	            powerValueSign = ch === 0x2D ? -1 : 1;
	            this.nextChar();
	          } else if (ch < 0x30 || ch > 0x39) {
	            break;
	          }
	          eNotation = true;
	        } else {
	          break;
	        }
	      }
	      if (divideBy !== 0) {
	        baseValue /= divideBy;
	      }
	      if (eNotation) {
	        baseValue *= Math.pow(10, powerValueSign * powerValue);
	      }
	      return sign * baseValue;
	    },
	    getString: function Lexer_getString() {
	      var numParen = 1;
	      var done = false;
	      var strBuf = this.strBuf;
	      strBuf.length = 0;
	      var ch = this.nextChar();
	      while (true) {
	        var charBuffered = false;
	        switch (ch | 0) {
	          case -1:
	            warn('Unterminated string');
	            done = true;
	            break;
	          case 0x28:
	            ++numParen;
	            strBuf.push('(');
	            break;
	          case 0x29:
	            if (--numParen === 0) {
	              this.nextChar();
	              done = true;
	            } else {
	              strBuf.push(')');
	            }
	            break;
	          case 0x5C:
	            ch = this.nextChar();
	            switch (ch) {
	              case -1:
	                warn('Unterminated string');
	                done = true;
	                break;
	              case 0x6E:
	                strBuf.push('\n');
	                break;
	              case 0x72:
	                strBuf.push('\r');
	                break;
	              case 0x74:
	                strBuf.push('\t');
	                break;
	              case 0x62:
	                strBuf.push('\b');
	                break;
	              case 0x66:
	                strBuf.push('\f');
	                break;
	              case 0x5C:
	              case 0x28:
	              case 0x29:
	                strBuf.push(String.fromCharCode(ch));
	                break;
	              case 0x30:
	              case 0x31:
	              case 0x32:
	              case 0x33:
	              case 0x34:
	              case 0x35:
	              case 0x36:
	              case 0x37:
	                var x = ch & 0x0F;
	                ch = this.nextChar();
	                charBuffered = true;
	                if (ch >= 0x30 && ch <= 0x37) {
	                  x = (x << 3) + (ch & 0x0F);
	                  ch = this.nextChar();
	                  if (ch >= 0x30 && ch <= 0x37) {
	                    charBuffered = false;
	                    x = (x << 3) + (ch & 0x0F);
	                  }
	                }
	                strBuf.push(String.fromCharCode(x));
	                break;
	              case 0x0D:
	                if (this.peekChar() === 0x0A) {
	                  this.nextChar();
	                }
	                break;
	              case 0x0A:
	                break;
	              default:
	                strBuf.push(String.fromCharCode(ch));
	                break;
	            }
	            break;
	          default:
	            strBuf.push(String.fromCharCode(ch));
	            break;
	        }
	        if (done) {
	          break;
	        }
	        if (!charBuffered) {
	          ch = this.nextChar();
	        }
	      }
	      return strBuf.join('');
	    },
	    getName: function Lexer_getName() {
	      var ch, previousCh;
	      var strBuf = this.strBuf;
	      strBuf.length = 0;
	      while ((ch = this.nextChar()) >= 0 && !specialChars[ch]) {
	        if (ch === 0x23) {
	          ch = this.nextChar();
	          if (specialChars[ch]) {
	            warn('Lexer_getName: ' + 'NUMBER SIGN (#) should be followed by a hexadecimal number.');
	            strBuf.push('#');
	            break;
	          }
	          var x = toHexDigit(ch);
	          if (x !== -1) {
	            previousCh = ch;
	            ch = this.nextChar();
	            var x2 = toHexDigit(ch);
	            if (x2 === -1) {
	              warn('Lexer_getName: Illegal digit (' + String.fromCharCode(ch) + ') in hexadecimal number.');
	              strBuf.push('#', String.fromCharCode(previousCh));
	              if (specialChars[ch]) {
	                break;
	              }
	              strBuf.push(String.fromCharCode(ch));
	              continue;
	            }
	            strBuf.push(String.fromCharCode(x << 4 | x2));
	          } else {
	            strBuf.push('#', String.fromCharCode(ch));
	          }
	        } else {
	          strBuf.push(String.fromCharCode(ch));
	        }
	      }
	      if (strBuf.length > 127) {
	        warn('name token is longer than allowed by the spec: ' + strBuf.length);
	      }
	      return Name.get(strBuf.join(''));
	    },
	    getHexString: function Lexer_getHexString() {
	      var strBuf = this.strBuf;
	      strBuf.length = 0;
	      var ch = this.currentChar;
	      var isFirstHex = true;
	      var firstDigit;
	      var secondDigit;
	      while (true) {
	        if (ch < 0) {
	          warn('Unterminated hex string');
	          break;
	        } else if (ch === 0x3E) {
	          this.nextChar();
	          break;
	        } else if (specialChars[ch] === 1) {
	          ch = this.nextChar();
	          continue;
	        } else {
	          if (isFirstHex) {
	            firstDigit = toHexDigit(ch);
	            if (firstDigit === -1) {
	              warn('Ignoring invalid character "' + ch + '" in hex string');
	              ch = this.nextChar();
	              continue;
	            }
	          } else {
	            secondDigit = toHexDigit(ch);
	            if (secondDigit === -1) {
	              warn('Ignoring invalid character "' + ch + '" in hex string');
	              ch = this.nextChar();
	              continue;
	            }
	            strBuf.push(String.fromCharCode(firstDigit << 4 | secondDigit));
	          }
	          isFirstHex = !isFirstHex;
	          ch = this.nextChar();
	        }
	      }
	      return strBuf.join('');
	    },
	    getObj: function Lexer_getObj() {
	      var comment = false;
	      var ch = this.currentChar;
	      while (true) {
	        if (ch < 0) {
	          return EOF;
	        }
	        if (comment) {
	          if (ch === 0x0A || ch === 0x0D) {
	            comment = false;
	          }
	        } else if (ch === 0x25) {
	          comment = true;
	        } else if (specialChars[ch] !== 1) {
	          break;
	        }
	        ch = this.nextChar();
	      }
	      switch (ch | 0) {
	        case 0x30:
	        case 0x31:
	        case 0x32:
	        case 0x33:
	        case 0x34:
	        case 0x35:
	        case 0x36:
	        case 0x37:
	        case 0x38:
	        case 0x39:
	        case 0x2B:
	        case 0x2D:
	        case 0x2E:
	          return this.getNumber();
	        case 0x28:
	          return this.getString();
	        case 0x2F:
	          return this.getName();
	        case 0x5B:
	          this.nextChar();
	          return Cmd.get('[');
	        case 0x5D:
	          this.nextChar();
	          return Cmd.get(']');
	        case 0x3C:
	          ch = this.nextChar();
	          if (ch === 0x3C) {
	            this.nextChar();
	            return Cmd.get('<<');
	          }
	          return this.getHexString();
	        case 0x3E:
	          ch = this.nextChar();
	          if (ch === 0x3E) {
	            this.nextChar();
	            return Cmd.get('>>');
	          }
	          return Cmd.get('>');
	        case 0x7B:
	          this.nextChar();
	          return Cmd.get('{');
	        case 0x7D:
	          this.nextChar();
	          return Cmd.get('}');
	        case 0x29:
	          this.nextChar();
	          error('Illegal character: ' + ch);
	          break;
	      }
	      var str = String.fromCharCode(ch);
	      var knownCommands = this.knownCommands;
	      var knownCommandFound = knownCommands && knownCommands[str] !== undefined;
	      while ((ch = this.nextChar()) >= 0 && !specialChars[ch]) {
	        var possibleCommand = str + String.fromCharCode(ch);
	        if (knownCommandFound && knownCommands[possibleCommand] === undefined) {
	          break;
	        }
	        if (str.length === 128) {
	          error('Command token too long: ' + str.length);
	        }
	        str = possibleCommand;
	        knownCommandFound = knownCommands && knownCommands[str] !== undefined;
	      }
	      if (str === 'true') {
	        return true;
	      }
	      if (str === 'false') {
	        return false;
	      }
	      if (str === 'null') {
	        return null;
	      }
	      return Cmd.get(str);
	    },
	    skipToNextLine: function Lexer_skipToNextLine() {
	      var ch = this.currentChar;
	      while (ch >= 0) {
	        if (ch === 0x0D) {
	          ch = this.nextChar();
	          if (ch === 0x0A) {
	            this.nextChar();
	          }
	          break;
	        } else if (ch === 0x0A) {
	          this.nextChar();
	          break;
	        }
	        ch = this.nextChar();
	      }
	    }
	  };
	  return Lexer;
	}();
	var Linearization = {
	  create: function LinearizationCreate(stream) {
	    function getInt(name, allowZeroValue) {
	      var obj = linDict.get(name);
	      if (isInt(obj) && (allowZeroValue ? obj >= 0 : obj > 0)) {
	        return obj;
	      }
	      throw new Error('The "' + name + '" parameter in the linearization ' + 'dictionary is invalid.');
	    }
	    function getHints() {
	      var hints = linDict.get('H'),
	          hintsLength,
	          item;
	      if (isArray(hints) && ((hintsLength = hints.length) === 2 || hintsLength === 4)) {
	        for (var index = 0; index < hintsLength; index++) {
	          if (!(isInt(item = hints[index]) && item > 0)) {
	            throw new Error('Hint (' + index + ') in the linearization dictionary is invalid.');
	          }
	        }
	        return hints;
	      }
	      throw new Error('Hint array in the linearization dictionary is invalid.');
	    }
	    var parser = new Parser(new Lexer(stream), false, null);
	    var obj1 = parser.getObj();
	    var obj2 = parser.getObj();
	    var obj3 = parser.getObj();
	    var linDict = parser.getObj();
	    var obj, length;
	    if (!(isInt(obj1) && isInt(obj2) && isCmd(obj3, 'obj') && isDict(linDict) && isNum(obj = linDict.get('Linearized')) && obj > 0)) {
	      return null;
	    } else if ((length = getInt('L')) !== stream.length) {
	      throw new Error('The "L" parameter in the linearization dictionary ' + 'does not equal the stream length.');
	    }
	    return {
	      length: length,
	      hints: getHints(),
	      objectNumberFirst: getInt('O'),
	      endFirst: getInt('E'),
	      numPages: getInt('N'),
	      mainXRefEntriesOffset: getInt('T'),
	      pageFirst: linDict.has('P') ? getInt('P', true) : 0
	    };
	  }
	};
	exports.Lexer = Lexer;
	exports.Linearization = Linearization;
	exports.Parser = Parser;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var corePsParser = __w_pdfjs_require__(34);
	var error = sharedUtil.error;
	var info = sharedUtil.info;
	var isArray = sharedUtil.isArray;
	var isBool = sharedUtil.isBool;
	var isDict = corePrimitives.isDict;
	var isStream = corePrimitives.isStream;
	var PostScriptLexer = corePsParser.PostScriptLexer;
	var PostScriptParser = corePsParser.PostScriptParser;
	var PDFFunction = function PDFFunctionClosure() {
	  var CONSTRUCT_SAMPLED = 0;
	  var CONSTRUCT_INTERPOLATED = 2;
	  var CONSTRUCT_STICHED = 3;
	  var CONSTRUCT_POSTSCRIPT = 4;
	  return {
	    getSampleArray: function PDFFunction_getSampleArray(size, outputSize, bps, str) {
	      var i, ii;
	      var length = 1;
	      for (i = 0, ii = size.length; i < ii; i++) {
	        length *= size[i];
	      }
	      length *= outputSize;
	      var array = new Array(length);
	      var codeSize = 0;
	      var codeBuf = 0;
	      var sampleMul = 1.0 / (Math.pow(2.0, bps) - 1);
	      var strBytes = str.getBytes((length * bps + 7) / 8);
	      var strIdx = 0;
	      for (i = 0; i < length; i++) {
	        while (codeSize < bps) {
	          codeBuf <<= 8;
	          codeBuf |= strBytes[strIdx++];
	          codeSize += 8;
	        }
	        codeSize -= bps;
	        array[i] = (codeBuf >> codeSize) * sampleMul;
	        codeBuf &= (1 << codeSize) - 1;
	      }
	      return array;
	    },
	    getIR: function PDFFunction_getIR(xref, fn) {
	      var dict = fn.dict;
	      if (!dict) {
	        dict = fn;
	      }
	      var types = [this.constructSampled, null, this.constructInterpolated, this.constructStiched, this.constructPostScript];
	      var typeNum = dict.get('FunctionType');
	      var typeFn = types[typeNum];
	      if (!typeFn) {
	        error('Unknown type of function');
	      }
	      return typeFn.call(this, fn, dict, xref);
	    },
	    fromIR: function PDFFunction_fromIR(IR) {
	      var type = IR[0];
	      switch (type) {
	        case CONSTRUCT_SAMPLED:
	          return this.constructSampledFromIR(IR);
	        case CONSTRUCT_INTERPOLATED:
	          return this.constructInterpolatedFromIR(IR);
	        case CONSTRUCT_STICHED:
	          return this.constructStichedFromIR(IR);
	        default:
	          return this.constructPostScriptFromIR(IR);
	      }
	    },
	    parse: function PDFFunction_parse(xref, fn) {
	      var IR = this.getIR(xref, fn);
	      return this.fromIR(IR);
	    },
	    parseArray: function PDFFunction_parseArray(xref, fnObj) {
	      if (!isArray(fnObj)) {
	        return this.parse(xref, fnObj);
	      }
	      var fnArray = [];
	      for (var j = 0, jj = fnObj.length; j < jj; j++) {
	        var obj = xref.fetchIfRef(fnObj[j]);
	        fnArray.push(PDFFunction.parse(xref, obj));
	      }
	      return function (src, srcOffset, dest, destOffset) {
	        for (var i = 0, ii = fnArray.length; i < ii; i++) {
	          fnArray[i](src, srcOffset, dest, destOffset + i);
	        }
	      };
	    },
	    constructSampled: function PDFFunction_constructSampled(str, dict) {
	      function toMultiArray(arr) {
	        var inputLength = arr.length;
	        var out = [];
	        var index = 0;
	        for (var i = 0; i < inputLength; i += 2) {
	          out[index] = [arr[i], arr[i + 1]];
	          ++index;
	        }
	        return out;
	      }
	      var domain = dict.getArray('Domain');
	      var range = dict.getArray('Range');
	      if (!domain || !range) {
	        error('No domain or range');
	      }
	      var inputSize = domain.length / 2;
	      var outputSize = range.length / 2;
	      domain = toMultiArray(domain);
	      range = toMultiArray(range);
	      var size = dict.get('Size');
	      var bps = dict.get('BitsPerSample');
	      var order = dict.get('Order') || 1;
	      if (order !== 1) {
	        info('No support for cubic spline interpolation: ' + order);
	      }
	      var encode = dict.getArray('Encode');
	      if (!encode) {
	        encode = [];
	        for (var i = 0; i < inputSize; ++i) {
	          encode.push(0);
	          encode.push(size[i] - 1);
	        }
	      }
	      encode = toMultiArray(encode);
	      var decode = dict.getArray('Decode');
	      if (!decode) {
	        decode = range;
	      } else {
	        decode = toMultiArray(decode);
	      }
	      var samples = this.getSampleArray(size, outputSize, bps, str);
	      return [CONSTRUCT_SAMPLED, inputSize, domain, encode, decode, samples, size, outputSize, Math.pow(2, bps) - 1, range];
	    },
	    constructSampledFromIR: function PDFFunction_constructSampledFromIR(IR) {
	      function interpolate(x, xmin, xmax, ymin, ymax) {
	        return ymin + (x - xmin) * ((ymax - ymin) / (xmax - xmin));
	      }
	      return function constructSampledFromIRResult(src, srcOffset, dest, destOffset) {
	        var m = IR[1];
	        var domain = IR[2];
	        var encode = IR[3];
	        var decode = IR[4];
	        var samples = IR[5];
	        var size = IR[6];
	        var n = IR[7];
	        var range = IR[9];
	        var cubeVertices = 1 << m;
	        var cubeN = new Float64Array(cubeVertices);
	        var cubeVertex = new Uint32Array(cubeVertices);
	        var i, j;
	        for (j = 0; j < cubeVertices; j++) {
	          cubeN[j] = 1;
	        }
	        var k = n,
	            pos = 1;
	        for (i = 0; i < m; ++i) {
	          var domain_2i = domain[i][0];
	          var domain_2i_1 = domain[i][1];
	          var xi = Math.min(Math.max(src[srcOffset + i], domain_2i), domain_2i_1);
	          var e = interpolate(xi, domain_2i, domain_2i_1, encode[i][0], encode[i][1]);
	          var size_i = size[i];
	          e = Math.min(Math.max(e, 0), size_i - 1);
	          var e0 = e < size_i - 1 ? Math.floor(e) : e - 1;
	          var n0 = e0 + 1 - e;
	          var n1 = e - e0;
	          var offset0 = e0 * k;
	          var offset1 = offset0 + k;
	          for (j = 0; j < cubeVertices; j++) {
	            if (j & pos) {
	              cubeN[j] *= n1;
	              cubeVertex[j] += offset1;
	            } else {
	              cubeN[j] *= n0;
	              cubeVertex[j] += offset0;
	            }
	          }
	          k *= size_i;
	          pos <<= 1;
	        }
	        for (j = 0; j < n; ++j) {
	          var rj = 0;
	          for (i = 0; i < cubeVertices; i++) {
	            rj += samples[cubeVertex[i] + j] * cubeN[i];
	          }
	          rj = interpolate(rj, 0, 1, decode[j][0], decode[j][1]);
	          dest[destOffset + j] = Math.min(Math.max(rj, range[j][0]), range[j][1]);
	        }
	      };
	    },
	    constructInterpolated: function PDFFunction_constructInterpolated(str, dict) {
	      var c0 = dict.getArray('C0') || [0];
	      var c1 = dict.getArray('C1') || [1];
	      var n = dict.get('N');
	      if (!isArray(c0) || !isArray(c1)) {
	        error('Illegal dictionary for interpolated function');
	      }
	      var length = c0.length;
	      var diff = [];
	      for (var i = 0; i < length; ++i) {
	        diff.push(c1[i] - c0[i]);
	      }
	      return [CONSTRUCT_INTERPOLATED, c0, diff, n];
	    },
	    constructInterpolatedFromIR: function PDFFunction_constructInterpolatedFromIR(IR) {
	      var c0 = IR[1];
	      var diff = IR[2];
	      var n = IR[3];
	      var length = diff.length;
	      return function constructInterpolatedFromIRResult(src, srcOffset, dest, destOffset) {
	        var x = n === 1 ? src[srcOffset] : Math.pow(src[srcOffset], n);
	        for (var j = 0; j < length; ++j) {
	          dest[destOffset + j] = c0[j] + x * diff[j];
	        }
	      };
	    },
	    constructStiched: function PDFFunction_constructStiched(fn, dict, xref) {
	      var domain = dict.getArray('Domain');
	      if (!domain) {
	        error('No domain');
	      }
	      var inputSize = domain.length / 2;
	      if (inputSize !== 1) {
	        error('Bad domain for stiched function');
	      }
	      var fnRefs = dict.get('Functions');
	      var fns = [];
	      for (var i = 0, ii = fnRefs.length; i < ii; ++i) {
	        fns.push(PDFFunction.getIR(xref, xref.fetchIfRef(fnRefs[i])));
	      }
	      var bounds = dict.getArray('Bounds');
	      var encode = dict.getArray('Encode');
	      return [CONSTRUCT_STICHED, domain, bounds, encode, fns];
	    },
	    constructStichedFromIR: function PDFFunction_constructStichedFromIR(IR) {
	      var domain = IR[1];
	      var bounds = IR[2];
	      var encode = IR[3];
	      var fnsIR = IR[4];
	      var fns = [];
	      var tmpBuf = new Float32Array(1);
	      for (var i = 0, ii = fnsIR.length; i < ii; i++) {
	        fns.push(PDFFunction.fromIR(fnsIR[i]));
	      }
	      return function constructStichedFromIRResult(src, srcOffset, dest, destOffset) {
	        var clip = function constructStichedFromIRClip(v, min, max) {
	          if (v > max) {
	            v = max;
	          } else if (v < min) {
	            v = min;
	          }
	          return v;
	        };
	        var v = clip(src[srcOffset], domain[0], domain[1]);
	        for (var i = 0, ii = bounds.length; i < ii; ++i) {
	          if (v < bounds[i]) {
	            break;
	          }
	        }
	        var dmin = domain[0];
	        if (i > 0) {
	          dmin = bounds[i - 1];
	        }
	        var dmax = domain[1];
	        if (i < bounds.length) {
	          dmax = bounds[i];
	        }
	        var rmin = encode[2 * i];
	        var rmax = encode[2 * i + 1];
	        tmpBuf[0] = dmin === dmax ? rmin : rmin + (v - dmin) * (rmax - rmin) / (dmax - dmin);
	        fns[i](tmpBuf, 0, dest, destOffset);
	      };
	    },
	    constructPostScript: function PDFFunction_constructPostScript(fn, dict, xref) {
	      var domain = dict.getArray('Domain');
	      var range = dict.getArray('Range');
	      if (!domain) {
	        error('No domain.');
	      }
	      if (!range) {
	        error('No range.');
	      }
	      var lexer = new PostScriptLexer(fn);
	      var parser = new PostScriptParser(lexer);
	      var code = parser.parse();
	      return [CONSTRUCT_POSTSCRIPT, domain, range, code];
	    },
	    constructPostScriptFromIR: function PDFFunction_constructPostScriptFromIR(IR) {
	      var domain = IR[1];
	      var range = IR[2];
	      var code = IR[3];
	      var compiled = new PostScriptCompiler().compile(code, domain, range);
	      if (compiled) {
	        return new Function('src', 'srcOffset', 'dest', 'destOffset', compiled);
	      }
	      info('Unable to compile PS function');
	      var numOutputs = range.length >> 1;
	      var numInputs = domain.length >> 1;
	      var evaluator = new PostScriptEvaluator(code);
	      var cache = Object.create(null);
	      var MAX_CACHE_SIZE = 2048 * 4;
	      var cache_available = MAX_CACHE_SIZE;
	      var tmpBuf = new Float32Array(numInputs);
	      return function constructPostScriptFromIRResult(src, srcOffset, dest, destOffset) {
	        var i, value;
	        var key = '';
	        var input = tmpBuf;
	        for (i = 0; i < numInputs; i++) {
	          value = src[srcOffset + i];
	          input[i] = value;
	          key += value + '_';
	        }
	        var cachedValue = cache[key];
	        if (cachedValue !== undefined) {
	          dest.set(cachedValue, destOffset);
	          return;
	        }
	        var output = new Float32Array(numOutputs);
	        var stack = evaluator.execute(input);
	        var stackIndex = stack.length - numOutputs;
	        for (i = 0; i < numOutputs; i++) {
	          value = stack[stackIndex + i];
	          var bound = range[i * 2];
	          if (value < bound) {
	            value = bound;
	          } else {
	            bound = range[i * 2 + 1];
	            if (value > bound) {
	              value = bound;
	            }
	          }
	          output[i] = value;
	        }
	        if (cache_available > 0) {
	          cache_available--;
	          cache[key] = output;
	        }
	        dest.set(output, destOffset);
	      };
	    }
	  };
	}();
	function isPDFFunction(v) {
	  var fnDict;
	  if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) !== 'object') {
	    return false;
	  } else if (isDict(v)) {
	    fnDict = v;
	  } else if (isStream(v)) {
	    fnDict = v.dict;
	  } else {
	    return false;
	  }
	  return fnDict.has('FunctionType');
	}
	var PostScriptStack = function PostScriptStackClosure() {
	  var MAX_STACK_SIZE = 100;
	  function PostScriptStack(initialStack) {
	    this.stack = !initialStack ? [] : Array.prototype.slice.call(initialStack, 0);
	  }
	  PostScriptStack.prototype = {
	    push: function PostScriptStack_push(value) {
	      if (this.stack.length >= MAX_STACK_SIZE) {
	        error('PostScript function stack overflow.');
	      }
	      this.stack.push(value);
	    },
	    pop: function PostScriptStack_pop() {
	      if (this.stack.length <= 0) {
	        error('PostScript function stack underflow.');
	      }
	      return this.stack.pop();
	    },
	    copy: function PostScriptStack_copy(n) {
	      if (this.stack.length + n >= MAX_STACK_SIZE) {
	        error('PostScript function stack overflow.');
	      }
	      var stack = this.stack;
	      for (var i = stack.length - n, j = n - 1; j >= 0; j--, i++) {
	        stack.push(stack[i]);
	      }
	    },
	    index: function PostScriptStack_index(n) {
	      this.push(this.stack[this.stack.length - n - 1]);
	    },
	    roll: function PostScriptStack_roll(n, p) {
	      var stack = this.stack;
	      var l = stack.length - n;
	      var r = stack.length - 1,
	          c = l + (p - Math.floor(p / n) * n),
	          i,
	          j,
	          t;
	      for (i = l, j = r; i < j; i++, j--) {
	        t = stack[i];
	        stack[i] = stack[j];
	        stack[j] = t;
	      }
	      for (i = l, j = c - 1; i < j; i++, j--) {
	        t = stack[i];
	        stack[i] = stack[j];
	        stack[j] = t;
	      }
	      for (i = c, j = r; i < j; i++, j--) {
	        t = stack[i];
	        stack[i] = stack[j];
	        stack[j] = t;
	      }
	    }
	  };
	  return PostScriptStack;
	}();
	var PostScriptEvaluator = function PostScriptEvaluatorClosure() {
	  function PostScriptEvaluator(operators) {
	    this.operators = operators;
	  }
	  PostScriptEvaluator.prototype = {
	    execute: function PostScriptEvaluator_execute(initialStack) {
	      var stack = new PostScriptStack(initialStack);
	      var counter = 0;
	      var operators = this.operators;
	      var length = operators.length;
	      var operator, a, b;
	      while (counter < length) {
	        operator = operators[counter++];
	        if (typeof operator === 'number') {
	          stack.push(operator);
	          continue;
	        }
	        switch (operator) {
	          case 'jz':
	            b = stack.pop();
	            a = stack.pop();
	            if (!a) {
	              counter = b;
	            }
	            break;
	          case 'j':
	            a = stack.pop();
	            counter = a;
	            break;
	          case 'abs':
	            a = stack.pop();
	            stack.push(Math.abs(a));
	            break;
	          case 'add':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a + b);
	            break;
	          case 'and':
	            b = stack.pop();
	            a = stack.pop();
	            if (isBool(a) && isBool(b)) {
	              stack.push(a && b);
	            } else {
	              stack.push(a & b);
	            }
	            break;
	          case 'atan':
	            a = stack.pop();
	            stack.push(Math.atan(a));
	            break;
	          case 'bitshift':
	            b = stack.pop();
	            a = stack.pop();
	            if (a > 0) {
	              stack.push(a << b);
	            } else {
	              stack.push(a >> b);
	            }
	            break;
	          case 'ceiling':
	            a = stack.pop();
	            stack.push(Math.ceil(a));
	            break;
	          case 'copy':
	            a = stack.pop();
	            stack.copy(a);
	            break;
	          case 'cos':
	            a = stack.pop();
	            stack.push(Math.cos(a));
	            break;
	          case 'cvi':
	            a = stack.pop() | 0;
	            stack.push(a);
	            break;
	          case 'cvr':
	            break;
	          case 'div':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a / b);
	            break;
	          case 'dup':
	            stack.copy(1);
	            break;
	          case 'eq':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a === b);
	            break;
	          case 'exch':
	            stack.roll(2, 1);
	            break;
	          case 'exp':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(Math.pow(a, b));
	            break;
	          case 'false':
	            stack.push(false);
	            break;
	          case 'floor':
	            a = stack.pop();
	            stack.push(Math.floor(a));
	            break;
	          case 'ge':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a >= b);
	            break;
	          case 'gt':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a > b);
	            break;
	          case 'idiv':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a / b | 0);
	            break;
	          case 'index':
	            a = stack.pop();
	            stack.index(a);
	            break;
	          case 'le':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a <= b);
	            break;
	          case 'ln':
	            a = stack.pop();
	            stack.push(Math.log(a));
	            break;
	          case 'log':
	            a = stack.pop();
	            stack.push(Math.log(a) / Math.LN10);
	            break;
	          case 'lt':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a < b);
	            break;
	          case 'mod':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a % b);
	            break;
	          case 'mul':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a * b);
	            break;
	          case 'ne':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a !== b);
	            break;
	          case 'neg':
	            a = stack.pop();
	            stack.push(-a);
	            break;
	          case 'not':
	            a = stack.pop();
	            if (isBool(a)) {
	              stack.push(!a);
	            } else {
	              stack.push(~a);
	            }
	            break;
	          case 'or':
	            b = stack.pop();
	            a = stack.pop();
	            if (isBool(a) && isBool(b)) {
	              stack.push(a || b);
	            } else {
	              stack.push(a | b);
	            }
	            break;
	          case 'pop':
	            stack.pop();
	            break;
	          case 'roll':
	            b = stack.pop();
	            a = stack.pop();
	            stack.roll(a, b);
	            break;
	          case 'round':
	            a = stack.pop();
	            stack.push(Math.round(a));
	            break;
	          case 'sin':
	            a = stack.pop();
	            stack.push(Math.sin(a));
	            break;
	          case 'sqrt':
	            a = stack.pop();
	            stack.push(Math.sqrt(a));
	            break;
	          case 'sub':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a - b);
	            break;
	          case 'true':
	            stack.push(true);
	            break;
	          case 'truncate':
	            a = stack.pop();
	            a = a < 0 ? Math.ceil(a) : Math.floor(a);
	            stack.push(a);
	            break;
	          case 'xor':
	            b = stack.pop();
	            a = stack.pop();
	            if (isBool(a) && isBool(b)) {
	              stack.push(a !== b);
	            } else {
	              stack.push(a ^ b);
	            }
	            break;
	          default:
	            error('Unknown operator ' + operator);
	            break;
	        }
	      }
	      return stack.stack;
	    }
	  };
	  return PostScriptEvaluator;
	}();
	var PostScriptCompiler = function PostScriptCompilerClosure() {
	  function AstNode(type) {
	    this.type = type;
	  }
	  AstNode.prototype.visit = function (visitor) {
	    throw new Error('abstract method');
	  };
	  function AstArgument(index, min, max) {
	    AstNode.call(this, 'args');
	    this.index = index;
	    this.min = min;
	    this.max = max;
	  }
	  AstArgument.prototype = Object.create(AstNode.prototype);
	  AstArgument.prototype.visit = function (visitor) {
	    visitor.visitArgument(this);
	  };
	  function AstLiteral(number) {
	    AstNode.call(this, 'literal');
	    this.number = number;
	    this.min = number;
	    this.max = number;
	  }
	  AstLiteral.prototype = Object.create(AstNode.prototype);
	  AstLiteral.prototype.visit = function (visitor) {
	    visitor.visitLiteral(this);
	  };
	  function AstBinaryOperation(op, arg1, arg2, min, max) {
	    AstNode.call(this, 'binary');
	    this.op = op;
	    this.arg1 = arg1;
	    this.arg2 = arg2;
	    this.min = min;
	    this.max = max;
	  }
	  AstBinaryOperation.prototype = Object.create(AstNode.prototype);
	  AstBinaryOperation.prototype.visit = function (visitor) {
	    visitor.visitBinaryOperation(this);
	  };
	  function AstMin(arg, max) {
	    AstNode.call(this, 'max');
	    this.arg = arg;
	    this.min = arg.min;
	    this.max = max;
	  }
	  AstMin.prototype = Object.create(AstNode.prototype);
	  AstMin.prototype.visit = function (visitor) {
	    visitor.visitMin(this);
	  };
	  function AstVariable(index, min, max) {
	    AstNode.call(this, 'var');
	    this.index = index;
	    this.min = min;
	    this.max = max;
	  }
	  AstVariable.prototype = Object.create(AstNode.prototype);
	  AstVariable.prototype.visit = function (visitor) {
	    visitor.visitVariable(this);
	  };
	  function AstVariableDefinition(variable, arg) {
	    AstNode.call(this, 'definition');
	    this.variable = variable;
	    this.arg = arg;
	  }
	  AstVariableDefinition.prototype = Object.create(AstNode.prototype);
	  AstVariableDefinition.prototype.visit = function (visitor) {
	    visitor.visitVariableDefinition(this);
	  };
	  function ExpressionBuilderVisitor() {
	    this.parts = [];
	  }
	  ExpressionBuilderVisitor.prototype = {
	    visitArgument: function visitArgument(arg) {
	      this.parts.push('Math.max(', arg.min, ', Math.min(', arg.max, ', src[srcOffset + ', arg.index, ']))');
	    },
	    visitVariable: function visitVariable(variable) {
	      this.parts.push('v', variable.index);
	    },
	    visitLiteral: function visitLiteral(literal) {
	      this.parts.push(literal.number);
	    },
	    visitBinaryOperation: function visitBinaryOperation(operation) {
	      this.parts.push('(');
	      operation.arg1.visit(this);
	      this.parts.push(' ', operation.op, ' ');
	      operation.arg2.visit(this);
	      this.parts.push(')');
	    },
	    visitVariableDefinition: function visitVariableDefinition(definition) {
	      this.parts.push('var ');
	      definition.variable.visit(this);
	      this.parts.push(' = ');
	      definition.arg.visit(this);
	      this.parts.push(';');
	    },
	    visitMin: function visitMin(max) {
	      this.parts.push('Math.min(');
	      max.arg.visit(this);
	      this.parts.push(', ', max.max, ')');
	    },
	    toString: function toString() {
	      return this.parts.join('');
	    }
	  };
	  function buildAddOperation(num1, num2) {
	    if (num2.type === 'literal' && num2.number === 0) {
	      return num1;
	    }
	    if (num1.type === 'literal' && num1.number === 0) {
	      return num2;
	    }
	    if (num2.type === 'literal' && num1.type === 'literal') {
	      return new AstLiteral(num1.number + num2.number);
	    }
	    return new AstBinaryOperation('+', num1, num2, num1.min + num2.min, num1.max + num2.max);
	  }
	  function buildMulOperation(num1, num2) {
	    if (num2.type === 'literal') {
	      if (num2.number === 0) {
	        return new AstLiteral(0);
	      } else if (num2.number === 1) {
	        return num1;
	      } else if (num1.type === 'literal') {
	        return new AstLiteral(num1.number * num2.number);
	      }
	    }
	    if (num1.type === 'literal') {
	      if (num1.number === 0) {
	        return new AstLiteral(0);
	      } else if (num1.number === 1) {
	        return num2;
	      }
	    }
	    var min = Math.min(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
	    var max = Math.max(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
	    return new AstBinaryOperation('*', num1, num2, min, max);
	  }
	  function buildSubOperation(num1, num2) {
	    if (num2.type === 'literal') {
	      if (num2.number === 0) {
	        return num1;
	      } else if (num1.type === 'literal') {
	        return new AstLiteral(num1.number - num2.number);
	      }
	    }
	    if (num2.type === 'binary' && num2.op === '-' && num1.type === 'literal' && num1.number === 1 && num2.arg1.type === 'literal' && num2.arg1.number === 1) {
	      return num2.arg2;
	    }
	    return new AstBinaryOperation('-', num1, num2, num1.min - num2.max, num1.max - num2.min);
	  }
	  function buildMinOperation(num1, max) {
	    if (num1.min >= max) {
	      return new AstLiteral(max);
	    } else if (num1.max <= max) {
	      return num1;
	    }
	    return new AstMin(num1, max);
	  }
	  function PostScriptCompiler() {}
	  PostScriptCompiler.prototype = {
	    compile: function PostScriptCompiler_compile(code, domain, range) {
	      var stack = [];
	      var i, ii;
	      var instructions = [];
	      var inputSize = domain.length >> 1,
	          outputSize = range.length >> 1;
	      var lastRegister = 0;
	      var n, j;
	      var num1, num2, ast1, ast2, tmpVar, item;
	      for (i = 0; i < inputSize; i++) {
	        stack.push(new AstArgument(i, domain[i * 2], domain[i * 2 + 1]));
	      }
	      for (i = 0, ii = code.length; i < ii; i++) {
	        item = code[i];
	        if (typeof item === 'number') {
	          stack.push(new AstLiteral(item));
	          continue;
	        }
	        switch (item) {
	          case 'add':
	            if (stack.length < 2) {
	              return null;
	            }
	            num2 = stack.pop();
	            num1 = stack.pop();
	            stack.push(buildAddOperation(num1, num2));
	            break;
	          case 'cvr':
	            if (stack.length < 1) {
	              return null;
	            }
	            break;
	          case 'mul':
	            if (stack.length < 2) {
	              return null;
	            }
	            num2 = stack.pop();
	            num1 = stack.pop();
	            stack.push(buildMulOperation(num1, num2));
	            break;
	          case 'sub':
	            if (stack.length < 2) {
	              return null;
	            }
	            num2 = stack.pop();
	            num1 = stack.pop();
	            stack.push(buildSubOperation(num1, num2));
	            break;
	          case 'exch':
	            if (stack.length < 2) {
	              return null;
	            }
	            ast1 = stack.pop();
	            ast2 = stack.pop();
	            stack.push(ast1, ast2);
	            break;
	          case 'pop':
	            if (stack.length < 1) {
	              return null;
	            }
	            stack.pop();
	            break;
	          case 'index':
	            if (stack.length < 1) {
	              return null;
	            }
	            num1 = stack.pop();
	            if (num1.type !== 'literal') {
	              return null;
	            }
	            n = num1.number;
	            if (n < 0 || (n | 0) !== n || stack.length < n) {
	              return null;
	            }
	            ast1 = stack[stack.length - n - 1];
	            if (ast1.type === 'literal' || ast1.type === 'var') {
	              stack.push(ast1);
	              break;
	            }
	            tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
	            stack[stack.length - n - 1] = tmpVar;
	            stack.push(tmpVar);
	            instructions.push(new AstVariableDefinition(tmpVar, ast1));
	            break;
	          case 'dup':
	            if (stack.length < 1) {
	              return null;
	            }
	            if (typeof code[i + 1] === 'number' && code[i + 2] === 'gt' && code[i + 3] === i + 7 && code[i + 4] === 'jz' && code[i + 5] === 'pop' && code[i + 6] === code[i + 1]) {
	              num1 = stack.pop();
	              stack.push(buildMinOperation(num1, code[i + 1]));
	              i += 6;
	              break;
	            }
	            ast1 = stack[stack.length - 1];
	            if (ast1.type === 'literal' || ast1.type === 'var') {
	              stack.push(ast1);
	              break;
	            }
	            tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
	            stack[stack.length - 1] = tmpVar;
	            stack.push(tmpVar);
	            instructions.push(new AstVariableDefinition(tmpVar, ast1));
	            break;
	          case 'roll':
	            if (stack.length < 2) {
	              return null;
	            }
	            num2 = stack.pop();
	            num1 = stack.pop();
	            if (num2.type !== 'literal' || num1.type !== 'literal') {
	              return null;
	            }
	            j = num2.number;
	            n = num1.number;
	            if (n <= 0 || (n | 0) !== n || (j | 0) !== j || stack.length < n) {
	              return null;
	            }
	            j = (j % n + n) % n;
	            if (j === 0) {
	              break;
	            }
	            Array.prototype.push.apply(stack, stack.splice(stack.length - n, n - j));
	            break;
	          default:
	            return null;
	        }
	      }
	      if (stack.length !== outputSize) {
	        return null;
	      }
	      var result = [];
	      instructions.forEach(function (instruction) {
	        var statementBuilder = new ExpressionBuilderVisitor();
	        instruction.visit(statementBuilder);
	        result.push(statementBuilder.toString());
	      });
	      stack.forEach(function (expr, i) {
	        var statementBuilder = new ExpressionBuilderVisitor();
	        expr.visit(statementBuilder);
	        var min = range[i * 2],
	            max = range[i * 2 + 1];
	        var out = [statementBuilder.toString()];
	        if (min > expr.min) {
	          out.unshift('Math.max(', min, ', ');
	          out.push(')');
	        }
	        if (max < expr.max) {
	          out.unshift('Math.min(', max, ', ');
	          out.push(')');
	        }
	        out.unshift('dest[destOffset + ', i, '] = ');
	        out.push(';');
	        result.push(out.join(''));
	      });
	      return result.join('\n');
	    }
	  };
	  return PostScriptCompiler;
	}();
	exports.isPDFFunction = isPDFFunction;
	exports.PDFFunction = PDFFunction;
	exports.PostScriptEvaluator = PostScriptEvaluator;
	exports.PostScriptCompiler = PostScriptCompiler;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var getLookupTableFactory = sharedUtil.getLookupTableFactory;
	var getGlyphsUnicode = getLookupTableFactory(function (t) {
	  t['A'] = 0x0041;
	  t['AE'] = 0x00C6;
	  t['AEacute'] = 0x01FC;
	  t['AEmacron'] = 0x01E2;
	  t['AEsmall'] = 0xF7E6;
	  t['Aacute'] = 0x00C1;
	  t['Aacutesmall'] = 0xF7E1;
	  t['Abreve'] = 0x0102;
	  t['Abreveacute'] = 0x1EAE;
	  t['Abrevecyrillic'] = 0x04D0;
	  t['Abrevedotbelow'] = 0x1EB6;
	  t['Abrevegrave'] = 0x1EB0;
	  t['Abrevehookabove'] = 0x1EB2;
	  t['Abrevetilde'] = 0x1EB4;
	  t['Acaron'] = 0x01CD;
	  t['Acircle'] = 0x24B6;
	  t['Acircumflex'] = 0x00C2;
	  t['Acircumflexacute'] = 0x1EA4;
	  t['Acircumflexdotbelow'] = 0x1EAC;
	  t['Acircumflexgrave'] = 0x1EA6;
	  t['Acircumflexhookabove'] = 0x1EA8;
	  t['Acircumflexsmall'] = 0xF7E2;
	  t['Acircumflextilde'] = 0x1EAA;
	  t['Acute'] = 0xF6C9;
	  t['Acutesmall'] = 0xF7B4;
	  t['Acyrillic'] = 0x0410;
	  t['Adblgrave'] = 0x0200;
	  t['Adieresis'] = 0x00C4;
	  t['Adieresiscyrillic'] = 0x04D2;
	  t['Adieresismacron'] = 0x01DE;
	  t['Adieresissmall'] = 0xF7E4;
	  t['Adotbelow'] = 0x1EA0;
	  t['Adotmacron'] = 0x01E0;
	  t['Agrave'] = 0x00C0;
	  t['Agravesmall'] = 0xF7E0;
	  t['Ahookabove'] = 0x1EA2;
	  t['Aiecyrillic'] = 0x04D4;
	  t['Ainvertedbreve'] = 0x0202;
	  t['Alpha'] = 0x0391;
	  t['Alphatonos'] = 0x0386;
	  t['Amacron'] = 0x0100;
	  t['Amonospace'] = 0xFF21;
	  t['Aogonek'] = 0x0104;
	  t['Aring'] = 0x00C5;
	  t['Aringacute'] = 0x01FA;
	  t['Aringbelow'] = 0x1E00;
	  t['Aringsmall'] = 0xF7E5;
	  t['Asmall'] = 0xF761;
	  t['Atilde'] = 0x00C3;
	  t['Atildesmall'] = 0xF7E3;
	  t['Aybarmenian'] = 0x0531;
	  t['B'] = 0x0042;
	  t['Bcircle'] = 0x24B7;
	  t['Bdotaccent'] = 0x1E02;
	  t['Bdotbelow'] = 0x1E04;
	  t['Becyrillic'] = 0x0411;
	  t['Benarmenian'] = 0x0532;
	  t['Beta'] = 0x0392;
	  t['Bhook'] = 0x0181;
	  t['Blinebelow'] = 0x1E06;
	  t['Bmonospace'] = 0xFF22;
	  t['Brevesmall'] = 0xF6F4;
	  t['Bsmall'] = 0xF762;
	  t['Btopbar'] = 0x0182;
	  t['C'] = 0x0043;
	  t['Caarmenian'] = 0x053E;
	  t['Cacute'] = 0x0106;
	  t['Caron'] = 0xF6CA;
	  t['Caronsmall'] = 0xF6F5;
	  t['Ccaron'] = 0x010C;
	  t['Ccedilla'] = 0x00C7;
	  t['Ccedillaacute'] = 0x1E08;
	  t['Ccedillasmall'] = 0xF7E7;
	  t['Ccircle'] = 0x24B8;
	  t['Ccircumflex'] = 0x0108;
	  t['Cdot'] = 0x010A;
	  t['Cdotaccent'] = 0x010A;
	  t['Cedillasmall'] = 0xF7B8;
	  t['Chaarmenian'] = 0x0549;
	  t['Cheabkhasiancyrillic'] = 0x04BC;
	  t['Checyrillic'] = 0x0427;
	  t['Chedescenderabkhasiancyrillic'] = 0x04BE;
	  t['Chedescendercyrillic'] = 0x04B6;
	  t['Chedieresiscyrillic'] = 0x04F4;
	  t['Cheharmenian'] = 0x0543;
	  t['Chekhakassiancyrillic'] = 0x04CB;
	  t['Cheverticalstrokecyrillic'] = 0x04B8;
	  t['Chi'] = 0x03A7;
	  t['Chook'] = 0x0187;
	  t['Circumflexsmall'] = 0xF6F6;
	  t['Cmonospace'] = 0xFF23;
	  t['Coarmenian'] = 0x0551;
	  t['Csmall'] = 0xF763;
	  t['D'] = 0x0044;
	  t['DZ'] = 0x01F1;
	  t['DZcaron'] = 0x01C4;
	  t['Daarmenian'] = 0x0534;
	  t['Dafrican'] = 0x0189;
	  t['Dcaron'] = 0x010E;
	  t['Dcedilla'] = 0x1E10;
	  t['Dcircle'] = 0x24B9;
	  t['Dcircumflexbelow'] = 0x1E12;
	  t['Dcroat'] = 0x0110;
	  t['Ddotaccent'] = 0x1E0A;
	  t['Ddotbelow'] = 0x1E0C;
	  t['Decyrillic'] = 0x0414;
	  t['Deicoptic'] = 0x03EE;
	  t['Delta'] = 0x2206;
	  t['Deltagreek'] = 0x0394;
	  t['Dhook'] = 0x018A;
	  t['Dieresis'] = 0xF6CB;
	  t['DieresisAcute'] = 0xF6CC;
	  t['DieresisGrave'] = 0xF6CD;
	  t['Dieresissmall'] = 0xF7A8;
	  t['Digammagreek'] = 0x03DC;
	  t['Djecyrillic'] = 0x0402;
	  t['Dlinebelow'] = 0x1E0E;
	  t['Dmonospace'] = 0xFF24;
	  t['Dotaccentsmall'] = 0xF6F7;
	  t['Dslash'] = 0x0110;
	  t['Dsmall'] = 0xF764;
	  t['Dtopbar'] = 0x018B;
	  t['Dz'] = 0x01F2;
	  t['Dzcaron'] = 0x01C5;
	  t['Dzeabkhasiancyrillic'] = 0x04E0;
	  t['Dzecyrillic'] = 0x0405;
	  t['Dzhecyrillic'] = 0x040F;
	  t['E'] = 0x0045;
	  t['Eacute'] = 0x00C9;
	  t['Eacutesmall'] = 0xF7E9;
	  t['Ebreve'] = 0x0114;
	  t['Ecaron'] = 0x011A;
	  t['Ecedillabreve'] = 0x1E1C;
	  t['Echarmenian'] = 0x0535;
	  t['Ecircle'] = 0x24BA;
	  t['Ecircumflex'] = 0x00CA;
	  t['Ecircumflexacute'] = 0x1EBE;
	  t['Ecircumflexbelow'] = 0x1E18;
	  t['Ecircumflexdotbelow'] = 0x1EC6;
	  t['Ecircumflexgrave'] = 0x1EC0;
	  t['Ecircumflexhookabove'] = 0x1EC2;
	  t['Ecircumflexsmall'] = 0xF7EA;
	  t['Ecircumflextilde'] = 0x1EC4;
	  t['Ecyrillic'] = 0x0404;
	  t['Edblgrave'] = 0x0204;
	  t['Edieresis'] = 0x00CB;
	  t['Edieresissmall'] = 0xF7EB;
	  t['Edot'] = 0x0116;
	  t['Edotaccent'] = 0x0116;
	  t['Edotbelow'] = 0x1EB8;
	  t['Efcyrillic'] = 0x0424;
	  t['Egrave'] = 0x00C8;
	  t['Egravesmall'] = 0xF7E8;
	  t['Eharmenian'] = 0x0537;
	  t['Ehookabove'] = 0x1EBA;
	  t['Eightroman'] = 0x2167;
	  t['Einvertedbreve'] = 0x0206;
	  t['Eiotifiedcyrillic'] = 0x0464;
	  t['Elcyrillic'] = 0x041B;
	  t['Elevenroman'] = 0x216A;
	  t['Emacron'] = 0x0112;
	  t['Emacronacute'] = 0x1E16;
	  t['Emacrongrave'] = 0x1E14;
	  t['Emcyrillic'] = 0x041C;
	  t['Emonospace'] = 0xFF25;
	  t['Encyrillic'] = 0x041D;
	  t['Endescendercyrillic'] = 0x04A2;
	  t['Eng'] = 0x014A;
	  t['Enghecyrillic'] = 0x04A4;
	  t['Enhookcyrillic'] = 0x04C7;
	  t['Eogonek'] = 0x0118;
	  t['Eopen'] = 0x0190;
	  t['Epsilon'] = 0x0395;
	  t['Epsilontonos'] = 0x0388;
	  t['Ercyrillic'] = 0x0420;
	  t['Ereversed'] = 0x018E;
	  t['Ereversedcyrillic'] = 0x042D;
	  t['Escyrillic'] = 0x0421;
	  t['Esdescendercyrillic'] = 0x04AA;
	  t['Esh'] = 0x01A9;
	  t['Esmall'] = 0xF765;
	  t['Eta'] = 0x0397;
	  t['Etarmenian'] = 0x0538;
	  t['Etatonos'] = 0x0389;
	  t['Eth'] = 0x00D0;
	  t['Ethsmall'] = 0xF7F0;
	  t['Etilde'] = 0x1EBC;
	  t['Etildebelow'] = 0x1E1A;
	  t['Euro'] = 0x20AC;
	  t['Ezh'] = 0x01B7;
	  t['Ezhcaron'] = 0x01EE;
	  t['Ezhreversed'] = 0x01B8;
	  t['F'] = 0x0046;
	  t['Fcircle'] = 0x24BB;
	  t['Fdotaccent'] = 0x1E1E;
	  t['Feharmenian'] = 0x0556;
	  t['Feicoptic'] = 0x03E4;
	  t['Fhook'] = 0x0191;
	  t['Fitacyrillic'] = 0x0472;
	  t['Fiveroman'] = 0x2164;
	  t['Fmonospace'] = 0xFF26;
	  t['Fourroman'] = 0x2163;
	  t['Fsmall'] = 0xF766;
	  t['G'] = 0x0047;
	  t['GBsquare'] = 0x3387;
	  t['Gacute'] = 0x01F4;
	  t['Gamma'] = 0x0393;
	  t['Gammaafrican'] = 0x0194;
	  t['Gangiacoptic'] = 0x03EA;
	  t['Gbreve'] = 0x011E;
	  t['Gcaron'] = 0x01E6;
	  t['Gcedilla'] = 0x0122;
	  t['Gcircle'] = 0x24BC;
	  t['Gcircumflex'] = 0x011C;
	  t['Gcommaaccent'] = 0x0122;
	  t['Gdot'] = 0x0120;
	  t['Gdotaccent'] = 0x0120;
	  t['Gecyrillic'] = 0x0413;
	  t['Ghadarmenian'] = 0x0542;
	  t['Ghemiddlehookcyrillic'] = 0x0494;
	  t['Ghestrokecyrillic'] = 0x0492;
	  t['Gheupturncyrillic'] = 0x0490;
	  t['Ghook'] = 0x0193;
	  t['Gimarmenian'] = 0x0533;
	  t['Gjecyrillic'] = 0x0403;
	  t['Gmacron'] = 0x1E20;
	  t['Gmonospace'] = 0xFF27;
	  t['Grave'] = 0xF6CE;
	  t['Gravesmall'] = 0xF760;
	  t['Gsmall'] = 0xF767;
	  t['Gsmallhook'] = 0x029B;
	  t['Gstroke'] = 0x01E4;
	  t['H'] = 0x0048;
	  t['H18533'] = 0x25CF;
	  t['H18543'] = 0x25AA;
	  t['H18551'] = 0x25AB;
	  t['H22073'] = 0x25A1;
	  t['HPsquare'] = 0x33CB;
	  t['Haabkhasiancyrillic'] = 0x04A8;
	  t['Hadescendercyrillic'] = 0x04B2;
	  t['Hardsigncyrillic'] = 0x042A;
	  t['Hbar'] = 0x0126;
	  t['Hbrevebelow'] = 0x1E2A;
	  t['Hcedilla'] = 0x1E28;
	  t['Hcircle'] = 0x24BD;
	  t['Hcircumflex'] = 0x0124;
	  t['Hdieresis'] = 0x1E26;
	  t['Hdotaccent'] = 0x1E22;
	  t['Hdotbelow'] = 0x1E24;
	  t['Hmonospace'] = 0xFF28;
	  t['Hoarmenian'] = 0x0540;
	  t['Horicoptic'] = 0x03E8;
	  t['Hsmall'] = 0xF768;
	  t['Hungarumlaut'] = 0xF6CF;
	  t['Hungarumlautsmall'] = 0xF6F8;
	  t['Hzsquare'] = 0x3390;
	  t['I'] = 0x0049;
	  t['IAcyrillic'] = 0x042F;
	  t['IJ'] = 0x0132;
	  t['IUcyrillic'] = 0x042E;
	  t['Iacute'] = 0x00CD;
	  t['Iacutesmall'] = 0xF7ED;
	  t['Ibreve'] = 0x012C;
	  t['Icaron'] = 0x01CF;
	  t['Icircle'] = 0x24BE;
	  t['Icircumflex'] = 0x00CE;
	  t['Icircumflexsmall'] = 0xF7EE;
	  t['Icyrillic'] = 0x0406;
	  t['Idblgrave'] = 0x0208;
	  t['Idieresis'] = 0x00CF;
	  t['Idieresisacute'] = 0x1E2E;
	  t['Idieresiscyrillic'] = 0x04E4;
	  t['Idieresissmall'] = 0xF7EF;
	  t['Idot'] = 0x0130;
	  t['Idotaccent'] = 0x0130;
	  t['Idotbelow'] = 0x1ECA;
	  t['Iebrevecyrillic'] = 0x04D6;
	  t['Iecyrillic'] = 0x0415;
	  t['Ifraktur'] = 0x2111;
	  t['Igrave'] = 0x00CC;
	  t['Igravesmall'] = 0xF7EC;
	  t['Ihookabove'] = 0x1EC8;
	  t['Iicyrillic'] = 0x0418;
	  t['Iinvertedbreve'] = 0x020A;
	  t['Iishortcyrillic'] = 0x0419;
	  t['Imacron'] = 0x012A;
	  t['Imacroncyrillic'] = 0x04E2;
	  t['Imonospace'] = 0xFF29;
	  t['Iniarmenian'] = 0x053B;
	  t['Iocyrillic'] = 0x0401;
	  t['Iogonek'] = 0x012E;
	  t['Iota'] = 0x0399;
	  t['Iotaafrican'] = 0x0196;
	  t['Iotadieresis'] = 0x03AA;
	  t['Iotatonos'] = 0x038A;
	  t['Ismall'] = 0xF769;
	  t['Istroke'] = 0x0197;
	  t['Itilde'] = 0x0128;
	  t['Itildebelow'] = 0x1E2C;
	  t['Izhitsacyrillic'] = 0x0474;
	  t['Izhitsadblgravecyrillic'] = 0x0476;
	  t['J'] = 0x004A;
	  t['Jaarmenian'] = 0x0541;
	  t['Jcircle'] = 0x24BF;
	  t['Jcircumflex'] = 0x0134;
	  t['Jecyrillic'] = 0x0408;
	  t['Jheharmenian'] = 0x054B;
	  t['Jmonospace'] = 0xFF2A;
	  t['Jsmall'] = 0xF76A;
	  t['K'] = 0x004B;
	  t['KBsquare'] = 0x3385;
	  t['KKsquare'] = 0x33CD;
	  t['Kabashkircyrillic'] = 0x04A0;
	  t['Kacute'] = 0x1E30;
	  t['Kacyrillic'] = 0x041A;
	  t['Kadescendercyrillic'] = 0x049A;
	  t['Kahookcyrillic'] = 0x04C3;
	  t['Kappa'] = 0x039A;
	  t['Kastrokecyrillic'] = 0x049E;
	  t['Kaverticalstrokecyrillic'] = 0x049C;
	  t['Kcaron'] = 0x01E8;
	  t['Kcedilla'] = 0x0136;
	  t['Kcircle'] = 0x24C0;
	  t['Kcommaaccent'] = 0x0136;
	  t['Kdotbelow'] = 0x1E32;
	  t['Keharmenian'] = 0x0554;
	  t['Kenarmenian'] = 0x053F;
	  t['Khacyrillic'] = 0x0425;
	  t['Kheicoptic'] = 0x03E6;
	  t['Khook'] = 0x0198;
	  t['Kjecyrillic'] = 0x040C;
	  t['Klinebelow'] = 0x1E34;
	  t['Kmonospace'] = 0xFF2B;
	  t['Koppacyrillic'] = 0x0480;
	  t['Koppagreek'] = 0x03DE;
	  t['Ksicyrillic'] = 0x046E;
	  t['Ksmall'] = 0xF76B;
	  t['L'] = 0x004C;
	  t['LJ'] = 0x01C7;
	  t['LL'] = 0xF6BF;
	  t['Lacute'] = 0x0139;
	  t['Lambda'] = 0x039B;
	  t['Lcaron'] = 0x013D;
	  t['Lcedilla'] = 0x013B;
	  t['Lcircle'] = 0x24C1;
	  t['Lcircumflexbelow'] = 0x1E3C;
	  t['Lcommaaccent'] = 0x013B;
	  t['Ldot'] = 0x013F;
	  t['Ldotaccent'] = 0x013F;
	  t['Ldotbelow'] = 0x1E36;
	  t['Ldotbelowmacron'] = 0x1E38;
	  t['Liwnarmenian'] = 0x053C;
	  t['Lj'] = 0x01C8;
	  t['Ljecyrillic'] = 0x0409;
	  t['Llinebelow'] = 0x1E3A;
	  t['Lmonospace'] = 0xFF2C;
	  t['Lslash'] = 0x0141;
	  t['Lslashsmall'] = 0xF6F9;
	  t['Lsmall'] = 0xF76C;
	  t['M'] = 0x004D;
	  t['MBsquare'] = 0x3386;
	  t['Macron'] = 0xF6D0;
	  t['Macronsmall'] = 0xF7AF;
	  t['Macute'] = 0x1E3E;
	  t['Mcircle'] = 0x24C2;
	  t['Mdotaccent'] = 0x1E40;
	  t['Mdotbelow'] = 0x1E42;
	  t['Menarmenian'] = 0x0544;
	  t['Mmonospace'] = 0xFF2D;
	  t['Msmall'] = 0xF76D;
	  t['Mturned'] = 0x019C;
	  t['Mu'] = 0x039C;
	  t['N'] = 0x004E;
	  t['NJ'] = 0x01CA;
	  t['Nacute'] = 0x0143;
	  t['Ncaron'] = 0x0147;
	  t['Ncedilla'] = 0x0145;
	  t['Ncircle'] = 0x24C3;
	  t['Ncircumflexbelow'] = 0x1E4A;
	  t['Ncommaaccent'] = 0x0145;
	  t['Ndotaccent'] = 0x1E44;
	  t['Ndotbelow'] = 0x1E46;
	  t['Nhookleft'] = 0x019D;
	  t['Nineroman'] = 0x2168;
	  t['Nj'] = 0x01CB;
	  t['Njecyrillic'] = 0x040A;
	  t['Nlinebelow'] = 0x1E48;
	  t['Nmonospace'] = 0xFF2E;
	  t['Nowarmenian'] = 0x0546;
	  t['Nsmall'] = 0xF76E;
	  t['Ntilde'] = 0x00D1;
	  t['Ntildesmall'] = 0xF7F1;
	  t['Nu'] = 0x039D;
	  t['O'] = 0x004F;
	  t['OE'] = 0x0152;
	  t['OEsmall'] = 0xF6FA;
	  t['Oacute'] = 0x00D3;
	  t['Oacutesmall'] = 0xF7F3;
	  t['Obarredcyrillic'] = 0x04E8;
	  t['Obarreddieresiscyrillic'] = 0x04EA;
	  t['Obreve'] = 0x014E;
	  t['Ocaron'] = 0x01D1;
	  t['Ocenteredtilde'] = 0x019F;
	  t['Ocircle'] = 0x24C4;
	  t['Ocircumflex'] = 0x00D4;
	  t['Ocircumflexacute'] = 0x1ED0;
	  t['Ocircumflexdotbelow'] = 0x1ED8;
	  t['Ocircumflexgrave'] = 0x1ED2;
	  t['Ocircumflexhookabove'] = 0x1ED4;
	  t['Ocircumflexsmall'] = 0xF7F4;
	  t['Ocircumflextilde'] = 0x1ED6;
	  t['Ocyrillic'] = 0x041E;
	  t['Odblacute'] = 0x0150;
	  t['Odblgrave'] = 0x020C;
	  t['Odieresis'] = 0x00D6;
	  t['Odieresiscyrillic'] = 0x04E6;
	  t['Odieresissmall'] = 0xF7F6;
	  t['Odotbelow'] = 0x1ECC;
	  t['Ogoneksmall'] = 0xF6FB;
	  t['Ograve'] = 0x00D2;
	  t['Ogravesmall'] = 0xF7F2;
	  t['Oharmenian'] = 0x0555;
	  t['Ohm'] = 0x2126;
	  t['Ohookabove'] = 0x1ECE;
	  t['Ohorn'] = 0x01A0;
	  t['Ohornacute'] = 0x1EDA;
	  t['Ohorndotbelow'] = 0x1EE2;
	  t['Ohorngrave'] = 0x1EDC;
	  t['Ohornhookabove'] = 0x1EDE;
	  t['Ohorntilde'] = 0x1EE0;
	  t['Ohungarumlaut'] = 0x0150;
	  t['Oi'] = 0x01A2;
	  t['Oinvertedbreve'] = 0x020E;
	  t['Omacron'] = 0x014C;
	  t['Omacronacute'] = 0x1E52;
	  t['Omacrongrave'] = 0x1E50;
	  t['Omega'] = 0x2126;
	  t['Omegacyrillic'] = 0x0460;
	  t['Omegagreek'] = 0x03A9;
	  t['Omegaroundcyrillic'] = 0x047A;
	  t['Omegatitlocyrillic'] = 0x047C;
	  t['Omegatonos'] = 0x038F;
	  t['Omicron'] = 0x039F;
	  t['Omicrontonos'] = 0x038C;
	  t['Omonospace'] = 0xFF2F;
	  t['Oneroman'] = 0x2160;
	  t['Oogonek'] = 0x01EA;
	  t['Oogonekmacron'] = 0x01EC;
	  t['Oopen'] = 0x0186;
	  t['Oslash'] = 0x00D8;
	  t['Oslashacute'] = 0x01FE;
	  t['Oslashsmall'] = 0xF7F8;
	  t['Osmall'] = 0xF76F;
	  t['Ostrokeacute'] = 0x01FE;
	  t['Otcyrillic'] = 0x047E;
	  t['Otilde'] = 0x00D5;
	  t['Otildeacute'] = 0x1E4C;
	  t['Otildedieresis'] = 0x1E4E;
	  t['Otildesmall'] = 0xF7F5;
	  t['P'] = 0x0050;
	  t['Pacute'] = 0x1E54;
	  t['Pcircle'] = 0x24C5;
	  t['Pdotaccent'] = 0x1E56;
	  t['Pecyrillic'] = 0x041F;
	  t['Peharmenian'] = 0x054A;
	  t['Pemiddlehookcyrillic'] = 0x04A6;
	  t['Phi'] = 0x03A6;
	  t['Phook'] = 0x01A4;
	  t['Pi'] = 0x03A0;
	  t['Piwrarmenian'] = 0x0553;
	  t['Pmonospace'] = 0xFF30;
	  t['Psi'] = 0x03A8;
	  t['Psicyrillic'] = 0x0470;
	  t['Psmall'] = 0xF770;
	  t['Q'] = 0x0051;
	  t['Qcircle'] = 0x24C6;
	  t['Qmonospace'] = 0xFF31;
	  t['Qsmall'] = 0xF771;
	  t['R'] = 0x0052;
	  t['Raarmenian'] = 0x054C;
	  t['Racute'] = 0x0154;
	  t['Rcaron'] = 0x0158;
	  t['Rcedilla'] = 0x0156;
	  t['Rcircle'] = 0x24C7;
	  t['Rcommaaccent'] = 0x0156;
	  t['Rdblgrave'] = 0x0210;
	  t['Rdotaccent'] = 0x1E58;
	  t['Rdotbelow'] = 0x1E5A;
	  t['Rdotbelowmacron'] = 0x1E5C;
	  t['Reharmenian'] = 0x0550;
	  t['Rfraktur'] = 0x211C;
	  t['Rho'] = 0x03A1;
	  t['Ringsmall'] = 0xF6FC;
	  t['Rinvertedbreve'] = 0x0212;
	  t['Rlinebelow'] = 0x1E5E;
	  t['Rmonospace'] = 0xFF32;
	  t['Rsmall'] = 0xF772;
	  t['Rsmallinverted'] = 0x0281;
	  t['Rsmallinvertedsuperior'] = 0x02B6;
	  t['S'] = 0x0053;
	  t['SF010000'] = 0x250C;
	  t['SF020000'] = 0x2514;
	  t['SF030000'] = 0x2510;
	  t['SF040000'] = 0x2518;
	  t['SF050000'] = 0x253C;
	  t['SF060000'] = 0x252C;
	  t['SF070000'] = 0x2534;
	  t['SF080000'] = 0x251C;
	  t['SF090000'] = 0x2524;
	  t['SF100000'] = 0x2500;
	  t['SF110000'] = 0x2502;
	  t['SF190000'] = 0x2561;
	  t['SF200000'] = 0x2562;
	  t['SF210000'] = 0x2556;
	  t['SF220000'] = 0x2555;
	  t['SF230000'] = 0x2563;
	  t['SF240000'] = 0x2551;
	  t['SF250000'] = 0x2557;
	  t['SF260000'] = 0x255D;
	  t['SF270000'] = 0x255C;
	  t['SF280000'] = 0x255B;
	  t['SF360000'] = 0x255E;
	  t['SF370000'] = 0x255F;
	  t['SF380000'] = 0x255A;
	  t['SF390000'] = 0x2554;
	  t['SF400000'] = 0x2569;
	  t['SF410000'] = 0x2566;
	  t['SF420000'] = 0x2560;
	  t['SF430000'] = 0x2550;
	  t['SF440000'] = 0x256C;
	  t['SF450000'] = 0x2567;
	  t['SF460000'] = 0x2568;
	  t['SF470000'] = 0x2564;
	  t['SF480000'] = 0x2565;
	  t['SF490000'] = 0x2559;
	  t['SF500000'] = 0x2558;
	  t['SF510000'] = 0x2552;
	  t['SF520000'] = 0x2553;
	  t['SF530000'] = 0x256B;
	  t['SF540000'] = 0x256A;
	  t['Sacute'] = 0x015A;
	  t['Sacutedotaccent'] = 0x1E64;
	  t['Sampigreek'] = 0x03E0;
	  t['Scaron'] = 0x0160;
	  t['Scarondotaccent'] = 0x1E66;
	  t['Scaronsmall'] = 0xF6FD;
	  t['Scedilla'] = 0x015E;
	  t['Schwa'] = 0x018F;
	  t['Schwacyrillic'] = 0x04D8;
	  t['Schwadieresiscyrillic'] = 0x04DA;
	  t['Scircle'] = 0x24C8;
	  t['Scircumflex'] = 0x015C;
	  t['Scommaaccent'] = 0x0218;
	  t['Sdotaccent'] = 0x1E60;
	  t['Sdotbelow'] = 0x1E62;
	  t['Sdotbelowdotaccent'] = 0x1E68;
	  t['Seharmenian'] = 0x054D;
	  t['Sevenroman'] = 0x2166;
	  t['Shaarmenian'] = 0x0547;
	  t['Shacyrillic'] = 0x0428;
	  t['Shchacyrillic'] = 0x0429;
	  t['Sheicoptic'] = 0x03E2;
	  t['Shhacyrillic'] = 0x04BA;
	  t['Shimacoptic'] = 0x03EC;
	  t['Sigma'] = 0x03A3;
	  t['Sixroman'] = 0x2165;
	  t['Smonospace'] = 0xFF33;
	  t['Softsigncyrillic'] = 0x042C;
	  t['Ssmall'] = 0xF773;
	  t['Stigmagreek'] = 0x03DA;
	  t['T'] = 0x0054;
	  t['Tau'] = 0x03A4;
	  t['Tbar'] = 0x0166;
	  t['Tcaron'] = 0x0164;
	  t['Tcedilla'] = 0x0162;
	  t['Tcircle'] = 0x24C9;
	  t['Tcircumflexbelow'] = 0x1E70;
	  t['Tcommaaccent'] = 0x0162;
	  t['Tdotaccent'] = 0x1E6A;
	  t['Tdotbelow'] = 0x1E6C;
	  t['Tecyrillic'] = 0x0422;
	  t['Tedescendercyrillic'] = 0x04AC;
	  t['Tenroman'] = 0x2169;
	  t['Tetsecyrillic'] = 0x04B4;
	  t['Theta'] = 0x0398;
	  t['Thook'] = 0x01AC;
	  t['Thorn'] = 0x00DE;
	  t['Thornsmall'] = 0xF7FE;
	  t['Threeroman'] = 0x2162;
	  t['Tildesmall'] = 0xF6FE;
	  t['Tiwnarmenian'] = 0x054F;
	  t['Tlinebelow'] = 0x1E6E;
	  t['Tmonospace'] = 0xFF34;
	  t['Toarmenian'] = 0x0539;
	  t['Tonefive'] = 0x01BC;
	  t['Tonesix'] = 0x0184;
	  t['Tonetwo'] = 0x01A7;
	  t['Tretroflexhook'] = 0x01AE;
	  t['Tsecyrillic'] = 0x0426;
	  t['Tshecyrillic'] = 0x040B;
	  t['Tsmall'] = 0xF774;
	  t['Twelveroman'] = 0x216B;
	  t['Tworoman'] = 0x2161;
	  t['U'] = 0x0055;
	  t['Uacute'] = 0x00DA;
	  t['Uacutesmall'] = 0xF7FA;
	  t['Ubreve'] = 0x016C;
	  t['Ucaron'] = 0x01D3;
	  t['Ucircle'] = 0x24CA;
	  t['Ucircumflex'] = 0x00DB;
	  t['Ucircumflexbelow'] = 0x1E76;
	  t['Ucircumflexsmall'] = 0xF7FB;
	  t['Ucyrillic'] = 0x0423;
	  t['Udblacute'] = 0x0170;
	  t['Udblgrave'] = 0x0214;
	  t['Udieresis'] = 0x00DC;
	  t['Udieresisacute'] = 0x01D7;
	  t['Udieresisbelow'] = 0x1E72;
	  t['Udieresiscaron'] = 0x01D9;
	  t['Udieresiscyrillic'] = 0x04F0;
	  t['Udieresisgrave'] = 0x01DB;
	  t['Udieresismacron'] = 0x01D5;
	  t['Udieresissmall'] = 0xF7FC;
	  t['Udotbelow'] = 0x1EE4;
	  t['Ugrave'] = 0x00D9;
	  t['Ugravesmall'] = 0xF7F9;
	  t['Uhookabove'] = 0x1EE6;
	  t['Uhorn'] = 0x01AF;
	  t['Uhornacute'] = 0x1EE8;
	  t['Uhorndotbelow'] = 0x1EF0;
	  t['Uhorngrave'] = 0x1EEA;
	  t['Uhornhookabove'] = 0x1EEC;
	  t['Uhorntilde'] = 0x1EEE;
	  t['Uhungarumlaut'] = 0x0170;
	  t['Uhungarumlautcyrillic'] = 0x04F2;
	  t['Uinvertedbreve'] = 0x0216;
	  t['Ukcyrillic'] = 0x0478;
	  t['Umacron'] = 0x016A;
	  t['Umacroncyrillic'] = 0x04EE;
	  t['Umacrondieresis'] = 0x1E7A;
	  t['Umonospace'] = 0xFF35;
	  t['Uogonek'] = 0x0172;
	  t['Upsilon'] = 0x03A5;
	  t['Upsilon1'] = 0x03D2;
	  t['Upsilonacutehooksymbolgreek'] = 0x03D3;
	  t['Upsilonafrican'] = 0x01B1;
	  t['Upsilondieresis'] = 0x03AB;
	  t['Upsilondieresishooksymbolgreek'] = 0x03D4;
	  t['Upsilonhooksymbol'] = 0x03D2;
	  t['Upsilontonos'] = 0x038E;
	  t['Uring'] = 0x016E;
	  t['Ushortcyrillic'] = 0x040E;
	  t['Usmall'] = 0xF775;
	  t['Ustraightcyrillic'] = 0x04AE;
	  t['Ustraightstrokecyrillic'] = 0x04B0;
	  t['Utilde'] = 0x0168;
	  t['Utildeacute'] = 0x1E78;
	  t['Utildebelow'] = 0x1E74;
	  t['V'] = 0x0056;
	  t['Vcircle'] = 0x24CB;
	  t['Vdotbelow'] = 0x1E7E;
	  t['Vecyrillic'] = 0x0412;
	  t['Vewarmenian'] = 0x054E;
	  t['Vhook'] = 0x01B2;
	  t['Vmonospace'] = 0xFF36;
	  t['Voarmenian'] = 0x0548;
	  t['Vsmall'] = 0xF776;
	  t['Vtilde'] = 0x1E7C;
	  t['W'] = 0x0057;
	  t['Wacute'] = 0x1E82;
	  t['Wcircle'] = 0x24CC;
	  t['Wcircumflex'] = 0x0174;
	  t['Wdieresis'] = 0x1E84;
	  t['Wdotaccent'] = 0x1E86;
	  t['Wdotbelow'] = 0x1E88;
	  t['Wgrave'] = 0x1E80;
	  t['Wmonospace'] = 0xFF37;
	  t['Wsmall'] = 0xF777;
	  t['X'] = 0x0058;
	  t['Xcircle'] = 0x24CD;
	  t['Xdieresis'] = 0x1E8C;
	  t['Xdotaccent'] = 0x1E8A;
	  t['Xeharmenian'] = 0x053D;
	  t['Xi'] = 0x039E;
	  t['Xmonospace'] = 0xFF38;
	  t['Xsmall'] = 0xF778;
	  t['Y'] = 0x0059;
	  t['Yacute'] = 0x00DD;
	  t['Yacutesmall'] = 0xF7FD;
	  t['Yatcyrillic'] = 0x0462;
	  t['Ycircle'] = 0x24CE;
	  t['Ycircumflex'] = 0x0176;
	  t['Ydieresis'] = 0x0178;
	  t['Ydieresissmall'] = 0xF7FF;
	  t['Ydotaccent'] = 0x1E8E;
	  t['Ydotbelow'] = 0x1EF4;
	  t['Yericyrillic'] = 0x042B;
	  t['Yerudieresiscyrillic'] = 0x04F8;
	  t['Ygrave'] = 0x1EF2;
	  t['Yhook'] = 0x01B3;
	  t['Yhookabove'] = 0x1EF6;
	  t['Yiarmenian'] = 0x0545;
	  t['Yicyrillic'] = 0x0407;
	  t['Yiwnarmenian'] = 0x0552;
	  t['Ymonospace'] = 0xFF39;
	  t['Ysmall'] = 0xF779;
	  t['Ytilde'] = 0x1EF8;
	  t['Yusbigcyrillic'] = 0x046A;
	  t['Yusbigiotifiedcyrillic'] = 0x046C;
	  t['Yuslittlecyrillic'] = 0x0466;
	  t['Yuslittleiotifiedcyrillic'] = 0x0468;
	  t['Z'] = 0x005A;
	  t['Zaarmenian'] = 0x0536;
	  t['Zacute'] = 0x0179;
	  t['Zcaron'] = 0x017D;
	  t['Zcaronsmall'] = 0xF6FF;
	  t['Zcircle'] = 0x24CF;
	  t['Zcircumflex'] = 0x1E90;
	  t['Zdot'] = 0x017B;
	  t['Zdotaccent'] = 0x017B;
	  t['Zdotbelow'] = 0x1E92;
	  t['Zecyrillic'] = 0x0417;
	  t['Zedescendercyrillic'] = 0x0498;
	  t['Zedieresiscyrillic'] = 0x04DE;
	  t['Zeta'] = 0x0396;
	  t['Zhearmenian'] = 0x053A;
	  t['Zhebrevecyrillic'] = 0x04C1;
	  t['Zhecyrillic'] = 0x0416;
	  t['Zhedescendercyrillic'] = 0x0496;
	  t['Zhedieresiscyrillic'] = 0x04DC;
	  t['Zlinebelow'] = 0x1E94;
	  t['Zmonospace'] = 0xFF3A;
	  t['Zsmall'] = 0xF77A;
	  t['Zstroke'] = 0x01B5;
	  t['a'] = 0x0061;
	  t['aabengali'] = 0x0986;
	  t['aacute'] = 0x00E1;
	  t['aadeva'] = 0x0906;
	  t['aagujarati'] = 0x0A86;
	  t['aagurmukhi'] = 0x0A06;
	  t['aamatragurmukhi'] = 0x0A3E;
	  t['aarusquare'] = 0x3303;
	  t['aavowelsignbengali'] = 0x09BE;
	  t['aavowelsigndeva'] = 0x093E;
	  t['aavowelsigngujarati'] = 0x0ABE;
	  t['abbreviationmarkarmenian'] = 0x055F;
	  t['abbreviationsigndeva'] = 0x0970;
	  t['abengali'] = 0x0985;
	  t['abopomofo'] = 0x311A;
	  t['abreve'] = 0x0103;
	  t['abreveacute'] = 0x1EAF;
	  t['abrevecyrillic'] = 0x04D1;
	  t['abrevedotbelow'] = 0x1EB7;
	  t['abrevegrave'] = 0x1EB1;
	  t['abrevehookabove'] = 0x1EB3;
	  t['abrevetilde'] = 0x1EB5;
	  t['acaron'] = 0x01CE;
	  t['acircle'] = 0x24D0;
	  t['acircumflex'] = 0x00E2;
	  t['acircumflexacute'] = 0x1EA5;
	  t['acircumflexdotbelow'] = 0x1EAD;
	  t['acircumflexgrave'] = 0x1EA7;
	  t['acircumflexhookabove'] = 0x1EA9;
	  t['acircumflextilde'] = 0x1EAB;
	  t['acute'] = 0x00B4;
	  t['acutebelowcmb'] = 0x0317;
	  t['acutecmb'] = 0x0301;
	  t['acutecomb'] = 0x0301;
	  t['acutedeva'] = 0x0954;
	  t['acutelowmod'] = 0x02CF;
	  t['acutetonecmb'] = 0x0341;
	  t['acyrillic'] = 0x0430;
	  t['adblgrave'] = 0x0201;
	  t['addakgurmukhi'] = 0x0A71;
	  t['adeva'] = 0x0905;
	  t['adieresis'] = 0x00E4;
	  t['adieresiscyrillic'] = 0x04D3;
	  t['adieresismacron'] = 0x01DF;
	  t['adotbelow'] = 0x1EA1;
	  t['adotmacron'] = 0x01E1;
	  t['ae'] = 0x00E6;
	  t['aeacute'] = 0x01FD;
	  t['aekorean'] = 0x3150;
	  t['aemacron'] = 0x01E3;
	  t['afii00208'] = 0x2015;
	  t['afii08941'] = 0x20A4;
	  t['afii10017'] = 0x0410;
	  t['afii10018'] = 0x0411;
	  t['afii10019'] = 0x0412;
	  t['afii10020'] = 0x0413;
	  t['afii10021'] = 0x0414;
	  t['afii10022'] = 0x0415;
	  t['afii10023'] = 0x0401;
	  t['afii10024'] = 0x0416;
	  t['afii10025'] = 0x0417;
	  t['afii10026'] = 0x0418;
	  t['afii10027'] = 0x0419;
	  t['afii10028'] = 0x041A;
	  t['afii10029'] = 0x041B;
	  t['afii10030'] = 0x041C;
	  t['afii10031'] = 0x041D;
	  t['afii10032'] = 0x041E;
	  t['afii10033'] = 0x041F;
	  t['afii10034'] = 0x0420;
	  t['afii10035'] = 0x0421;
	  t['afii10036'] = 0x0422;
	  t['afii10037'] = 0x0423;
	  t['afii10038'] = 0x0424;
	  t['afii10039'] = 0x0425;
	  t['afii10040'] = 0x0426;
	  t['afii10041'] = 0x0427;
	  t['afii10042'] = 0x0428;
	  t['afii10043'] = 0x0429;
	  t['afii10044'] = 0x042A;
	  t['afii10045'] = 0x042B;
	  t['afii10046'] = 0x042C;
	  t['afii10047'] = 0x042D;
	  t['afii10048'] = 0x042E;
	  t['afii10049'] = 0x042F;
	  t['afii10050'] = 0x0490;
	  t['afii10051'] = 0x0402;
	  t['afii10052'] = 0x0403;
	  t['afii10053'] = 0x0404;
	  t['afii10054'] = 0x0405;
	  t['afii10055'] = 0x0406;
	  t['afii10056'] = 0x0407;
	  t['afii10057'] = 0x0408;
	  t['afii10058'] = 0x0409;
	  t['afii10059'] = 0x040A;
	  t['afii10060'] = 0x040B;
	  t['afii10061'] = 0x040C;
	  t['afii10062'] = 0x040E;
	  t['afii10063'] = 0xF6C4;
	  t['afii10064'] = 0xF6C5;
	  t['afii10065'] = 0x0430;
	  t['afii10066'] = 0x0431;
	  t['afii10067'] = 0x0432;
	  t['afii10068'] = 0x0433;
	  t['afii10069'] = 0x0434;
	  t['afii10070'] = 0x0435;
	  t['afii10071'] = 0x0451;
	  t['afii10072'] = 0x0436;
	  t['afii10073'] = 0x0437;
	  t['afii10074'] = 0x0438;
	  t['afii10075'] = 0x0439;
	  t['afii10076'] = 0x043A;
	  t['afii10077'] = 0x043B;
	  t['afii10078'] = 0x043C;
	  t['afii10079'] = 0x043D;
	  t['afii10080'] = 0x043E;
	  t['afii10081'] = 0x043F;
	  t['afii10082'] = 0x0440;
	  t['afii10083'] = 0x0441;
	  t['afii10084'] = 0x0442;
	  t['afii10085'] = 0x0443;
	  t['afii10086'] = 0x0444;
	  t['afii10087'] = 0x0445;
	  t['afii10088'] = 0x0446;
	  t['afii10089'] = 0x0447;
	  t['afii10090'] = 0x0448;
	  t['afii10091'] = 0x0449;
	  t['afii10092'] = 0x044A;
	  t['afii10093'] = 0x044B;
	  t['afii10094'] = 0x044C;
	  t['afii10095'] = 0x044D;
	  t['afii10096'] = 0x044E;
	  t['afii10097'] = 0x044F;
	  t['afii10098'] = 0x0491;
	  t['afii10099'] = 0x0452;
	  t['afii10100'] = 0x0453;
	  t['afii10101'] = 0x0454;
	  t['afii10102'] = 0x0455;
	  t['afii10103'] = 0x0456;
	  t['afii10104'] = 0x0457;
	  t['afii10105'] = 0x0458;
	  t['afii10106'] = 0x0459;
	  t['afii10107'] = 0x045A;
	  t['afii10108'] = 0x045B;
	  t['afii10109'] = 0x045C;
	  t['afii10110'] = 0x045E;
	  t['afii10145'] = 0x040F;
	  t['afii10146'] = 0x0462;
	  t['afii10147'] = 0x0472;
	  t['afii10148'] = 0x0474;
	  t['afii10192'] = 0xF6C6;
	  t['afii10193'] = 0x045F;
	  t['afii10194'] = 0x0463;
	  t['afii10195'] = 0x0473;
	  t['afii10196'] = 0x0475;
	  t['afii10831'] = 0xF6C7;
	  t['afii10832'] = 0xF6C8;
	  t['afii10846'] = 0x04D9;
	  t['afii299'] = 0x200E;
	  t['afii300'] = 0x200F;
	  t['afii301'] = 0x200D;
	  t['afii57381'] = 0x066A;
	  t['afii57388'] = 0x060C;
	  t['afii57392'] = 0x0660;
	  t['afii57393'] = 0x0661;
	  t['afii57394'] = 0x0662;
	  t['afii57395'] = 0x0663;
	  t['afii57396'] = 0x0664;
	  t['afii57397'] = 0x0665;
	  t['afii57398'] = 0x0666;
	  t['afii57399'] = 0x0667;
	  t['afii57400'] = 0x0668;
	  t['afii57401'] = 0x0669;
	  t['afii57403'] = 0x061B;
	  t['afii57407'] = 0x061F;
	  t['afii57409'] = 0x0621;
	  t['afii57410'] = 0x0622;
	  t['afii57411'] = 0x0623;
	  t['afii57412'] = 0x0624;
	  t['afii57413'] = 0x0625;
	  t['afii57414'] = 0x0626;
	  t['afii57415'] = 0x0627;
	  t['afii57416'] = 0x0628;
	  t['afii57417'] = 0x0629;
	  t['afii57418'] = 0x062A;
	  t['afii57419'] = 0x062B;
	  t['afii57420'] = 0x062C;
	  t['afii57421'] = 0x062D;
	  t['afii57422'] = 0x062E;
	  t['afii57423'] = 0x062F;
	  t['afii57424'] = 0x0630;
	  t['afii57425'] = 0x0631;
	  t['afii57426'] = 0x0632;
	  t['afii57427'] = 0x0633;
	  t['afii57428'] = 0x0634;
	  t['afii57429'] = 0x0635;
	  t['afii57430'] = 0x0636;
	  t['afii57431'] = 0x0637;
	  t['afii57432'] = 0x0638;
	  t['afii57433'] = 0x0639;
	  t['afii57434'] = 0x063A;
	  t['afii57440'] = 0x0640;
	  t['afii57441'] = 0x0641;
	  t['afii57442'] = 0x0642;
	  t['afii57443'] = 0x0643;
	  t['afii57444'] = 0x0644;
	  t['afii57445'] = 0x0645;
	  t['afii57446'] = 0x0646;
	  t['afii57448'] = 0x0648;
	  t['afii57449'] = 0x0649;
	  t['afii57450'] = 0x064A;
	  t['afii57451'] = 0x064B;
	  t['afii57452'] = 0x064C;
	  t['afii57453'] = 0x064D;
	  t['afii57454'] = 0x064E;
	  t['afii57455'] = 0x064F;
	  t['afii57456'] = 0x0650;
	  t['afii57457'] = 0x0651;
	  t['afii57458'] = 0x0652;
	  t['afii57470'] = 0x0647;
	  t['afii57505'] = 0x06A4;
	  t['afii57506'] = 0x067E;
	  t['afii57507'] = 0x0686;
	  t['afii57508'] = 0x0698;
	  t['afii57509'] = 0x06AF;
	  t['afii57511'] = 0x0679;
	  t['afii57512'] = 0x0688;
	  t['afii57513'] = 0x0691;
	  t['afii57514'] = 0x06BA;
	  t['afii57519'] = 0x06D2;
	  t['afii57534'] = 0x06D5;
	  t['afii57636'] = 0x20AA;
	  t['afii57645'] = 0x05BE;
	  t['afii57658'] = 0x05C3;
	  t['afii57664'] = 0x05D0;
	  t['afii57665'] = 0x05D1;
	  t['afii57666'] = 0x05D2;
	  t['afii57667'] = 0x05D3;
	  t['afii57668'] = 0x05D4;
	  t['afii57669'] = 0x05D5;
	  t['afii57670'] = 0x05D6;
	  t['afii57671'] = 0x05D7;
	  t['afii57672'] = 0x05D8;
	  t['afii57673'] = 0x05D9;
	  t['afii57674'] = 0x05DA;
	  t['afii57675'] = 0x05DB;
	  t['afii57676'] = 0x05DC;
	  t['afii57677'] = 0x05DD;
	  t['afii57678'] = 0x05DE;
	  t['afii57679'] = 0x05DF;
	  t['afii57680'] = 0x05E0;
	  t['afii57681'] = 0x05E1;
	  t['afii57682'] = 0x05E2;
	  t['afii57683'] = 0x05E3;
	  t['afii57684'] = 0x05E4;
	  t['afii57685'] = 0x05E5;
	  t['afii57686'] = 0x05E6;
	  t['afii57687'] = 0x05E7;
	  t['afii57688'] = 0x05E8;
	  t['afii57689'] = 0x05E9;
	  t['afii57690'] = 0x05EA;
	  t['afii57694'] = 0xFB2A;
	  t['afii57695'] = 0xFB2B;
	  t['afii57700'] = 0xFB4B;
	  t['afii57705'] = 0xFB1F;
	  t['afii57716'] = 0x05F0;
	  t['afii57717'] = 0x05F1;
	  t['afii57718'] = 0x05F2;
	  t['afii57723'] = 0xFB35;
	  t['afii57793'] = 0x05B4;
	  t['afii57794'] = 0x05B5;
	  t['afii57795'] = 0x05B6;
	  t['afii57796'] = 0x05BB;
	  t['afii57797'] = 0x05B8;
	  t['afii57798'] = 0x05B7;
	  t['afii57799'] = 0x05B0;
	  t['afii57800'] = 0x05B2;
	  t['afii57801'] = 0x05B1;
	  t['afii57802'] = 0x05B3;
	  t['afii57803'] = 0x05C2;
	  t['afii57804'] = 0x05C1;
	  t['afii57806'] = 0x05B9;
	  t['afii57807'] = 0x05BC;
	  t['afii57839'] = 0x05BD;
	  t['afii57841'] = 0x05BF;
	  t['afii57842'] = 0x05C0;
	  t['afii57929'] = 0x02BC;
	  t['afii61248'] = 0x2105;
	  t['afii61289'] = 0x2113;
	  t['afii61352'] = 0x2116;
	  t['afii61573'] = 0x202C;
	  t['afii61574'] = 0x202D;
	  t['afii61575'] = 0x202E;
	  t['afii61664'] = 0x200C;
	  t['afii63167'] = 0x066D;
	  t['afii64937'] = 0x02BD;
	  t['agrave'] = 0x00E0;
	  t['agujarati'] = 0x0A85;
	  t['agurmukhi'] = 0x0A05;
	  t['ahiragana'] = 0x3042;
	  t['ahookabove'] = 0x1EA3;
	  t['aibengali'] = 0x0990;
	  t['aibopomofo'] = 0x311E;
	  t['aideva'] = 0x0910;
	  t['aiecyrillic'] = 0x04D5;
	  t['aigujarati'] = 0x0A90;
	  t['aigurmukhi'] = 0x0A10;
	  t['aimatragurmukhi'] = 0x0A48;
	  t['ainarabic'] = 0x0639;
	  t['ainfinalarabic'] = 0xFECA;
	  t['aininitialarabic'] = 0xFECB;
	  t['ainmedialarabic'] = 0xFECC;
	  t['ainvertedbreve'] = 0x0203;
	  t['aivowelsignbengali'] = 0x09C8;
	  t['aivowelsigndeva'] = 0x0948;
	  t['aivowelsigngujarati'] = 0x0AC8;
	  t['akatakana'] = 0x30A2;
	  t['akatakanahalfwidth'] = 0xFF71;
	  t['akorean'] = 0x314F;
	  t['alef'] = 0x05D0;
	  t['alefarabic'] = 0x0627;
	  t['alefdageshhebrew'] = 0xFB30;
	  t['aleffinalarabic'] = 0xFE8E;
	  t['alefhamzaabovearabic'] = 0x0623;
	  t['alefhamzaabovefinalarabic'] = 0xFE84;
	  t['alefhamzabelowarabic'] = 0x0625;
	  t['alefhamzabelowfinalarabic'] = 0xFE88;
	  t['alefhebrew'] = 0x05D0;
	  t['aleflamedhebrew'] = 0xFB4F;
	  t['alefmaddaabovearabic'] = 0x0622;
	  t['alefmaddaabovefinalarabic'] = 0xFE82;
	  t['alefmaksuraarabic'] = 0x0649;
	  t['alefmaksurafinalarabic'] = 0xFEF0;
	  t['alefmaksurainitialarabic'] = 0xFEF3;
	  t['alefmaksuramedialarabic'] = 0xFEF4;
	  t['alefpatahhebrew'] = 0xFB2E;
	  t['alefqamatshebrew'] = 0xFB2F;
	  t['aleph'] = 0x2135;
	  t['allequal'] = 0x224C;
	  t['alpha'] = 0x03B1;
	  t['alphatonos'] = 0x03AC;
	  t['amacron'] = 0x0101;
	  t['amonospace'] = 0xFF41;
	  t['ampersand'] = 0x0026;
	  t['ampersandmonospace'] = 0xFF06;
	  t['ampersandsmall'] = 0xF726;
	  t['amsquare'] = 0x33C2;
	  t['anbopomofo'] = 0x3122;
	  t['angbopomofo'] = 0x3124;
	  t['angbracketleft'] = 0x3008;
	  t['angbracketright'] = 0x3009;
	  t['angkhankhuthai'] = 0x0E5A;
	  t['angle'] = 0x2220;
	  t['anglebracketleft'] = 0x3008;
	  t['anglebracketleftvertical'] = 0xFE3F;
	  t['anglebracketright'] = 0x3009;
	  t['anglebracketrightvertical'] = 0xFE40;
	  t['angleleft'] = 0x2329;
	  t['angleright'] = 0x232A;
	  t['angstrom'] = 0x212B;
	  t['anoteleia'] = 0x0387;
	  t['anudattadeva'] = 0x0952;
	  t['anusvarabengali'] = 0x0982;
	  t['anusvaradeva'] = 0x0902;
	  t['anusvaragujarati'] = 0x0A82;
	  t['aogonek'] = 0x0105;
	  t['apaatosquare'] = 0x3300;
	  t['aparen'] = 0x249C;
	  t['apostrophearmenian'] = 0x055A;
	  t['apostrophemod'] = 0x02BC;
	  t['apple'] = 0xF8FF;
	  t['approaches'] = 0x2250;
	  t['approxequal'] = 0x2248;
	  t['approxequalorimage'] = 0x2252;
	  t['approximatelyequal'] = 0x2245;
	  t['araeaekorean'] = 0x318E;
	  t['araeakorean'] = 0x318D;
	  t['arc'] = 0x2312;
	  t['arighthalfring'] = 0x1E9A;
	  t['aring'] = 0x00E5;
	  t['aringacute'] = 0x01FB;
	  t['aringbelow'] = 0x1E01;
	  t['arrowboth'] = 0x2194;
	  t['arrowdashdown'] = 0x21E3;
	  t['arrowdashleft'] = 0x21E0;
	  t['arrowdashright'] = 0x21E2;
	  t['arrowdashup'] = 0x21E1;
	  t['arrowdblboth'] = 0x21D4;
	  t['arrowdbldown'] = 0x21D3;
	  t['arrowdblleft'] = 0x21D0;
	  t['arrowdblright'] = 0x21D2;
	  t['arrowdblup'] = 0x21D1;
	  t['arrowdown'] = 0x2193;
	  t['arrowdownleft'] = 0x2199;
	  t['arrowdownright'] = 0x2198;
	  t['arrowdownwhite'] = 0x21E9;
	  t['arrowheaddownmod'] = 0x02C5;
	  t['arrowheadleftmod'] = 0x02C2;
	  t['arrowheadrightmod'] = 0x02C3;
	  t['arrowheadupmod'] = 0x02C4;
	  t['arrowhorizex'] = 0xF8E7;
	  t['arrowleft'] = 0x2190;
	  t['arrowleftdbl'] = 0x21D0;
	  t['arrowleftdblstroke'] = 0x21CD;
	  t['arrowleftoverright'] = 0x21C6;
	  t['arrowleftwhite'] = 0x21E6;
	  t['arrowright'] = 0x2192;
	  t['arrowrightdblstroke'] = 0x21CF;
	  t['arrowrightheavy'] = 0x279E;
	  t['arrowrightoverleft'] = 0x21C4;
	  t['arrowrightwhite'] = 0x21E8;
	  t['arrowtableft'] = 0x21E4;
	  t['arrowtabright'] = 0x21E5;
	  t['arrowup'] = 0x2191;
	  t['arrowupdn'] = 0x2195;
	  t['arrowupdnbse'] = 0x21A8;
	  t['arrowupdownbase'] = 0x21A8;
	  t['arrowupleft'] = 0x2196;
	  t['arrowupleftofdown'] = 0x21C5;
	  t['arrowupright'] = 0x2197;
	  t['arrowupwhite'] = 0x21E7;
	  t['arrowvertex'] = 0xF8E6;
	  t['asciicircum'] = 0x005E;
	  t['asciicircummonospace'] = 0xFF3E;
	  t['asciitilde'] = 0x007E;
	  t['asciitildemonospace'] = 0xFF5E;
	  t['ascript'] = 0x0251;
	  t['ascriptturned'] = 0x0252;
	  t['asmallhiragana'] = 0x3041;
	  t['asmallkatakana'] = 0x30A1;
	  t['asmallkatakanahalfwidth'] = 0xFF67;
	  t['asterisk'] = 0x002A;
	  t['asteriskaltonearabic'] = 0x066D;
	  t['asteriskarabic'] = 0x066D;
	  t['asteriskmath'] = 0x2217;
	  t['asteriskmonospace'] = 0xFF0A;
	  t['asterisksmall'] = 0xFE61;
	  t['asterism'] = 0x2042;
	  t['asuperior'] = 0xF6E9;
	  t['asymptoticallyequal'] = 0x2243;
	  t['at'] = 0x0040;
	  t['atilde'] = 0x00E3;
	  t['atmonospace'] = 0xFF20;
	  t['atsmall'] = 0xFE6B;
	  t['aturned'] = 0x0250;
	  t['aubengali'] = 0x0994;
	  t['aubopomofo'] = 0x3120;
	  t['audeva'] = 0x0914;
	  t['augujarati'] = 0x0A94;
	  t['augurmukhi'] = 0x0A14;
	  t['aulengthmarkbengali'] = 0x09D7;
	  t['aumatragurmukhi'] = 0x0A4C;
	  t['auvowelsignbengali'] = 0x09CC;
	  t['auvowelsigndeva'] = 0x094C;
	  t['auvowelsigngujarati'] = 0x0ACC;
	  t['avagrahadeva'] = 0x093D;
	  t['aybarmenian'] = 0x0561;
	  t['ayin'] = 0x05E2;
	  t['ayinaltonehebrew'] = 0xFB20;
	  t['ayinhebrew'] = 0x05E2;
	  t['b'] = 0x0062;
	  t['babengali'] = 0x09AC;
	  t['backslash'] = 0x005C;
	  t['backslashmonospace'] = 0xFF3C;
	  t['badeva'] = 0x092C;
	  t['bagujarati'] = 0x0AAC;
	  t['bagurmukhi'] = 0x0A2C;
	  t['bahiragana'] = 0x3070;
	  t['bahtthai'] = 0x0E3F;
	  t['bakatakana'] = 0x30D0;
	  t['bar'] = 0x007C;
	  t['barmonospace'] = 0xFF5C;
	  t['bbopomofo'] = 0x3105;
	  t['bcircle'] = 0x24D1;
	  t['bdotaccent'] = 0x1E03;
	  t['bdotbelow'] = 0x1E05;
	  t['beamedsixteenthnotes'] = 0x266C;
	  t['because'] = 0x2235;
	  t['becyrillic'] = 0x0431;
	  t['beharabic'] = 0x0628;
	  t['behfinalarabic'] = 0xFE90;
	  t['behinitialarabic'] = 0xFE91;
	  t['behiragana'] = 0x3079;
	  t['behmedialarabic'] = 0xFE92;
	  t['behmeeminitialarabic'] = 0xFC9F;
	  t['behmeemisolatedarabic'] = 0xFC08;
	  t['behnoonfinalarabic'] = 0xFC6D;
	  t['bekatakana'] = 0x30D9;
	  t['benarmenian'] = 0x0562;
	  t['bet'] = 0x05D1;
	  t['beta'] = 0x03B2;
	  t['betasymbolgreek'] = 0x03D0;
	  t['betdagesh'] = 0xFB31;
	  t['betdageshhebrew'] = 0xFB31;
	  t['bethebrew'] = 0x05D1;
	  t['betrafehebrew'] = 0xFB4C;
	  t['bhabengali'] = 0x09AD;
	  t['bhadeva'] = 0x092D;
	  t['bhagujarati'] = 0x0AAD;
	  t['bhagurmukhi'] = 0x0A2D;
	  t['bhook'] = 0x0253;
	  t['bihiragana'] = 0x3073;
	  t['bikatakana'] = 0x30D3;
	  t['bilabialclick'] = 0x0298;
	  t['bindigurmukhi'] = 0x0A02;
	  t['birusquare'] = 0x3331;
	  t['blackcircle'] = 0x25CF;
	  t['blackdiamond'] = 0x25C6;
	  t['blackdownpointingtriangle'] = 0x25BC;
	  t['blackleftpointingpointer'] = 0x25C4;
	  t['blackleftpointingtriangle'] = 0x25C0;
	  t['blacklenticularbracketleft'] = 0x3010;
	  t['blacklenticularbracketleftvertical'] = 0xFE3B;
	  t['blacklenticularbracketright'] = 0x3011;
	  t['blacklenticularbracketrightvertical'] = 0xFE3C;
	  t['blacklowerlefttriangle'] = 0x25E3;
	  t['blacklowerrighttriangle'] = 0x25E2;
	  t['blackrectangle'] = 0x25AC;
	  t['blackrightpointingpointer'] = 0x25BA;
	  t['blackrightpointingtriangle'] = 0x25B6;
	  t['blacksmallsquare'] = 0x25AA;
	  t['blacksmilingface'] = 0x263B;
	  t['blacksquare'] = 0x25A0;
	  t['blackstar'] = 0x2605;
	  t['blackupperlefttriangle'] = 0x25E4;
	  t['blackupperrighttriangle'] = 0x25E5;
	  t['blackuppointingsmalltriangle'] = 0x25B4;
	  t['blackuppointingtriangle'] = 0x25B2;
	  t['blank'] = 0x2423;
	  t['blinebelow'] = 0x1E07;
	  t['block'] = 0x2588;
	  t['bmonospace'] = 0xFF42;
	  t['bobaimaithai'] = 0x0E1A;
	  t['bohiragana'] = 0x307C;
	  t['bokatakana'] = 0x30DC;
	  t['bparen'] = 0x249D;
	  t['bqsquare'] = 0x33C3;
	  t['braceex'] = 0xF8F4;
	  t['braceleft'] = 0x007B;
	  t['braceleftbt'] = 0xF8F3;
	  t['braceleftmid'] = 0xF8F2;
	  t['braceleftmonospace'] = 0xFF5B;
	  t['braceleftsmall'] = 0xFE5B;
	  t['bracelefttp'] = 0xF8F1;
	  t['braceleftvertical'] = 0xFE37;
	  t['braceright'] = 0x007D;
	  t['bracerightbt'] = 0xF8FE;
	  t['bracerightmid'] = 0xF8FD;
	  t['bracerightmonospace'] = 0xFF5D;
	  t['bracerightsmall'] = 0xFE5C;
	  t['bracerighttp'] = 0xF8FC;
	  t['bracerightvertical'] = 0xFE38;
	  t['bracketleft'] = 0x005B;
	  t['bracketleftbt'] = 0xF8F0;
	  t['bracketleftex'] = 0xF8EF;
	  t['bracketleftmonospace'] = 0xFF3B;
	  t['bracketlefttp'] = 0xF8EE;
	  t['bracketright'] = 0x005D;
	  t['bracketrightbt'] = 0xF8FB;
	  t['bracketrightex'] = 0xF8FA;
	  t['bracketrightmonospace'] = 0xFF3D;
	  t['bracketrighttp'] = 0xF8F9;
	  t['breve'] = 0x02D8;
	  t['brevebelowcmb'] = 0x032E;
	  t['brevecmb'] = 0x0306;
	  t['breveinvertedbelowcmb'] = 0x032F;
	  t['breveinvertedcmb'] = 0x0311;
	  t['breveinverteddoublecmb'] = 0x0361;
	  t['bridgebelowcmb'] = 0x032A;
	  t['bridgeinvertedbelowcmb'] = 0x033A;
	  t['brokenbar'] = 0x00A6;
	  t['bstroke'] = 0x0180;
	  t['bsuperior'] = 0xF6EA;
	  t['btopbar'] = 0x0183;
	  t['buhiragana'] = 0x3076;
	  t['bukatakana'] = 0x30D6;
	  t['bullet'] = 0x2022;
	  t['bulletinverse'] = 0x25D8;
	  t['bulletoperator'] = 0x2219;
	  t['bullseye'] = 0x25CE;
	  t['c'] = 0x0063;
	  t['caarmenian'] = 0x056E;
	  t['cabengali'] = 0x099A;
	  t['cacute'] = 0x0107;
	  t['cadeva'] = 0x091A;
	  t['cagujarati'] = 0x0A9A;
	  t['cagurmukhi'] = 0x0A1A;
	  t['calsquare'] = 0x3388;
	  t['candrabindubengali'] = 0x0981;
	  t['candrabinducmb'] = 0x0310;
	  t['candrabindudeva'] = 0x0901;
	  t['candrabindugujarati'] = 0x0A81;
	  t['capslock'] = 0x21EA;
	  t['careof'] = 0x2105;
	  t['caron'] = 0x02C7;
	  t['caronbelowcmb'] = 0x032C;
	  t['caroncmb'] = 0x030C;
	  t['carriagereturn'] = 0x21B5;
	  t['cbopomofo'] = 0x3118;
	  t['ccaron'] = 0x010D;
	  t['ccedilla'] = 0x00E7;
	  t['ccedillaacute'] = 0x1E09;
	  t['ccircle'] = 0x24D2;
	  t['ccircumflex'] = 0x0109;
	  t['ccurl'] = 0x0255;
	  t['cdot'] = 0x010B;
	  t['cdotaccent'] = 0x010B;
	  t['cdsquare'] = 0x33C5;
	  t['cedilla'] = 0x00B8;
	  t['cedillacmb'] = 0x0327;
	  t['cent'] = 0x00A2;
	  t['centigrade'] = 0x2103;
	  t['centinferior'] = 0xF6DF;
	  t['centmonospace'] = 0xFFE0;
	  t['centoldstyle'] = 0xF7A2;
	  t['centsuperior'] = 0xF6E0;
	  t['chaarmenian'] = 0x0579;
	  t['chabengali'] = 0x099B;
	  t['chadeva'] = 0x091B;
	  t['chagujarati'] = 0x0A9B;
	  t['chagurmukhi'] = 0x0A1B;
	  t['chbopomofo'] = 0x3114;
	  t['cheabkhasiancyrillic'] = 0x04BD;
	  t['checkmark'] = 0x2713;
	  t['checyrillic'] = 0x0447;
	  t['chedescenderabkhasiancyrillic'] = 0x04BF;
	  t['chedescendercyrillic'] = 0x04B7;
	  t['chedieresiscyrillic'] = 0x04F5;
	  t['cheharmenian'] = 0x0573;
	  t['chekhakassiancyrillic'] = 0x04CC;
	  t['cheverticalstrokecyrillic'] = 0x04B9;
	  t['chi'] = 0x03C7;
	  t['chieuchacirclekorean'] = 0x3277;
	  t['chieuchaparenkorean'] = 0x3217;
	  t['chieuchcirclekorean'] = 0x3269;
	  t['chieuchkorean'] = 0x314A;
	  t['chieuchparenkorean'] = 0x3209;
	  t['chochangthai'] = 0x0E0A;
	  t['chochanthai'] = 0x0E08;
	  t['chochingthai'] = 0x0E09;
	  t['chochoethai'] = 0x0E0C;
	  t['chook'] = 0x0188;
	  t['cieucacirclekorean'] = 0x3276;
	  t['cieucaparenkorean'] = 0x3216;
	  t['cieuccirclekorean'] = 0x3268;
	  t['cieuckorean'] = 0x3148;
	  t['cieucparenkorean'] = 0x3208;
	  t['cieucuparenkorean'] = 0x321C;
	  t['circle'] = 0x25CB;
	  t['circlecopyrt'] = 0x00A9;
	  t['circlemultiply'] = 0x2297;
	  t['circleot'] = 0x2299;
	  t['circleplus'] = 0x2295;
	  t['circlepostalmark'] = 0x3036;
	  t['circlewithlefthalfblack'] = 0x25D0;
	  t['circlewithrighthalfblack'] = 0x25D1;
	  t['circumflex'] = 0x02C6;
	  t['circumflexbelowcmb'] = 0x032D;
	  t['circumflexcmb'] = 0x0302;
	  t['clear'] = 0x2327;
	  t['clickalveolar'] = 0x01C2;
	  t['clickdental'] = 0x01C0;
	  t['clicklateral'] = 0x01C1;
	  t['clickretroflex'] = 0x01C3;
	  t['club'] = 0x2663;
	  t['clubsuitblack'] = 0x2663;
	  t['clubsuitwhite'] = 0x2667;
	  t['cmcubedsquare'] = 0x33A4;
	  t['cmonospace'] = 0xFF43;
	  t['cmsquaredsquare'] = 0x33A0;
	  t['coarmenian'] = 0x0581;
	  t['colon'] = 0x003A;
	  t['colonmonetary'] = 0x20A1;
	  t['colonmonospace'] = 0xFF1A;
	  t['colonsign'] = 0x20A1;
	  t['colonsmall'] = 0xFE55;
	  t['colontriangularhalfmod'] = 0x02D1;
	  t['colontriangularmod'] = 0x02D0;
	  t['comma'] = 0x002C;
	  t['commaabovecmb'] = 0x0313;
	  t['commaaboverightcmb'] = 0x0315;
	  t['commaaccent'] = 0xF6C3;
	  t['commaarabic'] = 0x060C;
	  t['commaarmenian'] = 0x055D;
	  t['commainferior'] = 0xF6E1;
	  t['commamonospace'] = 0xFF0C;
	  t['commareversedabovecmb'] = 0x0314;
	  t['commareversedmod'] = 0x02BD;
	  t['commasmall'] = 0xFE50;
	  t['commasuperior'] = 0xF6E2;
	  t['commaturnedabovecmb'] = 0x0312;
	  t['commaturnedmod'] = 0x02BB;
	  t['compass'] = 0x263C;
	  t['congruent'] = 0x2245;
	  t['contourintegral'] = 0x222E;
	  t['control'] = 0x2303;
	  t['controlACK'] = 0x0006;
	  t['controlBEL'] = 0x0007;
	  t['controlBS'] = 0x0008;
	  t['controlCAN'] = 0x0018;
	  t['controlCR'] = 0x000D;
	  t['controlDC1'] = 0x0011;
	  t['controlDC2'] = 0x0012;
	  t['controlDC3'] = 0x0013;
	  t['controlDC4'] = 0x0014;
	  t['controlDEL'] = 0x007F;
	  t['controlDLE'] = 0x0010;
	  t['controlEM'] = 0x0019;
	  t['controlENQ'] = 0x0005;
	  t['controlEOT'] = 0x0004;
	  t['controlESC'] = 0x001B;
	  t['controlETB'] = 0x0017;
	  t['controlETX'] = 0x0003;
	  t['controlFF'] = 0x000C;
	  t['controlFS'] = 0x001C;
	  t['controlGS'] = 0x001D;
	  t['controlHT'] = 0x0009;
	  t['controlLF'] = 0x000A;
	  t['controlNAK'] = 0x0015;
	  t['controlNULL'] = 0x0000;
	  t['controlRS'] = 0x001E;
	  t['controlSI'] = 0x000F;
	  t['controlSO'] = 0x000E;
	  t['controlSOT'] = 0x0002;
	  t['controlSTX'] = 0x0001;
	  t['controlSUB'] = 0x001A;
	  t['controlSYN'] = 0x0016;
	  t['controlUS'] = 0x001F;
	  t['controlVT'] = 0x000B;
	  t['copyright'] = 0x00A9;
	  t['copyrightsans'] = 0xF8E9;
	  t['copyrightserif'] = 0xF6D9;
	  t['cornerbracketleft'] = 0x300C;
	  t['cornerbracketlefthalfwidth'] = 0xFF62;
	  t['cornerbracketleftvertical'] = 0xFE41;
	  t['cornerbracketright'] = 0x300D;
	  t['cornerbracketrighthalfwidth'] = 0xFF63;
	  t['cornerbracketrightvertical'] = 0xFE42;
	  t['corporationsquare'] = 0x337F;
	  t['cosquare'] = 0x33C7;
	  t['coverkgsquare'] = 0x33C6;
	  t['cparen'] = 0x249E;
	  t['cruzeiro'] = 0x20A2;
	  t['cstretched'] = 0x0297;
	  t['curlyand'] = 0x22CF;
	  t['curlyor'] = 0x22CE;
	  t['currency'] = 0x00A4;
	  t['cyrBreve'] = 0xF6D1;
	  t['cyrFlex'] = 0xF6D2;
	  t['cyrbreve'] = 0xF6D4;
	  t['cyrflex'] = 0xF6D5;
	  t['d'] = 0x0064;
	  t['daarmenian'] = 0x0564;
	  t['dabengali'] = 0x09A6;
	  t['dadarabic'] = 0x0636;
	  t['dadeva'] = 0x0926;
	  t['dadfinalarabic'] = 0xFEBE;
	  t['dadinitialarabic'] = 0xFEBF;
	  t['dadmedialarabic'] = 0xFEC0;
	  t['dagesh'] = 0x05BC;
	  t['dageshhebrew'] = 0x05BC;
	  t['dagger'] = 0x2020;
	  t['daggerdbl'] = 0x2021;
	  t['dagujarati'] = 0x0AA6;
	  t['dagurmukhi'] = 0x0A26;
	  t['dahiragana'] = 0x3060;
	  t['dakatakana'] = 0x30C0;
	  t['dalarabic'] = 0x062F;
	  t['dalet'] = 0x05D3;
	  t['daletdagesh'] = 0xFB33;
	  t['daletdageshhebrew'] = 0xFB33;
	  t['dalethebrew'] = 0x05D3;
	  t['dalfinalarabic'] = 0xFEAA;
	  t['dammaarabic'] = 0x064F;
	  t['dammalowarabic'] = 0x064F;
	  t['dammatanaltonearabic'] = 0x064C;
	  t['dammatanarabic'] = 0x064C;
	  t['danda'] = 0x0964;
	  t['dargahebrew'] = 0x05A7;
	  t['dargalefthebrew'] = 0x05A7;
	  t['dasiapneumatacyrilliccmb'] = 0x0485;
	  t['dblGrave'] = 0xF6D3;
	  t['dblanglebracketleft'] = 0x300A;
	  t['dblanglebracketleftvertical'] = 0xFE3D;
	  t['dblanglebracketright'] = 0x300B;
	  t['dblanglebracketrightvertical'] = 0xFE3E;
	  t['dblarchinvertedbelowcmb'] = 0x032B;
	  t['dblarrowleft'] = 0x21D4;
	  t['dblarrowright'] = 0x21D2;
	  t['dbldanda'] = 0x0965;
	  t['dblgrave'] = 0xF6D6;
	  t['dblgravecmb'] = 0x030F;
	  t['dblintegral'] = 0x222C;
	  t['dbllowline'] = 0x2017;
	  t['dbllowlinecmb'] = 0x0333;
	  t['dbloverlinecmb'] = 0x033F;
	  t['dblprimemod'] = 0x02BA;
	  t['dblverticalbar'] = 0x2016;
	  t['dblverticallineabovecmb'] = 0x030E;
	  t['dbopomofo'] = 0x3109;
	  t['dbsquare'] = 0x33C8;
	  t['dcaron'] = 0x010F;
	  t['dcedilla'] = 0x1E11;
	  t['dcircle'] = 0x24D3;
	  t['dcircumflexbelow'] = 0x1E13;
	  t['dcroat'] = 0x0111;
	  t['ddabengali'] = 0x09A1;
	  t['ddadeva'] = 0x0921;
	  t['ddagujarati'] = 0x0AA1;
	  t['ddagurmukhi'] = 0x0A21;
	  t['ddalarabic'] = 0x0688;
	  t['ddalfinalarabic'] = 0xFB89;
	  t['dddhadeva'] = 0x095C;
	  t['ddhabengali'] = 0x09A2;
	  t['ddhadeva'] = 0x0922;
	  t['ddhagujarati'] = 0x0AA2;
	  t['ddhagurmukhi'] = 0x0A22;
	  t['ddotaccent'] = 0x1E0B;
	  t['ddotbelow'] = 0x1E0D;
	  t['decimalseparatorarabic'] = 0x066B;
	  t['decimalseparatorpersian'] = 0x066B;
	  t['decyrillic'] = 0x0434;
	  t['degree'] = 0x00B0;
	  t['dehihebrew'] = 0x05AD;
	  t['dehiragana'] = 0x3067;
	  t['deicoptic'] = 0x03EF;
	  t['dekatakana'] = 0x30C7;
	  t['deleteleft'] = 0x232B;
	  t['deleteright'] = 0x2326;
	  t['delta'] = 0x03B4;
	  t['deltaturned'] = 0x018D;
	  t['denominatorminusonenumeratorbengali'] = 0x09F8;
	  t['dezh'] = 0x02A4;
	  t['dhabengali'] = 0x09A7;
	  t['dhadeva'] = 0x0927;
	  t['dhagujarati'] = 0x0AA7;
	  t['dhagurmukhi'] = 0x0A27;
	  t['dhook'] = 0x0257;
	  t['dialytikatonos'] = 0x0385;
	  t['dialytikatonoscmb'] = 0x0344;
	  t['diamond'] = 0x2666;
	  t['diamondsuitwhite'] = 0x2662;
	  t['dieresis'] = 0x00A8;
	  t['dieresisacute'] = 0xF6D7;
	  t['dieresisbelowcmb'] = 0x0324;
	  t['dieresiscmb'] = 0x0308;
	  t['dieresisgrave'] = 0xF6D8;
	  t['dieresistonos'] = 0x0385;
	  t['dihiragana'] = 0x3062;
	  t['dikatakana'] = 0x30C2;
	  t['dittomark'] = 0x3003;
	  t['divide'] = 0x00F7;
	  t['divides'] = 0x2223;
	  t['divisionslash'] = 0x2215;
	  t['djecyrillic'] = 0x0452;
	  t['dkshade'] = 0x2593;
	  t['dlinebelow'] = 0x1E0F;
	  t['dlsquare'] = 0x3397;
	  t['dmacron'] = 0x0111;
	  t['dmonospace'] = 0xFF44;
	  t['dnblock'] = 0x2584;
	  t['dochadathai'] = 0x0E0E;
	  t['dodekthai'] = 0x0E14;
	  t['dohiragana'] = 0x3069;
	  t['dokatakana'] = 0x30C9;
	  t['dollar'] = 0x0024;
	  t['dollarinferior'] = 0xF6E3;
	  t['dollarmonospace'] = 0xFF04;
	  t['dollaroldstyle'] = 0xF724;
	  t['dollarsmall'] = 0xFE69;
	  t['dollarsuperior'] = 0xF6E4;
	  t['dong'] = 0x20AB;
	  t['dorusquare'] = 0x3326;
	  t['dotaccent'] = 0x02D9;
	  t['dotaccentcmb'] = 0x0307;
	  t['dotbelowcmb'] = 0x0323;
	  t['dotbelowcomb'] = 0x0323;
	  t['dotkatakana'] = 0x30FB;
	  t['dotlessi'] = 0x0131;
	  t['dotlessj'] = 0xF6BE;
	  t['dotlessjstrokehook'] = 0x0284;
	  t['dotmath'] = 0x22C5;
	  t['dottedcircle'] = 0x25CC;
	  t['doubleyodpatah'] = 0xFB1F;
	  t['doubleyodpatahhebrew'] = 0xFB1F;
	  t['downtackbelowcmb'] = 0x031E;
	  t['downtackmod'] = 0x02D5;
	  t['dparen'] = 0x249F;
	  t['dsuperior'] = 0xF6EB;
	  t['dtail'] = 0x0256;
	  t['dtopbar'] = 0x018C;
	  t['duhiragana'] = 0x3065;
	  t['dukatakana'] = 0x30C5;
	  t['dz'] = 0x01F3;
	  t['dzaltone'] = 0x02A3;
	  t['dzcaron'] = 0x01C6;
	  t['dzcurl'] = 0x02A5;
	  t['dzeabkhasiancyrillic'] = 0x04E1;
	  t['dzecyrillic'] = 0x0455;
	  t['dzhecyrillic'] = 0x045F;
	  t['e'] = 0x0065;
	  t['eacute'] = 0x00E9;
	  t['earth'] = 0x2641;
	  t['ebengali'] = 0x098F;
	  t['ebopomofo'] = 0x311C;
	  t['ebreve'] = 0x0115;
	  t['ecandradeva'] = 0x090D;
	  t['ecandragujarati'] = 0x0A8D;
	  t['ecandravowelsigndeva'] = 0x0945;
	  t['ecandravowelsigngujarati'] = 0x0AC5;
	  t['ecaron'] = 0x011B;
	  t['ecedillabreve'] = 0x1E1D;
	  t['echarmenian'] = 0x0565;
	  t['echyiwnarmenian'] = 0x0587;
	  t['ecircle'] = 0x24D4;
	  t['ecircumflex'] = 0x00EA;
	  t['ecircumflexacute'] = 0x1EBF;
	  t['ecircumflexbelow'] = 0x1E19;
	  t['ecircumflexdotbelow'] = 0x1EC7;
	  t['ecircumflexgrave'] = 0x1EC1;
	  t['ecircumflexhookabove'] = 0x1EC3;
	  t['ecircumflextilde'] = 0x1EC5;
	  t['ecyrillic'] = 0x0454;
	  t['edblgrave'] = 0x0205;
	  t['edeva'] = 0x090F;
	  t['edieresis'] = 0x00EB;
	  t['edot'] = 0x0117;
	  t['edotaccent'] = 0x0117;
	  t['edotbelow'] = 0x1EB9;
	  t['eegurmukhi'] = 0x0A0F;
	  t['eematragurmukhi'] = 0x0A47;
	  t['efcyrillic'] = 0x0444;
	  t['egrave'] = 0x00E8;
	  t['egujarati'] = 0x0A8F;
	  t['eharmenian'] = 0x0567;
	  t['ehbopomofo'] = 0x311D;
	  t['ehiragana'] = 0x3048;
	  t['ehookabove'] = 0x1EBB;
	  t['eibopomofo'] = 0x311F;
	  t['eight'] = 0x0038;
	  t['eightarabic'] = 0x0668;
	  t['eightbengali'] = 0x09EE;
	  t['eightcircle'] = 0x2467;
	  t['eightcircleinversesansserif'] = 0x2791;
	  t['eightdeva'] = 0x096E;
	  t['eighteencircle'] = 0x2471;
	  t['eighteenparen'] = 0x2485;
	  t['eighteenperiod'] = 0x2499;
	  t['eightgujarati'] = 0x0AEE;
	  t['eightgurmukhi'] = 0x0A6E;
	  t['eighthackarabic'] = 0x0668;
	  t['eighthangzhou'] = 0x3028;
	  t['eighthnotebeamed'] = 0x266B;
	  t['eightideographicparen'] = 0x3227;
	  t['eightinferior'] = 0x2088;
	  t['eightmonospace'] = 0xFF18;
	  t['eightoldstyle'] = 0xF738;
	  t['eightparen'] = 0x247B;
	  t['eightperiod'] = 0x248F;
	  t['eightpersian'] = 0x06F8;
	  t['eightroman'] = 0x2177;
	  t['eightsuperior'] = 0x2078;
	  t['eightthai'] = 0x0E58;
	  t['einvertedbreve'] = 0x0207;
	  t['eiotifiedcyrillic'] = 0x0465;
	  t['ekatakana'] = 0x30A8;
	  t['ekatakanahalfwidth'] = 0xFF74;
	  t['ekonkargurmukhi'] = 0x0A74;
	  t['ekorean'] = 0x3154;
	  t['elcyrillic'] = 0x043B;
	  t['element'] = 0x2208;
	  t['elevencircle'] = 0x246A;
	  t['elevenparen'] = 0x247E;
	  t['elevenperiod'] = 0x2492;
	  t['elevenroman'] = 0x217A;
	  t['ellipsis'] = 0x2026;
	  t['ellipsisvertical'] = 0x22EE;
	  t['emacron'] = 0x0113;
	  t['emacronacute'] = 0x1E17;
	  t['emacrongrave'] = 0x1E15;
	  t['emcyrillic'] = 0x043C;
	  t['emdash'] = 0x2014;
	  t['emdashvertical'] = 0xFE31;
	  t['emonospace'] = 0xFF45;
	  t['emphasismarkarmenian'] = 0x055B;
	  t['emptyset'] = 0x2205;
	  t['enbopomofo'] = 0x3123;
	  t['encyrillic'] = 0x043D;
	  t['endash'] = 0x2013;
	  t['endashvertical'] = 0xFE32;
	  t['endescendercyrillic'] = 0x04A3;
	  t['eng'] = 0x014B;
	  t['engbopomofo'] = 0x3125;
	  t['enghecyrillic'] = 0x04A5;
	  t['enhookcyrillic'] = 0x04C8;
	  t['enspace'] = 0x2002;
	  t['eogonek'] = 0x0119;
	  t['eokorean'] = 0x3153;
	  t['eopen'] = 0x025B;
	  t['eopenclosed'] = 0x029A;
	  t['eopenreversed'] = 0x025C;
	  t['eopenreversedclosed'] = 0x025E;
	  t['eopenreversedhook'] = 0x025D;
	  t['eparen'] = 0x24A0;
	  t['epsilon'] = 0x03B5;
	  t['epsilontonos'] = 0x03AD;
	  t['equal'] = 0x003D;
	  t['equalmonospace'] = 0xFF1D;
	  t['equalsmall'] = 0xFE66;
	  t['equalsuperior'] = 0x207C;
	  t['equivalence'] = 0x2261;
	  t['erbopomofo'] = 0x3126;
	  t['ercyrillic'] = 0x0440;
	  t['ereversed'] = 0x0258;
	  t['ereversedcyrillic'] = 0x044D;
	  t['escyrillic'] = 0x0441;
	  t['esdescendercyrillic'] = 0x04AB;
	  t['esh'] = 0x0283;
	  t['eshcurl'] = 0x0286;
	  t['eshortdeva'] = 0x090E;
	  t['eshortvowelsigndeva'] = 0x0946;
	  t['eshreversedloop'] = 0x01AA;
	  t['eshsquatreversed'] = 0x0285;
	  t['esmallhiragana'] = 0x3047;
	  t['esmallkatakana'] = 0x30A7;
	  t['esmallkatakanahalfwidth'] = 0xFF6A;
	  t['estimated'] = 0x212E;
	  t['esuperior'] = 0xF6EC;
	  t['eta'] = 0x03B7;
	  t['etarmenian'] = 0x0568;
	  t['etatonos'] = 0x03AE;
	  t['eth'] = 0x00F0;
	  t['etilde'] = 0x1EBD;
	  t['etildebelow'] = 0x1E1B;
	  t['etnahtafoukhhebrew'] = 0x0591;
	  t['etnahtafoukhlefthebrew'] = 0x0591;
	  t['etnahtahebrew'] = 0x0591;
	  t['etnahtalefthebrew'] = 0x0591;
	  t['eturned'] = 0x01DD;
	  t['eukorean'] = 0x3161;
	  t['euro'] = 0x20AC;
	  t['evowelsignbengali'] = 0x09C7;
	  t['evowelsigndeva'] = 0x0947;
	  t['evowelsigngujarati'] = 0x0AC7;
	  t['exclam'] = 0x0021;
	  t['exclamarmenian'] = 0x055C;
	  t['exclamdbl'] = 0x203C;
	  t['exclamdown'] = 0x00A1;
	  t['exclamdownsmall'] = 0xF7A1;
	  t['exclammonospace'] = 0xFF01;
	  t['exclamsmall'] = 0xF721;
	  t['existential'] = 0x2203;
	  t['ezh'] = 0x0292;
	  t['ezhcaron'] = 0x01EF;
	  t['ezhcurl'] = 0x0293;
	  t['ezhreversed'] = 0x01B9;
	  t['ezhtail'] = 0x01BA;
	  t['f'] = 0x0066;
	  t['fadeva'] = 0x095E;
	  t['fagurmukhi'] = 0x0A5E;
	  t['fahrenheit'] = 0x2109;
	  t['fathaarabic'] = 0x064E;
	  t['fathalowarabic'] = 0x064E;
	  t['fathatanarabic'] = 0x064B;
	  t['fbopomofo'] = 0x3108;
	  t['fcircle'] = 0x24D5;
	  t['fdotaccent'] = 0x1E1F;
	  t['feharabic'] = 0x0641;
	  t['feharmenian'] = 0x0586;
	  t['fehfinalarabic'] = 0xFED2;
	  t['fehinitialarabic'] = 0xFED3;
	  t['fehmedialarabic'] = 0xFED4;
	  t['feicoptic'] = 0x03E5;
	  t['female'] = 0x2640;
	  t['ff'] = 0xFB00;
	  t['ffi'] = 0xFB03;
	  t['ffl'] = 0xFB04;
	  t['fi'] = 0xFB01;
	  t['fifteencircle'] = 0x246E;
	  t['fifteenparen'] = 0x2482;
	  t['fifteenperiod'] = 0x2496;
	  t['figuredash'] = 0x2012;
	  t['filledbox'] = 0x25A0;
	  t['filledrect'] = 0x25AC;
	  t['finalkaf'] = 0x05DA;
	  t['finalkafdagesh'] = 0xFB3A;
	  t['finalkafdageshhebrew'] = 0xFB3A;
	  t['finalkafhebrew'] = 0x05DA;
	  t['finalmem'] = 0x05DD;
	  t['finalmemhebrew'] = 0x05DD;
	  t['finalnun'] = 0x05DF;
	  t['finalnunhebrew'] = 0x05DF;
	  t['finalpe'] = 0x05E3;
	  t['finalpehebrew'] = 0x05E3;
	  t['finaltsadi'] = 0x05E5;
	  t['finaltsadihebrew'] = 0x05E5;
	  t['firsttonechinese'] = 0x02C9;
	  t['fisheye'] = 0x25C9;
	  t['fitacyrillic'] = 0x0473;
	  t['five'] = 0x0035;
	  t['fivearabic'] = 0x0665;
	  t['fivebengali'] = 0x09EB;
	  t['fivecircle'] = 0x2464;
	  t['fivecircleinversesansserif'] = 0x278E;
	  t['fivedeva'] = 0x096B;
	  t['fiveeighths'] = 0x215D;
	  t['fivegujarati'] = 0x0AEB;
	  t['fivegurmukhi'] = 0x0A6B;
	  t['fivehackarabic'] = 0x0665;
	  t['fivehangzhou'] = 0x3025;
	  t['fiveideographicparen'] = 0x3224;
	  t['fiveinferior'] = 0x2085;
	  t['fivemonospace'] = 0xFF15;
	  t['fiveoldstyle'] = 0xF735;
	  t['fiveparen'] = 0x2478;
	  t['fiveperiod'] = 0x248C;
	  t['fivepersian'] = 0x06F5;
	  t['fiveroman'] = 0x2174;
	  t['fivesuperior'] = 0x2075;
	  t['fivethai'] = 0x0E55;
	  t['fl'] = 0xFB02;
	  t['florin'] = 0x0192;
	  t['fmonospace'] = 0xFF46;
	  t['fmsquare'] = 0x3399;
	  t['fofanthai'] = 0x0E1F;
	  t['fofathai'] = 0x0E1D;
	  t['fongmanthai'] = 0x0E4F;
	  t['forall'] = 0x2200;
	  t['four'] = 0x0034;
	  t['fourarabic'] = 0x0664;
	  t['fourbengali'] = 0x09EA;
	  t['fourcircle'] = 0x2463;
	  t['fourcircleinversesansserif'] = 0x278D;
	  t['fourdeva'] = 0x096A;
	  t['fourgujarati'] = 0x0AEA;
	  t['fourgurmukhi'] = 0x0A6A;
	  t['fourhackarabic'] = 0x0664;
	  t['fourhangzhou'] = 0x3024;
	  t['fourideographicparen'] = 0x3223;
	  t['fourinferior'] = 0x2084;
	  t['fourmonospace'] = 0xFF14;
	  t['fournumeratorbengali'] = 0x09F7;
	  t['fouroldstyle'] = 0xF734;
	  t['fourparen'] = 0x2477;
	  t['fourperiod'] = 0x248B;
	  t['fourpersian'] = 0x06F4;
	  t['fourroman'] = 0x2173;
	  t['foursuperior'] = 0x2074;
	  t['fourteencircle'] = 0x246D;
	  t['fourteenparen'] = 0x2481;
	  t['fourteenperiod'] = 0x2495;
	  t['fourthai'] = 0x0E54;
	  t['fourthtonechinese'] = 0x02CB;
	  t['fparen'] = 0x24A1;
	  t['fraction'] = 0x2044;
	  t['franc'] = 0x20A3;
	  t['g'] = 0x0067;
	  t['gabengali'] = 0x0997;
	  t['gacute'] = 0x01F5;
	  t['gadeva'] = 0x0917;
	  t['gafarabic'] = 0x06AF;
	  t['gaffinalarabic'] = 0xFB93;
	  t['gafinitialarabic'] = 0xFB94;
	  t['gafmedialarabic'] = 0xFB95;
	  t['gagujarati'] = 0x0A97;
	  t['gagurmukhi'] = 0x0A17;
	  t['gahiragana'] = 0x304C;
	  t['gakatakana'] = 0x30AC;
	  t['gamma'] = 0x03B3;
	  t['gammalatinsmall'] = 0x0263;
	  t['gammasuperior'] = 0x02E0;
	  t['gangiacoptic'] = 0x03EB;
	  t['gbopomofo'] = 0x310D;
	  t['gbreve'] = 0x011F;
	  t['gcaron'] = 0x01E7;
	  t['gcedilla'] = 0x0123;
	  t['gcircle'] = 0x24D6;
	  t['gcircumflex'] = 0x011D;
	  t['gcommaaccent'] = 0x0123;
	  t['gdot'] = 0x0121;
	  t['gdotaccent'] = 0x0121;
	  t['gecyrillic'] = 0x0433;
	  t['gehiragana'] = 0x3052;
	  t['gekatakana'] = 0x30B2;
	  t['geometricallyequal'] = 0x2251;
	  t['gereshaccenthebrew'] = 0x059C;
	  t['gereshhebrew'] = 0x05F3;
	  t['gereshmuqdamhebrew'] = 0x059D;
	  t['germandbls'] = 0x00DF;
	  t['gershayimaccenthebrew'] = 0x059E;
	  t['gershayimhebrew'] = 0x05F4;
	  t['getamark'] = 0x3013;
	  t['ghabengali'] = 0x0998;
	  t['ghadarmenian'] = 0x0572;
	  t['ghadeva'] = 0x0918;
	  t['ghagujarati'] = 0x0A98;
	  t['ghagurmukhi'] = 0x0A18;
	  t['ghainarabic'] = 0x063A;
	  t['ghainfinalarabic'] = 0xFECE;
	  t['ghaininitialarabic'] = 0xFECF;
	  t['ghainmedialarabic'] = 0xFED0;
	  t['ghemiddlehookcyrillic'] = 0x0495;
	  t['ghestrokecyrillic'] = 0x0493;
	  t['gheupturncyrillic'] = 0x0491;
	  t['ghhadeva'] = 0x095A;
	  t['ghhagurmukhi'] = 0x0A5A;
	  t['ghook'] = 0x0260;
	  t['ghzsquare'] = 0x3393;
	  t['gihiragana'] = 0x304E;
	  t['gikatakana'] = 0x30AE;
	  t['gimarmenian'] = 0x0563;
	  t['gimel'] = 0x05D2;
	  t['gimeldagesh'] = 0xFB32;
	  t['gimeldageshhebrew'] = 0xFB32;
	  t['gimelhebrew'] = 0x05D2;
	  t['gjecyrillic'] = 0x0453;
	  t['glottalinvertedstroke'] = 0x01BE;
	  t['glottalstop'] = 0x0294;
	  t['glottalstopinverted'] = 0x0296;
	  t['glottalstopmod'] = 0x02C0;
	  t['glottalstopreversed'] = 0x0295;
	  t['glottalstopreversedmod'] = 0x02C1;
	  t['glottalstopreversedsuperior'] = 0x02E4;
	  t['glottalstopstroke'] = 0x02A1;
	  t['glottalstopstrokereversed'] = 0x02A2;
	  t['gmacron'] = 0x1E21;
	  t['gmonospace'] = 0xFF47;
	  t['gohiragana'] = 0x3054;
	  t['gokatakana'] = 0x30B4;
	  t['gparen'] = 0x24A2;
	  t['gpasquare'] = 0x33AC;
	  t['gradient'] = 0x2207;
	  t['grave'] = 0x0060;
	  t['gravebelowcmb'] = 0x0316;
	  t['gravecmb'] = 0x0300;
	  t['gravecomb'] = 0x0300;
	  t['gravedeva'] = 0x0953;
	  t['gravelowmod'] = 0x02CE;
	  t['gravemonospace'] = 0xFF40;
	  t['gravetonecmb'] = 0x0340;
	  t['greater'] = 0x003E;
	  t['greaterequal'] = 0x2265;
	  t['greaterequalorless'] = 0x22DB;
	  t['greatermonospace'] = 0xFF1E;
	  t['greaterorequivalent'] = 0x2273;
	  t['greaterorless'] = 0x2277;
	  t['greateroverequal'] = 0x2267;
	  t['greatersmall'] = 0xFE65;
	  t['gscript'] = 0x0261;
	  t['gstroke'] = 0x01E5;
	  t['guhiragana'] = 0x3050;
	  t['guillemotleft'] = 0x00AB;
	  t['guillemotright'] = 0x00BB;
	  t['guilsinglleft'] = 0x2039;
	  t['guilsinglright'] = 0x203A;
	  t['gukatakana'] = 0x30B0;
	  t['guramusquare'] = 0x3318;
	  t['gysquare'] = 0x33C9;
	  t['h'] = 0x0068;
	  t['haabkhasiancyrillic'] = 0x04A9;
	  t['haaltonearabic'] = 0x06C1;
	  t['habengali'] = 0x09B9;
	  t['hadescendercyrillic'] = 0x04B3;
	  t['hadeva'] = 0x0939;
	  t['hagujarati'] = 0x0AB9;
	  t['hagurmukhi'] = 0x0A39;
	  t['haharabic'] = 0x062D;
	  t['hahfinalarabic'] = 0xFEA2;
	  t['hahinitialarabic'] = 0xFEA3;
	  t['hahiragana'] = 0x306F;
	  t['hahmedialarabic'] = 0xFEA4;
	  t['haitusquare'] = 0x332A;
	  t['hakatakana'] = 0x30CF;
	  t['hakatakanahalfwidth'] = 0xFF8A;
	  t['halantgurmukhi'] = 0x0A4D;
	  t['hamzaarabic'] = 0x0621;
	  t['hamzalowarabic'] = 0x0621;
	  t['hangulfiller'] = 0x3164;
	  t['hardsigncyrillic'] = 0x044A;
	  t['harpoonleftbarbup'] = 0x21BC;
	  t['harpoonrightbarbup'] = 0x21C0;
	  t['hasquare'] = 0x33CA;
	  t['hatafpatah'] = 0x05B2;
	  t['hatafpatah16'] = 0x05B2;
	  t['hatafpatah23'] = 0x05B2;
	  t['hatafpatah2f'] = 0x05B2;
	  t['hatafpatahhebrew'] = 0x05B2;
	  t['hatafpatahnarrowhebrew'] = 0x05B2;
	  t['hatafpatahquarterhebrew'] = 0x05B2;
	  t['hatafpatahwidehebrew'] = 0x05B2;
	  t['hatafqamats'] = 0x05B3;
	  t['hatafqamats1b'] = 0x05B3;
	  t['hatafqamats28'] = 0x05B3;
	  t['hatafqamats34'] = 0x05B3;
	  t['hatafqamatshebrew'] = 0x05B3;
	  t['hatafqamatsnarrowhebrew'] = 0x05B3;
	  t['hatafqamatsquarterhebrew'] = 0x05B3;
	  t['hatafqamatswidehebrew'] = 0x05B3;
	  t['hatafsegol'] = 0x05B1;
	  t['hatafsegol17'] = 0x05B1;
	  t['hatafsegol24'] = 0x05B1;
	  t['hatafsegol30'] = 0x05B1;
	  t['hatafsegolhebrew'] = 0x05B1;
	  t['hatafsegolnarrowhebrew'] = 0x05B1;
	  t['hatafsegolquarterhebrew'] = 0x05B1;
	  t['hatafsegolwidehebrew'] = 0x05B1;
	  t['hbar'] = 0x0127;
	  t['hbopomofo'] = 0x310F;
	  t['hbrevebelow'] = 0x1E2B;
	  t['hcedilla'] = 0x1E29;
	  t['hcircle'] = 0x24D7;
	  t['hcircumflex'] = 0x0125;
	  t['hdieresis'] = 0x1E27;
	  t['hdotaccent'] = 0x1E23;
	  t['hdotbelow'] = 0x1E25;
	  t['he'] = 0x05D4;
	  t['heart'] = 0x2665;
	  t['heartsuitblack'] = 0x2665;
	  t['heartsuitwhite'] = 0x2661;
	  t['hedagesh'] = 0xFB34;
	  t['hedageshhebrew'] = 0xFB34;
	  t['hehaltonearabic'] = 0x06C1;
	  t['heharabic'] = 0x0647;
	  t['hehebrew'] = 0x05D4;
	  t['hehfinalaltonearabic'] = 0xFBA7;
	  t['hehfinalalttwoarabic'] = 0xFEEA;
	  t['hehfinalarabic'] = 0xFEEA;
	  t['hehhamzaabovefinalarabic'] = 0xFBA5;
	  t['hehhamzaaboveisolatedarabic'] = 0xFBA4;
	  t['hehinitialaltonearabic'] = 0xFBA8;
	  t['hehinitialarabic'] = 0xFEEB;
	  t['hehiragana'] = 0x3078;
	  t['hehmedialaltonearabic'] = 0xFBA9;
	  t['hehmedialarabic'] = 0xFEEC;
	  t['heiseierasquare'] = 0x337B;
	  t['hekatakana'] = 0x30D8;
	  t['hekatakanahalfwidth'] = 0xFF8D;
	  t['hekutaarusquare'] = 0x3336;
	  t['henghook'] = 0x0267;
	  t['herutusquare'] = 0x3339;
	  t['het'] = 0x05D7;
	  t['hethebrew'] = 0x05D7;
	  t['hhook'] = 0x0266;
	  t['hhooksuperior'] = 0x02B1;
	  t['hieuhacirclekorean'] = 0x327B;
	  t['hieuhaparenkorean'] = 0x321B;
	  t['hieuhcirclekorean'] = 0x326D;
	  t['hieuhkorean'] = 0x314E;
	  t['hieuhparenkorean'] = 0x320D;
	  t['hihiragana'] = 0x3072;
	  t['hikatakana'] = 0x30D2;
	  t['hikatakanahalfwidth'] = 0xFF8B;
	  t['hiriq'] = 0x05B4;
	  t['hiriq14'] = 0x05B4;
	  t['hiriq21'] = 0x05B4;
	  t['hiriq2d'] = 0x05B4;
	  t['hiriqhebrew'] = 0x05B4;
	  t['hiriqnarrowhebrew'] = 0x05B4;
	  t['hiriqquarterhebrew'] = 0x05B4;
	  t['hiriqwidehebrew'] = 0x05B4;
	  t['hlinebelow'] = 0x1E96;
	  t['hmonospace'] = 0xFF48;
	  t['hoarmenian'] = 0x0570;
	  t['hohipthai'] = 0x0E2B;
	  t['hohiragana'] = 0x307B;
	  t['hokatakana'] = 0x30DB;
	  t['hokatakanahalfwidth'] = 0xFF8E;
	  t['holam'] = 0x05B9;
	  t['holam19'] = 0x05B9;
	  t['holam26'] = 0x05B9;
	  t['holam32'] = 0x05B9;
	  t['holamhebrew'] = 0x05B9;
	  t['holamnarrowhebrew'] = 0x05B9;
	  t['holamquarterhebrew'] = 0x05B9;
	  t['holamwidehebrew'] = 0x05B9;
	  t['honokhukthai'] = 0x0E2E;
	  t['hookabovecomb'] = 0x0309;
	  t['hookcmb'] = 0x0309;
	  t['hookpalatalizedbelowcmb'] = 0x0321;
	  t['hookretroflexbelowcmb'] = 0x0322;
	  t['hoonsquare'] = 0x3342;
	  t['horicoptic'] = 0x03E9;
	  t['horizontalbar'] = 0x2015;
	  t['horncmb'] = 0x031B;
	  t['hotsprings'] = 0x2668;
	  t['house'] = 0x2302;
	  t['hparen'] = 0x24A3;
	  t['hsuperior'] = 0x02B0;
	  t['hturned'] = 0x0265;
	  t['huhiragana'] = 0x3075;
	  t['huiitosquare'] = 0x3333;
	  t['hukatakana'] = 0x30D5;
	  t['hukatakanahalfwidth'] = 0xFF8C;
	  t['hungarumlaut'] = 0x02DD;
	  t['hungarumlautcmb'] = 0x030B;
	  t['hv'] = 0x0195;
	  t['hyphen'] = 0x002D;
	  t['hypheninferior'] = 0xF6E5;
	  t['hyphenmonospace'] = 0xFF0D;
	  t['hyphensmall'] = 0xFE63;
	  t['hyphensuperior'] = 0xF6E6;
	  t['hyphentwo'] = 0x2010;
	  t['i'] = 0x0069;
	  t['iacute'] = 0x00ED;
	  t['iacyrillic'] = 0x044F;
	  t['ibengali'] = 0x0987;
	  t['ibopomofo'] = 0x3127;
	  t['ibreve'] = 0x012D;
	  t['icaron'] = 0x01D0;
	  t['icircle'] = 0x24D8;
	  t['icircumflex'] = 0x00EE;
	  t['icyrillic'] = 0x0456;
	  t['idblgrave'] = 0x0209;
	  t['ideographearthcircle'] = 0x328F;
	  t['ideographfirecircle'] = 0x328B;
	  t['ideographicallianceparen'] = 0x323F;
	  t['ideographiccallparen'] = 0x323A;
	  t['ideographiccentrecircle'] = 0x32A5;
	  t['ideographicclose'] = 0x3006;
	  t['ideographiccomma'] = 0x3001;
	  t['ideographiccommaleft'] = 0xFF64;
	  t['ideographiccongratulationparen'] = 0x3237;
	  t['ideographiccorrectcircle'] = 0x32A3;
	  t['ideographicearthparen'] = 0x322F;
	  t['ideographicenterpriseparen'] = 0x323D;
	  t['ideographicexcellentcircle'] = 0x329D;
	  t['ideographicfestivalparen'] = 0x3240;
	  t['ideographicfinancialcircle'] = 0x3296;
	  t['ideographicfinancialparen'] = 0x3236;
	  t['ideographicfireparen'] = 0x322B;
	  t['ideographichaveparen'] = 0x3232;
	  t['ideographichighcircle'] = 0x32A4;
	  t['ideographiciterationmark'] = 0x3005;
	  t['ideographiclaborcircle'] = 0x3298;
	  t['ideographiclaborparen'] = 0x3238;
	  t['ideographicleftcircle'] = 0x32A7;
	  t['ideographiclowcircle'] = 0x32A6;
	  t['ideographicmedicinecircle'] = 0x32A9;
	  t['ideographicmetalparen'] = 0x322E;
	  t['ideographicmoonparen'] = 0x322A;
	  t['ideographicnameparen'] = 0x3234;
	  t['ideographicperiod'] = 0x3002;
	  t['ideographicprintcircle'] = 0x329E;
	  t['ideographicreachparen'] = 0x3243;
	  t['ideographicrepresentparen'] = 0x3239;
	  t['ideographicresourceparen'] = 0x323E;
	  t['ideographicrightcircle'] = 0x32A8;
	  t['ideographicsecretcircle'] = 0x3299;
	  t['ideographicselfparen'] = 0x3242;
	  t['ideographicsocietyparen'] = 0x3233;
	  t['ideographicspace'] = 0x3000;
	  t['ideographicspecialparen'] = 0x3235;
	  t['ideographicstockparen'] = 0x3231;
	  t['ideographicstudyparen'] = 0x323B;
	  t['ideographicsunparen'] = 0x3230;
	  t['ideographicsuperviseparen'] = 0x323C;
	  t['ideographicwaterparen'] = 0x322C;
	  t['ideographicwoodparen'] = 0x322D;
	  t['ideographiczero'] = 0x3007;
	  t['ideographmetalcircle'] = 0x328E;
	  t['ideographmooncircle'] = 0x328A;
	  t['ideographnamecircle'] = 0x3294;
	  t['ideographsuncircle'] = 0x3290;
	  t['ideographwatercircle'] = 0x328C;
	  t['ideographwoodcircle'] = 0x328D;
	  t['ideva'] = 0x0907;
	  t['idieresis'] = 0x00EF;
	  t['idieresisacute'] = 0x1E2F;
	  t['idieresiscyrillic'] = 0x04E5;
	  t['idotbelow'] = 0x1ECB;
	  t['iebrevecyrillic'] = 0x04D7;
	  t['iecyrillic'] = 0x0435;
	  t['ieungacirclekorean'] = 0x3275;
	  t['ieungaparenkorean'] = 0x3215;
	  t['ieungcirclekorean'] = 0x3267;
	  t['ieungkorean'] = 0x3147;
	  t['ieungparenkorean'] = 0x3207;
	  t['igrave'] = 0x00EC;
	  t['igujarati'] = 0x0A87;
	  t['igurmukhi'] = 0x0A07;
	  t['ihiragana'] = 0x3044;
	  t['ihookabove'] = 0x1EC9;
	  t['iibengali'] = 0x0988;
	  t['iicyrillic'] = 0x0438;
	  t['iideva'] = 0x0908;
	  t['iigujarati'] = 0x0A88;
	  t['iigurmukhi'] = 0x0A08;
	  t['iimatragurmukhi'] = 0x0A40;
	  t['iinvertedbreve'] = 0x020B;
	  t['iishortcyrillic'] = 0x0439;
	  t['iivowelsignbengali'] = 0x09C0;
	  t['iivowelsigndeva'] = 0x0940;
	  t['iivowelsigngujarati'] = 0x0AC0;
	  t['ij'] = 0x0133;
	  t['ikatakana'] = 0x30A4;
	  t['ikatakanahalfwidth'] = 0xFF72;
	  t['ikorean'] = 0x3163;
	  t['ilde'] = 0x02DC;
	  t['iluyhebrew'] = 0x05AC;
	  t['imacron'] = 0x012B;
	  t['imacroncyrillic'] = 0x04E3;
	  t['imageorapproximatelyequal'] = 0x2253;
	  t['imatragurmukhi'] = 0x0A3F;
	  t['imonospace'] = 0xFF49;
	  t['increment'] = 0x2206;
	  t['infinity'] = 0x221E;
	  t['iniarmenian'] = 0x056B;
	  t['integral'] = 0x222B;
	  t['integralbottom'] = 0x2321;
	  t['integralbt'] = 0x2321;
	  t['integralex'] = 0xF8F5;
	  t['integraltop'] = 0x2320;
	  t['integraltp'] = 0x2320;
	  t['intersection'] = 0x2229;
	  t['intisquare'] = 0x3305;
	  t['invbullet'] = 0x25D8;
	  t['invcircle'] = 0x25D9;
	  t['invsmileface'] = 0x263B;
	  t['iocyrillic'] = 0x0451;
	  t['iogonek'] = 0x012F;
	  t['iota'] = 0x03B9;
	  t['iotadieresis'] = 0x03CA;
	  t['iotadieresistonos'] = 0x0390;
	  t['iotalatin'] = 0x0269;
	  t['iotatonos'] = 0x03AF;
	  t['iparen'] = 0x24A4;
	  t['irigurmukhi'] = 0x0A72;
	  t['ismallhiragana'] = 0x3043;
	  t['ismallkatakana'] = 0x30A3;
	  t['ismallkatakanahalfwidth'] = 0xFF68;
	  t['issharbengali'] = 0x09FA;
	  t['istroke'] = 0x0268;
	  t['isuperior'] = 0xF6ED;
	  t['iterationhiragana'] = 0x309D;
	  t['iterationkatakana'] = 0x30FD;
	  t['itilde'] = 0x0129;
	  t['itildebelow'] = 0x1E2D;
	  t['iubopomofo'] = 0x3129;
	  t['iucyrillic'] = 0x044E;
	  t['ivowelsignbengali'] = 0x09BF;
	  t['ivowelsigndeva'] = 0x093F;
	  t['ivowelsigngujarati'] = 0x0ABF;
	  t['izhitsacyrillic'] = 0x0475;
	  t['izhitsadblgravecyrillic'] = 0x0477;
	  t['j'] = 0x006A;
	  t['jaarmenian'] = 0x0571;
	  t['jabengali'] = 0x099C;
	  t['jadeva'] = 0x091C;
	  t['jagujarati'] = 0x0A9C;
	  t['jagurmukhi'] = 0x0A1C;
	  t['jbopomofo'] = 0x3110;
	  t['jcaron'] = 0x01F0;
	  t['jcircle'] = 0x24D9;
	  t['jcircumflex'] = 0x0135;
	  t['jcrossedtail'] = 0x029D;
	  t['jdotlessstroke'] = 0x025F;
	  t['jecyrillic'] = 0x0458;
	  t['jeemarabic'] = 0x062C;
	  t['jeemfinalarabic'] = 0xFE9E;
	  t['jeeminitialarabic'] = 0xFE9F;
	  t['jeemmedialarabic'] = 0xFEA0;
	  t['jeharabic'] = 0x0698;
	  t['jehfinalarabic'] = 0xFB8B;
	  t['jhabengali'] = 0x099D;
	  t['jhadeva'] = 0x091D;
	  t['jhagujarati'] = 0x0A9D;
	  t['jhagurmukhi'] = 0x0A1D;
	  t['jheharmenian'] = 0x057B;
	  t['jis'] = 0x3004;
	  t['jmonospace'] = 0xFF4A;
	  t['jparen'] = 0x24A5;
	  t['jsuperior'] = 0x02B2;
	  t['k'] = 0x006B;
	  t['kabashkircyrillic'] = 0x04A1;
	  t['kabengali'] = 0x0995;
	  t['kacute'] = 0x1E31;
	  t['kacyrillic'] = 0x043A;
	  t['kadescendercyrillic'] = 0x049B;
	  t['kadeva'] = 0x0915;
	  t['kaf'] = 0x05DB;
	  t['kafarabic'] = 0x0643;
	  t['kafdagesh'] = 0xFB3B;
	  t['kafdageshhebrew'] = 0xFB3B;
	  t['kaffinalarabic'] = 0xFEDA;
	  t['kafhebrew'] = 0x05DB;
	  t['kafinitialarabic'] = 0xFEDB;
	  t['kafmedialarabic'] = 0xFEDC;
	  t['kafrafehebrew'] = 0xFB4D;
	  t['kagujarati'] = 0x0A95;
	  t['kagurmukhi'] = 0x0A15;
	  t['kahiragana'] = 0x304B;
	  t['kahookcyrillic'] = 0x04C4;
	  t['kakatakana'] = 0x30AB;
	  t['kakatakanahalfwidth'] = 0xFF76;
	  t['kappa'] = 0x03BA;
	  t['kappasymbolgreek'] = 0x03F0;
	  t['kapyeounmieumkorean'] = 0x3171;
	  t['kapyeounphieuphkorean'] = 0x3184;
	  t['kapyeounpieupkorean'] = 0x3178;
	  t['kapyeounssangpieupkorean'] = 0x3179;
	  t['karoriisquare'] = 0x330D;
	  t['kashidaautoarabic'] = 0x0640;
	  t['kashidaautonosidebearingarabic'] = 0x0640;
	  t['kasmallkatakana'] = 0x30F5;
	  t['kasquare'] = 0x3384;
	  t['kasraarabic'] = 0x0650;
	  t['kasratanarabic'] = 0x064D;
	  t['kastrokecyrillic'] = 0x049F;
	  t['katahiraprolongmarkhalfwidth'] = 0xFF70;
	  t['kaverticalstrokecyrillic'] = 0x049D;
	  t['kbopomofo'] = 0x310E;
	  t['kcalsquare'] = 0x3389;
	  t['kcaron'] = 0x01E9;
	  t['kcedilla'] = 0x0137;
	  t['kcircle'] = 0x24DA;
	  t['kcommaaccent'] = 0x0137;
	  t['kdotbelow'] = 0x1E33;
	  t['keharmenian'] = 0x0584;
	  t['kehiragana'] = 0x3051;
	  t['kekatakana'] = 0x30B1;
	  t['kekatakanahalfwidth'] = 0xFF79;
	  t['kenarmenian'] = 0x056F;
	  t['kesmallkatakana'] = 0x30F6;
	  t['kgreenlandic'] = 0x0138;
	  t['khabengali'] = 0x0996;
	  t['khacyrillic'] = 0x0445;
	  t['khadeva'] = 0x0916;
	  t['khagujarati'] = 0x0A96;
	  t['khagurmukhi'] = 0x0A16;
	  t['khaharabic'] = 0x062E;
	  t['khahfinalarabic'] = 0xFEA6;
	  t['khahinitialarabic'] = 0xFEA7;
	  t['khahmedialarabic'] = 0xFEA8;
	  t['kheicoptic'] = 0x03E7;
	  t['khhadeva'] = 0x0959;
	  t['khhagurmukhi'] = 0x0A59;
	  t['khieukhacirclekorean'] = 0x3278;
	  t['khieukhaparenkorean'] = 0x3218;
	  t['khieukhcirclekorean'] = 0x326A;
	  t['khieukhkorean'] = 0x314B;
	  t['khieukhparenkorean'] = 0x320A;
	  t['khokhaithai'] = 0x0E02;
	  t['khokhonthai'] = 0x0E05;
	  t['khokhuatthai'] = 0x0E03;
	  t['khokhwaithai'] = 0x0E04;
	  t['khomutthai'] = 0x0E5B;
	  t['khook'] = 0x0199;
	  t['khorakhangthai'] = 0x0E06;
	  t['khzsquare'] = 0x3391;
	  t['kihiragana'] = 0x304D;
	  t['kikatakana'] = 0x30AD;
	  t['kikatakanahalfwidth'] = 0xFF77;
	  t['kiroguramusquare'] = 0x3315;
	  t['kiromeetorusquare'] = 0x3316;
	  t['kirosquare'] = 0x3314;
	  t['kiyeokacirclekorean'] = 0x326E;
	  t['kiyeokaparenkorean'] = 0x320E;
	  t['kiyeokcirclekorean'] = 0x3260;
	  t['kiyeokkorean'] = 0x3131;
	  t['kiyeokparenkorean'] = 0x3200;
	  t['kiyeoksioskorean'] = 0x3133;
	  t['kjecyrillic'] = 0x045C;
	  t['klinebelow'] = 0x1E35;
	  t['klsquare'] = 0x3398;
	  t['kmcubedsquare'] = 0x33A6;
	  t['kmonospace'] = 0xFF4B;
	  t['kmsquaredsquare'] = 0x33A2;
	  t['kohiragana'] = 0x3053;
	  t['kohmsquare'] = 0x33C0;
	  t['kokaithai'] = 0x0E01;
	  t['kokatakana'] = 0x30B3;
	  t['kokatakanahalfwidth'] = 0xFF7A;
	  t['kooposquare'] = 0x331E;
	  t['koppacyrillic'] = 0x0481;
	  t['koreanstandardsymbol'] = 0x327F;
	  t['koroniscmb'] = 0x0343;
	  t['kparen'] = 0x24A6;
	  t['kpasquare'] = 0x33AA;
	  t['ksicyrillic'] = 0x046F;
	  t['ktsquare'] = 0x33CF;
	  t['kturned'] = 0x029E;
	  t['kuhiragana'] = 0x304F;
	  t['kukatakana'] = 0x30AF;
	  t['kukatakanahalfwidth'] = 0xFF78;
	  t['kvsquare'] = 0x33B8;
	  t['kwsquare'] = 0x33BE;
	  t['l'] = 0x006C;
	  t['labengali'] = 0x09B2;
	  t['lacute'] = 0x013A;
	  t['ladeva'] = 0x0932;
	  t['lagujarati'] = 0x0AB2;
	  t['lagurmukhi'] = 0x0A32;
	  t['lakkhangyaothai'] = 0x0E45;
	  t['lamaleffinalarabic'] = 0xFEFC;
	  t['lamalefhamzaabovefinalarabic'] = 0xFEF8;
	  t['lamalefhamzaaboveisolatedarabic'] = 0xFEF7;
	  t['lamalefhamzabelowfinalarabic'] = 0xFEFA;
	  t['lamalefhamzabelowisolatedarabic'] = 0xFEF9;
	  t['lamalefisolatedarabic'] = 0xFEFB;
	  t['lamalefmaddaabovefinalarabic'] = 0xFEF6;
	  t['lamalefmaddaaboveisolatedarabic'] = 0xFEF5;
	  t['lamarabic'] = 0x0644;
	  t['lambda'] = 0x03BB;
	  t['lambdastroke'] = 0x019B;
	  t['lamed'] = 0x05DC;
	  t['lameddagesh'] = 0xFB3C;
	  t['lameddageshhebrew'] = 0xFB3C;
	  t['lamedhebrew'] = 0x05DC;
	  t['lamfinalarabic'] = 0xFEDE;
	  t['lamhahinitialarabic'] = 0xFCCA;
	  t['laminitialarabic'] = 0xFEDF;
	  t['lamjeeminitialarabic'] = 0xFCC9;
	  t['lamkhahinitialarabic'] = 0xFCCB;
	  t['lamlamhehisolatedarabic'] = 0xFDF2;
	  t['lammedialarabic'] = 0xFEE0;
	  t['lammeemhahinitialarabic'] = 0xFD88;
	  t['lammeeminitialarabic'] = 0xFCCC;
	  t['largecircle'] = 0x25EF;
	  t['lbar'] = 0x019A;
	  t['lbelt'] = 0x026C;
	  t['lbopomofo'] = 0x310C;
	  t['lcaron'] = 0x013E;
	  t['lcedilla'] = 0x013C;
	  t['lcircle'] = 0x24DB;
	  t['lcircumflexbelow'] = 0x1E3D;
	  t['lcommaaccent'] = 0x013C;
	  t['ldot'] = 0x0140;
	  t['ldotaccent'] = 0x0140;
	  t['ldotbelow'] = 0x1E37;
	  t['ldotbelowmacron'] = 0x1E39;
	  t['leftangleabovecmb'] = 0x031A;
	  t['lefttackbelowcmb'] = 0x0318;
	  t['less'] = 0x003C;
	  t['lessequal'] = 0x2264;
	  t['lessequalorgreater'] = 0x22DA;
	  t['lessmonospace'] = 0xFF1C;
	  t['lessorequivalent'] = 0x2272;
	  t['lessorgreater'] = 0x2276;
	  t['lessoverequal'] = 0x2266;
	  t['lesssmall'] = 0xFE64;
	  t['lezh'] = 0x026E;
	  t['lfblock'] = 0x258C;
	  t['lhookretroflex'] = 0x026D;
	  t['lira'] = 0x20A4;
	  t['liwnarmenian'] = 0x056C;
	  t['lj'] = 0x01C9;
	  t['ljecyrillic'] = 0x0459;
	  t['ll'] = 0xF6C0;
	  t['lladeva'] = 0x0933;
	  t['llagujarati'] = 0x0AB3;
	  t['llinebelow'] = 0x1E3B;
	  t['llladeva'] = 0x0934;
	  t['llvocalicbengali'] = 0x09E1;
	  t['llvocalicdeva'] = 0x0961;
	  t['llvocalicvowelsignbengali'] = 0x09E3;
	  t['llvocalicvowelsigndeva'] = 0x0963;
	  t['lmiddletilde'] = 0x026B;
	  t['lmonospace'] = 0xFF4C;
	  t['lmsquare'] = 0x33D0;
	  t['lochulathai'] = 0x0E2C;
	  t['logicaland'] = 0x2227;
	  t['logicalnot'] = 0x00AC;
	  t['logicalnotreversed'] = 0x2310;
	  t['logicalor'] = 0x2228;
	  t['lolingthai'] = 0x0E25;
	  t['longs'] = 0x017F;
	  t['lowlinecenterline'] = 0xFE4E;
	  t['lowlinecmb'] = 0x0332;
	  t['lowlinedashed'] = 0xFE4D;
	  t['lozenge'] = 0x25CA;
	  t['lparen'] = 0x24A7;
	  t['lslash'] = 0x0142;
	  t['lsquare'] = 0x2113;
	  t['lsuperior'] = 0xF6EE;
	  t['ltshade'] = 0x2591;
	  t['luthai'] = 0x0E26;
	  t['lvocalicbengali'] = 0x098C;
	  t['lvocalicdeva'] = 0x090C;
	  t['lvocalicvowelsignbengali'] = 0x09E2;
	  t['lvocalicvowelsigndeva'] = 0x0962;
	  t['lxsquare'] = 0x33D3;
	  t['m'] = 0x006D;
	  t['mabengali'] = 0x09AE;
	  t['macron'] = 0x00AF;
	  t['macronbelowcmb'] = 0x0331;
	  t['macroncmb'] = 0x0304;
	  t['macronlowmod'] = 0x02CD;
	  t['macronmonospace'] = 0xFFE3;
	  t['macute'] = 0x1E3F;
	  t['madeva'] = 0x092E;
	  t['magujarati'] = 0x0AAE;
	  t['magurmukhi'] = 0x0A2E;
	  t['mahapakhhebrew'] = 0x05A4;
	  t['mahapakhlefthebrew'] = 0x05A4;
	  t['mahiragana'] = 0x307E;
	  t['maichattawalowleftthai'] = 0xF895;
	  t['maichattawalowrightthai'] = 0xF894;
	  t['maichattawathai'] = 0x0E4B;
	  t['maichattawaupperleftthai'] = 0xF893;
	  t['maieklowleftthai'] = 0xF88C;
	  t['maieklowrightthai'] = 0xF88B;
	  t['maiekthai'] = 0x0E48;
	  t['maiekupperleftthai'] = 0xF88A;
	  t['maihanakatleftthai'] = 0xF884;
	  t['maihanakatthai'] = 0x0E31;
	  t['maitaikhuleftthai'] = 0xF889;
	  t['maitaikhuthai'] = 0x0E47;
	  t['maitholowleftthai'] = 0xF88F;
	  t['maitholowrightthai'] = 0xF88E;
	  t['maithothai'] = 0x0E49;
	  t['maithoupperleftthai'] = 0xF88D;
	  t['maitrilowleftthai'] = 0xF892;
	  t['maitrilowrightthai'] = 0xF891;
	  t['maitrithai'] = 0x0E4A;
	  t['maitriupperleftthai'] = 0xF890;
	  t['maiyamokthai'] = 0x0E46;
	  t['makatakana'] = 0x30DE;
	  t['makatakanahalfwidth'] = 0xFF8F;
	  t['male'] = 0x2642;
	  t['mansyonsquare'] = 0x3347;
	  t['maqafhebrew'] = 0x05BE;
	  t['mars'] = 0x2642;
	  t['masoracirclehebrew'] = 0x05AF;
	  t['masquare'] = 0x3383;
	  t['mbopomofo'] = 0x3107;
	  t['mbsquare'] = 0x33D4;
	  t['mcircle'] = 0x24DC;
	  t['mcubedsquare'] = 0x33A5;
	  t['mdotaccent'] = 0x1E41;
	  t['mdotbelow'] = 0x1E43;
	  t['meemarabic'] = 0x0645;
	  t['meemfinalarabic'] = 0xFEE2;
	  t['meeminitialarabic'] = 0xFEE3;
	  t['meemmedialarabic'] = 0xFEE4;
	  t['meemmeeminitialarabic'] = 0xFCD1;
	  t['meemmeemisolatedarabic'] = 0xFC48;
	  t['meetorusquare'] = 0x334D;
	  t['mehiragana'] = 0x3081;
	  t['meizierasquare'] = 0x337E;
	  t['mekatakana'] = 0x30E1;
	  t['mekatakanahalfwidth'] = 0xFF92;
	  t['mem'] = 0x05DE;
	  t['memdagesh'] = 0xFB3E;
	  t['memdageshhebrew'] = 0xFB3E;
	  t['memhebrew'] = 0x05DE;
	  t['menarmenian'] = 0x0574;
	  t['merkhahebrew'] = 0x05A5;
	  t['merkhakefulahebrew'] = 0x05A6;
	  t['merkhakefulalefthebrew'] = 0x05A6;
	  t['merkhalefthebrew'] = 0x05A5;
	  t['mhook'] = 0x0271;
	  t['mhzsquare'] = 0x3392;
	  t['middledotkatakanahalfwidth'] = 0xFF65;
	  t['middot'] = 0x00B7;
	  t['mieumacirclekorean'] = 0x3272;
	  t['mieumaparenkorean'] = 0x3212;
	  t['mieumcirclekorean'] = 0x3264;
	  t['mieumkorean'] = 0x3141;
	  t['mieumpansioskorean'] = 0x3170;
	  t['mieumparenkorean'] = 0x3204;
	  t['mieumpieupkorean'] = 0x316E;
	  t['mieumsioskorean'] = 0x316F;
	  t['mihiragana'] = 0x307F;
	  t['mikatakana'] = 0x30DF;
	  t['mikatakanahalfwidth'] = 0xFF90;
	  t['minus'] = 0x2212;
	  t['minusbelowcmb'] = 0x0320;
	  t['minuscircle'] = 0x2296;
	  t['minusmod'] = 0x02D7;
	  t['minusplus'] = 0x2213;
	  t['minute'] = 0x2032;
	  t['miribaarusquare'] = 0x334A;
	  t['mirisquare'] = 0x3349;
	  t['mlonglegturned'] = 0x0270;
	  t['mlsquare'] = 0x3396;
	  t['mmcubedsquare'] = 0x33A3;
	  t['mmonospace'] = 0xFF4D;
	  t['mmsquaredsquare'] = 0x339F;
	  t['mohiragana'] = 0x3082;
	  t['mohmsquare'] = 0x33C1;
	  t['mokatakana'] = 0x30E2;
	  t['mokatakanahalfwidth'] = 0xFF93;
	  t['molsquare'] = 0x33D6;
	  t['momathai'] = 0x0E21;
	  t['moverssquare'] = 0x33A7;
	  t['moverssquaredsquare'] = 0x33A8;
	  t['mparen'] = 0x24A8;
	  t['mpasquare'] = 0x33AB;
	  t['mssquare'] = 0x33B3;
	  t['msuperior'] = 0xF6EF;
	  t['mturned'] = 0x026F;
	  t['mu'] = 0x00B5;
	  t['mu1'] = 0x00B5;
	  t['muasquare'] = 0x3382;
	  t['muchgreater'] = 0x226B;
	  t['muchless'] = 0x226A;
	  t['mufsquare'] = 0x338C;
	  t['mugreek'] = 0x03BC;
	  t['mugsquare'] = 0x338D;
	  t['muhiragana'] = 0x3080;
	  t['mukatakana'] = 0x30E0;
	  t['mukatakanahalfwidth'] = 0xFF91;
	  t['mulsquare'] = 0x3395;
	  t['multiply'] = 0x00D7;
	  t['mumsquare'] = 0x339B;
	  t['munahhebrew'] = 0x05A3;
	  t['munahlefthebrew'] = 0x05A3;
	  t['musicalnote'] = 0x266A;
	  t['musicalnotedbl'] = 0x266B;
	  t['musicflatsign'] = 0x266D;
	  t['musicsharpsign'] = 0x266F;
	  t['mussquare'] = 0x33B2;
	  t['muvsquare'] = 0x33B6;
	  t['muwsquare'] = 0x33BC;
	  t['mvmegasquare'] = 0x33B9;
	  t['mvsquare'] = 0x33B7;
	  t['mwmegasquare'] = 0x33BF;
	  t['mwsquare'] = 0x33BD;
	  t['n'] = 0x006E;
	  t['nabengali'] = 0x09A8;
	  t['nabla'] = 0x2207;
	  t['nacute'] = 0x0144;
	  t['nadeva'] = 0x0928;
	  t['nagujarati'] = 0x0AA8;
	  t['nagurmukhi'] = 0x0A28;
	  t['nahiragana'] = 0x306A;
	  t['nakatakana'] = 0x30CA;
	  t['nakatakanahalfwidth'] = 0xFF85;
	  t['napostrophe'] = 0x0149;
	  t['nasquare'] = 0x3381;
	  t['nbopomofo'] = 0x310B;
	  t['nbspace'] = 0x00A0;
	  t['ncaron'] = 0x0148;
	  t['ncedilla'] = 0x0146;
	  t['ncircle'] = 0x24DD;
	  t['ncircumflexbelow'] = 0x1E4B;
	  t['ncommaaccent'] = 0x0146;
	  t['ndotaccent'] = 0x1E45;
	  t['ndotbelow'] = 0x1E47;
	  t['nehiragana'] = 0x306D;
	  t['nekatakana'] = 0x30CD;
	  t['nekatakanahalfwidth'] = 0xFF88;
	  t['newsheqelsign'] = 0x20AA;
	  t['nfsquare'] = 0x338B;
	  t['ngabengali'] = 0x0999;
	  t['ngadeva'] = 0x0919;
	  t['ngagujarati'] = 0x0A99;
	  t['ngagurmukhi'] = 0x0A19;
	  t['ngonguthai'] = 0x0E07;
	  t['nhiragana'] = 0x3093;
	  t['nhookleft'] = 0x0272;
	  t['nhookretroflex'] = 0x0273;
	  t['nieunacirclekorean'] = 0x326F;
	  t['nieunaparenkorean'] = 0x320F;
	  t['nieuncieuckorean'] = 0x3135;
	  t['nieuncirclekorean'] = 0x3261;
	  t['nieunhieuhkorean'] = 0x3136;
	  t['nieunkorean'] = 0x3134;
	  t['nieunpansioskorean'] = 0x3168;
	  t['nieunparenkorean'] = 0x3201;
	  t['nieunsioskorean'] = 0x3167;
	  t['nieuntikeutkorean'] = 0x3166;
	  t['nihiragana'] = 0x306B;
	  t['nikatakana'] = 0x30CB;
	  t['nikatakanahalfwidth'] = 0xFF86;
	  t['nikhahitleftthai'] = 0xF899;
	  t['nikhahitthai'] = 0x0E4D;
	  t['nine'] = 0x0039;
	  t['ninearabic'] = 0x0669;
	  t['ninebengali'] = 0x09EF;
	  t['ninecircle'] = 0x2468;
	  t['ninecircleinversesansserif'] = 0x2792;
	  t['ninedeva'] = 0x096F;
	  t['ninegujarati'] = 0x0AEF;
	  t['ninegurmukhi'] = 0x0A6F;
	  t['ninehackarabic'] = 0x0669;
	  t['ninehangzhou'] = 0x3029;
	  t['nineideographicparen'] = 0x3228;
	  t['nineinferior'] = 0x2089;
	  t['ninemonospace'] = 0xFF19;
	  t['nineoldstyle'] = 0xF739;
	  t['nineparen'] = 0x247C;
	  t['nineperiod'] = 0x2490;
	  t['ninepersian'] = 0x06F9;
	  t['nineroman'] = 0x2178;
	  t['ninesuperior'] = 0x2079;
	  t['nineteencircle'] = 0x2472;
	  t['nineteenparen'] = 0x2486;
	  t['nineteenperiod'] = 0x249A;
	  t['ninethai'] = 0x0E59;
	  t['nj'] = 0x01CC;
	  t['njecyrillic'] = 0x045A;
	  t['nkatakana'] = 0x30F3;
	  t['nkatakanahalfwidth'] = 0xFF9D;
	  t['nlegrightlong'] = 0x019E;
	  t['nlinebelow'] = 0x1E49;
	  t['nmonospace'] = 0xFF4E;
	  t['nmsquare'] = 0x339A;
	  t['nnabengali'] = 0x09A3;
	  t['nnadeva'] = 0x0923;
	  t['nnagujarati'] = 0x0AA3;
	  t['nnagurmukhi'] = 0x0A23;
	  t['nnnadeva'] = 0x0929;
	  t['nohiragana'] = 0x306E;
	  t['nokatakana'] = 0x30CE;
	  t['nokatakanahalfwidth'] = 0xFF89;
	  t['nonbreakingspace'] = 0x00A0;
	  t['nonenthai'] = 0x0E13;
	  t['nonuthai'] = 0x0E19;
	  t['noonarabic'] = 0x0646;
	  t['noonfinalarabic'] = 0xFEE6;
	  t['noonghunnaarabic'] = 0x06BA;
	  t['noonghunnafinalarabic'] = 0xFB9F;
	  t['nooninitialarabic'] = 0xFEE7;
	  t['noonjeeminitialarabic'] = 0xFCD2;
	  t['noonjeemisolatedarabic'] = 0xFC4B;
	  t['noonmedialarabic'] = 0xFEE8;
	  t['noonmeeminitialarabic'] = 0xFCD5;
	  t['noonmeemisolatedarabic'] = 0xFC4E;
	  t['noonnoonfinalarabic'] = 0xFC8D;
	  t['notcontains'] = 0x220C;
	  t['notelement'] = 0x2209;
	  t['notelementof'] = 0x2209;
	  t['notequal'] = 0x2260;
	  t['notgreater'] = 0x226F;
	  t['notgreaternorequal'] = 0x2271;
	  t['notgreaternorless'] = 0x2279;
	  t['notidentical'] = 0x2262;
	  t['notless'] = 0x226E;
	  t['notlessnorequal'] = 0x2270;
	  t['notparallel'] = 0x2226;
	  t['notprecedes'] = 0x2280;
	  t['notsubset'] = 0x2284;
	  t['notsucceeds'] = 0x2281;
	  t['notsuperset'] = 0x2285;
	  t['nowarmenian'] = 0x0576;
	  t['nparen'] = 0x24A9;
	  t['nssquare'] = 0x33B1;
	  t['nsuperior'] = 0x207F;
	  t['ntilde'] = 0x00F1;
	  t['nu'] = 0x03BD;
	  t['nuhiragana'] = 0x306C;
	  t['nukatakana'] = 0x30CC;
	  t['nukatakanahalfwidth'] = 0xFF87;
	  t['nuktabengali'] = 0x09BC;
	  t['nuktadeva'] = 0x093C;
	  t['nuktagujarati'] = 0x0ABC;
	  t['nuktagurmukhi'] = 0x0A3C;
	  t['numbersign'] = 0x0023;
	  t['numbersignmonospace'] = 0xFF03;
	  t['numbersignsmall'] = 0xFE5F;
	  t['numeralsigngreek'] = 0x0374;
	  t['numeralsignlowergreek'] = 0x0375;
	  t['numero'] = 0x2116;
	  t['nun'] = 0x05E0;
	  t['nundagesh'] = 0xFB40;
	  t['nundageshhebrew'] = 0xFB40;
	  t['nunhebrew'] = 0x05E0;
	  t['nvsquare'] = 0x33B5;
	  t['nwsquare'] = 0x33BB;
	  t['nyabengali'] = 0x099E;
	  t['nyadeva'] = 0x091E;
	  t['nyagujarati'] = 0x0A9E;
	  t['nyagurmukhi'] = 0x0A1E;
	  t['o'] = 0x006F;
	  t['oacute'] = 0x00F3;
	  t['oangthai'] = 0x0E2D;
	  t['obarred'] = 0x0275;
	  t['obarredcyrillic'] = 0x04E9;
	  t['obarreddieresiscyrillic'] = 0x04EB;
	  t['obengali'] = 0x0993;
	  t['obopomofo'] = 0x311B;
	  t['obreve'] = 0x014F;
	  t['ocandradeva'] = 0x0911;
	  t['ocandragujarati'] = 0x0A91;
	  t['ocandravowelsigndeva'] = 0x0949;
	  t['ocandravowelsigngujarati'] = 0x0AC9;
	  t['ocaron'] = 0x01D2;
	  t['ocircle'] = 0x24DE;
	  t['ocircumflex'] = 0x00F4;
	  t['ocircumflexacute'] = 0x1ED1;
	  t['ocircumflexdotbelow'] = 0x1ED9;
	  t['ocircumflexgrave'] = 0x1ED3;
	  t['ocircumflexhookabove'] = 0x1ED5;
	  t['ocircumflextilde'] = 0x1ED7;
	  t['ocyrillic'] = 0x043E;
	  t['odblacute'] = 0x0151;
	  t['odblgrave'] = 0x020D;
	  t['odeva'] = 0x0913;
	  t['odieresis'] = 0x00F6;
	  t['odieresiscyrillic'] = 0x04E7;
	  t['odotbelow'] = 0x1ECD;
	  t['oe'] = 0x0153;
	  t['oekorean'] = 0x315A;
	  t['ogonek'] = 0x02DB;
	  t['ogonekcmb'] = 0x0328;
	  t['ograve'] = 0x00F2;
	  t['ogujarati'] = 0x0A93;
	  t['oharmenian'] = 0x0585;
	  t['ohiragana'] = 0x304A;
	  t['ohookabove'] = 0x1ECF;
	  t['ohorn'] = 0x01A1;
	  t['ohornacute'] = 0x1EDB;
	  t['ohorndotbelow'] = 0x1EE3;
	  t['ohorngrave'] = 0x1EDD;
	  t['ohornhookabove'] = 0x1EDF;
	  t['ohorntilde'] = 0x1EE1;
	  t['ohungarumlaut'] = 0x0151;
	  t['oi'] = 0x01A3;
	  t['oinvertedbreve'] = 0x020F;
	  t['okatakana'] = 0x30AA;
	  t['okatakanahalfwidth'] = 0xFF75;
	  t['okorean'] = 0x3157;
	  t['olehebrew'] = 0x05AB;
	  t['omacron'] = 0x014D;
	  t['omacronacute'] = 0x1E53;
	  t['omacrongrave'] = 0x1E51;
	  t['omdeva'] = 0x0950;
	  t['omega'] = 0x03C9;
	  t['omega1'] = 0x03D6;
	  t['omegacyrillic'] = 0x0461;
	  t['omegalatinclosed'] = 0x0277;
	  t['omegaroundcyrillic'] = 0x047B;
	  t['omegatitlocyrillic'] = 0x047D;
	  t['omegatonos'] = 0x03CE;
	  t['omgujarati'] = 0x0AD0;
	  t['omicron'] = 0x03BF;
	  t['omicrontonos'] = 0x03CC;
	  t['omonospace'] = 0xFF4F;
	  t['one'] = 0x0031;
	  t['onearabic'] = 0x0661;
	  t['onebengali'] = 0x09E7;
	  t['onecircle'] = 0x2460;
	  t['onecircleinversesansserif'] = 0x278A;
	  t['onedeva'] = 0x0967;
	  t['onedotenleader'] = 0x2024;
	  t['oneeighth'] = 0x215B;
	  t['onefitted'] = 0xF6DC;
	  t['onegujarati'] = 0x0AE7;
	  t['onegurmukhi'] = 0x0A67;
	  t['onehackarabic'] = 0x0661;
	  t['onehalf'] = 0x00BD;
	  t['onehangzhou'] = 0x3021;
	  t['oneideographicparen'] = 0x3220;
	  t['oneinferior'] = 0x2081;
	  t['onemonospace'] = 0xFF11;
	  t['onenumeratorbengali'] = 0x09F4;
	  t['oneoldstyle'] = 0xF731;
	  t['oneparen'] = 0x2474;
	  t['oneperiod'] = 0x2488;
	  t['onepersian'] = 0x06F1;
	  t['onequarter'] = 0x00BC;
	  t['oneroman'] = 0x2170;
	  t['onesuperior'] = 0x00B9;
	  t['onethai'] = 0x0E51;
	  t['onethird'] = 0x2153;
	  t['oogonek'] = 0x01EB;
	  t['oogonekmacron'] = 0x01ED;
	  t['oogurmukhi'] = 0x0A13;
	  t['oomatragurmukhi'] = 0x0A4B;
	  t['oopen'] = 0x0254;
	  t['oparen'] = 0x24AA;
	  t['openbullet'] = 0x25E6;
	  t['option'] = 0x2325;
	  t['ordfeminine'] = 0x00AA;
	  t['ordmasculine'] = 0x00BA;
	  t['orthogonal'] = 0x221F;
	  t['oshortdeva'] = 0x0912;
	  t['oshortvowelsigndeva'] = 0x094A;
	  t['oslash'] = 0x00F8;
	  t['oslashacute'] = 0x01FF;
	  t['osmallhiragana'] = 0x3049;
	  t['osmallkatakana'] = 0x30A9;
	  t['osmallkatakanahalfwidth'] = 0xFF6B;
	  t['ostrokeacute'] = 0x01FF;
	  t['osuperior'] = 0xF6F0;
	  t['otcyrillic'] = 0x047F;
	  t['otilde'] = 0x00F5;
	  t['otildeacute'] = 0x1E4D;
	  t['otildedieresis'] = 0x1E4F;
	  t['oubopomofo'] = 0x3121;
	  t['overline'] = 0x203E;
	  t['overlinecenterline'] = 0xFE4A;
	  t['overlinecmb'] = 0x0305;
	  t['overlinedashed'] = 0xFE49;
	  t['overlinedblwavy'] = 0xFE4C;
	  t['overlinewavy'] = 0xFE4B;
	  t['overscore'] = 0x00AF;
	  t['ovowelsignbengali'] = 0x09CB;
	  t['ovowelsigndeva'] = 0x094B;
	  t['ovowelsigngujarati'] = 0x0ACB;
	  t['p'] = 0x0070;
	  t['paampssquare'] = 0x3380;
	  t['paasentosquare'] = 0x332B;
	  t['pabengali'] = 0x09AA;
	  t['pacute'] = 0x1E55;
	  t['padeva'] = 0x092A;
	  t['pagedown'] = 0x21DF;
	  t['pageup'] = 0x21DE;
	  t['pagujarati'] = 0x0AAA;
	  t['pagurmukhi'] = 0x0A2A;
	  t['pahiragana'] = 0x3071;
	  t['paiyannoithai'] = 0x0E2F;
	  t['pakatakana'] = 0x30D1;
	  t['palatalizationcyrilliccmb'] = 0x0484;
	  t['palochkacyrillic'] = 0x04C0;
	  t['pansioskorean'] = 0x317F;
	  t['paragraph'] = 0x00B6;
	  t['parallel'] = 0x2225;
	  t['parenleft'] = 0x0028;
	  t['parenleftaltonearabic'] = 0xFD3E;
	  t['parenleftbt'] = 0xF8ED;
	  t['parenleftex'] = 0xF8EC;
	  t['parenleftinferior'] = 0x208D;
	  t['parenleftmonospace'] = 0xFF08;
	  t['parenleftsmall'] = 0xFE59;
	  t['parenleftsuperior'] = 0x207D;
	  t['parenlefttp'] = 0xF8EB;
	  t['parenleftvertical'] = 0xFE35;
	  t['parenright'] = 0x0029;
	  t['parenrightaltonearabic'] = 0xFD3F;
	  t['parenrightbt'] = 0xF8F8;
	  t['parenrightex'] = 0xF8F7;
	  t['parenrightinferior'] = 0x208E;
	  t['parenrightmonospace'] = 0xFF09;
	  t['parenrightsmall'] = 0xFE5A;
	  t['parenrightsuperior'] = 0x207E;
	  t['parenrighttp'] = 0xF8F6;
	  t['parenrightvertical'] = 0xFE36;
	  t['partialdiff'] = 0x2202;
	  t['paseqhebrew'] = 0x05C0;
	  t['pashtahebrew'] = 0x0599;
	  t['pasquare'] = 0x33A9;
	  t['patah'] = 0x05B7;
	  t['patah11'] = 0x05B7;
	  t['patah1d'] = 0x05B7;
	  t['patah2a'] = 0x05B7;
	  t['patahhebrew'] = 0x05B7;
	  t['patahnarrowhebrew'] = 0x05B7;
	  t['patahquarterhebrew'] = 0x05B7;
	  t['patahwidehebrew'] = 0x05B7;
	  t['pazerhebrew'] = 0x05A1;
	  t['pbopomofo'] = 0x3106;
	  t['pcircle'] = 0x24DF;
	  t['pdotaccent'] = 0x1E57;
	  t['pe'] = 0x05E4;
	  t['pecyrillic'] = 0x043F;
	  t['pedagesh'] = 0xFB44;
	  t['pedageshhebrew'] = 0xFB44;
	  t['peezisquare'] = 0x333B;
	  t['pefinaldageshhebrew'] = 0xFB43;
	  t['peharabic'] = 0x067E;
	  t['peharmenian'] = 0x057A;
	  t['pehebrew'] = 0x05E4;
	  t['pehfinalarabic'] = 0xFB57;
	  t['pehinitialarabic'] = 0xFB58;
	  t['pehiragana'] = 0x307A;
	  t['pehmedialarabic'] = 0xFB59;
	  t['pekatakana'] = 0x30DA;
	  t['pemiddlehookcyrillic'] = 0x04A7;
	  t['perafehebrew'] = 0xFB4E;
	  t['percent'] = 0x0025;
	  t['percentarabic'] = 0x066A;
	  t['percentmonospace'] = 0xFF05;
	  t['percentsmall'] = 0xFE6A;
	  t['period'] = 0x002E;
	  t['periodarmenian'] = 0x0589;
	  t['periodcentered'] = 0x00B7;
	  t['periodhalfwidth'] = 0xFF61;
	  t['periodinferior'] = 0xF6E7;
	  t['periodmonospace'] = 0xFF0E;
	  t['periodsmall'] = 0xFE52;
	  t['periodsuperior'] = 0xF6E8;
	  t['perispomenigreekcmb'] = 0x0342;
	  t['perpendicular'] = 0x22A5;
	  t['perthousand'] = 0x2030;
	  t['peseta'] = 0x20A7;
	  t['pfsquare'] = 0x338A;
	  t['phabengali'] = 0x09AB;
	  t['phadeva'] = 0x092B;
	  t['phagujarati'] = 0x0AAB;
	  t['phagurmukhi'] = 0x0A2B;
	  t['phi'] = 0x03C6;
	  t['phi1'] = 0x03D5;
	  t['phieuphacirclekorean'] = 0x327A;
	  t['phieuphaparenkorean'] = 0x321A;
	  t['phieuphcirclekorean'] = 0x326C;
	  t['phieuphkorean'] = 0x314D;
	  t['phieuphparenkorean'] = 0x320C;
	  t['philatin'] = 0x0278;
	  t['phinthuthai'] = 0x0E3A;
	  t['phisymbolgreek'] = 0x03D5;
	  t['phook'] = 0x01A5;
	  t['phophanthai'] = 0x0E1E;
	  t['phophungthai'] = 0x0E1C;
	  t['phosamphaothai'] = 0x0E20;
	  t['pi'] = 0x03C0;
	  t['pieupacirclekorean'] = 0x3273;
	  t['pieupaparenkorean'] = 0x3213;
	  t['pieupcieuckorean'] = 0x3176;
	  t['pieupcirclekorean'] = 0x3265;
	  t['pieupkiyeokkorean'] = 0x3172;
	  t['pieupkorean'] = 0x3142;
	  t['pieupparenkorean'] = 0x3205;
	  t['pieupsioskiyeokkorean'] = 0x3174;
	  t['pieupsioskorean'] = 0x3144;
	  t['pieupsiostikeutkorean'] = 0x3175;
	  t['pieupthieuthkorean'] = 0x3177;
	  t['pieuptikeutkorean'] = 0x3173;
	  t['pihiragana'] = 0x3074;
	  t['pikatakana'] = 0x30D4;
	  t['pisymbolgreek'] = 0x03D6;
	  t['piwrarmenian'] = 0x0583;
	  t['plus'] = 0x002B;
	  t['plusbelowcmb'] = 0x031F;
	  t['pluscircle'] = 0x2295;
	  t['plusminus'] = 0x00B1;
	  t['plusmod'] = 0x02D6;
	  t['plusmonospace'] = 0xFF0B;
	  t['plussmall'] = 0xFE62;
	  t['plussuperior'] = 0x207A;
	  t['pmonospace'] = 0xFF50;
	  t['pmsquare'] = 0x33D8;
	  t['pohiragana'] = 0x307D;
	  t['pointingindexdownwhite'] = 0x261F;
	  t['pointingindexleftwhite'] = 0x261C;
	  t['pointingindexrightwhite'] = 0x261E;
	  t['pointingindexupwhite'] = 0x261D;
	  t['pokatakana'] = 0x30DD;
	  t['poplathai'] = 0x0E1B;
	  t['postalmark'] = 0x3012;
	  t['postalmarkface'] = 0x3020;
	  t['pparen'] = 0x24AB;
	  t['precedes'] = 0x227A;
	  t['prescription'] = 0x211E;
	  t['primemod'] = 0x02B9;
	  t['primereversed'] = 0x2035;
	  t['product'] = 0x220F;
	  t['projective'] = 0x2305;
	  t['prolongedkana'] = 0x30FC;
	  t['propellor'] = 0x2318;
	  t['propersubset'] = 0x2282;
	  t['propersuperset'] = 0x2283;
	  t['proportion'] = 0x2237;
	  t['proportional'] = 0x221D;
	  t['psi'] = 0x03C8;
	  t['psicyrillic'] = 0x0471;
	  t['psilipneumatacyrilliccmb'] = 0x0486;
	  t['pssquare'] = 0x33B0;
	  t['puhiragana'] = 0x3077;
	  t['pukatakana'] = 0x30D7;
	  t['pvsquare'] = 0x33B4;
	  t['pwsquare'] = 0x33BA;
	  t['q'] = 0x0071;
	  t['qadeva'] = 0x0958;
	  t['qadmahebrew'] = 0x05A8;
	  t['qafarabic'] = 0x0642;
	  t['qaffinalarabic'] = 0xFED6;
	  t['qafinitialarabic'] = 0xFED7;
	  t['qafmedialarabic'] = 0xFED8;
	  t['qamats'] = 0x05B8;
	  t['qamats10'] = 0x05B8;
	  t['qamats1a'] = 0x05B8;
	  t['qamats1c'] = 0x05B8;
	  t['qamats27'] = 0x05B8;
	  t['qamats29'] = 0x05B8;
	  t['qamats33'] = 0x05B8;
	  t['qamatsde'] = 0x05B8;
	  t['qamatshebrew'] = 0x05B8;
	  t['qamatsnarrowhebrew'] = 0x05B8;
	  t['qamatsqatanhebrew'] = 0x05B8;
	  t['qamatsqatannarrowhebrew'] = 0x05B8;
	  t['qamatsqatanquarterhebrew'] = 0x05B8;
	  t['qamatsqatanwidehebrew'] = 0x05B8;
	  t['qamatsquarterhebrew'] = 0x05B8;
	  t['qamatswidehebrew'] = 0x05B8;
	  t['qarneyparahebrew'] = 0x059F;
	  t['qbopomofo'] = 0x3111;
	  t['qcircle'] = 0x24E0;
	  t['qhook'] = 0x02A0;
	  t['qmonospace'] = 0xFF51;
	  t['qof'] = 0x05E7;
	  t['qofdagesh'] = 0xFB47;
	  t['qofdageshhebrew'] = 0xFB47;
	  t['qofhebrew'] = 0x05E7;
	  t['qparen'] = 0x24AC;
	  t['quarternote'] = 0x2669;
	  t['qubuts'] = 0x05BB;
	  t['qubuts18'] = 0x05BB;
	  t['qubuts25'] = 0x05BB;
	  t['qubuts31'] = 0x05BB;
	  t['qubutshebrew'] = 0x05BB;
	  t['qubutsnarrowhebrew'] = 0x05BB;
	  t['qubutsquarterhebrew'] = 0x05BB;
	  t['qubutswidehebrew'] = 0x05BB;
	  t['question'] = 0x003F;
	  t['questionarabic'] = 0x061F;
	  t['questionarmenian'] = 0x055E;
	  t['questiondown'] = 0x00BF;
	  t['questiondownsmall'] = 0xF7BF;
	  t['questiongreek'] = 0x037E;
	  t['questionmonospace'] = 0xFF1F;
	  t['questionsmall'] = 0xF73F;
	  t['quotedbl'] = 0x0022;
	  t['quotedblbase'] = 0x201E;
	  t['quotedblleft'] = 0x201C;
	  t['quotedblmonospace'] = 0xFF02;
	  t['quotedblprime'] = 0x301E;
	  t['quotedblprimereversed'] = 0x301D;
	  t['quotedblright'] = 0x201D;
	  t['quoteleft'] = 0x2018;
	  t['quoteleftreversed'] = 0x201B;
	  t['quotereversed'] = 0x201B;
	  t['quoteright'] = 0x2019;
	  t['quoterightn'] = 0x0149;
	  t['quotesinglbase'] = 0x201A;
	  t['quotesingle'] = 0x0027;
	  t['quotesinglemonospace'] = 0xFF07;
	  t['r'] = 0x0072;
	  t['raarmenian'] = 0x057C;
	  t['rabengali'] = 0x09B0;
	  t['racute'] = 0x0155;
	  t['radeva'] = 0x0930;
	  t['radical'] = 0x221A;
	  t['radicalex'] = 0xF8E5;
	  t['radoverssquare'] = 0x33AE;
	  t['radoverssquaredsquare'] = 0x33AF;
	  t['radsquare'] = 0x33AD;
	  t['rafe'] = 0x05BF;
	  t['rafehebrew'] = 0x05BF;
	  t['ragujarati'] = 0x0AB0;
	  t['ragurmukhi'] = 0x0A30;
	  t['rahiragana'] = 0x3089;
	  t['rakatakana'] = 0x30E9;
	  t['rakatakanahalfwidth'] = 0xFF97;
	  t['ralowerdiagonalbengali'] = 0x09F1;
	  t['ramiddlediagonalbengali'] = 0x09F0;
	  t['ramshorn'] = 0x0264;
	  t['ratio'] = 0x2236;
	  t['rbopomofo'] = 0x3116;
	  t['rcaron'] = 0x0159;
	  t['rcedilla'] = 0x0157;
	  t['rcircle'] = 0x24E1;
	  t['rcommaaccent'] = 0x0157;
	  t['rdblgrave'] = 0x0211;
	  t['rdotaccent'] = 0x1E59;
	  t['rdotbelow'] = 0x1E5B;
	  t['rdotbelowmacron'] = 0x1E5D;
	  t['referencemark'] = 0x203B;
	  t['reflexsubset'] = 0x2286;
	  t['reflexsuperset'] = 0x2287;
	  t['registered'] = 0x00AE;
	  t['registersans'] = 0xF8E8;
	  t['registerserif'] = 0xF6DA;
	  t['reharabic'] = 0x0631;
	  t['reharmenian'] = 0x0580;
	  t['rehfinalarabic'] = 0xFEAE;
	  t['rehiragana'] = 0x308C;
	  t['rekatakana'] = 0x30EC;
	  t['rekatakanahalfwidth'] = 0xFF9A;
	  t['resh'] = 0x05E8;
	  t['reshdageshhebrew'] = 0xFB48;
	  t['reshhebrew'] = 0x05E8;
	  t['reversedtilde'] = 0x223D;
	  t['reviahebrew'] = 0x0597;
	  t['reviamugrashhebrew'] = 0x0597;
	  t['revlogicalnot'] = 0x2310;
	  t['rfishhook'] = 0x027E;
	  t['rfishhookreversed'] = 0x027F;
	  t['rhabengali'] = 0x09DD;
	  t['rhadeva'] = 0x095D;
	  t['rho'] = 0x03C1;
	  t['rhook'] = 0x027D;
	  t['rhookturned'] = 0x027B;
	  t['rhookturnedsuperior'] = 0x02B5;
	  t['rhosymbolgreek'] = 0x03F1;
	  t['rhotichookmod'] = 0x02DE;
	  t['rieulacirclekorean'] = 0x3271;
	  t['rieulaparenkorean'] = 0x3211;
	  t['rieulcirclekorean'] = 0x3263;
	  t['rieulhieuhkorean'] = 0x3140;
	  t['rieulkiyeokkorean'] = 0x313A;
	  t['rieulkiyeoksioskorean'] = 0x3169;
	  t['rieulkorean'] = 0x3139;
	  t['rieulmieumkorean'] = 0x313B;
	  t['rieulpansioskorean'] = 0x316C;
	  t['rieulparenkorean'] = 0x3203;
	  t['rieulphieuphkorean'] = 0x313F;
	  t['rieulpieupkorean'] = 0x313C;
	  t['rieulpieupsioskorean'] = 0x316B;
	  t['rieulsioskorean'] = 0x313D;
	  t['rieulthieuthkorean'] = 0x313E;
	  t['rieultikeutkorean'] = 0x316A;
	  t['rieulyeorinhieuhkorean'] = 0x316D;
	  t['rightangle'] = 0x221F;
	  t['righttackbelowcmb'] = 0x0319;
	  t['righttriangle'] = 0x22BF;
	  t['rihiragana'] = 0x308A;
	  t['rikatakana'] = 0x30EA;
	  t['rikatakanahalfwidth'] = 0xFF98;
	  t['ring'] = 0x02DA;
	  t['ringbelowcmb'] = 0x0325;
	  t['ringcmb'] = 0x030A;
	  t['ringhalfleft'] = 0x02BF;
	  t['ringhalfleftarmenian'] = 0x0559;
	  t['ringhalfleftbelowcmb'] = 0x031C;
	  t['ringhalfleftcentered'] = 0x02D3;
	  t['ringhalfright'] = 0x02BE;
	  t['ringhalfrightbelowcmb'] = 0x0339;
	  t['ringhalfrightcentered'] = 0x02D2;
	  t['rinvertedbreve'] = 0x0213;
	  t['rittorusquare'] = 0x3351;
	  t['rlinebelow'] = 0x1E5F;
	  t['rlongleg'] = 0x027C;
	  t['rlonglegturned'] = 0x027A;
	  t['rmonospace'] = 0xFF52;
	  t['rohiragana'] = 0x308D;
	  t['rokatakana'] = 0x30ED;
	  t['rokatakanahalfwidth'] = 0xFF9B;
	  t['roruathai'] = 0x0E23;
	  t['rparen'] = 0x24AD;
	  t['rrabengali'] = 0x09DC;
	  t['rradeva'] = 0x0931;
	  t['rragurmukhi'] = 0x0A5C;
	  t['rreharabic'] = 0x0691;
	  t['rrehfinalarabic'] = 0xFB8D;
	  t['rrvocalicbengali'] = 0x09E0;
	  t['rrvocalicdeva'] = 0x0960;
	  t['rrvocalicgujarati'] = 0x0AE0;
	  t['rrvocalicvowelsignbengali'] = 0x09C4;
	  t['rrvocalicvowelsigndeva'] = 0x0944;
	  t['rrvocalicvowelsigngujarati'] = 0x0AC4;
	  t['rsuperior'] = 0xF6F1;
	  t['rtblock'] = 0x2590;
	  t['rturned'] = 0x0279;
	  t['rturnedsuperior'] = 0x02B4;
	  t['ruhiragana'] = 0x308B;
	  t['rukatakana'] = 0x30EB;
	  t['rukatakanahalfwidth'] = 0xFF99;
	  t['rupeemarkbengali'] = 0x09F2;
	  t['rupeesignbengali'] = 0x09F3;
	  t['rupiah'] = 0xF6DD;
	  t['ruthai'] = 0x0E24;
	  t['rvocalicbengali'] = 0x098B;
	  t['rvocalicdeva'] = 0x090B;
	  t['rvocalicgujarati'] = 0x0A8B;
	  t['rvocalicvowelsignbengali'] = 0x09C3;
	  t['rvocalicvowelsigndeva'] = 0x0943;
	  t['rvocalicvowelsigngujarati'] = 0x0AC3;
	  t['s'] = 0x0073;
	  t['sabengali'] = 0x09B8;
	  t['sacute'] = 0x015B;
	  t['sacutedotaccent'] = 0x1E65;
	  t['sadarabic'] = 0x0635;
	  t['sadeva'] = 0x0938;
	  t['sadfinalarabic'] = 0xFEBA;
	  t['sadinitialarabic'] = 0xFEBB;
	  t['sadmedialarabic'] = 0xFEBC;
	  t['sagujarati'] = 0x0AB8;
	  t['sagurmukhi'] = 0x0A38;
	  t['sahiragana'] = 0x3055;
	  t['sakatakana'] = 0x30B5;
	  t['sakatakanahalfwidth'] = 0xFF7B;
	  t['sallallahoualayhewasallamarabic'] = 0xFDFA;
	  t['samekh'] = 0x05E1;
	  t['samekhdagesh'] = 0xFB41;
	  t['samekhdageshhebrew'] = 0xFB41;
	  t['samekhhebrew'] = 0x05E1;
	  t['saraaathai'] = 0x0E32;
	  t['saraaethai'] = 0x0E41;
	  t['saraaimaimalaithai'] = 0x0E44;
	  t['saraaimaimuanthai'] = 0x0E43;
	  t['saraamthai'] = 0x0E33;
	  t['saraathai'] = 0x0E30;
	  t['saraethai'] = 0x0E40;
	  t['saraiileftthai'] = 0xF886;
	  t['saraiithai'] = 0x0E35;
	  t['saraileftthai'] = 0xF885;
	  t['saraithai'] = 0x0E34;
	  t['saraothai'] = 0x0E42;
	  t['saraueeleftthai'] = 0xF888;
	  t['saraueethai'] = 0x0E37;
	  t['saraueleftthai'] = 0xF887;
	  t['sarauethai'] = 0x0E36;
	  t['sarauthai'] = 0x0E38;
	  t['sarauuthai'] = 0x0E39;
	  t['sbopomofo'] = 0x3119;
	  t['scaron'] = 0x0161;
	  t['scarondotaccent'] = 0x1E67;
	  t['scedilla'] = 0x015F;
	  t['schwa'] = 0x0259;
	  t['schwacyrillic'] = 0x04D9;
	  t['schwadieresiscyrillic'] = 0x04DB;
	  t['schwahook'] = 0x025A;
	  t['scircle'] = 0x24E2;
	  t['scircumflex'] = 0x015D;
	  t['scommaaccent'] = 0x0219;
	  t['sdotaccent'] = 0x1E61;
	  t['sdotbelow'] = 0x1E63;
	  t['sdotbelowdotaccent'] = 0x1E69;
	  t['seagullbelowcmb'] = 0x033C;
	  t['second'] = 0x2033;
	  t['secondtonechinese'] = 0x02CA;
	  t['section'] = 0x00A7;
	  t['seenarabic'] = 0x0633;
	  t['seenfinalarabic'] = 0xFEB2;
	  t['seeninitialarabic'] = 0xFEB3;
	  t['seenmedialarabic'] = 0xFEB4;
	  t['segol'] = 0x05B6;
	  t['segol13'] = 0x05B6;
	  t['segol1f'] = 0x05B6;
	  t['segol2c'] = 0x05B6;
	  t['segolhebrew'] = 0x05B6;
	  t['segolnarrowhebrew'] = 0x05B6;
	  t['segolquarterhebrew'] = 0x05B6;
	  t['segoltahebrew'] = 0x0592;
	  t['segolwidehebrew'] = 0x05B6;
	  t['seharmenian'] = 0x057D;
	  t['sehiragana'] = 0x305B;
	  t['sekatakana'] = 0x30BB;
	  t['sekatakanahalfwidth'] = 0xFF7E;
	  t['semicolon'] = 0x003B;
	  t['semicolonarabic'] = 0x061B;
	  t['semicolonmonospace'] = 0xFF1B;
	  t['semicolonsmall'] = 0xFE54;
	  t['semivoicedmarkkana'] = 0x309C;
	  t['semivoicedmarkkanahalfwidth'] = 0xFF9F;
	  t['sentisquare'] = 0x3322;
	  t['sentosquare'] = 0x3323;
	  t['seven'] = 0x0037;
	  t['sevenarabic'] = 0x0667;
	  t['sevenbengali'] = 0x09ED;
	  t['sevencircle'] = 0x2466;
	  t['sevencircleinversesansserif'] = 0x2790;
	  t['sevendeva'] = 0x096D;
	  t['seveneighths'] = 0x215E;
	  t['sevengujarati'] = 0x0AED;
	  t['sevengurmukhi'] = 0x0A6D;
	  t['sevenhackarabic'] = 0x0667;
	  t['sevenhangzhou'] = 0x3027;
	  t['sevenideographicparen'] = 0x3226;
	  t['seveninferior'] = 0x2087;
	  t['sevenmonospace'] = 0xFF17;
	  t['sevenoldstyle'] = 0xF737;
	  t['sevenparen'] = 0x247A;
	  t['sevenperiod'] = 0x248E;
	  t['sevenpersian'] = 0x06F7;
	  t['sevenroman'] = 0x2176;
	  t['sevensuperior'] = 0x2077;
	  t['seventeencircle'] = 0x2470;
	  t['seventeenparen'] = 0x2484;
	  t['seventeenperiod'] = 0x2498;
	  t['seventhai'] = 0x0E57;
	  t['sfthyphen'] = 0x00AD;
	  t['shaarmenian'] = 0x0577;
	  t['shabengali'] = 0x09B6;
	  t['shacyrillic'] = 0x0448;
	  t['shaddaarabic'] = 0x0651;
	  t['shaddadammaarabic'] = 0xFC61;
	  t['shaddadammatanarabic'] = 0xFC5E;
	  t['shaddafathaarabic'] = 0xFC60;
	  t['shaddakasraarabic'] = 0xFC62;
	  t['shaddakasratanarabic'] = 0xFC5F;
	  t['shade'] = 0x2592;
	  t['shadedark'] = 0x2593;
	  t['shadelight'] = 0x2591;
	  t['shademedium'] = 0x2592;
	  t['shadeva'] = 0x0936;
	  t['shagujarati'] = 0x0AB6;
	  t['shagurmukhi'] = 0x0A36;
	  t['shalshelethebrew'] = 0x0593;
	  t['shbopomofo'] = 0x3115;
	  t['shchacyrillic'] = 0x0449;
	  t['sheenarabic'] = 0x0634;
	  t['sheenfinalarabic'] = 0xFEB6;
	  t['sheeninitialarabic'] = 0xFEB7;
	  t['sheenmedialarabic'] = 0xFEB8;
	  t['sheicoptic'] = 0x03E3;
	  t['sheqel'] = 0x20AA;
	  t['sheqelhebrew'] = 0x20AA;
	  t['sheva'] = 0x05B0;
	  t['sheva115'] = 0x05B0;
	  t['sheva15'] = 0x05B0;
	  t['sheva22'] = 0x05B0;
	  t['sheva2e'] = 0x05B0;
	  t['shevahebrew'] = 0x05B0;
	  t['shevanarrowhebrew'] = 0x05B0;
	  t['shevaquarterhebrew'] = 0x05B0;
	  t['shevawidehebrew'] = 0x05B0;
	  t['shhacyrillic'] = 0x04BB;
	  t['shimacoptic'] = 0x03ED;
	  t['shin'] = 0x05E9;
	  t['shindagesh'] = 0xFB49;
	  t['shindageshhebrew'] = 0xFB49;
	  t['shindageshshindot'] = 0xFB2C;
	  t['shindageshshindothebrew'] = 0xFB2C;
	  t['shindageshsindot'] = 0xFB2D;
	  t['shindageshsindothebrew'] = 0xFB2D;
	  t['shindothebrew'] = 0x05C1;
	  t['shinhebrew'] = 0x05E9;
	  t['shinshindot'] = 0xFB2A;
	  t['shinshindothebrew'] = 0xFB2A;
	  t['shinsindot'] = 0xFB2B;
	  t['shinsindothebrew'] = 0xFB2B;
	  t['shook'] = 0x0282;
	  t['sigma'] = 0x03C3;
	  t['sigma1'] = 0x03C2;
	  t['sigmafinal'] = 0x03C2;
	  t['sigmalunatesymbolgreek'] = 0x03F2;
	  t['sihiragana'] = 0x3057;
	  t['sikatakana'] = 0x30B7;
	  t['sikatakanahalfwidth'] = 0xFF7C;
	  t['siluqhebrew'] = 0x05BD;
	  t['siluqlefthebrew'] = 0x05BD;
	  t['similar'] = 0x223C;
	  t['sindothebrew'] = 0x05C2;
	  t['siosacirclekorean'] = 0x3274;
	  t['siosaparenkorean'] = 0x3214;
	  t['sioscieuckorean'] = 0x317E;
	  t['sioscirclekorean'] = 0x3266;
	  t['sioskiyeokkorean'] = 0x317A;
	  t['sioskorean'] = 0x3145;
	  t['siosnieunkorean'] = 0x317B;
	  t['siosparenkorean'] = 0x3206;
	  t['siospieupkorean'] = 0x317D;
	  t['siostikeutkorean'] = 0x317C;
	  t['six'] = 0x0036;
	  t['sixarabic'] = 0x0666;
	  t['sixbengali'] = 0x09EC;
	  t['sixcircle'] = 0x2465;
	  t['sixcircleinversesansserif'] = 0x278F;
	  t['sixdeva'] = 0x096C;
	  t['sixgujarati'] = 0x0AEC;
	  t['sixgurmukhi'] = 0x0A6C;
	  t['sixhackarabic'] = 0x0666;
	  t['sixhangzhou'] = 0x3026;
	  t['sixideographicparen'] = 0x3225;
	  t['sixinferior'] = 0x2086;
	  t['sixmonospace'] = 0xFF16;
	  t['sixoldstyle'] = 0xF736;
	  t['sixparen'] = 0x2479;
	  t['sixperiod'] = 0x248D;
	  t['sixpersian'] = 0x06F6;
	  t['sixroman'] = 0x2175;
	  t['sixsuperior'] = 0x2076;
	  t['sixteencircle'] = 0x246F;
	  t['sixteencurrencydenominatorbengali'] = 0x09F9;
	  t['sixteenparen'] = 0x2483;
	  t['sixteenperiod'] = 0x2497;
	  t['sixthai'] = 0x0E56;
	  t['slash'] = 0x002F;
	  t['slashmonospace'] = 0xFF0F;
	  t['slong'] = 0x017F;
	  t['slongdotaccent'] = 0x1E9B;
	  t['smileface'] = 0x263A;
	  t['smonospace'] = 0xFF53;
	  t['sofpasuqhebrew'] = 0x05C3;
	  t['softhyphen'] = 0x00AD;
	  t['softsigncyrillic'] = 0x044C;
	  t['sohiragana'] = 0x305D;
	  t['sokatakana'] = 0x30BD;
	  t['sokatakanahalfwidth'] = 0xFF7F;
	  t['soliduslongoverlaycmb'] = 0x0338;
	  t['solidusshortoverlaycmb'] = 0x0337;
	  t['sorusithai'] = 0x0E29;
	  t['sosalathai'] = 0x0E28;
	  t['sosothai'] = 0x0E0B;
	  t['sosuathai'] = 0x0E2A;
	  t['space'] = 0x0020;
	  t['spacehackarabic'] = 0x0020;
	  t['spade'] = 0x2660;
	  t['spadesuitblack'] = 0x2660;
	  t['spadesuitwhite'] = 0x2664;
	  t['sparen'] = 0x24AE;
	  t['squarebelowcmb'] = 0x033B;
	  t['squarecc'] = 0x33C4;
	  t['squarecm'] = 0x339D;
	  t['squarediagonalcrosshatchfill'] = 0x25A9;
	  t['squarehorizontalfill'] = 0x25A4;
	  t['squarekg'] = 0x338F;
	  t['squarekm'] = 0x339E;
	  t['squarekmcapital'] = 0x33CE;
	  t['squareln'] = 0x33D1;
	  t['squarelog'] = 0x33D2;
	  t['squaremg'] = 0x338E;
	  t['squaremil'] = 0x33D5;
	  t['squaremm'] = 0x339C;
	  t['squaremsquared'] = 0x33A1;
	  t['squareorthogonalcrosshatchfill'] = 0x25A6;
	  t['squareupperlefttolowerrightfill'] = 0x25A7;
	  t['squareupperrighttolowerleftfill'] = 0x25A8;
	  t['squareverticalfill'] = 0x25A5;
	  t['squarewhitewithsmallblack'] = 0x25A3;
	  t['srsquare'] = 0x33DB;
	  t['ssabengali'] = 0x09B7;
	  t['ssadeva'] = 0x0937;
	  t['ssagujarati'] = 0x0AB7;
	  t['ssangcieuckorean'] = 0x3149;
	  t['ssanghieuhkorean'] = 0x3185;
	  t['ssangieungkorean'] = 0x3180;
	  t['ssangkiyeokkorean'] = 0x3132;
	  t['ssangnieunkorean'] = 0x3165;
	  t['ssangpieupkorean'] = 0x3143;
	  t['ssangsioskorean'] = 0x3146;
	  t['ssangtikeutkorean'] = 0x3138;
	  t['ssuperior'] = 0xF6F2;
	  t['sterling'] = 0x00A3;
	  t['sterlingmonospace'] = 0xFFE1;
	  t['strokelongoverlaycmb'] = 0x0336;
	  t['strokeshortoverlaycmb'] = 0x0335;
	  t['subset'] = 0x2282;
	  t['subsetnotequal'] = 0x228A;
	  t['subsetorequal'] = 0x2286;
	  t['succeeds'] = 0x227B;
	  t['suchthat'] = 0x220B;
	  t['suhiragana'] = 0x3059;
	  t['sukatakana'] = 0x30B9;
	  t['sukatakanahalfwidth'] = 0xFF7D;
	  t['sukunarabic'] = 0x0652;
	  t['summation'] = 0x2211;
	  t['sun'] = 0x263C;
	  t['superset'] = 0x2283;
	  t['supersetnotequal'] = 0x228B;
	  t['supersetorequal'] = 0x2287;
	  t['svsquare'] = 0x33DC;
	  t['syouwaerasquare'] = 0x337C;
	  t['t'] = 0x0074;
	  t['tabengali'] = 0x09A4;
	  t['tackdown'] = 0x22A4;
	  t['tackleft'] = 0x22A3;
	  t['tadeva'] = 0x0924;
	  t['tagujarati'] = 0x0AA4;
	  t['tagurmukhi'] = 0x0A24;
	  t['taharabic'] = 0x0637;
	  t['tahfinalarabic'] = 0xFEC2;
	  t['tahinitialarabic'] = 0xFEC3;
	  t['tahiragana'] = 0x305F;
	  t['tahmedialarabic'] = 0xFEC4;
	  t['taisyouerasquare'] = 0x337D;
	  t['takatakana'] = 0x30BF;
	  t['takatakanahalfwidth'] = 0xFF80;
	  t['tatweelarabic'] = 0x0640;
	  t['tau'] = 0x03C4;
	  t['tav'] = 0x05EA;
	  t['tavdages'] = 0xFB4A;
	  t['tavdagesh'] = 0xFB4A;
	  t['tavdageshhebrew'] = 0xFB4A;
	  t['tavhebrew'] = 0x05EA;
	  t['tbar'] = 0x0167;
	  t['tbopomofo'] = 0x310A;
	  t['tcaron'] = 0x0165;
	  t['tccurl'] = 0x02A8;
	  t['tcedilla'] = 0x0163;
	  t['tcheharabic'] = 0x0686;
	  t['tchehfinalarabic'] = 0xFB7B;
	  t['tchehinitialarabic'] = 0xFB7C;
	  t['tchehmedialarabic'] = 0xFB7D;
	  t['tcircle'] = 0x24E3;
	  t['tcircumflexbelow'] = 0x1E71;
	  t['tcommaaccent'] = 0x0163;
	  t['tdieresis'] = 0x1E97;
	  t['tdotaccent'] = 0x1E6B;
	  t['tdotbelow'] = 0x1E6D;
	  t['tecyrillic'] = 0x0442;
	  t['tedescendercyrillic'] = 0x04AD;
	  t['teharabic'] = 0x062A;
	  t['tehfinalarabic'] = 0xFE96;
	  t['tehhahinitialarabic'] = 0xFCA2;
	  t['tehhahisolatedarabic'] = 0xFC0C;
	  t['tehinitialarabic'] = 0xFE97;
	  t['tehiragana'] = 0x3066;
	  t['tehjeeminitialarabic'] = 0xFCA1;
	  t['tehjeemisolatedarabic'] = 0xFC0B;
	  t['tehmarbutaarabic'] = 0x0629;
	  t['tehmarbutafinalarabic'] = 0xFE94;
	  t['tehmedialarabic'] = 0xFE98;
	  t['tehmeeminitialarabic'] = 0xFCA4;
	  t['tehmeemisolatedarabic'] = 0xFC0E;
	  t['tehnoonfinalarabic'] = 0xFC73;
	  t['tekatakana'] = 0x30C6;
	  t['tekatakanahalfwidth'] = 0xFF83;
	  t['telephone'] = 0x2121;
	  t['telephoneblack'] = 0x260E;
	  t['telishagedolahebrew'] = 0x05A0;
	  t['telishaqetanahebrew'] = 0x05A9;
	  t['tencircle'] = 0x2469;
	  t['tenideographicparen'] = 0x3229;
	  t['tenparen'] = 0x247D;
	  t['tenperiod'] = 0x2491;
	  t['tenroman'] = 0x2179;
	  t['tesh'] = 0x02A7;
	  t['tet'] = 0x05D8;
	  t['tetdagesh'] = 0xFB38;
	  t['tetdageshhebrew'] = 0xFB38;
	  t['tethebrew'] = 0x05D8;
	  t['tetsecyrillic'] = 0x04B5;
	  t['tevirhebrew'] = 0x059B;
	  t['tevirlefthebrew'] = 0x059B;
	  t['thabengali'] = 0x09A5;
	  t['thadeva'] = 0x0925;
	  t['thagujarati'] = 0x0AA5;
	  t['thagurmukhi'] = 0x0A25;
	  t['thalarabic'] = 0x0630;
	  t['thalfinalarabic'] = 0xFEAC;
	  t['thanthakhatlowleftthai'] = 0xF898;
	  t['thanthakhatlowrightthai'] = 0xF897;
	  t['thanthakhatthai'] = 0x0E4C;
	  t['thanthakhatupperleftthai'] = 0xF896;
	  t['theharabic'] = 0x062B;
	  t['thehfinalarabic'] = 0xFE9A;
	  t['thehinitialarabic'] = 0xFE9B;
	  t['thehmedialarabic'] = 0xFE9C;
	  t['thereexists'] = 0x2203;
	  t['therefore'] = 0x2234;
	  t['theta'] = 0x03B8;
	  t['theta1'] = 0x03D1;
	  t['thetasymbolgreek'] = 0x03D1;
	  t['thieuthacirclekorean'] = 0x3279;
	  t['thieuthaparenkorean'] = 0x3219;
	  t['thieuthcirclekorean'] = 0x326B;
	  t['thieuthkorean'] = 0x314C;
	  t['thieuthparenkorean'] = 0x320B;
	  t['thirteencircle'] = 0x246C;
	  t['thirteenparen'] = 0x2480;
	  t['thirteenperiod'] = 0x2494;
	  t['thonangmonthothai'] = 0x0E11;
	  t['thook'] = 0x01AD;
	  t['thophuthaothai'] = 0x0E12;
	  t['thorn'] = 0x00FE;
	  t['thothahanthai'] = 0x0E17;
	  t['thothanthai'] = 0x0E10;
	  t['thothongthai'] = 0x0E18;
	  t['thothungthai'] = 0x0E16;
	  t['thousandcyrillic'] = 0x0482;
	  t['thousandsseparatorarabic'] = 0x066C;
	  t['thousandsseparatorpersian'] = 0x066C;
	  t['three'] = 0x0033;
	  t['threearabic'] = 0x0663;
	  t['threebengali'] = 0x09E9;
	  t['threecircle'] = 0x2462;
	  t['threecircleinversesansserif'] = 0x278C;
	  t['threedeva'] = 0x0969;
	  t['threeeighths'] = 0x215C;
	  t['threegujarati'] = 0x0AE9;
	  t['threegurmukhi'] = 0x0A69;
	  t['threehackarabic'] = 0x0663;
	  t['threehangzhou'] = 0x3023;
	  t['threeideographicparen'] = 0x3222;
	  t['threeinferior'] = 0x2083;
	  t['threemonospace'] = 0xFF13;
	  t['threenumeratorbengali'] = 0x09F6;
	  t['threeoldstyle'] = 0xF733;
	  t['threeparen'] = 0x2476;
	  t['threeperiod'] = 0x248A;
	  t['threepersian'] = 0x06F3;
	  t['threequarters'] = 0x00BE;
	  t['threequartersemdash'] = 0xF6DE;
	  t['threeroman'] = 0x2172;
	  t['threesuperior'] = 0x00B3;
	  t['threethai'] = 0x0E53;
	  t['thzsquare'] = 0x3394;
	  t['tihiragana'] = 0x3061;
	  t['tikatakana'] = 0x30C1;
	  t['tikatakanahalfwidth'] = 0xFF81;
	  t['tikeutacirclekorean'] = 0x3270;
	  t['tikeutaparenkorean'] = 0x3210;
	  t['tikeutcirclekorean'] = 0x3262;
	  t['tikeutkorean'] = 0x3137;
	  t['tikeutparenkorean'] = 0x3202;
	  t['tilde'] = 0x02DC;
	  t['tildebelowcmb'] = 0x0330;
	  t['tildecmb'] = 0x0303;
	  t['tildecomb'] = 0x0303;
	  t['tildedoublecmb'] = 0x0360;
	  t['tildeoperator'] = 0x223C;
	  t['tildeoverlaycmb'] = 0x0334;
	  t['tildeverticalcmb'] = 0x033E;
	  t['timescircle'] = 0x2297;
	  t['tipehahebrew'] = 0x0596;
	  t['tipehalefthebrew'] = 0x0596;
	  t['tippigurmukhi'] = 0x0A70;
	  t['titlocyrilliccmb'] = 0x0483;
	  t['tiwnarmenian'] = 0x057F;
	  t['tlinebelow'] = 0x1E6F;
	  t['tmonospace'] = 0xFF54;
	  t['toarmenian'] = 0x0569;
	  t['tohiragana'] = 0x3068;
	  t['tokatakana'] = 0x30C8;
	  t['tokatakanahalfwidth'] = 0xFF84;
	  t['tonebarextrahighmod'] = 0x02E5;
	  t['tonebarextralowmod'] = 0x02E9;
	  t['tonebarhighmod'] = 0x02E6;
	  t['tonebarlowmod'] = 0x02E8;
	  t['tonebarmidmod'] = 0x02E7;
	  t['tonefive'] = 0x01BD;
	  t['tonesix'] = 0x0185;
	  t['tonetwo'] = 0x01A8;
	  t['tonos'] = 0x0384;
	  t['tonsquare'] = 0x3327;
	  t['topatakthai'] = 0x0E0F;
	  t['tortoiseshellbracketleft'] = 0x3014;
	  t['tortoiseshellbracketleftsmall'] = 0xFE5D;
	  t['tortoiseshellbracketleftvertical'] = 0xFE39;
	  t['tortoiseshellbracketright'] = 0x3015;
	  t['tortoiseshellbracketrightsmall'] = 0xFE5E;
	  t['tortoiseshellbracketrightvertical'] = 0xFE3A;
	  t['totaothai'] = 0x0E15;
	  t['tpalatalhook'] = 0x01AB;
	  t['tparen'] = 0x24AF;
	  t['trademark'] = 0x2122;
	  t['trademarksans'] = 0xF8EA;
	  t['trademarkserif'] = 0xF6DB;
	  t['tretroflexhook'] = 0x0288;
	  t['triagdn'] = 0x25BC;
	  t['triaglf'] = 0x25C4;
	  t['triagrt'] = 0x25BA;
	  t['triagup'] = 0x25B2;
	  t['ts'] = 0x02A6;
	  t['tsadi'] = 0x05E6;
	  t['tsadidagesh'] = 0xFB46;
	  t['tsadidageshhebrew'] = 0xFB46;
	  t['tsadihebrew'] = 0x05E6;
	  t['tsecyrillic'] = 0x0446;
	  t['tsere'] = 0x05B5;
	  t['tsere12'] = 0x05B5;
	  t['tsere1e'] = 0x05B5;
	  t['tsere2b'] = 0x05B5;
	  t['tserehebrew'] = 0x05B5;
	  t['tserenarrowhebrew'] = 0x05B5;
	  t['tserequarterhebrew'] = 0x05B5;
	  t['tserewidehebrew'] = 0x05B5;
	  t['tshecyrillic'] = 0x045B;
	  t['tsuperior'] = 0xF6F3;
	  t['ttabengali'] = 0x099F;
	  t['ttadeva'] = 0x091F;
	  t['ttagujarati'] = 0x0A9F;
	  t['ttagurmukhi'] = 0x0A1F;
	  t['tteharabic'] = 0x0679;
	  t['ttehfinalarabic'] = 0xFB67;
	  t['ttehinitialarabic'] = 0xFB68;
	  t['ttehmedialarabic'] = 0xFB69;
	  t['tthabengali'] = 0x09A0;
	  t['tthadeva'] = 0x0920;
	  t['tthagujarati'] = 0x0AA0;
	  t['tthagurmukhi'] = 0x0A20;
	  t['tturned'] = 0x0287;
	  t['tuhiragana'] = 0x3064;
	  t['tukatakana'] = 0x30C4;
	  t['tukatakanahalfwidth'] = 0xFF82;
	  t['tusmallhiragana'] = 0x3063;
	  t['tusmallkatakana'] = 0x30C3;
	  t['tusmallkatakanahalfwidth'] = 0xFF6F;
	  t['twelvecircle'] = 0x246B;
	  t['twelveparen'] = 0x247F;
	  t['twelveperiod'] = 0x2493;
	  t['twelveroman'] = 0x217B;
	  t['twentycircle'] = 0x2473;
	  t['twentyhangzhou'] = 0x5344;
	  t['twentyparen'] = 0x2487;
	  t['twentyperiod'] = 0x249B;
	  t['two'] = 0x0032;
	  t['twoarabic'] = 0x0662;
	  t['twobengali'] = 0x09E8;
	  t['twocircle'] = 0x2461;
	  t['twocircleinversesansserif'] = 0x278B;
	  t['twodeva'] = 0x0968;
	  t['twodotenleader'] = 0x2025;
	  t['twodotleader'] = 0x2025;
	  t['twodotleadervertical'] = 0xFE30;
	  t['twogujarati'] = 0x0AE8;
	  t['twogurmukhi'] = 0x0A68;
	  t['twohackarabic'] = 0x0662;
	  t['twohangzhou'] = 0x3022;
	  t['twoideographicparen'] = 0x3221;
	  t['twoinferior'] = 0x2082;
	  t['twomonospace'] = 0xFF12;
	  t['twonumeratorbengali'] = 0x09F5;
	  t['twooldstyle'] = 0xF732;
	  t['twoparen'] = 0x2475;
	  t['twoperiod'] = 0x2489;
	  t['twopersian'] = 0x06F2;
	  t['tworoman'] = 0x2171;
	  t['twostroke'] = 0x01BB;
	  t['twosuperior'] = 0x00B2;
	  t['twothai'] = 0x0E52;
	  t['twothirds'] = 0x2154;
	  t['u'] = 0x0075;
	  t['uacute'] = 0x00FA;
	  t['ubar'] = 0x0289;
	  t['ubengali'] = 0x0989;
	  t['ubopomofo'] = 0x3128;
	  t['ubreve'] = 0x016D;
	  t['ucaron'] = 0x01D4;
	  t['ucircle'] = 0x24E4;
	  t['ucircumflex'] = 0x00FB;
	  t['ucircumflexbelow'] = 0x1E77;
	  t['ucyrillic'] = 0x0443;
	  t['udattadeva'] = 0x0951;
	  t['udblacute'] = 0x0171;
	  t['udblgrave'] = 0x0215;
	  t['udeva'] = 0x0909;
	  t['udieresis'] = 0x00FC;
	  t['udieresisacute'] = 0x01D8;
	  t['udieresisbelow'] = 0x1E73;
	  t['udieresiscaron'] = 0x01DA;
	  t['udieresiscyrillic'] = 0x04F1;
	  t['udieresisgrave'] = 0x01DC;
	  t['udieresismacron'] = 0x01D6;
	  t['udotbelow'] = 0x1EE5;
	  t['ugrave'] = 0x00F9;
	  t['ugujarati'] = 0x0A89;
	  t['ugurmukhi'] = 0x0A09;
	  t['uhiragana'] = 0x3046;
	  t['uhookabove'] = 0x1EE7;
	  t['uhorn'] = 0x01B0;
	  t['uhornacute'] = 0x1EE9;
	  t['uhorndotbelow'] = 0x1EF1;
	  t['uhorngrave'] = 0x1EEB;
	  t['uhornhookabove'] = 0x1EED;
	  t['uhorntilde'] = 0x1EEF;
	  t['uhungarumlaut'] = 0x0171;
	  t['uhungarumlautcyrillic'] = 0x04F3;
	  t['uinvertedbreve'] = 0x0217;
	  t['ukatakana'] = 0x30A6;
	  t['ukatakanahalfwidth'] = 0xFF73;
	  t['ukcyrillic'] = 0x0479;
	  t['ukorean'] = 0x315C;
	  t['umacron'] = 0x016B;
	  t['umacroncyrillic'] = 0x04EF;
	  t['umacrondieresis'] = 0x1E7B;
	  t['umatragurmukhi'] = 0x0A41;
	  t['umonospace'] = 0xFF55;
	  t['underscore'] = 0x005F;
	  t['underscoredbl'] = 0x2017;
	  t['underscoremonospace'] = 0xFF3F;
	  t['underscorevertical'] = 0xFE33;
	  t['underscorewavy'] = 0xFE4F;
	  t['union'] = 0x222A;
	  t['universal'] = 0x2200;
	  t['uogonek'] = 0x0173;
	  t['uparen'] = 0x24B0;
	  t['upblock'] = 0x2580;
	  t['upperdothebrew'] = 0x05C4;
	  t['upsilon'] = 0x03C5;
	  t['upsilondieresis'] = 0x03CB;
	  t['upsilondieresistonos'] = 0x03B0;
	  t['upsilonlatin'] = 0x028A;
	  t['upsilontonos'] = 0x03CD;
	  t['uptackbelowcmb'] = 0x031D;
	  t['uptackmod'] = 0x02D4;
	  t['uragurmukhi'] = 0x0A73;
	  t['uring'] = 0x016F;
	  t['ushortcyrillic'] = 0x045E;
	  t['usmallhiragana'] = 0x3045;
	  t['usmallkatakana'] = 0x30A5;
	  t['usmallkatakanahalfwidth'] = 0xFF69;
	  t['ustraightcyrillic'] = 0x04AF;
	  t['ustraightstrokecyrillic'] = 0x04B1;
	  t['utilde'] = 0x0169;
	  t['utildeacute'] = 0x1E79;
	  t['utildebelow'] = 0x1E75;
	  t['uubengali'] = 0x098A;
	  t['uudeva'] = 0x090A;
	  t['uugujarati'] = 0x0A8A;
	  t['uugurmukhi'] = 0x0A0A;
	  t['uumatragurmukhi'] = 0x0A42;
	  t['uuvowelsignbengali'] = 0x09C2;
	  t['uuvowelsigndeva'] = 0x0942;
	  t['uuvowelsigngujarati'] = 0x0AC2;
	  t['uvowelsignbengali'] = 0x09C1;
	  t['uvowelsigndeva'] = 0x0941;
	  t['uvowelsigngujarati'] = 0x0AC1;
	  t['v'] = 0x0076;
	  t['vadeva'] = 0x0935;
	  t['vagujarati'] = 0x0AB5;
	  t['vagurmukhi'] = 0x0A35;
	  t['vakatakana'] = 0x30F7;
	  t['vav'] = 0x05D5;
	  t['vavdagesh'] = 0xFB35;
	  t['vavdagesh65'] = 0xFB35;
	  t['vavdageshhebrew'] = 0xFB35;
	  t['vavhebrew'] = 0x05D5;
	  t['vavholam'] = 0xFB4B;
	  t['vavholamhebrew'] = 0xFB4B;
	  t['vavvavhebrew'] = 0x05F0;
	  t['vavyodhebrew'] = 0x05F1;
	  t['vcircle'] = 0x24E5;
	  t['vdotbelow'] = 0x1E7F;
	  t['vecyrillic'] = 0x0432;
	  t['veharabic'] = 0x06A4;
	  t['vehfinalarabic'] = 0xFB6B;
	  t['vehinitialarabic'] = 0xFB6C;
	  t['vehmedialarabic'] = 0xFB6D;
	  t['vekatakana'] = 0x30F9;
	  t['venus'] = 0x2640;
	  t['verticalbar'] = 0x007C;
	  t['verticallineabovecmb'] = 0x030D;
	  t['verticallinebelowcmb'] = 0x0329;
	  t['verticallinelowmod'] = 0x02CC;
	  t['verticallinemod'] = 0x02C8;
	  t['vewarmenian'] = 0x057E;
	  t['vhook'] = 0x028B;
	  t['vikatakana'] = 0x30F8;
	  t['viramabengali'] = 0x09CD;
	  t['viramadeva'] = 0x094D;
	  t['viramagujarati'] = 0x0ACD;
	  t['visargabengali'] = 0x0983;
	  t['visargadeva'] = 0x0903;
	  t['visargagujarati'] = 0x0A83;
	  t['vmonospace'] = 0xFF56;
	  t['voarmenian'] = 0x0578;
	  t['voicediterationhiragana'] = 0x309E;
	  t['voicediterationkatakana'] = 0x30FE;
	  t['voicedmarkkana'] = 0x309B;
	  t['voicedmarkkanahalfwidth'] = 0xFF9E;
	  t['vokatakana'] = 0x30FA;
	  t['vparen'] = 0x24B1;
	  t['vtilde'] = 0x1E7D;
	  t['vturned'] = 0x028C;
	  t['vuhiragana'] = 0x3094;
	  t['vukatakana'] = 0x30F4;
	  t['w'] = 0x0077;
	  t['wacute'] = 0x1E83;
	  t['waekorean'] = 0x3159;
	  t['wahiragana'] = 0x308F;
	  t['wakatakana'] = 0x30EF;
	  t['wakatakanahalfwidth'] = 0xFF9C;
	  t['wakorean'] = 0x3158;
	  t['wasmallhiragana'] = 0x308E;
	  t['wasmallkatakana'] = 0x30EE;
	  t['wattosquare'] = 0x3357;
	  t['wavedash'] = 0x301C;
	  t['wavyunderscorevertical'] = 0xFE34;
	  t['wawarabic'] = 0x0648;
	  t['wawfinalarabic'] = 0xFEEE;
	  t['wawhamzaabovearabic'] = 0x0624;
	  t['wawhamzaabovefinalarabic'] = 0xFE86;
	  t['wbsquare'] = 0x33DD;
	  t['wcircle'] = 0x24E6;
	  t['wcircumflex'] = 0x0175;
	  t['wdieresis'] = 0x1E85;
	  t['wdotaccent'] = 0x1E87;
	  t['wdotbelow'] = 0x1E89;
	  t['wehiragana'] = 0x3091;
	  t['weierstrass'] = 0x2118;
	  t['wekatakana'] = 0x30F1;
	  t['wekorean'] = 0x315E;
	  t['weokorean'] = 0x315D;
	  t['wgrave'] = 0x1E81;
	  t['whitebullet'] = 0x25E6;
	  t['whitecircle'] = 0x25CB;
	  t['whitecircleinverse'] = 0x25D9;
	  t['whitecornerbracketleft'] = 0x300E;
	  t['whitecornerbracketleftvertical'] = 0xFE43;
	  t['whitecornerbracketright'] = 0x300F;
	  t['whitecornerbracketrightvertical'] = 0xFE44;
	  t['whitediamond'] = 0x25C7;
	  t['whitediamondcontainingblacksmalldiamond'] = 0x25C8;
	  t['whitedownpointingsmalltriangle'] = 0x25BF;
	  t['whitedownpointingtriangle'] = 0x25BD;
	  t['whiteleftpointingsmalltriangle'] = 0x25C3;
	  t['whiteleftpointingtriangle'] = 0x25C1;
	  t['whitelenticularbracketleft'] = 0x3016;
	  t['whitelenticularbracketright'] = 0x3017;
	  t['whiterightpointingsmalltriangle'] = 0x25B9;
	  t['whiterightpointingtriangle'] = 0x25B7;
	  t['whitesmallsquare'] = 0x25AB;
	  t['whitesmilingface'] = 0x263A;
	  t['whitesquare'] = 0x25A1;
	  t['whitestar'] = 0x2606;
	  t['whitetelephone'] = 0x260F;
	  t['whitetortoiseshellbracketleft'] = 0x3018;
	  t['whitetortoiseshellbracketright'] = 0x3019;
	  t['whiteuppointingsmalltriangle'] = 0x25B5;
	  t['whiteuppointingtriangle'] = 0x25B3;
	  t['wihiragana'] = 0x3090;
	  t['wikatakana'] = 0x30F0;
	  t['wikorean'] = 0x315F;
	  t['wmonospace'] = 0xFF57;
	  t['wohiragana'] = 0x3092;
	  t['wokatakana'] = 0x30F2;
	  t['wokatakanahalfwidth'] = 0xFF66;
	  t['won'] = 0x20A9;
	  t['wonmonospace'] = 0xFFE6;
	  t['wowaenthai'] = 0x0E27;
	  t['wparen'] = 0x24B2;
	  t['wring'] = 0x1E98;
	  t['wsuperior'] = 0x02B7;
	  t['wturned'] = 0x028D;
	  t['wynn'] = 0x01BF;
	  t['x'] = 0x0078;
	  t['xabovecmb'] = 0x033D;
	  t['xbopomofo'] = 0x3112;
	  t['xcircle'] = 0x24E7;
	  t['xdieresis'] = 0x1E8D;
	  t['xdotaccent'] = 0x1E8B;
	  t['xeharmenian'] = 0x056D;
	  t['xi'] = 0x03BE;
	  t['xmonospace'] = 0xFF58;
	  t['xparen'] = 0x24B3;
	  t['xsuperior'] = 0x02E3;
	  t['y'] = 0x0079;
	  t['yaadosquare'] = 0x334E;
	  t['yabengali'] = 0x09AF;
	  t['yacute'] = 0x00FD;
	  t['yadeva'] = 0x092F;
	  t['yaekorean'] = 0x3152;
	  t['yagujarati'] = 0x0AAF;
	  t['yagurmukhi'] = 0x0A2F;
	  t['yahiragana'] = 0x3084;
	  t['yakatakana'] = 0x30E4;
	  t['yakatakanahalfwidth'] = 0xFF94;
	  t['yakorean'] = 0x3151;
	  t['yamakkanthai'] = 0x0E4E;
	  t['yasmallhiragana'] = 0x3083;
	  t['yasmallkatakana'] = 0x30E3;
	  t['yasmallkatakanahalfwidth'] = 0xFF6C;
	  t['yatcyrillic'] = 0x0463;
	  t['ycircle'] = 0x24E8;
	  t['ycircumflex'] = 0x0177;
	  t['ydieresis'] = 0x00FF;
	  t['ydotaccent'] = 0x1E8F;
	  t['ydotbelow'] = 0x1EF5;
	  t['yeharabic'] = 0x064A;
	  t['yehbarreearabic'] = 0x06D2;
	  t['yehbarreefinalarabic'] = 0xFBAF;
	  t['yehfinalarabic'] = 0xFEF2;
	  t['yehhamzaabovearabic'] = 0x0626;
	  t['yehhamzaabovefinalarabic'] = 0xFE8A;
	  t['yehhamzaaboveinitialarabic'] = 0xFE8B;
	  t['yehhamzaabovemedialarabic'] = 0xFE8C;
	  t['yehinitialarabic'] = 0xFEF3;
	  t['yehmedialarabic'] = 0xFEF4;
	  t['yehmeeminitialarabic'] = 0xFCDD;
	  t['yehmeemisolatedarabic'] = 0xFC58;
	  t['yehnoonfinalarabic'] = 0xFC94;
	  t['yehthreedotsbelowarabic'] = 0x06D1;
	  t['yekorean'] = 0x3156;
	  t['yen'] = 0x00A5;
	  t['yenmonospace'] = 0xFFE5;
	  t['yeokorean'] = 0x3155;
	  t['yeorinhieuhkorean'] = 0x3186;
	  t['yerahbenyomohebrew'] = 0x05AA;
	  t['yerahbenyomolefthebrew'] = 0x05AA;
	  t['yericyrillic'] = 0x044B;
	  t['yerudieresiscyrillic'] = 0x04F9;
	  t['yesieungkorean'] = 0x3181;
	  t['yesieungpansioskorean'] = 0x3183;
	  t['yesieungsioskorean'] = 0x3182;
	  t['yetivhebrew'] = 0x059A;
	  t['ygrave'] = 0x1EF3;
	  t['yhook'] = 0x01B4;
	  t['yhookabove'] = 0x1EF7;
	  t['yiarmenian'] = 0x0575;
	  t['yicyrillic'] = 0x0457;
	  t['yikorean'] = 0x3162;
	  t['yinyang'] = 0x262F;
	  t['yiwnarmenian'] = 0x0582;
	  t['ymonospace'] = 0xFF59;
	  t['yod'] = 0x05D9;
	  t['yoddagesh'] = 0xFB39;
	  t['yoddageshhebrew'] = 0xFB39;
	  t['yodhebrew'] = 0x05D9;
	  t['yodyodhebrew'] = 0x05F2;
	  t['yodyodpatahhebrew'] = 0xFB1F;
	  t['yohiragana'] = 0x3088;
	  t['yoikorean'] = 0x3189;
	  t['yokatakana'] = 0x30E8;
	  t['yokatakanahalfwidth'] = 0xFF96;
	  t['yokorean'] = 0x315B;
	  t['yosmallhiragana'] = 0x3087;
	  t['yosmallkatakana'] = 0x30E7;
	  t['yosmallkatakanahalfwidth'] = 0xFF6E;
	  t['yotgreek'] = 0x03F3;
	  t['yoyaekorean'] = 0x3188;
	  t['yoyakorean'] = 0x3187;
	  t['yoyakthai'] = 0x0E22;
	  t['yoyingthai'] = 0x0E0D;
	  t['yparen'] = 0x24B4;
	  t['ypogegrammeni'] = 0x037A;
	  t['ypogegrammenigreekcmb'] = 0x0345;
	  t['yr'] = 0x01A6;
	  t['yring'] = 0x1E99;
	  t['ysuperior'] = 0x02B8;
	  t['ytilde'] = 0x1EF9;
	  t['yturned'] = 0x028E;
	  t['yuhiragana'] = 0x3086;
	  t['yuikorean'] = 0x318C;
	  t['yukatakana'] = 0x30E6;
	  t['yukatakanahalfwidth'] = 0xFF95;
	  t['yukorean'] = 0x3160;
	  t['yusbigcyrillic'] = 0x046B;
	  t['yusbigiotifiedcyrillic'] = 0x046D;
	  t['yuslittlecyrillic'] = 0x0467;
	  t['yuslittleiotifiedcyrillic'] = 0x0469;
	  t['yusmallhiragana'] = 0x3085;
	  t['yusmallkatakana'] = 0x30E5;
	  t['yusmallkatakanahalfwidth'] = 0xFF6D;
	  t['yuyekorean'] = 0x318B;
	  t['yuyeokorean'] = 0x318A;
	  t['yyabengali'] = 0x09DF;
	  t['yyadeva'] = 0x095F;
	  t['z'] = 0x007A;
	  t['zaarmenian'] = 0x0566;
	  t['zacute'] = 0x017A;
	  t['zadeva'] = 0x095B;
	  t['zagurmukhi'] = 0x0A5B;
	  t['zaharabic'] = 0x0638;
	  t['zahfinalarabic'] = 0xFEC6;
	  t['zahinitialarabic'] = 0xFEC7;
	  t['zahiragana'] = 0x3056;
	  t['zahmedialarabic'] = 0xFEC8;
	  t['zainarabic'] = 0x0632;
	  t['zainfinalarabic'] = 0xFEB0;
	  t['zakatakana'] = 0x30B6;
	  t['zaqefgadolhebrew'] = 0x0595;
	  t['zaqefqatanhebrew'] = 0x0594;
	  t['zarqahebrew'] = 0x0598;
	  t['zayin'] = 0x05D6;
	  t['zayindagesh'] = 0xFB36;
	  t['zayindageshhebrew'] = 0xFB36;
	  t['zayinhebrew'] = 0x05D6;
	  t['zbopomofo'] = 0x3117;
	  t['zcaron'] = 0x017E;
	  t['zcircle'] = 0x24E9;
	  t['zcircumflex'] = 0x1E91;
	  t['zcurl'] = 0x0291;
	  t['zdot'] = 0x017C;
	  t['zdotaccent'] = 0x017C;
	  t['zdotbelow'] = 0x1E93;
	  t['zecyrillic'] = 0x0437;
	  t['zedescendercyrillic'] = 0x0499;
	  t['zedieresiscyrillic'] = 0x04DF;
	  t['zehiragana'] = 0x305C;
	  t['zekatakana'] = 0x30BC;
	  t['zero'] = 0x0030;
	  t['zeroarabic'] = 0x0660;
	  t['zerobengali'] = 0x09E6;
	  t['zerodeva'] = 0x0966;
	  t['zerogujarati'] = 0x0AE6;
	  t['zerogurmukhi'] = 0x0A66;
	  t['zerohackarabic'] = 0x0660;
	  t['zeroinferior'] = 0x2080;
	  t['zeromonospace'] = 0xFF10;
	  t['zerooldstyle'] = 0xF730;
	  t['zeropersian'] = 0x06F0;
	  t['zerosuperior'] = 0x2070;
	  t['zerothai'] = 0x0E50;
	  t['zerowidthjoiner'] = 0xFEFF;
	  t['zerowidthnonjoiner'] = 0x200C;
	  t['zerowidthspace'] = 0x200B;
	  t['zeta'] = 0x03B6;
	  t['zhbopomofo'] = 0x3113;
	  t['zhearmenian'] = 0x056A;
	  t['zhebrevecyrillic'] = 0x04C2;
	  t['zhecyrillic'] = 0x0436;
	  t['zhedescendercyrillic'] = 0x0497;
	  t['zhedieresiscyrillic'] = 0x04DD;
	  t['zihiragana'] = 0x3058;
	  t['zikatakana'] = 0x30B8;
	  t['zinorhebrew'] = 0x05AE;
	  t['zlinebelow'] = 0x1E95;
	  t['zmonospace'] = 0xFF5A;
	  t['zohiragana'] = 0x305E;
	  t['zokatakana'] = 0x30BE;
	  t['zparen'] = 0x24B5;
	  t['zretroflexhook'] = 0x0290;
	  t['zstroke'] = 0x01B6;
	  t['zuhiragana'] = 0x305A;
	  t['zukatakana'] = 0x30BA;
	  t['.notdef'] = 0x0000;
	  t['angbracketleftbig'] = 0x2329;
	  t['angbracketleftBig'] = 0x2329;
	  t['angbracketleftbigg'] = 0x2329;
	  t['angbracketleftBigg'] = 0x2329;
	  t['angbracketrightBig'] = 0x232A;
	  t['angbracketrightbig'] = 0x232A;
	  t['angbracketrightBigg'] = 0x232A;
	  t['angbracketrightbigg'] = 0x232A;
	  t['arrowhookleft'] = 0x21AA;
	  t['arrowhookright'] = 0x21A9;
	  t['arrowlefttophalf'] = 0x21BC;
	  t['arrowleftbothalf'] = 0x21BD;
	  t['arrownortheast'] = 0x2197;
	  t['arrownorthwest'] = 0x2196;
	  t['arrowrighttophalf'] = 0x21C0;
	  t['arrowrightbothalf'] = 0x21C1;
	  t['arrowsoutheast'] = 0x2198;
	  t['arrowsouthwest'] = 0x2199;
	  t['backslashbig'] = 0x2216;
	  t['backslashBig'] = 0x2216;
	  t['backslashBigg'] = 0x2216;
	  t['backslashbigg'] = 0x2216;
	  t['bardbl'] = 0x2016;
	  t['bracehtipdownleft'] = 0xFE37;
	  t['bracehtipdownright'] = 0xFE37;
	  t['bracehtipupleft'] = 0xFE38;
	  t['bracehtipupright'] = 0xFE38;
	  t['braceleftBig'] = 0x007B;
	  t['braceleftbig'] = 0x007B;
	  t['braceleftbigg'] = 0x007B;
	  t['braceleftBigg'] = 0x007B;
	  t['bracerightBig'] = 0x007D;
	  t['bracerightbig'] = 0x007D;
	  t['bracerightbigg'] = 0x007D;
	  t['bracerightBigg'] = 0x007D;
	  t['bracketleftbig'] = 0x005B;
	  t['bracketleftBig'] = 0x005B;
	  t['bracketleftbigg'] = 0x005B;
	  t['bracketleftBigg'] = 0x005B;
	  t['bracketrightBig'] = 0x005D;
	  t['bracketrightbig'] = 0x005D;
	  t['bracketrightbigg'] = 0x005D;
	  t['bracketrightBigg'] = 0x005D;
	  t['ceilingleftbig'] = 0x2308;
	  t['ceilingleftBig'] = 0x2308;
	  t['ceilingleftBigg'] = 0x2308;
	  t['ceilingleftbigg'] = 0x2308;
	  t['ceilingrightbig'] = 0x2309;
	  t['ceilingrightBig'] = 0x2309;
	  t['ceilingrightbigg'] = 0x2309;
	  t['ceilingrightBigg'] = 0x2309;
	  t['circledotdisplay'] = 0x2299;
	  t['circledottext'] = 0x2299;
	  t['circlemultiplydisplay'] = 0x2297;
	  t['circlemultiplytext'] = 0x2297;
	  t['circleplusdisplay'] = 0x2295;
	  t['circleplustext'] = 0x2295;
	  t['contintegraldisplay'] = 0x222E;
	  t['contintegraltext'] = 0x222E;
	  t['coproductdisplay'] = 0x2210;
	  t['coproducttext'] = 0x2210;
	  t['floorleftBig'] = 0x230A;
	  t['floorleftbig'] = 0x230A;
	  t['floorleftbigg'] = 0x230A;
	  t['floorleftBigg'] = 0x230A;
	  t['floorrightbig'] = 0x230B;
	  t['floorrightBig'] = 0x230B;
	  t['floorrightBigg'] = 0x230B;
	  t['floorrightbigg'] = 0x230B;
	  t['hatwide'] = 0x0302;
	  t['hatwider'] = 0x0302;
	  t['hatwidest'] = 0x0302;
	  t['intercal'] = 0x1D40;
	  t['integraldisplay'] = 0x222B;
	  t['integraltext'] = 0x222B;
	  t['intersectiondisplay'] = 0x22C2;
	  t['intersectiontext'] = 0x22C2;
	  t['logicalanddisplay'] = 0x2227;
	  t['logicalandtext'] = 0x2227;
	  t['logicalordisplay'] = 0x2228;
	  t['logicalortext'] = 0x2228;
	  t['parenleftBig'] = 0x0028;
	  t['parenleftbig'] = 0x0028;
	  t['parenleftBigg'] = 0x0028;
	  t['parenleftbigg'] = 0x0028;
	  t['parenrightBig'] = 0x0029;
	  t['parenrightbig'] = 0x0029;
	  t['parenrightBigg'] = 0x0029;
	  t['parenrightbigg'] = 0x0029;
	  t['prime'] = 0x2032;
	  t['productdisplay'] = 0x220F;
	  t['producttext'] = 0x220F;
	  t['radicalbig'] = 0x221A;
	  t['radicalBig'] = 0x221A;
	  t['radicalBigg'] = 0x221A;
	  t['radicalbigg'] = 0x221A;
	  t['radicalbt'] = 0x221A;
	  t['radicaltp'] = 0x221A;
	  t['radicalvertex'] = 0x221A;
	  t['slashbig'] = 0x002F;
	  t['slashBig'] = 0x002F;
	  t['slashBigg'] = 0x002F;
	  t['slashbigg'] = 0x002F;
	  t['summationdisplay'] = 0x2211;
	  t['summationtext'] = 0x2211;
	  t['tildewide'] = 0x02DC;
	  t['tildewider'] = 0x02DC;
	  t['tildewidest'] = 0x02DC;
	  t['uniondisplay'] = 0x22C3;
	  t['unionmultidisplay'] = 0x228E;
	  t['unionmultitext'] = 0x228E;
	  t['unionsqdisplay'] = 0x2294;
	  t['unionsqtext'] = 0x2294;
	  t['uniontext'] = 0x22C3;
	  t['vextenddouble'] = 0x2225;
	  t['vextendsingle'] = 0x2223;
	});
	var getDingbatsGlyphsUnicode = getLookupTableFactory(function (t) {
	  t['space'] = 0x0020;
	  t['a1'] = 0x2701;
	  t['a2'] = 0x2702;
	  t['a202'] = 0x2703;
	  t['a3'] = 0x2704;
	  t['a4'] = 0x260E;
	  t['a5'] = 0x2706;
	  t['a119'] = 0x2707;
	  t['a118'] = 0x2708;
	  t['a117'] = 0x2709;
	  t['a11'] = 0x261B;
	  t['a12'] = 0x261E;
	  t['a13'] = 0x270C;
	  t['a14'] = 0x270D;
	  t['a15'] = 0x270E;
	  t['a16'] = 0x270F;
	  t['a105'] = 0x2710;
	  t['a17'] = 0x2711;
	  t['a18'] = 0x2712;
	  t['a19'] = 0x2713;
	  t['a20'] = 0x2714;
	  t['a21'] = 0x2715;
	  t['a22'] = 0x2716;
	  t['a23'] = 0x2717;
	  t['a24'] = 0x2718;
	  t['a25'] = 0x2719;
	  t['a26'] = 0x271A;
	  t['a27'] = 0x271B;
	  t['a28'] = 0x271C;
	  t['a6'] = 0x271D;
	  t['a7'] = 0x271E;
	  t['a8'] = 0x271F;
	  t['a9'] = 0x2720;
	  t['a10'] = 0x2721;
	  t['a29'] = 0x2722;
	  t['a30'] = 0x2723;
	  t['a31'] = 0x2724;
	  t['a32'] = 0x2725;
	  t['a33'] = 0x2726;
	  t['a34'] = 0x2727;
	  t['a35'] = 0x2605;
	  t['a36'] = 0x2729;
	  t['a37'] = 0x272A;
	  t['a38'] = 0x272B;
	  t['a39'] = 0x272C;
	  t['a40'] = 0x272D;
	  t['a41'] = 0x272E;
	  t['a42'] = 0x272F;
	  t['a43'] = 0x2730;
	  t['a44'] = 0x2731;
	  t['a45'] = 0x2732;
	  t['a46'] = 0x2733;
	  t['a47'] = 0x2734;
	  t['a48'] = 0x2735;
	  t['a49'] = 0x2736;
	  t['a50'] = 0x2737;
	  t['a51'] = 0x2738;
	  t['a52'] = 0x2739;
	  t['a53'] = 0x273A;
	  t['a54'] = 0x273B;
	  t['a55'] = 0x273C;
	  t['a56'] = 0x273D;
	  t['a57'] = 0x273E;
	  t['a58'] = 0x273F;
	  t['a59'] = 0x2740;
	  t['a60'] = 0x2741;
	  t['a61'] = 0x2742;
	  t['a62'] = 0x2743;
	  t['a63'] = 0x2744;
	  t['a64'] = 0x2745;
	  t['a65'] = 0x2746;
	  t['a66'] = 0x2747;
	  t['a67'] = 0x2748;
	  t['a68'] = 0x2749;
	  t['a69'] = 0x274A;
	  t['a70'] = 0x274B;
	  t['a71'] = 0x25CF;
	  t['a72'] = 0x274D;
	  t['a73'] = 0x25A0;
	  t['a74'] = 0x274F;
	  t['a203'] = 0x2750;
	  t['a75'] = 0x2751;
	  t['a204'] = 0x2752;
	  t['a76'] = 0x25B2;
	  t['a77'] = 0x25BC;
	  t['a78'] = 0x25C6;
	  t['a79'] = 0x2756;
	  t['a81'] = 0x25D7;
	  t['a82'] = 0x2758;
	  t['a83'] = 0x2759;
	  t['a84'] = 0x275A;
	  t['a97'] = 0x275B;
	  t['a98'] = 0x275C;
	  t['a99'] = 0x275D;
	  t['a100'] = 0x275E;
	  t['a101'] = 0x2761;
	  t['a102'] = 0x2762;
	  t['a103'] = 0x2763;
	  t['a104'] = 0x2764;
	  t['a106'] = 0x2765;
	  t['a107'] = 0x2766;
	  t['a108'] = 0x2767;
	  t['a112'] = 0x2663;
	  t['a111'] = 0x2666;
	  t['a110'] = 0x2665;
	  t['a109'] = 0x2660;
	  t['a120'] = 0x2460;
	  t['a121'] = 0x2461;
	  t['a122'] = 0x2462;
	  t['a123'] = 0x2463;
	  t['a124'] = 0x2464;
	  t['a125'] = 0x2465;
	  t['a126'] = 0x2466;
	  t['a127'] = 0x2467;
	  t['a128'] = 0x2468;
	  t['a129'] = 0x2469;
	  t['a130'] = 0x2776;
	  t['a131'] = 0x2777;
	  t['a132'] = 0x2778;
	  t['a133'] = 0x2779;
	  t['a134'] = 0x277A;
	  t['a135'] = 0x277B;
	  t['a136'] = 0x277C;
	  t['a137'] = 0x277D;
	  t['a138'] = 0x277E;
	  t['a139'] = 0x277F;
	  t['a140'] = 0x2780;
	  t['a141'] = 0x2781;
	  t['a142'] = 0x2782;
	  t['a143'] = 0x2783;
	  t['a144'] = 0x2784;
	  t['a145'] = 0x2785;
	  t['a146'] = 0x2786;
	  t['a147'] = 0x2787;
	  t['a148'] = 0x2788;
	  t['a149'] = 0x2789;
	  t['a150'] = 0x278A;
	  t['a151'] = 0x278B;
	  t['a152'] = 0x278C;
	  t['a153'] = 0x278D;
	  t['a154'] = 0x278E;
	  t['a155'] = 0x278F;
	  t['a156'] = 0x2790;
	  t['a157'] = 0x2791;
	  t['a158'] = 0x2792;
	  t['a159'] = 0x2793;
	  t['a160'] = 0x2794;
	  t['a161'] = 0x2192;
	  t['a163'] = 0x2194;
	  t['a164'] = 0x2195;
	  t['a196'] = 0x2798;
	  t['a165'] = 0x2799;
	  t['a192'] = 0x279A;
	  t['a166'] = 0x279B;
	  t['a167'] = 0x279C;
	  t['a168'] = 0x279D;
	  t['a169'] = 0x279E;
	  t['a170'] = 0x279F;
	  t['a171'] = 0x27A0;
	  t['a172'] = 0x27A1;
	  t['a173'] = 0x27A2;
	  t['a162'] = 0x27A3;
	  t['a174'] = 0x27A4;
	  t['a175'] = 0x27A5;
	  t['a176'] = 0x27A6;
	  t['a177'] = 0x27A7;
	  t['a178'] = 0x27A8;
	  t['a179'] = 0x27A9;
	  t['a193'] = 0x27AA;
	  t['a180'] = 0x27AB;
	  t['a199'] = 0x27AC;
	  t['a181'] = 0x27AD;
	  t['a200'] = 0x27AE;
	  t['a182'] = 0x27AF;
	  t['a201'] = 0x27B1;
	  t['a183'] = 0x27B2;
	  t['a184'] = 0x27B3;
	  t['a197'] = 0x27B4;
	  t['a185'] = 0x27B5;
	  t['a194'] = 0x27B6;
	  t['a198'] = 0x27B7;
	  t['a186'] = 0x27B8;
	  t['a195'] = 0x27B9;
	  t['a187'] = 0x27BA;
	  t['a188'] = 0x27BB;
	  t['a189'] = 0x27BC;
	  t['a190'] = 0x27BD;
	  t['a191'] = 0x27BE;
	  t['a89'] = 0x2768;
	  t['a90'] = 0x2769;
	  t['a93'] = 0x276A;
	  t['a94'] = 0x276B;
	  t['a91'] = 0x276C;
	  t['a92'] = 0x276D;
	  t['a205'] = 0x276E;
	  t['a85'] = 0x276F;
	  t['a206'] = 0x2770;
	  t['a86'] = 0x2771;
	  t['a87'] = 0x2772;
	  t['a88'] = 0x2773;
	  t['a95'] = 0x2774;
	  t['a96'] = 0x2775;
	  t['.notdef'] = 0x0000;
	});
	exports.getGlyphsUnicode = getGlyphsUnicode;
	exports.getDingbatsGlyphsUnicode = getDingbatsGlyphsUnicode;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var corePdfManager = __w_pdfjs_require__(33);
	var UNSUPPORTED_FEATURES = sharedUtil.UNSUPPORTED_FEATURES;
	var InvalidPDFException = sharedUtil.InvalidPDFException;
	var MessageHandler = sharedUtil.MessageHandler;
	var MissingPDFException = sharedUtil.MissingPDFException;
	var UnexpectedResponseException = sharedUtil.UnexpectedResponseException;
	var PasswordException = sharedUtil.PasswordException;
	var UnknownErrorException = sharedUtil.UnknownErrorException;
	var XRefParseException = sharedUtil.XRefParseException;
	var arrayByteLength = sharedUtil.arrayByteLength;
	var arraysToBytes = sharedUtil.arraysToBytes;
	var assert = sharedUtil.assert;
	var createPromiseCapability = sharedUtil.createPromiseCapability;
	var info = sharedUtil.info;
	var warn = sharedUtil.warn;
	var setVerbosityLevel = sharedUtil.setVerbosityLevel;
	var isNodeJS = sharedUtil.isNodeJS;
	var Ref = corePrimitives.Ref;
	var LocalPdfManager = corePdfManager.LocalPdfManager;
	var NetworkPdfManager = corePdfManager.NetworkPdfManager;
	var WorkerTask = function WorkerTaskClosure() {
	  function WorkerTask(name) {
	    this.name = name;
	    this.terminated = false;
	    this._capability = createPromiseCapability();
	  }
	  WorkerTask.prototype = {
	    get finished() {
	      return this._capability.promise;
	    },
	    finish: function finish() {
	      this._capability.resolve();
	    },
	    terminate: function terminate() {
	      this.terminated = true;
	    },
	    ensureNotTerminated: function ensureNotTerminated() {
	      if (this.terminated) {
	        throw new Error('Worker task was terminated');
	      }
	    }
	  };
	  return WorkerTask;
	}();
	var PDFWorkerStream = function PDFWorkerStreamClosure() {
	  function PDFWorkerStream(params, msgHandler) {
	    this._queuedChunks = [];
	    var initialData = params.initialData;
	    if (initialData && initialData.length > 0) {
	      this._queuedChunks.push(initialData);
	    }
	    this._msgHandler = msgHandler;
	    this._isRangeSupported = !params.disableRange;
	    this._isStreamingSupported = !params.disableStream;
	    this._contentLength = params.length;
	    this._fullRequestReader = null;
	    this._rangeReaders = [];
	    msgHandler.on('OnDataRange', this._onReceiveData.bind(this));
	    msgHandler.on('OnDataProgress', this._onProgress.bind(this));
	  }
	  PDFWorkerStream.prototype = {
	    _onReceiveData: function PDFWorkerStream_onReceiveData(args) {
	      if (args.begin === undefined) {
	        if (this._fullRequestReader) {
	          this._fullRequestReader._enqueue(args.chunk);
	        } else {
	          this._queuedChunks.push(args.chunk);
	        }
	      } else {
	        var found = this._rangeReaders.some(function (rangeReader) {
	          if (rangeReader._begin !== args.begin) {
	            return false;
	          }
	          rangeReader._enqueue(args.chunk);
	          return true;
	        });
	        assert(found);
	      }
	    },
	    _onProgress: function PDFWorkerStream_onProgress(evt) {
	      if (this._rangeReaders.length > 0) {
	        var firstReader = this._rangeReaders[0];
	        if (firstReader.onProgress) {
	          firstReader.onProgress({ loaded: evt.loaded });
	        }
	      }
	    },
	    _removeRangeReader: function PDFWorkerStream_removeRangeReader(reader) {
	      var i = this._rangeReaders.indexOf(reader);
	      if (i >= 0) {
	        this._rangeReaders.splice(i, 1);
	      }
	    },
	    getFullReader: function PDFWorkerStream_getFullReader() {
	      assert(!this._fullRequestReader);
	      var queuedChunks = this._queuedChunks;
	      this._queuedChunks = null;
	      return new PDFWorkerStreamReader(this, queuedChunks);
	    },
	    getRangeReader: function PDFWorkerStream_getRangeReader(begin, end) {
	      var reader = new PDFWorkerStreamRangeReader(this, begin, end);
	      this._msgHandler.send('RequestDataRange', {
	        begin: begin,
	        end: end
	      });
	      this._rangeReaders.push(reader);
	      return reader;
	    },
	    cancelAllRequests: function PDFWorkerStream_cancelAllRequests(reason) {
	      if (this._fullRequestReader) {
	        this._fullRequestReader.cancel(reason);
	      }
	      var readers = this._rangeReaders.slice(0);
	      readers.forEach(function (rangeReader) {
	        rangeReader.cancel(reason);
	      });
	    }
	  };
	  function PDFWorkerStreamReader(stream, queuedChunks) {
	    this._stream = stream;
	    this._done = false;
	    this._queuedChunks = queuedChunks || [];
	    this._requests = [];
	    this._headersReady = Promise.resolve();
	    stream._fullRequestReader = this;
	    this.onProgress = null;
	  }
	  PDFWorkerStreamReader.prototype = {
	    _enqueue: function PDFWorkerStreamReader_enqueue(chunk) {
	      if (this._done) {
	        return;
	      }
	      if (this._requests.length > 0) {
	        var requestCapability = this._requests.shift();
	        requestCapability.resolve({
	          value: chunk,
	          done: false
	        });
	        return;
	      }
	      this._queuedChunks.push(chunk);
	    },
	    get headersReady() {
	      return this._headersReady;
	    },
	    get isRangeSupported() {
	      return this._stream._isRangeSupported;
	    },
	    get isStreamingSupported() {
	      return this._stream._isStreamingSupported;
	    },
	    get contentLength() {
	      return this._stream._contentLength;
	    },
	    read: function PDFWorkerStreamReader_read() {
	      if (this._queuedChunks.length > 0) {
	        var chunk = this._queuedChunks.shift();
	        return Promise.resolve({
	          value: chunk,
	          done: false
	        });
	      }
	      if (this._done) {
	        return Promise.resolve({
	          value: undefined,
	          done: true
	        });
	      }
	      var requestCapability = createPromiseCapability();
	      this._requests.push(requestCapability);
	      return requestCapability.promise;
	    },
	    cancel: function PDFWorkerStreamReader_cancel(reason) {
	      this._done = true;
	      this._requests.forEach(function (requestCapability) {
	        requestCapability.resolve({
	          value: undefined,
	          done: true
	        });
	      });
	      this._requests = [];
	    }
	  };
	  function PDFWorkerStreamRangeReader(stream, begin, end) {
	    this._stream = stream;
	    this._begin = begin;
	    this._end = end;
	    this._queuedChunk = null;
	    this._requests = [];
	    this._done = false;
	    this.onProgress = null;
	  }
	  PDFWorkerStreamRangeReader.prototype = {
	    _enqueue: function PDFWorkerStreamRangeReader_enqueue(chunk) {
	      if (this._done) {
	        return;
	      }
	      if (this._requests.length === 0) {
	        this._queuedChunk = chunk;
	      } else {
	        var requestsCapability = this._requests.shift();
	        requestsCapability.resolve({
	          value: chunk,
	          done: false
	        });
	        this._requests.forEach(function (requestCapability) {
	          requestCapability.resolve({
	            value: undefined,
	            done: true
	          });
	        });
	        this._requests = [];
	      }
	      this._done = true;
	      this._stream._removeRangeReader(this);
	    },
	    get isStreamingSupported() {
	      return false;
	    },
	    read: function PDFWorkerStreamRangeReader_read() {
	      if (this._queuedChunk) {
	        return Promise.resolve({
	          value: this._queuedChunk,
	          done: false
	        });
	      }
	      if (this._done) {
	        return Promise.resolve({
	          value: undefined,
	          done: true
	        });
	      }
	      var requestCapability = createPromiseCapability();
	      this._requests.push(requestCapability);
	      return requestCapability.promise;
	    },
	    cancel: function PDFWorkerStreamRangeReader_cancel(reason) {
	      this._done = true;
	      this._requests.forEach(function (requestCapability) {
	        requestCapability.resolve({
	          value: undefined,
	          done: true
	        });
	      });
	      this._requests = [];
	      this._stream._removeRangeReader(this);
	    }
	  };
	  return PDFWorkerStream;
	}();
	var PDFNetworkStream;
	function setPDFNetworkStreamClass(cls) {
	  PDFNetworkStream = cls;
	}
	var WorkerMessageHandler = {
	  setup: function setup(handler, port) {
	    var testMessageProcessed = false;
	    handler.on('test', function wphSetupTest(data) {
	      if (testMessageProcessed) {
	        return;
	      }
	      testMessageProcessed = true;
	      if (!(data instanceof Uint8Array)) {
	        handler.send('test', 'main', false);
	        return;
	      }
	      var supportTransfers = data[0] === 255;
	      handler.postMessageTransfers = supportTransfers;
	      var xhr = new XMLHttpRequest();
	      var responseExists = 'response' in xhr;
	      try {
	        xhr.responseType;
	      } catch (e) {
	        responseExists = false;
	      }
	      if (!responseExists) {
	        handler.send('test', false);
	        return;
	      }
	      handler.send('test', {
	        supportTypedArray: true,
	        supportTransfers: supportTransfers
	      });
	    });
	    handler.on('configure', function wphConfigure(data) {
	      setVerbosityLevel(data.verbosity);
	    });
	    handler.on('GetDocRequest', function wphSetupDoc(data) {
	      return WorkerMessageHandler.createDocumentHandler(data, port);
	    });
	  },
	  createDocumentHandler: function createDocumentHandler(docParams, port) {
	    var pdfManager;
	    var terminated = false;
	    var cancelXHRs = null;
	    var WorkerTasks = [];
	    var docId = docParams.docId;
	    var docBaseUrl = docParams.docBaseUrl;
	    var workerHandlerName = docParams.docId + '_worker';
	    var handler = new MessageHandler(workerHandlerName, docId, port);
	    handler.postMessageTransfers = docParams.postMessageTransfers;
	    function ensureNotTerminated() {
	      if (terminated) {
	        throw new Error('Worker was terminated');
	      }
	    }
	    function startWorkerTask(task) {
	      WorkerTasks.push(task);
	    }
	    function finishWorkerTask(task) {
	      task.finish();
	      var i = WorkerTasks.indexOf(task);
	      WorkerTasks.splice(i, 1);
	    }
	    function loadDocument(recoveryMode) {
	      var loadDocumentCapability = createPromiseCapability();
	      var parseSuccess = function parseSuccess() {
	        var numPagesPromise = pdfManager.ensureDoc('numPages');
	        var fingerprintPromise = pdfManager.ensureDoc('fingerprint');
	        var encryptedPromise = pdfManager.ensureXRef('encrypt');
	        Promise.all([numPagesPromise, fingerprintPromise, encryptedPromise]).then(function onDocReady(results) {
	          var doc = {
	            numPages: results[0],
	            fingerprint: results[1],
	            encrypted: !!results[2]
	          };
	          loadDocumentCapability.resolve(doc);
	        }, parseFailure);
	      };
	      var parseFailure = function parseFailure(e) {
	        loadDocumentCapability.reject(e);
	      };
	      pdfManager.ensureDoc('checkHeader', []).then(function () {
	        pdfManager.ensureDoc('parseStartXRef', []).then(function () {
	          pdfManager.ensureDoc('parse', [recoveryMode]).then(parseSuccess, parseFailure);
	        }, parseFailure);
	      }, parseFailure);
	      return loadDocumentCapability.promise;
	    }
	    function getPdfManager(data, evaluatorOptions) {
	      var pdfManagerCapability = createPromiseCapability();
	      var pdfManager;
	      var source = data.source;
	      if (source.data) {
	        try {
	          pdfManager = new LocalPdfManager(docId, source.data, source.password, evaluatorOptions, docBaseUrl);
	          pdfManagerCapability.resolve(pdfManager);
	        } catch (ex) {
	          pdfManagerCapability.reject(ex);
	        }
	        return pdfManagerCapability.promise;
	      }
	      var pdfStream;
	      try {
	        if (source.chunkedViewerLoading) {
	          pdfStream = new PDFWorkerStream(source, handler);
	        } else {
	          assert(PDFNetworkStream, 'pdfjs/core/network module is not loaded');
	          pdfStream = new PDFNetworkStream(data);
	        }
	      } catch (ex) {
	        pdfManagerCapability.reject(ex);
	        return pdfManagerCapability.promise;
	      }
	      var fullRequest = pdfStream.getFullReader();
	      fullRequest.headersReady.then(function () {
	        if (!fullRequest.isStreamingSupported || !fullRequest.isRangeSupported) {
	          fullRequest.onProgress = function (evt) {
	            handler.send('DocProgress', {
	              loaded: evt.loaded,
	              total: evt.total
	            });
	          };
	        }
	        if (!fullRequest.isRangeSupported) {
	          return;
	        }
	        var disableAutoFetch = source.disableAutoFetch || fullRequest.isStreamingSupported;
	        pdfManager = new NetworkPdfManager(docId, pdfStream, {
	          msgHandler: handler,
	          url: source.url,
	          password: source.password,
	          length: fullRequest.contentLength,
	          disableAutoFetch: disableAutoFetch,
	          rangeChunkSize: source.rangeChunkSize
	        }, evaluatorOptions, docBaseUrl);
	        pdfManagerCapability.resolve(pdfManager);
	        cancelXHRs = null;
	      }).catch(function (reason) {
	        pdfManagerCapability.reject(reason);
	        cancelXHRs = null;
	      });
	      var cachedChunks = [],
	          loaded = 0;
	      var flushChunks = function flushChunks() {
	        var pdfFile = arraysToBytes(cachedChunks);
	        if (source.length && pdfFile.length !== source.length) {
	          warn('reported HTTP length is different from actual');
	        }
	        try {
	          pdfManager = new LocalPdfManager(docId, pdfFile, source.password, evaluatorOptions, docBaseUrl);
	          pdfManagerCapability.resolve(pdfManager);
	        } catch (ex) {
	          pdfManagerCapability.reject(ex);
	        }
	        cachedChunks = [];
	      };
	      var readPromise = new Promise(function (resolve, reject) {
	        var readChunk = function readChunk(chunk) {
	          try {
	            ensureNotTerminated();
	            if (chunk.done) {
	              if (!pdfManager) {
	                flushChunks();
	              }
	              cancelXHRs = null;
	              return;
	            }
	            var data = chunk.value;
	            loaded += arrayByteLength(data);
	            if (!fullRequest.isStreamingSupported) {
	              handler.send('DocProgress', {
	                loaded: loaded,
	                total: Math.max(loaded, fullRequest.contentLength || 0)
	              });
	            }
	            if (pdfManager) {
	              pdfManager.sendProgressiveData(data);
	            } else {
	              cachedChunks.push(data);
	            }
	            fullRequest.read().then(readChunk, reject);
	          } catch (e) {
	            reject(e);
	          }
	        };
	        fullRequest.read().then(readChunk, reject);
	      });
	      readPromise.catch(function (e) {
	        pdfManagerCapability.reject(e);
	        cancelXHRs = null;
	      });
	      cancelXHRs = function cancelXHRs() {
	        pdfStream.cancelAllRequests('abort');
	      };
	      return pdfManagerCapability.promise;
	    }
	    function setupDoc(data) {
	      function onSuccess(doc) {
	        ensureNotTerminated();
	        handler.send('GetDoc', { pdfInfo: doc });
	      }
	      function onFailure(e) {
	        if (e instanceof PasswordException) {
	          var task = new WorkerTask('PasswordException: response ' + e.code);
	          startWorkerTask(task);
	          handler.sendWithPromise('PasswordRequest', e).then(function (data) {
	            finishWorkerTask(task);
	            pdfManager.updatePassword(data.password);
	            pdfManagerReady();
	          }).catch(function (ex) {
	            finishWorkerTask(task);
	            handler.send('PasswordException', ex);
	          }.bind(null, e));
	        } else if (e instanceof InvalidPDFException) {
	          handler.send('InvalidPDF', e);
	        } else if (e instanceof MissingPDFException) {
	          handler.send('MissingPDF', e);
	        } else if (e instanceof UnexpectedResponseException) {
	          handler.send('UnexpectedResponse', e);
	        } else {
	          handler.send('UnknownError', new UnknownErrorException(e.message, e.toString()));
	        }
	      }
	      function pdfManagerReady() {
	        ensureNotTerminated();
	        loadDocument(false).then(onSuccess, function loadFailure(ex) {
	          ensureNotTerminated();
	          if (!(ex instanceof XRefParseException)) {
	            onFailure(ex);
	            return;
	          }
	          pdfManager.requestLoadedStream();
	          pdfManager.onLoadedStream().then(function () {
	            ensureNotTerminated();
	            loadDocument(true).then(onSuccess, onFailure);
	          });
	        }, onFailure);
	      }
	      ensureNotTerminated();
	      var evaluatorOptions = {
	        forceDataSchema: data.disableCreateObjectURL,
	        maxImageSize: data.maxImageSize === undefined ? -1 : data.maxImageSize,
	        disableFontFace: data.disableFontFace,
	        disableNativeImageDecoder: data.disableNativeImageDecoder,
	        ignoreErrors: data.ignoreErrors
	      };
	      getPdfManager(data, evaluatorOptions).then(function (newPdfManager) {
	        if (terminated) {
	          newPdfManager.terminate();
	          throw new Error('Worker was terminated');
	        }
	        pdfManager = newPdfManager;
	        handler.send('PDFManagerReady', null);
	        pdfManager.onLoadedStream().then(function (stream) {
	          handler.send('DataLoaded', { length: stream.bytes.byteLength });
	        });
	      }).then(pdfManagerReady, onFailure);
	    }
	    handler.on('GetPage', function wphSetupGetPage(data) {
	      return pdfManager.getPage(data.pageIndex).then(function (page) {
	        var rotatePromise = pdfManager.ensure(page, 'rotate');
	        var refPromise = pdfManager.ensure(page, 'ref');
	        var userUnitPromise = pdfManager.ensure(page, 'userUnit');
	        var viewPromise = pdfManager.ensure(page, 'view');
	        return Promise.all([rotatePromise, refPromise, userUnitPromise, viewPromise]).then(function (results) {
	          return {
	            rotate: results[0],
	            ref: results[1],
	            userUnit: results[2],
	            view: results[3]
	          };
	        });
	      });
	    });
	    handler.on('GetPageIndex', function wphSetupGetPageIndex(data) {
	      var ref = new Ref(data.ref.num, data.ref.gen);
	      var catalog = pdfManager.pdfDocument.catalog;
	      return catalog.getPageIndex(ref);
	    });
	    handler.on('GetDestinations', function wphSetupGetDestinations(data) {
	      return pdfManager.ensureCatalog('destinations');
	    });
	    handler.on('GetDestination', function wphSetupGetDestination(data) {
	      return pdfManager.ensureCatalog('getDestination', [data.id]);
	    });
	    handler.on('GetPageLabels', function wphSetupGetPageLabels(data) {
	      return pdfManager.ensureCatalog('pageLabels');
	    });
	    handler.on('GetAttachments', function wphSetupGetAttachments(data) {
	      return pdfManager.ensureCatalog('attachments');
	    });
	    handler.on('GetJavaScript', function wphSetupGetJavaScript(data) {
	      return pdfManager.ensureCatalog('javaScript');
	    });
	    handler.on('GetOutline', function wphSetupGetOutline(data) {
	      return pdfManager.ensureCatalog('documentOutline');
	    });
	    handler.on('GetMetadata', function wphSetupGetMetadata(data) {
	      return Promise.all([pdfManager.ensureDoc('documentInfo'), pdfManager.ensureCatalog('metadata')]);
	    });
	    handler.on('GetData', function wphSetupGetData(data) {
	      pdfManager.requestLoadedStream();
	      return pdfManager.onLoadedStream().then(function (stream) {
	        return stream.bytes;
	      });
	    });
	    handler.on('GetStats', function wphSetupGetStats(data) {
	      return pdfManager.pdfDocument.xref.stats;
	    });
	    handler.on('GetAnnotations', function wphSetupGetAnnotations(data) {
	      return pdfManager.getPage(data.pageIndex).then(function (page) {
	        return pdfManager.ensure(page, 'getAnnotationsData', [data.intent]);
	      });
	    });
	    handler.on('RenderPageRequest', function wphSetupRenderPage(data) {
	      var pageIndex = data.pageIndex;
	      pdfManager.getPage(pageIndex).then(function (page) {
	        var task = new WorkerTask('RenderPageRequest: page ' + pageIndex);
	        startWorkerTask(task);
	        var pageNum = pageIndex + 1;
	        var start = Date.now();
	        page.getOperatorList({
	          handler: handler,
	          task: task,
	          intent: data.intent,
	          renderInteractiveForms: data.renderInteractiveForms
	        }).then(function (operatorList) {
	          finishWorkerTask(task);
	          info('page=' + pageNum + ' - getOperatorList: time=' + (Date.now() - start) + 'ms, len=' + operatorList.totalLength);
	        }, function (e) {
	          finishWorkerTask(task);
	          if (task.terminated) {
	            return;
	          }
	          handler.send('UnsupportedFeature', { featureId: UNSUPPORTED_FEATURES.unknown });
	          var minimumStackMessage = 'worker.js: while trying to getPage() and getOperatorList()';
	          var wrappedException;
	          if (typeof e === 'string') {
	            wrappedException = {
	              message: e,
	              stack: minimumStackMessage
	            };
	          } else if ((typeof e === 'undefined' ? 'undefined' : _typeof(e)) === 'object') {
	            wrappedException = {
	              message: e.message || e.toString(),
	              stack: e.stack || minimumStackMessage
	            };
	          } else {
	            wrappedException = {
	              message: 'Unknown exception type: ' + (typeof e === 'undefined' ? 'undefined' : _typeof(e)),
	              stack: minimumStackMessage
	            };
	          }
	          handler.send('PageError', {
	            pageNum: pageNum,
	            error: wrappedException,
	            intent: data.intent
	          });
	        });
	      });
	    }, this);
	    handler.on('GetTextContent', function wphExtractText(data) {
	      var pageIndex = data.pageIndex;
	      return pdfManager.getPage(pageIndex).then(function (page) {
	        var task = new WorkerTask('GetTextContent: page ' + pageIndex);
	        startWorkerTask(task);
	        var pageNum = pageIndex + 1;
	        var start = Date.now();
	        return page.extractTextContent({
	          handler: handler,
	          task: task,
	          normalizeWhitespace: data.normalizeWhitespace,
	          combineTextItems: data.combineTextItems
	        }).then(function (textContent) {
	          finishWorkerTask(task);
	          info('text indexing: page=' + pageNum + ' - time=' + (Date.now() - start) + 'ms');
	          return textContent;
	        }, function (reason) {
	          finishWorkerTask(task);
	          if (task.terminated) {
	            return;
	          }
	          throw reason;
	        });
	      });
	    });
	    handler.on('Cleanup', function wphCleanup(data) {
	      return pdfManager.cleanup();
	    });
	    handler.on('Terminate', function wphTerminate(data) {
	      terminated = true;
	      if (pdfManager) {
	        pdfManager.terminate();
	        pdfManager = null;
	      }
	      if (cancelXHRs) {
	        cancelXHRs();
	      }
	      var waitOn = [];
	      WorkerTasks.forEach(function (task) {
	        waitOn.push(task.finished);
	        task.terminate();
	      });
	      return Promise.all(waitOn).then(function () {
	        handler.destroy();
	        handler = null;
	      });
	    });
	    handler.on('Ready', function wphReady(data) {
	      setupDoc(docParams);
	      docParams = null;
	    });
	    return workerHandlerName;
	  },
	  initializeFromPort: function initializeFromPort(port) {
	    var handler = new MessageHandler('worker', 'main', port);
	    WorkerMessageHandler.setup(handler, port);
	    handler.send('ready', null);
	  }
	};
	function isMessagePort(maybePort) {
	  return typeof maybePort.postMessage === 'function' && 'onmessage' in maybePort;
	}
	if (typeof window === 'undefined' && !isNodeJS() && typeof self !== 'undefined' && isMessagePort(self)) {
	  WorkerMessageHandler.initializeFromPort(self);
	}
	exports.setPDFNetworkStreamClass = setPDFNetworkStreamClass;
	exports.WorkerTask = WorkerTask;
	exports.WorkerMessageHandler = WorkerMessageHandler;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var g;
	g = function () {
	  return this;
	}();
	try {
	  g = g || Function("return this")() || (1, eval)("this");
	} catch (e) {
	  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
	}
	module.exports = g;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ArithmeticDecoder = function ArithmeticDecoderClosure() {
	  var QeTable = [{
	    qe: 0x5601,
	    nmps: 1,
	    nlps: 1,
	    switchFlag: 1
	  }, {
	    qe: 0x3401,
	    nmps: 2,
	    nlps: 6,
	    switchFlag: 0
	  }, {
	    qe: 0x1801,
	    nmps: 3,
	    nlps: 9,
	    switchFlag: 0
	  }, {
	    qe: 0x0AC1,
	    nmps: 4,
	    nlps: 12,
	    switchFlag: 0
	  }, {
	    qe: 0x0521,
	    nmps: 5,
	    nlps: 29,
	    switchFlag: 0
	  }, {
	    qe: 0x0221,
	    nmps: 38,
	    nlps: 33,
	    switchFlag: 0
	  }, {
	    qe: 0x5601,
	    nmps: 7,
	    nlps: 6,
	    switchFlag: 1
	  }, {
	    qe: 0x5401,
	    nmps: 8,
	    nlps: 14,
	    switchFlag: 0
	  }, {
	    qe: 0x4801,
	    nmps: 9,
	    nlps: 14,
	    switchFlag: 0
	  }, {
	    qe: 0x3801,
	    nmps: 10,
	    nlps: 14,
	    switchFlag: 0
	  }, {
	    qe: 0x3001,
	    nmps: 11,
	    nlps: 17,
	    switchFlag: 0
	  }, {
	    qe: 0x2401,
	    nmps: 12,
	    nlps: 18,
	    switchFlag: 0
	  }, {
	    qe: 0x1C01,
	    nmps: 13,
	    nlps: 20,
	    switchFlag: 0
	  }, {
	    qe: 0x1601,
	    nmps: 29,
	    nlps: 21,
	    switchFlag: 0
	  }, {
	    qe: 0x5601,
	    nmps: 15,
	    nlps: 14,
	    switchFlag: 1
	  }, {
	    qe: 0x5401,
	    nmps: 16,
	    nlps: 14,
	    switchFlag: 0
	  }, {
	    qe: 0x5101,
	    nmps: 17,
	    nlps: 15,
	    switchFlag: 0
	  }, {
	    qe: 0x4801,
	    nmps: 18,
	    nlps: 16,
	    switchFlag: 0
	  }, {
	    qe: 0x3801,
	    nmps: 19,
	    nlps: 17,
	    switchFlag: 0
	  }, {
	    qe: 0x3401,
	    nmps: 20,
	    nlps: 18,
	    switchFlag: 0
	  }, {
	    qe: 0x3001,
	    nmps: 21,
	    nlps: 19,
	    switchFlag: 0
	  }, {
	    qe: 0x2801,
	    nmps: 22,
	    nlps: 19,
	    switchFlag: 0
	  }, {
	    qe: 0x2401,
	    nmps: 23,
	    nlps: 20,
	    switchFlag: 0
	  }, {
	    qe: 0x2201,
	    nmps: 24,
	    nlps: 21,
	    switchFlag: 0
	  }, {
	    qe: 0x1C01,
	    nmps: 25,
	    nlps: 22,
	    switchFlag: 0
	  }, {
	    qe: 0x1801,
	    nmps: 26,
	    nlps: 23,
	    switchFlag: 0
	  }, {
	    qe: 0x1601,
	    nmps: 27,
	    nlps: 24,
	    switchFlag: 0
	  }, {
	    qe: 0x1401,
	    nmps: 28,
	    nlps: 25,
	    switchFlag: 0
	  }, {
	    qe: 0x1201,
	    nmps: 29,
	    nlps: 26,
	    switchFlag: 0
	  }, {
	    qe: 0x1101,
	    nmps: 30,
	    nlps: 27,
	    switchFlag: 0
	  }, {
	    qe: 0x0AC1,
	    nmps: 31,
	    nlps: 28,
	    switchFlag: 0
	  }, {
	    qe: 0x09C1,
	    nmps: 32,
	    nlps: 29,
	    switchFlag: 0
	  }, {
	    qe: 0x08A1,
	    nmps: 33,
	    nlps: 30,
	    switchFlag: 0
	  }, {
	    qe: 0x0521,
	    nmps: 34,
	    nlps: 31,
	    switchFlag: 0
	  }, {
	    qe: 0x0441,
	    nmps: 35,
	    nlps: 32,
	    switchFlag: 0
	  }, {
	    qe: 0x02A1,
	    nmps: 36,
	    nlps: 33,
	    switchFlag: 0
	  }, {
	    qe: 0x0221,
	    nmps: 37,
	    nlps: 34,
	    switchFlag: 0
	  }, {
	    qe: 0x0141,
	    nmps: 38,
	    nlps: 35,
	    switchFlag: 0
	  }, {
	    qe: 0x0111,
	    nmps: 39,
	    nlps: 36,
	    switchFlag: 0
	  }, {
	    qe: 0x0085,
	    nmps: 40,
	    nlps: 37,
	    switchFlag: 0
	  }, {
	    qe: 0x0049,
	    nmps: 41,
	    nlps: 38,
	    switchFlag: 0
	  }, {
	    qe: 0x0025,
	    nmps: 42,
	    nlps: 39,
	    switchFlag: 0
	  }, {
	    qe: 0x0015,
	    nmps: 43,
	    nlps: 40,
	    switchFlag: 0
	  }, {
	    qe: 0x0009,
	    nmps: 44,
	    nlps: 41,
	    switchFlag: 0
	  }, {
	    qe: 0x0005,
	    nmps: 45,
	    nlps: 42,
	    switchFlag: 0
	  }, {
	    qe: 0x0001,
	    nmps: 45,
	    nlps: 43,
	    switchFlag: 0
	  }, {
	    qe: 0x5601,
	    nmps: 46,
	    nlps: 46,
	    switchFlag: 0
	  }];
	  function ArithmeticDecoder(data, start, end) {
	    this.data = data;
	    this.bp = start;
	    this.dataEnd = end;
	    this.chigh = data[start];
	    this.clow = 0;
	    this.byteIn();
	    this.chigh = this.chigh << 7 & 0xFFFF | this.clow >> 9 & 0x7F;
	    this.clow = this.clow << 7 & 0xFFFF;
	    this.ct -= 7;
	    this.a = 0x8000;
	  }
	  ArithmeticDecoder.prototype = {
	    byteIn: function ArithmeticDecoder_byteIn() {
	      var data = this.data;
	      var bp = this.bp;
	      if (data[bp] === 0xFF) {
	        var b1 = data[bp + 1];
	        if (b1 > 0x8F) {
	          this.clow += 0xFF00;
	          this.ct = 8;
	        } else {
	          bp++;
	          this.clow += data[bp] << 9;
	          this.ct = 7;
	          this.bp = bp;
	        }
	      } else {
	        bp++;
	        this.clow += bp < this.dataEnd ? data[bp] << 8 : 0xFF00;
	        this.ct = 8;
	        this.bp = bp;
	      }
	      if (this.clow > 0xFFFF) {
	        this.chigh += this.clow >> 16;
	        this.clow &= 0xFFFF;
	      }
	    },
	    readBit: function ArithmeticDecoder_readBit(contexts, pos) {
	      var cx_index = contexts[pos] >> 1,
	          cx_mps = contexts[pos] & 1;
	      var qeTableIcx = QeTable[cx_index];
	      var qeIcx = qeTableIcx.qe;
	      var d;
	      var a = this.a - qeIcx;
	      if (this.chigh < qeIcx) {
	        if (a < qeIcx) {
	          a = qeIcx;
	          d = cx_mps;
	          cx_index = qeTableIcx.nmps;
	        } else {
	          a = qeIcx;
	          d = 1 ^ cx_mps;
	          if (qeTableIcx.switchFlag === 1) {
	            cx_mps = d;
	          }
	          cx_index = qeTableIcx.nlps;
	        }
	      } else {
	        this.chigh -= qeIcx;
	        if ((a & 0x8000) !== 0) {
	          this.a = a;
	          return cx_mps;
	        }
	        if (a < qeIcx) {
	          d = 1 ^ cx_mps;
	          if (qeTableIcx.switchFlag === 1) {
	            cx_mps = d;
	          }
	          cx_index = qeTableIcx.nlps;
	        } else {
	          d = cx_mps;
	          cx_index = qeTableIcx.nmps;
	        }
	      }
	      do {
	        if (this.ct === 0) {
	          this.byteIn();
	        }
	        a <<= 1;
	        this.chigh = this.chigh << 1 & 0xFFFF | this.clow >> 15 & 1;
	        this.clow = this.clow << 1 & 0xFFFF;
	        this.ct--;
	      } while ((a & 0x8000) === 0);
	      this.a = a;
	      contexts[pos] = cx_index << 1 | cx_mps;
	      return d;
	    }
	  };
	  return ArithmeticDecoder;
	}();
	exports.ArithmeticDecoder = ArithmeticDecoder;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var coreCharsets = __w_pdfjs_require__(22);
	var coreEncodings = __w_pdfjs_require__(4);
	var error = sharedUtil.error;
	var info = sharedUtil.info;
	var bytesToString = sharedUtil.bytesToString;
	var warn = sharedUtil.warn;
	var isArray = sharedUtil.isArray;
	var Util = sharedUtil.Util;
	var stringToBytes = sharedUtil.stringToBytes;
	var assert = sharedUtil.assert;
	var ISOAdobeCharset = coreCharsets.ISOAdobeCharset;
	var ExpertCharset = coreCharsets.ExpertCharset;
	var ExpertSubsetCharset = coreCharsets.ExpertSubsetCharset;
	var StandardEncoding = coreEncodings.StandardEncoding;
	var ExpertEncoding = coreEncodings.ExpertEncoding;
	var MAX_SUBR_NESTING = 10;
	var CFFStandardStrings = ['.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', 'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE', 'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu', 'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn', 'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright', 'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex', 'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute', 'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute', 'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute', 'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave', 'yacute', 'ydieresis', 'zcaron', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', 'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall', '001.000', '001.001', '001.002', '001.003', 'Black', 'Bold', 'Book', 'Light', 'Medium', 'Regular', 'Roman', 'Semibold'];
	var CFFParser = function CFFParserClosure() {
	  var CharstringValidationData = [null, {
	    id: 'hstem',
	    min: 2,
	    stackClearing: true,
	    stem: true
	  }, null, {
	    id: 'vstem',
	    min: 2,
	    stackClearing: true,
	    stem: true
	  }, {
	    id: 'vmoveto',
	    min: 1,
	    stackClearing: true
	  }, {
	    id: 'rlineto',
	    min: 2,
	    resetStack: true
	  }, {
	    id: 'hlineto',
	    min: 1,
	    resetStack: true
	  }, {
	    id: 'vlineto',
	    min: 1,
	    resetStack: true
	  }, {
	    id: 'rrcurveto',
	    min: 6,
	    resetStack: true
	  }, null, {
	    id: 'callsubr',
	    min: 1,
	    undefStack: true
	  }, {
	    id: 'return',
	    min: 0,
	    undefStack: true
	  }, null, null, {
	    id: 'endchar',
	    min: 0,
	    stackClearing: true
	  }, null, null, null, {
	    id: 'hstemhm',
	    min: 2,
	    stackClearing: true,
	    stem: true
	  }, {
	    id: 'hintmask',
	    min: 0,
	    stackClearing: true
	  }, {
	    id: 'cntrmask',
	    min: 0,
	    stackClearing: true
	  }, {
	    id: 'rmoveto',
	    min: 2,
	    stackClearing: true
	  }, {
	    id: 'hmoveto',
	    min: 1,
	    stackClearing: true
	  }, {
	    id: 'vstemhm',
	    min: 2,
	    stackClearing: true,
	    stem: true
	  }, {
	    id: 'rcurveline',
	    min: 8,
	    resetStack: true
	  }, {
	    id: 'rlinecurve',
	    min: 8,
	    resetStack: true
	  }, {
	    id: 'vvcurveto',
	    min: 4,
	    resetStack: true
	  }, {
	    id: 'hhcurveto',
	    min: 4,
	    resetStack: true
	  }, null, {
	    id: 'callgsubr',
	    min: 1,
	    undefStack: true
	  }, {
	    id: 'vhcurveto',
	    min: 4,
	    resetStack: true
	  }, {
	    id: 'hvcurveto',
	    min: 4,
	    resetStack: true
	  }];
	  var CharstringValidationData12 = [null, null, null, {
	    id: 'and',
	    min: 2,
	    stackDelta: -1
	  }, {
	    id: 'or',
	    min: 2,
	    stackDelta: -1
	  }, {
	    id: 'not',
	    min: 1,
	    stackDelta: 0
	  }, null, null, null, {
	    id: 'abs',
	    min: 1,
	    stackDelta: 0
	  }, {
	    id: 'add',
	    min: 2,
	    stackDelta: -1,
	    stackFn: function stack_div(stack, index) {
	      stack[index - 2] = stack[index - 2] + stack[index - 1];
	    }
	  }, {
	    id: 'sub',
	    min: 2,
	    stackDelta: -1,
	    stackFn: function stack_div(stack, index) {
	      stack[index - 2] = stack[index - 2] - stack[index - 1];
	    }
	  }, {
	    id: 'div',
	    min: 2,
	    stackDelta: -1,
	    stackFn: function stack_div(stack, index) {
	      stack[index - 2] = stack[index - 2] / stack[index - 1];
	    }
	  }, null, {
	    id: 'neg',
	    min: 1,
	    stackDelta: 0,
	    stackFn: function stack_div(stack, index) {
	      stack[index - 1] = -stack[index - 1];
	    }
	  }, {
	    id: 'eq',
	    min: 2,
	    stackDelta: -1
	  }, null, null, {
	    id: 'drop',
	    min: 1,
	    stackDelta: -1
	  }, null, {
	    id: 'put',
	    min: 2,
	    stackDelta: -2
	  }, {
	    id: 'get',
	    min: 1,
	    stackDelta: 0
	  }, {
	    id: 'ifelse',
	    min: 4,
	    stackDelta: -3
	  }, {
	    id: 'random',
	    min: 0,
	    stackDelta: 1
	  }, {
	    id: 'mul',
	    min: 2,
	    stackDelta: -1,
	    stackFn: function stack_div(stack, index) {
	      stack[index - 2] = stack[index - 2] * stack[index - 1];
	    }
	  }, null, {
	    id: 'sqrt',
	    min: 1,
	    stackDelta: 0
	  }, {
	    id: 'dup',
	    min: 1,
	    stackDelta: 1
	  }, {
	    id: 'exch',
	    min: 2,
	    stackDelta: 0
	  }, {
	    id: 'index',
	    min: 2,
	    stackDelta: 0
	  }, {
	    id: 'roll',
	    min: 3,
	    stackDelta: -2
	  }, null, null, null, {
	    id: 'hflex',
	    min: 7,
	    resetStack: true
	  }, {
	    id: 'flex',
	    min: 13,
	    resetStack: true
	  }, {
	    id: 'hflex1',
	    min: 9,
	    resetStack: true
	  }, {
	    id: 'flex1',
	    min: 11,
	    resetStack: true
	  }];
	  function CFFParser(file, properties, seacAnalysisEnabled) {
	    this.bytes = file.getBytes();
	    this.properties = properties;
	    this.seacAnalysisEnabled = !!seacAnalysisEnabled;
	  }
	  CFFParser.prototype = {
	    parse: function CFFParser_parse() {
	      var properties = this.properties;
	      var cff = new CFF();
	      this.cff = cff;
	      var header = this.parseHeader();
	      var nameIndex = this.parseIndex(header.endPos);
	      var topDictIndex = this.parseIndex(nameIndex.endPos);
	      var stringIndex = this.parseIndex(topDictIndex.endPos);
	      var globalSubrIndex = this.parseIndex(stringIndex.endPos);
	      var topDictParsed = this.parseDict(topDictIndex.obj.get(0));
	      var topDict = this.createDict(CFFTopDict, topDictParsed, cff.strings);
	      cff.header = header.obj;
	      cff.names = this.parseNameIndex(nameIndex.obj);
	      cff.strings = this.parseStringIndex(stringIndex.obj);
	      cff.topDict = topDict;
	      cff.globalSubrIndex = globalSubrIndex.obj;
	      this.parsePrivateDict(cff.topDict);
	      cff.isCIDFont = topDict.hasName('ROS');
	      var charStringOffset = topDict.getByName('CharStrings');
	      var charStringIndex = this.parseIndex(charStringOffset).obj;
	      var fontMatrix = topDict.getByName('FontMatrix');
	      if (fontMatrix) {
	        properties.fontMatrix = fontMatrix;
	      }
	      var fontBBox = topDict.getByName('FontBBox');
	      if (fontBBox) {
	        properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
	        properties.descent = Math.min(fontBBox[1], fontBBox[3]);
	        properties.ascentScaled = true;
	      }
	      var charset, encoding;
	      if (cff.isCIDFont) {
	        var fdArrayIndex = this.parseIndex(topDict.getByName('FDArray')).obj;
	        for (var i = 0, ii = fdArrayIndex.count; i < ii; ++i) {
	          var dictRaw = fdArrayIndex.get(i);
	          var fontDict = this.createDict(CFFTopDict, this.parseDict(dictRaw), cff.strings);
	          this.parsePrivateDict(fontDict);
	          cff.fdArray.push(fontDict);
	        }
	        encoding = null;
	        charset = this.parseCharsets(topDict.getByName('charset'), charStringIndex.count, cff.strings, true);
	        cff.fdSelect = this.parseFDSelect(topDict.getByName('FDSelect'), charStringIndex.count);
	      } else {
	        charset = this.parseCharsets(topDict.getByName('charset'), charStringIndex.count, cff.strings, false);
	        encoding = this.parseEncoding(topDict.getByName('Encoding'), properties, cff.strings, charset.charset);
	      }
	      cff.charset = charset;
	      cff.encoding = encoding;
	      var charStringsAndSeacs = this.parseCharStrings(charStringIndex, topDict.privateDict.subrsIndex, globalSubrIndex.obj, cff.fdSelect, cff.fdArray);
	      cff.charStrings = charStringsAndSeacs.charStrings;
	      cff.seacs = charStringsAndSeacs.seacs;
	      cff.widths = charStringsAndSeacs.widths;
	      return cff;
	    },
	    parseHeader: function CFFParser_parseHeader() {
	      var bytes = this.bytes;
	      var bytesLength = bytes.length;
	      var offset = 0;
	      while (offset < bytesLength && bytes[offset] !== 1) {
	        ++offset;
	      }
	      if (offset >= bytesLength) {
	        error('Invalid CFF header');
	      } else if (offset !== 0) {
	        info('cff data is shifted');
	        bytes = bytes.subarray(offset);
	        this.bytes = bytes;
	      }
	      var major = bytes[0];
	      var minor = bytes[1];
	      var hdrSize = bytes[2];
	      var offSize = bytes[3];
	      var header = new CFFHeader(major, minor, hdrSize, offSize);
	      return {
	        obj: header,
	        endPos: hdrSize
	      };
	    },
	    parseDict: function CFFParser_parseDict(dict) {
	      var pos = 0;
	      function parseOperand() {
	        var value = dict[pos++];
	        if (value === 30) {
	          return parseFloatOperand();
	        } else if (value === 28) {
	          value = dict[pos++];
	          value = (value << 24 | dict[pos++] << 16) >> 16;
	          return value;
	        } else if (value === 29) {
	          value = dict[pos++];
	          value = value << 8 | dict[pos++];
	          value = value << 8 | dict[pos++];
	          value = value << 8 | dict[pos++];
	          return value;
	        } else if (value >= 32 && value <= 246) {
	          return value - 139;
	        } else if (value >= 247 && value <= 250) {
	          return (value - 247) * 256 + dict[pos++] + 108;
	        } else if (value >= 251 && value <= 254) {
	          return -((value - 251) * 256) - dict[pos++] - 108;
	        }
	        warn('CFFParser_parseDict: "' + value + '" is a reserved command.');
	        return NaN;
	      }
	      function parseFloatOperand() {
	        var str = '';
	        var eof = 15;
	        var lookup = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];
	        var length = dict.length;
	        while (pos < length) {
	          var b = dict[pos++];
	          var b1 = b >> 4;
	          var b2 = b & 15;
	          if (b1 === eof) {
	            break;
	          }
	          str += lookup[b1];
	          if (b2 === eof) {
	            break;
	          }
	          str += lookup[b2];
	        }
	        return parseFloat(str);
	      }
	      var operands = [];
	      var entries = [];
	      pos = 0;
	      var end = dict.length;
	      while (pos < end) {
	        var b = dict[pos];
	        if (b <= 21) {
	          if (b === 12) {
	            b = b << 8 | dict[++pos];
	          }
	          entries.push([b, operands]);
	          operands = [];
	          ++pos;
	        } else {
	          operands.push(parseOperand());
	        }
	      }
	      return entries;
	    },
	    parseIndex: function CFFParser_parseIndex(pos) {
	      var cffIndex = new CFFIndex();
	      var bytes = this.bytes;
	      var count = bytes[pos++] << 8 | bytes[pos++];
	      var offsets = [];
	      var end = pos;
	      var i, ii;
	      if (count !== 0) {
	        var offsetSize = bytes[pos++];
	        var startPos = pos + (count + 1) * offsetSize - 1;
	        for (i = 0, ii = count + 1; i < ii; ++i) {
	          var offset = 0;
	          for (var j = 0; j < offsetSize; ++j) {
	            offset <<= 8;
	            offset += bytes[pos++];
	          }
	          offsets.push(startPos + offset);
	        }
	        end = offsets[count];
	      }
	      for (i = 0, ii = offsets.length - 1; i < ii; ++i) {
	        var offsetStart = offsets[i];
	        var offsetEnd = offsets[i + 1];
	        cffIndex.add(bytes.subarray(offsetStart, offsetEnd));
	      }
	      return {
	        obj: cffIndex,
	        endPos: end
	      };
	    },
	    parseNameIndex: function CFFParser_parseNameIndex(index) {
	      var names = [];
	      for (var i = 0, ii = index.count; i < ii; ++i) {
	        var name = index.get(i);
	        var length = Math.min(name.length, 127);
	        var data = [];
	        for (var j = 0; j < length; ++j) {
	          var c = name[j];
	          if (j === 0 && c === 0) {
	            data[j] = c;
	            continue;
	          }
	          if (c < 33 || c > 126 || c === 91 || c === 93 || c === 40 || c === 41 || c === 123 || c === 125 || c === 60 || c === 62 || c === 47 || c === 37 || c === 35) {
	            data[j] = 95;
	            continue;
	          }
	          data[j] = c;
	        }
	        names.push(bytesToString(data));
	      }
	      return names;
	    },
	    parseStringIndex: function CFFParser_parseStringIndex(index) {
	      var strings = new CFFStrings();
	      for (var i = 0, ii = index.count; i < ii; ++i) {
	        var data = index.get(i);
	        strings.add(bytesToString(data));
	      }
	      return strings;
	    },
	    createDict: function CFFParser_createDict(Type, dict, strings) {
	      var cffDict = new Type(strings);
	      for (var i = 0, ii = dict.length; i < ii; ++i) {
	        var pair = dict[i];
	        var key = pair[0];
	        var value = pair[1];
	        cffDict.setByKey(key, value);
	      }
	      return cffDict;
	    },
	    parseCharString: function CFFParser_parseCharString(state, data, localSubrIndex, globalSubrIndex) {
	      if (!data || state.callDepth > MAX_SUBR_NESTING) {
	        return false;
	      }
	      var stackSize = state.stackSize;
	      var stack = state.stack;
	      var length = data.length;
	      for (var j = 0; j < length;) {
	        var value = data[j++];
	        var validationCommand = null;
	        if (value === 12) {
	          var q = data[j++];
	          if (q === 0) {
	            data[j - 2] = 139;
	            data[j - 1] = 22;
	            stackSize = 0;
	          } else {
	            validationCommand = CharstringValidationData12[q];
	          }
	        } else if (value === 28) {
	          stack[stackSize] = (data[j] << 24 | data[j + 1] << 16) >> 16;
	          j += 2;
	          stackSize++;
	        } else if (value === 14) {
	          if (stackSize >= 4) {
	            stackSize -= 4;
	            if (this.seacAnalysisEnabled) {
	              state.seac = stack.slice(stackSize, stackSize + 4);
	              return false;
	            }
	          }
	          validationCommand = CharstringValidationData[value];
	        } else if (value >= 32 && value <= 246) {
	          stack[stackSize] = value - 139;
	          stackSize++;
	        } else if (value >= 247 && value <= 254) {
	          stack[stackSize] = value < 251 ? (value - 247 << 8) + data[j] + 108 : -(value - 251 << 8) - data[j] - 108;
	          j++;
	          stackSize++;
	        } else if (value === 255) {
	          stack[stackSize] = (data[j] << 24 | data[j + 1] << 16 | data[j + 2] << 8 | data[j + 3]) / 65536;
	          j += 4;
	          stackSize++;
	        } else if (value === 19 || value === 20) {
	          state.hints += stackSize >> 1;
	          j += state.hints + 7 >> 3;
	          stackSize %= 2;
	          validationCommand = CharstringValidationData[value];
	        } else if (value === 10 || value === 29) {
	          var subrsIndex;
	          if (value === 10) {
	            subrsIndex = localSubrIndex;
	          } else {
	            subrsIndex = globalSubrIndex;
	          }
	          if (!subrsIndex) {
	            validationCommand = CharstringValidationData[value];
	            warn('Missing subrsIndex for ' + validationCommand.id);
	            return false;
	          }
	          var bias = 32768;
	          if (subrsIndex.count < 1240) {
	            bias = 107;
	          } else if (subrsIndex.count < 33900) {
	            bias = 1131;
	          }
	          var subrNumber = stack[--stackSize] + bias;
	          if (subrNumber < 0 || subrNumber >= subrsIndex.count || isNaN(subrNumber)) {
	            validationCommand = CharstringValidationData[value];
	            warn('Out of bounds subrIndex for ' + validationCommand.id);
	            return false;
	          }
	          state.stackSize = stackSize;
	          state.callDepth++;
	          var valid = this.parseCharString(state, subrsIndex.get(subrNumber), localSubrIndex, globalSubrIndex);
	          if (!valid) {
	            return false;
	          }
	          state.callDepth--;
	          stackSize = state.stackSize;
	          continue;
	        } else if (value === 11) {
	          state.stackSize = stackSize;
	          return true;
	        } else {
	          validationCommand = CharstringValidationData[value];
	        }
	        if (validationCommand) {
	          if (validationCommand.stem) {
	            state.hints += stackSize >> 1;
	          }
	          if ('min' in validationCommand) {
	            if (!state.undefStack && stackSize < validationCommand.min) {
	              warn('Not enough parameters for ' + validationCommand.id + '; actual: ' + stackSize + ', expected: ' + validationCommand.min);
	              return false;
	            }
	          }
	          if (state.firstStackClearing && validationCommand.stackClearing) {
	            state.firstStackClearing = false;
	            stackSize -= validationCommand.min;
	            if (stackSize >= 2 && validationCommand.stem) {
	              stackSize %= 2;
	            } else if (stackSize > 1) {
	              warn('Found too many parameters for stack-clearing command');
	            }
	            if (stackSize > 0 && stack[stackSize - 1] >= 0) {
	              state.width = stack[stackSize - 1];
	            }
	          }
	          if ('stackDelta' in validationCommand) {
	            if ('stackFn' in validationCommand) {
	              validationCommand.stackFn(stack, stackSize);
	            }
	            stackSize += validationCommand.stackDelta;
	          } else if (validationCommand.stackClearing) {
	            stackSize = 0;
	          } else if (validationCommand.resetStack) {
	            stackSize = 0;
	            state.undefStack = false;
	          } else if (validationCommand.undefStack) {
	            stackSize = 0;
	            state.undefStack = true;
	            state.firstStackClearing = false;
	          }
	        }
	      }
	      state.stackSize = stackSize;
	      return true;
	    },
	    parseCharStrings: function CFFParser_parseCharStrings(charStrings, localSubrIndex, globalSubrIndex, fdSelect, fdArray) {
	      var seacs = [];
	      var widths = [];
	      var count = charStrings.count;
	      for (var i = 0; i < count; i++) {
	        var charstring = charStrings.get(i);
	        var state = {
	          callDepth: 0,
	          stackSize: 0,
	          stack: [],
	          undefStack: true,
	          hints: 0,
	          firstStackClearing: true,
	          seac: null,
	          width: null
	        };
	        var valid = true;
	        var localSubrToUse = null;
	        if (fdSelect && fdArray.length) {
	          var fdIndex = fdSelect.getFDIndex(i);
	          if (fdIndex === -1) {
	            warn('Glyph index is not in fd select.');
	            valid = false;
	          }
	          if (fdIndex >= fdArray.length) {
	            warn('Invalid fd index for glyph index.');
	            valid = false;
	          }
	          if (valid) {
	            localSubrToUse = fdArray[fdIndex].privateDict.subrsIndex;
	          }
	        } else if (localSubrIndex) {
	          localSubrToUse = localSubrIndex;
	        }
	        if (valid) {
	          valid = this.parseCharString(state, charstring, localSubrToUse, globalSubrIndex);
	        }
	        if (state.width !== null) {
	          widths[i] = state.width;
	        }
	        if (state.seac !== null) {
	          seacs[i] = state.seac;
	        }
	        if (!valid) {
	          charStrings.set(i, new Uint8Array([14]));
	        }
	      }
	      return {
	        charStrings: charStrings,
	        seacs: seacs,
	        widths: widths
	      };
	    },
	    emptyPrivateDictionary: function CFFParser_emptyPrivateDictionary(parentDict) {
	      var privateDict = this.createDict(CFFPrivateDict, [], parentDict.strings);
	      parentDict.setByKey(18, [0, 0]);
	      parentDict.privateDict = privateDict;
	    },
	    parsePrivateDict: function CFFParser_parsePrivateDict(parentDict) {
	      if (!parentDict.hasName('Private')) {
	        this.emptyPrivateDictionary(parentDict);
	        return;
	      }
	      var privateOffset = parentDict.getByName('Private');
	      if (!isArray(privateOffset) || privateOffset.length !== 2) {
	        parentDict.removeByName('Private');
	        return;
	      }
	      var size = privateOffset[0];
	      var offset = privateOffset[1];
	      if (size === 0 || offset >= this.bytes.length) {
	        this.emptyPrivateDictionary(parentDict);
	        return;
	      }
	      var privateDictEnd = offset + size;
	      var dictData = this.bytes.subarray(offset, privateDictEnd);
	      var dict = this.parseDict(dictData);
	      var privateDict = this.createDict(CFFPrivateDict, dict, parentDict.strings);
	      parentDict.privateDict = privateDict;
	      if (!privateDict.getByName('Subrs')) {
	        return;
	      }
	      var subrsOffset = privateDict.getByName('Subrs');
	      var relativeOffset = offset + subrsOffset;
	      if (subrsOffset === 0 || relativeOffset >= this.bytes.length) {
	        this.emptyPrivateDictionary(parentDict);
	        return;
	      }
	      var subrsIndex = this.parseIndex(relativeOffset);
	      privateDict.subrsIndex = subrsIndex.obj;
	    },
	    parseCharsets: function CFFParser_parseCharsets(pos, length, strings, cid) {
	      if (pos === 0) {
	        return new CFFCharset(true, CFFCharsetPredefinedTypes.ISO_ADOBE, ISOAdobeCharset);
	      } else if (pos === 1) {
	        return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT, ExpertCharset);
	      } else if (pos === 2) {
	        return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT_SUBSET, ExpertSubsetCharset);
	      }
	      var bytes = this.bytes;
	      var start = pos;
	      var format = bytes[pos++];
	      var charset = ['.notdef'];
	      var id, count, i;
	      length -= 1;
	      switch (format) {
	        case 0:
	          for (i = 0; i < length; i++) {
	            id = bytes[pos++] << 8 | bytes[pos++];
	            charset.push(cid ? id : strings.get(id));
	          }
	          break;
	        case 1:
	          while (charset.length <= length) {
	            id = bytes[pos++] << 8 | bytes[pos++];
	            count = bytes[pos++];
	            for (i = 0; i <= count; i++) {
	              charset.push(cid ? id++ : strings.get(id++));
	            }
	          }
	          break;
	        case 2:
	          while (charset.length <= length) {
	            id = bytes[pos++] << 8 | bytes[pos++];
	            count = bytes[pos++] << 8 | bytes[pos++];
	            for (i = 0; i <= count; i++) {
	              charset.push(cid ? id++ : strings.get(id++));
	            }
	          }
	          break;
	        default:
	          error('Unknown charset format');
	      }
	      var end = pos;
	      var raw = bytes.subarray(start, end);
	      return new CFFCharset(false, format, charset, raw);
	    },
	    parseEncoding: function CFFParser_parseEncoding(pos, properties, strings, charset) {
	      var encoding = Object.create(null);
	      var bytes = this.bytes;
	      var predefined = false;
	      var format, i, ii;
	      var raw = null;
	      function readSupplement() {
	        var supplementsCount = bytes[pos++];
	        for (i = 0; i < supplementsCount; i++) {
	          var code = bytes[pos++];
	          var sid = (bytes[pos++] << 8) + (bytes[pos++] & 0xff);
	          encoding[code] = charset.indexOf(strings.get(sid));
	        }
	      }
	      if (pos === 0 || pos === 1) {
	        predefined = true;
	        format = pos;
	        var baseEncoding = pos ? ExpertEncoding : StandardEncoding;
	        for (i = 0, ii = charset.length; i < ii; i++) {
	          var index = baseEncoding.indexOf(charset[i]);
	          if (index !== -1) {
	            encoding[index] = i;
	          }
	        }
	      } else {
	        var dataStart = pos;
	        format = bytes[pos++];
	        switch (format & 0x7f) {
	          case 0:
	            var glyphsCount = bytes[pos++];
	            for (i = 1; i <= glyphsCount; i++) {
	              encoding[bytes[pos++]] = i;
	            }
	            break;
	          case 1:
	            var rangesCount = bytes[pos++];
	            var gid = 1;
	            for (i = 0; i < rangesCount; i++) {
	              var start = bytes[pos++];
	              var left = bytes[pos++];
	              for (var j = start; j <= start + left; j++) {
	                encoding[j] = gid++;
	              }
	            }
	            break;
	          default:
	            error('Unknown encoding format: ' + format + ' in CFF');
	            break;
	        }
	        var dataEnd = pos;
	        if (format & 0x80) {
	          bytes[dataStart] &= 0x7f;
	          readSupplement();
	        }
	        raw = bytes.subarray(dataStart, dataEnd);
	      }
	      format = format & 0x7f;
	      return new CFFEncoding(predefined, format, encoding, raw);
	    },
	    parseFDSelect: function CFFParser_parseFDSelect(pos, length) {
	      var start = pos;
	      var bytes = this.bytes;
	      var format = bytes[pos++];
	      var fdSelect = [],
	          rawBytes;
	      var i,
	          invalidFirstGID = false;
	      switch (format) {
	        case 0:
	          for (i = 0; i < length; ++i) {
	            var id = bytes[pos++];
	            fdSelect.push(id);
	          }
	          rawBytes = bytes.subarray(start, pos);
	          break;
	        case 3:
	          var rangesCount = bytes[pos++] << 8 | bytes[pos++];
	          for (i = 0; i < rangesCount; ++i) {
	            var first = bytes[pos++] << 8 | bytes[pos++];
	            if (i === 0 && first !== 0) {
	              warn('parseFDSelect: The first range must have a first GID of 0' + ' -- trying to recover.');
	              invalidFirstGID = true;
	              first = 0;
	            }
	            var fdIndex = bytes[pos++];
	            var next = bytes[pos] << 8 | bytes[pos + 1];
	            for (var j = first; j < next; ++j) {
	              fdSelect.push(fdIndex);
	            }
	          }
	          pos += 2;
	          rawBytes = bytes.subarray(start, pos);
	          if (invalidFirstGID) {
	            rawBytes[3] = rawBytes[4] = 0;
	          }
	          break;
	        default:
	          error('parseFDSelect: Unknown format "' + format + '".');
	          break;
	      }
	      assert(fdSelect.length === length, 'parseFDSelect: Invalid font data.');
	      return new CFFFDSelect(fdSelect, rawBytes);
	    }
	  };
	  return CFFParser;
	}();
	var CFF = function CFFClosure() {
	  function CFF() {
	    this.header = null;
	    this.names = [];
	    this.topDict = null;
	    this.strings = new CFFStrings();
	    this.globalSubrIndex = null;
	    this.encoding = null;
	    this.charset = null;
	    this.charStrings = null;
	    this.fdArray = [];
	    this.fdSelect = null;
	    this.isCIDFont = false;
	  }
	  return CFF;
	}();
	var CFFHeader = function CFFHeaderClosure() {
	  function CFFHeader(major, minor, hdrSize, offSize) {
	    this.major = major;
	    this.minor = minor;
	    this.hdrSize = hdrSize;
	    this.offSize = offSize;
	  }
	  return CFFHeader;
	}();
	var CFFStrings = function CFFStringsClosure() {
	  function CFFStrings() {
	    this.strings = [];
	  }
	  CFFStrings.prototype = {
	    get: function CFFStrings_get(index) {
	      if (index >= 0 && index <= 390) {
	        return CFFStandardStrings[index];
	      }
	      if (index - 391 <= this.strings.length) {
	        return this.strings[index - 391];
	      }
	      return CFFStandardStrings[0];
	    },
	    add: function CFFStrings_add(value) {
	      this.strings.push(value);
	    },
	    get count() {
	      return this.strings.length;
	    }
	  };
	  return CFFStrings;
	}();
	var CFFIndex = function CFFIndexClosure() {
	  function CFFIndex() {
	    this.objects = [];
	    this.length = 0;
	  }
	  CFFIndex.prototype = {
	    add: function CFFIndex_add(data) {
	      this.length += data.length;
	      this.objects.push(data);
	    },
	    set: function CFFIndex_set(index, data) {
	      this.length += data.length - this.objects[index].length;
	      this.objects[index] = data;
	    },
	    get: function CFFIndex_get(index) {
	      return this.objects[index];
	    },
	    get count() {
	      return this.objects.length;
	    }
	  };
	  return CFFIndex;
	}();
	var CFFDict = function CFFDictClosure() {
	  function CFFDict(tables, strings) {
	    this.keyToNameMap = tables.keyToNameMap;
	    this.nameToKeyMap = tables.nameToKeyMap;
	    this.defaults = tables.defaults;
	    this.types = tables.types;
	    this.opcodes = tables.opcodes;
	    this.order = tables.order;
	    this.strings = strings;
	    this.values = Object.create(null);
	  }
	  CFFDict.prototype = {
	    setByKey: function CFFDict_setByKey(key, value) {
	      if (!(key in this.keyToNameMap)) {
	        return false;
	      }
	      var valueLength = value.length;
	      if (valueLength === 0) {
	        return true;
	      }
	      for (var i = 0; i < valueLength; i++) {
	        if (isNaN(value[i])) {
	          warn('Invalid CFFDict value: "' + value + '" for key "' + key + '".');
	          return true;
	        }
	      }
	      var type = this.types[key];
	      if (type === 'num' || type === 'sid' || type === 'offset') {
	        value = value[0];
	      }
	      this.values[key] = value;
	      return true;
	    },
	    setByName: function CFFDict_setByName(name, value) {
	      if (!(name in this.nameToKeyMap)) {
	        error('Invalid dictionary name "' + name + '"');
	      }
	      this.values[this.nameToKeyMap[name]] = value;
	    },
	    hasName: function CFFDict_hasName(name) {
	      return this.nameToKeyMap[name] in this.values;
	    },
	    getByName: function CFFDict_getByName(name) {
	      if (!(name in this.nameToKeyMap)) {
	        error('Invalid dictionary name "' + name + '"');
	      }
	      var key = this.nameToKeyMap[name];
	      if (!(key in this.values)) {
	        return this.defaults[key];
	      }
	      return this.values[key];
	    },
	    removeByName: function CFFDict_removeByName(name) {
	      delete this.values[this.nameToKeyMap[name]];
	    }
	  };
	  CFFDict.createTables = function CFFDict_createTables(layout) {
	    var tables = {
	      keyToNameMap: {},
	      nameToKeyMap: {},
	      defaults: {},
	      types: {},
	      opcodes: {},
	      order: []
	    };
	    for (var i = 0, ii = layout.length; i < ii; ++i) {
	      var entry = layout[i];
	      var key = isArray(entry[0]) ? (entry[0][0] << 8) + entry[0][1] : entry[0];
	      tables.keyToNameMap[key] = entry[1];
	      tables.nameToKeyMap[entry[1]] = key;
	      tables.types[key] = entry[2];
	      tables.defaults[key] = entry[3];
	      tables.opcodes[key] = isArray(entry[0]) ? entry[0] : [entry[0]];
	      tables.order.push(key);
	    }
	    return tables;
	  };
	  return CFFDict;
	}();
	var CFFTopDict = function CFFTopDictClosure() {
	  var layout = [[[12, 30], 'ROS', ['sid', 'sid', 'num'], null], [[12, 20], 'SyntheticBase', 'num', null], [0, 'version', 'sid', null], [1, 'Notice', 'sid', null], [[12, 0], 'Copyright', 'sid', null], [2, 'FullName', 'sid', null], [3, 'FamilyName', 'sid', null], [4, 'Weight', 'sid', null], [[12, 1], 'isFixedPitch', 'num', 0], [[12, 2], 'ItalicAngle', 'num', 0], [[12, 3], 'UnderlinePosition', 'num', -100], [[12, 4], 'UnderlineThickness', 'num', 50], [[12, 5], 'PaintType', 'num', 0], [[12, 6], 'CharstringType', 'num', 2], [[12, 7], 'FontMatrix', ['num', 'num', 'num', 'num', 'num', 'num'], [0.001, 0, 0, 0.001, 0, 0]], [13, 'UniqueID', 'num', null], [5, 'FontBBox', ['num', 'num', 'num', 'num'], [0, 0, 0, 0]], [[12, 8], 'StrokeWidth', 'num', 0], [14, 'XUID', 'array', null], [15, 'charset', 'offset', 0], [16, 'Encoding', 'offset', 0], [17, 'CharStrings', 'offset', 0], [18, 'Private', ['offset', 'offset'], null], [[12, 21], 'PostScript', 'sid', null], [[12, 22], 'BaseFontName', 'sid', null], [[12, 23], 'BaseFontBlend', 'delta', null], [[12, 31], 'CIDFontVersion', 'num', 0], [[12, 32], 'CIDFontRevision', 'num', 0], [[12, 33], 'CIDFontType', 'num', 0], [[12, 34], 'CIDCount', 'num', 8720], [[12, 35], 'UIDBase', 'num', null], [[12, 37], 'FDSelect', 'offset', null], [[12, 36], 'FDArray', 'offset', null], [[12, 38], 'FontName', 'sid', null]];
	  var tables = null;
	  function CFFTopDict(strings) {
	    if (tables === null) {
	      tables = CFFDict.createTables(layout);
	    }
	    CFFDict.call(this, tables, strings);
	    this.privateDict = null;
	  }
	  CFFTopDict.prototype = Object.create(CFFDict.prototype);
	  return CFFTopDict;
	}();
	var CFFPrivateDict = function CFFPrivateDictClosure() {
	  var layout = [[6, 'BlueValues', 'delta', null], [7, 'OtherBlues', 'delta', null], [8, 'FamilyBlues', 'delta', null], [9, 'FamilyOtherBlues', 'delta', null], [[12, 9], 'BlueScale', 'num', 0.039625], [[12, 10], 'BlueShift', 'num', 7], [[12, 11], 'BlueFuzz', 'num', 1], [10, 'StdHW', 'num', null], [11, 'StdVW', 'num', null], [[12, 12], 'StemSnapH', 'delta', null], [[12, 13], 'StemSnapV', 'delta', null], [[12, 14], 'ForceBold', 'num', 0], [[12, 17], 'LanguageGroup', 'num', 0], [[12, 18], 'ExpansionFactor', 'num', 0.06], [[12, 19], 'initialRandomSeed', 'num', 0], [20, 'defaultWidthX', 'num', 0], [21, 'nominalWidthX', 'num', 0], [19, 'Subrs', 'offset', null]];
	  var tables = null;
	  function CFFPrivateDict(strings) {
	    if (tables === null) {
	      tables = CFFDict.createTables(layout);
	    }
	    CFFDict.call(this, tables, strings);
	    this.subrsIndex = null;
	  }
	  CFFPrivateDict.prototype = Object.create(CFFDict.prototype);
	  return CFFPrivateDict;
	}();
	var CFFCharsetPredefinedTypes = {
	  ISO_ADOBE: 0,
	  EXPERT: 1,
	  EXPERT_SUBSET: 2
	};
	var CFFCharset = function CFFCharsetClosure() {
	  function CFFCharset(predefined, format, charset, raw) {
	    this.predefined = predefined;
	    this.format = format;
	    this.charset = charset;
	    this.raw = raw;
	  }
	  return CFFCharset;
	}();
	var CFFEncoding = function CFFEncodingClosure() {
	  function CFFEncoding(predefined, format, encoding, raw) {
	    this.predefined = predefined;
	    this.format = format;
	    this.encoding = encoding;
	    this.raw = raw;
	  }
	  return CFFEncoding;
	}();
	var CFFFDSelect = function CFFFDSelectClosure() {
	  function CFFFDSelect(fdSelect, raw) {
	    this.fdSelect = fdSelect;
	    this.raw = raw;
	  }
	  CFFFDSelect.prototype = {
	    getFDIndex: function CFFFDSelect_get(glyphIndex) {
	      if (glyphIndex < 0 || glyphIndex >= this.fdSelect.length) {
	        return -1;
	      }
	      return this.fdSelect[glyphIndex];
	    }
	  };
	  return CFFFDSelect;
	}();
	var CFFOffsetTracker = function CFFOffsetTrackerClosure() {
	  function CFFOffsetTracker() {
	    this.offsets = Object.create(null);
	  }
	  CFFOffsetTracker.prototype = {
	    isTracking: function CFFOffsetTracker_isTracking(key) {
	      return key in this.offsets;
	    },
	    track: function CFFOffsetTracker_track(key, location) {
	      if (key in this.offsets) {
	        error('Already tracking location of ' + key);
	      }
	      this.offsets[key] = location;
	    },
	    offset: function CFFOffsetTracker_offset(value) {
	      for (var key in this.offsets) {
	        this.offsets[key] += value;
	      }
	    },
	    setEntryLocation: function CFFOffsetTracker_setEntryLocation(key, values, output) {
	      if (!(key in this.offsets)) {
	        error('Not tracking location of ' + key);
	      }
	      var data = output.data;
	      var dataOffset = this.offsets[key];
	      var size = 5;
	      for (var i = 0, ii = values.length; i < ii; ++i) {
	        var offset0 = i * size + dataOffset;
	        var offset1 = offset0 + 1;
	        var offset2 = offset0 + 2;
	        var offset3 = offset0 + 3;
	        var offset4 = offset0 + 4;
	        if (data[offset0] !== 0x1d || data[offset1] !== 0 || data[offset2] !== 0 || data[offset3] !== 0 || data[offset4] !== 0) {
	          error('writing to an offset that is not empty');
	        }
	        var value = values[i];
	        data[offset0] = 0x1d;
	        data[offset1] = value >> 24 & 0xFF;
	        data[offset2] = value >> 16 & 0xFF;
	        data[offset3] = value >> 8 & 0xFF;
	        data[offset4] = value & 0xFF;
	      }
	    }
	  };
	  return CFFOffsetTracker;
	}();
	var CFFCompiler = function CFFCompilerClosure() {
	  function CFFCompiler(cff) {
	    this.cff = cff;
	  }
	  CFFCompiler.prototype = {
	    compile: function CFFCompiler_compile() {
	      var cff = this.cff;
	      var output = {
	        data: [],
	        length: 0,
	        add: function CFFCompiler_add(data) {
	          this.data = this.data.concat(data);
	          this.length = this.data.length;
	        }
	      };
	      var header = this.compileHeader(cff.header);
	      output.add(header);
	      var nameIndex = this.compileNameIndex(cff.names);
	      output.add(nameIndex);
	      if (cff.isCIDFont) {
	        if (cff.topDict.hasName('FontMatrix')) {
	          var base = cff.topDict.getByName('FontMatrix');
	          cff.topDict.removeByName('FontMatrix');
	          for (var i = 0, ii = cff.fdArray.length; i < ii; i++) {
	            var subDict = cff.fdArray[i];
	            var matrix = base.slice(0);
	            if (subDict.hasName('FontMatrix')) {
	              matrix = Util.transform(matrix, subDict.getByName('FontMatrix'));
	            }
	            subDict.setByName('FontMatrix', matrix);
	          }
	        }
	      }
	      var compiled = this.compileTopDicts([cff.topDict], output.length, cff.isCIDFont);
	      output.add(compiled.output);
	      var topDictTracker = compiled.trackers[0];
	      var stringIndex = this.compileStringIndex(cff.strings.strings);
	      output.add(stringIndex);
	      var globalSubrIndex = this.compileIndex(cff.globalSubrIndex);
	      output.add(globalSubrIndex);
	      if (cff.encoding && cff.topDict.hasName('Encoding')) {
	        if (cff.encoding.predefined) {
	          topDictTracker.setEntryLocation('Encoding', [cff.encoding.format], output);
	        } else {
	          var encoding = this.compileEncoding(cff.encoding);
	          topDictTracker.setEntryLocation('Encoding', [output.length], output);
	          output.add(encoding);
	        }
	      }
	      if (cff.charset && cff.topDict.hasName('charset')) {
	        if (cff.charset.predefined) {
	          topDictTracker.setEntryLocation('charset', [cff.charset.format], output);
	        } else {
	          var charset = this.compileCharset(cff.charset);
	          topDictTracker.setEntryLocation('charset', [output.length], output);
	          output.add(charset);
	        }
	      }
	      var charStrings = this.compileCharStrings(cff.charStrings);
	      topDictTracker.setEntryLocation('CharStrings', [output.length], output);
	      output.add(charStrings);
	      if (cff.isCIDFont) {
	        topDictTracker.setEntryLocation('FDSelect', [output.length], output);
	        var fdSelect = this.compileFDSelect(cff.fdSelect.raw);
	        output.add(fdSelect);
	        compiled = this.compileTopDicts(cff.fdArray, output.length, true);
	        topDictTracker.setEntryLocation('FDArray', [output.length], output);
	        output.add(compiled.output);
	        var fontDictTrackers = compiled.trackers;
	        this.compilePrivateDicts(cff.fdArray, fontDictTrackers, output);
	      }
	      this.compilePrivateDicts([cff.topDict], [topDictTracker], output);
	      output.add([0]);
	      return output.data;
	    },
	    encodeNumber: function CFFCompiler_encodeNumber(value) {
	      if (parseFloat(value) === parseInt(value, 10) && !isNaN(value)) {
	        return this.encodeInteger(value);
	      }
	      return this.encodeFloat(value);
	    },
	    encodeFloat: function CFFCompiler_encodeFloat(num) {
	      var value = num.toString();
	      var m = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(value);
	      if (m) {
	        var epsilon = parseFloat('1e' + ((m[2] ? +m[2] : 0) + m[1].length));
	        value = (Math.round(num * epsilon) / epsilon).toString();
	      }
	      var nibbles = '';
	      var i, ii;
	      for (i = 0, ii = value.length; i < ii; ++i) {
	        var a = value[i];
	        if (a === 'e') {
	          nibbles += value[++i] === '-' ? 'c' : 'b';
	        } else if (a === '.') {
	          nibbles += 'a';
	        } else if (a === '-') {
	          nibbles += 'e';
	        } else {
	          nibbles += a;
	        }
	      }
	      nibbles += nibbles.length & 1 ? 'f' : 'ff';
	      var out = [30];
	      for (i = 0, ii = nibbles.length; i < ii; i += 2) {
	        out.push(parseInt(nibbles.substr(i, 2), 16));
	      }
	      return out;
	    },
	    encodeInteger: function CFFCompiler_encodeInteger(value) {
	      var code;
	      if (value >= -107 && value <= 107) {
	        code = [value + 139];
	      } else if (value >= 108 && value <= 1131) {
	        value = value - 108;
	        code = [(value >> 8) + 247, value & 0xFF];
	      } else if (value >= -1131 && value <= -108) {
	        value = -value - 108;
	        code = [(value >> 8) + 251, value & 0xFF];
	      } else if (value >= -32768 && value <= 32767) {
	        code = [0x1c, value >> 8 & 0xFF, value & 0xFF];
	      } else {
	        code = [0x1d, value >> 24 & 0xFF, value >> 16 & 0xFF, value >> 8 & 0xFF, value & 0xFF];
	      }
	      return code;
	    },
	    compileHeader: function CFFCompiler_compileHeader(header) {
	      return [header.major, header.minor, header.hdrSize, header.offSize];
	    },
	    compileNameIndex: function CFFCompiler_compileNameIndex(names) {
	      var nameIndex = new CFFIndex();
	      for (var i = 0, ii = names.length; i < ii; ++i) {
	        nameIndex.add(stringToBytes(names[i]));
	      }
	      return this.compileIndex(nameIndex);
	    },
	    compileTopDicts: function CFFCompiler_compileTopDicts(dicts, length, removeCidKeys) {
	      var fontDictTrackers = [];
	      var fdArrayIndex = new CFFIndex();
	      for (var i = 0, ii = dicts.length; i < ii; ++i) {
	        var fontDict = dicts[i];
	        if (removeCidKeys) {
	          fontDict.removeByName('CIDFontVersion');
	          fontDict.removeByName('CIDFontRevision');
	          fontDict.removeByName('CIDFontType');
	          fontDict.removeByName('CIDCount');
	          fontDict.removeByName('UIDBase');
	        }
	        var fontDictTracker = new CFFOffsetTracker();
	        var fontDictData = this.compileDict(fontDict, fontDictTracker);
	        fontDictTrackers.push(fontDictTracker);
	        fdArrayIndex.add(fontDictData);
	        fontDictTracker.offset(length);
	      }
	      fdArrayIndex = this.compileIndex(fdArrayIndex, fontDictTrackers);
	      return {
	        trackers: fontDictTrackers,
	        output: fdArrayIndex
	      };
	    },
	    compilePrivateDicts: function CFFCompiler_compilePrivateDicts(dicts, trackers, output) {
	      for (var i = 0, ii = dicts.length; i < ii; ++i) {
	        var fontDict = dicts[i];
	        assert(fontDict.privateDict && fontDict.hasName('Private'), 'There must be an private dictionary.');
	        var privateDict = fontDict.privateDict;
	        var privateDictTracker = new CFFOffsetTracker();
	        var privateDictData = this.compileDict(privateDict, privateDictTracker);
	        var outputLength = output.length;
	        privateDictTracker.offset(outputLength);
	        if (!privateDictData.length) {
	          outputLength = 0;
	        }
	        trackers[i].setEntryLocation('Private', [privateDictData.length, outputLength], output);
	        output.add(privateDictData);
	        if (privateDict.subrsIndex && privateDict.hasName('Subrs')) {
	          var subrs = this.compileIndex(privateDict.subrsIndex);
	          privateDictTracker.setEntryLocation('Subrs', [privateDictData.length], output);
	          output.add(subrs);
	        }
	      }
	    },
	    compileDict: function CFFCompiler_compileDict(dict, offsetTracker) {
	      var out = [];
	      var order = dict.order;
	      for (var i = 0; i < order.length; ++i) {
	        var key = order[i];
	        if (!(key in dict.values)) {
	          continue;
	        }
	        var values = dict.values[key];
	        var types = dict.types[key];
	        if (!isArray(types)) {
	          types = [types];
	        }
	        if (!isArray(values)) {
	          values = [values];
	        }
	        if (values.length === 0) {
	          continue;
	        }
	        for (var j = 0, jj = types.length; j < jj; ++j) {
	          var type = types[j];
	          var value = values[j];
	          switch (type) {
	            case 'num':
	            case 'sid':
	              out = out.concat(this.encodeNumber(value));
	              break;
	            case 'offset':
	              var name = dict.keyToNameMap[key];
	              if (!offsetTracker.isTracking(name)) {
	                offsetTracker.track(name, out.length);
	              }
	              out = out.concat([0x1d, 0, 0, 0, 0]);
	              break;
	            case 'array':
	            case 'delta':
	              out = out.concat(this.encodeNumber(value));
	              for (var k = 1, kk = values.length; k < kk; ++k) {
	                out = out.concat(this.encodeNumber(values[k]));
	              }
	              break;
	            default:
	              error('Unknown data type of ' + type);
	              break;
	          }
	        }
	        out = out.concat(dict.opcodes[key]);
	      }
	      return out;
	    },
	    compileStringIndex: function CFFCompiler_compileStringIndex(strings) {
	      var stringIndex = new CFFIndex();
	      for (var i = 0, ii = strings.length; i < ii; ++i) {
	        stringIndex.add(stringToBytes(strings[i]));
	      }
	      return this.compileIndex(stringIndex);
	    },
	    compileGlobalSubrIndex: function CFFCompiler_compileGlobalSubrIndex() {
	      var globalSubrIndex = this.cff.globalSubrIndex;
	      this.out.writeByteArray(this.compileIndex(globalSubrIndex));
	    },
	    compileCharStrings: function CFFCompiler_compileCharStrings(charStrings) {
	      return this.compileIndex(charStrings);
	    },
	    compileCharset: function CFFCompiler_compileCharset(charset) {
	      return this.compileTypedArray(charset.raw);
	    },
	    compileEncoding: function CFFCompiler_compileEncoding(encoding) {
	      return this.compileTypedArray(encoding.raw);
	    },
	    compileFDSelect: function CFFCompiler_compileFDSelect(fdSelect) {
	      return this.compileTypedArray(fdSelect);
	    },
	    compileTypedArray: function CFFCompiler_compileTypedArray(data) {
	      var out = [];
	      for (var i = 0, ii = data.length; i < ii; ++i) {
	        out[i] = data[i];
	      }
	      return out;
	    },
	    compileIndex: function CFFCompiler_compileIndex(index, trackers) {
	      trackers = trackers || [];
	      var objects = index.objects;
	      var count = objects.length;
	      if (count === 0) {
	        return [0, 0, 0];
	      }
	      var data = [count >> 8 & 0xFF, count & 0xff];
	      var lastOffset = 1,
	          i;
	      for (i = 0; i < count; ++i) {
	        lastOffset += objects[i].length;
	      }
	      var offsetSize;
	      if (lastOffset < 0x100) {
	        offsetSize = 1;
	      } else if (lastOffset < 0x10000) {
	        offsetSize = 2;
	      } else if (lastOffset < 0x1000000) {
	        offsetSize = 3;
	      } else {
	        offsetSize = 4;
	      }
	      data.push(offsetSize);
	      var relativeOffset = 1;
	      for (i = 0; i < count + 1; i++) {
	        if (offsetSize === 1) {
	          data.push(relativeOffset & 0xFF);
	        } else if (offsetSize === 2) {
	          data.push(relativeOffset >> 8 & 0xFF, relativeOffset & 0xFF);
	        } else if (offsetSize === 3) {
	          data.push(relativeOffset >> 16 & 0xFF, relativeOffset >> 8 & 0xFF, relativeOffset & 0xFF);
	        } else {
	          data.push(relativeOffset >>> 24 & 0xFF, relativeOffset >> 16 & 0xFF, relativeOffset >> 8 & 0xFF, relativeOffset & 0xFF);
	        }
	        if (objects[i]) {
	          relativeOffset += objects[i].length;
	        }
	      }
	      for (i = 0; i < count; i++) {
	        if (trackers[i]) {
	          trackers[i].offset(data.length);
	        }
	        for (var j = 0, jj = objects[i].length; j < jj; j++) {
	          data.push(objects[i][j]);
	        }
	      }
	      return data;
	    }
	  };
	  return CFFCompiler;
	}();
	exports.CFFStandardStrings = CFFStandardStrings;
	exports.CFFParser = CFFParser;
	exports.CFF = CFF;
	exports.CFFHeader = CFFHeader;
	exports.CFFStrings = CFFStrings;
	exports.CFFIndex = CFFIndex;
	exports.CFFCharset = CFFCharset;
	exports.CFFTopDict = CFFTopDict;
	exports.CFFPrivateDict = CFFPrivateDict;
	exports.CFFCompiler = CFFCompiler;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var MissingDataException = sharedUtil.MissingDataException;
	var arrayByteLength = sharedUtil.arrayByteLength;
	var arraysToBytes = sharedUtil.arraysToBytes;
	var assert = sharedUtil.assert;
	var createPromiseCapability = sharedUtil.createPromiseCapability;
	var isInt = sharedUtil.isInt;
	var isEmptyObj = sharedUtil.isEmptyObj;
	var ChunkedStream = function ChunkedStreamClosure() {
	  function ChunkedStream(length, chunkSize, manager) {
	    this.bytes = new Uint8Array(length);
	    this.start = 0;
	    this.pos = 0;
	    this.end = length;
	    this.chunkSize = chunkSize;
	    this.loadedChunks = [];
	    this.numChunksLoaded = 0;
	    this.numChunks = Math.ceil(length / chunkSize);
	    this.manager = manager;
	    this.progressiveDataLength = 0;
	    this.lastSuccessfulEnsureByteChunk = -1;
	  }
	  ChunkedStream.prototype = {
	    getMissingChunks: function ChunkedStream_getMissingChunks() {
	      var chunks = [];
	      for (var chunk = 0, n = this.numChunks; chunk < n; ++chunk) {
	        if (!this.loadedChunks[chunk]) {
	          chunks.push(chunk);
	        }
	      }
	      return chunks;
	    },
	    getBaseStreams: function ChunkedStream_getBaseStreams() {
	      return [this];
	    },
	    allChunksLoaded: function ChunkedStream_allChunksLoaded() {
	      return this.numChunksLoaded === this.numChunks;
	    },
	    onReceiveData: function ChunkedStream_onReceiveData(begin, chunk) {
	      var end = begin + chunk.byteLength;
	      assert(begin % this.chunkSize === 0, 'Bad begin offset: ' + begin);
	      var length = this.bytes.length;
	      assert(end % this.chunkSize === 0 || end === length, 'Bad end offset: ' + end);
	      this.bytes.set(new Uint8Array(chunk), begin);
	      var chunkSize = this.chunkSize;
	      var beginChunk = Math.floor(begin / chunkSize);
	      var endChunk = Math.floor((end - 1) / chunkSize) + 1;
	      var curChunk;
	      for (curChunk = beginChunk; curChunk < endChunk; ++curChunk) {
	        if (!this.loadedChunks[curChunk]) {
	          this.loadedChunks[curChunk] = true;
	          ++this.numChunksLoaded;
	        }
	      }
	    },
	    onReceiveProgressiveData: function ChunkedStream_onReceiveProgressiveData(data) {
	      var position = this.progressiveDataLength;
	      var beginChunk = Math.floor(position / this.chunkSize);
	      this.bytes.set(new Uint8Array(data), position);
	      position += data.byteLength;
	      this.progressiveDataLength = position;
	      var endChunk = position >= this.end ? this.numChunks : Math.floor(position / this.chunkSize);
	      var curChunk;
	      for (curChunk = beginChunk; curChunk < endChunk; ++curChunk) {
	        if (!this.loadedChunks[curChunk]) {
	          this.loadedChunks[curChunk] = true;
	          ++this.numChunksLoaded;
	        }
	      }
	    },
	    ensureByte: function ChunkedStream_ensureByte(pos) {
	      var chunk = Math.floor(pos / this.chunkSize);
	      if (chunk === this.lastSuccessfulEnsureByteChunk) {
	        return;
	      }
	      if (!this.loadedChunks[chunk]) {
	        throw new MissingDataException(pos, pos + 1);
	      }
	      this.lastSuccessfulEnsureByteChunk = chunk;
	    },
	    ensureRange: function ChunkedStream_ensureRange(begin, end) {
	      if (begin >= end) {
	        return;
	      }
	      if (end <= this.progressiveDataLength) {
	        return;
	      }
	      var chunkSize = this.chunkSize;
	      var beginChunk = Math.floor(begin / chunkSize);
	      var endChunk = Math.floor((end - 1) / chunkSize) + 1;
	      for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
	        if (!this.loadedChunks[chunk]) {
	          throw new MissingDataException(begin, end);
	        }
	      }
	    },
	    nextEmptyChunk: function ChunkedStream_nextEmptyChunk(beginChunk) {
	      var chunk,
	          numChunks = this.numChunks;
	      for (var i = 0; i < numChunks; ++i) {
	        chunk = (beginChunk + i) % numChunks;
	        if (!this.loadedChunks[chunk]) {
	          return chunk;
	        }
	      }
	      return null;
	    },
	    hasChunk: function ChunkedStream_hasChunk(chunk) {
	      return !!this.loadedChunks[chunk];
	    },
	    get length() {
	      return this.end - this.start;
	    },
	    get isEmpty() {
	      return this.length === 0;
	    },
	    getByte: function ChunkedStream_getByte() {
	      var pos = this.pos;
	      if (pos >= this.end) {
	        return -1;
	      }
	      this.ensureByte(pos);
	      return this.bytes[this.pos++];
	    },
	    getUint16: function ChunkedStream_getUint16() {
	      var b0 = this.getByte();
	      var b1 = this.getByte();
	      if (b0 === -1 || b1 === -1) {
	        return -1;
	      }
	      return (b0 << 8) + b1;
	    },
	    getInt32: function ChunkedStream_getInt32() {
	      var b0 = this.getByte();
	      var b1 = this.getByte();
	      var b2 = this.getByte();
	      var b3 = this.getByte();
	      return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
	    },
	    getBytes: function ChunkedStream_getBytes(length) {
	      var bytes = this.bytes;
	      var pos = this.pos;
	      var strEnd = this.end;
	      if (!length) {
	        this.ensureRange(pos, strEnd);
	        return bytes.subarray(pos, strEnd);
	      }
	      var end = pos + length;
	      if (end > strEnd) {
	        end = strEnd;
	      }
	      this.ensureRange(pos, end);
	      this.pos = end;
	      return bytes.subarray(pos, end);
	    },
	    peekByte: function ChunkedStream_peekByte() {
	      var peekedByte = this.getByte();
	      this.pos--;
	      return peekedByte;
	    },
	    peekBytes: function ChunkedStream_peekBytes(length) {
	      var bytes = this.getBytes(length);
	      this.pos -= bytes.length;
	      return bytes;
	    },
	    getByteRange: function ChunkedStream_getBytes(begin, end) {
	      this.ensureRange(begin, end);
	      return this.bytes.subarray(begin, end);
	    },
	    skip: function ChunkedStream_skip(n) {
	      if (!n) {
	        n = 1;
	      }
	      this.pos += n;
	    },
	    reset: function ChunkedStream_reset() {
	      this.pos = this.start;
	    },
	    moveStart: function ChunkedStream_moveStart() {
	      this.start = this.pos;
	    },
	    makeSubStream: function ChunkedStream_makeSubStream(start, length, dict) {
	      this.ensureRange(start, start + length);
	      function ChunkedStreamSubstream() {}
	      ChunkedStreamSubstream.prototype = Object.create(this);
	      ChunkedStreamSubstream.prototype.getMissingChunks = function () {
	        var chunkSize = this.chunkSize;
	        var beginChunk = Math.floor(this.start / chunkSize);
	        var endChunk = Math.floor((this.end - 1) / chunkSize) + 1;
	        var missingChunks = [];
	        for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
	          if (!this.loadedChunks[chunk]) {
	            missingChunks.push(chunk);
	          }
	        }
	        return missingChunks;
	      };
	      var subStream = new ChunkedStreamSubstream();
	      subStream.pos = subStream.start = start;
	      subStream.end = start + length || this.end;
	      subStream.dict = dict;
	      return subStream;
	    }
	  };
	  return ChunkedStream;
	}();
	var ChunkedStreamManager = function ChunkedStreamManagerClosure() {
	  function ChunkedStreamManager(pdfNetworkStream, args) {
	    var chunkSize = args.rangeChunkSize;
	    var length = args.length;
	    this.stream = new ChunkedStream(length, chunkSize, this);
	    this.length = length;
	    this.chunkSize = chunkSize;
	    this.pdfNetworkStream = pdfNetworkStream;
	    this.url = args.url;
	    this.disableAutoFetch = args.disableAutoFetch;
	    this.msgHandler = args.msgHandler;
	    this.currRequestId = 0;
	    this.chunksNeededByRequest = Object.create(null);
	    this.requestsByChunk = Object.create(null);
	    this.promisesByRequest = Object.create(null);
	    this.progressiveDataLength = 0;
	    this.aborted = false;
	    this._loadedStreamCapability = createPromiseCapability();
	  }
	  ChunkedStreamManager.prototype = {
	    onLoadedStream: function ChunkedStreamManager_getLoadedStream() {
	      return this._loadedStreamCapability.promise;
	    },
	    sendRequest: function ChunkedStreamManager_sendRequest(begin, end) {
	      var _this = this;
	
	      var rangeReader = this.pdfNetworkStream.getRangeReader(begin, end);
	      if (!rangeReader.isStreamingSupported) {
	        rangeReader.onProgress = this.onProgress.bind(this);
	      }
	      var chunks = [],
	          loaded = 0;
	      var manager = this;
	      var promise = new Promise(function (resolve, reject) {
	        var readChunk = function readChunk(chunk) {
	          try {
	            if (!chunk.done) {
	              var data = chunk.value;
	              chunks.push(data);
	              loaded += arrayByteLength(data);
	              if (rangeReader.isStreamingSupported) {
	                manager.onProgress({ loaded: loaded });
	              }
	              rangeReader.read().then(readChunk, reject);
	              return;
	            }
	            var chunkData = arraysToBytes(chunks);
	            chunks = null;
	            resolve(chunkData);
	          } catch (e) {
	            reject(e);
	          }
	        };
	        rangeReader.read().then(readChunk, reject);
	      });
	      promise.then(function (data) {
	        if (_this.aborted) {
	          return;
	        }
	        _this.onReceiveData({
	          chunk: data,
	          begin: begin
	        });
	      });
	    },
	    requestAllChunks: function ChunkedStreamManager_requestAllChunks() {
	      var missingChunks = this.stream.getMissingChunks();
	      this._requestChunks(missingChunks);
	      return this._loadedStreamCapability.promise;
	    },
	    _requestChunks: function ChunkedStreamManager_requestChunks(chunks) {
	      var requestId = this.currRequestId++;
	      var i, ii;
	      var chunksNeeded = Object.create(null);
	      this.chunksNeededByRequest[requestId] = chunksNeeded;
	      for (i = 0, ii = chunks.length; i < ii; i++) {
	        if (!this.stream.hasChunk(chunks[i])) {
	          chunksNeeded[chunks[i]] = true;
	        }
	      }
	      if (isEmptyObj(chunksNeeded)) {
	        return Promise.resolve();
	      }
	      var capability = createPromiseCapability();
	      this.promisesByRequest[requestId] = capability;
	      var chunksToRequest = [];
	      for (var chunk in chunksNeeded) {
	        chunk = chunk | 0;
	        if (!(chunk in this.requestsByChunk)) {
	          this.requestsByChunk[chunk] = [];
	          chunksToRequest.push(chunk);
	        }
	        this.requestsByChunk[chunk].push(requestId);
	      }
	      if (!chunksToRequest.length) {
	        return capability.promise;
	      }
	      var groupedChunksToRequest = this.groupChunks(chunksToRequest);
	      for (i = 0; i < groupedChunksToRequest.length; ++i) {
	        var groupedChunk = groupedChunksToRequest[i];
	        var begin = groupedChunk.beginChunk * this.chunkSize;
	        var end = Math.min(groupedChunk.endChunk * this.chunkSize, this.length);
	        this.sendRequest(begin, end);
	      }
	      return capability.promise;
	    },
	    getStream: function ChunkedStreamManager_getStream() {
	      return this.stream;
	    },
	    requestRange: function ChunkedStreamManager_requestRange(begin, end) {
	      end = Math.min(end, this.length);
	      var beginChunk = this.getBeginChunk(begin);
	      var endChunk = this.getEndChunk(end);
	      var chunks = [];
	      for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
	        chunks.push(chunk);
	      }
	      return this._requestChunks(chunks);
	    },
	    requestRanges: function ChunkedStreamManager_requestRanges(ranges) {
	      ranges = ranges || [];
	      var chunksToRequest = [];
	      for (var i = 0; i < ranges.length; i++) {
	        var beginChunk = this.getBeginChunk(ranges[i].begin);
	        var endChunk = this.getEndChunk(ranges[i].end);
	        for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
	          if (chunksToRequest.indexOf(chunk) < 0) {
	            chunksToRequest.push(chunk);
	          }
	        }
	      }
	      chunksToRequest.sort(function (a, b) {
	        return a - b;
	      });
	      return this._requestChunks(chunksToRequest);
	    },
	    groupChunks: function ChunkedStreamManager_groupChunks(chunks) {
	      var groupedChunks = [];
	      var beginChunk = -1;
	      var prevChunk = -1;
	      for (var i = 0; i < chunks.length; ++i) {
	        var chunk = chunks[i];
	        if (beginChunk < 0) {
	          beginChunk = chunk;
	        }
	        if (prevChunk >= 0 && prevChunk + 1 !== chunk) {
	          groupedChunks.push({
	            beginChunk: beginChunk,
	            endChunk: prevChunk + 1
	          });
	          beginChunk = chunk;
	        }
	        if (i + 1 === chunks.length) {
	          groupedChunks.push({
	            beginChunk: beginChunk,
	            endChunk: chunk + 1
	          });
	        }
	        prevChunk = chunk;
	      }
	      return groupedChunks;
	    },
	    onProgress: function ChunkedStreamManager_onProgress(args) {
	      var bytesLoaded = this.stream.numChunksLoaded * this.chunkSize + args.loaded;
	      this.msgHandler.send('DocProgress', {
	        loaded: bytesLoaded,
	        total: this.length
	      });
	    },
	    onReceiveData: function ChunkedStreamManager_onReceiveData(args) {
	      var chunk = args.chunk;
	      var isProgressive = args.begin === undefined;
	      var begin = isProgressive ? this.progressiveDataLength : args.begin;
	      var end = begin + chunk.byteLength;
	      var beginChunk = Math.floor(begin / this.chunkSize);
	      var endChunk = end < this.length ? Math.floor(end / this.chunkSize) : Math.ceil(end / this.chunkSize);
	      if (isProgressive) {
	        this.stream.onReceiveProgressiveData(chunk);
	        this.progressiveDataLength = end;
	      } else {
	        this.stream.onReceiveData(begin, chunk);
	      }
	      if (this.stream.allChunksLoaded()) {
	        this._loadedStreamCapability.resolve(this.stream);
	      }
	      var loadedRequests = [];
	      var i, requestId;
	      for (chunk = beginChunk; chunk < endChunk; ++chunk) {
	        var requestIds = this.requestsByChunk[chunk] || [];
	        delete this.requestsByChunk[chunk];
	        for (i = 0; i < requestIds.length; ++i) {
	          requestId = requestIds[i];
	          var chunksNeeded = this.chunksNeededByRequest[requestId];
	          if (chunk in chunksNeeded) {
	            delete chunksNeeded[chunk];
	          }
	          if (!isEmptyObj(chunksNeeded)) {
	            continue;
	          }
	          loadedRequests.push(requestId);
	        }
	      }
	      if (!this.disableAutoFetch && isEmptyObj(this.requestsByChunk)) {
	        var nextEmptyChunk;
	        if (this.stream.numChunksLoaded === 1) {
	          var lastChunk = this.stream.numChunks - 1;
	          if (!this.stream.hasChunk(lastChunk)) {
	            nextEmptyChunk = lastChunk;
	          }
	        } else {
	          nextEmptyChunk = this.stream.nextEmptyChunk(endChunk);
	        }
	        if (isInt(nextEmptyChunk)) {
	          this._requestChunks([nextEmptyChunk]);
	        }
	      }
	      for (i = 0; i < loadedRequests.length; ++i) {
	        requestId = loadedRequests[i];
	        var capability = this.promisesByRequest[requestId];
	        delete this.promisesByRequest[requestId];
	        capability.resolve();
	      }
	      this.msgHandler.send('DocProgress', {
	        loaded: this.stream.numChunksLoaded * this.chunkSize,
	        total: this.length
	      });
	    },
	    onError: function ChunkedStreamManager_onError(err) {
	      this._loadedStreamCapability.reject(err);
	    },
	    getBeginChunk: function ChunkedStreamManager_getBeginChunk(begin) {
	      var chunk = Math.floor(begin / this.chunkSize);
	      return chunk;
	    },
	    getEndChunk: function ChunkedStreamManager_getEndChunk(end) {
	      var chunk = Math.floor((end - 1) / this.chunkSize) + 1;
	      return chunk;
	    },
	    abort: function ChunkedStreamManager_abort() {
	      this.aborted = true;
	      if (this.pdfNetworkStream) {
	        this.pdfNetworkStream.cancelAllRequests('abort');
	      }
	      for (var requestId in this.promisesByRequest) {
	        var capability = this.promisesByRequest[requestId];
	        capability.reject(new Error('Request was aborted'));
	      }
	    }
	  };
	  return ChunkedStreamManager;
	}();
	exports.ChunkedStream = ChunkedStream;
	exports.ChunkedStreamManager = ChunkedStreamManager;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var coreStream = __w_pdfjs_require__(2);
	var PasswordException = sharedUtil.PasswordException;
	var PasswordResponses = sharedUtil.PasswordResponses;
	var bytesToString = sharedUtil.bytesToString;
	var warn = sharedUtil.warn;
	var error = sharedUtil.error;
	var assert = sharedUtil.assert;
	var isInt = sharedUtil.isInt;
	var stringToBytes = sharedUtil.stringToBytes;
	var utf8StringToString = sharedUtil.utf8StringToString;
	var Name = corePrimitives.Name;
	var isName = corePrimitives.isName;
	var isDict = corePrimitives.isDict;
	var DecryptStream = coreStream.DecryptStream;
	var ARCFourCipher = function ARCFourCipherClosure() {
	  function ARCFourCipher(key) {
	    this.a = 0;
	    this.b = 0;
	    var s = new Uint8Array(256);
	    var i,
	        j = 0,
	        tmp,
	        keyLength = key.length;
	    for (i = 0; i < 256; ++i) {
	      s[i] = i;
	    }
	    for (i = 0; i < 256; ++i) {
	      tmp = s[i];
	      j = j + tmp + key[i % keyLength] & 0xFF;
	      s[i] = s[j];
	      s[j] = tmp;
	    }
	    this.s = s;
	  }
	  ARCFourCipher.prototype = {
	    encryptBlock: function ARCFourCipher_encryptBlock(data) {
	      var i,
	          n = data.length,
	          tmp,
	          tmp2;
	      var a = this.a,
	          b = this.b,
	          s = this.s;
	      var output = new Uint8Array(n);
	      for (i = 0; i < n; ++i) {
	        a = a + 1 & 0xFF;
	        tmp = s[a];
	        b = b + tmp & 0xFF;
	        tmp2 = s[b];
	        s[a] = tmp2;
	        s[b] = tmp;
	        output[i] = data[i] ^ s[tmp + tmp2 & 0xFF];
	      }
	      this.a = a;
	      this.b = b;
	      return output;
	    }
	  };
	  ARCFourCipher.prototype.decryptBlock = ARCFourCipher.prototype.encryptBlock;
	  return ARCFourCipher;
	}();
	var calculateMD5 = function calculateMD5Closure() {
	  var r = new Uint8Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]);
	  var k = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
	  function hash(data, offset, length) {
	    var h0 = 1732584193,
	        h1 = -271733879,
	        h2 = -1732584194,
	        h3 = 271733878;
	    var paddedLength = length + 72 & ~63;
	    var padded = new Uint8Array(paddedLength);
	    var i, j, n;
	    for (i = 0; i < length; ++i) {
	      padded[i] = data[offset++];
	    }
	    padded[i++] = 0x80;
	    n = paddedLength - 8;
	    while (i < n) {
	      padded[i++] = 0;
	    }
	    padded[i++] = length << 3 & 0xFF;
	    padded[i++] = length >> 5 & 0xFF;
	    padded[i++] = length >> 13 & 0xFF;
	    padded[i++] = length >> 21 & 0xFF;
	    padded[i++] = length >>> 29 & 0xFF;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    var w = new Int32Array(16);
	    for (i = 0; i < paddedLength;) {
	      for (j = 0; j < 16; ++j, i += 4) {
	        w[j] = padded[i] | padded[i + 1] << 8 | padded[i + 2] << 16 | padded[i + 3] << 24;
	      }
	      var a = h0,
	          b = h1,
	          c = h2,
	          d = h3,
	          f,
	          g;
	      for (j = 0; j < 64; ++j) {
	        if (j < 16) {
	          f = b & c | ~b & d;
	          g = j;
	        } else if (j < 32) {
	          f = d & b | ~d & c;
	          g = 5 * j + 1 & 15;
	        } else if (j < 48) {
	          f = b ^ c ^ d;
	          g = 3 * j + 5 & 15;
	        } else {
	          f = c ^ (b | ~d);
	          g = 7 * j & 15;
	        }
	        var tmp = d,
	            rotateArg = a + f + k[j] + w[g] | 0,
	            rotate = r[j];
	        d = c;
	        c = b;
	        b = b + (rotateArg << rotate | rotateArg >>> 32 - rotate) | 0;
	        a = tmp;
	      }
	      h0 = h0 + a | 0;
	      h1 = h1 + b | 0;
	      h2 = h2 + c | 0;
	      h3 = h3 + d | 0;
	    }
	    return new Uint8Array([h0 & 0xFF, h0 >> 8 & 0xFF, h0 >> 16 & 0xFF, h0 >>> 24 & 0xFF, h1 & 0xFF, h1 >> 8 & 0xFF, h1 >> 16 & 0xFF, h1 >>> 24 & 0xFF, h2 & 0xFF, h2 >> 8 & 0xFF, h2 >> 16 & 0xFF, h2 >>> 24 & 0xFF, h3 & 0xFF, h3 >> 8 & 0xFF, h3 >> 16 & 0xFF, h3 >>> 24 & 0xFF]);
	  }
	  return hash;
	}();
	var Word64 = function Word64Closure() {
	  function Word64(highInteger, lowInteger) {
	    this.high = highInteger | 0;
	    this.low = lowInteger | 0;
	  }
	  Word64.prototype = {
	    and: function Word64_and(word) {
	      this.high &= word.high;
	      this.low &= word.low;
	    },
	    xor: function Word64_xor(word) {
	      this.high ^= word.high;
	      this.low ^= word.low;
	    },
	    or: function Word64_or(word) {
	      this.high |= word.high;
	      this.low |= word.low;
	    },
	    shiftRight: function Word64_shiftRight(places) {
	      if (places >= 32) {
	        this.low = this.high >>> places - 32 | 0;
	        this.high = 0;
	      } else {
	        this.low = this.low >>> places | this.high << 32 - places;
	        this.high = this.high >>> places | 0;
	      }
	    },
	    shiftLeft: function Word64_shiftLeft(places) {
	      if (places >= 32) {
	        this.high = this.low << places - 32;
	        this.low = 0;
	      } else {
	        this.high = this.high << places | this.low >>> 32 - places;
	        this.low = this.low << places;
	      }
	    },
	    rotateRight: function Word64_rotateRight(places) {
	      var low, high;
	      if (places & 32) {
	        high = this.low;
	        low = this.high;
	      } else {
	        low = this.low;
	        high = this.high;
	      }
	      places &= 31;
	      this.low = low >>> places | high << 32 - places;
	      this.high = high >>> places | low << 32 - places;
	    },
	    not: function Word64_not() {
	      this.high = ~this.high;
	      this.low = ~this.low;
	    },
	    add: function Word64_add(word) {
	      var lowAdd = (this.low >>> 0) + (word.low >>> 0);
	      var highAdd = (this.high >>> 0) + (word.high >>> 0);
	      if (lowAdd > 0xFFFFFFFF) {
	        highAdd += 1;
	      }
	      this.low = lowAdd | 0;
	      this.high = highAdd | 0;
	    },
	    copyTo: function Word64_copyTo(bytes, offset) {
	      bytes[offset] = this.high >>> 24 & 0xFF;
	      bytes[offset + 1] = this.high >> 16 & 0xFF;
	      bytes[offset + 2] = this.high >> 8 & 0xFF;
	      bytes[offset + 3] = this.high & 0xFF;
	      bytes[offset + 4] = this.low >>> 24 & 0xFF;
	      bytes[offset + 5] = this.low >> 16 & 0xFF;
	      bytes[offset + 6] = this.low >> 8 & 0xFF;
	      bytes[offset + 7] = this.low & 0xFF;
	    },
	    assign: function Word64_assign(word) {
	      this.high = word.high;
	      this.low = word.low;
	    }
	  };
	  return Word64;
	}();
	var calculateSHA256 = function calculateSHA256Closure() {
	  function rotr(x, n) {
	    return x >>> n | x << 32 - n;
	  }
	  function ch(x, y, z) {
	    return x & y ^ ~x & z;
	  }
	  function maj(x, y, z) {
	    return x & y ^ x & z ^ y & z;
	  }
	  function sigma(x) {
	    return rotr(x, 2) ^ rotr(x, 13) ^ rotr(x, 22);
	  }
	  function sigmaPrime(x) {
	    return rotr(x, 6) ^ rotr(x, 11) ^ rotr(x, 25);
	  }
	  function littleSigma(x) {
	    return rotr(x, 7) ^ rotr(x, 18) ^ x >>> 3;
	  }
	  function littleSigmaPrime(x) {
	    return rotr(x, 17) ^ rotr(x, 19) ^ x >>> 10;
	  }
	  var k = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];
	  function hash(data, offset, length) {
	    var h0 = 0x6a09e667,
	        h1 = 0xbb67ae85,
	        h2 = 0x3c6ef372,
	        h3 = 0xa54ff53a,
	        h4 = 0x510e527f,
	        h5 = 0x9b05688c,
	        h6 = 0x1f83d9ab,
	        h7 = 0x5be0cd19;
	    var paddedLength = Math.ceil((length + 9) / 64) * 64;
	    var padded = new Uint8Array(paddedLength);
	    var i, j, n;
	    for (i = 0; i < length; ++i) {
	      padded[i] = data[offset++];
	    }
	    padded[i++] = 0x80;
	    n = paddedLength - 8;
	    while (i < n) {
	      padded[i++] = 0;
	    }
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = length >>> 29 & 0xFF;
	    padded[i++] = length >> 21 & 0xFF;
	    padded[i++] = length >> 13 & 0xFF;
	    padded[i++] = length >> 5 & 0xFF;
	    padded[i++] = length << 3 & 0xFF;
	    var w = new Uint32Array(64);
	    for (i = 0; i < paddedLength;) {
	      for (j = 0; j < 16; ++j) {
	        w[j] = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
	        i += 4;
	      }
	      for (j = 16; j < 64; ++j) {
	        w[j] = littleSigmaPrime(w[j - 2]) + w[j - 7] + littleSigma(w[j - 15]) + w[j - 16] | 0;
	      }
	      var a = h0,
	          b = h1,
	          c = h2,
	          d = h3,
	          e = h4,
	          f = h5,
	          g = h6,
	          h = h7,
	          t1,
	          t2;
	      for (j = 0; j < 64; ++j) {
	        t1 = h + sigmaPrime(e) + ch(e, f, g) + k[j] + w[j];
	        t2 = sigma(a) + maj(a, b, c);
	        h = g;
	        g = f;
	        f = e;
	        e = d + t1 | 0;
	        d = c;
	        c = b;
	        b = a;
	        a = t1 + t2 | 0;
	      }
	      h0 = h0 + a | 0;
	      h1 = h1 + b | 0;
	      h2 = h2 + c | 0;
	      h3 = h3 + d | 0;
	      h4 = h4 + e | 0;
	      h5 = h5 + f | 0;
	      h6 = h6 + g | 0;
	      h7 = h7 + h | 0;
	    }
	    return new Uint8Array([h0 >> 24 & 0xFF, h0 >> 16 & 0xFF, h0 >> 8 & 0xFF, h0 & 0xFF, h1 >> 24 & 0xFF, h1 >> 16 & 0xFF, h1 >> 8 & 0xFF, h1 & 0xFF, h2 >> 24 & 0xFF, h2 >> 16 & 0xFF, h2 >> 8 & 0xFF, h2 & 0xFF, h3 >> 24 & 0xFF, h3 >> 16 & 0xFF, h3 >> 8 & 0xFF, h3 & 0xFF, h4 >> 24 & 0xFF, h4 >> 16 & 0xFF, h4 >> 8 & 0xFF, h4 & 0xFF, h5 >> 24 & 0xFF, h5 >> 16 & 0xFF, h5 >> 8 & 0xFF, h5 & 0xFF, h6 >> 24 & 0xFF, h6 >> 16 & 0xFF, h6 >> 8 & 0xFF, h6 & 0xFF, h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF]);
	  }
	  return hash;
	}();
	var calculateSHA512 = function calculateSHA512Closure() {
	  function ch(result, x, y, z, tmp) {
	    result.assign(x);
	    result.and(y);
	    tmp.assign(x);
	    tmp.not();
	    tmp.and(z);
	    result.xor(tmp);
	  }
	  function maj(result, x, y, z, tmp) {
	    result.assign(x);
	    result.and(y);
	    tmp.assign(x);
	    tmp.and(z);
	    result.xor(tmp);
	    tmp.assign(y);
	    tmp.and(z);
	    result.xor(tmp);
	  }
	  function sigma(result, x, tmp) {
	    result.assign(x);
	    result.rotateRight(28);
	    tmp.assign(x);
	    tmp.rotateRight(34);
	    result.xor(tmp);
	    tmp.assign(x);
	    tmp.rotateRight(39);
	    result.xor(tmp);
	  }
	  function sigmaPrime(result, x, tmp) {
	    result.assign(x);
	    result.rotateRight(14);
	    tmp.assign(x);
	    tmp.rotateRight(18);
	    result.xor(tmp);
	    tmp.assign(x);
	    tmp.rotateRight(41);
	    result.xor(tmp);
	  }
	  function littleSigma(result, x, tmp) {
	    result.assign(x);
	    result.rotateRight(1);
	    tmp.assign(x);
	    tmp.rotateRight(8);
	    result.xor(tmp);
	    tmp.assign(x);
	    tmp.shiftRight(7);
	    result.xor(tmp);
	  }
	  function littleSigmaPrime(result, x, tmp) {
	    result.assign(x);
	    result.rotateRight(19);
	    tmp.assign(x);
	    tmp.rotateRight(61);
	    result.xor(tmp);
	    tmp.assign(x);
	    tmp.shiftRight(6);
	    result.xor(tmp);
	  }
	  var k = [new Word64(0x428a2f98, 0xd728ae22), new Word64(0x71374491, 0x23ef65cd), new Word64(0xb5c0fbcf, 0xec4d3b2f), new Word64(0xe9b5dba5, 0x8189dbbc), new Word64(0x3956c25b, 0xf348b538), new Word64(0x59f111f1, 0xb605d019), new Word64(0x923f82a4, 0xaf194f9b), new Word64(0xab1c5ed5, 0xda6d8118), new Word64(0xd807aa98, 0xa3030242), new Word64(0x12835b01, 0x45706fbe), new Word64(0x243185be, 0x4ee4b28c), new Word64(0x550c7dc3, 0xd5ffb4e2), new Word64(0x72be5d74, 0xf27b896f), new Word64(0x80deb1fe, 0x3b1696b1), new Word64(0x9bdc06a7, 0x25c71235), new Word64(0xc19bf174, 0xcf692694), new Word64(0xe49b69c1, 0x9ef14ad2), new Word64(0xefbe4786, 0x384f25e3), new Word64(0x0fc19dc6, 0x8b8cd5b5), new Word64(0x240ca1cc, 0x77ac9c65), new Word64(0x2de92c6f, 0x592b0275), new Word64(0x4a7484aa, 0x6ea6e483), new Word64(0x5cb0a9dc, 0xbd41fbd4), new Word64(0x76f988da, 0x831153b5), new Word64(0x983e5152, 0xee66dfab), new Word64(0xa831c66d, 0x2db43210), new Word64(0xb00327c8, 0x98fb213f), new Word64(0xbf597fc7, 0xbeef0ee4), new Word64(0xc6e00bf3, 0x3da88fc2), new Word64(0xd5a79147, 0x930aa725), new Word64(0x06ca6351, 0xe003826f), new Word64(0x14292967, 0x0a0e6e70), new Word64(0x27b70a85, 0x46d22ffc), new Word64(0x2e1b2138, 0x5c26c926), new Word64(0x4d2c6dfc, 0x5ac42aed), new Word64(0x53380d13, 0x9d95b3df), new Word64(0x650a7354, 0x8baf63de), new Word64(0x766a0abb, 0x3c77b2a8), new Word64(0x81c2c92e, 0x47edaee6), new Word64(0x92722c85, 0x1482353b), new Word64(0xa2bfe8a1, 0x4cf10364), new Word64(0xa81a664b, 0xbc423001), new Word64(0xc24b8b70, 0xd0f89791), new Word64(0xc76c51a3, 0x0654be30), new Word64(0xd192e819, 0xd6ef5218), new Word64(0xd6990624, 0x5565a910), new Word64(0xf40e3585, 0x5771202a), new Word64(0x106aa070, 0x32bbd1b8), new Word64(0x19a4c116, 0xb8d2d0c8), new Word64(0x1e376c08, 0x5141ab53), new Word64(0x2748774c, 0xdf8eeb99), new Word64(0x34b0bcb5, 0xe19b48a8), new Word64(0x391c0cb3, 0xc5c95a63), new Word64(0x4ed8aa4a, 0xe3418acb), new Word64(0x5b9cca4f, 0x7763e373), new Word64(0x682e6ff3, 0xd6b2b8a3), new Word64(0x748f82ee, 0x5defb2fc), new Word64(0x78a5636f, 0x43172f60), new Word64(0x84c87814, 0xa1f0ab72), new Word64(0x8cc70208, 0x1a6439ec), new Word64(0x90befffa, 0x23631e28), new Word64(0xa4506ceb, 0xde82bde9), new Word64(0xbef9a3f7, 0xb2c67915), new Word64(0xc67178f2, 0xe372532b), new Word64(0xca273ece, 0xea26619c), new Word64(0xd186b8c7, 0x21c0c207), new Word64(0xeada7dd6, 0xcde0eb1e), new Word64(0xf57d4f7f, 0xee6ed178), new Word64(0x06f067aa, 0x72176fba), new Word64(0x0a637dc5, 0xa2c898a6), new Word64(0x113f9804, 0xbef90dae), new Word64(0x1b710b35, 0x131c471b), new Word64(0x28db77f5, 0x23047d84), new Word64(0x32caab7b, 0x40c72493), new Word64(0x3c9ebe0a, 0x15c9bebc), new Word64(0x431d67c4, 0x9c100d4c), new Word64(0x4cc5d4be, 0xcb3e42b6), new Word64(0x597f299c, 0xfc657e2a), new Word64(0x5fcb6fab, 0x3ad6faec), new Word64(0x6c44198c, 0x4a475817)];
	  function hash(data, offset, length, mode384) {
	    mode384 = !!mode384;
	    var h0, h1, h2, h3, h4, h5, h6, h7;
	    if (!mode384) {
	      h0 = new Word64(0x6a09e667, 0xf3bcc908);
	      h1 = new Word64(0xbb67ae85, 0x84caa73b);
	      h2 = new Word64(0x3c6ef372, 0xfe94f82b);
	      h3 = new Word64(0xa54ff53a, 0x5f1d36f1);
	      h4 = new Word64(0x510e527f, 0xade682d1);
	      h5 = new Word64(0x9b05688c, 0x2b3e6c1f);
	      h6 = new Word64(0x1f83d9ab, 0xfb41bd6b);
	      h7 = new Word64(0x5be0cd19, 0x137e2179);
	    } else {
	      h0 = new Word64(0xcbbb9d5d, 0xc1059ed8);
	      h1 = new Word64(0x629a292a, 0x367cd507);
	      h2 = new Word64(0x9159015a, 0x3070dd17);
	      h3 = new Word64(0x152fecd8, 0xf70e5939);
	      h4 = new Word64(0x67332667, 0xffc00b31);
	      h5 = new Word64(0x8eb44a87, 0x68581511);
	      h6 = new Word64(0xdb0c2e0d, 0x64f98fa7);
	      h7 = new Word64(0x47b5481d, 0xbefa4fa4);
	    }
	    var paddedLength = Math.ceil((length + 17) / 128) * 128;
	    var padded = new Uint8Array(paddedLength);
	    var i, j, n;
	    for (i = 0; i < length; ++i) {
	      padded[i] = data[offset++];
	    }
	    padded[i++] = 0x80;
	    n = paddedLength - 16;
	    while (i < n) {
	      padded[i++] = 0;
	    }
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = length >>> 29 & 0xFF;
	    padded[i++] = length >> 21 & 0xFF;
	    padded[i++] = length >> 13 & 0xFF;
	    padded[i++] = length >> 5 & 0xFF;
	    padded[i++] = length << 3 & 0xFF;
	    var w = new Array(80);
	    for (i = 0; i < 80; i++) {
	      w[i] = new Word64(0, 0);
	    }
	    var a = new Word64(0, 0),
	        b = new Word64(0, 0),
	        c = new Word64(0, 0);
	    var d = new Word64(0, 0),
	        e = new Word64(0, 0),
	        f = new Word64(0, 0);
	    var g = new Word64(0, 0),
	        h = new Word64(0, 0);
	    var t1 = new Word64(0, 0),
	        t2 = new Word64(0, 0);
	    var tmp1 = new Word64(0, 0),
	        tmp2 = new Word64(0, 0),
	        tmp3;
	    for (i = 0; i < paddedLength;) {
	      for (j = 0; j < 16; ++j) {
	        w[j].high = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
	        w[j].low = padded[i + 4] << 24 | padded[i + 5] << 16 | padded[i + 6] << 8 | padded[i + 7];
	        i += 8;
	      }
	      for (j = 16; j < 80; ++j) {
	        tmp3 = w[j];
	        littleSigmaPrime(tmp3, w[j - 2], tmp2);
	        tmp3.add(w[j - 7]);
	        littleSigma(tmp1, w[j - 15], tmp2);
	        tmp3.add(tmp1);
	        tmp3.add(w[j - 16]);
	      }
	      a.assign(h0);
	      b.assign(h1);
	      c.assign(h2);
	      d.assign(h3);
	      e.assign(h4);
	      f.assign(h5);
	      g.assign(h6);
	      h.assign(h7);
	      for (j = 0; j < 80; ++j) {
	        t1.assign(h);
	        sigmaPrime(tmp1, e, tmp2);
	        t1.add(tmp1);
	        ch(tmp1, e, f, g, tmp2);
	        t1.add(tmp1);
	        t1.add(k[j]);
	        t1.add(w[j]);
	        sigma(t2, a, tmp2);
	        maj(tmp1, a, b, c, tmp2);
	        t2.add(tmp1);
	        tmp3 = h;
	        h = g;
	        g = f;
	        f = e;
	        d.add(t1);
	        e = d;
	        d = c;
	        c = b;
	        b = a;
	        tmp3.assign(t1);
	        tmp3.add(t2);
	        a = tmp3;
	      }
	      h0.add(a);
	      h1.add(b);
	      h2.add(c);
	      h3.add(d);
	      h4.add(e);
	      h5.add(f);
	      h6.add(g);
	      h7.add(h);
	    }
	    var result;
	    if (!mode384) {
	      result = new Uint8Array(64);
	      h0.copyTo(result, 0);
	      h1.copyTo(result, 8);
	      h2.copyTo(result, 16);
	      h3.copyTo(result, 24);
	      h4.copyTo(result, 32);
	      h5.copyTo(result, 40);
	      h6.copyTo(result, 48);
	      h7.copyTo(result, 56);
	    } else {
	      result = new Uint8Array(48);
	      h0.copyTo(result, 0);
	      h1.copyTo(result, 8);
	      h2.copyTo(result, 16);
	      h3.copyTo(result, 24);
	      h4.copyTo(result, 32);
	      h5.copyTo(result, 40);
	    }
	    return result;
	  }
	  return hash;
	}();
	var calculateSHA384 = function calculateSHA384Closure() {
	  function hash(data, offset, length) {
	    return calculateSHA512(data, offset, length, true);
	  }
	  return hash;
	}();
	var NullCipher = function NullCipherClosure() {
	  function NullCipher() {}
	  NullCipher.prototype = {
	    decryptBlock: function NullCipher_decryptBlock(data) {
	      return data;
	    }
	  };
	  return NullCipher;
	}();
	var AES128Cipher = function AES128CipherClosure() {
	  var rcon = new Uint8Array([0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d]);
	  var s = new Uint8Array([0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76, 0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0, 0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15, 0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75, 0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84, 0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf, 0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8, 0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2, 0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73, 0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb, 0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79, 0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08, 0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a, 0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e, 0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf, 0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16]);
	  var inv_s = new Uint8Array([0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb, 0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb, 0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e, 0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25, 0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92, 0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84, 0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06, 0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b, 0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73, 0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e, 0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b, 0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4, 0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f, 0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef, 0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61, 0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d]);
	  var mixCol = new Uint8Array(256);
	  for (var i = 0; i < 256; i++) {
	    if (i < 128) {
	      mixCol[i] = i << 1;
	    } else {
	      mixCol[i] = i << 1 ^ 0x1b;
	    }
	  }
	  var mix = new Uint32Array([0x00000000, 0x0e090d0b, 0x1c121a16, 0x121b171d, 0x3824342c, 0x362d3927, 0x24362e3a, 0x2a3f2331, 0x70486858, 0x7e416553, 0x6c5a724e, 0x62537f45, 0x486c5c74, 0x4665517f, 0x547e4662, 0x5a774b69, 0xe090d0b0, 0xee99ddbb, 0xfc82caa6, 0xf28bc7ad, 0xd8b4e49c, 0xd6bde997, 0xc4a6fe8a, 0xcaaff381, 0x90d8b8e8, 0x9ed1b5e3, 0x8ccaa2fe, 0x82c3aff5, 0xa8fc8cc4, 0xa6f581cf, 0xb4ee96d2, 0xbae79bd9, 0xdb3bbb7b, 0xd532b670, 0xc729a16d, 0xc920ac66, 0xe31f8f57, 0xed16825c, 0xff0d9541, 0xf104984a, 0xab73d323, 0xa57ade28, 0xb761c935, 0xb968c43e, 0x9357e70f, 0x9d5eea04, 0x8f45fd19, 0x814cf012, 0x3bab6bcb, 0x35a266c0, 0x27b971dd, 0x29b07cd6, 0x038f5fe7, 0x0d8652ec, 0x1f9d45f1, 0x119448fa, 0x4be30393, 0x45ea0e98, 0x57f11985, 0x59f8148e, 0x73c737bf, 0x7dce3ab4, 0x6fd52da9, 0x61dc20a2, 0xad766df6, 0xa37f60fd, 0xb16477e0, 0xbf6d7aeb, 0x955259da, 0x9b5b54d1, 0x894043cc, 0x87494ec7, 0xdd3e05ae, 0xd33708a5, 0xc12c1fb8, 0xcf2512b3, 0xe51a3182, 0xeb133c89, 0xf9082b94, 0xf701269f, 0x4de6bd46, 0x43efb04d, 0x51f4a750, 0x5ffdaa5b, 0x75c2896a, 0x7bcb8461, 0x69d0937c, 0x67d99e77, 0x3daed51e, 0x33a7d815, 0x21bccf08, 0x2fb5c203, 0x058ae132, 0x0b83ec39, 0x1998fb24, 0x1791f62f, 0x764dd68d, 0x7844db86, 0x6a5fcc9b, 0x6456c190, 0x4e69e2a1, 0x4060efaa, 0x527bf8b7, 0x5c72f5bc, 0x0605bed5, 0x080cb3de, 0x1a17a4c3, 0x141ea9c8, 0x3e218af9, 0x302887f2, 0x223390ef, 0x2c3a9de4, 0x96dd063d, 0x98d40b36, 0x8acf1c2b, 0x84c61120, 0xaef93211, 0xa0f03f1a, 0xb2eb2807, 0xbce2250c, 0xe6956e65, 0xe89c636e, 0xfa877473, 0xf48e7978, 0xdeb15a49, 0xd0b85742, 0xc2a3405f, 0xccaa4d54, 0x41ecdaf7, 0x4fe5d7fc, 0x5dfec0e1, 0x53f7cdea, 0x79c8eedb, 0x77c1e3d0, 0x65daf4cd, 0x6bd3f9c6, 0x31a4b2af, 0x3fadbfa4, 0x2db6a8b9, 0x23bfa5b2, 0x09808683, 0x07898b88, 0x15929c95, 0x1b9b919e, 0xa17c0a47, 0xaf75074c, 0xbd6e1051, 0xb3671d5a, 0x99583e6b, 0x97513360, 0x854a247d, 0x8b432976, 0xd134621f, 0xdf3d6f14, 0xcd267809, 0xc32f7502, 0xe9105633, 0xe7195b38, 0xf5024c25, 0xfb0b412e, 0x9ad7618c, 0x94de6c87, 0x86c57b9a, 0x88cc7691, 0xa2f355a0, 0xacfa58ab, 0xbee14fb6, 0xb0e842bd, 0xea9f09d4, 0xe49604df, 0xf68d13c2, 0xf8841ec9, 0xd2bb3df8, 0xdcb230f3, 0xcea927ee, 0xc0a02ae5, 0x7a47b13c, 0x744ebc37, 0x6655ab2a, 0x685ca621, 0x42638510, 0x4c6a881b, 0x5e719f06, 0x5078920d, 0x0a0fd964, 0x0406d46f, 0x161dc372, 0x1814ce79, 0x322bed48, 0x3c22e043, 0x2e39f75e, 0x2030fa55, 0xec9ab701, 0xe293ba0a, 0xf088ad17, 0xfe81a01c, 0xd4be832d, 0xdab78e26, 0xc8ac993b, 0xc6a59430, 0x9cd2df59, 0x92dbd252, 0x80c0c54f, 0x8ec9c844, 0xa4f6eb75, 0xaaffe67e, 0xb8e4f163, 0xb6edfc68, 0x0c0a67b1, 0x02036aba, 0x10187da7, 0x1e1170ac, 0x342e539d, 0x3a275e96, 0x283c498b, 0x26354480, 0x7c420fe9, 0x724b02e2, 0x605015ff, 0x6e5918f4, 0x44663bc5, 0x4a6f36ce, 0x587421d3, 0x567d2cd8, 0x37a10c7a, 0x39a80171, 0x2bb3166c, 0x25ba1b67, 0x0f853856, 0x018c355d, 0x13972240, 0x1d9e2f4b, 0x47e96422, 0x49e06929, 0x5bfb7e34, 0x55f2733f, 0x7fcd500e, 0x71c45d05, 0x63df4a18, 0x6dd64713, 0xd731dcca, 0xd938d1c1, 0xcb23c6dc, 0xc52acbd7, 0xef15e8e6, 0xe11ce5ed, 0xf307f2f0, 0xfd0efffb, 0xa779b492, 0xa970b999, 0xbb6bae84, 0xb562a38f, 0x9f5d80be, 0x91548db5, 0x834f9aa8, 0x8d4697a3]);
	  function expandKey128(cipherKey) {
	    var b = 176,
	        result = new Uint8Array(b);
	    result.set(cipherKey);
	    for (var j = 16, i = 1; j < b; ++i) {
	      var t1 = result[j - 3],
	          t2 = result[j - 2],
	          t3 = result[j - 1],
	          t4 = result[j - 4];
	      t1 = s[t1];
	      t2 = s[t2];
	      t3 = s[t3];
	      t4 = s[t4];
	      t1 = t1 ^ rcon[i];
	      for (var n = 0; n < 4; ++n) {
	        result[j] = t1 ^= result[j - 16];
	        j++;
	        result[j] = t2 ^= result[j - 16];
	        j++;
	        result[j] = t3 ^= result[j - 16];
	        j++;
	        result[j] = t4 ^= result[j - 16];
	        j++;
	      }
	    }
	    return result;
	  }
	  function decrypt128(input, key) {
	    var state = new Uint8Array(16);
	    state.set(input);
	    var i, j, k;
	    var t, u, v;
	    for (j = 0, k = 160; j < 16; ++j, ++k) {
	      state[j] ^= key[k];
	    }
	    for (i = 9; i >= 1; --i) {
	      t = state[13];
	      state[13] = state[9];
	      state[9] = state[5];
	      state[5] = state[1];
	      state[1] = t;
	      t = state[14];
	      u = state[10];
	      state[14] = state[6];
	      state[10] = state[2];
	      state[6] = t;
	      state[2] = u;
	      t = state[15];
	      u = state[11];
	      v = state[7];
	      state[15] = state[3];
	      state[11] = t;
	      state[7] = u;
	      state[3] = v;
	      for (j = 0; j < 16; ++j) {
	        state[j] = inv_s[state[j]];
	      }
	      for (j = 0, k = i * 16; j < 16; ++j, ++k) {
	        state[j] ^= key[k];
	      }
	      for (j = 0; j < 16; j += 4) {
	        var s0 = mix[state[j]],
	            s1 = mix[state[j + 1]],
	            s2 = mix[state[j + 2]],
	            s3 = mix[state[j + 3]];
	        t = s0 ^ s1 >>> 8 ^ s1 << 24 ^ s2 >>> 16 ^ s2 << 16 ^ s3 >>> 24 ^ s3 << 8;
	        state[j] = t >>> 24 & 0xFF;
	        state[j + 1] = t >> 16 & 0xFF;
	        state[j + 2] = t >> 8 & 0xFF;
	        state[j + 3] = t & 0xFF;
	      }
	    }
	    t = state[13];
	    state[13] = state[9];
	    state[9] = state[5];
	    state[5] = state[1];
	    state[1] = t;
	    t = state[14];
	    u = state[10];
	    state[14] = state[6];
	    state[10] = state[2];
	    state[6] = t;
	    state[2] = u;
	    t = state[15];
	    u = state[11];
	    v = state[7];
	    state[15] = state[3];
	    state[11] = t;
	    state[7] = u;
	    state[3] = v;
	    for (j = 0; j < 16; ++j) {
	      state[j] = inv_s[state[j]];
	      state[j] ^= key[j];
	    }
	    return state;
	  }
	  function encrypt128(input, key) {
	    var t, u, v, k;
	    var state = new Uint8Array(16);
	    state.set(input);
	    for (j = 0; j < 16; ++j) {
	      state[j] ^= key[j];
	    }
	    for (i = 1; i < 10; i++) {
	      for (j = 0; j < 16; ++j) {
	        state[j] = s[state[j]];
	      }
	      v = state[1];
	      state[1] = state[5];
	      state[5] = state[9];
	      state[9] = state[13];
	      state[13] = v;
	      v = state[2];
	      u = state[6];
	      state[2] = state[10];
	      state[6] = state[14];
	      state[10] = v;
	      state[14] = u;
	      v = state[3];
	      u = state[7];
	      t = state[11];
	      state[3] = state[15];
	      state[7] = v;
	      state[11] = u;
	      state[15] = t;
	      for (var j = 0; j < 16; j += 4) {
	        var s0 = state[j + 0],
	            s1 = state[j + 1];
	        var s2 = state[j + 2],
	            s3 = state[j + 3];
	        t = s0 ^ s1 ^ s2 ^ s3;
	        state[j + 0] ^= t ^ mixCol[s0 ^ s1];
	        state[j + 1] ^= t ^ mixCol[s1 ^ s2];
	        state[j + 2] ^= t ^ mixCol[s2 ^ s3];
	        state[j + 3] ^= t ^ mixCol[s3 ^ s0];
	      }
	      for (j = 0, k = i * 16; j < 16; ++j, ++k) {
	        state[j] ^= key[k];
	      }
	    }
	    for (j = 0; j < 16; ++j) {
	      state[j] = s[state[j]];
	    }
	    v = state[1];
	    state[1] = state[5];
	    state[5] = state[9];
	    state[9] = state[13];
	    state[13] = v;
	    v = state[2];
	    u = state[6];
	    state[2] = state[10];
	    state[6] = state[14];
	    state[10] = v;
	    state[14] = u;
	    v = state[3];
	    u = state[7];
	    t = state[11];
	    state[3] = state[15];
	    state[7] = v;
	    state[11] = u;
	    state[15] = t;
	    for (j = 0, k = 160; j < 16; ++j, ++k) {
	      state[j] ^= key[k];
	    }
	    return state;
	  }
	  function AES128Cipher(key) {
	    this.key = expandKey128(key);
	    this.buffer = new Uint8Array(16);
	    this.bufferPosition = 0;
	  }
	  function decryptBlock2(data, finalize) {
	    var i,
	        j,
	        ii,
	        sourceLength = data.length,
	        buffer = this.buffer,
	        bufferLength = this.bufferPosition,
	        result = [],
	        iv = this.iv;
	    for (i = 0; i < sourceLength; ++i) {
	      buffer[bufferLength] = data[i];
	      ++bufferLength;
	      if (bufferLength < 16) {
	        continue;
	      }
	      var plain = decrypt128(buffer, this.key);
	      for (j = 0; j < 16; ++j) {
	        plain[j] ^= iv[j];
	      }
	      iv = buffer;
	      result.push(plain);
	      buffer = new Uint8Array(16);
	      bufferLength = 0;
	    }
	    this.buffer = buffer;
	    this.bufferLength = bufferLength;
	    this.iv = iv;
	    if (result.length === 0) {
	      return new Uint8Array([]);
	    }
	    var outputLength = 16 * result.length;
	    if (finalize) {
	      var lastBlock = result[result.length - 1];
	      var psLen = lastBlock[15];
	      if (psLen <= 16) {
	        for (i = 15, ii = 16 - psLen; i >= ii; --i) {
	          if (lastBlock[i] !== psLen) {
	            psLen = 0;
	            break;
	          }
	        }
	        outputLength -= psLen;
	        result[result.length - 1] = lastBlock.subarray(0, 16 - psLen);
	      }
	    }
	    var output = new Uint8Array(outputLength);
	    for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
	      output.set(result[i], j);
	    }
	    return output;
	  }
	  AES128Cipher.prototype = {
	    decryptBlock: function AES128Cipher_decryptBlock(data, finalize) {
	      var i,
	          sourceLength = data.length;
	      var buffer = this.buffer,
	          bufferLength = this.bufferPosition;
	      for (i = 0; bufferLength < 16 && i < sourceLength; ++i, ++bufferLength) {
	        buffer[bufferLength] = data[i];
	      }
	      if (bufferLength < 16) {
	        this.bufferLength = bufferLength;
	        return new Uint8Array([]);
	      }
	      this.iv = buffer;
	      this.buffer = new Uint8Array(16);
	      this.bufferLength = 0;
	      this.decryptBlock = decryptBlock2;
	      return this.decryptBlock(data.subarray(16), finalize);
	    },
	    encrypt: function AES128Cipher_encrypt(data, iv) {
	      var i,
	          j,
	          ii,
	          sourceLength = data.length,
	          buffer = this.buffer,
	          bufferLength = this.bufferPosition,
	          result = [];
	      if (!iv) {
	        iv = new Uint8Array(16);
	      }
	      for (i = 0; i < sourceLength; ++i) {
	        buffer[bufferLength] = data[i];
	        ++bufferLength;
	        if (bufferLength < 16) {
	          continue;
	        }
	        for (j = 0; j < 16; ++j) {
	          buffer[j] ^= iv[j];
	        }
	        var cipher = encrypt128(buffer, this.key);
	        iv = cipher;
	        result.push(cipher);
	        buffer = new Uint8Array(16);
	        bufferLength = 0;
	      }
	      this.buffer = buffer;
	      this.bufferLength = bufferLength;
	      this.iv = iv;
	      if (result.length === 0) {
	        return new Uint8Array([]);
	      }
	      var outputLength = 16 * result.length;
	      var output = new Uint8Array(outputLength);
	      for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
	        output.set(result[i], j);
	      }
	      return output;
	    }
	  };
	  return AES128Cipher;
	}();
	var AES256Cipher = function AES256CipherClosure() {
	  var s = new Uint8Array([0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76, 0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0, 0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15, 0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75, 0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84, 0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf, 0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8, 0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2, 0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73, 0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb, 0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79, 0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08, 0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a, 0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e, 0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf, 0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16]);
	  var inv_s = new Uint8Array([0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb, 0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb, 0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e, 0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25, 0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92, 0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84, 0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06, 0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b, 0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73, 0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e, 0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b, 0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4, 0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f, 0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef, 0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61, 0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d]);
	  var mixCol = new Uint8Array(256);
	  for (var i = 0; i < 256; i++) {
	    if (i < 128) {
	      mixCol[i] = i << 1;
	    } else {
	      mixCol[i] = i << 1 ^ 0x1b;
	    }
	  }
	  var mix = new Uint32Array([0x00000000, 0x0e090d0b, 0x1c121a16, 0x121b171d, 0x3824342c, 0x362d3927, 0x24362e3a, 0x2a3f2331, 0x70486858, 0x7e416553, 0x6c5a724e, 0x62537f45, 0x486c5c74, 0x4665517f, 0x547e4662, 0x5a774b69, 0xe090d0b0, 0xee99ddbb, 0xfc82caa6, 0xf28bc7ad, 0xd8b4e49c, 0xd6bde997, 0xc4a6fe8a, 0xcaaff381, 0x90d8b8e8, 0x9ed1b5e3, 0x8ccaa2fe, 0x82c3aff5, 0xa8fc8cc4, 0xa6f581cf, 0xb4ee96d2, 0xbae79bd9, 0xdb3bbb7b, 0xd532b670, 0xc729a16d, 0xc920ac66, 0xe31f8f57, 0xed16825c, 0xff0d9541, 0xf104984a, 0xab73d323, 0xa57ade28, 0xb761c935, 0xb968c43e, 0x9357e70f, 0x9d5eea04, 0x8f45fd19, 0x814cf012, 0x3bab6bcb, 0x35a266c0, 0x27b971dd, 0x29b07cd6, 0x038f5fe7, 0x0d8652ec, 0x1f9d45f1, 0x119448fa, 0x4be30393, 0x45ea0e98, 0x57f11985, 0x59f8148e, 0x73c737bf, 0x7dce3ab4, 0x6fd52da9, 0x61dc20a2, 0xad766df6, 0xa37f60fd, 0xb16477e0, 0xbf6d7aeb, 0x955259da, 0x9b5b54d1, 0x894043cc, 0x87494ec7, 0xdd3e05ae, 0xd33708a5, 0xc12c1fb8, 0xcf2512b3, 0xe51a3182, 0xeb133c89, 0xf9082b94, 0xf701269f, 0x4de6bd46, 0x43efb04d, 0x51f4a750, 0x5ffdaa5b, 0x75c2896a, 0x7bcb8461, 0x69d0937c, 0x67d99e77, 0x3daed51e, 0x33a7d815, 0x21bccf08, 0x2fb5c203, 0x058ae132, 0x0b83ec39, 0x1998fb24, 0x1791f62f, 0x764dd68d, 0x7844db86, 0x6a5fcc9b, 0x6456c190, 0x4e69e2a1, 0x4060efaa, 0x527bf8b7, 0x5c72f5bc, 0x0605bed5, 0x080cb3de, 0x1a17a4c3, 0x141ea9c8, 0x3e218af9, 0x302887f2, 0x223390ef, 0x2c3a9de4, 0x96dd063d, 0x98d40b36, 0x8acf1c2b, 0x84c61120, 0xaef93211, 0xa0f03f1a, 0xb2eb2807, 0xbce2250c, 0xe6956e65, 0xe89c636e, 0xfa877473, 0xf48e7978, 0xdeb15a49, 0xd0b85742, 0xc2a3405f, 0xccaa4d54, 0x41ecdaf7, 0x4fe5d7fc, 0x5dfec0e1, 0x53f7cdea, 0x79c8eedb, 0x77c1e3d0, 0x65daf4cd, 0x6bd3f9c6, 0x31a4b2af, 0x3fadbfa4, 0x2db6a8b9, 0x23bfa5b2, 0x09808683, 0x07898b88, 0x15929c95, 0x1b9b919e, 0xa17c0a47, 0xaf75074c, 0xbd6e1051, 0xb3671d5a, 0x99583e6b, 0x97513360, 0x854a247d, 0x8b432976, 0xd134621f, 0xdf3d6f14, 0xcd267809, 0xc32f7502, 0xe9105633, 0xe7195b38, 0xf5024c25, 0xfb0b412e, 0x9ad7618c, 0x94de6c87, 0x86c57b9a, 0x88cc7691, 0xa2f355a0, 0xacfa58ab, 0xbee14fb6, 0xb0e842bd, 0xea9f09d4, 0xe49604df, 0xf68d13c2, 0xf8841ec9, 0xd2bb3df8, 0xdcb230f3, 0xcea927ee, 0xc0a02ae5, 0x7a47b13c, 0x744ebc37, 0x6655ab2a, 0x685ca621, 0x42638510, 0x4c6a881b, 0x5e719f06, 0x5078920d, 0x0a0fd964, 0x0406d46f, 0x161dc372, 0x1814ce79, 0x322bed48, 0x3c22e043, 0x2e39f75e, 0x2030fa55, 0xec9ab701, 0xe293ba0a, 0xf088ad17, 0xfe81a01c, 0xd4be832d, 0xdab78e26, 0xc8ac993b, 0xc6a59430, 0x9cd2df59, 0x92dbd252, 0x80c0c54f, 0x8ec9c844, 0xa4f6eb75, 0xaaffe67e, 0xb8e4f163, 0xb6edfc68, 0x0c0a67b1, 0x02036aba, 0x10187da7, 0x1e1170ac, 0x342e539d, 0x3a275e96, 0x283c498b, 0x26354480, 0x7c420fe9, 0x724b02e2, 0x605015ff, 0x6e5918f4, 0x44663bc5, 0x4a6f36ce, 0x587421d3, 0x567d2cd8, 0x37a10c7a, 0x39a80171, 0x2bb3166c, 0x25ba1b67, 0x0f853856, 0x018c355d, 0x13972240, 0x1d9e2f4b, 0x47e96422, 0x49e06929, 0x5bfb7e34, 0x55f2733f, 0x7fcd500e, 0x71c45d05, 0x63df4a18, 0x6dd64713, 0xd731dcca, 0xd938d1c1, 0xcb23c6dc, 0xc52acbd7, 0xef15e8e6, 0xe11ce5ed, 0xf307f2f0, 0xfd0efffb, 0xa779b492, 0xa970b999, 0xbb6bae84, 0xb562a38f, 0x9f5d80be, 0x91548db5, 0x834f9aa8, 0x8d4697a3]);
	  function expandKey256(cipherKey) {
	    var b = 240,
	        result = new Uint8Array(b);
	    var r = 1;
	    result.set(cipherKey);
	    for (var j = 32, i = 1; j < b; ++i) {
	      if (j % 32 === 16) {
	        t1 = s[t1];
	        t2 = s[t2];
	        t3 = s[t3];
	        t4 = s[t4];
	      } else if (j % 32 === 0) {
	        var t1 = result[j - 3],
	            t2 = result[j - 2],
	            t3 = result[j - 1],
	            t4 = result[j - 4];
	        t1 = s[t1];
	        t2 = s[t2];
	        t3 = s[t3];
	        t4 = s[t4];
	        t1 = t1 ^ r;
	        if ((r <<= 1) >= 256) {
	          r = (r ^ 0x1b) & 0xFF;
	        }
	      }
	      for (var n = 0; n < 4; ++n) {
	        result[j] = t1 ^= result[j - 32];
	        j++;
	        result[j] = t2 ^= result[j - 32];
	        j++;
	        result[j] = t3 ^= result[j - 32];
	        j++;
	        result[j] = t4 ^= result[j - 32];
	        j++;
	      }
	    }
	    return result;
	  }
	  function decrypt256(input, key) {
	    var state = new Uint8Array(16);
	    state.set(input);
	    var i, j, k;
	    var t, u, v;
	    for (j = 0, k = 224; j < 16; ++j, ++k) {
	      state[j] ^= key[k];
	    }
	    for (i = 13; i >= 1; --i) {
	      t = state[13];
	      state[13] = state[9];
	      state[9] = state[5];
	      state[5] = state[1];
	      state[1] = t;
	      t = state[14];
	      u = state[10];
	      state[14] = state[6];
	      state[10] = state[2];
	      state[6] = t;
	      state[2] = u;
	      t = state[15];
	      u = state[11];
	      v = state[7];
	      state[15] = state[3];
	      state[11] = t;
	      state[7] = u;
	      state[3] = v;
	      for (j = 0; j < 16; ++j) {
	        state[j] = inv_s[state[j]];
	      }
	      for (j = 0, k = i * 16; j < 16; ++j, ++k) {
	        state[j] ^= key[k];
	      }
	      for (j = 0; j < 16; j += 4) {
	        var s0 = mix[state[j]],
	            s1 = mix[state[j + 1]],
	            s2 = mix[state[j + 2]],
	            s3 = mix[state[j + 3]];
	        t = s0 ^ s1 >>> 8 ^ s1 << 24 ^ s2 >>> 16 ^ s2 << 16 ^ s3 >>> 24 ^ s3 << 8;
	        state[j] = t >>> 24 & 0xFF;
	        state[j + 1] = t >> 16 & 0xFF;
	        state[j + 2] = t >> 8 & 0xFF;
	        state[j + 3] = t & 0xFF;
	      }
	    }
	    t = state[13];
	    state[13] = state[9];
	    state[9] = state[5];
	    state[5] = state[1];
	    state[1] = t;
	    t = state[14];
	    u = state[10];
	    state[14] = state[6];
	    state[10] = state[2];
	    state[6] = t;
	    state[2] = u;
	    t = state[15];
	    u = state[11];
	    v = state[7];
	    state[15] = state[3];
	    state[11] = t;
	    state[7] = u;
	    state[3] = v;
	    for (j = 0; j < 16; ++j) {
	      state[j] = inv_s[state[j]];
	      state[j] ^= key[j];
	    }
	    return state;
	  }
	  function encrypt256(input, key) {
	    var t, u, v, k;
	    var state = new Uint8Array(16);
	    state.set(input);
	    for (j = 0; j < 16; ++j) {
	      state[j] ^= key[j];
	    }
	    for (i = 1; i < 14; i++) {
	      for (j = 0; j < 16; ++j) {
	        state[j] = s[state[j]];
	      }
	      v = state[1];
	      state[1] = state[5];
	      state[5] = state[9];
	      state[9] = state[13];
	      state[13] = v;
	      v = state[2];
	      u = state[6];
	      state[2] = state[10];
	      state[6] = state[14];
	      state[10] = v;
	      state[14] = u;
	      v = state[3];
	      u = state[7];
	      t = state[11];
	      state[3] = state[15];
	      state[7] = v;
	      state[11] = u;
	      state[15] = t;
	      for (var j = 0; j < 16; j += 4) {
	        var s0 = state[j + 0],
	            s1 = state[j + 1];
	        var s2 = state[j + 2],
	            s3 = state[j + 3];
	        t = s0 ^ s1 ^ s2 ^ s3;
	        state[j + 0] ^= t ^ mixCol[s0 ^ s1];
	        state[j + 1] ^= t ^ mixCol[s1 ^ s2];
	        state[j + 2] ^= t ^ mixCol[s2 ^ s3];
	        state[j + 3] ^= t ^ mixCol[s3 ^ s0];
	      }
	      for (j = 0, k = i * 16; j < 16; ++j, ++k) {
	        state[j] ^= key[k];
	      }
	    }
	    for (j = 0; j < 16; ++j) {
	      state[j] = s[state[j]];
	    }
	    v = state[1];
	    state[1] = state[5];
	    state[5] = state[9];
	    state[9] = state[13];
	    state[13] = v;
	    v = state[2];
	    u = state[6];
	    state[2] = state[10];
	    state[6] = state[14];
	    state[10] = v;
	    state[14] = u;
	    v = state[3];
	    u = state[7];
	    t = state[11];
	    state[3] = state[15];
	    state[7] = v;
	    state[11] = u;
	    state[15] = t;
	    for (j = 0, k = 224; j < 16; ++j, ++k) {
	      state[j] ^= key[k];
	    }
	    return state;
	  }
	  function AES256Cipher(key) {
	    this.key = expandKey256(key);
	    this.buffer = new Uint8Array(16);
	    this.bufferPosition = 0;
	  }
	  function decryptBlock2(data, finalize) {
	    var i,
	        j,
	        ii,
	        sourceLength = data.length,
	        buffer = this.buffer,
	        bufferLength = this.bufferPosition,
	        result = [],
	        iv = this.iv;
	    for (i = 0; i < sourceLength; ++i) {
	      buffer[bufferLength] = data[i];
	      ++bufferLength;
	      if (bufferLength < 16) {
	        continue;
	      }
	      var plain = decrypt256(buffer, this.key);
	      for (j = 0; j < 16; ++j) {
	        plain[j] ^= iv[j];
	      }
	      iv = buffer;
	      result.push(plain);
	      buffer = new Uint8Array(16);
	      bufferLength = 0;
	    }
	    this.buffer = buffer;
	    this.bufferLength = bufferLength;
	    this.iv = iv;
	    if (result.length === 0) {
	      return new Uint8Array([]);
	    }
	    var outputLength = 16 * result.length;
	    if (finalize) {
	      var lastBlock = result[result.length - 1];
	      var psLen = lastBlock[15];
	      if (psLen <= 16) {
	        for (i = 15, ii = 16 - psLen; i >= ii; --i) {
	          if (lastBlock[i] !== psLen) {
	            psLen = 0;
	            break;
	          }
	        }
	        outputLength -= psLen;
	        result[result.length - 1] = lastBlock.subarray(0, 16 - psLen);
	      }
	    }
	    var output = new Uint8Array(outputLength);
	    for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
	      output.set(result[i], j);
	    }
	    return output;
	  }
	  AES256Cipher.prototype = {
	    decryptBlock: function AES256Cipher_decryptBlock(data, finalize, iv) {
	      var i,
	          sourceLength = data.length;
	      var buffer = this.buffer,
	          bufferLength = this.bufferPosition;
	      if (iv) {
	        this.iv = iv;
	      } else {
	        for (i = 0; bufferLength < 16 && i < sourceLength; ++i, ++bufferLength) {
	          buffer[bufferLength] = data[i];
	        }
	        if (bufferLength < 16) {
	          this.bufferLength = bufferLength;
	          return new Uint8Array([]);
	        }
	        this.iv = buffer;
	        data = data.subarray(16);
	      }
	      this.buffer = new Uint8Array(16);
	      this.bufferLength = 0;
	      this.decryptBlock = decryptBlock2;
	      return this.decryptBlock(data, finalize);
	    },
	    encrypt: function AES256Cipher_encrypt(data, iv) {
	      var i,
	          j,
	          ii,
	          sourceLength = data.length,
	          buffer = this.buffer,
	          bufferLength = this.bufferPosition,
	          result = [];
	      if (!iv) {
	        iv = new Uint8Array(16);
	      }
	      for (i = 0; i < sourceLength; ++i) {
	        buffer[bufferLength] = data[i];
	        ++bufferLength;
	        if (bufferLength < 16) {
	          continue;
	        }
	        for (j = 0; j < 16; ++j) {
	          buffer[j] ^= iv[j];
	        }
	        var cipher = encrypt256(buffer, this.key);
	        this.iv = cipher;
	        result.push(cipher);
	        buffer = new Uint8Array(16);
	        bufferLength = 0;
	      }
	      this.buffer = buffer;
	      this.bufferLength = bufferLength;
	      this.iv = iv;
	      if (result.length === 0) {
	        return new Uint8Array([]);
	      }
	      var outputLength = 16 * result.length;
	      var output = new Uint8Array(outputLength);
	      for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
	        output.set(result[i], j);
	      }
	      return output;
	    }
	  };
	  return AES256Cipher;
	}();
	var PDF17 = function PDF17Closure() {
	  function compareByteArrays(array1, array2) {
	    if (array1.length !== array2.length) {
	      return false;
	    }
	    for (var i = 0; i < array1.length; i++) {
	      if (array1[i] !== array2[i]) {
	        return false;
	      }
	    }
	    return true;
	  }
	  function PDF17() {}
	  PDF17.prototype = {
	    checkOwnerPassword: function PDF17_checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
	      var hashData = new Uint8Array(password.length + 56);
	      hashData.set(password, 0);
	      hashData.set(ownerValidationSalt, password.length);
	      hashData.set(userBytes, password.length + ownerValidationSalt.length);
	      var result = calculateSHA256(hashData, 0, hashData.length);
	      return compareByteArrays(result, ownerPassword);
	    },
	    checkUserPassword: function PDF17_checkUserPassword(password, userValidationSalt, userPassword) {
	      var hashData = new Uint8Array(password.length + 8);
	      hashData.set(password, 0);
	      hashData.set(userValidationSalt, password.length);
	      var result = calculateSHA256(hashData, 0, hashData.length);
	      return compareByteArrays(result, userPassword);
	    },
	    getOwnerKey: function PDF17_getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
	      var hashData = new Uint8Array(password.length + 56);
	      hashData.set(password, 0);
	      hashData.set(ownerKeySalt, password.length);
	      hashData.set(userBytes, password.length + ownerKeySalt.length);
	      var key = calculateSHA256(hashData, 0, hashData.length);
	      var cipher = new AES256Cipher(key);
	      return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
	    },
	    getUserKey: function PDF17_getUserKey(password, userKeySalt, userEncryption) {
	      var hashData = new Uint8Array(password.length + 8);
	      hashData.set(password, 0);
	      hashData.set(userKeySalt, password.length);
	      var key = calculateSHA256(hashData, 0, hashData.length);
	      var cipher = new AES256Cipher(key);
	      return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
	    }
	  };
	  return PDF17;
	}();
	var PDF20 = function PDF20Closure() {
	  function concatArrays(array1, array2) {
	    var t = new Uint8Array(array1.length + array2.length);
	    t.set(array1, 0);
	    t.set(array2, array1.length);
	    return t;
	  }
	  function calculatePDF20Hash(password, input, userBytes) {
	    var k = calculateSHA256(input, 0, input.length).subarray(0, 32);
	    var e = [0];
	    var i = 0;
	    while (i < 64 || e[e.length - 1] > i - 32) {
	      var arrayLength = password.length + k.length + userBytes.length;
	      var k1 = new Uint8Array(arrayLength * 64);
	      var array = concatArrays(password, k);
	      array = concatArrays(array, userBytes);
	      for (var j = 0, pos = 0; j < 64; j++, pos += arrayLength) {
	        k1.set(array, pos);
	      }
	      var cipher = new AES128Cipher(k.subarray(0, 16));
	      e = cipher.encrypt(k1, k.subarray(16, 32));
	      var remainder = 0;
	      for (var z = 0; z < 16; z++) {
	        remainder *= 256 % 3;
	        remainder %= 3;
	        remainder += (e[z] >>> 0) % 3;
	        remainder %= 3;
	      }
	      if (remainder === 0) {
	        k = calculateSHA256(e, 0, e.length);
	      } else if (remainder === 1) {
	        k = calculateSHA384(e, 0, e.length);
	      } else if (remainder === 2) {
	        k = calculateSHA512(e, 0, e.length);
	      }
	      i++;
	    }
	    return k.subarray(0, 32);
	  }
	  function PDF20() {}
	  function compareByteArrays(array1, array2) {
	    if (array1.length !== array2.length) {
	      return false;
	    }
	    for (var i = 0; i < array1.length; i++) {
	      if (array1[i] !== array2[i]) {
	        return false;
	      }
	    }
	    return true;
	  }
	  PDF20.prototype = {
	    hash: function PDF20_hash(password, concatBytes, userBytes) {
	      return calculatePDF20Hash(password, concatBytes, userBytes);
	    },
	    checkOwnerPassword: function PDF20_checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
	      var hashData = new Uint8Array(password.length + 56);
	      hashData.set(password, 0);
	      hashData.set(ownerValidationSalt, password.length);
	      hashData.set(userBytes, password.length + ownerValidationSalt.length);
	      var result = calculatePDF20Hash(password, hashData, userBytes);
	      return compareByteArrays(result, ownerPassword);
	    },
	    checkUserPassword: function PDF20_checkUserPassword(password, userValidationSalt, userPassword) {
	      var hashData = new Uint8Array(password.length + 8);
	      hashData.set(password, 0);
	      hashData.set(userValidationSalt, password.length);
	      var result = calculatePDF20Hash(password, hashData, []);
	      return compareByteArrays(result, userPassword);
	    },
	    getOwnerKey: function PDF20_getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
	      var hashData = new Uint8Array(password.length + 56);
	      hashData.set(password, 0);
	      hashData.set(ownerKeySalt, password.length);
	      hashData.set(userBytes, password.length + ownerKeySalt.length);
	      var key = calculatePDF20Hash(password, hashData, userBytes);
	      var cipher = new AES256Cipher(key);
	      return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
	    },
	    getUserKey: function PDF20_getUserKey(password, userKeySalt, userEncryption) {
	      var hashData = new Uint8Array(password.length + 8);
	      hashData.set(password, 0);
	      hashData.set(userKeySalt, password.length);
	      var key = calculatePDF20Hash(password, hashData, []);
	      var cipher = new AES256Cipher(key);
	      return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
	    }
	  };
	  return PDF20;
	}();
	var CipherTransform = function CipherTransformClosure() {
	  function CipherTransform(stringCipherConstructor, streamCipherConstructor) {
	    this.StringCipherConstructor = stringCipherConstructor;
	    this.StreamCipherConstructor = streamCipherConstructor;
	  }
	  CipherTransform.prototype = {
	    createStream: function CipherTransform_createStream(stream, length) {
	      var cipher = new this.StreamCipherConstructor();
	      return new DecryptStream(stream, length, function cipherTransformDecryptStream(data, finalize) {
	        return cipher.decryptBlock(data, finalize);
	      });
	    },
	    decryptString: function CipherTransform_decryptString(s) {
	      var cipher = new this.StringCipherConstructor();
	      var data = stringToBytes(s);
	      data = cipher.decryptBlock(data, true);
	      return bytesToString(data);
	    }
	  };
	  return CipherTransform;
	}();
	var CipherTransformFactory = function CipherTransformFactoryClosure() {
	  var defaultPasswordBytes = new Uint8Array([0x28, 0xBF, 0x4E, 0x5E, 0x4E, 0x75, 0x8A, 0x41, 0x64, 0x00, 0x4E, 0x56, 0xFF, 0xFA, 0x01, 0x08, 0x2E, 0x2E, 0x00, 0xB6, 0xD0, 0x68, 0x3E, 0x80, 0x2F, 0x0C, 0xA9, 0xFE, 0x64, 0x53, 0x69, 0x7A]);
	  function createEncryptionKey20(revision, password, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms) {
	    if (password) {
	      var passwordLength = Math.min(127, password.length);
	      password = password.subarray(0, passwordLength);
	    } else {
	      password = [];
	    }
	    var pdfAlgorithm;
	    if (revision === 6) {
	      pdfAlgorithm = new PDF20();
	    } else {
	      pdfAlgorithm = new PDF17();
	    }
	    if (pdfAlgorithm.checkUserPassword(password, userValidationSalt, userPassword)) {
	      return pdfAlgorithm.getUserKey(password, userKeySalt, userEncryption);
	    } else if (password.length && pdfAlgorithm.checkOwnerPassword(password, ownerValidationSalt, uBytes, ownerPassword)) {
	      return pdfAlgorithm.getOwnerKey(password, ownerKeySalt, uBytes, ownerEncryption);
	    }
	    return null;
	  }
	  function prepareKeyData(fileId, password, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata) {
	    var hashDataSize = 40 + ownerPassword.length + fileId.length;
	    var hashData = new Uint8Array(hashDataSize),
	        i = 0,
	        j,
	        n;
	    if (password) {
	      n = Math.min(32, password.length);
	      for (; i < n; ++i) {
	        hashData[i] = password[i];
	      }
	    }
	    j = 0;
	    while (i < 32) {
	      hashData[i++] = defaultPasswordBytes[j++];
	    }
	    for (j = 0, n = ownerPassword.length; j < n; ++j) {
	      hashData[i++] = ownerPassword[j];
	    }
	    hashData[i++] = flags & 0xFF;
	    hashData[i++] = flags >> 8 & 0xFF;
	    hashData[i++] = flags >> 16 & 0xFF;
	    hashData[i++] = flags >>> 24 & 0xFF;
	    for (j = 0, n = fileId.length; j < n; ++j) {
	      hashData[i++] = fileId[j];
	    }
	    if (revision >= 4 && !encryptMetadata) {
	      hashData[i++] = 0xFF;
	      hashData[i++] = 0xFF;
	      hashData[i++] = 0xFF;
	      hashData[i++] = 0xFF;
	    }
	    var hash = calculateMD5(hashData, 0, i);
	    var keyLengthInBytes = keyLength >> 3;
	    if (revision >= 3) {
	      for (j = 0; j < 50; ++j) {
	        hash = calculateMD5(hash, 0, keyLengthInBytes);
	      }
	    }
	    var encryptionKey = hash.subarray(0, keyLengthInBytes);
	    var cipher, checkData;
	    if (revision >= 3) {
	      for (i = 0; i < 32; ++i) {
	        hashData[i] = defaultPasswordBytes[i];
	      }
	      for (j = 0, n = fileId.length; j < n; ++j) {
	        hashData[i++] = fileId[j];
	      }
	      cipher = new ARCFourCipher(encryptionKey);
	      checkData = cipher.encryptBlock(calculateMD5(hashData, 0, i));
	      n = encryptionKey.length;
	      var derivedKey = new Uint8Array(n),
	          k;
	      for (j = 1; j <= 19; ++j) {
	        for (k = 0; k < n; ++k) {
	          derivedKey[k] = encryptionKey[k] ^ j;
	        }
	        cipher = new ARCFourCipher(derivedKey);
	        checkData = cipher.encryptBlock(checkData);
	      }
	      for (j = 0, n = checkData.length; j < n; ++j) {
	        if (userPassword[j] !== checkData[j]) {
	          return null;
	        }
	      }
	    } else {
	      cipher = new ARCFourCipher(encryptionKey);
	      checkData = cipher.encryptBlock(defaultPasswordBytes);
	      for (j = 0, n = checkData.length; j < n; ++j) {
	        if (userPassword[j] !== checkData[j]) {
	          return null;
	        }
	      }
	    }
	    return encryptionKey;
	  }
	  function decodeUserPassword(password, ownerPassword, revision, keyLength) {
	    var hashData = new Uint8Array(32),
	        i = 0,
	        j,
	        n;
	    n = Math.min(32, password.length);
	    for (; i < n; ++i) {
	      hashData[i] = password[i];
	    }
	    j = 0;
	    while (i < 32) {
	      hashData[i++] = defaultPasswordBytes[j++];
	    }
	    var hash = calculateMD5(hashData, 0, i);
	    var keyLengthInBytes = keyLength >> 3;
	    if (revision >= 3) {
	      for (j = 0; j < 50; ++j) {
	        hash = calculateMD5(hash, 0, hash.length);
	      }
	    }
	    var cipher, userPassword;
	    if (revision >= 3) {
	      userPassword = ownerPassword;
	      var derivedKey = new Uint8Array(keyLengthInBytes),
	          k;
	      for (j = 19; j >= 0; j--) {
	        for (k = 0; k < keyLengthInBytes; ++k) {
	          derivedKey[k] = hash[k] ^ j;
	        }
	        cipher = new ARCFourCipher(derivedKey);
	        userPassword = cipher.encryptBlock(userPassword);
	      }
	    } else {
	      cipher = new ARCFourCipher(hash.subarray(0, keyLengthInBytes));
	      userPassword = cipher.encryptBlock(ownerPassword);
	    }
	    return userPassword;
	  }
	  var identityName = Name.get('Identity');
	  function CipherTransformFactory(dict, fileId, password) {
	    var filter = dict.get('Filter');
	    if (!isName(filter, 'Standard')) {
	      error('unknown encryption method');
	    }
	    this.dict = dict;
	    var algorithm = dict.get('V');
	    if (!isInt(algorithm) || algorithm !== 1 && algorithm !== 2 && algorithm !== 4 && algorithm !== 5) {
	      error('unsupported encryption algorithm');
	    }
	    this.algorithm = algorithm;
	    var keyLength = dict.get('Length');
	    if (!keyLength) {
	      if (algorithm <= 3) {
	        keyLength = 40;
	      } else {
	        var cfDict = dict.get('CF');
	        var streamCryptoName = dict.get('StmF');
	        if (isDict(cfDict) && isName(streamCryptoName)) {
	          cfDict.suppressEncryption = true;
	          var handlerDict = cfDict.get(streamCryptoName.name);
	          keyLength = handlerDict && handlerDict.get('Length') || 128;
	          if (keyLength < 40) {
	            keyLength <<= 3;
	          }
	        }
	      }
	    }
	    if (!isInt(keyLength) || keyLength < 40 || keyLength % 8 !== 0) {
	      error('invalid key length');
	    }
	    var ownerPassword = stringToBytes(dict.get('O')).subarray(0, 32);
	    var userPassword = stringToBytes(dict.get('U')).subarray(0, 32);
	    var flags = dict.get('P');
	    var revision = dict.get('R');
	    var encryptMetadata = (algorithm === 4 || algorithm === 5) && dict.get('EncryptMetadata') !== false;
	    this.encryptMetadata = encryptMetadata;
	    var fileIdBytes = stringToBytes(fileId);
	    var passwordBytes;
	    if (password) {
	      if (revision === 6) {
	        try {
	          password = utf8StringToString(password);
	        } catch (ex) {
	          warn('CipherTransformFactory: ' + 'Unable to convert UTF8 encoded password.');
	        }
	      }
	      passwordBytes = stringToBytes(password);
	    }
	    var encryptionKey;
	    if (algorithm !== 5) {
	      encryptionKey = prepareKeyData(fileIdBytes, passwordBytes, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
	    } else {
	      var ownerValidationSalt = stringToBytes(dict.get('O')).subarray(32, 40);
	      var ownerKeySalt = stringToBytes(dict.get('O')).subarray(40, 48);
	      var uBytes = stringToBytes(dict.get('U')).subarray(0, 48);
	      var userValidationSalt = stringToBytes(dict.get('U')).subarray(32, 40);
	      var userKeySalt = stringToBytes(dict.get('U')).subarray(40, 48);
	      var ownerEncryption = stringToBytes(dict.get('OE'));
	      var userEncryption = stringToBytes(dict.get('UE'));
	      var perms = stringToBytes(dict.get('Perms'));
	      encryptionKey = createEncryptionKey20(revision, passwordBytes, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms);
	    }
	    if (!encryptionKey && !password) {
	      throw new PasswordException('No password given', PasswordResponses.NEED_PASSWORD);
	    } else if (!encryptionKey && password) {
	      var decodedPassword = decodeUserPassword(passwordBytes, ownerPassword, revision, keyLength);
	      encryptionKey = prepareKeyData(fileIdBytes, decodedPassword, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
	    }
	    if (!encryptionKey) {
	      throw new PasswordException('Incorrect Password', PasswordResponses.INCORRECT_PASSWORD);
	    }
	    this.encryptionKey = encryptionKey;
	    if (algorithm >= 4) {
	      var cf = dict.get('CF');
	      if (isDict(cf)) {
	        cf.suppressEncryption = true;
	      }
	      this.cf = cf;
	      this.stmf = dict.get('StmF') || identityName;
	      this.strf = dict.get('StrF') || identityName;
	      this.eff = dict.get('EFF') || this.stmf;
	    }
	  }
	  function buildObjectKey(num, gen, encryptionKey, isAes) {
	    var key = new Uint8Array(encryptionKey.length + 9),
	        i,
	        n;
	    for (i = 0, n = encryptionKey.length; i < n; ++i) {
	      key[i] = encryptionKey[i];
	    }
	    key[i++] = num & 0xFF;
	    key[i++] = num >> 8 & 0xFF;
	    key[i++] = num >> 16 & 0xFF;
	    key[i++] = gen & 0xFF;
	    key[i++] = gen >> 8 & 0xFF;
	    if (isAes) {
	      key[i++] = 0x73;
	      key[i++] = 0x41;
	      key[i++] = 0x6C;
	      key[i++] = 0x54;
	    }
	    var hash = calculateMD5(key, 0, i);
	    return hash.subarray(0, Math.min(encryptionKey.length + 5, 16));
	  }
	  function buildCipherConstructor(cf, name, num, gen, key) {
	    assert(isName(name), 'Invalid crypt filter name.');
	    var cryptFilter = cf.get(name.name);
	    var cfm;
	    if (cryptFilter !== null && cryptFilter !== undefined) {
	      cfm = cryptFilter.get('CFM');
	    }
	    if (!cfm || cfm.name === 'None') {
	      return function cipherTransformFactoryBuildCipherConstructorNone() {
	        return new NullCipher();
	      };
	    }
	    if (cfm.name === 'V2') {
	      return function cipherTransformFactoryBuildCipherConstructorV2() {
	        return new ARCFourCipher(buildObjectKey(num, gen, key, false));
	      };
	    }
	    if (cfm.name === 'AESV2') {
	      return function cipherTransformFactoryBuildCipherConstructorAESV2() {
	        return new AES128Cipher(buildObjectKey(num, gen, key, true));
	      };
	    }
	    if (cfm.name === 'AESV3') {
	      return function cipherTransformFactoryBuildCipherConstructorAESV3() {
	        return new AES256Cipher(key);
	      };
	    }
	    error('Unknown crypto method');
	  }
	  CipherTransformFactory.prototype = {
	    createCipherTransform: function CipherTransformFactory_createCipherTransform(num, gen) {
	      if (this.algorithm === 4 || this.algorithm === 5) {
	        return new CipherTransform(buildCipherConstructor(this.cf, this.stmf, num, gen, this.encryptionKey), buildCipherConstructor(this.cf, this.strf, num, gen, this.encryptionKey));
	      }
	      var key = buildObjectKey(num, gen, this.encryptionKey, false);
	      var cipherConstructor = function buildCipherCipherConstructor() {
	        return new ARCFourCipher(key);
	      };
	      return new CipherTransform(cipherConstructor, cipherConstructor);
	    }
	  };
	  return CipherTransformFactory;
	}();
	exports.AES128Cipher = AES128Cipher;
	exports.AES256Cipher = AES256Cipher;
	exports.ARCFourCipher = ARCFourCipher;
	exports.CipherTransformFactory = CipherTransformFactory;
	exports.PDF17 = PDF17;
	exports.PDF20 = PDF20;
	exports.calculateMD5 = calculateMD5;
	exports.calculateSHA256 = calculateSHA256;
	exports.calculateSHA384 = calculateSHA384;
	exports.calculateSHA512 = calculateSHA512;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var coreStream = __w_pdfjs_require__(2);
	var coreParser = __w_pdfjs_require__(5);
	var coreImage = __w_pdfjs_require__(27);
	var coreColorSpace = __w_pdfjs_require__(3);
	var coreMurmurHash3 = __w_pdfjs_require__(31);
	var coreFonts = __w_pdfjs_require__(26);
	var coreFunction = __w_pdfjs_require__(6);
	var corePattern = __w_pdfjs_require__(32);
	var coreCMap = __w_pdfjs_require__(23);
	var coreMetrics = __w_pdfjs_require__(30);
	var coreBidi = __w_pdfjs_require__(21);
	var coreEncodings = __w_pdfjs_require__(4);
	var coreStandardFonts = __w_pdfjs_require__(17);
	var coreUnicode = __w_pdfjs_require__(18);
	var coreGlyphList = __w_pdfjs_require__(7);
	var FONT_IDENTITY_MATRIX = sharedUtil.FONT_IDENTITY_MATRIX;
	var IDENTITY_MATRIX = sharedUtil.IDENTITY_MATRIX;
	var UNSUPPORTED_FEATURES = sharedUtil.UNSUPPORTED_FEATURES;
	var ImageKind = sharedUtil.ImageKind;
	var OPS = sharedUtil.OPS;
	var TextRenderingMode = sharedUtil.TextRenderingMode;
	var CMapCompressionType = sharedUtil.CMapCompressionType;
	var Util = sharedUtil.Util;
	var assert = sharedUtil.assert;
	var createPromiseCapability = sharedUtil.createPromiseCapability;
	var error = sharedUtil.error;
	var info = sharedUtil.info;
	var isArray = sharedUtil.isArray;
	var isNum = sharedUtil.isNum;
	var isString = sharedUtil.isString;
	var getLookupTableFactory = sharedUtil.getLookupTableFactory;
	var warn = sharedUtil.warn;
	var Dict = corePrimitives.Dict;
	var Name = corePrimitives.Name;
	var isEOF = corePrimitives.isEOF;
	var isCmd = corePrimitives.isCmd;
	var isDict = corePrimitives.isDict;
	var isName = corePrimitives.isName;
	var isRef = corePrimitives.isRef;
	var isStream = corePrimitives.isStream;
	var DecodeStream = coreStream.DecodeStream;
	var JpegStream = coreStream.JpegStream;
	var Stream = coreStream.Stream;
	var Lexer = coreParser.Lexer;
	var Parser = coreParser.Parser;
	var PDFImage = coreImage.PDFImage;
	var ColorSpace = coreColorSpace.ColorSpace;
	var MurmurHash3_64 = coreMurmurHash3.MurmurHash3_64;
	var ErrorFont = coreFonts.ErrorFont;
	var FontFlags = coreFonts.FontFlags;
	var Font = coreFonts.Font;
	var IdentityToUnicodeMap = coreFonts.IdentityToUnicodeMap;
	var ToUnicodeMap = coreFonts.ToUnicodeMap;
	var getFontType = coreFonts.getFontType;
	var isPDFFunction = coreFunction.isPDFFunction;
	var PDFFunction = coreFunction.PDFFunction;
	var Pattern = corePattern.Pattern;
	var getTilingPatternIR = corePattern.getTilingPatternIR;
	var CMapFactory = coreCMap.CMapFactory;
	var IdentityCMap = coreCMap.IdentityCMap;
	var getMetrics = coreMetrics.getMetrics;
	var bidi = coreBidi.bidi;
	var WinAnsiEncoding = coreEncodings.WinAnsiEncoding;
	var StandardEncoding = coreEncodings.StandardEncoding;
	var MacRomanEncoding = coreEncodings.MacRomanEncoding;
	var SymbolSetEncoding = coreEncodings.SymbolSetEncoding;
	var ZapfDingbatsEncoding = coreEncodings.ZapfDingbatsEncoding;
	var getEncoding = coreEncodings.getEncoding;
	var getStdFontMap = coreStandardFonts.getStdFontMap;
	var getSerifFonts = coreStandardFonts.getSerifFonts;
	var getSymbolsFonts = coreStandardFonts.getSymbolsFonts;
	var getNormalizedUnicodes = coreUnicode.getNormalizedUnicodes;
	var reverseIfRtl = coreUnicode.reverseIfRtl;
	var getUnicodeForGlyph = coreUnicode.getUnicodeForGlyph;
	var getGlyphsUnicode = coreGlyphList.getGlyphsUnicode;
	var PartialEvaluator = function PartialEvaluatorClosure() {
	  var DefaultPartialEvaluatorOptions = {
	    forceDataSchema: false,
	    maxImageSize: -1,
	    disableFontFace: false,
	    disableNativeImageDecoder: false,
	    ignoreErrors: false
	  };
	  function NativeImageDecoder(xref, resources, handler, forceDataSchema) {
	    this.xref = xref;
	    this.resources = resources;
	    this.handler = handler;
	    this.forceDataSchema = forceDataSchema;
	  }
	  NativeImageDecoder.prototype = {
	    canDecode: function canDecode(image) {
	      return image instanceof JpegStream && NativeImageDecoder.isDecodable(image, this.xref, this.resources);
	    },
	    decode: function decode(image) {
	      var dict = image.dict;
	      var colorSpace = dict.get('ColorSpace', 'CS');
	      colorSpace = ColorSpace.parse(colorSpace, this.xref, this.resources);
	      var numComps = colorSpace.numComps;
	      var decodePromise = this.handler.sendWithPromise('JpegDecode', [image.getIR(this.forceDataSchema), numComps]);
	      return decodePromise.then(function (message) {
	        var data = message.data;
	        return new Stream(data, 0, data.length, image.dict);
	      });
	    }
	  };
	  NativeImageDecoder.isSupported = function NativeImageDecoder_isSupported(image, xref, res) {
	    var dict = image.dict;
	    if (dict.has('DecodeParms') || dict.has('DP')) {
	      return false;
	    }
	    var cs = ColorSpace.parse(dict.get('ColorSpace', 'CS'), xref, res);
	    return (cs.name === 'DeviceGray' || cs.name === 'DeviceRGB') && cs.isDefaultDecode(dict.getArray('Decode', 'D'));
	  };
	  NativeImageDecoder.isDecodable = function NativeImageDecoder_isDecodable(image, xref, res) {
	    var dict = image.dict;
	    if (dict.has('DecodeParms') || dict.has('DP')) {
	      return false;
	    }
	    var cs = ColorSpace.parse(dict.get('ColorSpace', 'CS'), xref, res);
	    return (cs.numComps === 1 || cs.numComps === 3) && cs.isDefaultDecode(dict.getArray('Decode', 'D'));
	  };
	  function PartialEvaluator(_ref) {
	    var _this = this;
	
	    var pdfManager = _ref.pdfManager,
	        xref = _ref.xref,
	        handler = _ref.handler,
	        pageIndex = _ref.pageIndex,
	        idFactory = _ref.idFactory,
	        fontCache = _ref.fontCache,
	        builtInCMapCache = _ref.builtInCMapCache,
	        _ref$options = _ref.options,
	        options = _ref$options === undefined ? null : _ref$options;
	
	    this.pdfManager = pdfManager;
	    this.xref = xref;
	    this.handler = handler;
	    this.pageIndex = pageIndex;
	    this.idFactory = idFactory;
	    this.fontCache = fontCache;
	    this.builtInCMapCache = builtInCMapCache;
	    this.options = options || DefaultPartialEvaluatorOptions;
	    this.fetchBuiltInCMap = function (name) {
	      var cachedCMap = _this.builtInCMapCache[name];
	      if (cachedCMap) {
	        return Promise.resolve(cachedCMap);
	      }
	      return _this.handler.sendWithPromise('FetchBuiltInCMap', { name: name }).then(function (data) {
	        if (data.compressionType !== CMapCompressionType.NONE) {
	          _this.builtInCMapCache[name] = data;
	        }
	        return data;
	      });
	    };
	  }
	  var TIME_SLOT_DURATION_MS = 20;
	  var CHECK_TIME_EVERY = 100;
	  function TimeSlotManager() {
	    this.reset();
	  }
	  TimeSlotManager.prototype = {
	    check: function TimeSlotManager_check() {
	      if (++this.checked < CHECK_TIME_EVERY) {
	        return false;
	      }
	      this.checked = 0;
	      return this.endTime <= Date.now();
	    },
	    reset: function TimeSlotManager_reset() {
	      this.endTime = Date.now() + TIME_SLOT_DURATION_MS;
	      this.checked = 0;
	    }
	  };
	  function normalizeBlendMode(value) {
	    if (!isName(value)) {
	      return 'source-over';
	    }
	    switch (value.name) {
	      case 'Normal':
	      case 'Compatible':
	        return 'source-over';
	      case 'Multiply':
	        return 'multiply';
	      case 'Screen':
	        return 'screen';
	      case 'Overlay':
	        return 'overlay';
	      case 'Darken':
	        return 'darken';
	      case 'Lighten':
	        return 'lighten';
	      case 'ColorDodge':
	        return 'color-dodge';
	      case 'ColorBurn':
	        return 'color-burn';
	      case 'HardLight':
	        return 'hard-light';
	      case 'SoftLight':
	        return 'soft-light';
	      case 'Difference':
	        return 'difference';
	      case 'Exclusion':
	        return 'exclusion';
	      case 'Hue':
	        return 'hue';
	      case 'Saturation':
	        return 'saturation';
	      case 'Color':
	        return 'color';
	      case 'Luminosity':
	        return 'luminosity';
	    }
	    warn('Unsupported blend mode: ' + value.name);
	    return 'source-over';
	  }
	  var deferred = Promise.resolve();
	  var TILING_PATTERN = 1,
	      SHADING_PATTERN = 2;
	  PartialEvaluator.prototype = {
	    clone: function clone() {
	      var newOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultPartialEvaluatorOptions;
	
	      var newEvaluator = Object.create(this);
	      newEvaluator.options = newOptions;
	      return newEvaluator;
	    },
	
	    hasBlendModes: function PartialEvaluator_hasBlendModes(resources) {
	      if (!isDict(resources)) {
	        return false;
	      }
	      var processed = Object.create(null);
	      if (resources.objId) {
	        processed[resources.objId] = true;
	      }
	      var nodes = [resources],
	          xref = this.xref;
	      while (nodes.length) {
	        var key, i, ii;
	        var node = nodes.shift();
	        var graphicStates = node.get('ExtGState');
	        if (isDict(graphicStates)) {
	          var graphicStatesKeys = graphicStates.getKeys();
	          for (i = 0, ii = graphicStatesKeys.length; i < ii; i++) {
	            key = graphicStatesKeys[i];
	            var graphicState = graphicStates.get(key);
	            var bm = graphicState.get('BM');
	            if (isName(bm) && bm.name !== 'Normal') {
	              return true;
	            }
	          }
	        }
	        var xObjects = node.get('XObject');
	        if (!isDict(xObjects)) {
	          continue;
	        }
	        var xObjectsKeys = xObjects.getKeys();
	        for (i = 0, ii = xObjectsKeys.length; i < ii; i++) {
	          key = xObjectsKeys[i];
	          var xObject = xObjects.getRaw(key);
	          if (isRef(xObject)) {
	            if (processed[xObject.toString()]) {
	              continue;
	            }
	            xObject = xref.fetch(xObject);
	          }
	          if (!isStream(xObject)) {
	            continue;
	          }
	          if (xObject.dict.objId) {
	            if (processed[xObject.dict.objId]) {
	              continue;
	            }
	            processed[xObject.dict.objId] = true;
	          }
	          var xResources = xObject.dict.get('Resources');
	          if (isDict(xResources) && (!xResources.objId || !processed[xResources.objId])) {
	            nodes.push(xResources);
	            if (xResources.objId) {
	              processed[xResources.objId] = true;
	            }
	          }
	        }
	      }
	      return false;
	    },
	    buildFormXObject: function PartialEvaluator_buildFormXObject(resources, xobj, smask, operatorList, task, initialState) {
	      var dict = xobj.dict;
	      var matrix = dict.getArray('Matrix');
	      var bbox = dict.getArray('BBox');
	      var group = dict.get('Group');
	      if (group) {
	        var groupOptions = {
	          matrix: matrix,
	          bbox: bbox,
	          smask: smask,
	          isolated: false,
	          knockout: false
	        };
	        var groupSubtype = group.get('S');
	        var colorSpace;
	        if (isName(groupSubtype, 'Transparency')) {
	          groupOptions.isolated = group.get('I') || false;
	          groupOptions.knockout = group.get('K') || false;
	          colorSpace = group.has('CS') ? ColorSpace.parse(group.get('CS'), this.xref, resources) : null;
	        }
	        if (smask && smask.backdrop) {
	          colorSpace = colorSpace || ColorSpace.singletons.rgb;
	          smask.backdrop = colorSpace.getRgb(smask.backdrop, 0);
	        }
	        operatorList.addOp(OPS.beginGroup, [groupOptions]);
	      }
	      operatorList.addOp(OPS.paintFormXObjectBegin, [matrix, bbox]);
	      return this.getOperatorList({
	        stream: xobj,
	        task: task,
	        resources: dict.get('Resources') || resources,
	        operatorList: operatorList,
	        initialState: initialState
	      }).then(function () {
	        operatorList.addOp(OPS.paintFormXObjectEnd, []);
	        if (group) {
	          operatorList.addOp(OPS.endGroup, [groupOptions]);
	        }
	      });
	    },
	    buildPaintImageXObject: function PartialEvaluator_buildPaintImageXObject(resources, image, inline, operatorList, cacheKey, imageCache) {
	      var _this2 = this;
	
	      var dict = image.dict;
	      var w = dict.get('Width', 'W');
	      var h = dict.get('Height', 'H');
	      if (!(w && isNum(w)) || !(h && isNum(h))) {
	        warn('Image dimensions are missing, or not numbers.');
	        return;
	      }
	      var maxImageSize = this.options.maxImageSize;
	      if (maxImageSize !== -1 && w * h > maxImageSize) {
	        warn('Image exceeded maximum allowed size and was removed.');
	        return;
	      }
	      var imageMask = dict.get('ImageMask', 'IM') || false;
	      var imgData, args;
	      if (imageMask) {
	        var width = dict.get('Width', 'W');
	        var height = dict.get('Height', 'H');
	        var bitStrideLength = width + 7 >> 3;
	        var imgArray = image.getBytes(bitStrideLength * height);
	        var decode = dict.getArray('Decode', 'D');
	        var inverseDecode = !!decode && decode[0] > 0;
	        imgData = PDFImage.createMask(imgArray, width, height, image instanceof DecodeStream, inverseDecode);
	        imgData.cached = true;
	        args = [imgData];
	        operatorList.addOp(OPS.paintImageMaskXObject, args);
	        if (cacheKey) {
	          imageCache[cacheKey] = {
	            fn: OPS.paintImageMaskXObject,
	            args: args
	          };
	        }
	        return;
	      }
	      var softMask = dict.get('SMask', 'SM') || false;
	      var mask = dict.get('Mask') || false;
	      var SMALL_IMAGE_DIMENSIONS = 200;
	      if (inline && !softMask && !mask && !(image instanceof JpegStream) && w + h < SMALL_IMAGE_DIMENSIONS) {
	        var imageObj = new PDFImage(this.xref, resources, image, inline, null, null);
	        imgData = imageObj.createImageData(true);
	        operatorList.addOp(OPS.paintInlineImageXObject, [imgData]);
	        return;
	      }
	      var useNativeImageDecoder = !this.options.disableNativeImageDecoder;
	      var objId = 'img_' + this.idFactory.createObjId();
	      operatorList.addDependency(objId);
	      args = [objId, w, h];
	      if (useNativeImageDecoder && !softMask && !mask && image instanceof JpegStream && NativeImageDecoder.isSupported(image, this.xref, resources)) {
	        operatorList.addOp(OPS.paintJpegXObject, args);
	        this.handler.send('obj', [objId, this.pageIndex, 'JpegStream', image.getIR(this.options.forceDataSchema)]);
	        return;
	      }
	      var nativeImageDecoder = null;
	      if (useNativeImageDecoder && (image instanceof JpegStream || mask instanceof JpegStream || softMask instanceof JpegStream)) {
	        nativeImageDecoder = new NativeImageDecoder(this.xref, resources, this.handler, this.options.forceDataSchema);
	      }
	      PDFImage.buildImage(this.handler, this.xref, resources, image, inline, nativeImageDecoder).then(function (imageObj) {
	        var imgData = imageObj.createImageData(false);
	        _this2.handler.send('obj', [objId, _this2.pageIndex, 'Image', imgData], [imgData.data.buffer]);
	      }).catch(function (reason) {
	        warn('Unable to decode image: ' + reason);
	        _this2.handler.send('obj', [objId, _this2.pageIndex, 'Image', null]);
	      });
	      operatorList.addOp(OPS.paintImageXObject, args);
	      if (cacheKey) {
	        imageCache[cacheKey] = {
	          fn: OPS.paintImageXObject,
	          args: args
	        };
	      }
	    },
	    handleSMask: function PartialEvaluator_handleSmask(smask, resources, operatorList, task, stateManager) {
	      var smaskContent = smask.get('G');
	      var smaskOptions = {
	        subtype: smask.get('S').name,
	        backdrop: smask.get('BC')
	      };
	      var transferObj = smask.get('TR');
	      if (isPDFFunction(transferObj)) {
	        var transferFn = PDFFunction.parse(this.xref, transferObj);
	        var transferMap = new Uint8Array(256);
	        var tmp = new Float32Array(1);
	        for (var i = 0; i < 256; i++) {
	          tmp[0] = i / 255;
	          transferFn(tmp, 0, tmp, 0);
	          transferMap[i] = tmp[0] * 255 | 0;
	        }
	        smaskOptions.transferMap = transferMap;
	      }
	      return this.buildFormXObject(resources, smaskContent, smaskOptions, operatorList, task, stateManager.state.clone());
	    },
	    handleTilingType: function PartialEvaluator_handleTilingType(fn, args, resources, pattern, patternDict, operatorList, task) {
	      var tilingOpList = new OperatorList();
	      var resourcesArray = [patternDict.get('Resources'), resources];
	      var patternResources = Dict.merge(this.xref, resourcesArray);
	      return this.getOperatorList({
	        stream: pattern,
	        task: task,
	        resources: patternResources,
	        operatorList: tilingOpList
	      }).then(function () {
	        operatorList.addDependencies(tilingOpList.dependencies);
	        operatorList.addOp(fn, getTilingPatternIR({
	          fnArray: tilingOpList.fnArray,
	          argsArray: tilingOpList.argsArray
	        }, patternDict, args));
	      });
	    },
	    handleSetFont: function PartialEvaluator_handleSetFont(resources, fontArgs, fontRef, operatorList, task, state) {
	      var _this3 = this;
	
	      var fontName;
	      if (fontArgs) {
	        fontArgs = fontArgs.slice();
	        fontName = fontArgs[0].name;
	      }
	      return this.loadFont(fontName, fontRef, resources).then(function (translated) {
	        if (!translated.font.isType3Font) {
	          return translated;
	        }
	        return translated.loadType3Data(_this3, resources, operatorList, task).then(function () {
	          return translated;
	        }).catch(function (reason) {
	          _this3.handler.send('UnsupportedFeature', { featureId: UNSUPPORTED_FEATURES.font });
	          return new TranslatedFont('g_font_error', new ErrorFont('Type3 font load error: ' + reason), translated.font);
	        });
	      }).then(function (translated) {
	        state.font = translated.font;
	        translated.send(_this3.handler);
	        return translated.loadedName;
	      });
	    },
	    handleText: function PartialEvaluator_handleText(chars, state) {
	      var _this4 = this;
	
	      var font = state.font;
	      var glyphs = font.charsToGlyphs(chars);
	      var isAddToPathSet = !!(state.textRenderingMode & TextRenderingMode.ADD_TO_PATH_FLAG);
	      if (font.data && (isAddToPathSet || this.options.disableFontFace)) {
	        var buildPath = function buildPath(fontChar) {
	          if (!font.renderer.hasBuiltPath(fontChar)) {
	            var path = font.renderer.getPathJs(fontChar);
	            _this4.handler.send('commonobj', [font.loadedName + '_path_' + fontChar, 'FontPath', path]);
	          }
	        };
	        for (var i = 0, ii = glyphs.length; i < ii; i++) {
	          var glyph = glyphs[i];
	          buildPath(glyph.fontChar);
	          var accent = glyph.accent;
	          if (accent && accent.fontChar) {
	            buildPath(accent.fontChar);
	          }
	        }
	      }
	      return glyphs;
	    },
	    setGState: function PartialEvaluator_setGState(resources, gState, operatorList, task, stateManager) {
	      var _this5 = this;
	
	      var gStateObj = [];
	      var gStateKeys = gState.getKeys();
	      var promise = Promise.resolve();
	
	      var _loop = function _loop() {
	        var key = gStateKeys[i];
	        var value = gState.get(key);
	        switch (key) {
	          case 'Type':
	            break;
	          case 'LW':
	          case 'LC':
	          case 'LJ':
	          case 'ML':
	          case 'D':
	          case 'RI':
	          case 'FL':
	          case 'CA':
	          case 'ca':
	            gStateObj.push([key, value]);
	            break;
	          case 'Font':
	            promise = promise.then(function () {
	              return _this5.handleSetFont(resources, null, value[0], operatorList, task, stateManager.state).then(function (loadedName) {
	                operatorList.addDependency(loadedName);
	                gStateObj.push([key, [loadedName, value[1]]]);
	              });
	            });
	            break;
	          case 'BM':
	            gStateObj.push([key, normalizeBlendMode(value)]);
	            break;
	          case 'SMask':
	            if (isName(value, 'None')) {
	              gStateObj.push([key, false]);
	              break;
	            }
	            if (isDict(value)) {
	              promise = promise.then(function () {
	                return _this5.handleSMask(value, resources, operatorList, task, stateManager);
	              });
	              gStateObj.push([key, true]);
	            } else {
	              warn('Unsupported SMask type');
	            }
	            break;
	          case 'OP':
	          case 'op':
	          case 'OPM':
	          case 'BG':
	          case 'BG2':
	          case 'UCR':
	          case 'UCR2':
	          case 'TR':
	          case 'TR2':
	          case 'HT':
	          case 'SM':
	          case 'SA':
	          case 'AIS':
	          case 'TK':
	            info('graphic state operator ' + key);
	            break;
	          default:
	            info('Unknown graphic state operator ' + key);
	            break;
	        }
	      };
	
	      for (var i = 0, ii = gStateKeys.length; i < ii; i++) {
	        _loop();
	      }
	      return promise.then(function () {
	        if (gStateObj.length > 0) {
	          operatorList.addOp(OPS.setGState, [gStateObj]);
	        }
	      });
	    },
	    loadFont: function PartialEvaluator_loadFont(fontName, font, resources) {
	      var _this6 = this;
	
	      function errorFont() {
	        return Promise.resolve(new TranslatedFont('g_font_error', new ErrorFont('Font ' + fontName + ' is not available'), font));
	      }
	      var fontRef,
	          xref = this.xref;
	      if (font) {
	        assert(isRef(font));
	        fontRef = font;
	      } else {
	        var fontRes = resources.get('Font');
	        if (fontRes) {
	          fontRef = fontRes.getRaw(fontName);
	        } else {
	          warn('fontRes not available');
	          return errorFont();
	        }
	      }
	      if (!fontRef) {
	        warn('fontRef not available');
	        return errorFont();
	      }
	      if (this.fontCache.has(fontRef)) {
	        return this.fontCache.get(fontRef);
	      }
	      font = xref.fetchIfRef(fontRef);
	      if (!isDict(font)) {
	        return errorFont();
	      }
	      if (font.translated) {
	        return font.translated;
	      }
	      var fontCapability = createPromiseCapability();
	      var preEvaluatedFont = this.preEvaluateFont(font);
	      var descriptor = preEvaluatedFont.descriptor;
	      var fontRefIsRef = isRef(fontRef),
	          fontID;
	      if (fontRefIsRef) {
	        fontID = fontRef.toString();
	      }
	      if (isDict(descriptor)) {
	        if (!descriptor.fontAliases) {
	          descriptor.fontAliases = Object.create(null);
	        }
	        var fontAliases = descriptor.fontAliases;
	        var hash = preEvaluatedFont.hash;
	        if (fontAliases[hash]) {
	          var aliasFontRef = fontAliases[hash].aliasRef;
	          if (fontRefIsRef && aliasFontRef && this.fontCache.has(aliasFontRef)) {
	            this.fontCache.putAlias(fontRef, aliasFontRef);
	            return this.fontCache.get(fontRef);
	          }
	        } else {
	          fontAliases[hash] = { fontID: Font.getFontID() };
	        }
	        if (fontRefIsRef) {
	          fontAliases[hash].aliasRef = fontRef;
	        }
	        fontID = fontAliases[hash].fontID;
	      }
	      if (fontRefIsRef) {
	        this.fontCache.put(fontRef, fontCapability.promise);
	      } else {
	        if (!fontID) {
	          fontID = this.idFactory.createObjId();
	        }
	        this.fontCache.put('id_' + fontID, fontCapability.promise);
	      }
	      assert(fontID, 'The "fontID" must be defined.');
	      font.loadedName = 'g_' + this.pdfManager.docId + '_f' + fontID;
	      font.translated = fontCapability.promise;
	      var translatedPromise;
	      try {
	        translatedPromise = this.translateFont(preEvaluatedFont);
	      } catch (e) {
	        translatedPromise = Promise.reject(e);
	      }
	      translatedPromise.then(function (translatedFont) {
	        if (translatedFont.fontType !== undefined) {
	          var xrefFontStats = xref.stats.fontTypes;
	          xrefFontStats[translatedFont.fontType] = true;
	        }
	        fontCapability.resolve(new TranslatedFont(font.loadedName, translatedFont, font));
	      }).catch(function (reason) {
	        _this6.handler.send('UnsupportedFeature', { featureId: UNSUPPORTED_FEATURES.font });
	        try {
	          var descriptor = preEvaluatedFont.descriptor;
	          var fontFile3 = descriptor && descriptor.get('FontFile3');
	          var subtype = fontFile3 && fontFile3.get('Subtype');
	          var fontType = getFontType(preEvaluatedFont.type, subtype && subtype.name);
	          var xrefFontStats = xref.stats.fontTypes;
	          xrefFontStats[fontType] = true;
	        } catch (ex) {}
	        fontCapability.resolve(new TranslatedFont(font.loadedName, new ErrorFont(reason instanceof Error ? reason.message : reason), font));
	      });
	      return fontCapability.promise;
	    },
	    buildPath: function PartialEvaluator_buildPath(operatorList, fn, args) {
	      var lastIndex = operatorList.length - 1;
	      if (!args) {
	        args = [];
	      }
	      if (lastIndex < 0 || operatorList.fnArray[lastIndex] !== OPS.constructPath) {
	        operatorList.addOp(OPS.constructPath, [[fn], args]);
	      } else {
	        var opArgs = operatorList.argsArray[lastIndex];
	        opArgs[0].push(fn);
	        Array.prototype.push.apply(opArgs[1], args);
	      }
	    },
	    handleColorN: function PartialEvaluator_handleColorN(operatorList, fn, args, cs, patterns, resources, task) {
	      var patternName = args[args.length - 1];
	      var pattern;
	      if (isName(patternName) && (pattern = patterns.get(patternName.name))) {
	        var dict = isStream(pattern) ? pattern.dict : pattern;
	        var typeNum = dict.get('PatternType');
	        if (typeNum === TILING_PATTERN) {
	          var color = cs.base ? cs.base.getRgb(args, 0) : null;
	          return this.handleTilingType(fn, color, resources, pattern, dict, operatorList, task);
	        } else if (typeNum === SHADING_PATTERN) {
	          var shading = dict.get('Shading');
	          var matrix = dict.getArray('Matrix');
	          pattern = Pattern.parseShading(shading, matrix, this.xref, resources, this.handler);
	          operatorList.addOp(fn, pattern.getIR());
	          return Promise.resolve();
	        }
	        return Promise.reject(new Error('Unknown PatternType: ' + typeNum));
	      }
	      operatorList.addOp(fn, args);
	      return Promise.resolve();
	    },
	    getOperatorList: function getOperatorList(_ref2) {
	      var _this7 = this;
	
	      var stream = _ref2.stream,
	          task = _ref2.task,
	          resources = _ref2.resources,
	          operatorList = _ref2.operatorList,
	          _ref2$initialState = _ref2.initialState,
	          initialState = _ref2$initialState === undefined ? null : _ref2$initialState;
	
	      resources = resources || Dict.empty;
	      initialState = initialState || new EvalState();
	      assert(operatorList, 'getOperatorList: missing "operatorList" parameter');
	      var self = this;
	      var xref = this.xref;
	      var imageCache = Object.create(null);
	      var xobjs = resources.get('XObject') || Dict.empty;
	      var patterns = resources.get('Pattern') || Dict.empty;
	      var stateManager = new StateManager(initialState);
	      var preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
	      var timeSlotManager = new TimeSlotManager();
	      function closePendingRestoreOPS(argument) {
	        for (var i = 0, ii = preprocessor.savedStatesDepth; i < ii; i++) {
	          operatorList.addOp(OPS.restore, []);
	        }
	      }
	      return new Promise(function promiseBody(resolve, reject) {
	        var next = function next(promise) {
	          promise.then(function () {
	            try {
	              promiseBody(resolve, reject);
	            } catch (ex) {
	              reject(ex);
	            }
	          }, reject);
	        };
	        task.ensureNotTerminated();
	        timeSlotManager.reset();
	        var stop,
	            operation = {},
	            i,
	            ii,
	            cs;
	        while (!(stop = timeSlotManager.check())) {
	          operation.args = null;
	          if (!preprocessor.read(operation)) {
	            break;
	          }
	          var args = operation.args;
	          var fn = operation.fn;
	          switch (fn | 0) {
	            case OPS.paintXObject:
	              if (args[0].code) {
	                break;
	              }
	              var name = args[0].name;
	              if (!name) {
	                warn('XObject must be referred to by name.');
	                continue;
	              }
	              if (imageCache[name] !== undefined) {
	                operatorList.addOp(imageCache[name].fn, imageCache[name].args);
	                args = null;
	                continue;
	              }
	              var xobj = xobjs.get(name);
	              if (xobj) {
	                assert(isStream(xobj), 'XObject should be a stream');
	                var type = xobj.dict.get('Subtype');
	                assert(isName(type), 'XObject should have a Name subtype');
	                if (type.name === 'Form') {
	                  stateManager.save();
	                  next(self.buildFormXObject(resources, xobj, null, operatorList, task, stateManager.state.clone()).then(function () {
	                    stateManager.restore();
	                  }));
	                  return;
	                } else if (type.name === 'Image') {
	                  self.buildPaintImageXObject(resources, xobj, false, operatorList, name, imageCache);
	                  args = null;
	                  continue;
	                } else if (type.name === 'PS') {
	                  info('Ignored XObject subtype PS');
	                  continue;
	                } else {
	                  error('Unhandled XObject subtype ' + type.name);
	                }
	              }
	              break;
	            case OPS.setFont:
	              var fontSize = args[1];
	              next(self.handleSetFont(resources, args, null, operatorList, task, stateManager.state).then(function (loadedName) {
	                operatorList.addDependency(loadedName);
	                operatorList.addOp(OPS.setFont, [loadedName, fontSize]);
	              }));
	              return;
	            case OPS.endInlineImage:
	              var cacheKey = args[0].cacheKey;
	              if (cacheKey) {
	                var cacheEntry = imageCache[cacheKey];
	                if (cacheEntry !== undefined) {
	                  operatorList.addOp(cacheEntry.fn, cacheEntry.args);
	                  args = null;
	                  continue;
	                }
	              }
	              self.buildPaintImageXObject(resources, args[0], true, operatorList, cacheKey, imageCache);
	              args = null;
	              continue;
	            case OPS.showText:
	              args[0] = self.handleText(args[0], stateManager.state);
	              break;
	            case OPS.showSpacedText:
	              var arr = args[0];
	              var combinedGlyphs = [];
	              var arrLength = arr.length;
	              var state = stateManager.state;
	              for (i = 0; i < arrLength; ++i) {
	                var arrItem = arr[i];
	                if (isString(arrItem)) {
	                  Array.prototype.push.apply(combinedGlyphs, self.handleText(arrItem, state));
	                } else if (isNum(arrItem)) {
	                  combinedGlyphs.push(arrItem);
	                }
	              }
	              args[0] = combinedGlyphs;
	              fn = OPS.showText;
	              break;
	            case OPS.nextLineShowText:
	              operatorList.addOp(OPS.nextLine);
	              args[0] = self.handleText(args[0], stateManager.state);
	              fn = OPS.showText;
	              break;
	            case OPS.nextLineSetSpacingShowText:
	              operatorList.addOp(OPS.nextLine);
	              operatorList.addOp(OPS.setWordSpacing, [args.shift()]);
	              operatorList.addOp(OPS.setCharSpacing, [args.shift()]);
	              args[0] = self.handleText(args[0], stateManager.state);
	              fn = OPS.showText;
	              break;
	            case OPS.setTextRenderingMode:
	              stateManager.state.textRenderingMode = args[0];
	              break;
	            case OPS.setFillColorSpace:
	              stateManager.state.fillColorSpace = ColorSpace.parse(args[0], xref, resources);
	              continue;
	            case OPS.setStrokeColorSpace:
	              stateManager.state.strokeColorSpace = ColorSpace.parse(args[0], xref, resources);
	              continue;
	            case OPS.setFillColor:
	              cs = stateManager.state.fillColorSpace;
	              args = cs.getRgb(args, 0);
	              fn = OPS.setFillRGBColor;
	              break;
	            case OPS.setStrokeColor:
	              cs = stateManager.state.strokeColorSpace;
	              args = cs.getRgb(args, 0);
	              fn = OPS.setStrokeRGBColor;
	              break;
	            case OPS.setFillGray:
	              stateManager.state.fillColorSpace = ColorSpace.singletons.gray;
	              args = ColorSpace.singletons.gray.getRgb(args, 0);
	              fn = OPS.setFillRGBColor;
	              break;
	            case OPS.setStrokeGray:
	              stateManager.state.strokeColorSpace = ColorSpace.singletons.gray;
	              args = ColorSpace.singletons.gray.getRgb(args, 0);
	              fn = OPS.setStrokeRGBColor;
	              break;
	            case OPS.setFillCMYKColor:
	              stateManager.state.fillColorSpace = ColorSpace.singletons.cmyk;
	              args = ColorSpace.singletons.cmyk.getRgb(args, 0);
	              fn = OPS.setFillRGBColor;
	              break;
	            case OPS.setStrokeCMYKColor:
	              stateManager.state.strokeColorSpace = ColorSpace.singletons.cmyk;
	              args = ColorSpace.singletons.cmyk.getRgb(args, 0);
	              fn = OPS.setStrokeRGBColor;
	              break;
	            case OPS.setFillRGBColor:
	              stateManager.state.fillColorSpace = ColorSpace.singletons.rgb;
	              args = ColorSpace.singletons.rgb.getRgb(args, 0);
	              break;
	            case OPS.setStrokeRGBColor:
	              stateManager.state.strokeColorSpace = ColorSpace.singletons.rgb;
	              args = ColorSpace.singletons.rgb.getRgb(args, 0);
	              break;
	            case OPS.setFillColorN:
	              cs = stateManager.state.fillColorSpace;
	              if (cs.name === 'Pattern') {
	                next(self.handleColorN(operatorList, OPS.setFillColorN, args, cs, patterns, resources, task));
	                return;
	              }
	              args = cs.getRgb(args, 0);
	              fn = OPS.setFillRGBColor;
	              break;
	            case OPS.setStrokeColorN:
	              cs = stateManager.state.strokeColorSpace;
	              if (cs.name === 'Pattern') {
	                next(self.handleColorN(operatorList, OPS.setStrokeColorN, args, cs, patterns, resources, task));
	                return;
	              }
	              args = cs.getRgb(args, 0);
	              fn = OPS.setStrokeRGBColor;
	              break;
	            case OPS.shadingFill:
	              var shadingRes = resources.get('Shading');
	              assert(shadingRes, 'No shading resource found');
	              var shading = shadingRes.get(args[0].name);
	              assert(shading, 'No shading object found');
	              var shadingFill = Pattern.parseShading(shading, null, xref, resources, self.handler);
	              var patternIR = shadingFill.getIR();
	              args = [patternIR];
	              fn = OPS.shadingFill;
	              break;
	            case OPS.setGState:
	              var dictName = args[0];
	              var extGState = resources.get('ExtGState');
	              if (!isDict(extGState) || !extGState.has(dictName.name)) {
	                break;
	              }
	              var gState = extGState.get(dictName.name);
	              next(self.setGState(resources, gState, operatorList, task, stateManager));
	              return;
	            case OPS.moveTo:
	            case OPS.lineTo:
	            case OPS.curveTo:
	            case OPS.curveTo2:
	            case OPS.curveTo3:
	            case OPS.closePath:
	              self.buildPath(operatorList, fn, args);
	              continue;
	            case OPS.rectangle:
	              self.buildPath(operatorList, fn, args);
	              continue;
	            case OPS.markPoint:
	            case OPS.markPointProps:
	            case OPS.beginMarkedContent:
	            case OPS.beginMarkedContentProps:
	            case OPS.endMarkedContent:
	            case OPS.beginCompat:
	            case OPS.endCompat:
	              continue;
	            default:
	              if (args !== null) {
	                for (i = 0, ii = args.length; i < ii; i++) {
	                  if (args[i] instanceof Dict) {
	                    break;
	                  }
	                }
	                if (i < ii) {
	                  warn('getOperatorList - ignoring operator: ' + fn);
	                  continue;
	                }
	              }
	          }
	          operatorList.addOp(fn, args);
	        }
	        if (stop) {
	          next(deferred);
	          return;
	        }
	        closePendingRestoreOPS();
	        resolve();
	      }).catch(function (reason) {
	        if (_this7.options.ignoreErrors) {
	          _this7.handler.send('UnsupportedFeature', { featureId: UNSUPPORTED_FEATURES.unknown });
	          warn('getOperatorList - ignoring errors during task: ' + task.name);
	          closePendingRestoreOPS();
	          return;
	        }
	        throw reason;
	      });
	    },
	    getTextContent: function getTextContent(_ref3) {
	      var _this8 = this;
	
	      var stream = _ref3.stream,
	          task = _ref3.task,
	          resources = _ref3.resources,
	          _ref3$stateManager = _ref3.stateManager,
	          stateManager = _ref3$stateManager === undefined ? null : _ref3$stateManager,
	          _ref3$normalizeWhites = _ref3.normalizeWhitespace,
	          normalizeWhitespace = _ref3$normalizeWhites === undefined ? false : _ref3$normalizeWhites,
	          _ref3$combineTextItem = _ref3.combineTextItems,
	          combineTextItems = _ref3$combineTextItem === undefined ? false : _ref3$combineTextItem;
	
	      resources = resources || Dict.empty;
	      stateManager = stateManager || new StateManager(new TextState());
	      var WhitespaceRegexp = /\s/g;
	      var textContent = {
	        items: [],
	        styles: Object.create(null)
	      };
	      var textContentItem = {
	        initialized: false,
	        str: [],
	        width: 0,
	        height: 0,
	        vertical: false,
	        lastAdvanceWidth: 0,
	        lastAdvanceHeight: 0,
	        textAdvanceScale: 0,
	        spaceWidth: 0,
	        fakeSpaceMin: Infinity,
	        fakeMultiSpaceMin: Infinity,
	        fakeMultiSpaceMax: -0,
	        textRunBreakAllowed: false,
	        transform: null,
	        fontName: null
	      };
	      var SPACE_FACTOR = 0.3;
	      var MULTI_SPACE_FACTOR = 1.5;
	      var MULTI_SPACE_FACTOR_MAX = 4;
	      var self = this;
	      var xref = this.xref;
	      var xobjs = null;
	      var xobjsCache = Object.create(null);
	      var preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
	      var textState;
	      function ensureTextContentItem() {
	        if (textContentItem.initialized) {
	          return textContentItem;
	        }
	        var font = textState.font;
	        if (!(font.loadedName in textContent.styles)) {
	          textContent.styles[font.loadedName] = {
	            fontFamily: font.fallbackName,
	            ascent: font.ascent,
	            descent: font.descent,
	            vertical: font.vertical
	          };
	        }
	        textContentItem.fontName = font.loadedName;
	        var tsm = [textState.fontSize * textState.textHScale, 0, 0, textState.fontSize, 0, textState.textRise];
	        if (font.isType3Font && textState.fontMatrix !== FONT_IDENTITY_MATRIX && textState.fontSize === 1) {
	          var glyphHeight = font.bbox[3] - font.bbox[1];
	          if (glyphHeight > 0) {
	            glyphHeight = glyphHeight * textState.fontMatrix[3];
	            tsm[3] *= glyphHeight;
	          }
	        }
	        var trm = Util.transform(textState.ctm, Util.transform(textState.textMatrix, tsm));
	        textContentItem.transform = trm;
	        if (!font.vertical) {
	          textContentItem.width = 0;
	          textContentItem.height = Math.sqrt(trm[2] * trm[2] + trm[3] * trm[3]);
	          textContentItem.vertical = false;
	        } else {
	          textContentItem.width = Math.sqrt(trm[0] * trm[0] + trm[1] * trm[1]);
	          textContentItem.height = 0;
	          textContentItem.vertical = true;
	        }
	        var a = textState.textLineMatrix[0];
	        var b = textState.textLineMatrix[1];
	        var scaleLineX = Math.sqrt(a * a + b * b);
	        a = textState.ctm[0];
	        b = textState.ctm[1];
	        var scaleCtmX = Math.sqrt(a * a + b * b);
	        textContentItem.textAdvanceScale = scaleCtmX * scaleLineX;
	        textContentItem.lastAdvanceWidth = 0;
	        textContentItem.lastAdvanceHeight = 0;
	        var spaceWidth = font.spaceWidth / 1000 * textState.fontSize;
	        if (spaceWidth) {
	          textContentItem.spaceWidth = spaceWidth;
	          textContentItem.fakeSpaceMin = spaceWidth * SPACE_FACTOR;
	          textContentItem.fakeMultiSpaceMin = spaceWidth * MULTI_SPACE_FACTOR;
	          textContentItem.fakeMultiSpaceMax = spaceWidth * MULTI_SPACE_FACTOR_MAX;
	          textContentItem.textRunBreakAllowed = !font.isMonospace;
	        } else {
	          textContentItem.spaceWidth = 0;
	          textContentItem.fakeSpaceMin = Infinity;
	          textContentItem.fakeMultiSpaceMin = Infinity;
	          textContentItem.fakeMultiSpaceMax = 0;
	          textContentItem.textRunBreakAllowed = false;
	        }
	        textContentItem.initialized = true;
	        return textContentItem;
	      }
	      function replaceWhitespace(str) {
	        var i = 0,
	            ii = str.length,
	            code;
	        while (i < ii && (code = str.charCodeAt(i)) >= 0x20 && code <= 0x7F) {
	          i++;
	        }
	        return i < ii ? str.replace(WhitespaceRegexp, ' ') : str;
	      }
	      function runBidiTransform(textChunk) {
	        var str = textChunk.str.join('');
	        var bidiResult = bidi(str, -1, textChunk.vertical);
	        return {
	          str: normalizeWhitespace ? replaceWhitespace(bidiResult.str) : bidiResult.str,
	          dir: bidiResult.dir,
	          width: textChunk.width,
	          height: textChunk.height,
	          transform: textChunk.transform,
	          fontName: textChunk.fontName
	        };
	      }
	      function handleSetFont(fontName, fontRef) {
	        return self.loadFont(fontName, fontRef, resources).then(function (translated) {
	          textState.font = translated.font;
	          textState.fontMatrix = translated.font.fontMatrix || FONT_IDENTITY_MATRIX;
	        });
	      }
	      function buildTextContentItem(chars) {
	        var font = textState.font;
	        var textChunk = ensureTextContentItem();
	        var width = 0;
	        var height = 0;
	        var glyphs = font.charsToGlyphs(chars);
	        for (var i = 0; i < glyphs.length; i++) {
	          var glyph = glyphs[i];
	          var glyphWidth = null;
	          if (font.vertical && glyph.vmetric) {
	            glyphWidth = glyph.vmetric[0];
	          } else {
	            glyphWidth = glyph.width;
	          }
	          var glyphUnicode = glyph.unicode;
	          var NormalizedUnicodes = getNormalizedUnicodes();
	          if (NormalizedUnicodes[glyphUnicode] !== undefined) {
	            glyphUnicode = NormalizedUnicodes[glyphUnicode];
	          }
	          glyphUnicode = reverseIfRtl(glyphUnicode);
	          var charSpacing = textState.charSpacing;
	          if (glyph.isSpace) {
	            var wordSpacing = textState.wordSpacing;
	            charSpacing += wordSpacing;
	            if (wordSpacing > 0) {
	              addFakeSpaces(wordSpacing, textChunk.str);
	            }
	          }
	          var tx = 0;
	          var ty = 0;
	          if (!font.vertical) {
	            var w0 = glyphWidth * textState.fontMatrix[0];
	            tx = (w0 * textState.fontSize + charSpacing) * textState.textHScale;
	            width += tx;
	          } else {
	            var w1 = glyphWidth * textState.fontMatrix[0];
	            ty = w1 * textState.fontSize + charSpacing;
	            height += ty;
	          }
	          textState.translateTextMatrix(tx, ty);
	          textChunk.str.push(glyphUnicode);
	        }
	        if (!font.vertical) {
	          textChunk.lastAdvanceWidth = width;
	          textChunk.width += width;
	        } else {
	          textChunk.lastAdvanceHeight = height;
	          textChunk.height += Math.abs(height);
	        }
	        return textChunk;
	      }
	      function addFakeSpaces(width, strBuf) {
	        if (width < textContentItem.fakeSpaceMin) {
	          return;
	        }
	        if (width < textContentItem.fakeMultiSpaceMin) {
	          strBuf.push(' ');
	          return;
	        }
	        var fakeSpaces = Math.round(width / textContentItem.spaceWidth);
	        while (fakeSpaces-- > 0) {
	          strBuf.push(' ');
	        }
	      }
	      function flushTextContentItem() {
	        if (!textContentItem.initialized) {
	          return;
	        }
	        textContentItem.width *= textContentItem.textAdvanceScale;
	        textContentItem.height *= textContentItem.textAdvanceScale;
	        textContent.items.push(runBidiTransform(textContentItem));
	        textContentItem.initialized = false;
	        textContentItem.str.length = 0;
	      }
	      var timeSlotManager = new TimeSlotManager();
	      return new Promise(function promiseBody(resolve, reject) {
	        var next = function next(promise) {
	          promise.then(function () {
	            try {
	              promiseBody(resolve, reject);
	            } catch (ex) {
	              reject(ex);
	            }
	          }, reject);
	        };
	        task.ensureNotTerminated();
	        timeSlotManager.reset();
	        var stop,
	            operation = {},
	            args = [];
	        while (!(stop = timeSlotManager.check())) {
	          args.length = 0;
	          operation.args = args;
	          if (!preprocessor.read(operation)) {
	            break;
	          }
	          textState = stateManager.state;
	          var fn = operation.fn;
	          args = operation.args;
	          var advance, diff;
	          switch (fn | 0) {
	            case OPS.setFont:
	              var fontNameArg = args[0].name,
	                  fontSizeArg = args[1];
	              if (textState.font && fontNameArg === textState.fontName && fontSizeArg === textState.fontSize) {
	                break;
	              }
	              flushTextContentItem();
	              textState.fontName = fontNameArg;
	              textState.fontSize = fontSizeArg;
	              next(handleSetFont(fontNameArg, null));
	              return;
	            case OPS.setTextRise:
	              flushTextContentItem();
	              textState.textRise = args[0];
	              break;
	            case OPS.setHScale:
	              flushTextContentItem();
	              textState.textHScale = args[0] / 100;
	              break;
	            case OPS.setLeading:
	              flushTextContentItem();
	              textState.leading = args[0];
	              break;
	            case OPS.moveText:
	              var isSameTextLine = !textState.font ? false : (textState.font.vertical ? args[0] : args[1]) === 0;
	              advance = args[0] - args[1];
	              if (combineTextItems && isSameTextLine && textContentItem.initialized && advance > 0 && advance <= textContentItem.fakeMultiSpaceMax) {
	                textState.translateTextLineMatrix(args[0], args[1]);
	                textContentItem.width += args[0] - textContentItem.lastAdvanceWidth;
	                textContentItem.height += args[1] - textContentItem.lastAdvanceHeight;
	                diff = args[0] - textContentItem.lastAdvanceWidth - (args[1] - textContentItem.lastAdvanceHeight);
	                addFakeSpaces(diff, textContentItem.str);
	                break;
	              }
	              flushTextContentItem();
	              textState.translateTextLineMatrix(args[0], args[1]);
	              textState.textMatrix = textState.textLineMatrix.slice();
	              break;
	            case OPS.setLeadingMoveText:
	              flushTextContentItem();
	              textState.leading = -args[1];
	              textState.translateTextLineMatrix(args[0], args[1]);
	              textState.textMatrix = textState.textLineMatrix.slice();
	              break;
	            case OPS.nextLine:
	              flushTextContentItem();
	              textState.carriageReturn();
	              break;
	            case OPS.setTextMatrix:
	              advance = textState.calcTextLineMatrixAdvance(args[0], args[1], args[2], args[3], args[4], args[5]);
	              if (combineTextItems && advance !== null && textContentItem.initialized && advance.value > 0 && advance.value <= textContentItem.fakeMultiSpaceMax) {
	                textState.translateTextLineMatrix(advance.width, advance.height);
	                textContentItem.width += advance.width - textContentItem.lastAdvanceWidth;
	                textContentItem.height += advance.height - textContentItem.lastAdvanceHeight;
	                diff = advance.width - textContentItem.lastAdvanceWidth - (advance.height - textContentItem.lastAdvanceHeight);
	                addFakeSpaces(diff, textContentItem.str);
	                break;
	              }
	              flushTextContentItem();
	              textState.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
	              textState.setTextLineMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case OPS.setCharSpacing:
	              textState.charSpacing = args[0];
	              break;
	            case OPS.setWordSpacing:
	              textState.wordSpacing = args[0];
	              break;
	            case OPS.beginText:
	              flushTextContentItem();
	              textState.textMatrix = IDENTITY_MATRIX.slice();
	              textState.textLineMatrix = IDENTITY_MATRIX.slice();
	              break;
	            case OPS.showSpacedText:
	              var items = args[0];
	              var offset;
	              for (var j = 0, jj = items.length; j < jj; j++) {
	                if (typeof items[j] === 'string') {
	                  buildTextContentItem(items[j]);
	                } else if (isNum(items[j])) {
	                  ensureTextContentItem();
	                  advance = items[j] * textState.fontSize / 1000;
	                  var breakTextRun = false;
	                  if (textState.font.vertical) {
	                    offset = advance;
	                    textState.translateTextMatrix(0, offset);
	                    breakTextRun = textContentItem.textRunBreakAllowed && advance > textContentItem.fakeMultiSpaceMax;
	                    if (!breakTextRun) {
	                      textContentItem.height += offset;
	                    }
	                  } else {
	                    advance = -advance;
	                    offset = advance * textState.textHScale;
	                    textState.translateTextMatrix(offset, 0);
	                    breakTextRun = textContentItem.textRunBreakAllowed && advance > textContentItem.fakeMultiSpaceMax;
	                    if (!breakTextRun) {
	                      textContentItem.width += offset;
	                    }
	                  }
	                  if (breakTextRun) {
	                    flushTextContentItem();
	                  } else if (advance > 0) {
	                    addFakeSpaces(advance, textContentItem.str);
	                  }
	                }
	              }
	              break;
	            case OPS.showText:
	              buildTextContentItem(args[0]);
	              break;
	            case OPS.nextLineShowText:
	              flushTextContentItem();
	              textState.carriageReturn();
	              buildTextContentItem(args[0]);
	              break;
	            case OPS.nextLineSetSpacingShowText:
	              flushTextContentItem();
	              textState.wordSpacing = args[0];
	              textState.charSpacing = args[1];
	              textState.carriageReturn();
	              buildTextContentItem(args[2]);
	              break;
	            case OPS.paintXObject:
	              flushTextContentItem();
	              if (args[0].code) {
	                break;
	              }
	              if (!xobjs) {
	                xobjs = resources.get('XObject') || Dict.empty;
	              }
	              var name = args[0].name;
	              if (xobjsCache.key === name) {
	                if (xobjsCache.texts) {
	                  Util.appendToArray(textContent.items, xobjsCache.texts.items);
	                  Util.extendObj(textContent.styles, xobjsCache.texts.styles);
	                }
	                break;
	              }
	              var xobj = xobjs.get(name);
	              if (!xobj) {
	                break;
	              }
	              assert(isStream(xobj), 'XObject should be a stream');
	              var type = xobj.dict.get('Subtype');
	              assert(isName(type), 'XObject should have a Name subtype');
	              if (type.name !== 'Form') {
	                xobjsCache.key = name;
	                xobjsCache.texts = null;
	                break;
	              }
	              var currentState = stateManager.state.clone();
	              var xObjStateManager = new StateManager(currentState);
	              var matrix = xobj.dict.getArray('Matrix');
	              if (isArray(matrix) && matrix.length === 6) {
	                xObjStateManager.transform(matrix);
	              }
	              next(self.getTextContent({
	                stream: xobj,
	                task: task,
	                resources: xobj.dict.get('Resources') || resources,
	                stateManager: xObjStateManager,
	                normalizeWhitespace: normalizeWhitespace,
	                combineTextItems: combineTextItems
	              }).then(function (formTextContent) {
	                Util.appendToArray(textContent.items, formTextContent.items);
	                Util.extendObj(textContent.styles, formTextContent.styles);
	                xobjsCache.key = name;
	                xobjsCache.texts = formTextContent;
	              }));
	              return;
	            case OPS.setGState:
	              flushTextContentItem();
	              var dictName = args[0];
	              var extGState = resources.get('ExtGState');
	              if (!isDict(extGState) || !isName(dictName)) {
	                break;
	              }
	              var gState = extGState.get(dictName.name);
	              if (!isDict(gState)) {
	                break;
	              }
	              var gStateFont = gState.get('Font');
	              if (gStateFont) {
	                textState.fontName = null;
	                textState.fontSize = gStateFont[1];
	                next(handleSetFont(null, gStateFont[0]));
	                return;
	              }
	              break;
	          }
	        }
	        if (stop) {
	          next(deferred);
	          return;
	        }
	        flushTextContentItem();
	        resolve(textContent);
	      }).catch(function (reason) {
	        if (_this8.options.ignoreErrors) {
	          warn('getTextContent - ignoring errors during task: ' + task.name);
	          flushTextContentItem();
	          return textContent;
	        }
	        throw reason;
	      });
	    },
	
	    extractDataStructures: function PartialEvaluator_extractDataStructures(dict, baseDict, properties) {
	      var _this9 = this;
	
	      var xref = this.xref;
	      var toUnicode = dict.get('ToUnicode') || baseDict.get('ToUnicode');
	      var toUnicodePromise = toUnicode ? this.readToUnicode(toUnicode) : Promise.resolve(undefined);
	      if (properties.composite) {
	        var cidSystemInfo = dict.get('CIDSystemInfo');
	        if (isDict(cidSystemInfo)) {
	          properties.cidSystemInfo = {
	            registry: cidSystemInfo.get('Registry'),
	            ordering: cidSystemInfo.get('Ordering'),
	            supplement: cidSystemInfo.get('Supplement')
	          };
	        }
	        var cidToGidMap = dict.get('CIDToGIDMap');
	        if (isStream(cidToGidMap)) {
	          properties.cidToGidMap = this.readCidToGidMap(cidToGidMap);
	        }
	      }
	      var differences = [];
	      var baseEncodingName = null;
	      var encoding;
	      if (dict.has('Encoding')) {
	        encoding = dict.get('Encoding');
	        if (isDict(encoding)) {
	          baseEncodingName = encoding.get('BaseEncoding');
	          baseEncodingName = isName(baseEncodingName) ? baseEncodingName.name : null;
	          if (encoding.has('Differences')) {
	            var diffEncoding = encoding.get('Differences');
	            var index = 0;
	            for (var j = 0, jj = diffEncoding.length; j < jj; j++) {
	              var data = xref.fetchIfRef(diffEncoding[j]);
	              if (isNum(data)) {
	                index = data;
	              } else if (isName(data)) {
	                differences[index++] = data.name;
	              } else {
	                error('Invalid entry in \'Differences\' array: ' + data);
	              }
	            }
	          }
	        } else if (isName(encoding)) {
	          baseEncodingName = encoding.name;
	        } else {
	          error('Encoding is not a Name nor a Dict');
	        }
	        if (baseEncodingName !== 'MacRomanEncoding' && baseEncodingName !== 'MacExpertEncoding' && baseEncodingName !== 'WinAnsiEncoding') {
	          baseEncodingName = null;
	        }
	      }
	      if (baseEncodingName) {
	        properties.defaultEncoding = getEncoding(baseEncodingName).slice();
	      } else {
	        var isSymbolicFont = !!(properties.flags & FontFlags.Symbolic);
	        var isNonsymbolicFont = !!(properties.flags & FontFlags.Nonsymbolic);
	        encoding = StandardEncoding;
	        if (properties.type === 'TrueType' && !isNonsymbolicFont) {
	          encoding = WinAnsiEncoding;
	        }
	        if (isSymbolicFont) {
	          encoding = MacRomanEncoding;
	          if (!properties.file) {
	            if (/Symbol/i.test(properties.name)) {
	              encoding = SymbolSetEncoding;
	            } else if (/Dingbats/i.test(properties.name)) {
	              encoding = ZapfDingbatsEncoding;
	            }
	          }
	        }
	        properties.defaultEncoding = encoding;
	      }
	      properties.differences = differences;
	      properties.baseEncodingName = baseEncodingName;
	      properties.hasEncoding = !!baseEncodingName || differences.length > 0;
	      properties.dict = dict;
	      return toUnicodePromise.then(function (toUnicode) {
	        properties.toUnicode = toUnicode;
	        return _this9.buildToUnicode(properties);
	      }).then(function (toUnicode) {
	        properties.toUnicode = toUnicode;
	        return properties;
	      });
	    },
	    buildToUnicode: function PartialEvaluator_buildToUnicode(properties) {
	      properties.hasIncludedToUnicodeMap = !!properties.toUnicode && properties.toUnicode.length > 0;
	      if (properties.hasIncludedToUnicodeMap) {
	        return Promise.resolve(properties.toUnicode);
	      }
	      var toUnicode, charcode, glyphName;
	      if (!properties.composite) {
	        toUnicode = [];
	        var encoding = properties.defaultEncoding.slice();
	        var baseEncodingName = properties.baseEncodingName;
	        var differences = properties.differences;
	        for (charcode in differences) {
	          glyphName = differences[charcode];
	          if (glyphName === '.notdef') {
	            continue;
	          }
	          encoding[charcode] = glyphName;
	        }
	        var glyphsUnicodeMap = getGlyphsUnicode();
	        for (charcode in encoding) {
	          glyphName = encoding[charcode];
	          if (glyphName === '') {
	            continue;
	          } else if (glyphsUnicodeMap[glyphName] === undefined) {
	            var code = 0;
	            switch (glyphName[0]) {
	              case 'G':
	                if (glyphName.length === 3) {
	                  code = parseInt(glyphName.substr(1), 16);
	                }
	                break;
	              case 'g':
	                if (glyphName.length === 5) {
	                  code = parseInt(glyphName.substr(1), 16);
	                }
	                break;
	              case 'C':
	              case 'c':
	                if (glyphName.length >= 3) {
	                  code = +glyphName.substr(1);
	                }
	                break;
	              default:
	                var unicode = getUnicodeForGlyph(glyphName, glyphsUnicodeMap);
	                if (unicode !== -1) {
	                  code = unicode;
	                }
	            }
	            if (code) {
	              if (baseEncodingName && code === +charcode) {
	                var baseEncoding = getEncoding(baseEncodingName);
	                if (baseEncoding && (glyphName = baseEncoding[charcode])) {
	                  toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
	                  continue;
	                }
	              }
	              toUnicode[charcode] = String.fromCharCode(code);
	            }
	            continue;
	          }
	          toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
	        }
	        return Promise.resolve(new ToUnicodeMap(toUnicode));
	      }
	      if (properties.composite && (properties.cMap.builtInCMap && !(properties.cMap instanceof IdentityCMap) || properties.cidSystemInfo.registry === 'Adobe' && (properties.cidSystemInfo.ordering === 'GB1' || properties.cidSystemInfo.ordering === 'CNS1' || properties.cidSystemInfo.ordering === 'Japan1' || properties.cidSystemInfo.ordering === 'Korea1'))) {
	        var registry = properties.cidSystemInfo.registry;
	        var ordering = properties.cidSystemInfo.ordering;
	        var ucs2CMapName = Name.get(registry + '-' + ordering + '-UCS2');
	        return CMapFactory.create({
	          encoding: ucs2CMapName,
	          fetchBuiltInCMap: this.fetchBuiltInCMap,
	          useCMap: null
	        }).then(function (ucs2CMap) {
	          var cMap = properties.cMap;
	          toUnicode = [];
	          cMap.forEach(function (charcode, cid) {
	            assert(cid <= 0xffff, 'Max size of CID is 65,535');
	            var ucs2 = ucs2CMap.lookup(cid);
	            if (ucs2) {
	              toUnicode[charcode] = String.fromCharCode((ucs2.charCodeAt(0) << 8) + ucs2.charCodeAt(1));
	            }
	          });
	          return new ToUnicodeMap(toUnicode);
	        });
	      }
	      return Promise.resolve(new IdentityToUnicodeMap(properties.firstChar, properties.lastChar));
	    },
	    readToUnicode: function PartialEvaluator_readToUnicode(toUnicode) {
	      var cmapObj = toUnicode;
	      if (isName(cmapObj)) {
	        return CMapFactory.create({
	          encoding: cmapObj,
	          fetchBuiltInCMap: this.fetchBuiltInCMap,
	          useCMap: null
	        }).then(function (cmap) {
	          if (cmap instanceof IdentityCMap) {
	            return new IdentityToUnicodeMap(0, 0xFFFF);
	          }
	          return new ToUnicodeMap(cmap.getMap());
	        });
	      } else if (isStream(cmapObj)) {
	        return CMapFactory.create({
	          encoding: cmapObj,
	          fetchBuiltInCMap: this.fetchBuiltInCMap,
	          useCMap: null
	        }).then(function (cmap) {
	          if (cmap instanceof IdentityCMap) {
	            return new IdentityToUnicodeMap(0, 0xFFFF);
	          }
	          var map = new Array(cmap.length);
	          cmap.forEach(function (charCode, token) {
	            var str = [];
	            for (var k = 0; k < token.length; k += 2) {
	              var w1 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
	              if ((w1 & 0xF800) !== 0xD800) {
	                str.push(w1);
	                continue;
	              }
	              k += 2;
	              var w2 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
	              str.push(((w1 & 0x3ff) << 10) + (w2 & 0x3ff) + 0x10000);
	            }
	            map[charCode] = String.fromCharCode.apply(String, str);
	          });
	          return new ToUnicodeMap(map);
	        });
	      }
	      return Promise.resolve(null);
	    },
	    readCidToGidMap: function PartialEvaluator_readCidToGidMap(cidToGidStream) {
	      var glyphsData = cidToGidStream.getBytes();
	      var result = [];
	      for (var j = 0, jj = glyphsData.length; j < jj; j++) {
	        var glyphID = glyphsData[j++] << 8 | glyphsData[j];
	        if (glyphID === 0) {
	          continue;
	        }
	        var code = j >> 1;
	        result[code] = glyphID;
	      }
	      return result;
	    },
	    extractWidths: function PartialEvaluator_extractWidths(dict, descriptor, properties) {
	      var xref = this.xref;
	      var glyphsWidths = [];
	      var defaultWidth = 0;
	      var glyphsVMetrics = [];
	      var defaultVMetrics;
	      var i, ii, j, jj, start, code, widths;
	      if (properties.composite) {
	        defaultWidth = dict.get('DW') || 1000;
	        widths = dict.get('W');
	        if (widths) {
	          for (i = 0, ii = widths.length; i < ii; i++) {
	            start = xref.fetchIfRef(widths[i++]);
	            code = xref.fetchIfRef(widths[i]);
	            if (isArray(code)) {
	              for (j = 0, jj = code.length; j < jj; j++) {
	                glyphsWidths[start++] = xref.fetchIfRef(code[j]);
	              }
	            } else {
	              var width = xref.fetchIfRef(widths[++i]);
	              for (j = start; j <= code; j++) {
	                glyphsWidths[j] = width;
	              }
	            }
	          }
	        }
	        if (properties.vertical) {
	          var vmetrics = dict.getArray('DW2') || [880, -1000];
	          defaultVMetrics = [vmetrics[1], defaultWidth * 0.5, vmetrics[0]];
	          vmetrics = dict.get('W2');
	          if (vmetrics) {
	            for (i = 0, ii = vmetrics.length; i < ii; i++) {
	              start = xref.fetchIfRef(vmetrics[i++]);
	              code = xref.fetchIfRef(vmetrics[i]);
	              if (isArray(code)) {
	                for (j = 0, jj = code.length; j < jj; j++) {
	                  glyphsVMetrics[start++] = [xref.fetchIfRef(code[j++]), xref.fetchIfRef(code[j++]), xref.fetchIfRef(code[j])];
	                }
	              } else {
	                var vmetric = [xref.fetchIfRef(vmetrics[++i]), xref.fetchIfRef(vmetrics[++i]), xref.fetchIfRef(vmetrics[++i])];
	                for (j = start; j <= code; j++) {
	                  glyphsVMetrics[j] = vmetric;
	                }
	              }
	            }
	          }
	        }
	      } else {
	        var firstChar = properties.firstChar;
	        widths = dict.get('Widths');
	        if (widths) {
	          j = firstChar;
	          for (i = 0, ii = widths.length; i < ii; i++) {
	            glyphsWidths[j++] = xref.fetchIfRef(widths[i]);
	          }
	          defaultWidth = parseFloat(descriptor.get('MissingWidth')) || 0;
	        } else {
	          var baseFontName = dict.get('BaseFont');
	          if (isName(baseFontName)) {
	            var metrics = this.getBaseFontMetrics(baseFontName.name);
	            glyphsWidths = this.buildCharCodeToWidth(metrics.widths, properties);
	            defaultWidth = metrics.defaultWidth;
	          }
	        }
	      }
	      var isMonospace = true;
	      var firstWidth = defaultWidth;
	      for (var glyph in glyphsWidths) {
	        var glyphWidth = glyphsWidths[glyph];
	        if (!glyphWidth) {
	          continue;
	        }
	        if (!firstWidth) {
	          firstWidth = glyphWidth;
	          continue;
	        }
	        if (firstWidth !== glyphWidth) {
	          isMonospace = false;
	          break;
	        }
	      }
	      if (isMonospace) {
	        properties.flags |= FontFlags.FixedPitch;
	      }
	      properties.defaultWidth = defaultWidth;
	      properties.widths = glyphsWidths;
	      properties.defaultVMetrics = defaultVMetrics;
	      properties.vmetrics = glyphsVMetrics;
	    },
	    isSerifFont: function PartialEvaluator_isSerifFont(baseFontName) {
	      var fontNameWoStyle = baseFontName.split('-')[0];
	      return fontNameWoStyle in getSerifFonts() || fontNameWoStyle.search(/serif/gi) !== -1;
	    },
	    getBaseFontMetrics: function PartialEvaluator_getBaseFontMetrics(name) {
	      var defaultWidth = 0;
	      var widths = [];
	      var monospace = false;
	      var stdFontMap = getStdFontMap();
	      var lookupName = stdFontMap[name] || name;
	      var Metrics = getMetrics();
	      if (!(lookupName in Metrics)) {
	        if (this.isSerifFont(name)) {
	          lookupName = 'Times-Roman';
	        } else {
	          lookupName = 'Helvetica';
	        }
	      }
	      var glyphWidths = Metrics[lookupName];
	      if (isNum(glyphWidths)) {
	        defaultWidth = glyphWidths;
	        monospace = true;
	      } else {
	        widths = glyphWidths();
	      }
	      return {
	        defaultWidth: defaultWidth,
	        monospace: monospace,
	        widths: widths
	      };
	    },
	    buildCharCodeToWidth: function PartialEvaluator_bulildCharCodeToWidth(widthsByGlyphName, properties) {
	      var widths = Object.create(null);
	      var differences = properties.differences;
	      var encoding = properties.defaultEncoding;
	      for (var charCode = 0; charCode < 256; charCode++) {
	        if (charCode in differences && widthsByGlyphName[differences[charCode]]) {
	          widths[charCode] = widthsByGlyphName[differences[charCode]];
	          continue;
	        }
	        if (charCode in encoding && widthsByGlyphName[encoding[charCode]]) {
	          widths[charCode] = widthsByGlyphName[encoding[charCode]];
	          continue;
	        }
	      }
	      return widths;
	    },
	    preEvaluateFont: function PartialEvaluator_preEvaluateFont(dict) {
	      var baseDict = dict;
	      var type = dict.get('Subtype');
	      assert(isName(type), 'invalid font Subtype');
	      var composite = false;
	      var uint8array;
	      if (type.name === 'Type0') {
	        var df = dict.get('DescendantFonts');
	        assert(df, 'Descendant fonts are not specified');
	        dict = isArray(df) ? this.xref.fetchIfRef(df[0]) : df;
	        type = dict.get('Subtype');
	        assert(isName(type), 'invalid font Subtype');
	        composite = true;
	      }
	      var descriptor = dict.get('FontDescriptor');
	      if (descriptor) {
	        var hash = new MurmurHash3_64();
	        var encoding = baseDict.getRaw('Encoding');
	        if (isName(encoding)) {
	          hash.update(encoding.name);
	        } else if (isRef(encoding)) {
	          hash.update(encoding.toString());
	        } else if (isDict(encoding)) {
	          var keys = encoding.getKeys();
	          for (var i = 0, ii = keys.length; i < ii; i++) {
	            var entry = encoding.getRaw(keys[i]);
	            if (isName(entry)) {
	              hash.update(entry.name);
	            } else if (isRef(entry)) {
	              hash.update(entry.toString());
	            } else if (isArray(entry)) {
	              var diffLength = entry.length,
	                  diffBuf = new Array(diffLength);
	              for (var j = 0; j < diffLength; j++) {
	                var diffEntry = entry[j];
	                if (isName(diffEntry)) {
	                  diffBuf[j] = diffEntry.name;
	                } else if (isNum(diffEntry) || isRef(diffEntry)) {
	                  diffBuf[j] = diffEntry.toString();
	                }
	              }
	              hash.update(diffBuf.join());
	            }
	          }
	        }
	        var toUnicode = dict.get('ToUnicode') || baseDict.get('ToUnicode');
	        if (isStream(toUnicode)) {
	          var stream = toUnicode.str || toUnicode;
	          uint8array = stream.buffer ? new Uint8Array(stream.buffer.buffer, 0, stream.bufferLength) : new Uint8Array(stream.bytes.buffer, stream.start, stream.end - stream.start);
	          hash.update(uint8array);
	        } else if (isName(toUnicode)) {
	          hash.update(toUnicode.name);
	        }
	        var widths = dict.get('Widths') || baseDict.get('Widths');
	        if (widths) {
	          uint8array = new Uint8Array(new Uint32Array(widths).buffer);
	          hash.update(uint8array);
	        }
	      }
	      return {
	        descriptor: descriptor,
	        dict: dict,
	        baseDict: baseDict,
	        composite: composite,
	        type: type.name,
	        hash: hash ? hash.hexdigest() : ''
	      };
	    },
	    translateFont: function PartialEvaluator_translateFont(preEvaluatedFont) {
	      var _this10 = this;
	
	      var baseDict = preEvaluatedFont.baseDict;
	      var dict = preEvaluatedFont.dict;
	      var composite = preEvaluatedFont.composite;
	      var descriptor = preEvaluatedFont.descriptor;
	      var type = preEvaluatedFont.type;
	      var maxCharIndex = composite ? 0xFFFF : 0xFF;
	      var properties;
	      if (!descriptor) {
	        if (type === 'Type3') {
	          descriptor = new Dict(null);
	          descriptor.set('FontName', Name.get(type));
	          descriptor.set('FontBBox', dict.getArray('FontBBox'));
	        } else {
	          var baseFontName = dict.get('BaseFont');
	          assert(isName(baseFontName), 'Base font is not specified');
	          baseFontName = baseFontName.name.replace(/[,_]/g, '-');
	          var metrics = this.getBaseFontMetrics(baseFontName);
	          var fontNameWoStyle = baseFontName.split('-')[0];
	          var flags = (this.isSerifFont(fontNameWoStyle) ? FontFlags.Serif : 0) | (metrics.monospace ? FontFlags.FixedPitch : 0) | (getSymbolsFonts()[fontNameWoStyle] ? FontFlags.Symbolic : FontFlags.Nonsymbolic);
	          properties = {
	            type: type,
	            name: baseFontName,
	            widths: metrics.widths,
	            defaultWidth: metrics.defaultWidth,
	            flags: flags,
	            firstChar: 0,
	            lastChar: maxCharIndex
	          };
	          return this.extractDataStructures(dict, dict, properties).then(function (properties) {
	            properties.widths = _this10.buildCharCodeToWidth(metrics.widths, properties);
	            return new Font(baseFontName, null, properties);
	          });
	        }
	      }
	      var firstChar = dict.get('FirstChar') || 0;
	      var lastChar = dict.get('LastChar') || maxCharIndex;
	      var fontName = descriptor.get('FontName');
	      var baseFont = dict.get('BaseFont');
	      if (isString(fontName)) {
	        fontName = Name.get(fontName);
	      }
	      if (isString(baseFont)) {
	        baseFont = Name.get(baseFont);
	      }
	      if (type !== 'Type3') {
	        var fontNameStr = fontName && fontName.name;
	        var baseFontStr = baseFont && baseFont.name;
	        if (fontNameStr !== baseFontStr) {
	          info('The FontDescriptor\'s FontName is "' + fontNameStr + '" but should be the same as the Font\'s BaseFont "' + baseFontStr + '"');
	          if (fontNameStr && baseFontStr && baseFontStr.indexOf(fontNameStr) === 0) {
	            fontName = baseFont;
	          }
	        }
	      }
	      fontName = fontName || baseFont;
	      assert(isName(fontName), 'invalid font name');
	      var fontFile = descriptor.get('FontFile', 'FontFile2', 'FontFile3');
	      if (fontFile) {
	        if (fontFile.dict) {
	          var subtype = fontFile.dict.get('Subtype');
	          if (subtype) {
	            subtype = subtype.name;
	          }
	          var length1 = fontFile.dict.get('Length1');
	          var length2 = fontFile.dict.get('Length2');
	          var length3 = fontFile.dict.get('Length3');
	        }
	      }
	      properties = {
	        type: type,
	        name: fontName.name,
	        subtype: subtype,
	        file: fontFile,
	        length1: length1,
	        length2: length2,
	        length3: length3,
	        loadedName: baseDict.loadedName,
	        composite: composite,
	        wideChars: composite,
	        fixedPitch: false,
	        fontMatrix: dict.getArray('FontMatrix') || FONT_IDENTITY_MATRIX,
	        firstChar: firstChar || 0,
	        lastChar: lastChar || maxCharIndex,
	        bbox: descriptor.getArray('FontBBox'),
	        ascent: descriptor.get('Ascent'),
	        descent: descriptor.get('Descent'),
	        xHeight: descriptor.get('XHeight'),
	        capHeight: descriptor.get('CapHeight'),
	        flags: descriptor.get('Flags'),
	        italicAngle: descriptor.get('ItalicAngle'),
	        coded: false
	      };
	      var cMapPromise;
	      if (composite) {
	        var cidEncoding = baseDict.get('Encoding');
	        if (isName(cidEncoding)) {
	          properties.cidEncoding = cidEncoding.name;
	        }
	        cMapPromise = CMapFactory.create({
	          encoding: cidEncoding,
	          fetchBuiltInCMap: this.fetchBuiltInCMap,
	          useCMap: null
	        }).then(function (cMap) {
	          properties.cMap = cMap;
	          properties.vertical = properties.cMap.vertical;
	        });
	      } else {
	        cMapPromise = Promise.resolve(undefined);
	      }
	      return cMapPromise.then(function () {
	        return _this10.extractDataStructures(dict, baseDict, properties);
	      }).then(function (properties) {
	        _this10.extractWidths(dict, descriptor, properties);
	        if (type === 'Type3') {
	          properties.isType3Font = true;
	        }
	        return new Font(fontName.name, fontFile, properties);
	      });
	    }
	  };
	  return PartialEvaluator;
	}();
	var TranslatedFont = function TranslatedFontClosure() {
	  function TranslatedFont(loadedName, font, dict) {
	    this.loadedName = loadedName;
	    this.font = font;
	    this.dict = dict;
	    this.type3Loaded = null;
	    this.sent = false;
	  }
	  TranslatedFont.prototype = {
	    send: function send(handler) {
	      if (this.sent) {
	        return;
	      }
	      var fontData = this.font.exportData();
	      handler.send('commonobj', [this.loadedName, 'Font', fontData]);
	      this.sent = true;
	    },
	    loadType3Data: function loadType3Data(evaluator, resources, parentOperatorList, task) {
	      assert(this.font.isType3Font);
	      if (this.type3Loaded) {
	        return this.type3Loaded;
	      }
	      var type3Options = Object.create(evaluator.options);
	      type3Options.ignoreErrors = false;
	      var type3Evaluator = evaluator.clone(type3Options);
	      var translatedFont = this.font;
	      var loadCharProcsPromise = Promise.resolve();
	      var charProcs = this.dict.get('CharProcs');
	      var fontResources = this.dict.get('Resources') || resources;
	      var charProcKeys = charProcs.getKeys();
	      var charProcOperatorList = Object.create(null);
	
	      var _loop2 = function _loop2() {
	        var key = charProcKeys[i];
	        loadCharProcsPromise = loadCharProcsPromise.then(function () {
	          var glyphStream = charProcs.get(key);
	          var operatorList = new OperatorList();
	          return type3Evaluator.getOperatorList({
	            stream: glyphStream,
	            task: task,
	            resources: fontResources,
	            operatorList: operatorList
	          }).then(function () {
	            charProcOperatorList[key] = operatorList.getIR();
	            parentOperatorList.addDependencies(operatorList.dependencies);
	          }).catch(function (reason) {
	            warn('Type3 font resource "' + key + '" is not available.');
	            var operatorList = new OperatorList();
	            charProcOperatorList[key] = operatorList.getIR();
	          });
	        });
	      };
	
	      for (var i = 0, n = charProcKeys.length; i < n; ++i) {
	        _loop2();
	      }
	      this.type3Loaded = loadCharProcsPromise.then(function () {
	        translatedFont.charProcOperatorList = charProcOperatorList;
	      });
	      return this.type3Loaded;
	    }
	  };
	  return TranslatedFont;
	}();
	var OperatorList = function OperatorListClosure() {
	  var CHUNK_SIZE = 1000;
	  var CHUNK_SIZE_ABOUT = CHUNK_SIZE - 5;
	  function getTransfers(queue) {
	    var transfers = [];
	    var fnArray = queue.fnArray,
	        argsArray = queue.argsArray;
	    for (var i = 0, ii = queue.length; i < ii; i++) {
	      switch (fnArray[i]) {
	        case OPS.paintInlineImageXObject:
	        case OPS.paintInlineImageXObjectGroup:
	        case OPS.paintImageMaskXObject:
	          var arg = argsArray[i][0];
	          if (!arg.cached) {
	            transfers.push(arg.data.buffer);
	          }
	          break;
	      }
	    }
	    return transfers;
	  }
	  function OperatorList(intent, messageHandler, pageIndex) {
	    this.messageHandler = messageHandler;
	    this.fnArray = [];
	    this.argsArray = [];
	    this.dependencies = Object.create(null);
	    this._totalLength = 0;
	    this.pageIndex = pageIndex;
	    this.intent = intent;
	  }
	  OperatorList.prototype = {
	    get length() {
	      return this.argsArray.length;
	    },
	    get totalLength() {
	      return this._totalLength + this.length;
	    },
	    addOp: function addOp(fn, args) {
	      this.fnArray.push(fn);
	      this.argsArray.push(args);
	      if (this.messageHandler) {
	        if (this.fnArray.length >= CHUNK_SIZE) {
	          this.flush();
	        } else if (this.fnArray.length >= CHUNK_SIZE_ABOUT && (fn === OPS.restore || fn === OPS.endText)) {
	          this.flush();
	        }
	      }
	    },
	    addDependency: function addDependency(dependency) {
	      if (dependency in this.dependencies) {
	        return;
	      }
	      this.dependencies[dependency] = true;
	      this.addOp(OPS.dependency, [dependency]);
	    },
	    addDependencies: function addDependencies(dependencies) {
	      for (var key in dependencies) {
	        this.addDependency(key);
	      }
	    },
	    addOpList: function addOpList(opList) {
	      Util.extendObj(this.dependencies, opList.dependencies);
	      for (var i = 0, ii = opList.length; i < ii; i++) {
	        this.addOp(opList.fnArray[i], opList.argsArray[i]);
	      }
	    },
	    getIR: function getIR() {
	      return {
	        fnArray: this.fnArray,
	        argsArray: this.argsArray,
	        length: this.length
	      };
	    },
	    flush: function flush(lastChunk) {
	      if (this.intent !== 'oplist') {
	        new QueueOptimizer().optimize(this);
	      }
	      var transfers = getTransfers(this);
	      var length = this.length;
	      this._totalLength += length;
	      this.messageHandler.send('RenderPageChunk', {
	        operatorList: {
	          fnArray: this.fnArray,
	          argsArray: this.argsArray,
	          lastChunk: lastChunk,
	          length: length
	        },
	        pageIndex: this.pageIndex,
	        intent: this.intent
	      }, transfers);
	      this.dependencies = Object.create(null);
	      this.fnArray.length = 0;
	      this.argsArray.length = 0;
	    }
	  };
	  return OperatorList;
	}();
	var StateManager = function StateManagerClosure() {
	  function StateManager(initialState) {
	    this.state = initialState;
	    this.stateStack = [];
	  }
	  StateManager.prototype = {
	    save: function save() {
	      var old = this.state;
	      this.stateStack.push(this.state);
	      this.state = old.clone();
	    },
	    restore: function restore() {
	      var prev = this.stateStack.pop();
	      if (prev) {
	        this.state = prev;
	      }
	    },
	    transform: function transform(args) {
	      this.state.ctm = Util.transform(this.state.ctm, args);
	    }
	  };
	  return StateManager;
	}();
	var TextState = function TextStateClosure() {
	  function TextState() {
	    this.ctm = new Float32Array(IDENTITY_MATRIX);
	    this.fontName = null;
	    this.fontSize = 0;
	    this.font = null;
	    this.fontMatrix = FONT_IDENTITY_MATRIX;
	    this.textMatrix = IDENTITY_MATRIX.slice();
	    this.textLineMatrix = IDENTITY_MATRIX.slice();
	    this.charSpacing = 0;
	    this.wordSpacing = 0;
	    this.leading = 0;
	    this.textHScale = 1;
	    this.textRise = 0;
	  }
	  TextState.prototype = {
	    setTextMatrix: function TextState_setTextMatrix(a, b, c, d, e, f) {
	      var m = this.textMatrix;
	      m[0] = a;
	      m[1] = b;
	      m[2] = c;
	      m[3] = d;
	      m[4] = e;
	      m[5] = f;
	    },
	    setTextLineMatrix: function TextState_setTextMatrix(a, b, c, d, e, f) {
	      var m = this.textLineMatrix;
	      m[0] = a;
	      m[1] = b;
	      m[2] = c;
	      m[3] = d;
	      m[4] = e;
	      m[5] = f;
	    },
	    translateTextMatrix: function TextState_translateTextMatrix(x, y) {
	      var m = this.textMatrix;
	      m[4] = m[0] * x + m[2] * y + m[4];
	      m[5] = m[1] * x + m[3] * y + m[5];
	    },
	    translateTextLineMatrix: function TextState_translateTextMatrix(x, y) {
	      var m = this.textLineMatrix;
	      m[4] = m[0] * x + m[2] * y + m[4];
	      m[5] = m[1] * x + m[3] * y + m[5];
	    },
	    calcTextLineMatrixAdvance: function TextState_calcTextLineMatrixAdvance(a, b, c, d, e, f) {
	      var font = this.font;
	      if (!font) {
	        return null;
	      }
	      var m = this.textLineMatrix;
	      if (!(a === m[0] && b === m[1] && c === m[2] && d === m[3])) {
	        return null;
	      }
	      var txDiff = e - m[4],
	          tyDiff = f - m[5];
	      if (font.vertical && txDiff !== 0 || !font.vertical && tyDiff !== 0) {
	        return null;
	      }
	      var tx,
	          ty,
	          denominator = a * d - b * c;
	      if (font.vertical) {
	        tx = -tyDiff * c / denominator;
	        ty = tyDiff * a / denominator;
	      } else {
	        tx = txDiff * d / denominator;
	        ty = -txDiff * b / denominator;
	      }
	      return {
	        width: tx,
	        height: ty,
	        value: font.vertical ? ty : tx
	      };
	    },
	    calcRenderMatrix: function TextState_calcRendeMatrix(ctm) {
	      var tsm = [this.fontSize * this.textHScale, 0, 0, this.fontSize, 0, this.textRise];
	      return Util.transform(ctm, Util.transform(this.textMatrix, tsm));
	    },
	    carriageReturn: function TextState_carriageReturn() {
	      this.translateTextLineMatrix(0, -this.leading);
	      this.textMatrix = this.textLineMatrix.slice();
	    },
	    clone: function TextState_clone() {
	      var clone = Object.create(this);
	      clone.textMatrix = this.textMatrix.slice();
	      clone.textLineMatrix = this.textLineMatrix.slice();
	      clone.fontMatrix = this.fontMatrix.slice();
	      return clone;
	    }
	  };
	  return TextState;
	}();
	var EvalState = function EvalStateClosure() {
	  function EvalState() {
	    this.ctm = new Float32Array(IDENTITY_MATRIX);
	    this.font = null;
	    this.textRenderingMode = TextRenderingMode.FILL;
	    this.fillColorSpace = ColorSpace.singletons.gray;
	    this.strokeColorSpace = ColorSpace.singletons.gray;
	  }
	  EvalState.prototype = {
	    clone: function CanvasExtraState_clone() {
	      return Object.create(this);
	    }
	  };
	  return EvalState;
	}();
	var EvaluatorPreprocessor = function EvaluatorPreprocessorClosure() {
	  var getOPMap = getLookupTableFactory(function (t) {
	    t['w'] = {
	      id: OPS.setLineWidth,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['J'] = {
	      id: OPS.setLineCap,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['j'] = {
	      id: OPS.setLineJoin,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['M'] = {
	      id: OPS.setMiterLimit,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['d'] = {
	      id: OPS.setDash,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['ri'] = {
	      id: OPS.setRenderingIntent,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['i'] = {
	      id: OPS.setFlatness,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['gs'] = {
	      id: OPS.setGState,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['q'] = {
	      id: OPS.save,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['Q'] = {
	      id: OPS.restore,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['cm'] = {
	      id: OPS.transform,
	      numArgs: 6,
	      variableArgs: false
	    };
	    t['m'] = {
	      id: OPS.moveTo,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['l'] = {
	      id: OPS.lineTo,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['c'] = {
	      id: OPS.curveTo,
	      numArgs: 6,
	      variableArgs: false
	    };
	    t['v'] = {
	      id: OPS.curveTo2,
	      numArgs: 4,
	      variableArgs: false
	    };
	    t['y'] = {
	      id: OPS.curveTo3,
	      numArgs: 4,
	      variableArgs: false
	    };
	    t['h'] = {
	      id: OPS.closePath,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['re'] = {
	      id: OPS.rectangle,
	      numArgs: 4,
	      variableArgs: false
	    };
	    t['S'] = {
	      id: OPS.stroke,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['s'] = {
	      id: OPS.closeStroke,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['f'] = {
	      id: OPS.fill,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['F'] = {
	      id: OPS.fill,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['f*'] = {
	      id: OPS.eoFill,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['B'] = {
	      id: OPS.fillStroke,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['B*'] = {
	      id: OPS.eoFillStroke,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['b'] = {
	      id: OPS.closeFillStroke,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['b*'] = {
	      id: OPS.closeEOFillStroke,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['n'] = {
	      id: OPS.endPath,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['W'] = {
	      id: OPS.clip,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['W*'] = {
	      id: OPS.eoClip,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['BT'] = {
	      id: OPS.beginText,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['ET'] = {
	      id: OPS.endText,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['Tc'] = {
	      id: OPS.setCharSpacing,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['Tw'] = {
	      id: OPS.setWordSpacing,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['Tz'] = {
	      id: OPS.setHScale,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['TL'] = {
	      id: OPS.setLeading,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['Tf'] = {
	      id: OPS.setFont,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['Tr'] = {
	      id: OPS.setTextRenderingMode,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['Ts'] = {
	      id: OPS.setTextRise,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['Td'] = {
	      id: OPS.moveText,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['TD'] = {
	      id: OPS.setLeadingMoveText,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['Tm'] = {
	      id: OPS.setTextMatrix,
	      numArgs: 6,
	      variableArgs: false
	    };
	    t['T*'] = {
	      id: OPS.nextLine,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['Tj'] = {
	      id: OPS.showText,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['TJ'] = {
	      id: OPS.showSpacedText,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['\''] = {
	      id: OPS.nextLineShowText,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['"'] = {
	      id: OPS.nextLineSetSpacingShowText,
	      numArgs: 3,
	      variableArgs: false
	    };
	    t['d0'] = {
	      id: OPS.setCharWidth,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['d1'] = {
	      id: OPS.setCharWidthAndBounds,
	      numArgs: 6,
	      variableArgs: false
	    };
	    t['CS'] = {
	      id: OPS.setStrokeColorSpace,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['cs'] = {
	      id: OPS.setFillColorSpace,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['SC'] = {
	      id: OPS.setStrokeColor,
	      numArgs: 4,
	      variableArgs: true
	    };
	    t['SCN'] = {
	      id: OPS.setStrokeColorN,
	      numArgs: 33,
	      variableArgs: true
	    };
	    t['sc'] = {
	      id: OPS.setFillColor,
	      numArgs: 4,
	      variableArgs: true
	    };
	    t['scn'] = {
	      id: OPS.setFillColorN,
	      numArgs: 33,
	      variableArgs: true
	    };
	    t['G'] = {
	      id: OPS.setStrokeGray,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['g'] = {
	      id: OPS.setFillGray,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['RG'] = {
	      id: OPS.setStrokeRGBColor,
	      numArgs: 3,
	      variableArgs: false
	    };
	    t['rg'] = {
	      id: OPS.setFillRGBColor,
	      numArgs: 3,
	      variableArgs: false
	    };
	    t['K'] = {
	      id: OPS.setStrokeCMYKColor,
	      numArgs: 4,
	      variableArgs: false
	    };
	    t['k'] = {
	      id: OPS.setFillCMYKColor,
	      numArgs: 4,
	      variableArgs: false
	    };
	    t['sh'] = {
	      id: OPS.shadingFill,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['BI'] = {
	      id: OPS.beginInlineImage,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['ID'] = {
	      id: OPS.beginImageData,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['EI'] = {
	      id: OPS.endInlineImage,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['Do'] = {
	      id: OPS.paintXObject,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['MP'] = {
	      id: OPS.markPoint,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['DP'] = {
	      id: OPS.markPointProps,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['BMC'] = {
	      id: OPS.beginMarkedContent,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['BDC'] = {
	      id: OPS.beginMarkedContentProps,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['EMC'] = {
	      id: OPS.endMarkedContent,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['BX'] = {
	      id: OPS.beginCompat,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['EX'] = {
	      id: OPS.endCompat,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['BM'] = null;
	    t['BD'] = null;
	    t['true'] = null;
	    t['fa'] = null;
	    t['fal'] = null;
	    t['fals'] = null;
	    t['false'] = null;
	    t['nu'] = null;
	    t['nul'] = null;
	    t['null'] = null;
	  });
	  function EvaluatorPreprocessor(stream, xref, stateManager) {
	    this.opMap = getOPMap();
	    this.parser = new Parser(new Lexer(stream, this.opMap), false, xref);
	    this.stateManager = stateManager;
	    this.nonProcessedArgs = [];
	  }
	  EvaluatorPreprocessor.prototype = {
	    get savedStatesDepth() {
	      return this.stateManager.stateStack.length;
	    },
	    read: function EvaluatorPreprocessor_read(operation) {
	      var args = operation.args;
	      while (true) {
	        var obj = this.parser.getObj();
	        if (isCmd(obj)) {
	          var cmd = obj.cmd;
	          var opSpec = this.opMap[cmd];
	          if (!opSpec) {
	            warn('Unknown command "' + cmd + '"');
	            continue;
	          }
	          var fn = opSpec.id;
	          var numArgs = opSpec.numArgs;
	          var argsLength = args !== null ? args.length : 0;
	          if (!opSpec.variableArgs) {
	            if (argsLength !== numArgs) {
	              var nonProcessedArgs = this.nonProcessedArgs;
	              while (argsLength > numArgs) {
	                nonProcessedArgs.push(args.shift());
	                argsLength--;
	              }
	              while (argsLength < numArgs && nonProcessedArgs.length !== 0) {
	                if (args === null) {
	                  args = [];
	                }
	                args.unshift(nonProcessedArgs.pop());
	                argsLength++;
	              }
	            }
	            if (argsLength < numArgs) {
	              warn('Skipping command ' + fn + ': expected ' + numArgs + ' args, but received ' + argsLength + ' args.');
	              if (args !== null) {
	                args.length = 0;
	              }
	              continue;
	            }
	          } else if (argsLength > numArgs) {
	            info('Command ' + fn + ': expected [0,' + numArgs + '] args, but received ' + argsLength + ' args.');
	          }
	          this.preprocessCommand(fn, args);
	          operation.fn = fn;
	          operation.args = args;
	          return true;
	        }
	        if (isEOF(obj)) {
	          return false;
	        }
	        if (obj !== null) {
	          if (args === null) {
	            args = [];
	          }
	          args.push(obj);
	          assert(args.length <= 33, 'Too many arguments');
	        }
	      }
	    },
	    preprocessCommand: function EvaluatorPreprocessor_preprocessCommand(fn, args) {
	      switch (fn | 0) {
	        case OPS.save:
	          this.stateManager.save();
	          break;
	        case OPS.restore:
	          this.stateManager.restore();
	          break;
	        case OPS.transform:
	          this.stateManager.transform(args);
	          break;
	      }
	    }
	  };
	  return EvaluatorPreprocessor;
	}();
	var QueueOptimizer = function QueueOptimizerClosure() {
	  function addState(parentState, pattern, fn) {
	    var state = parentState;
	    for (var i = 0, ii = pattern.length - 1; i < ii; i++) {
	      var item = pattern[i];
	      state = state[item] || (state[item] = []);
	    }
	    state[pattern[pattern.length - 1]] = fn;
	  }
	  function handlePaintSolidColorImageMask(iFirstSave, count, fnArray, argsArray) {
	    var iFirstPIMXO = iFirstSave + 2;
	    for (var i = 0; i < count; i++) {
	      var arg = argsArray[iFirstPIMXO + 4 * i];
	      var imageMask = arg.length === 1 && arg[0];
	      if (imageMask && imageMask.width === 1 && imageMask.height === 1 && (!imageMask.data.length || imageMask.data.length === 1 && imageMask.data[0] === 0)) {
	        fnArray[iFirstPIMXO + 4 * i] = OPS.paintSolidColorImageMask;
	        continue;
	      }
	      break;
	    }
	    return count - i;
	  }
	  var InitialState = [];
	  addState(InitialState, [OPS.save, OPS.transform, OPS.paintInlineImageXObject, OPS.restore], function foundInlineImageGroup(context) {
	    var MIN_IMAGES_IN_INLINE_IMAGES_BLOCK = 10;
	    var MAX_IMAGES_IN_INLINE_IMAGES_BLOCK = 200;
	    var MAX_WIDTH = 1000;
	    var IMAGE_PADDING = 1;
	    var fnArray = context.fnArray,
	        argsArray = context.argsArray;
	    var curr = context.iCurr;
	    var iFirstSave = curr - 3;
	    var iFirstTransform = curr - 2;
	    var iFirstPIIXO = curr - 1;
	    var i = iFirstSave + 4;
	    var ii = fnArray.length;
	    while (i + 3 < ii) {
	      if (fnArray[i] !== OPS.save || fnArray[i + 1] !== OPS.transform || fnArray[i + 2] !== OPS.paintInlineImageXObject || fnArray[i + 3] !== OPS.restore) {
	        break;
	      }
	      i += 4;
	    }
	    var count = Math.min((i - iFirstSave) / 4, MAX_IMAGES_IN_INLINE_IMAGES_BLOCK);
	    if (count < MIN_IMAGES_IN_INLINE_IMAGES_BLOCK) {
	      return i;
	    }
	    var maxX = 0;
	    var map = [],
	        maxLineHeight = 0;
	    var currentX = IMAGE_PADDING,
	        currentY = IMAGE_PADDING;
	    var q;
	    for (q = 0; q < count; q++) {
	      var transform = argsArray[iFirstTransform + (q << 2)];
	      var img = argsArray[iFirstPIIXO + (q << 2)][0];
	      if (currentX + img.width > MAX_WIDTH) {
	        maxX = Math.max(maxX, currentX);
	        currentY += maxLineHeight + 2 * IMAGE_PADDING;
	        currentX = 0;
	        maxLineHeight = 0;
	      }
	      map.push({
	        transform: transform,
	        x: currentX,
	        y: currentY,
	        w: img.width,
	        h: img.height
	      });
	      currentX += img.width + 2 * IMAGE_PADDING;
	      maxLineHeight = Math.max(maxLineHeight, img.height);
	    }
	    var imgWidth = Math.max(maxX, currentX) + IMAGE_PADDING;
	    var imgHeight = currentY + maxLineHeight + IMAGE_PADDING;
	    var imgData = new Uint8Array(imgWidth * imgHeight * 4);
	    var imgRowSize = imgWidth << 2;
	    for (q = 0; q < count; q++) {
	      var data = argsArray[iFirstPIIXO + (q << 2)][0].data;
	      var rowSize = map[q].w << 2;
	      var dataOffset = 0;
	      var offset = map[q].x + map[q].y * imgWidth << 2;
	      imgData.set(data.subarray(0, rowSize), offset - imgRowSize);
	      for (var k = 0, kk = map[q].h; k < kk; k++) {
	        imgData.set(data.subarray(dataOffset, dataOffset + rowSize), offset);
	        dataOffset += rowSize;
	        offset += imgRowSize;
	      }
	      imgData.set(data.subarray(dataOffset - rowSize, dataOffset), offset);
	      while (offset >= 0) {
	        data[offset - 4] = data[offset];
	        data[offset - 3] = data[offset + 1];
	        data[offset - 2] = data[offset + 2];
	        data[offset - 1] = data[offset + 3];
	        data[offset + rowSize] = data[offset + rowSize - 4];
	        data[offset + rowSize + 1] = data[offset + rowSize - 3];
	        data[offset + rowSize + 2] = data[offset + rowSize - 2];
	        data[offset + rowSize + 3] = data[offset + rowSize - 1];
	        offset -= imgRowSize;
	      }
	    }
	    fnArray.splice(iFirstSave, count * 4, OPS.paintInlineImageXObjectGroup);
	    argsArray.splice(iFirstSave, count * 4, [{
	      width: imgWidth,
	      height: imgHeight,
	      kind: ImageKind.RGBA_32BPP,
	      data: imgData
	    }, map]);
	    return iFirstSave + 1;
	  });
	  addState(InitialState, [OPS.save, OPS.transform, OPS.paintImageMaskXObject, OPS.restore], function foundImageMaskGroup(context) {
	    var MIN_IMAGES_IN_MASKS_BLOCK = 10;
	    var MAX_IMAGES_IN_MASKS_BLOCK = 100;
	    var MAX_SAME_IMAGES_IN_MASKS_BLOCK = 1000;
	    var fnArray = context.fnArray,
	        argsArray = context.argsArray;
	    var curr = context.iCurr;
	    var iFirstSave = curr - 3;
	    var iFirstTransform = curr - 2;
	    var iFirstPIMXO = curr - 1;
	    var i = iFirstSave + 4;
	    var ii = fnArray.length;
	    while (i + 3 < ii) {
	      if (fnArray[i] !== OPS.save || fnArray[i + 1] !== OPS.transform || fnArray[i + 2] !== OPS.paintImageMaskXObject || fnArray[i + 3] !== OPS.restore) {
	        break;
	      }
	      i += 4;
	    }
	    var count = (i - iFirstSave) / 4;
	    count = handlePaintSolidColorImageMask(iFirstSave, count, fnArray, argsArray);
	    if (count < MIN_IMAGES_IN_MASKS_BLOCK) {
	      return i;
	    }
	    var q;
	    var isSameImage = false;
	    var iTransform, transformArgs;
	    var firstPIMXOArg0 = argsArray[iFirstPIMXO][0];
	    if (argsArray[iFirstTransform][1] === 0 && argsArray[iFirstTransform][2] === 0) {
	      isSameImage = true;
	      var firstTransformArg0 = argsArray[iFirstTransform][0];
	      var firstTransformArg3 = argsArray[iFirstTransform][3];
	      iTransform = iFirstTransform + 4;
	      var iPIMXO = iFirstPIMXO + 4;
	      for (q = 1; q < count; q++, iTransform += 4, iPIMXO += 4) {
	        transformArgs = argsArray[iTransform];
	        if (argsArray[iPIMXO][0] !== firstPIMXOArg0 || transformArgs[0] !== firstTransformArg0 || transformArgs[1] !== 0 || transformArgs[2] !== 0 || transformArgs[3] !== firstTransformArg3) {
	          if (q < MIN_IMAGES_IN_MASKS_BLOCK) {
	            isSameImage = false;
	          } else {
	            count = q;
	          }
	          break;
	        }
	      }
	    }
	    if (isSameImage) {
	      count = Math.min(count, MAX_SAME_IMAGES_IN_MASKS_BLOCK);
	      var positions = new Float32Array(count * 2);
	      iTransform = iFirstTransform;
	      for (q = 0; q < count; q++, iTransform += 4) {
	        transformArgs = argsArray[iTransform];
	        positions[q << 1] = transformArgs[4];
	        positions[(q << 1) + 1] = transformArgs[5];
	      }
	      fnArray.splice(iFirstSave, count * 4, OPS.paintImageMaskXObjectRepeat);
	      argsArray.splice(iFirstSave, count * 4, [firstPIMXOArg0, firstTransformArg0, firstTransformArg3, positions]);
	    } else {
	      count = Math.min(count, MAX_IMAGES_IN_MASKS_BLOCK);
	      var images = [];
	      for (q = 0; q < count; q++) {
	        transformArgs = argsArray[iFirstTransform + (q << 2)];
	        var maskParams = argsArray[iFirstPIMXO + (q << 2)][0];
	        images.push({
	          data: maskParams.data,
	          width: maskParams.width,
	          height: maskParams.height,
	          transform: transformArgs
	        });
	      }
	      fnArray.splice(iFirstSave, count * 4, OPS.paintImageMaskXObjectGroup);
	      argsArray.splice(iFirstSave, count * 4, [images]);
	    }
	    return iFirstSave + 1;
	  });
	  addState(InitialState, [OPS.save, OPS.transform, OPS.paintImageXObject, OPS.restore], function (context) {
	    var MIN_IMAGES_IN_BLOCK = 3;
	    var MAX_IMAGES_IN_BLOCK = 1000;
	    var fnArray = context.fnArray,
	        argsArray = context.argsArray;
	    var curr = context.iCurr;
	    var iFirstSave = curr - 3;
	    var iFirstTransform = curr - 2;
	    var iFirstPIXO = curr - 1;
	    var iFirstRestore = curr;
	    if (argsArray[iFirstTransform][1] !== 0 || argsArray[iFirstTransform][2] !== 0) {
	      return iFirstRestore + 1;
	    }
	    var firstPIXOArg0 = argsArray[iFirstPIXO][0];
	    var firstTransformArg0 = argsArray[iFirstTransform][0];
	    var firstTransformArg3 = argsArray[iFirstTransform][3];
	    var i = iFirstSave + 4;
	    var ii = fnArray.length;
	    while (i + 3 < ii) {
	      if (fnArray[i] !== OPS.save || fnArray[i + 1] !== OPS.transform || fnArray[i + 2] !== OPS.paintImageXObject || fnArray[i + 3] !== OPS.restore) {
	        break;
	      }
	      if (argsArray[i + 1][0] !== firstTransformArg0 || argsArray[i + 1][1] !== 0 || argsArray[i + 1][2] !== 0 || argsArray[i + 1][3] !== firstTransformArg3) {
	        break;
	      }
	      if (argsArray[i + 2][0] !== firstPIXOArg0) {
	        break;
	      }
	      i += 4;
	    }
	    var count = Math.min((i - iFirstSave) / 4, MAX_IMAGES_IN_BLOCK);
	    if (count < MIN_IMAGES_IN_BLOCK) {
	      return i;
	    }
	    var positions = new Float32Array(count * 2);
	    var iTransform = iFirstTransform;
	    for (var q = 0; q < count; q++, iTransform += 4) {
	      var transformArgs = argsArray[iTransform];
	      positions[q << 1] = transformArgs[4];
	      positions[(q << 1) + 1] = transformArgs[5];
	    }
	    var args = [firstPIXOArg0, firstTransformArg0, firstTransformArg3, positions];
	    fnArray.splice(iFirstSave, count * 4, OPS.paintImageXObjectRepeat);
	    argsArray.splice(iFirstSave, count * 4, args);
	    return iFirstSave + 1;
	  });
	  addState(InitialState, [OPS.beginText, OPS.setFont, OPS.setTextMatrix, OPS.showText, OPS.endText], function (context) {
	    var MIN_CHARS_IN_BLOCK = 3;
	    var MAX_CHARS_IN_BLOCK = 1000;
	    var fnArray = context.fnArray,
	        argsArray = context.argsArray;
	    var curr = context.iCurr;
	    var iFirstBeginText = curr - 4;
	    var iFirstSetFont = curr - 3;
	    var iFirstSetTextMatrix = curr - 2;
	    var iFirstShowText = curr - 1;
	    var iFirstEndText = curr;
	    var firstSetFontArg0 = argsArray[iFirstSetFont][0];
	    var firstSetFontArg1 = argsArray[iFirstSetFont][1];
	    var i = iFirstBeginText + 5;
	    var ii = fnArray.length;
	    while (i + 4 < ii) {
	      if (fnArray[i] !== OPS.beginText || fnArray[i + 1] !== OPS.setFont || fnArray[i + 2] !== OPS.setTextMatrix || fnArray[i + 3] !== OPS.showText || fnArray[i + 4] !== OPS.endText) {
	        break;
	      }
	      if (argsArray[i + 1][0] !== firstSetFontArg0 || argsArray[i + 1][1] !== firstSetFontArg1) {
	        break;
	      }
	      i += 5;
	    }
	    var count = Math.min((i - iFirstBeginText) / 5, MAX_CHARS_IN_BLOCK);
	    if (count < MIN_CHARS_IN_BLOCK) {
	      return i;
	    }
	    var iFirst = iFirstBeginText;
	    if (iFirstBeginText >= 4 && fnArray[iFirstBeginText - 4] === fnArray[iFirstSetFont] && fnArray[iFirstBeginText - 3] === fnArray[iFirstSetTextMatrix] && fnArray[iFirstBeginText - 2] === fnArray[iFirstShowText] && fnArray[iFirstBeginText - 1] === fnArray[iFirstEndText] && argsArray[iFirstBeginText - 4][0] === firstSetFontArg0 && argsArray[iFirstBeginText - 4][1] === firstSetFontArg1) {
	      count++;
	      iFirst -= 5;
	    }
	    var iEndText = iFirst + 4;
	    for (var q = 1; q < count; q++) {
	      fnArray.splice(iEndText, 3);
	      argsArray.splice(iEndText, 3);
	      iEndText += 2;
	    }
	    return iEndText + 1;
	  });
	  function QueueOptimizer() {}
	  QueueOptimizer.prototype = {
	    optimize: function QueueOptimizer_optimize(queue) {
	      var fnArray = queue.fnArray,
	          argsArray = queue.argsArray;
	      var context = {
	        iCurr: 0,
	        fnArray: fnArray,
	        argsArray: argsArray
	      };
	      var state;
	      var i = 0,
	          ii = fnArray.length;
	      while (i < ii) {
	        state = (state || InitialState)[fnArray[i]];
	        if (typeof state === 'function') {
	          context.iCurr = i;
	          i = state(context);
	          state = undefined;
	          ii = context.fnArray.length;
	        } else {
	          i++;
	        }
	      }
	    }
	  };
	  return QueueOptimizer;
	}();
	exports.OperatorList = OperatorList;
	exports.PartialEvaluator = PartialEvaluator;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var coreArithmeticDecoder = __w_pdfjs_require__(10);
	var info = sharedUtil.info;
	var warn = sharedUtil.warn;
	var error = sharedUtil.error;
	var log2 = sharedUtil.log2;
	var readUint16 = sharedUtil.readUint16;
	var readUint32 = sharedUtil.readUint32;
	var ArithmeticDecoder = coreArithmeticDecoder.ArithmeticDecoder;
	var JpxImage = function JpxImageClosure() {
	  var SubbandsGainLog2 = {
	    'LL': 0,
	    'LH': 1,
	    'HL': 1,
	    'HH': 2
	  };
	  function JpxImage() {
	    this.failOnCorruptedImage = false;
	  }
	  JpxImage.prototype = {
	    parse: function JpxImage_parse(data) {
	      var head = readUint16(data, 0);
	      if (head === 0xFF4F) {
	        this.parseCodestream(data, 0, data.length);
	        return;
	      }
	      var position = 0,
	          length = data.length;
	      while (position < length) {
	        var headerSize = 8;
	        var lbox = readUint32(data, position);
	        var tbox = readUint32(data, position + 4);
	        position += headerSize;
	        if (lbox === 1) {
	          lbox = readUint32(data, position) * 4294967296 + readUint32(data, position + 4);
	          position += 8;
	          headerSize += 8;
	        }
	        if (lbox === 0) {
	          lbox = length - position + headerSize;
	        }
	        if (lbox < headerSize) {
	          error('JPX Error: Invalid box field size');
	        }
	        var dataLength = lbox - headerSize;
	        var jumpDataLength = true;
	        switch (tbox) {
	          case 0x6A703268:
	            jumpDataLength = false;
	            break;
	          case 0x636F6C72:
	            var method = data[position];
	            if (method === 1) {
	              var colorspace = readUint32(data, position + 3);
	              switch (colorspace) {
	                case 16:
	                case 17:
	                case 18:
	                  break;
	                default:
	                  warn('Unknown colorspace ' + colorspace);
	                  break;
	              }
	            } else if (method === 2) {
	              info('ICC profile not supported');
	            }
	            break;
	          case 0x6A703263:
	            this.parseCodestream(data, position, position + dataLength);
	            break;
	          case 0x6A502020:
	            if (readUint32(data, position) !== 0x0d0a870a) {
	              warn('Invalid JP2 signature');
	            }
	            break;
	          case 0x6A501A1A:
	          case 0x66747970:
	          case 0x72726571:
	          case 0x72657320:
	          case 0x69686472:
	            break;
	          default:
	            var headerType = String.fromCharCode(tbox >> 24 & 0xFF, tbox >> 16 & 0xFF, tbox >> 8 & 0xFF, tbox & 0xFF);
	            warn('Unsupported header type ' + tbox + ' (' + headerType + ')');
	            break;
	        }
	        if (jumpDataLength) {
	          position += dataLength;
	        }
	      }
	    },
	    parseImageProperties: function JpxImage_parseImageProperties(stream) {
	      var newByte = stream.getByte();
	      while (newByte >= 0) {
	        var oldByte = newByte;
	        newByte = stream.getByte();
	        var code = oldByte << 8 | newByte;
	        if (code === 0xFF51) {
	          stream.skip(4);
	          var Xsiz = stream.getInt32() >>> 0;
	          var Ysiz = stream.getInt32() >>> 0;
	          var XOsiz = stream.getInt32() >>> 0;
	          var YOsiz = stream.getInt32() >>> 0;
	          stream.skip(16);
	          var Csiz = stream.getUint16();
	          this.width = Xsiz - XOsiz;
	          this.height = Ysiz - YOsiz;
	          this.componentsCount = Csiz;
	          this.bitsPerComponent = 8;
	          return;
	        }
	      }
	      error('JPX Error: No size marker found in JPX stream');
	    },
	    parseCodestream: function JpxImage_parseCodestream(data, start, end) {
	      var context = {};
	      var doNotRecover = false;
	      try {
	        var position = start;
	        while (position + 1 < end) {
	          var code = readUint16(data, position);
	          position += 2;
	          var length = 0,
	              j,
	              sqcd,
	              spqcds,
	              spqcdSize,
	              scalarExpounded,
	              tile;
	          switch (code) {
	            case 0xFF4F:
	              context.mainHeader = true;
	              break;
	            case 0xFFD9:
	              break;
	            case 0xFF51:
	              length = readUint16(data, position);
	              var siz = {};
	              siz.Xsiz = readUint32(data, position + 4);
	              siz.Ysiz = readUint32(data, position + 8);
	              siz.XOsiz = readUint32(data, position + 12);
	              siz.YOsiz = readUint32(data, position + 16);
	              siz.XTsiz = readUint32(data, position + 20);
	              siz.YTsiz = readUint32(data, position + 24);
	              siz.XTOsiz = readUint32(data, position + 28);
	              siz.YTOsiz = readUint32(data, position + 32);
	              var componentsCount = readUint16(data, position + 36);
	              siz.Csiz = componentsCount;
	              var components = [];
	              j = position + 38;
	              for (var i = 0; i < componentsCount; i++) {
	                var component = {
	                  precision: (data[j] & 0x7F) + 1,
	                  isSigned: !!(data[j] & 0x80),
	                  XRsiz: data[j + 1],
	                  YRsiz: data[j + 1]
	                };
	                calculateComponentDimensions(component, siz);
	                components.push(component);
	              }
	              context.SIZ = siz;
	              context.components = components;
	              calculateTileGrids(context, components);
	              context.QCC = [];
	              context.COC = [];
	              break;
	            case 0xFF5C:
	              length = readUint16(data, position);
	              var qcd = {};
	              j = position + 2;
	              sqcd = data[j++];
	              switch (sqcd & 0x1F) {
	                case 0:
	                  spqcdSize = 8;
	                  scalarExpounded = true;
	                  break;
	                case 1:
	                  spqcdSize = 16;
	                  scalarExpounded = false;
	                  break;
	                case 2:
	                  spqcdSize = 16;
	                  scalarExpounded = true;
	                  break;
	                default:
	                  throw new Error('Invalid SQcd value ' + sqcd);
	              }
	              qcd.noQuantization = spqcdSize === 8;
	              qcd.scalarExpounded = scalarExpounded;
	              qcd.guardBits = sqcd >> 5;
	              spqcds = [];
	              while (j < length + position) {
	                var spqcd = {};
	                if (spqcdSize === 8) {
	                  spqcd.epsilon = data[j++] >> 3;
	                  spqcd.mu = 0;
	                } else {
	                  spqcd.epsilon = data[j] >> 3;
	                  spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
	                  j += 2;
	                }
	                spqcds.push(spqcd);
	              }
	              qcd.SPqcds = spqcds;
	              if (context.mainHeader) {
	                context.QCD = qcd;
	              } else {
	                context.currentTile.QCD = qcd;
	                context.currentTile.QCC = [];
	              }
	              break;
	            case 0xFF5D:
	              length = readUint16(data, position);
	              var qcc = {};
	              j = position + 2;
	              var cqcc;
	              if (context.SIZ.Csiz < 257) {
	                cqcc = data[j++];
	              } else {
	                cqcc = readUint16(data, j);
	                j += 2;
	              }
	              sqcd = data[j++];
	              switch (sqcd & 0x1F) {
	                case 0:
	                  spqcdSize = 8;
	                  scalarExpounded = true;
	                  break;
	                case 1:
	                  spqcdSize = 16;
	                  scalarExpounded = false;
	                  break;
	                case 2:
	                  spqcdSize = 16;
	                  scalarExpounded = true;
	                  break;
	                default:
	                  throw new Error('Invalid SQcd value ' + sqcd);
	              }
	              qcc.noQuantization = spqcdSize === 8;
	              qcc.scalarExpounded = scalarExpounded;
	              qcc.guardBits = sqcd >> 5;
	              spqcds = [];
	              while (j < length + position) {
	                spqcd = {};
	                if (spqcdSize === 8) {
	                  spqcd.epsilon = data[j++] >> 3;
	                  spqcd.mu = 0;
	                } else {
	                  spqcd.epsilon = data[j] >> 3;
	                  spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
	                  j += 2;
	                }
	                spqcds.push(spqcd);
	              }
	              qcc.SPqcds = spqcds;
	              if (context.mainHeader) {
	                context.QCC[cqcc] = qcc;
	              } else {
	                context.currentTile.QCC[cqcc] = qcc;
	              }
	              break;
	            case 0xFF52:
	              length = readUint16(data, position);
	              var cod = {};
	              j = position + 2;
	              var scod = data[j++];
	              cod.entropyCoderWithCustomPrecincts = !!(scod & 1);
	              cod.sopMarkerUsed = !!(scod & 2);
	              cod.ephMarkerUsed = !!(scod & 4);
	              cod.progressionOrder = data[j++];
	              cod.layersCount = readUint16(data, j);
	              j += 2;
	              cod.multipleComponentTransform = data[j++];
	              cod.decompositionLevelsCount = data[j++];
	              cod.xcb = (data[j++] & 0xF) + 2;
	              cod.ycb = (data[j++] & 0xF) + 2;
	              var blockStyle = data[j++];
	              cod.selectiveArithmeticCodingBypass = !!(blockStyle & 1);
	              cod.resetContextProbabilities = !!(blockStyle & 2);
	              cod.terminationOnEachCodingPass = !!(blockStyle & 4);
	              cod.verticalyStripe = !!(blockStyle & 8);
	              cod.predictableTermination = !!(blockStyle & 16);
	              cod.segmentationSymbolUsed = !!(blockStyle & 32);
	              cod.reversibleTransformation = data[j++];
	              if (cod.entropyCoderWithCustomPrecincts) {
	                var precinctsSizes = [];
	                while (j < length + position) {
	                  var precinctsSize = data[j++];
	                  precinctsSizes.push({
	                    PPx: precinctsSize & 0xF,
	                    PPy: precinctsSize >> 4
	                  });
	                }
	                cod.precinctsSizes = precinctsSizes;
	              }
	              var unsupported = [];
	              if (cod.selectiveArithmeticCodingBypass) {
	                unsupported.push('selectiveArithmeticCodingBypass');
	              }
	              if (cod.resetContextProbabilities) {
	                unsupported.push('resetContextProbabilities');
	              }
	              if (cod.terminationOnEachCodingPass) {
	                unsupported.push('terminationOnEachCodingPass');
	              }
	              if (cod.verticalyStripe) {
	                unsupported.push('verticalyStripe');
	              }
	              if (cod.predictableTermination) {
	                unsupported.push('predictableTermination');
	              }
	              if (unsupported.length > 0) {
	                doNotRecover = true;
	                throw new Error('Unsupported COD options (' + unsupported.join(', ') + ')');
	              }
	              if (context.mainHeader) {
	                context.COD = cod;
	              } else {
	                context.currentTile.COD = cod;
	                context.currentTile.COC = [];
	              }
	              break;
	            case 0xFF90:
	              length = readUint16(data, position);
	              tile = {};
	              tile.index = readUint16(data, position + 2);
	              tile.length = readUint32(data, position + 4);
	              tile.dataEnd = tile.length + position - 2;
	              tile.partIndex = data[position + 8];
	              tile.partsCount = data[position + 9];
	              context.mainHeader = false;
	              if (tile.partIndex === 0) {
	                tile.COD = context.COD;
	                tile.COC = context.COC.slice(0);
	                tile.QCD = context.QCD;
	                tile.QCC = context.QCC.slice(0);
	              }
	              context.currentTile = tile;
	              break;
	            case 0xFF93:
	              tile = context.currentTile;
	              if (tile.partIndex === 0) {
	                initializeTile(context, tile.index);
	                buildPackets(context);
	              }
	              length = tile.dataEnd - position;
	              parseTilePackets(context, data, position, length);
	              break;
	            case 0xFF55:
	            case 0xFF57:
	            case 0xFF58:
	            case 0xFF64:
	              length = readUint16(data, position);
	              break;
	            case 0xFF53:
	              throw new Error('Codestream code 0xFF53 (COC) is ' + 'not implemented');
	            default:
	              throw new Error('Unknown codestream code: ' + code.toString(16));
	          }
	          position += length;
	        }
	      } catch (e) {
	        if (doNotRecover || this.failOnCorruptedImage) {
	          error('JPX Error: ' + e.message);
	        } else {
	          warn('JPX: Trying to recover from: ' + e.message);
	        }
	      }
	      this.tiles = transformComponents(context);
	      this.width = context.SIZ.Xsiz - context.SIZ.XOsiz;
	      this.height = context.SIZ.Ysiz - context.SIZ.YOsiz;
	      this.componentsCount = context.SIZ.Csiz;
	    }
	  };
	  function calculateComponentDimensions(component, siz) {
	    component.x0 = Math.ceil(siz.XOsiz / component.XRsiz);
	    component.x1 = Math.ceil(siz.Xsiz / component.XRsiz);
	    component.y0 = Math.ceil(siz.YOsiz / component.YRsiz);
	    component.y1 = Math.ceil(siz.Ysiz / component.YRsiz);
	    component.width = component.x1 - component.x0;
	    component.height = component.y1 - component.y0;
	  }
	  function calculateTileGrids(context, components) {
	    var siz = context.SIZ;
	    var tile,
	        tiles = [];
	    var numXtiles = Math.ceil((siz.Xsiz - siz.XTOsiz) / siz.XTsiz);
	    var numYtiles = Math.ceil((siz.Ysiz - siz.YTOsiz) / siz.YTsiz);
	    for (var q = 0; q < numYtiles; q++) {
	      for (var p = 0; p < numXtiles; p++) {
	        tile = {};
	        tile.tx0 = Math.max(siz.XTOsiz + p * siz.XTsiz, siz.XOsiz);
	        tile.ty0 = Math.max(siz.YTOsiz + q * siz.YTsiz, siz.YOsiz);
	        tile.tx1 = Math.min(siz.XTOsiz + (p + 1) * siz.XTsiz, siz.Xsiz);
	        tile.ty1 = Math.min(siz.YTOsiz + (q + 1) * siz.YTsiz, siz.Ysiz);
	        tile.width = tile.tx1 - tile.tx0;
	        tile.height = tile.ty1 - tile.ty0;
	        tile.components = [];
	        tiles.push(tile);
	      }
	    }
	    context.tiles = tiles;
	    var componentsCount = siz.Csiz;
	    for (var i = 0, ii = componentsCount; i < ii; i++) {
	      var component = components[i];
	      for (var j = 0, jj = tiles.length; j < jj; j++) {
	        var tileComponent = {};
	        tile = tiles[j];
	        tileComponent.tcx0 = Math.ceil(tile.tx0 / component.XRsiz);
	        tileComponent.tcy0 = Math.ceil(tile.ty0 / component.YRsiz);
	        tileComponent.tcx1 = Math.ceil(tile.tx1 / component.XRsiz);
	        tileComponent.tcy1 = Math.ceil(tile.ty1 / component.YRsiz);
	        tileComponent.width = tileComponent.tcx1 - tileComponent.tcx0;
	        tileComponent.height = tileComponent.tcy1 - tileComponent.tcy0;
	        tile.components[i] = tileComponent;
	      }
	    }
	  }
	  function getBlocksDimensions(context, component, r) {
	    var codOrCoc = component.codingStyleParameters;
	    var result = {};
	    if (!codOrCoc.entropyCoderWithCustomPrecincts) {
	      result.PPx = 15;
	      result.PPy = 15;
	    } else {
	      result.PPx = codOrCoc.precinctsSizes[r].PPx;
	      result.PPy = codOrCoc.precinctsSizes[r].PPy;
	    }
	    result.xcb_ = r > 0 ? Math.min(codOrCoc.xcb, result.PPx - 1) : Math.min(codOrCoc.xcb, result.PPx);
	    result.ycb_ = r > 0 ? Math.min(codOrCoc.ycb, result.PPy - 1) : Math.min(codOrCoc.ycb, result.PPy);
	    return result;
	  }
	  function buildPrecincts(context, resolution, dimensions) {
	    var precinctWidth = 1 << dimensions.PPx;
	    var precinctHeight = 1 << dimensions.PPy;
	    var isZeroRes = resolution.resLevel === 0;
	    var precinctWidthInSubband = 1 << dimensions.PPx + (isZeroRes ? 0 : -1);
	    var precinctHeightInSubband = 1 << dimensions.PPy + (isZeroRes ? 0 : -1);
	    var numprecinctswide = resolution.trx1 > resolution.trx0 ? Math.ceil(resolution.trx1 / precinctWidth) - Math.floor(resolution.trx0 / precinctWidth) : 0;
	    var numprecinctshigh = resolution.try1 > resolution.try0 ? Math.ceil(resolution.try1 / precinctHeight) - Math.floor(resolution.try0 / precinctHeight) : 0;
	    var numprecincts = numprecinctswide * numprecinctshigh;
	    resolution.precinctParameters = {
	      precinctWidth: precinctWidth,
	      precinctHeight: precinctHeight,
	      numprecinctswide: numprecinctswide,
	      numprecinctshigh: numprecinctshigh,
	      numprecincts: numprecincts,
	      precinctWidthInSubband: precinctWidthInSubband,
	      precinctHeightInSubband: precinctHeightInSubband
	    };
	  }
	  function buildCodeblocks(context, subband, dimensions) {
	    var xcb_ = dimensions.xcb_;
	    var ycb_ = dimensions.ycb_;
	    var codeblockWidth = 1 << xcb_;
	    var codeblockHeight = 1 << ycb_;
	    var cbx0 = subband.tbx0 >> xcb_;
	    var cby0 = subband.tby0 >> ycb_;
	    var cbx1 = subband.tbx1 + codeblockWidth - 1 >> xcb_;
	    var cby1 = subband.tby1 + codeblockHeight - 1 >> ycb_;
	    var precinctParameters = subband.resolution.precinctParameters;
	    var codeblocks = [];
	    var precincts = [];
	    var i, j, codeblock, precinctNumber;
	    for (j = cby0; j < cby1; j++) {
	      for (i = cbx0; i < cbx1; i++) {
	        codeblock = {
	          cbx: i,
	          cby: j,
	          tbx0: codeblockWidth * i,
	          tby0: codeblockHeight * j,
	          tbx1: codeblockWidth * (i + 1),
	          tby1: codeblockHeight * (j + 1)
	        };
	        codeblock.tbx0_ = Math.max(subband.tbx0, codeblock.tbx0);
	        codeblock.tby0_ = Math.max(subband.tby0, codeblock.tby0);
	        codeblock.tbx1_ = Math.min(subband.tbx1, codeblock.tbx1);
	        codeblock.tby1_ = Math.min(subband.tby1, codeblock.tby1);
	        var pi = Math.floor((codeblock.tbx0_ - subband.tbx0) / precinctParameters.precinctWidthInSubband);
	        var pj = Math.floor((codeblock.tby0_ - subband.tby0) / precinctParameters.precinctHeightInSubband);
	        precinctNumber = pi + pj * precinctParameters.numprecinctswide;
	        codeblock.precinctNumber = precinctNumber;
	        codeblock.subbandType = subband.type;
	        codeblock.Lblock = 3;
	        if (codeblock.tbx1_ <= codeblock.tbx0_ || codeblock.tby1_ <= codeblock.tby0_) {
	          continue;
	        }
	        codeblocks.push(codeblock);
	        var precinct = precincts[precinctNumber];
	        if (precinct !== undefined) {
	          if (i < precinct.cbxMin) {
	            precinct.cbxMin = i;
	          } else if (i > precinct.cbxMax) {
	            precinct.cbxMax = i;
	          }
	          if (j < precinct.cbyMin) {
	            precinct.cbxMin = j;
	          } else if (j > precinct.cbyMax) {
	            precinct.cbyMax = j;
	          }
	        } else {
	          precincts[precinctNumber] = precinct = {
	            cbxMin: i,
	            cbyMin: j,
	            cbxMax: i,
	            cbyMax: j
	          };
	        }
	        codeblock.precinct = precinct;
	      }
	    }
	    subband.codeblockParameters = {
	      codeblockWidth: xcb_,
	      codeblockHeight: ycb_,
	      numcodeblockwide: cbx1 - cbx0 + 1,
	      numcodeblockhigh: cby1 - cby0 + 1
	    };
	    subband.codeblocks = codeblocks;
	    subband.precincts = precincts;
	  }
	  function createPacket(resolution, precinctNumber, layerNumber) {
	    var precinctCodeblocks = [];
	    var subbands = resolution.subbands;
	    for (var i = 0, ii = subbands.length; i < ii; i++) {
	      var subband = subbands[i];
	      var codeblocks = subband.codeblocks;
	      for (var j = 0, jj = codeblocks.length; j < jj; j++) {
	        var codeblock = codeblocks[j];
	        if (codeblock.precinctNumber !== precinctNumber) {
	          continue;
	        }
	        precinctCodeblocks.push(codeblock);
	      }
	    }
	    return {
	      layerNumber: layerNumber,
	      codeblocks: precinctCodeblocks
	    };
	  }
	  function LayerResolutionComponentPositionIterator(context) {
	    var siz = context.SIZ;
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var layersCount = tile.codingStyleDefaultParameters.layersCount;
	    var componentsCount = siz.Csiz;
	    var maxDecompositionLevelsCount = 0;
	    for (var q = 0; q < componentsCount; q++) {
	      maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
	    }
	    var l = 0,
	        r = 0,
	        i = 0,
	        k = 0;
	    this.nextPacket = function JpxImage_nextPacket() {
	      for (; l < layersCount; l++) {
	        for (; r <= maxDecompositionLevelsCount; r++) {
	          for (; i < componentsCount; i++) {
	            var component = tile.components[i];
	            if (r > component.codingStyleParameters.decompositionLevelsCount) {
	              continue;
	            }
	            var resolution = component.resolutions[r];
	            var numprecincts = resolution.precinctParameters.numprecincts;
	            for (; k < numprecincts;) {
	              var packet = createPacket(resolution, k, l);
	              k++;
	              return packet;
	            }
	            k = 0;
	          }
	          i = 0;
	        }
	        r = 0;
	      }
	      error('JPX Error: Out of packets');
	    };
	  }
	  function ResolutionLayerComponentPositionIterator(context) {
	    var siz = context.SIZ;
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var layersCount = tile.codingStyleDefaultParameters.layersCount;
	    var componentsCount = siz.Csiz;
	    var maxDecompositionLevelsCount = 0;
	    for (var q = 0; q < componentsCount; q++) {
	      maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
	    }
	    var r = 0,
	        l = 0,
	        i = 0,
	        k = 0;
	    this.nextPacket = function JpxImage_nextPacket() {
	      for (; r <= maxDecompositionLevelsCount; r++) {
	        for (; l < layersCount; l++) {
	          for (; i < componentsCount; i++) {
	            var component = tile.components[i];
	            if (r > component.codingStyleParameters.decompositionLevelsCount) {
	              continue;
	            }
	            var resolution = component.resolutions[r];
	            var numprecincts = resolution.precinctParameters.numprecincts;
	            for (; k < numprecincts;) {
	              var packet = createPacket(resolution, k, l);
	              k++;
	              return packet;
	            }
	            k = 0;
	          }
	          i = 0;
	        }
	        l = 0;
	      }
	      error('JPX Error: Out of packets');
	    };
	  }
	  function ResolutionPositionComponentLayerIterator(context) {
	    var siz = context.SIZ;
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var layersCount = tile.codingStyleDefaultParameters.layersCount;
	    var componentsCount = siz.Csiz;
	    var l, r, c, p;
	    var maxDecompositionLevelsCount = 0;
	    for (c = 0; c < componentsCount; c++) {
	      var component = tile.components[c];
	      maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, component.codingStyleParameters.decompositionLevelsCount);
	    }
	    var maxNumPrecinctsInLevel = new Int32Array(maxDecompositionLevelsCount + 1);
	    for (r = 0; r <= maxDecompositionLevelsCount; ++r) {
	      var maxNumPrecincts = 0;
	      for (c = 0; c < componentsCount; ++c) {
	        var resolutions = tile.components[c].resolutions;
	        if (r < resolutions.length) {
	          maxNumPrecincts = Math.max(maxNumPrecincts, resolutions[r].precinctParameters.numprecincts);
	        }
	      }
	      maxNumPrecinctsInLevel[r] = maxNumPrecincts;
	    }
	    l = 0;
	    r = 0;
	    c = 0;
	    p = 0;
	    this.nextPacket = function JpxImage_nextPacket() {
	      for (; r <= maxDecompositionLevelsCount; r++) {
	        for (; p < maxNumPrecinctsInLevel[r]; p++) {
	          for (; c < componentsCount; c++) {
	            var component = tile.components[c];
	            if (r > component.codingStyleParameters.decompositionLevelsCount) {
	              continue;
	            }
	            var resolution = component.resolutions[r];
	            var numprecincts = resolution.precinctParameters.numprecincts;
	            if (p >= numprecincts) {
	              continue;
	            }
	            for (; l < layersCount;) {
	              var packet = createPacket(resolution, p, l);
	              l++;
	              return packet;
	            }
	            l = 0;
	          }
	          c = 0;
	        }
	        p = 0;
	      }
	      error('JPX Error: Out of packets');
	    };
	  }
	  function PositionComponentResolutionLayerIterator(context) {
	    var siz = context.SIZ;
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var layersCount = tile.codingStyleDefaultParameters.layersCount;
	    var componentsCount = siz.Csiz;
	    var precinctsSizes = getPrecinctSizesInImageScale(tile);
	    var precinctsIterationSizes = precinctsSizes;
	    var l = 0,
	        r = 0,
	        c = 0,
	        px = 0,
	        py = 0;
	    this.nextPacket = function JpxImage_nextPacket() {
	      for (; py < precinctsIterationSizes.maxNumHigh; py++) {
	        for (; px < precinctsIterationSizes.maxNumWide; px++) {
	          for (; c < componentsCount; c++) {
	            var component = tile.components[c];
	            var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
	            for (; r <= decompositionLevelsCount; r++) {
	              var resolution = component.resolutions[r];
	              var sizeInImageScale = precinctsSizes.components[c].resolutions[r];
	              var k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
	              if (k === null) {
	                continue;
	              }
	              for (; l < layersCount;) {
	                var packet = createPacket(resolution, k, l);
	                l++;
	                return packet;
	              }
	              l = 0;
	            }
	            r = 0;
	          }
	          c = 0;
	        }
	        px = 0;
	      }
	      error('JPX Error: Out of packets');
	    };
	  }
	  function ComponentPositionResolutionLayerIterator(context) {
	    var siz = context.SIZ;
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var layersCount = tile.codingStyleDefaultParameters.layersCount;
	    var componentsCount = siz.Csiz;
	    var precinctsSizes = getPrecinctSizesInImageScale(tile);
	    var l = 0,
	        r = 0,
	        c = 0,
	        px = 0,
	        py = 0;
	    this.nextPacket = function JpxImage_nextPacket() {
	      for (; c < componentsCount; ++c) {
	        var component = tile.components[c];
	        var precinctsIterationSizes = precinctsSizes.components[c];
	        var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
	        for (; py < precinctsIterationSizes.maxNumHigh; py++) {
	          for (; px < precinctsIterationSizes.maxNumWide; px++) {
	            for (; r <= decompositionLevelsCount; r++) {
	              var resolution = component.resolutions[r];
	              var sizeInImageScale = precinctsIterationSizes.resolutions[r];
	              var k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
	              if (k === null) {
	                continue;
	              }
	              for (; l < layersCount;) {
	                var packet = createPacket(resolution, k, l);
	                l++;
	                return packet;
	              }
	              l = 0;
	            }
	            r = 0;
	          }
	          px = 0;
	        }
	        py = 0;
	      }
	      error('JPX Error: Out of packets');
	    };
	  }
	  function getPrecinctIndexIfExist(pxIndex, pyIndex, sizeInImageScale, precinctIterationSizes, resolution) {
	    var posX = pxIndex * precinctIterationSizes.minWidth;
	    var posY = pyIndex * precinctIterationSizes.minHeight;
	    if (posX % sizeInImageScale.width !== 0 || posY % sizeInImageScale.height !== 0) {
	      return null;
	    }
	    var startPrecinctRowIndex = posY / sizeInImageScale.width * resolution.precinctParameters.numprecinctswide;
	    return posX / sizeInImageScale.height + startPrecinctRowIndex;
	  }
	  function getPrecinctSizesInImageScale(tile) {
	    var componentsCount = tile.components.length;
	    var minWidth = Number.MAX_VALUE;
	    var minHeight = Number.MAX_VALUE;
	    var maxNumWide = 0;
	    var maxNumHigh = 0;
	    var sizePerComponent = new Array(componentsCount);
	    for (var c = 0; c < componentsCount; c++) {
	      var component = tile.components[c];
	      var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
	      var sizePerResolution = new Array(decompositionLevelsCount + 1);
	      var minWidthCurrentComponent = Number.MAX_VALUE;
	      var minHeightCurrentComponent = Number.MAX_VALUE;
	      var maxNumWideCurrentComponent = 0;
	      var maxNumHighCurrentComponent = 0;
	      var scale = 1;
	      for (var r = decompositionLevelsCount; r >= 0; --r) {
	        var resolution = component.resolutions[r];
	        var widthCurrentResolution = scale * resolution.precinctParameters.precinctWidth;
	        var heightCurrentResolution = scale * resolution.precinctParameters.precinctHeight;
	        minWidthCurrentComponent = Math.min(minWidthCurrentComponent, widthCurrentResolution);
	        minHeightCurrentComponent = Math.min(minHeightCurrentComponent, heightCurrentResolution);
	        maxNumWideCurrentComponent = Math.max(maxNumWideCurrentComponent, resolution.precinctParameters.numprecinctswide);
	        maxNumHighCurrentComponent = Math.max(maxNumHighCurrentComponent, resolution.precinctParameters.numprecinctshigh);
	        sizePerResolution[r] = {
	          width: widthCurrentResolution,
	          height: heightCurrentResolution
	        };
	        scale <<= 1;
	      }
	      minWidth = Math.min(minWidth, minWidthCurrentComponent);
	      minHeight = Math.min(minHeight, minHeightCurrentComponent);
	      maxNumWide = Math.max(maxNumWide, maxNumWideCurrentComponent);
	      maxNumHigh = Math.max(maxNumHigh, maxNumHighCurrentComponent);
	      sizePerComponent[c] = {
	        resolutions: sizePerResolution,
	        minWidth: minWidthCurrentComponent,
	        minHeight: minHeightCurrentComponent,
	        maxNumWide: maxNumWideCurrentComponent,
	        maxNumHigh: maxNumHighCurrentComponent
	      };
	    }
	    return {
	      components: sizePerComponent,
	      minWidth: minWidth,
	      minHeight: minHeight,
	      maxNumWide: maxNumWide,
	      maxNumHigh: maxNumHigh
	    };
	  }
	  function buildPackets(context) {
	    var siz = context.SIZ;
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var componentsCount = siz.Csiz;
	    for (var c = 0; c < componentsCount; c++) {
	      var component = tile.components[c];
	      var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
	      var resolutions = [];
	      var subbands = [];
	      for (var r = 0; r <= decompositionLevelsCount; r++) {
	        var blocksDimensions = getBlocksDimensions(context, component, r);
	        var resolution = {};
	        var scale = 1 << decompositionLevelsCount - r;
	        resolution.trx0 = Math.ceil(component.tcx0 / scale);
	        resolution.try0 = Math.ceil(component.tcy0 / scale);
	        resolution.trx1 = Math.ceil(component.tcx1 / scale);
	        resolution.try1 = Math.ceil(component.tcy1 / scale);
	        resolution.resLevel = r;
	        buildPrecincts(context, resolution, blocksDimensions);
	        resolutions.push(resolution);
	        var subband;
	        if (r === 0) {
	          subband = {};
	          subband.type = 'LL';
	          subband.tbx0 = Math.ceil(component.tcx0 / scale);
	          subband.tby0 = Math.ceil(component.tcy0 / scale);
	          subband.tbx1 = Math.ceil(component.tcx1 / scale);
	          subband.tby1 = Math.ceil(component.tcy1 / scale);
	          subband.resolution = resolution;
	          buildCodeblocks(context, subband, blocksDimensions);
	          subbands.push(subband);
	          resolution.subbands = [subband];
	        } else {
	          var bscale = 1 << decompositionLevelsCount - r + 1;
	          var resolutionSubbands = [];
	          subband = {};
	          subband.type = 'HL';
	          subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
	          subband.tby0 = Math.ceil(component.tcy0 / bscale);
	          subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
	          subband.tby1 = Math.ceil(component.tcy1 / bscale);
	          subband.resolution = resolution;
	          buildCodeblocks(context, subband, blocksDimensions);
	          subbands.push(subband);
	          resolutionSubbands.push(subband);
	          subband = {};
	          subband.type = 'LH';
	          subband.tbx0 = Math.ceil(component.tcx0 / bscale);
	          subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
	          subband.tbx1 = Math.ceil(component.tcx1 / bscale);
	          subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
	          subband.resolution = resolution;
	          buildCodeblocks(context, subband, blocksDimensions);
	          subbands.push(subband);
	          resolutionSubbands.push(subband);
	          subband = {};
	          subband.type = 'HH';
	          subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
	          subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
	          subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
	          subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
	          subband.resolution = resolution;
	          buildCodeblocks(context, subband, blocksDimensions);
	          subbands.push(subband);
	          resolutionSubbands.push(subband);
	          resolution.subbands = resolutionSubbands;
	        }
	      }
	      component.resolutions = resolutions;
	      component.subbands = subbands;
	    }
	    var progressionOrder = tile.codingStyleDefaultParameters.progressionOrder;
	    switch (progressionOrder) {
	      case 0:
	        tile.packetsIterator = new LayerResolutionComponentPositionIterator(context);
	        break;
	      case 1:
	        tile.packetsIterator = new ResolutionLayerComponentPositionIterator(context);
	        break;
	      case 2:
	        tile.packetsIterator = new ResolutionPositionComponentLayerIterator(context);
	        break;
	      case 3:
	        tile.packetsIterator = new PositionComponentResolutionLayerIterator(context);
	        break;
	      case 4:
	        tile.packetsIterator = new ComponentPositionResolutionLayerIterator(context);
	        break;
	      default:
	        error('JPX Error: Unsupported progression order ' + progressionOrder);
	    }
	  }
	  function parseTilePackets(context, data, offset, dataLength) {
	    var position = 0;
	    var buffer,
	        bufferSize = 0,
	        skipNextBit = false;
	    function readBits(count) {
	      while (bufferSize < count) {
	        var b = data[offset + position];
	        position++;
	        if (skipNextBit) {
	          buffer = buffer << 7 | b;
	          bufferSize += 7;
	          skipNextBit = false;
	        } else {
	          buffer = buffer << 8 | b;
	          bufferSize += 8;
	        }
	        if (b === 0xFF) {
	          skipNextBit = true;
	        }
	      }
	      bufferSize -= count;
	      return buffer >>> bufferSize & (1 << count) - 1;
	    }
	    function skipMarkerIfEqual(value) {
	      if (data[offset + position - 1] === 0xFF && data[offset + position] === value) {
	        skipBytes(1);
	        return true;
	      } else if (data[offset + position] === 0xFF && data[offset + position + 1] === value) {
	        skipBytes(2);
	        return true;
	      }
	      return false;
	    }
	    function skipBytes(count) {
	      position += count;
	    }
	    function alignToByte() {
	      bufferSize = 0;
	      if (skipNextBit) {
	        position++;
	        skipNextBit = false;
	      }
	    }
	    function readCodingpasses() {
	      if (readBits(1) === 0) {
	        return 1;
	      }
	      if (readBits(1) === 0) {
	        return 2;
	      }
	      var value = readBits(2);
	      if (value < 3) {
	        return value + 3;
	      }
	      value = readBits(5);
	      if (value < 31) {
	        return value + 6;
	      }
	      value = readBits(7);
	      return value + 37;
	    }
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var sopMarkerUsed = context.COD.sopMarkerUsed;
	    var ephMarkerUsed = context.COD.ephMarkerUsed;
	    var packetsIterator = tile.packetsIterator;
	    while (position < dataLength) {
	      alignToByte();
	      if (sopMarkerUsed && skipMarkerIfEqual(0x91)) {
	        skipBytes(4);
	      }
	      var packet = packetsIterator.nextPacket();
	      if (!readBits(1)) {
	        continue;
	      }
	      var layerNumber = packet.layerNumber;
	      var queue = [],
	          codeblock;
	      for (var i = 0, ii = packet.codeblocks.length; i < ii; i++) {
	        codeblock = packet.codeblocks[i];
	        var precinct = codeblock.precinct;
	        var codeblockColumn = codeblock.cbx - precinct.cbxMin;
	        var codeblockRow = codeblock.cby - precinct.cbyMin;
	        var codeblockIncluded = false;
	        var firstTimeInclusion = false;
	        var valueReady;
	        if (codeblock['included'] !== undefined) {
	          codeblockIncluded = !!readBits(1);
	        } else {
	          precinct = codeblock.precinct;
	          var inclusionTree, zeroBitPlanesTree;
	          if (precinct['inclusionTree'] !== undefined) {
	            inclusionTree = precinct.inclusionTree;
	          } else {
	            var width = precinct.cbxMax - precinct.cbxMin + 1;
	            var height = precinct.cbyMax - precinct.cbyMin + 1;
	            inclusionTree = new InclusionTree(width, height, layerNumber);
	            zeroBitPlanesTree = new TagTree(width, height);
	            precinct.inclusionTree = inclusionTree;
	            precinct.zeroBitPlanesTree = zeroBitPlanesTree;
	          }
	          if (inclusionTree.reset(codeblockColumn, codeblockRow, layerNumber)) {
	            while (true) {
	              if (readBits(1)) {
	                valueReady = !inclusionTree.nextLevel();
	                if (valueReady) {
	                  codeblock.included = true;
	                  codeblockIncluded = firstTimeInclusion = true;
	                  break;
	                }
	              } else {
	                inclusionTree.incrementValue(layerNumber);
	                break;
	              }
	            }
	          }
	        }
	        if (!codeblockIncluded) {
	          continue;
	        }
	        if (firstTimeInclusion) {
	          zeroBitPlanesTree = precinct.zeroBitPlanesTree;
	          zeroBitPlanesTree.reset(codeblockColumn, codeblockRow);
	          while (true) {
	            if (readBits(1)) {
	              valueReady = !zeroBitPlanesTree.nextLevel();
	              if (valueReady) {
	                break;
	              }
	            } else {
	              zeroBitPlanesTree.incrementValue();
	            }
	          }
	          codeblock.zeroBitPlanes = zeroBitPlanesTree.value;
	        }
	        var codingpasses = readCodingpasses();
	        while (readBits(1)) {
	          codeblock.Lblock++;
	        }
	        var codingpassesLog2 = log2(codingpasses);
	        var bits = (codingpasses < 1 << codingpassesLog2 ? codingpassesLog2 - 1 : codingpassesLog2) + codeblock.Lblock;
	        var codedDataLength = readBits(bits);
	        queue.push({
	          codeblock: codeblock,
	          codingpasses: codingpasses,
	          dataLength: codedDataLength
	        });
	      }
	      alignToByte();
	      if (ephMarkerUsed) {
	        skipMarkerIfEqual(0x92);
	      }
	      while (queue.length > 0) {
	        var packetItem = queue.shift();
	        codeblock = packetItem.codeblock;
	        if (codeblock['data'] === undefined) {
	          codeblock.data = [];
	        }
	        codeblock.data.push({
	          data: data,
	          start: offset + position,
	          end: offset + position + packetItem.dataLength,
	          codingpasses: packetItem.codingpasses
	        });
	        position += packetItem.dataLength;
	      }
	    }
	    return position;
	  }
	  function copyCoefficients(coefficients, levelWidth, levelHeight, subband, delta, mb, reversible, segmentationSymbolUsed) {
	    var x0 = subband.tbx0;
	    var y0 = subband.tby0;
	    var width = subband.tbx1 - subband.tbx0;
	    var codeblocks = subband.codeblocks;
	    var right = subband.type.charAt(0) === 'H' ? 1 : 0;
	    var bottom = subband.type.charAt(1) === 'H' ? levelWidth : 0;
	    for (var i = 0, ii = codeblocks.length; i < ii; ++i) {
	      var codeblock = codeblocks[i];
	      var blockWidth = codeblock.tbx1_ - codeblock.tbx0_;
	      var blockHeight = codeblock.tby1_ - codeblock.tby0_;
	      if (blockWidth === 0 || blockHeight === 0) {
	        continue;
	      }
	      if (codeblock['data'] === undefined) {
	        continue;
	      }
	      var bitModel, currentCodingpassType;
	      bitModel = new BitModel(blockWidth, blockHeight, codeblock.subbandType, codeblock.zeroBitPlanes, mb);
	      currentCodingpassType = 2;
	      var data = codeblock.data,
	          totalLength = 0,
	          codingpasses = 0;
	      var j, jj, dataItem;
	      for (j = 0, jj = data.length; j < jj; j++) {
	        dataItem = data[j];
	        totalLength += dataItem.end - dataItem.start;
	        codingpasses += dataItem.codingpasses;
	      }
	      var encodedData = new Uint8Array(totalLength);
	      var position = 0;
	      for (j = 0, jj = data.length; j < jj; j++) {
	        dataItem = data[j];
	        var chunk = dataItem.data.subarray(dataItem.start, dataItem.end);
	        encodedData.set(chunk, position);
	        position += chunk.length;
	      }
	      var decoder = new ArithmeticDecoder(encodedData, 0, totalLength);
	      bitModel.setDecoder(decoder);
	      for (j = 0; j < codingpasses; j++) {
	        switch (currentCodingpassType) {
	          case 0:
	            bitModel.runSignificancePropagationPass();
	            break;
	          case 1:
	            bitModel.runMagnitudeRefinementPass();
	            break;
	          case 2:
	            bitModel.runCleanupPass();
	            if (segmentationSymbolUsed) {
	              bitModel.checkSegmentationSymbol();
	            }
	            break;
	        }
	        currentCodingpassType = (currentCodingpassType + 1) % 3;
	      }
	      var offset = codeblock.tbx0_ - x0 + (codeblock.tby0_ - y0) * width;
	      var sign = bitModel.coefficentsSign;
	      var magnitude = bitModel.coefficentsMagnitude;
	      var bitsDecoded = bitModel.bitsDecoded;
	      var magnitudeCorrection = reversible ? 0 : 0.5;
	      var k, n, nb;
	      position = 0;
	      var interleave = subband.type !== 'LL';
	      for (j = 0; j < blockHeight; j++) {
	        var row = offset / width | 0;
	        var levelOffset = 2 * row * (levelWidth - width) + right + bottom;
	        for (k = 0; k < blockWidth; k++) {
	          n = magnitude[position];
	          if (n !== 0) {
	            n = (n + magnitudeCorrection) * delta;
	            if (sign[position] !== 0) {
	              n = -n;
	            }
	            nb = bitsDecoded[position];
	            var pos = interleave ? levelOffset + (offset << 1) : offset;
	            if (reversible && nb >= mb) {
	              coefficients[pos] = n;
	            } else {
	              coefficients[pos] = n * (1 << mb - nb);
	            }
	          }
	          offset++;
	          position++;
	        }
	        offset += width - blockWidth;
	      }
	    }
	  }
	  function transformTile(context, tile, c) {
	    var component = tile.components[c];
	    var codingStyleParameters = component.codingStyleParameters;
	    var quantizationParameters = component.quantizationParameters;
	    var decompositionLevelsCount = codingStyleParameters.decompositionLevelsCount;
	    var spqcds = quantizationParameters.SPqcds;
	    var scalarExpounded = quantizationParameters.scalarExpounded;
	    var guardBits = quantizationParameters.guardBits;
	    var segmentationSymbolUsed = codingStyleParameters.segmentationSymbolUsed;
	    var precision = context.components[c].precision;
	    var reversible = codingStyleParameters.reversibleTransformation;
	    var transform = reversible ? new ReversibleTransform() : new IrreversibleTransform();
	    var subbandCoefficients = [];
	    var b = 0;
	    for (var i = 0; i <= decompositionLevelsCount; i++) {
	      var resolution = component.resolutions[i];
	      var width = resolution.trx1 - resolution.trx0;
	      var height = resolution.try1 - resolution.try0;
	      var coefficients = new Float32Array(width * height);
	      for (var j = 0, jj = resolution.subbands.length; j < jj; j++) {
	        var mu, epsilon;
	        if (!scalarExpounded) {
	          mu = spqcds[0].mu;
	          epsilon = spqcds[0].epsilon + (i > 0 ? 1 - i : 0);
	        } else {
	          mu = spqcds[b].mu;
	          epsilon = spqcds[b].epsilon;
	          b++;
	        }
	        var subband = resolution.subbands[j];
	        var gainLog2 = SubbandsGainLog2[subband.type];
	        var delta = reversible ? 1 : Math.pow(2, precision + gainLog2 - epsilon) * (1 + mu / 2048);
	        var mb = guardBits + epsilon - 1;
	        copyCoefficients(coefficients, width, height, subband, delta, mb, reversible, segmentationSymbolUsed);
	      }
	      subbandCoefficients.push({
	        width: width,
	        height: height,
	        items: coefficients
	      });
	    }
	    var result = transform.calculate(subbandCoefficients, component.tcx0, component.tcy0);
	    return {
	      left: component.tcx0,
	      top: component.tcy0,
	      width: result.width,
	      height: result.height,
	      items: result.items
	    };
	  }
	  function transformComponents(context) {
	    var siz = context.SIZ;
	    var components = context.components;
	    var componentsCount = siz.Csiz;
	    var resultImages = [];
	    for (var i = 0, ii = context.tiles.length; i < ii; i++) {
	      var tile = context.tiles[i];
	      var transformedTiles = [];
	      var c;
	      for (c = 0; c < componentsCount; c++) {
	        transformedTiles[c] = transformTile(context, tile, c);
	      }
	      var tile0 = transformedTiles[0];
	      var out = new Uint8Array(tile0.items.length * componentsCount);
	      var result = {
	        left: tile0.left,
	        top: tile0.top,
	        width: tile0.width,
	        height: tile0.height,
	        items: out
	      };
	      var shift, offset, max, min, maxK;
	      var pos = 0,
	          j,
	          jj,
	          y0,
	          y1,
	          y2,
	          r,
	          g,
	          b,
	          k,
	          val;
	      if (tile.codingStyleDefaultParameters.multipleComponentTransform) {
	        var fourComponents = componentsCount === 4;
	        var y0items = transformedTiles[0].items;
	        var y1items = transformedTiles[1].items;
	        var y2items = transformedTiles[2].items;
	        var y3items = fourComponents ? transformedTiles[3].items : null;
	        shift = components[0].precision - 8;
	        offset = (128 << shift) + 0.5;
	        max = 255 * (1 << shift);
	        maxK = max * 0.5;
	        min = -maxK;
	        var component0 = tile.components[0];
	        var alpha01 = componentsCount - 3;
	        jj = y0items.length;
	        if (!component0.codingStyleParameters.reversibleTransformation) {
	          for (j = 0; j < jj; j++, pos += alpha01) {
	            y0 = y0items[j] + offset;
	            y1 = y1items[j];
	            y2 = y2items[j];
	            r = y0 + 1.402 * y2;
	            g = y0 - 0.34413 * y1 - 0.71414 * y2;
	            b = y0 + 1.772 * y1;
	            out[pos++] = r <= 0 ? 0 : r >= max ? 255 : r >> shift;
	            out[pos++] = g <= 0 ? 0 : g >= max ? 255 : g >> shift;
	            out[pos++] = b <= 0 ? 0 : b >= max ? 255 : b >> shift;
	          }
	        } else {
	          for (j = 0; j < jj; j++, pos += alpha01) {
	            y0 = y0items[j] + offset;
	            y1 = y1items[j];
	            y2 = y2items[j];
	            g = y0 - (y2 + y1 >> 2);
	            r = g + y2;
	            b = g + y1;
	            out[pos++] = r <= 0 ? 0 : r >= max ? 255 : r >> shift;
	            out[pos++] = g <= 0 ? 0 : g >= max ? 255 : g >> shift;
	            out[pos++] = b <= 0 ? 0 : b >= max ? 255 : b >> shift;
	          }
	        }
	        if (fourComponents) {
	          for (j = 0, pos = 3; j < jj; j++, pos += 4) {
	            k = y3items[j];
	            out[pos] = k <= min ? 0 : k >= maxK ? 255 : k + offset >> shift;
	          }
	        }
	      } else {
	        for (c = 0; c < componentsCount; c++) {
	          var items = transformedTiles[c].items;
	          shift = components[c].precision - 8;
	          offset = (128 << shift) + 0.5;
	          max = 127.5 * (1 << shift);
	          min = -max;
	          for (pos = c, j = 0, jj = items.length; j < jj; j++) {
	            val = items[j];
	            out[pos] = val <= min ? 0 : val >= max ? 255 : val + offset >> shift;
	            pos += componentsCount;
	          }
	        }
	      }
	      resultImages.push(result);
	    }
	    return resultImages;
	  }
	  function initializeTile(context, tileIndex) {
	    var siz = context.SIZ;
	    var componentsCount = siz.Csiz;
	    var tile = context.tiles[tileIndex];
	    for (var c = 0; c < componentsCount; c++) {
	      var component = tile.components[c];
	      var qcdOrQcc = context.currentTile.QCC[c] !== undefined ? context.currentTile.QCC[c] : context.currentTile.QCD;
	      component.quantizationParameters = qcdOrQcc;
	      var codOrCoc = context.currentTile.COC[c] !== undefined ? context.currentTile.COC[c] : context.currentTile.COD;
	      component.codingStyleParameters = codOrCoc;
	    }
	    tile.codingStyleDefaultParameters = context.currentTile.COD;
	  }
	  var TagTree = function TagTreeClosure() {
	    function TagTree(width, height) {
	      var levelsLength = log2(Math.max(width, height)) + 1;
	      this.levels = [];
	      for (var i = 0; i < levelsLength; i++) {
	        var level = {
	          width: width,
	          height: height,
	          items: []
	        };
	        this.levels.push(level);
	        width = Math.ceil(width / 2);
	        height = Math.ceil(height / 2);
	      }
	    }
	    TagTree.prototype = {
	      reset: function TagTree_reset(i, j) {
	        var currentLevel = 0,
	            value = 0,
	            level;
	        while (currentLevel < this.levels.length) {
	          level = this.levels[currentLevel];
	          var index = i + j * level.width;
	          if (level.items[index] !== undefined) {
	            value = level.items[index];
	            break;
	          }
	          level.index = index;
	          i >>= 1;
	          j >>= 1;
	          currentLevel++;
	        }
	        currentLevel--;
	        level = this.levels[currentLevel];
	        level.items[level.index] = value;
	        this.currentLevel = currentLevel;
	        delete this.value;
	      },
	      incrementValue: function TagTree_incrementValue() {
	        var level = this.levels[this.currentLevel];
	        level.items[level.index]++;
	      },
	      nextLevel: function TagTree_nextLevel() {
	        var currentLevel = this.currentLevel;
	        var level = this.levels[currentLevel];
	        var value = level.items[level.index];
	        currentLevel--;
	        if (currentLevel < 0) {
	          this.value = value;
	          return false;
	        }
	        this.currentLevel = currentLevel;
	        level = this.levels[currentLevel];
	        level.items[level.index] = value;
	        return true;
	      }
	    };
	    return TagTree;
	  }();
	  var InclusionTree = function InclusionTreeClosure() {
	    function InclusionTree(width, height, defaultValue) {
	      var levelsLength = log2(Math.max(width, height)) + 1;
	      this.levels = [];
	      for (var i = 0; i < levelsLength; i++) {
	        var items = new Uint8Array(width * height);
	        for (var j = 0, jj = items.length; j < jj; j++) {
	          items[j] = defaultValue;
	        }
	        var level = {
	          width: width,
	          height: height,
	          items: items
	        };
	        this.levels.push(level);
	        width = Math.ceil(width / 2);
	        height = Math.ceil(height / 2);
	      }
	    }
	    InclusionTree.prototype = {
	      reset: function InclusionTree_reset(i, j, stopValue) {
	        var currentLevel = 0;
	        while (currentLevel < this.levels.length) {
	          var level = this.levels[currentLevel];
	          var index = i + j * level.width;
	          level.index = index;
	          var value = level.items[index];
	          if (value === 0xFF) {
	            break;
	          }
	          if (value > stopValue) {
	            this.currentLevel = currentLevel;
	            this.propagateValues();
	            return false;
	          }
	          i >>= 1;
	          j >>= 1;
	          currentLevel++;
	        }
	        this.currentLevel = currentLevel - 1;
	        return true;
	      },
	      incrementValue: function InclusionTree_incrementValue(stopValue) {
	        var level = this.levels[this.currentLevel];
	        level.items[level.index] = stopValue + 1;
	        this.propagateValues();
	      },
	      propagateValues: function InclusionTree_propagateValues() {
	        var levelIndex = this.currentLevel;
	        var level = this.levels[levelIndex];
	        var currentValue = level.items[level.index];
	        while (--levelIndex >= 0) {
	          level = this.levels[levelIndex];
	          level.items[level.index] = currentValue;
	        }
	      },
	      nextLevel: function InclusionTree_nextLevel() {
	        var currentLevel = this.currentLevel;
	        var level = this.levels[currentLevel];
	        var value = level.items[level.index];
	        level.items[level.index] = 0xFF;
	        currentLevel--;
	        if (currentLevel < 0) {
	          return false;
	        }
	        this.currentLevel = currentLevel;
	        level = this.levels[currentLevel];
	        level.items[level.index] = value;
	        return true;
	      }
	    };
	    return InclusionTree;
	  }();
	  var BitModel = function BitModelClosure() {
	    var UNIFORM_CONTEXT = 17;
	    var RUNLENGTH_CONTEXT = 18;
	    var LLAndLHContextsLabel = new Uint8Array([0, 5, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 1, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8]);
	    var HLContextLabel = new Uint8Array([0, 3, 4, 0, 5, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 1, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8]);
	    var HHContextLabel = new Uint8Array([0, 1, 2, 0, 1, 2, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 3, 4, 5, 0, 4, 5, 5, 0, 5, 5, 5, 0, 0, 0, 0, 0, 6, 7, 7, 0, 7, 7, 7, 0, 7, 7, 7, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8]);
	    function BitModel(width, height, subband, zeroBitPlanes, mb) {
	      this.width = width;
	      this.height = height;
	      this.contextLabelTable = subband === 'HH' ? HHContextLabel : subband === 'HL' ? HLContextLabel : LLAndLHContextsLabel;
	      var coefficientCount = width * height;
	      this.neighborsSignificance = new Uint8Array(coefficientCount);
	      this.coefficentsSign = new Uint8Array(coefficientCount);
	      this.coefficentsMagnitude = mb > 14 ? new Uint32Array(coefficientCount) : mb > 6 ? new Uint16Array(coefficientCount) : new Uint8Array(coefficientCount);
	      this.processingFlags = new Uint8Array(coefficientCount);
	      var bitsDecoded = new Uint8Array(coefficientCount);
	      if (zeroBitPlanes !== 0) {
	        for (var i = 0; i < coefficientCount; i++) {
	          bitsDecoded[i] = zeroBitPlanes;
	        }
	      }
	      this.bitsDecoded = bitsDecoded;
	      this.reset();
	    }
	    BitModel.prototype = {
	      setDecoder: function BitModel_setDecoder(decoder) {
	        this.decoder = decoder;
	      },
	      reset: function BitModel_reset() {
	        this.contexts = new Int8Array(19);
	        this.contexts[0] = 4 << 1 | 0;
	        this.contexts[UNIFORM_CONTEXT] = 46 << 1 | 0;
	        this.contexts[RUNLENGTH_CONTEXT] = 3 << 1 | 0;
	      },
	      setNeighborsSignificance: function BitModel_setNeighborsSignificance(row, column, index) {
	        var neighborsSignificance = this.neighborsSignificance;
	        var width = this.width,
	            height = this.height;
	        var left = column > 0;
	        var right = column + 1 < width;
	        var i;
	        if (row > 0) {
	          i = index - width;
	          if (left) {
	            neighborsSignificance[i - 1] += 0x10;
	          }
	          if (right) {
	            neighborsSignificance[i + 1] += 0x10;
	          }
	          neighborsSignificance[i] += 0x04;
	        }
	        if (row + 1 < height) {
	          i = index + width;
	          if (left) {
	            neighborsSignificance[i - 1] += 0x10;
	          }
	          if (right) {
	            neighborsSignificance[i + 1] += 0x10;
	          }
	          neighborsSignificance[i] += 0x04;
	        }
	        if (left) {
	          neighborsSignificance[index - 1] += 0x01;
	        }
	        if (right) {
	          neighborsSignificance[index + 1] += 0x01;
	        }
	        neighborsSignificance[index] |= 0x80;
	      },
	      runSignificancePropagationPass: function BitModel_runSignificancePropagationPass() {
	        var decoder = this.decoder;
	        var width = this.width,
	            height = this.height;
	        var coefficentsMagnitude = this.coefficentsMagnitude;
	        var coefficentsSign = this.coefficentsSign;
	        var neighborsSignificance = this.neighborsSignificance;
	        var processingFlags = this.processingFlags;
	        var contexts = this.contexts;
	        var labels = this.contextLabelTable;
	        var bitsDecoded = this.bitsDecoded;
	        var processedInverseMask = ~1;
	        var processedMask = 1;
	        var firstMagnitudeBitMask = 2;
	        for (var i0 = 0; i0 < height; i0 += 4) {
	          for (var j = 0; j < width; j++) {
	            var index = i0 * width + j;
	            for (var i1 = 0; i1 < 4; i1++, index += width) {
	              var i = i0 + i1;
	              if (i >= height) {
	                break;
	              }
	              processingFlags[index] &= processedInverseMask;
	              if (coefficentsMagnitude[index] || !neighborsSignificance[index]) {
	                continue;
	              }
	              var contextLabel = labels[neighborsSignificance[index]];
	              var decision = decoder.readBit(contexts, contextLabel);
	              if (decision) {
	                var sign = this.decodeSignBit(i, j, index);
	                coefficentsSign[index] = sign;
	                coefficentsMagnitude[index] = 1;
	                this.setNeighborsSignificance(i, j, index);
	                processingFlags[index] |= firstMagnitudeBitMask;
	              }
	              bitsDecoded[index]++;
	              processingFlags[index] |= processedMask;
	            }
	          }
	        }
	      },
	      decodeSignBit: function BitModel_decodeSignBit(row, column, index) {
	        var width = this.width,
	            height = this.height;
	        var coefficentsMagnitude = this.coefficentsMagnitude;
	        var coefficentsSign = this.coefficentsSign;
	        var contribution, sign0, sign1, significance1;
	        var contextLabel, decoded;
	        significance1 = column > 0 && coefficentsMagnitude[index - 1] !== 0;
	        if (column + 1 < width && coefficentsMagnitude[index + 1] !== 0) {
	          sign1 = coefficentsSign[index + 1];
	          if (significance1) {
	            sign0 = coefficentsSign[index - 1];
	            contribution = 1 - sign1 - sign0;
	          } else {
	            contribution = 1 - sign1 - sign1;
	          }
	        } else if (significance1) {
	          sign0 = coefficentsSign[index - 1];
	          contribution = 1 - sign0 - sign0;
	        } else {
	          contribution = 0;
	        }
	        var horizontalContribution = 3 * contribution;
	        significance1 = row > 0 && coefficentsMagnitude[index - width] !== 0;
	        if (row + 1 < height && coefficentsMagnitude[index + width] !== 0) {
	          sign1 = coefficentsSign[index + width];
	          if (significance1) {
	            sign0 = coefficentsSign[index - width];
	            contribution = 1 - sign1 - sign0 + horizontalContribution;
	          } else {
	            contribution = 1 - sign1 - sign1 + horizontalContribution;
	          }
	        } else if (significance1) {
	          sign0 = coefficentsSign[index - width];
	          contribution = 1 - sign0 - sign0 + horizontalContribution;
	        } else {
	          contribution = horizontalContribution;
	        }
	        if (contribution >= 0) {
	          contextLabel = 9 + contribution;
	          decoded = this.decoder.readBit(this.contexts, contextLabel);
	        } else {
	          contextLabel = 9 - contribution;
	          decoded = this.decoder.readBit(this.contexts, contextLabel) ^ 1;
	        }
	        return decoded;
	      },
	      runMagnitudeRefinementPass: function BitModel_runMagnitudeRefinementPass() {
	        var decoder = this.decoder;
	        var width = this.width,
	            height = this.height;
	        var coefficentsMagnitude = this.coefficentsMagnitude;
	        var neighborsSignificance = this.neighborsSignificance;
	        var contexts = this.contexts;
	        var bitsDecoded = this.bitsDecoded;
	        var processingFlags = this.processingFlags;
	        var processedMask = 1;
	        var firstMagnitudeBitMask = 2;
	        var length = width * height;
	        var width4 = width * 4;
	        for (var index0 = 0, indexNext; index0 < length; index0 = indexNext) {
	          indexNext = Math.min(length, index0 + width4);
	          for (var j = 0; j < width; j++) {
	            for (var index = index0 + j; index < indexNext; index += width) {
	              if (!coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) {
	                continue;
	              }
	              var contextLabel = 16;
	              if ((processingFlags[index] & firstMagnitudeBitMask) !== 0) {
	                processingFlags[index] ^= firstMagnitudeBitMask;
	                var significance = neighborsSignificance[index] & 127;
	                contextLabel = significance === 0 ? 15 : 14;
	              }
	              var bit = decoder.readBit(contexts, contextLabel);
	              coefficentsMagnitude[index] = coefficentsMagnitude[index] << 1 | bit;
	              bitsDecoded[index]++;
	              processingFlags[index] |= processedMask;
	            }
	          }
	        }
	      },
	      runCleanupPass: function BitModel_runCleanupPass() {
	        var decoder = this.decoder;
	        var width = this.width,
	            height = this.height;
	        var neighborsSignificance = this.neighborsSignificance;
	        var coefficentsMagnitude = this.coefficentsMagnitude;
	        var coefficentsSign = this.coefficentsSign;
	        var contexts = this.contexts;
	        var labels = this.contextLabelTable;
	        var bitsDecoded = this.bitsDecoded;
	        var processingFlags = this.processingFlags;
	        var processedMask = 1;
	        var firstMagnitudeBitMask = 2;
	        var oneRowDown = width;
	        var twoRowsDown = width * 2;
	        var threeRowsDown = width * 3;
	        var iNext;
	        for (var i0 = 0; i0 < height; i0 = iNext) {
	          iNext = Math.min(i0 + 4, height);
	          var indexBase = i0 * width;
	          var checkAllEmpty = i0 + 3 < height;
	          for (var j = 0; j < width; j++) {
	            var index0 = indexBase + j;
	            var allEmpty = checkAllEmpty && processingFlags[index0] === 0 && processingFlags[index0 + oneRowDown] === 0 && processingFlags[index0 + twoRowsDown] === 0 && processingFlags[index0 + threeRowsDown] === 0 && neighborsSignificance[index0] === 0 && neighborsSignificance[index0 + oneRowDown] === 0 && neighborsSignificance[index0 + twoRowsDown] === 0 && neighborsSignificance[index0 + threeRowsDown] === 0;
	            var i1 = 0,
	                index = index0;
	            var i = i0,
	                sign;
	            if (allEmpty) {
	              var hasSignificantCoefficent = decoder.readBit(contexts, RUNLENGTH_CONTEXT);
	              if (!hasSignificantCoefficent) {
	                bitsDecoded[index0]++;
	                bitsDecoded[index0 + oneRowDown]++;
	                bitsDecoded[index0 + twoRowsDown]++;
	                bitsDecoded[index0 + threeRowsDown]++;
	                continue;
	              }
	              i1 = decoder.readBit(contexts, UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, UNIFORM_CONTEXT);
	              if (i1 !== 0) {
	                i = i0 + i1;
	                index += i1 * width;
	              }
	              sign = this.decodeSignBit(i, j, index);
	              coefficentsSign[index] = sign;
	              coefficentsMagnitude[index] = 1;
	              this.setNeighborsSignificance(i, j, index);
	              processingFlags[index] |= firstMagnitudeBitMask;
	              index = index0;
	              for (var i2 = i0; i2 <= i; i2++, index += width) {
	                bitsDecoded[index]++;
	              }
	              i1++;
	            }
	            for (i = i0 + i1; i < iNext; i++, index += width) {
	              if (coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) {
	                continue;
	              }
	              var contextLabel = labels[neighborsSignificance[index]];
	              var decision = decoder.readBit(contexts, contextLabel);
	              if (decision === 1) {
	                sign = this.decodeSignBit(i, j, index);
	                coefficentsSign[index] = sign;
	                coefficentsMagnitude[index] = 1;
	                this.setNeighborsSignificance(i, j, index);
	                processingFlags[index] |= firstMagnitudeBitMask;
	              }
	              bitsDecoded[index]++;
	            }
	          }
	        }
	      },
	      checkSegmentationSymbol: function BitModel_checkSegmentationSymbol() {
	        var decoder = this.decoder;
	        var contexts = this.contexts;
	        var symbol = decoder.readBit(contexts, UNIFORM_CONTEXT) << 3 | decoder.readBit(contexts, UNIFORM_CONTEXT) << 2 | decoder.readBit(contexts, UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, UNIFORM_CONTEXT);
	        if (symbol !== 0xA) {
	          error('JPX Error: Invalid segmentation symbol');
	        }
	      }
	    };
	    return BitModel;
	  }();
	  var Transform = function TransformClosure() {
	    function Transform() {}
	    Transform.prototype.calculate = function transformCalculate(subbands, u0, v0) {
	      var ll = subbands[0];
	      for (var i = 1, ii = subbands.length; i < ii; i++) {
	        ll = this.iterate(ll, subbands[i], u0, v0);
	      }
	      return ll;
	    };
	    Transform.prototype.extend = function extend(buffer, offset, size) {
	      var i1 = offset - 1,
	          j1 = offset + 1;
	      var i2 = offset + size - 2,
	          j2 = offset + size;
	      buffer[i1--] = buffer[j1++];
	      buffer[j2++] = buffer[i2--];
	      buffer[i1--] = buffer[j1++];
	      buffer[j2++] = buffer[i2--];
	      buffer[i1--] = buffer[j1++];
	      buffer[j2++] = buffer[i2--];
	      buffer[i1] = buffer[j1];
	      buffer[j2] = buffer[i2];
	    };
	    Transform.prototype.iterate = function Transform_iterate(ll, hl_lh_hh, u0, v0) {
	      var llWidth = ll.width,
	          llHeight = ll.height,
	          llItems = ll.items;
	      var width = hl_lh_hh.width;
	      var height = hl_lh_hh.height;
	      var items = hl_lh_hh.items;
	      var i, j, k, l, u, v;
	      for (k = 0, i = 0; i < llHeight; i++) {
	        l = i * 2 * width;
	        for (j = 0; j < llWidth; j++, k++, l += 2) {
	          items[l] = llItems[k];
	        }
	      }
	      llItems = ll.items = null;
	      var bufferPadding = 4;
	      var rowBuffer = new Float32Array(width + 2 * bufferPadding);
	      if (width === 1) {
	        if ((u0 & 1) !== 0) {
	          for (v = 0, k = 0; v < height; v++, k += width) {
	            items[k] *= 0.5;
	          }
	        }
	      } else {
	        for (v = 0, k = 0; v < height; v++, k += width) {
	          rowBuffer.set(items.subarray(k, k + width), bufferPadding);
	          this.extend(rowBuffer, bufferPadding, width);
	          this.filter(rowBuffer, bufferPadding, width);
	          items.set(rowBuffer.subarray(bufferPadding, bufferPadding + width), k);
	        }
	      }
	      var numBuffers = 16;
	      var colBuffers = [];
	      for (i = 0; i < numBuffers; i++) {
	        colBuffers.push(new Float32Array(height + 2 * bufferPadding));
	      }
	      var b,
	          currentBuffer = 0;
	      ll = bufferPadding + height;
	      if (height === 1) {
	        if ((v0 & 1) !== 0) {
	          for (u = 0; u < width; u++) {
	            items[u] *= 0.5;
	          }
	        }
	      } else {
	        for (u = 0; u < width; u++) {
	          if (currentBuffer === 0) {
	            numBuffers = Math.min(width - u, numBuffers);
	            for (k = u, l = bufferPadding; l < ll; k += width, l++) {
	              for (b = 0; b < numBuffers; b++) {
	                colBuffers[b][l] = items[k + b];
	              }
	            }
	            currentBuffer = numBuffers;
	          }
	          currentBuffer--;
	          var buffer = colBuffers[currentBuffer];
	          this.extend(buffer, bufferPadding, height);
	          this.filter(buffer, bufferPadding, height);
	          if (currentBuffer === 0) {
	            k = u - numBuffers + 1;
	            for (l = bufferPadding; l < ll; k += width, l++) {
	              for (b = 0; b < numBuffers; b++) {
	                items[k + b] = colBuffers[b][l];
	              }
	            }
	          }
	        }
	      }
	      return {
	        width: width,
	        height: height,
	        items: items
	      };
	    };
	    return Transform;
	  }();
	  var IrreversibleTransform = function IrreversibleTransformClosure() {
	    function IrreversibleTransform() {
	      Transform.call(this);
	    }
	    IrreversibleTransform.prototype = Object.create(Transform.prototype);
	    IrreversibleTransform.prototype.filter = function irreversibleTransformFilter(x, offset, length) {
	      var len = length >> 1;
	      offset = offset | 0;
	      var j, n, current, next;
	      var alpha = -1.586134342059924;
	      var beta = -0.052980118572961;
	      var gamma = 0.882911075530934;
	      var delta = 0.443506852043971;
	      var K = 1.230174104914001;
	      var K_ = 1 / K;
	      j = offset - 3;
	      for (n = len + 4; n--; j += 2) {
	        x[j] *= K_;
	      }
	      j = offset - 2;
	      current = delta * x[j - 1];
	      for (n = len + 3; n--; j += 2) {
	        next = delta * x[j + 1];
	        x[j] = K * x[j] - current - next;
	        if (n--) {
	          j += 2;
	          current = delta * x[j + 1];
	          x[j] = K * x[j] - current - next;
	        } else {
	          break;
	        }
	      }
	      j = offset - 1;
	      current = gamma * x[j - 1];
	      for (n = len + 2; n--; j += 2) {
	        next = gamma * x[j + 1];
	        x[j] -= current + next;
	        if (n--) {
	          j += 2;
	          current = gamma * x[j + 1];
	          x[j] -= current + next;
	        } else {
	          break;
	        }
	      }
	      j = offset;
	      current = beta * x[j - 1];
	      for (n = len + 1; n--; j += 2) {
	        next = beta * x[j + 1];
	        x[j] -= current + next;
	        if (n--) {
	          j += 2;
	          current = beta * x[j + 1];
	          x[j] -= current + next;
	        } else {
	          break;
	        }
	      }
	      if (len !== 0) {
	        j = offset + 1;
	        current = alpha * x[j - 1];
	        for (n = len; n--; j += 2) {
	          next = alpha * x[j + 1];
	          x[j] -= current + next;
	          if (n--) {
	            j += 2;
	            current = alpha * x[j + 1];
	            x[j] -= current + next;
	          } else {
	            break;
	          }
	        }
	      }
	    };
	    return IrreversibleTransform;
	  }();
	  var ReversibleTransform = function ReversibleTransformClosure() {
	    function ReversibleTransform() {
	      Transform.call(this);
	    }
	    ReversibleTransform.prototype = Object.create(Transform.prototype);
	    ReversibleTransform.prototype.filter = function reversibleTransformFilter(x, offset, length) {
	      var len = length >> 1;
	      offset = offset | 0;
	      var j, n;
	      for (j = offset, n = len + 1; n--; j += 2) {
	        x[j] -= x[j - 1] + x[j + 1] + 2 >> 2;
	      }
	      for (j = offset + 1, n = len; n--; j += 2) {
	        x[j] += x[j - 1] + x[j + 1] >> 1;
	      }
	    };
	    return ReversibleTransform;
	  }();
	  return JpxImage;
	}();
	exports.JpxImage = JpxImage;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var coreCrypto = __w_pdfjs_require__(13);
	var coreParser = __w_pdfjs_require__(5);
	var coreChunkedStream = __w_pdfjs_require__(12);
	var coreColorSpace = __w_pdfjs_require__(3);
	var InvalidPDFException = sharedUtil.InvalidPDFException;
	var MissingDataException = sharedUtil.MissingDataException;
	var XRefParseException = sharedUtil.XRefParseException;
	var assert = sharedUtil.assert;
	var bytesToString = sharedUtil.bytesToString;
	var createPromiseCapability = sharedUtil.createPromiseCapability;
	var error = sharedUtil.error;
	var info = sharedUtil.info;
	var isArray = sharedUtil.isArray;
	var isBool = sharedUtil.isBool;
	var isInt = sharedUtil.isInt;
	var isString = sharedUtil.isString;
	var shadow = sharedUtil.shadow;
	var stringToPDFString = sharedUtil.stringToPDFString;
	var stringToUTF8String = sharedUtil.stringToUTF8String;
	var warn = sharedUtil.warn;
	var createValidAbsoluteUrl = sharedUtil.createValidAbsoluteUrl;
	var Util = sharedUtil.Util;
	var Dict = corePrimitives.Dict;
	var Ref = corePrimitives.Ref;
	var RefSet = corePrimitives.RefSet;
	var RefSetCache = corePrimitives.RefSetCache;
	var isName = corePrimitives.isName;
	var isCmd = corePrimitives.isCmd;
	var isDict = corePrimitives.isDict;
	var isRef = corePrimitives.isRef;
	var isRefsEqual = corePrimitives.isRefsEqual;
	var isStream = corePrimitives.isStream;
	var CipherTransformFactory = coreCrypto.CipherTransformFactory;
	var Lexer = coreParser.Lexer;
	var Parser = coreParser.Parser;
	var ChunkedStream = coreChunkedStream.ChunkedStream;
	var ColorSpace = coreColorSpace.ColorSpace;
	var Catalog = function CatalogClosure() {
	  function Catalog(pdfManager, xref, pageFactory) {
	    this.pdfManager = pdfManager;
	    this.xref = xref;
	    this.catDict = xref.getCatalogObj();
	    assert(isDict(this.catDict), 'catalog object is not a dictionary');
	    this.fontCache = new RefSetCache();
	    this.builtInCMapCache = Object.create(null);
	    this.pageKidsCountCache = new RefSetCache();
	    this.pageFactory = pageFactory;
	    this.pagePromises = [];
	  }
	  Catalog.prototype = {
	    get metadata() {
	      var streamRef = this.catDict.getRaw('Metadata');
	      if (!isRef(streamRef)) {
	        return shadow(this, 'metadata', null);
	      }
	      var encryptMetadata = !this.xref.encrypt ? false : this.xref.encrypt.encryptMetadata;
	      var stream = this.xref.fetch(streamRef, !encryptMetadata);
	      var metadata;
	      if (stream && isDict(stream.dict)) {
	        var type = stream.dict.get('Type');
	        var subtype = stream.dict.get('Subtype');
	        if (isName(type, 'Metadata') && isName(subtype, 'XML')) {
	          try {
	            metadata = stringToUTF8String(bytesToString(stream.getBytes()));
	          } catch (e) {
	            if (e instanceof MissingDataException) {
	              throw e;
	            }
	            info('Skipping invalid metadata.');
	          }
	        }
	      }
	      return shadow(this, 'metadata', metadata);
	    },
	    get toplevelPagesDict() {
	      var pagesObj = this.catDict.get('Pages');
	      assert(isDict(pagesObj), 'invalid top-level pages dictionary');
	      return shadow(this, 'toplevelPagesDict', pagesObj);
	    },
	    get documentOutline() {
	      var obj = null;
	      try {
	        obj = this.readDocumentOutline();
	      } catch (ex) {
	        if (ex instanceof MissingDataException) {
	          throw ex;
	        }
	        warn('Unable to read document outline');
	      }
	      return shadow(this, 'documentOutline', obj);
	    },
	    readDocumentOutline: function Catalog_readDocumentOutline() {
	      var obj = this.catDict.get('Outlines');
	      if (!isDict(obj)) {
	        return null;
	      }
	      obj = obj.getRaw('First');
	      if (!isRef(obj)) {
	        return null;
	      }
	      var root = { items: [] };
	      var queue = [{
	        obj: obj,
	        parent: root
	      }];
	      var processed = new RefSet();
	      processed.put(obj);
	      var xref = this.xref,
	          blackColor = new Uint8Array(3);
	      while (queue.length > 0) {
	        var i = queue.shift();
	        var outlineDict = xref.fetchIfRef(i.obj);
	        if (outlineDict === null) {
	          continue;
	        }
	        assert(outlineDict.has('Title'), 'Invalid outline item');
	        var data = {
	          url: null,
	          dest: null
	        };
	        Catalog.parseDestDictionary({
	          destDict: outlineDict,
	          resultObj: data,
	          docBaseUrl: this.pdfManager.docBaseUrl
	        });
	        var title = outlineDict.get('Title');
	        var flags = outlineDict.get('F') || 0;
	        var color = outlineDict.getArray('C'),
	            rgbColor = blackColor;
	        if (isArray(color) && color.length === 3 && (color[0] !== 0 || color[1] !== 0 || color[2] !== 0)) {
	          rgbColor = ColorSpace.singletons.rgb.getRgb(color, 0);
	        }
	        var outlineItem = {
	          dest: data.dest,
	          url: data.url,
	          unsafeUrl: data.unsafeUrl,
	          newWindow: data.newWindow,
	          title: stringToPDFString(title),
	          color: rgbColor,
	          count: outlineDict.get('Count'),
	          bold: !!(flags & 2),
	          italic: !!(flags & 1),
	          items: []
	        };
	        i.parent.items.push(outlineItem);
	        obj = outlineDict.getRaw('First');
	        if (isRef(obj) && !processed.has(obj)) {
	          queue.push({
	            obj: obj,
	            parent: outlineItem
	          });
	          processed.put(obj);
	        }
	        obj = outlineDict.getRaw('Next');
	        if (isRef(obj) && !processed.has(obj)) {
	          queue.push({
	            obj: obj,
	            parent: i.parent
	          });
	          processed.put(obj);
	        }
	      }
	      return root.items.length > 0 ? root.items : null;
	    },
	    get numPages() {
	      var obj = this.toplevelPagesDict.get('Count');
	      assert(isInt(obj), 'page count in top level pages object is not an integer');
	      return shadow(this, 'num', obj);
	    },
	    get destinations() {
	      function fetchDestination(dest) {
	        return isDict(dest) ? dest.get('D') : dest;
	      }
	      var xref = this.xref;
	      var dests = {},
	          nameTreeRef,
	          nameDictionaryRef;
	      var obj = this.catDict.get('Names');
	      if (obj && obj.has('Dests')) {
	        nameTreeRef = obj.getRaw('Dests');
	      } else if (this.catDict.has('Dests')) {
	        nameDictionaryRef = this.catDict.get('Dests');
	      }
	      if (nameDictionaryRef) {
	        obj = nameDictionaryRef;
	        obj.forEach(function catalogForEach(key, value) {
	          if (!value) {
	            return;
	          }
	          dests[key] = fetchDestination(value);
	        });
	      }
	      if (nameTreeRef) {
	        var nameTree = new NameTree(nameTreeRef, xref);
	        var names = nameTree.getAll();
	        for (var name in names) {
	          dests[name] = fetchDestination(names[name]);
	        }
	      }
	      return shadow(this, 'destinations', dests);
	    },
	    getDestination: function Catalog_getDestination(destinationId) {
	      function fetchDestination(dest) {
	        return isDict(dest) ? dest.get('D') : dest;
	      }
	      var xref = this.xref;
	      var dest = null,
	          nameTreeRef,
	          nameDictionaryRef;
	      var obj = this.catDict.get('Names');
	      if (obj && obj.has('Dests')) {
	        nameTreeRef = obj.getRaw('Dests');
	      } else if (this.catDict.has('Dests')) {
	        nameDictionaryRef = this.catDict.get('Dests');
	      }
	      if (nameDictionaryRef) {
	        var value = nameDictionaryRef.get(destinationId);
	        if (value) {
	          dest = fetchDestination(value);
	        }
	      }
	      if (nameTreeRef) {
	        var nameTree = new NameTree(nameTreeRef, xref);
	        dest = fetchDestination(nameTree.get(destinationId));
	      }
	      return dest;
	    },
	    get pageLabels() {
	      var obj = null;
	      try {
	        obj = this.readPageLabels();
	      } catch (ex) {
	        if (ex instanceof MissingDataException) {
	          throw ex;
	        }
	        warn('Unable to read page labels.');
	      }
	      return shadow(this, 'pageLabels', obj);
	    },
	    readPageLabels: function Catalog_readPageLabels() {
	      var obj = this.catDict.getRaw('PageLabels');
	      if (!obj) {
	        return null;
	      }
	      var pageLabels = new Array(this.numPages);
	      var style = null;
	      var prefix = '';
	      var numberTree = new NumberTree(obj, this.xref);
	      var nums = numberTree.getAll();
	      var currentLabel = '',
	          currentIndex = 1;
	      for (var i = 0, ii = this.numPages; i < ii; i++) {
	        if (i in nums) {
	          var labelDict = nums[i];
	          assert(isDict(labelDict), 'The PageLabel is not a dictionary.');
	          var type = labelDict.get('Type');
	          assert(!type || isName(type, 'PageLabel'), 'Invalid type in PageLabel dictionary.');
	          var s = labelDict.get('S');
	          assert(!s || isName(s), 'Invalid style in PageLabel dictionary.');
	          style = s ? s.name : null;
	          var p = labelDict.get('P');
	          assert(!p || isString(p), 'Invalid prefix in PageLabel dictionary.');
	          prefix = p ? stringToPDFString(p) : '';
	          var st = labelDict.get('St');
	          assert(!st || isInt(st) && st >= 1, 'Invalid start in PageLabel dictionary.');
	          currentIndex = st || 1;
	        }
	        switch (style) {
	          case 'D':
	            currentLabel = currentIndex;
	            break;
	          case 'R':
	          case 'r':
	            currentLabel = Util.toRoman(currentIndex, style === 'r');
	            break;
	          case 'A':
	          case 'a':
	            var LIMIT = 26;
	            var A_UPPER_CASE = 0x41,
	                A_LOWER_CASE = 0x61;
	            var baseCharCode = style === 'a' ? A_LOWER_CASE : A_UPPER_CASE;
	            var letterIndex = currentIndex - 1;
	            var character = String.fromCharCode(baseCharCode + letterIndex % LIMIT);
	            var charBuf = [];
	            for (var j = 0, jj = letterIndex / LIMIT | 0; j <= jj; j++) {
	              charBuf.push(character);
	            }
	            currentLabel = charBuf.join('');
	            break;
	          default:
	            assert(!style, 'Invalid style "' + style + '" in PageLabel dictionary.');
	        }
	        pageLabels[i] = prefix + currentLabel;
	        currentLabel = '';
	        currentIndex++;
	      }
	      return pageLabels;
	    },
	    get attachments() {
	      var xref = this.xref;
	      var attachments = null,
	          nameTreeRef;
	      var obj = this.catDict.get('Names');
	      if (obj) {
	        nameTreeRef = obj.getRaw('EmbeddedFiles');
	      }
	      if (nameTreeRef) {
	        var nameTree = new NameTree(nameTreeRef, xref);
	        var names = nameTree.getAll();
	        for (var name in names) {
	          var fs = new FileSpec(names[name], xref);
	          if (!attachments) {
	            attachments = Object.create(null);
	          }
	          attachments[stringToPDFString(name)] = fs.serializable;
	        }
	      }
	      return shadow(this, 'attachments', attachments);
	    },
	    get javaScript() {
	      var xref = this.xref;
	      var obj = this.catDict.get('Names');
	      var javaScript = [];
	      function appendIfJavaScriptDict(jsDict) {
	        var type = jsDict.get('S');
	        if (!isName(type, 'JavaScript')) {
	          return;
	        }
	        var js = jsDict.get('JS');
	        if (isStream(js)) {
	          js = bytesToString(js.getBytes());
	        } else if (!isString(js)) {
	          return;
	        }
	        javaScript.push(stringToPDFString(js));
	      }
	      if (obj && obj.has('JavaScript')) {
	        var nameTree = new NameTree(obj.getRaw('JavaScript'), xref);
	        var names = nameTree.getAll();
	        for (var name in names) {
	          var jsDict = names[name];
	          if (isDict(jsDict)) {
	            appendIfJavaScriptDict(jsDict);
	          }
	        }
	      }
	      var openactionDict = this.catDict.get('OpenAction');
	      if (isDict(openactionDict, 'Action')) {
	        var actionType = openactionDict.get('S');
	        if (isName(actionType, 'Named')) {
	          var action = openactionDict.get('N');
	          if (isName(action, 'Print')) {
	            javaScript.push('print({});');
	          }
	        } else {
	          appendIfJavaScriptDict(openactionDict);
	        }
	      }
	      return shadow(this, 'javaScript', javaScript);
	    },
	    cleanup: function Catalog_cleanup() {
	      var _this = this;
	
	      this.pageKidsCountCache.clear();
	      var promises = [];
	      this.fontCache.forEach(function (promise) {
	        promises.push(promise);
	      });
	      return Promise.all(promises).then(function (translatedFonts) {
	        for (var i = 0, ii = translatedFonts.length; i < ii; i++) {
	          var font = translatedFonts[i].dict;
	          delete font.translated;
	        }
	        _this.fontCache.clear();
	        _this.builtInCMapCache = Object.create(null);
	      });
	    },
	    getPage: function Catalog_getPage(pageIndex) {
	      var _this2 = this;
	
	      if (!(pageIndex in this.pagePromises)) {
	        this.pagePromises[pageIndex] = this.getPageDict(pageIndex).then(function (_ref) {
	          var _ref2 = _slicedToArray(_ref, 2),
	              dict = _ref2[0],
	              ref = _ref2[1];
	
	          return _this2.pageFactory.createPage(pageIndex, dict, ref, _this2.fontCache, _this2.builtInCMapCache);
	        });
	      }
	      return this.pagePromises[pageIndex];
	    },
	    getPageDict: function Catalog_getPageDict(pageIndex) {
	      var capability = createPromiseCapability();
	      var nodesToVisit = [this.catDict.getRaw('Pages')];
	      var count,
	          currentPageIndex = 0;
	      var xref = this.xref,
	          pageKidsCountCache = this.pageKidsCountCache;
	      function next() {
	        while (nodesToVisit.length) {
	          var currentNode = nodesToVisit.pop();
	          if (isRef(currentNode)) {
	            count = pageKidsCountCache.get(currentNode);
	            if (count > 0 && currentPageIndex + count < pageIndex) {
	              currentPageIndex += count;
	              continue;
	            }
	            xref.fetchAsync(currentNode).then(function (obj) {
	              if (isDict(obj, 'Page') || isDict(obj) && !obj.has('Kids')) {
	                if (pageIndex === currentPageIndex) {
	                  if (currentNode && !pageKidsCountCache.has(currentNode)) {
	                    pageKidsCountCache.put(currentNode, 1);
	                  }
	                  capability.resolve([obj, currentNode]);
	                } else {
	                  currentPageIndex++;
	                  next();
	                }
	                return;
	              }
	              nodesToVisit.push(obj);
	              next();
	            }, capability.reject);
	            return;
	          }
	          assert(isDict(currentNode), 'page dictionary kid reference points to wrong type of object');
	          count = currentNode.get('Count');
	          var objId = currentNode.objId;
	          if (objId && !pageKidsCountCache.has(objId)) {
	            pageKidsCountCache.put(objId, count);
	          }
	          if (currentPageIndex + count <= pageIndex) {
	            currentPageIndex += count;
	            continue;
	          }
	          var kids = currentNode.get('Kids');
	          assert(isArray(kids), 'page dictionary kids object is not an array');
	          for (var last = kids.length - 1; last >= 0; last--) {
	            nodesToVisit.push(kids[last]);
	          }
	        }
	        capability.reject('Page index ' + pageIndex + ' not found.');
	      }
	      next();
	      return capability.promise;
	    },
	    getPageIndex: function Catalog_getPageIndex(pageRef) {
	      var xref = this.xref;
	      function pagesBeforeRef(kidRef) {
	        var total = 0;
	        var parentRef;
	        return xref.fetchAsync(kidRef).then(function (node) {
	          if (isRefsEqual(kidRef, pageRef) && !isDict(node, 'Page') && !(isDict(node) && !node.has('Type') && node.has('Contents'))) {
	            throw new Error('The reference does not point to a /Page Dict.');
	          }
	          if (!node) {
	            return null;
	          }
	          assert(isDict(node), 'node must be a Dict.');
	          parentRef = node.getRaw('Parent');
	          return node.getAsync('Parent');
	        }).then(function (parent) {
	          if (!parent) {
	            return null;
	          }
	          assert(isDict(parent), 'parent must be a Dict.');
	          return parent.getAsync('Kids');
	        }).then(function (kids) {
	          if (!kids) {
	            return null;
	          }
	          var kidPromises = [];
	          var found = false;
	          for (var i = 0; i < kids.length; i++) {
	            var kid = kids[i];
	            assert(isRef(kid), 'kid must be a Ref.');
	            if (kid.num === kidRef.num) {
	              found = true;
	              break;
	            }
	            kidPromises.push(xref.fetchAsync(kid).then(function (kid) {
	              if (kid.has('Count')) {
	                var count = kid.get('Count');
	                total += count;
	              } else {
	                total++;
	              }
	            }));
	          }
	          if (!found) {
	            error('kid ref not found in parents kids');
	          }
	          return Promise.all(kidPromises).then(function () {
	            return [total, parentRef];
	          });
	        });
	      }
	      var total = 0;
	      function next(ref) {
	        return pagesBeforeRef(ref).then(function (args) {
	          if (!args) {
	            return total;
	          }
	          var count = args[0];
	          var parentRef = args[1];
	          total += count;
	          return next(parentRef);
	        });
	      }
	      return next(pageRef);
	    }
	  };
	  Catalog.parseDestDictionary = function Catalog_parseDestDictionary(params) {
	    function addDefaultProtocolToUrl(url) {
	      if (url.indexOf('www.') === 0) {
	        return 'http://' + url;
	      }
	      return url;
	    }
	    function tryConvertUrlEncoding(url) {
	      try {
	        return stringToUTF8String(url);
	      } catch (e) {
	        return url;
	      }
	    }
	    var destDict = params.destDict;
	    if (!isDict(destDict)) {
	      warn('Catalog_parseDestDictionary: "destDict" must be a dictionary.');
	      return;
	    }
	    var resultObj = params.resultObj;
	    if ((typeof resultObj === 'undefined' ? 'undefined' : _typeof(resultObj)) !== 'object') {
	      warn('Catalog_parseDestDictionary: "resultObj" must be an object.');
	      return;
	    }
	    var docBaseUrl = params.docBaseUrl || null;
	    var action = destDict.get('A'),
	        url,
	        dest;
	    if (isDict(action)) {
	      var linkType = action.get('S').name;
	      switch (linkType) {
	        case 'URI':
	          url = action.get('URI');
	          if (isName(url)) {
	            url = '/' + url.name;
	          } else if (isString(url)) {
	            url = addDefaultProtocolToUrl(url);
	          }
	          break;
	        case 'GoTo':
	          dest = action.get('D');
	          break;
	        case 'Launch':
	        case 'GoToR':
	          var urlDict = action.get('F');
	          if (isDict(urlDict)) {
	            url = urlDict.get('F') || null;
	          } else if (isString(urlDict)) {
	            url = urlDict;
	          }
	          var remoteDest = action.get('D');
	          if (remoteDest) {
	            if (isName(remoteDest)) {
	              remoteDest = remoteDest.name;
	            }
	            if (isString(url)) {
	              var baseUrl = url.split('#')[0];
	              if (isString(remoteDest)) {
	                url = baseUrl + '#' + (/^\d+$/.test(remoteDest) ? 'nameddest=' : '') + remoteDest;
	              } else if (isArray(remoteDest)) {
	                url = baseUrl + '#' + JSON.stringify(remoteDest);
	              }
	            }
	          }
	          var newWindow = action.get('NewWindow');
	          if (isBool(newWindow)) {
	            resultObj.newWindow = newWindow;
	          }
	          break;
	        case 'Named':
	          var namedAction = action.get('N');
	          if (isName(namedAction)) {
	            resultObj.action = namedAction.name;
	          }
	          break;
	        case 'JavaScript':
	          var jsAction = action.get('JS'),
	              js;
	          if (isStream(jsAction)) {
	            js = bytesToString(jsAction.getBytes());
	          } else if (isString(jsAction)) {
	            js = jsAction;
	          }
	          if (js) {
	            var URL_OPEN_METHODS = ['app.launchURL', 'window.open'];
	            var regex = new RegExp('^\\s*(' + URL_OPEN_METHODS.join('|').split('.').join('\\.') + ')\\((?:\'|\")([^\'\"]*)(?:\'|\")(?:,\\s*(\\w+)\\)|\\))', 'i');
	            var jsUrl = regex.exec(stringToPDFString(js));
	            if (jsUrl && jsUrl[2]) {
	              url = jsUrl[2];
	              if (jsUrl[3] === 'true' && jsUrl[1] === 'app.launchURL') {
	                resultObj.newWindow = true;
	              }
	              break;
	            }
	          }
	        default:
	          warn('Catalog_parseDestDictionary: Unrecognized link type "' + linkType + '".');
	          break;
	      }
	    } else if (destDict.has('Dest')) {
	      dest = destDict.get('Dest');
	    }
	    if (isString(url)) {
	      url = tryConvertUrlEncoding(url);
	      var absoluteUrl = createValidAbsoluteUrl(url, docBaseUrl);
	      if (absoluteUrl) {
	        resultObj.url = absoluteUrl.href;
	      }
	      resultObj.unsafeUrl = url;
	    }
	    if (dest) {
	      if (isName(dest)) {
	        dest = dest.name;
	      }
	      if (isString(dest) || isArray(dest)) {
	        resultObj.dest = dest;
	      }
	    }
	  };
	  return Catalog;
	}();
	var XRef = function XRefClosure() {
	  function XRef(stream, pdfManager) {
	    this.stream = stream;
	    this.pdfManager = pdfManager;
	    this.entries = [];
	    this.xrefstms = Object.create(null);
	    this.cache = [];
	    this.stats = {
	      streamTypes: [],
	      fontTypes: []
	    };
	  }
	  XRef.prototype = {
	    setStartXRef: function XRef_setStartXRef(startXRef) {
	      this.startXRefQueue = [startXRef];
	    },
	    parse: function XRef_parse(recoveryMode) {
	      var trailerDict;
	      if (!recoveryMode) {
	        trailerDict = this.readXRef();
	      } else {
	        warn('Indexing all PDF objects');
	        trailerDict = this.indexObjects();
	      }
	      trailerDict.assignXref(this);
	      this.trailer = trailerDict;
	      var encrypt = trailerDict.get('Encrypt');
	      if (isDict(encrypt)) {
	        var ids = trailerDict.get('ID');
	        var fileId = ids && ids.length ? ids[0] : '';
	        encrypt.suppressEncryption = true;
	        this.encrypt = new CipherTransformFactory(encrypt, fileId, this.pdfManager.password);
	      }
	      if (!(this.root = trailerDict.get('Root'))) {
	        error('Invalid root reference');
	      }
	    },
	    processXRefTable: function XRef_processXRefTable(parser) {
	      if (!('tableState' in this)) {
	        this.tableState = {
	          entryNum: 0,
	          streamPos: parser.lexer.stream.pos,
	          parserBuf1: parser.buf1,
	          parserBuf2: parser.buf2
	        };
	      }
	      var obj = this.readXRefTable(parser);
	      if (!isCmd(obj, 'trailer')) {
	        error('Invalid XRef table: could not find trailer dictionary');
	      }
	      var dict = parser.getObj();
	      if (!isDict(dict) && dict.dict) {
	        dict = dict.dict;
	      }
	      if (!isDict(dict)) {
	        error('Invalid XRef table: could not parse trailer dictionary');
	      }
	      delete this.tableState;
	      return dict;
	    },
	    readXRefTable: function XRef_readXRefTable(parser) {
	      var stream = parser.lexer.stream;
	      var tableState = this.tableState;
	      stream.pos = tableState.streamPos;
	      parser.buf1 = tableState.parserBuf1;
	      parser.buf2 = tableState.parserBuf2;
	      var obj;
	      while (true) {
	        if (!('firstEntryNum' in tableState) || !('entryCount' in tableState)) {
	          if (isCmd(obj = parser.getObj(), 'trailer')) {
	            break;
	          }
	          tableState.firstEntryNum = obj;
	          tableState.entryCount = parser.getObj();
	        }
	        var first = tableState.firstEntryNum;
	        var count = tableState.entryCount;
	        if (!isInt(first) || !isInt(count)) {
	          error('Invalid XRef table: wrong types in subsection header');
	        }
	        for (var i = tableState.entryNum; i < count; i++) {
	          tableState.streamPos = stream.pos;
	          tableState.entryNum = i;
	          tableState.parserBuf1 = parser.buf1;
	          tableState.parserBuf2 = parser.buf2;
	          var entry = {};
	          entry.offset = parser.getObj();
	          entry.gen = parser.getObj();
	          var type = parser.getObj();
	          if (isCmd(type, 'f')) {
	            entry.free = true;
	          } else if (isCmd(type, 'n')) {
	            entry.uncompressed = true;
	          }
	          if (!isInt(entry.offset) || !isInt(entry.gen) || !(entry.free || entry.uncompressed)) {
	            error('Invalid entry in XRef subsection: ' + first + ', ' + count);
	          }
	          if (i === 0 && entry.free && first === 1) {
	            first = 0;
	          }
	          if (!this.entries[i + first]) {
	            this.entries[i + first] = entry;
	          }
	        }
	        tableState.entryNum = 0;
	        tableState.streamPos = stream.pos;
	        tableState.parserBuf1 = parser.buf1;
	        tableState.parserBuf2 = parser.buf2;
	        delete tableState.firstEntryNum;
	        delete tableState.entryCount;
	      }
	      if (this.entries[0] && !this.entries[0].free) {
	        error('Invalid XRef table: unexpected first object');
	      }
	      return obj;
	    },
	    processXRefStream: function XRef_processXRefStream(stream) {
	      if (!('streamState' in this)) {
	        var streamParameters = stream.dict;
	        var byteWidths = streamParameters.get('W');
	        var range = streamParameters.get('Index');
	        if (!range) {
	          range = [0, streamParameters.get('Size')];
	        }
	        this.streamState = {
	          entryRanges: range,
	          byteWidths: byteWidths,
	          entryNum: 0,
	          streamPos: stream.pos
	        };
	      }
	      this.readXRefStream(stream);
	      delete this.streamState;
	      return stream.dict;
	    },
	    readXRefStream: function XRef_readXRefStream(stream) {
	      var i, j;
	      var streamState = this.streamState;
	      stream.pos = streamState.streamPos;
	      var byteWidths = streamState.byteWidths;
	      var typeFieldWidth = byteWidths[0];
	      var offsetFieldWidth = byteWidths[1];
	      var generationFieldWidth = byteWidths[2];
	      var entryRanges = streamState.entryRanges;
	      while (entryRanges.length > 0) {
	        var first = entryRanges[0];
	        var n = entryRanges[1];
	        if (!isInt(first) || !isInt(n)) {
	          error('Invalid XRef range fields: ' + first + ', ' + n);
	        }
	        if (!isInt(typeFieldWidth) || !isInt(offsetFieldWidth) || !isInt(generationFieldWidth)) {
	          error('Invalid XRef entry fields length: ' + first + ', ' + n);
	        }
	        for (i = streamState.entryNum; i < n; ++i) {
	          streamState.entryNum = i;
	          streamState.streamPos = stream.pos;
	          var type = 0,
	              offset = 0,
	              generation = 0;
	          for (j = 0; j < typeFieldWidth; ++j) {
	            type = type << 8 | stream.getByte();
	          }
	          if (typeFieldWidth === 0) {
	            type = 1;
	          }
	          for (j = 0; j < offsetFieldWidth; ++j) {
	            offset = offset << 8 | stream.getByte();
	          }
	          for (j = 0; j < generationFieldWidth; ++j) {
	            generation = generation << 8 | stream.getByte();
	          }
	          var entry = {};
	          entry.offset = offset;
	          entry.gen = generation;
	          switch (type) {
	            case 0:
	              entry.free = true;
	              break;
	            case 1:
	              entry.uncompressed = true;
	              break;
	            case 2:
	              break;
	            default:
	              error('Invalid XRef entry type: ' + type);
	          }
	          if (!this.entries[first + i]) {
	            this.entries[first + i] = entry;
	          }
	        }
	        streamState.entryNum = 0;
	        streamState.streamPos = stream.pos;
	        entryRanges.splice(0, 2);
	      }
	    },
	    indexObjects: function XRef_indexObjects() {
	      var TAB = 0x9,
	          LF = 0xA,
	          CR = 0xD,
	          SPACE = 0x20;
	      var PERCENT = 0x25,
	          LT = 0x3C;
	      function readToken(data, offset) {
	        var token = '',
	            ch = data[offset];
	        while (ch !== LF && ch !== CR && ch !== LT) {
	          if (++offset >= data.length) {
	            break;
	          }
	          token += String.fromCharCode(ch);
	          ch = data[offset];
	        }
	        return token;
	      }
	      function skipUntil(data, offset, what) {
	        var length = what.length,
	            dataLength = data.length;
	        var skipped = 0;
	        while (offset < dataLength) {
	          var i = 0;
	          while (i < length && data[offset + i] === what[i]) {
	            ++i;
	          }
	          if (i >= length) {
	            break;
	          }
	          offset++;
	          skipped++;
	        }
	        return skipped;
	      }
	      var objRegExp = /^(\d+)\s+(\d+)\s+obj\b/;
	      var trailerBytes = new Uint8Array([116, 114, 97, 105, 108, 101, 114]);
	      var startxrefBytes = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]);
	      var endobjBytes = new Uint8Array([101, 110, 100, 111, 98, 106]);
	      var xrefBytes = new Uint8Array([47, 88, 82, 101, 102]);
	      this.entries.length = 0;
	      var stream = this.stream;
	      stream.pos = 0;
	      var buffer = stream.getBytes();
	      var position = stream.start,
	          length = buffer.length;
	      var trailers = [],
	          xrefStms = [];
	      while (position < length) {
	        var ch = buffer[position];
	        if (ch === TAB || ch === LF || ch === CR || ch === SPACE) {
	          ++position;
	          continue;
	        }
	        if (ch === PERCENT) {
	          do {
	            ++position;
	            if (position >= length) {
	              break;
	            }
	            ch = buffer[position];
	          } while (ch !== LF && ch !== CR);
	          continue;
	        }
	        var token = readToken(buffer, position);
	        var m;
	        if (token.indexOf('xref') === 0 && (token.length === 4 || /\s/.test(token[4]))) {
	          position += skipUntil(buffer, position, trailerBytes);
	          trailers.push(position);
	          position += skipUntil(buffer, position, startxrefBytes);
	        } else if (m = objRegExp.exec(token)) {
	          if (typeof this.entries[m[1]] === 'undefined') {
	            this.entries[m[1]] = {
	              offset: position - stream.start,
	              gen: m[2] | 0,
	              uncompressed: true
	            };
	          }
	          var contentLength = skipUntil(buffer, position, endobjBytes) + 7;
	          var content = buffer.subarray(position, position + contentLength);
	          var xrefTagOffset = skipUntil(content, 0, xrefBytes);
	          if (xrefTagOffset < contentLength && content[xrefTagOffset + 5] < 64) {
	            xrefStms.push(position - stream.start);
	            this.xrefstms[position - stream.start] = 1;
	          }
	          position += contentLength;
	        } else if (token.indexOf('trailer') === 0 && (token.length === 7 || /\s/.test(token[7]))) {
	          trailers.push(position);
	          position += skipUntil(buffer, position, startxrefBytes);
	        } else {
	          position += token.length + 1;
	        }
	      }
	      var i, ii;
	      for (i = 0, ii = xrefStms.length; i < ii; ++i) {
	        this.startXRefQueue.push(xrefStms[i]);
	        this.readXRef(true);
	      }
	      var dict;
	      for (i = 0, ii = trailers.length; i < ii; ++i) {
	        stream.pos = trailers[i];
	        var parser = new Parser(new Lexer(stream), true, this, true);
	        var obj = parser.getObj();
	        if (!isCmd(obj, 'trailer')) {
	          continue;
	        }
	        dict = parser.getObj();
	        if (!isDict(dict)) {
	          continue;
	        }
	        if (dict.has('ID')) {
	          return dict;
	        }
	      }
	      if (dict) {
	        return dict;
	      }
	      throw new InvalidPDFException('Invalid PDF structure');
	    },
	    readXRef: function XRef_readXRef(recoveryMode) {
	      var stream = this.stream;
	      try {
	        while (this.startXRefQueue.length) {
	          var startXRef = this.startXRefQueue[0];
	          stream.pos = startXRef + stream.start;
	          var parser = new Parser(new Lexer(stream), true, this);
	          var obj = parser.getObj();
	          var dict;
	          if (isCmd(obj, 'xref')) {
	            dict = this.processXRefTable(parser);
	            if (!this.topDict) {
	              this.topDict = dict;
	            }
	            obj = dict.get('XRefStm');
	            if (isInt(obj)) {
	              var pos = obj;
	              if (!(pos in this.xrefstms)) {
	                this.xrefstms[pos] = 1;
	                this.startXRefQueue.push(pos);
	              }
	            }
	          } else if (isInt(obj)) {
	            if (!isInt(parser.getObj()) || !isCmd(parser.getObj(), 'obj') || !isStream(obj = parser.getObj())) {
	              error('Invalid XRef stream');
	            }
	            dict = this.processXRefStream(obj);
	            if (!this.topDict) {
	              this.topDict = dict;
	            }
	            if (!dict) {
	              error('Failed to read XRef stream');
	            }
	          } else {
	            error('Invalid XRef stream header');
	          }
	          obj = dict.get('Prev');
	          if (isInt(obj)) {
	            this.startXRefQueue.push(obj);
	          } else if (isRef(obj)) {
	            this.startXRefQueue.push(obj.num);
	          }
	          this.startXRefQueue.shift();
	        }
	        return this.topDict;
	      } catch (e) {
	        if (e instanceof MissingDataException) {
	          throw e;
	        }
	        info('(while reading XRef): ' + e);
	      }
	      if (recoveryMode) {
	        return;
	      }
	      throw new XRefParseException();
	    },
	    getEntry: function XRef_getEntry(i) {
	      var xrefEntry = this.entries[i];
	      if (xrefEntry && !xrefEntry.free && xrefEntry.offset) {
	        return xrefEntry;
	      }
	      return null;
	    },
	    fetchIfRef: function XRef_fetchIfRef(obj, suppressEncryption) {
	      if (!isRef(obj)) {
	        return obj;
	      }
	      return this.fetch(obj, suppressEncryption);
	    },
	    fetch: function XRef_fetch(ref, suppressEncryption) {
	      assert(isRef(ref), 'ref object is not a reference');
	      var num = ref.num;
	      if (num in this.cache) {
	        var cacheEntry = this.cache[num];
	        if (cacheEntry instanceof Dict && !cacheEntry.objId) {
	          cacheEntry.objId = ref.toString();
	        }
	        return cacheEntry;
	      }
	      var xrefEntry = this.getEntry(num);
	      if (xrefEntry === null) {
	        return this.cache[num] = null;
	      }
	      if (xrefEntry.uncompressed) {
	        xrefEntry = this.fetchUncompressed(ref, xrefEntry, suppressEncryption);
	      } else {
	        xrefEntry = this.fetchCompressed(xrefEntry, suppressEncryption);
	      }
	      if (isDict(xrefEntry)) {
	        xrefEntry.objId = ref.toString();
	      } else if (isStream(xrefEntry)) {
	        xrefEntry.dict.objId = ref.toString();
	      }
	      return xrefEntry;
	    },
	    fetchUncompressed: function XRef_fetchUncompressed(ref, xrefEntry, suppressEncryption) {
	      var gen = ref.gen;
	      var num = ref.num;
	      if (xrefEntry.gen !== gen) {
	        error('inconsistent generation in XRef');
	      }
	      var stream = this.stream.makeSubStream(xrefEntry.offset + this.stream.start);
	      var parser = new Parser(new Lexer(stream), true, this);
	      var obj1 = parser.getObj();
	      var obj2 = parser.getObj();
	      var obj3 = parser.getObj();
	      if (!isInt(obj1) || parseInt(obj1, 10) !== num || !isInt(obj2) || parseInt(obj2, 10) !== gen || !isCmd(obj3)) {
	        error('bad XRef entry');
	      }
	      if (!isCmd(obj3, 'obj')) {
	        if (obj3.cmd.indexOf('obj') === 0) {
	          num = parseInt(obj3.cmd.substring(3), 10);
	          if (!isNaN(num)) {
	            return num;
	          }
	        }
	        error('bad XRef entry');
	      }
	      if (this.encrypt && !suppressEncryption) {
	        xrefEntry = parser.getObj(this.encrypt.createCipherTransform(num, gen));
	      } else {
	        xrefEntry = parser.getObj();
	      }
	      if (!isStream(xrefEntry)) {
	        this.cache[num] = xrefEntry;
	      }
	      return xrefEntry;
	    },
	    fetchCompressed: function XRef_fetchCompressed(xrefEntry, suppressEncryption) {
	      var tableOffset = xrefEntry.offset;
	      var stream = this.fetch(new Ref(tableOffset, 0));
	      if (!isStream(stream)) {
	        error('bad ObjStm stream');
	      }
	      var first = stream.dict.get('First');
	      var n = stream.dict.get('N');
	      if (!isInt(first) || !isInt(n)) {
	        error('invalid first and n parameters for ObjStm stream');
	      }
	      var parser = new Parser(new Lexer(stream), false, this);
	      parser.allowStreams = true;
	      var i,
	          entries = [],
	          num,
	          nums = [];
	      for (i = 0; i < n; ++i) {
	        num = parser.getObj();
	        if (!isInt(num)) {
	          error('invalid object number in the ObjStm stream: ' + num);
	        }
	        nums.push(num);
	        var offset = parser.getObj();
	        if (!isInt(offset)) {
	          error('invalid object offset in the ObjStm stream: ' + offset);
	        }
	      }
	      for (i = 0; i < n; ++i) {
	        entries.push(parser.getObj());
	        if (isCmd(parser.buf1, 'endobj')) {
	          parser.shift();
	        }
	        num = nums[i];
	        var entry = this.entries[num];
	        if (entry && entry.offset === tableOffset && entry.gen === i) {
	          this.cache[num] = entries[i];
	        }
	      }
	      xrefEntry = entries[xrefEntry.gen];
	      if (xrefEntry === undefined) {
	        error('bad XRef entry for compressed object');
	      }
	      return xrefEntry;
	    },
	    fetchIfRefAsync: function XRef_fetchIfRefAsync(obj, suppressEncryption) {
	      if (!isRef(obj)) {
	        return Promise.resolve(obj);
	      }
	      return this.fetchAsync(obj, suppressEncryption);
	    },
	    fetchAsync: function XRef_fetchAsync(ref, suppressEncryption) {
	      var streamManager = this.stream.manager;
	      var xref = this;
	      return new Promise(function tryFetch(resolve, reject) {
	        try {
	          resolve(xref.fetch(ref, suppressEncryption));
	        } catch (e) {
	          if (e instanceof MissingDataException) {
	            streamManager.requestRange(e.begin, e.end).then(function () {
	              tryFetch(resolve, reject);
	            }, reject);
	            return;
	          }
	          reject(e);
	        }
	      });
	    },
	    getCatalogObj: function XRef_getCatalogObj() {
	      return this.root;
	    }
	  };
	  return XRef;
	}();
	var NameOrNumberTree = function NameOrNumberTreeClosure() {
	  function NameOrNumberTree(root, xref) {
	    throw new Error('Cannot initialize NameOrNumberTree.');
	  }
	  NameOrNumberTree.prototype = {
	    getAll: function NameOrNumberTree_getAll() {
	      var dict = Object.create(null);
	      if (!this.root) {
	        return dict;
	      }
	      var xref = this.xref;
	      var processed = new RefSet();
	      processed.put(this.root);
	      var queue = [this.root];
	      while (queue.length > 0) {
	        var i, n;
	        var obj = xref.fetchIfRef(queue.shift());
	        if (!isDict(obj)) {
	          continue;
	        }
	        if (obj.has('Kids')) {
	          var kids = obj.get('Kids');
	          for (i = 0, n = kids.length; i < n; i++) {
	            var kid = kids[i];
	            assert(!processed.has(kid), 'Duplicate entry in "' + this._type + '" tree.');
	            queue.push(kid);
	            processed.put(kid);
	          }
	          continue;
	        }
	        var entries = obj.get(this._type);
	        if (isArray(entries)) {
	          for (i = 0, n = entries.length; i < n; i += 2) {
	            dict[xref.fetchIfRef(entries[i])] = xref.fetchIfRef(entries[i + 1]);
	          }
	        }
	      }
	      return dict;
	    },
	    get: function NameOrNumberTree_get(key) {
	      if (!this.root) {
	        return null;
	      }
	      var xref = this.xref;
	      var kidsOrEntries = xref.fetchIfRef(this.root);
	      var loopCount = 0;
	      var MAX_LEVELS = 10;
	      var l, r, m;
	      while (kidsOrEntries.has('Kids')) {
	        if (++loopCount > MAX_LEVELS) {
	          warn('Search depth limit reached for "' + this._type + '" tree.');
	          return null;
	        }
	        var kids = kidsOrEntries.get('Kids');
	        if (!isArray(kids)) {
	          return null;
	        }
	        l = 0;
	        r = kids.length - 1;
	        while (l <= r) {
	          m = l + r >> 1;
	          var kid = xref.fetchIfRef(kids[m]);
	          var limits = kid.get('Limits');
	          if (key < xref.fetchIfRef(limits[0])) {
	            r = m - 1;
	          } else if (key > xref.fetchIfRef(limits[1])) {
	            l = m + 1;
	          } else {
	            kidsOrEntries = xref.fetchIfRef(kids[m]);
	            break;
	          }
	        }
	        if (l > r) {
	          return null;
	        }
	      }
	      var entries = kidsOrEntries.get(this._type);
	      if (isArray(entries)) {
	        l = 0;
	        r = entries.length - 2;
	        while (l <= r) {
	          m = l + r & ~1;
	          var currentKey = xref.fetchIfRef(entries[m]);
	          if (key < currentKey) {
	            r = m - 2;
	          } else if (key > currentKey) {
	            l = m + 2;
	          } else {
	            return xref.fetchIfRef(entries[m + 1]);
	          }
	        }
	      }
	      return null;
	    }
	  };
	  return NameOrNumberTree;
	}();
	var NameTree = function NameTreeClosure() {
	  function NameTree(root, xref) {
	    this.root = root;
	    this.xref = xref;
	    this._type = 'Names';
	  }
	  Util.inherit(NameTree, NameOrNumberTree, {});
	  return NameTree;
	}();
	var NumberTree = function NumberTreeClosure() {
	  function NumberTree(root, xref) {
	    this.root = root;
	    this.xref = xref;
	    this._type = 'Nums';
	  }
	  Util.inherit(NumberTree, NameOrNumberTree, {});
	  return NumberTree;
	}();
	var FileSpec = function FileSpecClosure() {
	  function FileSpec(root, xref) {
	    if (!root || !isDict(root)) {
	      return;
	    }
	    this.xref = xref;
	    this.root = root;
	    if (root.has('FS')) {
	      this.fs = root.get('FS');
	    }
	    this.description = root.has('Desc') ? stringToPDFString(root.get('Desc')) : '';
	    if (root.has('RF')) {
	      warn('Related file specifications are not supported');
	    }
	    this.contentAvailable = true;
	    if (!root.has('EF')) {
	      this.contentAvailable = false;
	      warn('Non-embedded file specifications are not supported');
	    }
	  }
	  function pickPlatformItem(dict) {
	    if (dict.has('UF')) {
	      return dict.get('UF');
	    } else if (dict.has('F')) {
	      return dict.get('F');
	    } else if (dict.has('Unix')) {
	      return dict.get('Unix');
	    } else if (dict.has('Mac')) {
	      return dict.get('Mac');
	    } else if (dict.has('DOS')) {
	      return dict.get('DOS');
	    }
	    return null;
	  }
	  FileSpec.prototype = {
	    get filename() {
	      if (!this._filename && this.root) {
	        var filename = pickPlatformItem(this.root) || 'unnamed';
	        this._filename = stringToPDFString(filename).replace(/\\\\/g, '\\').replace(/\\\//g, '/').replace(/\\/g, '/');
	      }
	      return this._filename;
	    },
	    get content() {
	      if (!this.contentAvailable) {
	        return null;
	      }
	      if (!this.contentRef && this.root) {
	        this.contentRef = pickPlatformItem(this.root.get('EF'));
	      }
	      var content = null;
	      if (this.contentRef) {
	        var xref = this.xref;
	        var fileObj = xref.fetchIfRef(this.contentRef);
	        if (fileObj && isStream(fileObj)) {
	          content = fileObj.getBytes();
	        } else {
	          warn('Embedded file specification points to non-existing/invalid ' + 'content');
	        }
	      } else {
	        warn('Embedded file specification does not have a content');
	      }
	      return content;
	    },
	    get serializable() {
	      return {
	        filename: this.filename,
	        content: this.content
	      };
	    }
	  };
	  return FileSpec;
	}();
	var ObjectLoader = function () {
	  function mayHaveChildren(value) {
	    return isRef(value) || isDict(value) || isArray(value) || isStream(value);
	  }
	  function addChildren(node, nodesToVisit) {
	    var value;
	    if (isDict(node) || isStream(node)) {
	      var map;
	      if (isDict(node)) {
	        map = node.map;
	      } else {
	        map = node.dict.map;
	      }
	      for (var key in map) {
	        value = map[key];
	        if (mayHaveChildren(value)) {
	          nodesToVisit.push(value);
	        }
	      }
	    } else if (isArray(node)) {
	      for (var i = 0, ii = node.length; i < ii; i++) {
	        value = node[i];
	        if (mayHaveChildren(value)) {
	          nodesToVisit.push(value);
	        }
	      }
	    }
	  }
	  function ObjectLoader(obj, keys, xref) {
	    this.obj = obj;
	    this.keys = keys;
	    this.xref = xref;
	    this.refSet = null;
	    this.capability = null;
	  }
	  ObjectLoader.prototype = {
	    load: function ObjectLoader_load() {
	      var keys = this.keys;
	      this.capability = createPromiseCapability();
	      if (!(this.xref.stream instanceof ChunkedStream) || this.xref.stream.getMissingChunks().length === 0) {
	        this.capability.resolve();
	        return this.capability.promise;
	      }
	      this.refSet = new RefSet();
	      var nodesToVisit = [];
	      for (var i = 0; i < keys.length; i++) {
	        nodesToVisit.push(this.obj[keys[i]]);
	      }
	      this._walk(nodesToVisit);
	      return this.capability.promise;
	    },
	    _walk: function ObjectLoader_walk(nodesToVisit) {
	      var _this3 = this;
	
	      var nodesToRevisit = [];
	      var pendingRequests = [];
	      while (nodesToVisit.length) {
	        var currentNode = nodesToVisit.pop();
	        if (isRef(currentNode)) {
	          if (this.refSet.has(currentNode)) {
	            continue;
	          }
	          try {
	            var ref = currentNode;
	            this.refSet.put(ref);
	            currentNode = this.xref.fetch(currentNode);
	          } catch (e) {
	            if (!(e instanceof MissingDataException)) {
	              throw e;
	            }
	            nodesToRevisit.push(currentNode);
	            pendingRequests.push({
	              begin: e.begin,
	              end: e.end
	            });
	          }
	        }
	        if (currentNode && currentNode.getBaseStreams) {
	          var baseStreams = currentNode.getBaseStreams();
	          var foundMissingData = false;
	          for (var i = 0; i < baseStreams.length; i++) {
	            var stream = baseStreams[i];
	            if (stream.getMissingChunks && stream.getMissingChunks().length) {
	              foundMissingData = true;
	              pendingRequests.push({
	                begin: stream.start,
	                end: stream.end
	              });
	            }
	          }
	          if (foundMissingData) {
	            nodesToRevisit.push(currentNode);
	          }
	        }
	        addChildren(currentNode, nodesToVisit);
	      }
	      if (pendingRequests.length) {
	        this.xref.stream.manager.requestRanges(pendingRequests).then(function () {
	          nodesToVisit = nodesToRevisit;
	          for (var i = 0; i < nodesToRevisit.length; i++) {
	            var node = nodesToRevisit[i];
	            if (isRef(node)) {
	              _this3.refSet.remove(node);
	            }
	          }
	          _this3._walk(nodesToVisit);
	        }, this.capability.reject);
	        return;
	      }
	      this.refSet = null;
	      this.capability.resolve();
	    }
	  };
	  return ObjectLoader;
	}();
	exports.Catalog = Catalog;
	exports.ObjectLoader = ObjectLoader;
	exports.XRef = XRef;
	exports.FileSpec = FileSpec;
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var getLookupTableFactory = sharedUtil.getLookupTableFactory;
	var getStdFontMap = getLookupTableFactory(function (t) {
	  t['ArialNarrow'] = 'Helvetica';
	  t['ArialNarrow-Bold'] = 'Helvetica-Bold';
	  t['ArialNarrow-BoldItalic'] = 'Helvetica-BoldOblique';
	  t['ArialNarrow-Italic'] = 'Helvetica-Oblique';
	  t['ArialBlack'] = 'Helvetica';
	  t['ArialBlack-Bold'] = 'Helvetica-Bold';
	  t['ArialBlack-BoldItalic'] = 'Helvetica-BoldOblique';
	  t['ArialBlack-Italic'] = 'Helvetica-Oblique';
	  t['Arial-Black'] = 'Helvetica';
	  t['Arial-Black-Bold'] = 'Helvetica-Bold';
	  t['Arial-Black-BoldItalic'] = 'Helvetica-BoldOblique';
	  t['Arial-Black-Italic'] = 'Helvetica-Oblique';
	  t['Arial'] = 'Helvetica';
	  t['Arial-Bold'] = 'Helvetica-Bold';
	  t['Arial-BoldItalic'] = 'Helvetica-BoldOblique';
	  t['Arial-Italic'] = 'Helvetica-Oblique';
	  t['Arial-BoldItalicMT'] = 'Helvetica-BoldOblique';
	  t['Arial-BoldMT'] = 'Helvetica-Bold';
	  t['Arial-ItalicMT'] = 'Helvetica-Oblique';
	  t['ArialMT'] = 'Helvetica';
	  t['Courier-Bold'] = 'Courier-Bold';
	  t['Courier-BoldItalic'] = 'Courier-BoldOblique';
	  t['Courier-Italic'] = 'Courier-Oblique';
	  t['CourierNew'] = 'Courier';
	  t['CourierNew-Bold'] = 'Courier-Bold';
	  t['CourierNew-BoldItalic'] = 'Courier-BoldOblique';
	  t['CourierNew-Italic'] = 'Courier-Oblique';
	  t['CourierNewPS-BoldItalicMT'] = 'Courier-BoldOblique';
	  t['CourierNewPS-BoldMT'] = 'Courier-Bold';
	  t['CourierNewPS-ItalicMT'] = 'Courier-Oblique';
	  t['CourierNewPSMT'] = 'Courier';
	  t['Helvetica'] = 'Helvetica';
	  t['Helvetica-Bold'] = 'Helvetica-Bold';
	  t['Helvetica-BoldItalic'] = 'Helvetica-BoldOblique';
	  t['Helvetica-BoldOblique'] = 'Helvetica-BoldOblique';
	  t['Helvetica-Italic'] = 'Helvetica-Oblique';
	  t['Helvetica-Oblique'] = 'Helvetica-Oblique';
	  t['Symbol-Bold'] = 'Symbol';
	  t['Symbol-BoldItalic'] = 'Symbol';
	  t['Symbol-Italic'] = 'Symbol';
	  t['TimesNewRoman'] = 'Times-Roman';
	  t['TimesNewRoman-Bold'] = 'Times-Bold';
	  t['TimesNewRoman-BoldItalic'] = 'Times-BoldItalic';
	  t['TimesNewRoman-Italic'] = 'Times-Italic';
	  t['TimesNewRomanPS'] = 'Times-Roman';
	  t['TimesNewRomanPS-Bold'] = 'Times-Bold';
	  t['TimesNewRomanPS-BoldItalic'] = 'Times-BoldItalic';
	  t['TimesNewRomanPS-BoldItalicMT'] = 'Times-BoldItalic';
	  t['TimesNewRomanPS-BoldMT'] = 'Times-Bold';
	  t['TimesNewRomanPS-Italic'] = 'Times-Italic';
	  t['TimesNewRomanPS-ItalicMT'] = 'Times-Italic';
	  t['TimesNewRomanPSMT'] = 'Times-Roman';
	  t['TimesNewRomanPSMT-Bold'] = 'Times-Bold';
	  t['TimesNewRomanPSMT-BoldItalic'] = 'Times-BoldItalic';
	  t['TimesNewRomanPSMT-Italic'] = 'Times-Italic';
	});
	var getNonStdFontMap = getLookupTableFactory(function (t) {
	  t['CenturyGothic'] = 'Helvetica';
	  t['CenturyGothic-Bold'] = 'Helvetica-Bold';
	  t['CenturyGothic-BoldItalic'] = 'Helvetica-BoldOblique';
	  t['CenturyGothic-Italic'] = 'Helvetica-Oblique';
	  t['ComicSansMS'] = 'Comic Sans MS';
	  t['ComicSansMS-Bold'] = 'Comic Sans MS-Bold';
	  t['ComicSansMS-BoldItalic'] = 'Comic Sans MS-BoldItalic';
	  t['ComicSansMS-Italic'] = 'Comic Sans MS-Italic';
	  t['LucidaConsole'] = 'Courier';
	  t['LucidaConsole-Bold'] = 'Courier-Bold';
	  t['LucidaConsole-BoldItalic'] = 'Courier-BoldOblique';
	  t['LucidaConsole-Italic'] = 'Courier-Oblique';
	  t['MS-Gothic'] = 'MS Gothic';
	  t['MS-Gothic-Bold'] = 'MS Gothic-Bold';
	  t['MS-Gothic-BoldItalic'] = 'MS Gothic-BoldItalic';
	  t['MS-Gothic-Italic'] = 'MS Gothic-Italic';
	  t['MS-Mincho'] = 'MS Mincho';
	  t['MS-Mincho-Bold'] = 'MS Mincho-Bold';
	  t['MS-Mincho-BoldItalic'] = 'MS Mincho-BoldItalic';
	  t['MS-Mincho-Italic'] = 'MS Mincho-Italic';
	  t['MS-PGothic'] = 'MS PGothic';
	  t['MS-PGothic-Bold'] = 'MS PGothic-Bold';
	  t['MS-PGothic-BoldItalic'] = 'MS PGothic-BoldItalic';
	  t['MS-PGothic-Italic'] = 'MS PGothic-Italic';
	  t['MS-PMincho'] = 'MS PMincho';
	  t['MS-PMincho-Bold'] = 'MS PMincho-Bold';
	  t['MS-PMincho-BoldItalic'] = 'MS PMincho-BoldItalic';
	  t['MS-PMincho-Italic'] = 'MS PMincho-Italic';
	  t['NuptialScript'] = 'Times-Italic';
	  t['Wingdings'] = 'ZapfDingbats';
	});
	var getSerifFonts = getLookupTableFactory(function (t) {
	  t['Adobe Jenson'] = true;
	  t['Adobe Text'] = true;
	  t['Albertus'] = true;
	  t['Aldus'] = true;
	  t['Alexandria'] = true;
	  t['Algerian'] = true;
	  t['American Typewriter'] = true;
	  t['Antiqua'] = true;
	  t['Apex'] = true;
	  t['Arno'] = true;
	  t['Aster'] = true;
	  t['Aurora'] = true;
	  t['Baskerville'] = true;
	  t['Bell'] = true;
	  t['Bembo'] = true;
	  t['Bembo Schoolbook'] = true;
	  t['Benguiat'] = true;
	  t['Berkeley Old Style'] = true;
	  t['Bernhard Modern'] = true;
	  t['Berthold City'] = true;
	  t['Bodoni'] = true;
	  t['Bauer Bodoni'] = true;
	  t['Book Antiqua'] = true;
	  t['Bookman'] = true;
	  t['Bordeaux Roman'] = true;
	  t['Californian FB'] = true;
	  t['Calisto'] = true;
	  t['Calvert'] = true;
	  t['Capitals'] = true;
	  t['Cambria'] = true;
	  t['Cartier'] = true;
	  t['Caslon'] = true;
	  t['Catull'] = true;
	  t['Centaur'] = true;
	  t['Century Old Style'] = true;
	  t['Century Schoolbook'] = true;
	  t['Chaparral'] = true;
	  t['Charis SIL'] = true;
	  t['Cheltenham'] = true;
	  t['Cholla Slab'] = true;
	  t['Clarendon'] = true;
	  t['Clearface'] = true;
	  t['Cochin'] = true;
	  t['Colonna'] = true;
	  t['Computer Modern'] = true;
	  t['Concrete Roman'] = true;
	  t['Constantia'] = true;
	  t['Cooper Black'] = true;
	  t['Corona'] = true;
	  t['Ecotype'] = true;
	  t['Egyptienne'] = true;
	  t['Elephant'] = true;
	  t['Excelsior'] = true;
	  t['Fairfield'] = true;
	  t['FF Scala'] = true;
	  t['Folkard'] = true;
	  t['Footlight'] = true;
	  t['FreeSerif'] = true;
	  t['Friz Quadrata'] = true;
	  t['Garamond'] = true;
	  t['Gentium'] = true;
	  t['Georgia'] = true;
	  t['Gloucester'] = true;
	  t['Goudy Old Style'] = true;
	  t['Goudy Schoolbook'] = true;
	  t['Goudy Pro Font'] = true;
	  t['Granjon'] = true;
	  t['Guardian Egyptian'] = true;
	  t['Heather'] = true;
	  t['Hercules'] = true;
	  t['High Tower Text'] = true;
	  t['Hiroshige'] = true;
	  t['Hoefler Text'] = true;
	  t['Humana Serif'] = true;
	  t['Imprint'] = true;
	  t['Ionic No. 5'] = true;
	  t['Janson'] = true;
	  t['Joanna'] = true;
	  t['Korinna'] = true;
	  t['Lexicon'] = true;
	  t['Liberation Serif'] = true;
	  t['Linux Libertine'] = true;
	  t['Literaturnaya'] = true;
	  t['Lucida'] = true;
	  t['Lucida Bright'] = true;
	  t['Melior'] = true;
	  t['Memphis'] = true;
	  t['Miller'] = true;
	  t['Minion'] = true;
	  t['Modern'] = true;
	  t['Mona Lisa'] = true;
	  t['Mrs Eaves'] = true;
	  t['MS Serif'] = true;
	  t['Museo Slab'] = true;
	  t['New York'] = true;
	  t['Nimbus Roman'] = true;
	  t['NPS Rawlinson Roadway'] = true;
	  t['NuptialScript'] = true;
	  t['Palatino'] = true;
	  t['Perpetua'] = true;
	  t['Plantin'] = true;
	  t['Plantin Schoolbook'] = true;
	  t['Playbill'] = true;
	  t['Poor Richard'] = true;
	  t['Rawlinson Roadway'] = true;
	  t['Renault'] = true;
	  t['Requiem'] = true;
	  t['Rockwell'] = true;
	  t['Roman'] = true;
	  t['Rotis Serif'] = true;
	  t['Sabon'] = true;
	  t['Scala'] = true;
	  t['Seagull'] = true;
	  t['Sistina'] = true;
	  t['Souvenir'] = true;
	  t['STIX'] = true;
	  t['Stone Informal'] = true;
	  t['Stone Serif'] = true;
	  t['Sylfaen'] = true;
	  t['Times'] = true;
	  t['Trajan'] = true;
	  t['Trinité'] = true;
	  t['Trump Mediaeval'] = true;
	  t['Utopia'] = true;
	  t['Vale Type'] = true;
	  t['Bitstream Vera'] = true;
	  t['Vera Serif'] = true;
	  t['Versailles'] = true;
	  t['Wanted'] = true;
	  t['Weiss'] = true;
	  t['Wide Latin'] = true;
	  t['Windsor'] = true;
	  t['XITS'] = true;
	});
	var getSymbolsFonts = getLookupTableFactory(function (t) {
	  t['Dingbats'] = true;
	  t['Symbol'] = true;
	  t['ZapfDingbats'] = true;
	});
	var getGlyphMapForStandardFonts = getLookupTableFactory(function (t) {
	  t[2] = 10;
	  t[3] = 32;
	  t[4] = 33;
	  t[5] = 34;
	  t[6] = 35;
	  t[7] = 36;
	  t[8] = 37;
	  t[9] = 38;
	  t[10] = 39;
	  t[11] = 40;
	  t[12] = 41;
	  t[13] = 42;
	  t[14] = 43;
	  t[15] = 44;
	  t[16] = 45;
	  t[17] = 46;
	  t[18] = 47;
	  t[19] = 48;
	  t[20] = 49;
	  t[21] = 50;
	  t[22] = 51;
	  t[23] = 52;
	  t[24] = 53;
	  t[25] = 54;
	  t[26] = 55;
	  t[27] = 56;
	  t[28] = 57;
	  t[29] = 58;
	  t[30] = 894;
	  t[31] = 60;
	  t[32] = 61;
	  t[33] = 62;
	  t[34] = 63;
	  t[35] = 64;
	  t[36] = 65;
	  t[37] = 66;
	  t[38] = 67;
	  t[39] = 68;
	  t[40] = 69;
	  t[41] = 70;
	  t[42] = 71;
	  t[43] = 72;
	  t[44] = 73;
	  t[45] = 74;
	  t[46] = 75;
	  t[47] = 76;
	  t[48] = 77;
	  t[49] = 78;
	  t[50] = 79;
	  t[51] = 80;
	  t[52] = 81;
	  t[53] = 82;
	  t[54] = 83;
	  t[55] = 84;
	  t[56] = 85;
	  t[57] = 86;
	  t[58] = 87;
	  t[59] = 88;
	  t[60] = 89;
	  t[61] = 90;
	  t[62] = 91;
	  t[63] = 92;
	  t[64] = 93;
	  t[65] = 94;
	  t[66] = 95;
	  t[67] = 96;
	  t[68] = 97;
	  t[69] = 98;
	  t[70] = 99;
	  t[71] = 100;
	  t[72] = 101;
	  t[73] = 102;
	  t[74] = 103;
	  t[75] = 104;
	  t[76] = 105;
	  t[77] = 106;
	  t[78] = 107;
	  t[79] = 108;
	  t[80] = 109;
	  t[81] = 110;
	  t[82] = 111;
	  t[83] = 112;
	  t[84] = 113;
	  t[85] = 114;
	  t[86] = 115;
	  t[87] = 116;
	  t[88] = 117;
	  t[89] = 118;
	  t[90] = 119;
	  t[91] = 120;
	  t[92] = 121;
	  t[93] = 122;
	  t[94] = 123;
	  t[95] = 124;
	  t[96] = 125;
	  t[97] = 126;
	  t[98] = 196;
	  t[99] = 197;
	  t[100] = 199;
	  t[101] = 201;
	  t[102] = 209;
	  t[103] = 214;
	  t[104] = 220;
	  t[105] = 225;
	  t[106] = 224;
	  t[107] = 226;
	  t[108] = 228;
	  t[109] = 227;
	  t[110] = 229;
	  t[111] = 231;
	  t[112] = 233;
	  t[113] = 232;
	  t[114] = 234;
	  t[115] = 235;
	  t[116] = 237;
	  t[117] = 236;
	  t[118] = 238;
	  t[119] = 239;
	  t[120] = 241;
	  t[121] = 243;
	  t[122] = 242;
	  t[123] = 244;
	  t[124] = 246;
	  t[125] = 245;
	  t[126] = 250;
	  t[127] = 249;
	  t[128] = 251;
	  t[129] = 252;
	  t[130] = 8224;
	  t[131] = 176;
	  t[132] = 162;
	  t[133] = 163;
	  t[134] = 167;
	  t[135] = 8226;
	  t[136] = 182;
	  t[137] = 223;
	  t[138] = 174;
	  t[139] = 169;
	  t[140] = 8482;
	  t[141] = 180;
	  t[142] = 168;
	  t[143] = 8800;
	  t[144] = 198;
	  t[145] = 216;
	  t[146] = 8734;
	  t[147] = 177;
	  t[148] = 8804;
	  t[149] = 8805;
	  t[150] = 165;
	  t[151] = 181;
	  t[152] = 8706;
	  t[153] = 8721;
	  t[154] = 8719;
	  t[156] = 8747;
	  t[157] = 170;
	  t[158] = 186;
	  t[159] = 8486;
	  t[160] = 230;
	  t[161] = 248;
	  t[162] = 191;
	  t[163] = 161;
	  t[164] = 172;
	  t[165] = 8730;
	  t[166] = 402;
	  t[167] = 8776;
	  t[168] = 8710;
	  t[169] = 171;
	  t[170] = 187;
	  t[171] = 8230;
	  t[210] = 218;
	  t[223] = 711;
	  t[224] = 321;
	  t[225] = 322;
	  t[227] = 353;
	  t[229] = 382;
	  t[234] = 253;
	  t[252] = 263;
	  t[253] = 268;
	  t[254] = 269;
	  t[258] = 258;
	  t[260] = 260;
	  t[261] = 261;
	  t[265] = 280;
	  t[266] = 281;
	  t[268] = 283;
	  t[269] = 313;
	  t[275] = 323;
	  t[276] = 324;
	  t[278] = 328;
	  t[284] = 345;
	  t[285] = 346;
	  t[286] = 347;
	  t[292] = 367;
	  t[295] = 377;
	  t[296] = 378;
	  t[298] = 380;
	  t[305] = 963;
	  t[306] = 964;
	  t[307] = 966;
	  t[308] = 8215;
	  t[309] = 8252;
	  t[310] = 8319;
	  t[311] = 8359;
	  t[312] = 8592;
	  t[313] = 8593;
	  t[337] = 9552;
	  t[493] = 1039;
	  t[494] = 1040;
	  t[705] = 1524;
	  t[706] = 8362;
	  t[710] = 64288;
	  t[711] = 64298;
	  t[759] = 1617;
	  t[761] = 1776;
	  t[763] = 1778;
	  t[775] = 1652;
	  t[777] = 1764;
	  t[778] = 1780;
	  t[779] = 1781;
	  t[780] = 1782;
	  t[782] = 771;
	  t[783] = 64726;
	  t[786] = 8363;
	  t[788] = 8532;
	  t[790] = 768;
	  t[791] = 769;
	  t[792] = 768;
	  t[795] = 803;
	  t[797] = 64336;
	  t[798] = 64337;
	  t[799] = 64342;
	  t[800] = 64343;
	  t[801] = 64344;
	  t[802] = 64345;
	  t[803] = 64362;
	  t[804] = 64363;
	  t[805] = 64364;
	  t[2424] = 7821;
	  t[2425] = 7822;
	  t[2426] = 7823;
	  t[2427] = 7824;
	  t[2428] = 7825;
	  t[2429] = 7826;
	  t[2430] = 7827;
	  t[2433] = 7682;
	  t[2678] = 8045;
	  t[2679] = 8046;
	  t[2830] = 1552;
	  t[2838] = 686;
	  t[2840] = 751;
	  t[2842] = 753;
	  t[2843] = 754;
	  t[2844] = 755;
	  t[2846] = 757;
	  t[2856] = 767;
	  t[2857] = 848;
	  t[2858] = 849;
	  t[2862] = 853;
	  t[2863] = 854;
	  t[2864] = 855;
	  t[2865] = 861;
	  t[2866] = 862;
	  t[2906] = 7460;
	  t[2908] = 7462;
	  t[2909] = 7463;
	  t[2910] = 7464;
	  t[2912] = 7466;
	  t[2913] = 7467;
	  t[2914] = 7468;
	  t[2916] = 7470;
	  t[2917] = 7471;
	  t[2918] = 7472;
	  t[2920] = 7474;
	  t[2921] = 7475;
	  t[2922] = 7476;
	  t[2924] = 7478;
	  t[2925] = 7479;
	  t[2926] = 7480;
	  t[2928] = 7482;
	  t[2929] = 7483;
	  t[2930] = 7484;
	  t[2932] = 7486;
	  t[2933] = 7487;
	  t[2934] = 7488;
	  t[2936] = 7490;
	  t[2937] = 7491;
	  t[2938] = 7492;
	  t[2940] = 7494;
	  t[2941] = 7495;
	  t[2942] = 7496;
	  t[2944] = 7498;
	  t[2946] = 7500;
	  t[2948] = 7502;
	  t[2950] = 7504;
	  t[2951] = 7505;
	  t[2952] = 7506;
	  t[2954] = 7508;
	  t[2955] = 7509;
	  t[2956] = 7510;
	  t[2958] = 7512;
	  t[2959] = 7513;
	  t[2960] = 7514;
	  t[2962] = 7516;
	  t[2963] = 7517;
	  t[2964] = 7518;
	  t[2966] = 7520;
	  t[2967] = 7521;
	  t[2968] = 7522;
	  t[2970] = 7524;
	  t[2971] = 7525;
	  t[2972] = 7526;
	  t[2974] = 7528;
	  t[2975] = 7529;
	  t[2976] = 7530;
	  t[2978] = 1537;
	  t[2979] = 1538;
	  t[2980] = 1539;
	  t[2982] = 1549;
	  t[2983] = 1551;
	  t[2984] = 1552;
	  t[2986] = 1554;
	  t[2987] = 1555;
	  t[2988] = 1556;
	  t[2990] = 1623;
	  t[2991] = 1624;
	  t[2995] = 1775;
	  t[2999] = 1791;
	  t[3002] = 64290;
	  t[3003] = 64291;
	  t[3004] = 64292;
	  t[3006] = 64294;
	  t[3007] = 64295;
	  t[3008] = 64296;
	  t[3011] = 1900;
	  t[3014] = 8223;
	  t[3015] = 8244;
	  t[3017] = 7532;
	  t[3018] = 7533;
	  t[3019] = 7534;
	  t[3075] = 7590;
	  t[3076] = 7591;
	  t[3079] = 7594;
	  t[3080] = 7595;
	  t[3083] = 7598;
	  t[3084] = 7599;
	  t[3087] = 7602;
	  t[3088] = 7603;
	  t[3091] = 7606;
	  t[3092] = 7607;
	  t[3095] = 7610;
	  t[3096] = 7611;
	  t[3099] = 7614;
	  t[3100] = 7615;
	  t[3103] = 7618;
	  t[3104] = 7619;
	  t[3107] = 8337;
	  t[3108] = 8338;
	  t[3116] = 1884;
	  t[3119] = 1885;
	  t[3120] = 1885;
	  t[3123] = 1886;
	  t[3124] = 1886;
	  t[3127] = 1887;
	  t[3128] = 1887;
	  t[3131] = 1888;
	  t[3132] = 1888;
	  t[3135] = 1889;
	  t[3136] = 1889;
	  t[3139] = 1890;
	  t[3140] = 1890;
	  t[3143] = 1891;
	  t[3144] = 1891;
	  t[3147] = 1892;
	  t[3148] = 1892;
	  t[3153] = 580;
	  t[3154] = 581;
	  t[3157] = 584;
	  t[3158] = 585;
	  t[3161] = 588;
	  t[3162] = 589;
	  t[3165] = 891;
	  t[3166] = 892;
	  t[3169] = 1274;
	  t[3170] = 1275;
	  t[3173] = 1278;
	  t[3174] = 1279;
	  t[3181] = 7622;
	  t[3182] = 7623;
	  t[3282] = 11799;
	  t[3316] = 578;
	  t[3379] = 42785;
	  t[3393] = 1159;
	  t[3416] = 8377;
	});
	var getSupplementalGlyphMapForArialBlack = getLookupTableFactory(function (t) {
	  t[227] = 322;
	  t[264] = 261;
	  t[291] = 346;
	});
	exports.getStdFontMap = getStdFontMap;
	exports.getNonStdFontMap = getNonStdFontMap;
	exports.getSerifFonts = getSerifFonts;
	exports.getSymbolsFonts = getSymbolsFonts;
	exports.getGlyphMapForStandardFonts = getGlyphMapForStandardFonts;
	exports.getSupplementalGlyphMapForArialBlack = getSupplementalGlyphMapForArialBlack;
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var getLookupTableFactory = sharedUtil.getLookupTableFactory;
	var getSpecialPUASymbols = getLookupTableFactory(function (t) {
	  t[63721] = 0x00A9;
	  t[63193] = 0x00A9;
	  t[63720] = 0x00AE;
	  t[63194] = 0x00AE;
	  t[63722] = 0x2122;
	  t[63195] = 0x2122;
	  t[63729] = 0x23A7;
	  t[63730] = 0x23A8;
	  t[63731] = 0x23A9;
	  t[63740] = 0x23AB;
	  t[63741] = 0x23AC;
	  t[63742] = 0x23AD;
	  t[63726] = 0x23A1;
	  t[63727] = 0x23A2;
	  t[63728] = 0x23A3;
	  t[63737] = 0x23A4;
	  t[63738] = 0x23A5;
	  t[63739] = 0x23A6;
	  t[63723] = 0x239B;
	  t[63724] = 0x239C;
	  t[63725] = 0x239D;
	  t[63734] = 0x239E;
	  t[63735] = 0x239F;
	  t[63736] = 0x23A0;
	});
	function mapSpecialUnicodeValues(code) {
	  if (code >= 0xFFF0 && code <= 0xFFFF) {
	    return 0;
	  } else if (code >= 0xF600 && code <= 0xF8FF) {
	    return getSpecialPUASymbols()[code] || code;
	  }
	  return code;
	}
	function getUnicodeForGlyph(name, glyphsUnicodeMap) {
	  var unicode = glyphsUnicodeMap[name];
	  if (unicode !== undefined) {
	    return unicode;
	  }
	  if (!name) {
	    return -1;
	  }
	  if (name[0] === 'u') {
	    var nameLen = name.length,
	        hexStr;
	    if (nameLen === 7 && name[1] === 'n' && name[2] === 'i') {
	      hexStr = name.substr(3);
	    } else if (nameLen >= 5 && nameLen <= 7) {
	      hexStr = name.substr(1);
	    } else {
	      return -1;
	    }
	    if (hexStr === hexStr.toUpperCase()) {
	      unicode = parseInt(hexStr, 16);
	      if (unicode >= 0) {
	        return unicode;
	      }
	    }
	  }
	  return -1;
	}
	var UnicodeRanges = [{
	  'begin': 0x0000,
	  'end': 0x007F
	}, {
	  'begin': 0x0080,
	  'end': 0x00FF
	}, {
	  'begin': 0x0100,
	  'end': 0x017F
	}, {
	  'begin': 0x0180,
	  'end': 0x024F
	}, {
	  'begin': 0x0250,
	  'end': 0x02AF
	}, {
	  'begin': 0x02B0,
	  'end': 0x02FF
	}, {
	  'begin': 0x0300,
	  'end': 0x036F
	}, {
	  'begin': 0x0370,
	  'end': 0x03FF
	}, {
	  'begin': 0x2C80,
	  'end': 0x2CFF
	}, {
	  'begin': 0x0400,
	  'end': 0x04FF
	}, {
	  'begin': 0x0530,
	  'end': 0x058F
	}, {
	  'begin': 0x0590,
	  'end': 0x05FF
	}, {
	  'begin': 0xA500,
	  'end': 0xA63F
	}, {
	  'begin': 0x0600,
	  'end': 0x06FF
	}, {
	  'begin': 0x07C0,
	  'end': 0x07FF
	}, {
	  'begin': 0x0900,
	  'end': 0x097F
	}, {
	  'begin': 0x0980,
	  'end': 0x09FF
	}, {
	  'begin': 0x0A00,
	  'end': 0x0A7F
	}, {
	  'begin': 0x0A80,
	  'end': 0x0AFF
	}, {
	  'begin': 0x0B00,
	  'end': 0x0B7F
	}, {
	  'begin': 0x0B80,
	  'end': 0x0BFF
	}, {
	  'begin': 0x0C00,
	  'end': 0x0C7F
	}, {
	  'begin': 0x0C80,
	  'end': 0x0CFF
	}, {
	  'begin': 0x0D00,
	  'end': 0x0D7F
	}, {
	  'begin': 0x0E00,
	  'end': 0x0E7F
	}, {
	  'begin': 0x0E80,
	  'end': 0x0EFF
	}, {
	  'begin': 0x10A0,
	  'end': 0x10FF
	}, {
	  'begin': 0x1B00,
	  'end': 0x1B7F
	}, {
	  'begin': 0x1100,
	  'end': 0x11FF
	}, {
	  'begin': 0x1E00,
	  'end': 0x1EFF
	}, {
	  'begin': 0x1F00,
	  'end': 0x1FFF
	}, {
	  'begin': 0x2000,
	  'end': 0x206F
	}, {
	  'begin': 0x2070,
	  'end': 0x209F
	}, {
	  'begin': 0x20A0,
	  'end': 0x20CF
	}, {
	  'begin': 0x20D0,
	  'end': 0x20FF
	}, {
	  'begin': 0x2100,
	  'end': 0x214F
	}, {
	  'begin': 0x2150,
	  'end': 0x218F
	}, {
	  'begin': 0x2190,
	  'end': 0x21FF
	}, {
	  'begin': 0x2200,
	  'end': 0x22FF
	}, {
	  'begin': 0x2300,
	  'end': 0x23FF
	}, {
	  'begin': 0x2400,
	  'end': 0x243F
	}, {
	  'begin': 0x2440,
	  'end': 0x245F
	}, {
	  'begin': 0x2460,
	  'end': 0x24FF
	}, {
	  'begin': 0x2500,
	  'end': 0x257F
	}, {
	  'begin': 0x2580,
	  'end': 0x259F
	}, {
	  'begin': 0x25A0,
	  'end': 0x25FF
	}, {
	  'begin': 0x2600,
	  'end': 0x26FF
	}, {
	  'begin': 0x2700,
	  'end': 0x27BF
	}, {
	  'begin': 0x3000,
	  'end': 0x303F
	}, {
	  'begin': 0x3040,
	  'end': 0x309F
	}, {
	  'begin': 0x30A0,
	  'end': 0x30FF
	}, {
	  'begin': 0x3100,
	  'end': 0x312F
	}, {
	  'begin': 0x3130,
	  'end': 0x318F
	}, {
	  'begin': 0xA840,
	  'end': 0xA87F
	}, {
	  'begin': 0x3200,
	  'end': 0x32FF
	}, {
	  'begin': 0x3300,
	  'end': 0x33FF
	}, {
	  'begin': 0xAC00,
	  'end': 0xD7AF
	}, {
	  'begin': 0xD800,
	  'end': 0xDFFF
	}, {
	  'begin': 0x10900,
	  'end': 0x1091F
	}, {
	  'begin': 0x4E00,
	  'end': 0x9FFF
	}, {
	  'begin': 0xE000,
	  'end': 0xF8FF
	}, {
	  'begin': 0x31C0,
	  'end': 0x31EF
	}, {
	  'begin': 0xFB00,
	  'end': 0xFB4F
	}, {
	  'begin': 0xFB50,
	  'end': 0xFDFF
	}, {
	  'begin': 0xFE20,
	  'end': 0xFE2F
	}, {
	  'begin': 0xFE10,
	  'end': 0xFE1F
	}, {
	  'begin': 0xFE50,
	  'end': 0xFE6F
	}, {
	  'begin': 0xFE70,
	  'end': 0xFEFF
	}, {
	  'begin': 0xFF00,
	  'end': 0xFFEF
	}, {
	  'begin': 0xFFF0,
	  'end': 0xFFFF
	}, {
	  'begin': 0x0F00,
	  'end': 0x0FFF
	}, {
	  'begin': 0x0700,
	  'end': 0x074F
	}, {
	  'begin': 0x0780,
	  'end': 0x07BF
	}, {
	  'begin': 0x0D80,
	  'end': 0x0DFF
	}, {
	  'begin': 0x1000,
	  'end': 0x109F
	}, {
	  'begin': 0x1200,
	  'end': 0x137F
	}, {
	  'begin': 0x13A0,
	  'end': 0x13FF
	}, {
	  'begin': 0x1400,
	  'end': 0x167F
	}, {
	  'begin': 0x1680,
	  'end': 0x169F
	}, {
	  'begin': 0x16A0,
	  'end': 0x16FF
	}, {
	  'begin': 0x1780,
	  'end': 0x17FF
	}, {
	  'begin': 0x1800,
	  'end': 0x18AF
	}, {
	  'begin': 0x2800,
	  'end': 0x28FF
	}, {
	  'begin': 0xA000,
	  'end': 0xA48F
	}, {
	  'begin': 0x1700,
	  'end': 0x171F
	}, {
	  'begin': 0x10300,
	  'end': 0x1032F
	}, {
	  'begin': 0x10330,
	  'end': 0x1034F
	}, {
	  'begin': 0x10400,
	  'end': 0x1044F
	}, {
	  'begin': 0x1D000,
	  'end': 0x1D0FF
	}, {
	  'begin': 0x1D400,
	  'end': 0x1D7FF
	}, {
	  'begin': 0xFF000,
	  'end': 0xFFFFD
	}, {
	  'begin': 0xFE00,
	  'end': 0xFE0F
	}, {
	  'begin': 0xE0000,
	  'end': 0xE007F
	}, {
	  'begin': 0x1900,
	  'end': 0x194F
	}, {
	  'begin': 0x1950,
	  'end': 0x197F
	}, {
	  'begin': 0x1980,
	  'end': 0x19DF
	}, {
	  'begin': 0x1A00,
	  'end': 0x1A1F
	}, {
	  'begin': 0x2C00,
	  'end': 0x2C5F
	}, {
	  'begin': 0x2D30,
	  'end': 0x2D7F
	}, {
	  'begin': 0x4DC0,
	  'end': 0x4DFF
	}, {
	  'begin': 0xA800,
	  'end': 0xA82F
	}, {
	  'begin': 0x10000,
	  'end': 0x1007F
	}, {
	  'begin': 0x10140,
	  'end': 0x1018F
	}, {
	  'begin': 0x10380,
	  'end': 0x1039F
	}, {
	  'begin': 0x103A0,
	  'end': 0x103DF
	}, {
	  'begin': 0x10450,
	  'end': 0x1047F
	}, {
	  'begin': 0x10480,
	  'end': 0x104AF
	}, {
	  'begin': 0x10800,
	  'end': 0x1083F
	}, {
	  'begin': 0x10A00,
	  'end': 0x10A5F
	}, {
	  'begin': 0x1D300,
	  'end': 0x1D35F
	}, {
	  'begin': 0x12000,
	  'end': 0x123FF
	}, {
	  'begin': 0x1D360,
	  'end': 0x1D37F
	}, {
	  'begin': 0x1B80,
	  'end': 0x1BBF
	}, {
	  'begin': 0x1C00,
	  'end': 0x1C4F
	}, {
	  'begin': 0x1C50,
	  'end': 0x1C7F
	}, {
	  'begin': 0xA880,
	  'end': 0xA8DF
	}, {
	  'begin': 0xA900,
	  'end': 0xA92F
	}, {
	  'begin': 0xA930,
	  'end': 0xA95F
	}, {
	  'begin': 0xAA00,
	  'end': 0xAA5F
	}, {
	  'begin': 0x10190,
	  'end': 0x101CF
	}, {
	  'begin': 0x101D0,
	  'end': 0x101FF
	}, {
	  'begin': 0x102A0,
	  'end': 0x102DF
	}, {
	  'begin': 0x1F030,
	  'end': 0x1F09F
	}];
	function getUnicodeRangeFor(value) {
	  for (var i = 0, ii = UnicodeRanges.length; i < ii; i++) {
	    var range = UnicodeRanges[i];
	    if (value >= range.begin && value < range.end) {
	      return i;
	    }
	  }
	  return -1;
	}
	function isRTLRangeFor(value) {
	  var range = UnicodeRanges[13];
	  if (value >= range.begin && value < range.end) {
	    return true;
	  }
	  range = UnicodeRanges[11];
	  if (value >= range.begin && value < range.end) {
	    return true;
	  }
	  return false;
	}
	var getNormalizedUnicodes = getLookupTableFactory(function (t) {
	  t['\xA8'] = ' \u0308';
	  t['\xAF'] = ' \u0304';
	  t['\xB4'] = ' \u0301';
	  t['\xB5'] = '\u03BC';
	  t['\xB8'] = ' \u0327';
	  t['\u0132'] = 'IJ';
	  t['\u0133'] = 'ij';
	  t['\u013F'] = 'L\xB7';
	  t['\u0140'] = 'l\xB7';
	  t['\u0149'] = '\u02BCn';
	  t['\u017F'] = 's';
	  t['\u01C4'] = 'D\u017D';
	  t['\u01C5'] = 'D\u017E';
	  t['\u01C6'] = 'd\u017E';
	  t['\u01C7'] = 'LJ';
	  t['\u01C8'] = 'Lj';
	  t['\u01C9'] = 'lj';
	  t['\u01CA'] = 'NJ';
	  t['\u01CB'] = 'Nj';
	  t['\u01CC'] = 'nj';
	  t['\u01F1'] = 'DZ';
	  t['\u01F2'] = 'Dz';
	  t['\u01F3'] = 'dz';
	  t['\u02D8'] = ' \u0306';
	  t['\u02D9'] = ' \u0307';
	  t['\u02DA'] = ' \u030A';
	  t['\u02DB'] = ' \u0328';
	  t['\u02DC'] = ' \u0303';
	  t['\u02DD'] = ' \u030B';
	  t['\u037A'] = ' \u0345';
	  t['\u0384'] = ' \u0301';
	  t['\u03D0'] = '\u03B2';
	  t['\u03D1'] = '\u03B8';
	  t['\u03D2'] = '\u03A5';
	  t['\u03D5'] = '\u03C6';
	  t['\u03D6'] = '\u03C0';
	  t['\u03F0'] = '\u03BA';
	  t['\u03F1'] = '\u03C1';
	  t['\u03F2'] = '\u03C2';
	  t['\u03F4'] = '\u0398';
	  t['\u03F5'] = '\u03B5';
	  t['\u03F9'] = '\u03A3';
	  t['\u0587'] = '\u0565\u0582';
	  t['\u0675'] = '\u0627\u0674';
	  t['\u0676'] = '\u0648\u0674';
	  t['\u0677'] = '\u06C7\u0674';
	  t['\u0678'] = '\u064A\u0674';
	  t['\u0E33'] = '\u0E4D\u0E32';
	  t['\u0EB3'] = '\u0ECD\u0EB2';
	  t['\u0EDC'] = '\u0EAB\u0E99';
	  t['\u0EDD'] = '\u0EAB\u0EA1';
	  t['\u0F77'] = '\u0FB2\u0F81';
	  t['\u0F79'] = '\u0FB3\u0F81';
	  t['\u1E9A'] = 'a\u02BE';
	  t['\u1FBD'] = ' \u0313';
	  t['\u1FBF'] = ' \u0313';
	  t['\u1FC0'] = ' \u0342';
	  t['\u1FFE'] = ' \u0314';
	  t['\u2002'] = ' ';
	  t['\u2003'] = ' ';
	  t['\u2004'] = ' ';
	  t['\u2005'] = ' ';
	  t['\u2006'] = ' ';
	  t['\u2008'] = ' ';
	  t['\u2009'] = ' ';
	  t['\u200A'] = ' ';
	  t['\u2017'] = ' \u0333';
	  t['\u2024'] = '.';
	  t['\u2025'] = '..';
	  t['\u2026'] = '...';
	  t['\u2033'] = '\u2032\u2032';
	  t['\u2034'] = '\u2032\u2032\u2032';
	  t['\u2036'] = '\u2035\u2035';
	  t['\u2037'] = '\u2035\u2035\u2035';
	  t['\u203C'] = '!!';
	  t['\u203E'] = ' \u0305';
	  t['\u2047'] = '??';
	  t['\u2048'] = '?!';
	  t['\u2049'] = '!?';
	  t['\u2057'] = '\u2032\u2032\u2032\u2032';
	  t['\u205F'] = ' ';
	  t['\u20A8'] = 'Rs';
	  t['\u2100'] = 'a/c';
	  t['\u2101'] = 'a/s';
	  t['\u2103'] = '\xB0C';
	  t['\u2105'] = 'c/o';
	  t['\u2106'] = 'c/u';
	  t['\u2107'] = '\u0190';
	  t['\u2109'] = '\xB0F';
	  t['\u2116'] = 'No';
	  t['\u2121'] = 'TEL';
	  t['\u2135'] = '\u05D0';
	  t['\u2136'] = '\u05D1';
	  t['\u2137'] = '\u05D2';
	  t['\u2138'] = '\u05D3';
	  t['\u213B'] = 'FAX';
	  t['\u2160'] = 'I';
	  t['\u2161'] = 'II';
	  t['\u2162'] = 'III';
	  t['\u2163'] = 'IV';
	  t['\u2164'] = 'V';
	  t['\u2165'] = 'VI';
	  t['\u2166'] = 'VII';
	  t['\u2167'] = 'VIII';
	  t['\u2168'] = 'IX';
	  t['\u2169'] = 'X';
	  t['\u216A'] = 'XI';
	  t['\u216B'] = 'XII';
	  t['\u216C'] = 'L';
	  t['\u216D'] = 'C';
	  t['\u216E'] = 'D';
	  t['\u216F'] = 'M';
	  t['\u2170'] = 'i';
	  t['\u2171'] = 'ii';
	  t['\u2172'] = 'iii';
	  t['\u2173'] = 'iv';
	  t['\u2174'] = 'v';
	  t['\u2175'] = 'vi';
	  t['\u2176'] = 'vii';
	  t['\u2177'] = 'viii';
	  t['\u2178'] = 'ix';
	  t['\u2179'] = 'x';
	  t['\u217A'] = 'xi';
	  t['\u217B'] = 'xii';
	  t['\u217C'] = 'l';
	  t['\u217D'] = 'c';
	  t['\u217E'] = 'd';
	  t['\u217F'] = 'm';
	  t['\u222C'] = '\u222B\u222B';
	  t['\u222D'] = '\u222B\u222B\u222B';
	  t['\u222F'] = '\u222E\u222E';
	  t['\u2230'] = '\u222E\u222E\u222E';
	  t['\u2474'] = '(1)';
	  t['\u2475'] = '(2)';
	  t['\u2476'] = '(3)';
	  t['\u2477'] = '(4)';
	  t['\u2478'] = '(5)';
	  t['\u2479'] = '(6)';
	  t['\u247A'] = '(7)';
	  t['\u247B'] = '(8)';
	  t['\u247C'] = '(9)';
	  t['\u247D'] = '(10)';
	  t['\u247E'] = '(11)';
	  t['\u247F'] = '(12)';
	  t['\u2480'] = '(13)';
	  t['\u2481'] = '(14)';
	  t['\u2482'] = '(15)';
	  t['\u2483'] = '(16)';
	  t['\u2484'] = '(17)';
	  t['\u2485'] = '(18)';
	  t['\u2486'] = '(19)';
	  t['\u2487'] = '(20)';
	  t['\u2488'] = '1.';
	  t['\u2489'] = '2.';
	  t['\u248A'] = '3.';
	  t['\u248B'] = '4.';
	  t['\u248C'] = '5.';
	  t['\u248D'] = '6.';
	  t['\u248E'] = '7.';
	  t['\u248F'] = '8.';
	  t['\u2490'] = '9.';
	  t['\u2491'] = '10.';
	  t['\u2492'] = '11.';
	  t['\u2493'] = '12.';
	  t['\u2494'] = '13.';
	  t['\u2495'] = '14.';
	  t['\u2496'] = '15.';
	  t['\u2497'] = '16.';
	  t['\u2498'] = '17.';
	  t['\u2499'] = '18.';
	  t['\u249A'] = '19.';
	  t['\u249B'] = '20.';
	  t['\u249C'] = '(a)';
	  t['\u249D'] = '(b)';
	  t['\u249E'] = '(c)';
	  t['\u249F'] = '(d)';
	  t['\u24A0'] = '(e)';
	  t['\u24A1'] = '(f)';
	  t['\u24A2'] = '(g)';
	  t['\u24A3'] = '(h)';
	  t['\u24A4'] = '(i)';
	  t['\u24A5'] = '(j)';
	  t['\u24A6'] = '(k)';
	  t['\u24A7'] = '(l)';
	  t['\u24A8'] = '(m)';
	  t['\u24A9'] = '(n)';
	  t['\u24AA'] = '(o)';
	  t['\u24AB'] = '(p)';
	  t['\u24AC'] = '(q)';
	  t['\u24AD'] = '(r)';
	  t['\u24AE'] = '(s)';
	  t['\u24AF'] = '(t)';
	  t['\u24B0'] = '(u)';
	  t['\u24B1'] = '(v)';
	  t['\u24B2'] = '(w)';
	  t['\u24B3'] = '(x)';
	  t['\u24B4'] = '(y)';
	  t['\u24B5'] = '(z)';
	  t['\u2A0C'] = '\u222B\u222B\u222B\u222B';
	  t['\u2A74'] = '::=';
	  t['\u2A75'] = '==';
	  t['\u2A76'] = '===';
	  t['\u2E9F'] = '\u6BCD';
	  t['\u2EF3'] = '\u9F9F';
	  t['\u2F00'] = '\u4E00';
	  t['\u2F01'] = '\u4E28';
	  t['\u2F02'] = '\u4E36';
	  t['\u2F03'] = '\u4E3F';
	  t['\u2F04'] = '\u4E59';
	  t['\u2F05'] = '\u4E85';
	  t['\u2F06'] = '\u4E8C';
	  t['\u2F07'] = '\u4EA0';
	  t['\u2F08'] = '\u4EBA';
	  t['\u2F09'] = '\u513F';
	  t['\u2F0A'] = '\u5165';
	  t['\u2F0B'] = '\u516B';
	  t['\u2F0C'] = '\u5182';
	  t['\u2F0D'] = '\u5196';
	  t['\u2F0E'] = '\u51AB';
	  t['\u2F0F'] = '\u51E0';
	  t['\u2F10'] = '\u51F5';
	  t['\u2F11'] = '\u5200';
	  t['\u2F12'] = '\u529B';
	  t['\u2F13'] = '\u52F9';
	  t['\u2F14'] = '\u5315';
	  t['\u2F15'] = '\u531A';
	  t['\u2F16'] = '\u5338';
	  t['\u2F17'] = '\u5341';
	  t['\u2F18'] = '\u535C';
	  t['\u2F19'] = '\u5369';
	  t['\u2F1A'] = '\u5382';
	  t['\u2F1B'] = '\u53B6';
	  t['\u2F1C'] = '\u53C8';
	  t['\u2F1D'] = '\u53E3';
	  t['\u2F1E'] = '\u56D7';
	  t['\u2F1F'] = '\u571F';
	  t['\u2F20'] = '\u58EB';
	  t['\u2F21'] = '\u5902';
	  t['\u2F22'] = '\u590A';
	  t['\u2F23'] = '\u5915';
	  t['\u2F24'] = '\u5927';
	  t['\u2F25'] = '\u5973';
	  t['\u2F26'] = '\u5B50';
	  t['\u2F27'] = '\u5B80';
	  t['\u2F28'] = '\u5BF8';
	  t['\u2F29'] = '\u5C0F';
	  t['\u2F2A'] = '\u5C22';
	  t['\u2F2B'] = '\u5C38';
	  t['\u2F2C'] = '\u5C6E';
	  t['\u2F2D'] = '\u5C71';
	  t['\u2F2E'] = '\u5DDB';
	  t['\u2F2F'] = '\u5DE5';
	  t['\u2F30'] = '\u5DF1';
	  t['\u2F31'] = '\u5DFE';
	  t['\u2F32'] = '\u5E72';
	  t['\u2F33'] = '\u5E7A';
	  t['\u2F34'] = '\u5E7F';
	  t['\u2F35'] = '\u5EF4';
	  t['\u2F36'] = '\u5EFE';
	  t['\u2F37'] = '\u5F0B';
	  t['\u2F38'] = '\u5F13';
	  t['\u2F39'] = '\u5F50';
	  t['\u2F3A'] = '\u5F61';
	  t['\u2F3B'] = '\u5F73';
	  t['\u2F3C'] = '\u5FC3';
	  t['\u2F3D'] = '\u6208';
	  t['\u2F3E'] = '\u6236';
	  t['\u2F3F'] = '\u624B';
	  t['\u2F40'] = '\u652F';
	  t['\u2F41'] = '\u6534';
	  t['\u2F42'] = '\u6587';
	  t['\u2F43'] = '\u6597';
	  t['\u2F44'] = '\u65A4';
	  t['\u2F45'] = '\u65B9';
	  t['\u2F46'] = '\u65E0';
	  t['\u2F47'] = '\u65E5';
	  t['\u2F48'] = '\u66F0';
	  t['\u2F49'] = '\u6708';
	  t['\u2F4A'] = '\u6728';
	  t['\u2F4B'] = '\u6B20';
	  t['\u2F4C'] = '\u6B62';
	  t['\u2F4D'] = '\u6B79';
	  t['\u2F4E'] = '\u6BB3';
	  t['\u2F4F'] = '\u6BCB';
	  t['\u2F50'] = '\u6BD4';
	  t['\u2F51'] = '\u6BDB';
	  t['\u2F52'] = '\u6C0F';
	  t['\u2F53'] = '\u6C14';
	  t['\u2F54'] = '\u6C34';
	  t['\u2F55'] = '\u706B';
	  t['\u2F56'] = '\u722A';
	  t['\u2F57'] = '\u7236';
	  t['\u2F58'] = '\u723B';
	  t['\u2F59'] = '\u723F';
	  t['\u2F5A'] = '\u7247';
	  t['\u2F5B'] = '\u7259';
	  t['\u2F5C'] = '\u725B';
	  t['\u2F5D'] = '\u72AC';
	  t['\u2F5E'] = '\u7384';
	  t['\u2F5F'] = '\u7389';
	  t['\u2F60'] = '\u74DC';
	  t['\u2F61'] = '\u74E6';
	  t['\u2F62'] = '\u7518';
	  t['\u2F63'] = '\u751F';
	  t['\u2F64'] = '\u7528';
	  t['\u2F65'] = '\u7530';
	  t['\u2F66'] = '\u758B';
	  t['\u2F67'] = '\u7592';
	  t['\u2F68'] = '\u7676';
	  t['\u2F69'] = '\u767D';
	  t['\u2F6A'] = '\u76AE';
	  t['\u2F6B'] = '\u76BF';
	  t['\u2F6C'] = '\u76EE';
	  t['\u2F6D'] = '\u77DB';
	  t['\u2F6E'] = '\u77E2';
	  t['\u2F6F'] = '\u77F3';
	  t['\u2F70'] = '\u793A';
	  t['\u2F71'] = '\u79B8';
	  t['\u2F72'] = '\u79BE';
	  t['\u2F73'] = '\u7A74';
	  t['\u2F74'] = '\u7ACB';
	  t['\u2F75'] = '\u7AF9';
	  t['\u2F76'] = '\u7C73';
	  t['\u2F77'] = '\u7CF8';
	  t['\u2F78'] = '\u7F36';
	  t['\u2F79'] = '\u7F51';
	  t['\u2F7A'] = '\u7F8A';
	  t['\u2F7B'] = '\u7FBD';
	  t['\u2F7C'] = '\u8001';
	  t['\u2F7D'] = '\u800C';
	  t['\u2F7E'] = '\u8012';
	  t['\u2F7F'] = '\u8033';
	  t['\u2F80'] = '\u807F';
	  t['\u2F81'] = '\u8089';
	  t['\u2F82'] = '\u81E3';
	  t['\u2F83'] = '\u81EA';
	  t['\u2F84'] = '\u81F3';
	  t['\u2F85'] = '\u81FC';
	  t['\u2F86'] = '\u820C';
	  t['\u2F87'] = '\u821B';
	  t['\u2F88'] = '\u821F';
	  t['\u2F89'] = '\u826E';
	  t['\u2F8A'] = '\u8272';
	  t['\u2F8B'] = '\u8278';
	  t['\u2F8C'] = '\u864D';
	  t['\u2F8D'] = '\u866B';
	  t['\u2F8E'] = '\u8840';
	  t['\u2F8F'] = '\u884C';
	  t['\u2F90'] = '\u8863';
	  t['\u2F91'] = '\u897E';
	  t['\u2F92'] = '\u898B';
	  t['\u2F93'] = '\u89D2';
	  t['\u2F94'] = '\u8A00';
	  t['\u2F95'] = '\u8C37';
	  t['\u2F96'] = '\u8C46';
	  t['\u2F97'] = '\u8C55';
	  t['\u2F98'] = '\u8C78';
	  t['\u2F99'] = '\u8C9D';
	  t['\u2F9A'] = '\u8D64';
	  t['\u2F9B'] = '\u8D70';
	  t['\u2F9C'] = '\u8DB3';
	  t['\u2F9D'] = '\u8EAB';
	  t['\u2F9E'] = '\u8ECA';
	  t['\u2F9F'] = '\u8F9B';
	  t['\u2FA0'] = '\u8FB0';
	  t['\u2FA1'] = '\u8FB5';
	  t['\u2FA2'] = '\u9091';
	  t['\u2FA3'] = '\u9149';
	  t['\u2FA4'] = '\u91C6';
	  t['\u2FA5'] = '\u91CC';
	  t['\u2FA6'] = '\u91D1';
	  t['\u2FA7'] = '\u9577';
	  t['\u2FA8'] = '\u9580';
	  t['\u2FA9'] = '\u961C';
	  t['\u2FAA'] = '\u96B6';
	  t['\u2FAB'] = '\u96B9';
	  t['\u2FAC'] = '\u96E8';
	  t['\u2FAD'] = '\u9751';
	  t['\u2FAE'] = '\u975E';
	  t['\u2FAF'] = '\u9762';
	  t['\u2FB0'] = '\u9769';
	  t['\u2FB1'] = '\u97CB';
	  t['\u2FB2'] = '\u97ED';
	  t['\u2FB3'] = '\u97F3';
	  t['\u2FB4'] = '\u9801';
	  t['\u2FB5'] = '\u98A8';
	  t['\u2FB6'] = '\u98DB';
	  t['\u2FB7'] = '\u98DF';
	  t['\u2FB8'] = '\u9996';
	  t['\u2FB9'] = '\u9999';
	  t['\u2FBA'] = '\u99AC';
	  t['\u2FBB'] = '\u9AA8';
	  t['\u2FBC'] = '\u9AD8';
	  t['\u2FBD'] = '\u9ADF';
	  t['\u2FBE'] = '\u9B25';
	  t['\u2FBF'] = '\u9B2F';
	  t['\u2FC0'] = '\u9B32';
	  t['\u2FC1'] = '\u9B3C';
	  t['\u2FC2'] = '\u9B5A';
	  t['\u2FC3'] = '\u9CE5';
	  t['\u2FC4'] = '\u9E75';
	  t['\u2FC5'] = '\u9E7F';
	  t['\u2FC6'] = '\u9EA5';
	  t['\u2FC7'] = '\u9EBB';
	  t['\u2FC8'] = '\u9EC3';
	  t['\u2FC9'] = '\u9ECD';
	  t['\u2FCA'] = '\u9ED1';
	  t['\u2FCB'] = '\u9EF9';
	  t['\u2FCC'] = '\u9EFD';
	  t['\u2FCD'] = '\u9F0E';
	  t['\u2FCE'] = '\u9F13';
	  t['\u2FCF'] = '\u9F20';
	  t['\u2FD0'] = '\u9F3B';
	  t['\u2FD1'] = '\u9F4A';
	  t['\u2FD2'] = '\u9F52';
	  t['\u2FD3'] = '\u9F8D';
	  t['\u2FD4'] = '\u9F9C';
	  t['\u2FD5'] = '\u9FA0';
	  t['\u3036'] = '\u3012';
	  t['\u3038'] = '\u5341';
	  t['\u3039'] = '\u5344';
	  t['\u303A'] = '\u5345';
	  t['\u309B'] = ' \u3099';
	  t['\u309C'] = ' \u309A';
	  t['\u3131'] = '\u1100';
	  t['\u3132'] = '\u1101';
	  t['\u3133'] = '\u11AA';
	  t['\u3134'] = '\u1102';
	  t['\u3135'] = '\u11AC';
	  t['\u3136'] = '\u11AD';
	  t['\u3137'] = '\u1103';
	  t['\u3138'] = '\u1104';
	  t['\u3139'] = '\u1105';
	  t['\u313A'] = '\u11B0';
	  t['\u313B'] = '\u11B1';
	  t['\u313C'] = '\u11B2';
	  t['\u313D'] = '\u11B3';
	  t['\u313E'] = '\u11B4';
	  t['\u313F'] = '\u11B5';
	  t['\u3140'] = '\u111A';
	  t['\u3141'] = '\u1106';
	  t['\u3142'] = '\u1107';
	  t['\u3143'] = '\u1108';
	  t['\u3144'] = '\u1121';
	  t['\u3145'] = '\u1109';
	  t['\u3146'] = '\u110A';
	  t['\u3147'] = '\u110B';
	  t['\u3148'] = '\u110C';
	  t['\u3149'] = '\u110D';
	  t['\u314A'] = '\u110E';
	  t['\u314B'] = '\u110F';
	  t['\u314C'] = '\u1110';
	  t['\u314D'] = '\u1111';
	  t['\u314E'] = '\u1112';
	  t['\u314F'] = '\u1161';
	  t['\u3150'] = '\u1162';
	  t['\u3151'] = '\u1163';
	  t['\u3152'] = '\u1164';
	  t['\u3153'] = '\u1165';
	  t['\u3154'] = '\u1166';
	  t['\u3155'] = '\u1167';
	  t['\u3156'] = '\u1168';
	  t['\u3157'] = '\u1169';
	  t['\u3158'] = '\u116A';
	  t['\u3159'] = '\u116B';
	  t['\u315A'] = '\u116C';
	  t['\u315B'] = '\u116D';
	  t['\u315C'] = '\u116E';
	  t['\u315D'] = '\u116F';
	  t['\u315E'] = '\u1170';
	  t['\u315F'] = '\u1171';
	  t['\u3160'] = '\u1172';
	  t['\u3161'] = '\u1173';
	  t['\u3162'] = '\u1174';
	  t['\u3163'] = '\u1175';
	  t['\u3164'] = '\u1160';
	  t['\u3165'] = '\u1114';
	  t['\u3166'] = '\u1115';
	  t['\u3167'] = '\u11C7';
	  t['\u3168'] = '\u11C8';
	  t['\u3169'] = '\u11CC';
	  t['\u316A'] = '\u11CE';
	  t['\u316B'] = '\u11D3';
	  t['\u316C'] = '\u11D7';
	  t['\u316D'] = '\u11D9';
	  t['\u316E'] = '\u111C';
	  t['\u316F'] = '\u11DD';
	  t['\u3170'] = '\u11DF';
	  t['\u3171'] = '\u111D';
	  t['\u3172'] = '\u111E';
	  t['\u3173'] = '\u1120';
	  t['\u3174'] = '\u1122';
	  t['\u3175'] = '\u1123';
	  t['\u3176'] = '\u1127';
	  t['\u3177'] = '\u1129';
	  t['\u3178'] = '\u112B';
	  t['\u3179'] = '\u112C';
	  t['\u317A'] = '\u112D';
	  t['\u317B'] = '\u112E';
	  t['\u317C'] = '\u112F';
	  t['\u317D'] = '\u1132';
	  t['\u317E'] = '\u1136';
	  t['\u317F'] = '\u1140';
	  t['\u3180'] = '\u1147';
	  t['\u3181'] = '\u114C';
	  t['\u3182'] = '\u11F1';
	  t['\u3183'] = '\u11F2';
	  t['\u3184'] = '\u1157';
	  t['\u3185'] = '\u1158';
	  t['\u3186'] = '\u1159';
	  t['\u3187'] = '\u1184';
	  t['\u3188'] = '\u1185';
	  t['\u3189'] = '\u1188';
	  t['\u318A'] = '\u1191';
	  t['\u318B'] = '\u1192';
	  t['\u318C'] = '\u1194';
	  t['\u318D'] = '\u119E';
	  t['\u318E'] = '\u11A1';
	  t['\u3200'] = '(\u1100)';
	  t['\u3201'] = '(\u1102)';
	  t['\u3202'] = '(\u1103)';
	  t['\u3203'] = '(\u1105)';
	  t['\u3204'] = '(\u1106)';
	  t['\u3205'] = '(\u1107)';
	  t['\u3206'] = '(\u1109)';
	  t['\u3207'] = '(\u110B)';
	  t['\u3208'] = '(\u110C)';
	  t['\u3209'] = '(\u110E)';
	  t['\u320A'] = '(\u110F)';
	  t['\u320B'] = '(\u1110)';
	  t['\u320C'] = '(\u1111)';
	  t['\u320D'] = '(\u1112)';
	  t['\u320E'] = '(\u1100\u1161)';
	  t['\u320F'] = '(\u1102\u1161)';
	  t['\u3210'] = '(\u1103\u1161)';
	  t['\u3211'] = '(\u1105\u1161)';
	  t['\u3212'] = '(\u1106\u1161)';
	  t['\u3213'] = '(\u1107\u1161)';
	  t['\u3214'] = '(\u1109\u1161)';
	  t['\u3215'] = '(\u110B\u1161)';
	  t['\u3216'] = '(\u110C\u1161)';
	  t['\u3217'] = '(\u110E\u1161)';
	  t['\u3218'] = '(\u110F\u1161)';
	  t['\u3219'] = '(\u1110\u1161)';
	  t['\u321A'] = '(\u1111\u1161)';
	  t['\u321B'] = '(\u1112\u1161)';
	  t['\u321C'] = '(\u110C\u116E)';
	  t['\u321D'] = '(\u110B\u1169\u110C\u1165\u11AB)';
	  t['\u321E'] = '(\u110B\u1169\u1112\u116E)';
	  t['\u3220'] = '(\u4E00)';
	  t['\u3221'] = '(\u4E8C)';
	  t['\u3222'] = '(\u4E09)';
	  t['\u3223'] = '(\u56DB)';
	  t['\u3224'] = '(\u4E94)';
	  t['\u3225'] = '(\u516D)';
	  t['\u3226'] = '(\u4E03)';
	  t['\u3227'] = '(\u516B)';
	  t['\u3228'] = '(\u4E5D)';
	  t['\u3229'] = '(\u5341)';
	  t['\u322A'] = '(\u6708)';
	  t['\u322B'] = '(\u706B)';
	  t['\u322C'] = '(\u6C34)';
	  t['\u322D'] = '(\u6728)';
	  t['\u322E'] = '(\u91D1)';
	  t['\u322F'] = '(\u571F)';
	  t['\u3230'] = '(\u65E5)';
	  t['\u3231'] = '(\u682A)';
	  t['\u3232'] = '(\u6709)';
	  t['\u3233'] = '(\u793E)';
	  t['\u3234'] = '(\u540D)';
	  t['\u3235'] = '(\u7279)';
	  t['\u3236'] = '(\u8CA1)';
	  t['\u3237'] = '(\u795D)';
	  t['\u3238'] = '(\u52B4)';
	  t['\u3239'] = '(\u4EE3)';
	  t['\u323A'] = '(\u547C)';
	  t['\u323B'] = '(\u5B66)';
	  t['\u323C'] = '(\u76E3)';
	  t['\u323D'] = '(\u4F01)';
	  t['\u323E'] = '(\u8CC7)';
	  t['\u323F'] = '(\u5354)';
	  t['\u3240'] = '(\u796D)';
	  t['\u3241'] = '(\u4F11)';
	  t['\u3242'] = '(\u81EA)';
	  t['\u3243'] = '(\u81F3)';
	  t['\u32C0'] = '1\u6708';
	  t['\u32C1'] = '2\u6708';
	  t['\u32C2'] = '3\u6708';
	  t['\u32C3'] = '4\u6708';
	  t['\u32C4'] = '5\u6708';
	  t['\u32C5'] = '6\u6708';
	  t['\u32C6'] = '7\u6708';
	  t['\u32C7'] = '8\u6708';
	  t['\u32C8'] = '9\u6708';
	  t['\u32C9'] = '10\u6708';
	  t['\u32CA'] = '11\u6708';
	  t['\u32CB'] = '12\u6708';
	  t['\u3358'] = '0\u70B9';
	  t['\u3359'] = '1\u70B9';
	  t['\u335A'] = '2\u70B9';
	  t['\u335B'] = '3\u70B9';
	  t['\u335C'] = '4\u70B9';
	  t['\u335D'] = '5\u70B9';
	  t['\u335E'] = '6\u70B9';
	  t['\u335F'] = '7\u70B9';
	  t['\u3360'] = '8\u70B9';
	  t['\u3361'] = '9\u70B9';
	  t['\u3362'] = '10\u70B9';
	  t['\u3363'] = '11\u70B9';
	  t['\u3364'] = '12\u70B9';
	  t['\u3365'] = '13\u70B9';
	  t['\u3366'] = '14\u70B9';
	  t['\u3367'] = '15\u70B9';
	  t['\u3368'] = '16\u70B9';
	  t['\u3369'] = '17\u70B9';
	  t['\u336A'] = '18\u70B9';
	  t['\u336B'] = '19\u70B9';
	  t['\u336C'] = '20\u70B9';
	  t['\u336D'] = '21\u70B9';
	  t['\u336E'] = '22\u70B9';
	  t['\u336F'] = '23\u70B9';
	  t['\u3370'] = '24\u70B9';
	  t['\u33E0'] = '1\u65E5';
	  t['\u33E1'] = '2\u65E5';
	  t['\u33E2'] = '3\u65E5';
	  t['\u33E3'] = '4\u65E5';
	  t['\u33E4'] = '5\u65E5';
	  t['\u33E5'] = '6\u65E5';
	  t['\u33E6'] = '7\u65E5';
	  t['\u33E7'] = '8\u65E5';
	  t['\u33E8'] = '9\u65E5';
	  t['\u33E9'] = '10\u65E5';
	  t['\u33EA'] = '11\u65E5';
	  t['\u33EB'] = '12\u65E5';
	  t['\u33EC'] = '13\u65E5';
	  t['\u33ED'] = '14\u65E5';
	  t['\u33EE'] = '15\u65E5';
	  t['\u33EF'] = '16\u65E5';
	  t['\u33F0'] = '17\u65E5';
	  t['\u33F1'] = '18\u65E5';
	  t['\u33F2'] = '19\u65E5';
	  t['\u33F3'] = '20\u65E5';
	  t['\u33F4'] = '21\u65E5';
	  t['\u33F5'] = '22\u65E5';
	  t['\u33F6'] = '23\u65E5';
	  t['\u33F7'] = '24\u65E5';
	  t['\u33F8'] = '25\u65E5';
	  t['\u33F9'] = '26\u65E5';
	  t['\u33FA'] = '27\u65E5';
	  t['\u33FB'] = '28\u65E5';
	  t['\u33FC'] = '29\u65E5';
	  t['\u33FD'] = '30\u65E5';
	  t['\u33FE'] = '31\u65E5';
	  t['\uFB00'] = 'ff';
	  t['\uFB01'] = 'fi';
	  t['\uFB02'] = 'fl';
	  t['\uFB03'] = 'ffi';
	  t['\uFB04'] = 'ffl';
	  t['\uFB05'] = '\u017Ft';
	  t['\uFB06'] = 'st';
	  t['\uFB13'] = '\u0574\u0576';
	  t['\uFB14'] = '\u0574\u0565';
	  t['\uFB15'] = '\u0574\u056B';
	  t['\uFB16'] = '\u057E\u0576';
	  t['\uFB17'] = '\u0574\u056D';
	  t['\uFB4F'] = '\u05D0\u05DC';
	  t['\uFB50'] = '\u0671';
	  t['\uFB51'] = '\u0671';
	  t['\uFB52'] = '\u067B';
	  t['\uFB53'] = '\u067B';
	  t['\uFB54'] = '\u067B';
	  t['\uFB55'] = '\u067B';
	  t['\uFB56'] = '\u067E';
	  t['\uFB57'] = '\u067E';
	  t['\uFB58'] = '\u067E';
	  t['\uFB59'] = '\u067E';
	  t['\uFB5A'] = '\u0680';
	  t['\uFB5B'] = '\u0680';
	  t['\uFB5C'] = '\u0680';
	  t['\uFB5D'] = '\u0680';
	  t['\uFB5E'] = '\u067A';
	  t['\uFB5F'] = '\u067A';
	  t['\uFB60'] = '\u067A';
	  t['\uFB61'] = '\u067A';
	  t['\uFB62'] = '\u067F';
	  t['\uFB63'] = '\u067F';
	  t['\uFB64'] = '\u067F';
	  t['\uFB65'] = '\u067F';
	  t['\uFB66'] = '\u0679';
	  t['\uFB67'] = '\u0679';
	  t['\uFB68'] = '\u0679';
	  t['\uFB69'] = '\u0679';
	  t['\uFB6A'] = '\u06A4';
	  t['\uFB6B'] = '\u06A4';
	  t['\uFB6C'] = '\u06A4';
	  t['\uFB6D'] = '\u06A4';
	  t['\uFB6E'] = '\u06A6';
	  t['\uFB6F'] = '\u06A6';
	  t['\uFB70'] = '\u06A6';
	  t['\uFB71'] = '\u06A6';
	  t['\uFB72'] = '\u0684';
	  t['\uFB73'] = '\u0684';
	  t['\uFB74'] = '\u0684';
	  t['\uFB75'] = '\u0684';
	  t['\uFB76'] = '\u0683';
	  t['\uFB77'] = '\u0683';
	  t['\uFB78'] = '\u0683';
	  t['\uFB79'] = '\u0683';
	  t['\uFB7A'] = '\u0686';
	  t['\uFB7B'] = '\u0686';
	  t['\uFB7C'] = '\u0686';
	  t['\uFB7D'] = '\u0686';
	  t['\uFB7E'] = '\u0687';
	  t['\uFB7F'] = '\u0687';
	  t['\uFB80'] = '\u0687';
	  t['\uFB81'] = '\u0687';
	  t['\uFB82'] = '\u068D';
	  t['\uFB83'] = '\u068D';
	  t['\uFB84'] = '\u068C';
	  t['\uFB85'] = '\u068C';
	  t['\uFB86'] = '\u068E';
	  t['\uFB87'] = '\u068E';
	  t['\uFB88'] = '\u0688';
	  t['\uFB89'] = '\u0688';
	  t['\uFB8A'] = '\u0698';
	  t['\uFB8B'] = '\u0698';
	  t['\uFB8C'] = '\u0691';
	  t['\uFB8D'] = '\u0691';
	  t['\uFB8E'] = '\u06A9';
	  t['\uFB8F'] = '\u06A9';
	  t['\uFB90'] = '\u06A9';
	  t['\uFB91'] = '\u06A9';
	  t['\uFB92'] = '\u06AF';
	  t['\uFB93'] = '\u06AF';
	  t['\uFB94'] = '\u06AF';
	  t['\uFB95'] = '\u06AF';
	  t['\uFB96'] = '\u06B3';
	  t['\uFB97'] = '\u06B3';
	  t['\uFB98'] = '\u06B3';
	  t['\uFB99'] = '\u06B3';
	  t['\uFB9A'] = '\u06B1';
	  t['\uFB9B'] = '\u06B1';
	  t['\uFB9C'] = '\u06B1';
	  t['\uFB9D'] = '\u06B1';
	  t['\uFB9E'] = '\u06BA';
	  t['\uFB9F'] = '\u06BA';
	  t['\uFBA0'] = '\u06BB';
	  t['\uFBA1'] = '\u06BB';
	  t['\uFBA2'] = '\u06BB';
	  t['\uFBA3'] = '\u06BB';
	  t['\uFBA4'] = '\u06C0';
	  t['\uFBA5'] = '\u06C0';
	  t['\uFBA6'] = '\u06C1';
	  t['\uFBA7'] = '\u06C1';
	  t['\uFBA8'] = '\u06C1';
	  t['\uFBA9'] = '\u06C1';
	  t['\uFBAA'] = '\u06BE';
	  t['\uFBAB'] = '\u06BE';
	  t['\uFBAC'] = '\u06BE';
	  t['\uFBAD'] = '\u06BE';
	  t['\uFBAE'] = '\u06D2';
	  t['\uFBAF'] = '\u06D2';
	  t['\uFBB0'] = '\u06D3';
	  t['\uFBB1'] = '\u06D3';
	  t['\uFBD3'] = '\u06AD';
	  t['\uFBD4'] = '\u06AD';
	  t['\uFBD5'] = '\u06AD';
	  t['\uFBD6'] = '\u06AD';
	  t['\uFBD7'] = '\u06C7';
	  t['\uFBD8'] = '\u06C7';
	  t['\uFBD9'] = '\u06C6';
	  t['\uFBDA'] = '\u06C6';
	  t['\uFBDB'] = '\u06C8';
	  t['\uFBDC'] = '\u06C8';
	  t['\uFBDD'] = '\u0677';
	  t['\uFBDE'] = '\u06CB';
	  t['\uFBDF'] = '\u06CB';
	  t['\uFBE0'] = '\u06C5';
	  t['\uFBE1'] = '\u06C5';
	  t['\uFBE2'] = '\u06C9';
	  t['\uFBE3'] = '\u06C9';
	  t['\uFBE4'] = '\u06D0';
	  t['\uFBE5'] = '\u06D0';
	  t['\uFBE6'] = '\u06D0';
	  t['\uFBE7'] = '\u06D0';
	  t['\uFBE8'] = '\u0649';
	  t['\uFBE9'] = '\u0649';
	  t['\uFBEA'] = '\u0626\u0627';
	  t['\uFBEB'] = '\u0626\u0627';
	  t['\uFBEC'] = '\u0626\u06D5';
	  t['\uFBED'] = '\u0626\u06D5';
	  t['\uFBEE'] = '\u0626\u0648';
	  t['\uFBEF'] = '\u0626\u0648';
	  t['\uFBF0'] = '\u0626\u06C7';
	  t['\uFBF1'] = '\u0626\u06C7';
	  t['\uFBF2'] = '\u0626\u06C6';
	  t['\uFBF3'] = '\u0626\u06C6';
	  t['\uFBF4'] = '\u0626\u06C8';
	  t['\uFBF5'] = '\u0626\u06C8';
	  t['\uFBF6'] = '\u0626\u06D0';
	  t['\uFBF7'] = '\u0626\u06D0';
	  t['\uFBF8'] = '\u0626\u06D0';
	  t['\uFBF9'] = '\u0626\u0649';
	  t['\uFBFA'] = '\u0626\u0649';
	  t['\uFBFB'] = '\u0626\u0649';
	  t['\uFBFC'] = '\u06CC';
	  t['\uFBFD'] = '\u06CC';
	  t['\uFBFE'] = '\u06CC';
	  t['\uFBFF'] = '\u06CC';
	  t['\uFC00'] = '\u0626\u062C';
	  t['\uFC01'] = '\u0626\u062D';
	  t['\uFC02'] = '\u0626\u0645';
	  t['\uFC03'] = '\u0626\u0649';
	  t['\uFC04'] = '\u0626\u064A';
	  t['\uFC05'] = '\u0628\u062C';
	  t['\uFC06'] = '\u0628\u062D';
	  t['\uFC07'] = '\u0628\u062E';
	  t['\uFC08'] = '\u0628\u0645';
	  t['\uFC09'] = '\u0628\u0649';
	  t['\uFC0A'] = '\u0628\u064A';
	  t['\uFC0B'] = '\u062A\u062C';
	  t['\uFC0C'] = '\u062A\u062D';
	  t['\uFC0D'] = '\u062A\u062E';
	  t['\uFC0E'] = '\u062A\u0645';
	  t['\uFC0F'] = '\u062A\u0649';
	  t['\uFC10'] = '\u062A\u064A';
	  t['\uFC11'] = '\u062B\u062C';
	  t['\uFC12'] = '\u062B\u0645';
	  t['\uFC13'] = '\u062B\u0649';
	  t['\uFC14'] = '\u062B\u064A';
	  t['\uFC15'] = '\u062C\u062D';
	  t['\uFC16'] = '\u062C\u0645';
	  t['\uFC17'] = '\u062D\u062C';
	  t['\uFC18'] = '\u062D\u0645';
	  t['\uFC19'] = '\u062E\u062C';
	  t['\uFC1A'] = '\u062E\u062D';
	  t['\uFC1B'] = '\u062E\u0645';
	  t['\uFC1C'] = '\u0633\u062C';
	  t['\uFC1D'] = '\u0633\u062D';
	  t['\uFC1E'] = '\u0633\u062E';
	  t['\uFC1F'] = '\u0633\u0645';
	  t['\uFC20'] = '\u0635\u062D';
	  t['\uFC21'] = '\u0635\u0645';
	  t['\uFC22'] = '\u0636\u062C';
	  t['\uFC23'] = '\u0636\u062D';
	  t['\uFC24'] = '\u0636\u062E';
	  t['\uFC25'] = '\u0636\u0645';
	  t['\uFC26'] = '\u0637\u062D';
	  t['\uFC27'] = '\u0637\u0645';
	  t['\uFC28'] = '\u0638\u0645';
	  t['\uFC29'] = '\u0639\u062C';
	  t['\uFC2A'] = '\u0639\u0645';
	  t['\uFC2B'] = '\u063A\u062C';
	  t['\uFC2C'] = '\u063A\u0645';
	  t['\uFC2D'] = '\u0641\u062C';
	  t['\uFC2E'] = '\u0641\u062D';
	  t['\uFC2F'] = '\u0641\u062E';
	  t['\uFC30'] = '\u0641\u0645';
	  t['\uFC31'] = '\u0641\u0649';
	  t['\uFC32'] = '\u0641\u064A';
	  t['\uFC33'] = '\u0642\u062D';
	  t['\uFC34'] = '\u0642\u0645';
	  t['\uFC35'] = '\u0642\u0649';
	  t['\uFC36'] = '\u0642\u064A';
	  t['\uFC37'] = '\u0643\u0627';
	  t['\uFC38'] = '\u0643\u062C';
	  t['\uFC39'] = '\u0643\u062D';
	  t['\uFC3A'] = '\u0643\u062E';
	  t['\uFC3B'] = '\u0643\u0644';
	  t['\uFC3C'] = '\u0643\u0645';
	  t['\uFC3D'] = '\u0643\u0649';
	  t['\uFC3E'] = '\u0643\u064A';
	  t['\uFC3F'] = '\u0644\u062C';
	  t['\uFC40'] = '\u0644\u062D';
	  t['\uFC41'] = '\u0644\u062E';
	  t['\uFC42'] = '\u0644\u0645';
	  t['\uFC43'] = '\u0644\u0649';
	  t['\uFC44'] = '\u0644\u064A';
	  t['\uFC45'] = '\u0645\u062C';
	  t['\uFC46'] = '\u0645\u062D';
	  t['\uFC47'] = '\u0645\u062E';
	  t['\uFC48'] = '\u0645\u0645';
	  t['\uFC49'] = '\u0645\u0649';
	  t['\uFC4A'] = '\u0645\u064A';
	  t['\uFC4B'] = '\u0646\u062C';
	  t['\uFC4C'] = '\u0646\u062D';
	  t['\uFC4D'] = '\u0646\u062E';
	  t['\uFC4E'] = '\u0646\u0645';
	  t['\uFC4F'] = '\u0646\u0649';
	  t['\uFC50'] = '\u0646\u064A';
	  t['\uFC51'] = '\u0647\u062C';
	  t['\uFC52'] = '\u0647\u0645';
	  t['\uFC53'] = '\u0647\u0649';
	  t['\uFC54'] = '\u0647\u064A';
	  t['\uFC55'] = '\u064A\u062C';
	  t['\uFC56'] = '\u064A\u062D';
	  t['\uFC57'] = '\u064A\u062E';
	  t['\uFC58'] = '\u064A\u0645';
	  t['\uFC59'] = '\u064A\u0649';
	  t['\uFC5A'] = '\u064A\u064A';
	  t['\uFC5B'] = '\u0630\u0670';
	  t['\uFC5C'] = '\u0631\u0670';
	  t['\uFC5D'] = '\u0649\u0670';
	  t['\uFC5E'] = ' \u064C\u0651';
	  t['\uFC5F'] = ' \u064D\u0651';
	  t['\uFC60'] = ' \u064E\u0651';
	  t['\uFC61'] = ' \u064F\u0651';
	  t['\uFC62'] = ' \u0650\u0651';
	  t['\uFC63'] = ' \u0651\u0670';
	  t['\uFC64'] = '\u0626\u0631';
	  t['\uFC65'] = '\u0626\u0632';
	  t['\uFC66'] = '\u0626\u0645';
	  t['\uFC67'] = '\u0626\u0646';
	  t['\uFC68'] = '\u0626\u0649';
	  t['\uFC69'] = '\u0626\u064A';
	  t['\uFC6A'] = '\u0628\u0631';
	  t['\uFC6B'] = '\u0628\u0632';
	  t['\uFC6C'] = '\u0628\u0645';
	  t['\uFC6D'] = '\u0628\u0646';
	  t['\uFC6E'] = '\u0628\u0649';
	  t['\uFC6F'] = '\u0628\u064A';
	  t['\uFC70'] = '\u062A\u0631';
	  t['\uFC71'] = '\u062A\u0632';
	  t['\uFC72'] = '\u062A\u0645';
	  t['\uFC73'] = '\u062A\u0646';
	  t['\uFC74'] = '\u062A\u0649';
	  t['\uFC75'] = '\u062A\u064A';
	  t['\uFC76'] = '\u062B\u0631';
	  t['\uFC77'] = '\u062B\u0632';
	  t['\uFC78'] = '\u062B\u0645';
	  t['\uFC79'] = '\u062B\u0646';
	  t['\uFC7A'] = '\u062B\u0649';
	  t['\uFC7B'] = '\u062B\u064A';
	  t['\uFC7C'] = '\u0641\u0649';
	  t['\uFC7D'] = '\u0641\u064A';
	  t['\uFC7E'] = '\u0642\u0649';
	  t['\uFC7F'] = '\u0642\u064A';
	  t['\uFC80'] = '\u0643\u0627';
	  t['\uFC81'] = '\u0643\u0644';
	  t['\uFC82'] = '\u0643\u0645';
	  t['\uFC83'] = '\u0643\u0649';
	  t['\uFC84'] = '\u0643\u064A';
	  t['\uFC85'] = '\u0644\u0645';
	  t['\uFC86'] = '\u0644\u0649';
	  t['\uFC87'] = '\u0644\u064A';
	  t['\uFC88'] = '\u0645\u0627';
	  t['\uFC89'] = '\u0645\u0645';
	  t['\uFC8A'] = '\u0646\u0631';
	  t['\uFC8B'] = '\u0646\u0632';
	  t['\uFC8C'] = '\u0646\u0645';
	  t['\uFC8D'] = '\u0646\u0646';
	  t['\uFC8E'] = '\u0646\u0649';
	  t['\uFC8F'] = '\u0646\u064A';
	  t['\uFC90'] = '\u0649\u0670';
	  t['\uFC91'] = '\u064A\u0631';
	  t['\uFC92'] = '\u064A\u0632';
	  t['\uFC93'] = '\u064A\u0645';
	  t['\uFC94'] = '\u064A\u0646';
	  t['\uFC95'] = '\u064A\u0649';
	  t['\uFC96'] = '\u064A\u064A';
	  t['\uFC97'] = '\u0626\u062C';
	  t['\uFC98'] = '\u0626\u062D';
	  t['\uFC99'] = '\u0626\u062E';
	  t['\uFC9A'] = '\u0626\u0645';
	  t['\uFC9B'] = '\u0626\u0647';
	  t['\uFC9C'] = '\u0628\u062C';
	  t['\uFC9D'] = '\u0628\u062D';
	  t['\uFC9E'] = '\u0628\u062E';
	  t['\uFC9F'] = '\u0628\u0645';
	  t['\uFCA0'] = '\u0628\u0647';
	  t['\uFCA1'] = '\u062A\u062C';
	  t['\uFCA2'] = '\u062A\u062D';
	  t['\uFCA3'] = '\u062A\u062E';
	  t['\uFCA4'] = '\u062A\u0645';
	  t['\uFCA5'] = '\u062A\u0647';
	  t['\uFCA6'] = '\u062B\u0645';
	  t['\uFCA7'] = '\u062C\u062D';
	  t['\uFCA8'] = '\u062C\u0645';
	  t['\uFCA9'] = '\u062D\u062C';
	  t['\uFCAA'] = '\u062D\u0645';
	  t['\uFCAB'] = '\u062E\u062C';
	  t['\uFCAC'] = '\u062E\u0645';
	  t['\uFCAD'] = '\u0633\u062C';
	  t['\uFCAE'] = '\u0633\u062D';
	  t['\uFCAF'] = '\u0633\u062E';
	  t['\uFCB0'] = '\u0633\u0645';
	  t['\uFCB1'] = '\u0635\u062D';
	  t['\uFCB2'] = '\u0635\u062E';
	  t['\uFCB3'] = '\u0635\u0645';
	  t['\uFCB4'] = '\u0636\u062C';
	  t['\uFCB5'] = '\u0636\u062D';
	  t['\uFCB6'] = '\u0636\u062E';
	  t['\uFCB7'] = '\u0636\u0645';
	  t['\uFCB8'] = '\u0637\u062D';
	  t['\uFCB9'] = '\u0638\u0645';
	  t['\uFCBA'] = '\u0639\u062C';
	  t['\uFCBB'] = '\u0639\u0645';
	  t['\uFCBC'] = '\u063A\u062C';
	  t['\uFCBD'] = '\u063A\u0645';
	  t['\uFCBE'] = '\u0641\u062C';
	  t['\uFCBF'] = '\u0641\u062D';
	  t['\uFCC0'] = '\u0641\u062E';
	  t['\uFCC1'] = '\u0641\u0645';
	  t['\uFCC2'] = '\u0642\u062D';
	  t['\uFCC3'] = '\u0642\u0645';
	  t['\uFCC4'] = '\u0643\u062C';
	  t['\uFCC5'] = '\u0643\u062D';
	  t['\uFCC6'] = '\u0643\u062E';
	  t['\uFCC7'] = '\u0643\u0644';
	  t['\uFCC8'] = '\u0643\u0645';
	  t['\uFCC9'] = '\u0644\u062C';
	  t['\uFCCA'] = '\u0644\u062D';
	  t['\uFCCB'] = '\u0644\u062E';
	  t['\uFCCC'] = '\u0644\u0645';
	  t['\uFCCD'] = '\u0644\u0647';
	  t['\uFCCE'] = '\u0645\u062C';
	  t['\uFCCF'] = '\u0645\u062D';
	  t['\uFCD0'] = '\u0645\u062E';
	  t['\uFCD1'] = '\u0645\u0645';
	  t['\uFCD2'] = '\u0646\u062C';
	  t['\uFCD3'] = '\u0646\u062D';
	  t['\uFCD4'] = '\u0646\u062E';
	  t['\uFCD5'] = '\u0646\u0645';
	  t['\uFCD6'] = '\u0646\u0647';
	  t['\uFCD7'] = '\u0647\u062C';
	  t['\uFCD8'] = '\u0647\u0645';
	  t['\uFCD9'] = '\u0647\u0670';
	  t['\uFCDA'] = '\u064A\u062C';
	  t['\uFCDB'] = '\u064A\u062D';
	  t['\uFCDC'] = '\u064A\u062E';
	  t['\uFCDD'] = '\u064A\u0645';
	  t['\uFCDE'] = '\u064A\u0647';
	  t['\uFCDF'] = '\u0626\u0645';
	  t['\uFCE0'] = '\u0626\u0647';
	  t['\uFCE1'] = '\u0628\u0645';
	  t['\uFCE2'] = '\u0628\u0647';
	  t['\uFCE3'] = '\u062A\u0645';
	  t['\uFCE4'] = '\u062A\u0647';
	  t['\uFCE5'] = '\u062B\u0645';
	  t['\uFCE6'] = '\u062B\u0647';
	  t['\uFCE7'] = '\u0633\u0645';
	  t['\uFCE8'] = '\u0633\u0647';
	  t['\uFCE9'] = '\u0634\u0645';
	  t['\uFCEA'] = '\u0634\u0647';
	  t['\uFCEB'] = '\u0643\u0644';
	  t['\uFCEC'] = '\u0643\u0645';
	  t['\uFCED'] = '\u0644\u0645';
	  t['\uFCEE'] = '\u0646\u0645';
	  t['\uFCEF'] = '\u0646\u0647';
	  t['\uFCF0'] = '\u064A\u0645';
	  t['\uFCF1'] = '\u064A\u0647';
	  t['\uFCF2'] = '\u0640\u064E\u0651';
	  t['\uFCF3'] = '\u0640\u064F\u0651';
	  t['\uFCF4'] = '\u0640\u0650\u0651';
	  t['\uFCF5'] = '\u0637\u0649';
	  t['\uFCF6'] = '\u0637\u064A';
	  t['\uFCF7'] = '\u0639\u0649';
	  t['\uFCF8'] = '\u0639\u064A';
	  t['\uFCF9'] = '\u063A\u0649';
	  t['\uFCFA'] = '\u063A\u064A';
	  t['\uFCFB'] = '\u0633\u0649';
	  t['\uFCFC'] = '\u0633\u064A';
	  t['\uFCFD'] = '\u0634\u0649';
	  t['\uFCFE'] = '\u0634\u064A';
	  t['\uFCFF'] = '\u062D\u0649';
	  t['\uFD00'] = '\u062D\u064A';
	  t['\uFD01'] = '\u062C\u0649';
	  t['\uFD02'] = '\u062C\u064A';
	  t['\uFD03'] = '\u062E\u0649';
	  t['\uFD04'] = '\u062E\u064A';
	  t['\uFD05'] = '\u0635\u0649';
	  t['\uFD06'] = '\u0635\u064A';
	  t['\uFD07'] = '\u0636\u0649';
	  t['\uFD08'] = '\u0636\u064A';
	  t['\uFD09'] = '\u0634\u062C';
	  t['\uFD0A'] = '\u0634\u062D';
	  t['\uFD0B'] = '\u0634\u062E';
	  t['\uFD0C'] = '\u0634\u0645';
	  t['\uFD0D'] = '\u0634\u0631';
	  t['\uFD0E'] = '\u0633\u0631';
	  t['\uFD0F'] = '\u0635\u0631';
	  t['\uFD10'] = '\u0636\u0631';
	  t['\uFD11'] = '\u0637\u0649';
	  t['\uFD12'] = '\u0637\u064A';
	  t['\uFD13'] = '\u0639\u0649';
	  t['\uFD14'] = '\u0639\u064A';
	  t['\uFD15'] = '\u063A\u0649';
	  t['\uFD16'] = '\u063A\u064A';
	  t['\uFD17'] = '\u0633\u0649';
	  t['\uFD18'] = '\u0633\u064A';
	  t['\uFD19'] = '\u0634\u0649';
	  t['\uFD1A'] = '\u0634\u064A';
	  t['\uFD1B'] = '\u062D\u0649';
	  t['\uFD1C'] = '\u062D\u064A';
	  t['\uFD1D'] = '\u062C\u0649';
	  t['\uFD1E'] = '\u062C\u064A';
	  t['\uFD1F'] = '\u062E\u0649';
	  t['\uFD20'] = '\u062E\u064A';
	  t['\uFD21'] = '\u0635\u0649';
	  t['\uFD22'] = '\u0635\u064A';
	  t['\uFD23'] = '\u0636\u0649';
	  t['\uFD24'] = '\u0636\u064A';
	  t['\uFD25'] = '\u0634\u062C';
	  t['\uFD26'] = '\u0634\u062D';
	  t['\uFD27'] = '\u0634\u062E';
	  t['\uFD28'] = '\u0634\u0645';
	  t['\uFD29'] = '\u0634\u0631';
	  t['\uFD2A'] = '\u0633\u0631';
	  t['\uFD2B'] = '\u0635\u0631';
	  t['\uFD2C'] = '\u0636\u0631';
	  t['\uFD2D'] = '\u0634\u062C';
	  t['\uFD2E'] = '\u0634\u062D';
	  t['\uFD2F'] = '\u0634\u062E';
	  t['\uFD30'] = '\u0634\u0645';
	  t['\uFD31'] = '\u0633\u0647';
	  t['\uFD32'] = '\u0634\u0647';
	  t['\uFD33'] = '\u0637\u0645';
	  t['\uFD34'] = '\u0633\u062C';
	  t['\uFD35'] = '\u0633\u062D';
	  t['\uFD36'] = '\u0633\u062E';
	  t['\uFD37'] = '\u0634\u062C';
	  t['\uFD38'] = '\u0634\u062D';
	  t['\uFD39'] = '\u0634\u062E';
	  t['\uFD3A'] = '\u0637\u0645';
	  t['\uFD3B'] = '\u0638\u0645';
	  t['\uFD3C'] = '\u0627\u064B';
	  t['\uFD3D'] = '\u0627\u064B';
	  t['\uFD50'] = '\u062A\u062C\u0645';
	  t['\uFD51'] = '\u062A\u062D\u062C';
	  t['\uFD52'] = '\u062A\u062D\u062C';
	  t['\uFD53'] = '\u062A\u062D\u0645';
	  t['\uFD54'] = '\u062A\u062E\u0645';
	  t['\uFD55'] = '\u062A\u0645\u062C';
	  t['\uFD56'] = '\u062A\u0645\u062D';
	  t['\uFD57'] = '\u062A\u0645\u062E';
	  t['\uFD58'] = '\u062C\u0645\u062D';
	  t['\uFD59'] = '\u062C\u0645\u062D';
	  t['\uFD5A'] = '\u062D\u0645\u064A';
	  t['\uFD5B'] = '\u062D\u0645\u0649';
	  t['\uFD5C'] = '\u0633\u062D\u062C';
	  t['\uFD5D'] = '\u0633\u062C\u062D';
	  t['\uFD5E'] = '\u0633\u062C\u0649';
	  t['\uFD5F'] = '\u0633\u0645\u062D';
	  t['\uFD60'] = '\u0633\u0645\u062D';
	  t['\uFD61'] = '\u0633\u0645\u062C';
	  t['\uFD62'] = '\u0633\u0645\u0645';
	  t['\uFD63'] = '\u0633\u0645\u0645';
	  t['\uFD64'] = '\u0635\u062D\u062D';
	  t['\uFD65'] = '\u0635\u062D\u062D';
	  t['\uFD66'] = '\u0635\u0645\u0645';
	  t['\uFD67'] = '\u0634\u062D\u0645';
	  t['\uFD68'] = '\u0634\u062D\u0645';
	  t['\uFD69'] = '\u0634\u062C\u064A';
	  t['\uFD6A'] = '\u0634\u0645\u062E';
	  t['\uFD6B'] = '\u0634\u0645\u062E';
	  t['\uFD6C'] = '\u0634\u0645\u0645';
	  t['\uFD6D'] = '\u0634\u0645\u0645';
	  t['\uFD6E'] = '\u0636\u062D\u0649';
	  t['\uFD6F'] = '\u0636\u062E\u0645';
	  t['\uFD70'] = '\u0636\u062E\u0645';
	  t['\uFD71'] = '\u0637\u0645\u062D';
	  t['\uFD72'] = '\u0637\u0645\u062D';
	  t['\uFD73'] = '\u0637\u0645\u0645';
	  t['\uFD74'] = '\u0637\u0645\u064A';
	  t['\uFD75'] = '\u0639\u062C\u0645';
	  t['\uFD76'] = '\u0639\u0645\u0645';
	  t['\uFD77'] = '\u0639\u0645\u0645';
	  t['\uFD78'] = '\u0639\u0645\u0649';
	  t['\uFD79'] = '\u063A\u0645\u0645';
	  t['\uFD7A'] = '\u063A\u0645\u064A';
	  t['\uFD7B'] = '\u063A\u0645\u0649';
	  t['\uFD7C'] = '\u0641\u062E\u0645';
	  t['\uFD7D'] = '\u0641\u062E\u0645';
	  t['\uFD7E'] = '\u0642\u0645\u062D';
	  t['\uFD7F'] = '\u0642\u0645\u0645';
	  t['\uFD80'] = '\u0644\u062D\u0645';
	  t['\uFD81'] = '\u0644\u062D\u064A';
	  t['\uFD82'] = '\u0644\u062D\u0649';
	  t['\uFD83'] = '\u0644\u062C\u062C';
	  t['\uFD84'] = '\u0644\u062C\u062C';
	  t['\uFD85'] = '\u0644\u062E\u0645';
	  t['\uFD86'] = '\u0644\u062E\u0645';
	  t['\uFD87'] = '\u0644\u0645\u062D';
	  t['\uFD88'] = '\u0644\u0645\u062D';
	  t['\uFD89'] = '\u0645\u062D\u062C';
	  t['\uFD8A'] = '\u0645\u062D\u0645';
	  t['\uFD8B'] = '\u0645\u062D\u064A';
	  t['\uFD8C'] = '\u0645\u062C\u062D';
	  t['\uFD8D'] = '\u0645\u062C\u0645';
	  t['\uFD8E'] = '\u0645\u062E\u062C';
	  t['\uFD8F'] = '\u0645\u062E\u0645';
	  t['\uFD92'] = '\u0645\u062C\u062E';
	  t['\uFD93'] = '\u0647\u0645\u062C';
	  t['\uFD94'] = '\u0647\u0645\u0645';
	  t['\uFD95'] = '\u0646\u062D\u0645';
	  t['\uFD96'] = '\u0646\u062D\u0649';
	  t['\uFD97'] = '\u0646\u062C\u0645';
	  t['\uFD98'] = '\u0646\u062C\u0645';
	  t['\uFD99'] = '\u0646\u062C\u0649';
	  t['\uFD9A'] = '\u0646\u0645\u064A';
	  t['\uFD9B'] = '\u0646\u0645\u0649';
	  t['\uFD9C'] = '\u064A\u0645\u0645';
	  t['\uFD9D'] = '\u064A\u0645\u0645';
	  t['\uFD9E'] = '\u0628\u062E\u064A';
	  t['\uFD9F'] = '\u062A\u062C\u064A';
	  t['\uFDA0'] = '\u062A\u062C\u0649';
	  t['\uFDA1'] = '\u062A\u062E\u064A';
	  t['\uFDA2'] = '\u062A\u062E\u0649';
	  t['\uFDA3'] = '\u062A\u0645\u064A';
	  t['\uFDA4'] = '\u062A\u0645\u0649';
	  t['\uFDA5'] = '\u062C\u0645\u064A';
	  t['\uFDA6'] = '\u062C\u062D\u0649';
	  t['\uFDA7'] = '\u062C\u0645\u0649';
	  t['\uFDA8'] = '\u0633\u062E\u0649';
	  t['\uFDA9'] = '\u0635\u062D\u064A';
	  t['\uFDAA'] = '\u0634\u062D\u064A';
	  t['\uFDAB'] = '\u0636\u062D\u064A';
	  t['\uFDAC'] = '\u0644\u062C\u064A';
	  t['\uFDAD'] = '\u0644\u0645\u064A';
	  t['\uFDAE'] = '\u064A\u062D\u064A';
	  t['\uFDAF'] = '\u064A\u062C\u064A';
	  t['\uFDB0'] = '\u064A\u0645\u064A';
	  t['\uFDB1'] = '\u0645\u0645\u064A';
	  t['\uFDB2'] = '\u0642\u0645\u064A';
	  t['\uFDB3'] = '\u0646\u062D\u064A';
	  t['\uFDB4'] = '\u0642\u0645\u062D';
	  t['\uFDB5'] = '\u0644\u062D\u0645';
	  t['\uFDB6'] = '\u0639\u0645\u064A';
	  t['\uFDB7'] = '\u0643\u0645\u064A';
	  t['\uFDB8'] = '\u0646\u062C\u062D';
	  t['\uFDB9'] = '\u0645\u062E\u064A';
	  t['\uFDBA'] = '\u0644\u062C\u0645';
	  t['\uFDBB'] = '\u0643\u0645\u0645';
	  t['\uFDBC'] = '\u0644\u062C\u0645';
	  t['\uFDBD'] = '\u0646\u062C\u062D';
	  t['\uFDBE'] = '\u062C\u062D\u064A';
	  t['\uFDBF'] = '\u062D\u062C\u064A';
	  t['\uFDC0'] = '\u0645\u062C\u064A';
	  t['\uFDC1'] = '\u0641\u0645\u064A';
	  t['\uFDC2'] = '\u0628\u062D\u064A';
	  t['\uFDC3'] = '\u0643\u0645\u0645';
	  t['\uFDC4'] = '\u0639\u062C\u0645';
	  t['\uFDC5'] = '\u0635\u0645\u0645';
	  t['\uFDC6'] = '\u0633\u062E\u064A';
	  t['\uFDC7'] = '\u0646\u062C\u064A';
	  t['\uFE49'] = '\u203E';
	  t['\uFE4A'] = '\u203E';
	  t['\uFE4B'] = '\u203E';
	  t['\uFE4C'] = '\u203E';
	  t['\uFE4D'] = '_';
	  t['\uFE4E'] = '_';
	  t['\uFE4F'] = '_';
	  t['\uFE80'] = '\u0621';
	  t['\uFE81'] = '\u0622';
	  t['\uFE82'] = '\u0622';
	  t['\uFE83'] = '\u0623';
	  t['\uFE84'] = '\u0623';
	  t['\uFE85'] = '\u0624';
	  t['\uFE86'] = '\u0624';
	  t['\uFE87'] = '\u0625';
	  t['\uFE88'] = '\u0625';
	  t['\uFE89'] = '\u0626';
	  t['\uFE8A'] = '\u0626';
	  t['\uFE8B'] = '\u0626';
	  t['\uFE8C'] = '\u0626';
	  t['\uFE8D'] = '\u0627';
	  t['\uFE8E'] = '\u0627';
	  t['\uFE8F'] = '\u0628';
	  t['\uFE90'] = '\u0628';
	  t['\uFE91'] = '\u0628';
	  t['\uFE92'] = '\u0628';
	  t['\uFE93'] = '\u0629';
	  t['\uFE94'] = '\u0629';
	  t['\uFE95'] = '\u062A';
	  t['\uFE96'] = '\u062A';
	  t['\uFE97'] = '\u062A';
	  t['\uFE98'] = '\u062A';
	  t['\uFE99'] = '\u062B';
	  t['\uFE9A'] = '\u062B';
	  t['\uFE9B'] = '\u062B';
	  t['\uFE9C'] = '\u062B';
	  t['\uFE9D'] = '\u062C';
	  t['\uFE9E'] = '\u062C';
	  t['\uFE9F'] = '\u062C';
	  t['\uFEA0'] = '\u062C';
	  t['\uFEA1'] = '\u062D';
	  t['\uFEA2'] = '\u062D';
	  t['\uFEA3'] = '\u062D';
	  t['\uFEA4'] = '\u062D';
	  t['\uFEA5'] = '\u062E';
	  t['\uFEA6'] = '\u062E';
	  t['\uFEA7'] = '\u062E';
	  t['\uFEA8'] = '\u062E';
	  t['\uFEA9'] = '\u062F';
	  t['\uFEAA'] = '\u062F';
	  t['\uFEAB'] = '\u0630';
	  t['\uFEAC'] = '\u0630';
	  t['\uFEAD'] = '\u0631';
	  t['\uFEAE'] = '\u0631';
	  t['\uFEAF'] = '\u0632';
	  t['\uFEB0'] = '\u0632';
	  t['\uFEB1'] = '\u0633';
	  t['\uFEB2'] = '\u0633';
	  t['\uFEB3'] = '\u0633';
	  t['\uFEB4'] = '\u0633';
	  t['\uFEB5'] = '\u0634';
	  t['\uFEB6'] = '\u0634';
	  t['\uFEB7'] = '\u0634';
	  t['\uFEB8'] = '\u0634';
	  t['\uFEB9'] = '\u0635';
	  t['\uFEBA'] = '\u0635';
	  t['\uFEBB'] = '\u0635';
	  t['\uFEBC'] = '\u0635';
	  t['\uFEBD'] = '\u0636';
	  t['\uFEBE'] = '\u0636';
	  t['\uFEBF'] = '\u0636';
	  t['\uFEC0'] = '\u0636';
	  t['\uFEC1'] = '\u0637';
	  t['\uFEC2'] = '\u0637';
	  t['\uFEC3'] = '\u0637';
	  t['\uFEC4'] = '\u0637';
	  t['\uFEC5'] = '\u0638';
	  t['\uFEC6'] = '\u0638';
	  t['\uFEC7'] = '\u0638';
	  t['\uFEC8'] = '\u0638';
	  t['\uFEC9'] = '\u0639';
	  t['\uFECA'] = '\u0639';
	  t['\uFECB'] = '\u0639';
	  t['\uFECC'] = '\u0639';
	  t['\uFECD'] = '\u063A';
	  t['\uFECE'] = '\u063A';
	  t['\uFECF'] = '\u063A';
	  t['\uFED0'] = '\u063A';
	  t['\uFED1'] = '\u0641';
	  t['\uFED2'] = '\u0641';
	  t['\uFED3'] = '\u0641';
	  t['\uFED4'] = '\u0641';
	  t['\uFED5'] = '\u0642';
	  t['\uFED6'] = '\u0642';
	  t['\uFED7'] = '\u0642';
	  t['\uFED8'] = '\u0642';
	  t['\uFED9'] = '\u0643';
	  t['\uFEDA'] = '\u0643';
	  t['\uFEDB'] = '\u0643';
	  t['\uFEDC'] = '\u0643';
	  t['\uFEDD'] = '\u0644';
	  t['\uFEDE'] = '\u0644';
	  t['\uFEDF'] = '\u0644';
	  t['\uFEE0'] = '\u0644';
	  t['\uFEE1'] = '\u0645';
	  t['\uFEE2'] = '\u0645';
	  t['\uFEE3'] = '\u0645';
	  t['\uFEE4'] = '\u0645';
	  t['\uFEE5'] = '\u0646';
	  t['\uFEE6'] = '\u0646';
	  t['\uFEE7'] = '\u0646';
	  t['\uFEE8'] = '\u0646';
	  t['\uFEE9'] = '\u0647';
	  t['\uFEEA'] = '\u0647';
	  t['\uFEEB'] = '\u0647';
	  t['\uFEEC'] = '\u0647';
	  t['\uFEED'] = '\u0648';
	  t['\uFEEE'] = '\u0648';
	  t['\uFEEF'] = '\u0649';
	  t['\uFEF0'] = '\u0649';
	  t['\uFEF1'] = '\u064A';
	  t['\uFEF2'] = '\u064A';
	  t['\uFEF3'] = '\u064A';
	  t['\uFEF4'] = '\u064A';
	  t['\uFEF5'] = '\u0644\u0622';
	  t['\uFEF6'] = '\u0644\u0622';
	  t['\uFEF7'] = '\u0644\u0623';
	  t['\uFEF8'] = '\u0644\u0623';
	  t['\uFEF9'] = '\u0644\u0625';
	  t['\uFEFA'] = '\u0644\u0625';
	  t['\uFEFB'] = '\u0644\u0627';
	  t['\uFEFC'] = '\u0644\u0627';
	});
	function reverseIfRtl(chars) {
	  var charsLength = chars.length;
	  if (charsLength <= 1 || !isRTLRangeFor(chars.charCodeAt(0))) {
	    return chars;
	  }
	  var s = '';
	  for (var ii = charsLength - 1; ii >= 0; ii--) {
	    s += chars[ii];
	  }
	  return s;
	}
	exports.mapSpecialUnicodeValues = mapSpecialUnicodeValues;
	exports.reverseIfRtl = reverseIfRtl;
	exports.getUnicodeRangeFor = getUnicodeRangeFor;
	exports.getNormalizedUnicodes = getNormalizedUnicodes;
	exports.getUnicodeForGlyph = getUnicodeForGlyph;
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var coreWorker = __w_pdfjs_require__(8);
	var globalScope = sharedUtil.globalScope;
	var OK_RESPONSE = 200;
	var PARTIAL_CONTENT_RESPONSE = 206;
	function NetworkManager(url, args) {
	  this.url = url;
	  args = args || {};
	  this.isHttp = /^https?:/i.test(url);
	  this.httpHeaders = this.isHttp && args.httpHeaders || {};
	  this.withCredentials = args.withCredentials || false;
	  this.getXhr = args.getXhr || function NetworkManager_getXhr() {
	    return new XMLHttpRequest();
	  };
	  this.currXhrId = 0;
	  this.pendingRequests = Object.create(null);
	  this.loadedRequests = Object.create(null);
	}
	function getArrayBuffer(xhr) {
	  var data = xhr.response;
	  if (typeof data !== 'string') {
	    return data;
	  }
	  var length = data.length;
	  var array = new Uint8Array(length);
	  for (var i = 0; i < length; i++) {
	    array[i] = data.charCodeAt(i) & 0xFF;
	  }
	  return array.buffer;
	}
	var supportsMozChunked = function supportsMozChunkedClosure() {
	  try {
	    var x = new XMLHttpRequest();
	    x.open('GET', globalScope.location.href);
	    x.responseType = 'moz-chunked-arraybuffer';
	    return x.responseType === 'moz-chunked-arraybuffer';
	  } catch (e) {
	    return false;
	  }
	}();
	NetworkManager.prototype = {
	  requestRange: function NetworkManager_requestRange(begin, end, listeners) {
	    var args = {
	      begin: begin,
	      end: end
	    };
	    for (var prop in listeners) {
	      args[prop] = listeners[prop];
	    }
	    return this.request(args);
	  },
	  requestFull: function NetworkManager_requestFull(listeners) {
	    return this.request(listeners);
	  },
	  request: function NetworkManager_request(args) {
	    var xhr = this.getXhr();
	    var xhrId = this.currXhrId++;
	    var pendingRequest = this.pendingRequests[xhrId] = { xhr: xhr };
	    xhr.open('GET', this.url);
	    xhr.withCredentials = this.withCredentials;
	    for (var property in this.httpHeaders) {
	      var value = this.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      xhr.setRequestHeader(property, value);
	    }
	    if (this.isHttp && 'begin' in args && 'end' in args) {
	      var rangeStr = args.begin + '-' + (args.end - 1);
	      xhr.setRequestHeader('Range', 'bytes=' + rangeStr);
	      pendingRequest.expectedStatus = 206;
	    } else {
	      pendingRequest.expectedStatus = 200;
	    }
	    var useMozChunkedLoading = supportsMozChunked && !!args.onProgressiveData;
	    if (useMozChunkedLoading) {
	      xhr.responseType = 'moz-chunked-arraybuffer';
	      pendingRequest.onProgressiveData = args.onProgressiveData;
	      pendingRequest.mozChunked = true;
	    } else {
	      xhr.responseType = 'arraybuffer';
	    }
	    if (args.onError) {
	      xhr.onerror = function (evt) {
	        args.onError(xhr.status);
	      };
	    }
	    xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
	    xhr.onprogress = this.onProgress.bind(this, xhrId);
	    pendingRequest.onHeadersReceived = args.onHeadersReceived;
	    pendingRequest.onDone = args.onDone;
	    pendingRequest.onError = args.onError;
	    pendingRequest.onProgress = args.onProgress;
	    xhr.send(null);
	    return xhrId;
	  },
	  onProgress: function NetworkManager_onProgress(xhrId, evt) {
	    var pendingRequest = this.pendingRequests[xhrId];
	    if (!pendingRequest) {
	      return;
	    }
	    if (pendingRequest.mozChunked) {
	      var chunk = getArrayBuffer(pendingRequest.xhr);
	      pendingRequest.onProgressiveData(chunk);
	    }
	    var onProgress = pendingRequest.onProgress;
	    if (onProgress) {
	      onProgress(evt);
	    }
	  },
	  onStateChange: function NetworkManager_onStateChange(xhrId, evt) {
	    var pendingRequest = this.pendingRequests[xhrId];
	    if (!pendingRequest) {
	      return;
	    }
	    var xhr = pendingRequest.xhr;
	    if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
	      pendingRequest.onHeadersReceived();
	      delete pendingRequest.onHeadersReceived;
	    }
	    if (xhr.readyState !== 4) {
	      return;
	    }
	    if (!(xhrId in this.pendingRequests)) {
	      return;
	    }
	    delete this.pendingRequests[xhrId];
	    if (xhr.status === 0 && this.isHttp) {
	      if (pendingRequest.onError) {
	        pendingRequest.onError(xhr.status);
	      }
	      return;
	    }
	    var xhrStatus = xhr.status || OK_RESPONSE;
	    var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
	    if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
	      if (pendingRequest.onError) {
	        pendingRequest.onError(xhr.status);
	      }
	      return;
	    }
	    this.loadedRequests[xhrId] = true;
	    var chunk = getArrayBuffer(xhr);
	    if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
	      var rangeHeader = xhr.getResponseHeader('Content-Range');
	      var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
	      var begin = parseInt(matches[1], 10);
	      pendingRequest.onDone({
	        begin: begin,
	        chunk: chunk
	      });
	    } else if (pendingRequest.onProgressiveData) {
	      pendingRequest.onDone(null);
	    } else if (chunk) {
	      pendingRequest.onDone({
	        begin: 0,
	        chunk: chunk
	      });
	    } else if (pendingRequest.onError) {
	      pendingRequest.onError(xhr.status);
	    }
	  },
	  hasPendingRequests: function NetworkManager_hasPendingRequests() {
	    for (var xhrId in this.pendingRequests) {
	      return true;
	    }
	    return false;
	  },
	  getRequestXhr: function NetworkManager_getXhr(xhrId) {
	    return this.pendingRequests[xhrId].xhr;
	  },
	  isStreamingRequest: function NetworkManager_isStreamingRequest(xhrId) {
	    return !!this.pendingRequests[xhrId].onProgressiveData;
	  },
	  isPendingRequest: function NetworkManager_isPendingRequest(xhrId) {
	    return xhrId in this.pendingRequests;
	  },
	  isLoadedRequest: function NetworkManager_isLoadedRequest(xhrId) {
	    return xhrId in this.loadedRequests;
	  },
	  abortAllRequests: function NetworkManager_abortAllRequests() {
	    for (var xhrId in this.pendingRequests) {
	      this.abortRequest(xhrId | 0);
	    }
	  },
	  abortRequest: function NetworkManager_abortRequest(xhrId) {
	    var xhr = this.pendingRequests[xhrId].xhr;
	    delete this.pendingRequests[xhrId];
	    xhr.abort();
	  }
	};
	var assert = sharedUtil.assert;
	var createPromiseCapability = sharedUtil.createPromiseCapability;
	var isInt = sharedUtil.isInt;
	var MissingPDFException = sharedUtil.MissingPDFException;
	var UnexpectedResponseException = sharedUtil.UnexpectedResponseException;
	function PDFNetworkStream(options) {
	  this._options = options;
	  var source = options.source;
	  this._manager = new NetworkManager(source.url, {
	    httpHeaders: source.httpHeaders,
	    withCredentials: source.withCredentials
	  });
	  this._rangeChunkSize = source.rangeChunkSize;
	  this._fullRequestReader = null;
	  this._rangeRequestReaders = [];
	}
	PDFNetworkStream.prototype = {
	  _onRangeRequestReaderClosed: function PDFNetworkStream_onRangeRequestReaderClosed(reader) {
	    var i = this._rangeRequestReaders.indexOf(reader);
	    if (i >= 0) {
	      this._rangeRequestReaders.splice(i, 1);
	    }
	  },
	  getFullReader: function PDFNetworkStream_getFullReader() {
	    assert(!this._fullRequestReader);
	    this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._options);
	    return this._fullRequestReader;
	  },
	  getRangeReader: function PDFNetworkStream_getRangeReader(begin, end) {
	    var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
	    reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
	    this._rangeRequestReaders.push(reader);
	    return reader;
	  },
	  cancelAllRequests: function PDFNetworkStream_cancelAllRequests(reason) {
	    if (this._fullRequestReader) {
	      this._fullRequestReader.cancel(reason);
	    }
	    var readers = this._rangeRequestReaders.slice(0);
	    readers.forEach(function (reader) {
	      reader.cancel(reason);
	    });
	  }
	};
	function PDFNetworkStreamFullRequestReader(manager, options) {
	  this._manager = manager;
	  var source = options.source;
	  var args = {
	    onHeadersReceived: this._onHeadersReceived.bind(this),
	    onProgressiveData: source.disableStream ? null : this._onProgressiveData.bind(this),
	    onDone: this._onDone.bind(this),
	    onError: this._onError.bind(this),
	    onProgress: this._onProgress.bind(this)
	  };
	  this._url = source.url;
	  this._fullRequestId = manager.requestFull(args);
	  this._headersReceivedCapability = createPromiseCapability();
	  this._disableRange = options.disableRange || false;
	  this._contentLength = source.length;
	  this._rangeChunkSize = source.rangeChunkSize;
	  if (!this._rangeChunkSize && !this._disableRange) {
	    this._disableRange = true;
	  }
	  this._isStreamingSupported = false;
	  this._isRangeSupported = false;
	  this._cachedChunks = [];
	  this._requests = [];
	  this._done = false;
	  this._storedError = undefined;
	  this.onProgress = null;
	}
	PDFNetworkStreamFullRequestReader.prototype = {
	  _validateRangeRequestCapabilities: function PDFNetworkStreamFullRequestReader_validateRangeRequestCapabilities() {
	    if (this._disableRange) {
	      return false;
	    }
	    var networkManager = this._manager;
	    if (!networkManager.isHttp) {
	      return false;
	    }
	    var fullRequestXhrId = this._fullRequestId;
	    var fullRequestXhr = networkManager.getRequestXhr(fullRequestXhrId);
	    if (fullRequestXhr.getResponseHeader('Accept-Ranges') !== 'bytes') {
	      return false;
	    }
	    var contentEncoding = fullRequestXhr.getResponseHeader('Content-Encoding') || 'identity';
	    if (contentEncoding !== 'identity') {
	      return false;
	    }
	    var length = fullRequestXhr.getResponseHeader('Content-Length');
	    length = parseInt(length, 10);
	    if (!isInt(length)) {
	      return false;
	    }
	    this._contentLength = length;
	    if (length <= 2 * this._rangeChunkSize) {
	      return false;
	    }
	    return true;
	  },
	  _onHeadersReceived: function PDFNetworkStreamFullRequestReader_onHeadersReceived() {
	    if (this._validateRangeRequestCapabilities()) {
	      this._isRangeSupported = true;
	    }
	    var networkManager = this._manager;
	    var fullRequestXhrId = this._fullRequestId;
	    if (networkManager.isStreamingRequest(fullRequestXhrId)) {
	      this._isStreamingSupported = true;
	    } else if (this._isRangeSupported) {
	      networkManager.abortRequest(fullRequestXhrId);
	    }
	    this._headersReceivedCapability.resolve();
	  },
	  _onProgressiveData: function PDFNetworkStreamFullRequestReader_onProgressiveData(chunk) {
	    if (this._requests.length > 0) {
	      var requestCapability = this._requests.shift();
	      requestCapability.resolve({
	        value: chunk,
	        done: false
	      });
	    } else {
	      this._cachedChunks.push(chunk);
	    }
	  },
	  _onDone: function PDFNetworkStreamFullRequestReader_onDone(args) {
	    if (args) {
	      this._onProgressiveData(args.chunk);
	    }
	    this._done = true;
	    if (this._cachedChunks.length > 0) {
	      return;
	    }
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	  },
	  _onError: function PDFNetworkStreamFullRequestReader_onError(status) {
	    var url = this._url;
	    var exception;
	    if (status === 404 || status === 0 && /^file:/.test(url)) {
	      exception = new MissingPDFException('Missing PDF "' + url + '".');
	    } else {
	      exception = new UnexpectedResponseException('Unexpected server response (' + status + ') while retrieving PDF "' + url + '".', status);
	    }
	    this._storedError = exception;
	    this._headersReceivedCapability.reject(exception);
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.reject(exception);
	    });
	    this._requests = [];
	    this._cachedChunks = [];
	  },
	  _onProgress: function PDFNetworkStreamFullRequestReader_onProgress(data) {
	    if (this.onProgress) {
	      this.onProgress({
	        loaded: data.loaded,
	        total: data.lengthComputable ? data.total : this._contentLength
	      });
	    }
	  },
	  get isRangeSupported() {
	    return this._isRangeSupported;
	  },
	  get isStreamingSupported() {
	    return this._isStreamingSupported;
	  },
	  get contentLength() {
	    return this._contentLength;
	  },
	  get headersReady() {
	    return this._headersReceivedCapability.promise;
	  },
	  read: function PDFNetworkStreamFullRequestReader_read() {
	    if (this._storedError) {
	      return Promise.reject(this._storedError);
	    }
	    if (this._cachedChunks.length > 0) {
	      var chunk = this._cachedChunks.shift();
	      return Promise.resolve(chunk);
	    }
	    if (this._done) {
	      return Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    }
	    var requestCapability = createPromiseCapability();
	    this._requests.push(requestCapability);
	    return requestCapability.promise;
	  },
	  cancel: function PDFNetworkStreamFullRequestReader_cancel(reason) {
	    this._done = true;
	    this._headersReceivedCapability.reject(reason);
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    if (this._manager.isPendingRequest(this._fullRequestId)) {
	      this._manager.abortRequest(this._fullRequestId);
	    }
	    this._fullRequestReader = null;
	  }
	};
	function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
	  this._manager = manager;
	  var args = {
	    onDone: this._onDone.bind(this),
	    onProgress: this._onProgress.bind(this)
	  };
	  this._requestId = manager.requestRange(begin, end, args);
	  this._requests = [];
	  this._queuedChunk = null;
	  this._done = false;
	  this.onProgress = null;
	  this.onClosed = null;
	}
	PDFNetworkStreamRangeRequestReader.prototype = {
	  _close: function PDFNetworkStreamRangeRequestReader_close() {
	    if (this.onClosed) {
	      this.onClosed(this);
	    }
	  },
	  _onDone: function PDFNetworkStreamRangeRequestReader_onDone(data) {
	    var chunk = data.chunk;
	    if (this._requests.length > 0) {
	      var requestCapability = this._requests.shift();
	      requestCapability.resolve({
	        value: chunk,
	        done: false
	      });
	    } else {
	      this._queuedChunk = chunk;
	    }
	    this._done = true;
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    this._close();
	  },
	  _onProgress: function PDFNetworkStreamRangeRequestReader_onProgress(evt) {
	    if (!this.isStreamingSupported && this.onProgress) {
	      this.onProgress({ loaded: evt.loaded });
	    }
	  },
	  get isStreamingSupported() {
	    return false;
	  },
	  read: function PDFNetworkStreamRangeRequestReader_read() {
	    if (this._queuedChunk !== null) {
	      var chunk = this._queuedChunk;
	      this._queuedChunk = null;
	      return Promise.resolve({
	        value: chunk,
	        done: false
	      });
	    }
	    if (this._done) {
	      return Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    }
	    var requestCapability = createPromiseCapability();
	    this._requests.push(requestCapability);
	    return requestCapability.promise;
	  },
	  cancel: function PDFNetworkStreamRangeRequestReader_cancel(reason) {
	    this._done = true;
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    if (this._manager.isPendingRequest(this._requestId)) {
	      this._manager.abortRequest(this._requestId);
	    }
	    this._close();
	  }
	};
	coreWorker.setPDFNetworkStreamClass(PDFNetworkStream);
	exports.PDFNetworkStream = PDFNetworkStream;
	exports.NetworkManager = NetworkManager;
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var coreStream = __w_pdfjs_require__(2);
	var coreColorSpace = __w_pdfjs_require__(3);
	var coreObj = __w_pdfjs_require__(16);
	var coreEvaluator = __w_pdfjs_require__(14);
	var AnnotationBorderStyleType = sharedUtil.AnnotationBorderStyleType;
	var AnnotationFieldFlag = sharedUtil.AnnotationFieldFlag;
	var AnnotationFlag = sharedUtil.AnnotationFlag;
	var AnnotationType = sharedUtil.AnnotationType;
	var OPS = sharedUtil.OPS;
	var Util = sharedUtil.Util;
	var isArray = sharedUtil.isArray;
	var isInt = sharedUtil.isInt;
	var stringToBytes = sharedUtil.stringToBytes;
	var stringToPDFString = sharedUtil.stringToPDFString;
	var warn = sharedUtil.warn;
	var Dict = corePrimitives.Dict;
	var isDict = corePrimitives.isDict;
	var isName = corePrimitives.isName;
	var isRef = corePrimitives.isRef;
	var isStream = corePrimitives.isStream;
	var Stream = coreStream.Stream;
	var ColorSpace = coreColorSpace.ColorSpace;
	var Catalog = coreObj.Catalog;
	var ObjectLoader = coreObj.ObjectLoader;
	var FileSpec = coreObj.FileSpec;
	var OperatorList = coreEvaluator.OperatorList;
	function AnnotationFactory() {}
	AnnotationFactory.prototype = {
	  create: function AnnotationFactory_create(xref, ref, pdfManager, idFactory) {
	    var dict = xref.fetchIfRef(ref);
	    if (!isDict(dict)) {
	      return;
	    }
	    var id = isRef(ref) ? ref.toString() : 'annot_' + idFactory.createObjId();
	    var subtype = dict.get('Subtype');
	    subtype = isName(subtype) ? subtype.name : null;
	    var parameters = {
	      xref: xref,
	      dict: dict,
	      ref: isRef(ref) ? ref : null,
	      subtype: subtype,
	      id: id,
	      pdfManager: pdfManager
	    };
	    switch (subtype) {
	      case 'Link':
	        return new LinkAnnotation(parameters);
	      case 'Text':
	        return new TextAnnotation(parameters);
	      case 'Widget':
	        var fieldType = Util.getInheritableProperty(dict, 'FT');
	        fieldType = isName(fieldType) ? fieldType.name : null;
	        switch (fieldType) {
	          case 'Tx':
	            return new TextWidgetAnnotation(parameters);
	          case 'Btn':
	            return new ButtonWidgetAnnotation(parameters);
	          case 'Ch':
	            return new ChoiceWidgetAnnotation(parameters);
	        }
	        warn('Unimplemented widget field type "' + fieldType + '", ' + 'falling back to base field type.');
	        return new WidgetAnnotation(parameters);
	      case 'Popup':
	        return new PopupAnnotation(parameters);
	      case 'Line':
	        return new LineAnnotation(parameters);
	      case 'Highlight':
	        return new HighlightAnnotation(parameters);
	      case 'Underline':
	        return new UnderlineAnnotation(parameters);
	      case 'Squiggly':
	        return new SquigglyAnnotation(parameters);
	      case 'StrikeOut':
	        return new StrikeOutAnnotation(parameters);
	      case 'FileAttachment':
	        return new FileAttachmentAnnotation(parameters);
	      default:
	        if (!subtype) {
	          warn('Annotation is missing the required /Subtype.');
	        } else {
	          warn('Unimplemented annotation type "' + subtype + '", ' + 'falling back to base annotation.');
	        }
	        return new Annotation(parameters);
	    }
	  }
	};
	var Annotation = function AnnotationClosure() {
	  function getTransformMatrix(rect, bbox, matrix) {
	    var bounds = Util.getAxialAlignedBoundingBox(bbox, matrix);
	    var minX = bounds[0];
	    var minY = bounds[1];
	    var maxX = bounds[2];
	    var maxY = bounds[3];
	    if (minX === maxX || minY === maxY) {
	      return [1, 0, 0, 1, rect[0], rect[1]];
	    }
	    var xRatio = (rect[2] - rect[0]) / (maxX - minX);
	    var yRatio = (rect[3] - rect[1]) / (maxY - minY);
	    return [xRatio, 0, 0, yRatio, rect[0] - minX * xRatio, rect[1] - minY * yRatio];
	  }
	  function Annotation(params) {
	    var dict = params.dict;
	    this.setFlags(dict.get('F'));
	    this.setRectangle(dict.getArray('Rect'));
	    this.setColor(dict.getArray('C'));
	    this.setBorderStyle(dict);
	    this.setAppearance(dict);
	    this.data = {};
	    this.data.id = params.id;
	    this.data.subtype = params.subtype;
	    this.data.annotationFlags = this.flags;
	    this.data.rect = this.rectangle;
	    this.data.color = this.color;
	    this.data.borderStyle = this.borderStyle;
	    this.data.hasAppearance = !!this.appearance;
	  }
	  Annotation.prototype = {
	    _hasFlag: function Annotation_hasFlag(flags, flag) {
	      return !!(flags & flag);
	    },
	    _isViewable: function Annotation_isViewable(flags) {
	      return !this._hasFlag(flags, AnnotationFlag.INVISIBLE) && !this._hasFlag(flags, AnnotationFlag.HIDDEN) && !this._hasFlag(flags, AnnotationFlag.NOVIEW);
	    },
	    _isPrintable: function AnnotationFlag_isPrintable(flags) {
	      return this._hasFlag(flags, AnnotationFlag.PRINT) && !this._hasFlag(flags, AnnotationFlag.INVISIBLE) && !this._hasFlag(flags, AnnotationFlag.HIDDEN);
	    },
	    get viewable() {
	      if (this.flags === 0) {
	        return true;
	      }
	      return this._isViewable(this.flags);
	    },
	    get printable() {
	      if (this.flags === 0) {
	        return false;
	      }
	      return this._isPrintable(this.flags);
	    },
	    setFlags: function Annotation_setFlags(flags) {
	      this.flags = isInt(flags) && flags > 0 ? flags : 0;
	    },
	    hasFlag: function Annotation_hasFlag(flag) {
	      return this._hasFlag(this.flags, flag);
	    },
	    setRectangle: function Annotation_setRectangle(rectangle) {
	      if (isArray(rectangle) && rectangle.length === 4) {
	        this.rectangle = Util.normalizeRect(rectangle);
	      } else {
	        this.rectangle = [0, 0, 0, 0];
	      }
	    },
	    setColor: function Annotation_setColor(color) {
	      var rgbColor = new Uint8Array(3);
	      if (!isArray(color)) {
	        this.color = rgbColor;
	        return;
	      }
	      switch (color.length) {
	        case 0:
	          this.color = null;
	          break;
	        case 1:
	          ColorSpace.singletons.gray.getRgbItem(color, 0, rgbColor, 0);
	          this.color = rgbColor;
	          break;
	        case 3:
	          ColorSpace.singletons.rgb.getRgbItem(color, 0, rgbColor, 0);
	          this.color = rgbColor;
	          break;
	        case 4:
	          ColorSpace.singletons.cmyk.getRgbItem(color, 0, rgbColor, 0);
	          this.color = rgbColor;
	          break;
	        default:
	          this.color = rgbColor;
	          break;
	      }
	    },
	    setBorderStyle: function Annotation_setBorderStyle(borderStyle) {
	      this.borderStyle = new AnnotationBorderStyle();
	      if (!isDict(borderStyle)) {
	        return;
	      }
	      if (borderStyle.has('BS')) {
	        var dict = borderStyle.get('BS');
	        var dictType = dict.get('Type');
	        if (!dictType || isName(dictType, 'Border')) {
	          this.borderStyle.setWidth(dict.get('W'));
	          this.borderStyle.setStyle(dict.get('S'));
	          this.borderStyle.setDashArray(dict.getArray('D'));
	        }
	      } else if (borderStyle.has('Border')) {
	        var array = borderStyle.getArray('Border');
	        if (isArray(array) && array.length >= 3) {
	          this.borderStyle.setHorizontalCornerRadius(array[0]);
	          this.borderStyle.setVerticalCornerRadius(array[1]);
	          this.borderStyle.setWidth(array[2]);
	          if (array.length === 4) {
	            this.borderStyle.setDashArray(array[3]);
	          }
	        }
	      } else {
	        this.borderStyle.setWidth(0);
	      }
	    },
	    setAppearance: function Annotation_setAppearance(dict) {
	      this.appearance = null;
	      var appearanceStates = dict.get('AP');
	      if (!isDict(appearanceStates)) {
	        return;
	      }
	      var normalAppearanceState = appearanceStates.get('N');
	      if (isStream(normalAppearanceState)) {
	        this.appearance = normalAppearanceState;
	        return;
	      }
	      if (!isDict(normalAppearanceState)) {
	        return;
	      }
	      var as = dict.get('AS');
	      if (!isName(as) || !normalAppearanceState.has(as.name)) {
	        return;
	      }
	      this.appearance = normalAppearanceState.get(as.name);
	    },
	    _preparePopup: function Annotation_preparePopup(dict) {
	      if (!dict.has('C')) {
	        this.data.color = null;
	      }
	      this.data.hasPopup = dict.has('Popup');
	      this.data.title = stringToPDFString(dict.get('T') || '');
	      this.data.contents = stringToPDFString(dict.get('Contents') || '');
	    },
	    loadResources: function Annotation_loadResources(keys) {
	      return this.appearance.dict.getAsync('Resources').then(function (resources) {
	        if (!resources) {
	          return;
	        }
	        var objectLoader = new ObjectLoader(resources.map, keys, resources.xref);
	        return objectLoader.load().then(function () {
	          return resources;
	        });
	      });
	    },
	    getOperatorList: function Annotation_getOperatorList(evaluator, task, renderForms) {
	      var _this = this;
	
	      if (!this.appearance) {
	        return Promise.resolve(new OperatorList());
	      }
	      var data = this.data;
	      var appearanceDict = this.appearance.dict;
	      var resourcesPromise = this.loadResources(['ExtGState', 'ColorSpace', 'Pattern', 'Shading', 'XObject', 'Font']);
	      var bbox = appearanceDict.getArray('BBox') || [0, 0, 1, 1];
	      var matrix = appearanceDict.getArray('Matrix') || [1, 0, 0, 1, 0, 0];
	      var transform = getTransformMatrix(data.rect, bbox, matrix);
	      return resourcesPromise.then(function (resources) {
	        var opList = new OperatorList();
	        opList.addOp(OPS.beginAnnotation, [data.rect, transform, matrix]);
	        return evaluator.getOperatorList({
	          stream: _this.appearance,
	          task: task,
	          resources: resources,
	          operatorList: opList
	        }).then(function () {
	          opList.addOp(OPS.endAnnotation, []);
	          _this.appearance.reset();
	          return opList;
	        });
	      });
	    }
	  };
	  return Annotation;
	}();
	var AnnotationBorderStyle = function AnnotationBorderStyleClosure() {
	  function AnnotationBorderStyle() {
	    this.width = 1;
	    this.style = AnnotationBorderStyleType.SOLID;
	    this.dashArray = [3];
	    this.horizontalCornerRadius = 0;
	    this.verticalCornerRadius = 0;
	  }
	  AnnotationBorderStyle.prototype = {
	    setWidth: function AnnotationBorderStyle_setWidth(width) {
	      if (width === (width | 0)) {
	        this.width = width;
	      }
	    },
	    setStyle: function AnnotationBorderStyle_setStyle(style) {
	      if (!style) {
	        return;
	      }
	      switch (style.name) {
	        case 'S':
	          this.style = AnnotationBorderStyleType.SOLID;
	          break;
	        case 'D':
	          this.style = AnnotationBorderStyleType.DASHED;
	          break;
	        case 'B':
	          this.style = AnnotationBorderStyleType.BEVELED;
	          break;
	        case 'I':
	          this.style = AnnotationBorderStyleType.INSET;
	          break;
	        case 'U':
	          this.style = AnnotationBorderStyleType.UNDERLINE;
	          break;
	        default:
	          break;
	      }
	    },
	    setDashArray: function AnnotationBorderStyle_setDashArray(dashArray) {
	      if (isArray(dashArray) && dashArray.length > 0) {
	        var isValid = true;
	        var allZeros = true;
	        for (var i = 0, len = dashArray.length; i < len; i++) {
	          var element = dashArray[i];
	          var validNumber = +element >= 0;
	          if (!validNumber) {
	            isValid = false;
	            break;
	          } else if (element > 0) {
	            allZeros = false;
	          }
	        }
	        if (isValid && !allZeros) {
	          this.dashArray = dashArray;
	        } else {
	          this.width = 0;
	        }
	      } else if (dashArray) {
	        this.width = 0;
	      }
	    },
	    setHorizontalCornerRadius: function AnnotationBorderStyle_setHorizontalCornerRadius(radius) {
	      if (radius === (radius | 0)) {
	        this.horizontalCornerRadius = radius;
	      }
	    },
	    setVerticalCornerRadius: function AnnotationBorderStyle_setVerticalCornerRadius(radius) {
	      if (radius === (radius | 0)) {
	        this.verticalCornerRadius = radius;
	      }
	    }
	  };
	  return AnnotationBorderStyle;
	}();
	var WidgetAnnotation = function WidgetAnnotationClosure() {
	  function WidgetAnnotation(params) {
	    Annotation.call(this, params);
	    var dict = params.dict;
	    var data = this.data;
	    data.annotationType = AnnotationType.WIDGET;
	    data.fieldName = this._constructFieldName(dict);
	    data.fieldValue = Util.getInheritableProperty(dict, 'V', true);
	    data.alternativeText = stringToPDFString(dict.get('TU') || '');
	    data.defaultAppearance = Util.getInheritableProperty(dict, 'DA') || '';
	    var fieldType = Util.getInheritableProperty(dict, 'FT');
	    data.fieldType = isName(fieldType) ? fieldType.name : null;
	    this.fieldResources = Util.getInheritableProperty(dict, 'DR') || Dict.empty;
	    data.fieldFlags = Util.getInheritableProperty(dict, 'Ff');
	    if (!isInt(data.fieldFlags) || data.fieldFlags < 0) {
	      data.fieldFlags = 0;
	    }
	    data.readOnly = this.hasFieldFlag(AnnotationFieldFlag.READONLY);
	    if (data.fieldType === 'Sig') {
	      this.setFlags(AnnotationFlag.HIDDEN);
	    }
	  }
	  Util.inherit(WidgetAnnotation, Annotation, {
	    _constructFieldName: function WidgetAnnotation_constructFieldName(dict) {
	      if (!dict.has('T') && !dict.has('Parent')) {
	        warn('Unknown field name, falling back to empty field name.');
	        return '';
	      }
	      if (!dict.has('Parent')) {
	        return stringToPDFString(dict.get('T'));
	      }
	      var fieldName = [];
	      if (dict.has('T')) {
	        fieldName.unshift(stringToPDFString(dict.get('T')));
	      }
	      var loopDict = dict;
	      while (loopDict.has('Parent')) {
	        loopDict = loopDict.get('Parent');
	        if (!isDict(loopDict)) {
	          break;
	        }
	        if (loopDict.has('T')) {
	          fieldName.unshift(stringToPDFString(loopDict.get('T')));
	        }
	      }
	      return fieldName.join('.');
	    },
	    hasFieldFlag: function WidgetAnnotation_hasFieldFlag(flag) {
	      return !!(this.data.fieldFlags & flag);
	    }
	  });
	  return WidgetAnnotation;
	}();
	var TextWidgetAnnotation = function TextWidgetAnnotationClosure() {
	  function TextWidgetAnnotation(params) {
	    WidgetAnnotation.call(this, params);
	    this.data.fieldValue = stringToPDFString(this.data.fieldValue || '');
	    var alignment = Util.getInheritableProperty(params.dict, 'Q');
	    if (!isInt(alignment) || alignment < 0 || alignment > 2) {
	      alignment = null;
	    }
	    this.data.textAlignment = alignment;
	    var maximumLength = Util.getInheritableProperty(params.dict, 'MaxLen');
	    if (!isInt(maximumLength) || maximumLength < 0) {
	      maximumLength = null;
	    }
	    this.data.maxLen = maximumLength;
	    this.data.multiLine = this.hasFieldFlag(AnnotationFieldFlag.MULTILINE);
	    this.data.comb = this.hasFieldFlag(AnnotationFieldFlag.COMB) && !this.hasFieldFlag(AnnotationFieldFlag.MULTILINE) && !this.hasFieldFlag(AnnotationFieldFlag.PASSWORD) && !this.hasFieldFlag(AnnotationFieldFlag.FILESELECT) && this.data.maxLen !== null;
	  }
	  Util.inherit(TextWidgetAnnotation, WidgetAnnotation, {
	    getOperatorList: function TextWidgetAnnotation_getOperatorList(evaluator, task, renderForms) {
	      var operatorList = new OperatorList();
	      if (renderForms) {
	        return Promise.resolve(operatorList);
	      }
	      if (this.appearance) {
	        return Annotation.prototype.getOperatorList.call(this, evaluator, task, renderForms);
	      }
	      if (!this.data.defaultAppearance) {
	        return Promise.resolve(operatorList);
	      }
	      var stream = new Stream(stringToBytes(this.data.defaultAppearance));
	      return evaluator.getOperatorList({
	        stream: stream,
	        task: task,
	        resources: this.fieldResources,
	        operatorList: operatorList
	      }).then(function () {
	        return operatorList;
	      });
	    }
	  });
	  return TextWidgetAnnotation;
	}();
	var ButtonWidgetAnnotation = function ButtonWidgetAnnotationClosure() {
	  function ButtonWidgetAnnotation(params) {
	    WidgetAnnotation.call(this, params);
	    this.data.checkBox = !this.hasFieldFlag(AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(AnnotationFieldFlag.PUSHBUTTON);
	    if (this.data.checkBox) {
	      if (!isName(this.data.fieldValue)) {
	        return;
	      }
	      this.data.fieldValue = this.data.fieldValue.name;
	    }
	    this.data.radioButton = this.hasFieldFlag(AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(AnnotationFieldFlag.PUSHBUTTON);
	    if (this.data.radioButton) {
	      this.data.fieldValue = this.data.buttonValue = null;
	      var fieldParent = params.dict.get('Parent');
	      if (isDict(fieldParent) && fieldParent.has('V')) {
	        var fieldParentValue = fieldParent.get('V');
	        if (isName(fieldParentValue)) {
	          this.data.fieldValue = fieldParentValue.name;
	        }
	      }
	      var appearanceStates = params.dict.get('AP');
	      if (!isDict(appearanceStates)) {
	        return;
	      }
	      var normalAppearanceState = appearanceStates.get('N');
	      if (!isDict(normalAppearanceState)) {
	        return;
	      }
	      var keys = normalAppearanceState.getKeys();
	      for (var i = 0, ii = keys.length; i < ii; i++) {
	        if (keys[i] !== 'Off') {
	          this.data.buttonValue = keys[i];
	          break;
	        }
	      }
	    }
	  }
	  Util.inherit(ButtonWidgetAnnotation, WidgetAnnotation, {
	    getOperatorList: function ButtonWidgetAnnotation_getOperatorList(evaluator, task, renderForms) {
	      var operatorList = new OperatorList();
	      if (renderForms) {
	        return Promise.resolve(operatorList);
	      }
	      if (this.appearance) {
	        return Annotation.prototype.getOperatorList.call(this, evaluator, task, renderForms);
	      }
	      return Promise.resolve(operatorList);
	    }
	  });
	  return ButtonWidgetAnnotation;
	}();
	var ChoiceWidgetAnnotation = function ChoiceWidgetAnnotationClosure() {
	  function ChoiceWidgetAnnotation(params) {
	    WidgetAnnotation.call(this, params);
	    this.data.options = [];
	    var options = Util.getInheritableProperty(params.dict, 'Opt');
	    if (isArray(options)) {
	      var xref = params.xref;
	      for (var i = 0, ii = options.length; i < ii; i++) {
	        var option = xref.fetchIfRef(options[i]);
	        var isOptionArray = isArray(option);
	        this.data.options[i] = {
	          exportValue: isOptionArray ? xref.fetchIfRef(option[0]) : option,
	          displayValue: isOptionArray ? xref.fetchIfRef(option[1]) : option
	        };
	      }
	    }
	    if (!isArray(this.data.fieldValue)) {
	      this.data.fieldValue = [this.data.fieldValue];
	    }
	    this.data.combo = this.hasFieldFlag(AnnotationFieldFlag.COMBO);
	    this.data.multiSelect = this.hasFieldFlag(AnnotationFieldFlag.MULTISELECT);
	  }
	  Util.inherit(ChoiceWidgetAnnotation, WidgetAnnotation, {
	    getOperatorList: function ChoiceWidgetAnnotation_getOperatorList(evaluator, task, renderForms) {
	      var operatorList = new OperatorList();
	      if (renderForms) {
	        return Promise.resolve(operatorList);
	      }
	      return Annotation.prototype.getOperatorList.call(this, evaluator, task, renderForms);
	    }
	  });
	  return ChoiceWidgetAnnotation;
	}();
	var TextAnnotation = function TextAnnotationClosure() {
	  var DEFAULT_ICON_SIZE = 22;
	  function TextAnnotation(parameters) {
	    Annotation.call(this, parameters);
	    this.data.annotationType = AnnotationType.TEXT;
	    if (this.data.hasAppearance) {
	      this.data.name = 'NoIcon';
	    } else {
	      this.data.rect[1] = this.data.rect[3] - DEFAULT_ICON_SIZE;
	      this.data.rect[2] = this.data.rect[0] + DEFAULT_ICON_SIZE;
	      this.data.name = parameters.dict.has('Name') ? parameters.dict.get('Name').name : 'Note';
	    }
	    this._preparePopup(parameters.dict);
	  }
	  Util.inherit(TextAnnotation, Annotation, {});
	  return TextAnnotation;
	}();
	var LinkAnnotation = function LinkAnnotationClosure() {
	  function LinkAnnotation(params) {
	    Annotation.call(this, params);
	    var data = this.data;
	    data.annotationType = AnnotationType.LINK;
	    Catalog.parseDestDictionary({
	      destDict: params.dict,
	      resultObj: data,
	      docBaseUrl: params.pdfManager.docBaseUrl
	    });
	  }
	  Util.inherit(LinkAnnotation, Annotation, {});
	  return LinkAnnotation;
	}();
	var PopupAnnotation = function PopupAnnotationClosure() {
	  function PopupAnnotation(parameters) {
	    Annotation.call(this, parameters);
	    this.data.annotationType = AnnotationType.POPUP;
	    var dict = parameters.dict;
	    var parentItem = dict.get('Parent');
	    if (!parentItem) {
	      warn('Popup annotation has a missing or invalid parent annotation.');
	      return;
	    }
	    var parentSubtype = parentItem.get('Subtype');
	    this.data.parentType = isName(parentSubtype) ? parentSubtype.name : null;
	    this.data.parentId = dict.getRaw('Parent').toString();
	    this.data.title = stringToPDFString(parentItem.get('T') || '');
	    this.data.contents = stringToPDFString(parentItem.get('Contents') || '');
	    if (!parentItem.has('C')) {
	      this.data.color = null;
	    } else {
	      this.setColor(parentItem.getArray('C'));
	      this.data.color = this.color;
	    }
	    if (!this.viewable) {
	      var parentFlags = parentItem.get('F');
	      if (this._isViewable(parentFlags)) {
	        this.setFlags(parentFlags);
	      }
	    }
	  }
	  Util.inherit(PopupAnnotation, Annotation, {});
	  return PopupAnnotation;
	}();
	var LineAnnotation = function LineAnnotationClosure() {
	  function LineAnnotation(parameters) {
	    Annotation.call(this, parameters);
	    this.data.annotationType = AnnotationType.LINE;
	    var dict = parameters.dict;
	    this.data.lineCoordinates = Util.normalizeRect(dict.getArray('L'));
	    this._preparePopup(dict);
	  }
	  Util.inherit(LineAnnotation, Annotation, {});
	  return LineAnnotation;
	}();
	var HighlightAnnotation = function HighlightAnnotationClosure() {
	  function HighlightAnnotation(parameters) {
	    Annotation.call(this, parameters);
	    this.data.annotationType = AnnotationType.HIGHLIGHT;
	    this._preparePopup(parameters.dict);
	  }
	  Util.inherit(HighlightAnnotation, Annotation, {});
	  return HighlightAnnotation;
	}();
	var UnderlineAnnotation = function UnderlineAnnotationClosure() {
	  function UnderlineAnnotation(parameters) {
	    Annotation.call(this, parameters);
	    this.data.annotationType = AnnotationType.UNDERLINE;
	    this._preparePopup(parameters.dict);
	  }
	  Util.inherit(UnderlineAnnotation, Annotation, {});
	  return UnderlineAnnotation;
	}();
	var SquigglyAnnotation = function SquigglyAnnotationClosure() {
	  function SquigglyAnnotation(parameters) {
	    Annotation.call(this, parameters);
	    this.data.annotationType = AnnotationType.SQUIGGLY;
	    this._preparePopup(parameters.dict);
	  }
	  Util.inherit(SquigglyAnnotation, Annotation, {});
	  return SquigglyAnnotation;
	}();
	var StrikeOutAnnotation = function StrikeOutAnnotationClosure() {
	  function StrikeOutAnnotation(parameters) {
	    Annotation.call(this, parameters);
	    this.data.annotationType = AnnotationType.STRIKEOUT;
	    this._preparePopup(parameters.dict);
	  }
	  Util.inherit(StrikeOutAnnotation, Annotation, {});
	  return StrikeOutAnnotation;
	}();
	var FileAttachmentAnnotation = function FileAttachmentAnnotationClosure() {
	  function FileAttachmentAnnotation(parameters) {
	    Annotation.call(this, parameters);
	    var file = new FileSpec(parameters.dict.get('FS'), parameters.xref);
	    this.data.annotationType = AnnotationType.FILEATTACHMENT;
	    this.data.file = file.serializable;
	    this._preparePopup(parameters.dict);
	  }
	  Util.inherit(FileAttachmentAnnotation, Annotation, {});
	  return FileAttachmentAnnotation;
	}();
	exports.Annotation = Annotation;
	exports.AnnotationBorderStyle = AnnotationBorderStyle;
	exports.AnnotationFactory = AnnotationFactory;
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var warn = sharedUtil.warn;
	var baseTypes = ['BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'S', 'B', 'S', 'WS', 'B', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'B', 'B', 'B', 'S', 'WS', 'ON', 'ON', 'ET', 'ET', 'ET', 'ON', 'ON', 'ON', 'ON', 'ON', 'ES', 'CS', 'ES', 'CS', 'CS', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'CS', 'ON', 'ON', 'ON', 'ON', 'ON', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'ON', 'ON', 'ON', 'ON', 'ON', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'ON', 'ON', 'ON', 'ON', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'B', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'CS', 'ON', 'ET', 'ET', 'ET', 'ET', 'ON', 'ON', 'ON', 'ON', 'L', 'ON', 'ON', 'BN', 'ON', 'ON', 'ET', 'ET', 'EN', 'EN', 'ON', 'L', 'ON', 'ON', 'ON', 'EN', 'L', 'ON', 'ON', 'ON', 'ON', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L'];
	var arabicTypes = ['AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'ON', 'ON', 'AL', 'ET', 'ET', 'AL', 'CS', 'AL', 'ON', 'ON', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'AL', 'AL', '', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'ET', 'AN', 'AN', 'AL', 'AL', 'AL', 'NSM', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'AN', 'ON', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'AL', 'AL', 'NSM', 'NSM', 'ON', 'NSM', 'NSM', 'NSM', 'NSM', 'AL', 'AL', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL'];
	function isOdd(i) {
	  return (i & 1) !== 0;
	}
	function isEven(i) {
	  return (i & 1) === 0;
	}
	function findUnequal(arr, start, value) {
	  for (var j = start, jj = arr.length; j < jj; ++j) {
	    if (arr[j] !== value) {
	      return j;
	    }
	  }
	  return j;
	}
	function setValues(arr, start, end, value) {
	  for (var j = start; j < end; ++j) {
	    arr[j] = value;
	  }
	}
	function reverseValues(arr, start, end) {
	  for (var i = start, j = end - 1; i < j; ++i, --j) {
	    var temp = arr[i];
	    arr[i] = arr[j];
	    arr[j] = temp;
	  }
	}
	function createBidiText(str, isLTR, vertical) {
	  return {
	    str: str,
	    dir: vertical ? 'ttb' : isLTR ? 'ltr' : 'rtl'
	  };
	}
	var chars = [];
	var types = [];
	function bidi(str, startLevel, vertical) {
	  var isLTR = true;
	  var strLength = str.length;
	  if (strLength === 0 || vertical) {
	    return createBidiText(str, isLTR, vertical);
	  }
	  chars.length = strLength;
	  types.length = strLength;
	  var numBidi = 0;
	  var i, ii;
	  for (i = 0; i < strLength; ++i) {
	    chars[i] = str.charAt(i);
	    var charCode = str.charCodeAt(i);
	    var charType = 'L';
	    if (charCode <= 0x00ff) {
	      charType = baseTypes[charCode];
	    } else if (0x0590 <= charCode && charCode <= 0x05f4) {
	      charType = 'R';
	    } else if (0x0600 <= charCode && charCode <= 0x06ff) {
	      charType = arabicTypes[charCode & 0xff];
	      if (!charType) {
	        warn('Bidi: invalid Unicode character ' + charCode.toString(16));
	      }
	    } else if (0x0700 <= charCode && charCode <= 0x08AC) {
	      charType = 'AL';
	    }
	    if (charType === 'R' || charType === 'AL' || charType === 'AN') {
	      numBidi++;
	    }
	    types[i] = charType;
	  }
	  if (numBidi === 0) {
	    isLTR = true;
	    return createBidiText(str, isLTR);
	  }
	  if (startLevel === -1) {
	    if (numBidi / strLength < 0.3) {
	      isLTR = true;
	      startLevel = 0;
	    } else {
	      isLTR = false;
	      startLevel = 1;
	    }
	  }
	  var levels = [];
	  for (i = 0; i < strLength; ++i) {
	    levels[i] = startLevel;
	  }
	  var e = isOdd(startLevel) ? 'R' : 'L';
	  var sor = e;
	  var eor = sor;
	  var lastType = sor;
	  for (i = 0; i < strLength; ++i) {
	    if (types[i] === 'NSM') {
	      types[i] = lastType;
	    } else {
	      lastType = types[i];
	    }
	  }
	  lastType = sor;
	  var t;
	  for (i = 0; i < strLength; ++i) {
	    t = types[i];
	    if (t === 'EN') {
	      types[i] = lastType === 'AL' ? 'AN' : 'EN';
	    } else if (t === 'R' || t === 'L' || t === 'AL') {
	      lastType = t;
	    }
	  }
	  for (i = 0; i < strLength; ++i) {
	    t = types[i];
	    if (t === 'AL') {
	      types[i] = 'R';
	    }
	  }
	  for (i = 1; i < strLength - 1; ++i) {
	    if (types[i] === 'ES' && types[i - 1] === 'EN' && types[i + 1] === 'EN') {
	      types[i] = 'EN';
	    }
	    if (types[i] === 'CS' && (types[i - 1] === 'EN' || types[i - 1] === 'AN') && types[i + 1] === types[i - 1]) {
	      types[i] = types[i - 1];
	    }
	  }
	  for (i = 0; i < strLength; ++i) {
	    if (types[i] === 'EN') {
	      var j;
	      for (j = i - 1; j >= 0; --j) {
	        if (types[j] !== 'ET') {
	          break;
	        }
	        types[j] = 'EN';
	      }
	      for (j = i + 1; j < strLength; ++j) {
	        if (types[j] !== 'ET') {
	          break;
	        }
	        types[j] = 'EN';
	      }
	    }
	  }
	  for (i = 0; i < strLength; ++i) {
	    t = types[i];
	    if (t === 'WS' || t === 'ES' || t === 'ET' || t === 'CS') {
	      types[i] = 'ON';
	    }
	  }
	  lastType = sor;
	  for (i = 0; i < strLength; ++i) {
	    t = types[i];
	    if (t === 'EN') {
	      types[i] = lastType === 'L' ? 'L' : 'EN';
	    } else if (t === 'R' || t === 'L') {
	      lastType = t;
	    }
	  }
	  for (i = 0; i < strLength; ++i) {
	    if (types[i] === 'ON') {
	      var end = findUnequal(types, i + 1, 'ON');
	      var before = sor;
	      if (i > 0) {
	        before = types[i - 1];
	      }
	      var after = eor;
	      if (end + 1 < strLength) {
	        after = types[end + 1];
	      }
	      if (before !== 'L') {
	        before = 'R';
	      }
	      if (after !== 'L') {
	        after = 'R';
	      }
	      if (before === after) {
	        setValues(types, i, end, before);
	      }
	      i = end - 1;
	    }
	  }
	  for (i = 0; i < strLength; ++i) {
	    if (types[i] === 'ON') {
	      types[i] = e;
	    }
	  }
	  for (i = 0; i < strLength; ++i) {
	    t = types[i];
	    if (isEven(levels[i])) {
	      if (t === 'R') {
	        levels[i] += 1;
	      } else if (t === 'AN' || t === 'EN') {
	        levels[i] += 2;
	      }
	    } else {
	      if (t === 'L' || t === 'AN' || t === 'EN') {
	        levels[i] += 1;
	      }
	    }
	  }
	  var highestLevel = -1;
	  var lowestOddLevel = 99;
	  var level;
	  for (i = 0, ii = levels.length; i < ii; ++i) {
	    level = levels[i];
	    if (highestLevel < level) {
	      highestLevel = level;
	    }
	    if (lowestOddLevel > level && isOdd(level)) {
	      lowestOddLevel = level;
	    }
	  }
	  for (level = highestLevel; level >= lowestOddLevel; --level) {
	    var start = -1;
	    for (i = 0, ii = levels.length; i < ii; ++i) {
	      if (levels[i] < level) {
	        if (start >= 0) {
	          reverseValues(chars, start, i);
	          start = -1;
	        }
	      } else if (start < 0) {
	        start = i;
	      }
	    }
	    if (start >= 0) {
	      reverseValues(chars, start, levels.length);
	    }
	  }
	  for (i = 0, ii = chars.length; i < ii; ++i) {
	    var ch = chars[i];
	    if (ch === '<' || ch === '>') {
	      chars[i] = '';
	    }
	  }
	  return createBidiText(chars.join(''), isLTR);
	}
	exports.bidi = bidi;
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ISOAdobeCharset = ['.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', 'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE', 'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu', 'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn', 'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright', 'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex', 'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute', 'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute', 'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute', 'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave', 'yacute', 'ydieresis', 'zcaron'];
	var ExpertCharset = ['.notdef', 'space', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', 'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];
	var ExpertSubsetCharset = ['.notdef', 'space', 'dollaroldstyle', 'dollarsuperior', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'hyphensuperior', 'colonmonetary', 'onefitted', 'rupiah', 'centoldstyle', 'figuredash', 'hypheninferior', 'onequarter', 'onehalf', 'threequarters', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior'];
	exports.ISOAdobeCharset = ISOAdobeCharset;
	exports.ExpertCharset = ExpertCharset;
	exports.ExpertSubsetCharset = ExpertSubsetCharset;
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var coreStream = __w_pdfjs_require__(2);
	var coreParser = __w_pdfjs_require__(5);
	var Util = sharedUtil.Util;
	var assert = sharedUtil.assert;
	var warn = sharedUtil.warn;
	var error = sharedUtil.error;
	var isInt = sharedUtil.isInt;
	var isString = sharedUtil.isString;
	var MissingDataException = sharedUtil.MissingDataException;
	var CMapCompressionType = sharedUtil.CMapCompressionType;
	var isEOF = corePrimitives.isEOF;
	var isName = corePrimitives.isName;
	var isCmd = corePrimitives.isCmd;
	var isStream = corePrimitives.isStream;
	var Stream = coreStream.Stream;
	var Lexer = coreParser.Lexer;
	var BUILT_IN_CMAPS = ['Adobe-GB1-UCS2', 'Adobe-CNS1-UCS2', 'Adobe-Japan1-UCS2', 'Adobe-Korea1-UCS2', '78-EUC-H', '78-EUC-V', '78-H', '78-RKSJ-H', '78-RKSJ-V', '78-V', '78ms-RKSJ-H', '78ms-RKSJ-V', '83pv-RKSJ-H', '90ms-RKSJ-H', '90ms-RKSJ-V', '90msp-RKSJ-H', '90msp-RKSJ-V', '90pv-RKSJ-H', '90pv-RKSJ-V', 'Add-H', 'Add-RKSJ-H', 'Add-RKSJ-V', 'Add-V', 'Adobe-CNS1-0', 'Adobe-CNS1-1', 'Adobe-CNS1-2', 'Adobe-CNS1-3', 'Adobe-CNS1-4', 'Adobe-CNS1-5', 'Adobe-CNS1-6', 'Adobe-GB1-0', 'Adobe-GB1-1', 'Adobe-GB1-2', 'Adobe-GB1-3', 'Adobe-GB1-4', 'Adobe-GB1-5', 'Adobe-Japan1-0', 'Adobe-Japan1-1', 'Adobe-Japan1-2', 'Adobe-Japan1-3', 'Adobe-Japan1-4', 'Adobe-Japan1-5', 'Adobe-Japan1-6', 'Adobe-Korea1-0', 'Adobe-Korea1-1', 'Adobe-Korea1-2', 'B5-H', 'B5-V', 'B5pc-H', 'B5pc-V', 'CNS-EUC-H', 'CNS-EUC-V', 'CNS1-H', 'CNS1-V', 'CNS2-H', 'CNS2-V', 'ETHK-B5-H', 'ETHK-B5-V', 'ETen-B5-H', 'ETen-B5-V', 'ETenms-B5-H', 'ETenms-B5-V', 'EUC-H', 'EUC-V', 'Ext-H', 'Ext-RKSJ-H', 'Ext-RKSJ-V', 'Ext-V', 'GB-EUC-H', 'GB-EUC-V', 'GB-H', 'GB-V', 'GBK-EUC-H', 'GBK-EUC-V', 'GBK2K-H', 'GBK2K-V', 'GBKp-EUC-H', 'GBKp-EUC-V', 'GBT-EUC-H', 'GBT-EUC-V', 'GBT-H', 'GBT-V', 'GBTpc-EUC-H', 'GBTpc-EUC-V', 'GBpc-EUC-H', 'GBpc-EUC-V', 'H', 'HKdla-B5-H', 'HKdla-B5-V', 'HKdlb-B5-H', 'HKdlb-B5-V', 'HKgccs-B5-H', 'HKgccs-B5-V', 'HKm314-B5-H', 'HKm314-B5-V', 'HKm471-B5-H', 'HKm471-B5-V', 'HKscs-B5-H', 'HKscs-B5-V', 'Hankaku', 'Hiragana', 'KSC-EUC-H', 'KSC-EUC-V', 'KSC-H', 'KSC-Johab-H', 'KSC-Johab-V', 'KSC-V', 'KSCms-UHC-H', 'KSCms-UHC-HW-H', 'KSCms-UHC-HW-V', 'KSCms-UHC-V', 'KSCpc-EUC-H', 'KSCpc-EUC-V', 'Katakana', 'NWP-H', 'NWP-V', 'RKSJ-H', 'RKSJ-V', 'Roman', 'UniCNS-UCS2-H', 'UniCNS-UCS2-V', 'UniCNS-UTF16-H', 'UniCNS-UTF16-V', 'UniCNS-UTF32-H', 'UniCNS-UTF32-V', 'UniCNS-UTF8-H', 'UniCNS-UTF8-V', 'UniGB-UCS2-H', 'UniGB-UCS2-V', 'UniGB-UTF16-H', 'UniGB-UTF16-V', 'UniGB-UTF32-H', 'UniGB-UTF32-V', 'UniGB-UTF8-H', 'UniGB-UTF8-V', 'UniJIS-UCS2-H', 'UniJIS-UCS2-HW-H', 'UniJIS-UCS2-HW-V', 'UniJIS-UCS2-V', 'UniJIS-UTF16-H', 'UniJIS-UTF16-V', 'UniJIS-UTF32-H', 'UniJIS-UTF32-V', 'UniJIS-UTF8-H', 'UniJIS-UTF8-V', 'UniJIS2004-UTF16-H', 'UniJIS2004-UTF16-V', 'UniJIS2004-UTF32-H', 'UniJIS2004-UTF32-V', 'UniJIS2004-UTF8-H', 'UniJIS2004-UTF8-V', 'UniJISPro-UCS2-HW-V', 'UniJISPro-UCS2-V', 'UniJISPro-UTF8-V', 'UniJISX0213-UTF32-H', 'UniJISX0213-UTF32-V', 'UniJISX02132004-UTF32-H', 'UniJISX02132004-UTF32-V', 'UniKS-UCS2-H', 'UniKS-UCS2-V', 'UniKS-UTF16-H', 'UniKS-UTF16-V', 'UniKS-UTF32-H', 'UniKS-UTF32-V', 'UniKS-UTF8-H', 'UniKS-UTF8-V', 'V', 'WP-Symbol'];
	var CMap = function CMapClosure() {
	  function CMap(builtInCMap) {
	    this.codespaceRanges = [[], [], [], []];
	    this.numCodespaceRanges = 0;
	    this._map = [];
	    this.name = '';
	    this.vertical = false;
	    this.useCMap = null;
	    this.builtInCMap = builtInCMap;
	  }
	  CMap.prototype = {
	    addCodespaceRange: function addCodespaceRange(n, low, high) {
	      this.codespaceRanges[n - 1].push(low, high);
	      this.numCodespaceRanges++;
	    },
	    mapCidRange: function mapCidRange(low, high, dstLow) {
	      while (low <= high) {
	        this._map[low++] = dstLow++;
	      }
	    },
	    mapBfRange: function mapBfRange(low, high, dstLow) {
	      var lastByte = dstLow.length - 1;
	      while (low <= high) {
	        this._map[low++] = dstLow;
	        dstLow = dstLow.substr(0, lastByte) + String.fromCharCode(dstLow.charCodeAt(lastByte) + 1);
	      }
	    },
	    mapBfRangeToArray: function mapBfRangeToArray(low, high, array) {
	      var i = 0,
	          ii = array.length;
	      while (low <= high && i < ii) {
	        this._map[low] = array[i++];
	        ++low;
	      }
	    },
	    mapOne: function mapOne(src, dst) {
	      this._map[src] = dst;
	    },
	    lookup: function lookup(code) {
	      return this._map[code];
	    },
	    contains: function contains(code) {
	      return this._map[code] !== undefined;
	    },
	    forEach: function forEach(callback) {
	      var map = this._map;
	      var length = map.length;
	      var i;
	      if (length <= 0x10000) {
	        for (i = 0; i < length; i++) {
	          if (map[i] !== undefined) {
	            callback(i, map[i]);
	          }
	        }
	      } else {
	        for (i in this._map) {
	          callback(i, map[i]);
	        }
	      }
	    },
	    charCodeOf: function charCodeOf(value) {
	      return this._map.indexOf(value);
	    },
	    getMap: function getMap() {
	      return this._map;
	    },
	    readCharCode: function readCharCode(str, offset, out) {
	      var c = 0;
	      var codespaceRanges = this.codespaceRanges;
	      var codespaceRangesLen = this.codespaceRanges.length;
	      for (var n = 0; n < codespaceRangesLen; n++) {
	        c = (c << 8 | str.charCodeAt(offset + n)) >>> 0;
	        var codespaceRange = codespaceRanges[n];
	        for (var k = 0, kk = codespaceRange.length; k < kk;) {
	          var low = codespaceRange[k++];
	          var high = codespaceRange[k++];
	          if (c >= low && c <= high) {
	            out.charcode = c;
	            out.length = n + 1;
	            return;
	          }
	        }
	      }
	      out.charcode = 0;
	      out.length = 1;
	    },
	
	    get length() {
	      return this._map.length;
	    },
	    get isIdentityCMap() {
	      if (!(this.name === 'Identity-H' || this.name === 'Identity-V')) {
	        return false;
	      }
	      if (this._map.length !== 0x10000) {
	        return false;
	      }
	      for (var i = 0; i < 0x10000; i++) {
	        if (this._map[i] !== i) {
	          return false;
	        }
	      }
	      return true;
	    }
	  };
	  return CMap;
	}();
	var IdentityCMap = function IdentityCMapClosure() {
	  function IdentityCMap(vertical, n) {
	    CMap.call(this);
	    this.vertical = vertical;
	    this.addCodespaceRange(n, 0, 0xffff);
	  }
	  Util.inherit(IdentityCMap, CMap, {});
	  IdentityCMap.prototype = {
	    addCodespaceRange: CMap.prototype.addCodespaceRange,
	    mapCidRange: function mapCidRange(low, high, dstLow) {
	      error('should not call mapCidRange');
	    },
	    mapBfRange: function mapBfRange(low, high, dstLow) {
	      error('should not call mapBfRange');
	    },
	    mapBfRangeToArray: function mapBfRangeToArray(low, high, array) {
	      error('should not call mapBfRangeToArray');
	    },
	    mapOne: function mapOne(src, dst) {
	      error('should not call mapCidOne');
	    },
	    lookup: function lookup(code) {
	      return isInt(code) && code <= 0xffff ? code : undefined;
	    },
	    contains: function contains(code) {
	      return isInt(code) && code <= 0xffff;
	    },
	    forEach: function forEach(callback) {
	      for (var i = 0; i <= 0xffff; i++) {
	        callback(i, i);
	      }
	    },
	    charCodeOf: function charCodeOf(value) {
	      return isInt(value) && value <= 0xffff ? value : -1;
	    },
	    getMap: function getMap() {
	      var map = new Array(0x10000);
	      for (var i = 0; i <= 0xffff; i++) {
	        map[i] = i;
	      }
	      return map;
	    },
	
	    readCharCode: CMap.prototype.readCharCode,
	    get length() {
	      return 0x10000;
	    },
	    get isIdentityCMap() {
	      error('should not access .isIdentityCMap');
	    }
	  };
	  return IdentityCMap;
	}();
	var BinaryCMapReader = function BinaryCMapReaderClosure() {
	  function hexToInt(a, size) {
	    var n = 0;
	    for (var i = 0; i <= size; i++) {
	      n = n << 8 | a[i];
	    }
	    return n >>> 0;
	  }
	  function hexToStr(a, size) {
	    if (size === 1) {
	      return String.fromCharCode(a[0], a[1]);
	    }
	    if (size === 3) {
	      return String.fromCharCode(a[0], a[1], a[2], a[3]);
	    }
	    return String.fromCharCode.apply(null, a.subarray(0, size + 1));
	  }
	  function addHex(a, b, size) {
	    var c = 0;
	    for (var i = size; i >= 0; i--) {
	      c += a[i] + b[i];
	      a[i] = c & 255;
	      c >>= 8;
	    }
	  }
	  function incHex(a, size) {
	    var c = 1;
	    for (var i = size; i >= 0 && c > 0; i--) {
	      c += a[i];
	      a[i] = c & 255;
	      c >>= 8;
	    }
	  }
	  var MAX_NUM_SIZE = 16;
	  var MAX_ENCODED_NUM_SIZE = 19;
	  function BinaryCMapStream(data) {
	    this.buffer = data;
	    this.pos = 0;
	    this.end = data.length;
	    this.tmpBuf = new Uint8Array(MAX_ENCODED_NUM_SIZE);
	  }
	  BinaryCMapStream.prototype = {
	    readByte: function readByte() {
	      if (this.pos >= this.end) {
	        return -1;
	      }
	      return this.buffer[this.pos++];
	    },
	    readNumber: function readNumber() {
	      var n = 0;
	      var last;
	      do {
	        var b = this.readByte();
	        if (b < 0) {
	          error('unexpected EOF in bcmap');
	        }
	        last = !(b & 0x80);
	        n = n << 7 | b & 0x7F;
	      } while (!last);
	      return n;
	    },
	    readSigned: function readSigned() {
	      var n = this.readNumber();
	      return n & 1 ? ~(n >>> 1) : n >>> 1;
	    },
	    readHex: function readHex(num, size) {
	      num.set(this.buffer.subarray(this.pos, this.pos + size + 1));
	      this.pos += size + 1;
	    },
	    readHexNumber: function readHexNumber(num, size) {
	      var last;
	      var stack = this.tmpBuf,
	          sp = 0;
	      do {
	        var b = this.readByte();
	        if (b < 0) {
	          error('unexpected EOF in bcmap');
	        }
	        last = !(b & 0x80);
	        stack[sp++] = b & 0x7F;
	      } while (!last);
	      var i = size,
	          buffer = 0,
	          bufferSize = 0;
	      while (i >= 0) {
	        while (bufferSize < 8 && stack.length > 0) {
	          buffer = stack[--sp] << bufferSize | buffer;
	          bufferSize += 7;
	        }
	        num[i] = buffer & 255;
	        i--;
	        buffer >>= 8;
	        bufferSize -= 8;
	      }
	    },
	    readHexSigned: function readHexSigned(num, size) {
	      this.readHexNumber(num, size);
	      var sign = num[size] & 1 ? 255 : 0;
	      var c = 0;
	      for (var i = 0; i <= size; i++) {
	        c = (c & 1) << 8 | num[i];
	        num[i] = c >> 1 ^ sign;
	      }
	    },
	    readString: function readString() {
	      var len = this.readNumber();
	      var s = '';
	      for (var i = 0; i < len; i++) {
	        s += String.fromCharCode(this.readNumber());
	      }
	      return s;
	    }
	  };
	  function processBinaryCMap(data, cMap, extend) {
	    return new Promise(function (resolve, reject) {
	      var stream = new BinaryCMapStream(data);
	      var header = stream.readByte();
	      cMap.vertical = !!(header & 1);
	      var useCMap = null;
	      var start = new Uint8Array(MAX_NUM_SIZE);
	      var end = new Uint8Array(MAX_NUM_SIZE);
	      var char = new Uint8Array(MAX_NUM_SIZE);
	      var charCode = new Uint8Array(MAX_NUM_SIZE);
	      var tmp = new Uint8Array(MAX_NUM_SIZE);
	      var code;
	      var b;
	      while ((b = stream.readByte()) >= 0) {
	        var type = b >> 5;
	        if (type === 7) {
	          switch (b & 0x1F) {
	            case 0:
	              stream.readString();
	              break;
	            case 1:
	              useCMap = stream.readString();
	              break;
	          }
	          continue;
	        }
	        var sequence = !!(b & 0x10);
	        var dataSize = b & 15;
	        assert(dataSize + 1 <= MAX_NUM_SIZE);
	        var ucs2DataSize = 1;
	        var subitemsCount = stream.readNumber();
	        var i;
	        switch (type) {
	          case 0:
	            stream.readHex(start, dataSize);
	            stream.readHexNumber(end, dataSize);
	            addHex(end, start, dataSize);
	            cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
	            for (i = 1; i < subitemsCount; i++) {
	              incHex(end, dataSize);
	              stream.readHexNumber(start, dataSize);
	              addHex(start, end, dataSize);
	              stream.readHexNumber(end, dataSize);
	              addHex(end, start, dataSize);
	              cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
	            }
	            break;
	          case 1:
	            stream.readHex(start, dataSize);
	            stream.readHexNumber(end, dataSize);
	            addHex(end, start, dataSize);
	            code = stream.readNumber();
	            for (i = 1; i < subitemsCount; i++) {
	              incHex(end, dataSize);
	              stream.readHexNumber(start, dataSize);
	              addHex(start, end, dataSize);
	              stream.readHexNumber(end, dataSize);
	              addHex(end, start, dataSize);
	              code = stream.readNumber();
	            }
	            break;
	          case 2:
	            stream.readHex(char, dataSize);
	            code = stream.readNumber();
	            cMap.mapOne(hexToInt(char, dataSize), code);
	            for (i = 1; i < subitemsCount; i++) {
	              incHex(char, dataSize);
	              if (!sequence) {
	                stream.readHexNumber(tmp, dataSize);
	                addHex(char, tmp, dataSize);
	              }
	              code = stream.readSigned() + (code + 1);
	              cMap.mapOne(hexToInt(char, dataSize), code);
	            }
	            break;
	          case 3:
	            stream.readHex(start, dataSize);
	            stream.readHexNumber(end, dataSize);
	            addHex(end, start, dataSize);
	            code = stream.readNumber();
	            cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
	            for (i = 1; i < subitemsCount; i++) {
	              incHex(end, dataSize);
	              if (!sequence) {
	                stream.readHexNumber(start, dataSize);
	                addHex(start, end, dataSize);
	              } else {
	                start.set(end);
	              }
	              stream.readHexNumber(end, dataSize);
	              addHex(end, start, dataSize);
	              code = stream.readNumber();
	              cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
	            }
	            break;
	          case 4:
	            stream.readHex(char, ucs2DataSize);
	            stream.readHex(charCode, dataSize);
	            cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
	            for (i = 1; i < subitemsCount; i++) {
	              incHex(char, ucs2DataSize);
	              if (!sequence) {
	                stream.readHexNumber(tmp, ucs2DataSize);
	                addHex(char, tmp, ucs2DataSize);
	              }
	              incHex(charCode, dataSize);
	              stream.readHexSigned(tmp, dataSize);
	              addHex(charCode, tmp, dataSize);
	              cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
	            }
	            break;
	          case 5:
	            stream.readHex(start, ucs2DataSize);
	            stream.readHexNumber(end, ucs2DataSize);
	            addHex(end, start, ucs2DataSize);
	            stream.readHex(charCode, dataSize);
	            cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
	            for (i = 1; i < subitemsCount; i++) {
	              incHex(end, ucs2DataSize);
	              if (!sequence) {
	                stream.readHexNumber(start, ucs2DataSize);
	                addHex(start, end, ucs2DataSize);
	              } else {
	                start.set(end);
	              }
	              stream.readHexNumber(end, ucs2DataSize);
	              addHex(end, start, ucs2DataSize);
	              stream.readHex(charCode, dataSize);
	              cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
	            }
	            break;
	          default:
	            reject(new Error('processBinaryCMap: Unknown type: ' + type));
	            return;
	        }
	      }
	      if (useCMap) {
	        resolve(extend(useCMap));
	        return;
	      }
	      resolve(cMap);
	    });
	  }
	  function BinaryCMapReader() {}
	  BinaryCMapReader.prototype = { process: processBinaryCMap };
	  return BinaryCMapReader;
	}();
	var CMapFactory = function CMapFactoryClosure() {
	  function strToInt(str) {
	    var a = 0;
	    for (var i = 0; i < str.length; i++) {
	      a = a << 8 | str.charCodeAt(i);
	    }
	    return a >>> 0;
	  }
	  function expectString(obj) {
	    if (!isString(obj)) {
	      error('Malformed CMap: expected string.');
	    }
	  }
	  function expectInt(obj) {
	    if (!isInt(obj)) {
	      error('Malformed CMap: expected int.');
	    }
	  }
	  function parseBfChar(cMap, lexer) {
	    while (true) {
	      var obj = lexer.getObj();
	      if (isEOF(obj)) {
	        break;
	      }
	      if (isCmd(obj, 'endbfchar')) {
	        return;
	      }
	      expectString(obj);
	      var src = strToInt(obj);
	      obj = lexer.getObj();
	      expectString(obj);
	      var dst = obj;
	      cMap.mapOne(src, dst);
	    }
	  }
	  function parseBfRange(cMap, lexer) {
	    while (true) {
	      var obj = lexer.getObj();
	      if (isEOF(obj)) {
	        break;
	      }
	      if (isCmd(obj, 'endbfrange')) {
	        return;
	      }
	      expectString(obj);
	      var low = strToInt(obj);
	      obj = lexer.getObj();
	      expectString(obj);
	      var high = strToInt(obj);
	      obj = lexer.getObj();
	      if (isInt(obj) || isString(obj)) {
	        var dstLow = isInt(obj) ? String.fromCharCode(obj) : obj;
	        cMap.mapBfRange(low, high, dstLow);
	      } else if (isCmd(obj, '[')) {
	        obj = lexer.getObj();
	        var array = [];
	        while (!isCmd(obj, ']') && !isEOF(obj)) {
	          array.push(obj);
	          obj = lexer.getObj();
	        }
	        cMap.mapBfRangeToArray(low, high, array);
	      } else {
	        break;
	      }
	    }
	    error('Invalid bf range.');
	  }
	  function parseCidChar(cMap, lexer) {
	    while (true) {
	      var obj = lexer.getObj();
	      if (isEOF(obj)) {
	        break;
	      }
	      if (isCmd(obj, 'endcidchar')) {
	        return;
	      }
	      expectString(obj);
	      var src = strToInt(obj);
	      obj = lexer.getObj();
	      expectInt(obj);
	      var dst = obj;
	      cMap.mapOne(src, dst);
	    }
	  }
	  function parseCidRange(cMap, lexer) {
	    while (true) {
	      var obj = lexer.getObj();
	      if (isEOF(obj)) {
	        break;
	      }
	      if (isCmd(obj, 'endcidrange')) {
	        return;
	      }
	      expectString(obj);
	      var low = strToInt(obj);
	      obj = lexer.getObj();
	      expectString(obj);
	      var high = strToInt(obj);
	      obj = lexer.getObj();
	      expectInt(obj);
	      var dstLow = obj;
	      cMap.mapCidRange(low, high, dstLow);
	    }
	  }
	  function parseCodespaceRange(cMap, lexer) {
	    while (true) {
	      var obj = lexer.getObj();
	      if (isEOF(obj)) {
	        break;
	      }
	      if (isCmd(obj, 'endcodespacerange')) {
	        return;
	      }
	      if (!isString(obj)) {
	        break;
	      }
	      var low = strToInt(obj);
	      obj = lexer.getObj();
	      if (!isString(obj)) {
	        break;
	      }
	      var high = strToInt(obj);
	      cMap.addCodespaceRange(obj.length, low, high);
	    }
	    error('Invalid codespace range.');
	  }
	  function parseWMode(cMap, lexer) {
	    var obj = lexer.getObj();
	    if (isInt(obj)) {
	      cMap.vertical = !!obj;
	    }
	  }
	  function parseCMapName(cMap, lexer) {
	    var obj = lexer.getObj();
	    if (isName(obj) && isString(obj.name)) {
	      cMap.name = obj.name;
	    }
	  }
	  function parseCMap(cMap, lexer, fetchBuiltInCMap, useCMap) {
	    var previous;
	    var embededUseCMap;
	    objLoop: while (true) {
	      try {
	        var obj = lexer.getObj();
	        if (isEOF(obj)) {
	          break;
	        } else if (isName(obj)) {
	          if (obj.name === 'WMode') {
	            parseWMode(cMap, lexer);
	          } else if (obj.name === 'CMapName') {
	            parseCMapName(cMap, lexer);
	          }
	          previous = obj;
	        } else if (isCmd(obj)) {
	          switch (obj.cmd) {
	            case 'endcmap':
	              break objLoop;
	            case 'usecmap':
	              if (isName(previous)) {
	                embededUseCMap = previous.name;
	              }
	              break;
	            case 'begincodespacerange':
	              parseCodespaceRange(cMap, lexer);
	              break;
	            case 'beginbfchar':
	              parseBfChar(cMap, lexer);
	              break;
	            case 'begincidchar':
	              parseCidChar(cMap, lexer);
	              break;
	            case 'beginbfrange':
	              parseBfRange(cMap, lexer);
	              break;
	            case 'begincidrange':
	              parseCidRange(cMap, lexer);
	              break;
	          }
	        }
	      } catch (ex) {
	        if (ex instanceof MissingDataException) {
	          throw ex;
	        }
	        warn('Invalid cMap data: ' + ex);
	        continue;
	      }
	    }
	    if (!useCMap && embededUseCMap) {
	      useCMap = embededUseCMap;
	    }
	    if (useCMap) {
	      return extendCMap(cMap, fetchBuiltInCMap, useCMap);
	    }
	    return Promise.resolve(cMap);
	  }
	  function extendCMap(cMap, fetchBuiltInCMap, useCMap) {
	    return createBuiltInCMap(useCMap, fetchBuiltInCMap).then(function (newCMap) {
	      cMap.useCMap = newCMap;
	      if (cMap.numCodespaceRanges === 0) {
	        var useCodespaceRanges = cMap.useCMap.codespaceRanges;
	        for (var i = 0; i < useCodespaceRanges.length; i++) {
	          cMap.codespaceRanges[i] = useCodespaceRanges[i].slice();
	        }
	        cMap.numCodespaceRanges = cMap.useCMap.numCodespaceRanges;
	      }
	      cMap.useCMap.forEach(function (key, value) {
	        if (!cMap.contains(key)) {
	          cMap.mapOne(key, cMap.useCMap.lookup(key));
	        }
	      });
	      return cMap;
	    });
	  }
	  function createBuiltInCMap(name, fetchBuiltInCMap) {
	    if (name === 'Identity-H') {
	      return Promise.resolve(new IdentityCMap(false, 2));
	    } else if (name === 'Identity-V') {
	      return Promise.resolve(new IdentityCMap(true, 2));
	    }
	    if (BUILT_IN_CMAPS.indexOf(name) === -1) {
	      return Promise.reject(new Error('Unknown CMap name: ' + name));
	    }
	    assert(fetchBuiltInCMap, 'Built-in CMap parameters are not provided.');
	    return fetchBuiltInCMap(name).then(function (data) {
	      var cMapData = data.cMapData,
	          compressionType = data.compressionType;
	      var cMap = new CMap(true);
	      if (compressionType === CMapCompressionType.BINARY) {
	        return new BinaryCMapReader().process(cMapData, cMap, function (useCMap) {
	          return extendCMap(cMap, fetchBuiltInCMap, useCMap);
	        });
	      }
	      assert(compressionType === CMapCompressionType.NONE, 'TODO: Only BINARY/NONE CMap compression is currently supported.');
	      var lexer = new Lexer(new Stream(cMapData));
	      return parseCMap(cMap, lexer, fetchBuiltInCMap, null);
	    });
	  }
	  return {
	    create: function create(params) {
	      var encoding = params.encoding;
	      var fetchBuiltInCMap = params.fetchBuiltInCMap;
	      var useCMap = params.useCMap;
	      if (isName(encoding)) {
	        return createBuiltInCMap(encoding.name, fetchBuiltInCMap);
	      } else if (isStream(encoding)) {
	        var cMap = new CMap();
	        var lexer = new Lexer(encoding);
	        return parseCMap(cMap, lexer, fetchBuiltInCMap, useCMap).then(function (parsedCMap) {
	          if (parsedCMap.isIdentityCMap) {
	            return createBuiltInCMap(parsedCMap.name, fetchBuiltInCMap);
	          }
	          return parsedCMap;
	        });
	      }
	      return Promise.reject(new Error('Encoding required.'));
	    }
	  };
	}();
	exports.CMap = CMap;
	exports.CMapFactory = CMapFactory;
	exports.IdentityCMap = IdentityCMap;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var coreStream = __w_pdfjs_require__(2);
	var coreObj = __w_pdfjs_require__(16);
	var coreParser = __w_pdfjs_require__(5);
	var coreCrypto = __w_pdfjs_require__(13);
	var coreEvaluator = __w_pdfjs_require__(14);
	var coreAnnotation = __w_pdfjs_require__(20);
	var OPS = sharedUtil.OPS;
	var MissingDataException = sharedUtil.MissingDataException;
	var Util = sharedUtil.Util;
	var assert = sharedUtil.assert;
	var error = sharedUtil.error;
	var info = sharedUtil.info;
	var isArray = sharedUtil.isArray;
	var isArrayBuffer = sharedUtil.isArrayBuffer;
	var isNum = sharedUtil.isNum;
	var isString = sharedUtil.isString;
	var shadow = sharedUtil.shadow;
	var stringToBytes = sharedUtil.stringToBytes;
	var stringToPDFString = sharedUtil.stringToPDFString;
	var warn = sharedUtil.warn;
	var isSpace = sharedUtil.isSpace;
	var Dict = corePrimitives.Dict;
	var isDict = corePrimitives.isDict;
	var isName = corePrimitives.isName;
	var isStream = corePrimitives.isStream;
	var NullStream = coreStream.NullStream;
	var Stream = coreStream.Stream;
	var StreamsSequenceStream = coreStream.StreamsSequenceStream;
	var Catalog = coreObj.Catalog;
	var ObjectLoader = coreObj.ObjectLoader;
	var XRef = coreObj.XRef;
	var Linearization = coreParser.Linearization;
	var calculateMD5 = coreCrypto.calculateMD5;
	var OperatorList = coreEvaluator.OperatorList;
	var PartialEvaluator = coreEvaluator.PartialEvaluator;
	var AnnotationFactory = coreAnnotation.AnnotationFactory;
	var Page = function PageClosure() {
	  var DEFAULT_USER_UNIT = 1.0;
	  var LETTER_SIZE_MEDIABOX = [0, 0, 612, 792];
	  function isAnnotationRenderable(annotation, intent) {
	    return intent === 'display' && annotation.viewable || intent === 'print' && annotation.printable;
	  }
	  function Page(pdfManager, xref, pageIndex, pageDict, ref, fontCache, builtInCMapCache) {
	    this.pdfManager = pdfManager;
	    this.pageIndex = pageIndex;
	    this.pageDict = pageDict;
	    this.xref = xref;
	    this.ref = ref;
	    this.fontCache = fontCache;
	    this.builtInCMapCache = builtInCMapCache;
	    this.evaluatorOptions = pdfManager.evaluatorOptions;
	    this.resourcesPromise = null;
	    var uniquePrefix = 'p' + this.pageIndex + '_';
	    var idCounters = { obj: 0 };
	    this.idFactory = {
	      createObjId: function createObjId() {
	        return uniquePrefix + ++idCounters.obj;
	      }
	    };
	  }
	  Page.prototype = {
	    getPageProp: function Page_getPageProp(key) {
	      return this.pageDict.get(key);
	    },
	    getInheritedPageProp: function Page_getInheritedPageProp(key, getArray) {
	      var dict = this.pageDict,
	          valueArray = null,
	          loopCount = 0;
	      var MAX_LOOP_COUNT = 100;
	      getArray = getArray || false;
	      while (dict) {
	        var value = getArray ? dict.getArray(key) : dict.get(key);
	        if (value !== undefined) {
	          if (!valueArray) {
	            valueArray = [];
	          }
	          valueArray.push(value);
	        }
	        if (++loopCount > MAX_LOOP_COUNT) {
	          warn('getInheritedPageProp: maximum loop count exceeded for ' + key);
	          return valueArray ? valueArray[0] : undefined;
	        }
	        dict = dict.get('Parent');
	      }
	      if (!valueArray) {
	        return undefined;
	      }
	      if (valueArray.length === 1 || !isDict(valueArray[0])) {
	        return valueArray[0];
	      }
	      return Dict.merge(this.xref, valueArray);
	    },
	    get content() {
	      return this.getPageProp('Contents');
	    },
	    get resources() {
	      return shadow(this, 'resources', this.getInheritedPageProp('Resources') || Dict.empty);
	    },
	    get mediaBox() {
	      var mediaBox = this.getInheritedPageProp('MediaBox', true);
	      if (!isArray(mediaBox) || mediaBox.length !== 4) {
	        return shadow(this, 'mediaBox', LETTER_SIZE_MEDIABOX);
	      }
	      return shadow(this, 'mediaBox', mediaBox);
	    },
	    get cropBox() {
	      var cropBox = this.getInheritedPageProp('CropBox', true);
	      if (!isArray(cropBox) || cropBox.length !== 4) {
	        return shadow(this, 'cropBox', this.mediaBox);
	      }
	      return shadow(this, 'cropBox', cropBox);
	    },
	    get userUnit() {
	      var obj = this.getPageProp('UserUnit');
	      if (!isNum(obj) || obj <= 0) {
	        obj = DEFAULT_USER_UNIT;
	      }
	      return shadow(this, 'userUnit', obj);
	    },
	    get view() {
	      var mediaBox = this.mediaBox,
	          cropBox = this.cropBox;
	      if (mediaBox === cropBox) {
	        return shadow(this, 'view', mediaBox);
	      }
	      var intersection = Util.intersect(cropBox, mediaBox);
	      return shadow(this, 'view', intersection || mediaBox);
	    },
	    get rotate() {
	      var rotate = this.getInheritedPageProp('Rotate') || 0;
	      if (rotate % 90 !== 0) {
	        rotate = 0;
	      } else if (rotate >= 360) {
	        rotate = rotate % 360;
	      } else if (rotate < 0) {
	        rotate = (rotate % 360 + 360) % 360;
	      }
	      return shadow(this, 'rotate', rotate);
	    },
	    getContentStream: function Page_getContentStream() {
	      var content = this.content;
	      var stream;
	      if (isArray(content)) {
	        var xref = this.xref;
	        var i,
	            n = content.length;
	        var streams = [];
	        for (i = 0; i < n; ++i) {
	          streams.push(xref.fetchIfRef(content[i]));
	        }
	        stream = new StreamsSequenceStream(streams);
	      } else if (isStream(content)) {
	        stream = content;
	      } else {
	        stream = new NullStream();
	      }
	      return stream;
	    },
	    loadResources: function Page_loadResources(keys) {
	      var _this = this;
	
	      if (!this.resourcesPromise) {
	        this.resourcesPromise = this.pdfManager.ensure(this, 'resources');
	      }
	      return this.resourcesPromise.then(function () {
	        var objectLoader = new ObjectLoader(_this.resources.map, keys, _this.xref);
	        return objectLoader.load();
	      });
	    },
	    getOperatorList: function getOperatorList(_ref) {
	      var _this2 = this;
	
	      var handler = _ref.handler,
	          task = _ref.task,
	          intent = _ref.intent,
	          renderInteractiveForms = _ref.renderInteractiveForms;
	
	      var contentStreamPromise = this.pdfManager.ensure(this, 'getContentStream');
	      var resourcesPromise = this.loadResources(['ExtGState', 'ColorSpace', 'Pattern', 'Shading', 'XObject', 'Font']);
	      var partialEvaluator = new PartialEvaluator({
	        pdfManager: this.pdfManager,
	        xref: this.xref,
	        handler: handler,
	        pageIndex: this.pageIndex,
	        idFactory: this.idFactory,
	        fontCache: this.fontCache,
	        builtInCMapCache: this.builtInCMapCache,
	        options: this.evaluatorOptions
	      });
	      var dataPromises = Promise.all([contentStreamPromise, resourcesPromise]);
	      var pageListPromise = dataPromises.then(function (_ref2) {
	        var _ref3 = _slicedToArray(_ref2, 1),
	            contentStream = _ref3[0];
	
	        var opList = new OperatorList(intent, handler, _this2.pageIndex);
	        handler.send('StartRenderPage', {
	          transparency: partialEvaluator.hasBlendModes(_this2.resources),
	          pageIndex: _this2.pageIndex,
	          intent: intent
	        });
	        return partialEvaluator.getOperatorList({
	          stream: contentStream,
	          task: task,
	          resources: _this2.resources,
	          operatorList: opList
	        }).then(function () {
	          return opList;
	        });
	      });
	      var annotationsPromise = this.pdfManager.ensure(this, 'annotations');
	      return Promise.all([pageListPromise, annotationsPromise]).then(function (_ref4) {
	        var _ref5 = _slicedToArray(_ref4, 2),
	            pageOpList = _ref5[0],
	            annotations = _ref5[1];
	
	        if (annotations.length === 0) {
	          pageOpList.flush(true);
	          return pageOpList;
	        }
	        var i,
	            ii,
	            opListPromises = [];
	        for (i = 0, ii = annotations.length; i < ii; i++) {
	          if (isAnnotationRenderable(annotations[i], intent)) {
	            opListPromises.push(annotations[i].getOperatorList(partialEvaluator, task, renderInteractiveForms));
	          }
	        }
	        return Promise.all(opListPromises).then(function (opLists) {
	          pageOpList.addOp(OPS.beginAnnotations, []);
	          for (i = 0, ii = opLists.length; i < ii; i++) {
	            pageOpList.addOpList(opLists[i]);
	          }
	          pageOpList.addOp(OPS.endAnnotations, []);
	          pageOpList.flush(true);
	          return pageOpList;
	        });
	      });
	    },
	    extractTextContent: function extractTextContent(_ref6) {
	      var _this3 = this;
	
	      var handler = _ref6.handler,
	          task = _ref6.task,
	          normalizeWhitespace = _ref6.normalizeWhitespace,
	          combineTextItems = _ref6.combineTextItems;
	
	      var contentStreamPromise = this.pdfManager.ensure(this, 'getContentStream');
	      var resourcesPromise = this.loadResources(['ExtGState', 'XObject', 'Font']);
	      var dataPromises = Promise.all([contentStreamPromise, resourcesPromise]);
	      return dataPromises.then(function (_ref7) {
	        var _ref8 = _slicedToArray(_ref7, 1),
	            contentStream = _ref8[0];
	
	        var partialEvaluator = new PartialEvaluator({
	          pdfManager: _this3.pdfManager,
	          xref: _this3.xref,
	          handler: handler,
	          pageIndex: _this3.pageIndex,
	          idFactory: _this3.idFactory,
	          fontCache: _this3.fontCache,
	          builtInCMapCache: _this3.builtInCMapCache,
	          options: _this3.evaluatorOptions
	        });
	        return partialEvaluator.getTextContent({
	          stream: contentStream,
	          task: task,
	          resources: _this3.resources,
	          normalizeWhitespace: normalizeWhitespace,
	          combineTextItems: combineTextItems
	        });
	      });
	    },
	
	    getAnnotationsData: function Page_getAnnotationsData(intent) {
	      var annotations = this.annotations;
	      var annotationsData = [];
	      for (var i = 0, n = annotations.length; i < n; ++i) {
	        if (!intent || isAnnotationRenderable(annotations[i], intent)) {
	          annotationsData.push(annotations[i].data);
	        }
	      }
	      return annotationsData;
	    },
	    get annotations() {
	      var annotations = [];
	      var annotationRefs = this.getInheritedPageProp('Annots') || [];
	      var annotationFactory = new AnnotationFactory();
	      for (var i = 0, n = annotationRefs.length; i < n; ++i) {
	        var annotationRef = annotationRefs[i];
	        var annotation = annotationFactory.create(this.xref, annotationRef, this.pdfManager, this.idFactory);
	        if (annotation) {
	          annotations.push(annotation);
	        }
	      }
	      return shadow(this, 'annotations', annotations);
	    }
	  };
	  return Page;
	}();
	var PDFDocument = function PDFDocumentClosure() {
	  var FINGERPRINT_FIRST_BYTES = 1024;
	  var EMPTY_FINGERPRINT = '\x00\x00\x00\x00\x00\x00\x00' + '\x00\x00\x00\x00\x00\x00\x00\x00\x00';
	  function PDFDocument(pdfManager, arg) {
	    var stream;
	    if (isStream(arg)) {
	      stream = arg;
	    } else if (isArrayBuffer(arg)) {
	      stream = new Stream(arg);
	    } else {
	      error('PDFDocument: Unknown argument type');
	    }
	    assert(stream.length > 0, 'stream must have data');
	    this.pdfManager = pdfManager;
	    this.stream = stream;
	    this.xref = new XRef(stream, pdfManager);
	  }
	  function find(stream, needle, limit, backwards) {
	    var pos = stream.pos;
	    var end = stream.end;
	    var strBuf = [];
	    if (pos + limit > end) {
	      limit = end - pos;
	    }
	    for (var n = 0; n < limit; ++n) {
	      strBuf.push(String.fromCharCode(stream.getByte()));
	    }
	    var str = strBuf.join('');
	    stream.pos = pos;
	    var index = backwards ? str.lastIndexOf(needle) : str.indexOf(needle);
	    if (index === -1) {
	      return false;
	    }
	    stream.pos += index;
	    return true;
	  }
	  var DocumentInfoValidators = {
	    get entries() {
	      return shadow(this, 'entries', {
	        Title: isString,
	        Author: isString,
	        Subject: isString,
	        Keywords: isString,
	        Creator: isString,
	        Producer: isString,
	        CreationDate: isString,
	        ModDate: isString,
	        Trapped: isName
	      });
	    }
	  };
	  PDFDocument.prototype = {
	    parse: function PDFDocument_parse(recoveryMode) {
	      this.setup(recoveryMode);
	      var version = this.catalog.catDict.get('Version');
	      if (isName(version)) {
	        this.pdfFormatVersion = version.name;
	      }
	      try {
	        this.acroForm = this.catalog.catDict.get('AcroForm');
	        if (this.acroForm) {
	          this.xfa = this.acroForm.get('XFA');
	          var fields = this.acroForm.get('Fields');
	          if ((!fields || !isArray(fields) || fields.length === 0) && !this.xfa) {
	            this.acroForm = null;
	          }
	        }
	      } catch (ex) {
	        if (ex instanceof MissingDataException) {
	          throw ex;
	        }
	        info('Something wrong with AcroForm entry');
	        this.acroForm = null;
	      }
	    },
	    get linearization() {
	      var linearization = null;
	      if (this.stream.length) {
	        try {
	          linearization = Linearization.create(this.stream);
	        } catch (err) {
	          if (err instanceof MissingDataException) {
	            throw err;
	          }
	          info(err);
	        }
	      }
	      return shadow(this, 'linearization', linearization);
	    },
	    get startXRef() {
	      var stream = this.stream;
	      var startXRef = 0;
	      var linearization = this.linearization;
	      if (linearization) {
	        stream.reset();
	        if (find(stream, 'endobj', 1024)) {
	          startXRef = stream.pos + 6;
	        }
	      } else {
	        var step = 1024;
	        var found = false,
	            pos = stream.end;
	        while (!found && pos > 0) {
	          pos -= step - 'startxref'.length;
	          if (pos < 0) {
	            pos = 0;
	          }
	          stream.pos = pos;
	          found = find(stream, 'startxref', step, true);
	        }
	        if (found) {
	          stream.skip(9);
	          var ch;
	          do {
	            ch = stream.getByte();
	          } while (isSpace(ch));
	          var str = '';
	          while (ch >= 0x20 && ch <= 0x39) {
	            str += String.fromCharCode(ch);
	            ch = stream.getByte();
	          }
	          startXRef = parseInt(str, 10);
	          if (isNaN(startXRef)) {
	            startXRef = 0;
	          }
	        }
	      }
	      return shadow(this, 'startXRef', startXRef);
	    },
	    get mainXRefEntriesOffset() {
	      var mainXRefEntriesOffset = 0;
	      var linearization = this.linearization;
	      if (linearization) {
	        mainXRefEntriesOffset = linearization.mainXRefEntriesOffset;
	      }
	      return shadow(this, 'mainXRefEntriesOffset', mainXRefEntriesOffset);
	    },
	    checkHeader: function PDFDocument_checkHeader() {
	      var stream = this.stream;
	      stream.reset();
	      if (find(stream, '%PDF-', 1024)) {
	        stream.moveStart();
	        var MAX_VERSION_LENGTH = 12;
	        var version = '',
	            ch;
	        while ((ch = stream.getByte()) > 0x20) {
	          if (version.length >= MAX_VERSION_LENGTH) {
	            break;
	          }
	          version += String.fromCharCode(ch);
	        }
	        if (!this.pdfFormatVersion) {
	          this.pdfFormatVersion = version.substring(5);
	        }
	        return;
	      }
	    },
	    parseStartXRef: function PDFDocument_parseStartXRef() {
	      var startXRef = this.startXRef;
	      this.xref.setStartXRef(startXRef);
	    },
	    setup: function PDFDocument_setup(recoveryMode) {
	      var _this4 = this;
	
	      this.xref.parse(recoveryMode);
	      var pageFactory = {
	        createPage: function createPage(pageIndex, dict, ref, fontCache, builtInCMapCache) {
	          return new Page(_this4.pdfManager, _this4.xref, pageIndex, dict, ref, fontCache, builtInCMapCache);
	        }
	      };
	      this.catalog = new Catalog(this.pdfManager, this.xref, pageFactory);
	    },
	    get numPages() {
	      var linearization = this.linearization;
	      var num = linearization ? linearization.numPages : this.catalog.numPages;
	      return shadow(this, 'numPages', num);
	    },
	    get documentInfo() {
	      var docInfo = {
	        PDFFormatVersion: this.pdfFormatVersion,
	        IsAcroFormPresent: !!this.acroForm,
	        IsXFAPresent: !!this.xfa
	      };
	      var infoDict;
	      try {
	        infoDict = this.xref.trailer.get('Info');
	      } catch (err) {
	        if (err instanceof MissingDataException) {
	          throw err;
	        }
	        info('The document information dictionary is invalid.');
	      }
	      if (infoDict) {
	        var validEntries = DocumentInfoValidators.entries;
	        for (var key in validEntries) {
	          if (infoDict.has(key)) {
	            var value = infoDict.get(key);
	            if (validEntries[key](value)) {
	              docInfo[key] = typeof value !== 'string' ? value : stringToPDFString(value);
	            } else {
	              info('Bad value in document info for "' + key + '"');
	            }
	          }
	        }
	      }
	      return shadow(this, 'documentInfo', docInfo);
	    },
	    get fingerprint() {
	      var xref = this.xref,
	          hash,
	          fileID = '';
	      var idArray = xref.trailer.get('ID');
	      if (idArray && isArray(idArray) && idArray[0] && isString(idArray[0]) && idArray[0] !== EMPTY_FINGERPRINT) {
	        hash = stringToBytes(idArray[0]);
	      } else {
	        if (this.stream.ensureRange) {
	          this.stream.ensureRange(0, Math.min(FINGERPRINT_FIRST_BYTES, this.stream.end));
	        }
	        hash = calculateMD5(this.stream.bytes.subarray(0, FINGERPRINT_FIRST_BYTES), 0, FINGERPRINT_FIRST_BYTES);
	      }
	      for (var i = 0, n = hash.length; i < n; i++) {
	        var hex = hash[i].toString(16);
	        fileID += hex.length === 1 ? '0' + hex : hex;
	      }
	      return shadow(this, 'fingerprint', fileID);
	    },
	    getPage: function PDFDocument_getPage(pageIndex) {
	      return this.catalog.getPage(pageIndex);
	    },
	    cleanup: function PDFDocument_cleanup() {
	      return this.catalog.cleanup();
	    }
	  };
	  return PDFDocument;
	}();
	exports.Page = Page;
	exports.PDFDocument = PDFDocument;
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var coreStream = __w_pdfjs_require__(2);
	var coreGlyphList = __w_pdfjs_require__(7);
	var coreEncodings = __w_pdfjs_require__(4);
	var coreCFFParser = __w_pdfjs_require__(11);
	var Util = sharedUtil.Util;
	var bytesToString = sharedUtil.bytesToString;
	var error = sharedUtil.error;
	var Stream = coreStream.Stream;
	var getGlyphsUnicode = coreGlyphList.getGlyphsUnicode;
	var StandardEncoding = coreEncodings.StandardEncoding;
	var CFFParser = coreCFFParser.CFFParser;
	var FontRendererFactory = function FontRendererFactoryClosure() {
	  function getLong(data, offset) {
	    return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
	  }
	  function getUshort(data, offset) {
	    return data[offset] << 8 | data[offset + 1];
	  }
	  function parseCmap(data, start, end) {
	    var offset = getUshort(data, start + 2) === 1 ? getLong(data, start + 8) : getLong(data, start + 16);
	    var format = getUshort(data, start + offset);
	    var ranges, p, i;
	    if (format === 4) {
	      getUshort(data, start + offset + 2);
	      var segCount = getUshort(data, start + offset + 6) >> 1;
	      p = start + offset + 14;
	      ranges = [];
	      for (i = 0; i < segCount; i++, p += 2) {
	        ranges[i] = { end: getUshort(data, p) };
	      }
	      p += 2;
	      for (i = 0; i < segCount; i++, p += 2) {
	        ranges[i].start = getUshort(data, p);
	      }
	      for (i = 0; i < segCount; i++, p += 2) {
	        ranges[i].idDelta = getUshort(data, p);
	      }
	      for (i = 0; i < segCount; i++, p += 2) {
	        var idOffset = getUshort(data, p);
	        if (idOffset === 0) {
	          continue;
	        }
	        ranges[i].ids = [];
	        for (var j = 0, jj = ranges[i].end - ranges[i].start + 1; j < jj; j++) {
	          ranges[i].ids[j] = getUshort(data, p + idOffset);
	          idOffset += 2;
	        }
	      }
	      return ranges;
	    } else if (format === 12) {
	      getLong(data, start + offset + 4);
	      var groups = getLong(data, start + offset + 12);
	      p = start + offset + 16;
	      ranges = [];
	      for (i = 0; i < groups; i++) {
	        ranges.push({
	          start: getLong(data, p),
	          end: getLong(data, p + 4),
	          idDelta: getLong(data, p + 8) - getLong(data, p)
	        });
	        p += 12;
	      }
	      return ranges;
	    }
	    error('not supported cmap: ' + format);
	  }
	  function parseCff(data, start, end, seacAnalysisEnabled) {
	    var properties = {};
	    var parser = new CFFParser(new Stream(data, start, end - start), properties, seacAnalysisEnabled);
	    var cff = parser.parse();
	    return {
	      glyphs: cff.charStrings.objects,
	      subrs: cff.topDict.privateDict && cff.topDict.privateDict.subrsIndex && cff.topDict.privateDict.subrsIndex.objects,
	      gsubrs: cff.globalSubrIndex && cff.globalSubrIndex.objects
	    };
	  }
	  function parseGlyfTable(glyf, loca, isGlyphLocationsLong) {
	    var itemSize, itemDecode;
	    if (isGlyphLocationsLong) {
	      itemSize = 4;
	      itemDecode = function fontItemDecodeLong(data, offset) {
	        return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
	      };
	    } else {
	      itemSize = 2;
	      itemDecode = function fontItemDecode(data, offset) {
	        return data[offset] << 9 | data[offset + 1] << 1;
	      };
	    }
	    var glyphs = [];
	    var startOffset = itemDecode(loca, 0);
	    for (var j = itemSize; j < loca.length; j += itemSize) {
	      var endOffset = itemDecode(loca, j);
	      glyphs.push(glyf.subarray(startOffset, endOffset));
	      startOffset = endOffset;
	    }
	    return glyphs;
	  }
	  function lookupCmap(ranges, unicode) {
	    var code = unicode.charCodeAt(0),
	        gid = 0;
	    var l = 0,
	        r = ranges.length - 1;
	    while (l < r) {
	      var c = l + r + 1 >> 1;
	      if (code < ranges[c].start) {
	        r = c - 1;
	      } else {
	        l = c;
	      }
	    }
	    if (ranges[l].start <= code && code <= ranges[l].end) {
	      gid = ranges[l].idDelta + (ranges[l].ids ? ranges[l].ids[code - ranges[l].start] : code) & 0xFFFF;
	    }
	    return {
	      charCode: code,
	      glyphId: gid
	    };
	  }
	  function compileGlyf(code, cmds, font) {
	    function moveTo(x, y) {
	      cmds.push({
	        cmd: 'moveTo',
	        args: [x, y]
	      });
	    }
	    function lineTo(x, y) {
	      cmds.push({
	        cmd: 'lineTo',
	        args: [x, y]
	      });
	    }
	    function quadraticCurveTo(xa, ya, x, y) {
	      cmds.push({
	        cmd: 'quadraticCurveTo',
	        args: [xa, ya, x, y]
	      });
	    }
	    var i = 0;
	    var numberOfContours = (code[i] << 24 | code[i + 1] << 16) >> 16;
	    var flags;
	    var x = 0,
	        y = 0;
	    i += 10;
	    if (numberOfContours < 0) {
	      do {
	        flags = code[i] << 8 | code[i + 1];
	        var glyphIndex = code[i + 2] << 8 | code[i + 3];
	        i += 4;
	        var arg1, arg2;
	        if (flags & 0x01) {
	          arg1 = (code[i] << 24 | code[i + 1] << 16) >> 16;
	          arg2 = (code[i + 2] << 24 | code[i + 3] << 16) >> 16;
	          i += 4;
	        } else {
	          arg1 = code[i++];
	          arg2 = code[i++];
	        }
	        if (flags & 0x02) {
	          x = arg1;
	          y = arg2;
	        } else {
	          x = 0;
	          y = 0;
	        }
	        var scaleX = 1,
	            scaleY = 1,
	            scale01 = 0,
	            scale10 = 0;
	        if (flags & 0x08) {
	          scaleX = scaleY = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
	          i += 2;
	        } else if (flags & 0x40) {
	          scaleX = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
	          scaleY = (code[i + 2] << 24 | code[i + 3] << 16) / 1073741824;
	          i += 4;
	        } else if (flags & 0x80) {
	          scaleX = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
	          scale01 = (code[i + 2] << 24 | code[i + 3] << 16) / 1073741824;
	          scale10 = (code[i + 4] << 24 | code[i + 5] << 16) / 1073741824;
	          scaleY = (code[i + 6] << 24 | code[i + 7] << 16) / 1073741824;
	          i += 8;
	        }
	        var subglyph = font.glyphs[glyphIndex];
	        if (subglyph) {
	          cmds.push({ cmd: 'save' });
	          cmds.push({
	            cmd: 'transform',
	            args: [scaleX, scale01, scale10, scaleY, x, y]
	          });
	          compileGlyf(subglyph, cmds, font);
	          cmds.push({ cmd: 'restore' });
	        }
	      } while (flags & 0x20);
	    } else {
	      var endPtsOfContours = [];
	      var j, jj;
	      for (j = 0; j < numberOfContours; j++) {
	        endPtsOfContours.push(code[i] << 8 | code[i + 1]);
	        i += 2;
	      }
	      var instructionLength = code[i] << 8 | code[i + 1];
	      i += 2 + instructionLength;
	      var numberOfPoints = endPtsOfContours[endPtsOfContours.length - 1] + 1;
	      var points = [];
	      while (points.length < numberOfPoints) {
	        flags = code[i++];
	        var repeat = 1;
	        if (flags & 0x08) {
	          repeat += code[i++];
	        }
	        while (repeat-- > 0) {
	          points.push({ flags: flags });
	        }
	      }
	      for (j = 0; j < numberOfPoints; j++) {
	        switch (points[j].flags & 0x12) {
	          case 0x00:
	            x += (code[i] << 24 | code[i + 1] << 16) >> 16;
	            i += 2;
	            break;
	          case 0x02:
	            x -= code[i++];
	            break;
	          case 0x12:
	            x += code[i++];
	            break;
	        }
	        points[j].x = x;
	      }
	      for (j = 0; j < numberOfPoints; j++) {
	        switch (points[j].flags & 0x24) {
	          case 0x00:
	            y += (code[i] << 24 | code[i + 1] << 16) >> 16;
	            i += 2;
	            break;
	          case 0x04:
	            y -= code[i++];
	            break;
	          case 0x24:
	            y += code[i++];
	            break;
	        }
	        points[j].y = y;
	      }
	      var startPoint = 0;
	      for (i = 0; i < numberOfContours; i++) {
	        var endPoint = endPtsOfContours[i];
	        var contour = points.slice(startPoint, endPoint + 1);
	        if (contour[0].flags & 1) {
	          contour.push(contour[0]);
	        } else if (contour[contour.length - 1].flags & 1) {
	          contour.unshift(contour[contour.length - 1]);
	        } else {
	          var p = {
	            flags: 1,
	            x: (contour[0].x + contour[contour.length - 1].x) / 2,
	            y: (contour[0].y + contour[contour.length - 1].y) / 2
	          };
	          contour.unshift(p);
	          contour.push(p);
	        }
	        moveTo(contour[0].x, contour[0].y);
	        for (j = 1, jj = contour.length; j < jj; j++) {
	          if (contour[j].flags & 1) {
	            lineTo(contour[j].x, contour[j].y);
	          } else if (contour[j + 1].flags & 1) {
	            quadraticCurveTo(contour[j].x, contour[j].y, contour[j + 1].x, contour[j + 1].y);
	            j++;
	          } else {
	            quadraticCurveTo(contour[j].x, contour[j].y, (contour[j].x + contour[j + 1].x) / 2, (contour[j].y + contour[j + 1].y) / 2);
	          }
	        }
	        startPoint = endPoint + 1;
	      }
	    }
	  }
	  function compileCharString(code, cmds, font) {
	    var stack = [];
	    var x = 0,
	        y = 0;
	    var stems = 0;
	    function moveTo(x, y) {
	      cmds.push({
	        cmd: 'moveTo',
	        args: [x, y]
	      });
	    }
	    function lineTo(x, y) {
	      cmds.push({
	        cmd: 'lineTo',
	        args: [x, y]
	      });
	    }
	    function bezierCurveTo(x1, y1, x2, y2, x, y) {
	      cmds.push({
	        cmd: 'bezierCurveTo',
	        args: [x1, y1, x2, y2, x, y]
	      });
	    }
	    function parse(code) {
	      var i = 0;
	      while (i < code.length) {
	        var stackClean = false;
	        var v = code[i++];
	        var xa, xb, ya, yb, y1, y2, y3, n, subrCode;
	        switch (v) {
	          case 1:
	            stems += stack.length >> 1;
	            stackClean = true;
	            break;
	          case 3:
	            stems += stack.length >> 1;
	            stackClean = true;
	            break;
	          case 4:
	            y += stack.pop();
	            moveTo(x, y);
	            stackClean = true;
	            break;
	          case 5:
	            while (stack.length > 0) {
	              x += stack.shift();
	              y += stack.shift();
	              lineTo(x, y);
	            }
	            break;
	          case 6:
	            while (stack.length > 0) {
	              x += stack.shift();
	              lineTo(x, y);
	              if (stack.length === 0) {
	                break;
	              }
	              y += stack.shift();
	              lineTo(x, y);
	            }
	            break;
	          case 7:
	            while (stack.length > 0) {
	              y += stack.shift();
	              lineTo(x, y);
	              if (stack.length === 0) {
	                break;
	              }
	              x += stack.shift();
	              lineTo(x, y);
	            }
	            break;
	          case 8:
	            while (stack.length > 0) {
	              xa = x + stack.shift();
	              ya = y + stack.shift();
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              x = xb + stack.shift();
	              y = yb + stack.shift();
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	            }
	            break;
	          case 10:
	            n = stack.pop() + font.subrsBias;
	            subrCode = font.subrs[n];
	            if (subrCode) {
	              parse(subrCode);
	            }
	            break;
	          case 11:
	            return;
	          case 12:
	            v = code[i++];
	            switch (v) {
	              case 34:
	                xa = x + stack.shift();
	                xb = xa + stack.shift();
	                y1 = y + stack.shift();
	                x = xb + stack.shift();
	                bezierCurveTo(xa, y, xb, y1, x, y1);
	                xa = x + stack.shift();
	                xb = xa + stack.shift();
	                x = xb + stack.shift();
	                bezierCurveTo(xa, y1, xb, y, x, y);
	                break;
	              case 35:
	                xa = x + stack.shift();
	                ya = y + stack.shift();
	                xb = xa + stack.shift();
	                yb = ya + stack.shift();
	                x = xb + stack.shift();
	                y = yb + stack.shift();
	                bezierCurveTo(xa, ya, xb, yb, x, y);
	                xa = x + stack.shift();
	                ya = y + stack.shift();
	                xb = xa + stack.shift();
	                yb = ya + stack.shift();
	                x = xb + stack.shift();
	                y = yb + stack.shift();
	                bezierCurveTo(xa, ya, xb, yb, x, y);
	                stack.pop();
	                break;
	              case 36:
	                xa = x + stack.shift();
	                y1 = y + stack.shift();
	                xb = xa + stack.shift();
	                y2 = y1 + stack.shift();
	                x = xb + stack.shift();
	                bezierCurveTo(xa, y1, xb, y2, x, y2);
	                xa = x + stack.shift();
	                xb = xa + stack.shift();
	                y3 = y2 + stack.shift();
	                x = xb + stack.shift();
	                bezierCurveTo(xa, y2, xb, y3, x, y);
	                break;
	              case 37:
	                var x0 = x,
	                    y0 = y;
	                xa = x + stack.shift();
	                ya = y + stack.shift();
	                xb = xa + stack.shift();
	                yb = ya + stack.shift();
	                x = xb + stack.shift();
	                y = yb + stack.shift();
	                bezierCurveTo(xa, ya, xb, yb, x, y);
	                xa = x + stack.shift();
	                ya = y + stack.shift();
	                xb = xa + stack.shift();
	                yb = ya + stack.shift();
	                x = xb;
	                y = yb;
	                if (Math.abs(x - x0) > Math.abs(y - y0)) {
	                  x += stack.shift();
	                } else {
	                  y += stack.shift();
	                }
	                bezierCurveTo(xa, ya, xb, yb, x, y);
	                break;
	              default:
	                error('unknown operator: 12 ' + v);
	            }
	            break;
	          case 14:
	            if (stack.length >= 4) {
	              var achar = stack.pop();
	              var bchar = stack.pop();
	              y = stack.pop();
	              x = stack.pop();
	              cmds.push({ cmd: 'save' });
	              cmds.push({
	                cmd: 'translate',
	                args: [x, y]
	              });
	              var cmap = lookupCmap(font.cmap, String.fromCharCode(font.glyphNameMap[StandardEncoding[achar]]));
	              compileCharString(font.glyphs[cmap.glyphId], cmds, font);
	              cmds.push({ cmd: 'restore' });
	              cmap = lookupCmap(font.cmap, String.fromCharCode(font.glyphNameMap[StandardEncoding[bchar]]));
	              compileCharString(font.glyphs[cmap.glyphId], cmds, font);
	            }
	            return;
	          case 18:
	            stems += stack.length >> 1;
	            stackClean = true;
	            break;
	          case 19:
	            stems += stack.length >> 1;
	            i += stems + 7 >> 3;
	            stackClean = true;
	            break;
	          case 20:
	            stems += stack.length >> 1;
	            i += stems + 7 >> 3;
	            stackClean = true;
	            break;
	          case 21:
	            y += stack.pop();
	            x += stack.pop();
	            moveTo(x, y);
	            stackClean = true;
	            break;
	          case 22:
	            x += stack.pop();
	            moveTo(x, y);
	            stackClean = true;
	            break;
	          case 23:
	            stems += stack.length >> 1;
	            stackClean = true;
	            break;
	          case 24:
	            while (stack.length > 2) {
	              xa = x + stack.shift();
	              ya = y + stack.shift();
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              x = xb + stack.shift();
	              y = yb + stack.shift();
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	            }
	            x += stack.shift();
	            y += stack.shift();
	            lineTo(x, y);
	            break;
	          case 25:
	            while (stack.length > 6) {
	              x += stack.shift();
	              y += stack.shift();
	              lineTo(x, y);
	            }
	            xa = x + stack.shift();
	            ya = y + stack.shift();
	            xb = xa + stack.shift();
	            yb = ya + stack.shift();
	            x = xb + stack.shift();
	            y = yb + stack.shift();
	            bezierCurveTo(xa, ya, xb, yb, x, y);
	            break;
	          case 26:
	            if (stack.length % 2) {
	              x += stack.shift();
	            }
	            while (stack.length > 0) {
	              xa = x;
	              ya = y + stack.shift();
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              x = xb;
	              y = yb + stack.shift();
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	            }
	            break;
	          case 27:
	            if (stack.length % 2) {
	              y += stack.shift();
	            }
	            while (stack.length > 0) {
	              xa = x + stack.shift();
	              ya = y;
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              x = xb + stack.shift();
	              y = yb;
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	            }
	            break;
	          case 28:
	            stack.push((code[i] << 24 | code[i + 1] << 16) >> 16);
	            i += 2;
	            break;
	          case 29:
	            n = stack.pop() + font.gsubrsBias;
	            subrCode = font.gsubrs[n];
	            if (subrCode) {
	              parse(subrCode);
	            }
	            break;
	          case 30:
	            while (stack.length > 0) {
	              xa = x;
	              ya = y + stack.shift();
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              x = xb + stack.shift();
	              y = yb + (stack.length === 1 ? stack.shift() : 0);
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	              if (stack.length === 0) {
	                break;
	              }
	              xa = x + stack.shift();
	              ya = y;
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              y = yb + stack.shift();
	              x = xb + (stack.length === 1 ? stack.shift() : 0);
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	            }
	            break;
	          case 31:
	            while (stack.length > 0) {
	              xa = x + stack.shift();
	              ya = y;
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              y = yb + stack.shift();
	              x = xb + (stack.length === 1 ? stack.shift() : 0);
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	              if (stack.length === 0) {
	                break;
	              }
	              xa = x;
	              ya = y + stack.shift();
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              x = xb + stack.shift();
	              y = yb + (stack.length === 1 ? stack.shift() : 0);
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	            }
	            break;
	          default:
	            if (v < 32) {
	              error('unknown operator: ' + v);
	            }
	            if (v < 247) {
	              stack.push(v - 139);
	            } else if (v < 251) {
	              stack.push((v - 247) * 256 + code[i++] + 108);
	            } else if (v < 255) {
	              stack.push(-(v - 251) * 256 - code[i++] - 108);
	            } else {
	              stack.push((code[i] << 24 | code[i + 1] << 16 | code[i + 2] << 8 | code[i + 3]) / 65536);
	              i += 4;
	            }
	            break;
	        }
	        if (stackClean) {
	          stack.length = 0;
	        }
	      }
	    }
	    parse(code);
	  }
	  var noop = '';
	  function CompiledFont(fontMatrix) {
	    this.compiledGlyphs = Object.create(null);
	    this.compiledCharCodeToGlyphId = Object.create(null);
	    this.fontMatrix = fontMatrix;
	  }
	  CompiledFont.prototype = {
	    getPathJs: function getPathJs(unicode) {
	      var cmap = lookupCmap(this.cmap, unicode);
	      var fn = this.compiledGlyphs[cmap.glyphId];
	      if (!fn) {
	        fn = this.compileGlyph(this.glyphs[cmap.glyphId]);
	        this.compiledGlyphs[cmap.glyphId] = fn;
	      }
	      if (this.compiledCharCodeToGlyphId[cmap.charCode] === undefined) {
	        this.compiledCharCodeToGlyphId[cmap.charCode] = cmap.glyphId;
	      }
	      return fn;
	    },
	    compileGlyph: function compileGlyph(code) {
	      if (!code || code.length === 0 || code[0] === 14) {
	        return noop;
	      }
	      var cmds = [];
	      cmds.push({ cmd: 'save' });
	      cmds.push({
	        cmd: 'transform',
	        args: this.fontMatrix.slice()
	      });
	      cmds.push({
	        cmd: 'scale',
	        args: ['size', '-size']
	      });
	      this.compileGlyphImpl(code, cmds);
	      cmds.push({ cmd: 'restore' });
	      return cmds;
	    },
	    compileGlyphImpl: function compileGlyphImpl() {
	      error('Children classes should implement this.');
	    },
	    hasBuiltPath: function hasBuiltPath(unicode) {
	      var cmap = lookupCmap(this.cmap, unicode);
	      return this.compiledGlyphs[cmap.glyphId] !== undefined && this.compiledCharCodeToGlyphId[cmap.charCode] !== undefined;
	    }
	  };
	  function TrueTypeCompiled(glyphs, cmap, fontMatrix) {
	    fontMatrix = fontMatrix || [0.000488, 0, 0, 0.000488, 0, 0];
	    CompiledFont.call(this, fontMatrix);
	    this.glyphs = glyphs;
	    this.cmap = cmap;
	  }
	  Util.inherit(TrueTypeCompiled, CompiledFont, {
	    compileGlyphImpl: function compileGlyphImpl(code, cmds) {
	      compileGlyf(code, cmds, this);
	    }
	  });
	  function Type2Compiled(cffInfo, cmap, fontMatrix, glyphNameMap) {
	    fontMatrix = fontMatrix || [0.001, 0, 0, 0.001, 0, 0];
	    CompiledFont.call(this, fontMatrix);
	    this.glyphs = cffInfo.glyphs;
	    this.gsubrs = cffInfo.gsubrs || [];
	    this.subrs = cffInfo.subrs || [];
	    this.cmap = cmap;
	    this.glyphNameMap = glyphNameMap || getGlyphsUnicode();
	    this.gsubrsBias = this.gsubrs.length < 1240 ? 107 : this.gsubrs.length < 33900 ? 1131 : 32768;
	    this.subrsBias = this.subrs.length < 1240 ? 107 : this.subrs.length < 33900 ? 1131 : 32768;
	  }
	  Util.inherit(Type2Compiled, CompiledFont, {
	    compileGlyphImpl: function compileGlyphImpl(code, cmds) {
	      compileCharString(code, cmds, this);
	    }
	  });
	  return {
	    create: function FontRendererFactory_create(font, seacAnalysisEnabled) {
	      var data = new Uint8Array(font.data);
	      var cmap, glyf, loca, cff, indexToLocFormat, unitsPerEm;
	      var numTables = getUshort(data, 4);
	      for (var i = 0, p = 12; i < numTables; i++, p += 16) {
	        var tag = bytesToString(data.subarray(p, p + 4));
	        var offset = getLong(data, p + 8);
	        var length = getLong(data, p + 12);
	        switch (tag) {
	          case 'cmap':
	            cmap = parseCmap(data, offset, offset + length);
	            break;
	          case 'glyf':
	            glyf = data.subarray(offset, offset + length);
	            break;
	          case 'loca':
	            loca = data.subarray(offset, offset + length);
	            break;
	          case 'head':
	            unitsPerEm = getUshort(data, offset + 18);
	            indexToLocFormat = getUshort(data, offset + 50);
	            break;
	          case 'CFF ':
	            cff = parseCff(data, offset, offset + length, seacAnalysisEnabled);
	            break;
	        }
	      }
	      if (glyf) {
	        var fontMatrix = !unitsPerEm ? font.fontMatrix : [1 / unitsPerEm, 0, 0, 1 / unitsPerEm, 0, 0];
	        return new TrueTypeCompiled(parseGlyfTable(glyf, loca, indexToLocFormat), cmap, fontMatrix);
	      }
	      return new Type2Compiled(cff, cmap, font.fontMatrix, font.glyphNameMap);
	    }
	  };
	}();
	exports.FontRendererFactory = FontRendererFactory;
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var coreStream = __w_pdfjs_require__(2);
	var coreGlyphList = __w_pdfjs_require__(7);
	var coreFontRenderer = __w_pdfjs_require__(25);
	var coreEncodings = __w_pdfjs_require__(4);
	var coreStandardFonts = __w_pdfjs_require__(17);
	var coreUnicode = __w_pdfjs_require__(18);
	var coreType1Parser = __w_pdfjs_require__(35);
	var coreCFFParser = __w_pdfjs_require__(11);
	var FONT_IDENTITY_MATRIX = sharedUtil.FONT_IDENTITY_MATRIX;
	var FontType = sharedUtil.FontType;
	var assert = sharedUtil.assert;
	var bytesToString = sharedUtil.bytesToString;
	var error = sharedUtil.error;
	var info = sharedUtil.info;
	var isArray = sharedUtil.isArray;
	var isInt = sharedUtil.isInt;
	var isNum = sharedUtil.isNum;
	var readUint32 = sharedUtil.readUint32;
	var shadow = sharedUtil.shadow;
	var string32 = sharedUtil.string32;
	var warn = sharedUtil.warn;
	var MissingDataException = sharedUtil.MissingDataException;
	var isSpace = sharedUtil.isSpace;
	var Stream = coreStream.Stream;
	var getGlyphsUnicode = coreGlyphList.getGlyphsUnicode;
	var getDingbatsGlyphsUnicode = coreGlyphList.getDingbatsGlyphsUnicode;
	var FontRendererFactory = coreFontRenderer.FontRendererFactory;
	var StandardEncoding = coreEncodings.StandardEncoding;
	var MacRomanEncoding = coreEncodings.MacRomanEncoding;
	var SymbolSetEncoding = coreEncodings.SymbolSetEncoding;
	var ZapfDingbatsEncoding = coreEncodings.ZapfDingbatsEncoding;
	var getEncoding = coreEncodings.getEncoding;
	var getStdFontMap = coreStandardFonts.getStdFontMap;
	var getNonStdFontMap = coreStandardFonts.getNonStdFontMap;
	var getGlyphMapForStandardFonts = coreStandardFonts.getGlyphMapForStandardFonts;
	var getSupplementalGlyphMapForArialBlack = coreStandardFonts.getSupplementalGlyphMapForArialBlack;
	var getUnicodeRangeFor = coreUnicode.getUnicodeRangeFor;
	var mapSpecialUnicodeValues = coreUnicode.mapSpecialUnicodeValues;
	var getUnicodeForGlyph = coreUnicode.getUnicodeForGlyph;
	var Type1Parser = coreType1Parser.Type1Parser;
	var CFFStandardStrings = coreCFFParser.CFFStandardStrings;
	var CFFParser = coreCFFParser.CFFParser;
	var CFFCompiler = coreCFFParser.CFFCompiler;
	var CFF = coreCFFParser.CFF;
	var CFFHeader = coreCFFParser.CFFHeader;
	var CFFTopDict = coreCFFParser.CFFTopDict;
	var CFFPrivateDict = coreCFFParser.CFFPrivateDict;
	var CFFStrings = coreCFFParser.CFFStrings;
	var CFFIndex = coreCFFParser.CFFIndex;
	var CFFCharset = coreCFFParser.CFFCharset;
	var PRIVATE_USE_OFFSET_START = 0xE000;
	var PRIVATE_USE_OFFSET_END = 0xF8FF;
	var SKIP_PRIVATE_USE_RANGE_F000_TO_F01F = false;
	var PDF_GLYPH_SPACE_UNITS = 1000;
	var SEAC_ANALYSIS_ENABLED = false;
	var FontFlags = {
	  FixedPitch: 1,
	  Serif: 2,
	  Symbolic: 4,
	  Script: 8,
	  Nonsymbolic: 32,
	  Italic: 64,
	  AllCap: 65536,
	  SmallCap: 131072,
	  ForceBold: 262144
	};
	var MacStandardGlyphOrdering = ['.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave', 'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis', 'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis', 'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section', 'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal', 'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation', 'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown', 'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright', 'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft', 'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction', 'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase', 'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex', 'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth', 'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior', 'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla', 'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];
	function adjustWidths(properties) {
	  if (!properties.fontMatrix) {
	    return;
	  }
	  if (properties.fontMatrix[0] === FONT_IDENTITY_MATRIX[0]) {
	    return;
	  }
	  var scale = 0.001 / properties.fontMatrix[0];
	  var glyphsWidths = properties.widths;
	  for (var glyph in glyphsWidths) {
	    glyphsWidths[glyph] *= scale;
	  }
	  properties.defaultWidth *= scale;
	}
	function adjustToUnicode(properties, builtInEncoding) {
	  if (properties.hasIncludedToUnicodeMap) {
	    return;
	  }
	  if (properties.hasEncoding) {
	    return;
	  }
	  if (builtInEncoding === properties.defaultEncoding) {
	    return;
	  }
	  if (properties.toUnicode instanceof IdentityToUnicodeMap) {
	    return;
	  }
	  var toUnicode = [],
	      glyphsUnicodeMap = getGlyphsUnicode();
	  for (var charCode in builtInEncoding) {
	    var glyphName = builtInEncoding[charCode];
	    var unicode = getUnicodeForGlyph(glyphName, glyphsUnicodeMap);
	    if (unicode !== -1) {
	      toUnicode[charCode] = String.fromCharCode(unicode);
	    }
	  }
	  properties.toUnicode.amend(toUnicode);
	}
	function getFontType(type, subtype) {
	  switch (type) {
	    case 'Type1':
	      return subtype === 'Type1C' ? FontType.TYPE1C : FontType.TYPE1;
	    case 'CIDFontType0':
	      return subtype === 'CIDFontType0C' ? FontType.CIDFONTTYPE0C : FontType.CIDFONTTYPE0;
	    case 'OpenType':
	      return FontType.OPENTYPE;
	    case 'TrueType':
	      return FontType.TRUETYPE;
	    case 'CIDFontType2':
	      return FontType.CIDFONTTYPE2;
	    case 'MMType1':
	      return FontType.MMTYPE1;
	    case 'Type0':
	      return FontType.TYPE0;
	    default:
	      return FontType.UNKNOWN;
	  }
	}
	function recoverGlyphName(name, glyphsUnicodeMap) {
	  if (glyphsUnicodeMap[name] !== undefined) {
	    return name;
	  }
	  var unicode = getUnicodeForGlyph(name, glyphsUnicodeMap);
	  if (unicode !== -1) {
	    for (var key in glyphsUnicodeMap) {
	      if (glyphsUnicodeMap[key] === unicode) {
	        return key;
	      }
	    }
	  }
	  info('Unable to recover a standard glyph name for: ' + name);
	  return name;
	}
	var Glyph = function GlyphClosure() {
	  function Glyph(fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont) {
	    this.fontChar = fontChar;
	    this.unicode = unicode;
	    this.accent = accent;
	    this.width = width;
	    this.vmetric = vmetric;
	    this.operatorListId = operatorListId;
	    this.isSpace = isSpace;
	    this.isInFont = isInFont;
	  }
	  Glyph.prototype.matchesForCache = function (fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont) {
	    return this.fontChar === fontChar && this.unicode === unicode && this.accent === accent && this.width === width && this.vmetric === vmetric && this.operatorListId === operatorListId && this.isSpace === isSpace && this.isInFont === isInFont;
	  };
	  return Glyph;
	}();
	var ToUnicodeMap = function ToUnicodeMapClosure() {
	  function ToUnicodeMap(cmap) {
	    this._map = cmap;
	  }
	  ToUnicodeMap.prototype = {
	    get length() {
	      return this._map.length;
	    },
	    forEach: function forEach(callback) {
	      for (var charCode in this._map) {
	        callback(charCode, this._map[charCode].charCodeAt(0));
	      }
	    },
	    has: function has(i) {
	      return this._map[i] !== undefined;
	    },
	    get: function get(i) {
	      return this._map[i];
	    },
	    charCodeOf: function charCodeOf(v) {
	      return this._map.indexOf(v);
	    },
	    amend: function amend(map) {
	      for (var charCode in map) {
	        this._map[charCode] = map[charCode];
	      }
	    }
	  };
	  return ToUnicodeMap;
	}();
	var IdentityToUnicodeMap = function IdentityToUnicodeMapClosure() {
	  function IdentityToUnicodeMap(firstChar, lastChar) {
	    this.firstChar = firstChar;
	    this.lastChar = lastChar;
	  }
	  IdentityToUnicodeMap.prototype = {
	    get length() {
	      return this.lastChar + 1 - this.firstChar;
	    },
	    forEach: function forEach(callback) {
	      for (var i = this.firstChar, ii = this.lastChar; i <= ii; i++) {
	        callback(i, i);
	      }
	    },
	    has: function has(i) {
	      return this.firstChar <= i && i <= this.lastChar;
	    },
	    get: function get(i) {
	      if (this.firstChar <= i && i <= this.lastChar) {
	        return String.fromCharCode(i);
	      }
	      return undefined;
	    },
	    charCodeOf: function charCodeOf(v) {
	      return isInt(v) && v >= this.firstChar && v <= this.lastChar ? v : -1;
	    },
	    amend: function amend(map) {
	      error('Should not call amend()');
	    }
	  };
	  return IdentityToUnicodeMap;
	}();
	var OpenTypeFileBuilder = function OpenTypeFileBuilderClosure() {
	  function writeInt16(dest, offset, num) {
	    dest[offset] = num >> 8 & 0xFF;
	    dest[offset + 1] = num & 0xFF;
	  }
	  function writeInt32(dest, offset, num) {
	    dest[offset] = num >> 24 & 0xFF;
	    dest[offset + 1] = num >> 16 & 0xFF;
	    dest[offset + 2] = num >> 8 & 0xFF;
	    dest[offset + 3] = num & 0xFF;
	  }
	  function writeData(dest, offset, data) {
	    var i, ii;
	    if (data instanceof Uint8Array) {
	      dest.set(data, offset);
	    } else if (typeof data === 'string') {
	      for (i = 0, ii = data.length; i < ii; i++) {
	        dest[offset++] = data.charCodeAt(i) & 0xFF;
	      }
	    } else {
	      for (i = 0, ii = data.length; i < ii; i++) {
	        dest[offset++] = data[i] & 0xFF;
	      }
	    }
	  }
	  function OpenTypeFileBuilder(sfnt) {
	    this.sfnt = sfnt;
	    this.tables = Object.create(null);
	  }
	  OpenTypeFileBuilder.getSearchParams = function OpenTypeFileBuilder_getSearchParams(entriesCount, entrySize) {
	    var maxPower2 = 1,
	        log2 = 0;
	    while ((maxPower2 ^ entriesCount) > maxPower2) {
	      maxPower2 <<= 1;
	      log2++;
	    }
	    var searchRange = maxPower2 * entrySize;
	    return {
	      range: searchRange,
	      entry: log2,
	      rangeShift: entrySize * entriesCount - searchRange
	    };
	  };
	  var OTF_HEADER_SIZE = 12;
	  var OTF_TABLE_ENTRY_SIZE = 16;
	  OpenTypeFileBuilder.prototype = {
	    toArray: function OpenTypeFileBuilder_toArray() {
	      var sfnt = this.sfnt;
	      var tables = this.tables;
	      var tablesNames = Object.keys(tables);
	      tablesNames.sort();
	      var numTables = tablesNames.length;
	      var i, j, jj, table, tableName;
	      var offset = OTF_HEADER_SIZE + numTables * OTF_TABLE_ENTRY_SIZE;
	      var tableOffsets = [offset];
	      for (i = 0; i < numTables; i++) {
	        table = tables[tablesNames[i]];
	        var paddedLength = (table.length + 3 & ~3) >>> 0;
	        offset += paddedLength;
	        tableOffsets.push(offset);
	      }
	      var file = new Uint8Array(offset);
	      for (i = 0; i < numTables; i++) {
	        table = tables[tablesNames[i]];
	        writeData(file, tableOffsets[i], table);
	      }
	      if (sfnt === 'true') {
	        sfnt = string32(0x00010000);
	      }
	      file[0] = sfnt.charCodeAt(0) & 0xFF;
	      file[1] = sfnt.charCodeAt(1) & 0xFF;
	      file[2] = sfnt.charCodeAt(2) & 0xFF;
	      file[3] = sfnt.charCodeAt(3) & 0xFF;
	      writeInt16(file, 4, numTables);
	      var searchParams = OpenTypeFileBuilder.getSearchParams(numTables, 16);
	      writeInt16(file, 6, searchParams.range);
	      writeInt16(file, 8, searchParams.entry);
	      writeInt16(file, 10, searchParams.rangeShift);
	      offset = OTF_HEADER_SIZE;
	      for (i = 0; i < numTables; i++) {
	        tableName = tablesNames[i];
	        file[offset] = tableName.charCodeAt(0) & 0xFF;
	        file[offset + 1] = tableName.charCodeAt(1) & 0xFF;
	        file[offset + 2] = tableName.charCodeAt(2) & 0xFF;
	        file[offset + 3] = tableName.charCodeAt(3) & 0xFF;
	        var checksum = 0;
	        for (j = tableOffsets[i], jj = tableOffsets[i + 1]; j < jj; j += 4) {
	          var quad = readUint32(file, j);
	          checksum = checksum + quad >>> 0;
	        }
	        writeInt32(file, offset + 4, checksum);
	        writeInt32(file, offset + 8, tableOffsets[i]);
	        writeInt32(file, offset + 12, tables[tableName].length);
	        offset += OTF_TABLE_ENTRY_SIZE;
	      }
	      return file;
	    },
	    addTable: function OpenTypeFileBuilder_addTable(tag, data) {
	      if (tag in this.tables) {
	        throw new Error('Table ' + tag + ' already exists');
	      }
	      this.tables[tag] = data;
	    }
	  };
	  return OpenTypeFileBuilder;
	}();
	var ProblematicCharRanges = new Int32Array([0x0000, 0x0020, 0x007F, 0x00A1, 0x00AD, 0x00AE, 0x0600, 0x0780, 0x08A0, 0x10A0, 0x1780, 0x1800, 0x1C00, 0x1C50, 0x2000, 0x2010, 0x2011, 0x2012, 0x2028, 0x2030, 0x205F, 0x2070, 0x25CC, 0x25CD, 0x3000, 0x3001, 0xAA60, 0xAA80, 0xFFF0, 0x10000]);
	var Font = function FontClosure() {
	  function Font(name, file, properties) {
	    var _this = this;
	
	    var charCode, glyphName, unicode;
	    this.name = name;
	    this.loadedName = properties.loadedName;
	    this.isType3Font = properties.isType3Font;
	    this.sizes = [];
	    this.missingFile = false;
	    this.glyphCache = Object.create(null);
	    this.isSerifFont = !!(properties.flags & FontFlags.Serif);
	    this.isSymbolicFont = !!(properties.flags & FontFlags.Symbolic);
	    this.isMonospace = !!(properties.flags & FontFlags.FixedPitch);
	    var type = properties.type;
	    var subtype = properties.subtype;
	    this.type = type;
	    this.fallbackName = this.isMonospace ? 'monospace' : this.isSerifFont ? 'serif' : 'sans-serif';
	    this.differences = properties.differences;
	    this.widths = properties.widths;
	    this.defaultWidth = properties.defaultWidth;
	    this.composite = properties.composite;
	    this.wideChars = properties.wideChars;
	    this.cMap = properties.cMap;
	    this.ascent = properties.ascent / PDF_GLYPH_SPACE_UNITS;
	    this.descent = properties.descent / PDF_GLYPH_SPACE_UNITS;
	    this.fontMatrix = properties.fontMatrix;
	    this.bbox = properties.bbox;
	    this.toUnicode = properties.toUnicode;
	    this.toFontChar = [];
	    if (properties.type === 'Type3') {
	      for (charCode = 0; charCode < 256; charCode++) {
	        this.toFontChar[charCode] = this.differences[charCode] || properties.defaultEncoding[charCode];
	      }
	      this.fontType = FontType.TYPE3;
	      return;
	    }
	    this.cidEncoding = properties.cidEncoding;
	    this.vertical = properties.vertical;
	    if (this.vertical) {
	      this.vmetrics = properties.vmetrics;
	      this.defaultVMetrics = properties.defaultVMetrics;
	    }
	    var glyphsUnicodeMap;
	    if (!file || file.isEmpty) {
	      if (file) {
	        warn('Font file is empty in "' + name + '" (' + this.loadedName + ')');
	      }
	      this.missingFile = true;
	      var fontName = name.replace(/[,_]/g, '-');
	      var stdFontMap = getStdFontMap(),
	          nonStdFontMap = getNonStdFontMap();
	      var isStandardFont = !!stdFontMap[fontName] || !!(nonStdFontMap[fontName] && stdFontMap[nonStdFontMap[fontName]]);
	      fontName = stdFontMap[fontName] || nonStdFontMap[fontName] || fontName;
	      this.bold = fontName.search(/bold/gi) !== -1;
	      this.italic = fontName.search(/oblique/gi) !== -1 || fontName.search(/italic/gi) !== -1;
	      this.black = name.search(/Black/g) !== -1;
	      this.remeasure = Object.keys(this.widths).length > 0;
	      if (isStandardFont && type === 'CIDFontType2' && properties.cidEncoding.indexOf('Identity-') === 0) {
	        var GlyphMapForStandardFonts = getGlyphMapForStandardFonts();
	        var map = [];
	        for (charCode in GlyphMapForStandardFonts) {
	          map[+charCode] = GlyphMapForStandardFonts[charCode];
	        }
	        if (/Arial-?Black/i.test(name)) {
	          var SupplementalGlyphMapForArialBlack = getSupplementalGlyphMapForArialBlack();
	          for (charCode in SupplementalGlyphMapForArialBlack) {
	            map[+charCode] = SupplementalGlyphMapForArialBlack[charCode];
	          }
	        }
	        var isIdentityUnicode = this.toUnicode instanceof IdentityToUnicodeMap;
	        if (!isIdentityUnicode) {
	          this.toUnicode.forEach(function (charCode, unicodeCharCode) {
	            map[+charCode] = unicodeCharCode;
	          });
	        }
	        this.toFontChar = map;
	        this.toUnicode = new ToUnicodeMap(map);
	      } else if (/Symbol/i.test(fontName)) {
	        this.toFontChar = buildToFontChar(SymbolSetEncoding, getGlyphsUnicode(), properties.differences);
	      } else if (/Dingbats/i.test(fontName)) {
	        if (/Wingdings/i.test(name)) {
	          warn('Non-embedded Wingdings font, falling back to ZapfDingbats.');
	        }
	        this.toFontChar = buildToFontChar(ZapfDingbatsEncoding, getDingbatsGlyphsUnicode(), properties.differences);
	      } else if (isStandardFont) {
	        this.toFontChar = buildToFontChar(properties.defaultEncoding, getGlyphsUnicode(), properties.differences);
	      } else {
	        glyphsUnicodeMap = getGlyphsUnicode();
	        this.toUnicode.forEach(function (charCode, unicodeCharCode) {
	          if (!_this.composite) {
	            glyphName = properties.differences[charCode] || properties.defaultEncoding[charCode];
	            unicode = getUnicodeForGlyph(glyphName, glyphsUnicodeMap);
	            if (unicode !== -1) {
	              unicodeCharCode = unicode;
	            }
	          }
	          _this.toFontChar[charCode] = unicodeCharCode;
	        });
	      }
	      this.loadedName = fontName.split('-')[0];
	      this.loading = false;
	      this.fontType = getFontType(type, subtype);
	      return;
	    }
	    if (subtype === 'Type1C') {
	      if (type !== 'Type1' && type !== 'MMType1') {
	        if (isTrueTypeFile(file)) {
	          subtype = 'TrueType';
	        } else {
	          type = 'Type1';
	        }
	      } else if (isOpenTypeFile(file)) {
	        type = subtype = 'OpenType';
	      }
	    }
	    if (subtype === 'CIDFontType0C' && type !== 'CIDFontType0') {
	      type = 'CIDFontType0';
	    }
	    if (subtype === 'OpenType') {
	      type = 'OpenType';
	    }
	    if (type === 'CIDFontType0') {
	      if (isType1File(file)) {
	        subtype = 'CIDFontType0';
	      } else if (isOpenTypeFile(file)) {
	        type = subtype = 'OpenType';
	      } else {
	        subtype = 'CIDFontType0C';
	      }
	    }
	    var data;
	    switch (type) {
	      case 'MMType1':
	        info('MMType1 font (' + name + '), falling back to Type1.');
	      case 'Type1':
	      case 'CIDFontType0':
	        this.mimetype = 'font/opentype';
	        var cff = subtype === 'Type1C' || subtype === 'CIDFontType0C' ? new CFFFont(file, properties) : new Type1Font(name, file, properties);
	        adjustWidths(properties);
	        data = this.convert(name, cff, properties);
	        break;
	      case 'OpenType':
	      case 'TrueType':
	      case 'CIDFontType2':
	        this.mimetype = 'font/opentype';
	        data = this.checkAndRepair(name, file, properties);
	        if (this.isOpenType) {
	          adjustWidths(properties);
	          type = 'OpenType';
	        }
	        break;
	      default:
	        error('Font ' + type + ' is not supported');
	        break;
	    }
	    this.data = data;
	    this.fontType = getFontType(type, subtype);
	    this.fontMatrix = properties.fontMatrix;
	    this.widths = properties.widths;
	    this.defaultWidth = properties.defaultWidth;
	    this.toUnicode = properties.toUnicode;
	    this.encoding = properties.baseEncoding;
	    this.seacMap = properties.seacMap;
	    this.loading = true;
	  }
	  Font.getFontID = function () {
	    var ID = 1;
	    return function Font_getFontID() {
	      return String(ID++);
	    };
	  }();
	  function int16(b0, b1) {
	    return (b0 << 8) + b1;
	  }
	  function signedInt16(b0, b1) {
	    var value = (b0 << 8) + b1;
	    return value & 1 << 15 ? value - 0x10000 : value;
	  }
	  function int32(b0, b1, b2, b3) {
	    return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
	  }
	  function string16(value) {
	    return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
	  }
	  function safeString16(value) {
	    value = value > 0x7FFF ? 0x7FFF : value < -0x8000 ? -0x8000 : value;
	    return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
	  }
	  function isTrueTypeFile(file) {
	    var header = file.peekBytes(4);
	    return readUint32(header, 0) === 0x00010000;
	  }
	  function isOpenTypeFile(file) {
	    var header = file.peekBytes(4);
	    return bytesToString(header) === 'OTTO';
	  }
	  function isType1File(file) {
	    var header = file.peekBytes(2);
	    if (header[0] === 0x25 && header[1] === 0x21) {
	      return true;
	    }
	    if (header[0] === 0x80 && header[1] === 0x01) {
	      return true;
	    }
	    return false;
	  }
	  function buildToFontChar(encoding, glyphsUnicodeMap, differences) {
	    var toFontChar = [],
	        unicode;
	    for (var i = 0, ii = encoding.length; i < ii; i++) {
	      unicode = getUnicodeForGlyph(encoding[i], glyphsUnicodeMap);
	      if (unicode !== -1) {
	        toFontChar[i] = unicode;
	      }
	    }
	    for (var charCode in differences) {
	      unicode = getUnicodeForGlyph(differences[charCode], glyphsUnicodeMap);
	      if (unicode !== -1) {
	        toFontChar[+charCode] = unicode;
	      }
	    }
	    return toFontChar;
	  }
	  function isProblematicUnicodeLocation(code) {
	    var i = 0,
	        j = ProblematicCharRanges.length - 1;
	    while (i < j) {
	      var c = i + j + 1 >> 1;
	      if (code < ProblematicCharRanges[c]) {
	        j = c - 1;
	      } else {
	        i = c;
	      }
	    }
	    return !(i & 1);
	  }
	  function adjustMapping(charCodeToGlyphId, properties) {
	    var toUnicode = properties.toUnicode;
	    var isSymbolic = !!(properties.flags & FontFlags.Symbolic);
	    var isIdentityUnicode = properties.toUnicode instanceof IdentityToUnicodeMap;
	    var newMap = Object.create(null);
	    var toFontChar = [];
	    var usedFontCharCodes = [];
	    var nextAvailableFontCharCode = PRIVATE_USE_OFFSET_START;
	    for (var originalCharCode in charCodeToGlyphId) {
	      originalCharCode |= 0;
	      var glyphId = charCodeToGlyphId[originalCharCode];
	      var fontCharCode = originalCharCode;
	      var hasUnicodeValue = false;
	      if (!isIdentityUnicode && toUnicode.has(originalCharCode)) {
	        hasUnicodeValue = true;
	        var unicode = toUnicode.get(fontCharCode);
	        if (unicode.length === 1) {
	          fontCharCode = unicode.charCodeAt(0);
	        }
	      }
	      if ((usedFontCharCodes[fontCharCode] !== undefined || isProblematicUnicodeLocation(fontCharCode) || isSymbolic && !hasUnicodeValue) && nextAvailableFontCharCode <= PRIVATE_USE_OFFSET_END) {
	        do {
	          fontCharCode = nextAvailableFontCharCode++;
	          if (SKIP_PRIVATE_USE_RANGE_F000_TO_F01F && fontCharCode === 0xF000) {
	            fontCharCode = 0xF020;
	            nextAvailableFontCharCode = fontCharCode + 1;
	          }
	        } while (usedFontCharCodes[fontCharCode] !== undefined && nextAvailableFontCharCode <= PRIVATE_USE_OFFSET_END);
	      }
	      newMap[fontCharCode] = glyphId;
	      toFontChar[originalCharCode] = fontCharCode;
	      usedFontCharCodes[fontCharCode] = true;
	    }
	    return {
	      toFontChar: toFontChar,
	      charCodeToGlyphId: newMap,
	      nextAvailableFontCharCode: nextAvailableFontCharCode
	    };
	  }
	  function getRanges(glyphs, numGlyphs) {
	    var codes = [];
	    for (var charCode in glyphs) {
	      if (glyphs[charCode] >= numGlyphs) {
	        continue;
	      }
	      codes.push({
	        fontCharCode: charCode | 0,
	        glyphId: glyphs[charCode]
	      });
	    }
	    codes.sort(function fontGetRangesSort(a, b) {
	      return a.fontCharCode - b.fontCharCode;
	    });
	    var ranges = [];
	    var length = codes.length;
	    for (var n = 0; n < length;) {
	      var start = codes[n].fontCharCode;
	      var codeIndices = [codes[n].glyphId];
	      ++n;
	      var end = start;
	      while (n < length && end + 1 === codes[n].fontCharCode) {
	        codeIndices.push(codes[n].glyphId);
	        ++end;
	        ++n;
	        if (end === 0xFFFF) {
	          break;
	        }
	      }
	      ranges.push([start, end, codeIndices]);
	    }
	    return ranges;
	  }
	  function createCmapTable(glyphs, numGlyphs) {
	    var ranges = getRanges(glyphs, numGlyphs);
	    var numTables = ranges[ranges.length - 1][1] > 0xFFFF ? 2 : 1;
	    var cmap = '\x00\x00' + string16(numTables) + '\x00\x03' + '\x00\x01' + string32(4 + numTables * 8);
	    var i, ii, j, jj;
	    for (i = ranges.length - 1; i >= 0; --i) {
	      if (ranges[i][0] <= 0xFFFF) {
	        break;
	      }
	    }
	    var bmpLength = i + 1;
	    if (ranges[i][0] < 0xFFFF && ranges[i][1] === 0xFFFF) {
	      ranges[i][1] = 0xFFFE;
	    }
	    var trailingRangesCount = ranges[i][1] < 0xFFFF ? 1 : 0;
	    var segCount = bmpLength + trailingRangesCount;
	    var searchParams = OpenTypeFileBuilder.getSearchParams(segCount, 2);
	    var startCount = '';
	    var endCount = '';
	    var idDeltas = '';
	    var idRangeOffsets = '';
	    var glyphsIds = '';
	    var bias = 0;
	    var range, start, end, codes;
	    for (i = 0, ii = bmpLength; i < ii; i++) {
	      range = ranges[i];
	      start = range[0];
	      end = range[1];
	      startCount += string16(start);
	      endCount += string16(end);
	      codes = range[2];
	      var contiguous = true;
	      for (j = 1, jj = codes.length; j < jj; ++j) {
	        if (codes[j] !== codes[j - 1] + 1) {
	          contiguous = false;
	          break;
	        }
	      }
	      if (!contiguous) {
	        var offset = (segCount - i) * 2 + bias * 2;
	        bias += end - start + 1;
	        idDeltas += string16(0);
	        idRangeOffsets += string16(offset);
	        for (j = 0, jj = codes.length; j < jj; ++j) {
	          glyphsIds += string16(codes[j]);
	        }
	      } else {
	        var startCode = codes[0];
	        idDeltas += string16(startCode - start & 0xFFFF);
	        idRangeOffsets += string16(0);
	      }
	    }
	    if (trailingRangesCount > 0) {
	      endCount += '\xFF\xFF';
	      startCount += '\xFF\xFF';
	      idDeltas += '\x00\x01';
	      idRangeOffsets += '\x00\x00';
	    }
	    var format314 = '\x00\x00' + string16(2 * segCount) + string16(searchParams.range) + string16(searchParams.entry) + string16(searchParams.rangeShift) + endCount + '\x00\x00' + startCount + idDeltas + idRangeOffsets + glyphsIds;
	    var format31012 = '';
	    var header31012 = '';
	    if (numTables > 1) {
	      cmap += '\x00\x03' + '\x00\x0A' + string32(4 + numTables * 8 + 4 + format314.length);
	      format31012 = '';
	      for (i = 0, ii = ranges.length; i < ii; i++) {
	        range = ranges[i];
	        start = range[0];
	        codes = range[2];
	        var code = codes[0];
	        for (j = 1, jj = codes.length; j < jj; ++j) {
	          if (codes[j] !== codes[j - 1] + 1) {
	            end = range[0] + j - 1;
	            format31012 += string32(start) + string32(end) + string32(code);
	            start = end + 1;
	            code = codes[j];
	          }
	        }
	        format31012 += string32(start) + string32(range[1]) + string32(code);
	      }
	      header31012 = '\x00\x0C' + '\x00\x00' + string32(format31012.length + 16) + '\x00\x00\x00\x00' + string32(format31012.length / 12);
	    }
	    return cmap + '\x00\x04' + string16(format314.length + 4) + format314 + header31012 + format31012;
	  }
	  function validateOS2Table(os2) {
	    var stream = new Stream(os2.data);
	    var version = stream.getUint16();
	    stream.getBytes(60);
	    var selection = stream.getUint16();
	    if (version < 4 && selection & 0x0300) {
	      return false;
	    }
	    var firstChar = stream.getUint16();
	    var lastChar = stream.getUint16();
	    if (firstChar > lastChar) {
	      return false;
	    }
	    stream.getBytes(6);
	    var usWinAscent = stream.getUint16();
	    if (usWinAscent === 0) {
	      return false;
	    }
	    os2.data[8] = os2.data[9] = 0;
	    return true;
	  }
	  function createOS2Table(properties, charstrings, override) {
	    override = override || {
	      unitsPerEm: 0,
	      yMax: 0,
	      yMin: 0,
	      ascent: 0,
	      descent: 0
	    };
	    var ulUnicodeRange1 = 0;
	    var ulUnicodeRange2 = 0;
	    var ulUnicodeRange3 = 0;
	    var ulUnicodeRange4 = 0;
	    var firstCharIndex = null;
	    var lastCharIndex = 0;
	    if (charstrings) {
	      for (var code in charstrings) {
	        code |= 0;
	        if (firstCharIndex > code || !firstCharIndex) {
	          firstCharIndex = code;
	        }
	        if (lastCharIndex < code) {
	          lastCharIndex = code;
	        }
	        var position = getUnicodeRangeFor(code);
	        if (position < 32) {
	          ulUnicodeRange1 |= 1 << position;
	        } else if (position < 64) {
	          ulUnicodeRange2 |= 1 << position - 32;
	        } else if (position < 96) {
	          ulUnicodeRange3 |= 1 << position - 64;
	        } else if (position < 123) {
	          ulUnicodeRange4 |= 1 << position - 96;
	        } else {
	          error('Unicode ranges Bits > 123 are reserved for internal usage');
	        }
	      }
	    } else {
	      firstCharIndex = 0;
	      lastCharIndex = 255;
	    }
	    var bbox = properties.bbox || [0, 0, 0, 0];
	    var unitsPerEm = override.unitsPerEm || 1 / (properties.fontMatrix || FONT_IDENTITY_MATRIX)[0];
	    var scale = properties.ascentScaled ? 1.0 : unitsPerEm / PDF_GLYPH_SPACE_UNITS;
	    var typoAscent = override.ascent || Math.round(scale * (properties.ascent || bbox[3]));
	    var typoDescent = override.descent || Math.round(scale * (properties.descent || bbox[1]));
	    if (typoDescent > 0 && properties.descent > 0 && bbox[1] < 0) {
	      typoDescent = -typoDescent;
	    }
	    var winAscent = override.yMax || typoAscent;
	    var winDescent = -override.yMin || -typoDescent;
	    return '\x00\x03' + '\x02\x24' + '\x01\xF4' + '\x00\x05' + '\x00\x00' + '\x02\x8A' + '\x02\xBB' + '\x00\x00' + '\x00\x8C' + '\x02\x8A' + '\x02\xBB' + '\x00\x00' + '\x01\xDF' + '\x00\x31' + '\x01\x02' + '\x00\x00' + '\x00\x00\x06' + String.fromCharCode(properties.fixedPitch ? 0x09 : 0x00) + '\x00\x00\x00\x00\x00\x00' + string32(ulUnicodeRange1) + string32(ulUnicodeRange2) + string32(ulUnicodeRange3) + string32(ulUnicodeRange4) + '\x2A\x32\x31\x2A' + string16(properties.italicAngle ? 1 : 0) + string16(firstCharIndex || properties.firstChar) + string16(lastCharIndex || properties.lastChar) + string16(typoAscent) + string16(typoDescent) + '\x00\x64' + string16(winAscent) + string16(winDescent) + '\x00\x00\x00\x00' + '\x00\x00\x00\x00' + string16(properties.xHeight) + string16(properties.capHeight) + string16(0) + string16(firstCharIndex || properties.firstChar) + '\x00\x03';
	  }
	  function createPostTable(properties) {
	    var angle = Math.floor(properties.italicAngle * Math.pow(2, 16));
	    return '\x00\x03\x00\x00' + string32(angle) + '\x00\x00' + '\x00\x00' + string32(properties.fixedPitch) + '\x00\x00\x00\x00' + '\x00\x00\x00\x00' + '\x00\x00\x00\x00' + '\x00\x00\x00\x00';
	  }
	  function createNameTable(name, proto) {
	    if (!proto) {
	      proto = [[], []];
	    }
	    var strings = [proto[0][0] || 'Original licence', proto[0][1] || name, proto[0][2] || 'Unknown', proto[0][3] || 'uniqueID', proto[0][4] || name, proto[0][5] || 'Version 0.11', proto[0][6] || '', proto[0][7] || 'Unknown', proto[0][8] || 'Unknown', proto[0][9] || 'Unknown'];
	    var stringsUnicode = [];
	    var i, ii, j, jj, str;
	    for (i = 0, ii = strings.length; i < ii; i++) {
	      str = proto[1][i] || strings[i];
	      var strBufUnicode = [];
	      for (j = 0, jj = str.length; j < jj; j++) {
	        strBufUnicode.push(string16(str.charCodeAt(j)));
	      }
	      stringsUnicode.push(strBufUnicode.join(''));
	    }
	    var names = [strings, stringsUnicode];
	    var platforms = ['\x00\x01', '\x00\x03'];
	    var encodings = ['\x00\x00', '\x00\x01'];
	    var languages = ['\x00\x00', '\x04\x09'];
	    var namesRecordCount = strings.length * platforms.length;
	    var nameTable = '\x00\x00' + string16(namesRecordCount) + string16(namesRecordCount * 12 + 6);
	    var strOffset = 0;
	    for (i = 0, ii = platforms.length; i < ii; i++) {
	      var strs = names[i];
	      for (j = 0, jj = strs.length; j < jj; j++) {
	        str = strs[j];
	        var nameRecord = platforms[i] + encodings[i] + languages[i] + string16(j) + string16(str.length) + string16(strOffset);
	        nameTable += nameRecord;
	        strOffset += str.length;
	      }
	    }
	    nameTable += strings.join('') + stringsUnicode.join('');
	    return nameTable;
	  }
	  Font.prototype = {
	    name: null,
	    font: null,
	    mimetype: null,
	    encoding: null,
	    get renderer() {
	      var renderer = FontRendererFactory.create(this, SEAC_ANALYSIS_ENABLED);
	      return shadow(this, 'renderer', renderer);
	    },
	    exportData: function Font_exportData() {
	      var data = {};
	      for (var i in this) {
	        if (this.hasOwnProperty(i)) {
	          data[i] = this[i];
	        }
	      }
	      return data;
	    },
	    checkAndRepair: function Font_checkAndRepair(name, font, properties) {
	      function readTableEntry(file) {
	        var tag = bytesToString(file.getBytes(4));
	        var checksum = file.getInt32() >>> 0;
	        var offset = file.getInt32() >>> 0;
	        var length = file.getInt32() >>> 0;
	        var previousPosition = file.pos;
	        file.pos = file.start ? file.start : 0;
	        file.skip(offset);
	        var data = file.getBytes(length);
	        file.pos = previousPosition;
	        if (tag === 'head') {
	          data[8] = data[9] = data[10] = data[11] = 0;
	          data[17] |= 0x20;
	        }
	        return {
	          tag: tag,
	          checksum: checksum,
	          length: length,
	          offset: offset,
	          data: data
	        };
	      }
	      function readOpenTypeHeader(ttf) {
	        return {
	          version: bytesToString(ttf.getBytes(4)),
	          numTables: ttf.getUint16(),
	          searchRange: ttf.getUint16(),
	          entrySelector: ttf.getUint16(),
	          rangeShift: ttf.getUint16()
	        };
	      }
	      function readCmapTable(cmap, font, isSymbolicFont, hasEncoding) {
	        if (!cmap) {
	          warn('No cmap table available.');
	          return {
	            platformId: -1,
	            encodingId: -1,
	            mappings: [],
	            hasShortCmap: false
	          };
	        }
	        var segment;
	        var start = (font.start ? font.start : 0) + cmap.offset;
	        font.pos = start;
	        font.getUint16();
	        var numTables = font.getUint16();
	        var potentialTable;
	        var canBreak = false;
	        for (var i = 0; i < numTables; i++) {
	          var platformId = font.getUint16();
	          var encodingId = font.getUint16();
	          var offset = font.getInt32() >>> 0;
	          var useTable = false;
	          if (platformId === 0 && encodingId === 0) {
	            useTable = true;
	          } else if (platformId === 1 && encodingId === 0) {
	            useTable = true;
	          } else if (platformId === 3 && encodingId === 1 && (hasEncoding || !potentialTable)) {
	            useTable = true;
	            if (!isSymbolicFont) {
	              canBreak = true;
	            }
	          } else if (isSymbolicFont && platformId === 3 && encodingId === 0) {
	            useTable = true;
	            canBreak = true;
	          }
	          if (useTable) {
	            potentialTable = {
	              platformId: platformId,
	              encodingId: encodingId,
	              offset: offset
	            };
	          }
	          if (canBreak) {
	            break;
	          }
	        }
	        if (potentialTable) {
	          font.pos = start + potentialTable.offset;
	        }
	        if (!potentialTable || font.peekByte() === -1) {
	          warn('Could not find a preferred cmap table.');
	          return {
	            platformId: -1,
	            encodingId: -1,
	            mappings: [],
	            hasShortCmap: false
	          };
	        }
	        var format = font.getUint16();
	        font.getUint16();
	        font.getUint16();
	        var hasShortCmap = false;
	        var mappings = [];
	        var j, glyphId;
	        if (format === 0) {
	          for (j = 0; j < 256; j++) {
	            var index = font.getByte();
	            if (!index) {
	              continue;
	            }
	            mappings.push({
	              charCode: j,
	              glyphId: index
	            });
	          }
	          hasShortCmap = true;
	        } else if (format === 4) {
	          var segCount = font.getUint16() >> 1;
	          font.getBytes(6);
	          var segIndex,
	              segments = [];
	          for (segIndex = 0; segIndex < segCount; segIndex++) {
	            segments.push({ end: font.getUint16() });
	          }
	          font.getUint16();
	          for (segIndex = 0; segIndex < segCount; segIndex++) {
	            segments[segIndex].start = font.getUint16();
	          }
	          for (segIndex = 0; segIndex < segCount; segIndex++) {
	            segments[segIndex].delta = font.getUint16();
	          }
	          var offsetsCount = 0;
	          for (segIndex = 0; segIndex < segCount; segIndex++) {
	            segment = segments[segIndex];
	            var rangeOffset = font.getUint16();
	            if (!rangeOffset) {
	              segment.offsetIndex = -1;
	              continue;
	            }
	            var offsetIndex = (rangeOffset >> 1) - (segCount - segIndex);
	            segment.offsetIndex = offsetIndex;
	            offsetsCount = Math.max(offsetsCount, offsetIndex + segment.end - segment.start + 1);
	          }
	          var offsets = [];
	          for (j = 0; j < offsetsCount; j++) {
	            offsets.push(font.getUint16());
	          }
	          for (segIndex = 0; segIndex < segCount; segIndex++) {
	            segment = segments[segIndex];
	            start = segment.start;
	            var end = segment.end;
	            var delta = segment.delta;
	            offsetIndex = segment.offsetIndex;
	            for (j = start; j <= end; j++) {
	              if (j === 0xFFFF) {
	                continue;
	              }
	              glyphId = offsetIndex < 0 ? j : offsets[offsetIndex + j - start];
	              glyphId = glyphId + delta & 0xFFFF;
	              mappings.push({
	                charCode: j,
	                glyphId: glyphId
	              });
	            }
	          }
	        } else if (format === 6) {
	          var firstCode = font.getUint16();
	          var entryCount = font.getUint16();
	          for (j = 0; j < entryCount; j++) {
	            glyphId = font.getUint16();
	            var charCode = firstCode + j;
	            mappings.push({
	              charCode: charCode,
	              glyphId: glyphId
	            });
	          }
	        } else {
	          warn('cmap table has unsupported format: ' + format);
	          return {
	            platformId: -1,
	            encodingId: -1,
	            mappings: [],
	            hasShortCmap: false
	          };
	        }
	        mappings.sort(function (a, b) {
	          return a.charCode - b.charCode;
	        });
	        for (i = 1; i < mappings.length; i++) {
	          if (mappings[i - 1].charCode === mappings[i].charCode) {
	            mappings.splice(i, 1);
	            i--;
	          }
	        }
	        return {
	          platformId: potentialTable.platformId,
	          encodingId: potentialTable.encodingId,
	          mappings: mappings,
	          hasShortCmap: hasShortCmap
	        };
	      }
	      function sanitizeMetrics(font, header, metrics, numGlyphs) {
	        if (!header) {
	          if (metrics) {
	            metrics.data = null;
	          }
	          return;
	        }
	        font.pos = (font.start ? font.start : 0) + header.offset;
	        font.pos += header.length - 2;
	        var numOfMetrics = font.getUint16();
	        if (numOfMetrics > numGlyphs) {
	          info('The numOfMetrics (' + numOfMetrics + ') should not be ' + 'greater than the numGlyphs (' + numGlyphs + ')');
	          numOfMetrics = numGlyphs;
	          header.data[34] = (numOfMetrics & 0xff00) >> 8;
	          header.data[35] = numOfMetrics & 0x00ff;
	        }
	        var numOfSidebearings = numGlyphs - numOfMetrics;
	        var numMissing = numOfSidebearings - (metrics.length - numOfMetrics * 4 >> 1);
	        if (numMissing > 0) {
	          var entries = new Uint8Array(metrics.length + numMissing * 2);
	          entries.set(metrics.data);
	          metrics.data = entries;
	        }
	      }
	      function sanitizeGlyph(source, sourceStart, sourceEnd, dest, destStart, hintsValid) {
	        if (sourceEnd - sourceStart <= 12) {
	          return 0;
	        }
	        var glyf = source.subarray(sourceStart, sourceEnd);
	        var contoursCount = glyf[0] << 8 | glyf[1];
	        if (contoursCount & 0x8000) {
	          dest.set(glyf, destStart);
	          return glyf.length;
	        }
	        var i,
	            j = 10,
	            flagsCount = 0;
	        for (i = 0; i < contoursCount; i++) {
	          var endPoint = glyf[j] << 8 | glyf[j + 1];
	          flagsCount = endPoint + 1;
	          j += 2;
	        }
	        var instructionsStart = j;
	        var instructionsLength = glyf[j] << 8 | glyf[j + 1];
	        j += 2 + instructionsLength;
	        var instructionsEnd = j;
	        var coordinatesLength = 0;
	        for (i = 0; i < flagsCount; i++) {
	          var flag = glyf[j++];
	          if (flag & 0xC0) {
	            glyf[j - 1] = flag & 0x3F;
	          }
	          var xyLength = (flag & 2 ? 1 : flag & 16 ? 0 : 2) + (flag & 4 ? 1 : flag & 32 ? 0 : 2);
	          coordinatesLength += xyLength;
	          if (flag & 8) {
	            var repeat = glyf[j++];
	            i += repeat;
	            coordinatesLength += repeat * xyLength;
	          }
	        }
	        if (coordinatesLength === 0) {
	          return 0;
	        }
	        var glyphDataLength = j + coordinatesLength;
	        if (glyphDataLength > glyf.length) {
	          return 0;
	        }
	        if (!hintsValid && instructionsLength > 0) {
	          dest.set(glyf.subarray(0, instructionsStart), destStart);
	          dest.set([0, 0], destStart + instructionsStart);
	          dest.set(glyf.subarray(instructionsEnd, glyphDataLength), destStart + instructionsStart + 2);
	          glyphDataLength -= instructionsLength;
	          if (glyf.length - glyphDataLength > 3) {
	            glyphDataLength = glyphDataLength + 3 & ~3;
	          }
	          return glyphDataLength;
	        }
	        if (glyf.length - glyphDataLength > 3) {
	          glyphDataLength = glyphDataLength + 3 & ~3;
	          dest.set(glyf.subarray(0, glyphDataLength), destStart);
	          return glyphDataLength;
	        }
	        dest.set(glyf, destStart);
	        return glyf.length;
	      }
	      function sanitizeHead(head, numGlyphs, locaLength) {
	        var data = head.data;
	        var version = int32(data[0], data[1], data[2], data[3]);
	        if (version >> 16 !== 1) {
	          info('Attempting to fix invalid version in head table: ' + version);
	          data[0] = 0;
	          data[1] = 1;
	          data[2] = 0;
	          data[3] = 0;
	        }
	        var indexToLocFormat = int16(data[50], data[51]);
	        if (indexToLocFormat < 0 || indexToLocFormat > 1) {
	          info('Attempting to fix invalid indexToLocFormat in head table: ' + indexToLocFormat);
	          var numGlyphsPlusOne = numGlyphs + 1;
	          if (locaLength === numGlyphsPlusOne << 1) {
	            data[50] = 0;
	            data[51] = 0;
	          } else if (locaLength === numGlyphsPlusOne << 2) {
	            data[50] = 0;
	            data[51] = 1;
	          } else {
	            warn('Could not fix indexToLocFormat: ' + indexToLocFormat);
	          }
	        }
	      }
	      function sanitizeGlyphLocations(loca, glyf, numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry) {
	        var itemSize, itemDecode, itemEncode;
	        if (isGlyphLocationsLong) {
	          itemSize = 4;
	          itemDecode = function fontItemDecodeLong(data, offset) {
	            return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
	          };
	          itemEncode = function fontItemEncodeLong(data, offset, value) {
	            data[offset] = value >>> 24 & 0xFF;
	            data[offset + 1] = value >> 16 & 0xFF;
	            data[offset + 2] = value >> 8 & 0xFF;
	            data[offset + 3] = value & 0xFF;
	          };
	        } else {
	          itemSize = 2;
	          itemDecode = function fontItemDecode(data, offset) {
	            return data[offset] << 9 | data[offset + 1] << 1;
	          };
	          itemEncode = function fontItemEncode(data, offset, value) {
	            data[offset] = value >> 9 & 0xFF;
	            data[offset + 1] = value >> 1 & 0xFF;
	          };
	        }
	        var locaData = loca.data;
	        var locaDataSize = itemSize * (1 + numGlyphs);
	        if (locaData.length !== locaDataSize) {
	          locaData = new Uint8Array(locaDataSize);
	          locaData.set(loca.data.subarray(0, locaDataSize));
	          loca.data = locaData;
	        }
	        var oldGlyfData = glyf.data;
	        var oldGlyfDataLength = oldGlyfData.length;
	        var newGlyfData = new Uint8Array(oldGlyfDataLength);
	        var startOffset = itemDecode(locaData, 0);
	        var writeOffset = 0;
	        var missingGlyphData = Object.create(null);
	        itemEncode(locaData, 0, writeOffset);
	        var i, j;
	        for (i = 0, j = itemSize; i < numGlyphs; i++, j += itemSize) {
	          var endOffset = itemDecode(locaData, j);
	          if (endOffset > oldGlyfDataLength && (oldGlyfDataLength + 3 & ~3) === endOffset) {
	            endOffset = oldGlyfDataLength;
	          }
	          if (endOffset > oldGlyfDataLength) {
	            itemEncode(locaData, j, writeOffset);
	            startOffset = endOffset;
	            continue;
	          }
	          if (startOffset === endOffset) {
	            missingGlyphData[i] = true;
	          }
	          var newLength = sanitizeGlyph(oldGlyfData, startOffset, endOffset, newGlyfData, writeOffset, hintsValid);
	          writeOffset += newLength;
	          itemEncode(locaData, j, writeOffset);
	          startOffset = endOffset;
	        }
	        if (writeOffset === 0) {
	          var simpleGlyph = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
	          for (i = 0, j = itemSize; i < numGlyphs; i++, j += itemSize) {
	            itemEncode(locaData, j, simpleGlyph.length);
	          }
	          glyf.data = simpleGlyph;
	          return missingGlyphData;
	        }
	        if (dupFirstEntry) {
	          var firstEntryLength = itemDecode(locaData, itemSize);
	          if (newGlyfData.length > firstEntryLength + writeOffset) {
	            glyf.data = newGlyfData.subarray(0, firstEntryLength + writeOffset);
	          } else {
	            glyf.data = new Uint8Array(firstEntryLength + writeOffset);
	            glyf.data.set(newGlyfData.subarray(0, writeOffset));
	          }
	          glyf.data.set(newGlyfData.subarray(0, firstEntryLength), writeOffset);
	          itemEncode(loca.data, locaData.length - itemSize, writeOffset + firstEntryLength);
	        } else {
	          glyf.data = newGlyfData.subarray(0, writeOffset);
	        }
	        return missingGlyphData;
	      }
	      function readPostScriptTable(post, properties, maxpNumGlyphs) {
	        var start = (font.start ? font.start : 0) + post.offset;
	        font.pos = start;
	        var length = post.length,
	            end = start + length;
	        var version = font.getInt32();
	        font.getBytes(28);
	        var glyphNames;
	        var valid = true;
	        var i;
	        switch (version) {
	          case 0x00010000:
	            glyphNames = MacStandardGlyphOrdering;
	            break;
	          case 0x00020000:
	            var numGlyphs = font.getUint16();
	            if (numGlyphs !== maxpNumGlyphs) {
	              valid = false;
	              break;
	            }
	            var glyphNameIndexes = [];
	            for (i = 0; i < numGlyphs; ++i) {
	              var index = font.getUint16();
	              if (index >= 32768) {
	                valid = false;
	                break;
	              }
	              glyphNameIndexes.push(index);
	            }
	            if (!valid) {
	              break;
	            }
	            var customNames = [];
	            var strBuf = [];
	            while (font.pos < end) {
	              var stringLength = font.getByte();
	              strBuf.length = stringLength;
	              for (i = 0; i < stringLength; ++i) {
	                strBuf[i] = String.fromCharCode(font.getByte());
	              }
	              customNames.push(strBuf.join(''));
	            }
	            glyphNames = [];
	            for (i = 0; i < numGlyphs; ++i) {
	              var j = glyphNameIndexes[i];
	              if (j < 258) {
	                glyphNames.push(MacStandardGlyphOrdering[j]);
	                continue;
	              }
	              glyphNames.push(customNames[j - 258]);
	            }
	            break;
	          case 0x00030000:
	            break;
	          default:
	            warn('Unknown/unsupported post table version ' + version);
	            valid = false;
	            if (properties.defaultEncoding) {
	              glyphNames = properties.defaultEncoding;
	            }
	            break;
	        }
	        properties.glyphNames = glyphNames;
	        return valid;
	      }
	      function readNameTable(nameTable) {
	        var start = (font.start ? font.start : 0) + nameTable.offset;
	        font.pos = start;
	        var names = [[], []];
	        var length = nameTable.length,
	            end = start + length;
	        var format = font.getUint16();
	        var FORMAT_0_HEADER_LENGTH = 6;
	        if (format !== 0 || length < FORMAT_0_HEADER_LENGTH) {
	          return names;
	        }
	        var numRecords = font.getUint16();
	        var stringsStart = font.getUint16();
	        var records = [];
	        var NAME_RECORD_LENGTH = 12;
	        var i, ii;
	        for (i = 0; i < numRecords && font.pos + NAME_RECORD_LENGTH <= end; i++) {
	          var r = {
	            platform: font.getUint16(),
	            encoding: font.getUint16(),
	            language: font.getUint16(),
	            name: font.getUint16(),
	            length: font.getUint16(),
	            offset: font.getUint16()
	          };
	          if (r.platform === 1 && r.encoding === 0 && r.language === 0 || r.platform === 3 && r.encoding === 1 && r.language === 0x409) {
	            records.push(r);
	          }
	        }
	        for (i = 0, ii = records.length; i < ii; i++) {
	          var record = records[i];
	          if (record.length <= 0) {
	            continue;
	          }
	          var pos = start + stringsStart + record.offset;
	          if (pos + record.length > end) {
	            continue;
	          }
	          font.pos = pos;
	          var nameIndex = record.name;
	          if (record.encoding) {
	            var str = '';
	            for (var j = 0, jj = record.length; j < jj; j += 2) {
	              str += String.fromCharCode(font.getUint16());
	            }
	            names[1][nameIndex] = str;
	          } else {
	            names[0][nameIndex] = bytesToString(font.getBytes(record.length));
	          }
	        }
	        return names;
	      }
	      var TTOpsStackDeltas = [0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1, -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0, 0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0, -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0, 0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1, -1, -2];
	      function sanitizeTTProgram(table, ttContext) {
	        var data = table.data;
	        var i = 0,
	            j,
	            n,
	            b,
	            funcId,
	            pc,
	            lastEndf = 0,
	            lastDeff = 0;
	        var stack = [];
	        var callstack = [];
	        var functionsCalled = [];
	        var tooComplexToFollowFunctions = ttContext.tooComplexToFollowFunctions;
	        var inFDEF = false,
	            ifLevel = 0,
	            inELSE = 0;
	        for (var ii = data.length; i < ii;) {
	          var op = data[i++];
	          if (op === 0x40) {
	            n = data[i++];
	            if (inFDEF || inELSE) {
	              i += n;
	            } else {
	              for (j = 0; j < n; j++) {
	                stack.push(data[i++]);
	              }
	            }
	          } else if (op === 0x41) {
	            n = data[i++];
	            if (inFDEF || inELSE) {
	              i += n * 2;
	            } else {
	              for (j = 0; j < n; j++) {
	                b = data[i++];
	                stack.push(b << 8 | data[i++]);
	              }
	            }
	          } else if ((op & 0xF8) === 0xB0) {
	            n = op - 0xB0 + 1;
	            if (inFDEF || inELSE) {
	              i += n;
	            } else {
	              for (j = 0; j < n; j++) {
	                stack.push(data[i++]);
	              }
	            }
	          } else if ((op & 0xF8) === 0xB8) {
	            n = op - 0xB8 + 1;
	            if (inFDEF || inELSE) {
	              i += n * 2;
	            } else {
	              for (j = 0; j < n; j++) {
	                b = data[i++];
	                stack.push(b << 8 | data[i++]);
	              }
	            }
	          } else if (op === 0x2B && !tooComplexToFollowFunctions) {
	            if (!inFDEF && !inELSE) {
	              funcId = stack[stack.length - 1];
	              ttContext.functionsUsed[funcId] = true;
	              if (funcId in ttContext.functionsStackDeltas) {
	                stack.length += ttContext.functionsStackDeltas[funcId];
	              } else if (funcId in ttContext.functionsDefined && functionsCalled.indexOf(funcId) < 0) {
	                callstack.push({
	                  data: data,
	                  i: i,
	                  stackTop: stack.length - 1
	                });
	                functionsCalled.push(funcId);
	                pc = ttContext.functionsDefined[funcId];
	                if (!pc) {
	                  warn('TT: CALL non-existent function');
	                  ttContext.hintsValid = false;
	                  return;
	                }
	                data = pc.data;
	                i = pc.i;
	              }
	            }
	          } else if (op === 0x2C && !tooComplexToFollowFunctions) {
	            if (inFDEF || inELSE) {
	              warn('TT: nested FDEFs not allowed');
	              tooComplexToFollowFunctions = true;
	            }
	            inFDEF = true;
	            lastDeff = i;
	            funcId = stack.pop();
	            ttContext.functionsDefined[funcId] = {
	              data: data,
	              i: i
	            };
	          } else if (op === 0x2D) {
	            if (inFDEF) {
	              inFDEF = false;
	              lastEndf = i;
	            } else {
	              pc = callstack.pop();
	              if (!pc) {
	                warn('TT: ENDF bad stack');
	                ttContext.hintsValid = false;
	                return;
	              }
	              funcId = functionsCalled.pop();
	              data = pc.data;
	              i = pc.i;
	              ttContext.functionsStackDeltas[funcId] = stack.length - pc.stackTop;
	            }
	          } else if (op === 0x89) {
	            if (inFDEF || inELSE) {
	              warn('TT: nested IDEFs not allowed');
	              tooComplexToFollowFunctions = true;
	            }
	            inFDEF = true;
	            lastDeff = i;
	          } else if (op === 0x58) {
	            ++ifLevel;
	          } else if (op === 0x1B) {
	            inELSE = ifLevel;
	          } else if (op === 0x59) {
	            if (inELSE === ifLevel) {
	              inELSE = 0;
	            }
	            --ifLevel;
	          } else if (op === 0x1C) {
	            if (!inFDEF && !inELSE) {
	              var offset = stack[stack.length - 1];
	              if (offset > 0) {
	                i += offset - 1;
	              }
	            }
	          }
	          if (!inFDEF && !inELSE) {
	            var stackDelta = op <= 0x8E ? TTOpsStackDeltas[op] : op >= 0xC0 && op <= 0xDF ? -1 : op >= 0xE0 ? -2 : 0;
	            if (op >= 0x71 && op <= 0x75) {
	              n = stack.pop();
	              if (!isNaN(n)) {
	                stackDelta = -n * 2;
	              }
	            }
	            while (stackDelta < 0 && stack.length > 0) {
	              stack.pop();
	              stackDelta++;
	            }
	            while (stackDelta > 0) {
	              stack.push(NaN);
	              stackDelta--;
	            }
	          }
	        }
	        ttContext.tooComplexToFollowFunctions = tooComplexToFollowFunctions;
	        var content = [data];
	        if (i > data.length) {
	          content.push(new Uint8Array(i - data.length));
	        }
	        if (lastDeff > lastEndf) {
	          warn('TT: complementing a missing function tail');
	          content.push(new Uint8Array([0x22, 0x2D]));
	        }
	        foldTTTable(table, content);
	      }
	      function checkInvalidFunctions(ttContext, maxFunctionDefs) {
	        if (ttContext.tooComplexToFollowFunctions) {
	          return;
	        }
	        if (ttContext.functionsDefined.length > maxFunctionDefs) {
	          warn('TT: more functions defined than expected');
	          ttContext.hintsValid = false;
	          return;
	        }
	        for (var j = 0, jj = ttContext.functionsUsed.length; j < jj; j++) {
	          if (j > maxFunctionDefs) {
	            warn('TT: invalid function id: ' + j);
	            ttContext.hintsValid = false;
	            return;
	          }
	          if (ttContext.functionsUsed[j] && !ttContext.functionsDefined[j]) {
	            warn('TT: undefined function: ' + j);
	            ttContext.hintsValid = false;
	            return;
	          }
	        }
	      }
	      function foldTTTable(table, content) {
	        if (content.length > 1) {
	          var newLength = 0;
	          var j, jj;
	          for (j = 0, jj = content.length; j < jj; j++) {
	            newLength += content[j].length;
	          }
	          newLength = newLength + 3 & ~3;
	          var result = new Uint8Array(newLength);
	          var pos = 0;
	          for (j = 0, jj = content.length; j < jj; j++) {
	            result.set(content[j], pos);
	            pos += content[j].length;
	          }
	          table.data = result;
	          table.length = newLength;
	        }
	      }
	      function sanitizeTTPrograms(fpgm, prep, cvt, maxFunctionDefs) {
	        var ttContext = {
	          functionsDefined: [],
	          functionsUsed: [],
	          functionsStackDeltas: [],
	          tooComplexToFollowFunctions: false,
	          hintsValid: true
	        };
	        if (fpgm) {
	          sanitizeTTProgram(fpgm, ttContext);
	        }
	        if (prep) {
	          sanitizeTTProgram(prep, ttContext);
	        }
	        if (fpgm) {
	          checkInvalidFunctions(ttContext, maxFunctionDefs);
	        }
	        if (cvt && cvt.length & 1) {
	          var cvtData = new Uint8Array(cvt.length + 1);
	          cvtData.set(cvt.data);
	          cvt.data = cvtData;
	        }
	        return ttContext.hintsValid;
	      }
	      font = new Stream(new Uint8Array(font.getBytes()));
	      var VALID_TABLES = ['OS/2', 'cmap', 'head', 'hhea', 'hmtx', 'maxp', 'name', 'post', 'loca', 'glyf', 'fpgm', 'prep', 'cvt ', 'CFF '];
	      var header = readOpenTypeHeader(font);
	      var numTables = header.numTables;
	      var cff, cffFile;
	      var tables = Object.create(null);
	      tables['OS/2'] = null;
	      tables['cmap'] = null;
	      tables['head'] = null;
	      tables['hhea'] = null;
	      tables['hmtx'] = null;
	      tables['maxp'] = null;
	      tables['name'] = null;
	      tables['post'] = null;
	      var table;
	      for (var i = 0; i < numTables; i++) {
	        table = readTableEntry(font);
	        if (VALID_TABLES.indexOf(table.tag) < 0) {
	          continue;
	        }
	        if (table.length === 0) {
	          continue;
	        }
	        tables[table.tag] = table;
	      }
	      var isTrueType = !tables['CFF '];
	      if (!isTrueType) {
	        if (header.version === 'OTTO' && !properties.composite || !tables['head'] || !tables['hhea'] || !tables['maxp'] || !tables['post']) {
	          cffFile = new Stream(tables['CFF '].data);
	          cff = new CFFFont(cffFile, properties);
	          adjustWidths(properties);
	          return this.convert(name, cff, properties);
	        }
	        delete tables['glyf'];
	        delete tables['loca'];
	        delete tables['fpgm'];
	        delete tables['prep'];
	        delete tables['cvt '];
	        this.isOpenType = true;
	      } else {
	        if (!tables['loca']) {
	          error('Required "loca" table is not found');
	        }
	        if (!tables['glyf']) {
	          warn('Required "glyf" table is not found -- trying to recover.');
	          tables['glyf'] = {
	            tag: 'glyf',
	            data: new Uint8Array(0)
	          };
	        }
	        this.isOpenType = false;
	      }
	      if (!tables['maxp']) {
	        error('Required "maxp" table is not found');
	      }
	      font.pos = (font.start || 0) + tables['maxp'].offset;
	      var version = font.getInt32();
	      var numGlyphs = font.getUint16();
	      var maxFunctionDefs = 0;
	      if (version >= 0x00010000 && tables['maxp'].length >= 22) {
	        font.pos += 8;
	        var maxZones = font.getUint16();
	        if (maxZones > 2) {
	          tables['maxp'].data[14] = 0;
	          tables['maxp'].data[15] = 2;
	        }
	        font.pos += 4;
	        maxFunctionDefs = font.getUint16();
	      }
	      var dupFirstEntry = false;
	      if (properties.type === 'CIDFontType2' && properties.toUnicode && properties.toUnicode.get(0) > '\0') {
	        dupFirstEntry = true;
	        numGlyphs++;
	        tables['maxp'].data[4] = numGlyphs >> 8;
	        tables['maxp'].data[5] = numGlyphs & 255;
	      }
	      var hintsValid = sanitizeTTPrograms(tables['fpgm'], tables['prep'], tables['cvt '], maxFunctionDefs);
	      if (!hintsValid) {
	        delete tables['fpgm'];
	        delete tables['prep'];
	        delete tables['cvt '];
	      }
	      sanitizeMetrics(font, tables['hhea'], tables['hmtx'], numGlyphs);
	      if (!tables['head']) {
	        error('Required "head" table is not found');
	      }
	      sanitizeHead(tables['head'], numGlyphs, isTrueType ? tables['loca'].length : 0);
	      var missingGlyphs = Object.create(null);
	      if (isTrueType) {
	        var isGlyphLocationsLong = int16(tables['head'].data[50], tables['head'].data[51]);
	        missingGlyphs = sanitizeGlyphLocations(tables['loca'], tables['glyf'], numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry);
	      }
	      if (!tables['hhea']) {
	        error('Required "hhea" table is not found');
	      }
	      if (tables['hhea'].data[10] === 0 && tables['hhea'].data[11] === 0) {
	        tables['hhea'].data[10] = 0xFF;
	        tables['hhea'].data[11] = 0xFF;
	      }
	      var metricsOverride = {
	        unitsPerEm: int16(tables['head'].data[18], tables['head'].data[19]),
	        yMax: int16(tables['head'].data[42], tables['head'].data[43]),
	        yMin: signedInt16(tables['head'].data[38], tables['head'].data[39]),
	        ascent: int16(tables['hhea'].data[4], tables['hhea'].data[5]),
	        descent: signedInt16(tables['hhea'].data[6], tables['hhea'].data[7])
	      };
	      this.ascent = metricsOverride.ascent / metricsOverride.unitsPerEm;
	      this.descent = metricsOverride.descent / metricsOverride.unitsPerEm;
	      if (tables['post']) {
	        var valid = readPostScriptTable(tables['post'], properties, numGlyphs);
	        if (!valid) {
	          tables['post'] = null;
	        }
	      }
	      var charCodeToGlyphId = [],
	          charCode;
	      var toUnicode = properties.toUnicode,
	          widths = properties.widths;
	      var skipToUnicode = toUnicode instanceof IdentityToUnicodeMap || toUnicode.length === 0x10000;
	      function hasGlyph(glyphId, charCode, widthCode) {
	        if (!missingGlyphs[glyphId]) {
	          return true;
	        }
	        if (!skipToUnicode && charCode >= 0 && toUnicode.has(charCode)) {
	          return true;
	        }
	        if (widths && widthCode >= 0 && isNum(widths[widthCode])) {
	          return true;
	        }
	        return false;
	      }
	      if (properties.composite) {
	        var cidToGidMap = properties.cidToGidMap || [];
	        var isCidToGidMapEmpty = cidToGidMap.length === 0;
	        properties.cMap.forEach(function (charCode, cid) {
	          assert(cid <= 0xffff, 'Max size of CID is 65,535');
	          var glyphId = -1;
	          if (isCidToGidMapEmpty) {
	            glyphId = cid;
	          } else if (cidToGidMap[cid] !== undefined) {
	            glyphId = cidToGidMap[cid];
	          }
	          if (glyphId >= 0 && glyphId < numGlyphs && hasGlyph(glyphId, charCode, cid)) {
	            charCodeToGlyphId[charCode] = glyphId;
	          }
	        });
	        if (dupFirstEntry && (isCidToGidMapEmpty || !charCodeToGlyphId[0])) {
	          charCodeToGlyphId[0] = numGlyphs - 1;
	        }
	      } else {
	        var cmapTable = readCmapTable(tables['cmap'], font, this.isSymbolicFont, properties.hasEncoding);
	        var cmapPlatformId = cmapTable.platformId;
	        var cmapEncodingId = cmapTable.encodingId;
	        var cmapMappings = cmapTable.mappings;
	        var cmapMappingsLength = cmapMappings.length;
	        if (properties.hasEncoding && (cmapPlatformId === 3 && cmapEncodingId === 1 || cmapPlatformId === 1 && cmapEncodingId === 0) || cmapPlatformId === -1 && cmapEncodingId === -1 && !!getEncoding(properties.baseEncodingName)) {
	          var baseEncoding = [];
	          if (properties.baseEncodingName === 'MacRomanEncoding' || properties.baseEncodingName === 'WinAnsiEncoding') {
	            baseEncoding = getEncoding(properties.baseEncodingName);
	          }
	          var glyphsUnicodeMap = getGlyphsUnicode();
	          for (charCode = 0; charCode < 256; charCode++) {
	            var glyphName, standardGlyphName;
	            if (this.differences && charCode in this.differences) {
	              glyphName = this.differences[charCode];
	            } else if (charCode in baseEncoding && baseEncoding[charCode] !== '') {
	              glyphName = baseEncoding[charCode];
	            } else {
	              glyphName = StandardEncoding[charCode];
	            }
	            if (!glyphName) {
	              continue;
	            }
	            standardGlyphName = recoverGlyphName(glyphName, glyphsUnicodeMap);
	            var unicodeOrCharCode,
	                isUnicode = false;
	            if (cmapPlatformId === 3 && cmapEncodingId === 1) {
	              unicodeOrCharCode = glyphsUnicodeMap[standardGlyphName];
	              isUnicode = true;
	            } else if (cmapPlatformId === 1 && cmapEncodingId === 0) {
	              unicodeOrCharCode = MacRomanEncoding.indexOf(standardGlyphName);
	            }
	            var found = false;
	            for (i = 0; i < cmapMappingsLength; ++i) {
	              if (cmapMappings[i].charCode !== unicodeOrCharCode) {
	                continue;
	              }
	              var code = isUnicode ? charCode : unicodeOrCharCode;
	              if (hasGlyph(cmapMappings[i].glyphId, code, -1)) {
	                charCodeToGlyphId[charCode] = cmapMappings[i].glyphId;
	                found = true;
	                break;
	              }
	            }
	            if (!found && properties.glyphNames) {
	              var glyphId = properties.glyphNames.indexOf(glyphName);
	              if (glyphId === -1 && standardGlyphName !== glyphName) {
	                glyphId = properties.glyphNames.indexOf(standardGlyphName);
	              }
	              if (glyphId > 0 && hasGlyph(glyphId, -1, -1)) {
	                charCodeToGlyphId[charCode] = glyphId;
	                found = true;
	              }
	            }
	            if (!found) {
	              charCodeToGlyphId[charCode] = 0;
	            }
	          }
	        } else if (cmapPlatformId === 0 && cmapEncodingId === 0) {
	          for (i = 0; i < cmapMappingsLength; ++i) {
	            charCodeToGlyphId[cmapMappings[i].charCode] = cmapMappings[i].glyphId;
	          }
	        } else {
	          for (i = 0; i < cmapMappingsLength; ++i) {
	            charCode = cmapMappings[i].charCode & 0xFF;
	            charCodeToGlyphId[charCode] = cmapMappings[i].glyphId;
	          }
	        }
	      }
	      if (charCodeToGlyphId.length === 0) {
	        charCodeToGlyphId[0] = 0;
	      }
	      var newMapping = adjustMapping(charCodeToGlyphId, properties);
	      this.toFontChar = newMapping.toFontChar;
	      tables['cmap'] = {
	        tag: 'cmap',
	        data: createCmapTable(newMapping.charCodeToGlyphId, numGlyphs)
	      };
	      if (!tables['OS/2'] || !validateOS2Table(tables['OS/2'])) {
	        tables['OS/2'] = {
	          tag: 'OS/2',
	          data: createOS2Table(properties, newMapping.charCodeToGlyphId, metricsOverride)
	        };
	      }
	      if (!tables['post']) {
	        tables['post'] = {
	          tag: 'post',
	          data: createPostTable(properties)
	        };
	      }
	      if (!isTrueType) {
	        try {
	          cffFile = new Stream(tables['CFF '].data);
	          var parser = new CFFParser(cffFile, properties, SEAC_ANALYSIS_ENABLED);
	          cff = parser.parse();
	          var compiler = new CFFCompiler(cff);
	          tables['CFF '].data = compiler.compile();
	        } catch (e) {
	          warn('Failed to compile font ' + properties.loadedName);
	        }
	      }
	      if (!tables['name']) {
	        tables['name'] = {
	          tag: 'name',
	          data: createNameTable(this.name)
	        };
	      } else {
	        var namePrototype = readNameTable(tables['name']);
	        tables['name'].data = createNameTable(name, namePrototype);
	      }
	      var builder = new OpenTypeFileBuilder(header.version);
	      for (var tableTag in tables) {
	        builder.addTable(tableTag, tables[tableTag].data);
	      }
	      return builder.toArray();
	    },
	    convert: function Font_convert(fontName, font, properties) {
	      properties.fixedPitch = false;
	      if (properties.builtInEncoding) {
	        adjustToUnicode(properties, properties.builtInEncoding);
	      }
	      var mapping = font.getGlyphMapping(properties);
	      var newMapping = adjustMapping(mapping, properties);
	      this.toFontChar = newMapping.toFontChar;
	      var numGlyphs = font.numGlyphs;
	      function getCharCodes(charCodeToGlyphId, glyphId) {
	        var charCodes = null;
	        for (var charCode in charCodeToGlyphId) {
	          if (glyphId === charCodeToGlyphId[charCode]) {
	            if (!charCodes) {
	              charCodes = [];
	            }
	            charCodes.push(charCode | 0);
	          }
	        }
	        return charCodes;
	      }
	      function createCharCode(charCodeToGlyphId, glyphId) {
	        for (var charCode in charCodeToGlyphId) {
	          if (glyphId === charCodeToGlyphId[charCode]) {
	            return charCode | 0;
	          }
	        }
	        newMapping.charCodeToGlyphId[newMapping.nextAvailableFontCharCode] = glyphId;
	        return newMapping.nextAvailableFontCharCode++;
	      }
	      var seacs = font.seacs;
	      if (SEAC_ANALYSIS_ENABLED && seacs && seacs.length) {
	        var matrix = properties.fontMatrix || FONT_IDENTITY_MATRIX;
	        var charset = font.getCharset();
	        var seacMap = Object.create(null);
	        for (var glyphId in seacs) {
	          glyphId |= 0;
	          var seac = seacs[glyphId];
	          var baseGlyphName = StandardEncoding[seac[2]];
	          var accentGlyphName = StandardEncoding[seac[3]];
	          var baseGlyphId = charset.indexOf(baseGlyphName);
	          var accentGlyphId = charset.indexOf(accentGlyphName);
	          if (baseGlyphId < 0 || accentGlyphId < 0) {
	            continue;
	          }
	          var accentOffset = {
	            x: seac[0] * matrix[0] + seac[1] * matrix[2] + matrix[4],
	            y: seac[0] * matrix[1] + seac[1] * matrix[3] + matrix[5]
	          };
	          var charCodes = getCharCodes(mapping, glyphId);
	          if (!charCodes) {
	            continue;
	          }
	          for (var i = 0, ii = charCodes.length; i < ii; i++) {
	            var charCode = charCodes[i];
	            var charCodeToGlyphId = newMapping.charCodeToGlyphId;
	            var baseFontCharCode = createCharCode(charCodeToGlyphId, baseGlyphId);
	            var accentFontCharCode = createCharCode(charCodeToGlyphId, accentGlyphId);
	            seacMap[charCode] = {
	              baseFontCharCode: baseFontCharCode,
	              accentFontCharCode: accentFontCharCode,
	              accentOffset: accentOffset
	            };
	          }
	        }
	        properties.seacMap = seacMap;
	      }
	      var unitsPerEm = 1 / (properties.fontMatrix || FONT_IDENTITY_MATRIX)[0];
	      var builder = new OpenTypeFileBuilder('\x4F\x54\x54\x4F');
	      builder.addTable('CFF ', font.data);
	      builder.addTable('OS/2', createOS2Table(properties, newMapping.charCodeToGlyphId));
	      builder.addTable('cmap', createCmapTable(newMapping.charCodeToGlyphId, numGlyphs));
	      builder.addTable('head', '\x00\x01\x00\x00' + '\x00\x00\x10\x00' + '\x00\x00\x00\x00' + '\x5F\x0F\x3C\xF5' + '\x00\x00' + safeString16(unitsPerEm) + '\x00\x00\x00\x00\x9e\x0b\x7e\x27' + '\x00\x00\x00\x00\x9e\x0b\x7e\x27' + '\x00\x00' + safeString16(properties.descent) + '\x0F\xFF' + safeString16(properties.ascent) + string16(properties.italicAngle ? 2 : 0) + '\x00\x11' + '\x00\x00' + '\x00\x00' + '\x00\x00');
	      builder.addTable('hhea', '\x00\x01\x00\x00' + safeString16(properties.ascent) + safeString16(properties.descent) + '\x00\x00' + '\xFF\xFF' + '\x00\x00' + '\x00\x00' + '\x00\x00' + safeString16(properties.capHeight) + safeString16(Math.tan(properties.italicAngle) * properties.xHeight) + '\x00\x00' + '\x00\x00' + '\x00\x00' + '\x00\x00' + '\x00\x00' + '\x00\x00' + string16(numGlyphs));
	      builder.addTable('hmtx', function fontFieldsHmtx() {
	        var charstrings = font.charstrings;
	        var cffWidths = font.cff ? font.cff.widths : null;
	        var hmtx = '\x00\x00\x00\x00';
	        for (var i = 1, ii = numGlyphs; i < ii; i++) {
	          var width = 0;
	          if (charstrings) {
	            var charstring = charstrings[i - 1];
	            width = 'width' in charstring ? charstring.width : 0;
	          } else if (cffWidths) {
	            width = Math.ceil(cffWidths[i] || 0);
	          }
	          hmtx += string16(width) + string16(0);
	        }
	        return hmtx;
	      }());
	      builder.addTable('maxp', '\x00\x00\x50\x00' + string16(numGlyphs));
	      builder.addTable('name', createNameTable(fontName));
	      builder.addTable('post', createPostTable(properties));
	      return builder.toArray();
	    },
	    get spaceWidth() {
	      if ('_shadowWidth' in this) {
	        return this._shadowWidth;
	      }
	      var possibleSpaceReplacements = ['space', 'minus', 'one', 'i', 'I'];
	      var width;
	      for (var i = 0, ii = possibleSpaceReplacements.length; i < ii; i++) {
	        var glyphName = possibleSpaceReplacements[i];
	        if (glyphName in this.widths) {
	          width = this.widths[glyphName];
	          break;
	        }
	        var glyphsUnicodeMap = getGlyphsUnicode();
	        var glyphUnicode = glyphsUnicodeMap[glyphName];
	        var charcode = 0;
	        if (this.composite) {
	          if (this.cMap.contains(glyphUnicode)) {
	            charcode = this.cMap.lookup(glyphUnicode);
	          }
	        }
	        if (!charcode && this.toUnicode) {
	          charcode = this.toUnicode.charCodeOf(glyphUnicode);
	        }
	        if (charcode <= 0) {
	          charcode = glyphUnicode;
	        }
	        width = this.widths[charcode];
	        if (width) {
	          break;
	        }
	      }
	      width = width || this.defaultWidth;
	      this._shadowWidth = width;
	      return width;
	    },
	    charToGlyph: function Font_charToGlyph(charcode, isSpace) {
	      var fontCharCode, width, operatorListId;
	      var widthCode = charcode;
	      if (this.cMap && this.cMap.contains(charcode)) {
	        widthCode = this.cMap.lookup(charcode);
	      }
	      width = this.widths[widthCode];
	      width = isNum(width) ? width : this.defaultWidth;
	      var vmetric = this.vmetrics && this.vmetrics[widthCode];
	      var unicode = this.toUnicode.get(charcode) || charcode;
	      if (typeof unicode === 'number') {
	        unicode = String.fromCharCode(unicode);
	      }
	      var isInFont = charcode in this.toFontChar;
	      fontCharCode = this.toFontChar[charcode] || charcode;
	      if (this.missingFile) {
	        fontCharCode = mapSpecialUnicodeValues(fontCharCode);
	      }
	      if (this.isType3Font) {
	        operatorListId = fontCharCode;
	      }
	      var accent = null;
	      if (this.seacMap && this.seacMap[charcode]) {
	        isInFont = true;
	        var seac = this.seacMap[charcode];
	        fontCharCode = seac.baseFontCharCode;
	        accent = {
	          fontChar: String.fromCharCode(seac.accentFontCharCode),
	          offset: seac.accentOffset
	        };
	      }
	      var fontChar = String.fromCharCode(fontCharCode);
	      var glyph = this.glyphCache[charcode];
	      if (!glyph || !glyph.matchesForCache(fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont)) {
	        glyph = new Glyph(fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont);
	        this.glyphCache[charcode] = glyph;
	      }
	      return glyph;
	    },
	    charsToGlyphs: function Font_charsToGlyphs(chars) {
	      var charsCache = this.charsCache;
	      var glyphs, glyph, charcode;
	      if (charsCache) {
	        glyphs = charsCache[chars];
	        if (glyphs) {
	          return glyphs;
	        }
	      }
	      if (!charsCache) {
	        charsCache = this.charsCache = Object.create(null);
	      }
	      glyphs = [];
	      var charsCacheKey = chars;
	      var i = 0,
	          ii;
	      if (this.cMap) {
	        var c = Object.create(null);
	        while (i < chars.length) {
	          this.cMap.readCharCode(chars, i, c);
	          charcode = c.charcode;
	          var length = c.length;
	          i += length;
	          var isSpace = length === 1 && chars.charCodeAt(i - 1) === 0x20;
	          glyph = this.charToGlyph(charcode, isSpace);
	          glyphs.push(glyph);
	        }
	      } else {
	        for (i = 0, ii = chars.length; i < ii; ++i) {
	          charcode = chars.charCodeAt(i);
	          glyph = this.charToGlyph(charcode, charcode === 0x20);
	          glyphs.push(glyph);
	        }
	      }
	      return charsCache[charsCacheKey] = glyphs;
	    }
	  };
	  return Font;
	}();
	var ErrorFont = function ErrorFontClosure() {
	  function ErrorFont(error) {
	    this.error = error;
	    this.loadedName = 'g_font_error';
	    this.loading = false;
	  }
	  ErrorFont.prototype = {
	    charsToGlyphs: function ErrorFont_charsToGlyphs() {
	      return [];
	    },
	    exportData: function ErrorFont_exportData() {
	      return { error: this.error };
	    }
	  };
	  return ErrorFont;
	}();
	function type1FontGlyphMapping(properties, builtInEncoding, glyphNames) {
	  var charCodeToGlyphId = Object.create(null);
	  var glyphId, charCode, baseEncoding;
	  var isSymbolicFont = !!(properties.flags & FontFlags.Symbolic);
	  if (properties.baseEncodingName) {
	    baseEncoding = getEncoding(properties.baseEncodingName);
	    for (charCode = 0; charCode < baseEncoding.length; charCode++) {
	      glyphId = glyphNames.indexOf(baseEncoding[charCode]);
	      if (glyphId >= 0) {
	        charCodeToGlyphId[charCode] = glyphId;
	      } else {
	        charCodeToGlyphId[charCode] = 0;
	      }
	    }
	  } else if (isSymbolicFont) {
	    for (charCode in builtInEncoding) {
	      charCodeToGlyphId[charCode] = builtInEncoding[charCode];
	    }
	  } else {
	    baseEncoding = StandardEncoding;
	    for (charCode = 0; charCode < baseEncoding.length; charCode++) {
	      glyphId = glyphNames.indexOf(baseEncoding[charCode]);
	      if (glyphId >= 0) {
	        charCodeToGlyphId[charCode] = glyphId;
	      } else {
	        charCodeToGlyphId[charCode] = 0;
	      }
	    }
	  }
	  var differences = properties.differences,
	      glyphsUnicodeMap;
	  if (differences) {
	    for (charCode in differences) {
	      var glyphName = differences[charCode];
	      glyphId = glyphNames.indexOf(glyphName);
	      if (glyphId === -1) {
	        if (!glyphsUnicodeMap) {
	          glyphsUnicodeMap = getGlyphsUnicode();
	        }
	        var standardGlyphName = recoverGlyphName(glyphName, glyphsUnicodeMap);
	        if (standardGlyphName !== glyphName) {
	          glyphId = glyphNames.indexOf(standardGlyphName);
	        }
	      }
	      if (glyphId >= 0) {
	        charCodeToGlyphId[charCode] = glyphId;
	      } else {
	        charCodeToGlyphId[charCode] = 0;
	      }
	    }
	  }
	  return charCodeToGlyphId;
	}
	var Type1Font = function Type1FontClosure() {
	  function findBlock(streamBytes, signature, startIndex) {
	    var streamBytesLength = streamBytes.length;
	    var signatureLength = signature.length;
	    var scanLength = streamBytesLength - signatureLength;
	    var i = startIndex,
	        j,
	        found = false;
	    while (i < scanLength) {
	      j = 0;
	      while (j < signatureLength && streamBytes[i + j] === signature[j]) {
	        j++;
	      }
	      if (j >= signatureLength) {
	        i += j;
	        while (i < streamBytesLength && isSpace(streamBytes[i])) {
	          i++;
	        }
	        found = true;
	        break;
	      }
	      i++;
	    }
	    return {
	      found: found,
	      length: i
	    };
	  }
	  function getHeaderBlock(stream, suggestedLength) {
	    var EEXEC_SIGNATURE = [0x65, 0x65, 0x78, 0x65, 0x63];
	    var streamStartPos = stream.pos;
	    var headerBytes, headerBytesLength, block;
	    try {
	      headerBytes = stream.getBytes(suggestedLength);
	      headerBytesLength = headerBytes.length;
	    } catch (ex) {
	      if (ex instanceof MissingDataException) {
	        throw ex;
	      }
	    }
	    if (headerBytesLength === suggestedLength) {
	      block = findBlock(headerBytes, EEXEC_SIGNATURE, suggestedLength - 2 * EEXEC_SIGNATURE.length);
	      if (block.found && block.length === suggestedLength) {
	        return {
	          stream: new Stream(headerBytes),
	          length: suggestedLength
	        };
	      }
	    }
	    warn('Invalid "Length1" property in Type1 font -- trying to recover.');
	    stream.pos = streamStartPos;
	    var SCAN_BLOCK_LENGTH = 2048;
	    var actualLength;
	    while (true) {
	      var scanBytes = stream.peekBytes(SCAN_BLOCK_LENGTH);
	      block = findBlock(scanBytes, EEXEC_SIGNATURE, 0);
	      if (block.length === 0) {
	        break;
	      }
	      stream.pos += block.length;
	      if (block.found) {
	        actualLength = stream.pos - streamStartPos;
	        break;
	      }
	    }
	    stream.pos = streamStartPos;
	    if (actualLength) {
	      return {
	        stream: new Stream(stream.getBytes(actualLength)),
	        length: actualLength
	      };
	    }
	    warn('Unable to recover "Length1" property in Type1 font -- using as is.');
	    return {
	      stream: new Stream(stream.getBytes(suggestedLength)),
	      length: suggestedLength
	    };
	  }
	  function getEexecBlock(stream, suggestedLength) {
	    var eexecBytes = stream.getBytes();
	    return {
	      stream: new Stream(eexecBytes),
	      length: eexecBytes.length
	    };
	  }
	  function Type1Font(name, file, properties) {
	    var PFB_HEADER_SIZE = 6;
	    var headerBlockLength = properties.length1;
	    var eexecBlockLength = properties.length2;
	    var pfbHeader = file.peekBytes(PFB_HEADER_SIZE);
	    var pfbHeaderPresent = pfbHeader[0] === 0x80 && pfbHeader[1] === 0x01;
	    if (pfbHeaderPresent) {
	      file.skip(PFB_HEADER_SIZE);
	      headerBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
	    }
	    var headerBlock = getHeaderBlock(file, headerBlockLength);
	    headerBlockLength = headerBlock.length;
	    var headerBlockParser = new Type1Parser(headerBlock.stream, false, SEAC_ANALYSIS_ENABLED);
	    headerBlockParser.extractFontHeader(properties);
	    if (pfbHeaderPresent) {
	      pfbHeader = file.getBytes(PFB_HEADER_SIZE);
	      eexecBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
	    }
	    var eexecBlock = getEexecBlock(file, eexecBlockLength);
	    eexecBlockLength = eexecBlock.length;
	    var eexecBlockParser = new Type1Parser(eexecBlock.stream, true, SEAC_ANALYSIS_ENABLED);
	    var data = eexecBlockParser.extractFontProgram();
	    for (var info in data.properties) {
	      properties[info] = data.properties[info];
	    }
	    var charstrings = data.charstrings;
	    var type2Charstrings = this.getType2Charstrings(charstrings);
	    var subrs = this.getType2Subrs(data.subrs);
	    this.charstrings = charstrings;
	    this.data = this.wrap(name, type2Charstrings, this.charstrings, subrs, properties);
	    this.seacs = this.getSeacs(data.charstrings);
	  }
	  Type1Font.prototype = {
	    get numGlyphs() {
	      return this.charstrings.length + 1;
	    },
	    getCharset: function Type1Font_getCharset() {
	      var charset = ['.notdef'];
	      var charstrings = this.charstrings;
	      for (var glyphId = 0; glyphId < charstrings.length; glyphId++) {
	        charset.push(charstrings[glyphId].glyphName);
	      }
	      return charset;
	    },
	    getGlyphMapping: function Type1Font_getGlyphMapping(properties) {
	      var charstrings = this.charstrings;
	      var glyphNames = ['.notdef'],
	          glyphId;
	      for (glyphId = 0; glyphId < charstrings.length; glyphId++) {
	        glyphNames.push(charstrings[glyphId].glyphName);
	      }
	      var encoding = properties.builtInEncoding;
	      if (encoding) {
	        var builtInEncoding = Object.create(null);
	        for (var charCode in encoding) {
	          glyphId = glyphNames.indexOf(encoding[charCode]);
	          if (glyphId >= 0) {
	            builtInEncoding[charCode] = glyphId;
	          }
	        }
	      }
	      return type1FontGlyphMapping(properties, builtInEncoding, glyphNames);
	    },
	    getSeacs: function Type1Font_getSeacs(charstrings) {
	      var i, ii;
	      var seacMap = [];
	      for (i = 0, ii = charstrings.length; i < ii; i++) {
	        var charstring = charstrings[i];
	        if (charstring.seac) {
	          seacMap[i + 1] = charstring.seac;
	        }
	      }
	      return seacMap;
	    },
	    getType2Charstrings: function Type1Font_getType2Charstrings(type1Charstrings) {
	      var type2Charstrings = [];
	      for (var i = 0, ii = type1Charstrings.length; i < ii; i++) {
	        type2Charstrings.push(type1Charstrings[i].charstring);
	      }
	      return type2Charstrings;
	    },
	    getType2Subrs: function Type1Font_getType2Subrs(type1Subrs) {
	      var bias = 0;
	      var count = type1Subrs.length;
	      if (count < 1133) {
	        bias = 107;
	      } else if (count < 33769) {
	        bias = 1131;
	      } else {
	        bias = 32768;
	      }
	      var type2Subrs = [];
	      var i;
	      for (i = 0; i < bias; i++) {
	        type2Subrs.push([0x0B]);
	      }
	      for (i = 0; i < count; i++) {
	        type2Subrs.push(type1Subrs[i]);
	      }
	      return type2Subrs;
	    },
	    wrap: function Type1Font_wrap(name, glyphs, charstrings, subrs, properties) {
	      var cff = new CFF();
	      cff.header = new CFFHeader(1, 0, 4, 4);
	      cff.names = [name];
	      var topDict = new CFFTopDict();
	      topDict.setByName('version', 391);
	      topDict.setByName('Notice', 392);
	      topDict.setByName('FullName', 393);
	      topDict.setByName('FamilyName', 394);
	      topDict.setByName('Weight', 395);
	      topDict.setByName('Encoding', null);
	      topDict.setByName('FontMatrix', properties.fontMatrix);
	      topDict.setByName('FontBBox', properties.bbox);
	      topDict.setByName('charset', null);
	      topDict.setByName('CharStrings', null);
	      topDict.setByName('Private', null);
	      cff.topDict = topDict;
	      var strings = new CFFStrings();
	      strings.add('Version 0.11');
	      strings.add('See original notice');
	      strings.add(name);
	      strings.add(name);
	      strings.add('Medium');
	      cff.strings = strings;
	      cff.globalSubrIndex = new CFFIndex();
	      var count = glyphs.length;
	      var charsetArray = [0];
	      var i, ii;
	      for (i = 0; i < count; i++) {
	        var index = CFFStandardStrings.indexOf(charstrings[i].glyphName);
	        if (index === -1) {
	          index = 0;
	        }
	        charsetArray.push(index >> 8 & 0xff, index & 0xff);
	      }
	      cff.charset = new CFFCharset(false, 0, [], charsetArray);
	      var charStringsIndex = new CFFIndex();
	      charStringsIndex.add([0x8B, 0x0E]);
	      for (i = 0; i < count; i++) {
	        var glyph = glyphs[i];
	        if (glyph.length === 0) {
	          charStringsIndex.add([0x8B, 0x0E]);
	          continue;
	        }
	        charStringsIndex.add(glyph);
	      }
	      cff.charStrings = charStringsIndex;
	      var privateDict = new CFFPrivateDict();
	      privateDict.setByName('Subrs', null);
	      var fields = ['BlueValues', 'OtherBlues', 'FamilyBlues', 'FamilyOtherBlues', 'StemSnapH', 'StemSnapV', 'BlueShift', 'BlueFuzz', 'BlueScale', 'LanguageGroup', 'ExpansionFactor', 'ForceBold', 'StdHW', 'StdVW'];
	      for (i = 0, ii = fields.length; i < ii; i++) {
	        var field = fields[i];
	        if (!(field in properties.privateData)) {
	          continue;
	        }
	        var value = properties.privateData[field];
	        if (isArray(value)) {
	          for (var j = value.length - 1; j > 0; j--) {
	            value[j] -= value[j - 1];
	          }
	        }
	        privateDict.setByName(field, value);
	      }
	      cff.topDict.privateDict = privateDict;
	      var subrIndex = new CFFIndex();
	      for (i = 0, ii = subrs.length; i < ii; i++) {
	        subrIndex.add(subrs[i]);
	      }
	      privateDict.subrsIndex = subrIndex;
	      var compiler = new CFFCompiler(cff);
	      return compiler.compile();
	    }
	  };
	  return Type1Font;
	}();
	var CFFFont = function CFFFontClosure() {
	  function CFFFont(file, properties) {
	    this.properties = properties;
	    var parser = new CFFParser(file, properties, SEAC_ANALYSIS_ENABLED);
	    this.cff = parser.parse();
	    var compiler = new CFFCompiler(this.cff);
	    this.seacs = this.cff.seacs;
	    try {
	      this.data = compiler.compile();
	    } catch (e) {
	      warn('Failed to compile font ' + properties.loadedName);
	      this.data = file;
	    }
	  }
	  CFFFont.prototype = {
	    get numGlyphs() {
	      return this.cff.charStrings.count;
	    },
	    getCharset: function CFFFont_getCharset() {
	      return this.cff.charset.charset;
	    },
	    getGlyphMapping: function CFFFont_getGlyphMapping() {
	      var cff = this.cff;
	      var properties = this.properties;
	      var charsets = cff.charset.charset;
	      var charCodeToGlyphId;
	      var glyphId;
	      if (properties.composite) {
	        charCodeToGlyphId = Object.create(null);
	        if (cff.isCIDFont) {
	          for (glyphId = 0; glyphId < charsets.length; glyphId++) {
	            var cid = charsets[glyphId];
	            var charCode = properties.cMap.charCodeOf(cid);
	            charCodeToGlyphId[charCode] = glyphId;
	          }
	        } else {
	          for (glyphId = 0; glyphId < cff.charStrings.count; glyphId++) {
	            charCodeToGlyphId[glyphId] = glyphId;
	          }
	        }
	        return charCodeToGlyphId;
	      }
	      var encoding = cff.encoding ? cff.encoding.encoding : null;
	      charCodeToGlyphId = type1FontGlyphMapping(properties, encoding, charsets);
	      return charCodeToGlyphId;
	    }
	  };
	  return CFFFont;
	}();
	(function checkSeacSupport() {
	  if (typeof navigator !== 'undefined' && /Windows/.test(navigator.userAgent)) {
	    SEAC_ANALYSIS_ENABLED = true;
	  }
	})();
	(function checkChromeWindows() {
	  if (typeof navigator !== 'undefined' && /Windows.*Chrome/.test(navigator.userAgent)) {
	    SKIP_PRIVATE_USE_RANGE_F000_TO_F01F = true;
	  }
	})();
	exports.SEAC_ANALYSIS_ENABLED = SEAC_ANALYSIS_ENABLED;
	exports.PRIVATE_USE_OFFSET_START = PRIVATE_USE_OFFSET_START;
	exports.PRIVATE_USE_OFFSET_END = PRIVATE_USE_OFFSET_END;
	exports.ErrorFont = ErrorFont;
	exports.Font = Font;
	exports.FontFlags = FontFlags;
	exports.IdentityToUnicodeMap = IdentityToUnicodeMap;
	exports.ProblematicCharRanges = ProblematicCharRanges;
	exports.ToUnicodeMap = ToUnicodeMap;
	exports.getFontType = getFontType;
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var coreColorSpace = __w_pdfjs_require__(3);
	var coreStream = __w_pdfjs_require__(2);
	var coreJpx = __w_pdfjs_require__(15);
	var ImageKind = sharedUtil.ImageKind;
	var assert = sharedUtil.assert;
	var error = sharedUtil.error;
	var info = sharedUtil.info;
	var isArray = sharedUtil.isArray;
	var warn = sharedUtil.warn;
	var Name = corePrimitives.Name;
	var isStream = corePrimitives.isStream;
	var ColorSpace = coreColorSpace.ColorSpace;
	var DecodeStream = coreStream.DecodeStream;
	var JpegStream = coreStream.JpegStream;
	var JpxImage = coreJpx.JpxImage;
	var PDFImage = function PDFImageClosure() {
	  function handleImageData(image, nativeDecoder) {
	    if (nativeDecoder && nativeDecoder.canDecode(image)) {
	      return nativeDecoder.decode(image);
	    }
	    return Promise.resolve(image);
	  }
	  function decodeAndClamp(value, addend, coefficient, max) {
	    value = addend + value * coefficient;
	    return value < 0 ? 0 : value > max ? max : value;
	  }
	  function resizeImageMask(src, bpc, w1, h1, w2, h2) {
	    var length = w2 * h2;
	    var dest = bpc <= 8 ? new Uint8Array(length) : bpc <= 16 ? new Uint16Array(length) : new Uint32Array(length);
	    var xRatio = w1 / w2;
	    var yRatio = h1 / h2;
	    var i,
	        j,
	        py,
	        newIndex = 0,
	        oldIndex;
	    var xScaled = new Uint16Array(w2);
	    var w1Scanline = w1;
	    for (i = 0; i < w2; i++) {
	      xScaled[i] = Math.floor(i * xRatio);
	    }
	    for (i = 0; i < h2; i++) {
	      py = Math.floor(i * yRatio) * w1Scanline;
	      for (j = 0; j < w2; j++) {
	        oldIndex = py + xScaled[j];
	        dest[newIndex++] = src[oldIndex];
	      }
	    }
	    return dest;
	  }
	  function PDFImage(xref, res, image, inline, smask, mask, isMask) {
	    this.image = image;
	    var dict = image.dict;
	    if (dict.has('Filter')) {
	      var filter = dict.get('Filter').name;
	      if (filter === 'JPXDecode') {
	        var jpxImage = new JpxImage();
	        jpxImage.parseImageProperties(image.stream);
	        image.stream.reset();
	        image.bitsPerComponent = jpxImage.bitsPerComponent;
	        image.numComps = jpxImage.componentsCount;
	      } else if (filter === 'JBIG2Decode') {
	        image.bitsPerComponent = 1;
	        image.numComps = 1;
	      }
	    }
	    this.width = dict.get('Width', 'W');
	    this.height = dict.get('Height', 'H');
	    if (this.width < 1 || this.height < 1) {
	      error('Invalid image width: ' + this.width + ' or height: ' + this.height);
	    }
	    this.interpolate = dict.get('Interpolate', 'I') || false;
	    this.imageMask = dict.get('ImageMask', 'IM') || false;
	    this.matte = dict.get('Matte') || false;
	    var bitsPerComponent = image.bitsPerComponent;
	    if (!bitsPerComponent) {
	      bitsPerComponent = dict.get('BitsPerComponent', 'BPC');
	      if (!bitsPerComponent) {
	        if (this.imageMask) {
	          bitsPerComponent = 1;
	        } else {
	          error('Bits per component missing in image: ' + this.imageMask);
	        }
	      }
	    }
	    this.bpc = bitsPerComponent;
	    if (!this.imageMask) {
	      var colorSpace = dict.get('ColorSpace', 'CS');
	      if (!colorSpace) {
	        info('JPX images (which do not require color spaces)');
	        switch (image.numComps) {
	          case 1:
	            colorSpace = Name.get('DeviceGray');
	            break;
	          case 3:
	            colorSpace = Name.get('DeviceRGB');
	            break;
	          case 4:
	            colorSpace = Name.get('DeviceCMYK');
	            break;
	          default:
	            error('JPX images with ' + this.numComps + ' color components not supported.');
	        }
	      }
	      this.colorSpace = ColorSpace.parse(colorSpace, xref, res);
	      this.numComps = this.colorSpace.numComps;
	    }
	    this.decode = dict.getArray('Decode', 'D');
	    this.needsDecode = false;
	    if (this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode) || isMask && !ColorSpace.isDefaultDecode(this.decode, 1))) {
	      this.needsDecode = true;
	      var max = (1 << bitsPerComponent) - 1;
	      this.decodeCoefficients = [];
	      this.decodeAddends = [];
	      for (var i = 0, j = 0; i < this.decode.length; i += 2, ++j) {
	        var dmin = this.decode[i];
	        var dmax = this.decode[i + 1];
	        this.decodeCoefficients[j] = dmax - dmin;
	        this.decodeAddends[j] = max * dmin;
	      }
	    }
	    if (smask) {
	      this.smask = new PDFImage(xref, res, smask, false);
	    } else if (mask) {
	      if (isStream(mask)) {
	        var maskDict = mask.dict,
	            imageMask = maskDict.get('ImageMask', 'IM');
	        if (!imageMask) {
	          warn('Ignoring /Mask in image without /ImageMask.');
	        } else {
	          this.mask = new PDFImage(xref, res, mask, false, null, null, true);
	        }
	      } else {
	        this.mask = mask;
	      }
	    }
	  }
	  PDFImage.buildImage = function PDFImage_buildImage(handler, xref, res, image, inline, nativeDecoder) {
	    var imagePromise = handleImageData(image, nativeDecoder);
	    var smaskPromise;
	    var maskPromise;
	    var smask = image.dict.get('SMask');
	    var mask = image.dict.get('Mask');
	    if (smask) {
	      smaskPromise = handleImageData(smask, nativeDecoder);
	      maskPromise = Promise.resolve(null);
	    } else {
	      smaskPromise = Promise.resolve(null);
	      if (mask) {
	        if (isStream(mask)) {
	          maskPromise = handleImageData(mask, nativeDecoder);
	        } else if (isArray(mask)) {
	          maskPromise = Promise.resolve(mask);
	        } else {
	          warn('Unsupported mask format.');
	          maskPromise = Promise.resolve(null);
	        }
	      } else {
	        maskPromise = Promise.resolve(null);
	      }
	    }
	    return Promise.all([imagePromise, smaskPromise, maskPromise]).then(function (results) {
	      var imageData = results[0];
	      var smaskData = results[1];
	      var maskData = results[2];
	      return new PDFImage(xref, res, imageData, inline, smaskData, maskData);
	    });
	  };
	  PDFImage.createMask = function PDFImage_createMask(imgArray, width, height, imageIsFromDecodeStream, inverseDecode) {
	    var computedLength = (width + 7 >> 3) * height;
	    var actualLength = imgArray.byteLength;
	    var haveFullData = computedLength === actualLength;
	    var data, i;
	    if (imageIsFromDecodeStream && (!inverseDecode || haveFullData)) {
	      data = imgArray;
	    } else if (!inverseDecode) {
	      data = new Uint8Array(actualLength);
	      data.set(imgArray);
	    } else {
	      data = new Uint8Array(computedLength);
	      data.set(imgArray);
	      for (i = actualLength; i < computedLength; i++) {
	        data[i] = 0xff;
	      }
	    }
	    if (inverseDecode) {
	      for (i = 0; i < actualLength; i++) {
	        data[i] = ~data[i];
	      }
	    }
	    return {
	      data: data,
	      width: width,
	      height: height
	    };
	  };
	  PDFImage.prototype = {
	    get drawWidth() {
	      return Math.max(this.width, this.smask && this.smask.width || 0, this.mask && this.mask.width || 0);
	    },
	    get drawHeight() {
	      return Math.max(this.height, this.smask && this.smask.height || 0, this.mask && this.mask.height || 0);
	    },
	    decodeBuffer: function PDFImage_decodeBuffer(buffer) {
	      var bpc = this.bpc;
	      var numComps = this.numComps;
	      var decodeAddends = this.decodeAddends;
	      var decodeCoefficients = this.decodeCoefficients;
	      var max = (1 << bpc) - 1;
	      var i, ii;
	      if (bpc === 1) {
	        for (i = 0, ii = buffer.length; i < ii; i++) {
	          buffer[i] = +!buffer[i];
	        }
	        return;
	      }
	      var index = 0;
	      for (i = 0, ii = this.width * this.height; i < ii; i++) {
	        for (var j = 0; j < numComps; j++) {
	          buffer[index] = decodeAndClamp(buffer[index], decodeAddends[j], decodeCoefficients[j], max);
	          index++;
	        }
	      }
	    },
	    getComponents: function PDFImage_getComponents(buffer) {
	      var bpc = this.bpc;
	      if (bpc === 8) {
	        return buffer;
	      }
	      var width = this.width;
	      var height = this.height;
	      var numComps = this.numComps;
	      var length = width * height * numComps;
	      var bufferPos = 0;
	      var output = bpc <= 8 ? new Uint8Array(length) : bpc <= 16 ? new Uint16Array(length) : new Uint32Array(length);
	      var rowComps = width * numComps;
	      var max = (1 << bpc) - 1;
	      var i = 0,
	          ii,
	          buf;
	      if (bpc === 1) {
	        var mask, loop1End, loop2End;
	        for (var j = 0; j < height; j++) {
	          loop1End = i + (rowComps & ~7);
	          loop2End = i + rowComps;
	          while (i < loop1End) {
	            buf = buffer[bufferPos++];
	            output[i] = buf >> 7 & 1;
	            output[i + 1] = buf >> 6 & 1;
	            output[i + 2] = buf >> 5 & 1;
	            output[i + 3] = buf >> 4 & 1;
	            output[i + 4] = buf >> 3 & 1;
	            output[i + 5] = buf >> 2 & 1;
	            output[i + 6] = buf >> 1 & 1;
	            output[i + 7] = buf & 1;
	            i += 8;
	          }
	          if (i < loop2End) {
	            buf = buffer[bufferPos++];
	            mask = 128;
	            while (i < loop2End) {
	              output[i++] = +!!(buf & mask);
	              mask >>= 1;
	            }
	          }
	        }
	      } else {
	        var bits = 0;
	        buf = 0;
	        for (i = 0, ii = length; i < ii; ++i) {
	          if (i % rowComps === 0) {
	            buf = 0;
	            bits = 0;
	          }
	          while (bits < bpc) {
	            buf = buf << 8 | buffer[bufferPos++];
	            bits += 8;
	          }
	          var remainingBits = bits - bpc;
	          var value = buf >> remainingBits;
	          output[i] = value < 0 ? 0 : value > max ? max : value;
	          buf = buf & (1 << remainingBits) - 1;
	          bits = remainingBits;
	        }
	      }
	      return output;
	    },
	    fillOpacity: function PDFImage_fillOpacity(rgbaBuf, width, height, actualHeight, image) {
	      var smask = this.smask;
	      var mask = this.mask;
	      var alphaBuf, sw, sh, i, ii, j;
	      if (smask) {
	        sw = smask.width;
	        sh = smask.height;
	        alphaBuf = new Uint8Array(sw * sh);
	        smask.fillGrayBuffer(alphaBuf);
	        if (sw !== width || sh !== height) {
	          alphaBuf = resizeImageMask(alphaBuf, smask.bpc, sw, sh, width, height);
	        }
	      } else if (mask) {
	        if (mask instanceof PDFImage) {
	          sw = mask.width;
	          sh = mask.height;
	          alphaBuf = new Uint8Array(sw * sh);
	          mask.numComps = 1;
	          mask.fillGrayBuffer(alphaBuf);
	          for (i = 0, ii = sw * sh; i < ii; ++i) {
	            alphaBuf[i] = 255 - alphaBuf[i];
	          }
	          if (sw !== width || sh !== height) {
	            alphaBuf = resizeImageMask(alphaBuf, mask.bpc, sw, sh, width, height);
	          }
	        } else if (isArray(mask)) {
	          alphaBuf = new Uint8Array(width * height);
	          var numComps = this.numComps;
	          for (i = 0, ii = width * height; i < ii; ++i) {
	            var opacity = 0;
	            var imageOffset = i * numComps;
	            for (j = 0; j < numComps; ++j) {
	              var color = image[imageOffset + j];
	              var maskOffset = j * 2;
	              if (color < mask[maskOffset] || color > mask[maskOffset + 1]) {
	                opacity = 255;
	                break;
	              }
	            }
	            alphaBuf[i] = opacity;
	          }
	        } else {
	          error('Unknown mask format.');
	        }
	      }
	      if (alphaBuf) {
	        for (i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4) {
	          rgbaBuf[j] = alphaBuf[i];
	        }
	      } else {
	        for (i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4) {
	          rgbaBuf[j] = 255;
	        }
	      }
	    },
	    undoPreblend: function PDFImage_undoPreblend(buffer, width, height) {
	      var matte = this.smask && this.smask.matte;
	      if (!matte) {
	        return;
	      }
	      var matteRgb = this.colorSpace.getRgb(matte, 0);
	      var matteR = matteRgb[0];
	      var matteG = matteRgb[1];
	      var matteB = matteRgb[2];
	      var length = width * height * 4;
	      var r, g, b;
	      for (var i = 0; i < length; i += 4) {
	        var alpha = buffer[i + 3];
	        if (alpha === 0) {
	          buffer[i] = 255;
	          buffer[i + 1] = 255;
	          buffer[i + 2] = 255;
	          continue;
	        }
	        var k = 255 / alpha;
	        r = (buffer[i] - matteR) * k + matteR;
	        g = (buffer[i + 1] - matteG) * k + matteG;
	        b = (buffer[i + 2] - matteB) * k + matteB;
	        buffer[i] = r <= 0 ? 0 : r >= 255 ? 255 : r | 0;
	        buffer[i + 1] = g <= 0 ? 0 : g >= 255 ? 255 : g | 0;
	        buffer[i + 2] = b <= 0 ? 0 : b >= 255 ? 255 : b | 0;
	      }
	    },
	    createImageData: function PDFImage_createImageData(forceRGBA) {
	      var drawWidth = this.drawWidth;
	      var drawHeight = this.drawHeight;
	      var imgData = {
	        width: drawWidth,
	        height: drawHeight
	      };
	      var numComps = this.numComps;
	      var originalWidth = this.width;
	      var originalHeight = this.height;
	      var bpc = this.bpc;
	      var rowBytes = originalWidth * numComps * bpc + 7 >> 3;
	      var imgArray;
	      if (!forceRGBA) {
	        var kind;
	        if (this.colorSpace.name === 'DeviceGray' && bpc === 1) {
	          kind = ImageKind.GRAYSCALE_1BPP;
	        } else if (this.colorSpace.name === 'DeviceRGB' && bpc === 8 && !this.needsDecode) {
	          kind = ImageKind.RGB_24BPP;
	        }
	        if (kind && !this.smask && !this.mask && drawWidth === originalWidth && drawHeight === originalHeight) {
	          imgData.kind = kind;
	          imgArray = this.getImageBytes(originalHeight * rowBytes);
	          if (this.image instanceof DecodeStream) {
	            imgData.data = imgArray;
	          } else {
	            var newArray = new Uint8Array(imgArray.length);
	            newArray.set(imgArray);
	            imgData.data = newArray;
	          }
	          if (this.needsDecode) {
	            assert(kind === ImageKind.GRAYSCALE_1BPP);
	            var buffer = imgData.data;
	            for (var i = 0, ii = buffer.length; i < ii; i++) {
	              buffer[i] ^= 0xff;
	            }
	          }
	          return imgData;
	        }
	        if (this.image instanceof JpegStream && !this.smask && !this.mask && (this.colorSpace.name === 'DeviceGray' || this.colorSpace.name === 'DeviceRGB' || this.colorSpace.name === 'DeviceCMYK')) {
	          imgData.kind = ImageKind.RGB_24BPP;
	          imgData.data = this.getImageBytes(originalHeight * rowBytes, drawWidth, drawHeight, true);
	          return imgData;
	        }
	      }
	      imgArray = this.getImageBytes(originalHeight * rowBytes);
	      var actualHeight = 0 | imgArray.length / rowBytes * drawHeight / originalHeight;
	      var comps = this.getComponents(imgArray);
	      var alpha01, maybeUndoPreblend;
	      if (!forceRGBA && !this.smask && !this.mask) {
	        imgData.kind = ImageKind.RGB_24BPP;
	        imgData.data = new Uint8Array(drawWidth * drawHeight * 3);
	        alpha01 = 0;
	        maybeUndoPreblend = false;
	      } else {
	        imgData.kind = ImageKind.RGBA_32BPP;
	        imgData.data = new Uint8Array(drawWidth * drawHeight * 4);
	        alpha01 = 1;
	        maybeUndoPreblend = true;
	        this.fillOpacity(imgData.data, drawWidth, drawHeight, actualHeight, comps);
	      }
	      if (this.needsDecode) {
	        this.decodeBuffer(comps);
	      }
	      this.colorSpace.fillRgb(imgData.data, originalWidth, originalHeight, drawWidth, drawHeight, actualHeight, bpc, comps, alpha01);
	      if (maybeUndoPreblend) {
	        this.undoPreblend(imgData.data, drawWidth, actualHeight);
	      }
	      return imgData;
	    },
	    fillGrayBuffer: function PDFImage_fillGrayBuffer(buffer) {
	      var numComps = this.numComps;
	      if (numComps !== 1) {
	        error('Reading gray scale from a color image: ' + numComps);
	      }
	      var width = this.width;
	      var height = this.height;
	      var bpc = this.bpc;
	      var rowBytes = width * numComps * bpc + 7 >> 3;
	      var imgArray = this.getImageBytes(height * rowBytes);
	      var comps = this.getComponents(imgArray);
	      var i, length;
	      if (bpc === 1) {
	        length = width * height;
	        if (this.needsDecode) {
	          for (i = 0; i < length; ++i) {
	            buffer[i] = comps[i] - 1 & 255;
	          }
	        } else {
	          for (i = 0; i < length; ++i) {
	            buffer[i] = -comps[i] & 255;
	          }
	        }
	        return;
	      }
	      if (this.needsDecode) {
	        this.decodeBuffer(comps);
	      }
	      length = width * height;
	      var scale = 255 / ((1 << bpc) - 1);
	      for (i = 0; i < length; ++i) {
	        buffer[i] = scale * comps[i] | 0;
	      }
	    },
	    getImageBytes: function PDFImage_getImageBytes(length, drawWidth, drawHeight, forceRGB) {
	      this.image.reset();
	      this.image.drawWidth = drawWidth || this.width;
	      this.image.drawHeight = drawHeight || this.height;
	      this.image.forceRGB = !!forceRGB;
	      return this.image.getBytes(length);
	    }
	  };
	  return PDFImage;
	}();
	exports.PDFImage = PDFImage;
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var coreArithmeticDecoder = __w_pdfjs_require__(10);
	var error = sharedUtil.error;
	var log2 = sharedUtil.log2;
	var readInt8 = sharedUtil.readInt8;
	var readUint16 = sharedUtil.readUint16;
	var readUint32 = sharedUtil.readUint32;
	var shadow = sharedUtil.shadow;
	var ArithmeticDecoder = coreArithmeticDecoder.ArithmeticDecoder;
	var Jbig2Image = function Jbig2ImageClosure() {
	  function ContextCache() {}
	  ContextCache.prototype = {
	    getContexts: function getContexts(id) {
	      if (id in this) {
	        return this[id];
	      }
	      return this[id] = new Int8Array(1 << 16);
	    }
	  };
	  function DecodingContext(data, start, end) {
	    this.data = data;
	    this.start = start;
	    this.end = end;
	  }
	  DecodingContext.prototype = {
	    get decoder() {
	      var decoder = new ArithmeticDecoder(this.data, this.start, this.end);
	      return shadow(this, 'decoder', decoder);
	    },
	    get contextCache() {
	      var cache = new ContextCache();
	      return shadow(this, 'contextCache', cache);
	    }
	  };
	  function decodeInteger(contextCache, procedure, decoder) {
	    var contexts = contextCache.getContexts(procedure);
	    var prev = 1;
	    function readBits(length) {
	      var v = 0;
	      for (var i = 0; i < length; i++) {
	        var bit = decoder.readBit(contexts, prev);
	        prev = prev < 256 ? prev << 1 | bit : (prev << 1 | bit) & 511 | 256;
	        v = v << 1 | bit;
	      }
	      return v >>> 0;
	    }
	    var sign = readBits(1);
	    var value = readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(32) + 4436 : readBits(12) + 340 : readBits(8) + 84 : readBits(6) + 20 : readBits(4) + 4 : readBits(2);
	    return sign === 0 ? value : value > 0 ? -value : null;
	  }
	  function decodeIAID(contextCache, decoder, codeLength) {
	    var contexts = contextCache.getContexts('IAID');
	    var prev = 1;
	    for (var i = 0; i < codeLength; i++) {
	      var bit = decoder.readBit(contexts, prev);
	      prev = prev << 1 | bit;
	    }
	    if (codeLength < 31) {
	      return prev & (1 << codeLength) - 1;
	    }
	    return prev & 0x7FFFFFFF;
	  }
	  var SegmentTypes = ['SymbolDictionary', null, null, null, 'IntermediateTextRegion', null, 'ImmediateTextRegion', 'ImmediateLosslessTextRegion', null, null, null, null, null, null, null, null, 'patternDictionary', null, null, null, 'IntermediateHalftoneRegion', null, 'ImmediateHalftoneRegion', 'ImmediateLosslessHalftoneRegion', null, null, null, null, null, null, null, null, null, null, null, null, 'IntermediateGenericRegion', null, 'ImmediateGenericRegion', 'ImmediateLosslessGenericRegion', 'IntermediateGenericRefinementRegion', null, 'ImmediateGenericRefinementRegion', 'ImmediateLosslessGenericRefinementRegion', null, null, null, null, 'PageInformation', 'EndOfPage', 'EndOfStripe', 'EndOfFile', 'Profiles', 'Tables', null, null, null, null, null, null, null, null, 'Extension'];
	  var CodingTemplates = [[{
	    x: -1,
	    y: -2
	  }, {
	    x: 0,
	    y: -2
	  }, {
	    x: 1,
	    y: -2
	  }, {
	    x: -2,
	    y: -1
	  }, {
	    x: -1,
	    y: -1
	  }, {
	    x: 0,
	    y: -1
	  }, {
	    x: 1,
	    y: -1
	  }, {
	    x: 2,
	    y: -1
	  }, {
	    x: -4,
	    y: 0
	  }, {
	    x: -3,
	    y: 0
	  }, {
	    x: -2,
	    y: 0
	  }, {
	    x: -1,
	    y: 0
	  }], [{
	    x: -1,
	    y: -2
	  }, {
	    x: 0,
	    y: -2
	  }, {
	    x: 1,
	    y: -2
	  }, {
	    x: 2,
	    y: -2
	  }, {
	    x: -2,
	    y: -1
	  }, {
	    x: -1,
	    y: -1
	  }, {
	    x: 0,
	    y: -1
	  }, {
	    x: 1,
	    y: -1
	  }, {
	    x: 2,
	    y: -1
	  }, {
	    x: -3,
	    y: 0
	  }, {
	    x: -2,
	    y: 0
	  }, {
	    x: -1,
	    y: 0
	  }], [{
	    x: -1,
	    y: -2
	  }, {
	    x: 0,
	    y: -2
	  }, {
	    x: 1,
	    y: -2
	  }, {
	    x: -2,
	    y: -1
	  }, {
	    x: -1,
	    y: -1
	  }, {
	    x: 0,
	    y: -1
	  }, {
	    x: 1,
	    y: -1
	  }, {
	    x: -2,
	    y: 0
	  }, {
	    x: -1,
	    y: 0
	  }], [{
	    x: -3,
	    y: -1
	  }, {
	    x: -2,
	    y: -1
	  }, {
	    x: -1,
	    y: -1
	  }, {
	    x: 0,
	    y: -1
	  }, {
	    x: 1,
	    y: -1
	  }, {
	    x: -4,
	    y: 0
	  }, {
	    x: -3,
	    y: 0
	  }, {
	    x: -2,
	    y: 0
	  }, {
	    x: -1,
	    y: 0
	  }]];
	  var RefinementTemplates = [{
	    coding: [{
	      x: 0,
	      y: -1
	    }, {
	      x: 1,
	      y: -1
	    }, {
	      x: -1,
	      y: 0
	    }],
	    reference: [{
	      x: 0,
	      y: -1
	    }, {
	      x: 1,
	      y: -1
	    }, {
	      x: -1,
	      y: 0
	    }, {
	      x: 0,
	      y: 0
	    }, {
	      x: 1,
	      y: 0
	    }, {
	      x: -1,
	      y: 1
	    }, {
	      x: 0,
	      y: 1
	    }, {
	      x: 1,
	      y: 1
	    }]
	  }, {
	    coding: [{
	      x: -1,
	      y: -1
	    }, {
	      x: 0,
	      y: -1
	    }, {
	      x: 1,
	      y: -1
	    }, {
	      x: -1,
	      y: 0
	    }],
	    reference: [{
	      x: 0,
	      y: -1
	    }, {
	      x: -1,
	      y: 0
	    }, {
	      x: 0,
	      y: 0
	    }, {
	      x: 1,
	      y: 0
	    }, {
	      x: 0,
	      y: 1
	    }, {
	      x: 1,
	      y: 1
	    }]
	  }];
	  var ReusedContexts = [0x9B25, 0x0795, 0x00E5, 0x0195];
	  var RefinementReusedContexts = [0x0020, 0x0008];
	  function decodeBitmapTemplate0(width, height, decodingContext) {
	    var decoder = decodingContext.decoder;
	    var contexts = decodingContext.contextCache.getContexts('GB');
	    var contextLabel,
	        i,
	        j,
	        pixel,
	        row,
	        row1,
	        row2,
	        bitmap = [];
	    var OLD_PIXEL_MASK = 0x7BF7;
	    for (i = 0; i < height; i++) {
	      row = bitmap[i] = new Uint8Array(width);
	      row1 = i < 1 ? row : bitmap[i - 1];
	      row2 = i < 2 ? row : bitmap[i - 2];
	      contextLabel = row2[0] << 13 | row2[1] << 12 | row2[2] << 11 | row1[0] << 7 | row1[1] << 6 | row1[2] << 5 | row1[3] << 4;
	      for (j = 0; j < width; j++) {
	        row[j] = pixel = decoder.readBit(contexts, contextLabel);
	        contextLabel = (contextLabel & OLD_PIXEL_MASK) << 1 | (j + 3 < width ? row2[j + 3] << 11 : 0) | (j + 4 < width ? row1[j + 4] << 4 : 0) | pixel;
	      }
	    }
	    return bitmap;
	  }
	  function decodeBitmap(mmr, width, height, templateIndex, prediction, skip, at, decodingContext) {
	    if (mmr) {
	      error('JBIG2 error: MMR encoding is not supported');
	    }
	    if (templateIndex === 0 && !skip && !prediction && at.length === 4 && at[0].x === 3 && at[0].y === -1 && at[1].x === -3 && at[1].y === -1 && at[2].x === 2 && at[2].y === -2 && at[3].x === -2 && at[3].y === -2) {
	      return decodeBitmapTemplate0(width, height, decodingContext);
	    }
	    var useskip = !!skip;
	    var template = CodingTemplates[templateIndex].concat(at);
	    template.sort(function (a, b) {
	      return a.y - b.y || a.x - b.x;
	    });
	    var templateLength = template.length;
	    var templateX = new Int8Array(templateLength);
	    var templateY = new Int8Array(templateLength);
	    var changingTemplateEntries = [];
	    var reuseMask = 0,
	        minX = 0,
	        maxX = 0,
	        minY = 0;
	    var c, k;
	    for (k = 0; k < templateLength; k++) {
	      templateX[k] = template[k].x;
	      templateY[k] = template[k].y;
	      minX = Math.min(minX, template[k].x);
	      maxX = Math.max(maxX, template[k].x);
	      minY = Math.min(minY, template[k].y);
	      if (k < templateLength - 1 && template[k].y === template[k + 1].y && template[k].x === template[k + 1].x - 1) {
	        reuseMask |= 1 << templateLength - 1 - k;
	      } else {
	        changingTemplateEntries.push(k);
	      }
	    }
	    var changingEntriesLength = changingTemplateEntries.length;
	    var changingTemplateX = new Int8Array(changingEntriesLength);
	    var changingTemplateY = new Int8Array(changingEntriesLength);
	    var changingTemplateBit = new Uint16Array(changingEntriesLength);
	    for (c = 0; c < changingEntriesLength; c++) {
	      k = changingTemplateEntries[c];
	      changingTemplateX[c] = template[k].x;
	      changingTemplateY[c] = template[k].y;
	      changingTemplateBit[c] = 1 << templateLength - 1 - k;
	    }
	    var sbb_left = -minX;
	    var sbb_top = -minY;
	    var sbb_right = width - maxX;
	    var pseudoPixelContext = ReusedContexts[templateIndex];
	    var row = new Uint8Array(width);
	    var bitmap = [];
	    var decoder = decodingContext.decoder;
	    var contexts = decodingContext.contextCache.getContexts('GB');
	    var ltp = 0,
	        j,
	        i0,
	        j0,
	        contextLabel = 0,
	        bit,
	        shift;
	    for (var i = 0; i < height; i++) {
	      if (prediction) {
	        var sltp = decoder.readBit(contexts, pseudoPixelContext);
	        ltp ^= sltp;
	        if (ltp) {
	          bitmap.push(row);
	          continue;
	        }
	      }
	      row = new Uint8Array(row);
	      bitmap.push(row);
	      for (j = 0; j < width; j++) {
	        if (useskip && skip[i][j]) {
	          row[j] = 0;
	          continue;
	        }
	        if (j >= sbb_left && j < sbb_right && i >= sbb_top) {
	          contextLabel = contextLabel << 1 & reuseMask;
	          for (k = 0; k < changingEntriesLength; k++) {
	            i0 = i + changingTemplateY[k];
	            j0 = j + changingTemplateX[k];
	            bit = bitmap[i0][j0];
	            if (bit) {
	              bit = changingTemplateBit[k];
	              contextLabel |= bit;
	            }
	          }
	        } else {
	          contextLabel = 0;
	          shift = templateLength - 1;
	          for (k = 0; k < templateLength; k++, shift--) {
	            j0 = j + templateX[k];
	            if (j0 >= 0 && j0 < width) {
	              i0 = i + templateY[k];
	              if (i0 >= 0) {
	                bit = bitmap[i0][j0];
	                if (bit) {
	                  contextLabel |= bit << shift;
	                }
	              }
	            }
	          }
	        }
	        var pixel = decoder.readBit(contexts, contextLabel);
	        row[j] = pixel;
	      }
	    }
	    return bitmap;
	  }
	  function decodeRefinement(width, height, templateIndex, referenceBitmap, offsetX, offsetY, prediction, at, decodingContext) {
	    var codingTemplate = RefinementTemplates[templateIndex].coding;
	    if (templateIndex === 0) {
	      codingTemplate = codingTemplate.concat([at[0]]);
	    }
	    var codingTemplateLength = codingTemplate.length;
	    var codingTemplateX = new Int32Array(codingTemplateLength);
	    var codingTemplateY = new Int32Array(codingTemplateLength);
	    var k;
	    for (k = 0; k < codingTemplateLength; k++) {
	      codingTemplateX[k] = codingTemplate[k].x;
	      codingTemplateY[k] = codingTemplate[k].y;
	    }
	    var referenceTemplate = RefinementTemplates[templateIndex].reference;
	    if (templateIndex === 0) {
	      referenceTemplate = referenceTemplate.concat([at[1]]);
	    }
	    var referenceTemplateLength = referenceTemplate.length;
	    var referenceTemplateX = new Int32Array(referenceTemplateLength);
	    var referenceTemplateY = new Int32Array(referenceTemplateLength);
	    for (k = 0; k < referenceTemplateLength; k++) {
	      referenceTemplateX[k] = referenceTemplate[k].x;
	      referenceTemplateY[k] = referenceTemplate[k].y;
	    }
	    var referenceWidth = referenceBitmap[0].length;
	    var referenceHeight = referenceBitmap.length;
	    var pseudoPixelContext = RefinementReusedContexts[templateIndex];
	    var bitmap = [];
	    var decoder = decodingContext.decoder;
	    var contexts = decodingContext.contextCache.getContexts('GR');
	    var ltp = 0;
	    for (var i = 0; i < height; i++) {
	      if (prediction) {
	        var sltp = decoder.readBit(contexts, pseudoPixelContext);
	        ltp ^= sltp;
	        if (ltp) {
	          error('JBIG2 error: prediction is not supported');
	        }
	      }
	      var row = new Uint8Array(width);
	      bitmap.push(row);
	      for (var j = 0; j < width; j++) {
	        var i0, j0;
	        var contextLabel = 0;
	        for (k = 0; k < codingTemplateLength; k++) {
	          i0 = i + codingTemplateY[k];
	          j0 = j + codingTemplateX[k];
	          if (i0 < 0 || j0 < 0 || j0 >= width) {
	            contextLabel <<= 1;
	          } else {
	            contextLabel = contextLabel << 1 | bitmap[i0][j0];
	          }
	        }
	        for (k = 0; k < referenceTemplateLength; k++) {
	          i0 = i + referenceTemplateY[k] - offsetY;
	          j0 = j + referenceTemplateX[k] - offsetX;
	          if (i0 < 0 || i0 >= referenceHeight || j0 < 0 || j0 >= referenceWidth) {
	            contextLabel <<= 1;
	          } else {
	            contextLabel = contextLabel << 1 | referenceBitmap[i0][j0];
	          }
	        }
	        var pixel = decoder.readBit(contexts, contextLabel);
	        row[j] = pixel;
	      }
	    }
	    return bitmap;
	  }
	  function decodeSymbolDictionary(huffman, refinement, symbols, numberOfNewSymbols, numberOfExportedSymbols, huffmanTables, templateIndex, at, refinementTemplateIndex, refinementAt, decodingContext) {
	    if (huffman) {
	      error('JBIG2 error: huffman is not supported');
	    }
	    var newSymbols = [];
	    var currentHeight = 0;
	    var symbolCodeLength = log2(symbols.length + numberOfNewSymbols);
	    var decoder = decodingContext.decoder;
	    var contextCache = decodingContext.contextCache;
	    while (newSymbols.length < numberOfNewSymbols) {
	      var deltaHeight = decodeInteger(contextCache, 'IADH', decoder);
	      currentHeight += deltaHeight;
	      var currentWidth = 0;
	      while (true) {
	        var deltaWidth = decodeInteger(contextCache, 'IADW', decoder);
	        if (deltaWidth === null) {
	          break;
	        }
	        currentWidth += deltaWidth;
	        var bitmap;
	        if (refinement) {
	          var numberOfInstances = decodeInteger(contextCache, 'IAAI', decoder);
	          if (numberOfInstances > 1) {
	            bitmap = decodeTextRegion(huffman, refinement, currentWidth, currentHeight, 0, numberOfInstances, 1, symbols.concat(newSymbols), symbolCodeLength, 0, 0, 1, 0, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext);
	          } else {
	            var symbolId = decodeIAID(contextCache, decoder, symbolCodeLength);
	            var rdx = decodeInteger(contextCache, 'IARDX', decoder);
	            var rdy = decodeInteger(contextCache, 'IARDY', decoder);
	            var symbol = symbolId < symbols.length ? symbols[symbolId] : newSymbols[symbolId - symbols.length];
	            bitmap = decodeRefinement(currentWidth, currentHeight, refinementTemplateIndex, symbol, rdx, rdy, false, refinementAt, decodingContext);
	          }
	        } else {
	          bitmap = decodeBitmap(false, currentWidth, currentHeight, templateIndex, false, null, at, decodingContext);
	        }
	        newSymbols.push(bitmap);
	      }
	    }
	    var exportedSymbols = [];
	    var flags = [],
	        currentFlag = false;
	    var totalSymbolsLength = symbols.length + numberOfNewSymbols;
	    while (flags.length < totalSymbolsLength) {
	      var runLength = decodeInteger(contextCache, 'IAEX', decoder);
	      while (runLength--) {
	        flags.push(currentFlag);
	      }
	      currentFlag = !currentFlag;
	    }
	    for (var i = 0, ii = symbols.length; i < ii; i++) {
	      if (flags[i]) {
	        exportedSymbols.push(symbols[i]);
	      }
	    }
	    for (var j = 0; j < numberOfNewSymbols; i++, j++) {
	      if (flags[i]) {
	        exportedSymbols.push(newSymbols[j]);
	      }
	    }
	    return exportedSymbols;
	  }
	  function decodeTextRegion(huffman, refinement, width, height, defaultPixelValue, numberOfSymbolInstances, stripSize, inputSymbols, symbolCodeLength, transposed, dsOffset, referenceCorner, combinationOperator, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext) {
	    if (huffman) {
	      error('JBIG2 error: huffman is not supported');
	    }
	    var bitmap = [];
	    var i, row;
	    for (i = 0; i < height; i++) {
	      row = new Uint8Array(width);
	      if (defaultPixelValue) {
	        for (var j = 0; j < width; j++) {
	          row[j] = defaultPixelValue;
	        }
	      }
	      bitmap.push(row);
	    }
	    var decoder = decodingContext.decoder;
	    var contextCache = decodingContext.contextCache;
	    var stripT = -decodeInteger(contextCache, 'IADT', decoder);
	    var firstS = 0;
	    i = 0;
	    while (i < numberOfSymbolInstances) {
	      var deltaT = decodeInteger(contextCache, 'IADT', decoder);
	      stripT += deltaT;
	      var deltaFirstS = decodeInteger(contextCache, 'IAFS', decoder);
	      firstS += deltaFirstS;
	      var currentS = firstS;
	      do {
	        var currentT = stripSize === 1 ? 0 : decodeInteger(contextCache, 'IAIT', decoder);
	        var t = stripSize * stripT + currentT;
	        var symbolId = decodeIAID(contextCache, decoder, symbolCodeLength);
	        var applyRefinement = refinement && decodeInteger(contextCache, 'IARI', decoder);
	        var symbolBitmap = inputSymbols[symbolId];
	        var symbolWidth = symbolBitmap[0].length;
	        var symbolHeight = symbolBitmap.length;
	        if (applyRefinement) {
	          var rdw = decodeInteger(contextCache, 'IARDW', decoder);
	          var rdh = decodeInteger(contextCache, 'IARDH', decoder);
	          var rdx = decodeInteger(contextCache, 'IARDX', decoder);
	          var rdy = decodeInteger(contextCache, 'IARDY', decoder);
	          symbolWidth += rdw;
	          symbolHeight += rdh;
	          symbolBitmap = decodeRefinement(symbolWidth, symbolHeight, refinementTemplateIndex, symbolBitmap, (rdw >> 1) + rdx, (rdh >> 1) + rdy, false, refinementAt, decodingContext);
	        }
	        var offsetT = t - (referenceCorner & 1 ? 0 : symbolHeight);
	        var offsetS = currentS - (referenceCorner & 2 ? symbolWidth : 0);
	        var s2, t2, symbolRow;
	        if (transposed) {
	          for (s2 = 0; s2 < symbolHeight; s2++) {
	            row = bitmap[offsetS + s2];
	            if (!row) {
	              continue;
	            }
	            symbolRow = symbolBitmap[s2];
	            var maxWidth = Math.min(width - offsetT, symbolWidth);
	            switch (combinationOperator) {
	              case 0:
	                for (t2 = 0; t2 < maxWidth; t2++) {
	                  row[offsetT + t2] |= symbolRow[t2];
	                }
	                break;
	              case 2:
	                for (t2 = 0; t2 < maxWidth; t2++) {
	                  row[offsetT + t2] ^= symbolRow[t2];
	                }
	                break;
	              default:
	                error('JBIG2 error: operator ' + combinationOperator + ' is not supported');
	            }
	          }
	          currentS += symbolHeight - 1;
	        } else {
	          for (t2 = 0; t2 < symbolHeight; t2++) {
	            row = bitmap[offsetT + t2];
	            if (!row) {
	              continue;
	            }
	            symbolRow = symbolBitmap[t2];
	            switch (combinationOperator) {
	              case 0:
	                for (s2 = 0; s2 < symbolWidth; s2++) {
	                  row[offsetS + s2] |= symbolRow[s2];
	                }
	                break;
	              case 2:
	                for (s2 = 0; s2 < symbolWidth; s2++) {
	                  row[offsetS + s2] ^= symbolRow[s2];
	                }
	                break;
	              default:
	                error('JBIG2 error: operator ' + combinationOperator + ' is not supported');
	            }
	          }
	          currentS += symbolWidth - 1;
	        }
	        i++;
	        var deltaS = decodeInteger(contextCache, 'IADS', decoder);
	        if (deltaS === null) {
	          break;
	        }
	        currentS += deltaS + dsOffset;
	      } while (true);
	    }
	    return bitmap;
	  }
	  function readSegmentHeader(data, start) {
	    var segmentHeader = {};
	    segmentHeader.number = readUint32(data, start);
	    var flags = data[start + 4];
	    var segmentType = flags & 0x3F;
	    if (!SegmentTypes[segmentType]) {
	      error('JBIG2 error: invalid segment type: ' + segmentType);
	    }
	    segmentHeader.type = segmentType;
	    segmentHeader.typeName = SegmentTypes[segmentType];
	    segmentHeader.deferredNonRetain = !!(flags & 0x80);
	    var pageAssociationFieldSize = !!(flags & 0x40);
	    var referredFlags = data[start + 5];
	    var referredToCount = referredFlags >> 5 & 7;
	    var retainBits = [referredFlags & 31];
	    var position = start + 6;
	    if (referredFlags === 7) {
	      referredToCount = readUint32(data, position - 1) & 0x1FFFFFFF;
	      position += 3;
	      var bytes = referredToCount + 7 >> 3;
	      retainBits[0] = data[position++];
	      while (--bytes > 0) {
	        retainBits.push(data[position++]);
	      }
	    } else if (referredFlags === 5 || referredFlags === 6) {
	      error('JBIG2 error: invalid referred-to flags');
	    }
	    segmentHeader.retainBits = retainBits;
	    var referredToSegmentNumberSize = segmentHeader.number <= 256 ? 1 : segmentHeader.number <= 65536 ? 2 : 4;
	    var referredTo = [];
	    var i, ii;
	    for (i = 0; i < referredToCount; i++) {
	      var number = referredToSegmentNumberSize === 1 ? data[position] : referredToSegmentNumberSize === 2 ? readUint16(data, position) : readUint32(data, position);
	      referredTo.push(number);
	      position += referredToSegmentNumberSize;
	    }
	    segmentHeader.referredTo = referredTo;
	    if (!pageAssociationFieldSize) {
	      segmentHeader.pageAssociation = data[position++];
	    } else {
	      segmentHeader.pageAssociation = readUint32(data, position);
	      position += 4;
	    }
	    segmentHeader.length = readUint32(data, position);
	    position += 4;
	    if (segmentHeader.length === 0xFFFFFFFF) {
	      if (segmentType === 38) {
	        var genericRegionInfo = readRegionSegmentInformation(data, position);
	        var genericRegionSegmentFlags = data[position + RegionSegmentInformationFieldLength];
	        var genericRegionMmr = !!(genericRegionSegmentFlags & 1);
	        var searchPatternLength = 6;
	        var searchPattern = new Uint8Array(searchPatternLength);
	        if (!genericRegionMmr) {
	          searchPattern[0] = 0xFF;
	          searchPattern[1] = 0xAC;
	        }
	        searchPattern[2] = genericRegionInfo.height >>> 24 & 0xFF;
	        searchPattern[3] = genericRegionInfo.height >> 16 & 0xFF;
	        searchPattern[4] = genericRegionInfo.height >> 8 & 0xFF;
	        searchPattern[5] = genericRegionInfo.height & 0xFF;
	        for (i = position, ii = data.length; i < ii; i++) {
	          var j = 0;
	          while (j < searchPatternLength && searchPattern[j] === data[i + j]) {
	            j++;
	          }
	          if (j === searchPatternLength) {
	            segmentHeader.length = i + searchPatternLength;
	            break;
	          }
	        }
	        if (segmentHeader.length === 0xFFFFFFFF) {
	          error('JBIG2 error: segment end was not found');
	        }
	      } else {
	        error('JBIG2 error: invalid unknown segment length');
	      }
	    }
	    segmentHeader.headerEnd = position;
	    return segmentHeader;
	  }
	  function readSegments(header, data, start, end) {
	    var segments = [];
	    var position = start;
	    while (position < end) {
	      var segmentHeader = readSegmentHeader(data, position);
	      position = segmentHeader.headerEnd;
	      var segment = {
	        header: segmentHeader,
	        data: data
	      };
	      if (!header.randomAccess) {
	        segment.start = position;
	        position += segmentHeader.length;
	        segment.end = position;
	      }
	      segments.push(segment);
	      if (segmentHeader.type === 51) {
	        break;
	      }
	    }
	    if (header.randomAccess) {
	      for (var i = 0, ii = segments.length; i < ii; i++) {
	        segments[i].start = position;
	        position += segments[i].header.length;
	        segments[i].end = position;
	      }
	    }
	    return segments;
	  }
	  function readRegionSegmentInformation(data, start) {
	    return {
	      width: readUint32(data, start),
	      height: readUint32(data, start + 4),
	      x: readUint32(data, start + 8),
	      y: readUint32(data, start + 12),
	      combinationOperator: data[start + 16] & 7
	    };
	  }
	  var RegionSegmentInformationFieldLength = 17;
	  function processSegment(segment, visitor) {
	    var header = segment.header;
	    var data = segment.data,
	        position = segment.start,
	        end = segment.end;
	    var args, at, i, atLength;
	    switch (header.type) {
	      case 0:
	        var dictionary = {};
	        var dictionaryFlags = readUint16(data, position);
	        dictionary.huffman = !!(dictionaryFlags & 1);
	        dictionary.refinement = !!(dictionaryFlags & 2);
	        dictionary.huffmanDHSelector = dictionaryFlags >> 2 & 3;
	        dictionary.huffmanDWSelector = dictionaryFlags >> 4 & 3;
	        dictionary.bitmapSizeSelector = dictionaryFlags >> 6 & 1;
	        dictionary.aggregationInstancesSelector = dictionaryFlags >> 7 & 1;
	        dictionary.bitmapCodingContextUsed = !!(dictionaryFlags & 256);
	        dictionary.bitmapCodingContextRetained = !!(dictionaryFlags & 512);
	        dictionary.template = dictionaryFlags >> 10 & 3;
	        dictionary.refinementTemplate = dictionaryFlags >> 12 & 1;
	        position += 2;
	        if (!dictionary.huffman) {
	          atLength = dictionary.template === 0 ? 4 : 1;
	          at = [];
	          for (i = 0; i < atLength; i++) {
	            at.push({
	              x: readInt8(data, position),
	              y: readInt8(data, position + 1)
	            });
	            position += 2;
	          }
	          dictionary.at = at;
	        }
	        if (dictionary.refinement && !dictionary.refinementTemplate) {
	          at = [];
	          for (i = 0; i < 2; i++) {
	            at.push({
	              x: readInt8(data, position),
	              y: readInt8(data, position + 1)
	            });
	            position += 2;
	          }
	          dictionary.refinementAt = at;
	        }
	        dictionary.numberOfExportedSymbols = readUint32(data, position);
	        position += 4;
	        dictionary.numberOfNewSymbols = readUint32(data, position);
	        position += 4;
	        args = [dictionary, header.number, header.referredTo, data, position, end];
	        break;
	      case 6:
	      case 7:
	        var textRegion = {};
	        textRegion.info = readRegionSegmentInformation(data, position);
	        position += RegionSegmentInformationFieldLength;
	        var textRegionSegmentFlags = readUint16(data, position);
	        position += 2;
	        textRegion.huffman = !!(textRegionSegmentFlags & 1);
	        textRegion.refinement = !!(textRegionSegmentFlags & 2);
	        textRegion.stripSize = 1 << (textRegionSegmentFlags >> 2 & 3);
	        textRegion.referenceCorner = textRegionSegmentFlags >> 4 & 3;
	        textRegion.transposed = !!(textRegionSegmentFlags & 64);
	        textRegion.combinationOperator = textRegionSegmentFlags >> 7 & 3;
	        textRegion.defaultPixelValue = textRegionSegmentFlags >> 9 & 1;
	        textRegion.dsOffset = textRegionSegmentFlags << 17 >> 27;
	        textRegion.refinementTemplate = textRegionSegmentFlags >> 15 & 1;
	        if (textRegion.huffman) {
	          var textRegionHuffmanFlags = readUint16(data, position);
	          position += 2;
	          textRegion.huffmanFS = textRegionHuffmanFlags & 3;
	          textRegion.huffmanDS = textRegionHuffmanFlags >> 2 & 3;
	          textRegion.huffmanDT = textRegionHuffmanFlags >> 4 & 3;
	          textRegion.huffmanRefinementDW = textRegionHuffmanFlags >> 6 & 3;
	          textRegion.huffmanRefinementDH = textRegionHuffmanFlags >> 8 & 3;
	          textRegion.huffmanRefinementDX = textRegionHuffmanFlags >> 10 & 3;
	          textRegion.huffmanRefinementDY = textRegionHuffmanFlags >> 12 & 3;
	          textRegion.huffmanRefinementSizeSelector = !!(textRegionHuffmanFlags & 14);
	        }
	        if (textRegion.refinement && !textRegion.refinementTemplate) {
	          at = [];
	          for (i = 0; i < 2; i++) {
	            at.push({
	              x: readInt8(data, position),
	              y: readInt8(data, position + 1)
	            });
	            position += 2;
	          }
	          textRegion.refinementAt = at;
	        }
	        textRegion.numberOfSymbolInstances = readUint32(data, position);
	        position += 4;
	        if (textRegion.huffman) {
	          error('JBIG2 error: huffman is not supported');
	        }
	        args = [textRegion, header.referredTo, data, position, end];
	        break;
	      case 38:
	      case 39:
	        var genericRegion = {};
	        genericRegion.info = readRegionSegmentInformation(data, position);
	        position += RegionSegmentInformationFieldLength;
	        var genericRegionSegmentFlags = data[position++];
	        genericRegion.mmr = !!(genericRegionSegmentFlags & 1);
	        genericRegion.template = genericRegionSegmentFlags >> 1 & 3;
	        genericRegion.prediction = !!(genericRegionSegmentFlags & 8);
	        if (!genericRegion.mmr) {
	          atLength = genericRegion.template === 0 ? 4 : 1;
	          at = [];
	          for (i = 0; i < atLength; i++) {
	            at.push({
	              x: readInt8(data, position),
	              y: readInt8(data, position + 1)
	            });
	            position += 2;
	          }
	          genericRegion.at = at;
	        }
	        args = [genericRegion, data, position, end];
	        break;
	      case 48:
	        var pageInfo = {
	          width: readUint32(data, position),
	          height: readUint32(data, position + 4),
	          resolutionX: readUint32(data, position + 8),
	          resolutionY: readUint32(data, position + 12)
	        };
	        if (pageInfo.height === 0xFFFFFFFF) {
	          delete pageInfo.height;
	        }
	        var pageSegmentFlags = data[position + 16];
	        readUint16(data, position + 17);
	        pageInfo.lossless = !!(pageSegmentFlags & 1);
	        pageInfo.refinement = !!(pageSegmentFlags & 2);
	        pageInfo.defaultPixelValue = pageSegmentFlags >> 2 & 1;
	        pageInfo.combinationOperator = pageSegmentFlags >> 3 & 3;
	        pageInfo.requiresBuffer = !!(pageSegmentFlags & 32);
	        pageInfo.combinationOperatorOverride = !!(pageSegmentFlags & 64);
	        args = [pageInfo];
	        break;
	      case 49:
	        break;
	      case 50:
	        break;
	      case 51:
	        break;
	      case 62:
	        break;
	      default:
	        error('JBIG2 error: segment type ' + header.typeName + '(' + header.type + ') is not implemented');
	    }
	    var callbackName = 'on' + header.typeName;
	    if (callbackName in visitor) {
	      visitor[callbackName].apply(visitor, args);
	    }
	  }
	  function processSegments(segments, visitor) {
	    for (var i = 0, ii = segments.length; i < ii; i++) {
	      processSegment(segments[i], visitor);
	    }
	  }
	  function parseJbig2(data, start, end) {
	    var position = start;
	    if (data[position] !== 0x97 || data[position + 1] !== 0x4A || data[position + 2] !== 0x42 || data[position + 3] !== 0x32 || data[position + 4] !== 0x0D || data[position + 5] !== 0x0A || data[position + 6] !== 0x1A || data[position + 7] !== 0x0A) {
	      error('JBIG2 error: invalid header');
	    }
	    var header = {};
	    position += 8;
	    var flags = data[position++];
	    header.randomAccess = !(flags & 1);
	    if (!(flags & 2)) {
	      header.numberOfPages = readUint32(data, position);
	      position += 4;
	    }
	    readSegments(header, data, position, end);
	    error('Not implemented');
	  }
	  function parseJbig2Chunks(chunks) {
	    var visitor = new SimpleSegmentVisitor();
	    for (var i = 0, ii = chunks.length; i < ii; i++) {
	      var chunk = chunks[i];
	      var segments = readSegments({}, chunk.data, chunk.start, chunk.end);
	      processSegments(segments, visitor);
	    }
	    return visitor.buffer;
	  }
	  function SimpleSegmentVisitor() {}
	  SimpleSegmentVisitor.prototype = {
	    onPageInformation: function SimpleSegmentVisitor_onPageInformation(info) {
	      this.currentPageInfo = info;
	      var rowSize = info.width + 7 >> 3;
	      var buffer = new Uint8Array(rowSize * info.height);
	      if (info.defaultPixelValue) {
	        for (var i = 0, ii = buffer.length; i < ii; i++) {
	          buffer[i] = 0xFF;
	        }
	      }
	      this.buffer = buffer;
	    },
	    drawBitmap: function SimpleSegmentVisitor_drawBitmap(regionInfo, bitmap) {
	      var pageInfo = this.currentPageInfo;
	      var width = regionInfo.width,
	          height = regionInfo.height;
	      var rowSize = pageInfo.width + 7 >> 3;
	      var combinationOperator = pageInfo.combinationOperatorOverride ? regionInfo.combinationOperator : pageInfo.combinationOperator;
	      var buffer = this.buffer;
	      var mask0 = 128 >> (regionInfo.x & 7);
	      var offset0 = regionInfo.y * rowSize + (regionInfo.x >> 3);
	      var i, j, mask, offset;
	      switch (combinationOperator) {
	        case 0:
	          for (i = 0; i < height; i++) {
	            mask = mask0;
	            offset = offset0;
	            for (j = 0; j < width; j++) {
	              if (bitmap[i][j]) {
	                buffer[offset] |= mask;
	              }
	              mask >>= 1;
	              if (!mask) {
	                mask = 128;
	                offset++;
	              }
	            }
	            offset0 += rowSize;
	          }
	          break;
	        case 2:
	          for (i = 0; i < height; i++) {
	            mask = mask0;
	            offset = offset0;
	            for (j = 0; j < width; j++) {
	              if (bitmap[i][j]) {
	                buffer[offset] ^= mask;
	              }
	              mask >>= 1;
	              if (!mask) {
	                mask = 128;
	                offset++;
	              }
	            }
	            offset0 += rowSize;
	          }
	          break;
	        default:
	          error('JBIG2 error: operator ' + combinationOperator + ' is not supported');
	      }
	    },
	    onImmediateGenericRegion: function SimpleSegmentVisitor_onImmediateGenericRegion(region, data, start, end) {
	      var regionInfo = region.info;
	      var decodingContext = new DecodingContext(data, start, end);
	      var bitmap = decodeBitmap(region.mmr, regionInfo.width, regionInfo.height, region.template, region.prediction, null, region.at, decodingContext);
	      this.drawBitmap(regionInfo, bitmap);
	    },
	    onImmediateLosslessGenericRegion: function SimpleSegmentVisitor_onImmediateLosslessGenericRegion() {
	      this.onImmediateGenericRegion.apply(this, arguments);
	    },
	    onSymbolDictionary: function SimpleSegmentVisitor_onSymbolDictionary(dictionary, currentSegment, referredSegments, data, start, end) {
	      var huffmanTables;
	      if (dictionary.huffman) {
	        error('JBIG2 error: huffman is not supported');
	      }
	      var symbols = this.symbols;
	      if (!symbols) {
	        this.symbols = symbols = {};
	      }
	      var inputSymbols = [];
	      for (var i = 0, ii = referredSegments.length; i < ii; i++) {
	        inputSymbols = inputSymbols.concat(symbols[referredSegments[i]]);
	      }
	      var decodingContext = new DecodingContext(data, start, end);
	      symbols[currentSegment] = decodeSymbolDictionary(dictionary.huffman, dictionary.refinement, inputSymbols, dictionary.numberOfNewSymbols, dictionary.numberOfExportedSymbols, huffmanTables, dictionary.template, dictionary.at, dictionary.refinementTemplate, dictionary.refinementAt, decodingContext);
	    },
	    onImmediateTextRegion: function SimpleSegmentVisitor_onImmediateTextRegion(region, referredSegments, data, start, end) {
	      var regionInfo = region.info;
	      var huffmanTables;
	      var symbols = this.symbols;
	      var inputSymbols = [];
	      for (var i = 0, ii = referredSegments.length; i < ii; i++) {
	        inputSymbols = inputSymbols.concat(symbols[referredSegments[i]]);
	      }
	      var symbolCodeLength = log2(inputSymbols.length);
	      var decodingContext = new DecodingContext(data, start, end);
	      var bitmap = decodeTextRegion(region.huffman, region.refinement, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.numberOfSymbolInstances, region.stripSize, inputSymbols, symbolCodeLength, region.transposed, region.dsOffset, region.referenceCorner, region.combinationOperator, huffmanTables, region.refinementTemplate, region.refinementAt, decodingContext);
	      this.drawBitmap(regionInfo, bitmap);
	    },
	    onImmediateLosslessTextRegion: function SimpleSegmentVisitor_onImmediateLosslessTextRegion() {
	      this.onImmediateTextRegion.apply(this, arguments);
	    }
	  };
	  function Jbig2Image() {}
	  Jbig2Image.prototype = {
	    parseChunks: function Jbig2Image_parseChunks(chunks) {
	      return parseJbig2Chunks(chunks);
	    }
	  };
	  return Jbig2Image;
	}();
	exports.Jbig2Image = Jbig2Image;
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var sharedUtil = __w_pdfjs_require__(0);
	var warn = sharedUtil.warn;
	var error = sharedUtil.error;
	var JpegImage = function JpegImageClosure() {
	  var dctZigZag = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]);
	  var dctCos1 = 4017;
	  var dctSin1 = 799;
	  var dctCos3 = 3406;
	  var dctSin3 = 2276;
	  var dctCos6 = 1567;
	  var dctSin6 = 3784;
	  var dctSqrt2 = 5793;
	  var dctSqrt1d2 = 2896;
	  function JpegImage() {
	    this.decodeTransform = null;
	    this.colorTransform = -1;
	  }
	  function buildHuffmanTable(codeLengths, values) {
	    var k = 0,
	        code = [],
	        i,
	        j,
	        length = 16;
	    while (length > 0 && !codeLengths[length - 1]) {
	      length--;
	    }
	    code.push({
	      children: [],
	      index: 0
	    });
	    var p = code[0],
	        q;
	    for (i = 0; i < length; i++) {
	      for (j = 0; j < codeLengths[i]; j++) {
	        p = code.pop();
	        p.children[p.index] = values[k];
	        while (p.index > 0) {
	          p = code.pop();
	        }
	        p.index++;
	        code.push(p);
	        while (code.length <= i) {
	          code.push(q = {
	            children: [],
	            index: 0
	          });
	          p.children[p.index] = q.children;
	          p = q;
	        }
	        k++;
	      }
	      if (i + 1 < length) {
	        code.push(q = {
	          children: [],
	          index: 0
	        });
	        p.children[p.index] = q.children;
	        p = q;
	      }
	    }
	    return code[0].children;
	  }
	  function getBlockBufferOffset(component, row, col) {
	    return 64 * ((component.blocksPerLine + 1) * row + col);
	  }
	  function decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successivePrev, successive) {
	    var mcusPerLine = frame.mcusPerLine;
	    var progressive = frame.progressive;
	    var startOffset = offset,
	        bitsData = 0,
	        bitsCount = 0;
	    function readBit() {
	      if (bitsCount > 0) {
	        bitsCount--;
	        return bitsData >> bitsCount & 1;
	      }
	      bitsData = data[offset++];
	      if (bitsData === 0xFF) {
	        var nextByte = data[offset++];
	        if (nextByte) {
	          error('JPEG error: unexpected marker ' + (bitsData << 8 | nextByte).toString(16));
	        }
	      }
	      bitsCount = 7;
	      return bitsData >>> 7;
	    }
	    function decodeHuffman(tree) {
	      var node = tree;
	      while (true) {
	        node = node[readBit()];
	        if (typeof node === 'number') {
	          return node;
	        }
	        if ((typeof node === 'undefined' ? 'undefined' : _typeof(node)) !== 'object') {
	          error('JPEG error: invalid huffman sequence');
	        }
	      }
	    }
	    function receive(length) {
	      var n = 0;
	      while (length > 0) {
	        n = n << 1 | readBit();
	        length--;
	      }
	      return n;
	    }
	    function receiveAndExtend(length) {
	      if (length === 1) {
	        return readBit() === 1 ? 1 : -1;
	      }
	      var n = receive(length);
	      if (n >= 1 << length - 1) {
	        return n;
	      }
	      return n + (-1 << length) + 1;
	    }
	    function decodeBaseline(component, offset) {
	      var t = decodeHuffman(component.huffmanTableDC);
	      var diff = t === 0 ? 0 : receiveAndExtend(t);
	      component.blockData[offset] = component.pred += diff;
	      var k = 1;
	      while (k < 64) {
	        var rs = decodeHuffman(component.huffmanTableAC);
	        var s = rs & 15,
	            r = rs >> 4;
	        if (s === 0) {
	          if (r < 15) {
	            break;
	          }
	          k += 16;
	          continue;
	        }
	        k += r;
	        var z = dctZigZag[k];
	        component.blockData[offset + z] = receiveAndExtend(s);
	        k++;
	      }
	    }
	    function decodeDCFirst(component, offset) {
	      var t = decodeHuffman(component.huffmanTableDC);
	      var diff = t === 0 ? 0 : receiveAndExtend(t) << successive;
	      component.blockData[offset] = component.pred += diff;
	    }
	    function decodeDCSuccessive(component, offset) {
	      component.blockData[offset] |= readBit() << successive;
	    }
	    var eobrun = 0;
	    function decodeACFirst(component, offset) {
	      if (eobrun > 0) {
	        eobrun--;
	        return;
	      }
	      var k = spectralStart,
	          e = spectralEnd;
	      while (k <= e) {
	        var rs = decodeHuffman(component.huffmanTableAC);
	        var s = rs & 15,
	            r = rs >> 4;
	        if (s === 0) {
	          if (r < 15) {
	            eobrun = receive(r) + (1 << r) - 1;
	            break;
	          }
	          k += 16;
	          continue;
	        }
	        k += r;
	        var z = dctZigZag[k];
	        component.blockData[offset + z] = receiveAndExtend(s) * (1 << successive);
	        k++;
	      }
	    }
	    var successiveACState = 0,
	        successiveACNextValue;
	    function decodeACSuccessive(component, offset) {
	      var k = spectralStart;
	      var e = spectralEnd;
	      var r = 0;
	      var s;
	      var rs;
	      while (k <= e) {
	        var z = dctZigZag[k];
	        switch (successiveACState) {
	          case 0:
	            rs = decodeHuffman(component.huffmanTableAC);
	            s = rs & 15;
	            r = rs >> 4;
	            if (s === 0) {
	              if (r < 15) {
	                eobrun = receive(r) + (1 << r);
	                successiveACState = 4;
	              } else {
	                r = 16;
	                successiveACState = 1;
	              }
	            } else {
	              if (s !== 1) {
	                error('JPEG error: invalid ACn encoding');
	              }
	              successiveACNextValue = receiveAndExtend(s);
	              successiveACState = r ? 2 : 3;
	            }
	            continue;
	          case 1:
	          case 2:
	            if (component.blockData[offset + z]) {
	              component.blockData[offset + z] += readBit() << successive;
	            } else {
	              r--;
	              if (r === 0) {
	                successiveACState = successiveACState === 2 ? 3 : 0;
	              }
	            }
	            break;
	          case 3:
	            if (component.blockData[offset + z]) {
	              component.blockData[offset + z] += readBit() << successive;
	            } else {
	              component.blockData[offset + z] = successiveACNextValue << successive;
	              successiveACState = 0;
	            }
	            break;
	          case 4:
	            if (component.blockData[offset + z]) {
	              component.blockData[offset + z] += readBit() << successive;
	            }
	            break;
	        }
	        k++;
	      }
	      if (successiveACState === 4) {
	        eobrun--;
	        if (eobrun === 0) {
	          successiveACState = 0;
	        }
	      }
	    }
	    function decodeMcu(component, decode, mcu, row, col) {
	      var mcuRow = mcu / mcusPerLine | 0;
	      var mcuCol = mcu % mcusPerLine;
	      var blockRow = mcuRow * component.v + row;
	      var blockCol = mcuCol * component.h + col;
	      var offset = getBlockBufferOffset(component, blockRow, blockCol);
	      decode(component, offset);
	    }
	    function decodeBlock(component, decode, mcu) {
	      var blockRow = mcu / component.blocksPerLine | 0;
	      var blockCol = mcu % component.blocksPerLine;
	      var offset = getBlockBufferOffset(component, blockRow, blockCol);
	      decode(component, offset);
	    }
	    var componentsLength = components.length;
	    var component, i, j, k, n;
	    var decodeFn;
	    if (progressive) {
	      if (spectralStart === 0) {
	        decodeFn = successivePrev === 0 ? decodeDCFirst : decodeDCSuccessive;
	      } else {
	        decodeFn = successivePrev === 0 ? decodeACFirst : decodeACSuccessive;
	      }
	    } else {
	      decodeFn = decodeBaseline;
	    }
	    var mcu = 0,
	        fileMarker;
	    var mcuExpected;
	    if (componentsLength === 1) {
	      mcuExpected = components[0].blocksPerLine * components[0].blocksPerColumn;
	    } else {
	      mcuExpected = mcusPerLine * frame.mcusPerColumn;
	    }
	    var h, v;
	    while (mcu < mcuExpected) {
	      var mcuToRead = resetInterval ? Math.min(mcuExpected - mcu, resetInterval) : mcuExpected;
	      for (i = 0; i < componentsLength; i++) {
	        components[i].pred = 0;
	      }
	      eobrun = 0;
	      if (componentsLength === 1) {
	        component = components[0];
	        for (n = 0; n < mcuToRead; n++) {
	          decodeBlock(component, decodeFn, mcu);
	          mcu++;
	        }
	      } else {
	        for (n = 0; n < mcuToRead; n++) {
	          for (i = 0; i < componentsLength; i++) {
	            component = components[i];
	            h = component.h;
	            v = component.v;
	            for (j = 0; j < v; j++) {
	              for (k = 0; k < h; k++) {
	                decodeMcu(component, decodeFn, mcu, j, k);
	              }
	            }
	          }
	          mcu++;
	        }
	      }
	      bitsCount = 0;
	      fileMarker = findNextFileMarker(data, offset);
	      if (fileMarker && fileMarker.invalid) {
	        warn('decodeScan - unexpected MCU data, next marker is: ' + fileMarker.invalid);
	        offset = fileMarker.offset;
	      }
	      var marker = fileMarker && fileMarker.marker;
	      if (!marker || marker <= 0xFF00) {
	        error('JPEG error: marker was not found');
	      }
	      if (marker >= 0xFFD0 && marker <= 0xFFD7) {
	        offset += 2;
	      } else {
	        break;
	      }
	    }
	    fileMarker = findNextFileMarker(data, offset);
	    if (fileMarker && fileMarker.invalid) {
	      warn('decodeScan - unexpected Scan data, next marker is: ' + fileMarker.invalid);
	      offset = fileMarker.offset;
	    }
	    return offset - startOffset;
	  }
	  function quantizeAndInverse(component, blockBufferOffset, p) {
	    var qt = component.quantizationTable,
	        blockData = component.blockData;
	    var v0, v1, v2, v3, v4, v5, v6, v7;
	    var p0, p1, p2, p3, p4, p5, p6, p7;
	    var t;
	    if (!qt) {
	      error('JPEG error: missing required Quantization Table.');
	    }
	    for (var row = 0; row < 64; row += 8) {
	      p0 = blockData[blockBufferOffset + row];
	      p1 = blockData[blockBufferOffset + row + 1];
	      p2 = blockData[blockBufferOffset + row + 2];
	      p3 = blockData[blockBufferOffset + row + 3];
	      p4 = blockData[blockBufferOffset + row + 4];
	      p5 = blockData[blockBufferOffset + row + 5];
	      p6 = blockData[blockBufferOffset + row + 6];
	      p7 = blockData[blockBufferOffset + row + 7];
	      p0 *= qt[row];
	      if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
	        t = dctSqrt2 * p0 + 512 >> 10;
	        p[row] = t;
	        p[row + 1] = t;
	        p[row + 2] = t;
	        p[row + 3] = t;
	        p[row + 4] = t;
	        p[row + 5] = t;
	        p[row + 6] = t;
	        p[row + 7] = t;
	        continue;
	      }
	      p1 *= qt[row + 1];
	      p2 *= qt[row + 2];
	      p3 *= qt[row + 3];
	      p4 *= qt[row + 4];
	      p5 *= qt[row + 5];
	      p6 *= qt[row + 6];
	      p7 *= qt[row + 7];
	      v0 = dctSqrt2 * p0 + 128 >> 8;
	      v1 = dctSqrt2 * p4 + 128 >> 8;
	      v2 = p2;
	      v3 = p6;
	      v4 = dctSqrt1d2 * (p1 - p7) + 128 >> 8;
	      v7 = dctSqrt1d2 * (p1 + p7) + 128 >> 8;
	      v5 = p3 << 4;
	      v6 = p5 << 4;
	      v0 = v0 + v1 + 1 >> 1;
	      v1 = v0 - v1;
	      t = v2 * dctSin6 + v3 * dctCos6 + 128 >> 8;
	      v2 = v2 * dctCos6 - v3 * dctSin6 + 128 >> 8;
	      v3 = t;
	      v4 = v4 + v6 + 1 >> 1;
	      v6 = v4 - v6;
	      v7 = v7 + v5 + 1 >> 1;
	      v5 = v7 - v5;
	      v0 = v0 + v3 + 1 >> 1;
	      v3 = v0 - v3;
	      v1 = v1 + v2 + 1 >> 1;
	      v2 = v1 - v2;
	      t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
	      v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
	      v7 = t;
	      t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
	      v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
	      v6 = t;
	      p[row] = v0 + v7;
	      p[row + 7] = v0 - v7;
	      p[row + 1] = v1 + v6;
	      p[row + 6] = v1 - v6;
	      p[row + 2] = v2 + v5;
	      p[row + 5] = v2 - v5;
	      p[row + 3] = v3 + v4;
	      p[row + 4] = v3 - v4;
	    }
	    for (var col = 0; col < 8; ++col) {
	      p0 = p[col];
	      p1 = p[col + 8];
	      p2 = p[col + 16];
	      p3 = p[col + 24];
	      p4 = p[col + 32];
	      p5 = p[col + 40];
	      p6 = p[col + 48];
	      p7 = p[col + 56];
	      if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
	        t = dctSqrt2 * p0 + 8192 >> 14;
	        t = t < -2040 ? 0 : t >= 2024 ? 255 : t + 2056 >> 4;
	        blockData[blockBufferOffset + col] = t;
	        blockData[blockBufferOffset + col + 8] = t;
	        blockData[blockBufferOffset + col + 16] = t;
	        blockData[blockBufferOffset + col + 24] = t;
	        blockData[blockBufferOffset + col + 32] = t;
	        blockData[blockBufferOffset + col + 40] = t;
	        blockData[blockBufferOffset + col + 48] = t;
	        blockData[blockBufferOffset + col + 56] = t;
	        continue;
	      }
	      v0 = dctSqrt2 * p0 + 2048 >> 12;
	      v1 = dctSqrt2 * p4 + 2048 >> 12;
	      v2 = p2;
	      v3 = p6;
	      v4 = dctSqrt1d2 * (p1 - p7) + 2048 >> 12;
	      v7 = dctSqrt1d2 * (p1 + p7) + 2048 >> 12;
	      v5 = p3;
	      v6 = p5;
	      v0 = (v0 + v1 + 1 >> 1) + 4112;
	      v1 = v0 - v1;
	      t = v2 * dctSin6 + v3 * dctCos6 + 2048 >> 12;
	      v2 = v2 * dctCos6 - v3 * dctSin6 + 2048 >> 12;
	      v3 = t;
	      v4 = v4 + v6 + 1 >> 1;
	      v6 = v4 - v6;
	      v7 = v7 + v5 + 1 >> 1;
	      v5 = v7 - v5;
	      v0 = v0 + v3 + 1 >> 1;
	      v3 = v0 - v3;
	      v1 = v1 + v2 + 1 >> 1;
	      v2 = v1 - v2;
	      t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
	      v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
	      v7 = t;
	      t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
	      v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
	      v6 = t;
	      p0 = v0 + v7;
	      p7 = v0 - v7;
	      p1 = v1 + v6;
	      p6 = v1 - v6;
	      p2 = v2 + v5;
	      p5 = v2 - v5;
	      p3 = v3 + v4;
	      p4 = v3 - v4;
	      p0 = p0 < 16 ? 0 : p0 >= 4080 ? 255 : p0 >> 4;
	      p1 = p1 < 16 ? 0 : p1 >= 4080 ? 255 : p1 >> 4;
	      p2 = p2 < 16 ? 0 : p2 >= 4080 ? 255 : p2 >> 4;
	      p3 = p3 < 16 ? 0 : p3 >= 4080 ? 255 : p3 >> 4;
	      p4 = p4 < 16 ? 0 : p4 >= 4080 ? 255 : p4 >> 4;
	      p5 = p5 < 16 ? 0 : p5 >= 4080 ? 255 : p5 >> 4;
	      p6 = p6 < 16 ? 0 : p6 >= 4080 ? 255 : p6 >> 4;
	      p7 = p7 < 16 ? 0 : p7 >= 4080 ? 255 : p7 >> 4;
	      blockData[blockBufferOffset + col] = p0;
	      blockData[blockBufferOffset + col + 8] = p1;
	      blockData[blockBufferOffset + col + 16] = p2;
	      blockData[blockBufferOffset + col + 24] = p3;
	      blockData[blockBufferOffset + col + 32] = p4;
	      blockData[blockBufferOffset + col + 40] = p5;
	      blockData[blockBufferOffset + col + 48] = p6;
	      blockData[blockBufferOffset + col + 56] = p7;
	    }
	  }
	  function buildComponentData(frame, component) {
	    var blocksPerLine = component.blocksPerLine;
	    var blocksPerColumn = component.blocksPerColumn;
	    var computationBuffer = new Int16Array(64);
	    for (var blockRow = 0; blockRow < blocksPerColumn; blockRow++) {
	      for (var blockCol = 0; blockCol < blocksPerLine; blockCol++) {
	        var offset = getBlockBufferOffset(component, blockRow, blockCol);
	        quantizeAndInverse(component, offset, computationBuffer);
	      }
	    }
	    return component.blockData;
	  }
	  function clamp0to255(a) {
	    return a <= 0 ? 0 : a >= 255 ? 255 : a;
	  }
	  function findNextFileMarker(data, currentPos, startPos) {
	    function peekUint16(pos) {
	      return data[pos] << 8 | data[pos + 1];
	    }
	    var maxPos = data.length - 1;
	    var newPos = startPos < currentPos ? startPos : currentPos;
	    if (currentPos >= maxPos) {
	      return null;
	    }
	    var currentMarker = peekUint16(currentPos);
	    if (currentMarker >= 0xFFC0 && currentMarker <= 0xFFFE) {
	      return {
	        invalid: null,
	        marker: currentMarker,
	        offset: currentPos
	      };
	    }
	    var newMarker = peekUint16(newPos);
	    while (!(newMarker >= 0xFFC0 && newMarker <= 0xFFFE)) {
	      if (++newPos >= maxPos) {
	        return null;
	      }
	      newMarker = peekUint16(newPos);
	    }
	    return {
	      invalid: currentMarker.toString(16),
	      marker: newMarker,
	      offset: newPos
	    };
	  }
	  JpegImage.prototype = {
	    parse: function parse(data) {
	      function readUint16() {
	        var value = data[offset] << 8 | data[offset + 1];
	        offset += 2;
	        return value;
	      }
	      function readDataBlock() {
	        var length = readUint16();
	        var endOffset = offset + length - 2;
	        var fileMarker = findNextFileMarker(data, endOffset, offset);
	        if (fileMarker && fileMarker.invalid) {
	          warn('readDataBlock - incorrect length, next marker is: ' + fileMarker.invalid);
	          endOffset = fileMarker.offset;
	        }
	        var array = data.subarray(offset, endOffset);
	        offset += array.length;
	        return array;
	      }
	      function prepareComponents(frame) {
	        var mcusPerLine = Math.ceil(frame.samplesPerLine / 8 / frame.maxH);
	        var mcusPerColumn = Math.ceil(frame.scanLines / 8 / frame.maxV);
	        for (var i = 0; i < frame.components.length; i++) {
	          component = frame.components[i];
	          var blocksPerLine = Math.ceil(Math.ceil(frame.samplesPerLine / 8) * component.h / frame.maxH);
	          var blocksPerColumn = Math.ceil(Math.ceil(frame.scanLines / 8) * component.v / frame.maxV);
	          var blocksPerLineForMcu = mcusPerLine * component.h;
	          var blocksPerColumnForMcu = mcusPerColumn * component.v;
	          var blocksBufferSize = 64 * blocksPerColumnForMcu * (blocksPerLineForMcu + 1);
	          component.blockData = new Int16Array(blocksBufferSize);
	          component.blocksPerLine = blocksPerLine;
	          component.blocksPerColumn = blocksPerColumn;
	        }
	        frame.mcusPerLine = mcusPerLine;
	        frame.mcusPerColumn = mcusPerColumn;
	      }
	      var offset = 0;
	      var jfif = null;
	      var adobe = null;
	      var frame, resetInterval;
	      var quantizationTables = [];
	      var huffmanTablesAC = [],
	          huffmanTablesDC = [];
	      var fileMarker = readUint16();
	      if (fileMarker !== 0xFFD8) {
	        error('JPEG error: SOI not found');
	      }
	      fileMarker = readUint16();
	      while (fileMarker !== 0xFFD9) {
	        var i, j, l;
	        switch (fileMarker) {
	          case 0xFFE0:
	          case 0xFFE1:
	          case 0xFFE2:
	          case 0xFFE3:
	          case 0xFFE4:
	          case 0xFFE5:
	          case 0xFFE6:
	          case 0xFFE7:
	          case 0xFFE8:
	          case 0xFFE9:
	          case 0xFFEA:
	          case 0xFFEB:
	          case 0xFFEC:
	          case 0xFFED:
	          case 0xFFEE:
	          case 0xFFEF:
	          case 0xFFFE:
	            var appData = readDataBlock();
	            if (fileMarker === 0xFFE0) {
	              if (appData[0] === 0x4A && appData[1] === 0x46 && appData[2] === 0x49 && appData[3] === 0x46 && appData[4] === 0) {
	                jfif = {
	                  version: {
	                    major: appData[5],
	                    minor: appData[6]
	                  },
	                  densityUnits: appData[7],
	                  xDensity: appData[8] << 8 | appData[9],
	                  yDensity: appData[10] << 8 | appData[11],
	                  thumbWidth: appData[12],
	                  thumbHeight: appData[13],
	                  thumbData: appData.subarray(14, 14 + 3 * appData[12] * appData[13])
	                };
	              }
	            }
	            if (fileMarker === 0xFFEE) {
	              if (appData[0] === 0x41 && appData[1] === 0x64 && appData[2] === 0x6F && appData[3] === 0x62 && appData[4] === 0x65) {
	                adobe = {
	                  version: appData[5] << 8 | appData[6],
	                  flags0: appData[7] << 8 | appData[8],
	                  flags1: appData[9] << 8 | appData[10],
	                  transformCode: appData[11]
	                };
	              }
	            }
	            break;
	          case 0xFFDB:
	            var quantizationTablesLength = readUint16();
	            var quantizationTablesEnd = quantizationTablesLength + offset - 2;
	            var z;
	            while (offset < quantizationTablesEnd) {
	              var quantizationTableSpec = data[offset++];
	              var tableData = new Uint16Array(64);
	              if (quantizationTableSpec >> 4 === 0) {
	                for (j = 0; j < 64; j++) {
	                  z = dctZigZag[j];
	                  tableData[z] = data[offset++];
	                }
	              } else if (quantizationTableSpec >> 4 === 1) {
	                for (j = 0; j < 64; j++) {
	                  z = dctZigZag[j];
	                  tableData[z] = readUint16();
	                }
	              } else {
	                error('JPEG error: DQT - invalid table spec');
	              }
	              quantizationTables[quantizationTableSpec & 15] = tableData;
	            }
	            break;
	          case 0xFFC0:
	          case 0xFFC1:
	          case 0xFFC2:
	            if (frame) {
	              error('JPEG error: Only single frame JPEGs supported');
	            }
	            readUint16();
	            frame = {};
	            frame.extended = fileMarker === 0xFFC1;
	            frame.progressive = fileMarker === 0xFFC2;
	            frame.precision = data[offset++];
	            frame.scanLines = readUint16();
	            frame.samplesPerLine = readUint16();
	            frame.components = [];
	            frame.componentIds = {};
	            var componentsCount = data[offset++],
	                componentId;
	            var maxH = 0,
	                maxV = 0;
	            for (i = 0; i < componentsCount; i++) {
	              componentId = data[offset];
	              var h = data[offset + 1] >> 4;
	              var v = data[offset + 1] & 15;
	              if (maxH < h) {
	                maxH = h;
	              }
	              if (maxV < v) {
	                maxV = v;
	              }
	              var qId = data[offset + 2];
	              l = frame.components.push({
	                h: h,
	                v: v,
	                quantizationId: qId,
	                quantizationTable: null
	              });
	              frame.componentIds[componentId] = l - 1;
	              offset += 3;
	            }
	            frame.maxH = maxH;
	            frame.maxV = maxV;
	            prepareComponents(frame);
	            break;
	          case 0xFFC4:
	            var huffmanLength = readUint16();
	            for (i = 2; i < huffmanLength;) {
	              var huffmanTableSpec = data[offset++];
	              var codeLengths = new Uint8Array(16);
	              var codeLengthSum = 0;
	              for (j = 0; j < 16; j++, offset++) {
	                codeLengthSum += codeLengths[j] = data[offset];
	              }
	              var huffmanValues = new Uint8Array(codeLengthSum);
	              for (j = 0; j < codeLengthSum; j++, offset++) {
	                huffmanValues[j] = data[offset];
	              }
	              i += 17 + codeLengthSum;
	              (huffmanTableSpec >> 4 === 0 ? huffmanTablesDC : huffmanTablesAC)[huffmanTableSpec & 15] = buildHuffmanTable(codeLengths, huffmanValues);
	            }
	            break;
	          case 0xFFDD:
	            readUint16();
	            resetInterval = readUint16();
	            break;
	          case 0xFFDA:
	            readUint16();
	            var selectorsCount = data[offset++];
	            var components = [],
	                component;
	            for (i = 0; i < selectorsCount; i++) {
	              var componentIndex = frame.componentIds[data[offset++]];
	              component = frame.components[componentIndex];
	              var tableSpec = data[offset++];
	              component.huffmanTableDC = huffmanTablesDC[tableSpec >> 4];
	              component.huffmanTableAC = huffmanTablesAC[tableSpec & 15];
	              components.push(component);
	            }
	            var spectralStart = data[offset++];
	            var spectralEnd = data[offset++];
	            var successiveApproximation = data[offset++];
	            var processed = decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successiveApproximation >> 4, successiveApproximation & 15);
	            offset += processed;
	            break;
	          case 0xFFFF:
	            if (data[offset] !== 0xFF) {
	              offset--;
	            }
	            break;
	          default:
	            if (data[offset - 3] === 0xFF && data[offset - 2] >= 0xC0 && data[offset - 2] <= 0xFE) {
	              offset -= 3;
	              break;
	            }
	            error('JPEG error: unknown marker ' + fileMarker.toString(16));
	        }
	        fileMarker = readUint16();
	      }
	      this.width = frame.samplesPerLine;
	      this.height = frame.scanLines;
	      this.jfif = jfif;
	      this.adobe = adobe;
	      this.components = [];
	      for (i = 0; i < frame.components.length; i++) {
	        component = frame.components[i];
	        var quantizationTable = quantizationTables[component.quantizationId];
	        if (quantizationTable) {
	          component.quantizationTable = quantizationTable;
	        }
	        this.components.push({
	          output: buildComponentData(frame, component),
	          scaleX: component.h / frame.maxH,
	          scaleY: component.v / frame.maxV,
	          blocksPerLine: component.blocksPerLine,
	          blocksPerColumn: component.blocksPerColumn
	        });
	      }
	      this.numComponents = this.components.length;
	    },
	    _getLinearizedBlockData: function getLinearizedBlockData(width, height) {
	      var scaleX = this.width / width,
	          scaleY = this.height / height;
	      var component, componentScaleX, componentScaleY, blocksPerScanline;
	      var x, y, i, j, k;
	      var index;
	      var offset = 0;
	      var output;
	      var numComponents = this.components.length;
	      var dataLength = width * height * numComponents;
	      var data = new Uint8Array(dataLength);
	      var xScaleBlockOffset = new Uint32Array(width);
	      var mask3LSB = 0xfffffff8;
	      for (i = 0; i < numComponents; i++) {
	        component = this.components[i];
	        componentScaleX = component.scaleX * scaleX;
	        componentScaleY = component.scaleY * scaleY;
	        offset = i;
	        output = component.output;
	        blocksPerScanline = component.blocksPerLine + 1 << 3;
	        for (x = 0; x < width; x++) {
	          j = 0 | x * componentScaleX;
	          xScaleBlockOffset[x] = (j & mask3LSB) << 3 | j & 7;
	        }
	        for (y = 0; y < height; y++) {
	          j = 0 | y * componentScaleY;
	          index = blocksPerScanline * (j & mask3LSB) | (j & 7) << 3;
	          for (x = 0; x < width; x++) {
	            data[offset] = output[index + xScaleBlockOffset[x]];
	            offset += numComponents;
	          }
	        }
	      }
	      var transform = this.decodeTransform;
	      if (transform) {
	        for (i = 0; i < dataLength;) {
	          for (j = 0, k = 0; j < numComponents; j++, i++, k += 2) {
	            data[i] = (data[i] * transform[k] >> 8) + transform[k + 1];
	          }
	        }
	      }
	      return data;
	    },
	    _isColorConversionNeeded: function isColorConversionNeeded() {
	      if (this.adobe && this.adobe.transformCode) {
	        return true;
	      } else if (this.numComponents === 3) {
	        if (!this.adobe && this.colorTransform === 0) {
	          return false;
	        }
	        return true;
	      }
	      if (!this.adobe && this.colorTransform === 1) {
	        return true;
	      }
	      return false;
	    },
	    _convertYccToRgb: function convertYccToRgb(data) {
	      var Y, Cb, Cr;
	      for (var i = 0, length = data.length; i < length; i += 3) {
	        Y = data[i];
	        Cb = data[i + 1];
	        Cr = data[i + 2];
	        data[i] = clamp0to255(Y - 179.456 + 1.402 * Cr);
	        data[i + 1] = clamp0to255(Y + 135.459 - 0.344 * Cb - 0.714 * Cr);
	        data[i + 2] = clamp0to255(Y - 226.816 + 1.772 * Cb);
	      }
	      return data;
	    },
	    _convertYcckToRgb: function convertYcckToRgb(data) {
	      var Y, Cb, Cr, k;
	      var offset = 0;
	      for (var i = 0, length = data.length; i < length; i += 4) {
	        Y = data[i];
	        Cb = data[i + 1];
	        Cr = data[i + 2];
	        k = data[i + 3];
	        var r = -122.67195406894 + Cb * (-6.60635669420364e-5 * Cb + 0.000437130475926232 * Cr - 5.4080610064599e-5 * Y + 0.00048449797120281 * k - 0.154362151871126) + Cr * (-0.000957964378445773 * Cr + 0.000817076911346625 * Y - 0.00477271405408747 * k + 1.53380253221734) + Y * (0.000961250184130688 * Y - 0.00266257332283933 * k + 0.48357088451265) + k * (-0.000336197177618394 * k + 0.484791561490776);
	        var g = 107.268039397724 + Cb * (2.19927104525741e-5 * Cb - 0.000640992018297945 * Cr + 0.000659397001245577 * Y + 0.000426105652938837 * k - 0.176491792462875) + Cr * (-0.000778269941513683 * Cr + 0.00130872261408275 * Y + 0.000770482631801132 * k - 0.151051492775562) + Y * (0.00126935368114843 * Y - 0.00265090189010898 * k + 0.25802910206845) + k * (-0.000318913117588328 * k - 0.213742400323665);
	        var b = -20.810012546947 + Cb * (-0.000570115196973677 * Cb - 2.63409051004589e-5 * Cr + 0.0020741088115012 * Y - 0.00288260236853442 * k + 0.814272968359295) + Cr * (-1.53496057440975e-5 * Cr - 0.000132689043961446 * Y + 0.000560833691242812 * k - 0.195152027534049) + Y * (0.00174418132927582 * Y - 0.00255243321439347 * k + 0.116935020465145) + k * (-0.000343531996510555 * k + 0.24165260232407);
	        data[offset++] = clamp0to255(r);
	        data[offset++] = clamp0to255(g);
	        data[offset++] = clamp0to255(b);
	      }
	      return data;
	    },
	    _convertYcckToCmyk: function convertYcckToCmyk(data) {
	      var Y, Cb, Cr;
	      for (var i = 0, length = data.length; i < length; i += 4) {
	        Y = data[i];
	        Cb = data[i + 1];
	        Cr = data[i + 2];
	        data[i] = clamp0to255(434.456 - Y - 1.402 * Cr);
	        data[i + 1] = clamp0to255(119.541 - Y + 0.344 * Cb + 0.714 * Cr);
	        data[i + 2] = clamp0to255(481.816 - Y - 1.772 * Cb);
	      }
	      return data;
	    },
	    _convertCmykToRgb: function convertCmykToRgb(data) {
	      var c, m, y, k;
	      var offset = 0;
	      var min = -255 * 255 * 255;
	      var scale = 1 / 255 / 255;
	      for (var i = 0, length = data.length; i < length; i += 4) {
	        c = data[i];
	        m = data[i + 1];
	        y = data[i + 2];
	        k = data[i + 3];
	        var r = c * (-4.387332384609988 * c + 54.48615194189176 * m + 18.82290502165302 * y + 212.25662451639585 * k - 72734.4411664936) + m * (1.7149763477362134 * m - 5.6096736904047315 * y - 17.873870861415444 * k - 1401.7366389350734) + y * (-2.5217340131683033 * y - 21.248923337353073 * k + 4465.541406466231) - k * (21.86122147463605 * k + 48317.86113160301);
	        var g = c * (8.841041422036149 * c + 60.118027045597366 * m + 6.871425592049007 * y + 31.159100130055922 * k - 20220.756542821975) + m * (-15.310361306967817 * m + 17.575251261109482 * y + 131.35250912493976 * k - 48691.05921601825) + y * (4.444339102852739 * y + 9.8632861493405 * k - 6341.191035517494) - k * (20.737325471181034 * k + 47890.15695978492);
	        var b = c * (0.8842522430003296 * c + 8.078677503112928 * m + 30.89978309703729 * y - 0.23883238689178934 * k - 3616.812083916688) + m * (10.49593273432072 * m + 63.02378494754052 * y + 50.606957656360734 * k - 28620.90484698408) + y * (0.03296041114873217 * y + 115.60384449646641 * k - 49363.43385999684) - k * (22.33816807309886 * k + 45932.16563550634);
	        data[offset++] = r >= 0 ? 255 : r <= min ? 0 : 255 + r * scale | 0;
	        data[offset++] = g >= 0 ? 255 : g <= min ? 0 : 255 + g * scale | 0;
	        data[offset++] = b >= 0 ? 255 : b <= min ? 0 : 255 + b * scale | 0;
	      }
	      return data;
	    },
	    getData: function getData(width, height, forceRGBoutput) {
	      if (this.numComponents > 4) {
	        error('JPEG error: Unsupported color mode');
	      }
	      var data = this._getLinearizedBlockData(width, height);
	      if (this.numComponents === 1 && forceRGBoutput) {
	        var dataLength = data.length;
	        var rgbData = new Uint8Array(dataLength * 3);
	        var offset = 0;
	        for (var i = 0; i < dataLength; i++) {
	          var grayColor = data[i];
	          rgbData[offset++] = grayColor;
	          rgbData[offset++] = grayColor;
	          rgbData[offset++] = grayColor;
	        }
	        return rgbData;
	      } else if (this.numComponents === 3 && this._isColorConversionNeeded()) {
	        return this._convertYccToRgb(data);
	      } else if (this.numComponents === 4) {
	        if (this._isColorConversionNeeded()) {
	          if (forceRGBoutput) {
	            return this._convertYcckToRgb(data);
	          }
	          return this._convertYcckToCmyk(data);
	        } else if (forceRGBoutput) {
	          return this._convertCmykToRgb(data);
	        }
	      }
	      return data;
	    }
	  };
	  return JpegImage;
	}();
	exports.JpegImage = JpegImage;
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var getLookupTableFactory = sharedUtil.getLookupTableFactory;
	var getMetrics = getLookupTableFactory(function (t) {
	  t['Courier'] = 600;
	  t['Courier-Bold'] = 600;
	  t['Courier-BoldOblique'] = 600;
	  t['Courier-Oblique'] = 600;
	  t['Helvetica'] = getLookupTableFactory(function (t) {
	    t['space'] = 278;
	    t['exclam'] = 278;
	    t['quotedbl'] = 355;
	    t['numbersign'] = 556;
	    t['dollar'] = 556;
	    t['percent'] = 889;
	    t['ampersand'] = 667;
	    t['quoteright'] = 222;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 389;
	    t['plus'] = 584;
	    t['comma'] = 278;
	    t['hyphen'] = 333;
	    t['period'] = 278;
	    t['slash'] = 278;
	    t['zero'] = 556;
	    t['one'] = 556;
	    t['two'] = 556;
	    t['three'] = 556;
	    t['four'] = 556;
	    t['five'] = 556;
	    t['six'] = 556;
	    t['seven'] = 556;
	    t['eight'] = 556;
	    t['nine'] = 556;
	    t['colon'] = 278;
	    t['semicolon'] = 278;
	    t['less'] = 584;
	    t['equal'] = 584;
	    t['greater'] = 584;
	    t['question'] = 556;
	    t['at'] = 1015;
	    t['A'] = 667;
	    t['B'] = 667;
	    t['C'] = 722;
	    t['D'] = 722;
	    t['E'] = 667;
	    t['F'] = 611;
	    t['G'] = 778;
	    t['H'] = 722;
	    t['I'] = 278;
	    t['J'] = 500;
	    t['K'] = 667;
	    t['L'] = 556;
	    t['M'] = 833;
	    t['N'] = 722;
	    t['O'] = 778;
	    t['P'] = 667;
	    t['Q'] = 778;
	    t['R'] = 722;
	    t['S'] = 667;
	    t['T'] = 611;
	    t['U'] = 722;
	    t['V'] = 667;
	    t['W'] = 944;
	    t['X'] = 667;
	    t['Y'] = 667;
	    t['Z'] = 611;
	    t['bracketleft'] = 278;
	    t['backslash'] = 278;
	    t['bracketright'] = 278;
	    t['asciicircum'] = 469;
	    t['underscore'] = 556;
	    t['quoteleft'] = 222;
	    t['a'] = 556;
	    t['b'] = 556;
	    t['c'] = 500;
	    t['d'] = 556;
	    t['e'] = 556;
	    t['f'] = 278;
	    t['g'] = 556;
	    t['h'] = 556;
	    t['i'] = 222;
	    t['j'] = 222;
	    t['k'] = 500;
	    t['l'] = 222;
	    t['m'] = 833;
	    t['n'] = 556;
	    t['o'] = 556;
	    t['p'] = 556;
	    t['q'] = 556;
	    t['r'] = 333;
	    t['s'] = 500;
	    t['t'] = 278;
	    t['u'] = 556;
	    t['v'] = 500;
	    t['w'] = 722;
	    t['x'] = 500;
	    t['y'] = 500;
	    t['z'] = 500;
	    t['braceleft'] = 334;
	    t['bar'] = 260;
	    t['braceright'] = 334;
	    t['asciitilde'] = 584;
	    t['exclamdown'] = 333;
	    t['cent'] = 556;
	    t['sterling'] = 556;
	    t['fraction'] = 167;
	    t['yen'] = 556;
	    t['florin'] = 556;
	    t['section'] = 556;
	    t['currency'] = 556;
	    t['quotesingle'] = 191;
	    t['quotedblleft'] = 333;
	    t['guillemotleft'] = 556;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 500;
	    t['fl'] = 500;
	    t['endash'] = 556;
	    t['dagger'] = 556;
	    t['daggerdbl'] = 556;
	    t['periodcentered'] = 278;
	    t['paragraph'] = 537;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 222;
	    t['quotedblbase'] = 333;
	    t['quotedblright'] = 333;
	    t['guillemotright'] = 556;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 611;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 1000;
	    t['ordfeminine'] = 370;
	    t['Lslash'] = 556;
	    t['Oslash'] = 778;
	    t['OE'] = 1000;
	    t['ordmasculine'] = 365;
	    t['ae'] = 889;
	    t['dotlessi'] = 278;
	    t['lslash'] = 222;
	    t['oslash'] = 611;
	    t['oe'] = 944;
	    t['germandbls'] = 611;
	    t['Idieresis'] = 278;
	    t['eacute'] = 556;
	    t['abreve'] = 556;
	    t['uhungarumlaut'] = 556;
	    t['ecaron'] = 556;
	    t['Ydieresis'] = 667;
	    t['divide'] = 584;
	    t['Yacute'] = 667;
	    t['Acircumflex'] = 667;
	    t['aacute'] = 556;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 500;
	    t['scommaaccent'] = 500;
	    t['ecircumflex'] = 556;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 556;
	    t['Uacute'] = 722;
	    t['uogonek'] = 556;
	    t['Edieresis'] = 667;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 737;
	    t['Emacron'] = 667;
	    t['ccaron'] = 500;
	    t['aring'] = 556;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 222;
	    t['agrave'] = 556;
	    t['Tcommaaccent'] = 611;
	    t['Cacute'] = 722;
	    t['atilde'] = 556;
	    t['Edotaccent'] = 667;
	    t['scaron'] = 500;
	    t['scedilla'] = 500;
	    t['iacute'] = 278;
	    t['lozenge'] = 471;
	    t['Rcaron'] = 722;
	    t['Gcommaaccent'] = 778;
	    t['ucircumflex'] = 556;
	    t['acircumflex'] = 556;
	    t['Amacron'] = 667;
	    t['rcaron'] = 333;
	    t['ccedilla'] = 500;
	    t['Zdotaccent'] = 611;
	    t['Thorn'] = 667;
	    t['Omacron'] = 778;
	    t['Racute'] = 722;
	    t['Sacute'] = 667;
	    t['dcaron'] = 643;
	    t['Umacron'] = 722;
	    t['uring'] = 556;
	    t['threesuperior'] = 333;
	    t['Ograve'] = 778;
	    t['Agrave'] = 667;
	    t['Abreve'] = 667;
	    t['multiply'] = 584;
	    t['uacute'] = 556;
	    t['Tcaron'] = 611;
	    t['partialdiff'] = 476;
	    t['ydieresis'] = 500;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 667;
	    t['adieresis'] = 556;
	    t['edieresis'] = 556;
	    t['cacute'] = 500;
	    t['nacute'] = 556;
	    t['umacron'] = 556;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 278;
	    t['plusminus'] = 584;
	    t['brokenbar'] = 260;
	    t['registered'] = 737;
	    t['Gbreve'] = 778;
	    t['Idotaccent'] = 278;
	    t['summation'] = 600;
	    t['Egrave'] = 667;
	    t['racute'] = 333;
	    t['omacron'] = 556;
	    t['Zacute'] = 611;
	    t['Zcaron'] = 611;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 722;
	    t['lcommaaccent'] = 222;
	    t['tcaron'] = 317;
	    t['eogonek'] = 556;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 667;
	    t['Adieresis'] = 667;
	    t['egrave'] = 556;
	    t['zacute'] = 500;
	    t['iogonek'] = 222;
	    t['Oacute'] = 778;
	    t['oacute'] = 556;
	    t['amacron'] = 556;
	    t['sacute'] = 500;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 778;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 556;
	    t['twosuperior'] = 333;
	    t['Odieresis'] = 778;
	    t['mu'] = 556;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 556;
	    t['Eogonek'] = 667;
	    t['dcroat'] = 556;
	    t['threequarters'] = 834;
	    t['Scedilla'] = 667;
	    t['lcaron'] = 299;
	    t['Kcommaaccent'] = 667;
	    t['Lacute'] = 556;
	    t['trademark'] = 1000;
	    t['edotaccent'] = 556;
	    t['Igrave'] = 278;
	    t['Imacron'] = 278;
	    t['Lcaron'] = 556;
	    t['onehalf'] = 834;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 556;
	    t['ntilde'] = 556;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 667;
	    t['emacron'] = 556;
	    t['gbreve'] = 556;
	    t['onequarter'] = 834;
	    t['Scaron'] = 667;
	    t['Scommaaccent'] = 667;
	    t['Ohungarumlaut'] = 778;
	    t['degree'] = 400;
	    t['ograve'] = 556;
	    t['Ccaron'] = 722;
	    t['ugrave'] = 556;
	    t['radical'] = 453;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 333;
	    t['Ntilde'] = 722;
	    t['otilde'] = 556;
	    t['Rcommaaccent'] = 722;
	    t['Lcommaaccent'] = 556;
	    t['Atilde'] = 667;
	    t['Aogonek'] = 667;
	    t['Aring'] = 667;
	    t['Otilde'] = 778;
	    t['zdotaccent'] = 500;
	    t['Ecaron'] = 667;
	    t['Iogonek'] = 278;
	    t['kcommaaccent'] = 500;
	    t['minus'] = 584;
	    t['Icircumflex'] = 278;
	    t['ncaron'] = 556;
	    t['tcommaaccent'] = 278;
	    t['logicalnot'] = 584;
	    t['odieresis'] = 556;
	    t['udieresis'] = 556;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 556;
	    t['eth'] = 556;
	    t['zcaron'] = 500;
	    t['ncommaaccent'] = 556;
	    t['onesuperior'] = 333;
	    t['imacron'] = 278;
	    t['Euro'] = 556;
	  });
	  t['Helvetica-Bold'] = getLookupTableFactory(function (t) {
	    t['space'] = 278;
	    t['exclam'] = 333;
	    t['quotedbl'] = 474;
	    t['numbersign'] = 556;
	    t['dollar'] = 556;
	    t['percent'] = 889;
	    t['ampersand'] = 722;
	    t['quoteright'] = 278;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 389;
	    t['plus'] = 584;
	    t['comma'] = 278;
	    t['hyphen'] = 333;
	    t['period'] = 278;
	    t['slash'] = 278;
	    t['zero'] = 556;
	    t['one'] = 556;
	    t['two'] = 556;
	    t['three'] = 556;
	    t['four'] = 556;
	    t['five'] = 556;
	    t['six'] = 556;
	    t['seven'] = 556;
	    t['eight'] = 556;
	    t['nine'] = 556;
	    t['colon'] = 333;
	    t['semicolon'] = 333;
	    t['less'] = 584;
	    t['equal'] = 584;
	    t['greater'] = 584;
	    t['question'] = 611;
	    t['at'] = 975;
	    t['A'] = 722;
	    t['B'] = 722;
	    t['C'] = 722;
	    t['D'] = 722;
	    t['E'] = 667;
	    t['F'] = 611;
	    t['G'] = 778;
	    t['H'] = 722;
	    t['I'] = 278;
	    t['J'] = 556;
	    t['K'] = 722;
	    t['L'] = 611;
	    t['M'] = 833;
	    t['N'] = 722;
	    t['O'] = 778;
	    t['P'] = 667;
	    t['Q'] = 778;
	    t['R'] = 722;
	    t['S'] = 667;
	    t['T'] = 611;
	    t['U'] = 722;
	    t['V'] = 667;
	    t['W'] = 944;
	    t['X'] = 667;
	    t['Y'] = 667;
	    t['Z'] = 611;
	    t['bracketleft'] = 333;
	    t['backslash'] = 278;
	    t['bracketright'] = 333;
	    t['asciicircum'] = 584;
	    t['underscore'] = 556;
	    t['quoteleft'] = 278;
	    t['a'] = 556;
	    t['b'] = 611;
	    t['c'] = 556;
	    t['d'] = 611;
	    t['e'] = 556;
	    t['f'] = 333;
	    t['g'] = 611;
	    t['h'] = 611;
	    t['i'] = 278;
	    t['j'] = 278;
	    t['k'] = 556;
	    t['l'] = 278;
	    t['m'] = 889;
	    t['n'] = 611;
	    t['o'] = 611;
	    t['p'] = 611;
	    t['q'] = 611;
	    t['r'] = 389;
	    t['s'] = 556;
	    t['t'] = 333;
	    t['u'] = 611;
	    t['v'] = 556;
	    t['w'] = 778;
	    t['x'] = 556;
	    t['y'] = 556;
	    t['z'] = 500;
	    t['braceleft'] = 389;
	    t['bar'] = 280;
	    t['braceright'] = 389;
	    t['asciitilde'] = 584;
	    t['exclamdown'] = 333;
	    t['cent'] = 556;
	    t['sterling'] = 556;
	    t['fraction'] = 167;
	    t['yen'] = 556;
	    t['florin'] = 556;
	    t['section'] = 556;
	    t['currency'] = 556;
	    t['quotesingle'] = 238;
	    t['quotedblleft'] = 500;
	    t['guillemotleft'] = 556;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 611;
	    t['fl'] = 611;
	    t['endash'] = 556;
	    t['dagger'] = 556;
	    t['daggerdbl'] = 556;
	    t['periodcentered'] = 278;
	    t['paragraph'] = 556;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 278;
	    t['quotedblbase'] = 500;
	    t['quotedblright'] = 500;
	    t['guillemotright'] = 556;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 611;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 1000;
	    t['ordfeminine'] = 370;
	    t['Lslash'] = 611;
	    t['Oslash'] = 778;
	    t['OE'] = 1000;
	    t['ordmasculine'] = 365;
	    t['ae'] = 889;
	    t['dotlessi'] = 278;
	    t['lslash'] = 278;
	    t['oslash'] = 611;
	    t['oe'] = 944;
	    t['germandbls'] = 611;
	    t['Idieresis'] = 278;
	    t['eacute'] = 556;
	    t['abreve'] = 556;
	    t['uhungarumlaut'] = 611;
	    t['ecaron'] = 556;
	    t['Ydieresis'] = 667;
	    t['divide'] = 584;
	    t['Yacute'] = 667;
	    t['Acircumflex'] = 722;
	    t['aacute'] = 556;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 556;
	    t['scommaaccent'] = 556;
	    t['ecircumflex'] = 556;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 556;
	    t['Uacute'] = 722;
	    t['uogonek'] = 611;
	    t['Edieresis'] = 667;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 737;
	    t['Emacron'] = 667;
	    t['ccaron'] = 556;
	    t['aring'] = 556;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 278;
	    t['agrave'] = 556;
	    t['Tcommaaccent'] = 611;
	    t['Cacute'] = 722;
	    t['atilde'] = 556;
	    t['Edotaccent'] = 667;
	    t['scaron'] = 556;
	    t['scedilla'] = 556;
	    t['iacute'] = 278;
	    t['lozenge'] = 494;
	    t['Rcaron'] = 722;
	    t['Gcommaaccent'] = 778;
	    t['ucircumflex'] = 611;
	    t['acircumflex'] = 556;
	    t['Amacron'] = 722;
	    t['rcaron'] = 389;
	    t['ccedilla'] = 556;
	    t['Zdotaccent'] = 611;
	    t['Thorn'] = 667;
	    t['Omacron'] = 778;
	    t['Racute'] = 722;
	    t['Sacute'] = 667;
	    t['dcaron'] = 743;
	    t['Umacron'] = 722;
	    t['uring'] = 611;
	    t['threesuperior'] = 333;
	    t['Ograve'] = 778;
	    t['Agrave'] = 722;
	    t['Abreve'] = 722;
	    t['multiply'] = 584;
	    t['uacute'] = 611;
	    t['Tcaron'] = 611;
	    t['partialdiff'] = 494;
	    t['ydieresis'] = 556;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 667;
	    t['adieresis'] = 556;
	    t['edieresis'] = 556;
	    t['cacute'] = 556;
	    t['nacute'] = 611;
	    t['umacron'] = 611;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 278;
	    t['plusminus'] = 584;
	    t['brokenbar'] = 280;
	    t['registered'] = 737;
	    t['Gbreve'] = 778;
	    t['Idotaccent'] = 278;
	    t['summation'] = 600;
	    t['Egrave'] = 667;
	    t['racute'] = 389;
	    t['omacron'] = 611;
	    t['Zacute'] = 611;
	    t['Zcaron'] = 611;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 722;
	    t['lcommaaccent'] = 278;
	    t['tcaron'] = 389;
	    t['eogonek'] = 556;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 722;
	    t['Adieresis'] = 722;
	    t['egrave'] = 556;
	    t['zacute'] = 500;
	    t['iogonek'] = 278;
	    t['Oacute'] = 778;
	    t['oacute'] = 611;
	    t['amacron'] = 556;
	    t['sacute'] = 556;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 778;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 611;
	    t['twosuperior'] = 333;
	    t['Odieresis'] = 778;
	    t['mu'] = 611;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 611;
	    t['Eogonek'] = 667;
	    t['dcroat'] = 611;
	    t['threequarters'] = 834;
	    t['Scedilla'] = 667;
	    t['lcaron'] = 400;
	    t['Kcommaaccent'] = 722;
	    t['Lacute'] = 611;
	    t['trademark'] = 1000;
	    t['edotaccent'] = 556;
	    t['Igrave'] = 278;
	    t['Imacron'] = 278;
	    t['Lcaron'] = 611;
	    t['onehalf'] = 834;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 611;
	    t['ntilde'] = 611;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 667;
	    t['emacron'] = 556;
	    t['gbreve'] = 611;
	    t['onequarter'] = 834;
	    t['Scaron'] = 667;
	    t['Scommaaccent'] = 667;
	    t['Ohungarumlaut'] = 778;
	    t['degree'] = 400;
	    t['ograve'] = 611;
	    t['Ccaron'] = 722;
	    t['ugrave'] = 611;
	    t['radical'] = 549;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 389;
	    t['Ntilde'] = 722;
	    t['otilde'] = 611;
	    t['Rcommaaccent'] = 722;
	    t['Lcommaaccent'] = 611;
	    t['Atilde'] = 722;
	    t['Aogonek'] = 722;
	    t['Aring'] = 722;
	    t['Otilde'] = 778;
	    t['zdotaccent'] = 500;
	    t['Ecaron'] = 667;
	    t['Iogonek'] = 278;
	    t['kcommaaccent'] = 556;
	    t['minus'] = 584;
	    t['Icircumflex'] = 278;
	    t['ncaron'] = 611;
	    t['tcommaaccent'] = 333;
	    t['logicalnot'] = 584;
	    t['odieresis'] = 611;
	    t['udieresis'] = 611;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 611;
	    t['eth'] = 611;
	    t['zcaron'] = 500;
	    t['ncommaaccent'] = 611;
	    t['onesuperior'] = 333;
	    t['imacron'] = 278;
	    t['Euro'] = 556;
	  });
	  t['Helvetica-BoldOblique'] = getLookupTableFactory(function (t) {
	    t['space'] = 278;
	    t['exclam'] = 333;
	    t['quotedbl'] = 474;
	    t['numbersign'] = 556;
	    t['dollar'] = 556;
	    t['percent'] = 889;
	    t['ampersand'] = 722;
	    t['quoteright'] = 278;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 389;
	    t['plus'] = 584;
	    t['comma'] = 278;
	    t['hyphen'] = 333;
	    t['period'] = 278;
	    t['slash'] = 278;
	    t['zero'] = 556;
	    t['one'] = 556;
	    t['two'] = 556;
	    t['three'] = 556;
	    t['four'] = 556;
	    t['five'] = 556;
	    t['six'] = 556;
	    t['seven'] = 556;
	    t['eight'] = 556;
	    t['nine'] = 556;
	    t['colon'] = 333;
	    t['semicolon'] = 333;
	    t['less'] = 584;
	    t['equal'] = 584;
	    t['greater'] = 584;
	    t['question'] = 611;
	    t['at'] = 975;
	    t['A'] = 722;
	    t['B'] = 722;
	    t['C'] = 722;
	    t['D'] = 722;
	    t['E'] = 667;
	    t['F'] = 611;
	    t['G'] = 778;
	    t['H'] = 722;
	    t['I'] = 278;
	    t['J'] = 556;
	    t['K'] = 722;
	    t['L'] = 611;
	    t['M'] = 833;
	    t['N'] = 722;
	    t['O'] = 778;
	    t['P'] = 667;
	    t['Q'] = 778;
	    t['R'] = 722;
	    t['S'] = 667;
	    t['T'] = 611;
	    t['U'] = 722;
	    t['V'] = 667;
	    t['W'] = 944;
	    t['X'] = 667;
	    t['Y'] = 667;
	    t['Z'] = 611;
	    t['bracketleft'] = 333;
	    t['backslash'] = 278;
	    t['bracketright'] = 333;
	    t['asciicircum'] = 584;
	    t['underscore'] = 556;
	    t['quoteleft'] = 278;
	    t['a'] = 556;
	    t['b'] = 611;
	    t['c'] = 556;
	    t['d'] = 611;
	    t['e'] = 556;
	    t['f'] = 333;
	    t['g'] = 611;
	    t['h'] = 611;
	    t['i'] = 278;
	    t['j'] = 278;
	    t['k'] = 556;
	    t['l'] = 278;
	    t['m'] = 889;
	    t['n'] = 611;
	    t['o'] = 611;
	    t['p'] = 611;
	    t['q'] = 611;
	    t['r'] = 389;
	    t['s'] = 556;
	    t['t'] = 333;
	    t['u'] = 611;
	    t['v'] = 556;
	    t['w'] = 778;
	    t['x'] = 556;
	    t['y'] = 556;
	    t['z'] = 500;
	    t['braceleft'] = 389;
	    t['bar'] = 280;
	    t['braceright'] = 389;
	    t['asciitilde'] = 584;
	    t['exclamdown'] = 333;
	    t['cent'] = 556;
	    t['sterling'] = 556;
	    t['fraction'] = 167;
	    t['yen'] = 556;
	    t['florin'] = 556;
	    t['section'] = 556;
	    t['currency'] = 556;
	    t['quotesingle'] = 238;
	    t['quotedblleft'] = 500;
	    t['guillemotleft'] = 556;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 611;
	    t['fl'] = 611;
	    t['endash'] = 556;
	    t['dagger'] = 556;
	    t['daggerdbl'] = 556;
	    t['periodcentered'] = 278;
	    t['paragraph'] = 556;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 278;
	    t['quotedblbase'] = 500;
	    t['quotedblright'] = 500;
	    t['guillemotright'] = 556;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 611;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 1000;
	    t['ordfeminine'] = 370;
	    t['Lslash'] = 611;
	    t['Oslash'] = 778;
	    t['OE'] = 1000;
	    t['ordmasculine'] = 365;
	    t['ae'] = 889;
	    t['dotlessi'] = 278;
	    t['lslash'] = 278;
	    t['oslash'] = 611;
	    t['oe'] = 944;
	    t['germandbls'] = 611;
	    t['Idieresis'] = 278;
	    t['eacute'] = 556;
	    t['abreve'] = 556;
	    t['uhungarumlaut'] = 611;
	    t['ecaron'] = 556;
	    t['Ydieresis'] = 667;
	    t['divide'] = 584;
	    t['Yacute'] = 667;
	    t['Acircumflex'] = 722;
	    t['aacute'] = 556;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 556;
	    t['scommaaccent'] = 556;
	    t['ecircumflex'] = 556;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 556;
	    t['Uacute'] = 722;
	    t['uogonek'] = 611;
	    t['Edieresis'] = 667;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 737;
	    t['Emacron'] = 667;
	    t['ccaron'] = 556;
	    t['aring'] = 556;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 278;
	    t['agrave'] = 556;
	    t['Tcommaaccent'] = 611;
	    t['Cacute'] = 722;
	    t['atilde'] = 556;
	    t['Edotaccent'] = 667;
	    t['scaron'] = 556;
	    t['scedilla'] = 556;
	    t['iacute'] = 278;
	    t['lozenge'] = 494;
	    t['Rcaron'] = 722;
	    t['Gcommaaccent'] = 778;
	    t['ucircumflex'] = 611;
	    t['acircumflex'] = 556;
	    t['Amacron'] = 722;
	    t['rcaron'] = 389;
	    t['ccedilla'] = 556;
	    t['Zdotaccent'] = 611;
	    t['Thorn'] = 667;
	    t['Omacron'] = 778;
	    t['Racute'] = 722;
	    t['Sacute'] = 667;
	    t['dcaron'] = 743;
	    t['Umacron'] = 722;
	    t['uring'] = 611;
	    t['threesuperior'] = 333;
	    t['Ograve'] = 778;
	    t['Agrave'] = 722;
	    t['Abreve'] = 722;
	    t['multiply'] = 584;
	    t['uacute'] = 611;
	    t['Tcaron'] = 611;
	    t['partialdiff'] = 494;
	    t['ydieresis'] = 556;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 667;
	    t['adieresis'] = 556;
	    t['edieresis'] = 556;
	    t['cacute'] = 556;
	    t['nacute'] = 611;
	    t['umacron'] = 611;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 278;
	    t['plusminus'] = 584;
	    t['brokenbar'] = 280;
	    t['registered'] = 737;
	    t['Gbreve'] = 778;
	    t['Idotaccent'] = 278;
	    t['summation'] = 600;
	    t['Egrave'] = 667;
	    t['racute'] = 389;
	    t['omacron'] = 611;
	    t['Zacute'] = 611;
	    t['Zcaron'] = 611;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 722;
	    t['lcommaaccent'] = 278;
	    t['tcaron'] = 389;
	    t['eogonek'] = 556;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 722;
	    t['Adieresis'] = 722;
	    t['egrave'] = 556;
	    t['zacute'] = 500;
	    t['iogonek'] = 278;
	    t['Oacute'] = 778;
	    t['oacute'] = 611;
	    t['amacron'] = 556;
	    t['sacute'] = 556;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 778;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 611;
	    t['twosuperior'] = 333;
	    t['Odieresis'] = 778;
	    t['mu'] = 611;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 611;
	    t['Eogonek'] = 667;
	    t['dcroat'] = 611;
	    t['threequarters'] = 834;
	    t['Scedilla'] = 667;
	    t['lcaron'] = 400;
	    t['Kcommaaccent'] = 722;
	    t['Lacute'] = 611;
	    t['trademark'] = 1000;
	    t['edotaccent'] = 556;
	    t['Igrave'] = 278;
	    t['Imacron'] = 278;
	    t['Lcaron'] = 611;
	    t['onehalf'] = 834;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 611;
	    t['ntilde'] = 611;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 667;
	    t['emacron'] = 556;
	    t['gbreve'] = 611;
	    t['onequarter'] = 834;
	    t['Scaron'] = 667;
	    t['Scommaaccent'] = 667;
	    t['Ohungarumlaut'] = 778;
	    t['degree'] = 400;
	    t['ograve'] = 611;
	    t['Ccaron'] = 722;
	    t['ugrave'] = 611;
	    t['radical'] = 549;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 389;
	    t['Ntilde'] = 722;
	    t['otilde'] = 611;
	    t['Rcommaaccent'] = 722;
	    t['Lcommaaccent'] = 611;
	    t['Atilde'] = 722;
	    t['Aogonek'] = 722;
	    t['Aring'] = 722;
	    t['Otilde'] = 778;
	    t['zdotaccent'] = 500;
	    t['Ecaron'] = 667;
	    t['Iogonek'] = 278;
	    t['kcommaaccent'] = 556;
	    t['minus'] = 584;
	    t['Icircumflex'] = 278;
	    t['ncaron'] = 611;
	    t['tcommaaccent'] = 333;
	    t['logicalnot'] = 584;
	    t['odieresis'] = 611;
	    t['udieresis'] = 611;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 611;
	    t['eth'] = 611;
	    t['zcaron'] = 500;
	    t['ncommaaccent'] = 611;
	    t['onesuperior'] = 333;
	    t['imacron'] = 278;
	    t['Euro'] = 556;
	  });
	  t['Helvetica-Oblique'] = getLookupTableFactory(function (t) {
	    t['space'] = 278;
	    t['exclam'] = 278;
	    t['quotedbl'] = 355;
	    t['numbersign'] = 556;
	    t['dollar'] = 556;
	    t['percent'] = 889;
	    t['ampersand'] = 667;
	    t['quoteright'] = 222;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 389;
	    t['plus'] = 584;
	    t['comma'] = 278;
	    t['hyphen'] = 333;
	    t['period'] = 278;
	    t['slash'] = 278;
	    t['zero'] = 556;
	    t['one'] = 556;
	    t['two'] = 556;
	    t['three'] = 556;
	    t['four'] = 556;
	    t['five'] = 556;
	    t['six'] = 556;
	    t['seven'] = 556;
	    t['eight'] = 556;
	    t['nine'] = 556;
	    t['colon'] = 278;
	    t['semicolon'] = 278;
	    t['less'] = 584;
	    t['equal'] = 584;
	    t['greater'] = 584;
	    t['question'] = 556;
	    t['at'] = 1015;
	    t['A'] = 667;
	    t['B'] = 667;
	    t['C'] = 722;
	    t['D'] = 722;
	    t['E'] = 667;
	    t['F'] = 611;
	    t['G'] = 778;
	    t['H'] = 722;
	    t['I'] = 278;
	    t['J'] = 500;
	    t['K'] = 667;
	    t['L'] = 556;
	    t['M'] = 833;
	    t['N'] = 722;
	    t['O'] = 778;
	    t['P'] = 667;
	    t['Q'] = 778;
	    t['R'] = 722;
	    t['S'] = 667;
	    t['T'] = 611;
	    t['U'] = 722;
	    t['V'] = 667;
	    t['W'] = 944;
	    t['X'] = 667;
	    t['Y'] = 667;
	    t['Z'] = 611;
	    t['bracketleft'] = 278;
	    t['backslash'] = 278;
	    t['bracketright'] = 278;
	    t['asciicircum'] = 469;
	    t['underscore'] = 556;
	    t['quoteleft'] = 222;
	    t['a'] = 556;
	    t['b'] = 556;
	    t['c'] = 500;
	    t['d'] = 556;
	    t['e'] = 556;
	    t['f'] = 278;
	    t['g'] = 556;
	    t['h'] = 556;
	    t['i'] = 222;
	    t['j'] = 222;
	    t['k'] = 500;
	    t['l'] = 222;
	    t['m'] = 833;
	    t['n'] = 556;
	    t['o'] = 556;
	    t['p'] = 556;
	    t['q'] = 556;
	    t['r'] = 333;
	    t['s'] = 500;
	    t['t'] = 278;
	    t['u'] = 556;
	    t['v'] = 500;
	    t['w'] = 722;
	    t['x'] = 500;
	    t['y'] = 500;
	    t['z'] = 500;
	    t['braceleft'] = 334;
	    t['bar'] = 260;
	    t['braceright'] = 334;
	    t['asciitilde'] = 584;
	    t['exclamdown'] = 333;
	    t['cent'] = 556;
	    t['sterling'] = 556;
	    t['fraction'] = 167;
	    t['yen'] = 556;
	    t['florin'] = 556;
	    t['section'] = 556;
	    t['currency'] = 556;
	    t['quotesingle'] = 191;
	    t['quotedblleft'] = 333;
	    t['guillemotleft'] = 556;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 500;
	    t['fl'] = 500;
	    t['endash'] = 556;
	    t['dagger'] = 556;
	    t['daggerdbl'] = 556;
	    t['periodcentered'] = 278;
	    t['paragraph'] = 537;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 222;
	    t['quotedblbase'] = 333;
	    t['quotedblright'] = 333;
	    t['guillemotright'] = 556;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 611;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 1000;
	    t['ordfeminine'] = 370;
	    t['Lslash'] = 556;
	    t['Oslash'] = 778;
	    t['OE'] = 1000;
	    t['ordmasculine'] = 365;
	    t['ae'] = 889;
	    t['dotlessi'] = 278;
	    t['lslash'] = 222;
	    t['oslash'] = 611;
	    t['oe'] = 944;
	    t['germandbls'] = 611;
	    t['Idieresis'] = 278;
	    t['eacute'] = 556;
	    t['abreve'] = 556;
	    t['uhungarumlaut'] = 556;
	    t['ecaron'] = 556;
	    t['Ydieresis'] = 667;
	    t['divide'] = 584;
	    t['Yacute'] = 667;
	    t['Acircumflex'] = 667;
	    t['aacute'] = 556;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 500;
	    t['scommaaccent'] = 500;
	    t['ecircumflex'] = 556;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 556;
	    t['Uacute'] = 722;
	    t['uogonek'] = 556;
	    t['Edieresis'] = 667;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 737;
	    t['Emacron'] = 667;
	    t['ccaron'] = 500;
	    t['aring'] = 556;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 222;
	    t['agrave'] = 556;
	    t['Tcommaaccent'] = 611;
	    t['Cacute'] = 722;
	    t['atilde'] = 556;
	    t['Edotaccent'] = 667;
	    t['scaron'] = 500;
	    t['scedilla'] = 500;
	    t['iacute'] = 278;
	    t['lozenge'] = 471;
	    t['Rcaron'] = 722;
	    t['Gcommaaccent'] = 778;
	    t['ucircumflex'] = 556;
	    t['acircumflex'] = 556;
	    t['Amacron'] = 667;
	    t['rcaron'] = 333;
	    t['ccedilla'] = 500;
	    t['Zdotaccent'] = 611;
	    t['Thorn'] = 667;
	    t['Omacron'] = 778;
	    t['Racute'] = 722;
	    t['Sacute'] = 667;
	    t['dcaron'] = 643;
	    t['Umacron'] = 722;
	    t['uring'] = 556;
	    t['threesuperior'] = 333;
	    t['Ograve'] = 778;
	    t['Agrave'] = 667;
	    t['Abreve'] = 667;
	    t['multiply'] = 584;
	    t['uacute'] = 556;
	    t['Tcaron'] = 611;
	    t['partialdiff'] = 476;
	    t['ydieresis'] = 500;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 667;
	    t['adieresis'] = 556;
	    t['edieresis'] = 556;
	    t['cacute'] = 500;
	    t['nacute'] = 556;
	    t['umacron'] = 556;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 278;
	    t['plusminus'] = 584;
	    t['brokenbar'] = 260;
	    t['registered'] = 737;
	    t['Gbreve'] = 778;
	    t['Idotaccent'] = 278;
	    t['summation'] = 600;
	    t['Egrave'] = 667;
	    t['racute'] = 333;
	    t['omacron'] = 556;
	    t['Zacute'] = 611;
	    t['Zcaron'] = 611;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 722;
	    t['lcommaaccent'] = 222;
	    t['tcaron'] = 317;
	    t['eogonek'] = 556;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 667;
	    t['Adieresis'] = 667;
	    t['egrave'] = 556;
	    t['zacute'] = 500;
	    t['iogonek'] = 222;
	    t['Oacute'] = 778;
	    t['oacute'] = 556;
	    t['amacron'] = 556;
	    t['sacute'] = 500;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 778;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 556;
	    t['twosuperior'] = 333;
	    t['Odieresis'] = 778;
	    t['mu'] = 556;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 556;
	    t['Eogonek'] = 667;
	    t['dcroat'] = 556;
	    t['threequarters'] = 834;
	    t['Scedilla'] = 667;
	    t['lcaron'] = 299;
	    t['Kcommaaccent'] = 667;
	    t['Lacute'] = 556;
	    t['trademark'] = 1000;
	    t['edotaccent'] = 556;
	    t['Igrave'] = 278;
	    t['Imacron'] = 278;
	    t['Lcaron'] = 556;
	    t['onehalf'] = 834;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 556;
	    t['ntilde'] = 556;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 667;
	    t['emacron'] = 556;
	    t['gbreve'] = 556;
	    t['onequarter'] = 834;
	    t['Scaron'] = 667;
	    t['Scommaaccent'] = 667;
	    t['Ohungarumlaut'] = 778;
	    t['degree'] = 400;
	    t['ograve'] = 556;
	    t['Ccaron'] = 722;
	    t['ugrave'] = 556;
	    t['radical'] = 453;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 333;
	    t['Ntilde'] = 722;
	    t['otilde'] = 556;
	    t['Rcommaaccent'] = 722;
	    t['Lcommaaccent'] = 556;
	    t['Atilde'] = 667;
	    t['Aogonek'] = 667;
	    t['Aring'] = 667;
	    t['Otilde'] = 778;
	    t['zdotaccent'] = 500;
	    t['Ecaron'] = 667;
	    t['Iogonek'] = 278;
	    t['kcommaaccent'] = 500;
	    t['minus'] = 584;
	    t['Icircumflex'] = 278;
	    t['ncaron'] = 556;
	    t['tcommaaccent'] = 278;
	    t['logicalnot'] = 584;
	    t['odieresis'] = 556;
	    t['udieresis'] = 556;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 556;
	    t['eth'] = 556;
	    t['zcaron'] = 500;
	    t['ncommaaccent'] = 556;
	    t['onesuperior'] = 333;
	    t['imacron'] = 278;
	    t['Euro'] = 556;
	  });
	  t['Symbol'] = getLookupTableFactory(function (t) {
	    t['space'] = 250;
	    t['exclam'] = 333;
	    t['universal'] = 713;
	    t['numbersign'] = 500;
	    t['existential'] = 549;
	    t['percent'] = 833;
	    t['ampersand'] = 778;
	    t['suchthat'] = 439;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asteriskmath'] = 500;
	    t['plus'] = 549;
	    t['comma'] = 250;
	    t['minus'] = 549;
	    t['period'] = 250;
	    t['slash'] = 278;
	    t['zero'] = 500;
	    t['one'] = 500;
	    t['two'] = 500;
	    t['three'] = 500;
	    t['four'] = 500;
	    t['five'] = 500;
	    t['six'] = 500;
	    t['seven'] = 500;
	    t['eight'] = 500;
	    t['nine'] = 500;
	    t['colon'] = 278;
	    t['semicolon'] = 278;
	    t['less'] = 549;
	    t['equal'] = 549;
	    t['greater'] = 549;
	    t['question'] = 444;
	    t['congruent'] = 549;
	    t['Alpha'] = 722;
	    t['Beta'] = 667;
	    t['Chi'] = 722;
	    t['Delta'] = 612;
	    t['Epsilon'] = 611;
	    t['Phi'] = 763;
	    t['Gamma'] = 603;
	    t['Eta'] = 722;
	    t['Iota'] = 333;
	    t['theta1'] = 631;
	    t['Kappa'] = 722;
	    t['Lambda'] = 686;
	    t['Mu'] = 889;
	    t['Nu'] = 722;
	    t['Omicron'] = 722;
	    t['Pi'] = 768;
	    t['Theta'] = 741;
	    t['Rho'] = 556;
	    t['Sigma'] = 592;
	    t['Tau'] = 611;
	    t['Upsilon'] = 690;
	    t['sigma1'] = 439;
	    t['Omega'] = 768;
	    t['Xi'] = 645;
	    t['Psi'] = 795;
	    t['Zeta'] = 611;
	    t['bracketleft'] = 333;
	    t['therefore'] = 863;
	    t['bracketright'] = 333;
	    t['perpendicular'] = 658;
	    t['underscore'] = 500;
	    t['radicalex'] = 500;
	    t['alpha'] = 631;
	    t['beta'] = 549;
	    t['chi'] = 549;
	    t['delta'] = 494;
	    t['epsilon'] = 439;
	    t['phi'] = 521;
	    t['gamma'] = 411;
	    t['eta'] = 603;
	    t['iota'] = 329;
	    t['phi1'] = 603;
	    t['kappa'] = 549;
	    t['lambda'] = 549;
	    t['mu'] = 576;
	    t['nu'] = 521;
	    t['omicron'] = 549;
	    t['pi'] = 549;
	    t['theta'] = 521;
	    t['rho'] = 549;
	    t['sigma'] = 603;
	    t['tau'] = 439;
	    t['upsilon'] = 576;
	    t['omega1'] = 713;
	    t['omega'] = 686;
	    t['xi'] = 493;
	    t['psi'] = 686;
	    t['zeta'] = 494;
	    t['braceleft'] = 480;
	    t['bar'] = 200;
	    t['braceright'] = 480;
	    t['similar'] = 549;
	    t['Euro'] = 750;
	    t['Upsilon1'] = 620;
	    t['minute'] = 247;
	    t['lessequal'] = 549;
	    t['fraction'] = 167;
	    t['infinity'] = 713;
	    t['florin'] = 500;
	    t['club'] = 753;
	    t['diamond'] = 753;
	    t['heart'] = 753;
	    t['spade'] = 753;
	    t['arrowboth'] = 1042;
	    t['arrowleft'] = 987;
	    t['arrowup'] = 603;
	    t['arrowright'] = 987;
	    t['arrowdown'] = 603;
	    t['degree'] = 400;
	    t['plusminus'] = 549;
	    t['second'] = 411;
	    t['greaterequal'] = 549;
	    t['multiply'] = 549;
	    t['proportional'] = 713;
	    t['partialdiff'] = 494;
	    t['bullet'] = 460;
	    t['divide'] = 549;
	    t['notequal'] = 549;
	    t['equivalence'] = 549;
	    t['approxequal'] = 549;
	    t['ellipsis'] = 1000;
	    t['arrowvertex'] = 603;
	    t['arrowhorizex'] = 1000;
	    t['carriagereturn'] = 658;
	    t['aleph'] = 823;
	    t['Ifraktur'] = 686;
	    t['Rfraktur'] = 795;
	    t['weierstrass'] = 987;
	    t['circlemultiply'] = 768;
	    t['circleplus'] = 768;
	    t['emptyset'] = 823;
	    t['intersection'] = 768;
	    t['union'] = 768;
	    t['propersuperset'] = 713;
	    t['reflexsuperset'] = 713;
	    t['notsubset'] = 713;
	    t['propersubset'] = 713;
	    t['reflexsubset'] = 713;
	    t['element'] = 713;
	    t['notelement'] = 713;
	    t['angle'] = 768;
	    t['gradient'] = 713;
	    t['registerserif'] = 790;
	    t['copyrightserif'] = 790;
	    t['trademarkserif'] = 890;
	    t['product'] = 823;
	    t['radical'] = 549;
	    t['dotmath'] = 250;
	    t['logicalnot'] = 713;
	    t['logicaland'] = 603;
	    t['logicalor'] = 603;
	    t['arrowdblboth'] = 1042;
	    t['arrowdblleft'] = 987;
	    t['arrowdblup'] = 603;
	    t['arrowdblright'] = 987;
	    t['arrowdbldown'] = 603;
	    t['lozenge'] = 494;
	    t['angleleft'] = 329;
	    t['registersans'] = 790;
	    t['copyrightsans'] = 790;
	    t['trademarksans'] = 786;
	    t['summation'] = 713;
	    t['parenlefttp'] = 384;
	    t['parenleftex'] = 384;
	    t['parenleftbt'] = 384;
	    t['bracketlefttp'] = 384;
	    t['bracketleftex'] = 384;
	    t['bracketleftbt'] = 384;
	    t['bracelefttp'] = 494;
	    t['braceleftmid'] = 494;
	    t['braceleftbt'] = 494;
	    t['braceex'] = 494;
	    t['angleright'] = 329;
	    t['integral'] = 274;
	    t['integraltp'] = 686;
	    t['integralex'] = 686;
	    t['integralbt'] = 686;
	    t['parenrighttp'] = 384;
	    t['parenrightex'] = 384;
	    t['parenrightbt'] = 384;
	    t['bracketrighttp'] = 384;
	    t['bracketrightex'] = 384;
	    t['bracketrightbt'] = 384;
	    t['bracerighttp'] = 494;
	    t['bracerightmid'] = 494;
	    t['bracerightbt'] = 494;
	    t['apple'] = 790;
	  });
	  t['Times-Roman'] = getLookupTableFactory(function (t) {
	    t['space'] = 250;
	    t['exclam'] = 333;
	    t['quotedbl'] = 408;
	    t['numbersign'] = 500;
	    t['dollar'] = 500;
	    t['percent'] = 833;
	    t['ampersand'] = 778;
	    t['quoteright'] = 333;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 500;
	    t['plus'] = 564;
	    t['comma'] = 250;
	    t['hyphen'] = 333;
	    t['period'] = 250;
	    t['slash'] = 278;
	    t['zero'] = 500;
	    t['one'] = 500;
	    t['two'] = 500;
	    t['three'] = 500;
	    t['four'] = 500;
	    t['five'] = 500;
	    t['six'] = 500;
	    t['seven'] = 500;
	    t['eight'] = 500;
	    t['nine'] = 500;
	    t['colon'] = 278;
	    t['semicolon'] = 278;
	    t['less'] = 564;
	    t['equal'] = 564;
	    t['greater'] = 564;
	    t['question'] = 444;
	    t['at'] = 921;
	    t['A'] = 722;
	    t['B'] = 667;
	    t['C'] = 667;
	    t['D'] = 722;
	    t['E'] = 611;
	    t['F'] = 556;
	    t['G'] = 722;
	    t['H'] = 722;
	    t['I'] = 333;
	    t['J'] = 389;
	    t['K'] = 722;
	    t['L'] = 611;
	    t['M'] = 889;
	    t['N'] = 722;
	    t['O'] = 722;
	    t['P'] = 556;
	    t['Q'] = 722;
	    t['R'] = 667;
	    t['S'] = 556;
	    t['T'] = 611;
	    t['U'] = 722;
	    t['V'] = 722;
	    t['W'] = 944;
	    t['X'] = 722;
	    t['Y'] = 722;
	    t['Z'] = 611;
	    t['bracketleft'] = 333;
	    t['backslash'] = 278;
	    t['bracketright'] = 333;
	    t['asciicircum'] = 469;
	    t['underscore'] = 500;
	    t['quoteleft'] = 333;
	    t['a'] = 444;
	    t['b'] = 500;
	    t['c'] = 444;
	    t['d'] = 500;
	    t['e'] = 444;
	    t['f'] = 333;
	    t['g'] = 500;
	    t['h'] = 500;
	    t['i'] = 278;
	    t['j'] = 278;
	    t['k'] = 500;
	    t['l'] = 278;
	    t['m'] = 778;
	    t['n'] = 500;
	    t['o'] = 500;
	    t['p'] = 500;
	    t['q'] = 500;
	    t['r'] = 333;
	    t['s'] = 389;
	    t['t'] = 278;
	    t['u'] = 500;
	    t['v'] = 500;
	    t['w'] = 722;
	    t['x'] = 500;
	    t['y'] = 500;
	    t['z'] = 444;
	    t['braceleft'] = 480;
	    t['bar'] = 200;
	    t['braceright'] = 480;
	    t['asciitilde'] = 541;
	    t['exclamdown'] = 333;
	    t['cent'] = 500;
	    t['sterling'] = 500;
	    t['fraction'] = 167;
	    t['yen'] = 500;
	    t['florin'] = 500;
	    t['section'] = 500;
	    t['currency'] = 500;
	    t['quotesingle'] = 180;
	    t['quotedblleft'] = 444;
	    t['guillemotleft'] = 500;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 556;
	    t['fl'] = 556;
	    t['endash'] = 500;
	    t['dagger'] = 500;
	    t['daggerdbl'] = 500;
	    t['periodcentered'] = 250;
	    t['paragraph'] = 453;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 333;
	    t['quotedblbase'] = 444;
	    t['quotedblright'] = 444;
	    t['guillemotright'] = 500;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 444;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 889;
	    t['ordfeminine'] = 276;
	    t['Lslash'] = 611;
	    t['Oslash'] = 722;
	    t['OE'] = 889;
	    t['ordmasculine'] = 310;
	    t['ae'] = 667;
	    t['dotlessi'] = 278;
	    t['lslash'] = 278;
	    t['oslash'] = 500;
	    t['oe'] = 722;
	    t['germandbls'] = 500;
	    t['Idieresis'] = 333;
	    t['eacute'] = 444;
	    t['abreve'] = 444;
	    t['uhungarumlaut'] = 500;
	    t['ecaron'] = 444;
	    t['Ydieresis'] = 722;
	    t['divide'] = 564;
	    t['Yacute'] = 722;
	    t['Acircumflex'] = 722;
	    t['aacute'] = 444;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 500;
	    t['scommaaccent'] = 389;
	    t['ecircumflex'] = 444;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 444;
	    t['Uacute'] = 722;
	    t['uogonek'] = 500;
	    t['Edieresis'] = 611;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 760;
	    t['Emacron'] = 611;
	    t['ccaron'] = 444;
	    t['aring'] = 444;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 278;
	    t['agrave'] = 444;
	    t['Tcommaaccent'] = 611;
	    t['Cacute'] = 667;
	    t['atilde'] = 444;
	    t['Edotaccent'] = 611;
	    t['scaron'] = 389;
	    t['scedilla'] = 389;
	    t['iacute'] = 278;
	    t['lozenge'] = 471;
	    t['Rcaron'] = 667;
	    t['Gcommaaccent'] = 722;
	    t['ucircumflex'] = 500;
	    t['acircumflex'] = 444;
	    t['Amacron'] = 722;
	    t['rcaron'] = 333;
	    t['ccedilla'] = 444;
	    t['Zdotaccent'] = 611;
	    t['Thorn'] = 556;
	    t['Omacron'] = 722;
	    t['Racute'] = 667;
	    t['Sacute'] = 556;
	    t['dcaron'] = 588;
	    t['Umacron'] = 722;
	    t['uring'] = 500;
	    t['threesuperior'] = 300;
	    t['Ograve'] = 722;
	    t['Agrave'] = 722;
	    t['Abreve'] = 722;
	    t['multiply'] = 564;
	    t['uacute'] = 500;
	    t['Tcaron'] = 611;
	    t['partialdiff'] = 476;
	    t['ydieresis'] = 500;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 611;
	    t['adieresis'] = 444;
	    t['edieresis'] = 444;
	    t['cacute'] = 444;
	    t['nacute'] = 500;
	    t['umacron'] = 500;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 333;
	    t['plusminus'] = 564;
	    t['brokenbar'] = 200;
	    t['registered'] = 760;
	    t['Gbreve'] = 722;
	    t['Idotaccent'] = 333;
	    t['summation'] = 600;
	    t['Egrave'] = 611;
	    t['racute'] = 333;
	    t['omacron'] = 500;
	    t['Zacute'] = 611;
	    t['Zcaron'] = 611;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 667;
	    t['lcommaaccent'] = 278;
	    t['tcaron'] = 326;
	    t['eogonek'] = 444;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 722;
	    t['Adieresis'] = 722;
	    t['egrave'] = 444;
	    t['zacute'] = 444;
	    t['iogonek'] = 278;
	    t['Oacute'] = 722;
	    t['oacute'] = 500;
	    t['amacron'] = 444;
	    t['sacute'] = 389;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 722;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 500;
	    t['twosuperior'] = 300;
	    t['Odieresis'] = 722;
	    t['mu'] = 500;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 500;
	    t['Eogonek'] = 611;
	    t['dcroat'] = 500;
	    t['threequarters'] = 750;
	    t['Scedilla'] = 556;
	    t['lcaron'] = 344;
	    t['Kcommaaccent'] = 722;
	    t['Lacute'] = 611;
	    t['trademark'] = 980;
	    t['edotaccent'] = 444;
	    t['Igrave'] = 333;
	    t['Imacron'] = 333;
	    t['Lcaron'] = 611;
	    t['onehalf'] = 750;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 500;
	    t['ntilde'] = 500;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 611;
	    t['emacron'] = 444;
	    t['gbreve'] = 500;
	    t['onequarter'] = 750;
	    t['Scaron'] = 556;
	    t['Scommaaccent'] = 556;
	    t['Ohungarumlaut'] = 722;
	    t['degree'] = 400;
	    t['ograve'] = 500;
	    t['Ccaron'] = 667;
	    t['ugrave'] = 500;
	    t['radical'] = 453;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 333;
	    t['Ntilde'] = 722;
	    t['otilde'] = 500;
	    t['Rcommaaccent'] = 667;
	    t['Lcommaaccent'] = 611;
	    t['Atilde'] = 722;
	    t['Aogonek'] = 722;
	    t['Aring'] = 722;
	    t['Otilde'] = 722;
	    t['zdotaccent'] = 444;
	    t['Ecaron'] = 611;
	    t['Iogonek'] = 333;
	    t['kcommaaccent'] = 500;
	    t['minus'] = 564;
	    t['Icircumflex'] = 333;
	    t['ncaron'] = 500;
	    t['tcommaaccent'] = 278;
	    t['logicalnot'] = 564;
	    t['odieresis'] = 500;
	    t['udieresis'] = 500;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 500;
	    t['eth'] = 500;
	    t['zcaron'] = 444;
	    t['ncommaaccent'] = 500;
	    t['onesuperior'] = 300;
	    t['imacron'] = 278;
	    t['Euro'] = 500;
	  });
	  t['Times-Bold'] = getLookupTableFactory(function (t) {
	    t['space'] = 250;
	    t['exclam'] = 333;
	    t['quotedbl'] = 555;
	    t['numbersign'] = 500;
	    t['dollar'] = 500;
	    t['percent'] = 1000;
	    t['ampersand'] = 833;
	    t['quoteright'] = 333;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 500;
	    t['plus'] = 570;
	    t['comma'] = 250;
	    t['hyphen'] = 333;
	    t['period'] = 250;
	    t['slash'] = 278;
	    t['zero'] = 500;
	    t['one'] = 500;
	    t['two'] = 500;
	    t['three'] = 500;
	    t['four'] = 500;
	    t['five'] = 500;
	    t['six'] = 500;
	    t['seven'] = 500;
	    t['eight'] = 500;
	    t['nine'] = 500;
	    t['colon'] = 333;
	    t['semicolon'] = 333;
	    t['less'] = 570;
	    t['equal'] = 570;
	    t['greater'] = 570;
	    t['question'] = 500;
	    t['at'] = 930;
	    t['A'] = 722;
	    t['B'] = 667;
	    t['C'] = 722;
	    t['D'] = 722;
	    t['E'] = 667;
	    t['F'] = 611;
	    t['G'] = 778;
	    t['H'] = 778;
	    t['I'] = 389;
	    t['J'] = 500;
	    t['K'] = 778;
	    t['L'] = 667;
	    t['M'] = 944;
	    t['N'] = 722;
	    t['O'] = 778;
	    t['P'] = 611;
	    t['Q'] = 778;
	    t['R'] = 722;
	    t['S'] = 556;
	    t['T'] = 667;
	    t['U'] = 722;
	    t['V'] = 722;
	    t['W'] = 1000;
	    t['X'] = 722;
	    t['Y'] = 722;
	    t['Z'] = 667;
	    t['bracketleft'] = 333;
	    t['backslash'] = 278;
	    t['bracketright'] = 333;
	    t['asciicircum'] = 581;
	    t['underscore'] = 500;
	    t['quoteleft'] = 333;
	    t['a'] = 500;
	    t['b'] = 556;
	    t['c'] = 444;
	    t['d'] = 556;
	    t['e'] = 444;
	    t['f'] = 333;
	    t['g'] = 500;
	    t['h'] = 556;
	    t['i'] = 278;
	    t['j'] = 333;
	    t['k'] = 556;
	    t['l'] = 278;
	    t['m'] = 833;
	    t['n'] = 556;
	    t['o'] = 500;
	    t['p'] = 556;
	    t['q'] = 556;
	    t['r'] = 444;
	    t['s'] = 389;
	    t['t'] = 333;
	    t['u'] = 556;
	    t['v'] = 500;
	    t['w'] = 722;
	    t['x'] = 500;
	    t['y'] = 500;
	    t['z'] = 444;
	    t['braceleft'] = 394;
	    t['bar'] = 220;
	    t['braceright'] = 394;
	    t['asciitilde'] = 520;
	    t['exclamdown'] = 333;
	    t['cent'] = 500;
	    t['sterling'] = 500;
	    t['fraction'] = 167;
	    t['yen'] = 500;
	    t['florin'] = 500;
	    t['section'] = 500;
	    t['currency'] = 500;
	    t['quotesingle'] = 278;
	    t['quotedblleft'] = 500;
	    t['guillemotleft'] = 500;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 556;
	    t['fl'] = 556;
	    t['endash'] = 500;
	    t['dagger'] = 500;
	    t['daggerdbl'] = 500;
	    t['periodcentered'] = 250;
	    t['paragraph'] = 540;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 333;
	    t['quotedblbase'] = 500;
	    t['quotedblright'] = 500;
	    t['guillemotright'] = 500;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 500;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 1000;
	    t['ordfeminine'] = 300;
	    t['Lslash'] = 667;
	    t['Oslash'] = 778;
	    t['OE'] = 1000;
	    t['ordmasculine'] = 330;
	    t['ae'] = 722;
	    t['dotlessi'] = 278;
	    t['lslash'] = 278;
	    t['oslash'] = 500;
	    t['oe'] = 722;
	    t['germandbls'] = 556;
	    t['Idieresis'] = 389;
	    t['eacute'] = 444;
	    t['abreve'] = 500;
	    t['uhungarumlaut'] = 556;
	    t['ecaron'] = 444;
	    t['Ydieresis'] = 722;
	    t['divide'] = 570;
	    t['Yacute'] = 722;
	    t['Acircumflex'] = 722;
	    t['aacute'] = 500;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 500;
	    t['scommaaccent'] = 389;
	    t['ecircumflex'] = 444;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 500;
	    t['Uacute'] = 722;
	    t['uogonek'] = 556;
	    t['Edieresis'] = 667;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 747;
	    t['Emacron'] = 667;
	    t['ccaron'] = 444;
	    t['aring'] = 500;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 278;
	    t['agrave'] = 500;
	    t['Tcommaaccent'] = 667;
	    t['Cacute'] = 722;
	    t['atilde'] = 500;
	    t['Edotaccent'] = 667;
	    t['scaron'] = 389;
	    t['scedilla'] = 389;
	    t['iacute'] = 278;
	    t['lozenge'] = 494;
	    t['Rcaron'] = 722;
	    t['Gcommaaccent'] = 778;
	    t['ucircumflex'] = 556;
	    t['acircumflex'] = 500;
	    t['Amacron'] = 722;
	    t['rcaron'] = 444;
	    t['ccedilla'] = 444;
	    t['Zdotaccent'] = 667;
	    t['Thorn'] = 611;
	    t['Omacron'] = 778;
	    t['Racute'] = 722;
	    t['Sacute'] = 556;
	    t['dcaron'] = 672;
	    t['Umacron'] = 722;
	    t['uring'] = 556;
	    t['threesuperior'] = 300;
	    t['Ograve'] = 778;
	    t['Agrave'] = 722;
	    t['Abreve'] = 722;
	    t['multiply'] = 570;
	    t['uacute'] = 556;
	    t['Tcaron'] = 667;
	    t['partialdiff'] = 494;
	    t['ydieresis'] = 500;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 667;
	    t['adieresis'] = 500;
	    t['edieresis'] = 444;
	    t['cacute'] = 444;
	    t['nacute'] = 556;
	    t['umacron'] = 556;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 389;
	    t['plusminus'] = 570;
	    t['brokenbar'] = 220;
	    t['registered'] = 747;
	    t['Gbreve'] = 778;
	    t['Idotaccent'] = 389;
	    t['summation'] = 600;
	    t['Egrave'] = 667;
	    t['racute'] = 444;
	    t['omacron'] = 500;
	    t['Zacute'] = 667;
	    t['Zcaron'] = 667;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 722;
	    t['lcommaaccent'] = 278;
	    t['tcaron'] = 416;
	    t['eogonek'] = 444;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 722;
	    t['Adieresis'] = 722;
	    t['egrave'] = 444;
	    t['zacute'] = 444;
	    t['iogonek'] = 278;
	    t['Oacute'] = 778;
	    t['oacute'] = 500;
	    t['amacron'] = 500;
	    t['sacute'] = 389;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 778;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 556;
	    t['twosuperior'] = 300;
	    t['Odieresis'] = 778;
	    t['mu'] = 556;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 500;
	    t['Eogonek'] = 667;
	    t['dcroat'] = 556;
	    t['threequarters'] = 750;
	    t['Scedilla'] = 556;
	    t['lcaron'] = 394;
	    t['Kcommaaccent'] = 778;
	    t['Lacute'] = 667;
	    t['trademark'] = 1000;
	    t['edotaccent'] = 444;
	    t['Igrave'] = 389;
	    t['Imacron'] = 389;
	    t['Lcaron'] = 667;
	    t['onehalf'] = 750;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 500;
	    t['ntilde'] = 556;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 667;
	    t['emacron'] = 444;
	    t['gbreve'] = 500;
	    t['onequarter'] = 750;
	    t['Scaron'] = 556;
	    t['Scommaaccent'] = 556;
	    t['Ohungarumlaut'] = 778;
	    t['degree'] = 400;
	    t['ograve'] = 500;
	    t['Ccaron'] = 722;
	    t['ugrave'] = 556;
	    t['radical'] = 549;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 444;
	    t['Ntilde'] = 722;
	    t['otilde'] = 500;
	    t['Rcommaaccent'] = 722;
	    t['Lcommaaccent'] = 667;
	    t['Atilde'] = 722;
	    t['Aogonek'] = 722;
	    t['Aring'] = 722;
	    t['Otilde'] = 778;
	    t['zdotaccent'] = 444;
	    t['Ecaron'] = 667;
	    t['Iogonek'] = 389;
	    t['kcommaaccent'] = 556;
	    t['minus'] = 570;
	    t['Icircumflex'] = 389;
	    t['ncaron'] = 556;
	    t['tcommaaccent'] = 333;
	    t['logicalnot'] = 570;
	    t['odieresis'] = 500;
	    t['udieresis'] = 556;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 500;
	    t['eth'] = 500;
	    t['zcaron'] = 444;
	    t['ncommaaccent'] = 556;
	    t['onesuperior'] = 300;
	    t['imacron'] = 278;
	    t['Euro'] = 500;
	  });
	  t['Times-BoldItalic'] = getLookupTableFactory(function (t) {
	    t['space'] = 250;
	    t['exclam'] = 389;
	    t['quotedbl'] = 555;
	    t['numbersign'] = 500;
	    t['dollar'] = 500;
	    t['percent'] = 833;
	    t['ampersand'] = 778;
	    t['quoteright'] = 333;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 500;
	    t['plus'] = 570;
	    t['comma'] = 250;
	    t['hyphen'] = 333;
	    t['period'] = 250;
	    t['slash'] = 278;
	    t['zero'] = 500;
	    t['one'] = 500;
	    t['two'] = 500;
	    t['three'] = 500;
	    t['four'] = 500;
	    t['five'] = 500;
	    t['six'] = 500;
	    t['seven'] = 500;
	    t['eight'] = 500;
	    t['nine'] = 500;
	    t['colon'] = 333;
	    t['semicolon'] = 333;
	    t['less'] = 570;
	    t['equal'] = 570;
	    t['greater'] = 570;
	    t['question'] = 500;
	    t['at'] = 832;
	    t['A'] = 667;
	    t['B'] = 667;
	    t['C'] = 667;
	    t['D'] = 722;
	    t['E'] = 667;
	    t['F'] = 667;
	    t['G'] = 722;
	    t['H'] = 778;
	    t['I'] = 389;
	    t['J'] = 500;
	    t['K'] = 667;
	    t['L'] = 611;
	    t['M'] = 889;
	    t['N'] = 722;
	    t['O'] = 722;
	    t['P'] = 611;
	    t['Q'] = 722;
	    t['R'] = 667;
	    t['S'] = 556;
	    t['T'] = 611;
	    t['U'] = 722;
	    t['V'] = 667;
	    t['W'] = 889;
	    t['X'] = 667;
	    t['Y'] = 611;
	    t['Z'] = 611;
	    t['bracketleft'] = 333;
	    t['backslash'] = 278;
	    t['bracketright'] = 333;
	    t['asciicircum'] = 570;
	    t['underscore'] = 500;
	    t['quoteleft'] = 333;
	    t['a'] = 500;
	    t['b'] = 500;
	    t['c'] = 444;
	    t['d'] = 500;
	    t['e'] = 444;
	    t['f'] = 333;
	    t['g'] = 500;
	    t['h'] = 556;
	    t['i'] = 278;
	    t['j'] = 278;
	    t['k'] = 500;
	    t['l'] = 278;
	    t['m'] = 778;
	    t['n'] = 556;
	    t['o'] = 500;
	    t['p'] = 500;
	    t['q'] = 500;
	    t['r'] = 389;
	    t['s'] = 389;
	    t['t'] = 278;
	    t['u'] = 556;
	    t['v'] = 444;
	    t['w'] = 667;
	    t['x'] = 500;
	    t['y'] = 444;
	    t['z'] = 389;
	    t['braceleft'] = 348;
	    t['bar'] = 220;
	    t['braceright'] = 348;
	    t['asciitilde'] = 570;
	    t['exclamdown'] = 389;
	    t['cent'] = 500;
	    t['sterling'] = 500;
	    t['fraction'] = 167;
	    t['yen'] = 500;
	    t['florin'] = 500;
	    t['section'] = 500;
	    t['currency'] = 500;
	    t['quotesingle'] = 278;
	    t['quotedblleft'] = 500;
	    t['guillemotleft'] = 500;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 556;
	    t['fl'] = 556;
	    t['endash'] = 500;
	    t['dagger'] = 500;
	    t['daggerdbl'] = 500;
	    t['periodcentered'] = 250;
	    t['paragraph'] = 500;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 333;
	    t['quotedblbase'] = 500;
	    t['quotedblright'] = 500;
	    t['guillemotright'] = 500;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 500;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 944;
	    t['ordfeminine'] = 266;
	    t['Lslash'] = 611;
	    t['Oslash'] = 722;
	    t['OE'] = 944;
	    t['ordmasculine'] = 300;
	    t['ae'] = 722;
	    t['dotlessi'] = 278;
	    t['lslash'] = 278;
	    t['oslash'] = 500;
	    t['oe'] = 722;
	    t['germandbls'] = 500;
	    t['Idieresis'] = 389;
	    t['eacute'] = 444;
	    t['abreve'] = 500;
	    t['uhungarumlaut'] = 556;
	    t['ecaron'] = 444;
	    t['Ydieresis'] = 611;
	    t['divide'] = 570;
	    t['Yacute'] = 611;
	    t['Acircumflex'] = 667;
	    t['aacute'] = 500;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 444;
	    t['scommaaccent'] = 389;
	    t['ecircumflex'] = 444;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 500;
	    t['Uacute'] = 722;
	    t['uogonek'] = 556;
	    t['Edieresis'] = 667;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 747;
	    t['Emacron'] = 667;
	    t['ccaron'] = 444;
	    t['aring'] = 500;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 278;
	    t['agrave'] = 500;
	    t['Tcommaaccent'] = 611;
	    t['Cacute'] = 667;
	    t['atilde'] = 500;
	    t['Edotaccent'] = 667;
	    t['scaron'] = 389;
	    t['scedilla'] = 389;
	    t['iacute'] = 278;
	    t['lozenge'] = 494;
	    t['Rcaron'] = 667;
	    t['Gcommaaccent'] = 722;
	    t['ucircumflex'] = 556;
	    t['acircumflex'] = 500;
	    t['Amacron'] = 667;
	    t['rcaron'] = 389;
	    t['ccedilla'] = 444;
	    t['Zdotaccent'] = 611;
	    t['Thorn'] = 611;
	    t['Omacron'] = 722;
	    t['Racute'] = 667;
	    t['Sacute'] = 556;
	    t['dcaron'] = 608;
	    t['Umacron'] = 722;
	    t['uring'] = 556;
	    t['threesuperior'] = 300;
	    t['Ograve'] = 722;
	    t['Agrave'] = 667;
	    t['Abreve'] = 667;
	    t['multiply'] = 570;
	    t['uacute'] = 556;
	    t['Tcaron'] = 611;
	    t['partialdiff'] = 494;
	    t['ydieresis'] = 444;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 667;
	    t['adieresis'] = 500;
	    t['edieresis'] = 444;
	    t['cacute'] = 444;
	    t['nacute'] = 556;
	    t['umacron'] = 556;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 389;
	    t['plusminus'] = 570;
	    t['brokenbar'] = 220;
	    t['registered'] = 747;
	    t['Gbreve'] = 722;
	    t['Idotaccent'] = 389;
	    t['summation'] = 600;
	    t['Egrave'] = 667;
	    t['racute'] = 389;
	    t['omacron'] = 500;
	    t['Zacute'] = 611;
	    t['Zcaron'] = 611;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 667;
	    t['lcommaaccent'] = 278;
	    t['tcaron'] = 366;
	    t['eogonek'] = 444;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 667;
	    t['Adieresis'] = 667;
	    t['egrave'] = 444;
	    t['zacute'] = 389;
	    t['iogonek'] = 278;
	    t['Oacute'] = 722;
	    t['oacute'] = 500;
	    t['amacron'] = 500;
	    t['sacute'] = 389;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 722;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 500;
	    t['twosuperior'] = 300;
	    t['Odieresis'] = 722;
	    t['mu'] = 576;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 500;
	    t['Eogonek'] = 667;
	    t['dcroat'] = 500;
	    t['threequarters'] = 750;
	    t['Scedilla'] = 556;
	    t['lcaron'] = 382;
	    t['Kcommaaccent'] = 667;
	    t['Lacute'] = 611;
	    t['trademark'] = 1000;
	    t['edotaccent'] = 444;
	    t['Igrave'] = 389;
	    t['Imacron'] = 389;
	    t['Lcaron'] = 611;
	    t['onehalf'] = 750;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 500;
	    t['ntilde'] = 556;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 667;
	    t['emacron'] = 444;
	    t['gbreve'] = 500;
	    t['onequarter'] = 750;
	    t['Scaron'] = 556;
	    t['Scommaaccent'] = 556;
	    t['Ohungarumlaut'] = 722;
	    t['degree'] = 400;
	    t['ograve'] = 500;
	    t['Ccaron'] = 667;
	    t['ugrave'] = 556;
	    t['radical'] = 549;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 389;
	    t['Ntilde'] = 722;
	    t['otilde'] = 500;
	    t['Rcommaaccent'] = 667;
	    t['Lcommaaccent'] = 611;
	    t['Atilde'] = 667;
	    t['Aogonek'] = 667;
	    t['Aring'] = 667;
	    t['Otilde'] = 722;
	    t['zdotaccent'] = 389;
	    t['Ecaron'] = 667;
	    t['Iogonek'] = 389;
	    t['kcommaaccent'] = 500;
	    t['minus'] = 606;
	    t['Icircumflex'] = 389;
	    t['ncaron'] = 556;
	    t['tcommaaccent'] = 278;
	    t['logicalnot'] = 606;
	    t['odieresis'] = 500;
	    t['udieresis'] = 556;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 500;
	    t['eth'] = 500;
	    t['zcaron'] = 389;
	    t['ncommaaccent'] = 556;
	    t['onesuperior'] = 300;
	    t['imacron'] = 278;
	    t['Euro'] = 500;
	  });
	  t['Times-Italic'] = getLookupTableFactory(function (t) {
	    t['space'] = 250;
	    t['exclam'] = 333;
	    t['quotedbl'] = 420;
	    t['numbersign'] = 500;
	    t['dollar'] = 500;
	    t['percent'] = 833;
	    t['ampersand'] = 778;
	    t['quoteright'] = 333;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 500;
	    t['plus'] = 675;
	    t['comma'] = 250;
	    t['hyphen'] = 333;
	    t['period'] = 250;
	    t['slash'] = 278;
	    t['zero'] = 500;
	    t['one'] = 500;
	    t['two'] = 500;
	    t['three'] = 500;
	    t['four'] = 500;
	    t['five'] = 500;
	    t['six'] = 500;
	    t['seven'] = 500;
	    t['eight'] = 500;
	    t['nine'] = 500;
	    t['colon'] = 333;
	    t['semicolon'] = 333;
	    t['less'] = 675;
	    t['equal'] = 675;
	    t['greater'] = 675;
	    t['question'] = 500;
	    t['at'] = 920;
	    t['A'] = 611;
	    t['B'] = 611;
	    t['C'] = 667;
	    t['D'] = 722;
	    t['E'] = 611;
	    t['F'] = 611;
	    t['G'] = 722;
	    t['H'] = 722;
	    t['I'] = 333;
	    t['J'] = 444;
	    t['K'] = 667;
	    t['L'] = 556;
	    t['M'] = 833;
	    t['N'] = 667;
	    t['O'] = 722;
	    t['P'] = 611;
	    t['Q'] = 722;
	    t['R'] = 611;
	    t['S'] = 500;
	    t['T'] = 556;
	    t['U'] = 722;
	    t['V'] = 611;
	    t['W'] = 833;
	    t['X'] = 611;
	    t['Y'] = 556;
	    t['Z'] = 556;
	    t['bracketleft'] = 389;
	    t['backslash'] = 278;
	    t['bracketright'] = 389;
	    t['asciicircum'] = 422;
	    t['underscore'] = 500;
	    t['quoteleft'] = 333;
	    t['a'] = 500;
	    t['b'] = 500;
	    t['c'] = 444;
	    t['d'] = 500;
	    t['e'] = 444;
	    t['f'] = 278;
	    t['g'] = 500;
	    t['h'] = 500;
	    t['i'] = 278;
	    t['j'] = 278;
	    t['k'] = 444;
	    t['l'] = 278;
	    t['m'] = 722;
	    t['n'] = 500;
	    t['o'] = 500;
	    t['p'] = 500;
	    t['q'] = 500;
	    t['r'] = 389;
	    t['s'] = 389;
	    t['t'] = 278;
	    t['u'] = 500;
	    t['v'] = 444;
	    t['w'] = 667;
	    t['x'] = 444;
	    t['y'] = 444;
	    t['z'] = 389;
	    t['braceleft'] = 400;
	    t['bar'] = 275;
	    t['braceright'] = 400;
	    t['asciitilde'] = 541;
	    t['exclamdown'] = 389;
	    t['cent'] = 500;
	    t['sterling'] = 500;
	    t['fraction'] = 167;
	    t['yen'] = 500;
	    t['florin'] = 500;
	    t['section'] = 500;
	    t['currency'] = 500;
	    t['quotesingle'] = 214;
	    t['quotedblleft'] = 556;
	    t['guillemotleft'] = 500;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 500;
	    t['fl'] = 500;
	    t['endash'] = 500;
	    t['dagger'] = 500;
	    t['daggerdbl'] = 500;
	    t['periodcentered'] = 250;
	    t['paragraph'] = 523;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 333;
	    t['quotedblbase'] = 556;
	    t['quotedblright'] = 556;
	    t['guillemotright'] = 500;
	    t['ellipsis'] = 889;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 500;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 889;
	    t['AE'] = 889;
	    t['ordfeminine'] = 276;
	    t['Lslash'] = 556;
	    t['Oslash'] = 722;
	    t['OE'] = 944;
	    t['ordmasculine'] = 310;
	    t['ae'] = 667;
	    t['dotlessi'] = 278;
	    t['lslash'] = 278;
	    t['oslash'] = 500;
	    t['oe'] = 667;
	    t['germandbls'] = 500;
	    t['Idieresis'] = 333;
	    t['eacute'] = 444;
	    t['abreve'] = 500;
	    t['uhungarumlaut'] = 500;
	    t['ecaron'] = 444;
	    t['Ydieresis'] = 556;
	    t['divide'] = 675;
	    t['Yacute'] = 556;
	    t['Acircumflex'] = 611;
	    t['aacute'] = 500;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 444;
	    t['scommaaccent'] = 389;
	    t['ecircumflex'] = 444;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 500;
	    t['Uacute'] = 722;
	    t['uogonek'] = 500;
	    t['Edieresis'] = 611;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 760;
	    t['Emacron'] = 611;
	    t['ccaron'] = 444;
	    t['aring'] = 500;
	    t['Ncommaaccent'] = 667;
	    t['lacute'] = 278;
	    t['agrave'] = 500;
	    t['Tcommaaccent'] = 556;
	    t['Cacute'] = 667;
	    t['atilde'] = 500;
	    t['Edotaccent'] = 611;
	    t['scaron'] = 389;
	    t['scedilla'] = 389;
	    t['iacute'] = 278;
	    t['lozenge'] = 471;
	    t['Rcaron'] = 611;
	    t['Gcommaaccent'] = 722;
	    t['ucircumflex'] = 500;
	    t['acircumflex'] = 500;
	    t['Amacron'] = 611;
	    t['rcaron'] = 389;
	    t['ccedilla'] = 444;
	    t['Zdotaccent'] = 556;
	    t['Thorn'] = 611;
	    t['Omacron'] = 722;
	    t['Racute'] = 611;
	    t['Sacute'] = 500;
	    t['dcaron'] = 544;
	    t['Umacron'] = 722;
	    t['uring'] = 500;
	    t['threesuperior'] = 300;
	    t['Ograve'] = 722;
	    t['Agrave'] = 611;
	    t['Abreve'] = 611;
	    t['multiply'] = 675;
	    t['uacute'] = 500;
	    t['Tcaron'] = 556;
	    t['partialdiff'] = 476;
	    t['ydieresis'] = 444;
	    t['Nacute'] = 667;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 611;
	    t['adieresis'] = 500;
	    t['edieresis'] = 444;
	    t['cacute'] = 444;
	    t['nacute'] = 500;
	    t['umacron'] = 500;
	    t['Ncaron'] = 667;
	    t['Iacute'] = 333;
	    t['plusminus'] = 675;
	    t['brokenbar'] = 275;
	    t['registered'] = 760;
	    t['Gbreve'] = 722;
	    t['Idotaccent'] = 333;
	    t['summation'] = 600;
	    t['Egrave'] = 611;
	    t['racute'] = 389;
	    t['omacron'] = 500;
	    t['Zacute'] = 556;
	    t['Zcaron'] = 556;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 667;
	    t['lcommaaccent'] = 278;
	    t['tcaron'] = 300;
	    t['eogonek'] = 444;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 611;
	    t['Adieresis'] = 611;
	    t['egrave'] = 444;
	    t['zacute'] = 389;
	    t['iogonek'] = 278;
	    t['Oacute'] = 722;
	    t['oacute'] = 500;
	    t['amacron'] = 500;
	    t['sacute'] = 389;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 722;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 500;
	    t['twosuperior'] = 300;
	    t['Odieresis'] = 722;
	    t['mu'] = 500;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 500;
	    t['Eogonek'] = 611;
	    t['dcroat'] = 500;
	    t['threequarters'] = 750;
	    t['Scedilla'] = 500;
	    t['lcaron'] = 300;
	    t['Kcommaaccent'] = 667;
	    t['Lacute'] = 556;
	    t['trademark'] = 980;
	    t['edotaccent'] = 444;
	    t['Igrave'] = 333;
	    t['Imacron'] = 333;
	    t['Lcaron'] = 611;
	    t['onehalf'] = 750;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 500;
	    t['ntilde'] = 500;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 611;
	    t['emacron'] = 444;
	    t['gbreve'] = 500;
	    t['onequarter'] = 750;
	    t['Scaron'] = 500;
	    t['Scommaaccent'] = 500;
	    t['Ohungarumlaut'] = 722;
	    t['degree'] = 400;
	    t['ograve'] = 500;
	    t['Ccaron'] = 667;
	    t['ugrave'] = 500;
	    t['radical'] = 453;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 389;
	    t['Ntilde'] = 667;
	    t['otilde'] = 500;
	    t['Rcommaaccent'] = 611;
	    t['Lcommaaccent'] = 556;
	    t['Atilde'] = 611;
	    t['Aogonek'] = 611;
	    t['Aring'] = 611;
	    t['Otilde'] = 722;
	    t['zdotaccent'] = 389;
	    t['Ecaron'] = 611;
	    t['Iogonek'] = 333;
	    t['kcommaaccent'] = 444;
	    t['minus'] = 675;
	    t['Icircumflex'] = 333;
	    t['ncaron'] = 500;
	    t['tcommaaccent'] = 278;
	    t['logicalnot'] = 675;
	    t['odieresis'] = 500;
	    t['udieresis'] = 500;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 500;
	    t['eth'] = 500;
	    t['zcaron'] = 389;
	    t['ncommaaccent'] = 500;
	    t['onesuperior'] = 300;
	    t['imacron'] = 278;
	    t['Euro'] = 500;
	  });
	  t['ZapfDingbats'] = getLookupTableFactory(function (t) {
	    t['space'] = 278;
	    t['a1'] = 974;
	    t['a2'] = 961;
	    t['a202'] = 974;
	    t['a3'] = 980;
	    t['a4'] = 719;
	    t['a5'] = 789;
	    t['a119'] = 790;
	    t['a118'] = 791;
	    t['a117'] = 690;
	    t['a11'] = 960;
	    t['a12'] = 939;
	    t['a13'] = 549;
	    t['a14'] = 855;
	    t['a15'] = 911;
	    t['a16'] = 933;
	    t['a105'] = 911;
	    t['a17'] = 945;
	    t['a18'] = 974;
	    t['a19'] = 755;
	    t['a20'] = 846;
	    t['a21'] = 762;
	    t['a22'] = 761;
	    t['a23'] = 571;
	    t['a24'] = 677;
	    t['a25'] = 763;
	    t['a26'] = 760;
	    t['a27'] = 759;
	    t['a28'] = 754;
	    t['a6'] = 494;
	    t['a7'] = 552;
	    t['a8'] = 537;
	    t['a9'] = 577;
	    t['a10'] = 692;
	    t['a29'] = 786;
	    t['a30'] = 788;
	    t['a31'] = 788;
	    t['a32'] = 790;
	    t['a33'] = 793;
	    t['a34'] = 794;
	    t['a35'] = 816;
	    t['a36'] = 823;
	    t['a37'] = 789;
	    t['a38'] = 841;
	    t['a39'] = 823;
	    t['a40'] = 833;
	    t['a41'] = 816;
	    t['a42'] = 831;
	    t['a43'] = 923;
	    t['a44'] = 744;
	    t['a45'] = 723;
	    t['a46'] = 749;
	    t['a47'] = 790;
	    t['a48'] = 792;
	    t['a49'] = 695;
	    t['a50'] = 776;
	    t['a51'] = 768;
	    t['a52'] = 792;
	    t['a53'] = 759;
	    t['a54'] = 707;
	    t['a55'] = 708;
	    t['a56'] = 682;
	    t['a57'] = 701;
	    t['a58'] = 826;
	    t['a59'] = 815;
	    t['a60'] = 789;
	    t['a61'] = 789;
	    t['a62'] = 707;
	    t['a63'] = 687;
	    t['a64'] = 696;
	    t['a65'] = 689;
	    t['a66'] = 786;
	    t['a67'] = 787;
	    t['a68'] = 713;
	    t['a69'] = 791;
	    t['a70'] = 785;
	    t['a71'] = 791;
	    t['a72'] = 873;
	    t['a73'] = 761;
	    t['a74'] = 762;
	    t['a203'] = 762;
	    t['a75'] = 759;
	    t['a204'] = 759;
	    t['a76'] = 892;
	    t['a77'] = 892;
	    t['a78'] = 788;
	    t['a79'] = 784;
	    t['a81'] = 438;
	    t['a82'] = 138;
	    t['a83'] = 277;
	    t['a84'] = 415;
	    t['a97'] = 392;
	    t['a98'] = 392;
	    t['a99'] = 668;
	    t['a100'] = 668;
	    t['a89'] = 390;
	    t['a90'] = 390;
	    t['a93'] = 317;
	    t['a94'] = 317;
	    t['a91'] = 276;
	    t['a92'] = 276;
	    t['a205'] = 509;
	    t['a85'] = 509;
	    t['a206'] = 410;
	    t['a86'] = 410;
	    t['a87'] = 234;
	    t['a88'] = 234;
	    t['a95'] = 334;
	    t['a96'] = 334;
	    t['a101'] = 732;
	    t['a102'] = 544;
	    t['a103'] = 544;
	    t['a104'] = 910;
	    t['a106'] = 667;
	    t['a107'] = 760;
	    t['a108'] = 760;
	    t['a112'] = 776;
	    t['a111'] = 595;
	    t['a110'] = 694;
	    t['a109'] = 626;
	    t['a120'] = 788;
	    t['a121'] = 788;
	    t['a122'] = 788;
	    t['a123'] = 788;
	    t['a124'] = 788;
	    t['a125'] = 788;
	    t['a126'] = 788;
	    t['a127'] = 788;
	    t['a128'] = 788;
	    t['a129'] = 788;
	    t['a130'] = 788;
	    t['a131'] = 788;
	    t['a132'] = 788;
	    t['a133'] = 788;
	    t['a134'] = 788;
	    t['a135'] = 788;
	    t['a136'] = 788;
	    t['a137'] = 788;
	    t['a138'] = 788;
	    t['a139'] = 788;
	    t['a140'] = 788;
	    t['a141'] = 788;
	    t['a142'] = 788;
	    t['a143'] = 788;
	    t['a144'] = 788;
	    t['a145'] = 788;
	    t['a146'] = 788;
	    t['a147'] = 788;
	    t['a148'] = 788;
	    t['a149'] = 788;
	    t['a150'] = 788;
	    t['a151'] = 788;
	    t['a152'] = 788;
	    t['a153'] = 788;
	    t['a154'] = 788;
	    t['a155'] = 788;
	    t['a156'] = 788;
	    t['a157'] = 788;
	    t['a158'] = 788;
	    t['a159'] = 788;
	    t['a160'] = 894;
	    t['a161'] = 838;
	    t['a163'] = 1016;
	    t['a164'] = 458;
	    t['a196'] = 748;
	    t['a165'] = 924;
	    t['a192'] = 748;
	    t['a166'] = 918;
	    t['a167'] = 927;
	    t['a168'] = 928;
	    t['a169'] = 928;
	    t['a170'] = 834;
	    t['a171'] = 873;
	    t['a172'] = 828;
	    t['a173'] = 924;
	    t['a162'] = 924;
	    t['a174'] = 917;
	    t['a175'] = 930;
	    t['a176'] = 931;
	    t['a177'] = 463;
	    t['a178'] = 883;
	    t['a179'] = 836;
	    t['a193'] = 836;
	    t['a180'] = 867;
	    t['a199'] = 867;
	    t['a181'] = 696;
	    t['a200'] = 696;
	    t['a182'] = 874;
	    t['a201'] = 874;
	    t['a183'] = 760;
	    t['a184'] = 946;
	    t['a197'] = 771;
	    t['a185'] = 865;
	    t['a194'] = 771;
	    t['a198'] = 888;
	    t['a186'] = 967;
	    t['a195'] = 888;
	    t['a187'] = 831;
	    t['a188'] = 873;
	    t['a189'] = 927;
	    t['a190'] = 970;
	    t['a191'] = 918;
	  });
	});
	exports.getMetrics = getMetrics;
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var sharedUtil = __w_pdfjs_require__(0);
	var MurmurHash3_64 = function MurmurHash3_64Closure(seed) {
	  var MASK_HIGH = 0xffff0000;
	  var MASK_LOW = 0xffff;
	  function MurmurHash3_64(seed) {
	    var SEED = 0xc3d2e1f0;
	    this.h1 = seed ? seed & 0xffffffff : SEED;
	    this.h2 = seed ? seed & 0xffffffff : SEED;
	  }
	  MurmurHash3_64.prototype = {
	    update: function MurmurHash3_64_update(input) {
	      var i;
	      if (typeof input === 'string') {
	        var data = new Uint8Array(input.length * 2);
	        var length = 0;
	        for (i = 0; i < input.length; i++) {
	          var code = input.charCodeAt(i);
	          if (code <= 0xff) {
	            data[length++] = code;
	          } else {
	            data[length++] = code >>> 8;
	            data[length++] = code & 0xff;
	          }
	        }
	      } else if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object' && 'byteLength' in input) {
	        data = input;
	        length = data.byteLength;
	      } else {
	        throw new Error('Wrong data format in MurmurHash3_64_update. ' + 'Input must be a string or array.');
	      }
	      var blockCounts = length >> 2;
	      var tailLength = length - blockCounts * 4;
	      var dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
	      var k1 = 0;
	      var k2 = 0;
	      var h1 = this.h1;
	      var h2 = this.h2;
	      var C1 = 0xcc9e2d51;
	      var C2 = 0x1b873593;
	      var C1_LOW = C1 & MASK_LOW;
	      var C2_LOW = C2 & MASK_LOW;
	      for (i = 0; i < blockCounts; i++) {
	        if (i & 1) {
	          k1 = dataUint32[i];
	          k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
	          k1 = k1 << 15 | k1 >>> 17;
	          k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
	          h1 ^= k1;
	          h1 = h1 << 13 | h1 >>> 19;
	          h1 = h1 * 5 + 0xe6546b64;
	        } else {
	          k2 = dataUint32[i];
	          k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
	          k2 = k2 << 15 | k2 >>> 17;
	          k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
	          h2 ^= k2;
	          h2 = h2 << 13 | h2 >>> 19;
	          h2 = h2 * 5 + 0xe6546b64;
	        }
	      }
	      k1 = 0;
	      switch (tailLength) {
	        case 3:
	          k1 ^= data[blockCounts * 4 + 2] << 16;
	        case 2:
	          k1 ^= data[blockCounts * 4 + 1] << 8;
	        case 1:
	          k1 ^= data[blockCounts * 4];
	          k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
	          k1 = k1 << 15 | k1 >>> 17;
	          k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
	          if (blockCounts & 1) {
	            h1 ^= k1;
	          } else {
	            h2 ^= k1;
	          }
	      }
	      this.h1 = h1;
	      this.h2 = h2;
	      return this;
	    },
	    hexdigest: function MurmurHash3_64_hexdigest() {
	      var h1 = this.h1;
	      var h2 = this.h2;
	      h1 ^= h2 >>> 1;
	      h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
	      h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
	      h1 ^= h2 >>> 1;
	      h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
	      h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
	      h1 ^= h2 >>> 1;
	      for (var i = 0, arr = [h1, h2], str = ''; i < arr.length; i++) {
	        var hex = (arr[i] >>> 0).toString(16);
	        while (hex.length < 8) {
	          hex = '0' + hex;
	        }
	        str += hex;
	      }
	      return str;
	    }
	  };
	  return MurmurHash3_64;
	}();
	exports.MurmurHash3_64 = MurmurHash3_64;
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var coreFunction = __w_pdfjs_require__(6);
	var coreColorSpace = __w_pdfjs_require__(3);
	var UNSUPPORTED_FEATURES = sharedUtil.UNSUPPORTED_FEATURES;
	var MissingDataException = sharedUtil.MissingDataException;
	var Util = sharedUtil.Util;
	var assert = sharedUtil.assert;
	var error = sharedUtil.error;
	var info = sharedUtil.info;
	var warn = sharedUtil.warn;
	var isStream = corePrimitives.isStream;
	var PDFFunction = coreFunction.PDFFunction;
	var ColorSpace = coreColorSpace.ColorSpace;
	var ShadingType = {
	  FUNCTION_BASED: 1,
	  AXIAL: 2,
	  RADIAL: 3,
	  FREE_FORM_MESH: 4,
	  LATTICE_FORM_MESH: 5,
	  COONS_PATCH_MESH: 6,
	  TENSOR_PATCH_MESH: 7
	};
	var Pattern = function PatternClosure() {
	  function Pattern() {
	    error('should not call Pattern constructor');
	  }
	  Pattern.prototype = {
	    getPattern: function Pattern_getPattern(ctx) {
	      error('Should not call Pattern.getStyle: ' + ctx);
	    }
	  };
	  Pattern.parseShading = function Pattern_parseShading(shading, matrix, xref, res, handler) {
	    var dict = isStream(shading) ? shading.dict : shading;
	    var type = dict.get('ShadingType');
	    try {
	      switch (type) {
	        case ShadingType.AXIAL:
	        case ShadingType.RADIAL:
	          return new Shadings.RadialAxial(dict, matrix, xref, res);
	        case ShadingType.FREE_FORM_MESH:
	        case ShadingType.LATTICE_FORM_MESH:
	        case ShadingType.COONS_PATCH_MESH:
	        case ShadingType.TENSOR_PATCH_MESH:
	          return new Shadings.Mesh(shading, matrix, xref, res);
	        default:
	          throw new Error('Unsupported ShadingType: ' + type);
	      }
	    } catch (ex) {
	      if (ex instanceof MissingDataException) {
	        throw ex;
	      }
	      handler.send('UnsupportedFeature', { featureId: UNSUPPORTED_FEATURES.shadingPattern });
	      warn(ex);
	      return new Shadings.Dummy();
	    }
	  };
	  return Pattern;
	}();
	var Shadings = {};
	Shadings.SMALL_NUMBER = 1e-6;
	Shadings.RadialAxial = function RadialAxialClosure() {
	  function RadialAxial(dict, matrix, xref, res) {
	    this.matrix = matrix;
	    this.coordsArr = dict.getArray('Coords');
	    this.shadingType = dict.get('ShadingType');
	    this.type = 'Pattern';
	    var cs = dict.get('ColorSpace', 'CS');
	    cs = ColorSpace.parse(cs, xref, res);
	    this.cs = cs;
	    var t0 = 0.0,
	        t1 = 1.0;
	    if (dict.has('Domain')) {
	      var domainArr = dict.getArray('Domain');
	      t0 = domainArr[0];
	      t1 = domainArr[1];
	    }
	    var extendStart = false,
	        extendEnd = false;
	    if (dict.has('Extend')) {
	      var extendArr = dict.getArray('Extend');
	      extendStart = extendArr[0];
	      extendEnd = extendArr[1];
	    }
	    if (this.shadingType === ShadingType.RADIAL && (!extendStart || !extendEnd)) {
	      var x1 = this.coordsArr[0];
	      var y1 = this.coordsArr[1];
	      var r1 = this.coordsArr[2];
	      var x2 = this.coordsArr[3];
	      var y2 = this.coordsArr[4];
	      var r2 = this.coordsArr[5];
	      var distance = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
	      if (r1 <= r2 + distance && r2 <= r1 + distance) {
	        warn('Unsupported radial gradient.');
	      }
	    }
	    this.extendStart = extendStart;
	    this.extendEnd = extendEnd;
	    var fnObj = dict.get('Function');
	    var fn = PDFFunction.parseArray(xref, fnObj);
	    var diff = t1 - t0;
	    var step = diff / 10;
	    var colorStops = this.colorStops = [];
	    if (t0 >= t1 || step <= 0) {
	      info('Bad shading domain.');
	      return;
	    }
	    var color = new Float32Array(cs.numComps),
	        ratio = new Float32Array(1);
	    var rgbColor;
	    for (var i = t0; i <= t1; i += step) {
	      ratio[0] = i;
	      fn(ratio, 0, color, 0);
	      rgbColor = cs.getRgb(color, 0);
	      var cssColor = Util.makeCssRgb(rgbColor[0], rgbColor[1], rgbColor[2]);
	      colorStops.push([(i - t0) / diff, cssColor]);
	    }
	    var background = 'transparent';
	    if (dict.has('Background')) {
	      rgbColor = cs.getRgb(dict.get('Background'), 0);
	      background = Util.makeCssRgb(rgbColor[0], rgbColor[1], rgbColor[2]);
	    }
	    if (!extendStart) {
	      colorStops.unshift([0, background]);
	      colorStops[1][0] += Shadings.SMALL_NUMBER;
	    }
	    if (!extendEnd) {
	      colorStops[colorStops.length - 1][0] -= Shadings.SMALL_NUMBER;
	      colorStops.push([1, background]);
	    }
	    this.colorStops = colorStops;
	  }
	  RadialAxial.prototype = {
	    getIR: function RadialAxial_getIR() {
	      var coordsArr = this.coordsArr;
	      var shadingType = this.shadingType;
	      var type, p0, p1, r0, r1;
	      if (shadingType === ShadingType.AXIAL) {
	        p0 = [coordsArr[0], coordsArr[1]];
	        p1 = [coordsArr[2], coordsArr[3]];
	        r0 = null;
	        r1 = null;
	        type = 'axial';
	      } else if (shadingType === ShadingType.RADIAL) {
	        p0 = [coordsArr[0], coordsArr[1]];
	        p1 = [coordsArr[3], coordsArr[4]];
	        r0 = coordsArr[2];
	        r1 = coordsArr[5];
	        type = 'radial';
	      } else {
	        error('getPattern type unknown: ' + shadingType);
	      }
	      var matrix = this.matrix;
	      if (matrix) {
	        p0 = Util.applyTransform(p0, matrix);
	        p1 = Util.applyTransform(p1, matrix);
	        if (shadingType === ShadingType.RADIAL) {
	          var scale = Util.singularValueDecompose2dScale(matrix);
	          r0 *= scale[0];
	          r1 *= scale[1];
	        }
	      }
	      return ['RadialAxial', type, this.colorStops, p0, p1, r0, r1];
	    }
	  };
	  return RadialAxial;
	}();
	Shadings.Mesh = function MeshClosure() {
	  function MeshStreamReader(stream, context) {
	    this.stream = stream;
	    this.context = context;
	    this.buffer = 0;
	    this.bufferLength = 0;
	    var numComps = context.numComps;
	    this.tmpCompsBuf = new Float32Array(numComps);
	    var csNumComps = context.colorSpace.numComps;
	    this.tmpCsCompsBuf = context.colorFn ? new Float32Array(csNumComps) : this.tmpCompsBuf;
	  }
	  MeshStreamReader.prototype = {
	    get hasData() {
	      if (this.stream.end) {
	        return this.stream.pos < this.stream.end;
	      }
	      if (this.bufferLength > 0) {
	        return true;
	      }
	      var nextByte = this.stream.getByte();
	      if (nextByte < 0) {
	        return false;
	      }
	      this.buffer = nextByte;
	      this.bufferLength = 8;
	      return true;
	    },
	    readBits: function MeshStreamReader_readBits(n) {
	      var buffer = this.buffer;
	      var bufferLength = this.bufferLength;
	      if (n === 32) {
	        if (bufferLength === 0) {
	          return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
	        }
	        buffer = buffer << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
	        var nextByte = this.stream.getByte();
	        this.buffer = nextByte & (1 << bufferLength) - 1;
	        return (buffer << 8 - bufferLength | (nextByte & 0xFF) >> bufferLength) >>> 0;
	      }
	      if (n === 8 && bufferLength === 0) {
	        return this.stream.getByte();
	      }
	      while (bufferLength < n) {
	        buffer = buffer << 8 | this.stream.getByte();
	        bufferLength += 8;
	      }
	      bufferLength -= n;
	      this.bufferLength = bufferLength;
	      this.buffer = buffer & (1 << bufferLength) - 1;
	      return buffer >> bufferLength;
	    },
	    align: function MeshStreamReader_align() {
	      this.buffer = 0;
	      this.bufferLength = 0;
	    },
	    readFlag: function MeshStreamReader_readFlag() {
	      return this.readBits(this.context.bitsPerFlag);
	    },
	    readCoordinate: function MeshStreamReader_readCoordinate() {
	      var bitsPerCoordinate = this.context.bitsPerCoordinate;
	      var xi = this.readBits(bitsPerCoordinate);
	      var yi = this.readBits(bitsPerCoordinate);
	      var decode = this.context.decode;
	      var scale = bitsPerCoordinate < 32 ? 1 / ((1 << bitsPerCoordinate) - 1) : 2.3283064365386963e-10;
	      return [xi * scale * (decode[1] - decode[0]) + decode[0], yi * scale * (decode[3] - decode[2]) + decode[2]];
	    },
	    readComponents: function MeshStreamReader_readComponents() {
	      var numComps = this.context.numComps;
	      var bitsPerComponent = this.context.bitsPerComponent;
	      var scale = bitsPerComponent < 32 ? 1 / ((1 << bitsPerComponent) - 1) : 2.3283064365386963e-10;
	      var decode = this.context.decode;
	      var components = this.tmpCompsBuf;
	      for (var i = 0, j = 4; i < numComps; i++, j += 2) {
	        var ci = this.readBits(bitsPerComponent);
	        components[i] = ci * scale * (decode[j + 1] - decode[j]) + decode[j];
	      }
	      var color = this.tmpCsCompsBuf;
	      if (this.context.colorFn) {
	        this.context.colorFn(components, 0, color, 0);
	      }
	      return this.context.colorSpace.getRgb(color, 0);
	    }
	  };
	  function decodeType4Shading(mesh, reader) {
	    var coords = mesh.coords;
	    var colors = mesh.colors;
	    var operators = [];
	    var ps = [];
	    var verticesLeft = 0;
	    while (reader.hasData) {
	      var f = reader.readFlag();
	      var coord = reader.readCoordinate();
	      var color = reader.readComponents();
	      if (verticesLeft === 0) {
	        assert(0 <= f && f <= 2, 'Unknown type4 flag');
	        switch (f) {
	          case 0:
	            verticesLeft = 3;
	            break;
	          case 1:
	            ps.push(ps[ps.length - 2], ps[ps.length - 1]);
	            verticesLeft = 1;
	            break;
	          case 2:
	            ps.push(ps[ps.length - 3], ps[ps.length - 1]);
	            verticesLeft = 1;
	            break;
	        }
	        operators.push(f);
	      }
	      ps.push(coords.length);
	      coords.push(coord);
	      colors.push(color);
	      verticesLeft--;
	      reader.align();
	    }
	    mesh.figures.push({
	      type: 'triangles',
	      coords: new Int32Array(ps),
	      colors: new Int32Array(ps)
	    });
	  }
	  function decodeType5Shading(mesh, reader, verticesPerRow) {
	    var coords = mesh.coords;
	    var colors = mesh.colors;
	    var ps = [];
	    while (reader.hasData) {
	      var coord = reader.readCoordinate();
	      var color = reader.readComponents();
	      ps.push(coords.length);
	      coords.push(coord);
	      colors.push(color);
	    }
	    mesh.figures.push({
	      type: 'lattice',
	      coords: new Int32Array(ps),
	      colors: new Int32Array(ps),
	      verticesPerRow: verticesPerRow
	    });
	  }
	  var MIN_SPLIT_PATCH_CHUNKS_AMOUNT = 3;
	  var MAX_SPLIT_PATCH_CHUNKS_AMOUNT = 20;
	  var TRIANGLE_DENSITY = 20;
	  var getB = function getBClosure() {
	    function buildB(count) {
	      var lut = [];
	      for (var i = 0; i <= count; i++) {
	        var t = i / count,
	            t_ = 1 - t;
	        lut.push(new Float32Array([t_ * t_ * t_, 3 * t * t_ * t_, 3 * t * t * t_, t * t * t]));
	      }
	      return lut;
	    }
	    var cache = [];
	    return function getB(count) {
	      if (!cache[count]) {
	        cache[count] = buildB(count);
	      }
	      return cache[count];
	    };
	  }();
	  function buildFigureFromPatch(mesh, index) {
	    var figure = mesh.figures[index];
	    assert(figure.type === 'patch', 'Unexpected patch mesh figure');
	    var coords = mesh.coords,
	        colors = mesh.colors;
	    var pi = figure.coords;
	    var ci = figure.colors;
	    var figureMinX = Math.min(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
	    var figureMinY = Math.min(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
	    var figureMaxX = Math.max(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
	    var figureMaxY = Math.max(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
	    var splitXBy = Math.ceil((figureMaxX - figureMinX) * TRIANGLE_DENSITY / (mesh.bounds[2] - mesh.bounds[0]));
	    splitXBy = Math.max(MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitXBy));
	    var splitYBy = Math.ceil((figureMaxY - figureMinY) * TRIANGLE_DENSITY / (mesh.bounds[3] - mesh.bounds[1]));
	    splitYBy = Math.max(MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitYBy));
	    var verticesPerRow = splitXBy + 1;
	    var figureCoords = new Int32Array((splitYBy + 1) * verticesPerRow);
	    var figureColors = new Int32Array((splitYBy + 1) * verticesPerRow);
	    var k = 0;
	    var cl = new Uint8Array(3),
	        cr = new Uint8Array(3);
	    var c0 = colors[ci[0]],
	        c1 = colors[ci[1]],
	        c2 = colors[ci[2]],
	        c3 = colors[ci[3]];
	    var bRow = getB(splitYBy),
	        bCol = getB(splitXBy);
	    for (var row = 0; row <= splitYBy; row++) {
	      cl[0] = (c0[0] * (splitYBy - row) + c2[0] * row) / splitYBy | 0;
	      cl[1] = (c0[1] * (splitYBy - row) + c2[1] * row) / splitYBy | 0;
	      cl[2] = (c0[2] * (splitYBy - row) + c2[2] * row) / splitYBy | 0;
	      cr[0] = (c1[0] * (splitYBy - row) + c3[0] * row) / splitYBy | 0;
	      cr[1] = (c1[1] * (splitYBy - row) + c3[1] * row) / splitYBy | 0;
	      cr[2] = (c1[2] * (splitYBy - row) + c3[2] * row) / splitYBy | 0;
	      for (var col = 0; col <= splitXBy; col++, k++) {
	        if ((row === 0 || row === splitYBy) && (col === 0 || col === splitXBy)) {
	          continue;
	        }
	        var x = 0,
	            y = 0;
	        var q = 0;
	        for (var i = 0; i <= 3; i++) {
	          for (var j = 0; j <= 3; j++, q++) {
	            var m = bRow[row][i] * bCol[col][j];
	            x += coords[pi[q]][0] * m;
	            y += coords[pi[q]][1] * m;
	          }
	        }
	        figureCoords[k] = coords.length;
	        coords.push([x, y]);
	        figureColors[k] = colors.length;
	        var newColor = new Uint8Array(3);
	        newColor[0] = (cl[0] * (splitXBy - col) + cr[0] * col) / splitXBy | 0;
	        newColor[1] = (cl[1] * (splitXBy - col) + cr[1] * col) / splitXBy | 0;
	        newColor[2] = (cl[2] * (splitXBy - col) + cr[2] * col) / splitXBy | 0;
	        colors.push(newColor);
	      }
	    }
	    figureCoords[0] = pi[0];
	    figureColors[0] = ci[0];
	    figureCoords[splitXBy] = pi[3];
	    figureColors[splitXBy] = ci[1];
	    figureCoords[verticesPerRow * splitYBy] = pi[12];
	    figureColors[verticesPerRow * splitYBy] = ci[2];
	    figureCoords[verticesPerRow * splitYBy + splitXBy] = pi[15];
	    figureColors[verticesPerRow * splitYBy + splitXBy] = ci[3];
	    mesh.figures[index] = {
	      type: 'lattice',
	      coords: figureCoords,
	      colors: figureColors,
	      verticesPerRow: verticesPerRow
	    };
	  }
	  function decodeType6Shading(mesh, reader) {
	    var coords = mesh.coords;
	    var colors = mesh.colors;
	    var ps = new Int32Array(16);
	    var cs = new Int32Array(4);
	    while (reader.hasData) {
	      var f = reader.readFlag();
	      assert(0 <= f && f <= 3, 'Unknown type6 flag');
	      var i, ii;
	      var pi = coords.length;
	      for (i = 0, ii = f !== 0 ? 8 : 12; i < ii; i++) {
	        coords.push(reader.readCoordinate());
	      }
	      var ci = colors.length;
	      for (i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++) {
	        colors.push(reader.readComponents());
	      }
	      var tmp1, tmp2, tmp3, tmp4;
	      switch (f) {
	        case 0:
	          ps[12] = pi + 3;
	          ps[13] = pi + 4;
	          ps[14] = pi + 5;
	          ps[15] = pi + 6;
	          ps[8] = pi + 2;
	          ps[11] = pi + 7;
	          ps[4] = pi + 1;
	          ps[7] = pi + 8;
	          ps[0] = pi;
	          ps[1] = pi + 11;
	          ps[2] = pi + 10;
	          ps[3] = pi + 9;
	          cs[2] = ci + 1;
	          cs[3] = ci + 2;
	          cs[0] = ci;
	          cs[1] = ci + 3;
	          break;
	        case 1:
	          tmp1 = ps[12];
	          tmp2 = ps[13];
	          tmp3 = ps[14];
	          tmp4 = ps[15];
	          ps[12] = tmp4;
	          ps[13] = pi + 0;
	          ps[14] = pi + 1;
	          ps[15] = pi + 2;
	          ps[8] = tmp3;
	          ps[11] = pi + 3;
	          ps[4] = tmp2;
	          ps[7] = pi + 4;
	          ps[0] = tmp1;
	          ps[1] = pi + 7;
	          ps[2] = pi + 6;
	          ps[3] = pi + 5;
	          tmp1 = cs[2];
	          tmp2 = cs[3];
	          cs[2] = tmp2;
	          cs[3] = ci;
	          cs[0] = tmp1;
	          cs[1] = ci + 1;
	          break;
	        case 2:
	          tmp1 = ps[15];
	          tmp2 = ps[11];
	          ps[12] = ps[3];
	          ps[13] = pi + 0;
	          ps[14] = pi + 1;
	          ps[15] = pi + 2;
	          ps[8] = ps[7];
	          ps[11] = pi + 3;
	          ps[4] = tmp2;
	          ps[7] = pi + 4;
	          ps[0] = tmp1;
	          ps[1] = pi + 7;
	          ps[2] = pi + 6;
	          ps[3] = pi + 5;
	          tmp1 = cs[3];
	          cs[2] = cs[1];
	          cs[3] = ci;
	          cs[0] = tmp1;
	          cs[1] = ci + 1;
	          break;
	        case 3:
	          ps[12] = ps[0];
	          ps[13] = pi + 0;
	          ps[14] = pi + 1;
	          ps[15] = pi + 2;
	          ps[8] = ps[1];
	          ps[11] = pi + 3;
	          ps[4] = ps[2];
	          ps[7] = pi + 4;
	          ps[0] = ps[3];
	          ps[1] = pi + 7;
	          ps[2] = pi + 6;
	          ps[3] = pi + 5;
	          cs[2] = cs[0];
	          cs[3] = ci;
	          cs[0] = cs[1];
	          cs[1] = ci + 1;
	          break;
	      }
	      ps[5] = coords.length;
	      coords.push([(-4 * coords[ps[0]][0] - coords[ps[15]][0] + 6 * (coords[ps[4]][0] + coords[ps[1]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[13]][0] + coords[ps[7]][0])) / 9, (-4 * coords[ps[0]][1] - coords[ps[15]][1] + 6 * (coords[ps[4]][1] + coords[ps[1]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[13]][1] + coords[ps[7]][1])) / 9]);
	      ps[6] = coords.length;
	      coords.push([(-4 * coords[ps[3]][0] - coords[ps[12]][0] + 6 * (coords[ps[2]][0] + coords[ps[7]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[4]][0] + coords[ps[14]][0])) / 9, (-4 * coords[ps[3]][1] - coords[ps[12]][1] + 6 * (coords[ps[2]][1] + coords[ps[7]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[4]][1] + coords[ps[14]][1])) / 9]);
	      ps[9] = coords.length;
	      coords.push([(-4 * coords[ps[12]][0] - coords[ps[3]][0] + 6 * (coords[ps[8]][0] + coords[ps[13]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[11]][0] + coords[ps[1]][0])) / 9, (-4 * coords[ps[12]][1] - coords[ps[3]][1] + 6 * (coords[ps[8]][1] + coords[ps[13]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[11]][1] + coords[ps[1]][1])) / 9]);
	      ps[10] = coords.length;
	      coords.push([(-4 * coords[ps[15]][0] - coords[ps[0]][0] + 6 * (coords[ps[11]][0] + coords[ps[14]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[2]][0] + coords[ps[8]][0])) / 9, (-4 * coords[ps[15]][1] - coords[ps[0]][1] + 6 * (coords[ps[11]][1] + coords[ps[14]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[2]][1] + coords[ps[8]][1])) / 9]);
	      mesh.figures.push({
	        type: 'patch',
	        coords: new Int32Array(ps),
	        colors: new Int32Array(cs)
	      });
	    }
	  }
	  function decodeType7Shading(mesh, reader) {
	    var coords = mesh.coords;
	    var colors = mesh.colors;
	    var ps = new Int32Array(16);
	    var cs = new Int32Array(4);
	    while (reader.hasData) {
	      var f = reader.readFlag();
	      assert(0 <= f && f <= 3, 'Unknown type7 flag');
	      var i, ii;
	      var pi = coords.length;
	      for (i = 0, ii = f !== 0 ? 12 : 16; i < ii; i++) {
	        coords.push(reader.readCoordinate());
	      }
	      var ci = colors.length;
	      for (i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++) {
	        colors.push(reader.readComponents());
	      }
	      var tmp1, tmp2, tmp3, tmp4;
	      switch (f) {
	        case 0:
	          ps[12] = pi + 3;
	          ps[13] = pi + 4;
	          ps[14] = pi + 5;
	          ps[15] = pi + 6;
	          ps[8] = pi + 2;
	          ps[9] = pi + 13;
	          ps[10] = pi + 14;
	          ps[11] = pi + 7;
	          ps[4] = pi + 1;
	          ps[5] = pi + 12;
	          ps[6] = pi + 15;
	          ps[7] = pi + 8;
	          ps[0] = pi;
	          ps[1] = pi + 11;
	          ps[2] = pi + 10;
	          ps[3] = pi + 9;
	          cs[2] = ci + 1;
	          cs[3] = ci + 2;
	          cs[0] = ci;
	          cs[1] = ci + 3;
	          break;
	        case 1:
	          tmp1 = ps[12];
	          tmp2 = ps[13];
	          tmp3 = ps[14];
	          tmp4 = ps[15];
	          ps[12] = tmp4;
	          ps[13] = pi + 0;
	          ps[14] = pi + 1;
	          ps[15] = pi + 2;
	          ps[8] = tmp3;
	          ps[9] = pi + 9;
	          ps[10] = pi + 10;
	          ps[11] = pi + 3;
	          ps[4] = tmp2;
	          ps[5] = pi + 8;
	          ps[6] = pi + 11;
	          ps[7] = pi + 4;
	          ps[0] = tmp1;
	          ps[1] = pi + 7;
	          ps[2] = pi + 6;
	          ps[3] = pi + 5;
	          tmp1 = cs[2];
	          tmp2 = cs[3];
	          cs[2] = tmp2;
	          cs[3] = ci;
	          cs[0] = tmp1;
	          cs[1] = ci + 1;
	          break;
	        case 2:
	          tmp1 = ps[15];
	          tmp2 = ps[11];
	          ps[12] = ps[3];
	          ps[13] = pi + 0;
	          ps[14] = pi + 1;
	          ps[15] = pi + 2;
	          ps[8] = ps[7];
	          ps[9] = pi + 9;
	          ps[10] = pi + 10;
	          ps[11] = pi + 3;
	          ps[4] = tmp2;
	          ps[5] = pi + 8;
	          ps[6] = pi + 11;
	          ps[7] = pi + 4;
	          ps[0] = tmp1;
	          ps[1] = pi + 7;
	          ps[2] = pi + 6;
	          ps[3] = pi + 5;
	          tmp1 = cs[3];
	          cs[2] = cs[1];
	          cs[3] = ci;
	          cs[0] = tmp1;
	          cs[1] = ci + 1;
	          break;
	        case 3:
	          ps[12] = ps[0];
	          ps[13] = pi + 0;
	          ps[14] = pi + 1;
	          ps[15] = pi + 2;
	          ps[8] = ps[1];
	          ps[9] = pi + 9;
	          ps[10] = pi + 10;
	          ps[11] = pi + 3;
	          ps[4] = ps[2];
	          ps[5] = pi + 8;
	          ps[6] = pi + 11;
	          ps[7] = pi + 4;
	          ps[0] = ps[3];
	          ps[1] = pi + 7;
	          ps[2] = pi + 6;
	          ps[3] = pi + 5;
	          cs[2] = cs[0];
	          cs[3] = ci;
	          cs[0] = cs[1];
	          cs[1] = ci + 1;
	          break;
	      }
	      mesh.figures.push({
	        type: 'patch',
	        coords: new Int32Array(ps),
	        colors: new Int32Array(cs)
	      });
	    }
	  }
	  function updateBounds(mesh) {
	    var minX = mesh.coords[0][0],
	        minY = mesh.coords[0][1],
	        maxX = minX,
	        maxY = minY;
	    for (var i = 1, ii = mesh.coords.length; i < ii; i++) {
	      var x = mesh.coords[i][0],
	          y = mesh.coords[i][1];
	      minX = minX > x ? x : minX;
	      minY = minY > y ? y : minY;
	      maxX = maxX < x ? x : maxX;
	      maxY = maxY < y ? y : maxY;
	    }
	    mesh.bounds = [minX, minY, maxX, maxY];
	  }
	  function packData(mesh) {
	    var i, ii, j, jj;
	    var coords = mesh.coords;
	    var coordsPacked = new Float32Array(coords.length * 2);
	    for (i = 0, j = 0, ii = coords.length; i < ii; i++) {
	      var xy = coords[i];
	      coordsPacked[j++] = xy[0];
	      coordsPacked[j++] = xy[1];
	    }
	    mesh.coords = coordsPacked;
	    var colors = mesh.colors;
	    var colorsPacked = new Uint8Array(colors.length * 3);
	    for (i = 0, j = 0, ii = colors.length; i < ii; i++) {
	      var c = colors[i];
	      colorsPacked[j++] = c[0];
	      colorsPacked[j++] = c[1];
	      colorsPacked[j++] = c[2];
	    }
	    mesh.colors = colorsPacked;
	    var figures = mesh.figures;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      var figure = figures[i],
	          ps = figure.coords,
	          cs = figure.colors;
	      for (j = 0, jj = ps.length; j < jj; j++) {
	        ps[j] *= 2;
	        cs[j] *= 3;
	      }
	    }
	  }
	  function Mesh(stream, matrix, xref, res) {
	    assert(isStream(stream), 'Mesh data is not a stream');
	    var dict = stream.dict;
	    this.matrix = matrix;
	    this.shadingType = dict.get('ShadingType');
	    this.type = 'Pattern';
	    this.bbox = dict.getArray('BBox');
	    var cs = dict.get('ColorSpace', 'CS');
	    cs = ColorSpace.parse(cs, xref, res);
	    this.cs = cs;
	    this.background = dict.has('Background') ? cs.getRgb(dict.get('Background'), 0) : null;
	    var fnObj = dict.get('Function');
	    var fn = fnObj ? PDFFunction.parseArray(xref, fnObj) : null;
	    this.coords = [];
	    this.colors = [];
	    this.figures = [];
	    var decodeContext = {
	      bitsPerCoordinate: dict.get('BitsPerCoordinate'),
	      bitsPerComponent: dict.get('BitsPerComponent'),
	      bitsPerFlag: dict.get('BitsPerFlag'),
	      decode: dict.getArray('Decode'),
	      colorFn: fn,
	      colorSpace: cs,
	      numComps: fn ? 1 : cs.numComps
	    };
	    var reader = new MeshStreamReader(stream, decodeContext);
	    var patchMesh = false;
	    switch (this.shadingType) {
	      case ShadingType.FREE_FORM_MESH:
	        decodeType4Shading(this, reader);
	        break;
	      case ShadingType.LATTICE_FORM_MESH:
	        var verticesPerRow = dict.get('VerticesPerRow') | 0;
	        assert(verticesPerRow >= 2, 'Invalid VerticesPerRow');
	        decodeType5Shading(this, reader, verticesPerRow);
	        break;
	      case ShadingType.COONS_PATCH_MESH:
	        decodeType6Shading(this, reader);
	        patchMesh = true;
	        break;
	      case ShadingType.TENSOR_PATCH_MESH:
	        decodeType7Shading(this, reader);
	        patchMesh = true;
	        break;
	      default:
	        error('Unsupported mesh type.');
	        break;
	    }
	    if (patchMesh) {
	      updateBounds(this);
	      for (var i = 0, ii = this.figures.length; i < ii; i++) {
	        buildFigureFromPatch(this, i);
	      }
	    }
	    updateBounds(this);
	    packData(this);
	  }
	  Mesh.prototype = {
	    getIR: function Mesh_getIR() {
	      return ['Mesh', this.shadingType, this.coords, this.colors, this.figures, this.bounds, this.matrix, this.bbox, this.background];
	    }
	  };
	  return Mesh;
	}();
	Shadings.Dummy = function DummyClosure() {
	  function Dummy() {
	    this.type = 'Pattern';
	  }
	  Dummy.prototype = {
	    getIR: function Dummy_getIR() {
	      return ['Dummy'];
	    }
	  };
	  return Dummy;
	}();
	function getTilingPatternIR(operatorList, dict, args) {
	  var matrix = dict.getArray('Matrix');
	  var bbox = dict.getArray('BBox');
	  var xstep = dict.get('XStep');
	  var ystep = dict.get('YStep');
	  var paintType = dict.get('PaintType');
	  var tilingType = dict.get('TilingType');
	  return ['TilingPattern', args, operatorList, matrix, bbox, xstep, ystep, paintType, tilingType];
	}
	exports.Pattern = Pattern;
	exports.getTilingPatternIR = getTilingPatternIR;
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var coreStream = __w_pdfjs_require__(2);
	var coreChunkedStream = __w_pdfjs_require__(12);
	var coreDocument = __w_pdfjs_require__(24);
	var warn = sharedUtil.warn;
	var createValidAbsoluteUrl = sharedUtil.createValidAbsoluteUrl;
	var shadow = sharedUtil.shadow;
	var NotImplementedException = sharedUtil.NotImplementedException;
	var MissingDataException = sharedUtil.MissingDataException;
	var createPromiseCapability = sharedUtil.createPromiseCapability;
	var Util = sharedUtil.Util;
	var Stream = coreStream.Stream;
	var ChunkedStreamManager = coreChunkedStream.ChunkedStreamManager;
	var PDFDocument = coreDocument.PDFDocument;
	var BasePdfManager = function BasePdfManagerClosure() {
	  function BasePdfManager() {
	    throw new Error('Cannot initialize BaseManagerManager');
	  }
	  BasePdfManager.prototype = {
	    get docId() {
	      return this._docId;
	    },
	    get password() {
	      return this._password;
	    },
	    get docBaseUrl() {
	      var docBaseUrl = null;
	      if (this._docBaseUrl) {
	        var absoluteUrl = createValidAbsoluteUrl(this._docBaseUrl);
	        if (absoluteUrl) {
	          docBaseUrl = absoluteUrl.href;
	        } else {
	          warn('Invalid absolute docBaseUrl: "' + this._docBaseUrl + '".');
	        }
	      }
	      return shadow(this, 'docBaseUrl', docBaseUrl);
	    },
	    onLoadedStream: function BasePdfManager_onLoadedStream() {
	      throw new NotImplementedException();
	    },
	    ensureDoc: function BasePdfManager_ensureDoc(prop, args) {
	      return this.ensure(this.pdfDocument, prop, args);
	    },
	    ensureXRef: function BasePdfManager_ensureXRef(prop, args) {
	      return this.ensure(this.pdfDocument.xref, prop, args);
	    },
	    ensureCatalog: function BasePdfManager_ensureCatalog(prop, args) {
	      return this.ensure(this.pdfDocument.catalog, prop, args);
	    },
	    getPage: function BasePdfManager_getPage(pageIndex) {
	      return this.pdfDocument.getPage(pageIndex);
	    },
	    cleanup: function BasePdfManager_cleanup() {
	      return this.pdfDocument.cleanup();
	    },
	    ensure: function BasePdfManager_ensure(obj, prop, args) {
	      return new NotImplementedException();
	    },
	    requestRange: function BasePdfManager_requestRange(begin, end) {
	      return new NotImplementedException();
	    },
	    requestLoadedStream: function BasePdfManager_requestLoadedStream() {
	      return new NotImplementedException();
	    },
	    sendProgressiveData: function BasePdfManager_sendProgressiveData(chunk) {
	      return new NotImplementedException();
	    },
	    updatePassword: function BasePdfManager_updatePassword(password) {
	      this._password = password;
	    },
	    terminate: function BasePdfManager_terminate() {
	      return new NotImplementedException();
	    }
	  };
	  return BasePdfManager;
	}();
	var LocalPdfManager = function LocalPdfManagerClosure() {
	  function LocalPdfManager(docId, data, password, evaluatorOptions, docBaseUrl) {
	    this._docId = docId;
	    this._password = password;
	    this._docBaseUrl = docBaseUrl;
	    this.evaluatorOptions = evaluatorOptions;
	    var stream = new Stream(data);
	    this.pdfDocument = new PDFDocument(this, stream);
	    this._loadedStreamCapability = createPromiseCapability();
	    this._loadedStreamCapability.resolve(stream);
	  }
	  Util.inherit(LocalPdfManager, BasePdfManager, {
	    ensure: function LocalPdfManager_ensure(obj, prop, args) {
	      return new Promise(function (resolve, reject) {
	        try {
	          var value = obj[prop];
	          var result;
	          if (typeof value === 'function') {
	            result = value.apply(obj, args);
	          } else {
	            result = value;
	          }
	          resolve(result);
	        } catch (e) {
	          reject(e);
	        }
	      });
	    },
	    requestRange: function LocalPdfManager_requestRange(begin, end) {
	      return Promise.resolve();
	    },
	    requestLoadedStream: function LocalPdfManager_requestLoadedStream() {},
	    onLoadedStream: function LocalPdfManager_onLoadedStream() {
	      return this._loadedStreamCapability.promise;
	    },
	    terminate: function LocalPdfManager_terminate() {}
	  });
	  return LocalPdfManager;
	}();
	var NetworkPdfManager = function NetworkPdfManagerClosure() {
	  function NetworkPdfManager(docId, pdfNetworkStream, args, evaluatorOptions, docBaseUrl) {
	    this._docId = docId;
	    this._password = args.password;
	    this._docBaseUrl = docBaseUrl;
	    this.msgHandler = args.msgHandler;
	    this.evaluatorOptions = evaluatorOptions;
	    var params = {
	      msgHandler: args.msgHandler,
	      url: args.url,
	      length: args.length,
	      disableAutoFetch: args.disableAutoFetch,
	      rangeChunkSize: args.rangeChunkSize
	    };
	    this.streamManager = new ChunkedStreamManager(pdfNetworkStream, params);
	    this.pdfDocument = new PDFDocument(this, this.streamManager.getStream());
	  }
	  Util.inherit(NetworkPdfManager, BasePdfManager, {
	    ensure: function NetworkPdfManager_ensure(obj, prop, args) {
	      var pdfManager = this;
	      return new Promise(function (resolve, reject) {
	        function ensureHelper() {
	          try {
	            var result;
	            var value = obj[prop];
	            if (typeof value === 'function') {
	              result = value.apply(obj, args);
	            } else {
	              result = value;
	            }
	            resolve(result);
	          } catch (e) {
	            if (!(e instanceof MissingDataException)) {
	              reject(e);
	              return;
	            }
	            pdfManager.streamManager.requestRange(e.begin, e.end).then(ensureHelper, reject);
	          }
	        }
	        ensureHelper();
	      });
	    },
	    requestRange: function NetworkPdfManager_requestRange(begin, end) {
	      return this.streamManager.requestRange(begin, end);
	    },
	    requestLoadedStream: function NetworkPdfManager_requestLoadedStream() {
	      this.streamManager.requestAllChunks();
	    },
	    sendProgressiveData: function NetworkPdfManager_sendProgressiveData(chunk) {
	      this.streamManager.onReceiveData({ chunk: chunk });
	    },
	    onLoadedStream: function NetworkPdfManager_onLoadedStream() {
	      return this.streamManager.onLoadedStream();
	    },
	    terminate: function NetworkPdfManager_terminate() {
	      this.streamManager.abort();
	    }
	  });
	  return NetworkPdfManager;
	}();
	exports.LocalPdfManager = LocalPdfManager;
	exports.NetworkPdfManager = NetworkPdfManager;
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var corePrimitives = __w_pdfjs_require__(1);
	var error = sharedUtil.error;
	var isSpace = sharedUtil.isSpace;
	var EOF = corePrimitives.EOF;
	var PostScriptParser = function PostScriptParserClosure() {
	  function PostScriptParser(lexer) {
	    this.lexer = lexer;
	    this.operators = [];
	    this.token = null;
	    this.prev = null;
	  }
	  PostScriptParser.prototype = {
	    nextToken: function PostScriptParser_nextToken() {
	      this.prev = this.token;
	      this.token = this.lexer.getToken();
	    },
	    accept: function PostScriptParser_accept(type) {
	      if (this.token.type === type) {
	        this.nextToken();
	        return true;
	      }
	      return false;
	    },
	    expect: function PostScriptParser_expect(type) {
	      if (this.accept(type)) {
	        return true;
	      }
	      error('Unexpected symbol: found ' + this.token.type + ' expected ' + type + '.');
	    },
	    parse: function PostScriptParser_parse() {
	      this.nextToken();
	      this.expect(PostScriptTokenTypes.LBRACE);
	      this.parseBlock();
	      this.expect(PostScriptTokenTypes.RBRACE);
	      return this.operators;
	    },
	    parseBlock: function PostScriptParser_parseBlock() {
	      while (true) {
	        if (this.accept(PostScriptTokenTypes.NUMBER)) {
	          this.operators.push(this.prev.value);
	        } else if (this.accept(PostScriptTokenTypes.OPERATOR)) {
	          this.operators.push(this.prev.value);
	        } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
	          this.parseCondition();
	        } else {
	          return;
	        }
	      }
	    },
	    parseCondition: function PostScriptParser_parseCondition() {
	      var conditionLocation = this.operators.length;
	      this.operators.push(null, null);
	      this.parseBlock();
	      this.expect(PostScriptTokenTypes.RBRACE);
	      if (this.accept(PostScriptTokenTypes.IF)) {
	        this.operators[conditionLocation] = this.operators.length;
	        this.operators[conditionLocation + 1] = 'jz';
	      } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
	        var jumpLocation = this.operators.length;
	        this.operators.push(null, null);
	        var endOfTrue = this.operators.length;
	        this.parseBlock();
	        this.expect(PostScriptTokenTypes.RBRACE);
	        this.expect(PostScriptTokenTypes.IFELSE);
	        this.operators[jumpLocation] = this.operators.length;
	        this.operators[jumpLocation + 1] = 'j';
	        this.operators[conditionLocation] = endOfTrue;
	        this.operators[conditionLocation + 1] = 'jz';
	      } else {
	        error('PS Function: error parsing conditional.');
	      }
	    }
	  };
	  return PostScriptParser;
	}();
	var PostScriptTokenTypes = {
	  LBRACE: 0,
	  RBRACE: 1,
	  NUMBER: 2,
	  OPERATOR: 3,
	  IF: 4,
	  IFELSE: 5
	};
	var PostScriptToken = function PostScriptTokenClosure() {
	  function PostScriptToken(type, value) {
	    this.type = type;
	    this.value = value;
	  }
	  var opCache = Object.create(null);
	  PostScriptToken.getOperator = function PostScriptToken_getOperator(op) {
	    var opValue = opCache[op];
	    if (opValue) {
	      return opValue;
	    }
	    return opCache[op] = new PostScriptToken(PostScriptTokenTypes.OPERATOR, op);
	  };
	  PostScriptToken.LBRACE = new PostScriptToken(PostScriptTokenTypes.LBRACE, '{');
	  PostScriptToken.RBRACE = new PostScriptToken(PostScriptTokenTypes.RBRACE, '}');
	  PostScriptToken.IF = new PostScriptToken(PostScriptTokenTypes.IF, 'IF');
	  PostScriptToken.IFELSE = new PostScriptToken(PostScriptTokenTypes.IFELSE, 'IFELSE');
	  return PostScriptToken;
	}();
	var PostScriptLexer = function PostScriptLexerClosure() {
	  function PostScriptLexer(stream) {
	    this.stream = stream;
	    this.nextChar();
	    this.strBuf = [];
	  }
	  PostScriptLexer.prototype = {
	    nextChar: function PostScriptLexer_nextChar() {
	      return this.currentChar = this.stream.getByte();
	    },
	    getToken: function PostScriptLexer_getToken() {
	      var comment = false;
	      var ch = this.currentChar;
	      while (true) {
	        if (ch < 0) {
	          return EOF;
	        }
	        if (comment) {
	          if (ch === 0x0A || ch === 0x0D) {
	            comment = false;
	          }
	        } else if (ch === 0x25) {
	          comment = true;
	        } else if (!isSpace(ch)) {
	          break;
	        }
	        ch = this.nextChar();
	      }
	      switch (ch | 0) {
	        case 0x30:
	        case 0x31:
	        case 0x32:
	        case 0x33:
	        case 0x34:
	        case 0x35:
	        case 0x36:
	        case 0x37:
	        case 0x38:
	        case 0x39:
	        case 0x2B:
	        case 0x2D:
	        case 0x2E:
	          return new PostScriptToken(PostScriptTokenTypes.NUMBER, this.getNumber());
	        case 0x7B:
	          this.nextChar();
	          return PostScriptToken.LBRACE;
	        case 0x7D:
	          this.nextChar();
	          return PostScriptToken.RBRACE;
	      }
	      var strBuf = this.strBuf;
	      strBuf.length = 0;
	      strBuf[0] = String.fromCharCode(ch);
	      while ((ch = this.nextChar()) >= 0 && (ch >= 0x41 && ch <= 0x5A || ch >= 0x61 && ch <= 0x7A)) {
	        strBuf.push(String.fromCharCode(ch));
	      }
	      var str = strBuf.join('');
	      switch (str.toLowerCase()) {
	        case 'if':
	          return PostScriptToken.IF;
	        case 'ifelse':
	          return PostScriptToken.IFELSE;
	        default:
	          return PostScriptToken.getOperator(str);
	      }
	    },
	    getNumber: function PostScriptLexer_getNumber() {
	      var ch = this.currentChar;
	      var strBuf = this.strBuf;
	      strBuf.length = 0;
	      strBuf[0] = String.fromCharCode(ch);
	      while ((ch = this.nextChar()) >= 0) {
	        if (ch >= 0x30 && ch <= 0x39 || ch === 0x2D || ch === 0x2E) {
	          strBuf.push(String.fromCharCode(ch));
	        } else {
	          break;
	        }
	      }
	      var value = parseFloat(strBuf.join(''));
	      if (isNaN(value)) {
	        error('Invalid floating point number: ' + value);
	      }
	      return value;
	    }
	  };
	  return PostScriptLexer;
	}();
	exports.PostScriptLexer = PostScriptLexer;
	exports.PostScriptParser = PostScriptParser;
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var sharedUtil = __w_pdfjs_require__(0);
	var coreStream = __w_pdfjs_require__(2);
	var coreEncodings = __w_pdfjs_require__(4);
	var warn = sharedUtil.warn;
	var isSpace = sharedUtil.isSpace;
	var Stream = coreStream.Stream;
	var getEncoding = coreEncodings.getEncoding;
	var HINTING_ENABLED = false;
	var Type1CharString = function Type1CharStringClosure() {
	  var COMMAND_MAP = {
	    'hstem': [1],
	    'vstem': [3],
	    'vmoveto': [4],
	    'rlineto': [5],
	    'hlineto': [6],
	    'vlineto': [7],
	    'rrcurveto': [8],
	    'callsubr': [10],
	    'flex': [12, 35],
	    'drop': [12, 18],
	    'endchar': [14],
	    'rmoveto': [21],
	    'hmoveto': [22],
	    'vhcurveto': [30],
	    'hvcurveto': [31]
	  };
	  function Type1CharString() {
	    this.width = 0;
	    this.lsb = 0;
	    this.flexing = false;
	    this.output = [];
	    this.stack = [];
	  }
	  Type1CharString.prototype = {
	    convert: function Type1CharString_convert(encoded, subrs, seacAnalysisEnabled) {
	      var count = encoded.length;
	      var error = false;
	      var wx, sbx, subrNumber;
	      for (var i = 0; i < count; i++) {
	        var value = encoded[i];
	        if (value < 32) {
	          if (value === 12) {
	            value = (value << 8) + encoded[++i];
	          }
	          switch (value) {
	            case 1:
	              if (!HINTING_ENABLED) {
	                this.stack = [];
	                break;
	              }
	              error = this.executeCommand(2, COMMAND_MAP.hstem);
	              break;
	            case 3:
	              if (!HINTING_ENABLED) {
	                this.stack = [];
	                break;
	              }
	              error = this.executeCommand(2, COMMAND_MAP.vstem);
	              break;
	            case 4:
	              if (this.flexing) {
	                if (this.stack.length < 1) {
	                  error = true;
	                  break;
	                }
	                var dy = this.stack.pop();
	                this.stack.push(0, dy);
	                break;
	              }
	              error = this.executeCommand(1, COMMAND_MAP.vmoveto);
	              break;
	            case 5:
	              error = this.executeCommand(2, COMMAND_MAP.rlineto);
	              break;
	            case 6:
	              error = this.executeCommand(1, COMMAND_MAP.hlineto);
	              break;
	            case 7:
	              error = this.executeCommand(1, COMMAND_MAP.vlineto);
	              break;
	            case 8:
	              error = this.executeCommand(6, COMMAND_MAP.rrcurveto);
	              break;
	            case 9:
	              this.stack = [];
	              break;
	            case 10:
	              if (this.stack.length < 1) {
	                error = true;
	                break;
	              }
	              subrNumber = this.stack.pop();
	              error = this.convert(subrs[subrNumber], subrs, seacAnalysisEnabled);
	              break;
	            case 11:
	              return error;
	            case 13:
	              if (this.stack.length < 2) {
	                error = true;
	                break;
	              }
	              wx = this.stack.pop();
	              sbx = this.stack.pop();
	              this.lsb = sbx;
	              this.width = wx;
	              this.stack.push(wx, sbx);
	              error = this.executeCommand(2, COMMAND_MAP.hmoveto);
	              break;
	            case 14:
	              this.output.push(COMMAND_MAP.endchar[0]);
	              break;
	            case 21:
	              if (this.flexing) {
	                break;
	              }
	              error = this.executeCommand(2, COMMAND_MAP.rmoveto);
	              break;
	            case 22:
	              if (this.flexing) {
	                this.stack.push(0);
	                break;
	              }
	              error = this.executeCommand(1, COMMAND_MAP.hmoveto);
	              break;
	            case 30:
	              error = this.executeCommand(4, COMMAND_MAP.vhcurveto);
	              break;
	            case 31:
	              error = this.executeCommand(4, COMMAND_MAP.hvcurveto);
	              break;
	            case (12 << 8) + 0:
	              this.stack = [];
	              break;
	            case (12 << 8) + 1:
	              if (!HINTING_ENABLED) {
	                this.stack = [];
	                break;
	              }
	              error = this.executeCommand(2, COMMAND_MAP.vstem);
	              break;
	            case (12 << 8) + 2:
	              if (!HINTING_ENABLED) {
	                this.stack = [];
	                break;
	              }
	              error = this.executeCommand(2, COMMAND_MAP.hstem);
	              break;
	            case (12 << 8) + 6:
	              if (seacAnalysisEnabled) {
	                this.seac = this.stack.splice(-4, 4);
	                error = this.executeCommand(0, COMMAND_MAP.endchar);
	              } else {
	                error = this.executeCommand(4, COMMAND_MAP.endchar);
	              }
	              break;
	            case (12 << 8) + 7:
	              if (this.stack.length < 4) {
	                error = true;
	                break;
	              }
	              this.stack.pop();
	              wx = this.stack.pop();
	              var sby = this.stack.pop();
	              sbx = this.stack.pop();
	              this.lsb = sbx;
	              this.width = wx;
	              this.stack.push(wx, sbx, sby);
	              error = this.executeCommand(3, COMMAND_MAP.rmoveto);
	              break;
	            case (12 << 8) + 12:
	              if (this.stack.length < 2) {
	                error = true;
	                break;
	              }
	              var num2 = this.stack.pop();
	              var num1 = this.stack.pop();
	              this.stack.push(num1 / num2);
	              break;
	            case (12 << 8) + 16:
	              if (this.stack.length < 2) {
	                error = true;
	                break;
	              }
	              subrNumber = this.stack.pop();
	              var numArgs = this.stack.pop();
	              if (subrNumber === 0 && numArgs === 3) {
	                var flexArgs = this.stack.splice(this.stack.length - 17, 17);
	                this.stack.push(flexArgs[2] + flexArgs[0], flexArgs[3] + flexArgs[1], flexArgs[4], flexArgs[5], flexArgs[6], flexArgs[7], flexArgs[8], flexArgs[9], flexArgs[10], flexArgs[11], flexArgs[12], flexArgs[13], flexArgs[14]);
	                error = this.executeCommand(13, COMMAND_MAP.flex, true);
	                this.flexing = false;
	                this.stack.push(flexArgs[15], flexArgs[16]);
	              } else if (subrNumber === 1 && numArgs === 0) {
	                this.flexing = true;
	              }
	              break;
	            case (12 << 8) + 17:
	              break;
	            case (12 << 8) + 33:
	              this.stack = [];
	              break;
	            default:
	              warn('Unknown type 1 charstring command of "' + value + '"');
	              break;
	          }
	          if (error) {
	            break;
	          }
	          continue;
	        } else if (value <= 246) {
	          value = value - 139;
	        } else if (value <= 250) {
	          value = (value - 247) * 256 + encoded[++i] + 108;
	        } else if (value <= 254) {
	          value = -((value - 251) * 256) - encoded[++i] - 108;
	        } else {
	          value = (encoded[++i] & 0xff) << 24 | (encoded[++i] & 0xff) << 16 | (encoded[++i] & 0xff) << 8 | (encoded[++i] & 0xff) << 0;
	        }
	        this.stack.push(value);
	      }
	      return error;
	    },
	    executeCommand: function executeCommand(howManyArgs, command, keepStack) {
	      var stackLength = this.stack.length;
	      if (howManyArgs > stackLength) {
	        return true;
	      }
	      var start = stackLength - howManyArgs;
	      for (var i = start; i < stackLength; i++) {
	        var value = this.stack[i];
	        if (value === (value | 0)) {
	          this.output.push(28, value >> 8 & 0xff, value & 0xff);
	        } else {
	          value = 65536 * value | 0;
	          this.output.push(255, value >> 24 & 0xFF, value >> 16 & 0xFF, value >> 8 & 0xFF, value & 0xFF);
	        }
	      }
	      this.output.push.apply(this.output, command);
	      if (keepStack) {
	        this.stack.splice(start, howManyArgs);
	      } else {
	        this.stack.length = 0;
	      }
	      return false;
	    }
	  };
	  return Type1CharString;
	}();
	var Type1Parser = function Type1ParserClosure() {
	  var EEXEC_ENCRYPT_KEY = 55665;
	  var CHAR_STRS_ENCRYPT_KEY = 4330;
	  function isHexDigit(code) {
	    return code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102;
	  }
	  function decrypt(data, key, discardNumber) {
	    if (discardNumber >= data.length) {
	      return new Uint8Array(0);
	    }
	    var r = key | 0,
	        c1 = 52845,
	        c2 = 22719,
	        i,
	        j;
	    for (i = 0; i < discardNumber; i++) {
	      r = (data[i] + r) * c1 + c2 & (1 << 16) - 1;
	    }
	    var count = data.length - discardNumber;
	    var decrypted = new Uint8Array(count);
	    for (i = discardNumber, j = 0; j < count; i++, j++) {
	      var value = data[i];
	      decrypted[j] = value ^ r >> 8;
	      r = (value + r) * c1 + c2 & (1 << 16) - 1;
	    }
	    return decrypted;
	  }
	  function decryptAscii(data, key, discardNumber) {
	    var r = key | 0,
	        c1 = 52845,
	        c2 = 22719;
	    var count = data.length,
	        maybeLength = count >>> 1;
	    var decrypted = new Uint8Array(maybeLength);
	    var i, j;
	    for (i = 0, j = 0; i < count; i++) {
	      var digit1 = data[i];
	      if (!isHexDigit(digit1)) {
	        continue;
	      }
	      i++;
	      var digit2;
	      while (i < count && !isHexDigit(digit2 = data[i])) {
	        i++;
	      }
	      if (i < count) {
	        var value = parseInt(String.fromCharCode(digit1, digit2), 16);
	        decrypted[j++] = value ^ r >> 8;
	        r = (value + r) * c1 + c2 & (1 << 16) - 1;
	      }
	    }
	    return Array.prototype.slice.call(decrypted, discardNumber, j);
	  }
	  function isSpecial(c) {
	    return c === 0x2F || c === 0x5B || c === 0x5D || c === 0x7B || c === 0x7D || c === 0x28 || c === 0x29;
	  }
	  function Type1Parser(stream, encrypted, seacAnalysisEnabled) {
	    if (encrypted) {
	      var data = stream.getBytes();
	      var isBinary = !(isHexDigit(data[0]) && isHexDigit(data[1]) && isHexDigit(data[2]) && isHexDigit(data[3]));
	      stream = new Stream(isBinary ? decrypt(data, EEXEC_ENCRYPT_KEY, 4) : decryptAscii(data, EEXEC_ENCRYPT_KEY, 4));
	    }
	    this.seacAnalysisEnabled = !!seacAnalysisEnabled;
	    this.stream = stream;
	    this.nextChar();
	  }
	  Type1Parser.prototype = {
	    readNumberArray: function Type1Parser_readNumberArray() {
	      this.getToken();
	      var array = [];
	      while (true) {
	        var token = this.getToken();
	        if (token === null || token === ']' || token === '}') {
	          break;
	        }
	        array.push(parseFloat(token || 0));
	      }
	      return array;
	    },
	    readNumber: function Type1Parser_readNumber() {
	      var token = this.getToken();
	      return parseFloat(token || 0);
	    },
	    readInt: function Type1Parser_readInt() {
	      var token = this.getToken();
	      return parseInt(token || 0, 10) | 0;
	    },
	    readBoolean: function Type1Parser_readBoolean() {
	      var token = this.getToken();
	      return token === 'true' ? 1 : 0;
	    },
	    nextChar: function Type1_nextChar() {
	      return this.currentChar = this.stream.getByte();
	    },
	    getToken: function Type1Parser_getToken() {
	      var comment = false;
	      var ch = this.currentChar;
	      while (true) {
	        if (ch === -1) {
	          return null;
	        }
	        if (comment) {
	          if (ch === 0x0A || ch === 0x0D) {
	            comment = false;
	          }
	        } else if (ch === 0x25) {
	          comment = true;
	        } else if (!isSpace(ch)) {
	          break;
	        }
	        ch = this.nextChar();
	      }
	      if (isSpecial(ch)) {
	        this.nextChar();
	        return String.fromCharCode(ch);
	      }
	      var token = '';
	      do {
	        token += String.fromCharCode(ch);
	        ch = this.nextChar();
	      } while (ch >= 0 && !isSpace(ch) && !isSpecial(ch));
	      return token;
	    },
	    extractFontProgram: function Type1Parser_extractFontProgram() {
	      var stream = this.stream;
	      var subrs = [],
	          charstrings = [];
	      var privateData = Object.create(null);
	      privateData['lenIV'] = 4;
	      var program = {
	        subrs: [],
	        charstrings: [],
	        properties: { 'privateData': privateData }
	      };
	      var token, length, data, lenIV, encoded;
	      while ((token = this.getToken()) !== null) {
	        if (token !== '/') {
	          continue;
	        }
	        token = this.getToken();
	        switch (token) {
	          case 'CharStrings':
	            this.getToken();
	            this.getToken();
	            this.getToken();
	            this.getToken();
	            while (true) {
	              token = this.getToken();
	              if (token === null || token === 'end') {
	                break;
	              }
	              if (token !== '/') {
	                continue;
	              }
	              var glyph = this.getToken();
	              length = this.readInt();
	              this.getToken();
	              data = stream.makeSubStream(stream.pos, length);
	              lenIV = program.properties.privateData['lenIV'];
	              encoded = decrypt(data.getBytes(), CHAR_STRS_ENCRYPT_KEY, lenIV);
	              stream.skip(length);
	              this.nextChar();
	              token = this.getToken();
	              if (token === 'noaccess') {
	                this.getToken();
	              }
	              charstrings.push({
	                glyph: glyph,
	                encoded: encoded
	              });
	            }
	            break;
	          case 'Subrs':
	            this.readInt();
	            this.getToken();
	            while ((token = this.getToken()) === 'dup') {
	              var index = this.readInt();
	              length = this.readInt();
	              this.getToken();
	              data = stream.makeSubStream(stream.pos, length);
	              lenIV = program.properties.privateData['lenIV'];
	              encoded = decrypt(data.getBytes(), CHAR_STRS_ENCRYPT_KEY, lenIV);
	              stream.skip(length);
	              this.nextChar();
	              token = this.getToken();
	              if (token === 'noaccess') {
	                this.getToken();
	              }
	              subrs[index] = encoded;
	            }
	            break;
	          case 'BlueValues':
	          case 'OtherBlues':
	          case 'FamilyBlues':
	          case 'FamilyOtherBlues':
	            var blueArray = this.readNumberArray();
	            if (blueArray.length > 0 && blueArray.length % 2 === 0 && HINTING_ENABLED) {
	              program.properties.privateData[token] = blueArray;
	            }
	            break;
	          case 'StemSnapH':
	          case 'StemSnapV':
	            program.properties.privateData[token] = this.readNumberArray();
	            break;
	          case 'StdHW':
	          case 'StdVW':
	            program.properties.privateData[token] = this.readNumberArray()[0];
	            break;
	          case 'BlueShift':
	          case 'lenIV':
	          case 'BlueFuzz':
	          case 'BlueScale':
	          case 'LanguageGroup':
	          case 'ExpansionFactor':
	            program.properties.privateData[token] = this.readNumber();
	            break;
	          case 'ForceBold':
	            program.properties.privateData[token] = this.readBoolean();
	            break;
	        }
	      }
	      for (var i = 0; i < charstrings.length; i++) {
	        glyph = charstrings[i].glyph;
	        encoded = charstrings[i].encoded;
	        var charString = new Type1CharString();
	        var error = charString.convert(encoded, subrs, this.seacAnalysisEnabled);
	        var output = charString.output;
	        if (error) {
	          output = [14];
	        }
	        program.charstrings.push({
	          glyphName: glyph,
	          charstring: output,
	          width: charString.width,
	          lsb: charString.lsb,
	          seac: charString.seac
	        });
	      }
	      return program;
	    },
	    extractFontHeader: function Type1Parser_extractFontHeader(properties) {
	      var token;
	      while ((token = this.getToken()) !== null) {
	        if (token !== '/') {
	          continue;
	        }
	        token = this.getToken();
	        switch (token) {
	          case 'FontMatrix':
	            var matrix = this.readNumberArray();
	            properties.fontMatrix = matrix;
	            break;
	          case 'Encoding':
	            var encodingArg = this.getToken();
	            var encoding;
	            if (!/^\d+$/.test(encodingArg)) {
	              encoding = getEncoding(encodingArg);
	            } else {
	              encoding = [];
	              var size = parseInt(encodingArg, 10) | 0;
	              this.getToken();
	              for (var j = 0; j < size; j++) {
	                token = this.getToken();
	                while (token !== 'dup' && token !== 'def') {
	                  token = this.getToken();
	                  if (token === null) {
	                    return;
	                  }
	                }
	                if (token === 'def') {
	                  break;
	                }
	                var index = this.readInt();
	                this.getToken();
	                var glyph = this.getToken();
	                encoding[index] = glyph;
	                this.getToken();
	              }
	            }
	            properties.builtInEncoding = encoding;
	            break;
	          case 'FontBBox':
	            var fontBBox = this.readNumberArray();
	            properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
	            properties.descent = Math.min(fontBBox[1], fontBBox[3]);
	            properties.ascentScaled = true;
	            break;
	        }
	      }
	    }
	  };
	  return Type1Parser;
	}();
	exports.Type1Parser = Type1Parser;
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var pdfjsVersion = '1.8.331';
	var pdfjsBuild = '0dbc68a6';
	var pdfjsCoreWorker = __w_pdfjs_require__(8);
	{
	  __w_pdfjs_require__(19);
	}
	exports.WorkerMessageHandler = pdfjsCoreWorker.WorkerMessageHandler;
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
	  var globalScope = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : undefined;
	  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
	  var isAndroid = /Android/.test(userAgent);
	  var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
	  var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
	  var isChrome = userAgent.indexOf('Chrom') >= 0;
	  var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
	  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
	  var isIE = userAgent.indexOf('Trident') >= 0;
	  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
	  var isOpera = userAgent.indexOf('Opera') >= 0;
	  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
	  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
	  if (typeof PDFJS === 'undefined') {
	    globalScope.PDFJS = {};
	  }
	  PDFJS.compatibilityChecked = true;
	  (function checkTypedArrayCompatibility() {
	    if (typeof Uint8Array !== 'undefined') {
	      if (typeof Uint8Array.prototype.subarray === 'undefined') {
	        Uint8Array.prototype.subarray = function subarray(start, end) {
	          return new Uint8Array(this.slice(start, end));
	        };
	        Float32Array.prototype.subarray = function subarray(start, end) {
	          return new Float32Array(this.slice(start, end));
	        };
	      }
	      if (typeof Float64Array === 'undefined') {
	        globalScope.Float64Array = Float32Array;
	      }
	      return;
	    }
	    function subarray(start, end) {
	      return new TypedArray(this.slice(start, end));
	    }
	    function setArrayOffset(array, offset) {
	      if (arguments.length < 2) {
	        offset = 0;
	      }
	      for (var i = 0, n = array.length; i < n; ++i, ++offset) {
	        this[offset] = array[i] & 0xFF;
	      }
	    }
	    function Uint32ArrayView(buffer, length) {
	      this.buffer = buffer;
	      this.byteLength = buffer.length;
	      this.length = length;
	      ensureUint32ArrayViewProps(this.length);
	    }
	    Uint32ArrayView.prototype = Object.create(null);
	    var uint32ArrayViewSetters = 0;
	    function createUint32ArrayProp(index) {
	      return {
	        get: function get() {
	          var buffer = this.buffer,
	              offset = index << 2;
	          return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
	        },
	        set: function set(value) {
	          var buffer = this.buffer,
	              offset = index << 2;
	          buffer[offset] = value & 255;
	          buffer[offset + 1] = value >> 8 & 255;
	          buffer[offset + 2] = value >> 16 & 255;
	          buffer[offset + 3] = value >>> 24 & 255;
	        }
	      };
	    }
	    function ensureUint32ArrayViewProps(length) {
	      while (uint32ArrayViewSetters < length) {
	        Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
	        uint32ArrayViewSetters++;
	      }
	    }
	    function TypedArray(arg1) {
	      var result, i, n;
	      if (typeof arg1 === 'number') {
	        result = [];
	        for (i = 0; i < arg1; ++i) {
	          result[i] = 0;
	        }
	      } else if ('slice' in arg1) {
	        result = arg1.slice(0);
	      } else {
	        result = [];
	        for (i = 0, n = arg1.length; i < n; ++i) {
	          result[i] = arg1[i];
	        }
	      }
	      result.subarray = subarray;
	      result.buffer = result;
	      result.byteLength = result.length;
	      result.set = setArrayOffset;
	      if ((typeof arg1 === 'undefined' ? 'undefined' : _typeof(arg1)) === 'object' && arg1.buffer) {
	        result.buffer = arg1.buffer;
	      }
	      return result;
	    }
	    globalScope.Uint8Array = TypedArray;
	    globalScope.Int8Array = TypedArray;
	    globalScope.Int32Array = TypedArray;
	    globalScope.Uint16Array = TypedArray;
	    globalScope.Float32Array = TypedArray;
	    globalScope.Float64Array = TypedArray;
	    globalScope.Uint32Array = function () {
	      if (arguments.length === 3) {
	        if (arguments[1] !== 0) {
	          throw new Error('offset !== 0 is not supported');
	        }
	        return new Uint32ArrayView(arguments[0], arguments[2]);
	      }
	      return TypedArray.apply(this, arguments);
	    };
	  })();
	  (function canvasPixelArrayBuffer() {
	    if (!hasDOM || !window.CanvasPixelArray) {
	      return;
	    }
	    var cpaProto = window.CanvasPixelArray.prototype;
	    if ('buffer' in cpaProto) {
	      return;
	    }
	    Object.defineProperty(cpaProto, 'buffer', {
	      get: function get() {
	        return this;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	    Object.defineProperty(cpaProto, 'byteLength', {
	      get: function get() {
	        return this.length;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	  })();
	  (function normalizeURLObject() {
	    if (!globalScope.URL) {
	      globalScope.URL = globalScope.webkitURL;
	    }
	  })();
	  (function checkObjectDefinePropertyCompatibility() {
	    if (typeof Object.defineProperty !== 'undefined') {
	      var definePropertyPossible = true;
	      try {
	        if (hasDOM) {
	          Object.defineProperty(new Image(), 'id', { value: 'test' });
	        }
	        var Test = function Test() {};
	        Test.prototype = {
	          get id() {}
	        };
	        Object.defineProperty(new Test(), 'id', {
	          value: '',
	          configurable: true,
	          enumerable: true,
	          writable: false
	        });
	      } catch (e) {
	        definePropertyPossible = false;
	      }
	      if (definePropertyPossible) {
	        return;
	      }
	    }
	    Object.defineProperty = function objectDefineProperty(obj, name, def) {
	      delete obj[name];
	      if ('get' in def) {
	        obj.__defineGetter__(name, def['get']);
	      }
	      if ('set' in def) {
	        obj.__defineSetter__(name, def['set']);
	      }
	      if ('value' in def) {
	        obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
	          this.__defineGetter__(name, function objectDefinePropertyGetter() {
	            return value;
	          });
	          return value;
	        });
	        obj[name] = def.value;
	      }
	    };
	  })();
	  (function checkXMLHttpRequestResponseCompatibility() {
	    if (typeof XMLHttpRequest === 'undefined') {
	      return;
	    }
	    var xhrPrototype = XMLHttpRequest.prototype;
	    var xhr = new XMLHttpRequest();
	    if (!('overrideMimeType' in xhr)) {
	      Object.defineProperty(xhrPrototype, 'overrideMimeType', {
	        value: function xmlHttpRequestOverrideMimeType(mimeType) {}
	      });
	    }
	    if ('responseType' in xhr) {
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'responseType', {
	      get: function xmlHttpRequestGetResponseType() {
	        return this._responseType || 'text';
	      },
	      set: function xmlHttpRequestSetResponseType(value) {
	        if (value === 'text' || value === 'arraybuffer') {
	          this._responseType = value;
	          if (value === 'arraybuffer' && typeof this.overrideMimeType === 'function') {
	            this.overrideMimeType('text/plain; charset=x-user-defined');
	          }
	        }
	      }
	    });
	    if (typeof VBArray !== 'undefined') {
	      Object.defineProperty(xhrPrototype, 'response', {
	        get: function xmlHttpRequestResponseGet() {
	          if (this.responseType === 'arraybuffer') {
	            return new Uint8Array(new VBArray(this.responseBody).toArray());
	          }
	          return this.responseText;
	        }
	      });
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'response', {
	      get: function xmlHttpRequestResponseGet() {
	        if (this.responseType !== 'arraybuffer') {
	          return this.responseText;
	        }
	        var text = this.responseText;
	        var i,
	            n = text.length;
	        var result = new Uint8Array(n);
	        for (i = 0; i < n; ++i) {
	          result[i] = text.charCodeAt(i) & 0xFF;
	        }
	        return result.buffer;
	      }
	    });
	  })();
	  (function checkWindowBtoaCompatibility() {
	    if ('btoa' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.btoa = function (chars) {
	      var buffer = '';
	      var i, n;
	      for (i = 0, n = chars.length; i < n; i += 3) {
	        var b1 = chars.charCodeAt(i) & 0xFF;
	        var b2 = chars.charCodeAt(i + 1) & 0xFF;
	        var b3 = chars.charCodeAt(i + 2) & 0xFF;
	        var d1 = b1 >> 2,
	            d2 = (b1 & 3) << 4 | b2 >> 4;
	        var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	        var d4 = i + 2 < n ? b3 & 0x3F : 64;
	        buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
	      }
	      return buffer;
	    };
	  })();
	  (function checkWindowAtobCompatibility() {
	    if ('atob' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.atob = function (input) {
	      input = input.replace(/=+$/, '');
	      if (input.length % 4 === 1) {
	        throw new Error('bad atob input');
	      }
	      for (var bc = 0, bs, buffer, idx = 0, output = ''; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
	        buffer = digits.indexOf(buffer);
	      }
	      return output;
	    };
	  })();
	  (function checkFunctionPrototypeBindCompatibility() {
	    if (typeof Function.prototype.bind !== 'undefined') {
	      return;
	    }
	    Function.prototype.bind = function functionPrototypeBind(obj) {
	      var fn = this,
	          headArgs = Array.prototype.slice.call(arguments, 1);
	      var bound = function functionPrototypeBindBound() {
	        var args = headArgs.concat(Array.prototype.slice.call(arguments));
	        return fn.apply(obj, args);
	      };
	      return bound;
	    };
	  })();
	  (function checkDatasetProperty() {
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('dataset' in div) {
	      return;
	    }
	    Object.defineProperty(HTMLElement.prototype, 'dataset', {
	      get: function get() {
	        if (this._dataset) {
	          return this._dataset;
	        }
	        var dataset = {};
	        for (var j = 0, jj = this.attributes.length; j < jj; j++) {
	          var attribute = this.attributes[j];
	          if (attribute.name.substring(0, 5) !== 'data-') {
	            continue;
	          }
	          var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
	            return ch.toUpperCase();
	          });
	          dataset[key] = attribute.value;
	        }
	        Object.defineProperty(this, '_dataset', {
	          value: dataset,
	          writable: false,
	          enumerable: false
	        });
	        return dataset;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkClassListProperty() {
	    function changeList(element, itemName, add, remove) {
	      var s = element.className || '';
	      var list = s.split(/\s+/g);
	      if (list[0] === '') {
	        list.shift();
	      }
	      var index = list.indexOf(itemName);
	      if (index < 0 && add) {
	        list.push(itemName);
	      }
	      if (index >= 0 && remove) {
	        list.splice(index, 1);
	      }
	      element.className = list.join(' ');
	      return index >= 0;
	    }
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('classList' in div) {
	      return;
	    }
	    var classListPrototype = {
	      add: function add(name) {
	        changeList(this.element, name, true, false);
	      },
	      contains: function contains(name) {
	        return changeList(this.element, name, false, false);
	      },
	      remove: function remove(name) {
	        changeList(this.element, name, false, true);
	      },
	      toggle: function toggle(name) {
	        changeList(this.element, name, true, true);
	      }
	    };
	    Object.defineProperty(HTMLElement.prototype, 'classList', {
	      get: function get() {
	        if (this._classList) {
	          return this._classList;
	        }
	        var classList = Object.create(classListPrototype, {
	          element: {
	            value: this,
	            writable: false,
	            enumerable: true
	          }
	        });
	        Object.defineProperty(this, '_classList', {
	          value: classList,
	          writable: false,
	          enumerable: false
	        });
	        return classList;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkWorkerConsoleCompatibility() {
	    if (typeof importScripts === 'undefined' || 'console' in globalScope) {
	      return;
	    }
	    var consoleTimer = {};
	    var workerConsole = {
	      log: function log() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_log',
	          data: args
	        });
	      },
	      error: function error() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_error',
	          data: args
	        });
	      },
	      time: function time(name) {
	        consoleTimer[name] = Date.now();
	      },
	      timeEnd: function timeEnd(name) {
	        var time = consoleTimer[name];
	        if (!time) {
	          throw new Error('Unknown timer name ' + name);
	        }
	        this.log('Timer:', name, Date.now() - time);
	      }
	    };
	    globalScope.console = workerConsole;
	  })();
	  (function checkConsoleCompatibility() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!('console' in window)) {
	      window.console = {
	        log: function log() {},
	        error: function error() {},
	        warn: function warn() {}
	      };
	      return;
	    }
	    if (!('bind' in console.log)) {
	      console.log = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.log);
	      console.error = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.error);
	      console.warn = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.warn);
	      return;
	    }
	  })();
	  (function checkOnClickCompatibility() {
	    function ignoreIfTargetDisabled(event) {
	      if (isDisabled(event.target)) {
	        event.stopPropagation();
	      }
	    }
	    function isDisabled(node) {
	      return node.disabled || node.parentNode && isDisabled(node.parentNode);
	    }
	    if (isOpera) {
	      document.addEventListener('click', ignoreIfTargetDisabled, true);
	    }
	  })();
	  (function checkOnBlobSupport() {
	    if (isIE || isIOSChrome) {
	      PDFJS.disableCreateObjectURL = true;
	    }
	  })();
	  (function checkNavigatorLanguage() {
	    if (typeof navigator === 'undefined') {
	      return;
	    }
	    if ('language' in navigator) {
	      return;
	    }
	    PDFJS.locale = navigator.userLanguage || 'en-US';
	  })();
	  (function checkRangeRequests() {
	    if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
	      PDFJS.disableRange = true;
	      PDFJS.disableStream = true;
	    }
	  })();
	  (function checkHistoryManipulation() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!history.pushState || isAndroidPre3) {
	      PDFJS.disableHistory = true;
	    }
	  })();
	  (function checkSetPresenceInImageData() {
	    if (!hasDOM) {
	      return;
	    }
	    if (window.CanvasPixelArray) {
	      if (typeof window.CanvasPixelArray.prototype.set !== 'function') {
	        window.CanvasPixelArray.prototype.set = function (arr) {
	          for (var i = 0, ii = this.length; i < ii; i++) {
	            this[i] = arr[i];
	          }
	        };
	      }
	    } else {
	      var polyfill = false,
	          versionMatch;
	      if (isChrome) {
	        versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
	        polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
	      } else if (isAndroid) {
	        polyfill = isAndroidPre5;
	      } else if (isSafari) {
	        versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
	        polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
	      }
	      if (polyfill) {
	        var contextPrototype = window.CanvasRenderingContext2D.prototype;
	        var createImageData = contextPrototype.createImageData;
	        contextPrototype.createImageData = function (w, h) {
	          var imageData = createImageData.call(this, w, h);
	          imageData.data.set = function (arr) {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	              this[i] = arr[i];
	            }
	          };
	          return imageData;
	        };
	        contextPrototype = null;
	      }
	    }
	  })();
	  (function checkRequestAnimationFrame() {
	    function installFakeAnimationFrameFunctions() {
	      window.requestAnimationFrame = function (callback) {
	        return window.setTimeout(callback, 20);
	      };
	      window.cancelAnimationFrame = function (timeoutID) {
	        window.clearTimeout(timeoutID);
	      };
	    }
	    if (!hasDOM) {
	      return;
	    }
	    if (isIOS) {
	      installFakeAnimationFrameFunctions();
	      return;
	    }
	    if ('requestAnimationFrame' in window) {
	      return;
	    }
	    window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
	    if (window.requestAnimationFrame) {
	      return;
	    }
	    installFakeAnimationFrameFunctions();
	  })();
	  (function checkCanvasSizeLimitation() {
	    if (isIOS || isAndroid) {
	      PDFJS.maxCanvasPixels = 5242880;
	    }
	  })();
	  (function checkFullscreenSupport() {
	    if (!hasDOM) {
	      return;
	    }
	    if (isIE && window.parent !== window) {
	      PDFJS.disableFullscreen = true;
	    }
	  })();
	  (function checkCurrentScript() {
	    if (!hasDOM) {
	      return;
	    }
	    if ('currentScript' in document) {
	      return;
	    }
	    Object.defineProperty(document, 'currentScript', {
	      get: function get() {
	        var scripts = document.getElementsByTagName('script');
	        return scripts[scripts.length - 1];
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkInputTypeNumberAssign() {
	    if (!hasDOM) {
	      return;
	    }
	    var el = document.createElement('input');
	    try {
	      el.type = 'number';
	    } catch (ex) {
	      var inputProto = el.constructor.prototype;
	      var typeProperty = Object.getOwnPropertyDescriptor(inputProto, 'type');
	      Object.defineProperty(inputProto, 'type', {
	        get: function get() {
	          return typeProperty.get.call(this);
	        },
	        set: function set(value) {
	          typeProperty.set.call(this, value === 'number' ? 'text' : value);
	        },
	
	        enumerable: true,
	        configurable: true
	      });
	    }
	  })();
	  (function checkDocumentReadyState() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!document.attachEvent) {
	      return;
	    }
	    var documentProto = document.constructor.prototype;
	    var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, 'readyState');
	    Object.defineProperty(documentProto, 'readyState', {
	      get: function get() {
	        var value = readyStateProto.get.call(this);
	        return value === 'interactive' ? 'loading' : value;
	      },
	      set: function set(value) {
	        readyStateProto.set.call(this, value);
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkChildNodeRemove() {
	    if (!hasDOM) {
	      return;
	    }
	    if (typeof Element.prototype.remove !== 'undefined') {
	      return;
	    }
	    Element.prototype.remove = function () {
	      if (this.parentNode) {
	        this.parentNode.removeChild(this);
	      }
	    };
	  })();
	  (function checkPromise() {
	    if (globalScope.Promise) {
	      if (typeof globalScope.Promise.all !== 'function') {
	        globalScope.Promise.all = function (iterable) {
	          var count = 0,
	              results = [],
	              resolve,
	              reject;
	          var promise = new globalScope.Promise(function (resolve_, reject_) {
	            resolve = resolve_;
	            reject = reject_;
	          });
	          iterable.forEach(function (p, i) {
	            count++;
	            p.then(function (result) {
	              results[i] = result;
	              count--;
	              if (count === 0) {
	                resolve(results);
	              }
	            }, reject);
	          });
	          if (count === 0) {
	            resolve(results);
	          }
	          return promise;
	        };
	      }
	      if (typeof globalScope.Promise.resolve !== 'function') {
	        globalScope.Promise.resolve = function (value) {
	          return new globalScope.Promise(function (resolve) {
	            resolve(value);
	          });
	        };
	      }
	      if (typeof globalScope.Promise.reject !== 'function') {
	        globalScope.Promise.reject = function (reason) {
	          return new globalScope.Promise(function (resolve, reject) {
	            reject(reason);
	          });
	        };
	      }
	      if (typeof globalScope.Promise.prototype.catch !== 'function') {
	        globalScope.Promise.prototype.catch = function (onReject) {
	          return globalScope.Promise.prototype.then(undefined, onReject);
	        };
	      }
	      return;
	    }
	    var STATUS_PENDING = 0;
	    var STATUS_RESOLVED = 1;
	    var STATUS_REJECTED = 2;
	    var REJECTION_TIMEOUT = 500;
	    var HandlerManager = {
	      handlers: [],
	      running: false,
	      unhandledRejections: [],
	      pendingRejectionCheck: false,
	      scheduleHandlers: function scheduleHandlers(promise) {
	        if (promise._status === STATUS_PENDING) {
	          return;
	        }
	        this.handlers = this.handlers.concat(promise._handlers);
	        promise._handlers = [];
	        if (this.running) {
	          return;
	        }
	        this.running = true;
	        setTimeout(this.runHandlers.bind(this), 0);
	      },
	      runHandlers: function runHandlers() {
	        var RUN_TIMEOUT = 1;
	        var timeoutAt = Date.now() + RUN_TIMEOUT;
	        while (this.handlers.length > 0) {
	          var handler = this.handlers.shift();
	          var nextStatus = handler.thisPromise._status;
	          var nextValue = handler.thisPromise._value;
	          try {
	            if (nextStatus === STATUS_RESOLVED) {
	              if (typeof handler.onResolve === 'function') {
	                nextValue = handler.onResolve(nextValue);
	              }
	            } else if (typeof handler.onReject === 'function') {
	              nextValue = handler.onReject(nextValue);
	              nextStatus = STATUS_RESOLVED;
	              if (handler.thisPromise._unhandledRejection) {
	                this.removeUnhandeledRejection(handler.thisPromise);
	              }
	            }
	          } catch (ex) {
	            nextStatus = STATUS_REJECTED;
	            nextValue = ex;
	          }
	          handler.nextPromise._updateStatus(nextStatus, nextValue);
	          if (Date.now() >= timeoutAt) {
	            break;
	          }
	        }
	        if (this.handlers.length > 0) {
	          setTimeout(this.runHandlers.bind(this), 0);
	          return;
	        }
	        this.running = false;
	      },
	      addUnhandledRejection: function addUnhandledRejection(promise) {
	        this.unhandledRejections.push({
	          promise: promise,
	          time: Date.now()
	        });
	        this.scheduleRejectionCheck();
	      },
	      removeUnhandeledRejection: function removeUnhandeledRejection(promise) {
	        promise._unhandledRejection = false;
	        for (var i = 0; i < this.unhandledRejections.length; i++) {
	          if (this.unhandledRejections[i].promise === promise) {
	            this.unhandledRejections.splice(i);
	            i--;
	          }
	        }
	      },
	      scheduleRejectionCheck: function scheduleRejectionCheck() {
	        var _this = this;
	
	        if (this.pendingRejectionCheck) {
	          return;
	        }
	        this.pendingRejectionCheck = true;
	        setTimeout(function () {
	          _this.pendingRejectionCheck = false;
	          var now = Date.now();
	          for (var i = 0; i < _this.unhandledRejections.length; i++) {
	            if (now - _this.unhandledRejections[i].time > REJECTION_TIMEOUT) {
	              var unhandled = _this.unhandledRejections[i].promise._value;
	              var msg = 'Unhandled rejection: ' + unhandled;
	              if (unhandled.stack) {
	                msg += '\n' + unhandled.stack;
	              }
	              try {
	                throw new Error(msg);
	              } catch (_) {
	                console.warn(msg);
	              }
	              _this.unhandledRejections.splice(i);
	              i--;
	            }
	          }
	          if (_this.unhandledRejections.length) {
	            _this.scheduleRejectionCheck();
	          }
	        }, REJECTION_TIMEOUT);
	      }
	    };
	    var Promise = function Promise(resolver) {
	      this._status = STATUS_PENDING;
	      this._handlers = [];
	      try {
	        resolver.call(this, this._resolve.bind(this), this._reject.bind(this));
	      } catch (e) {
	        this._reject(e);
	      }
	    };
	    Promise.all = function Promise_all(promises) {
	      var resolveAll, rejectAll;
	      var deferred = new Promise(function (resolve, reject) {
	        resolveAll = resolve;
	        rejectAll = reject;
	      });
	      var unresolved = promises.length;
	      var results = [];
	      if (unresolved === 0) {
	        resolveAll(results);
	        return deferred;
	      }
	      function reject(reason) {
	        if (deferred._status === STATUS_REJECTED) {
	          return;
	        }
	        results = [];
	        rejectAll(reason);
	      }
	      for (var i = 0, ii = promises.length; i < ii; ++i) {
	        var promise = promises[i];
	        var resolve = function (i) {
	          return function (value) {
	            if (deferred._status === STATUS_REJECTED) {
	              return;
	            }
	            results[i] = value;
	            unresolved--;
	            if (unresolved === 0) {
	              resolveAll(results);
	            }
	          };
	        }(i);
	        if (Promise.isPromise(promise)) {
	          promise.then(resolve, reject);
	        } else {
	          resolve(promise);
	        }
	      }
	      return deferred;
	    };
	    Promise.isPromise = function Promise_isPromise(value) {
	      return value && typeof value.then === 'function';
	    };
	    Promise.resolve = function Promise_resolve(value) {
	      return new Promise(function (resolve) {
	        resolve(value);
	      });
	    };
	    Promise.reject = function Promise_reject(reason) {
	      return new Promise(function (resolve, reject) {
	        reject(reason);
	      });
	    };
	    Promise.prototype = {
	      _status: null,
	      _value: null,
	      _handlers: null,
	      _unhandledRejection: null,
	      _updateStatus: function Promise__updateStatus(status, value) {
	        if (this._status === STATUS_RESOLVED || this._status === STATUS_REJECTED) {
	          return;
	        }
	        if (status === STATUS_RESOLVED && Promise.isPromise(value)) {
	          value.then(this._updateStatus.bind(this, STATUS_RESOLVED), this._updateStatus.bind(this, STATUS_REJECTED));
	          return;
	        }
	        this._status = status;
	        this._value = value;
	        if (status === STATUS_REJECTED && this._handlers.length === 0) {
	          this._unhandledRejection = true;
	          HandlerManager.addUnhandledRejection(this);
	        }
	        HandlerManager.scheduleHandlers(this);
	      },
	      _resolve: function Promise_resolve(value) {
	        this._updateStatus(STATUS_RESOLVED, value);
	      },
	      _reject: function Promise_reject(reason) {
	        this._updateStatus(STATUS_REJECTED, reason);
	      },
	      then: function Promise_then(onResolve, onReject) {
	        var nextPromise = new Promise(function (resolve, reject) {
	          this.resolve = resolve;
	          this.reject = reject;
	        });
	        this._handlers.push({
	          thisPromise: this,
	          onResolve: onResolve,
	          onReject: onReject,
	          nextPromise: nextPromise
	        });
	        HandlerManager.scheduleHandlers(this);
	        return nextPromise;
	      },
	      catch: function Promise_catch(onReject) {
	        return this.then(undefined, onReject);
	      }
	    };
	    globalScope.Promise = Promise;
	  })();
	  (function checkWeakMap() {
	    if (globalScope.WeakMap) {
	      return;
	    }
	    var id = 0;
	    function WeakMap() {
	      this.id = '$weakmap' + id++;
	    }
	    WeakMap.prototype = {
	      has: function has(obj) {
	        return !!Object.getOwnPropertyDescriptor(obj, this.id);
	      },
	      get: function get(obj, defaultValue) {
	        return this.has(obj) ? obj[this.id] : defaultValue;
	      },
	      set: function set(obj, value) {
	        Object.defineProperty(obj, this.id, {
	          value: value,
	          enumerable: false,
	          configurable: true
	        });
	      },
	      delete: function _delete(obj) {
	        delete obj[this.id];
	      }
	    };
	    globalScope.WeakMap = WeakMap;
	  })();
	  (function checkURLConstructor() {
	    var hasWorkingUrl = false;
	    try {
	      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
	        var u = new URL('b', 'http://a');
	        u.pathname = 'c%20d';
	        hasWorkingUrl = u.href === 'http://a/c%20d';
	      }
	    } catch (e) {}
	    if (hasWorkingUrl) {
	      return;
	    }
	    var relative = Object.create(null);
	    relative['ftp'] = 21;
	    relative['file'] = 0;
	    relative['gopher'] = 70;
	    relative['http'] = 80;
	    relative['https'] = 443;
	    relative['ws'] = 80;
	    relative['wss'] = 443;
	    var relativePathDotMapping = Object.create(null);
	    relativePathDotMapping['%2e'] = '.';
	    relativePathDotMapping['.%2e'] = '..';
	    relativePathDotMapping['%2e.'] = '..';
	    relativePathDotMapping['%2e%2e'] = '..';
	    function isRelativeScheme(scheme) {
	      return relative[scheme] !== undefined;
	    }
	    function invalid() {
	      clear.call(this);
	      this._isInvalid = true;
	    }
	    function IDNAToASCII(h) {
	      if (h === '') {
	        invalid.call(this);
	      }
	      return h.toLowerCase();
	    }
	    function percentEscape(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    function percentEscapeQuery(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    var EOF,
	        ALPHA = /[a-zA-Z]/,
	        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
	    function parse(input, stateOverride, base) {
	      function err(message) {
	        errors.push(message);
	      }
	      var state = stateOverride || 'scheme start',
	          cursor = 0,
	          buffer = '',
	          seenAt = false,
	          seenBracket = false,
	          errors = [];
	      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
	        var c = input[cursor];
	        switch (state) {
	          case 'scheme start':
	            if (c && ALPHA.test(c)) {
	              buffer += c.toLowerCase();
	              state = 'scheme';
	            } else if (!stateOverride) {
	              buffer = '';
	              state = 'no scheme';
	              continue;
	            } else {
	              err('Invalid scheme.');
	              break loop;
	            }
	            break;
	          case 'scheme':
	            if (c && ALPHANUMERIC.test(c)) {
	              buffer += c.toLowerCase();
	            } else if (c === ':') {
	              this._scheme = buffer;
	              buffer = '';
	              if (stateOverride) {
	                break loop;
	              }
	              if (isRelativeScheme(this._scheme)) {
	                this._isRelative = true;
	              }
	              if (this._scheme === 'file') {
	                state = 'relative';
	              } else if (this._isRelative && base && base._scheme === this._scheme) {
	                state = 'relative or authority';
	              } else if (this._isRelative) {
	                state = 'authority first slash';
	              } else {
	                state = 'scheme data';
	              }
	            } else if (!stateOverride) {
	              buffer = '';
	              cursor = 0;
	              state = 'no scheme';
	              continue;
	            } else if (c === EOF) {
	              break loop;
	            } else {
	              err('Code point not allowed in scheme: ' + c);
	              break loop;
	            }
	            break;
	          case 'scheme data':
	            if (c === '?') {
	              this._query = '?';
	              state = 'query';
	            } else if (c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else {
	              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	                this._schemeData += percentEscape(c);
	              }
	            }
	            break;
	          case 'no scheme':
	            if (!base || !isRelativeScheme(base._scheme)) {
	              err('Missing scheme.');
	              invalid.call(this);
	            } else {
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative or authority':
	            if (c === '/' && input[cursor + 1] === '/') {
	              state = 'authority ignore slashes';
	            } else {
	              err('Expected /, got: ' + c);
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative':
	            this._isRelative = true;
	            if (this._scheme !== 'file') {
	              this._scheme = base._scheme;
	            }
	            if (c === EOF) {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._username = base._username;
	              this._password = base._password;
	              break loop;
	            } else if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              state = 'relative slash';
	            } else if (c === '?') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = '?';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'query';
	            } else if (c === '#') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._fragment = '#';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'fragment';
	            } else {
	              var nextC = input[cursor + 1];
	              var nextNextC = input[cursor + 2];
	              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	                this._path = base._path.slice();
	                this._path.pop();
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'relative slash':
	            if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              if (this._scheme === 'file') {
	                state = 'file host';
	              } else {
	                state = 'authority ignore slashes';
	              }
	            } else {
	              if (this._scheme !== 'file') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'authority first slash':
	            if (c === '/') {
	              state = 'authority second slash';
	            } else {
	              err('Expected \'/\', got: ' + c);
	              state = 'authority ignore slashes';
	              continue;
	            }
	            break;
	          case 'authority second slash':
	            state = 'authority ignore slashes';
	            if (c !== '/') {
	              err('Expected \'/\', got: ' + c);
	              continue;
	            }
	            break;
	          case 'authority ignore slashes':
	            if (c !== '/' && c !== '\\') {
	              state = 'authority';
	              continue;
	            } else {
	              err('Expected authority, got: ' + c);
	            }
	            break;
	          case 'authority':
	            if (c === '@') {
	              if (seenAt) {
	                err('@ already seen.');
	                buffer += '%40';
	              }
	              seenAt = true;
	              for (var i = 0; i < buffer.length; i++) {
	                var cp = buffer[i];
	                if (cp === '\t' || cp === '\n' || cp === '\r') {
	                  err('Invalid whitespace in authority.');
	                  continue;
	                }
	                if (cp === ':' && this._password === null) {
	                  this._password = '';
	                  continue;
	                }
	                var tempC = percentEscape(cp);
	                if (this._password !== null) {
	                  this._password += tempC;
	                } else {
	                  this._username += tempC;
	                }
	              }
	              buffer = '';
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              cursor -= buffer.length;
	              buffer = '';
	              state = 'host';
	              continue;
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'file host':
	            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
	                state = 'relative path';
	              } else if (buffer.length === 0) {
	                state = 'relative path start';
	              } else {
	                this._host = IDNAToASCII.call(this, buffer);
	                buffer = '';
	                state = 'relative path start';
	              }
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid whitespace in file host.');
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'host':
	          case 'hostname':
	            if (c === ':' && !seenBracket) {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'port';
	              if (stateOverride === 'hostname') {
	                break loop;
	              }
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'relative path start';
	              if (stateOverride) {
	                break loop;
	              }
	              continue;
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              if (c === '[') {
	                seenBracket = true;
	              } else if (c === ']') {
	                seenBracket = false;
	              }
	              buffer += c;
	            } else {
	              err('Invalid code point in host/hostname: ' + c);
	            }
	            break;
	          case 'port':
	            if (/[0-9]/.test(c)) {
	              buffer += c;
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
	              if (buffer !== '') {
	                var temp = parseInt(buffer, 10);
	                if (temp !== relative[this._scheme]) {
	                  this._port = temp + '';
	                }
	                buffer = '';
	              }
	              if (stateOverride) {
	                break loop;
	              }
	              state = 'relative path start';
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid code point in port: ' + c);
	            } else {
	              invalid.call(this);
	            }
	            break;
	          case 'relative path start':
	            if (c === '\\') {
	              err('\'\\\' not allowed in path.');
	            }
	            state = 'relative path';
	            if (c !== '/' && c !== '\\') {
	              continue;
	            }
	            break;
	          case 'relative path':
	            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
	              if (c === '\\') {
	                err('\\ not allowed in relative path.');
	              }
	              var tmp;
	              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
	                buffer = tmp;
	              }
	              if (buffer === '..') {
	                this._path.pop();
	                if (c !== '/' && c !== '\\') {
	                  this._path.push('');
	                }
	              } else if (buffer === '.' && c !== '/' && c !== '\\') {
	                this._path.push('');
	              } else if (buffer !== '.') {
	                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
	                  buffer = buffer[0] + ':';
	                }
	                this._path.push(buffer);
	              }
	              buffer = '';
	              if (c === '?') {
	                this._query = '?';
	                state = 'query';
	              } else if (c === '#') {
	                this._fragment = '#';
	                state = 'fragment';
	              }
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              buffer += percentEscape(c);
	            }
	            break;
	          case 'query':
	            if (!stateOverride && c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._query += percentEscapeQuery(c);
	            }
	            break;
	          case 'fragment':
	            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._fragment += c;
	            }
	            break;
	        }
	        cursor++;
	      }
	    }
	    function clear() {
	      this._scheme = '';
	      this._schemeData = '';
	      this._username = '';
	      this._password = null;
	      this._host = '';
	      this._port = '';
	      this._path = [];
	      this._query = '';
	      this._fragment = '';
	      this._isInvalid = false;
	      this._isRelative = false;
	    }
	    function JURL(url, base) {
	      if (base !== undefined && !(base instanceof JURL)) {
	        base = new JURL(String(base));
	      }
	      this._url = url;
	      clear.call(this);
	      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
	      parse.call(this, input, null, base);
	    }
	    JURL.prototype = {
	      toString: function toString() {
	        return this.href;
	      },
	
	      get href() {
	        if (this._isInvalid) {
	          return this._url;
	        }
	        var authority = '';
	        if (this._username !== '' || this._password !== null) {
	          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
	        }
	        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
	      },
	      set href(href) {
	        clear.call(this);
	        parse.call(this, href);
	      },
	      get protocol() {
	        return this._scheme + ':';
	      },
	      set protocol(protocol) {
	        if (this._isInvalid) {
	          return;
	        }
	        parse.call(this, protocol + ':', 'scheme start');
	      },
	      get host() {
	        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
	      },
	      set host(host) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, host, 'host');
	      },
	      get hostname() {
	        return this._host;
	      },
	      set hostname(hostname) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, hostname, 'hostname');
	      },
	      get port() {
	        return this._port;
	      },
	      set port(port) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, port, 'port');
	      },
	      get pathname() {
	        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
	      },
	      set pathname(pathname) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._path = [];
	        parse.call(this, pathname, 'relative path start');
	      },
	      get search() {
	        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
	      },
	      set search(search) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._query = '?';
	        if (search[0] === '?') {
	          search = search.slice(1);
	        }
	        parse.call(this, search, 'query');
	      },
	      get hash() {
	        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
	      },
	      set hash(hash) {
	        if (this._isInvalid) {
	          return;
	        }
	        this._fragment = '#';
	        if (hash[0] === '#') {
	          hash = hash.slice(1);
	        }
	        parse.call(this, hash, 'fragment');
	      },
	      get origin() {
	        var host;
	        if (this._isInvalid || !this._scheme) {
	          return '';
	        }
	        switch (this._scheme) {
	          case 'data':
	          case 'file':
	          case 'javascript':
	          case 'mailto':
	            return 'null';
	        }
	        host = this.host;
	        if (!host) {
	          return '';
	        }
	        return this._scheme + '://' + host;
	      }
	    };
	    var OriginalURL = globalScope.URL;
	    if (OriginalURL) {
	      JURL.createObjectURL = function (blob) {
	        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
	      };
	      JURL.revokeObjectURL = function (url) {
	        OriginalURL.revokeObjectURL(url);
	      };
	    }
	    globalScope.URL = JURL;
	  })();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __w_pdfjs_require__(9)))
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=pdf.worker.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(173);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 147 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(32);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(40);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactInstrumentation = __webpack_require__(20);
	
	var quoteAttributeValueForBrowser = __webpack_require__(389);
	var warning = __webpack_require__(3);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 150 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var LinkedValueUtils = __webpack_require__(99);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactUpdates = __webpack_require__(22);
	
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 152 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 153 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(349);
	
	var containsNode = __webpack_require__(242);
	var focusNode = __webpack_require__(134);
	var getActiveElement = __webpack_require__(135);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(39);
	var DOMProperty = __webpack_require__(40);
	var React = __webpack_require__(33);
	var ReactBrowserEventEmitter = __webpack_require__(66);
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactDOMContainerInfo = __webpack_require__(343);
	var ReactDOMFeatureFlags = __webpack_require__(345);
	var ReactFeatureFlags = __webpack_require__(153);
	var ReactInstanceMap = __webpack_require__(57);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactMarkupChecksum = __webpack_require__(359);
	var ReactReconciler = __webpack_require__(43);
	var ReactUpdateQueue = __webpack_require__(102);
	var ReactUpdates = __webpack_require__(22);
	
	var emptyObject = __webpack_require__(53);
	var instantiateReactComponent = __webpack_require__(162);
	var invariant = __webpack_require__(2);
	var setInnerHTML = __webpack_require__(70);
	var shouldUpdateReactComponent = __webpack_require__(109);
	var warning = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var React = __webpack_require__(33);
	
	var invariant = __webpack_require__(2);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 159 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(157);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(16);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var ReactCompositeComponent = __webpack_require__(340);
	var ReactEmptyComponent = __webpack_require__(152);
	var ReactHostComponent = __webpack_require__(154);
	
	var getNextDebugID = __webpack_require__(421);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(16);
	var escapeTextContentForBrowser = __webpack_require__(69);
	var setInnerHTML = __webpack_require__(70);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(24);
	var REACT_ELEMENT_TYPE = __webpack_require__(355);
	
	var getIteratorFn = __webpack_require__(386);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(98);
	var warning = __webpack_require__(3);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 166 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.parseStartTime = parseStartTime;
	var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
	var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
	var MATCH_NUMERIC = /^\d+$/;
	
	// Parse YouTube URL for a start time param, ie ?t=1h14m30s
	// and return the start time in seconds
	function parseStartTime(url) {
	  var match = url.match(MATCH_START_QUERY);
	  if (match) {
	    var stamp = match[1];
	    if (stamp.match(MATCH_START_STAMP)) {
	      return parseStartStamp(stamp);
	    }
	    if (MATCH_NUMERIC.test(stamp)) {
	      return parseInt(stamp, 10);
	    }
	  }
	  return 0;
	}
	
	function parseStartStamp(stamp) {
	  var seconds = 0;
	  var array = MATCH_START_STAMP.exec(stamp);
	  while (array !== null) {
	    var _array = array,
	        _array2 = _slicedToArray(_array, 3),
	        count = _array2[1],
	        period = _array2[2];
	
	    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
	    if (period === 'm') seconds += parseInt(count, 10) * 60;
	    if (period === 's') seconds += parseInt(count, 10);
	    array = MATCH_START_STAMP.exec(stamp);
	  }
	  return seconds;
	}

/***/ },
/* 167 */
98,
/* 168 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactCurrentOwner = __webpack_require__(24);
	var REACT_ELEMENT_TYPE = __webpack_require__(168);
	
	var getIteratorFn = __webpack_require__(420);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(167);
	var warning = __webpack_require__(3);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _wrapDisplayName = __webpack_require__(430);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHelper = function createHelper(func, helperName) {
	  var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (false) {
	    if (noArgs) {
	      return function (BaseComponent) {
	        var Component = func(BaseComponent);
	        Component.displayName = (0, _wrapDisplayName2.default)(BaseComponent, helperName);
	        return Component;
	      };
	    }
	
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return function (BaseComponent) {
	        var Component = func.apply(undefined, args)(BaseComponent);
	        Component.displayName = (0, _wrapDisplayName2.default)(BaseComponent, helperName);
	        return Component;
	      };
	    };
	  }
	
	  return func;
	};
	
	exports.default = createHelper;

/***/ },
/* 172 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 173 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _logo = __webpack_require__(432);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _Paper = __webpack_require__(140);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	__webpack_require__(234);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Header() {
	  return _react2.default.createElement(
	    _Paper2.default,
	    { className: 'Header' },
	    _react2.default.createElement('img', { src: _logo2.default, alt: 'Idaho High School Activities Association' })
	  );
	}
	
	exports.default = Header;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(319);
	
	__webpack_require__(318);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	window.PDFJS.workerSrc = __webpack_require__(145);
	window.PDFJS.disableWorker = true;
	
	var ReactPDF = function (_Component) {
	  _inherits(ReactPDF, _Component);
	
	  function ReactPDF() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactPDF);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPDF.__proto__ || Object.getPrototypeOf(ReactPDF)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReactPDF, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleFileLoad();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.isParameterObject(nextProps.file)) {
	        // File is a parameter object
	        if (nextProps.file && !this.props.file || nextProps.file.data !== this.props.file.data || nextProps.file.range !== this.props.file.range || nextProps.file.url !== this.props.file.url) {
	          this.handleFileLoad(nextProps);
	          return;
	        }
	      } else if (nextProps.file && nextProps.file !== this.props.file) {
	        // File is a normal object or not an object at all
	        this.handleFileLoad(nextProps);
	        return;
	      }
	
	      if (this.state.pdf && typeof nextProps.pageIndex !== 'undefined' && nextProps.pageIndex !== this.props.pageIndex) {
	        this.loadPage(nextProps.pageIndex);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return nextState.pdf !== this.state.pdf || nextState.page !== this.state.page || nextProps.width !== this.props.width || nextProps.scale !== this.props.scale;
	    }
	
	    /**
	     * Called when a document is loaded successfully.
	     */
	
	
	    /**
	     * Called when a document fails to load.
	     */
	
	
	    /**
	     * Called when a page is loaded successfully.
	     */
	
	
	    /**
	     * Called when a page is rendered successfully.
	     */
	
	
	    /**
	     * Called when a page fails to load or render.
	     */
	
	  }, {
	    key: 'getPageScale',
	    value: function getPageScale() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.page;
	      var _props = this.props,
	          scale = _props.scale,
	          width = _props.width;
	
	      // Be default, we'll render page at 100% * scale width.
	
	      var pageScale = 1;
	
	      // If width is defined, calculate the scale of the page so it could be of desired width.
	      if (width) {
	        pageScale = width / page.getViewport(scale).width;
	      }
	
	      return scale * pageScale;
	    }
	  }, {
	    key: 'handleFileLoad',
	    value: function handleFileLoad() {
	      var _this2 = this;
	
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var file = props.file;
	
	
	      if (!file || this.isParameterObject(file) && !file.data && !file.range && !file.url) {
	        return null;
	      }
	
	      this.setState({
	        page: null,
	        pdf: null
	      });
	
	      // File is a string
	      if (typeof file === 'string') {
	        // File is not data URI
	        if (!this.isDataURI(file)) {
	          if (window.location.protocol === 'file:') {
	            this.displayCORSWarning();
	          }
	
	          return this.loadDocument(file);
	        }
	
	        // File is data URI
	        file = this.dataURItoBlob(file);
	
	        // Fall through to "File is a blob"
	      }
	
	      // File is a Blob
	      if (file instanceof Blob) {
	        file = URL.createObjectURL(file);
	
	        return this.loadDocument(file);
	      }
	
	      // File is a File
	      if (file instanceof File) {
	        var reader = new FileReader();
	
	        reader.onloadend = function () {
	          _this2.loadDocument(new Uint8Array(reader.result));
	        };
	
	        return reader.readAsArrayBuffer(file);
	      }
	
	      // File is an ArrayBuffer
	      if (file instanceof ArrayBuffer) {
	        return this.loadDocument(file);
	      }
	
	      // File is a parameter object
	      if (this.isParameterObject(file)) {
	        if (file.url && window.location.protocol === 'file:') {
	          this.displayCORSWarning();
	        }
	
	        // Prevent from modifying props
	        file = Object.assign({}, file);
	
	        // File is data URI
	        if (file.url && this.isDataURI(file.url)) {
	          file = URL.createObjectURL(this.dataURItoBlob(file.url));
	        }
	
	        return this.loadDocument(file);
	      }
	
	      throw new Error('Unrecognized input type.');
	    }
	  }, {
	    key: 'loadDocument',
	    value: function loadDocument() {
	      var _window$PDFJS;
	
	      (_window$PDFJS = window.PDFJS).getDocument.apply(_window$PDFJS, arguments).then(this.onDocumentLoad).catch(this.onDocumentError);
	    }
	  }, {
	    key: 'loadPage',
	    value: function loadPage(pageIndex) {
	      var pdf = this.state.pdf;
	
	
	      if (!pdf) {
	        throw new Error('Unexpected call to getPage() before the document has been loaded.');
	      }
	
	      var pageNumber = pageIndex + 1;
	
	      if (!pageIndex || pageNumber < 1) {
	        pageNumber = 1;
	      } else if (pageNumber >= pdf.numPages) {
	        pageNumber = pdf.numPages;
	      }
	
	      pdf.getPage(pageNumber).then(this.onPageLoad).catch(this.onPageError);
	    }
	  }, {
	    key: 'renderNoData',
	    value: function renderNoData() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.noData
	      );
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.error
	      );
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.loading
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var file = this.props.file;
	      var _state = this.state,
	          pdf = _state.pdf,
	          page = _state.page;
	
	
	      if (!file) {
	        return this.renderNoData();
	      }
	
	      if (pdf === false || page === false) {
	        return this.renderError();
	      }
	
	      if (pdf === null || page === null) {
	        return this.renderLoader();
	      }
	
	      return _react2.default.createElement('canvas', {
	        ref: function ref(_ref2) {
	          if (!_ref2) {
	            return;
	          }
	
	          _this3.canvas = _ref2;
	
	          var pixelRatio = window.devicePixelRatio || 1;
	          var viewport = page.getViewport(_this3.getPageScale() * pixelRatio);
	
	          _this3.canvas.height = viewport.height;
	          _this3.canvas.width = viewport.width;
	
	          _this3.canvas.style.height = viewport.height / pixelRatio + 'px';
	          _this3.canvas.style.width = viewport.width / pixelRatio + 'px';
	
	          var canvasContext = _this3.canvas.getContext('2d');
	
	          var renderContext = {
	            canvasContext: canvasContext,
	            viewport: viewport
	          };
	
	          // If another render is in progress, let's cancel it
	          /* eslint-disable no-underscore-dangle */
	          if (_this3.renderer && _this3.renderer._internalRenderTask.running) {
	            _this3.renderer._internalRenderTask.cancel();
	          }
	          /* eslint-enable no-underscore-dangle */
	
	          _this3.renderer = page.render(renderContext);
	
	          _this3.renderer.then(_this3.onPageRender).catch(function (dismiss) {
	            if (dismiss === 'cancelled') {
	              // Everything's alright
	              return;
	            }
	
	            _this3.onPageError(dismiss);
	          });
	        }
	      });
	    }
	  }]);
	
	  return ReactPDF;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.state = {
	    pdf: null,
	    page: null
	  };
	
	  this.onDocumentLoad = function (pdf) {
	    _this4.callIfDefined(_this4.props.onDocumentLoad, {
	      total: pdf.numPages
	    });
	
	    _this4.setState({ pdf: pdf });
	
	    _this4.loadPage(_this4.props.pageIndex);
	  };
	
	  this.onDocumentError = function (error) {
	    _this4.callIfDefined(_this4.props.onDocumentError, error);
	
	    _this4.setState({ pdf: false });
	  };
	
	  this.onPageLoad = function (page) {
	    var scale = _this4.getPageScale(page);
	
	    _this4.callIfDefined(_this4.props.onPageLoad, {
	      pageIndex: page.pageIndex,
	      pageNumber: page.pageNumber,
	      get width() {
	        return page.view[2] * scale;
	      },
	      get height() {
	        return page.view[3] * scale;
	      },
	      scale: scale,
	      get originalWidth() {
	        return page.view[2];
	      },
	      get originalHeight() {
	        return page.view[3];
	      }
	    });
	
	    _this4.setState({ page: page });
	  };
	
	  this.onPageRender = function () {
	    _this4.callIfDefined(_this4.props.onPageRender, _this4.canvas);
	  };
	
	  this.onPageError = function (error) {
	    _this4.callIfDefined(_this4.props.onPageError, error);
	
	    _this4.setState({ page: false });
	  };
	
	  this.callIfDefined = function (fn, args) {
	    if (fn && typeof fn === 'function') {
	      fn(args);
	    }
	  };
	
	  this.displayCORSWarning = function () {
	    // eslint-disable-next-line no-console
	    console.warn('Loading PDF as base64 strings/URLs might not work on protocols other than HTTP/HTTPS. On Google Chrome, you can use --allow-file-access-from-files flag for debugging purposes.');
	  };
	
	  this.isParameterObject = function (object) {
	    return object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && ['file', 'range', 'url'].some(function (key) {
	      return Object.keys(object).includes(key);
	    });
	  };
	
	  this.isDataURI = function (str) {
	    return (/^data:/.test(str)
	    );
	  };
	
	  this.dataURItoBlob = function (dataURI) {
	    var byteString = void 0;
	    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
	      byteString = atob(dataURI.split(',')[1]);
	    } else {
	      byteString = unescape(dataURI.split(',')[1]);
	    }
	
	    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
	
	    var ia = new Uint8Array(byteString.length);
	    for (var i = 0; i < byteString.length; i += 1) {
	      ia[i] = byteString.charCodeAt(i);
	    }
	
	    return new Blob([ia], { type: mimeString });
	  };
	};
	
	exports.default = ReactPDF;
	
	
	ReactPDF.defaultProps = {
	  pageIndex: 0,
	  scale: 1.0,
	  error: 'Failed to load PDF file.',
	  loading: 'Loading PDF…',
	  noData: 'No PDF file specified.'
	};
	
	ReactPDF.propTypes = {
	  error: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
	  file: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.instanceOf(File), _react.PropTypes.instanceOf(Blob), _react.PropTypes.shape({
	    data: _react.PropTypes.object,
	    httpHeaders: _react.PropTypes.object,
	    range: _react.PropTypes.object,
	    url: _react.PropTypes.string
	  })]),
	  loading: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
	  noData: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
	  onDocumentError: _react.PropTypes.func,
	  onDocumentLoad: _react.PropTypes.func,
	  onPageError: _react.PropTypes.func,
	  onPageLoad: _react.PropTypes.func,
	  onPageRender: _react.PropTypes.func,
	  pageIndex: _react.PropTypes.number,
	  scale: _react.PropTypes.number,
	  width: _react.PropTypes.number
	};

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(255);
	
	exports.default = (0, _immutable.fromJS)([{
	  question: 'A concussion is a:',
	  answer: 'a',
	  answers: {
	    a: 'Type of traumatic brain injury or TBI caused by a bump, blow or jolt to the head or by a hit to the body that causes the head and brain to move rapidly back and forth',
	    b: 'A brain bruise',
	    c: 'Loud sound heard from far away'
	  }
	}, {
	  question: 'When can concussions occur?',
	  answer: 'c',
	  answers: {
	    a: 'Only while playing contact sports',
	    b: 'Only when the individual who was hit or jolted loses consciousness',
	    c: 'In any organized or unorganized recreational sport or activity and most occur without a loss of consciousness'
	  }
	}, {
	  question: 'How do you identify a concussion?',
	  answer: 'b',
	  answers: {
	    a: 'By looking at CT or MRI scans of the individual’s brain',
	    b: 'By watching for different types of signs and symptoms, such as a change in the athlete’s behavior, thinking, or physical functioning',
	    c: 'Asking an athlete if they had their “bell rung” in the last hit'
	  }
	}, {
	  question: 'Which of the following are signs of a concussion that you as a coach may identify?',
	  answer: 'a',
	  answers: {
	    a: 'The athlete appears stunned, is unsure of the game, score, or opponent, is confused about their assignment of position, and is answering questions slowly',
	    b: 'The athlete follows the rules for safety and the rules of the sport, practices good sportsmanship, and uses the proper equipment for the sport',
	    c: 'The athlete looks pale, their tongue is white, and after gently pinching the skin, it does not immediately snap back into place'
	  }
	}, {
	  question: 'Which of the following are symptoms of a concussion that an athlete may describe?',
	  answer: 'c',
	  answers: {
	    a: 'The athlete complains of shoulder pain that radiates down the arm to a tingling feeling in the fingers',
	    b: 'The athlete feels weak, tired and has stopped sweating',
	    c: 'The athlete states the lights hurt their eyes, they feel confused, or complains of a headache'
	  }
	}, {
	  question: 'If a player returns to activity before fully healing from the concussion they:',
	  answer: 'a',
	  answers: {
	    a: 'Are more likely to sustain another concussion',
	    b: 'Will never have another concussion',
	    c: 'Will not sustain another concussion from a similar blow or jolt'
	  }
	}, {
	  question: 'What is the first thing you should do as a coach when one of your players has sustained a bump or blow to the head or body and isn’t acting right?',
	  answer: 'c',
	  answers: {
	    a: 'Immediately rush the athlete to the hospital – even if none of the Red Flags are present',
	    b: 'Allow the athlete to finish out the quarter/period/half, etc. and then take the athlete for a medical examination',
	    c: 'Remove the athlete from play and look for signs or symptoms of a concussion – even those that may appear hours later'
	  }
	}, {
	  question: 'Which of the following would indicate a medical emergency and require rushing an athlete to the emergency department immediately?',
	  answer: 'b',
	  answers: {
	    a: 'The athlete seems slightly off balance, complains of a headache, did not lose consciousness, but just “isn’t feeling right.”',
	    b: 'The athlete lost consciousness, is persistently vomiting, or seems to become increasingly more confused or restless',
	    c: 'The athlete complains of a headache and appears slightly dazed or stunned'
	  }
	}, {
	  question: 'The athlete shall be removed from play and the athlete’s parents should be alerted about a possible concussion immediately following the game or practice before allowing the child to go home. What other elements make up the “Heads Up” 4-step action plan?',
	  answer: 'c',
	  answers: {
	    a: 'Ensure that the participant is evaluated by a healthcare professional',
	    b: 'Keep the participant out of play the day of the injury and until an appropriate healthcare professional says the player is symptom free and is okay to return to play',
	    c: 'Both A & B'
	  }
	}, {
	  question: 'When can an athlete return to play after a concussion?',
	  answer: 'c',
	  answers: {
	    a: 'As soon as they are feeling better',
	    b: 'After being evaluated by a health care professional',
	    c: 'After being cleared by a health care professional and after following a stepwise process in which the athlete’s activity level is slowly increased over a period of days, weeks, or months depending on the athlete’s response to increasingly challenging activities'
	  }
	}, {
	  question: 'How can you help prevent concussions?',
	  answer: 'c',
	  answers: {
	    a: 'By ensuring that all athletes wear properly fitted protective equipment, practice good sportsmanship at all times and follow the rules of play',
	    b: 'By working with parents, athletes, and school and club administrators to spread awareness about concussion all year: pre-season, during the season and post-season',
	    c: 'Both A & B'
	  }
	}, {
	  question: 'Why is a return-to-learn plan critical for youth athletes who have sustained a concussion?',
	  answer: 'a',
	  answers: {
	    a: 'Cognitive activities that require concentration, memory, and attention to detail, such as school work and reading, may worsen symptoms and delay recovery if not introduced in an appropriate, individualized process',
	    b: 'Student athletes must maintain a 3.5 GPA before being allowed to return to school-sanctioned sports after injury',
	    c: 'A return-to-learn plan is not necessary as long as the athlete has completed the return-to-play process and has resumed full competition'
	  }
	}, {
	  question: 'At the beginning of each sanctioned sport season, the youth athlete and the athlete’s parent or guardian shall receive information describing the risks, signs and symptoms of concussion. What other tenets comprise Idaho concussion legislation?',
	  answer: 'c',
	  answers: {
	    a: 'A coach or athletic trainer may return an athlete to play the same day they are suspected of sustaining a concussion after obtaining written consent from the athlete’s parent or guardian',
	    b: 'If an athlete is 18 years of age, they are no longer considered a youth athlete and are exempt from the concussion and head injury requirements under Idaho’s concussion law',
	    c: 'Any athlete playing a school sanctioned sport, who is reasonably suspected of sustaining a concussion, must be immediately removed from play AND in order to return to play, the athlete must obtain medical clearance by a qualified healthcare professional trained in the management of concussion'
	  }
	}, {
	  question: 'Why are concussions managed more conservatively in youth than in adults?',
	  answer: 'b',
	  answers: {
	    a: 'Adults brains are not susceptible to concussion',
	    b: 'While the brain is still recovering from a concussion, it is particularly vulnerable to further injury; a second concussion during this time in a developing brain can result in catastrophic injury',
	    c: 'Concussions often cause permanent learning disabilities in youth athletes'
	  }
	}, {
	  question: 'What Idaho resources are available for creating a concussion management protocol for your school or sports league?',
	  answer: 'd',
	  answers: {
	    a: 'Idaho High School Activities Association: idhsaa.org',
	    b: 'St. Luke’s Sports Medicine Concussion Clinic: www.stlukesonline/concussion.org',
	    c: 'Know Concussion.org: www.knowconcussion.org',
	    d: 'All of the above'
	  }
	}]);

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Stepper = __webpack_require__(288);
	
	var _MuiThemeProvider = __webpack_require__(303);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _getMuiTheme = __webpack_require__(143);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _colors = __webpack_require__(63);
	
	var _Header = __webpack_require__(174);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _PersonalDetails = __webpack_require__(179);
	
	var _PersonalDetails2 = _interopRequireDefault(_PersonalDetails);
	
	var _Certificate = __webpack_require__(178);
	
	var _Certificate2 = _interopRequireDefault(_Certificate);
	
	var _Quiz = __webpack_require__(180);
	
	var _Quiz2 = _interopRequireDefault(_Quiz);
	
	var _Video = __webpack_require__(181);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	__webpack_require__(235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stepperStyle = {
	  display: 'flex',
	  flexDirection: 'row'
	};
	
	var stepLabelStyle = {
	  flexGrow: 1
	};
	
	var theme = (0, _getMuiTheme2.default)({
	  palette: {
	    primary1Color: _colors.lightBlue400,
	    primary2Color: _colors.lightBlueA700,
	    primary3Color: _colors.redA200
	  }
	});
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, App);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      details: {
	        name: 'Test User'
	      },
	      stepIndex: 0,
	      finished: false
	    }, _this.handleNext = function () {
	      var stepIndex = _this.state.stepIndex;
	
	      _this.setState({
	        stepIndex: stepIndex + 1,
	        finished: stepIndex >= 2
	      });
	    }, _this.handlePrev = function () {
	      var stepIndex = _this.state.stepIndex;
	
	      if (stepIndex > 0) {
	        _this.setState({ stepIndex: stepIndex - 1 });
	      }
	    }, _this.handleFinishDetails = function (details) {
	      _this.setState({ details: details });
	      _this.handleNext();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(App, [{
	    key: 'renderCurrentStep',
	    value: function renderCurrentStep() {
	      switch (this.state.stepIndex) {
	        case 0:
	          return _react2.default.createElement(_PersonalDetails2.default, { onFinishDetails: this.handleFinishDetails });
	
	        case 1:
	          return _react2.default.createElement(_Quiz2.default, { preTest: true, onFinishQuiz: this.handleNext });
	
	        case 2:
	          return _react2.default.createElement(_Video2.default, { onFinishVideo: this.handleNext });
	
	        case 3:
	          return _react2.default.createElement(_Quiz2.default, { onFinishQuiz: this.handleNext });
	
	        case 4:
	          return _react2.default.createElement(_Certificate2.default, { details: this.state.details });
	
	        default:
	          return null;
	
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        { muiTheme: theme },
	        _react2.default.createElement(
	          'div',
	          { className: 'App' },
	          _react2.default.createElement(
	            'div',
	            { className: 'App-content' },
	            _react2.default.createElement(
	              _Stepper.Stepper,
	              { activeStep: this.state.stepIndex, style: stepperStyle },
	              _react2.default.createElement(
	                _Stepper.Step,
	                null,
	                _react2.default.createElement(
	                  _Stepper.StepLabel,
	                  { style: stepLabelStyle },
	                  'Begin'
	                )
	              ),
	              _react2.default.createElement(
	                _Stepper.Step,
	                null,
	                _react2.default.createElement(
	                  _Stepper.StepLabel,
	                  { style: stepLabelStyle },
	                  'Pre-Test: 15 Questions'
	                )
	              ),
	              _react2.default.createElement(
	                _Stepper.Step,
	                null,
	                _react2.default.createElement(
	                  _Stepper.StepLabel,
	                  { style: stepLabelStyle },
	                  'Training Video: 20 Minutes'
	                )
	              ),
	              _react2.default.createElement(
	                _Stepper.Step,
	                null,
	                _react2.default.createElement(
	                  _Stepper.StepLabel,
	                  { style: stepLabelStyle },
	                  'Post-Test: 15 Questions'
	                )
	              ),
	              _react2.default.createElement(
	                _Stepper.Step,
	                null,
	                _react2.default.createElement(
	                  _Stepper.StepLabel,
	                  { style: stepLabelStyle },
	                  'Certificate of Completion'
	                )
	              )
	            ),
	            this.renderCurrentStep()
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jspdf = __webpack_require__(275);
	
	var _jspdf2 = _interopRequireDefault(_jspdf);
	
	__webpack_require__(435);
	
	var _ContinueFooter = __webpack_require__(58);
	
	var _ContinueFooter2 = _interopRequireDefault(_ContinueFooter);
	
	var _ReactPDF = __webpack_require__(175);
	
	var _ReactPDF2 = _interopRequireDefault(_ReactPDF);
	
	var _RaisedButton = __webpack_require__(141);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _certificate = __webpack_require__(431);
	
	var _certificate2 = _interopRequireDefault(_certificate);
	
	__webpack_require__(236);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TOOD: https://wiki.base22.com/display/btg/Send+data+to+Google+docs+using+a+web+form+and+AJAX
	var GOOGLE_URL = 'https://script.google.com/macros/s/AKfycbzf9HRCg1m0XevrAsv7WiLHkllomHmJdD48IHmuefiM50sW0dQ/exec';
	
	var Certificate = function (_Component) {
	  _inherits(Certificate, _Component);
	
	  function Certificate() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Certificate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Certificate.__proto__ || Object.getPrototypeOf(Certificate)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnPageRender = function () {
	      var ctx = _this.pdf.canvas.getContext('2d');
	
	      ctx.font = '40px Arial';
	      ctx.textAlign = 'center';
	      ctx.fillText(_this.props.details.name, _this.pdf.canvas.width / 2, _this.pdf.canvas.height / 2);
	
	      ctx.font = '16px Arial';
	      ctx.textAlign = 'center';
	      ctx.fillText(new Date().toDateString(), _this.pdf.canvas.width * 0.26, _this.pdf.canvas.height * 0.76);
	    }, _this.handlePrintPress = function () {
	      window.print();
	    }, _this.handleDownloadPress = function () {
	      var pdf = new _jspdf2.default({
	        format: 'a4',
	        unit: 'px',
	        compress: true,
	        autoSize: true,
	        orientation: 'landscape'
	      });
	
	      pdf.addImage(_this.pdf.canvas, 'Canvas', 0, -10, 640, 460);
	      pdf.save('IHSAA Concussion Certificate - ' + _this.props.details.name + '.pdf');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Certificate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      try {
	        var formData = new FormData();
	
	        formData.append('Name', this.props.details.name);
	        formData.append('Email', this.props.details.email);
	        formData.append('Phone Number', this.props.details.phoneNumber);
	
	        fetch(GOOGLE_URL, { method: 'post', body: formData });
	      } catch (e) {
	        //
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Certificate printable' },
	        _react2.default.createElement(_ReactPDF2.default, {
	          className: 'printable',
	          file: _certificate2.default,
	          onPageRender: this.handleOnPageRender,
	          ref: function ref(pdf) {
	            _this2.pdf = pdf;
	          }
	        }),
	        _react2.default.createElement(
	          _ContinueFooter2.default,
	          {
	            continueLabel: 'Download Certificate',
	            onContinue: this.handleDownloadPress
	          },
	          _react2.default.createElement(_RaisedButton2.default, {
	            primary: true,
	            label: 'Print Certificate',
	            onTouchTap: this.handlePrintPress
	          })
	        )
	      );
	    }
	  }]);
	
	  return Certificate;
	}(_react.Component);
	
	Certificate.propTypes = {
	  details: _propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    email: _propTypes2.default.string.isRequired,
	    phoneNumber: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	exports.default = Certificate;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextField = __webpack_require__(295);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _ContinueFooter = __webpack_require__(58);
	
	var _ContinueFooter2 = _interopRequireDefault(_ContinueFooter);
	
	__webpack_require__(237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PersonalDetails = function (_Component) {
	  _inherits(PersonalDetails, _Component);
	
	  function PersonalDetails() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PersonalDetails);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PersonalDetails.__proto__ || Object.getPrototypeOf(PersonalDetails)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      name: '',
	      email: '',
	      phoneNumber: ''
	    }, _this.handleFinish = function () {
	      return _this.props.onFinishDetails(_this.state);
	    }, _this.handleChange = function (field) {
	      return function (event) {
	        return _this.setState(_defineProperty({}, field, event.target.value));
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PersonalDetails, [{
	    key: 'isValid',
	    value: function isValid() {
	      return this.state.name.length > 3 && this.state.email.length > 10 && this.state.phoneNumber.length > 7;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'PersonalDetails' },
	        _react2.default.createElement(_TextField2.default, {
	          value: this.state.name,
	          onChange: this.handleChange('name'),
	          floatingLabelText: 'Full Name'
	        }),
	        _react2.default.createElement(_TextField2.default, {
	          value: this.state.phoneNumber,
	          onChange: this.handleChange('phoneNumber'),
	          floatingLabelText: 'Phone Number'
	        }),
	        _react2.default.createElement(_TextField2.default, {
	          value: this.state.email,
	          onChange: this.handleChange('email'),
	          floatingLabelText: 'E-Mail Address'
	        }),
	        _react2.default.createElement(_ContinueFooter2.default, {
	          continueLabel: 'Begin Certification',
	          disableContinue: !this.isValid(),
	          onContinue: this.handleFinish
	        })
	      );
	    }
	  }]);
	
	  return PersonalDetails;
	}(_react.Component);
	
	PersonalDetails.propTypes = {
	  onFinishDetails: _propTypes2.default.func.isRequired
	};
	exports.default = PersonalDetails;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(238);
	
	var _ContinueFooter = __webpack_require__(58);
	
	var _ContinueFooter2 = _interopRequireDefault(_ContinueFooter);
	
	var _FlatButton = __webpack_require__(139);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _close = __webpack_require__(309);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _check = __webpack_require__(308);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _checkCircle = __webpack_require__(144);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _questions = __webpack_require__(176);
	
	var _questions2 = _interopRequireDefault(_questions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var answerStyle = {
	  textAlign: 'left',
	  paddingTop: 8,
	  paddingBottom: 8,
	  height: 'auto',
	  display: 'flex',
	  flexDirection: 'row',
	  alignItems: 'center'
	};
	
	var answerLabelStyle = {
	  fontSize: 20,
	  lineHeight: 1.5,
	  display: 'block',
	  textTransform: 'none'
	};
	
	var Quiz = function (_Component) {
	  _inherits(Quiz, _Component);
	
	  function Quiz() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Quiz);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Quiz.__proto__ || Object.getPrototypeOf(Quiz)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      done: false,
	      answers: [],
	      currentQuestionIndex: 0
	    }, _this.setAnswer = function (key) {
	      return function (e) {
	        var answers = _this.state.answers;
	        answers[_this.state.currentQuestionIndex] = {
	          answer: key,
	          submitted: false
	        };
	
	        _this.setState({
	          answers: answers
	        });
	      };
	    }, _this.handleRetakePress = function () {
	      _this.setState({
	        done: false,
	        answers: [],
	        currentQuestionIndex: 0
	      });
	    }, _this.handleContinuePress = function () {
	      var currentQuestionIndex = _this.state.currentQuestionIndex;
	      var currentAnswer = _this.state.answers[currentQuestionIndex];
	
	      if (currentAnswer && !currentAnswer.submitted) {
	        var answers = _this.state.answers;
	        answers[_this.state.currentQuestionIndex] = Object.assign({}, currentAnswer, {
	          submitted: true
	        });
	
	        _this.setState({
	          answers: answers
	        });
	      } else if (currentAnswer && currentAnswer.submitted && _this.state.currentQuestionIndex < _questions2.default.size - 1) {
	        _this.setState({
	          currentQuestionIndex: _this.state.currentQuestionIndex + 1
	        });
	      } else if (_this.state.currentQuestionIndex === _questions2.default.size - 1) {
	        _this.setState({
	          done: true
	        });
	      }
	    }, _this.handleBackPress = function () {
	      _this.setState({
	        currentQuestionIndex: _this.state.currentQuestionIndex - 1
	      });
	    }, _this.handleFinishQuiz = function () {
	      _this.props.onFinishQuiz(_this.state);
	    }, _this.renderAnswer = function (answer, key) {
	      var currentQuestion = _questions2.default.get(_this.state.currentQuestionIndex);
	      var currentQuestionIndex = _this.state.currentQuestionIndex;
	      var currentAnswer = _this.state.answers[currentQuestionIndex];
	      var thisAnswerSelected = currentAnswer && currentAnswer.answer === key;
	      var thisAnswerCorrect = currentQuestion.get('answer') === key;
	
	      var iconStyle = { width: 32, height: 32 };
	
	      var icon = void 0;
	      if (currentAnswer && currentAnswer.submitted) {
	        if (thisAnswerCorrect) {
	          icon = _react2.default.createElement(_check2.default, { color: 'green', style: iconStyle });
	        } else if (thisAnswerSelected && !thisAnswerCorrect) {
	          icon = _react2.default.createElement(_close2.default, { color: 'red', style: iconStyle });
	        }
	      }
	
	      return _react2.default.createElement(_FlatButton2.default, {
	        className: 'Quiz__answers__answer',
	        fullWidth: true,
	        primary: currentAnswer && thisAnswerSelected,
	        label: key + ') ' + answer,
	        style: answerStyle,
	        labelStyle: answerLabelStyle,
	        labelPosition: 'before',
	        icon: icon,
	        onTouchTap: _this.setAnswer(key),
	        disabled: currentAnswer && currentAnswer.submitted
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Quiz, [{
	    key: 'numberOfCorrectAnswers',
	    value: function numberOfCorrectAnswers() {
	      return parseInt(this.state.answers.filter(function (answer, index) {
	        return answer.answer === _questions2.default.get(index).get('answer');
	      }).length, 10);
	    }
	  }, {
	    key: 'renderQuiz',
	    value: function renderQuiz() {
	      var currentQuestion = _questions2.default.get(this.state.currentQuestionIndex);
	      var currentQuestionIndex = this.state.currentQuestionIndex;
	      var currentAnswer = this.state.answers[currentQuestionIndex];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'Quiz' },
	        _react2.default.createElement(
	          'header',
	          { className: 'Quiz__header' },
	          _react2.default.createElement(
	            'span',
	            { className: 'Quiz__header__count' },
	            this.state.currentQuestionIndex + 1,
	            ' / ',
	            _questions2.default.size
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'Quiz__header__title' },
	            currentQuestion.get('question')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Quiz__answers' },
	          currentQuestion.get('answers').map(this.renderAnswer)
	        ),
	        _react2.default.createElement(_ContinueFooter2.default, {
	          showBack: true,
	          onBack: this.handleBackPress,
	          disableBack: currentQuestionIndex === 0,
	          continueLabel: currentAnswer && currentAnswer.submitted ? 'Continue' : 'Check',
	          disableContinue: !currentAnswer,
	          onContinue: this.handleContinuePress
	        })
	      );
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Results' },
	        _react2.default.createElement(_checkCircle2.default, { color: 'green', style: { height: 256, width: 256 } }),
	        _react2.default.createElement(
	          'h3',
	          { className: 'Results__message' },
	          'You scored ',
	          this.numberOfCorrectAnswers(),
	          ' / ',
	          _questions2.default.size
	        ),
	        _react2.default.createElement(_ContinueFooter2.default, {
	          stacked: true,
	          showBack: this.props.preTest || this.numberOfCorrectAnswers() < _questions2.default.size,
	          onBack: this.handleRetakePress,
	          backLabel: 'Retake Quiz',
	          continueLabel: this.props.preTest ? 'Continue to Video' : 'Congratulations! Redeem your certificate',
	          onContinue: this.handleFinishQuiz,
	          showContinue: this.props.preTest,
	          disableContinue: !this.props.preTest && this.numberOfCorrectAnswers() < _questions2.default.size
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.state.done ? this.renderResults() : this.renderQuiz();
	    }
	  }]);
	
	  return Quiz;
	}(_react.Component);
	
	Quiz.propTypes = {
	  preTest: _propTypes2.default.bool,
	  onFinishQuiz: _propTypes2.default.func.isRequired
	};
	exports.default = Quiz;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPlayer = __webpack_require__(394);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _ContinueFooter = __webpack_require__(58);
	
	var _ContinueFooter2 = _interopRequireDefault(_ContinueFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Video = function (_Component) {
	  _inherits(Video, _Component);
	
	  function Video() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Video);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Video.__proto__ || Object.getPrototypeOf(Video)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      finished: false
	    }, _this.handleVideoEnded = function () {
	      return _this.setState({
	        finished: true
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Video, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactPlayer2.default, {
	          width: '960px',
	          height: '540px',
	          url: 'https://portonefive.wistia.com/medias/n7ozoqiq07',
	          onEnded: this.handleVideoEnded
	        }),
	        _react2.default.createElement(
	          _ContinueFooter2.default,
	          {
	            continueLabel: 'Continue to Post-Test',
	            onContinue: this.props.onFinishVideo,
	            disableContinue: !this.state.finished
	          },
	          _react2.default.createElement(
	            'span',
	            { style: { color: '#aaa' } },
	            'You must complete the video in order to continue.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Video;
	}(_react.Component);
	
	Video.propTypes = {
	  onFinishVideo: _propTypes2.default.func.isRequired
	};
	exports.default = Video;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(177);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(239);
	
	var _reactTapEventPlugin = __webpack_require__(408);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Needed for onTouchTap
	// http://stackoverflow.com/a/34015469/988941
	(0, _reactTapEventPlugin2.default)();
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(191), __esModule: true };

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(195), __esModule: true };

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(196), __esModule: true };

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(197), __esModule: true };

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(115);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
	};

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(172)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)os/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/chrome.+? edge/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && !result.msedge && (android || result.silk)) {
	      result.android = t
	    } else if (!result.windowsphone && !result.msedge && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	    } else if (mac) {
	      result.mac = t
	    } else if (xbox) {
	      result.xbox = t
	    } else if (windows) {
	      result.windows = t
	    } else if (linux) {
	      result.linux = t
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  return bowser
	});


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(131);
	__webpack_require__(220);
	module.exports = __webpack_require__(19).Array.from;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(222);
	module.exports = __webpack_require__(19).Object.assign;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223);
	var $Object = __webpack_require__(19).Object;
	module.exports = function create(P, D){
	  return $Object.create(P, D);
	};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224);
	var $Object = __webpack_require__(19).Object;
	module.exports = function defineProperty(it, key, desc){
	  return $Object.defineProperty(it, key, desc);
	};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(225);
	module.exports = __webpack_require__(19).Object.getPrototypeOf;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(226);
	module.exports = __webpack_require__(19).Object.keys;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(227);
	module.exports = __webpack_require__(19).Object.setPrototypeOf;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(229);
	__webpack_require__(228);
	__webpack_require__(230);
	__webpack_require__(231);
	module.exports = __webpack_require__(19).Symbol;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(131);
	__webpack_require__(232);
	module.exports = __webpack_require__(87).f('iterator');

/***/ },
/* 198 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 199 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(31)
	  , toLength  = __webpack_require__(130)
	  , toIndex   = __webpack_require__(218);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(74)
	  , TAG = __webpack_require__(21)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(27)
	  , createDesc      = __webpack_require__(51);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(37)
	  , gOPS    = __webpack_require__(80)
	  , pIE     = __webpack_require__(60);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(26).document && document.documentElement;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(50)
	  , ITERATOR   = __webpack_require__(21)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(74);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(34);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(79)
	  , descriptor     = __webpack_require__(51)
	  , setToStringTag = __webpack_require__(81)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(36)(IteratorPrototype, __webpack_require__(21)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(21)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 210 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(37)
	  , toIObject = __webpack_require__(31);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(61)('meta')
	  , isObject = __webpack_require__(49)
	  , has      = __webpack_require__(30)
	  , setDesc  = __webpack_require__(27).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(35)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(37)
	  , gOPS     = __webpack_require__(80)
	  , pIE      = __webpack_require__(60)
	  , toObject = __webpack_require__(52)
	  , IObject  = __webpack_require__(122)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(35)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(27)
	  , anObject = __webpack_require__(34)
	  , getKeys  = __webpack_require__(37);
	
	module.exports = __webpack_require__(29) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(31)
	  , gOPN      = __webpack_require__(125).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(49)
	  , anObject = __webpack_require__(34);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(75)(Function.call, __webpack_require__(124).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84)
	  , defined   = __webpack_require__(76);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(201)
	  , ITERATOR  = __webpack_require__(21)('iterator')
	  , Iterators = __webpack_require__(50);
	module.exports = __webpack_require__(19).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(75)
	  , $export        = __webpack_require__(25)
	  , toObject       = __webpack_require__(52)
	  , call           = __webpack_require__(207)
	  , isArrayIter    = __webpack_require__(205)
	  , toLength       = __webpack_require__(130)
	  , createProperty = __webpack_require__(202)
	  , getIterFn      = __webpack_require__(219);
	
	$export($export.S + $export.F * !__webpack_require__(209)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(199)
	  , step             = __webpack_require__(210)
	  , Iterators        = __webpack_require__(50)
	  , toIObject        = __webpack_require__(31);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(123)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(25);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(213)});

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(25)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(79)});

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(25);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(29), 'Object', {defineProperty: __webpack_require__(27).f});

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(52)
	  , $getPrototypeOf = __webpack_require__(126);
	
	__webpack_require__(128)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(52)
	  , $keys    = __webpack_require__(37);
	
	__webpack_require__(128)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(25);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(216).set});

/***/ },
/* 228 */
/***/ function(module, exports) {



/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(26)
	  , has            = __webpack_require__(30)
	  , DESCRIPTORS    = __webpack_require__(29)
	  , $export        = __webpack_require__(25)
	  , redefine       = __webpack_require__(129)
	  , META           = __webpack_require__(212).KEY
	  , $fails         = __webpack_require__(35)
	  , shared         = __webpack_require__(83)
	  , setToStringTag = __webpack_require__(81)
	  , uid            = __webpack_require__(61)
	  , wks            = __webpack_require__(21)
	  , wksExt         = __webpack_require__(87)
	  , wksDefine      = __webpack_require__(86)
	  , keyOf          = __webpack_require__(211)
	  , enumKeys       = __webpack_require__(203)
	  , isArray        = __webpack_require__(206)
	  , anObject       = __webpack_require__(34)
	  , toIObject      = __webpack_require__(31)
	  , toPrimitive    = __webpack_require__(85)
	  , createDesc     = __webpack_require__(51)
	  , _create        = __webpack_require__(79)
	  , gOPNExt        = __webpack_require__(215)
	  , $GOPD          = __webpack_require__(124)
	  , $DP            = __webpack_require__(27)
	  , $keys          = __webpack_require__(37)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(125).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(60).f  = $propertyIsEnumerable;
	  __webpack_require__(80).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(78)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(36)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(86)('asyncIterator');

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(86)('observable');

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(221);
	var global        = __webpack_require__(26)
	  , hide          = __webpack_require__(36)
	  , Iterators     = __webpack_require__(50)
	  , TO_STRING_TAG = __webpack_require__(21)('toStringTag');
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype;
	  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}

/***/ },
/* 233 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 234 */
233,
/* 235 */
233,
/* 236 */
233,
/* 237 */
233,
/* 238 */
233,
/* 239 */
233,
/* 240 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(240);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(250);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(16);
	
	var createArrayFromMixed = __webpack_require__(243);
	var getMarkupWrap = __webpack_require__(245);
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(16);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 246 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 247 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(247);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 249 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(249);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 251 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 252 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
	    factory(exports, module);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, mod);
	    global.fetchJsonp = mod.exports;
	  }
	})(this, function (exports, module) {
	  'use strict';
	
	  var defaultOptions = {
	    timeout: 5000,
	    jsonpCallback: 'callback',
	    jsonpCallbackFunction: null
	  };
	
	  function generateCallbackFunction() {
	    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
	  }
	
	  // Known issue: Will throw 'Uncaught ReferenceError: callback_*** is not defined'
	  // error if request timeout
	  function clearFunction(functionName) {
	    // IE8 throws an exception when you try to delete a property on window
	    // http://stackoverflow.com/a/1824228/751089
	    try {
	      delete window[functionName];
	    } catch (e) {
	      window[functionName] = undefined;
	    }
	  }
	
	  function removeScript(scriptId) {
	    var script = document.getElementById(scriptId);
	    document.getElementsByTagName('head')[0].removeChild(script);
	  }
	
	  function fetchJsonp(_url) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    // to avoid param reassign
	    var url = _url;
	    var timeout = options.timeout || defaultOptions.timeout;
	    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;
	
	    var timeoutId = undefined;
	
	    return new Promise(function (resolve, reject) {
	      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
	      var scriptId = jsonpCallback + '_' + callbackFunction;
	
	      window[callbackFunction] = function (response) {
	        resolve({
	          ok: true,
	          // keep consistent with fetch API
	          json: function json() {
	            return Promise.resolve(response);
	          }
	        });
	
	        if (timeoutId) clearTimeout(timeoutId);
	
	        removeScript(scriptId);
	
	        clearFunction(callbackFunction);
	      };
	
	      // Check if the user set their own params, and if not add a ? to start a list of params
	      url += url.indexOf('?') === -1 ? '?' : '&';
	
	      var jsonpScript = document.createElement('script');
	      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
	      jsonpScript.id = scriptId;
	      document.getElementsByTagName('head')[0].appendChild(jsonpScript);
	
	      timeoutId = setTimeout(function () {
	        reject(new Error('JSONP request to ' + _url + ' timed out'));
	
	        clearFunction(callbackFunction);
	        removeScript(scriptId);
	      }, timeout);
	    });
	  }
	
	  // export as global function
	  /*
	  let local;
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	  local.fetchJsonp = fetchJsonp;
	  */
	
	  module.exports = fetchJsonp;
	});

/***/ },
/* 254 */
/***/ function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createPrefixer;
	
	var _getBrowserInformation = __webpack_require__(272);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(273);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(89);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _addNewValuesOnly = __webpack_require__(136);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(137);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _prefixValue = __webpack_require__(138);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
	    return style;
	  };
	
	  return function () {
	    /**
	    * Instantiante a new prefixer
	    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	    * @param {string} keepUnprefixed - keeps unprefixed properties and values
	    */
	    function Prefixer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      _classCallCheck(this, Prefixer);
	
	      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	      this._userAgent = options.userAgent || defaultUserAgent;
	      this._keepUnprefixed = options.keepUnprefixed || false;
	
	      if (this._userAgent) {
	        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	      }
	
	      // Checks if the userAgent was resolved correctly
	      if (this._browserInfo && this._browserInfo.cssPrefix) {
	        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
	      } else {
	        this._useFallback = true;
	        return false;
	      }
	
	      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
	      if (prefixData) {
	        this._requiresPrefix = {};
	
	        for (var property in prefixData) {
	          if (prefixData[property] >= this._browserInfo.browserVersion) {
	            this._requiresPrefix[property] = true;
	          }
	        }
	
	        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	      } else {
	        this._useFallback = true;
	      }
	
	      this._metaData = {
	        browserVersion: this._browserInfo.browserVersion,
	        browserName: this._browserInfo.browserName,
	        cssPrefix: this._browserInfo.cssPrefix,
	        jsPrefix: this._browserInfo.jsPrefix,
	        keepUnprefixed: this._keepUnprefixed,
	        requiresPrefix: this._requiresPrefix
	      };
	    }
	
	    _createClass(Prefixer, [{
	      key: 'prefix',
	      value: function prefix(style) {
	        // use static prefixer as fallback if userAgent can not be resolved
	        if (this._useFallback) {
	          return fallback(style);
	        }
	
	        // only add prefixes if needed
	        if (!this._hasPropsRequiringPrefix) {
	          return style;
	        }
	
	        return this._prefixStyle(style);
	      }
	    }, {
	      key: '_prefixStyle',
	      value: function _prefixStyle(style) {
	        for (var property in style) {
	          var value = style[property];
	
	          // handle nested objects
	          if ((0, _isObject2.default)(value)) {
	            style[property] = this.prefix(value);
	            // handle array values
	          } else if (Array.isArray(value)) {
	            var combinedValue = [];
	
	            for (var i = 0, len = value.length; i < len; ++i) {
	              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
	              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	            }
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (combinedValue.length > 0) {
	              style[property] = combinedValue;
	            }
	          } else {
	            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (_processedValue) {
	              style[property] = _processedValue;
	            }
	
	            // add prefixes to properties
	            if (this._requiresPrefix.hasOwnProperty(property)) {
	              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	              if (!this._keepUnprefixed) {
	                delete style[property];
	              }
	            }
	          }
	        }
	
	        return style;
	      }
	
	      /**
	      * Returns a prefixed version of the style object using all vendor prefixes
	      * @param {Object} styles - Style object that gets prefixed properties added
	      * @returns {Object} - Style object with prefixed properties and values
	      */
	
	    }], [{
	      key: 'prefixAll',
	      value: function prefixAll(styles) {
	        return fallback(styles);
	      }
	    }]);
	
	    return Prefixer;
	  }();
	}
	module.exports = exports['default'];

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(38);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
	    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(38);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  flex: true,
	  'inline-flex': true
	};
	function flex(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(38);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(38);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      if (value.indexOf('column') > -1) {
	        style.WebkitBoxOrient = 'vertical';
	      } else {
	        style.WebkitBoxOrient = 'horizontal';
	      }
	      if (value.indexOf('reverse') > -1) {
	        style.WebkitBoxDirection = 'reverse';
	      } else {
	        style.WebkitBoxDirection = 'normal';
	      }
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(38);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	function gradient(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(38);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	// TODO: chrome & opera support it
	function sizing(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(132);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	var requiresPrefixDashCased = void 0;
	
	function transition(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var _ret = function () {
	      // memoize the prefix array for later use
	      if (!requiresPrefixDashCased) {
	        requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	          return (0, _hyphenateProperty2.default)(prop);
	        });
	      }
	
	      // only split multi values, not cubic beziers
	      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	      requiresPrefixDashCased.forEach(function (prop) {
	        multipleValues.forEach(function (val, index) {
	          if (val.indexOf(prop) > -1 && prop !== 'order') {
	            multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
	          }
	        });
	      });
	
	      return {
	        v: multipleValues.join(',')
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(274);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(138);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(136);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(137);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _isPrefixedValue = __webpack_require__(88);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 266 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: true,
	  'inline-flex': true
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 267 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value, style) {
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 268 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(88);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 270 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(132);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(88);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(89);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getBrowserInformation;
	
	var _bowser = __webpack_require__(188);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixByBrowser = {
	  chrome: 'Webkit',
	  safari: 'Webkit',
	  ios: 'Webkit',
	  android: 'Webkit',
	  phantom: 'Webkit',
	  opera: 'Webkit',
	  webos: 'Webkit',
	  blackberry: 'Webkit',
	  bada: 'Webkit',
	  tizen: 'Webkit',
	  chromium: 'Webkit',
	  vivaldi: 'Webkit',
	  firefox: 'Moz',
	  seamoney: 'Moz',
	  sailfish: 'Moz',
	  msie: 'ms',
	  msedge: 'ms'
	};
	
	
	var browserByCanIuseAlias = {
	  chrome: 'chrome',
	  chromium: 'chrome',
	  safari: 'safari',
	  firfox: 'firefox',
	  msedge: 'edge',
	  opera: 'opera',
	  vivaldi: 'opera',
	  msie: 'ie'
	};
	
	function getBrowserName(browserInfo) {
	  if (browserInfo.firefox) {
	    return 'firefox';
	  }
	
	  if (browserInfo.mobile || browserInfo.tablet) {
	    if (browserInfo.ios) {
	      return 'ios_saf';
	    } else if (browserInfo.android) {
	      return 'android';
	    } else if (browserInfo.opera) {
	      return 'op_mini';
	    }
	  }
	
	  for (var browser in browserByCanIuseAlias) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      return browserByCanIuseAlias[browser];
	    }
	  }
	}
	
	/**
	 * Uses bowser to get default browser browserInformation such as version and name
	 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	function getBrowserInformation(userAgent) {
	  var browserInfo = _bowser2.default._detect(userAgent);
	
	  for (var browser in prefixByBrowser) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      var prefix = prefixByBrowser[browser];
	
	      browserInfo.jsPrefix = prefix;
	      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
	      break;
	    }
	  }
	
	  browserInfo.browserName = getBrowserName(browserInfo);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  if (browserInfo.version) {
	    browserInfo.browserVersion = parseFloat(browserInfo.version);
	  } else {
	    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
	  }
	
	  browserInfo.osVersion = parseFloat(browserInfo.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
	    browserInfo.browserName = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // Samsung browser are basically build on Chrome > 44
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
	  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
	    browserInfo.browserName = 'and_chr';
	    browserInfo.browserVersion = 44;
	  }
	
	  return browserInfo;
	}
	module.exports = exports['default'];

/***/ },
/* 273 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedKeyframes;
	function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
	  var prefixedKeyframes = 'keyframes';
	
	  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
	    return cssPrefix + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	}
	module.exports = exports['default'];

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(89);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var requiredPrefixes = prefixProperties[property];
	    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
	      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function(global) {!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.jspdf=e()}(this,function(){"use strict";var t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},e=(function(){function t(t){this.value=t}function e(e){function n(t,e){return new Promise(function(n,i){var s={key:t,arg:e,resolve:n,reject:i,next:null};a?a=a.next=s:(o=a=s,r(t,e))})}function r(n,o){try{var a=e[n](o),s=a.value;s instanceof t?Promise.resolve(s.value).then(function(t){r("next",t)},function(t){r("throw",t)}):i(a.done?"return":"normal",a.value)}catch(t){i("throw",t)}}function i(t,e){switch(t){case"return":o.resolve({value:e,done:!0});break;case"throw":o.reject(e);break;default:o.resolve({value:e,done:!1})}o=o.next,o?r(o.key,o.arg):a=null}var o,a;this._invoke=n,"function"!=typeof e.return&&(this.return=void 0)}return"function"==typeof Symbol&&Symbol.asyncIterator&&(e.prototype[Symbol.asyncIterator]=function(){return this}),e.prototype.next=function(t){return this._invoke("next",t)},e.prototype.throw=function(t){return this._invoke("throw",t)},e.prototype.return=function(t){return this._invoke("return",t)},{wrap:function(t){return function(){return new e(t.apply(this,arguments))}},await:function(e){return new t(e)}}}(),function(e){function n(t){var n={};this.subscribe=function(t,e,r){if("function"!=typeof e)return!1;n.hasOwnProperty(t)||(n[t]={});var i=Math.random().toString(35);return n[t][i]=[e,!!r],i},this.unsubscribe=function(t){for(var e in n)if(n[e][t])return delete n[e][t],!0;return!1},this.publish=function(r){if(n.hasOwnProperty(r)){var i=Array.prototype.slice.call(arguments,1),o=[];for(var a in n[r]){var s=n[r][a];try{s[0].apply(t,i)}catch(t){e.console&&console.error("jsPDF PubSub Error",t.message,t)}s[1]&&o.push(a)}o.length&&o.forEach(this.unsubscribe)}}}function r(c,l,u,h){var f={};"object"===("undefined"==typeof c?"undefined":t(c))&&(f=c,c=f.orientation,l=f.unit||l,u=f.format||u,h=f.compress||f.compressPdf||h),l=l||"mm",u=u||"a4",c=(""+(c||"P")).toLowerCase();var d,p,g,m,w,y,v,b,x,k=((""+u).toLowerCase(),!!h&&"function"==typeof Uint8Array),_=f.textColor||"0 g",C=f.drawColor||"0 G",A=f.fontSize||16,S=f.lineHeight||1.15,q=f.lineWidth||.200025,T=2,P=!1,I=[],E={},O={},F=0,R=[],B=[],D=[],j=[],z=[],N=0,L=0,M=0,U={title:"",subject:"",author:"",keywords:"",creator:""},H={},W=new n(H),X=function(t){return t.toFixed(2)},V=function(t){return t.toFixed(3)},Y=function(t){return("0"+parseInt(t)).slice(-2)},G=function(t){P?R[m].push(t):(M+=t.length+1,j.push(t))},J=function(){return T++,I[T]=M,G(T+" 0 obj"),T},Q=function(){var t=2*R.length+1;t+=z.length;var e={objId:t,content:""};return z.push(e),e},K=function(){return T++,I[T]=function(){return M},T},$=function(t){I[t]=M},Z=function(t){G("stream"),G(t),G("endstream")},tt=function(){var t,n,i,o,s,c,l,u,h,f=[];for(l=e.adler32cs||r.adler32cs,k&&"undefined"==typeof l&&(k=!1),t=1;t<=F;t++){if(f.push(J()),u=(w=D[t].width)*p,h=(y=D[t].height)*p,G("<</Type /Page"),G("/Parent 1 0 R"),G("/Resources 2 0 R"),G("/MediaBox [0 0 "+X(u)+" "+X(h)+"]"),W.publish("putPage",{pageNumber:t,page:R[t]}),G("/Contents "+(T+1)+" 0 R"),G(">>"),G("endobj"),n=R[t].join("\n"),J(),k){for(i=[],o=n.length;o--;)i[o]=n.charCodeAt(o);c=l.from(n),s=new a(6),s.append(new Uint8Array(i)),n=s.flush(),i=new Uint8Array(n.length+6),i.set(new Uint8Array([120,156])),i.set(n,2),i.set(new Uint8Array([255&c,c>>8&255,c>>16&255,c>>24&255]),n.length+2),n=String.fromCharCode.apply(null,i),G("<</Length "+n.length+" /Filter [/FlateDecode]>>")}else G("<</Length "+n.length+">>");Z(n),G("endobj")}I[1]=M,G("1 0 obj"),G("<</Type /Pages");var d="/Kids [";for(o=0;o<F;o++)d+=f[o]+" 0 R ";G(d+"]"),G("/Count "+F),G(">>"),G("endobj"),W.publish("postPutPages")},et=function(t){t.objectNumber=J(),G("<</BaseFont/"+t.PostScriptName+"/Type/Font"),"string"==typeof t.encoding&&G("/Encoding/"+t.encoding),G("/Subtype/Type1>>"),G("endobj")},nt=function(){for(var t in E)E.hasOwnProperty(t)&&et(E[t])},rt=function(){W.publish("putXobjectDict")},it=function(){G("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),G("/Font <<");for(var t in E)E.hasOwnProperty(t)&&G("/"+t+" "+E[t].objectNumber+" 0 R");G(">>"),G("/XObject <<"),rt(),G(">>")},ot=function(){nt(),W.publish("putResources"),I[2]=M,G("2 0 obj"),G("<<"),it(),G(">>"),G("endobj"),W.publish("postPutResources")},at=function(){W.publish("putAdditionalObjects");for(var t=0;t<z.length;t++){var e=z[t];I[e.objId]=M,G(e.objId+" 0 obj"),G(e.content),G("endobj")}T+=z.length,W.publish("postPutAdditionalObjects")},st=function(t,e,n){O.hasOwnProperty(e)||(O[e]={}),O[e][n]=t},ct=function(t,e,n,r){var i="F"+(Object.keys(E).length+1).toString(10),o=E[i]={id:i,PostScriptName:t,fontName:e,fontStyle:n,encoding:r,metadata:{}};return st(i,e,n),W.publish("addFont",o),i},lt=function(){for(var t="helvetica",e="times",n="courier",r="normal",i="bold",o="italic",a="bolditalic",s="StandardEncoding",c="zapfdingbats",l=[["Helvetica",t,r],["Helvetica-Bold",t,i],["Helvetica-Oblique",t,o],["Helvetica-BoldOblique",t,a],["Courier",n,r],["Courier-Bold",n,i],["Courier-Oblique",n,o],["Courier-BoldOblique",n,a],["Times-Roman",e,r],["Times-Bold",e,i],["Times-Italic",e,o],["Times-BoldItalic",e,a],["ZapfDingbats",c]],u=0,h=l.length;u<h;u++){var f=ct(l[u][0],l[u][1],l[u][2],s),d=l[u][0].split("-");st(f,d[0],d[1]||"")}W.publish("addFonts",{fonts:E,dictionary:O})},ut=function(t){return t.foo=function(){try{return t.apply(this,arguments)}catch(t){var n=t.stack||"";~n.indexOf(" at ")&&(n=n.split(" at ")[1]);var r="Error in function "+n.split("\n")[0].split("<")[0]+": "+t.message;if(!e.console)throw new Error(r);e.console.error(r,t),e.alert&&alert(r)}},t.foo.bar=t,t.foo},ht=function(t,e){var n,r,i,o,a,s,c,l,u;if(e=e||{},i=e.sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&E[d].metadata&&E[d].metadata[i]&&E[d].metadata[i].encoding&&(o=E[d].metadata[i].encoding,!a&&E[d].encoding&&(a=E[d].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(c=!1,s=[],n=0,r=t.length;n<r;n++)l=a[t.charCodeAt(n)],l?s.push(String.fromCharCode(l)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(c=!0);t=s.join("")}for(n=t.length;void 0===c&&0!==n;)t.charCodeAt(n-1)>>8&&(c=!0),n--;if(!c)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if(l=t.charCodeAt(n),u=l>>8,u>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(u),s.push(l-(u<<8))}return String.fromCharCode.apply(void 0,s)},ft=function(t,e){return ht(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},dt=function(){G("/Producer (jsPDF "+r.version+")");for(var t in U)U.hasOwnProperty(t)&&U[t]&&G("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+ft(U[t])+")");var e=new Date,n=e.getTimezoneOffset(),i=n<0?"+":"-",o=Math.floor(Math.abs(n/60)),a=Math.abs(n%60),s=[i,Y(o),"'",Y(a),"'"].join("");G(["/CreationDate (D:",e.getFullYear(),Y(e.getMonth()+1),Y(e.getDate()),Y(e.getHours()),Y(e.getMinutes()),Y(e.getSeconds()),s,")"].join(""))},pt=function(){switch(G("/Type /Catalog"),G("/Pages 1 0 R"),b||(b="fullwidth"),b){case"fullwidth":G("/OpenAction [3 0 R /FitH null]");break;case"fullheight":G("/OpenAction [3 0 R /FitV null]");break;case"fullpage":G("/OpenAction [3 0 R /Fit]");break;case"original":G("/OpenAction [3 0 R /XYZ null null 1]");break;default:var t=""+b;"%"===t.substr(t.length-1)&&(b=parseInt(b)/100),"number"==typeof b&&G("/OpenAction [3 0 R /XYZ null null "+X(b)+"]")}switch(x||(x="continuous"),x){case"continuous":G("/PageLayout /OneColumn");break;case"single":G("/PageLayout /SinglePage");break;case"two":case"twoleft":G("/PageLayout /TwoColumnLeft");break;case"tworight":G("/PageLayout /TwoColumnRight")}v&&G("/PageMode /"+v),W.publish("putCatalog")},gt=function(){G("/Size "+(T+1)),G("/Root "+T+" 0 R"),G("/Info "+(T-1)+" 0 R")},mt=function(t,e){var n="string"==typeof e&&e.toLowerCase();if("string"==typeof t){var r=t.toLowerCase();s.hasOwnProperty(r)&&(t=s[r][0]/p,e=s[r][1]/p)}if(Array.isArray(t)&&(e=t[1],t=t[0]),n){switch(n.substr(0,1)){case"l":e>t&&(n="s");break;case"p":t>e&&(n="s")}"s"===n&&(g=t,t=e,e=g)}P=!0,R[++F]=[],D[F]={width:Number(t)||w,height:Number(e)||y},B[F]={},vt(F)},wt=function(){mt.apply(this,arguments),G(X(q*p)+" w"),G(C),0!==N&&G(N+" J"),0!==L&&G(L+" j"),W.publish("addPage",{pageNumber:F})},yt=function(t){t>0&&t<=F&&(R.splice(t,1),D.splice(t,1),F--,m>F&&(m=F),this.setPage(m))},vt=function(t){t>0&&t<=F&&(m=t,w=D[t].width,y=D[t].height)},bt=function(t,e){var n;switch(t=void 0!==t?t:E[d].fontName,e=void 0!==e?e:E[d].fontStyle,void 0!==t&&(t=t.toLowerCase()),t){case"sans-serif":case"verdana":case"arial":case"helvetica":t="helvetica";break;case"fixed":case"monospace":case"terminal":case"courier":t="courier";break;case"serif":case"cursive":case"fantasy":default:t="times"}try{n=O[t][e]}catch(t){}return n||(n=O.times[e],null==n&&(n=O.times.normal)),n},xt=function(){P=!1,T=2,M=0,j=[],I=[],z=[],W.publish("buildDocument"),G("%PDF-"+o),tt(),at(),ot(),J(),G("<<"),dt(),G(">>"),G("endobj"),J(),G("<<"),pt(),G(">>"),G("endobj");var t,e=M,n="0000000000";for(G("xref"),G("0 "+(T+1)),G(n+" 65535 f "),t=1;t<=T;t++){var r=I[t];G("function"==typeof r?(n+I[t]()).slice(-10)+" 00000 n ":(n+I[t]).slice(-10)+" 00000 n ")}return G("trailer"),G("<<"),gt(),G(">>"),G("startxref"),G(""+e),G("%%EOF"),P=!0,j.join("\n")},kt=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e},_t=function(){for(var t=xt(),e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},Ct=function(){return new Blob([_t()],{type:"application/pdf"})},At=ut(function(t,n){var r="dataur"===(""+t).substr(0,6)?"data:application/pdf;base64,"+btoa(xt()):0;switch(t){case void 0:return xt();case"save":if(navigator.getUserMedia&&(void 0===e.URL||void 0===e.URL.createObjectURL))return H.output("dataurlnewwindow");i(Ct(),n),"function"==typeof i.unload&&e.setTimeout&&setTimeout(i.unload,911);break;case"arraybuffer":return _t();case"blob":return Ct();case"bloburi":case"bloburl":return e.URL&&e.URL.createObjectURL(Ct())||void 0;case"datauristring":case"dataurlstring":return r;case"dataurlnewwindow":var o=e.open(r);if(o||"undefined"==typeof safari)return o;case"datauri":case"dataurl":return e.document.location.href=r;default:throw new Error('Output type "'+t+'" is not supported.')}});switch(l){case"pt":p=1;break;case"mm":p=72/25.4000508;break;case"cm":p=72/2.54000508;break;case"in":p=72;break;case"px":p=96/72;break;case"pc":p=12;break;case"em":p=12;break;case"ex":p=6;break;default:throw"Invalid unit: "+l}H.internal={pdfEscape:ft,getStyle:kt,getFont:function(){return E[bt.apply(H,arguments)]},getFontSize:function(){return A},getLineHeight:function(){return A*S},write:function(t){G(1===arguments.length?t:Array.prototype.join.call(arguments," "))},getCoordinateString:function(t){return X(t*p)},getVerticalCoordinateString:function(t){return X((y-t)*p)},collections:{},newObject:J,newAdditionalObject:Q,newObjectDeferred:K,newObjectDeferredBegin:$,putStream:Z,events:W,scaleFactor:p,pageSize:{get width(){return w},get height(){return y}},output:function(t,e){return At(t,e)},getNumberOfPages:function(){return R.length-1},pages:R,out:G,f2:X,getPageInfo:function(t){var e=2*(t-1)+3;return{objId:e,pageNumber:t,pageContext:B[t]}},getCurrentPageInfo:function(){var t=2*(m-1)+3;return{objId:t,pageNumber:m,pageContext:B[m]}},getPDFVersion:function(){return o}},H.addPage=function(){return wt.apply(this,arguments),this},H.setPage=function(){return vt.apply(this,arguments),this},H.insertPage=function(t){return this.addPage(),this.movePage(m,t),this},H.movePage=function(t,e){if(t>e){for(var n=R[t],r=D[t],i=B[t],o=t;o>e;o--)R[o]=R[o-1],D[o]=D[o-1],B[o]=B[o-1];R[e]=n,D[e]=r,B[e]=i,this.setPage(e)}else if(t<e){for(var n=R[t],r=D[t],i=B[t],o=t;o<e;o++)R[o]=R[o+1],D[o]=D[o+1],B[o]=B[o+1];R[e]=n,D[e]=r,B[e]=i,this.setPage(e)}return this},H.deletePage=function(){return yt.apply(this,arguments),this},H.setDisplayMode=function(t,e,n){b=t,x=e,v=n;var r=[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"];if(r.indexOf(n)==-1)throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+n+'" is not recognized.');return this},H.text=function(t,e,n,r,i,o){function a(t){return t=t.split("\t").join(Array(f.TabLen||9).join(" ")),ft(t,r)}"number"==typeof t&&(g=n,n=e,e=t,t=g),"string"==typeof t&&(t=t.match(/[\n\r]/)?t.split(/\r\n|\r|\n/g):[t]),"string"==typeof i&&(o=i,i=null),"string"==typeof r&&(o=r,r=null),"number"==typeof r&&(i=r,r=null);var s,c="",l="Td";if(i){i*=Math.PI/180;var u=Math.cos(i),h=Math.sin(i);c=[X(u),X(h),X(h*-1),X(u),""].join(" "),l="Tm"}r=r||{},"noBOM"in r||(r.noBOM=!0),"autoencode"in r||(r.autoencode=!0);var m="",w=this.internal.getCurrentPageInfo().pageContext;if(!0===r.stroke?w.lastTextWasStroke!==!0&&(m="1 Tr\n",w.lastTextWasStroke=!0):(w.lastTextWasStroke&&(m="0 Tr\n"),w.lastTextWasStroke=!1),"undefined"==typeof this._runningPageHeight&&(this._runningPageHeight=0),"string"==typeof t)t=a(t);else{if("[object Array]"!==Object.prototype.toString.call(t))throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');for(var v=t.concat(),b=[],x=v.length;x--;)b.push(a(v.shift()));var k=Math.ceil((y-n-this._runningPageHeight)*p/(A*S));if(0<=k&&k<b.length+1,o){var C,q,T,P=A*S,I=t.map(function(t){return this.getStringUnitWidth(t)*A/p},this);if(T=Math.max.apply(Math,I),"center"===o)C=e-T/2,e-=I[0]/2;else{if("right"!==o)throw new Error('Unrecognized alignment option, use "center" or "right".');C=e-T,e-=I[0]}q=e,t=b[0];for(var E=1,x=b.length;E<x;E++){var O=T-I[E];"center"===o&&(O/=2),t+=") Tj\n"+(C-q+O)+" -"+P+" Td ("+b[E],q=C+O}}else t=b.join(") Tj\nT* (")}var F;return s||(F=X((y-n)*p)),G("BT\n/"+d+" "+A+" Tf\n"+A*S+" TL\n"+m+_+"\n"+c+X(e*p)+" "+F+" "+l+"\n("+t+") Tj\nET"),s&&this.text(s,e,n),this},H.lstext=function(t,e,n,r){console.warn("jsPDF.lstext is deprecated");for(var i=0,o=t.length;i<o;i++,e+=r)this.text(t[i],e,n);return this},H.line=function(t,e,n,r){return this.lines([[n-t,r-e]],t,e)},H.clip=function(){G("W"),G("S")},H.clip_fixed=function(t){G("evenodd"===t?"W*":"W"),G("n")},H.lines=function(t,e,n,r,i,o){var a,s,c,l,u,h,f,d,m,w,v;for("number"==typeof t&&(g=n,n=e,e=t,t=g),r=r||[1,1],G(V(e*p)+" "+V((y-n)*p)+" m "),a=r[0],s=r[1],l=t.length,w=e,v=n,c=0;c<l;c++)u=t[c],2===u.length?(w=u[0]*a+w,v=u[1]*s+v,G(V(w*p)+" "+V((y-v)*p)+" l")):(h=u[0]*a+w,f=u[1]*s+v,d=u[2]*a+w,m=u[3]*s+v,w=u[4]*a+w,v=u[5]*s+v,G(V(h*p)+" "+V((y-f)*p)+" "+V(d*p)+" "+V((y-m)*p)+" "+V(w*p)+" "+V((y-v)*p)+" c"));return o&&G(" h"),null!==i&&G(kt(i)),this},H.rect=function(t,e,n,r,i){kt(i);return G([X(t*p),X((y-e)*p),X(n*p),X(-r*p),"re"].join(" ")),null!==i&&G(kt(i)),this},H.triangle=function(t,e,n,r,i,o,a){return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},H.roundedRect=function(t,e,n,r,i,o,a){var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-(i*s),o,-i,o],[-n+2*i,0],[-(i*s),0,-i,-(o*s),-i,-o],[0,-r+2*o],[0,-(o*s),i*s,-o,i,-o]],t+i,e,[1,1],a),this},H.ellipse=function(t,e,n,r,i){var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return G([X((t+n)*p),X((y-e)*p),"m",X((t+n)*p),X((y-(e-a))*p),X((t+o)*p),X((y-(e-r))*p),X(t*p),X((y-(e-r))*p),"c"].join(" ")),G([X((t-o)*p),X((y-(e-r))*p),X((t-n)*p),X((y-(e-a))*p),X((t-n)*p),X((y-e)*p),"c"].join(" ")),G([X((t-n)*p),X((y-(e+a))*p),X((t-o)*p),X((y-(e+r))*p),X(t*p),X((y-(e+r))*p),"c"].join(" ")),G([X((t+o)*p),X((y-(e+r))*p),X((t+n)*p),X((y-(e+a))*p),X((t+n)*p),X((y-e)*p),"c"].join(" ")),null!==i&&G(kt(i)),this},H.circle=function(t,e,n,r){return this.ellipse(t,e,n,n,r)},H.setProperties=function(t){for(var e in U)U.hasOwnProperty(e)&&t[e]&&(U[e]=t[e]);return this},H.setFontSize=function(t){return A=t,this},H.setFont=function(t,e){return d=bt(t,e),this},H.setFontStyle=H.setFontType=function(t){return d=bt(void 0,t),this},H.getFontList=function(){var t,e,n,r={};for(t in O)if(O.hasOwnProperty(t)){r[t]=n=[];for(e in O[t])O[t].hasOwnProperty(e)&&n.push(e)}return r},H.addFont=function(t,e,n){ct(t,e,n,"StandardEncoding")},H.setLineWidth=function(t){return G((t*p).toFixed(2)+" w"),this},H.setDrawColor=function(t,e,n,r){var i;return i=void 0===e||void 0===r&&t===e===n?"string"==typeof t?t+" G":X(t/255)+" G":void 0===r?"string"==typeof t?[t,e,n,"RG"].join(" "):[X(t/255),X(e/255),X(n/255),"RG"].join(" "):"string"==typeof t?[t,e,n,r,"K"].join(" "):[X(t),X(e),X(n),X(r),"K"].join(" "),G(i),this},H.setFillColor=function(e,n,r,i){var o;return void 0===n||void 0===i&&e===n===r?o="string"==typeof e?e+" g":X(e/255)+" g":void 0===i||"object"===("undefined"==typeof i?"undefined":t(i))?(o="string"==typeof e?[e,n,r,"rg"].join(" "):[X(e/255),X(n/255),X(r/255),"rg"].join(" "),i&&0===i.a&&(o=["255","255","255","rg"].join(" "))):o="string"==typeof e?[e,n,r,i,"k"].join(" "):[X(e),X(n),X(r),X(i),"k"].join(" "),G(o),this},H.setTextColor=function(t,e,n){if("string"==typeof t&&/^#[0-9A-Fa-f]{6}$/.test(t)){var r=parseInt(t.substr(1),16);t=r>>16&255,e=r>>8&255,n=255&r}return _=0===t&&0===e&&0===n||"undefined"==typeof e?V(t/255)+" g":[V(t/255),V(e/255),V(n/255),"rg"].join(" "),this},H.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},H.setLineCap=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return N=e,G(e+" J"),this},H.setLineJoin=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return L=e,G(e+" j"),this},H.output=At,H.save=function(t){H.output("save",t)};for(var St in r.API)r.API.hasOwnProperty(St)&&("events"===St&&r.API.events.length?!function(t,e){var n,r,i;for(i=e.length-1;i!==-1;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(W,r.API.events):H[St]=r.API[St]);return lt(),d="F1",wt(u,c),W.publish("initialized"),H}var o="1.3",s={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};return r.API={events:[]},r.version="1.x-master", true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return r}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?module.exports=r:e.jsPDF=r,r}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0));/**
	 * jsPDF AcroForm Plugin
	 * Copyright (c) 2016 Alexander Weidt, https://github.com/BiggA94
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	(window.AcroForm=function(t){var n=window.AcroForm;n.scale=function(t){return t*(r.internal.scaleFactor/1)},n.antiScale=function(t){return 1/r.internal.scaleFactor*t};var r={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null};e.API.acroformPlugin=r;var i=function(){for(var t in this.acroformPlugin.acroFormDictionaryRoot.Fields){var e=this.acroformPlugin.acroFormDictionaryRoot.Fields[t];e.hasAnnotation&&a.call(this,e)}},o=function(){if(this.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");this.acroformPlugin.acroFormDictionaryRoot=new n.AcroFormDictionary,this.acroformPlugin.internal=this.internal,this.acroformPlugin.acroFormDictionaryRoot._eventID=this.internal.events.subscribe("postPutResources",l),this.internal.events.subscribe("buildDocument",i),this.internal.events.subscribe("putCatalog",c),this.internal.events.subscribe("postPutPages",u)},a=function(t){var n={type:"reference",object:t};e.API.annotationPlugin.annotations[this.internal.getPageInfo(t.page).pageNumber].push(n)},s=function(t){this.acroformPlugin.printedOut&&(this.acroformPlugin.printedOut=!1,this.acroformPlugin.acroFormDictionaryRoot=null),this.acroformPlugin.acroFormDictionaryRoot||o.call(this),this.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)},c=function(){"undefined"!=typeof this.acroformPlugin.acroFormDictionaryRoot?this.internal.write("/AcroForm "+this.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R"):console.log("Root missing...")},l=function(){this.internal.events.unsubscribe(this.acroformPlugin.acroFormDictionaryRoot._eventID),delete this.acroformPlugin.acroFormDictionaryRoot._eventID,this.acroformPlugin.printedOut=!0},u=function(t){var e=!t;t||(this.internal.newObjectDeferredBegin(this.acroformPlugin.acroFormDictionaryRoot.objId),this.internal.out(this.acroformPlugin.acroFormDictionaryRoot.getString()));var t=t||this.acroformPlugin.acroFormDictionaryRoot.Kids;for(var r in t){var i=t[r],o=i.Rect;i.Rect&&(i.Rect=n.internal.calculateCoordinates.call(this,i.Rect)),this.internal.newObjectDeferredBegin(i.objId);var a="";if(a+=i.objId+" 0 obj\n",a+="<<\n"+i.getContent(),i.Rect=o,i.hasAppearanceStream&&!i.appearanceStreamContent){var s=n.internal.calculateAppearanceStream.call(this,i);a+="/AP << /N "+s+" >>\n",this.acroformPlugin.xForms.push(s)}if(i.appearanceStreamContent){a+="/AP << ";for(var c in i.appearanceStreamContent){var l=i.appearanceStreamContent[c];if(a+="/"+c+" ",a+="<< ",Object.keys(l).length>=1||Array.isArray(l))for(var r in l){var u=l[r];"function"==typeof u&&(u=u.call(this,i)),a+="/"+r+" "+u+" ",this.acroformPlugin.xForms.indexOf(u)>=0||this.acroformPlugin.xForms.push(u)}else{var u=l;"function"==typeof u&&(u=u.call(this,i)),a+="/"+r+" "+u+" \n",this.acroformPlugin.xForms.indexOf(u)>=0||this.acroformPlugin.xForms.push(u)}a+=" >>\n"}a+=">>\n"}a+=">>\nendobj\n",this.internal.out(a)}e&&h.call(this,this.acroformPlugin.xForms)},h=function(t){for(var e in t){var n=e,r=t[e];this.internal.newObjectDeferredBegin(r&&r.objId);var i="";i+=r?r.getString():"",this.internal.out(i),delete t[n]}};t.addField=function(t){return t instanceof n.TextField?d.call(this,t):t instanceof n.ChoiceField?p.call(this,t):t instanceof n.Button?f.call(this,t):t instanceof n.ChildClass?s.call(this,t):t&&s.call(this,t),t.page=this.acroformPlugin.internal.getCurrentPageInfo().pageNumber,this};var f=function(t){var t=t||new n.Field;t.FT="/Btn";var e=t.Ff||0;t.pushbutton&&(e=n.internal.setBitPosition(e,17),delete t.pushbutton),t.radio&&(e=n.internal.setBitPosition(e,16),delete t.radio),t.noToggleToOff&&(e=n.internal.setBitPosition(e,15)),t.Ff=e,s.call(this,t)},d=function(t){var t=t||new n.Field;t.FT="/Tx";var e=t.Ff||0;t.multiline&&(e=4096|e),t.password&&(e=8192|e),t.fileSelect&&(e|=1<<20),t.doNotSpellCheck&&(e|=1<<22),t.doNotScroll&&(e|=1<<23),t.Ff=t.Ff||e,s.call(this,t)},p=function(t){var e=t||new n.Field;e.FT="/Ch";var r=e.Ff||0;e.combo&&(r=n.internal.setBitPosition(r,18),delete e.combo),e.edit&&(r=n.internal.setBitPosition(r,19),delete e.edit),e.sort&&(r=n.internal.setBitPosition(r,20),delete e.sort),e.multiSelect&&this.internal.getPDFVersion()>=1.4&&(r=n.internal.setBitPosition(r,22),delete e.multiSelect),e.doNotSpellCheck&&this.internal.getPDFVersion()>=1.4&&(r=n.internal.setBitPosition(r,23),delete e.doNotSpellCheck),e.Ff=r,s.call(this,e)}})(e.API);var n=window.AcroForm;n.internal={},n.createFormXObject=function(t){var e=new n.FormXObject,r=n.Appearance.internal.getHeight(t)||0,i=n.Appearance.internal.getWidth(t)||0;return e.BBox=[0,0,i,r],e},n.Appearance={CheckBox:{createAppearanceStream:function(){var t={N:{On:n.Appearance.CheckBox.YesNormal},D:{On:n.Appearance.CheckBox.YesPushDown,Off:n.Appearance.CheckBox.OffPushDown}};return t},createMK:function(){return"<< /CA (3)>>"},YesPushDown:function(t){var e=n.createFormXObject(t),r="";t.Q=1;var i=n.internal.calculateX(t,"3","ZapfDingbats",50);return r+="0.749023 g\n             0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n             f\n             BMC\n             q\n             0 0 1 rg\n             /F13 "+i.fontSize+" Tf 0 g\n             BT\n",r+=i.text,r+="ET\n             Q\n             EMC\n",e.stream=r,e},YesNormal:function(t){var e=n.createFormXObject(t),r="";t.Q=1;var i=n.internal.calculateX(t,"3","ZapfDingbats",.9*n.Appearance.internal.getHeight(t));return r+="1 g\n0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\nf\nq\n0 0 1 rg\n0 0 "+(n.Appearance.internal.getWidth(t)-1)+" "+(n.Appearance.internal.getHeight(t)-1)+" re\nW\nn\n0 g\nBT\n/F13 "+i.fontSize+" Tf 0 g\n",r+=i.text,r+="ET\n             Q\n",e.stream=r,e},OffPushDown:function(t){var e=n.createFormXObject(t),r="";return r+="0.749023 g\n            0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n            f\n",e.stream=r,e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:n.Appearance.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=n.Appearance.RadioButton.Circle.YesNormal,e.D[t]=n.Appearance.RadioButton.Circle.YesPushDown,e},createMK:function(){return"<< /CA (l)>>"},YesNormal:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.getWidth(t)<=n.Appearance.internal.getHeight(t)?n.Appearance.internal.getWidth(t)/4:n.Appearance.internal.getHeight(t)/4;i*=.9;var o=n.Appearance.internal.Bezier_C;return r+="q\n1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+i+" 0 m\n"+i+" "+i*o+" "+i*o+" "+i+" 0 "+i+" c\n-"+i*o+" "+i+" -"+i+" "+i*o+" -"+i+" 0 c\n-"+i+" -"+i*o+" -"+i*o+" -"+i+" 0 -"+i+" c\n"+i*o+" -"+i+" "+i+" -"+i*o+" "+i+" 0 c\nf\nQ\n",e.stream=r,e},YesPushDown:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.getWidth(t)<=n.Appearance.internal.getHeight(t)?n.Appearance.internal.getWidth(t)/4:n.Appearance.internal.getHeight(t)/4;i*=.9;var o=2*i,a=o*n.Appearance.internal.Bezier_C,s=i*n.Appearance.internal.Bezier_C;return r+="0.749023 g\n            q\n           1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+o+" 0 m\n"+o+" "+a+" "+a+" "+o+" 0 "+o+" c\n-"+a+" "+o+" -"+o+" "+a+" -"+o+" 0 c\n-"+o+" -"+a+" -"+a+" -"+o+" 0 -"+o+" c\n"+a+" -"+o+" "+o+" -"+a+" "+o+" 0 c\n            f\n            Q\n            0 g\n            q\n            1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+i+" 0 m\n"+i+" "+s+" "+s+" "+i+" 0 "+i+" c\n-"+s+" "+i+" -"+i+" "+s+" -"+i+" 0 c\n-"+i+" -"+s+" -"+s+" -"+i+" 0 -"+i+" c\n"+s+" -"+i+" "+i+" -"+s+" "+i+" 0 c\n            f\n            Q\n",e.stream=r,e},OffPushDown:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.getWidth(t)<=n.Appearance.internal.getHeight(t)?n.Appearance.internal.getWidth(t)/4:n.Appearance.internal.getHeight(t)/4;i*=.9;var o=2*i,a=o*n.Appearance.internal.Bezier_C;return r+="0.749023 g\n            q\n 1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+o+" 0 m\n"+o+" "+a+" "+a+" "+o+" 0 "+o+" c\n-"+a+" "+o+" -"+o+" "+a+" -"+o+" 0 c\n-"+o+" -"+a+" -"+a+" -"+o+" 0 -"+o+" c\n"+a+" -"+o+" "+o+" -"+a+" "+o+" 0 c\n            f\n            Q\n",e.stream=r,e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:n.Appearance.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=n.Appearance.RadioButton.Cross.YesNormal,e.D[t]=n.Appearance.RadioButton.Cross.YesPushDown,e},createMK:function(){return"<< /CA (8)>>"},YesNormal:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.calculateCross(t);return r+="q\n            1 1 "+(n.Appearance.internal.getWidth(t)-2)+" "+(n.Appearance.internal.getHeight(t)-2)+" re\n            W\n            n\n            "+i.x1.x+" "+i.x1.y+" m\n            "+i.x2.x+" "+i.x2.y+" l\n            "+i.x4.x+" "+i.x4.y+" m\n            "+i.x3.x+" "+i.x3.y+" l\n            s\n            Q\n",e.stream=r,e},YesPushDown:function(t){var e=n.createFormXObject(t),r=n.Appearance.internal.calculateCross(t),i="";return i+="0.749023 g\n            0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n            f\n            q\n            1 1 "+(n.Appearance.internal.getWidth(t)-2)+" "+(n.Appearance.internal.getHeight(t)-2)+" re\n            W\n            n\n            "+r.x1.x+" "+r.x1.y+" m\n            "+r.x2.x+" "+r.x2.y+" l\n            "+r.x4.x+" "+r.x4.y+" m\n            "+r.x3.x+" "+r.x3.y+" l\n            s\n            Q\n",e.stream=i,e},OffPushDown:function(t){var e=n.createFormXObject(t),r="";return r+="0.749023 g\n            0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n            f\n",e.stream=r,e}}},createDefaultAppearanceStream:function(t){var e="";return e+="/Helv 0 Tf 0 g"}},n.Appearance.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=function(t,e){return t>e?e:t},r=n.Appearance.internal.getWidth(t),i=n.Appearance.internal.getHeight(t),o=e(r,i),a={x1:{x:(r-o)/2,y:(i-o)/2+o},x2:{x:(r-o)/2+o,y:(i-o)/2},x3:{x:(r-o)/2,y:(i-o)/2},x4:{x:(r-o)/2+o,y:(i-o)/2+o}};return a}},n.Appearance.internal.getWidth=function(t){return t.Rect[2]},n.Appearance.internal.getHeight=function(t){return t.Rect[3]},n.internal.inherit=function(t,e){Object.create||function(t){var e=function(){};return e.prototype=t,new e};t.prototype=Object.create(e.prototype),t.prototype.constructor=t},n.internal.arrayToPdfArray=function(t){if(Array.isArray(t)){var e=" [";for(var n in t){var r=t[n].toString();e+=r,e+=n<t.length-1?" ":""}return e+="]"}},n.internal.toPdfString=function(t){return t=t||"",0!==t.indexOf("(")&&(t="("+t),")"!=t.substring(t.length-1)&&(t+="("),t},n.PDFObject=function(){var t;Object.defineProperty(this,"objId",{get:function(){return t||(this.internal?t=this.internal.newObjectDeferred():e.API.acroformPlugin.internal&&(t=e.API.acroformPlugin.internal.newObjectDeferred())),t||console.log("Couldn't create Object ID"),t},configurable:!1})},n.PDFObject.prototype.toString=function(){return this.objId+" 0 R"},n.PDFObject.prototype.getString=function(){var t=this.objId+" 0 obj\n<<",e=this.getContent();return t+=e+">>\n",this.stream&&(t+="stream\n",t+=this.stream,t+="endstream\n"),t+="endobj\n"},n.PDFObject.prototype.getContent=function(){var t=function(t){var e="",r=Object.keys(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var i in r){var o=r[i],a=t[o];a&&(e+=Array.isArray(a)?"/"+o+" "+n.internal.arrayToPdfArray(a)+"\n":a instanceof n.PDFObject?"/"+o+" "+a.objId+" 0 R\n":"/"+o+" "+a+"\n")}return e},e="";return e+=t(this)},n.FormXObject=function(){n.PDFObject.call(this),this.Type="/XObject",this.Subtype="/Form",this.FormType=1,this.BBox,this.Matrix,this.Resources="2 0 R",this.PieceInfo;var t;Object.defineProperty(this,"Length",{enumerable:!0,get:function(){return void 0!==t?t.length:0}}),Object.defineProperty(this,"stream",{enumerable:!1,set:function(e){t=e},get:function(){return t?t:null}})},n.internal.inherit(n.FormXObject,n.PDFObject),n.AcroFormDictionary=function(){n.PDFObject.call(this);var t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return t.length>0?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!0,configurable:!0,get:function(){return t}}),this.DA},n.internal.inherit(n.AcroFormDictionary,n.PDFObject),n.Field=function(){n.PDFObject.call(this);var t;Object.defineProperty(this,"Rect",{enumerable:!0,configurable:!1,get:function(){if(t){var e=t;return e}},set:function(e){t=e}});var e="";Object.defineProperty(this,"FT",{enumerable:!0,set:function(t){e=t},get:function(){return e}});var r;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,set:function(t){r=t},get:function(){if(!r||r.length<1){if(this instanceof n.ChildClass)return;return"(FieldObject"+n.Field.FieldNum++ +")"}return"("==r.substring(0,1)&&r.substring(r.length-1)?r:"("+r+")"}});var i;Object.defineProperty(this,"DA",{enumerable:!0,get:function(){if(i)return"("+i+")"},set:function(t){i=t}});var o;Object.defineProperty(this,"DV",{enumerable:!0,configurable:!0,get:function(){if(o)return o},set:function(t){o=t}}),Object.defineProperty(this,"Type",{enumerable:!0,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,get:function(){return this.hasAnnotation?"/Widget":null}}),this.BG,Object.defineProperty(this,"hasAnnotation",{enumerable:!1,get:function(){return!!(this.Rect||this.BC||this.BG)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,configurable:!0,writable:!0}),Object.defineProperty(this,"page",{enumerable:!1,configurable:!0,writable:!0})},n.Field.FieldNum=0,n.internal.inherit(n.Field,n.PDFObject),n.ChoiceField=function(){n.Field.call(this),this.FT="/Ch",this.Opt=[],this.V="()",this.TI=0,this.combo=!1,Object.defineProperty(this,"edit",{enumerable:!0,set:function(t){1==t?(this._edit=!0,this.combo=!0):this._edit=!1},get:function(){return!!this._edit&&this._edit},configurable:!1}),this.hasAppearanceStream=!0,Object.defineProperty(this,"V",{get:function(){n.internal.toPdfString()}})},n.internal.inherit(n.ChoiceField,n.Field),window.ChoiceField=n.ChoiceField,n.ListBox=function(){n.ChoiceField.call(this)},n.internal.inherit(n.ListBox,n.ChoiceField),window.ListBox=n.ListBox,n.ComboBox=function(){n.ListBox.call(this),this.combo=!0},n.internal.inherit(n.ComboBox,n.ListBox),window.ComboBox=n.ComboBox,n.EditBox=function(){n.ComboBox.call(this),this.edit=!0},n.internal.inherit(n.EditBox,n.ComboBox),window.EditBox=n.EditBox,n.Button=function(){n.Field.call(this),this.FT="/Btn"},n.internal.inherit(n.Button,n.Field),window.Button=n.Button,n.PushButton=function(){n.Button.call(this),this.pushbutton=!0},n.internal.inherit(n.PushButton,n.Button),window.PushButton=n.PushButton,n.RadioButton=function(){n.Button.call(this),this.radio=!0;var t=[];Object.defineProperty(this,"Kids",{enumerable:!0,get:function(){if(t.length>0)return t}}),Object.defineProperty(this,"__Kids",{get:function(){return t}});var e;Object.defineProperty(this,"noToggleToOff",{enumerable:!1,get:function(){return e},set:function(t){e=t}})},n.internal.inherit(n.RadioButton,n.Button),window.RadioButton=n.RadioButton,n.ChildClass=function(t,e){n.Field.call(this),this.Parent=t,this._AppearanceType=n.Appearance.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(e),this.F=n.internal.setBitPosition(this.F,3,1),this.MK=this._AppearanceType.createMK(),this.AS="/Off",this._Name=e},n.internal.inherit(n.ChildClass,n.Field),n.RadioButton.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t&&"createMK"in t))return void console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.__Kids){var n=this.__Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n._Name),n.MK=t.createMK()}},n.RadioButton.prototype.createOption=function(t){var r=this,i=(this.__Kids.length,new n.ChildClass(r,t));return this.__Kids.push(i),e.API.addField(i),i},n.CheckBox=function(){Button.call(this),this.appearanceStreamContent=n.Appearance.CheckBox.createAppearanceStream(),this.MK=n.Appearance.CheckBox.createMK(),this.AS="/On",this.V="/On"},n.internal.inherit(n.CheckBox,n.Button),window.CheckBox=n.CheckBox,n.TextField=function(){n.Field.call(this),this.DA=n.Appearance.createDefaultAppearanceStream(),this.F=4;var t;Object.defineProperty(this,"V",{get:function(){return t?"("+t+")":t},enumerable:!0,set:function(e){t=e}});var e;Object.defineProperty(this,"DV",{get:function(){return e?"("+e+")":e},enumerable:!0,set:function(t){e=t}});var r=!1;Object.defineProperty(this,"multiline",{enumerable:!1,get:function(){return r},set:function(t){r=t}});var i=!1;Object.defineProperty(this,"MaxLen",{enumerable:!0,get:function(){return i},set:function(t){i=t}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,get:function(){return this.V||this.DV}})},n.internal.inherit(n.TextField,n.Field),window.TextField=n.TextField,n.PasswordField=function(){TextField.call(this),Object.defineProperty(this,"password",{value:!0,enumerable:!1,configurable:!1,writable:!1})},n.internal.inherit(n.PasswordField,n.TextField),window.PasswordField=n.PasswordField,n.internal.calculateFontSpace=function(t,e,r){var r=r||"helvetica",i=n.internal.calculateFontSpace.canvas||(n.internal.calculateFontSpace.canvas=document.createElement("canvas")),o=i.getContext("2d");o.save();var a=e+" "+r;o.font=a;var s=o.measureText(t);o.fontcolor="black";var o=i.getContext("2d");s.height=1.5*o.measureText("3").width,o.restore();s.width;return s},n.internal.calculateX=function(t,e,r,i){var i=i||12,r=r||"helvetica",o={text:"",fontSize:""};e="("==e.substr(0,1)?e.substr(1):e,e=")"==e.substr(e.length-1)?e.substr(0,e.length-1):e;var a=e.split(" "),s=i,c=2,l=2,u=n.Appearance.internal.getHeight(t)||0;u=u<0?-u:u;var h=n.Appearance.internal.getWidth(t)||0;h=h<0?-h:h;var f=function(t,e,i){if(t+1<a.length){var o=e+" "+a[t+1],s=n.internal.calculateFontSpace(o,i+"px",r).width,c=h-2*l;return s<=c}return!1};s++;t:for(;;){var e="";s--;var d=n.internal.calculateFontSpace("3",s+"px",r).height,p=t.multiline?u-s:(u-d)/2;p+=c;var g=-l,m=g,w=p,y=0,v=0,b=0;if(0==s){s=12,e="(...) Tj\n",e+="% Width of Text: "+n.internal.calculateFontSpace(e,"1px").width+", FieldWidth:"+h+"\n";break}b=n.internal.calculateFontSpace(a[0]+" ",s+"px",r).width;var x="",k=0;for(var _ in a){x+=a[_]+" ",x=" "==x.substr(x.length-1)?x.substr(0,x.length-1):x;var C=parseInt(_);b=n.internal.calculateFontSpace(x+" ",s+"px",r).width;var A=f(C,x,s),S=_>=a.length-1;if(!A||S){if(A||S){if(S)v=C;else if(t.multiline&&(d+c)*(k+2)+c>u)continue t}else{if(!t.multiline)continue t;if((d+c)*(k+2)+c>u)continue t;v=C}for(var q="",T=y;T<=v;T++)q+=a[T]+" ";switch(q=" "==q.substr(q.length-1)?q.substr(0,q.length-1):q,b=n.internal.calculateFontSpace(q,s+"px",r).width,t.Q){case 2:g=h-b-l;break;case 1:g=(h-b)/2;break;case 0:default:g=l}e+=g+" "+w+" Td\n",e+="("+q+") Tj\n",e+=-g+" 0 Td\n",w=-(s+c),m=g,b=0,y=v+1,k++,x=""}else x+=" "}break}return o.text=e,o.fontSize=s,o},n.internal.calculateAppearanceStream=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e="",r=t.V||t.DV,i=n.internal.calculateX(t,r);e+="/Tx BMC\nq\n/F1 "+i.fontSize+" Tf\n1 0 0 1 0 0 Tm\n",e+="BT\n",e+=i.text,e+="ET\n",e+="Q\nEMC\n";var o=new n.createFormXObject(t);o.stream=e;return o}},n.internal.calculateCoordinates=function(t,e,r,i){var o={};if(this.internal){var a=function(t){return t*this.internal.scaleFactor};Array.isArray(t)?(t[0]=n.scale(t[0]),t[1]=n.scale(t[1]),t[2]=n.scale(t[2]),t[3]=n.scale(t[3]),o.lowerLeft_X=t[0]||0,o.lowerLeft_Y=a.call(this,this.internal.pageSize.height)-t[3]-t[1]||0,o.upperRight_X=t[0]+t[2]||0,o.upperRight_Y=a.call(this,this.internal.pageSize.height)-t[1]||0):(t=n.scale(t),e=n.scale(e),r=n.scale(r),i=n.scale(i),o.lowerLeft_X=t||0,o.lowerLeft_Y=this.internal.pageSize.height-e||0,o.upperRight_X=t+r||0,o.upperRight_Y=this.internal.pageSize.height-e+i||0)}else Array.isArray(t)?(o.lowerLeft_X=t[0]||0,o.lowerLeft_Y=t[1]||0,o.upperRight_X=t[0]+t[2]||0,o.upperRight_Y=t[1]+t[3]||0):(o.lowerLeft_X=t||0,o.lowerLeft_Y=e||0,o.upperRight_X=t+r||0,o.upperRight_Y=e+i||0);return[o.lowerLeft_X,o.lowerLeft_Y,o.upperRight_X,o.upperRight_Y]},n.internal.calculateColor=function(t,e,n){var r=new Array(3);return r.r=0|t,r.g=0|e,r.b=0|n,r},n.internal.getBitPosition=function(t,e){t=t||0;var n=1;return n<<=e-1,t|n},n.internal.setBitPosition=function(t,e,n){t=t||0,n=n||1;var r=1;if(r<<=e-1,1==n)var t=t|r;else var t=t&~r;return t},/**
	 * jsPDF addHTML PlugIn
	 * Copyright (c) 2014 Diego Casorran
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	function(t){t.addHTML=function(t,e,n,r,i){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof e&&(r=e,i=n),"function"==typeof r&&(i=r,r=null);var o=this.internal,a=o.scaleFactor,s=o.pageSize.width,c=o.pageSize.height;if(r=r||{},r.onrendered=function(t){e=parseInt(e)||0,n=parseInt(n)||0;var o=r.dim||{},l=o.h||0,u=o.w||Math.min(s,t.width/a)-e,h="JPEG";if(r.format&&(h=r.format),t.height>c&&r.pagesplit){var f=function(){for(var r=0;;){var o=document.createElement("canvas");o.width=Math.min(s*a,t.width),o.height=Math.min(c*a,t.height-r);var l=o.getContext("2d");l.drawImage(t,0,r,t.width,o.height,0,0,o.width,o.height);var f=[o,e,r?0:n,o.width/a,o.height/a,h,null,"SLOW"];if(this.addImage.apply(this,f),r+=o.height,r>=t.height)break;this.addPage()}i(u,r,null,f)}.bind(this);if("CANVAS"===t.nodeName){var d=new Image;d.onload=f,d.src=t.toDataURL("image/png"),t=d}else f()}else{var p=Math.random().toString(35),g=[t,e,n,u,l,h,p,"SLOW"];this.addImage.apply(this,g),i(u,l,p,g)}}.bind(this),"undefined"!=typeof html2canvas&&!r.rstz)return html2canvas(t,r);if("undefined"!=typeof rasterizeHTML){var l="drawDocument";return"string"==typeof t&&(l=/^http/.test(t)?"drawURL":"drawHTML"),r.width=r.width||s*a,rasterizeHTML[l](t,void 0,r).then(function(t){r.onrendered(t.image)},function(t){i(null,t)})}return null}}(e.API),/** @preserve
	 * jsPDF addImage plugin
	 * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
	 *               2013 Chris Dowling, https://github.com/gingerchris
	 *               2013 Trinh Ho, https://github.com/ineedfat
	 *               2013 Edwin Alejandro Perez, https://github.com/eaparango
	 *               2013 Norah Smith, https://github.com/burnburnrocket
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 James Robb, https://github.com/jamesbrobb
	 *
	 * 
	 */
	function(e){var n="addImage_",r=["jpeg","jpg","png"],i=function t(e){var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream;if(e.n=n,r("<</Type /XObject"),r("/Subtype /Image"),r("/Width "+e.w),r("/Height "+e.h),e.cs===this.color_spaces.INDEXED?r("/ColorSpace [/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"):(r("/ColorSpace /"+e.cs),e.cs===this.color_spaces.DEVICE_CMYK&&r("/Decode [1 0 1 0 1 0 1 0]")),r("/BitsPerComponent "+e.bpc),"f"in e&&r("/Filter /"+e.f),"dp"in e&&r("/DecodeParms <<"+e.dp+">>"),"trns"in e&&e.trns.constructor==Array){for(var o="",a=0,s=e.trns.length;a<s;a++)o+=e.trns[a]+" "+e.trns[a]+" ";r("/Mask ["+o+"]")}if("smask"in e&&r("/SMask "+(n+1)+" 0 R"),r("/Length "+e.data.length+">>"),i(e.data),r("endobj"),"smask"in e){var c="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,l={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:c,data:e.smask};"f"in e&&(l.f=e.f),t.call(this,l)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),r("<< /Length "+e.pal.length+">>"),i(this.arrayBufferToBinaryString(new Uint8Array(e.pal))),r("endobj"))},o=function(){var t=this.internal.collections[n+"images"];for(var e in t)i.call(this,t[e])},a=function(){var t,e=this.internal.collections[n+"images"],r=this.internal.write;for(var i in e)t=e[i],r("/I"+t.i,t.n,"0","R")},s=function(t){return t&&"string"==typeof t&&(t=t.toUpperCase()),t in e.image_compression?t:e.image_compression.NONE},c=function(){var t=this.internal.collections[n+"images"];return t||(this.internal.collections[n+"images"]=t={},this.internal.events.subscribe("putResources",o),this.internal.events.subscribe("putXobjectDict",a)),t},l=function(t){var e=0;return t&&(e=Object.keys?Object.keys(t).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(t)),e},u=function(t){return"undefined"==typeof t||null===t},h=function(t){return"string"==typeof t&&e.sHashCode(t)},f=function(t){return r.indexOf(t)===-1},d=function(t){return"function"!=typeof e["process"+t.toUpperCase()]},p=function(e){return"object"===("undefined"==typeof e?"undefined":t(e))&&1===e.nodeType},g=function(e,n,r){if("IMG"===e.nodeName&&e.hasAttribute("src")){var i=""+e.getAttribute("src");if(!r&&0===i.indexOf("data:image/"))return i;!n&&/\.png(?:[?#].*)?$/i.test(i)&&(n="png")}if("CANVAS"===e.nodeName)var o=e;else{var o=document.createElement("canvas");o.width=e.clientWidth||e.width,o.height=e.clientHeight||e.height;var a=o.getContext("2d");if(!a)throw"addImage requires canvas to be supported by browser.";if(r){var s,c,l,u,h,f,d,p,g=Math.PI/180;"object"===("undefined"==typeof r?"undefined":t(r))&&(s=r.x,c=r.y,l=r.bg,r=r.angle),p=r*g,u=Math.abs(Math.cos(p)),h=Math.abs(Math.sin(p)),f=o.width,d=o.height,o.width=d*h+f*u,o.height=d*u+f*h,isNaN(s)&&(s=o.width/2),isNaN(c)&&(c=o.height/2),a.clearRect(0,0,o.width,o.height),a.fillStyle=l||"white",a.fillRect(0,0,o.width,o.height),a.save(),a.translate(s,c),a.rotate(p),a.drawImage(e,-(f/2),-(d/2)),a.rotate(-p),a.translate(-s,-c),a.restore()}else a.drawImage(e,0,0,o.width,o.height)}return o.toDataURL("png"==(""+n).toLowerCase()?"image/png":"image/jpeg")},m=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n},w=function(t,e,n){return t||e||(t=-96,e=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]},y=function(t,e,n,r,i,o,a){var s=w.call(this,n,r,i),c=this.internal.getCoordinateString,l=this.internal.getVerticalCoordinateString;n=s[0],r=s[1],a[o]=i,this.internal.write("q",c(n),"0 0",c(r),c(t),l(e+r),"cm /I"+i.i,"Do Q")};e.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},e.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},e.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},e.sHashCode=function(t){return Array.prototype.reduce&&t.split("").reduce(function(t,e){return t=(t<<5)-t+e.charCodeAt(0),t&t},0)},e.isString=function(t){return"string"==typeof t},e.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));base64,(.+?)$/g.exec(t)},e.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},e.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},e.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},e.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},e.arrayBufferToBinaryString=function(t){this.isArrayBuffer(t)&&(t=new Uint8Array(t));for(var e="",n=t.byteLength,r=0;r<n;r++)e+=String.fromCharCode(t[r]);return e},e.arrayBufferToBase64=function(t){for(var e,n,r,i,o,a="",s="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",c=new Uint8Array(t),l=c.byteLength,u=l%3,h=l-u,f=0;f<h;f+=3)o=c[f]<<16|c[f+1]<<8|c[f+2],e=(16515072&o)>>18,n=(258048&o)>>12,r=(4032&o)>>6,i=63&o,a+=s[e]+s[n]+s[r]+s[i];return 1==u?(o=c[h],e=(252&o)>>2,n=(3&o)<<4,a+=s[e]+s[n]+"=="):2==u&&(o=c[h]<<8|c[h+1],e=(64512&o)>>10,n=(1008&o)>>4,r=(15&o)<<2,a+=s[e]+s[n]+s[r]+"="),a},e.createImageInfo=function(t,e,n,r,i,o,a,s,c,l,u,h,f){var d={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(d.f=o),c&&(d.dp=c),l&&(d.trns=l),u&&(d.pal=u),h&&(d.smask=h),f&&(d.p=f),d},e.addImage=function(e,n,i,o,a,w,v,b,x){if("string"!=typeof n){var k=w;w=a,a=o,o=i,i=n,n=k}if("object"===("undefined"==typeof e?"undefined":t(e))&&!p(e)&&"imageData"in e){var _=e;e=_.imageData,n=_.format||n,i=_.x||i||0,o=_.y||o||0,a=_.w||a,w=_.h||w,v=_.alias||v,b=_.compression||b,x=_.rotation||_.angle||x}if(isNaN(i)||isNaN(o))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var C,A=c.call(this);if(!(C=m(e,A))){var S;if(p(e)&&(e=g(e,n,x)),u(v)&&(v=h(e)),!(C=m(v,A))){if(this.isString(e)){var q=this.extractInfoFromBase64DataURI(e);q?(n=q[2],e=atob(q[3])):137===e.charCodeAt(0)&&80===e.charCodeAt(1)&&78===e.charCodeAt(2)&&71===e.charCodeAt(3)&&(n="png")}if(n=(n||"JPEG").toLowerCase(),f(n))throw new Error("addImage currently only supports formats "+r+", not '"+n+"'");if(d(n))throw new Error("please ensure that the plugin for '"+n+"' support is added");if(this.supportsArrayBuffer()&&(e instanceof Uint8Array||(S=e,e=this.binaryStringToUint8Array(e))),C=this["process"+n.toUpperCase()](e,l(A),v,s(b),S),!C)throw new Error("An unkwown error occurred whilst processing the image")}}return y.call(this,i,o,a,w,C,C.i,A),this};var v=function(t){var e,n,r;if(255===!t.charCodeAt(0)||216===!t.charCodeAt(1)||255===!t.charCodeAt(2)||224===!t.charCodeAt(3)||!t.charCodeAt(6)==="J".charCodeAt(0)||!t.charCodeAt(7)==="F".charCodeAt(0)||!t.charCodeAt(8)==="I".charCodeAt(0)||!t.charCodeAt(9)==="F".charCodeAt(0)||0===!t.charCodeAt(10))throw new Error("getJpegSize requires a binary string jpeg file");for(var i=256*t.charCodeAt(4)+t.charCodeAt(5),o=4,a=t.length;o<a;){if(o+=i,255!==t.charCodeAt(o))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(o+1)||193===t.charCodeAt(o+1)||194===t.charCodeAt(o+1)||195===t.charCodeAt(o+1)||196===t.charCodeAt(o+1)||197===t.charCodeAt(o+1)||198===t.charCodeAt(o+1)||199===t.charCodeAt(o+1))return n=256*t.charCodeAt(o+5)+t.charCodeAt(o+6),e=256*t.charCodeAt(o+7)+t.charCodeAt(o+8),r=t.charCodeAt(o+9),[e,n,r];o+=2,i=256*t.charCodeAt(o)+t.charCodeAt(o+1)}},b=function(t){var e=t[0]<<8|t[1];if(65496!==e)throw new Error("Supplied data is not a JPEG");for(var n,r,i,o,a=t.length,s=(t[4]<<8)+t[5],c=4;c<a;){if(c+=s,n=x(t,c),s=(n[2]<<8)+n[3],(192===n[1]||194===n[1])&&255===n[0]&&s>7)return n=x(t,c+5),r=(n[2]<<8)+n[3],i=(n[0]<<8)+n[1],o=n[4],{width:r,height:i,numcomponents:o};c+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")},x=function(t,e){return t.subarray(e,e+5)};e.processJPEG=function(t,e,n,r,i){var o,a=this.color_spaces.DEVICE_RGB,s=this.decode.DCT_DECODE,c=8;return this.isString(t)?(o=v(t),this.createImageInfo(t,o[0],o[1],1==o[3]?this.color_spaces.DEVICE_GRAY:a,c,s,e,n)):(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)?(o=b(t),t=i||this.arrayBufferToBinaryString(t),this.createImageInfo(t,o.width,o.height,1==o.numcomponents?this.color_spaces.DEVICE_GRAY:a,c,s,e,n)):null)},e.processJPG=function(){return this.processJPEG.apply(this,arguments)}}(e.API),/**
	 * jsPDF Annotations PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	function(t){var n={annotations:[],f2:function(t){return t.toFixed(2)},notEmpty:function(t){if("undefined"!=typeof t&&""!=t)return!0}};return e.API.annotationPlugin=n,e.API.events.push(["addPage",function(t){this.annotationPlugin.annotations[t.pageNumber]=[]}]),t.events.push(["putPage",function(t){for(var e=this.annotationPlugin.annotations[t.pageNumber],r=!1,i=0;i<e.length&&!r;i++){var o=e[i];switch(o.type){case"link":if(n.notEmpty(o.options.url)||n.notEmpty(o.options.pageNumber)){r=!0;break}case"reference":case"text":case"freetext":r=!0}}if(0!=r){this.internal.write("/Annots [");for(var a=this.annotationPlugin.f2,s=this.internal.scaleFactor,c=this.internal.pageSize.height,l=this.internal.getPageInfo(t.pageNumber),i=0;i<e.length;i++){var o=e[i];switch(o.type){case"reference":this.internal.write(" "+o.object.objId+" 0 R ");break;case"text":var u=this.internal.newAdditionalObject(),h=this.internal.newAdditionalObject(),f=o.title||"Note",d="/Rect ["+a(o.bounds.x*s)+" "+a(c-(o.bounds.y+o.bounds.h)*s)+" "+a((o.bounds.x+o.bounds.w)*s)+" "+a((c-o.bounds.y)*s)+"] ";y="<</Type /Annot /Subtype /Text "+d+"/Contents ("+o.contents+")",y+=" /Popup "+h.objId+" 0 R",y+=" /P "+l.objId+" 0 R",y+=" /T ("+f+") >>",u.content=y;var p=u.objId+" 0 R",g=30,d="/Rect ["+a((o.bounds.x+g)*s)+" "+a(c-(o.bounds.y+o.bounds.h)*s)+" "+a((o.bounds.x+o.bounds.w+g)*s)+" "+a((c-o.bounds.y)*s)+"] ";y="<</Type /Annot /Subtype /Popup "+d+" /Parent "+p,o.open&&(y+=" /Open true"),y+=" >>",h.content=y,this.internal.write(u.objId,"0 R",h.objId,"0 R");break;case"freetext":var d="/Rect ["+a(o.bounds.x*s)+" "+a((c-o.bounds.y)*s)+" "+a(o.bounds.x+o.bounds.w*s)+" "+a(c-(o.bounds.y+o.bounds.h)*s)+"] ",m=o.color||"#000000";y="<</Type /Annot /Subtype /FreeText "+d+"/Contents ("+o.contents+")",y+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+m+")",y+=" /Border [0 0 0]",y+=" >>",this.internal.write(y);break;case"link":if(o.options.name){var w=this.annotations._nameMap[o.options.name];o.options.pageNumber=w.page,o.options.top=w.y}else o.options.top||(o.options.top=0);var d="/Rect ["+a(o.x*s)+" "+a((c-o.y)*s)+" "+a(o.x+o.w*s)+" "+a(c-(o.y+o.h)*s)+"] ",y="";if(o.options.url)y="<</Type /Annot /Subtype /Link "+d+"/Border [0 0 0] /A <</S /URI /URI ("+o.options.url+") >>";else if(o.options.pageNumber){var t=this.internal.getPageInfo(o.options.pageNumber);switch(y="<</Type /Annot /Subtype /Link "+d+"/Border [0 0 0] /Dest ["+t.objId+" 0 R",o.options.magFactor=o.options.magFactor||"XYZ",o.options.magFactor){case"Fit":y+=" /Fit]";break;case"FitH":y+=" /FitH "+o.options.top+"]";break;case"FitV":o.options.left=o.options.left||0,y+=" /FitV "+o.options.left+"]";break;case"XYZ":default:var v=a((c-o.options.top)*s);o.options.left=o.options.left||0,"undefined"==typeof o.options.zoom&&(o.options.zoom=0),y+=" /XYZ "+o.options.left+" "+v+" "+o.options.zoom+"]"}}""!=y&&(y+=" >>",this.internal.write(y))}}this.internal.write("]")}}]),t.createAnnotation=function(t){switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(t)}},t.link=function(t,e,n,r,i){this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.link=function(t,e,n,r,i){this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight();return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize(),n=this.getStringUnitWidth(t)*e/this.internal.scaleFactor;return n},t.getLineHeight=function(){return this.internal.getLineHeight()},this}(e.API),function(t){t.autoPrint=function(){var t;return this.internal.events.subscribe("postPutResources",function(){t=this.internal.newObject(),this.internal.write("<< /S/Named /Type/Action /N/Print >>","endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.write("/OpenAction "+t+" 0 R")}),this}}(e.API),/**
	 * jsPDF Canvas PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	function(t){return t.events.push(["initialized",function(){this.canvas.pdf=this}]),t.canvas={getContext:function(t){return this.pdf.context2d._canvas=this,this.pdf.context2d},style:{}},Object.defineProperty(t.canvas,"width",{get:function(){return this._width},set:function(t){this._width=t,this.getContext("2d").pageWrapX=t+1}}),Object.defineProperty(t.canvas,"height",{get:function(){return this._height},set:function(t){this._height=t,this.getContext("2d").pageWrapY=t+1}}),this}(e.API),/** ====================================================================
	 * jsPDF Cell plugin
	 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	 *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	 *               2013 Lee Driscoll, https://github.com/lsdriscoll
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 James Hall, james@parall.ax
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *
	 * 
	 * ====================================================================
	 */
	function(t){var e,n,r,i,o=3,a=13,s={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},c=1,l=function(t,e,n,r,i){s={x:t,y:e,w:n,h:r,ln:i}},u=function(){return s},h={left:0,top:0,bottom:0};t.setHeaderFunction=function(t){i=t},t.getTextDimensions=function(t){e=this.internal.getFont().fontName,n=this.table_font_size||this.internal.getFontSize(),r=this.internal.getFont().fontStyle;var i,o,a=19.049976/25.4;o=document.createElement("font"),o.id="jsPDFCell";try{o.style.fontStyle=r}catch(t){o.style.fontWeight=r}o.style.fontName=e,o.style.fontSize=n+"pt";try{o.textContent=t}catch(e){o.innerText=t}return document.body.appendChild(o),i={w:(o.offsetWidth+1)*a,h:(o.offsetHeight+1)*a},document.body.removeChild(o),i},t.cellAddPage=function(){var t=this.margins||h;this.addPage(),l(t.left,t.top,void 0,void 0),c+=1},t.cellInitialize=function(){s={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},c=1},t.cell=function(t,e,n,r,i,s,c){var f=u(),d=!1;if(void 0!==f.ln)if(f.ln===s)t=f.x+f.w,e=f.y;else{var p=this.margins||h;f.y+f.h+r+a>=this.internal.pageSize.height-p.bottom&&(this.cellAddPage(),d=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(s,!0)),e=u().y+u().h,d&&(e=a+10)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===c){i instanceof Array||(i=[i]);for(var g=0;g<i.length;g++){var m=i[g],w=this.getStringUnitWidth(m)*this.internal.getFontSize();this.text(m,t+n-w-o,e+this.internal.getLineHeight()*(g+1))}}else this.text(i,t+o,e+this.internal.getLineHeight());return l(t,e,n,r,s),this},t.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?e(o,i)===-1&&(o=i):i>o&&(o=i);return o},t.table=function(e,n,r,i,o){if(!r)throw"No data for PDF table";var a,l,u,f,d,p,g,m,w,y,v=[],b=[],x={},k={},_=[],C=[],A=!1,S=!0,q=12,T=h;if(T.width=this.internal.pageSize.width,o&&(o.autoSize===!0&&(A=!0),o.printHeaders===!1&&(S=!1),o.fontSize&&(q=o.fontSize),o.css&&"undefined"!=typeof o.css["font-size"]&&(q=16*o.css["font-size"]),o.margins&&(T=o.margins)),this.lnMod=0,s={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},c=1,this.printHeaders=S,this.margins=T,this.setFontSize(q),this.table_font_size=q,void 0===i||null===i)v=Object.keys(r[0]);else if(i[0]&&"string"!=typeof i[0]){var P=19.049976/25.4;for(l=0,u=i.length;l<u;l+=1)a=i[l],v.push(a.name),b.push(a.prompt),k[a.name]=a.width*P}else v=i;if(A)for(y=function(t){return t[a]},l=0,u=v.length;l<u;l+=1){for(a=v[l],x[a]=r.map(y),_.push(this.getTextDimensions(b[l]||a).w),p=x[a],g=0,f=p.length;g<f;g+=1)d=p[g],_.push(this.getTextDimensions(d).w);k[a]=t.arrayMax(_),_=[]}if(S){var I=this.calculateLineHeight(v,k,b.length?b:v);for(l=0,u=v.length;l<u;l+=1)a=v[l],C.push([e,n,k[a],I,String(b.length?b[l]:a)]);this.setTableHeaderRow(C),this.printHeaderRow(1,!1)}for(l=0,u=r.length;l<u;l+=1){var I;for(m=r[l],I=this.calculateLineHeight(v,k,m),g=0,w=v.length;g<w;g+=1)a=v[g],this.cell(e,n,k[a],I,m[a],l+2,a.align)}return this.lastCellPos=s,this.table_x=e,this.table_y=n,this},t.calculateLineHeight=function(t,e,n){for(var r,i=0,a=0;a<t.length;a++){r=t[a],n[r]=this.splitTextToSize(String(n[r]),e[r]-o);var s=this.internal.getLineHeight()*n[r].length+o;s>i&&(i=s)}return i},t.setTableHeaderRow=function(t){this.tableHeaderRow=t},t.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,o,s;if(this.printingHeaderRow=!0,void 0!==i){var u=i(this,c);l(u[0],u[1],u[2],u[3],-1)}this.setFontStyle("bold");var h=[];for(o=0,s=this.tableHeaderRow.length;o<s;o+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[o],e&&(this.margins.top=a,n[1]=this.margins&&this.margins.top||0,h.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));h.length>0&&this.setTableHeaderRow(h),this.setFontStyle("normal"),this.printingHeaderRow=!1}}(e.API),/**
	 * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
	 *
	 * Licensed under the MIT License. http://opensource.org/licenses/mit-license
	 */
	function(t){function e(){this._isStrokeTransparent=!1,this._strokeOpacity=1,this.strokeStyle="#000000",this.fillStyle="#000000",this._isFillTransparent=!1,this._fillOpacity=1,this.font="12pt times",this.textBaseline="alphabetic",this.textAlign="start",this.lineWidth=1,this.lineJoin="miter",this.lineCap="butt",this._transform=[1,0,0,1,0,0],this.globalCompositeOperation="normal",this.globalAlpha=1,this._clip_path=[],this.ignoreClearRect=!1,this.copy=function(t){this._isStrokeTransparent=t._isStrokeTransparent,this._strokeOpacity=t._strokeOpacity,this.strokeStyle=t.strokeStyle,this._isFillTransparent=t._isFillTransparent,this._fillOpacity=t._fillOpacity,this.fillStyle=t.fillStyle,this.font=t.font,this.lineWidth=t.lineWidth,this.lineJoin=t.lineJoin,this.lineCap=t.lineCap,this.textBaseline=t.textBaseline,this.textAlign=t.textAlign,this._fontSize=t._fontSize,this._transform=t._transform.slice(0),this.globalCompositeOperation=t.globalCompositeOperation,this.globalAlpha=t.globalAlpha,this._clip_path=t._clip_path.slice(0),this.ignoreClearRect=t.ignoreClearRect}}t.events.push(["initialized",function(){this.context2d.pdf=this,this.context2d.internal.pdf=this,this.context2d.ctx=new e,this.context2d.ctxStack=[],this.context2d.path=[]}]),t.context2d={pageWrapXEnabled:!1,pageWrapYEnabled:!1,pageWrapX:9999999,pageWrapY:9999999,ctx:new e,f2:function(t){return t.toFixed(2)},fillRect:function(t,e,n,r){if(!this._isFillTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"f")}},strokeRect:function(t,e,n,r){if(!this._isStrokeTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"s")}},clearRect:function(t,e,n,r){if(!this.ctx.ignoreClearRect){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.save(),this.setFillStyle("#ffffff"),this.pdf.rect(i.x,i.y,i.w,i.h,"f"),this.restore()}},save:function(){this.ctx._fontSize=this.pdf.internal.getFontSize();var t=new e;t.copy(this.ctx),this.ctxStack.push(this.ctx),this.ctx=t},restore:function(){this.ctx=this.ctxStack.pop(),this.setFillStyle(this.ctx.fillStyle),this.setStrokeStyle(this.ctx.strokeStyle),this.setFont(this.ctx.font),this.pdf.setFontSize(this.ctx._fontSize),this.setLineCap(this.ctx.lineCap),this.setLineWidth(this.ctx.lineWidth),this.setLineJoin(this.ctx.lineJoin)},rect:function(t,e,n,r){this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.closePath()},beginPath:function(){this.path=[]},closePath:function(){this.path.push({type:"close"})},_getRgba:function(t){var e={};if(this.internal.rxTransparent.test(t))e.r=0,e.g=0,e.b=0,e.a=0;else{var n=this.internal.rxRgb.exec(t);null!=n?(e.r=parseInt(n[1]),e.g=parseInt(n[2]),e.b=parseInt(n[3]),e.a=1):(n=this.internal.rxRgba.exec(t),null!=n?(e.r=parseInt(n[1]),e.g=parseInt(n[2]),e.b=parseInt(n[3]),e.a=parseFloat(n[4])):(e.a=1,"#"!=t.charAt(0)&&(t=o.colorNameToHex(t),t||(t="#000000")),4===t.length?(e.r=t.substring(1,2),e.r+=r,e.g=t.substring(2,3),e.g+=g,e.b=t.substring(3,4),e.b+=b):(e.r=t.substring(1,3),e.g=t.substring(3,5),e.b=t.substring(5,7)),e.r=parseInt(e.r,16),e.g=parseInt(e.g,16),e.b=parseInt(e.b,16)))}return e.style=t,e},setFillStyle:function(t){var e,n,r,i;if(this.internal.rxTransparent.test(t))e=0,n=0,r=0,i=0;else{var a=this.internal.rxRgb.exec(t);null!=a?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),i=1):(a=this.internal.rxRgba.exec(t),null!=a?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),i=parseFloat(a[4])):(i=1,"#"!=t.charAt(0)&&(t=o.colorNameToHex(t),t||(t="#000000")),4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16)))}this.ctx.fillStyle=t,this.ctx._isFillTransparent=0==i,this.ctx._fillOpacity=i,this.pdf.setFillColor(e,n,r,{a:i}),this.pdf.setTextColor(e,n,r,{a:i})},setStrokeStyle:function(t){var e=this._getRgba(t);this.ctx.strokeStyle=e.style,this.ctx._isStrokeTransparent=0==e.a,this.ctx._strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):1===e.a?this.pdf.setDrawColor(e.r,e.g,e.b):this.pdf.setDrawColor(e.r,e.g,e.b)},fillText:function(t,e,n,r){if(!this._isFillTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=this._matrix_rotation(this.ctx._transform),a=57.2958*o;if(this.ctx._clip_path.length>0){var s;s=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage(),s.push("q");var c=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=c}var l;if(l=this.pdf.hotfix&&this.pdf.hotfix.scale_text?this._getTransform()[0]:1,l<.01)this.pdf.text(t,e,this._getBaseline(n),null,a);else{var u=this.pdf.internal.getFontSize();this.pdf.setFontSize(u*l),this.pdf.text(t,e,this._getBaseline(n),null,a),this.pdf.setFontSize(u)}this.ctx._clip_path.length>0&&s.push("Q")}},strokeText:function(t,e,n,r){if(!this._isStrokeTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=this._matrix_rotation(this.ctx._transform),a=57.2958*o;if(this.ctx._clip_path.length>0){var s;s=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage(),s.push("q");var c=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=c}var l;if(l=this.pdf.hotfix&&this.pdf.hotfix.scale_text?this._getTransform()[0]:1,1===l)this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},a);else{var u=this.pdf.internal.getFontSize();this.pdf.setFontSize(u*l),this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},a),this.pdf.setFontSize(u)}this.ctx._clip_path.length>0&&s.push("Q")}},setFont:function(t){this.ctx.font=t;var e=/\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/;if(h=e.exec(t),null!=h){var n=h[1],r=(h[2],h[3]),i=h[4],o=h[5],a=h[6];i="px"===o?Math.floor(parseFloat(i)):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)),this.pdf.setFontSize(i),"bold"===r||"700"===r?this.pdf.setFontStyle("bold"):"italic"===n?this.pdf.setFontStyle("italic"):this.pdf.setFontStyle("normal");var s,c=a,l=c.toLowerCase().split(/\s*,\s*/);s=l.indexOf("arial")!=-1?"Arial":l.indexOf("verdana")!=-1?"Verdana":l.indexOf("helvetica")!=-1?"Helvetica":l.indexOf("sans-serif")!=-1?"sans-serif":l.indexOf("fixed")!=-1?"Fixed":l.indexOf("monospace")!=-1?"Monospace":l.indexOf("terminal")!=-1?"Terminal":l.indexOf("courier")!=-1?"Courier":l.indexOf("times")!=-1?"Times":l.indexOf("cursive")!=-1?"Cursive":l.indexOf("fantasy")!=-1?"Fantasy":(l.indexOf("serif")!=-1,"Serif");var u;u="bold"===r?"bold":"normal",this.pdf.setFont(s,u)}else{var e=/(\d+)(pt|px|em)\s+(\w+)\s*(\w+)?/,h=e.exec(t);if(null!=h){var f=h[1],c=(h[2],h[3]),u=h[4];u||(u="normal"),f="em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(f)),this.pdf.setFontSize(f),this.pdf.setFont(c,u)}}},setTextBaseline:function(t){this.ctx.textBaseline=t},getTextBaseline:function(){return this.ctx.textBaseline},setTextAlign:function(t){this.ctx.textAlign=t},getTextAlign:function(){return this.ctx.textAlign},setLineWidth:function(t){this.ctx.lineWidth=t,this.pdf.setLineWidth(t)},setLineCap:function(t){this.ctx.lineCap=t,this.pdf.setLineCap(t)},setLineJoin:function(t){this.ctx.lineJoin=t,this.pdf.setLineJoin(t)},moveTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]);t=n[0],e=n[1];var r={type:"mt",x:t,y:e};this.path.push(r)},_wrapX:function(t){return this.pageWrapXEnabled?t%this.pageWrapX:t},_wrapY:function(t){return this.pageWrapYEnabled?(this._gotoPage(this._page(t)),(t-this.lastBreak)%this.pageWrapY):t},transform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},setTransform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},_getTransform:function(){return this.ctx._transform},lastBreak:0,pageBreaks:[],_page:function(t){if(this.pageWrapYEnabled){this.lastBreak=0;for(var e=0,n=0,r=0;r<this.pageBreaks.length;r++)if(t>=this.pageBreaks[r]){e++,0===this.lastBreak&&n++;var i=this.pageBreaks[r]-this.lastBreak;this.lastBreak=this.pageBreaks[r];var o=Math.floor(i/this.pageWrapY);n+=o}if(0===this.lastBreak){var o=Math.floor(t/this.pageWrapY)+1;n+=o}return n+e}return this.pdf.internal.getCurrentPageInfo().pageNumber},_gotoPage:function(t){},lineTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]);t=n[0],e=n[1];var r={type:"lt",x:t,y:e};this.path.push(r)},bezierCurveTo:function(t,e,n,r,i,o){t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r),i=this._wrapX(i),o=this._wrapY(o);var a;a=this._matrix_map_point(this.ctx._transform,[i,o]),i=a[0],o=a[1],a=this._matrix_map_point(this.ctx._transform,[t,e]),t=a[0],e=a[1],a=this._matrix_map_point(this.ctx._transform,[n,r]),n=a[0],r=a[1];var s={type:"bct",x1:t,y1:e,x2:n,y2:r,x:i,y:o};this.path.push(s)},quadraticCurveTo:function(t,e,n,r){t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r);var i;i=this._matrix_map_point(this.ctx._transform,[n,r]),n=i[0],r=i[1],i=this._matrix_map_point(this.ctx._transform,[t,e]),t=i[0],e=i[1];var o={type:"qct",x1:t,y1:e,x:n,y:r};this.path.push(o)},arc:function(t,e,n,r,i,o){if(t=this._wrapX(t),e=this._wrapY(e),!this._matrix_is_identity(this.ctx._transform)){var a=this._matrix_map_point(this.ctx._transform,[t,e]);t=a[0],e=a[1];var s=this._matrix_map_point(this.ctx._transform,[0,0]),c=this._matrix_map_point(this.ctx._transform,[0,n]);n=Math.sqrt(Math.pow(c[0]-s[0],2)+Math.pow(c[1]-s[1],2))}var l={type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,anticlockwise:o};this.path.push(l)},drawImage:function(t,e,n,r,i,o,a,s,c){void 0!==o&&(e=o,n=a,r=s,i=c),e=this._wrapX(e),n=this._wrapY(n);var l,u=this._matrix_map_rect(this.ctx._transform,{x:e,y:n,w:r,h:i}),h=(this._matrix_map_rect(this.ctx._transform,{x:o,y:a,w:s,h:c}),/data:image\/(\w+).*/i),f=h.exec(t);l=null!=f?f[1]:"png",this.pdf.addImage(t,l,u.x,u.y,u.w,u.h)},_matrix_multiply:function(t,e){var n=e[0],r=e[1],i=e[2],o=e[3],a=e[4],s=e[5],c=n*t[0]+r*t[2],l=i*t[0]+o*t[2],u=a*t[0]+s*t[2]+t[4];return r=n*t[1]+r*t[3],o=i*t[1]+o*t[3],s=a*t[1]+s*t[3]+t[5],n=c,i=l,a=u,[n,r,i,o,a,s]},_matrix_rotation:function(t){return Math.atan2(t[2],t[0])},_matrix_decompose:function(t){var e=t[0],n=t[1],r=t[2],i=t[3],o=Math.sqrt(e*e+n*n);e/=o,n/=o;var a=e*r+n*i;r-=e*a,i-=n*a;var s=Math.sqrt(r*r+i*i);return r/=s,i/=s,a/=s,e*i<n*r&&(e=-e,n=-n,a=-a,o=-o),{scale:[o,0,0,s,0,0],translate:[1,0,0,1,t[4],t[5]],rotate:[e,n,-n,e,0,0],skew:[1,0,a,1,0,0]}},_matrix_map_point:function(t,e){var n=t[0],r=t[1],i=t[2],o=t[3],a=t[4],s=t[5],c=e[0],l=e[1],u=c*n+l*i+a,h=c*r+l*o+s;return[u,h]},_matrix_map_point_obj:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]);return{x:n[0],y:n[1]}},_matrix_map_rect:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]),r=this._matrix_map_point(t,[e.x+e.w,e.y+e.h]);return{x:n[0],y:n[1],w:r[0]-n[0],h:r[1]-n[1]}},_matrix_is_identity:function(t){return 1==t[0]&&(0==t[1]&&(0==t[2]&&(1==t[3]&&(0==t[4]&&0==t[5]))))},rotate:function(t){var e=[Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,e)},scale:function(t,e){var n=[t,0,0,e,0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},translate:function(t,e){var n=[1,0,0,1,t,e];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},stroke:function(){if(this.ctx._clip_path.length>0){var t;t=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage(),t.push("q");var e=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._stroke(!0),this.ctx._clip_path=this.path,this.path=e,this._stroke(!1),t.push("Q")}else this._stroke(!1)},_stroke:function(t){if(t||!this._isStrokeTransparent()){for(var e=[],n=!1,r=this.path,i=0;i<r.length;i++){var o=r[i];switch(o.type){case"mt":e.push({start:o,deltas:[],abs:[]});break;case"lt":var a=[o.x-r[i-1].x,o.y-r[i-1].y];e[e.length-1].deltas.push(a),e[e.length-1].abs.push(o);break;case"bct":var a=[o.x1-r[i-1].x,o.y1-r[i-1].y,o.x2-r[i-1].x,o.y2-r[i-1].y,o.x-r[i-1].x,o.y-r[i-1].y];e[e.length-1].deltas.push(a);break;case"qct":var s=r[i-1].x+2/3*(o.x1-r[i-1].x),c=r[i-1].y+2/3*(o.y1-r[i-1].y),l=o.x+2/3*(o.x1-o.x),u=o.y+2/3*(o.y1-o.y),h=o.x,f=o.y,a=[s-r[i-1].x,c-r[i-1].y,l-r[i-1].x,u-r[i-1].y,h-r[i-1].x,f-r[i-1].y];e[e.length-1].deltas.push(a);break;case"arc":0==e.length&&e.push({start:{x:0,y:0},deltas:[],abs:[]}),e[e.length-1].arc=!0,e[e.length-1].abs.push(o);break;case"close":n=!0}}for(var i=0;i<e.length;i++){var d;if(d=i==e.length-1?"s":null,e[i].arc)for(var p=e[i].abs,g=0;g<p.length;g++){var m=p[g],w=360*m.startAngle/(2*Math.PI),y=360*m.endAngle/(2*Math.PI),v=m.x,b=m.y;this.internal.arc2(this,v,b,m.radius,w,y,m.anticlockwise,d,t)}else{var v=e[i].start.x,b=e[i].start.y;t?(this.pdf.lines(e[i].deltas,v,b,null,null),this.pdf.clip_fixed()):this.pdf.lines(e[i].deltas,v,b,null,d)}}}},_isFillTransparent:function(){return this.ctx._isFillTransparent||0==this.globalAlpha},_isStrokeTransparent:function(){return this.ctx._isStrokeTransparent||0==this.globalAlpha},fill:function(t){if(this.ctx._clip_path.length>0){var e;e=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage(),e.push("q");var n=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(t,!0),this.ctx._clip_path=this.path,this.path=n,this._fill(t,!1),e.push("Q")}else this._fill(t,!1)},_fill:function(t,e){if(!this._isFillTransparent()){var r,i="function"==typeof this.pdf.internal.newObject2;r=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage();var o=[],a=window.outIntercept;if(i)switch(this.ctx.globalCompositeOperation){case"normal":case"source-over":break;case"destination-in":case"destination-out":var s=this.pdf.internal.newStreamObject(),c=this.pdf.internal.newObject2();c.push("<</Type /ExtGState"),c.push("/SMask <</S /Alpha /G "+s.objId+" 0 R>>"),c.push(">>");var l="MASK"+c.objId;this.pdf.internal.addGraphicsState(l,c.objId);var u="/"+l+" gs";r.splice(0,0,"q"),r.splice(1,0,u),r.push("Q"),window.outIntercept=s;break;default:var h="/"+this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];h&&this.pdf.internal.out(h+" gs")}var f=this.ctx.globalAlpha;if(this.ctx._fillOpacity<1&&(f=this.ctx._fillOpacity),i){var d=this.pdf.internal.newObject2();d.push("<</Type /ExtGState"),d.push("/CA "+f),d.push("/ca "+f),d.push(">>");var l="GS_O_"+d.objId;this.pdf.internal.addGraphicsState(l,d.objId),this.pdf.internal.out("/"+l+" gs")}for(var p=this.path,g=0;g<p.length;g++){var m=p[g];switch(m.type){case"mt":o.push({start:m,deltas:[],abs:[]});break;case"lt":var w=[m.x-p[g-1].x,m.y-p[g-1].y];o[o.length-1].deltas.push(w),o[o.length-1].abs.push(m);break;case"bct":var w=[m.x1-p[g-1].x,m.y1-p[g-1].y,m.x2-p[g-1].x,m.y2-p[g-1].y,m.x-p[g-1].x,m.y-p[g-1].y];o[o.length-1].deltas.push(w);break;case"qct":var y=p[g-1].x+2/3*(m.x1-p[g-1].x),v=p[g-1].y+2/3*(m.y1-p[g-1].y),b=m.x+2/3*(m.x1-m.x),x=m.y+2/3*(m.y1-m.y),k=m.x,_=m.y,w=[y-p[g-1].x,v-p[g-1].y,b-p[g-1].x,x-p[g-1].y,k-p[g-1].x,_-p[g-1].y];o[o.length-1].deltas.push(w);break;case"arc":0===o.length&&o.push({deltas:[],abs:[]}),o[o.length-1].arc=!0,o[o.length-1].abs.push(m);break;case"close":o.push({close:!0})}}for(var g=0;g<o.length;g++){var C;if(g==o.length-1?(C="f","evenodd"===t&&(C+="*")):C=null,o[g].close)this.pdf.internal.out("h"),this.pdf.internal.out("f");else if(o[g].arc){o[g].start&&this.internal.move2(this,o[g].start.x,o[g].start.y);for(var A=o[g].abs,S=0;S<A.length;S++){var q=A[S];if("undefined"!=typeof q.startAngle){var T=360*q.startAngle/(2*Math.PI),P=360*q.endAngle/(2*Math.PI),I=q.x,E=q.y;if(0===S&&this.internal.move2(this,I,E),this.internal.arc2(this,I,E,q.radius,T,P,q.anticlockwise,null,e),S===A.length-1&&o[g].start){var I=o[g].start.x,E=o[g].start.y;this.internal.line2(n,I,E)}}else this.internal.line2(n,q.x,q.y)}}else{var I=o[g].start.x,E=o[g].start.y;e?(this.pdf.lines(o[g].deltas,I,E,null,null),this.pdf.clip_fixed()):this.pdf.lines(o[g].deltas,I,E,null,C)}}window.outIntercept=a}},pushMask:function(){var t="function"==typeof this.pdf.internal.newObject2;if(!t)return void console.log("jsPDF v2 not enabled");var e=this.pdf.internal.newStreamObject(),n=this.pdf.internal.newObject2();n.push("<</Type /ExtGState"),n.push("/SMask <</S /Alpha /G "+e.objId+" 0 R>>"),n.push(">>");var r="MASK"+n.objId;this.pdf.internal.addGraphicsState(r,n.objId);var i="/"+r+" gs";this.pdf.internal.out(i)},clip:function(){if(this.ctx._clip_path.length>0)for(var t=0;t<this.path.length;t++)this.ctx._clip_path.push(this.path[t]);else this.ctx._clip_path=this.path;this.path=[]},measureText:function(t){var e=this.pdf;return{getWidth:function(){var n=e.internal.getFontSize(),r=e.getStringUnitWidth(t)*n/e.internal.scaleFactor;return r*=1.3333},get width(){return this.getWidth(t)}}},_getBaseline:function(t){var e=parseInt(this.pdf.internal.getFontSize()),n=.25*e;switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e;case"hanging":return t+e-n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}}};var n=t.context2d;return Object.defineProperty(n,"fillStyle",{set:function(t){this.setFillStyle(t)},get:function(){return this.ctx.fillStyle}}),Object.defineProperty(n,"strokeStyle",{set:function(t){this.setStrokeStyle(t)},get:function(){return this.ctx.strokeStyle}}),Object.defineProperty(n,"lineWidth",{set:function(t){this.setLineWidth(t)},get:function(){return this.ctx.lineWidth}}),Object.defineProperty(n,"lineCap",{set:function(t){this.setLineCap(t)},get:function(){return this.ctx.lineCap}}),Object.defineProperty(n,"lineJoin",{set:function(t){this.setLineJoin(t)},get:function(){return this.ctx.lineJoin}}),Object.defineProperty(n,"miterLimit",{set:function(t){this.ctx.miterLimit=t},get:function(){return this.ctx.miterLimit}}),Object.defineProperty(n,"textBaseline",{set:function(t){this.setTextBaseline(t)},get:function(){return this.getTextBaseline()}}),Object.defineProperty(n,"textAlign",{set:function(t){this.setTextAlign(t)},get:function(){return this.getTextAlign()}}),Object.defineProperty(n,"font",{set:function(t){this.setFont(t)},get:function(){return this.ctx.font}}),Object.defineProperty(n,"globalCompositeOperation",{set:function(t){this.ctx.globalCompositeOperation=t},get:function(){return this.ctx.globalCompositeOperation}}),Object.defineProperty(n,"globalAlpha",{set:function(t){this.ctx.globalAlpha=t},get:function(){return this.ctx.globalAlpha}}),Object.defineProperty(n,"ignoreClearRect",{set:function(t){this.ctx.ignoreClearRect=t},get:function(){return this.ctx.ignoreClearRect}}),n.internal={},n.internal.rxRgb=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/,n.internal.rxRgba=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/,n.internal.rxTransparent=/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/,n.internal.arc=function(t,e,n,r,i,o,a,s){for(var c=!0,l=this.pdf.internal.scaleFactor,u=this.pdf.internal.pageSize.height,h=this.pdf.internal.f2,f=i*(Math.PI/180),d=o*(Math.PI/180),p=this.createArc(r,f,d,a),g=0;g<p.length;g++){var m=p[g];c&&0===g?this.pdf.internal.out([h((m.x1+e)*l),h((u-(m.y1+n))*l),"m",h((m.x2+e)*l),h((u-(m.y2+n))*l),h((m.x3+e)*l),h((u-(m.y3+n))*l),h((m.x4+e)*l),h((u-(m.y4+n))*l),"c"].join(" ")):this.pdf.internal.out([h((m.x2+e)*l),h((u-(m.y2+n))*l),h((m.x3+e)*l),h((u-(m.y3+n))*l),h((m.x4+e)*l),h((u-(m.y4+n))*l),"c"].join(" ")),t._lastPoint={x:e,y:n}}null!==s&&this.pdf.internal.out(this.pdf.internal.getStyle(s))},n.internal.arc2=function(t,e,n,r,i,o,a,s,c){var l=e,u=n;c?(this.arc(t,l,u,r,i,o,a,null),this.pdf.clip_fixed()):this.arc(t,l,u,r,i,o,a,s)},n.internal.move2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.height,o=this.pdf.internal.f2;this.pdf.internal.out([o(e*r),o((i-n)*r),"m"].join(" ")),t._lastPoint={x:e,y:n}},n.internal.line2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.height,o=this.pdf.internal.f2,a={x:e,y:n};this.pdf.internal.out([o(a.x*r),o((i-a.y)*r),"l"].join(" ")),t._lastPoint=a},n.internal.createArc=function(t,e,n,r){var i=1e-5,o=2*Math.PI,a=Math.PI/2,s=e;for((s<o||s>o)&&(s%=o),s<0&&(s=o+s);e>n;)e-=o;var c=Math.abs(n-e);c<o&&r&&(c=o-c);for(var l=[],u=r?-1:1,h=s;c>i;){var f=u*Math.min(c,a),d=h+f;l.push(this.createSmallArc(t,h,d)),c-=Math.abs(d-h),h=d}return l},n.internal.getCurrentPage=function(){return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber]},n.internal.createSmallArc=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,c=a*a+s*s,l=c+a*i+s*o,u=4/3*(Math.sqrt(2*c*l)-l)/(a*o-s*i),h=a-u*s,f=s+u*a,d=h,p=-f,g=r+e,m=Math.cos(g),w=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:h*m-f*w,y2:h*w+f*m,x3:d*m-p*w,y3:d*w+p*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}},this}(e.API),/** @preserve
	 * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
	 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 Daniel Husar, https://github.com/danielhusar
	 *               2014 Wolfgang Gassler, https://github.com/woolfg
	 *               2014 Steven Spungin, https://github.com/flamenco
	 *
	 * 
	 * ====================================================================
	 */
	function(e){var n,r,i,a,s,c,l,u,h,f,d,p,g,m,w,y,v,b,x,k;n=function(){function t(){}return function(e){return t.prototype=e,new t}}(),f=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,i=!1,a=!1;!i&&n!==r;)e=t[n]=t[n].trimLeft(),e&&(i=!0),n++;for(n=r-1;r&&!a&&n!==-1;)e=t[n]=t[n].trimRight(),e&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},d=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this},p=function(t){var e,n,r;for(e=void 0,r=t.split(","),n=r.shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},g=function(t){t="auto"===t?"0px":t,t.indexOf("em")>-1&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),t.indexOf("pt")>-1&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px");var e,n,r;return n=void 0,e=16,(r=m[t])?r:(r={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[{css_line_height_string:t}],r!==n?m[t]=r/e:(r=parseFloat(t))?m[t]=r/e:(r=t.match(/([\d\.]+)(px)/),3===r.length?m[t]=parseFloat(r[1])/e:m[t]=1))},h=function(t){var e,n,r;return r=function(t){var e;return e=function(t){return document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(t,null):t.currentStyle?t.currentStyle:t.style}(t),function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),e[t]}}(t),e={},n=void 0,e["font-family"]=p(r("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left",n=c[r("font-weight")]||"normal","bold"===n&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=g(r("font-size"))||1,e["line-height"]=g(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&g(r("margin-top"))||0,e["margin-bottom"]=n&&g(r("margin-bottom"))||0,e["padding-top"]=n&&g(r("padding-top"))||0,e["padding-bottom"]=n&&g(r("padding-bottom"))||0,e["margin-left"]=n&&g(r("margin-left"))||0,e["margin-right"]=n&&g(r("margin-right"))||0,e["padding-left"]=n&&g(r("padding-left"))||0,e["padding-right"]=n&&g(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=l[r("cssFloat")]||"none",e.clear=u[r("clear")]||"none",e.color=r("color"),e},w=function(t,e,n){var r,i,o,a,s;if(o=!1,i=void 0,a=void 0,s=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},k=function(t,e){var n,r,i,o,a,s,c,l,u,h;for(n=[],r=[],i=0,h=t.rows[0].cells.length,l=t.clientWidth;i<h;)u=t.rows[0].cells[i],r[i]={name:u.textContent.toLowerCase().replace(/\s+/g,""),prompt:u.textContent.replace(/\r?\n/g,""),width:u.clientWidth/l*e.pdf.internal.pageSize.width},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return c={rows:n,headers:r}};var _={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},C=1;r=function(e,i,o){var a,s,c,l,u,f,d,p,g;for(s=e.childNodes,a=void 0,c=h(e),u="block"===c.display,u&&(i.setBlockBoundary(),i.setBlockStyle(c)),d=19.049976/25.4,l=0,f=s.length;l<f;){if(a=s[l],"object"===("undefined"==typeof a?"undefined":t(a))){if(i.executeWatchFunctions(a),1===a.nodeType&&"HEADER"===a.nodeName){var m=a,v=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=v,r(m,i,o),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===a.nodeType&&"#comment"===a.nodeName)~a.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==a.nodeType||_[a.nodeName])if(3===a.nodeType){var b=a.nodeValue;if(a.nodeValue&&"LI"===a.parentNode.nodeName)if("OL"===a.parentNode.parentNode.nodeName)b=C++ +". "+b;else{var x=c["font-size"],A=(3-.75*x)*i.pdf.internal.scaleFactor,S=.75*x*i.pdf.internal.scaleFactor,q=1.74*x/i.pdf.internal.scaleFactor;g=function(t,e){this.pdf.circle(t+A,e+S,q,"FD")}}16&a.ownerDocument.body.compareDocumentPosition(a)&&i.addText(b,c)}else"string"==typeof a&&i.addText(a,c);else{var T;if("IMG"===a.nodeName){var P=a.getAttribute("src");T=y[i.pdf.sHashCode(P)||P]}if(T){i.pdf.internal.pageSize.height-i.pdf.margins_doc.bottom<i.y+a.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(a));var I=h(a),E=i.x,O=12/i.pdf.internal.scaleFactor,F=(I["margin-left"]+I["padding-left"])*O,R=(I["margin-right"]+I["padding-right"])*O,B=(I["margin-top"]+I["padding-top"])*O,D=(I["margin-bottom"]+I["padding-bottom"])*O;E+=void 0!==I.float&&"right"===I.float?i.settings.width-a.width-R:F,i.pdf.addImage(T,E,i.y+B,a.width,a.height),T=void 0,"right"===I.float||"left"===I.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!_[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===I.float?-a.width-F-R:0,i.y+a.height+B+D,a.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===h(n).clear&&(i.y=t,!0)}.bind(this,i.y+a.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=a.width+F+R,"left"===I.float&&(i.x+=a.width+F+R)):i.y+=a.height+B+D}else if("TABLE"===a.nodeName)p=k(a,i),i.y+=10,i.pdf.table(i.x,i.y,p.rows,p.headers,{autoSize:!1,printHeaders:o.printHeaders,margins:i.pdf.margins_doc,css:h(a)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===a.nodeName||"UL"===a.nodeName)C=1,w(a,i,o)||r(a,i,o),i.y+=10;else if("LI"===a.nodeName){var j=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,w(a,i,o)||r(a,i,o),i.x=j}else"BR"===a.nodeName?(i.y+=c["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",n(c))):w(a,i,o)||r(a,i,o)}}l++}if(o.outY=i.y,u)return i.setBlockBoundary(g)},y={},v=function(t,e,n,r){function i(){e.pdf.internal.events.publish("imagesLoaded"),r(a)}function o(t,n,r){if(t){var o=new Image;a=++l,o.crossOrigin="",o.onerror=o.onload=function(){if(o.complete&&(0===o.src.indexOf("data:image/")&&(o.width=n||o.width||0,o.height=r||o.height||0),o.width+o.height)){var a=e.pdf.sHashCode(t)||t;y[a]=y[a]||o}--l||i()},o.src=t}}for(var a,s=t.getElementsByTagName("img"),c=s.length,l=0;c--;)o(s[c].getAttribute("src"),s[c].width,s[c].height);return l||i()},b=function(t,e,n){var i=t.getElementsByTagName("footer");if(i.length>0){i=i[0];var o=e.pdf.internal.write,a=e.y;e.pdf.internal.write=function(){},r(i,e,n);var s=Math.ceil(e.y-a)+5;e.y=a,e.pdf.internal.write=o,e.pdf.margins_doc.bottom+=s;for(var c=function(t){var o=void 0!==t?t.pageNumber:1,a=e.y;e.y=e.pdf.internal.pageSize.height-e.pdf.margins_doc.bottom,e.pdf.margins_doc.bottom-=s;for(var c=i.getElementsByTagName("span"),l=0;l<c.length;++l)(" "+c[l].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")>-1&&(c[l].innerHTML=o),(" "+c[l].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")>-1&&(c[l].innerHTML="###jsPDFVarTotalPages###");r(i,e,n),e.pdf.margins_doc.bottom+=s,e.y=a},l=i.getElementsByTagName("span"),u=0;u<l.length;++u)(" "+l[u].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")>-1&&e.pdf.internal.events.subscribe("htmlRenderingFinished",e.pdf.putTotalPages.bind(e.pdf,"###jsPDFVarTotalPages###"),!0);e.pdf.internal.events.subscribe("addPage",c,!1),c(),_.FOOTER=1}},x=function(t,e,n,i,o,a){if(!e)return!1;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(e=function(t){var e,n,r,i;return r="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),i="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",n=document.createElement("div"),n.style.cssText=i,n.innerHTML='<iframe style="height:1px;width:1px" name="'+r+'" />',document.body.appendChild(n),e=window.frames[r],e.document.open(),e.document.writeln(t),e.document.close(),e.document.body}(e.replace(/<\/?script[^>]*?>/gi,"")));var s,c=new d(t,n,i,o);return v.call(this,e,c,o.elementHandlers,function(t){b(e,c,o.elementHandlers),r(e,c,o.elementHandlers),c.pdf.internal.events.publish("htmlRenderingFinished"),s=c.dispose(),"function"==typeof a?a(s):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),s||{x:c.x,y:c.y}},d.prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},d.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},d.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(this.watchFunctions.length>0){for(var r=0;r<this.watchFunctions.length;++r)this.watchFunctions[r](t)===!0?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},d.prototype.splitFragmentsIntoLines=function(t,e){var r,i,o,a,s,c,l,u,h,f,d,p,g,m,w;for(i=12,d=this.pdf.internal.scaleFactor,s={},o=void 0,f=void 0,a=void 0,c=void 0,w=void 0,h=void 0,u=void 0,l=void 0,p=[],g=[p],r=0,m=this.settings.width;t.length;)if(c=t.shift(),w=e.shift(),c)if(o=w["font-family"],f=w["font-style"],a=s[o+f],a||(a=this.pdf.internal.getFont(o,f).metadata.Unicode,s[o+f]=a),h={widths:a.widths,kerning:a.kerning,fontSize:w["font-size"]*i,textIndent:r},u=this.pdf.getStringUnitWidth(c,h)*h.fontSize/d,"\u2028"==c)p=[],g.push(p);else if(r+u>m){for(l=this.pdf.splitTextToSize(c,m,h),p.push([l.shift(),w]);l.length;)p=[[l.shift(),w]],g.push(p);r=this.pdf.getStringUnitWidth(p[0][0],h)*h.fontSize/d}else p.push([c,w]),r+=u;if(void 0!==w["text-align"]&&("center"===w["text-align"]||"right"===w["text-align"]||"justify"===w["text-align"]))for(var y=0;y<g.length;++y){var v=this.pdf.getStringUnitWidth(g[y][0][0],h)*h.fontSize/d;y>0&&(g[y][0][1]=n(g[y][0][1]));var b=m-v;if("right"===w["text-align"])g[y][0][1]["margin-left"]=b;else if("center"===w["text-align"])g[y][0][1]["margin-left"]=b/2;else if("justify"===w["text-align"]){var x=g[y][0][0].split(" ").length-1;g[y][0][1]["word-spacing"]=b/x,y===g.length-1&&(g[y][0][1]["word-spacing"]=0)}}return g},d.prototype.RenderTextFragment=function(t,e){var n,r,i;i=0,n=12,this.pdf.internal.pageSize.height-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),e.color,"Td"),i=Math.max(i,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-1*n*i).toFixed(2),"Td")),r=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var o=this.getPdfColor(e.color);o!==this.lastTextColor&&(this.pdf.internal.write(o),this.lastTextColor=o),void 0!==e["word-spacing"]&&e["word-spacing"]>0&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+r.id,(n*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},d.prototype.getPdfColor=function(t){var e,n,r,i,a=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/,s=a.exec(t);if(null!=s?(n=parseInt(s[1]),r=parseInt(s[2]),i=parseInt(s[3])):("#"!=t.charAt(0)&&(t=o.colorNameToHex(t),t||(t="#000000")),n=t.substring(1,3),n=parseInt(n,16),r=t.substring(3,5),r=parseInt(r,16),i=t.substring(5,7),i=parseInt(i,16)),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var c=parseInt(n.substr(1),16);n=c>>16&255,r=c>>8&255,i=255&c}var l=this.f3;return e=0===n&&0===r&&0===i||"undefined"==typeof r?l(n/255)+" g":[l(n/255),l(r/255),l(i/255),"rg"].join(" ")},d.prototype.f3=function(t){return t.toFixed(3)},d.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,c,l,u,h,d,p,g,m;if(i=f(this.paragraph.text),g=this.paragraph.style,e=this.paragraph.blockstyle,p=this.paragraph.priorblockstyle||{},this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},i.join("").trim()){c=this.splitFragmentsIntoLines(i,g),s=void 0,l=void 0,n=12,r=n/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,d=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*r,h=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*r,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,d=((e["margin-top"]||0)+(e["padding-top"]||0))*r),u=this.pdf.internal.write,o=void 0,a=void 0,this.y+=d,u("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var w=0;c.length;){for(s=c.shift(),l=0,o=0,a=s.length;o!==a;)s[o][0].trim()&&(l=Math.max(l,s[o][1]["line-height"],s[o][1]["font-size"]),m=7*s[o][1]["font-size"]),o++;var y=0,v=0;void 0!==s[0][1]["margin-left"]&&s[0][1]["margin-left"]>0&&(v=this.pdf.internal.getCoordinateString(s[0][1]["margin-left"]),y=v-w,w=v);var b=Math.max(e["margin-left"]||0,0)*r;for(u(y+b,(-1*n*l).toFixed(2),"Td"),o=0,a=s.length;o!==a;)s[o][0]&&this.RenderTextFragment(s[o][0],s[o][1]),o++;if(this.y+=l*r,this.executeWatchFunctions(s[0][1])&&c.length>0){var x=[],k=[];c.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(x.push(t[e][0]+" "),k.push(t[e][1])),++e}),c=this.splitFragmentsIntoLines(f(x),k),u("ET","Q"),u("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-m/2),u("ET","Q"),this.y+=h}},d.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},d.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},d.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},c={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},l={none:"none",right:"right",left:"left"},u={none:"none",both:"both"},m={normal:1},e.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),x(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(e.API),/** ==================================================================== 
	 * jsPDF JavaScript plugin
	 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	 * 
	 * 
	 * ====================================================================
	 */
	function(t){var e,n,r;t.addJS=function(t){return r=t,this.internal.events.subscribe("postPutResources",function(t){e=this.internal.newObject(),this.internal.write("<< /Names [(EmbeddedJS) "+(e+1)+" 0 R] >>","endobj"),n=this.internal.newObject(),this.internal.write("<< /S /JavaScript /JS (",r,") >>","endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==e&&void 0!==n&&this.internal.write("/Names <</JavaScript "+e+" 0 R>>")}),this}}(e.API),/**
	 * jsPDF Outline PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	function(t){return t.events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(this.outline.root.children.length>0)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a)}t.internal.write(i)}if(this.outline.createNamedDestinations){for(var s=this.internal.pages.length,c=[],r=0;r<s;r++){var l=t.internal.newObject();c.push(l);var u=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+u.objId+" 0 R /XYZ null null null]>> endobj")}var h=t.internal.newObject();t.internal.write("<< /Names [ ");for(var r=0;r<c.length;r++)t.internal.write("(page_"+(r+1)+")"+c[r]+" 0 R");t.internal.write(" ] >>","endobj");t.internal.newObject();t.internal.write("<< /Dests "+h+" 0 R"),t.internal.write(">>","endobj")}}]),t.events.push(["putCatalog",function(){var t=this;t.outline.root.children.length>0&&(t.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&t.internal.write("/Names "+namesOid+" 0 R"))}]),t.events.push(["initialized",function(){var t=this;t.outline={createNamedDestinations:!1,root:{children:[]}};t.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},t.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=t,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},t.outline.genIds_r=function(e){e.id=t.internal.newObjectDeferred();for(var n=0;n<e.children.length;n++)this.genIds_r(e.children[n])},t.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),t.children.length>0&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},t.outline.renderItems=function(e){for(var n=0;n<e.children.length;n++){var r=e.children[n];this.objStart(r),this.line("/Title "+this.makeString(r.title)),this.line("/Parent "+this.makeRef(e)),n>0&&this.line("/Prev "+this.makeRef(e.children[n-1])),n<e.children.length-1&&this.line("/Next "+this.makeRef(e.children[n+1])),r.children.length>0&&(this.line("/First "+this.makeRef(r.children[0])),this.line("/Last "+this.makeRef(r.children[r.children.length-1])));var i=this.count=this.count_r({count:0},r);if(i>0&&this.line("/Count "+i),r.options&&r.options.pageNumber){var o=t.internal.getPageInfo(r.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+this.ctx.pdf.internal.pageSize.height+" 0]")}this.objEnd()}for(var n=0;n<e.children.length;n++){var r=e.children[n];this.renderItems(r)}},t.outline.line=function(t){this.ctx.val+=t+"\r\n"},t.outline.makeRef=function(t){return t.id+" 0 R"},t.outline.makeString=function(e){return"("+t.internal.pdfEscape(e)+")"},t.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},t.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},t.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),this}(e.API),/**@preserve
	 *  ====================================================================
	 * jsPDF PNG PlugIn
	 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
	 *
	 * 
	 * ====================================================================
	 */
	function(t){var e=function(){return"function"!=typeof PNG||"function"!=typeof c},n=function(e){return e!==t.image_compression.NONE&&r()},r=function(){var t="function"==typeof a;if(!t)throw new Error("requires deflate.js for compression");return t},i=function(e,n,r,i){var c=5,u=f;switch(i){case t.image_compression.FAST:c=3,u=h;break;case t.image_compression.MEDIUM:c=6,u=d;break;case t.image_compression.SLOW:c=9,u=p}e=l(e,n,r,u);var g=new Uint8Array(o(c)),m=s(e),w=new a(c),y=w.append(e),v=w.flush(),b=g.length+y.length+v.length,x=new Uint8Array(b+4);return x.set(g),x.set(y,g.length),x.set(v,g.length+y.length),x[b++]=m>>>24&255,x[b++]=m>>>16&255,x[b++]=m>>>8&255,x[b++]=255&m,t.arrayBufferToBinaryString(x)},o=function(t,e){var n=8,r=Math.LOG2E*Math.log(32768)-8,i=r<<4|n,o=i<<8,a=Math.min(3,(e-1&255)>>1);return o|=a<<6,o|=0,o+=31-o%31,[i,255&o&255]},s=function(t,e){for(var n,r=1,i=65535&r,o=r>>>16&65535,a=t.length,s=0;a>0;){n=a>e?e:a,a-=n;do i+=t[s++],o+=i;while(--n);i%=65521,o%=65521}return(o<<16|i)>>>0},l=function(t,e,n,r){for(var i,o,a,s=t.length/e,c=new Uint8Array(t.length+s),l=m(),u=0;u<s;u++){if(a=u*e,i=t.subarray(a,a+e),r)c.set(r(i,n,o),a+u);else{for(var h=0,f=l.length,d=[];h<f;h++)d[h]=l[h](i,n,o);var p=w(d.concat());c.set(d[p],a+u)}o=i}return c},u=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},h=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},f=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},d=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},p=function(t,e,n){var r,i,o,a,s=[],c=0,l=t.length;for(s[0]=4;c<l;c++)r=t[c-e]||0,i=n&&n[c]||0,o=n&&n[c-e]||0,a=g(r,i,o),s[c+1]=t[c]-a+256&255;return s},g=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},m=function(){return[u,h,f,d,p]},w=function(t){for(var e,n,r,i=0,o=t.length;i<o;)e=y(t[i].slice(1)),(e<n||!n)&&(n=e,r=i),i++;return r},y=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},v=function(e){var n;switch(e){case t.image_compression.FAST:n=11;break;case t.image_compression.MEDIUM:n=13;break;case t.image_compression.SLOW:n=14;break;default:n=12}return n};t.processPNG=function(t,r,o,a,s){var c,l,u,h,f,d,p=this.color_spaces.DEVICE_RGB,g=this.decode.FLATE_DECODE,m=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if(e())throw new Error("PNG support requires png.js and zlib.js");if(c=new PNG(t),t=c.imgData,m=c.bits,p=c.colorSpace,h=c.colors,[4,6].indexOf(c.colorType)!==-1){if(8===c.bits)for(var w,y,b=32==c.pixelBitlength?new Uint32Array(c.decodePixels().buffer):16==c.pixelBitlength?new Uint16Array(c.decodePixels().buffer):new Uint8Array(c.decodePixels().buffer),x=b.length,k=new Uint8Array(x*c.colors),_=new Uint8Array(x),C=c.pixelBitlength-c.bits,A=0,S=0;A<x;A++){for(w=b[A],y=0;y<C;)k[S++]=w>>>y&255,y+=c.bits;_[A]=w>>>y&255}if(16===c.bits){for(var w,b=new Uint32Array(c.decodePixels().buffer),x=b.length,k=new Uint8Array(x*(32/c.pixelBitlength)*c.colors),_=new Uint8Array(x*(32/c.pixelBitlength)),q=c.colors>1,A=0,S=0,T=0;A<x;)w=b[A++],k[S++]=w>>>0&255,q&&(k[S++]=w>>>16&255,w=b[A++],k[S++]=w>>>0&255),_[T++]=w>>>16&255;m=8}n(a)?(t=i(k,c.width*c.colors,c.colors,a),d=i(_,c.width,1,a)):(t=k,d=_,g=null)}if(3===c.colorType&&(p=this.color_spaces.INDEXED,f=c.palette,c.transparency.indexed)){for(var P=c.transparency.indexed,I=0,A=0,x=P.length;A<x;++A)I+=P[A];if(I/=255,I===x-1&&P.indexOf(0)!==-1)u=[P.indexOf(0)];else if(I!==x){for(var b=c.decodePixels(),_=new Uint8Array(b.length),A=0,x=b.length;A<x;A++)_[A]=P[b[A]];d=i(_,c.width,1)}}var E=v(a);return l=g===this.decode.FLATE_DECODE?"/Predictor "+E+" /Colors "+h+" /BitsPerComponent "+m+" /Columns "+c.width:"/Colors "+h+" /BitsPerComponent "+m+" /Columns "+c.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(d&&this.isArrayBuffer(d)||this.isArrayBufferView(d))&&(d=this.arrayBufferToBinaryString(d)),this.createImageInfo(t,c.width,c.height,p,m,g,r,o,l,u,f,d,E)}throw new Error("Unsupported PNG image data, try using JPEG instead.")}}(e.API),function(t){t.autoPrint=function(){var t;return this.internal.events.subscribe("postPutResources",function(){t=this.internal.newObject(),this.internal.write("<< /S/Named /Type/Action /N/Print >>","endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.write("/OpenAction "+t+" 0 R")}),this}}(e.API),/** @preserve
	 * jsPDF split_text_to_size plugin - MIT license.
	 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	 *               2014 Diego Casorran, https://github.com/diegocr
	 */
	function(t){var e=t.getCharWidthsArray=function(t,e){e||(e={});var n,r,i,o=e.widths?e.widths:this.internal.getFont().metadata.Unicode.widths,a=o.fof?o.fof:1,s=e.kerning?e.kerning:this.internal.getFont().metadata.Unicode.kerning,c=s.fof?s.fof:1,l=0,u=o[0]||a,h=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),h.push((o[i]||u)/a+(s[i]&&s[i][l]||0)/c),l=i;return h},n=function(t){for(var e=t.length,n=0;e;)e--,n+=t[e];return n},r=t.getStringUnitWidth=function(t,r){return n(e.call(this,t,r))},i=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var c=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(c,o)),s=0,c=o),s+=e[o],o++;return c!==o&&i.push(t.slice(c,o)),i},o=function(t,o,a){a||(a={});var s,c,l,u,h,f,d=[],p=[d],g=a.textIndent||0,m=0,w=0,y=t.split(" "),v=e(" ",a)[0];if(f=a.lineIndent===-1?y[0].length+2:a.lineIndent||0){var b=Array(f).join(" "),x=[];y.map(function(t){t=t.split(/\s*\n/),t.length>1?x=x.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):x.push(t[0])}),y=x,f=r(b,a)}for(l=0,u=y.length;l<u;l++){var k=0;if(s=y[l],f&&"\n"==s[0]&&(s=s.substr(1),k=1),c=e(s,a),w=n(c),g+m+w>o||k){if(w>o){for(h=i(s,c,o-(g+m),o),d.push(h.shift()),d=[h.pop()];h.length;)p.push([h.shift()]);w=n(c.slice(s.length-d[0].length))}else d=[s];p.push(d),g=w+f,m=v}else d.push(s),g+=m+w,m=v}if(f)var _=function(t,e){return(e?b:"")+t.join(" ")};else var _=function(t){return t.join(" ")};return p.map(_)};t.splitTextToSize=function(t,e,n){n||(n={});var r,i=n.fontSize||this.internal.getFontSize(),a=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle),i="Unicode";return r.metadata[i]?{widths:r.metadata[i].widths||e,kerning:r.metadata[i].kerning||n}:{widths:e,kerning:n}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var s=1*this.internal.scaleFactor*e/i;a.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,a.lineIndent=n.lineIndent;var c,l,u=[];for(c=0,l=r.length;c<l;c++)u=u.concat(o(r[c],s,a));return u}}(e.API),/** @preserve 
	jsPDF standard_fonts_metrics plugin
	Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	MIT license.
	*/
	function(t){var e=function(t){for(var e="0123456789abcdef",n="klmnopqrstuvwxyz",r={},i=0;i<n.length;i++)r[n[i]]=e[i];var o,a,s,c,l,u={},h=1,f=u,d=[],p="",g="",m=t.length-1;for(i=1;i!=m;)l=t[i],i+=1,"'"==l?a?(c=a.join(""),a=o):a=[]:a?a.push(l):"{"==l?(d.push([f,c]),f={},c=o):"}"==l?(s=d.pop(),s[0][s[1]]=f,c=o,f=s[0]):"-"==l?h=-1:c===o?r.hasOwnProperty(l)?(p+=r[l],c=parseInt(p,16)*h,h=1,p=""):p+=l:r.hasOwnProperty(l)?(g+=r[l],f[c]=parseInt(g,16)*h,h=1,c=o,g=""):g+=l;return u},n={codePages:["WinAnsiEncoding"],WinAnsiEncoding:e("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},r={Unicode:{Courier:n,"Courier-Bold":n,"Courier-BoldOblique":n,"Courier-Oblique":n,Helvetica:n,"Helvetica-Bold":n,"Helvetica-BoldOblique":n,"Helvetica-Oblique":n,"Times-Roman":n,"Times-Bold":n,"Times-BoldItalic":n,"Times-Italic":n}},i={Unicode:{"Courier-Oblique":e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":e("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":e("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":e("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Helvetica:e("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":e("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),"Courier-Bold":e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":e("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":e("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":e("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}};t.events.push(["addFont",function(t){var e,n,o,a="Unicode";e=i[a][t.PostScriptName],e&&(n=t.metadata[a]?t.metadata[a]:t.metadata[a]={},n.widths=e.widths,n.kerning=e.kerning),o=r[a][t.PostScriptName],o&&(n=t.metadata[a]?t.metadata[a]:t.metadata[a]={},n.encoding=o,o.codePages&&o.codePages.length&&(t.encoding=o.codePages[0]))}])}(e.API),/** @preserve
	jsPDF SVG plugin
	Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	*/
	function(t){t.addSVG=function(t,e,n,r,i){function o(t,e){var n=e.createElement("style");n.type="text/css",n.styleSheet?n.styleSheet.cssText=t:n.appendChild(e.createTextNode(t)),e.getElementsByTagName("head")[0].appendChild(n)}function a(t){var e="childframe",n=t.createElement("iframe");return o(".jsPDF_sillysvg_iframe {display:none;position:absolute;}",t),n.name=e,n.setAttribute("width",0),n.setAttribute("height",0),n.setAttribute("frameborder","0"),n.setAttribute("scrolling","no"),n.setAttribute("seamless","seamless"),n.setAttribute("class","jsPDF_sillysvg_iframe"),t.body.appendChild(n),n}function s(t,e){var n=(e.contentWindow||e.contentDocument).document;return n.write(t),n.close(),n.getElementsByTagName("svg")[0]}function c(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var l;if(e===l||n===l)throw new Error("addSVG needs values for 'x' and 'y'");var u=a(document),h=s(t,u),f=[1,1],d=parseFloat(h.getAttribute("width")),p=parseFloat(h.getAttribute("height"));d&&p&&(r&&i?f=[r/d,i/p]:r?f=[r/d,r/d]:i&&(f=[i/p,i/p]));var g,m,w,y,v=h.childNodes;for(g=0,m=v.length;g<m;g++)w=v[g],w.tagName&&"PATH"===w.tagName.toUpperCase()&&(y=c(w.getAttribute("d").split(" ")),y[0]=y[0]*f[0]+e,y[1]=y[1]*f[1]+n,this.lines.call(this,y[2],y[0],y[1],f));return this}}(e.API),/** ==================================================================== 
	 * jsPDF total_pages plugin
	 * Copyright (c) 2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	 * 
	 * 
	 * ====================================================================
	 */
	function(t){t.putTotalPages=function(t){for(var e=new RegExp(t,"g"),n=1;n<=this.internal.getNumberOfPages();n++)for(var r=0;r<this.internal.pages[n].length;r++)this.internal.pages[n][r]=this.internal.pages[n][r].replace(e,this.internal.getNumberOfPages());return this}}(e.API),/** ==================================================================== 
	 * jsPDF XMP metadata plugin
	 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
	 * 
	 * 
	 * ====================================================================
	 */
	function(t){var e="",n="",r="";t.addMetadata=function(t,i){return n=i||"http://jspdf.default.namespaceuri/",e=t,this.internal.events.subscribe("postPutResources",function(){if(e){var t='<x:xmpmeta xmlns:x="adobe:ns:meta/">',i='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+n+'"><jspdf:metadata>',o="</jspdf:metadata></rdf:Description></rdf:RDF>",a="</x:xmpmeta>",s=unescape(encodeURIComponent(t)),c=unescape(encodeURIComponent(i)),l=unescape(encodeURIComponent(e)),u=unescape(encodeURIComponent(o)),h=unescape(encodeURIComponent(a)),f=c.length+l.length+u.length+s.length+h.length;r=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+f+" >>"),this.internal.write("stream"),this.internal.write(s+c+l+u+h),this.internal.write("endstream"),this.internal.write("endobj")}else r=""}),this.internal.events.subscribe("putCatalog",function(){r&&this.internal.write("/Metadata "+r+" 0 R")}),this}}(e.API),function(t){if(t.URL=t.URL||t.webkitURL,t.Blob&&t.URL)try{return void new Blob}catch(t){}var e=t.BlobBuilder||t.WebKitBlobBuilder||t.MozBlobBuilder||function(t){var e=function(t){return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1]},n=function(){this.data=[]},r=function(t,e,n){this.data=t,this.size=t.length,this.type=e,this.encoding=n},i=n.prototype,o=r.prototype,a=t.FileReaderSync,s=function(t){this.code=this[this.name=t]},c="NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "),l=c.length,u=t.URL||t.webkitURL||t,h=u.createObjectURL,f=u.revokeObjectURL,d=u,p=t.btoa,g=t.atob,m=t.ArrayBuffer,w=t.Uint8Array,y=/^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;for(r.fake=o.fake=!0;l--;)s.prototype[c[l]]=l+1;return u.createObjectURL||(d=t.URL=function(t){var e,n=document.createElementNS("http://www.w3.org/1999/xhtml","a");return n.href=t,"origin"in n||("data:"===n.protocol.toLowerCase()?n.origin=null:(e=t.match(y),n.origin=e&&e[1])),n}),d.createObjectURL=function(t){var e,n=t.type;return null===n&&(n="application/octet-stream"),t instanceof r?(e="data:"+n,"base64"===t.encoding?e+";base64,"+t.data:"URI"===t.encoding?e+","+decodeURIComponent(t.data):p?e+";base64,"+p(t.data):e+","+encodeURIComponent(t.data)):h?h.call(u,t):void 0},d.revokeObjectURL=function(t){"data:"!==t.substring(0,5)&&f&&f.call(u,t)},i.append=function(t){var n=this.data;if(w&&(t instanceof m||t instanceof w)){for(var i="",o=new w(t),c=0,l=o.length;c<l;c++)i+=String.fromCharCode(o[c]);n.push(i)}else if("Blob"===e(t)||"File"===e(t)){if(!a)throw new s("NOT_READABLE_ERR");var u=new a;n.push(u.readAsBinaryString(t))}else t instanceof r?"base64"===t.encoding&&g?n.push(g(t.data)):"URI"===t.encoding?n.push(decodeURIComponent(t.data)):"raw"===t.encoding&&n.push(t.data):("string"!=typeof t&&(t+=""),n.push(unescape(encodeURIComponent(t))))},i.getBlob=function(t){return arguments.length||(t=null),new r(this.data.join(""),t,"raw")},i.toString=function(){return"[object BlobBuilder]"},o.slice=function(t,e,n){var i=arguments.length;return i<3&&(n=null),new r(this.data.slice(t,i>1?e:this.data.length),n,this.encoding)},o.toString=function(){return"[object Blob]"},o.close=function(){this.size=0,delete this.data},n}(t);t.Blob=function(t,n){var r=n?n.type||"":"",i=new e;if(t)for(var o=0,a=t.length;o<a;o++)Uint8Array&&t[o]instanceof Uint8Array?i.append(t[o].buffer):i.append(t[o]);var s=i.getBlob(r);return!s.slice&&s.webkitSlice&&(s.slice=s.webkitSlice),s};var n=Object.getPrototypeOf||function(t){return t.__proto__};t.Blob.prototype=n(new t.Blob)}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||(void 0).content||void 0);var i=i||function(t){if("undefined"==typeof navigator||!/MSIE [1-9]\./.test(navigator.userAgent)){var e=t.document,n=function(){return t.URL||t.webkitURL||t},r=e.createElementNS("http://www.w3.org/1999/xhtml","a"),i="download"in r,o=function(t){var e=new MouseEvent("click");t.dispatchEvent(e)},a=/Version\/[\d\.]+.*Safari/.test(navigator.userAgent),s=t.webkitRequestFileSystem,c=t.requestFileSystem||s||t.mozRequestFileSystem,l=function(e){(t.setImmediate||t.setTimeout)(function(){throw e},0)},u="application/octet-stream",h=0,f=500,d=function(e){var r=function(){"string"==typeof e?n().revokeObjectURL(e):e.remove()};t.chrome?r():setTimeout(r,f)},p=function(t,e,n){e=[].concat(e);for(var r=e.length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){l(t)}}},g=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob(["\ufeff",t],{type:t.type}):t},m=function(e,l,f){f||(e=g(e));var m,w,y,v=this,b=e.type,x=!1,k=function(){p(v,"writestart progress write writeend".split(" "))},_=function(){if(w&&a&&"undefined"!=typeof FileReader){var r=new FileReader;return r.onloadend=function(){var t=r.result;w.location.href="data:attachment/file"+t.slice(t.search(/[,;]/)),v.readyState=v.DONE,k()},r.readAsDataURL(e),void(v.readyState=v.INIT)}if(!x&&m||(m=n().createObjectURL(e)),w)w.location.href=m;else{var i=t.open(m,"_blank");void 0==i&&a&&(t.location.href=m)}v.readyState=v.DONE,k(),d(m)},C=function(t){return function(){if(v.readyState!==v.DONE)return t.apply(this,arguments)}},A={create:!0,exclusive:!1};return v.readyState=v.INIT,l||(l="download"),i?(m=n().createObjectURL(e),void setTimeout(function(){r.href=m,r.download=l,o(r),k(),d(m),v.readyState=v.DONE})):(t.chrome&&b&&b!==u&&(y=e.slice||e.webkitSlice,e=y.call(e,0,e.size,u),x=!0),s&&"download"!==l&&(l+=".download"),(b===u||s)&&(w=t),c?(h+=e.size,void c(t.TEMPORARY,h,C(function(t){t.root.getDirectory("saved",A,C(function(t){var n=function(){t.getFile(l,A,C(function(t){t.createWriter(C(function(n){n.onwriteend=function(e){w.location.href=t.toURL(),v.readyState=v.DONE,p(v,"writeend",e),d(t)},n.onerror=function(){var t=n.error;t.code!==t.ABORT_ERR&&_()},"writestart progress write abort".split(" ").forEach(function(t){n["on"+t]=v["on"+t]}),n.write(e),v.abort=function(){n.abort(),v.readyState=v.DONE},v.readyState=v.WRITING}),_)}),_)};t.getFile(l,{create:!1},C(function(t){t.remove(),n()}),C(function(t){t.code===t.NOT_FOUND_ERR?n():_()}))}),_)}),_)):void _())},w=m.prototype,y=function(t,e,n){return new m(t,e,n)};return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return n||(t=g(t)),navigator.msSaveOrOpenBlob(t,e||"download")}:(w.abort=function(){var t=this;t.readyState=t.DONE,p(t,"abort")},w.readyState=w.INIT=0,w.WRITING=1,w.DONE=2,w.error=w.onwritestart=w.onprogress=w.onwrite=w.onabort=w.onerror=w.onwriteend=null,y)}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||(void 0).content);"undefined"!=typeof module&&module.exports?module.exports.saveAs=i:"undefined"!="function"&&null!==__webpack_require__(172)&&null!=__webpack_require__(433)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return i}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)),/*
	 * Copyright (c) 2012 chick307 <chick307@gmail.com>
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	void function(t,e){ true?module.exports=e():"function"==typeof define?define(e):t.adler32cs=e()}(e,function(){var t="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,e=null,n=function(){if(!t)return function(){return!1};try{var n={};"function"==typeof n.Buffer&&(e=n.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==e&&t instanceof e}}(),r=function(){return null!==e?function(t){return new e(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))}}(),i=65521,o=function(t,e){for(var n=65535&t,r=t>>>16,o=0,a=e.length;o<a;o++)n=(n+(255&e.charCodeAt(o)))%i,r=(r+n)%i;return(r<<16|n)>>>0},a=function(t,e){for(var n=65535&t,r=t>>>16,o=0,a=e.length;o<a;o++)n=(n+e[o])%i,r=(r+n)%i;return(r<<16|n)>>>0},s={},c=s.Adler32=function(){var e=function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0},i=e.prototype={};return i.constructor=e,e.from=function(t){return t.prototype=i,t}(function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=o(1,t.toString())}),e.fromUtf8=function(t){return t.prototype=i,t}(function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var n=r(t.toString());this.checksum=o(1,n)}),t&&(e.fromBuffer=function(t){return t.prototype=i,t}(function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(!n(t))throw new Error("First argument needs to be ArrayBuffer.");var r=new Uint8Array(t);return this.checksum=a(1,r)})),i.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=o(this.checksum,t)},i.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=r(t.toString());return this.checksum=o(this.checksum,e)},t&&(i.updateBuffer=function(t){if(!n(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=a(this.checksum,e)}),i.clone=function(){return new c(this.checksum)},e}();return s.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return o(1,t.toString())},s.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=r(t.toString());return o(1,e)},t&&(s.fromBuffer=function(t){if(!n(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return a(1,e)}),s});/**
	 * CssColors
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	var o={};o._colorsTable={aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",black:"#000000",blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgreen:"#006400",darkkhaki:"#bdb76b",darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",deepskyblue:"#00bfff",dimgray:"#696969",dodgerblue:"#1e90ff",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",fuchsia:"#ff00ff",gainsboro:"#dcdcdc",ghostwhite:"#f8f8ff",gold:"#ffd700",goldenrod:"#daa520",gray:"#808080",green:"#008000",greenyellow:"#adff2f",honeydew:"#f0fff0",hotpink:"#ff69b4","indianred ":"#cd5c5c",indigo:"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgrey:"#d3d3d3",lightgreen:"#90ee90",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",lightseagreen:"#20b2aa",lightskyblue:"#87cefa",lightslategray:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",mediumorchid:"#ba55d3",mediumpurple:"#9370d8",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",moccasin:"#ffe4b5",navajowhite:"#ffdead",navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#d87093",papayawhip:"#ffefd5",peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",red:"#ff0000",rosybrown:"#bc8f8f",royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",seagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",wheat:"#f5deb3",white:"#ffffff",whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"},o.colorNameToHex=function(t){return t=t.toLowerCase(),"undefined"!=typeof this._colorsTable[t]&&this._colorsTable[t]};/*
	 Deflate.js - https://github.com/gildas-lormeau/zip.js
	 Copyright (c) 2013 Gildas Lormeau. All rights reserved.
	
	 Redistribution and use in source and binary forms, with or without
	 modification, are permitted provided that the following conditions are met:
	
	 1. Redistributions of source code must retain the above copyright notice,
	 this list of conditions and the following disclaimer.
	
	 2. Redistributions in binary form must reproduce the above copyright 
	 notice, this list of conditions and the following disclaimer in 
	 the documentation and/or other materials provided with the distribution.
	
	 3. The names of the authors may not be used to endorse or promote products
	 derived from this software without specific prior written permission.
	
	 THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
	 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
	 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
	 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
	 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
	 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	var a=function(t){function e(){function t(t){var e,n,i,o,a,c,l=r.dyn_tree,u=r.stat_desc.static_tree,h=r.stat_desc.extra_bits,f=r.stat_desc.extra_base,p=r.stat_desc.max_length,g=0;for(o=0;o<=s;o++)t.bl_count[o]=0;for(l[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<d;e++)n=t.heap[e],o=l[2*l[2*n+1]+1]+1,o>p&&(o=p,g++),l[2*n+1]=o,n>r.max_code||(t.bl_count[o]++,a=0,n>=f&&(a=h[n-f]),c=l[2*n],t.opt_len+=c*(o+a),u&&(t.static_len+=c*(u[2*n+1]+a)));if(0!==g){do{for(o=p-1;0===t.bl_count[o];)o--;t.bl_count[o]--,t.bl_count[o+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(o=p;0!==o;o--)for(n=t.bl_count[o];0!==n;)i=t.heap[--e],i>r.max_code||(l[2*i+1]!=o&&(t.opt_len+=(o-l[2*i+1])*l[2*i],l[2*i+1]=o),n--)}}function e(t,e){var n=0;do n|=1&t,t>>>=1,n<<=1;while(--e>0);return n>>>1}function n(t,n,r){var i,o,a,c=[],l=0;for(i=1;i<=s;i++)c[i]=l=l+r[i-1]<<1;for(o=0;o<=n;o++)a=t[2*o+1],0!==a&&(t[2*o]=e(c[a]++,a))}var r=this;r.build_tree=function(e){var i,o,a,s=r.dyn_tree,c=r.stat_desc.static_tree,l=r.stat_desc.elems,u=-1;for(e.heap_len=0,e.heap_max=d,i=0;i<l;i++)0!==s[2*i]?(e.heap[++e.heap_len]=u=i,e.depth[i]=0):s[2*i+1]=0;for(;e.heap_len<2;)a=e.heap[++e.heap_len]=u<2?++u:0,s[2*a]=1,e.depth[a]=0,e.opt_len--,c&&(e.static_len-=c[2*a+1]);for(r.max_code=u,i=Math.floor(e.heap_len/2);i>=1;i--)e.pqdownheap(s,i);a=l;do i=e.heap[1],e.heap[1]=e.heap[e.heap_len--],e.pqdownheap(s,1),o=e.heap[1],e.heap[--e.heap_max]=i,e.heap[--e.heap_max]=o,s[2*a]=s[2*i]+s[2*o],e.depth[a]=Math.max(e.depth[i],e.depth[o])+1,s[2*i+1]=s[2*o+1]=a,e.heap[1]=a++,e.pqdownheap(s,1);while(e.heap_len>=2);e.heap[--e.heap_max]=e.heap[1],t(e),n(s,r.max_code,e.bl_count)}}function n(t,e,n,r,i){var o=this;o.static_tree=t,o.extra_bits=e,o.extra_base=n,o.elems=r,o.max_length=i}function r(t,e,n,r,i){var o=this;o.good_length=t,o.max_lazy=e,o.nice_length=n,o.max_chain=r,o.func=i}function i(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function o(){function t(){var t;for(It=2*St,Ot[Rt-1]=0,t=0;t<Rt-1;t++)Ot[t]=0;Yt=L[Gt].max_lazy,Qt=L[Gt].good_length,Kt=L[Gt].nice_length,Vt=L[Gt].max_chain,Ut=0,zt=0,Wt=0,Nt=Xt=tt-1,Mt=0,Ft=0}function r(){var t;for(t=0;t<f;t++)$t[2*t]=0;for(t=0;t<c;t++)Zt[2*t]=0;for(t=0;t<l;t++)te[2*t]=0;$t[2*p]=1,ee.opt_len=ee.static_len=0,se=le=0}function o(){ne.dyn_tree=$t,ne.stat_desc=n.static_l_desc,re.dyn_tree=Zt,re.stat_desc=n.static_d_desc,ie.dyn_tree=te,ie.stat_desc=n.static_bl_desc,he=0,fe=0,ue=8,r()}function a(t,e){var n,r,i=-1,o=t[1],a=0,s=7,c=4;for(0===o&&(s=138,c=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<c?te[2*r]+=a:0!==r?(r!=i&&te[2*r]++,te[2*m]++):a<=10?te[2*w]++:te[2*y]++,a=0,i=r,0===o?(s=138,c=3):r==o?(s=6,c=3):(s=7,c=4))}function s(){var t;for(a($t,ne.max_code),a(Zt,re.max_code),ie.build_tree(ee),t=l-1;t>=3&&0===te[2*e.bl_order[t]+1];t--);return ee.opt_len+=3*(t+1)+5+5+4,t}function u(t){ee.pending_buf[ee.pending++]=t}function d(t){u(255&t),u(t>>>8&255)}function g(t){u(t>>8&255),u(255&t&255)}function R(t,e){var n,r=e;fe>v-r?(n=t,he|=n<<fe&65535,d(he),he=n>>>v-fe,fe+=r-v):(he|=t<<fe&65535,fe+=r)}function rt(t,e){var n=2*t;R(65535&e[n],65535&e[n+1])}function it(t,e){var n,r,i=-1,o=t[1],a=0,s=7,c=4;for(0===o&&(s=138,c=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<c){do rt(r,te);while(0!==--a)}else 0!==r?(r!=i&&(rt(r,te),a--),rt(m,te),R(a-3,2)):a<=10?(rt(w,te),R(a-3,3)):(rt(y,te),R(a-11,7));a=0,i=r,0===o?(s=138,c=3):r==o?(s=6,c=3):(s=7,c=4)}}function ot(t,n,r){var i;for(R(t-257,5),R(n-1,5),R(r-4,4),i=0;i<r;i++)R(te[2*e.bl_order[i]+1],3);it($t,t-1),it(Zt,n-1)}function at(){16==fe?(d(he),he=0,fe=0):fe>=8&&(u(255&he),he>>>=8,fe-=8)}function st(){R($<<1,3),rt(p,n.static_ltree),at(),1+ue+10-fe<9&&(R($<<1,3),rt(p,n.static_ltree),at()),ue=7}function ct(t,n){var r,i,o;if(ee.pending_buf[ce+2*se]=t>>>8&255,ee.pending_buf[ce+2*se+1]=255&t,ee.pending_buf[oe+se]=255&n,se++,0===t?$t[2*n]++:(le++,t--,$t[2*(e._length_code[n]+h+1)]++,Zt[2*e.d_code(t)]++),0===(8191&se)&&Gt>2){for(r=8*se,i=Ut-zt,o=0;o<c;o++)r+=Zt[2*o]*(5+e.extra_dbits[o]);if(r>>>=3,le<Math.floor(se/2)&&r<Math.floor(i/2))return!0}return se==ae-1}function lt(t,n){var r,i,o,a,s=0;if(0!==se)do r=ee.pending_buf[ce+2*s]<<8&65280|255&ee.pending_buf[ce+2*s+1],i=255&ee.pending_buf[oe+s],s++,0===r?rt(i,t):(o=e._length_code[i],rt(o+h+1,t),a=e.extra_lbits[o],0!==a&&(i-=e.base_length[o],R(i,a)),r--,o=e.d_code(r),rt(o,n),a=e.extra_dbits[o],0!==a&&(r-=e.base_dist[o],R(r,a)));while(s<se);rt(p,t),ue=t[2*p+1]}function ut(){fe>8?d(he):fe>0&&u(255&he),he=0,fe=0}function ht(t,e,n){ut(),ue=8,n&&(d(e),d(~e)),ee.pending_buf.set(Pt.subarray(t,t+e),ee.pending),ee.pending+=e}function ft(t,e,n){R((K<<1)+(n?1:0),3),ht(t,e,!0)}function dt(t,e,i){var o,a,c=0;Gt>0?(ne.build_tree(ee),re.build_tree(ee),c=s(),o=ee.opt_len+3+7>>>3,a=ee.static_len+3+7>>>3,a<=o&&(o=a)):o=a=e+5,e+4<=o&&t!=-1?ft(t,e,i):a==o?(R(($<<1)+(i?1:0),3),lt(n.static_ltree,n.static_dtree)):(R((Z<<1)+(i?1:0),3),ot(ne.max_code+1,re.max_code+1,c+1),lt($t,Zt)),r(),i&&ut()}function pt(t){dt(zt>=0?zt:-1,Ut-zt,t),zt=Ut,xt.flush_pending()}function gt(){var t,e,n,r;do{if(r=It-Wt-Ut,0===r&&0===Ut&&0===Wt)r=St;else if(r==-1)r--;else if(Ut>=St+St-nt){Pt.set(Pt.subarray(St,St+St),0),Ht-=St,Ut-=St,zt-=St,t=Rt,n=t;do e=65535&Ot[--n],Ot[n]=e>=St?e-St:0;while(0!==--t);t=St,n=t;do e=65535&Et[--n],Et[n]=e>=St?e-St:0;while(0!==--t);r+=St}if(0===xt.avail_in)return;t=xt.read_buf(Pt,Ut+Wt,r),Wt+=t,Wt>=tt&&(Ft=255&Pt[Ut],Ft=(Ft<<jt^255&Pt[Ut+1])&Dt)}while(Wt<nt&&0!==xt.avail_in)}function mt(t){var e,n=65535;for(n>_t-5&&(n=_t-5);;){if(Wt<=1){if(gt(),0===Wt&&t==C)return U;if(0===Wt)break}if(Ut+=Wt,Wt=0,e=zt+n,(0===Ut||Ut>=e)&&(Wt=Ut-e,Ut=e,pt(!1),0===xt.avail_out))return U;if(Ut-zt>=St-nt&&(pt(!1),0===xt.avail_out))return U}return pt(t==q),0===xt.avail_out?t==q?W:U:t==q?X:H}function wt(t){var e,n,r=Vt,i=Ut,o=Xt,a=Ut>St-nt?Ut-(St-nt):0,s=Kt,c=Tt,l=Ut+et,u=Pt[i+o-1],h=Pt[i+o];Xt>=Qt&&(r>>=2),s>Wt&&(s=Wt);do if(e=t,Pt[e+o]==h&&Pt[e+o-1]==u&&Pt[e]==Pt[i]&&Pt[++e]==Pt[i+1]){i+=2,e++;do;while(Pt[++i]==Pt[++e]&&Pt[++i]==Pt[++e]&&Pt[++i]==Pt[++e]&&Pt[++i]==Pt[++e]&&Pt[++i]==Pt[++e]&&Pt[++i]==Pt[++e]&&Pt[++i]==Pt[++e]&&Pt[++i]==Pt[++e]&&i<l);if(n=et-(l-i),i=l-et,n>o){if(Ht=t,o=n,n>=s)break;u=Pt[i+o-1],h=Pt[i+o]}}while((t=65535&Et[t&c])>a&&0!==--r);return o<=Wt?o:Wt}function yt(t){for(var e,n=0;;){if(Wt<nt){if(gt(),Wt<nt&&t==C)return U;if(0===Wt)break}if(Wt>=tt&&(Ft=(Ft<<jt^255&Pt[Ut+(tt-1)])&Dt,n=65535&Ot[Ft],Et[Ut&Tt]=Ot[Ft],Ot[Ft]=Ut),0!==n&&(Ut-n&65535)<=St-nt&&Jt!=k&&(Nt=wt(n)),Nt>=tt)if(e=ct(Ut-Ht,Nt-tt),Wt-=Nt,Nt<=Yt&&Wt>=tt){Nt--;do Ut++,Ft=(Ft<<jt^255&Pt[Ut+(tt-1)])&Dt,n=65535&Ot[Ft],Et[Ut&Tt]=Ot[Ft],Ot[Ft]=Ut;while(0!==--Nt);Ut++}else Ut+=Nt,Nt=0,Ft=255&Pt[Ut],Ft=(Ft<<jt^255&Pt[Ut+1])&Dt;else e=ct(0,255&Pt[Ut]),Wt--,Ut++;if(e&&(pt(!1),0===xt.avail_out))return U}return pt(t==q),0===xt.avail_out?t==q?W:U:t==q?X:H}function vt(t){for(var e,n,r=0;;){if(Wt<nt){if(gt(),Wt<nt&&t==C)return U;if(0===Wt)break}if(Wt>=tt&&(Ft=(Ft<<jt^255&Pt[Ut+(tt-1)])&Dt,r=65535&Ot[Ft],Et[Ut&Tt]=Ot[Ft],Ot[Ft]=Ut),Xt=Nt,Lt=Ht,Nt=tt-1,0!==r&&Xt<Yt&&(Ut-r&65535)<=St-nt&&(Jt!=k&&(Nt=wt(r)),Nt<=5&&(Jt==x||Nt==tt&&Ut-Ht>4096)&&(Nt=tt-1)),Xt>=tt&&Nt<=Xt){n=Ut+Wt-tt,e=ct(Ut-1-Lt,Xt-tt),Wt-=Xt-1,Xt-=2;do++Ut<=n&&(Ft=(Ft<<jt^255&Pt[Ut+(tt-1)])&Dt,r=65535&Ot[Ft],Et[Ut&Tt]=Ot[Ft],Ot[Ft]=Ut);while(0!==--Xt);if(Mt=0,Nt=tt-1,Ut++,e&&(pt(!1),0===xt.avail_out))return U}else if(0!==Mt){if(e=ct(0,255&Pt[Ut-1]),e&&pt(!1),Ut++,Wt--,0===xt.avail_out)return U}else Mt=1,Ut++,Wt--}return 0!==Mt&&(e=ct(0,255&Pt[Ut-1]),Mt=0),pt(t==q),0===xt.avail_out?t==q?W:U:t==q?X:H}function bt(e){return e.total_in=e.total_out=0,e.msg=null,ee.pending=0,ee.pending_out=0,kt=G,At=C,o(),t(),T}var xt,kt,_t,Ct,At,St,qt,Tt,Pt,It,Et,Ot,Ft,Rt,Bt,Dt,jt,zt,Nt,Lt,Mt,Ut,Ht,Wt,Xt,Vt,Yt,Gt,Jt,Qt,Kt,$t,Zt,te,ee=this,ne=new e,re=new e,ie=new e;ee.depth=[];var oe,ae,se,ce,le,ue,he,fe;ee.bl_count=[],ee.heap=[],$t=[],Zt=[],te=[],ee.pqdownheap=function(t,e){for(var n=ee.heap,r=n[e],o=e<<1;o<=ee.heap_len&&(o<ee.heap_len&&i(t,n[o+1],n[o],ee.depth)&&o++,!i(t,r,n[o],ee.depth));)n[e]=n[o],e=o,o<<=1;n[e]=r},ee.deflateInit=function(t,e,n,r,i,o){return r||(r=Q),i||(i=D),o||(o=_),t.msg=null,e==b&&(e=6),i<1||i>B||r!=Q||n<9||n>15||e<0||e>9||o<0||o>k?E:(t.dstate=ee,qt=n,St=1<<qt,Tt=St-1,Bt=i+7,Rt=1<<Bt,Dt=Rt-1,jt=Math.floor((Bt+tt-1)/tt),Pt=new Uint8Array(2*St),Et=[],Ot=[],ae=1<<i+6,ee.pending_buf=new Uint8Array(4*ae),_t=4*ae,ce=Math.floor(ae/2),oe=3*ae,Gt=e,Jt=o,Ct=255&r,bt(t))},ee.deflateEnd=function(){return kt!=Y&&kt!=G&&kt!=J?E:(ee.pending_buf=null,Ot=null,Et=null,Pt=null,ee.dstate=null,kt==G?O:T)},ee.deflateParams=function(t,e,n){var r=T;return e==b&&(e=6),e<0||e>9||n<0||n>k?E:(L[Gt].func!=L[e].func&&0!==t.total_in&&(r=t.deflate(A)),Gt!=e&&(Gt=e,Yt=L[Gt].max_lazy,Qt=L[Gt].good_length,Kt=L[Gt].nice_length,Vt=L[Gt].max_chain),Jt=n,r)},ee.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||kt!=Y)return E;if(i<tt)return T;for(i>St-nt&&(i=St-nt,o=n-i),Pt.set(e.subarray(o,o+i),0),Ut=i,zt=i,Ft=255&Pt[0],Ft=(Ft<<jt^255&Pt[1])&Dt,r=0;r<=i-tt;r++)Ft=(Ft<<jt^255&Pt[r+(tt-1)])&Dt,Et[r&Tt]=Ot[Ft],Ot[Ft]=r;return T},ee.deflate=function(t,e){var n,r,i,o,a;if(e>q||e<0)return E;if(!t.next_out||!t.next_in&&0!==t.avail_in||kt==J&&e!=q)return t.msg=M[I-E],E;if(0===t.avail_out)return t.msg=M[I-F],F;if(xt=t,o=At,At=e,kt==Y&&(r=Q+(qt-8<<4)<<8,i=(Gt-1&255)>>1,i>3&&(i=3),r|=i<<6,0!==Ut&&(r|=V),r+=31-r%31,kt=G,g(r)),0!==ee.pending){if(xt.flush_pending(),0===xt.avail_out)return At=-1,T}else if(0===xt.avail_in&&e<=o&&e!=q)return xt.msg=M[I-F],F;if(kt==J&&0!==xt.avail_in)return t.msg=M[I-F],F;if(0!==xt.avail_in||0!==Wt||e!=C&&kt!=J){switch(a=-1,L[Gt].func){case j:a=mt(e);break;case z:a=yt(e);break;case N:a=vt(e)}if(a!=W&&a!=X||(kt=J),a==U||a==W)return 0===xt.avail_out&&(At=-1),T;if(a==H){if(e==A)st();else if(ft(0,0,!1),e==S)for(n=0;n<Rt;n++)Ot[n]=0;if(xt.flush_pending(),0===xt.avail_out)return At=-1,T}}return e!=q?T:P}}function a(){var t=this;t.next_in_index=0,t.next_out_index=0,t.avail_in=0,t.total_in=0,t.avail_out=0,t.total_out=0}var s=15,c=30,l=19,u=29,h=256,f=h+1+u,d=2*f+1,p=256,g=7,m=16,w=17,y=18,v=16,b=-1,x=1,k=2,_=0,C=0,A=1,S=3,q=4,T=0,P=1,I=2,E=-2,O=-3,F=-5,R=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];e._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],e.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],e.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],e.d_code=function(t){return t<256?R[t]:R[256+(t>>>7)]},e.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],e.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],e.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],e.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],n.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],n.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],n.static_l_desc=new n(n.static_ltree,e.extra_lbits,h+1,f,s),n.static_d_desc=new n(n.static_dtree,e.extra_dbits,0,c,s),n.static_bl_desc=new n(null,e.extra_blbits,0,l,g);var B=9,D=8,j=0,z=1,N=2,L=[new r(0,0,0,0,j),new r(4,4,8,4,z),new r(4,5,16,8,z),new r(4,6,32,32,z),new r(4,4,16,16,N),new r(8,16,32,32,N),new r(8,16,128,128,N),new r(8,32,128,256,N),new r(32,128,258,1024,N),new r(32,258,258,4096,N)],M=["need dictionary","stream end","","","stream error","data error","","buffer error","",""],U=0,H=1,W=2,X=3,V=32,Y=42,G=113,J=666,Q=8,K=0,$=1,Z=2,tt=3,et=258,nt=et+tt+1;return a.prototype={deflateInit:function(t,e){var n=this;return n.dstate=new o,e||(e=s),n.dstate.deflateInit(n,t,e)},deflate:function(t){var e=this;return e.dstate?e.dstate.deflate(e,t):E},deflateEnd:function(){var t=this;if(!t.dstate)return E;var e=t.dstate.deflateEnd();return t.dstate=null,e},deflateParams:function(t,e){var n=this;return n.dstate?n.dstate.deflateParams(n,t,e):E},deflateSetDictionary:function(t,e){var n=this;return n.dstate?n.dstate.deflateSetDictionary(n,t,e):E},read_buf:function(t,e,n){var r=this,i=r.avail_in;return i>n&&(i=n),0===i?0:(r.avail_in-=i,t.set(r.next_in.subarray(r.next_in_index,r.next_in_index+i),e),r.next_in_index+=i,r.total_in+=i,i)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}},function(t){var e=this,n=new a,r=512,i=C,o=new Uint8Array(r);"undefined"==typeof t&&(t=b),n.deflateInit(t),n.next_out=o,e.append=function(t,e){var a,s,c=[],l=0,u=0,h=0;if(t.length){n.next_in_index=0,n.next_in=t,n.avail_in=t.length;do{if(n.next_out_index=0,n.avail_out=r,a=n.deflate(i),a!=T)throw"deflating: "+n.msg;n.next_out_index&&(n.next_out_index==r?c.push(new Uint8Array(o)):c.push(new Uint8Array(o.subarray(0,n.next_out_index)))),h+=n.next_out_index,e&&n.next_in_index>0&&n.next_in_index!=l&&(e(n.next_in_index),l=n.next_in_index)}while(n.avail_in>0||0===n.avail_out);return s=new Uint8Array(h),c.forEach(function(t){s.set(t,u),u+=t.length}),s}},e.flush=function(){var t,e,i=[],a=0,s=0;do{if(n.next_out_index=0,n.avail_out=r,t=n.deflate(q),t!=P&&t!=T)throw"deflating: "+n.msg;r-n.avail_out>0&&i.push(new Uint8Array(o.subarray(0,n.next_out_index))),s+=n.next_out_index}while(n.avail_in>0||0===n.avail_out);return n.deflateEnd(),e=new Uint8Array(s),i.forEach(function(t){e.set(t,a),a+=t.length}),e}}}(void 0);/*
	  html2canvas 0.5.0-beta3 <http://html2canvas.hertzen.com>
	  Copyright (c) 2016 Niklas von Hertzen
	
	  Released under  License
	*/
	!function(t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.html2canvas=t()}}(function(){var t;return function t(e,n,r){function i(a,s){if(!n[a]){if(!e[a]){var c="function"==typeof require&&require;if(!s&&c)return require(a,!0);if(o)return o(a,!0);var l=new Error("Cannot find module '"+a+"'");throw l.code="MODULE_NOT_FOUND",l}var u=n[a]={exports:{}};e[a][0].call(u.exports,function(t){var n=e[a][1][t];return i(n?n:t)},u,u.exports,t,e,n,r)}return n[a].exports}for(var o="function"==typeof require&&require,a=0;a<r.length;a++)i(r[a]);return i}({1:[function(e,n,r){(function(e){!function(i){function o(t){throw RangeError(R[t])}function a(t,e){for(var n=t.length;n--;)t[n]=e(t[n]);return t}function s(t,e){return a(t.split(F),e).join(".")}function c(t){for(var e,n,r=[],i=0,o=t.length;i<o;)e=t.charCodeAt(i++),e>=55296&&e<=56319&&i<o?(n=t.charCodeAt(i++),56320==(64512&n)?r.push(((1023&e)<<10)+(1023&n)+65536):(r.push(e),i--)):r.push(e);return r}function l(t){return a(t,function(t){var e="";return t>65535&&(t-=65536,e+=j(t>>>10&1023|55296),t=56320|1023&t),e+=j(t)}).join("")}function u(t){return t-48<10?t-22:t-65<26?t-65:t-97<26?t-97:_}function h(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function f(t,e,n){var r=0;for(t=n?D(t/q):t>>1,t+=D(t/e);t>B*A>>1;r+=_)t=D(t/B);return D(r+(B+1)*t/(t+S))}function d(t){var e,n,r,i,a,s,c,h,d,p,g=[],m=t.length,w=0,y=P,v=T;for(n=t.lastIndexOf(I),n<0&&(n=0),r=0;r<n;++r)t.charCodeAt(r)>=128&&o("not-basic"),g.push(t.charCodeAt(r));for(i=n>0?n+1:0;i<m;){for(a=w,s=1,c=_;i>=m&&o("invalid-input"),h=u(t.charCodeAt(i++)),(h>=_||h>D((k-w)/s))&&o("overflow"),w+=h*s,d=c<=v?C:c>=v+A?A:c-v,!(h<d);c+=_)p=_-d,s>D(k/p)&&o("overflow"),s*=p;e=g.length+1,v=f(w-a,e,0==a),D(w/e)>k-y&&o("overflow"),y+=D(w/e),w%=e,g.splice(w++,0,y)}return l(g)}function p(t){var e,n,r,i,a,s,l,u,d,p,g,m,w,y,v,b=[];for(t=c(t),m=t.length,e=P,n=0,a=T,s=0;s<m;++s)g=t[s],g<128&&b.push(j(g));for(r=i=b.length,i&&b.push(I);r<m;){for(l=k,s=0;s<m;++s)g=t[s],g>=e&&g<l&&(l=g);for(w=r+1,l-e>D((k-n)/w)&&o("overflow"),n+=(l-e)*w,e=l,s=0;s<m;++s)if(g=t[s],g<e&&++n>k&&o("overflow"),g==e){for(u=n,d=_;p=d<=a?C:d>=a+A?A:d-a,!(u<p);d+=_)v=u-p,y=_-p,b.push(j(h(p+v%y,0))),u=D(v/y);b.push(j(h(u,0))),a=f(n,w,r==i),n=0,++r}++n,++e}return b.join("")}function g(t){return s(t,function(t){return E.test(t)?d(t.slice(4).toLowerCase()):t})}function m(t){return s(t,function(t){return O.test(t)?"xn--"+p(t):t})}var w="object"==typeof r&&r,y="object"==typeof n&&n&&n.exports==w&&n,v="object"==typeof e&&e;v.global!==v&&v.window!==v||(i=v);var b,x,k=2147483647,_=36,C=1,A=26,S=38,q=700,T=72,P=128,I="-",E=/^xn--/,O=/[^ -~]/,F=/\x2E|\u3002|\uFF0E|\uFF61/g,R={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},B=_-C,D=Math.floor,j=String.fromCharCode;if(b={version:"1.2.4",ucs2:{decode:c,encode:l},decode:d,encode:p,toASCII:m,toUnicode:g},"function"==typeof t&&"object"==typeof t.amd&&t.amd)t("punycode",function(){return b});else if(w&&!w.nodeType)if(y)y.exports=b;else for(x in b)b.hasOwnProperty(x)&&(w[x]=b[x]);else i.punycode=b}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],2:[function(t,e,n){function r(t,e,n){!t.defaultView||e===t.defaultView.pageXOffset&&n===t.defaultView.pageYOffset||t.defaultView.scrollTo(e,n)}function i(t,e){try{e&&(e.width=t.width,e.height=t.height,e.getContext("2d").putImageData(t.getContext("2d").getImageData(0,0,t.width,t.height),0,0))}catch(e){s("Unable to copy canvas content from",t,e)}}function o(t,e){for(var n=3===t.nodeType?document.createTextNode(t.nodeValue):t.cloneNode(!1),r=t.firstChild;r;)e!==!0&&1===r.nodeType&&"SCRIPT"===r.nodeName||n.appendChild(o(r,e)),r=r.nextSibling;return 1===t.nodeType&&(n._scrollTop=t.scrollTop,n._scrollLeft=t.scrollLeft,"CANVAS"===t.nodeName?i(t,n):"TEXTAREA"!==t.nodeName&&"SELECT"!==t.nodeName||(n.value=t.value)),n}function a(t){if(1===t.nodeType){t.scrollTop=t._scrollTop,t.scrollLeft=t._scrollLeft;for(var e=t.firstChild;e;)a(e),e=e.nextSibling}}var s=t("./log");e.exports=function(t,e,n,i,s,c,l){var u=o(t.documentElement,s.javascriptEnabled),h=e.createElement("iframe");return h.className="html2canvas-container",h.style.visibility="hidden",h.style.position="fixed",h.style.left="-10000px",h.style.top="0px",h.style.border="0",h.width=n,h.height=i,h.scrolling="no",e.body.appendChild(h),new Promise(function(e){var n=h.contentWindow.document;h.contentWindow.onload=h.onload=function(){var t=setInterval(function(){n.body.childNodes.length>0&&(a(n.documentElement),clearInterval(t),"view"===s.type&&(h.contentWindow.scrollTo(c,l),!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)||h.contentWindow.scrollY===l&&h.contentWindow.scrollX===c||(n.documentElement.style.top=-l+"px",n.documentElement.style.left=-c+"px",n.documentElement.style.position="absolute")),e(h))},50)},n.open(),n.write("<!DOCTYPE html><html></html>"),r(t,c,l),n.replaceChild(n.adoptNode(u),n.documentElement),n.close()})}},{"./log":13}],3:[function(t,e,n){function r(t){this.r=0,this.g=0,this.b=0,this.a=null;this.fromArray(t)||this.namedColor(t)||this.rgb(t)||this.rgba(t)||this.hex6(t)||this.hex3(t)}r.prototype.darken=function(t){var e=1-t;return new r([Math.round(this.r*e),Math.round(this.g*e),Math.round(this.b*e),this.a])},r.prototype.isTransparent=function(){return 0===this.a},r.prototype.isBlack=function(){return 0===this.r&&0===this.g&&0===this.b},r.prototype.fromArray=function(t){return Array.isArray(t)&&(this.r=Math.min(t[0],255),this.g=Math.min(t[1],255),this.b=Math.min(t[2],255),t.length>3&&(this.a=t[3])),Array.isArray(t)};var i=/^#([a-f0-9]{3})$/i;r.prototype.hex3=function(t){var e=null;return null!==(e=t.match(i))&&(this.r=parseInt(e[1][0]+e[1][0],16),this.g=parseInt(e[1][1]+e[1][1],16),this.b=parseInt(e[1][2]+e[1][2],16)),null!==e};var o=/^#([a-f0-9]{6})$/i;r.prototype.hex6=function(t){var e=null;return null!==(e=t.match(o))&&(this.r=parseInt(e[1].substring(0,2),16),this.g=parseInt(e[1].substring(2,4),16),this.b=parseInt(e[1].substring(4,6),16)),null!==e};var a=/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;r.prototype.rgb=function(t){var e=null;return null!==(e=t.match(a))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3])),null!==e};var s=/^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;r.prototype.rgba=function(t){var e=null;return null!==(e=t.match(s))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3]),this.a=Number(e[4])),null!==e},r.prototype.toString=function(){return null!==this.a&&1!==this.a?"rgba("+[this.r,this.g,this.b,this.a].join(",")+")":"rgb("+[this.r,this.g,this.b].join(",")+")"},r.prototype.namedColor=function(t){t=t.toLowerCase();var e=c[t];if(e)this.r=e[0],this.g=e[1],this.b=e[2];else if("transparent"===t)return this.r=this.g=this.b=this.a=0,!0;return!!e},r.prototype.isColor=!0;var c={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]};e.exports=r},{}],4:[function(e,n,r){function i(t,e){var n=_++;if(e=e||{},e.logging&&(w.options.logging=!0,w.options.start=Date.now()),e.async="undefined"==typeof e.async||e.async,e.allowTaint="undefined"!=typeof e.allowTaint&&e.allowTaint,e.removeContainer="undefined"==typeof e.removeContainer||e.removeContainer,e.javascriptEnabled="undefined"!=typeof e.javascriptEnabled&&e.javascriptEnabled,e.imageTimeout="undefined"==typeof e.imageTimeout?1e4:e.imageTimeout,e.renderer="function"==typeof e.renderer?e.renderer:d,e.strict=!!e.strict,"string"==typeof t){if("string"!=typeof e.proxy)return Promise.reject("Proxy must be used when rendering url");var r=null!=e.width?e.width:window.innerWidth,i=null!=e.height?e.height:window.innerHeight;return b(h(t),e.proxy,document,r,i,e).then(function(t){return a(t.contentWindow.document.documentElement,t,e,r,i)})}var s=(void 0===t?[document.documentElement]:t.length?t:[t])[0];return s.setAttribute(k+n,n),o(s.ownerDocument,e,s.ownerDocument.defaultView.innerWidth,s.ownerDocument.defaultView.innerHeight,n).then(function(t){return"function"==typeof e.onrendered&&(w("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas"),e.onrendered(t)),t})}function o(t,e,n,r,i){return v(t,t,n,r,e,t.defaultView.pageXOffset,t.defaultView.pageYOffset).then(function(o){w("Document cloned");var s=k+i,c="["+s+"='"+i+"']";t.querySelector(c).removeAttribute(s);var l=o.contentWindow,u=l.document.querySelector(c),h="function"==typeof e.onclone?Promise.resolve(e.onclone(l.document)):Promise.resolve(!0);return h.then(function(){return a(u,o,e,n,r)})})}function a(t,e,n,r,i){var o=e.contentWindow,a=new f(o.document),h=new p(n,a),d=x(t),m="view"===n.type?r:l(o.document),y="view"===n.type?i:u(o.document),v=new n.renderer(m,y,h,n,document),b=new g(t,v,a,h,n);return b.ready.then(function(){w("Finished rendering");var r;return r="view"===n.type?c(v.canvas,{width:v.canvas.width,height:v.canvas.height,top:0,left:0,x:0,y:0}):t===o.document.body||t===o.document.documentElement||null!=n.canvas?v.canvas:c(v.canvas,{width:null!=n.width?n.width:d.width,height:null!=n.height?n.height:d.height,top:d.top,left:d.left,x:0,y:0}),s(e,n),r})}function s(t,e){e.removeContainer&&(t.parentNode.removeChild(t),w("Cleaned up container"))}function c(t,e){var n=document.createElement("canvas"),r=Math.min(t.width-1,Math.max(0,e.left)),i=Math.min(t.width,Math.max(1,e.left+e.width)),o=Math.min(t.height-1,Math.max(0,e.top)),a=Math.min(t.height,Math.max(1,e.top+e.height));n.width=e.width,n.height=e.height;var s=i-r,c=a-o;return w("Cropping canvas at:","left:",e.left,"top:",e.top,"width:",s,"height:",c),w("Resulting crop with width",e.width,"and height",e.height,"with x",r,"and y",o),n.getContext("2d").drawImage(t,r,o,s,c,e.x,e.y,s,c),n}function l(t){return Math.max(Math.max(t.body.scrollWidth,t.documentElement.scrollWidth),Math.max(t.body.offsetWidth,t.documentElement.offsetWidth),Math.max(t.body.clientWidth,t.documentElement.clientWidth))}function u(t){return Math.max(Math.max(t.body.scrollHeight,t.documentElement.scrollHeight),Math.max(t.body.offsetHeight,t.documentElement.offsetHeight),Math.max(t.body.clientHeight,t.documentElement.clientHeight))}function h(t){var e=document.createElement("a");return e.href=t,e.href=e.href,e}var f=e("./support"),d=e("./renderers/canvas"),p=e("./imageloader"),g=e("./nodeparser"),m=e("./nodecontainer"),w=e("./log"),y=e("./utils"),v=e("./clone"),b=e("./proxy").loadUrlDocument,x=y.getBounds,k="data-html2canvas-node",_=0;i.CanvasRenderer=d,i.NodeContainer=m,i.log=w,i.utils=y;var C="undefined"==typeof document||"function"!=typeof Object.create||"function"!=typeof document.createElement("canvas").getContext?function(){return Promise.reject("No canvas support")}:i;n.exports=C,"function"==typeof t&&t.amd&&t("html2canvas",[],function(){return C})},{"./clone":2,"./imageloader":11,"./log":13,"./nodecontainer":14,"./nodeparser":15,"./proxy":16,"./renderers/canvas":20,"./support":22,"./utils":26}],5:[function(t,e,n){function r(t){if(this.src=t,i("DummyImageContainer for",t),!this.promise||!this.image){i("Initiating DummyImageContainer"),r.prototype.image=new Image;var e=this.image;r.prototype.promise=new Promise(function(t,n){e.onload=t,e.onerror=n,e.src=o(),e.complete===!0&&t(e)})}}var i=t("./log"),o=t("./utils").smallImage;e.exports=r},{"./log":13,"./utils":26}],6:[function(t,e,n){function r(t,e){var n,r,o=document.createElement("div"),a=document.createElement("img"),s=document.createElement("span"),c="Hidden Text";o.style.visibility="hidden",o.style.fontFamily=t,o.style.fontSize=e,o.style.margin=0,o.style.padding=0,document.body.appendChild(o),a.src=i(),a.width=1,a.height=1,a.style.margin=0,a.style.padding=0,a.style.verticalAlign="baseline",s.style.fontFamily=t,s.style.fontSize=e,s.style.margin=0,s.style.padding=0,s.appendChild(document.createTextNode(c)),o.appendChild(s),o.appendChild(a),n=a.offsetTop-s.offsetTop+1,o.removeChild(s),o.appendChild(document.createTextNode(c)),o.style.lineHeight="normal",a.style.verticalAlign="super",r=a.offsetTop-o.offsetTop+1,document.body.removeChild(o),this.baseline=n,this.lineWidth=1,this.middle=r}var i=t("./utils").smallImage;e.exports=r},{"./utils":26}],7:[function(t,e,n){function r(){this.data={}}var i=t("./font");r.prototype.getMetrics=function(t,e){return void 0===this.data[t+"-"+e]&&(this.data[t+"-"+e]=new i(t,e)),this.data[t+"-"+e]},e.exports=r},{"./font":6}],8:[function(t,e,n){function r(e,n,r){this.image=null,this.src=e;var i=this,a=o(e);this.promise=(n?new Promise(function(t){"about:blank"===e.contentWindow.document.URL||null==e.contentWindow.document.documentElement?e.contentWindow.onload=e.onload=function(){t(e)}:t(e)}):this.proxyLoad(r.proxy,a,r)).then(function(e){var n=t("./core");return n(e.contentWindow.document.documentElement,{type:"view",width:e.width,height:e.height,proxy:r.proxy,javascriptEnabled:r.javascriptEnabled,removeContainer:r.removeContainer,allowTaint:r.allowTaint,imageTimeout:r.imageTimeout/2})}).then(function(t){return i.image=t})}var i=t("./utils"),o=i.getBounds,a=t("./proxy").loadUrlDocument;r.prototype.proxyLoad=function(t,e,n){var r=this.src;return a(r.src,t,r.ownerDocument,e.width,e.height,n)},e.exports=r},{"./core":4,"./proxy":16,"./utils":26}],9:[function(t,e,n){function r(t){this.src=t.value,this.colorStops=[],this.type=null,this.x0=.5,this.y0=.5,this.x1=.5,this.y1=.5,this.promise=Promise.resolve(!0)}r.TYPES={LINEAR:1,RADIAL:2},r.REGEXP_COLORSTOP=/^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i,e.exports=r},{}],10:[function(t,e,n){function r(t,e){this.src=t,this.image=new Image;var n=this;this.tainted=null,this.promise=new Promise(function(r,i){n.image.onload=r,n.image.onerror=i,e&&(n.image.crossOrigin="anonymous"),n.image.src=t,n.image.complete===!0&&r(n.image)})}e.exports=r},{}],11:[function(t,e,n){function r(t,e){this.link=null,this.options=t,this.support=e,this.origin=this.getOrigin(window.location.href)}var i=t("./log"),o=t("./imagecontainer"),a=t("./dummyimagecontainer"),s=t("./proxyimagecontainer"),c=t("./framecontainer"),l=t("./svgcontainer"),u=t("./svgnodecontainer"),h=t("./lineargradientcontainer"),f=t("./webkitgradientcontainer"),d=t("./utils").bind;r.prototype.findImages=function(t){var e=[];return t.reduce(function(t,e){switch(e.node.nodeName){case"IMG":return t.concat([{args:[e.node.src],method:"url"}]);case"svg":case"IFRAME":return t.concat([{args:[e.node],method:e.node.nodeName}])}return t},[]).forEach(this.addImage(e,this.loadImage),this),e},r.prototype.findBackgroundImage=function(t,e){return e.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(t,this.loadImage),this),t},r.prototype.addImage=function(t,e){return function(n){n.args.forEach(function(r){this.imageExists(t,r)||(t.splice(0,0,e.call(this,n)),i("Added image #"+t.length,"string"==typeof r?r.substring(0,100):r))},this)}},r.prototype.hasImageBackground=function(t){return"none"!==t.method},r.prototype.loadImage=function(t){if("url"===t.method){var e=t.args[0];return!this.isSVG(e)||this.support.svg||this.options.allowTaint?e.match(/data:image\/.*;base64,/i)?new o(e.replace(/url\(['"]{0,}|['"]{0,}\)$/gi,""),!1):this.isSameOrigin(e)||this.options.allowTaint===!0||this.isSVG(e)?new o(e,!1):this.support.cors&&!this.options.allowTaint&&this.options.useCORS?new o(e,!0):this.options.proxy?new s(e,this.options.proxy):new a(e):new l(e)}return"linear-gradient"===t.method?new h(t):"gradient"===t.method?new f(t):"svg"===t.method?new u(t.args[0],this.support.svg):"IFRAME"===t.method?new c(t.args[0],this.isSameOrigin(t.args[0].src),this.options):new a(t)},r.prototype.isSVG=function(t){return"svg"===t.substring(t.length-3).toLowerCase()||l.prototype.isInline(t)},r.prototype.imageExists=function(t,e){return t.some(function(t){return t.src===e})},r.prototype.isSameOrigin=function(t){return this.getOrigin(t)===this.origin},r.prototype.getOrigin=function(t){var e=this.link||(this.link=document.createElement("a"));return e.href=t,e.href=e.href,e.protocol+e.hostname+e.port},r.prototype.getPromise=function(t){return this.timeout(t,this.options.imageTimeout).catch(function(){var e=new a(t.src);return e.promise.then(function(e){t.image=e})})},r.prototype.get=function(t){var e=null;return this.images.some(function(n){return(e=n).src===t})?e:null},r.prototype.fetch=function(t){return this.images=t.reduce(d(this.findBackgroundImage,this),this.findImages(t)),this.images.forEach(function(t,e){t.promise.then(function(){i("Succesfully loaded image #"+(e+1),t)},function(n){i("Failed loading image #"+(e+1),t,n)})}),this.ready=Promise.all(this.images.map(this.getPromise,this)),i("Finished searching images"),this},r.prototype.timeout=function(t,e){var n,r=Promise.race([t.promise,new Promise(function(r,o){n=setTimeout(function(){i("Timed out loading image",t),o(t)},e)})]).then(function(t){return clearTimeout(n),t});return r.catch(function(){clearTimeout(n)}),r},e.exports=r},{"./dummyimagecontainer":5,"./framecontainer":8,"./imagecontainer":10,"./lineargradientcontainer":12,"./log":13,"./proxyimagecontainer":17,"./svgcontainer":23,"./svgnodecontainer":24,"./utils":26,"./webkitgradientcontainer":27}],12:[function(t,e,n){function r(t){i.apply(this,arguments),this.type=i.TYPES.LINEAR;var e=r.REGEXP_DIRECTION.test(t.args[0])||!i.REGEXP_COLORSTOP.test(t.args[0]);e?t.args[0].split(/\s+/).reverse().forEach(function(t,e){switch(t){case"left":this.x0=0,this.x1=1;break;case"top":this.y0=0,this.y1=1;break;case"right":this.x0=1,this.x1=0;break;case"bottom":this.y0=1,this.y1=0;break;case"to":var n=this.y0,r=this.x0;this.y0=this.y1,this.x0=this.x1,this.x1=r,this.y1=n;break;case"center":break;default:var i=.01*parseFloat(t,10);if(isNaN(i))break;0===e?(this.y0=i,this.y1=1-this.y0):(this.x0=i,this.x1=1-this.x0)}},this):(this.y0=0,this.y1=1),this.colorStops=t.args.slice(e?1:0).map(function(t){var e=t.match(i.REGEXP_COLORSTOP),n=+e[2],r=0===n?"%":e[3];return{color:new o(e[1]),stop:"%"===r?n/100:null}}),null===this.colorStops[0].stop&&(this.colorStops[0].stop=0),null===this.colorStops[this.colorStops.length-1].stop&&(this.colorStops[this.colorStops.length-1].stop=1),this.colorStops.forEach(function(t,e){null===t.stop&&this.colorStops.slice(e).some(function(n,r){return null!==n.stop&&(t.stop=(n.stop-this.colorStops[e-1].stop)/(r+1)+this.colorStops[e-1].stop,!0)},this)},this)}var i=t("./gradientcontainer"),o=t("./color");r.prototype=Object.create(i.prototype),r.REGEXP_DIRECTION=/^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i,e.exports=r},{"./color":3,"./gradientcontainer":9}],13:[function(t,e,n){var r=function(){r.options.logging&&window.console&&window.console.log&&Function.prototype.bind.call(window.console.log,window.console).apply(window.console,[Date.now()-r.options.start+"ms","html2canvas:"].concat([].slice.call(arguments,0)))};r.options={logging:!1},e.exports=r},{}],14:[function(t,e,n){function r(t,e){this.node=t,this.parent=e,this.stack=null,this.bounds=null,this.borders=null,this.clip=[],this.backgroundClip=[],this.offsetBounds=null,this.visible=null,this.computedStyles=null,this.colors={},this.styles={},this.backgroundImages=null,this.transformData=null,this.transformMatrix=null,this.isPseudoElement=!1,this.opacity=null}function i(t){var e=t.options[t.selectedIndex||0];return e?e.text||"":""}function o(t){if(t&&"matrix"===t[1])return t[2].split(",").map(function(t){return parseFloat(t.trim())});if(t&&"matrix3d"===t[1]){var e=t[2].split(",").map(function(t){return parseFloat(t.trim())});return[e[0],e[1],e[4],e[5],e[12],e[13]]}}function a(t){return t.toString().indexOf("%")!==-1}function s(t){return t.replace("px","")}function c(t){return parseFloat(t)}var l=t("./color"),u=t("./utils"),h=u.getBounds,f=u.parseBackgrounds,d=u.offsetBounds;r.prototype.cloneTo=function(t){t.visible=this.visible,t.borders=this.borders,t.bounds=this.bounds,t.clip=this.clip,t.backgroundClip=this.backgroundClip,t.computedStyles=this.computedStyles,t.styles=this.styles,t.backgroundImages=this.backgroundImages,t.opacity=this.opacity},r.prototype.getOpacity=function(){return null===this.opacity?this.opacity=this.cssFloat("opacity"):this.opacity},r.prototype.assignStack=function(t){this.stack=t,t.children.push(this)},r.prototype.isElementVisible=function(){return this.node.nodeType===Node.TEXT_NODE?this.parent.visible:"none"!==this.css("display")&&"hidden"!==this.css("visibility")&&!this.node.hasAttribute("data-html2canvas-ignore")&&("INPUT"!==this.node.nodeName||"hidden"!==this.node.getAttribute("type"))},r.prototype.css=function(t){return this.computedStyles||(this.computedStyles=this.isPseudoElement?this.parent.computedStyle(this.before?":before":":after"):this.computedStyle(null)),this.styles[t]||(this.styles[t]=this.computedStyles[t])},r.prototype.prefixedCss=function(t){var e=["webkit","moz","ms","o"],n=this.css(t);return void 0===n&&e.some(function(e){return n=this.css(e+t.substr(0,1).toUpperCase()+t.substr(1)),void 0!==n},this),void 0===n?null:n},r.prototype.computedStyle=function(t){return this.node.ownerDocument.defaultView.getComputedStyle(this.node,t)},r.prototype.cssInt=function(t){var e=parseInt(this.css(t),10);return isNaN(e)?0:e},r.prototype.color=function(t){return this.colors[t]||(this.colors[t]=new l(this.css(t)))},r.prototype.cssFloat=function(t){var e=parseFloat(this.css(t));return isNaN(e)?0:e},r.prototype.fontWeight=function(){var t=this.css("fontWeight");switch(parseInt(t,10)){case 401:t="bold";break;case 400:t="normal"}return t},r.prototype.parseClip=function(){var t=this.css("clip").match(this.CLIP);return t?{top:parseInt(t[1],10),right:parseInt(t[2],10),bottom:parseInt(t[3],10),left:parseInt(t[4],10)}:null},r.prototype.parseBackgroundImages=function(){return this.backgroundImages||(this.backgroundImages=f(this.css("backgroundImage")))},r.prototype.cssList=function(t,e){var n=(this.css(t)||"").split(",");return n=n[e||0]||n[0]||"auto",n=n.trim().split(" "),1===n.length&&(n=[n[0],a(n[0])?"auto":n[0]]),n},r.prototype.parseBackgroundSize=function(t,e,n){var r,i,o=this.cssList("backgroundSize",n);if(a(o[0]))r=t.width*parseFloat(o[0])/100;else{if(/contain|cover/.test(o[0])){var s=t.width/t.height,c=e.width/e.height;return s<c^"contain"===o[0]?{width:t.height*c,height:t.height}:{width:t.width,height:t.width/c}}r=parseInt(o[0],10)}return i="auto"===o[0]&&"auto"===o[1]?e.height:"auto"===o[1]?r/e.width*e.height:a(o[1])?t.height*parseFloat(o[1])/100:parseInt(o[1],10),"auto"===o[0]&&(r=i/e.height*e.width),{width:r,height:i}},r.prototype.parseBackgroundPosition=function(t,e,n,r){var i,o,s=this.cssList("backgroundPosition",n);return i=a(s[0])?(t.width-(r||e).width)*(parseFloat(s[0])/100):parseInt(s[0],10),o="auto"===s[1]?i/e.width*e.height:a(s[1])?(t.height-(r||e).height)*parseFloat(s[1])/100:parseInt(s[1],10),"auto"===s[0]&&(i=o/e.height*e.width),{left:i,top:o}},r.prototype.parseBackgroundRepeat=function(t){return this.cssList("backgroundRepeat",t)[0]},r.prototype.parseTextShadows=function(){var t=this.css("textShadow"),e=[];if(t&&"none"!==t)for(var n=t.match(this.TEXT_SHADOW_PROPERTY),r=0;n&&r<n.length;r++){var i=n[r].match(this.TEXT_SHADOW_VALUES);e.push({color:new l(i[0]),offsetX:i[1]?parseFloat(i[1].replace("px","")):0,offsetY:i[2]?parseFloat(i[2].replace("px","")):0,blur:i[3]?i[3].replace("px",""):0})}return e},r.prototype.parseTransform=function(){if(!this.transformData)if(this.hasTransform()){var t=this.parseBounds(),e=this.prefixedCss("transformOrigin").split(" ").map(s).map(c);e[0]+=t.left,e[1]+=t.top,this.transformData={origin:e,matrix:this.parseTransformMatrix()}}else this.transformData={origin:[0,0],matrix:[1,0,0,1,0,0]};return this.transformData},r.prototype.parseTransformMatrix=function(){if(!this.transformMatrix){var t=this.prefixedCss("transform"),e=t?o(t.match(this.MATRIX_PROPERTY)):null;this.transformMatrix=e?e:[1,0,0,1,0,0]}return this.transformMatrix},r.prototype.parseBounds=function(){return this.bounds||(this.bounds=this.hasTransform()?d(this.node):h(this.node))},r.prototype.hasTransform=function(){return"1,0,0,1,0,0"!==this.parseTransformMatrix().join(",")||this.parent&&this.parent.hasTransform()},r.prototype.getValue=function(){var t=this.node.value||"";return"SELECT"===this.node.tagName?t=i(this.node):"password"===this.node.type&&(t=Array(t.length+1).join("•")),0===t.length?this.node.placeholder||"":t},r.prototype.MATRIX_PROPERTY=/(matrix|matrix3d)\((.+)\)/,r.prototype.TEXT_SHADOW_PROPERTY=/((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g,r.prototype.TEXT_SHADOW_VALUES=/(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g,r.prototype.CLIP=/^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/,e.exports=r},{"./color":3,"./utils":26}],15:[function(t,e,n){function r(t,e,n,r,i){L("Starting NodeParser"),this.renderer=e,this.options=i,this.range=null,this.support=n,this.renderQueue=[],this.stack=new Y(!0,1,t.ownerDocument,null);var o=new U(t,null);if(i.background&&e.rectangle(0,0,e.width,e.height,new V(i.background)),t===t.ownerDocument.documentElement){var a=new U(o.color("backgroundColor").isTransparent()?t.ownerDocument.body:t.ownerDocument.documentElement,null);e.rectangle(0,0,e.width,e.height,a.color("backgroundColor"))}o.visibile=o.isElementVisible(),this.createPseudoHideStyles(t.ownerDocument),this.disableAnimations(t.ownerDocument),this.nodes=B([o].concat(this.getChildren(o)).filter(function(t){return t.visible=t.isElementVisible()}).map(this.getPseudoElements,this)),this.fontMetrics=new X,L("Fetched nodes, total:",this.nodes.length),L("Calculate overflow clips"),this.calculateOverflowClips(),L("Start fetching images"),this.images=r.fetch(this.nodes.filter(q)),this.ready=this.images.ready.then(J(function(){return L("Images loaded, starting parsing"),L("Creating stacking contexts"),this.createStackingContexts(),L("Sorting stacking contexts"),this.sortStackingContexts(this.stack),this.parse(this.stack),L("Render queue created with "+this.renderQueue.length+" items"),new Promise(J(function(t){i.async?"function"==typeof i.async?i.async.call(this,this.renderQueue,t):this.renderQueue.length>0?(this.renderIndex=0,this.asyncRenderer(this.renderQueue,t)):t():(this.renderQueue.forEach(this.paint,this),t())},this))},this))}function i(t){return t.parent&&t.parent.clip.length}function o(t){return t.replace(/(\-[a-z])/g,function(t){return t.toUpperCase().replace("-","")})}function a(){}function s(t,e,n,r){return t.map(function(i,o){if(i.width>0){var a=e.left,s=e.top,c=e.width,l=e.height-t[2].width;switch(o){case 0:l=t[0].width,i.args=h({c1:[a,s],c2:[a+c,s],c3:[a+c-t[1].width,s+l],c4:[a+t[3].width,s+l]},r[0],r[1],n.topLeftOuter,n.topLeftInner,n.topRightOuter,n.topRightInner);break;case 1:a=e.left+e.width-t[1].width,c=t[1].width,i.args=h({c1:[a+c,s],c2:[a+c,s+l+t[2].width],c3:[a,s+l],c4:[a,s+t[0].width]},r[1],r[2],n.topRightOuter,n.topRightInner,n.bottomRightOuter,n.bottomRightInner);break;case 2:s=s+e.height-t[2].width,l=t[2].width,i.args=h({c1:[a+c,s+l],c2:[a,s+l],c3:[a+t[3].width,s],c4:[a+c-t[3].width,s]},r[2],r[3],n.bottomRightOuter,n.bottomRightInner,n.bottomLeftOuter,n.bottomLeftInner);break;case 3:c=t[3].width,i.args=h({c1:[a,s+l+t[2].width],c2:[a,s],c3:[a+c,s+t[0].width],c4:[a+c,s+l]},r[3],r[0],n.bottomLeftOuter,n.bottomLeftInner,n.topLeftOuter,n.topLeftInner)}}return i})}function c(t,e,n,r){var i=4*((Math.sqrt(2)-1)/3),o=n*i,a=r*i,s=t+n,c=e+r;return{topLeft:u({x:t,y:c},{x:t,y:c-a},{x:s-o,y:e},{x:s,y:e}),topRight:u({x:t,y:e},{x:t+o,y:e},{x:s,y:c-a},{x:s,y:c}),bottomRight:u({x:s,y:e},{x:s,y:e+a},{x:t+o,y:c},{x:t,y:c}),bottomLeft:u({x:s,y:c},{x:s-o,y:c},{x:t,y:e+a},{x:t,y:e})}}function l(t,e,n){var r=t.left,i=t.top,o=t.width,a=t.height,s=e[0][0]<o/2?e[0][0]:o/2,l=e[0][1]<a/2?e[0][1]:a/2,u=e[1][0]<o/2?e[1][0]:o/2,h=e[1][1]<a/2?e[1][1]:a/2,f=e[2][0]<o/2?e[2][0]:o/2,d=e[2][1]<a/2?e[2][1]:a/2,p=e[3][0]<o/2?e[3][0]:o/2,g=e[3][1]<a/2?e[3][1]:a/2,m=o-u,w=a-d,y=o-f,v=a-g;return{topLeftOuter:c(r,i,s,l).topLeft.subdivide(.5),topLeftInner:c(r+n[3].width,i+n[0].width,Math.max(0,s-n[3].width),Math.max(0,l-n[0].width)).topLeft.subdivide(.5),topRightOuter:c(r+m,i,u,h).topRight.subdivide(.5),topRightInner:c(r+Math.min(m,o+n[3].width),i+n[0].width,m>o+n[3].width?0:u-n[3].width,h-n[0].width).topRight.subdivide(.5),bottomRightOuter:c(r+y,i+w,f,d).bottomRight.subdivide(.5),bottomRightInner:c(r+Math.min(y,o-n[3].width),i+Math.min(w,a+n[0].width),Math.max(0,f-n[1].width),d-n[2].width).bottomRight.subdivide(.5),bottomLeftOuter:c(r,i+v,p,g).bottomLeft.subdivide(.5),
	bottomLeftInner:c(r+n[3].width,i+v,Math.max(0,p-n[3].width),g-n[2].width).bottomLeft.subdivide(.5)}}function u(t,e,n,r){var i=function(t,e,n){return{x:t.x+(e.x-t.x)*n,y:t.y+(e.y-t.y)*n}};return{start:t,startControl:e,endControl:n,end:r,subdivide:function(o){var a=i(t,e,o),s=i(e,n,o),c=i(n,r,o),l=i(a,s,o),h=i(s,c,o),f=i(l,h,o);return[u(t,a,l,f),u(f,h,c,r)]},curveTo:function(t){t.push(["bezierCurve",e.x,e.y,n.x,n.y,r.x,r.y])},curveToReversed:function(r){r.push(["bezierCurve",n.x,n.y,e.x,e.y,t.x,t.y])}}}function h(t,e,n,r,i,o,a){var s=[];return e[0]>0||e[1]>0?(s.push(["line",r[1].start.x,r[1].start.y]),r[1].curveTo(s)):s.push(["line",t.c1[0],t.c1[1]]),n[0]>0||n[1]>0?(s.push(["line",o[0].start.x,o[0].start.y]),o[0].curveTo(s),s.push(["line",a[0].end.x,a[0].end.y]),a[0].curveToReversed(s)):(s.push(["line",t.c2[0],t.c2[1]]),s.push(["line",t.c3[0],t.c3[1]])),e[0]>0||e[1]>0?(s.push(["line",i[1].end.x,i[1].end.y]),i[1].curveToReversed(s)):s.push(["line",t.c4[0],t.c4[1]]),s}function f(t,e,n,r,i,o,a){e[0]>0||e[1]>0?(t.push(["line",r[0].start.x,r[0].start.y]),r[0].curveTo(t),r[1].curveTo(t)):t.push(["line",o,a]),(n[0]>0||n[1]>0)&&t.push(["line",i[0].start.x,i[0].start.y])}function d(t){return t.cssInt("zIndex")<0}function p(t){return t.cssInt("zIndex")>0}function g(t){return 0===t.cssInt("zIndex")}function m(t){return["inline","inline-block","inline-table"].indexOf(t.css("display"))!==-1}function w(t){return t instanceof Y}function y(t){return t.node.data.trim().length>0}function v(t){return/^(normal|none|0px)$/.test(t.parent.css("letterSpacing"))}function b(t){return["TopLeft","TopRight","BottomRight","BottomLeft"].map(function(e){var n=t.css("border"+e+"Radius"),r=n.split(" ");return r.length<=1&&(r[1]=r[0]),r.map(O)})}function x(t){return t.nodeType===Node.TEXT_NODE||t.nodeType===Node.ELEMENT_NODE}function k(t){var e=t.css("position"),n=["absolute","relative","fixed"].indexOf(e)!==-1?t.css("zIndex"):"auto";return"auto"!==n}function _(t){return"static"!==t.css("position")}function C(t){return"none"!==t.css("float")}function A(t){return["inline-block","inline-table"].indexOf(t.css("display"))!==-1}function S(t){var e=this;return function(){return!t.apply(e,arguments)}}function q(t){return t.node.nodeType===Node.ELEMENT_NODE}function T(t){return t.isPseudoElement===!0}function P(t){return t.node.nodeType===Node.TEXT_NODE}function I(t){return function(e,n){return e.cssInt("zIndex")+t.indexOf(e)/t.length-(n.cssInt("zIndex")+t.indexOf(n)/t.length)}}function E(t){return t.getOpacity()<1}function O(t){return parseInt(t,10)}function F(t){return t.width}function R(t){return t.node.nodeType!==Node.ELEMENT_NODE||["SCRIPT","HEAD","TITLE","OBJECT","BR","OPTION"].indexOf(t.node.nodeName)===-1}function B(t){return[].concat.apply([],t)}function D(t){var e=t.substr(0,1);return e===t.substr(t.length-1)&&e.match(/'|"/)?t.substr(1,t.length-2):t}function j(t){for(var e,n=[],r=0,i=!1;t.length;)z(t[r])===i?(e=t.splice(0,r),e.length&&n.push(M.ucs2.encode(e)),i=!i,r=0):r++,r>=t.length&&(e=t.splice(0,r),e.length&&n.push(M.ucs2.encode(e)));return n}function z(t){return[32,13,10,9,45].indexOf(t)!==-1}function N(t){return/[^\u0000-\u00ff]/.test(t)}var L=t("./log"),M=t("punycode"),U=t("./nodecontainer"),H=t("./textcontainer"),W=t("./pseudoelementcontainer"),X=t("./fontmetrics"),V=t("./color"),Y=t("./stackingcontext"),G=t("./utils"),J=G.bind,Q=G.getBounds,K=G.parseBackgrounds,$=G.offsetBounds;r.prototype.calculateOverflowClips=function(){this.nodes.forEach(function(t){if(q(t)){T(t)&&t.appendToDOM(),t.borders=this.parseBorders(t);var e="hidden"===t.css("overflow")?[t.borders.clip]:[],n=t.parseClip();n&&["absolute","fixed"].indexOf(t.css("position"))!==-1&&e.push([["rect",t.bounds.left+n.left,t.bounds.top+n.top,n.right-n.left,n.bottom-n.top]]),t.clip=i(t)?t.parent.clip.concat(e):e,t.backgroundClip="hidden"!==t.css("overflow")?t.clip.concat([t.borders.clip]):t.clip,T(t)&&t.cleanDOM()}else P(t)&&(t.clip=i(t)?t.parent.clip:[]);T(t)||(t.bounds=null)},this)},r.prototype.asyncRenderer=function(t,e,n){n=n||Date.now(),this.paint(t[this.renderIndex++]),t.length===this.renderIndex?e():n+20>Date.now()?this.asyncRenderer(t,e,n):setTimeout(J(function(){this.asyncRenderer(t,e)},this),0)},r.prototype.createPseudoHideStyles=function(t){this.createStyles(t,"."+W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+':before { content: "" !important; display: none !important; }.'+W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER+':after { content: "" !important; display: none !important; }')},r.prototype.disableAnimations=function(t){this.createStyles(t,"* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; -webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}")},r.prototype.createStyles=function(t,e){var n=t.createElement("style");n.innerHTML=e,t.body.appendChild(n)},r.prototype.getPseudoElements=function(t){var e=[[t]];if(t.node.nodeType===Node.ELEMENT_NODE){var n=this.getPseudoElement(t,":before"),r=this.getPseudoElement(t,":after");n&&e.push(n),r&&e.push(r)}return B(e)},r.prototype.getPseudoElement=function(t,e){var n=t.computedStyle(e);if(!n||!n.content||"none"===n.content||"-moz-alt-content"===n.content||"none"===n.display)return null;for(var r=D(n.content),i="url"===r.substr(0,3),a=document.createElement(i?"img":"html2canvaspseudoelement"),s=new W(a,t,e),c=n.length-1;c>=0;c--){var l=o(n.item(c));a.style[l]=n[l]}if(a.className=W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+" "+W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER,i)return a.src=K(r)[0].args[0],[s];var u=document.createTextNode(r);return a.appendChild(u),[s,new H(u,s)]},r.prototype.getChildren=function(t){return B([].filter.call(t.node.childNodes,x).map(function(e){var n=[e.nodeType===Node.TEXT_NODE?new H(e,t):new U(e,t)].filter(R);return e.nodeType===Node.ELEMENT_NODE&&n.length&&"TEXTAREA"!==e.tagName?n[0].isElementVisible()?n.concat(this.getChildren(n[0])):[]:n},this))},r.prototype.newStackingContext=function(t,e){var n=new Y(e,t.getOpacity(),t.node,t.parent);t.cloneTo(n);var r=e?n.getParentStack(this):n.parent.stack;r.contexts.push(n),t.stack=n},r.prototype.createStackingContexts=function(){this.nodes.forEach(function(t){q(t)&&(this.isRootElement(t)||E(t)||k(t)||this.isBodyWithTransparentRoot(t)||t.hasTransform())?this.newStackingContext(t,!0):q(t)&&(_(t)&&g(t)||A(t)||C(t))?this.newStackingContext(t,!1):t.assignStack(t.parent.stack)},this)},r.prototype.isBodyWithTransparentRoot=function(t){return"BODY"===t.node.nodeName&&t.parent.color("backgroundColor").isTransparent()},r.prototype.isRootElement=function(t){return null===t.parent},r.prototype.sortStackingContexts=function(t){t.contexts.sort(I(t.contexts.slice(0))),t.contexts.forEach(this.sortStackingContexts,this)},r.prototype.parseTextBounds=function(t){return function(e,n,r){if("none"!==t.parent.css("textDecoration").substr(0,4)||0!==e.trim().length){if(this.support.rangeBounds&&!t.parent.hasTransform()){var i=r.slice(0,n).join("").length;return this.getRangeBounds(t.node,i,e.length)}if(t.node&&"string"==typeof t.node.data){var o=t.node.splitText(e.length),a=this.getWrapperBounds(t.node,t.parent.hasTransform());return t.node=o,a}}else this.support.rangeBounds&&!t.parent.hasTransform()||(t.node=t.node.splitText(e.length));return{}}},r.prototype.getWrapperBounds=function(t,e){var n=t.ownerDocument.createElement("html2canvaswrapper"),r=t.parentNode,i=t.cloneNode(!0);n.appendChild(t.cloneNode(!0)),r.replaceChild(n,t);var o=e?$(n):Q(n);return r.replaceChild(i,n),o},r.prototype.getRangeBounds=function(t,e,n){var r=this.range||(this.range=t.ownerDocument.createRange());return r.setStart(t,e),r.setEnd(t,e+n),r.getBoundingClientRect()},r.prototype.parse=function(t){var e=t.contexts.filter(d),n=t.children.filter(q),r=n.filter(S(C)),i=r.filter(S(_)).filter(S(m)),o=n.filter(S(_)).filter(C),s=r.filter(S(_)).filter(m),c=t.contexts.concat(r.filter(_)).filter(g),l=t.children.filter(P).filter(y),u=t.contexts.filter(p);e.concat(i).concat(o).concat(s).concat(c).concat(l).concat(u).forEach(function(t){this.renderQueue.push(t),w(t)&&(this.parse(t),this.renderQueue.push(new a))},this)},r.prototype.paint=function(t){try{t instanceof a?this.renderer.ctx.restore():P(t)?(T(t.parent)&&t.parent.appendToDOM(),this.paintText(t),T(t.parent)&&t.parent.cleanDOM()):this.paintNode(t)}catch(t){if(L(t),this.options.strict)throw t}},r.prototype.paintNode=function(t){w(t)&&(this.renderer.setOpacity(t.opacity),this.renderer.ctx.save(),t.hasTransform()&&this.renderer.setTransform(t.parseTransform())),"INPUT"===t.node.nodeName&&"checkbox"===t.node.type?this.paintCheckbox(t):"INPUT"===t.node.nodeName&&"radio"===t.node.type?this.paintRadio(t):this.paintElement(t)},r.prototype.paintElement=function(t){var e=t.parseBounds();this.renderer.clip(t.backgroundClip,function(){this.renderer.renderBackground(t,e,t.borders.borders.map(F))},this),this.renderer.clip(t.clip,function(){this.renderer.renderBorders(t.borders.borders)},this),this.renderer.clip(t.backgroundClip,function(){switch(t.node.nodeName){case"svg":case"IFRAME":var n=this.images.get(t.node);n?this.renderer.renderImage(t,e,t.borders,n):L("Error loading <"+t.node.nodeName+">",t.node);break;case"IMG":var r=this.images.get(t.node.src);r?this.renderer.renderImage(t,e,t.borders,r):L("Error loading <img>",t.node.src);break;case"CANVAS":this.renderer.renderImage(t,e,t.borders,{image:t.node});break;case"SELECT":case"INPUT":case"TEXTAREA":this.paintFormValue(t)}},this)},r.prototype.paintCheckbox=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height),r={width:n-1,height:n-1,top:e.top,left:e.left},i=[3,3],o=[i,i,i,i],a=[1,1,1,1].map(function(t){return{color:new V("#A5A5A5"),width:t}}),c=l(r,o,a);this.renderer.clip(t.backgroundClip,function(){this.renderer.rectangle(r.left+1,r.top+1,r.width-2,r.height-2,new V("#DEDEDE")),this.renderer.renderBorders(s(a,r,c,o)),t.node.checked&&(this.renderer.font(new V("#424242"),"normal","normal","bold",n-3+"px","arial"),this.renderer.text("✔",r.left+n/6,r.top+n-1))},this)},r.prototype.paintRadio=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height)-2;this.renderer.clip(t.backgroundClip,function(){this.renderer.circleStroke(e.left+1,e.top+1,n,new V("#DEDEDE"),1,new V("#A5A5A5")),t.node.checked&&this.renderer.circle(Math.ceil(e.left+n/4)+1,Math.ceil(e.top+n/4)+1,Math.floor(n/2),new V("#424242"))},this)},r.prototype.paintFormValue=function(t){var e=t.getValue();if(e.length>0){var n=t.node.ownerDocument,r=n.createElement("html2canvaswrapper"),i=["lineHeight","textAlign","fontFamily","fontWeight","fontSize","color","paddingLeft","paddingTop","paddingRight","paddingBottom","width","height","borderLeftStyle","borderTopStyle","borderLeftWidth","borderTopWidth","boxSizing","whiteSpace","wordWrap"];i.forEach(function(e){try{r.style[e]=t.css(e)}catch(t){L("html2canvas: Parse: Exception caught in renderFormValue: "+t.message)}});var o=t.parseBounds();r.style.position="fixed",r.style.left=o.left+"px",r.style.top=o.top+"px",r.textContent=e,n.body.appendChild(r),this.paintText(new H(r.firstChild,t)),n.body.removeChild(r)}},r.prototype.paintText=function(t){t.applyTextTransform();var e=M.ucs2.decode(t.node.data),n=this.options.letterRendering&&!v(t)||N(t.node.data)?e.map(function(t){return M.ucs2.encode([t])}):j(e),r=t.parent.fontWeight(),i=t.parent.css("fontSize"),o=t.parent.css("fontFamily"),a=t.parent.parseTextShadows();this.renderer.font(t.parent.color("color"),t.parent.css("fontStyle"),t.parent.css("fontVariant"),r,i,o),a.length?this.renderer.fontShadow(a[0].color,a[0].offsetX,a[0].offsetY,a[0].blur):this.renderer.clearShadow(),this.renderer.clip(t.parent.clip,function(){n.map(this.parseTextBounds(t),this).forEach(function(e,r){e&&(this.renderer.text(n[r],e.left,e.bottom),this.renderTextDecoration(t.parent,e,this.fontMetrics.getMetrics(o,i)))},this)},this)},r.prototype.renderTextDecoration=function(t,e,n){switch(t.css("textDecoration").split(" ")[0]){case"underline":this.renderer.rectangle(e.left,Math.round(e.top+n.baseline+n.lineWidth),e.width,1,t.color("color"));break;case"overline":this.renderer.rectangle(e.left,Math.round(e.top),e.width,1,t.color("color"));break;case"line-through":this.renderer.rectangle(e.left,Math.ceil(e.top+n.middle+n.lineWidth),e.width,1,t.color("color"))}};var Z={inset:[["darken",.6],["darken",.1],["darken",.1],["darken",.6]]};r.prototype.parseBorders=function(t){var e=t.parseBounds(),n=b(t),r=["Top","Right","Bottom","Left"].map(function(e,n){var r=t.css("border"+e+"Style"),i=t.color("border"+e+"Color");"inset"===r&&i.isBlack()&&(i=new V([255,255,255,i.a]));var o=Z[r]?Z[r][n]:null;return{width:t.cssInt("border"+e+"Width"),color:o?i[o[0]](o[1]):i,args:null}}),i=l(e,n,r);return{clip:this.parseBackgroundClip(t,i,r,n,e),borders:s(r,e,i,n)}},r.prototype.parseBackgroundClip=function(t,e,n,r,i){var o=t.css("backgroundClip"),a=[];switch(o){case"content-box":case"padding-box":f(a,r[0],r[1],e.topLeftInner,e.topRightInner,i.left+n[3].width,i.top+n[0].width),f(a,r[1],r[2],e.topRightInner,e.bottomRightInner,i.left+i.width-n[1].width,i.top+n[0].width),f(a,r[2],r[3],e.bottomRightInner,e.bottomLeftInner,i.left+i.width-n[1].width,i.top+i.height-n[2].width),f(a,r[3],r[0],e.bottomLeftInner,e.topLeftInner,i.left+n[3].width,i.top+i.height-n[2].width);break;default:f(a,r[0],r[1],e.topLeftOuter,e.topRightOuter,i.left,i.top),f(a,r[1],r[2],e.topRightOuter,e.bottomRightOuter,i.left+i.width,i.top),f(a,r[2],r[3],e.bottomRightOuter,e.bottomLeftOuter,i.left+i.width,i.top+i.height),f(a,r[3],r[0],e.bottomLeftOuter,e.topLeftOuter,i.left,i.top+i.height)}return a},e.exports=r},{"./color":3,"./fontmetrics":7,"./log":13,"./nodecontainer":14,"./pseudoelementcontainer":18,"./stackingcontext":21,"./textcontainer":25,"./utils":26,punycode:1}],16:[function(t,e,n){function r(t,e,n){var r="withCredentials"in new XMLHttpRequest;if(!e)return Promise.reject("No proxy configured");var i=a(r),c=s(e,t,i);return r?u(c):o(n,c,i).then(function(t){return p(t.content)})}function i(t,e,n){var r="crossOrigin"in new Image,i=a(r),c=s(e,t,i);return r?Promise.resolve(c):o(n,c,i).then(function(t){return"data:"+t.type+";base64,"+t.content})}function o(t,e,n){return new Promise(function(r,i){var o=t.createElement("script"),a=function(){delete window.html2canvas.proxy[n],t.body.removeChild(o)};window.html2canvas.proxy[n]=function(t){a(),r(t)},o.src=e,o.onerror=function(t){a(),i(t)},t.body.appendChild(o)})}function a(t){return t?"":"html2canvas_"+Date.now()+"_"+ ++g+"_"+Math.round(1e5*Math.random())}function s(t,e,n){return t+"?url="+encodeURIComponent(e)+(n.length?"&callback=html2canvas.proxy."+n:"")}function c(t){return function(e){var n,r=new DOMParser;try{n=r.parseFromString(e,"text/html")}catch(t){f("DOMParser not supported, falling back to createHTMLDocument"),n=document.implementation.createHTMLDocument("");try{n.open(),n.write(e),n.close()}catch(t){f("createHTMLDocument write not supported, falling back to document.body.innerHTML"),n.body.innerHTML=e}}var i=n.querySelector("base");if(!i||!i.href.host){var o=n.createElement("base");o.href=t,n.head.insertBefore(o,n.head.firstChild)}return n}}function l(t,e,n,i,o,a){return new r(t,e,window.document).then(c(t)).then(function(t){return d(t,n,i,o,a,0,0)})}var u=t("./xhr"),h=t("./utils"),f=t("./log"),d=t("./clone"),p=h.decode64,g=0;n.Proxy=r,n.ProxyURL=i,n.loadUrlDocument=l},{"./clone":2,"./log":13,"./utils":26,"./xhr":28}],17:[function(t,e,n){function r(t,e){var n=document.createElement("a");n.href=t,t=n.href,this.src=t,this.image=new Image;var r=this;this.promise=new Promise(function(n,o){r.image.crossOrigin="Anonymous",r.image.onload=n,r.image.onerror=o,new i(t,e,document).then(function(t){r.image.src=t}).catch(o)})}var i=t("./proxy").ProxyURL;e.exports=r},{"./proxy":16}],18:[function(t,e,n){function r(t,e,n){i.call(this,t,e),this.isPseudoElement=!0,this.before=":before"===n}var i=t("./nodecontainer");r.prototype.cloneTo=function(t){r.prototype.cloneTo.call(this,t),t.isPseudoElement=!0,t.before=this.before},r.prototype=Object.create(i.prototype),r.prototype.appendToDOM=function(){this.before?this.parent.node.insertBefore(this.node,this.parent.node.firstChild):this.parent.node.appendChild(this.node),this.parent.node.className+=" "+this.getHideClass()},r.prototype.cleanDOM=function(){this.node.parentNode.removeChild(this.node),this.parent.node.className=this.parent.node.className.replace(this.getHideClass(),"")},r.prototype.getHideClass=function(){return this["PSEUDO_HIDE_ELEMENT_CLASS_"+(this.before?"BEFORE":"AFTER")]},r.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE="___html2canvas___pseudoelement_before",r.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER="___html2canvas___pseudoelement_after",e.exports=r},{"./nodecontainer":14}],19:[function(t,e,n){function r(t,e,n,r,i){this.width=t,this.height=e,this.images=n,this.options=r,this.document=i}var i=t("./log");r.prototype.renderImage=function(t,e,n,r){var i=t.cssInt("paddingLeft"),o=t.cssInt("paddingTop"),a=t.cssInt("paddingRight"),s=t.cssInt("paddingBottom"),c=n.borders,l=e.width-(c[1].width+c[3].width+i+a),u=e.height-(c[0].width+c[2].width+o+s);this.drawImage(r,0,0,r.image.width||l,r.image.height||u,e.left+i+c[3].width,e.top+o+c[0].width,l,u)},r.prototype.renderBackground=function(t,e,n){e.height>0&&e.width>0&&(this.renderBackgroundColor(t,e),this.renderBackgroundImage(t,e,n))},r.prototype.renderBackgroundColor=function(t,e){var n=t.color("backgroundColor");n.isTransparent()||this.rectangle(e.left,e.top,e.width,e.height,n)},r.prototype.renderBorders=function(t){t.forEach(this.renderBorder,this)},r.prototype.renderBorder=function(t){t.color.isTransparent()||null===t.args||this.drawShape(t.args,t.color)},r.prototype.renderBackgroundImage=function(t,e,n){var r=t.parseBackgroundImages();r.reverse().forEach(function(r,o,a){switch(r.method){case"url":var s=this.images.get(r.args[0]);s?this.renderBackgroundRepeating(t,e,s,a.length-(o+1),n):i("Error loading background-image",r.args[0]);break;case"linear-gradient":case"gradient":var c=this.images.get(r.value);c?this.renderBackgroundGradient(c,e,n):i("Error loading background-image",r.args[0]);break;case"none":break;default:i("Unknown background-image type",r.args[0])}},this)},r.prototype.renderBackgroundRepeating=function(t,e,n,r,i){var o=t.parseBackgroundSize(e,n.image,r),a=t.parseBackgroundPosition(e,n.image,r,o),s=t.parseBackgroundRepeat(r);switch(s){case"repeat-x":case"repeat no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+i[3],e.top+a.top+i[0],99999,o.height,i);break;case"repeat-y":case"no-repeat repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+i[0],o.width,99999,i);break;case"no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+a.top+i[0],o.width,o.height,i);break;default:this.renderBackgroundRepeat(n,a,o,{top:e.top,left:e.left},i[3],i[0])}},e.exports=r},{"./log":13}],20:[function(t,e,n){function r(t,e){o.apply(this,arguments),this.canvas=this.options.canvas||this.document.createElement("canvas"),this.options.canvas||(this.canvas.width=t,this.canvas.height=e),this.ctx=this.canvas.getContext("2d"),this.taintCtx=this.document.createElement("canvas").getContext("2d"),this.ctx.textBaseline="bottom",this.variables={},s("Initialized CanvasRenderer with size",t,"x",e)}function i(t){return t.length>0}var o=t("../renderer"),a=t("../lineargradientcontainer"),s=t("../log");r.prototype=Object.create(o.prototype),r.prototype.setFillStyle=function(t){return this.ctx.fillStyle="object"==typeof t&&t.isColor?t.toString():t,this.ctx},r.prototype.rectangle=function(t,e,n,r,i){this.setFillStyle(i).fillRect(t,e,n,r)},r.prototype.circle=function(t,e,n,r){this.setFillStyle(r),this.ctx.beginPath(),this.ctx.arc(t+n/2,e+n/2,n/2,0,2*Math.PI,!0),this.ctx.closePath(),this.ctx.fill()},r.prototype.circleStroke=function(t,e,n,r,i,o){this.circle(t,e,n,r),this.ctx.strokeStyle=o.toString(),this.ctx.stroke()},r.prototype.drawShape=function(t,e){this.shape(t),this.setFillStyle(e).fill()},r.prototype.taints=function(t){if(null===t.tainted){this.taintCtx.drawImage(t.image,0,0);try{this.taintCtx.getImageData(0,0,1,1),t.tainted=!1}catch(e){this.taintCtx=document.createElement("canvas").getContext("2d"),t.tainted=!0}}return t.tainted},r.prototype.drawImage=function(t,e,n,r,i,o,a,s,c){this.taints(t)&&!this.options.allowTaint||this.ctx.drawImage(t.image,e,n,r,i,o,a,s,c)},r.prototype.clip=function(t,e,n){this.ctx.save(),t.filter(i).forEach(function(t){this.shape(t).clip()},this),e.call(n),this.ctx.restore()},r.prototype.shape=function(t){return this.ctx.beginPath(),t.forEach(function(t,e){"rect"===t[0]?this.ctx.rect.apply(this.ctx,t.slice(1)):this.ctx[0===e?"moveTo":t[0]+"To"].apply(this.ctx,t.slice(1))},this),this.ctx.closePath(),this.ctx},r.prototype.font=function(t,e,n,r,i,o){this.setFillStyle(t).font=[e,n,r,i,o].join(" ").split(",")[0]},r.prototype.fontShadow=function(t,e,n,r){this.setVariable("shadowColor",t.toString()).setVariable("shadowOffsetY",e).setVariable("shadowOffsetX",n).setVariable("shadowBlur",r)},r.prototype.clearShadow=function(){this.setVariable("shadowColor","rgba(0,0,0,0)")},r.prototype.setOpacity=function(t){this.ctx.globalAlpha=t},r.prototype.setTransform=function(t){this.ctx.translate(t.origin[0],t.origin[1]),this.ctx.transform.apply(this.ctx,t.matrix),this.ctx.translate(-t.origin[0],-t.origin[1])},r.prototype.setVariable=function(t,e){return this.variables[t]!==e&&(this.variables[t]=this.ctx[t]=e),this},r.prototype.text=function(t,e,n){this.ctx.fillText(t,e,n)},r.prototype.backgroundRepeatShape=function(t,e,n,r,i,o,a,s,c){var l=[["line",Math.round(i),Math.round(o)],["line",Math.round(i+a),Math.round(o)],["line",Math.round(i+a),Math.round(s+o)],["line",Math.round(i),Math.round(s+o)]];this.clip([l],function(){this.renderBackgroundRepeat(t,e,n,r,c[3],c[0])},this)},r.prototype.renderBackgroundRepeat=function(t,e,n,r,i,o){var a=Math.round(r.left+e.left+i),s=Math.round(r.top+e.top+o);this.setFillStyle(this.ctx.createPattern(this.resizeImage(t,n),"repeat")),this.ctx.translate(a,s),this.ctx.fill(),this.ctx.translate(-a,-s)},r.prototype.renderBackgroundGradient=function(t,e){if(t instanceof a){var n=this.ctx.createLinearGradient(e.left+e.width*t.x0,e.top+e.height*t.y0,e.left+e.width*t.x1,e.top+e.height*t.y1);t.colorStops.forEach(function(t){n.addColorStop(t.stop,t.color.toString())}),this.rectangle(e.left,e.top,e.width,e.height,n)}},r.prototype.resizeImage=function(t,e){var n=t.image;if(n.width===e.width&&n.height===e.height)return n;var r,i=document.createElement("canvas");return i.width=e.width,i.height=e.height,r=i.getContext("2d"),r.drawImage(n,0,0,n.width,n.height,0,0,e.width,e.height),i},e.exports=r},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(t,e,n){function r(t,e,n,r){i.call(this,n,r),this.ownStacking=t,this.contexts=[],this.children=[],this.opacity=(this.parent?this.parent.stack.opacity:1)*e}var i=t("./nodecontainer");r.prototype=Object.create(i.prototype),r.prototype.getParentStack=function(t){var e=this.parent?this.parent.stack:null;return e?e.ownStacking?e:e.getParentStack(t):t.stack},e.exports=r},{"./nodecontainer":14}],22:[function(t,e,n){function r(t){this.rangeBounds=this.testRangeBounds(t),this.cors=this.testCORS(),this.svg=this.testSVG()}r.prototype.testRangeBounds=function(t){var e,n,r,i,o=!1;return t.createRange&&(e=t.createRange(),e.getBoundingClientRect&&(n=t.createElement("boundtest"),n.style.height="123px",n.style.display="block",t.body.appendChild(n),e.selectNode(n),r=e.getBoundingClientRect(),i=r.height,123===i&&(o=!0),t.body.removeChild(n))),o},r.prototype.testCORS=function(){return"undefined"!=typeof(new Image).crossOrigin},r.prototype.testSVG=function(){var t=new Image,e=document.createElement("canvas"),n=e.getContext("2d");t.src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";try{n.drawImage(t,0,0),e.toDataURL()}catch(t){return!1}return!0},e.exports=r},{}],23:[function(t,e,n){function r(t){this.src=t,this.image=null;var e=this;this.promise=this.hasFabric().then(function(){return e.isInline(t)?Promise.resolve(e.inlineFormatting(t)):i(t)}).then(function(t){return new Promise(function(n){window.html2canvas.svg.fabric.loadSVGFromString(t,e.createCanvas.call(e,n))})})}var i=t("./xhr"),o=t("./utils").decode64;r.prototype.hasFabric=function(){return window.html2canvas.svg&&window.html2canvas.svg.fabric?Promise.resolve():Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg"))},r.prototype.inlineFormatting=function(t){return/^data:image\/svg\+xml;base64,/.test(t)?this.decode64(this.removeContentType(t)):this.removeContentType(t)},r.prototype.removeContentType=function(t){return t.replace(/^data:image\/svg\+xml(;base64)?,/,"")},r.prototype.isInline=function(t){return/^data:image\/svg\+xml/i.test(t)},r.prototype.createCanvas=function(t){var e=this;return function(n,r){var i=new window.html2canvas.svg.fabric.StaticCanvas("c");e.image=i.lowerCanvasEl,i.setWidth(r.width).setHeight(r.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(n,r)).renderAll(),t(i.lowerCanvasEl)}},r.prototype.decode64=function(t){return"function"==typeof window.atob?window.atob(t):o(t)},e.exports=r},{"./utils":26,"./xhr":28}],24:[function(t,e,n){function r(t,e){this.src=t,this.image=null;var n=this;this.promise=e?new Promise(function(e,r){n.image=new Image,n.image.onload=e,n.image.onerror=r,n.image.src="data:image/svg+xml,"+(new XMLSerializer).serializeToString(t),n.image.complete===!0&&e(n.image)}):this.hasFabric().then(function(){return new Promise(function(e){window.html2canvas.svg.fabric.parseSVGDocument(t,n.createCanvas.call(n,e))})})}var i=t("./svgcontainer");r.prototype=Object.create(i.prototype),e.exports=r},{"./svgcontainer":23}],25:[function(t,e,n){function r(t,e){o.call(this,t,e)}function i(t,e,n){if(t.length>0)return e+n.toUpperCase()}var o=t("./nodecontainer");r.prototype=Object.create(o.prototype),r.prototype.applyTextTransform=function(){this.node.data=this.transform(this.parent.css("textTransform"))},r.prototype.transform=function(t){var e=this.node.data;switch(t){case"lowercase":return e.toLowerCase();case"capitalize":return e.replace(/(^|\s|:|-|\(|\))([a-z])/g,i);case"uppercase":return e.toUpperCase();default:return e}},e.exports=r},{"./nodecontainer":14}],26:[function(t,e,n){n.smallImage=function(){return"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"},n.bind=function(t,e){return function(){return t.apply(e,arguments)}},/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	n.decode64=function(t){var e,n,r,i,o,a,s,c,l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",u=t.length,h="";for(e=0;e<u;e+=4)n=l.indexOf(t[e]),r=l.indexOf(t[e+1]),i=l.indexOf(t[e+2]),o=l.indexOf(t[e+3]),a=n<<2|r>>4,s=(15&r)<<4|i>>2,c=(3&i)<<6|o,h+=64===i?String.fromCharCode(a):64===o||o===-1?String.fromCharCode(a,s):String.fromCharCode(a,s,c);return h},n.getBounds=function(t){if(t.getBoundingClientRect){var e=t.getBoundingClientRect(),n=null==t.offsetWidth?e.width:t.offsetWidth;return{top:e.top,bottom:e.bottom||e.top+e.height,right:e.left+n,left:e.left,width:n,height:null==t.offsetHeight?e.height:t.offsetHeight}}return{}},n.offsetBounds=function(t){var e=t.offsetParent?n.offsetBounds(t.offsetParent):{top:0,left:0};return{top:t.offsetTop+e.top,bottom:t.offsetTop+t.offsetHeight+e.top,right:t.offsetLeft+e.left+t.offsetWidth,left:t.offsetLeft+e.left,width:t.offsetWidth,height:t.offsetHeight}},n.parseBackgrounds=function(t){var e,n,r,i,o,a,s,c=" \r\n\t",l=[],u=0,h=0,f=function(){e&&('"'===n.substr(0,1)&&(n=n.substr(1,n.length-2)),n&&s.push(n),"-"===e.substr(0,1)&&(i=e.indexOf("-",1)+1)>0&&(r=e.substr(0,i),e=e.substr(i)),l.push({prefix:r,method:e.toLowerCase(),value:o,args:s,image:null})),s=[],e=r=n=o=""};return s=[],e=r=n=o="",t.split("").forEach(function(t){if(!(0===u&&c.indexOf(t)>-1)){switch(t){case'"':a?a===t&&(a=null):a=t;break;case"(":if(a)break;if(0===u)return u=1,void(o+=t);h++;break;case")":if(a)break;if(1===u){if(0===h)return u=0,o+=t,void f();h--}break;case",":if(a)break;if(0===u)return void f();if(1===u&&0===h&&!e.match(/^url$/i))return s.push(n),n="",void(o+=t)}o+=t,0===u?e+=t:n+=t}}),f(),l}},{}],27:[function(t,e,n){function r(t){i.apply(this,arguments),this.type="linear"===t.args[0]?i.TYPES.LINEAR:i.TYPES.RADIAL}var i=t("./gradientcontainer");r.prototype=Object.create(i.prototype),e.exports=r},{"./gradientcontainer":9}],28:[function(t,e,n){function r(t){return new Promise(function(e,n){var r=new XMLHttpRequest;r.open("GET",t),r.onload=function(){200===r.status?e(r.responseText):n(new Error(r.statusText))},r.onerror=function(){n(new Error("Network Error"))},r.send()})}e.exports=r},{}]},{},[4])(4)}),/*
	# PNG.js
	# Copyright (c) 2011 Devon Govett
	# MIT LICENSE
	# 
	# 
	*/
	function(t){var e;e=function(){function e(t){var e,n,r,i,o,a,s,c,l,u,h,f,d,p,g;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),u=function(){var t,e;for(e=[],s=t=0;t<4;s=++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===u&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,s=d=0;0<=e?d<e:d>e;s=0<=e?++d:--d)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(h=r-this.transparency.indexed.length,h>0)for(s=p=0;0<=h?p<h:p>h;s=0<=h?++p:--p)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":f=this.read(e),c=f.indexOf(0),l=String.fromCharCode.apply(String,f.slice(0,c)),this.text[l]=String.fromCharCode.apply(String,f.slice(c+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(g=this.colorType)||6===g,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}var n,r,i,o,a,s,l,u;e.load=function(t,n,r){var i;return"function"==typeof n&&(r=n),i=new XMLHttpRequest,i.open("GET",t,!0),i.responseType="arraybuffer",i.onload=function(){var t,o;return t=new Uint8Array(i.response||i.mozResponseArrayBuffer),o=new e(t),"function"==typeof(null!=n?n.getContext:void 0)&&o.render(n),"function"==typeof r?r(o):void 0},i.send(null)},o=0,i=1,a=2,r=0,n=1,e.prototype.read=function(t){var e,n,r;for(r=[],e=n=0;0<=t?n<t:n>t;e=0<=t?++n:--n)r.push(this.data[this.pos++]);return r},e.prototype.readUInt32=function(){var t,e,n,r;return t=this.data[this.pos++]<<24,e=this.data[this.pos++]<<16,n=this.data[this.pos++]<<8,r=this.data[this.pos++],t|e|n|r},e.prototype.readUInt16=function(){var t,e;return t=this.data[this.pos++]<<8,e=this.data[this.pos++],t|e},e.prototype.decodePixels=function(t){var e,n,r,i,o,a,s,l,u,h,f,d,p,g,m,w,y,v,b,x,k,_,C;if(null==t&&(t=this.imgData),0===t.length)return new Uint8Array(0);for(t=new c(t),t=t.getBytes(),d=this.pixelBitlength/8,w=d*this.width,p=new Uint8Array(w*this.height),a=t.length,m=0,g=0,n=0;g<a;){switch(t[g++]){case 0:for(i=b=0;b<w;i=b+=1)p[n++]=t[g++];break;case 1:for(i=x=0;x<w;i=x+=1)e=t[g++],o=i<d?0:p[n-d],p[n++]=(e+o)%256;break;case 2:for(i=k=0;k<w;i=k+=1)e=t[g++],r=(i-i%d)/d,y=m&&p[(m-1)*w+r*d+i%d],p[n++]=(y+e)%256;break;case 3:for(i=_=0;_<w;i=_+=1)e=t[g++],r=(i-i%d)/d,o=i<d?0:p[n-d],y=m&&p[(m-1)*w+r*d+i%d],p[n++]=(e+Math.floor((o+y)/2))%256;break;case 4:for(i=C=0;C<w;i=C+=1)e=t[g++],r=(i-i%d)/d,o=i<d?0:p[n-d],0===m?y=v=0:(y=p[(m-1)*w+r*d+i%d],v=r&&p[(m-1)*w+(r-1)*d+i%d]),s=o+y-v,l=Math.abs(s-o),h=Math.abs(s-y),f=Math.abs(s-v),u=l<=h&&l<=f?o:h<=f?y:v,p[n++]=(e+u)%256;break;default:throw new Error("Invalid filter algorithm: "+t[g-1])}m++}return p},e.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,c,l;for(r=this.palette,a=this.transparency.indexed||[],o=new Uint8Array((a.length||0)+r.length),i=0,n=r.length,t=0,e=s=0,c=r.length;s<c;e=s+=3)o[i++]=r[e],o[i++]=r[e+1],o[i++]=r[e+2],o[i++]=null!=(l=a[t++])?l:255;return o},e.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,c,l,u,h,f;if(r=this.colors,u=null,n=this.hasAlphaChannel,this.palette.length&&(u=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),i=t.data||t,l=i.length,a=u||e,o=s=0,1===r)for(;o<l;)c=u?4*e[o/4]:s,h=a[c++],i[o++]=h,i[o++]=h,i[o++]=h,i[o++]=n?a[c++]:255,s=c;else for(;o<l;)c=u?4*e[o/4]:s,i[o++]=a[c++],i[o++]=a[c++],i[o++]=a[c++],i[o++]=n?a[c++]:255,s=c},e.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{l=t.document.createElement("canvas"),u=l.getContext("2d")}catch(t){return-1}return s=function(t){var e;return u.width=t.width,u.height=t.height,u.clearRect(0,0,t.width,t.height),u.putImageData(t,0,0),e=new Image,e.src=l.toDataURL(),e},e.prototype.decodeFrames=function(t){var e,n,r,i,o,a,c,l;if(this.animation){for(c=this.animation.frames,l=[],n=o=0,a=c.length;o<a;n=++o)e=c[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,l.push(e.image=s(r));return l}},e.prototype.renderFrame=function(t,e){var n,o,s;return o=this.animation.frames,n=o[e],s=o[e-1],0===e&&t.clearRect(0,0,this.width,this.height),(null!=s?s.disposeOp:void 0)===i?t.clearRect(s.xOffset,s.yOffset,s.width,s.height):(null!=s?s.disposeOp:void 0)===a&&t.putImageData(s.imageData,s.xOffset,s.yOffset),n.blendOp===r&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},e.prototype.animate=function(t){var e,n,r,i,o,a,s=this;return n=0,a=this.animation,i=a.numFrames,r=a.frames,o=a.numPlays,(e=function(){var a,c;if(a=n++%i,c=r[a],s.renderFrame(t,a),i>1&&n/i<o)return s.animation._timeout=setTimeout(e,c.delay)})()},e.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},e.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},e}(),t.PNG=e}("undefined"!=typeof window&&window||void 0);/*
	 * Extracted from pdf.js
	 * https://github.com/andreasgal/pdf.js
	 *
	 * Copyright (c) 2011 Mozilla Foundation
	 *
	 * Contributors: Andreas Gal <gal@mozilla.com>
	 *               Chris G Jones <cjones@mozilla.com>
	 *               Shaon Barman <shaon.barman@gmail.com>
	 *               Vivien Nicolas <21@vingtetun.org>
	 *               Justin D'Arcangelo <justindarc@gmail.com>
	 *               Yury Delendik
	 *
	 * 
	 */
	var s=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;n>r&&(n=r)}else{for(;!this.eof;)this.readBlock();var n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),c=function(){function t(t){throw new Error(t)}function e(e){var n=0,r=e[n++],i=e[n++];r!=-1&&i!=-1||t("Invalid header in flate stream"),8!=(15&r)&&t("Unknown compression method in flate stream"),((r<<8)+i)%31!=0&&t("Bad FCHECK in flate stream"),32&i&&t("FDICT bit set in flate stream"),this.bytes=e,this.bytesPos=n,this.codeSize=0,this.codeBuf=0,s.call(this)}if("undefined"!=typeof Uint32Array){var n=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),r=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),i=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),o=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],a=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return e.prototype=Object.create(s.prototype),e.prototype.getBits=function(e){for(var n,r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<e;)"undefined"==typeof(n=o[a++])&&t("Bad encoding in flate stream"),i|=n<<r,r+=8;return n=i&(1<<e)-1,this.codeBuf=i>>e,this.codeSize=r-=e,this.bytesPos=a,n},e.prototype.getCode=function(e){for(var n=e[0],r=e[1],i=this.codeSize,o=this.codeBuf,a=this.bytes,s=this.bytesPos;i<r;){var c;"undefined"==typeof(c=a[s++])&&t("Bad encoding in flate stream"),o|=c<<i,i+=8}var l=n[o&(1<<r)-1],u=l>>16,h=65535&l;return(0==i||i<u||0==u)&&t("Bad encoding in flate stream"),this.codeBuf=o>>u,this.codeSize=i-u,this.bytesPos=s,h},e.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,c=2;a<=n;++a,s<<=1,c<<=1)for(var l=0;l<e;++l)if(t[l]==a){for(var u=0,h=s,r=0;r<a;++r)u=u<<1|1&h,h>>=1;for(var r=u;r<i;r+=c)o[r]=a<<16|l;++s}return[o,n]},e.prototype.readBlock=function(){function e(t,e,n,r,i){for(var o=t.getBits(n)+r;o-- >0;)e[_++]=i}var s=this.getBits(3);if(1&s&&(this.eof=!0),s>>=1,0==s){var c,l=this.bytes,u=this.bytesPos;"undefined"==typeof(c=l[u++])&&t("Bad block header in flate stream");var h=c;"undefined"==typeof(c=l[u++])&&t("Bad block header in flate stream"),h|=c<<8,"undefined"==typeof(c=l[u++])&&t("Bad block header in flate stream");var f=c;"undefined"==typeof(c=l[u++])&&t("Bad block header in flate stream"),f|=c<<8,f!=(65535&~h)&&t("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var d=this.bufferLength,p=this.ensureBuffer(d+h),g=d+h;this.bufferLength=g;for(var m=d;m<g;++m){if("undefined"==typeof(c=l[u++])){this.eof=!0;break}p[m]=c}return void(this.bytesPos=u)}var w,y;if(1==s)w=o,y=a;else if(2==s){for(var v=this.getBits(5)+257,b=this.getBits(5)+1,x=this.getBits(4)+4,k=Array(n.length),_=0;_<x;)k[n[_++]]=this.getBits(3);for(var C=this.generateHuffmanTable(k),A=0,_=0,S=v+b,q=new Array(S);_<S;){var T=this.getCode(C);16==T?e(this,q,2,3,A):17==T?e(this,q,3,3,A=0):18==T?e(this,q,7,11,A=0):q[_++]=A=T}w=this.generateHuffmanTable(q.slice(0,v)),y=this.generateHuffmanTable(q.slice(v,S))}else t("Unknown block type in flate stream");for(var p=this.buffer,P=p?p.length:0,I=this.bufferLength;;){var E=this.getCode(w);if(E<256)I+1>=P&&(p=this.ensureBuffer(I+1),P=p.length),p[I++]=E;else{if(256==E)return void(this.bufferLength=I);E-=257,E=r[E];var O=E>>16;O>0&&(O=this.getBits(O));var A=(65535&E)+O;E=this.getCode(y),E=i[E],O=E>>16,O>0&&(O=this.getBits(O));var F=(65535&E)+O;I+A>=P&&(p=this.ensureBuffer(I+A),P=p.length);for(var R=0;R<A;++R,++I)p[I]=p[I-F]}}},e}}();return function(t){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";"undefined"==typeof t.btoa&&(t.btoa=function(t){var n,r,i,o,a,s,c,l,u=0,h=0,f="",d=[];if(!t)return t;do n=t.charCodeAt(u++),r=t.charCodeAt(u++),i=t.charCodeAt(u++),l=n<<16|r<<8|i,o=l>>18&63,a=l>>12&63,s=l>>6&63,c=63&l,d[h++]=e.charAt(o)+e.charAt(a)+e.charAt(s)+e.charAt(c);while(u<t.length);f=d.join("");var p=t.length%3;return(p?f.slice(0,p-3):f)+"===".slice(p||3)}),"undefined"==typeof t.atob&&(t.atob=function(t){var n,r,i,o,a,s,c,l,u=0,h=0,f="",d=[];if(!t)return t;t+="";do o=e.indexOf(t.charAt(u++)),a=e.indexOf(t.charAt(u++)),s=e.indexOf(t.charAt(u++)),c=e.indexOf(t.charAt(u++)),l=o<<18|a<<12|s<<6|c,n=l>>16&255,r=l>>8&255,i=255&l,64==s?d[h++]=String.fromCharCode(n):64==c?d[h++]=String.fromCharCode(n,r):d[h++]=String.fromCharCode(n,r,i);while(u<t.length);return f=d.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(void 0===this||null===this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=arguments.length>1?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(void 0===this||null===this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Object.keys||(Object.keys=function(){var t=Object.prototype.hasOwnProperty,e=!{toString:null}.propertyIsEnumerable("toString"),n=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],r=n.length;return function(i){if("object"!=typeof i&&("function"!=typeof i||null===i))throw new TypeError;var o,a,s=[];for(o in i)t.call(i,o)&&s.push(o);if(e)for(a=0;a<r;a++)t.call(i,n[a])&&s.push(n[a]);return s}}()),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")})}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0),e});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 276 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  if (!(isArray(source) || isTypedArray(source))) {
	    var props = baseKeysIn(source);
	  }
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(434)(module)))

/***/ },
/* 278 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return basePickBy(object, props, function(value, key) {
	    return key in object;
	  });
	}
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick from.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, props, predicate) {
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Creates an array of the own and inherited enumerable symbol properties
	 * of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable string keyed properties of `object` that are
	 * not omitted.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = baseRest(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  props = arrayMap(baseFlatten(props, 1), toKey);
	  return basePick(object, baseDifference(getAllKeysIn(object), props));
	});
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = omit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _childUtils = __webpack_require__(92);
	
	var _colorManipulator = __webpack_require__(64);
	
	var _EnhancedButton = __webpack_require__(90);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FlatButtonLabel = __webpack_require__(280);
	
	var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	var FlatButton = function (_Component) {
	  (0, _inherits3.default)(FlatButton, _Component);
	
	  function FlatButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FlatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FlatButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({
	          hovered: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          children = _props.children,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          hoverColor = _props.hoverColor,
	          icon = _props.icon,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          primary = _props.primary,
	          rippleColor = _props.rippleColor,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'children', 'disabled', 'fullWidth', 'hoverColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
	      var _context$muiTheme = this.context.muiTheme,
	          borderRadius = _context$muiTheme.borderRadius,
	          _context$muiTheme$but = _context$muiTheme.button,
	          buttonHeight = _context$muiTheme$but.height,
	          buttonMinWidth = _context$muiTheme$but.minWidth,
	          buttonTextTransform = _context$muiTheme$but.textTransform,
	          _context$muiTheme$fla = _context$muiTheme.flatButton,
	          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
	          buttonColor = _context$muiTheme$fla.color,
	          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
	          fontSize = _context$muiTheme$fla.fontSize,
	          fontWeight = _context$muiTheme$fla.fontWeight,
	          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
	          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
	          textColor = _context$muiTheme$fla.textColor,
	          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
	          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;
	
	      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
	      var defaultRippleColor = buttonFilterColor;
	      var buttonHoverColor = hoverColor || defaultHoverColor;
	      var buttonRippleColor = rippleColor || defaultRippleColor;
	      var buttonBackgroundColor = backgroundColor || buttonColor;
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        height: buttonHeight,
	        lineHeight: buttonHeight + 'px',
	        minWidth: fullWidth ? '100%' : buttonMinWidth,
	        color: defaultTextColor,
	        transition: _transitions2.default.easeOut(),
	        borderRadius: borderRadius,
	        userSelect: 'none',
	        overflow: 'hidden',
	        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	        padding: 0,
	        margin: 0,
	        textAlign: 'center'
	      }, style);
	
	      var iconCloned = void 0;
	      var labelStyleIcon = {};
	
	      if (icon) {
	        var iconStyles = (0, _simpleAssign2.default)({
	          verticalAlign: 'middle',
	          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	          marginRight: label && labelPosition === 'before' ? 12 : 0
	        }, icon.props.style);
	        iconCloned = _react2.default.cloneElement(icon, {
	          color: icon.props.color || mergedRootStyles.color,
	          style: iconStyles
	        });
	
	        if (labelPosition === 'before') {
	          labelStyleIcon.paddingRight = 8;
	        } else {
	          labelStyleIcon.paddingLeft = 8;
	        }
	      }
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({
	        letterSpacing: 0,
	        textTransform: textTransform,
	        fontWeight: fontWeight,
	        fontSize: fontSize
	      }, labelStyleIcon, labelStyle);
	
	      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { label: label, style: mergedLabelStyles }) : undefined;
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          focusRippleColor: buttonRippleColor,
	          focusRippleOpacity: 0.3,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          touchRippleColor: buttonRippleColor,
	          touchRippleOpacity: 0.3
	        }),
	        enhancedButtonChildren
	      );
	    }
	  }]);
	  return FlatButton;
	}(_react.Component);
	
	FlatButton.muiName = 'FlatButton';
	FlatButton.defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  labelStyle: {},
	  labelPosition: 'after',
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onTouchStart: function onTouchStart() {},
	  primary: false,
	  secondary: false
	};
	FlatButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? FlatButton.propTypes = {
	  /**
	   * Color of button when mouse is not hovering over it.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * This is what will be displayed inside the button.
	   * If a label is specified, the text within the label prop will
	   * be displayed. Otherwise, the component will expect children
	   * which will then be displayed. (In our example,
	   * we are nesting an `<input type="file" />` and a `span`
	   * that acts as our label to be displayed.) This only
	   * applies to flat and raised buttons.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The element to use as the container for the FlatButton. Either a string to
	   * use a DOM element or a ReactElement. This is useful for wrapping the
	   * FlatButton in a custom Link component. If a ReactElement is given, ensure
	   * that it passes all of its given props through to the underlying DOM
	   * element and renders its children prop for proper integration.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Color of button when mouse hovers over.
	   */
	  hoverColor: _propTypes2.default.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * Use this property to display an icon.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * Label for the button.
	   */
	  label: validateLabel,
	  /**
	   * Place label before or after the passed children.
	   */
	  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * If true, colors button according to
	   * primaryTextColor from the Theme.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * Color for the ripple after button is clicked.
	   */
	  rippleColor: _propTypes2.default.string,
	  /**
	   * If true, colors button according to secondaryTextColor from the theme.
	   * The primary prop has precendent if set to true.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = FlatButton;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      paddingLeft: baseTheme.spacing.desktopGutterLess,
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      verticalAlign: 'middle'
	    }
	  };
	}
	
	var FlatButtonLabel = function (_Component) {
	  (0, _inherits3.default)(FlatButtonLabel, _Component);
	
	  function FlatButtonLabel() {
	    (0, _classCallCheck3.default)(this, FlatButtonLabel);
	    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FlatButtonLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        label
	      );
	    }
	  }]);
	  return FlatButtonLabel;
	}(_react.Component);
	
	FlatButtonLabel.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? FlatButtonLabel.propTypes = {
	  label: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = FlatButtonLabel;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(316);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var rounded = props.rounded,
	      circle = props.circle,
	      transitionEnabled = props.transitionEnabled,
	      zDepth = props.zDepth;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      paper = _context$muiTheme.paper,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  return {
	    root: {
	      color: paper.color,
	      backgroundColor: paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: baseTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? borderRadius : '0px'
	    }
	  };
	}
	
	var Paper = function (_Component) {
	  (0, _inherits3.default)(Paper, _Component);
	
	  function Paper() {
	    (0, _classCallCheck3.default)(this, Paper);
	    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          circle = _props.circle,
	          rounded = _props.rounded,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Paper;
	}(_react.Component);
	
	Paper.defaultProps = {
	  circle: false,
	  rounded: true,
	  transitionEnabled: true,
	  zDepth: 1
	};
	Paper.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Paper.propTypes = {
	  /**
	   * Children passed into the paper element.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Set to true to generate a circlular paper container.
	   */
	  circle: _propTypes2.default.bool,
	  /**
	   * By default, the paper container will have a border radius.
	   * Set this to false to generate a container with sharp corners.
	   */
	  rounded: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Set to false to disable CSS transitions for the paper element.
	   */
	  transitionEnabled: _propTypes2.default.bool,
	  /**
	   * This number represents the zDepth of the paper shadow.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : void 0;
	exports.default = Paper;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(64);
	
	var _childUtils = __webpack_require__(92);
	
	var _EnhancedButton = __webpack_require__(90);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _Paper = __webpack_require__(140);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      raisedButton = _context$muiTheme.raisedButton,
	      borderRadius = _context$muiTheme.borderRadius;
	  var disabled = props.disabled,
	      disabledBackgroundColor = props.disabledBackgroundColor,
	      disabledLabelColor = props.disabledLabelColor,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      label = props.label,
	      labelPosition = props.labelPosition,
	      primary = props.primary,
	      secondary = props.secondary,
	      style = props.style;
	
	
	  var amount = primary || secondary ? 0.4 : 0.08;
	
	  var backgroundColor = raisedButton.color;
	  var labelColor = raisedButton.textColor;
	
	  if (disabled) {
	    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
	    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
	  } else if (primary) {
	    backgroundColor = raisedButton.primaryColor;
	    labelColor = raisedButton.primaryTextColor;
	  } else if (secondary) {
	    backgroundColor = raisedButton.secondaryColor;
	    labelColor = raisedButton.secondaryTextColor;
	  } else {
	    if (props.backgroundColor) {
	      backgroundColor = props.backgroundColor;
	    }
	    if (props.labelColor) {
	      labelColor = props.labelColor;
	    }
	  }
	
	  var buttonHeight = style && style.height || button.height;
	
	  return {
	    root: {
	      display: 'inline-block',
	      transition: _transitions2.default.easeOut(),
	      minWidth: fullWidth ? '100%' : button.minWidth
	    },
	    button: {
	      height: buttonHeight,
	      lineHeight: buttonHeight + 'px',
	      width: '100%',
	      padding: 0,
	      borderRadius: borderRadius,
	      transition: _transitions2.default.easeOut(),
	      backgroundColor: backgroundColor,
	      // That's the default value for a button but not a link
	      textAlign: 'center'
	    },
	    label: {
	      position: 'relative',
	      opacity: 1,
	      fontSize: raisedButton.fontSize,
	      letterSpacing: 0,
	      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
	      fontWeight: raisedButton.fontWeight,
	      margin: 0,
	      userSelect: 'none',
	      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      color: labelColor
	    },
	    icon: {
	      verticalAlign: 'middle',
	      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	      marginRight: label && labelPosition === 'before' ? 12 : 0
	    },
	    overlay: {
	      height: buttonHeight,
	      borderRadius: borderRadius,
	      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    ripple: {
	      color: labelColor,
	      opacity: !(primary || secondary) ? 0.1 : 0.16
	    }
	  };
	}
	
	var RaisedButton = function (_Component) {
	  (0, _inherits3.default)(RaisedButton, _Component);
	
	  function RaisedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RaisedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaisedButton.__proto__ || (0, _getPrototypeOf2.default)(RaisedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      keyboardFocused: false,
	      touched: false,
	      initialZDepth: 0,
	      zDepth: 0
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth + 1
	        });
	      }
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.state.keyboardFocused) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth,
	          hovered: false
	        });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.keyboardFocused && !_this.state.touched) {
	        _this.setState({
	          hovered: true
	        });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth + 1
	      });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth
	      });
	
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;
	
	      _this.setState({
	        zDepth: zDepth,
	        keyboardFocused: keyboardFocused
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RaisedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var zDepth = this.props.disabled ? 0 : 1;
	      this.setState({
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var zDepth = nextProps.disabled ? 0 : 1;
	      var nextState = {
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      };
	
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          buttonStyle = _props.buttonStyle,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          disabledBackgroundColor = _props.disabledBackgroundColor,
	          disabledLabelColor = _props.disabledLabelColor,
	          fullWidth = _props.fullWidth,
	          icon = _props.icon,
	          label = _props.label,
	          labelColor = _props.labelColor,
	          labelPosition = _props.labelPosition,
	          labelStyle = _props.labelStyle,
	          overlayStyle = _props.overlayStyle,
	          primary = _props.primary,
	          rippleStyle = _props.rippleStyle,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'buttonStyle', 'children', 'className', 'disabled', 'disabledBackgroundColor', 'disabledLabelColor', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'overlayStyle', 'primary', 'rippleStyle', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);
	
	      var buttonEventHandlers = disabled ? {} : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var labelElement = label && _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var iconCloned = icon && (0, _react.cloneElement)(icon, {
	        color: icon.props.color || styles.label.color,
	        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	      });
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: this.state.zDepth
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.button, buttonStyle),
	            focusRippleColor: mergedRippleStyles.color,
	            touchRippleColor: mergedRippleStyles.color,
	            focusRippleOpacity: mergedRippleStyles.opacity,
	            touchRippleOpacity: mergedRippleStyles.opacity
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, overlayStyle))
	            },
	            enhancedButtonChildren
	          )
	        )
	      );
	    }
	  }]);
	  return RaisedButton;
	}(_react.Component);
	
	RaisedButton.muiName = 'RaisedButton';
	RaisedButton.defaultProps = {
	  disabled: false,
	  labelPosition: 'after',
	  fullWidth: false,
	  primary: false,
	  secondary: false
	};
	RaisedButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? RaisedButton.propTypes = {
	  /**
	   * Override the default background color for the button,
	   * but not the default disabled background color
	   * (use `disabledBackgroundColor` for this).
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _propTypes2.default.object,
	  /**
	   * The content of the button.
	   * If a label is provided via the `label` prop, the text within the label
	   * will be displayed in addition to the content provided here.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	    * The element to use as the container for the RaisedButton. Either a string to
	    * use a DOM element or a ReactElement. This is useful for wrapping the
	    * RaisedButton in a custom Link component. If a ReactElement is given, ensure
	    * that it passes all of its given props through to the underlying DOM
	    * element and renders its children prop for proper integration.
	    */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * If true, the button will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the default background color for the button
	   * when it is disabled.
	   */
	  disabledBackgroundColor: _propTypes2.default.string,
	  /**
	   * The color of the button's label when the button is disabled.
	   */
	  disabledLabelColor: _propTypes2.default.string,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * An icon to be displayed within the button.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * The label to be displayed within the button.
	   * If content is provided via the `children` prop, that content will be
	   * displayed in addition to the label provided here.
	   */
	  label: validateLabel,
	  /**
	   * The color of the button's label.
	   */
	  labelColor: _propTypes2.default.string,
	  /**
	   * The position of the button's label relative to the button's `children`.
	   */
	  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * Override the inline style of the button overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will use the theme's primary color.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * Override the inline style of the ripple element.
	   */
	  rippleStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will use the theme's secondary color.
	   * If both `secondary` and `primary` are true, the button will use
	   * the theme's primary color.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = RaisedButton;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var index = _ref.index;
	  var stepper = _ref2.stepper;
	  var orientation = stepper.orientation;
	
	  var styles = {
	    root: {
	      flex: '0 0 auto'
	    }
	  };
	
	  if (index > 0) {
	    if (orientation === 'horizontal') {
	      styles.root.marginLeft = -6;
	    } else if (orientation === 'vertical') {
	      styles.root.marginTop = -14;
	    }
	  }
	
	  return styles;
	};
	
	var Step = function (_Component) {
	  (0, _inherits3.default)(Step, _Component);
	
	  function Step() {
	    var _ref3;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Step.__proto__ || (0, _getPrototypeOf2.default)(Step)).call.apply(_ref3, [this].concat(args))), _this), _this.renderChild = function (child) {
	      var _this$props = _this.props,
	          active = _this$props.active,
	          completed = _this$props.completed,
	          disabled = _this$props.disabled,
	          index = _this$props.index,
	          last = _this$props.last;
	
	
	      var icon = index + 1;
	
	      return _react2.default.cloneElement(child, (0, _simpleAssign2.default)({ active: active, completed: completed, disabled: disabled, icon: icon, last: last }, child.props));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          index = _props.index,
	          last = _props.last,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'completed', 'disabled', 'index', 'last', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.Children.map(children, this.renderChild)
	      );
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	Step.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	 false ? Step.propTypes = {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Should be `Step` sub-components such as `StepLabel`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _propTypes2.default.number,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = Step;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(90);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _StepLabel = __webpack_require__(142);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isLabel = function isLabel(child) {
	  return child && child.type && child.type.muiName === 'StepLabel';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var hovered = state.hovered;
	  var _context$muiTheme$ste = context.muiTheme.stepper,
	      backgroundColor = _context$muiTheme$ste.backgroundColor,
	      hoverBackgroundColor = _context$muiTheme$ste.hoverBackgroundColor;
	
	
	  var styles = {
	    root: {
	      padding: 0,
	      backgroundColor: hovered ? hoverBackgroundColor : backgroundColor,
	      transition: _transitions2.default.easeOut()
	    }
	  };
	
	  if (context.stepper.orientation === 'vertical') {
	    styles.root.width = '100%';
	  }
	
	  return styles;
	};
	
	var StepButton = function (_Component) {
	  (0, _inherits3.default)(StepButton, _Component);
	
	  function StepButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, StepButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepButton.__proto__ || (0, _getPrototypeOf2.default)(StepButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touched: false
	    }, _this.handleMouseEnter = function (event) {
	      var onMouseEnter = _this.props.onMouseEnter;
	      // Cancel hover styles for touch devices
	
	      if (!_this.state.touched) {
	        _this.setState({ hovered: true });
	      }
	      if (typeof onMouseEnter === 'function') {
	        onMouseEnter(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      _this.setState({ hovered: false });
	      if (typeof onMouseLeave === 'function') {
	        onMouseLeave(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      var onTouchStart = _this.props.onTouchStart;
	
	      if (!_this.state.touched) {
	        _this.setState({ touched: true });
	      }
	      if (typeof onTouchStart === 'function') {
	        onTouchStart(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(StepButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          icon = _props.icon,
	          iconContainerStyle = _props.iconContainerStyle,
	          last = _props.last,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'disabled', 'icon', 'iconContainerStyle', 'last', 'onMouseEnter', 'onMouseLeave', 'onTouchStart', 'style']);
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var child = isLabel(children) ? children : _react2.default.createElement(
	        _StepLabel2.default,
	        null,
	        children
	      );
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart
	        }, other),
	        _react2.default.cloneElement(child, { active: active, completed: completed, disabled: disabled, icon: icon, iconContainerStyle: iconContainerStyle })
	      );
	    }
	  }]);
	  return StepButton;
	}(_react.Component);
	
	StepButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	 false ? StepButton.propTypes = {
	  /**
	   * Passed from `Step` Is passed to StepLabel.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _propTypes2.default.object,
	  /** @ignore */
	  last: _propTypes2.default.bool,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = StepButton;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlainStepConnector = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(72);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	};
	
	var contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	
	var StepConnector = function StepConnector(props, context) {
	  var muiTheme = context.muiTheme,
	      stepper = context.stepper;
	
	
	  var styles = {
	    wrapper: {
	      flex: '1 1 auto'
	    },
	    line: {
	      display: 'block',
	      borderColor: muiTheme.stepper.connectorLineColor
	    }
	  };
	
	  /**
	   * Clean up once we can use CSS pseudo elements
	   */
	  if (stepper.orientation === 'horizontal') {
	    styles.line.marginLeft = -6;
	    styles.line.borderTopStyle = 'solid';
	    styles.line.borderTopWidth = 1;
	  } else if (stepper.orientation === 'vertical') {
	    styles.wrapper.marginLeft = 14 + 11; // padding + 1/2 icon
	    styles.line.borderLeftStyle = 'solid';
	    styles.line.borderLeftWidth = 1;
	    styles.line.minHeight = 28;
	  }
	
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles(styles.wrapper) },
	    _react2.default.createElement('span', { style: prepareStyles(styles.line) })
	  );
	};
	
	 false ? StepConnector.propTypes = propTypes : void 0;
	StepConnector.contextTypes = contextTypes;
	
	exports.PlainStepConnector = StepConnector;
	exports.default = (0, _pure2.default)(StepConnector);

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ExpandTransition = __webpack_require__(297);
	
	var _ExpandTransition2 = _interopRequireDefault(_ExpandTransition);
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExpandTransition(props) {
	  return _react2.default.createElement(_ExpandTransition2.default, props);
	}
	
	var getStyles = function getStyles(props, context) {
	  var styles = {
	    root: {
	      marginTop: -14,
	      marginLeft: 14 + 11, // padding + 1/2 icon
	      paddingLeft: 24 - 11 + 8,
	      paddingRight: 16,
	      overflow: 'hidden'
	    }
	  };
	
	  if (!props.last) {
	    styles.root.borderLeft = '1px solid ' + context.muiTheme.stepper.connectorLineColor;
	  }
	
	  return styles;
	};
	
	var StepContent = function (_Component) {
	  (0, _inherits3.default)(StepContent, _Component);
	
	  function StepContent() {
	    (0, _classCallCheck3.default)(this, StepContent);
	    return (0, _possibleConstructorReturn3.default)(this, (StepContent.__proto__ || (0, _getPrototypeOf2.default)(StepContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StepContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          last = _props.last,
	          style = _props.style,
	          transition = _props.transition,
	          transitionDuration = _props.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'last', 'style', 'transition', 'transitionDuration']);
	      var _context = this.context,
	          stepper = _context.stepper,
	          prepareStyles = _context.muiTheme.prepareStyles;
	
	
	      if (stepper.orientation !== 'vertical') {
	         false ? (0, _warning2.default)(false, 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
	        return null;
	      }
	
	      var styles = getStyles(this.props, this.context);
	      var transitionProps = {
	        enterDelay: transitionDuration,
	        transitionDuration: transitionDuration,
	        open: active
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.createElement(transition, transitionProps, _react2.default.createElement(
	          'div',
	          { style: { overflow: 'hidden' } },
	          children
	        ))
	      );
	    }
	  }]);
	  return StepContent;
	}(_react.Component);
	
	StepContent.defaultProps = {
	  transition: ExpandTransition,
	  transitionDuration: 450
	};
	StepContent.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	 false ? StepContent.propTypes = {
	  /**
	   * Expands the content
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Step content
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * ReactTransitionGroup component.
	   */
	  transition: _propTypes2.default.func,
	  /**
	   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
	   */
	  transitionDuration: _propTypes2.default.number
	} : void 0;
	exports.default = StepContent;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StepConnector = __webpack_require__(285);
	
	var _StepConnector2 = _interopRequireDefault(_StepConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props) {
	  var orientation = props.orientation;
	
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
	      alignContent: 'center',
	      alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
	      justifyContent: 'space-between'
	    }
	  };
	};
	
	var Stepper = function (_Component) {
	  (0, _inherits3.default)(Stepper, _Component);
	
	  function Stepper() {
	    (0, _classCallCheck3.default)(this, Stepper);
	    return (0, _possibleConstructorReturn3.default)(this, (Stepper.__proto__ || (0, _getPrototypeOf2.default)(Stepper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Stepper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var orientation = this.props.orientation;
	
	      return { stepper: { orientation: orientation } };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeStep = _props.activeStep,
	          children = _props.children,
	          connector = _props.connector,
	          linear = _props.linear,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      /**
	       * One day, we may be able to use real CSS tools
	       * For now, we need to create our own "pseudo" elements
	       * and nth child selectors, etc
	       * That's what some of this garbage is for :)
	       */
	      var numChildren = _react.Children.count(children);
	      var steps = _react.Children.map(children, function (step, index) {
	        var controlProps = { index: index };
	
	        if (activeStep === index) {
	          controlProps.active = true;
	        } else if (linear && activeStep > index) {
	          controlProps.completed = true;
	        } else if (linear && activeStep < index) {
	          controlProps.disabled = true;
	        }
	
	        if (index + 1 === numChildren) {
	          controlProps.last = true;
	        }
	
	        return [index > 0 && connector, _react2.default.cloneElement(step, (0, _simpleAssign2.default)(controlProps, step.props))];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        steps
	      );
	    }
	  }]);
	  return Stepper;
	}(_react.Component);
	
	Stepper.defaultProps = {
	  connector: _react2.default.createElement(_StepConnector2.default, null),
	  orientation: 'horizontal',
	  linear: true
	};
	Stepper.contextTypes = { muiTheme: _propTypes2.default.object.isRequired };
	Stepper.childContextTypes = { stepper: _propTypes2.default.object };
	 false ? Stepper.propTypes = {
	  /**
	   * Set the active step (zero based index). This will enable `Step` control helpers.
	   */
	  activeStep: _propTypes2.default.number,
	  /**
	   * Should be two or more `<Step />` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * A component to be placed between each step.
	   */
	  connector: _propTypes2.default.node,
	  /**
	   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
	   */
	  linear: _propTypes2.default.bool,
	  /**
	   * The stepper orientation (layout flow direction)
	   */
	  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = Stepper;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = undefined;
	
	var _Step2 = __webpack_require__(283);
	
	var _Step3 = _interopRequireDefault(_Step2);
	
	var _StepButton2 = __webpack_require__(284);
	
	var _StepButton3 = _interopRequireDefault(_StepButton2);
	
	var _StepContent2 = __webpack_require__(286);
	
	var _StepContent3 = _interopRequireDefault(_StepContent2);
	
	var _StepLabel2 = __webpack_require__(142);
	
	var _StepLabel3 = _interopRequireDefault(_StepLabel2);
	
	var _Stepper2 = __webpack_require__(287);
	
	var _Stepper3 = _interopRequireDefault(_Stepper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Step = _Step3.default;
	exports.StepButton = _StepButton3.default;
	exports.StepContent = _StepContent3.default;
	exports.StepLabel = _StepLabel3.default;
	exports.Stepper = _Stepper3.default;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgIcon = function (_Component) {
	  (0, _inherits3.default)(SvgIcon, _Component);
	
	  function SvgIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SvgIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SvgIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          color = _props.color,
	          hoverColor = _props.hoverColor,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          style = _props.style,
	          viewBox = _props.viewBox,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	      var _context$muiTheme = this.context.muiTheme,
	          svgIcon = _context$muiTheme.svgIcon,
	          prepareStyles = _context$muiTheme.prepareStyles;
	
	
	      var offColor = color ? color : 'currentColor';
	      var onColor = hoverColor ? hoverColor : offColor;
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        display: 'inline-block',
	        color: svgIcon.color,
	        fill: this.state.hovered ? onColor : offColor,
	        height: 24,
	        width: 24,
	        userSelect: 'none',
	        transition: _transitions2.default.easeOut()
	      }, style);
	
	      return _react2.default.createElement(
	        'svg',
	        (0, _extends3.default)({}, other, {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: prepareStyles(mergedStyles),
	          viewBox: viewBox
	        }),
	        children
	      );
	    }
	  }]);
	  return SvgIcon;
	}(_react.Component);
	
	SvgIcon.muiName = 'SvgIcon';
	SvgIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  viewBox: '0 0 24 24'
	};
	SvgIcon.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? SvgIcon.propTypes = {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * This is the fill color of the svg icon.
	   * If not specified, this component will default
	   * to muiTheme.palette.textColor.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _propTypes2.default.string,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Allows you to redefine what the coordinates
	   * without units mean inside an svg element. For example,
	   * if the SVG element is 500 (width) by 200 (height), and you
	   * pass viewBox="0 0 50 20", this means that the coordinates inside
	   * the svg will go from the top left corner (0,0) to bottom right (50,20)
	   * and each unit will be worth 10px.
	   */
	  viewBox: _propTypes2.default.string
	} : void 0;
	exports.default = SvgIcon;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(392);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowsHeight = 24;
	
	function getStyles(props, context, state) {
	  return {
	    root: {
	      position: 'relative' },
	    textarea: {
	      height: state.height,
	      width: '100%',
	      resize: 'none',
	      font: 'inherit',
	      padding: 0,
	      cursor: 'inherit'
	    },
	    shadow: {
	      resize: 'none',
	      // Overflow also needed to here to remove the extra row
	      // added to textareas in Firefox.
	      overflow: 'hidden',
	      // Visibility needed to hide the extra text area on ipads
	      visibility: 'hidden',
	      position: 'absolute',
	      height: 'auto'
	    }
	  };
	}
	
	var EnhancedTextarea = function (_Component) {
	  (0, _inherits3.default)(EnhancedTextarea, _Component);
	
	  function EnhancedTextarea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedTextarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.handleResize = function (event) {
	      _this.syncHeightWithShadow(undefined, event);
	    }, _this.handleChange = function (event) {
	      _this.syncHeightWithShadow(event.target.value);
	
	      if (_this.props.hasOwnProperty('valueLink')) {
	        _this.props.valueLink.requestChange(event.target.value);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        height: this.props.rows * rowsHeight
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value || nextProps.rowsMax !== this.props.rowsMax) {
	        this.syncHeightWithShadow(nextProps.value, null, nextProps);
	      }
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.getInputNode().value = value;
	      this.syncHeightWithShadow(value);
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(newValue, event, props) {
	      var shadow = this.refs.shadow;
	      var displayText = this.props.hintText && (newValue === '' || newValue === undefined || newValue === null) ? this.props.hintText : newValue;
	
	      if (displayText !== undefined) {
	        shadow.value = displayText;
	      }
	
	      var newHeight = shadow.scrollHeight;
	
	      // Guarding for jsdom, where scrollHeight isn't present.
	      // See https://github.com/tmpvar/jsdom/issues/1013
	      if (newHeight === undefined) return;
	
	      props = props || this.props;
	
	      if (props.rowsMax >= props.rows) {
	        newHeight = Math.min(props.rowsMax * rowsHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, rowsHeight);
	
	      if (this.state.height !== newHeight) {
	        this.setState({
	          height: newHeight
	        });
	
	        if (props.onHeightChange) {
	          props.onHeightChange(event, newHeight);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          onHeightChange = _props.onHeightChange,
	          rows = _props.rows,
	          rowsMax = _props.rowsMax,
	          shadowStyle = _props.shadowStyle,
	          style = _props.style,
	          hintText = _props.hintText,
	          textareaStyle = _props.textareaStyle,
	          valueLink = _props.valueLink,
	          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'hintText', 'textareaStyle', 'valueLink']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
	      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
	
	      if (this.props.hasOwnProperty('valueLink')) {
	        other.value = this.props.valueLink.value;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(rootStyles) },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', {
	          ref: 'shadow',
	          style: prepareStyles(shadowStyles),
	          tabIndex: '-1',
	          rows: this.props.rows,
	          defaultValue: this.props.defaultValue,
	          readOnly: true,
	          value: this.props.value,
	          valueLink: this.props.valueLink
	        }),
	        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
	          ref: 'input',
	          rows: this.props.rows,
	          style: prepareStyles(textareaStyles),
	          onChange: this.handleChange
	        }))
	      );
	    }
	  }]);
	  return EnhancedTextarea;
	}(_react.Component);
	
	EnhancedTextarea.defaultProps = {
	  rows: 1
	};
	EnhancedTextarea.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? EnhancedTextarea.propTypes = {
	  defaultValue: _propTypes2.default.any,
	  disabled: _propTypes2.default.bool,
	  hintText: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  onHeightChange: _propTypes2.default.func,
	  rows: _propTypes2.default.number,
	  rowsMax: _propTypes2.default.number,
	  shadowStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  textareaStyle: _propTypes2.default.object,
	  value: _propTypes2.default.string,
	  valueLink: _propTypes2.default.object
	} : void 0;
	exports.default = EnhancedTextarea;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(73);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedTextarea = __webpack_require__(290);
	
	var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);
	
	var _TextFieldHint = __webpack_require__(292);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(293);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(294);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      _context$muiTheme$tex = _context$muiTheme.textField,
	      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
	      focusColor = _context$muiTheme$tex.focusColor,
	      textColor = _context$muiTheme$tex.textColor,
	      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
	      backgroundColor = _context$muiTheme$tex.backgroundColor,
	      errorColor = _context$muiTheme$tex.errorColor;
	
	
	  var styles = {
	    root: {
	      fontSize: 16,
	      lineHeight: '24px',
	      width: props.fullWidth ? '100%' : 256,
	      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	      display: 'inline-block',
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      fontFamily: baseTheme.fontFamily,
	      transition: _transitions2.default.easeOut('200ms', 'height'),
	      cursor: props.disabled ? 'not-allowed' : 'auto'
	    },
	    error: {
	      position: 'relative',
	      bottom: 2,
	      fontSize: 12,
	      lineHeight: '12px',
	      color: errorColor,
	      transition: _transitions2.default.easeOut()
	    },
	    floatingLabel: {
	      color: props.disabled ? disabledTextColor : floatingLabelColor,
	      pointerEvents: 'none'
	    },
	    input: {
	      padding: 0,
	      position: 'relative',
	      width: '100%',
	      border: 'none',
	      outline: 'none',
	      backgroundColor: 'rgba(0,0,0,0)',
	      color: props.disabled ? disabledTextColor : textColor,
	      cursor: 'inherit',
	      font: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' },
	    inputNative: {
	      appearance: 'textfield' }
	  };
	
	  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
	    marginTop: props.floatingLabelText ? 36 : 12,
	    marginBottom: props.floatingLabelText ? -36 : -12,
	    boxSizing: 'border-box',
	    font: 'inherit'
	  });
	
	  // Do not assign a height to the textarea as he handles it on his own.
	  styles.input.height = '100%';
	
	  if (state.isFocused) {
	    styles.floatingLabel.color = focusColor;
	  }
	
	  if (props.floatingLabelText) {
	    styles.input.boxSizing = 'border-box';
	
	    if (!props.multiLine) {
	      styles.input.marginTop = 14;
	    }
	
	    if (state.errorText) {
	      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	    }
	  }
	
	  if (state.errorText) {
	    if (state.isFocused) {
	      styles.floatingLabel.color = styles.error.color;
	    }
	  }
	
	  return styles;
	};
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
	}
	
	var TextField = function (_Component) {
	  (0, _inherits3.default)(TextField, _Component);
	
	  function TextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFocused: false,
	      errorText: undefined,
	      hasValue: false
	    }, _this.handleInputBlur = function (event) {
	      _this.setState({ isFocused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleInputChange = function (event) {
	      if (!_this.props.hasOwnProperty('value')) {
	        _this.setState({ hasValue: isValid(event.target.value) });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(event, event.target.value);
	      }
	    }, _this.handleInputFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	      _this.setState({ isFocused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleHeightChange = function (event, height) {
	      var newHeight = height + 24;
	      if (_this.props.floatingLabelText) {
	        newHeight += 24;
	      }
	      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          hintText = _props.hintText,
	          floatingLabelText = _props.floatingLabelText,
	          id = _props.id;
	
	
	      var propsLeaf = children ? children.props : this.props;
	
	      this.setState({
	        errorText: this.props.errorText,
	        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
	      });
	
	       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;
	
	      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
	      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.errorText !== this.props.errorText) {
	        this.setState({
	          errorText: nextProps.errorText
	        });
	      }
	
	      if (nextProps.children && nextProps.children.props) {
	        nextProps = nextProps.children.props;
	      }
	
	      if (nextProps.hasOwnProperty('value')) {
	        var hasValue = isValid(nextProps.value);
	
	        this.setState({
	          hasValue: hasValue
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      if (this.input) {
	        this.getInputNode().blur();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) {
	        this.getInputNode().focus();
	      }
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      if (this.input) {
	        this.getInputNode().select();
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input ? this.getInputNode().value : undefined;
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
	    }
	  }, {
	    key: '_isControlled',
	    value: function _isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          errorStyle = _props2.errorStyle,
	          errorText = _props2.errorText,
	          floatingLabelFixed = _props2.floatingLabelFixed,
	          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
	          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
	          floatingLabelStyle = _props2.floatingLabelStyle,
	          floatingLabelText = _props2.floatingLabelText,
	          fullWidth = _props2.fullWidth,
	          hintText = _props2.hintText,
	          hintStyle = _props2.hintStyle,
	          id = _props2.id,
	          inputStyle = _props2.inputStyle,
	          multiLine = _props2.multiLine,
	          onBlur = _props2.onBlur,
	          onChange = _props2.onChange,
	          onFocus = _props2.onFocus,
	          style = _props2.style,
	          type = _props2.type,
	          underlineDisabledStyle = _props2.underlineDisabledStyle,
	          underlineFocusStyle = _props2.underlineFocusStyle,
	          underlineShow = _props2.underlineShow,
	          underlineStyle = _props2.underlineStyle,
	          rows = _props2.rows,
	          rowsMax = _props2.rowsMax,
	          textareaStyle = _props2.textareaStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var inputId = id || this.uniqueId;
	
	      var errorTextElement = this.state.errorText && _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
	        this.state.errorText
	      );
	
	      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
	        _TextFieldLabel2.default,
	        {
	          muiTheme: this.context.muiTheme,
	          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
	          shrinkStyle: floatingLabelShrinkStyle,
	          htmlFor: inputId,
	          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
	          disabled: disabled
	        },
	        floatingLabelText
	      );
	
	      var inputProps = {
	        id: inputId,
	        ref: function ref(elem) {
	          return _this2.input = elem;
	        },
	        disabled: this.props.disabled,
	        onBlur: this.handleInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus
	      };
	
	      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);
	
	      var inputElement = void 0;
	      if (children) {
	        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
	          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
	        }));
	      } else {
	        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
	          style: childStyleMerged,
	          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
	          rows: rows,
	          rowsMax: rowsMax,
	          hintText: hintText
	        }, other, inputProps, {
	          onHeightChange: this.handleHeightChange
	        })) : _react2.default.createElement('input', (0, _extends3.default)({
	          type: type,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
	        }, other, inputProps));
	      }
	
	      var rootProps = {};
	
	      if (children) {
	        rootProps = other;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, rootProps, {
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }),
	        floatingLabelTextElement,
	        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	          muiTheme: this.context.muiTheme,
	          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
	          style: hintStyle,
	          text: hintText
	        }) : null,
	        inputElement,
	        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	          disabled: disabled,
	          disabledStyle: underlineDisabledStyle,
	          error: !!this.state.errorText,
	          errorStyle: errorStyle,
	          focus: this.state.isFocused,
	          focusStyle: underlineFocusStyle,
	          muiTheme: this.context.muiTheme,
	          style: underlineStyle
	        }) : null,
	        errorTextElement
	      );
	    }
	  }]);
	  return TextField;
	}(_react.Component);
	
	TextField.defaultProps = {
	  disabled: false,
	  floatingLabelFixed: false,
	  multiLine: false,
	  fullWidth: false,
	  type: 'text',
	  underlineShow: true,
	  rows: 1
	};
	TextField.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TextField.propTypes = {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The text string to use for the default value.
	   */
	  defaultValue: _propTypes2.default.any,
	  /**
	   * Disables the text field if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The style object to use to override error styles.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * If true, the floating label will float even when there is no value.
	   */
	  floatingLabelFixed: _propTypes2.default.bool,
	  /**
	   * The style object to use to override floating label styles when focused.
	   */
	  floatingLabelFocusStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override floating label styles when shrunk.
	   */
	  floatingLabelShrinkStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override floating label styles.
	   */
	  floatingLabelStyle: _propTypes2.default.object,
	  /**
	   * The content to use for the floating label element.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the field receives the property width 100%.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the TextField's hint text element.
	   */
	  hintStyle: _propTypes2.default.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * The id prop for the text field.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the TextField's input element.
	   * When multiLine is false: define the style of the input element.
	   * When multiLine is true: define the style of the container of the textarea.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * If true, a textarea element will be rendered.
	   * The textarea also grows and shrinks according to the number of lines.
	   */
	  multiLine: _propTypes2.default.bool,
	  /**
	   * Name applied to the input.
	   */
	  name: _propTypes2.default.string,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the textfield's value changes.
	   *
	   * @param {object} event Change event targeting the text field.
	   * @param {string} newValue The new value of the text field.
	   */
	  onChange: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Number of rows to display when multiLine option is set to true.
	   */
	  rows: _propTypes2.default.number,
	  /**
	   * Maximum number of rows to display when
	   * multiLine option is set to true.
	   */
	  rowsMax: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the TextField's textarea element.
	   * The TextField use either a textarea or an input,
	   * this property has effects only when multiLine is true.
	   */
	  textareaStyle: _propTypes2.default.object,
	  /**
	   * Specifies the type of input to display
	   * such as "password" or "text".
	   */
	  type: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the
	   * TextField's underline element when disabled.
	   */
	  underlineDisabledStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the TextField's
	   * underline element when focussed.
	   */
	  underlineFocusStyle: _propTypes2.default.object,
	  /**
	   * If true, shows the underline for the text field.
	   */
	  underlineShow: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the TextField's underline element.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * The value of the text field.
	   */
	  value: _propTypes2.default.any
	} : void 0;
	exports.default = TextField;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var hintColor = props.muiTheme.textField.hintColor,
	      show = props.show;
	
	
	  return {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	}
	
	var TextFieldHint = function TextFieldHint(props) {
	  var prepareStyles = props.muiTheme.prepareStyles,
	      style = props.style,
	      text = props.text;
	
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	    text
	  );
	};
	
	 false ? TextFieldHint.propTypes = {
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The hint text displayed.
	   */
	  text: _propTypes2.default.node
	} : void 0;
	
	TextFieldHint.defaultProps = {
	  show: true
	};
	
	exports.default = TextFieldHint;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var defaultStyles = {
	    position: 'absolute',
	    lineHeight: '22px',
	    top: 38,
	    transition: _transitions2.default.easeOut(),
	    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	    transform: 'scale(1) translate(0, 0)',
	    transformOrigin: 'left top',
	    pointerEvents: 'auto',
	    userSelect: 'none'
	  };
	
	  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
	    transform: 'scale(0.75) translate(0, -28px)',
	    pointerEvents: 'none'
	  }, props.shrinkStyle) : null;
	
	  return {
	    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
	  };
	}
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme,
	      className = props.className,
	      children = props.children,
	      htmlFor = props.htmlFor,
	      onTouchTap = props.onTouchTap;
	  var prepareStyles = muiTheme.prepareStyles;
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: prepareStyles(styles.root),
	      htmlFor: htmlFor,
	      onTouchTap: onTouchTap
	    },
	    children
	  );
	};
	
	 false ? TextFieldLabel.propTypes = {
	  /**
	   * The label contents.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _propTypes2.default.string,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * Callback function for when the label is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the text field label.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element when shrunk.
	   */
	  shrinkStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	
	TextFieldLabel.defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	exports.default = TextFieldLabel;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _propTypes2.default.object,
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled,
	      disabledStyle = props.disabledStyle,
	      error = props.error,
	      errorStyle = props.errorStyle,
	      focus = props.focus,
	      focusStyle = props.focusStyle,
	      muiTheme = props.muiTheme,
	      style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var prepareStyles = muiTheme.prepareStyles,
	      _muiTheme$textField = muiTheme.textField,
	      borderColor = _muiTheme$textField.borderColor,
	      disabledTextColor = _muiTheme$textField.disabledTextColor,
	      errorColor = _muiTheme$textField.errorColor,
	      focusColor = _muiTheme$textField.focusColor;
	
	
	  var styles = {
	    root: {
	      borderTop: 'none',
	      borderLeft: 'none',
	      borderRight: 'none',
	      borderBottom: 'solid 1px',
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottom: 'dotted 2px',
	      borderColor: disabledTextColor
	    },
	    focus: {
	      borderBottom: 'solid 2px',
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
	  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { style: prepareStyles(underline) }),
	    _react2.default.createElement('hr', { style: prepareStyles(focusedUnderline) })
	  );
	};
	
	 false ? TextFieldUnderline.propTypes = propTypes : void 0;
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextField = __webpack_require__(291);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(73);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(91);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleRipple = function (_Component) {
	  (0, _inherits3.default)(CircleRipple, _Component);
	
	  function CircleRipple() {
	    (0, _classCallCheck3.default)(this, CircleRipple);
	    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircleRipple, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = 0;
	      // If the animation is aborted, remove from the DOM immediately
	      var removeAfter = this.props.aborted ? 0 : 2000;
	      this.enterTimer = setTimeout(callback, removeAfter);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
	      _autoPrefix2.default.set(style, 'transition', transitionValue);
	      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = this.props.opacity;
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	      this.leaveTimer = setTimeout(callback, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          aborted = _props.aborted,
	          color = _props.color,
	          opacity = _props.opacity,
	          style = _props.style,
	          touchGenerated = _props.touchGenerated,
	          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        backgroundColor: color
	      }, style);
	
	      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
	    }
	  }]);
	  return CircleRipple;
	}(_react.Component);
	
	CircleRipple.defaultProps = {
	  opacity: 0.1,
	  aborted: false
	};
	CircleRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? CircleRipple.propTypes = {
	  aborted: _propTypes2.default.bool,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  touchGenerated: _propTypes2.default.bool
	} : void 0;
	exports.default = CircleRipple;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsTransitionGroup = __webpack_require__(94);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ExpandTransitionChild = __webpack_require__(298);
	
	var _ExpandTransitionChild2 = _interopRequireDefault(_ExpandTransitionChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandTransition = function (_Component) {
	  (0, _inherits3.default)(ExpandTransition, _Component);
	
	  function ExpandTransition() {
	    (0, _classCallCheck3.default)(this, ExpandTransition);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransition.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransition)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransition, [{
	    key: 'renderChildren',
	    value: function renderChildren(children) {
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      return _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ExpandTransitionChild2.default,
	          {
	            enterDelay: enterDelay,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            key: child.key
	          },
	          child
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          enterDelay = _props2.enterDelay,
	          loading = _props2.loading,
	          open = _props2.open,
	          style = _props2.style,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'enterDelay', 'loading', 'open', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: 'auto'
	      }, style);
	
	      var newChildren = loading ? [] : this.renderChildren(children);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }, other),
	        open && newChildren
	      );
	    }
	  }]);
	  return ExpandTransition;
	}(_react.Component);
	
	ExpandTransition.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450,
	  loading: false,
	  open: false
	};
	ExpandTransition.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ExpandTransition.propTypes = {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  loading: _propTypes2.default.bool,
	  open: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  transitionDelay: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number
	} : void 0;
	exports.default = ExpandTransition;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reflow = function reflow(elem) {
	  return elem.offsetHeight;
	};
	
	var ExpandTransitionChild = function (_Component) {
	  (0, _inherits3.default)(ExpandTransitionChild, _Component);
	
	  function ExpandTransitionChild() {
	    (0, _classCallCheck3.default)(this, ExpandTransitionChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransitionChild.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransitionChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransitionChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.enteredTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.open();
	      callback();
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = 0;
	      this.enterTimer = setTimeout(function () {
	        return _this2.open();
	      }, enterDelay);
	      this.enteredTimer = setTimeout(function () {
	        return callback();
	      }, enterDelay + transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var _props2 = this.props,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      // Set fixed height first for animated property value
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	      reflow(element);
	      element.style.transitionDuration = transitionDuration + 'ms';
	      element.style.height = 0;
	      this.leaveTimer = setTimeout(function () {
	        return callback();
	      }, transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'setAutoHeight',
	    value: function setAutoHeight() {
	      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this),
	          style = _ReactDOM$findDOMNode.style;
	
	      style.transitionDuration = 0;
	      style.height = 'auto';
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          enterDelay = _props3.enterDelay,
	          style = _props3.style,
	          transitionDelay = _props3.transitionDelay,
	          transitionDuration = _props3.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['children', 'enterDelay', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        position: 'relative',
	        height: 0,
	        width: '100%',
	        top: 0,
	        left: 0,
	        overflow: 'hidden',
	        transition: _transitions2.default.easeOut(transitionDuration + 'ms', ['height'], transitionDelay + 'ms')
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper' },
	          children
	        )
	      );
	    }
	  }]);
	  return ExpandTransitionChild;
	}(_react.Component);
	
	ExpandTransitionChild.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450
	};
	ExpandTransitionChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ExpandTransitionChild.propTypes = {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  transitionDelay: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number
	} : void 0;
	exports.default = ExpandTransitionChild;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(73);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(91);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ScaleIn = __webpack_require__(300);
	
	var _ScaleIn2 = _interopRequireDefault(_ScaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = function (_Component) {
	  (0, _inherits3.default)(FocusRipple, _Component);
	
	  function FocusRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FocusRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
	      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
	      if (!innerCircle) return;
	
	      var startScale = 'scale(1)';
	      var endScale = 'scale(0.85)';
	      var currentScale = innerCircle.style.transform || startScale;
	      var nextScale = currentScale === startScale ? endScale : startScale;
	
	      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
	      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FocusRipple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      } else {
	        if (this.timeout) clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'getRippleElement',
	    value: function getRippleElement(props) {
	      var color = props.color,
	          innerStyle = props.innerStyle,
	          opacity = props.opacity;
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          ripple = _context$muiTheme.ripple;
	
	
	      var innerStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        opacity: opacity ? opacity : 0.16,
	        backgroundColor: color || ripple.color,
	        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	      }, innerStyle);
	
	      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	      var height = el.offsetHeight;
	      var width = el.offsetWidth;
	      var size = Math.max(height, width);
	
	      var oldTop = 0;
	      // For browsers that don't support endsWith()
	      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	        oldTop = parseInt(el.style.top);
	      }
	      el.style.height = size + 'px';
	      el.style.top = height / 2 - size / 2 + oldTop + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          style = _props.style;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0
	      }, style);
	
	      var ripple = show ? this.getRippleElement(this.props) : null;
	
	      return _react2.default.createElement(
	        _ScaleIn2.default,
	        {
	          maxScale: 0.85,
	          style: mergedRootStyles
	        },
	        ripple
	      );
	    }
	  }]);
	  return FocusRipple;
	}(_react.Component);
	
	FocusRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? FocusRipple.propTypes = {
	  color: _propTypes2.default.string,
	  innerStyle: _propTypes2.default.object,
	  opacity: _propTypes2.default.number,
	  show: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = FocusRipple;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsTransitionGroup = __webpack_require__(94);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ScaleInChild = __webpack_require__(301);
	
	var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleIn = function (_Component) {
	  (0, _inherits3.default)(ScaleIn, _Component);
	
	  function ScaleIn() {
	    (0, _classCallCheck3.default)(this, ScaleIn);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleIn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ScaleInChild2.default,
	          {
	            key: child.key,
	            enterDelay: enterDelay,
	            maxScale: maxScale,
	            minScale: minScale,
	            style: childStyle
	          },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return ScaleIn;
	}(_react.Component);
	
	ScaleIn.defaultProps = {
	  enterDelay: 0
	};
	ScaleIn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ScaleIn.propTypes = {
	  childStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  maxScale: _propTypes2.default.number,
	  minScale: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = ScaleIn;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(91);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(18);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleInChild = function (_Component) {
	  (0, _inherits3.default)(ScaleInChild, _Component);
	
	  function ScaleInChild() {
	    (0, _classCallCheck3.default)(this, ScaleInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return ScaleInChild;
	}(_react.Component);
	
	ScaleInChild.defaultProps = {
	  enterDelay: 0,
	  maxScale: 1,
	  minScale: 0
	};
	ScaleInChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ScaleInChild.propTypes = {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  maxScale: _propTypes2.default.number,
	  minScale: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = ScaleInChild;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(119);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toArray2 = __webpack_require__(187);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _simpleAssign = __webpack_require__(7);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsTransitionGroup = __webpack_require__(94);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _dom = __webpack_require__(314);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _CircleRipple = __webpack_require__(296);
	
	var _CircleRipple2 = _interopRequireDefault(_CircleRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Remove the first element of the array
	var shift = function shift(_ref) {
	  var _ref2 = (0, _toArray3.default)(_ref),
	      newArray = _ref2.slice(1);
	
	  return newArray;
	};
	
	var TouchRipple = function (_Component) {
	  (0, _inherits3.default)(TouchRipple, _Component);
	
	  function TouchRipple(props, context) {
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    // Touch start produces a mouse down event for compat reasons. To avoid
	    // showing ripples twice we skip showing a ripple for the first mouse down
	    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    // to avoid re-rendering when we change it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));
	
	    _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.start(event, false);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.end();
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.end();
	    };
	
	    _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      // If the user is swiping (not just tapping), save the position so we can
	      // abort ripples if the user appears to be scrolling.
	      if (_this.props.abortOnScroll && event.touches) {
	        _this.startListeningForScrollAbort(event);
	        _this.startTime = Date.now();
	      }
	      _this.start(event, true);
	    };
	
	    _this.handleTouchEnd = function () {
	      _this.end();
	    };
	
	    _this.handleTouchMove = function (event) {
	      // Stop trying to abort if we're already 300ms into the animation
	      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
	      if (timeSinceStart > 300) {
	        _this.stopListeningForScrollAbort();
	        return;
	      }
	
	      // If the user is scrolling...
	      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
	      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
	      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
	      if (deltaY > 6 || deltaX > 6) {
	        var currentRipples = _this.state.ripples;
	        var ripple = currentRipples[0];
	        // This clone will replace the ripple in ReactTransitionGroup with a
	        // version that will disappear immediately when removed from the DOM
	        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
	        // Remove the old ripple and replace it with the new updated one
	        currentRipples = shift(currentRipples);
	        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
	        _this.setState({ ripples: currentRipples }, function () {
	          // Call end after we've set the ripple to abort otherwise the setState
	          // in end() merges with this and the ripple abort fails
	          _this.end();
	        });
	      }
	    };
	
	    _this.ignoreNextMouseDown = false;
	
	    _this.state = {
	      // This prop allows us to only render the ReactTransitionGroup
	      // on the first click of the component, making the inital render faster.
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'start',
	    value: function start(event, isRippleTouchGenerated) {
	      var theme = this.context.muiTheme.ripple;
	
	      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
	        this.ignoreNextMouseDown = false;
	        return;
	      }
	
	      var ripples = this.state.ripples;
	
	      // Add a ripple to the ripples array
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
	        key: this.state.nextKey,
	        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
	        color: this.props.color || theme.color,
	        opacity: this.props.opacity,
	        touchGenerated: isRippleTouchGenerated
	      })]);
	
	      this.ignoreNextMouseDown = isRippleTouchGenerated;
	      this.setState({
	        hasRipples: true,
	        nextKey: this.state.nextKey + 1,
	        ripples: ripples
	      });
	    }
	  }, {
	    key: 'end',
	    value: function end() {
	      var currentRipples = this.state.ripples;
	      this.setState({
	        ripples: shift(currentRipples)
	      });
	      if (this.props.abortOnScroll) {
	        this.stopListeningForScrollAbort();
	      }
	    }
	
	    // Check if the user seems to be scrolling and abort the animation if so
	
	  }, {
	    key: 'startListeningForScrollAbort',
	    value: function startListeningForScrollAbort(event) {
	      this.firstTouchY = event.touches[0].clientY;
	      this.firstTouchX = event.touches[0].clientX;
	      // Note that when scolling Chrome throttles this event to every 200ms
	      // Also note we don't listen for scroll events directly as there's no general
	      // way to cover cases like scrolling within containers on the page
	      document.body.addEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'stopListeningForScrollAbort',
	    value: function stopListeningForScrollAbort() {
	      document.body.removeEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'getRippleStyle',
	    value: function getRippleStyle(event) {
	      var el = _reactDom2.default.findDOMNode(this);
	      var elHeight = el.offsetHeight;
	      var elWidth = el.offsetWidth;
	      var offset = _dom2.default.offset(el);
	      var isTouchEvent = event.touches && event.touches.length;
	      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
	      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
	      var pointerX = pageX - offset.left;
	      var pointerY = pageY - offset.top;
	      var topLeftDiag = this.calcDiag(pointerX, pointerY);
	      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
	      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
	      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
	      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	      var rippleSize = rippleRadius * 2;
	      var left = pointerX - rippleRadius;
	      var top = pointerY - rippleRadius;
	
	      return {
	        directionInvariant: true,
	        height: rippleSize,
	        width: rippleSize,
	        top: top,
	        left: left
	      };
	    }
	  }, {
	    key: 'calcDiag',
	    value: function calcDiag(a, b) {
	      return Math.sqrt(a * a + b * b);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style;
	      var _state = this.state,
	          hasRipples = _state.hasRipples,
	          ripples = _state.ripples;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var rippleGroup = void 0;
	
	      if (hasRipples) {
	        var mergedStyles = (0, _simpleAssign2.default)({
	          height: '100%',
	          width: '100%',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          overflow: 'hidden',
	          pointerEvents: 'none'
	        }, style);
	
	        rippleGroup = _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          { style: prepareStyles(mergedStyles) },
	          ripples
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        },
	        rippleGroup,
	        children
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.defaultProps = {
	  abortOnScroll: true
	};
	TouchRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TouchRipple.propTypes = {
	  abortOnScroll: _propTypes2.default.bool,
	  centerRipple: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = TouchRipple;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getMuiTheme = __webpack_require__(143);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MuiThemeProvider = function (_Component) {
	  (0, _inherits3.default)(MuiThemeProvider, _Component);
	
	  function MuiThemeProvider() {
	    (0, _classCallCheck3.default)(this, MuiThemeProvider);
	    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react.Component);
	
	MuiThemeProvider.childContextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? MuiThemeProvider.propTypes = {
	  children: _propTypes2.default.element,
	  muiTheme: _propTypes2.default.object
	} : void 0;
	exports.default = MuiThemeProvider;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(63);
	
	var _colorManipulator = __webpack_require__(64);
	
	var _spacing = __webpack_require__(305);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  borderRadius: 2,
	  palette: {
	    primary1Color: _colors.cyan500,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey400,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	  }
	}; /**
	    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
	    */

/***/ },
/* 305 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopDrawerMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _colors = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Typography = function Typography() {
	  (0, _classCallCheck3.default)(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors.fullBlack;
	  this.textDarkBlack = _colors.darkBlack;
	  this.textLightBlack = _colors.lightBlack;
	  this.textMinBlack = _colors.minBlack;
	  this.textFullWhite = _colors.fullWhite;
	  this.textDarkWhite = _colors.darkWhite;
	  this.textLightWhite = _colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();

/***/ },
/* 307 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  drawerOverlay: 1200,
	  drawer: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(72);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(62);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = function NavigationCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	  );
	};
	NavigationCheck = (0, _pure2.default)(NavigationCheck);
	NavigationCheck.displayName = 'NavigationCheck';
	NavigationCheck.muiName = 'SvgIcon';
	
	exports.default = NavigationCheck;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(72);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(62);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationClose = function NavigationClose(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
	  );
	};
	NavigationClose = (0, _pure2.default)(NavigationClose);
	NavigationClose.displayName = 'NavigationClose';
	NavigationClose.muiName = 'SvgIcon';
	
	exports.default = NavigationClose;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (muiTheme) {
	  var isClient = typeof navigator !== 'undefined';
	  var userAgent = muiTheme.userAgent;
	
	  if (userAgent === undefined && isClient) {
	    userAgent = navigator.userAgent;
	  }
	
	  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;
	
	    hasWarnedAboutUserAgent = true;
	  }
	
	  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);
	
	  if (userAgent === false) {
	    // Disabled autoprefixer
	    return null;
	  } else if (userAgent === 'all' || userAgent === undefined) {
	    // Prefix for all user agent
	    return function (style) {
	      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
	      var stylePrefixed = prefixAll(style);
	
	      if (isFlex) {
	        var display = stylePrefixed.display;
	        if (isClient) {
	          // We can't apply this join with react-dom:
	          // #https://github.com/facebook/react/issues/6467
	          stylePrefixed.display = display[display.length - 1];
	        } else {
	          stylePrefixed.display = display.join('; display: ');
	        }
	      }
	
	      return stylePrefixed;
	    };
	  } else {
	    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
	    var prefixer = new Prefixer({
	      userAgent: userAgent
	    });
	
	    return function (style) {
	      return prefixer.prefix(style);
	    };
	  }
	};
	
	var _createPrefixer = __webpack_require__(264);
	
	var _createPrefixer2 = _interopRequireDefault(_createPrefixer);
	
	var _createPrefixer3 = __webpack_require__(256);
	
	var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);
	
	var _autoprefixerDynamic = __webpack_require__(311);
	
	var _autoprefixerDynamic2 = _interopRequireDefault(_autoprefixerDynamic);
	
	var _autoprefixerStatic = __webpack_require__(312);
	
	var _autoprefixerStatic2 = _interopRequireDefault(_autoprefixerStatic);
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasWarnedAboutUserAgent = false;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(257);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _flex = __webpack_require__(258);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(259);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(260);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(261);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _sizing = __webpack_require__(262);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(263);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
	  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
	}; /* eslint-disable */

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(265);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _flex = __webpack_require__(266);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(267);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(268);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(269);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _sizing = __webpack_require__(270);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(271);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
	  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
	}; /* eslint-disable */

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (false) {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}

/***/ },
/* 314 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  }
	};

/***/ },
/* 315 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(event) {
	      event.target.removeEventListener(event.type, recursiveFunction);
	      return callback(event);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(event) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
	  }
	};

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var horizontal = _propTypes2.default.oneOf(['left', 'middle', 'right']);
	var vertical = _propTypes2.default.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _propTypes2.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _propTypes2.default.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _propTypes2.default.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(118);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = rtl;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      if (style.directionInvariant === true) {
	        return style;
	      }
	
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      (0, _keys2.default)(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            if (!value) break;
	            var matches = void 0;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (!value) break;
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/* Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("pdfjs-dist/build/pdf", [], factory);
		else if(typeof exports === 'object')
			exports["pdfjs-dist/build/pdf"] = factory();
		else
			root["pdfjs-dist/build/pdf"] = root.pdfjsDistBuildPdf = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __w_pdfjs_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__w_pdfjs_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__w_pdfjs_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__w_pdfjs_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
	/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__w_pdfjs_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__w_pdfjs_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 13);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isNodeJS = exports.isSpace = exports.isString = exports.isNum = exports.isInt = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.isArray = exports.info = exports.globalScope = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.error = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.StatTimer = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	__w_pdfjs_require__(14);
	
	var globalScope = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : undefined;
	var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
	var TextRenderingMode = {
	  FILL: 0,
	  STROKE: 1,
	  FILL_STROKE: 2,
	  INVISIBLE: 3,
	  FILL_ADD_TO_PATH: 4,
	  STROKE_ADD_TO_PATH: 5,
	  FILL_STROKE_ADD_TO_PATH: 6,
	  ADD_TO_PATH: 7,
	  FILL_STROKE_MASK: 3,
	  ADD_TO_PATH_FLAG: 4
	};
	var ImageKind = {
	  GRAYSCALE_1BPP: 1,
	  RGB_24BPP: 2,
	  RGBA_32BPP: 3
	};
	var AnnotationType = {
	  TEXT: 1,
	  LINK: 2,
	  FREETEXT: 3,
	  LINE: 4,
	  SQUARE: 5,
	  CIRCLE: 6,
	  POLYGON: 7,
	  POLYLINE: 8,
	  HIGHLIGHT: 9,
	  UNDERLINE: 10,
	  SQUIGGLY: 11,
	  STRIKEOUT: 12,
	  STAMP: 13,
	  CARET: 14,
	  INK: 15,
	  POPUP: 16,
	  FILEATTACHMENT: 17,
	  SOUND: 18,
	  MOVIE: 19,
	  WIDGET: 20,
	  SCREEN: 21,
	  PRINTERMARK: 22,
	  TRAPNET: 23,
	  WATERMARK: 24,
	  THREED: 25,
	  REDACT: 26
	};
	var AnnotationFlag = {
	  INVISIBLE: 0x01,
	  HIDDEN: 0x02,
	  PRINT: 0x04,
	  NOZOOM: 0x08,
	  NOROTATE: 0x10,
	  NOVIEW: 0x20,
	  READONLY: 0x40,
	  LOCKED: 0x80,
	  TOGGLENOVIEW: 0x100,
	  LOCKEDCONTENTS: 0x200
	};
	var AnnotationFieldFlag = {
	  READONLY: 0x0000001,
	  REQUIRED: 0x0000002,
	  NOEXPORT: 0x0000004,
	  MULTILINE: 0x0001000,
	  PASSWORD: 0x0002000,
	  NOTOGGLETOOFF: 0x0004000,
	  RADIO: 0x0008000,
	  PUSHBUTTON: 0x0010000,
	  COMBO: 0x0020000,
	  EDIT: 0x0040000,
	  SORT: 0x0080000,
	  FILESELECT: 0x0100000,
	  MULTISELECT: 0x0200000,
	  DONOTSPELLCHECK: 0x0400000,
	  DONOTSCROLL: 0x0800000,
	  COMB: 0x1000000,
	  RICHTEXT: 0x2000000,
	  RADIOSINUNISON: 0x2000000,
	  COMMITONSELCHANGE: 0x4000000
	};
	var AnnotationBorderStyleType = {
	  SOLID: 1,
	  DASHED: 2,
	  BEVELED: 3,
	  INSET: 4,
	  UNDERLINE: 5
	};
	var StreamType = {
	  UNKNOWN: 0,
	  FLATE: 1,
	  LZW: 2,
	  DCT: 3,
	  JPX: 4,
	  JBIG: 5,
	  A85: 6,
	  AHX: 7,
	  CCF: 8,
	  RL: 9
	};
	var FontType = {
	  UNKNOWN: 0,
	  TYPE1: 1,
	  TYPE1C: 2,
	  CIDFONTTYPE0: 3,
	  CIDFONTTYPE0C: 4,
	  TRUETYPE: 5,
	  CIDFONTTYPE2: 6,
	  TYPE3: 7,
	  OPENTYPE: 8,
	  TYPE0: 9,
	  MMTYPE1: 10
	};
	var VERBOSITY_LEVELS = {
	  errors: 0,
	  warnings: 1,
	  infos: 5
	};
	var CMapCompressionType = {
	  NONE: 0,
	  BINARY: 1,
	  STREAM: 2
	};
	var OPS = {
	  dependency: 1,
	  setLineWidth: 2,
	  setLineCap: 3,
	  setLineJoin: 4,
	  setMiterLimit: 5,
	  setDash: 6,
	  setRenderingIntent: 7,
	  setFlatness: 8,
	  setGState: 9,
	  save: 10,
	  restore: 11,
	  transform: 12,
	  moveTo: 13,
	  lineTo: 14,
	  curveTo: 15,
	  curveTo2: 16,
	  curveTo3: 17,
	  closePath: 18,
	  rectangle: 19,
	  stroke: 20,
	  closeStroke: 21,
	  fill: 22,
	  eoFill: 23,
	  fillStroke: 24,
	  eoFillStroke: 25,
	  closeFillStroke: 26,
	  closeEOFillStroke: 27,
	  endPath: 28,
	  clip: 29,
	  eoClip: 30,
	  beginText: 31,
	  endText: 32,
	  setCharSpacing: 33,
	  setWordSpacing: 34,
	  setHScale: 35,
	  setLeading: 36,
	  setFont: 37,
	  setTextRenderingMode: 38,
	  setTextRise: 39,
	  moveText: 40,
	  setLeadingMoveText: 41,
	  setTextMatrix: 42,
	  nextLine: 43,
	  showText: 44,
	  showSpacedText: 45,
	  nextLineShowText: 46,
	  nextLineSetSpacingShowText: 47,
	  setCharWidth: 48,
	  setCharWidthAndBounds: 49,
	  setStrokeColorSpace: 50,
	  setFillColorSpace: 51,
	  setStrokeColor: 52,
	  setStrokeColorN: 53,
	  setFillColor: 54,
	  setFillColorN: 55,
	  setStrokeGray: 56,
	  setFillGray: 57,
	  setStrokeRGBColor: 58,
	  setFillRGBColor: 59,
	  setStrokeCMYKColor: 60,
	  setFillCMYKColor: 61,
	  shadingFill: 62,
	  beginInlineImage: 63,
	  beginImageData: 64,
	  endInlineImage: 65,
	  paintXObject: 66,
	  markPoint: 67,
	  markPointProps: 68,
	  beginMarkedContent: 69,
	  beginMarkedContentProps: 70,
	  endMarkedContent: 71,
	  beginCompat: 72,
	  endCompat: 73,
	  paintFormXObjectBegin: 74,
	  paintFormXObjectEnd: 75,
	  beginGroup: 76,
	  endGroup: 77,
	  beginAnnotations: 78,
	  endAnnotations: 79,
	  beginAnnotation: 80,
	  endAnnotation: 81,
	  paintJpegXObject: 82,
	  paintImageMaskXObject: 83,
	  paintImageMaskXObjectGroup: 84,
	  paintImageXObject: 85,
	  paintInlineImageXObject: 86,
	  paintInlineImageXObjectGroup: 87,
	  paintImageXObjectRepeat: 88,
	  paintImageMaskXObjectRepeat: 89,
	  paintSolidColorImageMask: 90,
	  constructPath: 91
	};
	var verbosity = VERBOSITY_LEVELS.warnings;
	function setVerbosityLevel(level) {
	  verbosity = level;
	}
	function getVerbosityLevel() {
	  return verbosity;
	}
	function info(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.infos) {
	    console.log('Info: ' + msg);
	  }
	}
	function warn(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.warnings) {
	    console.log('Warning: ' + msg);
	  }
	}
	function deprecated(details) {
	  console.log('Deprecated API usage: ' + details);
	}
	function error(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.errors) {
	    console.log('Error: ' + msg);
	    console.log(backtrace());
	  }
	  throw new Error(msg);
	}
	function backtrace() {
	  try {
	    throw new Error();
	  } catch (e) {
	    return e.stack ? e.stack.split('\n').slice(2).join('\n') : '';
	  }
	}
	function assert(cond, msg) {
	  if (!cond) {
	    error(msg);
	  }
	}
	var UNSUPPORTED_FEATURES = {
	  unknown: 'unknown',
	  forms: 'forms',
	  javaScript: 'javaScript',
	  smask: 'smask',
	  shadingPattern: 'shadingPattern',
	  font: 'font'
	};
	function isSameOrigin(baseUrl, otherUrl) {
	  try {
	    var base = new URL(baseUrl);
	    if (!base.origin || base.origin === 'null') {
	      return false;
	    }
	  } catch (e) {
	    return false;
	  }
	  var other = new URL(otherUrl, base);
	  return base.origin === other.origin;
	}
	function isValidProtocol(url) {
	  if (!url) {
	    return false;
	  }
	  switch (url.protocol) {
	    case 'http:':
	    case 'https:':
	    case 'ftp:':
	    case 'mailto:':
	    case 'tel:':
	      return true;
	    default:
	      return false;
	  }
	}
	function createValidAbsoluteUrl(url, baseUrl) {
	  if (!url) {
	    return null;
	  }
	  try {
	    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
	    if (isValidProtocol(absoluteUrl)) {
	      return absoluteUrl;
	    }
	  } catch (ex) {}
	  return null;
	}
	function shadow(obj, prop, value) {
	  Object.defineProperty(obj, prop, {
	    value: value,
	    enumerable: true,
	    configurable: true,
	    writable: false
	  });
	  return value;
	}
	function getLookupTableFactory(initializer) {
	  var lookup;
	  return function () {
	    if (initializer) {
	      lookup = Object.create(null);
	      initializer(lookup);
	      initializer = null;
	    }
	    return lookup;
	  };
	}
	var PasswordResponses = {
	  NEED_PASSWORD: 1,
	  INCORRECT_PASSWORD: 2
	};
	var PasswordException = function PasswordExceptionClosure() {
	  function PasswordException(msg, code) {
	    this.name = 'PasswordException';
	    this.message = msg;
	    this.code = code;
	  }
	  PasswordException.prototype = new Error();
	  PasswordException.constructor = PasswordException;
	  return PasswordException;
	}();
	var UnknownErrorException = function UnknownErrorExceptionClosure() {
	  function UnknownErrorException(msg, details) {
	    this.name = 'UnknownErrorException';
	    this.message = msg;
	    this.details = details;
	  }
	  UnknownErrorException.prototype = new Error();
	  UnknownErrorException.constructor = UnknownErrorException;
	  return UnknownErrorException;
	}();
	var InvalidPDFException = function InvalidPDFExceptionClosure() {
	  function InvalidPDFException(msg) {
	    this.name = 'InvalidPDFException';
	    this.message = msg;
	  }
	  InvalidPDFException.prototype = new Error();
	  InvalidPDFException.constructor = InvalidPDFException;
	  return InvalidPDFException;
	}();
	var MissingPDFException = function MissingPDFExceptionClosure() {
	  function MissingPDFException(msg) {
	    this.name = 'MissingPDFException';
	    this.message = msg;
	  }
	  MissingPDFException.prototype = new Error();
	  MissingPDFException.constructor = MissingPDFException;
	  return MissingPDFException;
	}();
	var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
	  function UnexpectedResponseException(msg, status) {
	    this.name = 'UnexpectedResponseException';
	    this.message = msg;
	    this.status = status;
	  }
	  UnexpectedResponseException.prototype = new Error();
	  UnexpectedResponseException.constructor = UnexpectedResponseException;
	  return UnexpectedResponseException;
	}();
	var NotImplementedException = function NotImplementedExceptionClosure() {
	  function NotImplementedException(msg) {
	    this.message = msg;
	  }
	  NotImplementedException.prototype = new Error();
	  NotImplementedException.prototype.name = 'NotImplementedException';
	  NotImplementedException.constructor = NotImplementedException;
	  return NotImplementedException;
	}();
	var MissingDataException = function MissingDataExceptionClosure() {
	  function MissingDataException(begin, end) {
	    this.begin = begin;
	    this.end = end;
	    this.message = 'Missing data [' + begin + ', ' + end + ')';
	  }
	  MissingDataException.prototype = new Error();
	  MissingDataException.prototype.name = 'MissingDataException';
	  MissingDataException.constructor = MissingDataException;
	  return MissingDataException;
	}();
	var XRefParseException = function XRefParseExceptionClosure() {
	  function XRefParseException(msg) {
	    this.message = msg;
	  }
	  XRefParseException.prototype = new Error();
	  XRefParseException.prototype.name = 'XRefParseException';
	  XRefParseException.constructor = XRefParseException;
	  return XRefParseException;
	}();
	var NullCharactersRegExp = /\x00/g;
	function removeNullCharacters(str) {
	  if (typeof str !== 'string') {
	    warn('The argument for removeNullCharacters must be a string.');
	    return str;
	  }
	  return str.replace(NullCharactersRegExp, '');
	}
	function bytesToString(bytes) {
	  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
	  var length = bytes.length;
	  var MAX_ARGUMENT_COUNT = 8192;
	  if (length < MAX_ARGUMENT_COUNT) {
	    return String.fromCharCode.apply(null, bytes);
	  }
	  var strBuf = [];
	  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
	    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
	    var chunk = bytes.subarray(i, chunkEnd);
	    strBuf.push(String.fromCharCode.apply(null, chunk));
	  }
	  return strBuf.join('');
	}
	function stringToBytes(str) {
	  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
	  var length = str.length;
	  var bytes = new Uint8Array(length);
	  for (var i = 0; i < length; ++i) {
	    bytes[i] = str.charCodeAt(i) & 0xFF;
	  }
	  return bytes;
	}
	function arrayByteLength(arr) {
	  if (arr.length !== undefined) {
	    return arr.length;
	  }
	  assert(arr.byteLength !== undefined);
	  return arr.byteLength;
	}
	function arraysToBytes(arr) {
	  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
	    return arr[0];
	  }
	  var resultLength = 0;
	  var i,
	      ii = arr.length;
	  var item, itemLength;
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    itemLength = arrayByteLength(item);
	    resultLength += itemLength;
	  }
	  var pos = 0;
	  var data = new Uint8Array(resultLength);
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    if (!(item instanceof Uint8Array)) {
	      if (typeof item === 'string') {
	        item = stringToBytes(item);
	      } else {
	        item = new Uint8Array(item);
	      }
	    }
	    itemLength = item.byteLength;
	    data.set(item, pos);
	    pos += itemLength;
	  }
	  return data;
	}
	function string32(value) {
	  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
	}
	function log2(x) {
	  var n = 1,
	      i = 0;
	  while (x > n) {
	    n <<= 1;
	    i++;
	  }
	  return i;
	}
	function readInt8(data, start) {
	  return data[start] << 24 >> 24;
	}
	function readUint16(data, offset) {
	  return data[offset] << 8 | data[offset + 1];
	}
	function readUint32(data, offset) {
	  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
	}
	function isLittleEndian() {
	  var buffer8 = new Uint8Array(4);
	  buffer8[0] = 1;
	  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
	  return view32[0] === 1;
	}
	function isEvalSupported() {
	  try {
	    new Function('');
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
	var Util = function UtilClosure() {
	  function Util() {}
	  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
	  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
	    rgbBuf[1] = r;
	    rgbBuf[3] = g;
	    rgbBuf[5] = b;
	    return rgbBuf.join('');
	  };
	  Util.transform = function Util_transform(m1, m2) {
	    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
	  };
	  Util.applyTransform = function Util_applyTransform(p, m) {
	    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
	    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
	    return [xt, yt];
	  };
	  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
	    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
	    return [xt, yt];
	  };
	  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
	    var p1 = Util.applyTransform(r, m);
	    var p2 = Util.applyTransform(r.slice(2, 4), m);
	    var p3 = Util.applyTransform([r[0], r[3]], m);
	    var p4 = Util.applyTransform([r[2], r[1]], m);
	    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
	  };
	  Util.inverseTransform = function Util_inverseTransform(m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
	  };
	  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
	    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
	  };
	  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
	    var transpose = [m[0], m[2], m[1], m[3]];
	    var a = m[0] * transpose[0] + m[1] * transpose[2];
	    var b = m[0] * transpose[1] + m[1] * transpose[3];
	    var c = m[2] * transpose[0] + m[3] * transpose[2];
	    var d = m[2] * transpose[1] + m[3] * transpose[3];
	    var first = (a + d) / 2;
	    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
	    var sx = first + second || 1;
	    var sy = first - second || 1;
	    return [Math.sqrt(sx), Math.sqrt(sy)];
	  };
	  Util.normalizeRect = function Util_normalizeRect(rect) {
	    var r = rect.slice(0);
	    if (rect[0] > rect[2]) {
	      r[0] = rect[2];
	      r[2] = rect[0];
	    }
	    if (rect[1] > rect[3]) {
	      r[1] = rect[3];
	      r[3] = rect[1];
	    }
	    return r;
	  };
	  Util.intersect = function Util_intersect(rect1, rect2) {
	    function compare(a, b) {
	      return a - b;
	    }
	    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
	        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
	        result = [];
	    rect1 = Util.normalizeRect(rect1);
	    rect2 = Util.normalizeRect(rect2);
	    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
	      result[0] = orderedX[1];
	      result[2] = orderedX[2];
	    } else {
	      return false;
	    }
	    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
	      result[1] = orderedY[1];
	      result[3] = orderedY[2];
	    } else {
	      return false;
	    }
	    return result;
	  };
	  Util.sign = function Util_sign(num) {
	    return num < 0 ? -1 : 1;
	  };
	  var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
	  Util.toRoman = function Util_toRoman(number, lowerCase) {
	    assert(isInt(number) && number > 0, 'The number should be a positive integer.');
	    var pos,
	        romanBuf = [];
	    while (number >= 1000) {
	      number -= 1000;
	      romanBuf.push('M');
	    }
	    pos = number / 100 | 0;
	    number %= 100;
	    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
	    pos = number / 10 | 0;
	    number %= 10;
	    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
	    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
	    var romanStr = romanBuf.join('');
	    return lowerCase ? romanStr.toLowerCase() : romanStr;
	  };
	  Util.appendToArray = function Util_appendToArray(arr1, arr2) {
	    Array.prototype.push.apply(arr1, arr2);
	  };
	  Util.prependToArray = function Util_prependToArray(arr1, arr2) {
	    Array.prototype.unshift.apply(arr1, arr2);
	  };
	  Util.extendObj = function extendObj(obj1, obj2) {
	    for (var key in obj2) {
	      obj1[key] = obj2[key];
	    }
	  };
	  Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
	    while (dict && !dict.has(name)) {
	      dict = dict.get('Parent');
	    }
	    if (!dict) {
	      return null;
	    }
	    return getArray ? dict.getArray(name) : dict.get(name);
	  };
	  Util.inherit = function Util_inherit(sub, base, prototype) {
	    sub.prototype = Object.create(base.prototype);
	    sub.prototype.constructor = sub;
	    for (var prop in prototype) {
	      sub.prototype[prop] = prototype[prop];
	    }
	  };
	  Util.loadScript = function Util_loadScript(src, callback) {
	    var script = document.createElement('script');
	    var loaded = false;
	    script.setAttribute('src', src);
	    if (callback) {
	      script.onload = function () {
	        if (!loaded) {
	          callback();
	        }
	        loaded = true;
	      };
	    }
	    document.getElementsByTagName('head')[0].appendChild(script);
	  };
	  return Util;
	}();
	var PageViewport = function PageViewportClosure() {
	  function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
	    this.viewBox = viewBox;
	    this.scale = scale;
	    this.rotation = rotation;
	    this.offsetX = offsetX;
	    this.offsetY = offsetY;
	    var centerX = (viewBox[2] + viewBox[0]) / 2;
	    var centerY = (viewBox[3] + viewBox[1]) / 2;
	    var rotateA, rotateB, rotateC, rotateD;
	    rotation = rotation % 360;
	    rotation = rotation < 0 ? rotation + 360 : rotation;
	    switch (rotation) {
	      case 180:
	        rotateA = -1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = 1;
	        break;
	      case 90:
	        rotateA = 0;
	        rotateB = 1;
	        rotateC = 1;
	        rotateD = 0;
	        break;
	      case 270:
	        rotateA = 0;
	        rotateB = -1;
	        rotateC = -1;
	        rotateD = 0;
	        break;
	      default:
	        rotateA = 1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = -1;
	        break;
	    }
	    if (dontFlip) {
	      rotateC = -rotateC;
	      rotateD = -rotateD;
	    }
	    var offsetCanvasX, offsetCanvasY;
	    var width, height;
	    if (rotateA === 0) {
	      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
	      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
	      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
	    } else {
	      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
	      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
	      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
	    }
	    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
	    this.width = width;
	    this.height = height;
	    this.fontScale = scale;
	  }
	  PageViewport.prototype = {
	    clone: function PageViewPort_clone(args) {
	      args = args || {};
	      var scale = 'scale' in args ? args.scale : this.scale;
	      var rotation = 'rotation' in args ? args.rotation : this.rotation;
	      return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
	    },
	    convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
	      return Util.applyTransform([x, y], this.transform);
	    },
	    convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
	      var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
	      var br = Util.applyTransform([rect[2], rect[3]], this.transform);
	      return [tl[0], tl[1], br[0], br[1]];
	    },
	    convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
	      return Util.applyInverseTransform([x, y], this.transform);
	    }
	  };
	  return PageViewport;
	}();
	var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
	function stringToPDFString(str) {
	  var i,
	      n = str.length,
	      strBuf = [];
	  if (str[0] === '\xFE' && str[1] === '\xFF') {
	    for (i = 2; i < n; i += 2) {
	      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
	    }
	  } else {
	    for (i = 0; i < n; ++i) {
	      var code = PDFStringTranslateTable[str.charCodeAt(i)];
	      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
	    }
	  }
	  return strBuf.join('');
	}
	function stringToUTF8String(str) {
	  return decodeURIComponent(escape(str));
	}
	function utf8StringToString(str) {
	  return unescape(encodeURIComponent(str));
	}
	function isEmptyObj(obj) {
	  for (var key in obj) {
	    return false;
	  }
	  return true;
	}
	function isBool(v) {
	  return typeof v === 'boolean';
	}
	function isInt(v) {
	  return typeof v === 'number' && (v | 0) === v;
	}
	function isNum(v) {
	  return typeof v === 'number';
	}
	function isString(v) {
	  return typeof v === 'string';
	}
	function isArray(v) {
	  return v instanceof Array;
	}
	function isArrayBuffer(v) {
	  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
	}
	function isSpace(ch) {
	  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
	}
	function isNodeJS() {
	  if (typeof __pdfjsdev_webpack__ === 'undefined') {
	    return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
	  }
	  return false;
	}
	function createPromiseCapability() {
	  var capability = {};
	  capability.promise = new Promise(function (resolve, reject) {
	    capability.resolve = resolve;
	    capability.reject = reject;
	  });
	  return capability;
	}
	var StatTimer = function StatTimerClosure() {
	  function rpad(str, pad, length) {
	    while (str.length < length) {
	      str += pad;
	    }
	    return str;
	  }
	  function StatTimer() {
	    this.started = Object.create(null);
	    this.times = [];
	    this.enabled = true;
	  }
	  StatTimer.prototype = {
	    time: function StatTimer_time(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (name in this.started) {
	        warn('Timer is already running for ' + name);
	      }
	      this.started[name] = Date.now();
	    },
	    timeEnd: function StatTimer_timeEnd(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (!(name in this.started)) {
	        warn('Timer has not been started for ' + name);
	      }
	      this.times.push({
	        'name': name,
	        'start': this.started[name],
	        'end': Date.now()
	      });
	      delete this.started[name];
	    },
	    toString: function StatTimer_toString() {
	      var i, ii;
	      var times = this.times;
	      var out = '';
	      var longest = 0;
	      for (i = 0, ii = times.length; i < ii; ++i) {
	        var name = times[i]['name'];
	        if (name.length > longest) {
	          longest = name.length;
	        }
	      }
	      for (i = 0, ii = times.length; i < ii; ++i) {
	        var span = times[i];
	        var duration = span.end - span.start;
	        out += rpad(span['name'], ' ', longest) + ' ' + duration + 'ms\n';
	      }
	      return out;
	    }
	  };
	  return StatTimer;
	}();
	var createBlob = function createBlob(data, contentType) {
	  if (typeof Blob !== 'undefined') {
	    return new Blob([data], { type: contentType });
	  }
	  throw new Error('The "Blob" constructor is not supported.');
	};
	var createObjectURL = function createObjectURLClosure() {
	  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	  return function createObjectURL(data, contentType) {
	    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (!forceDataSchema && URL.createObjectURL) {
	      var blob = createBlob(data, contentType);
	      return URL.createObjectURL(blob);
	    }
	    var buffer = 'data:' + contentType + ';base64,';
	    for (var i = 0, ii = data.length; i < ii; i += 3) {
	      var b1 = data[i] & 0xFF;
	      var b2 = data[i + 1] & 0xFF;
	      var b3 = data[i + 2] & 0xFF;
	      var d1 = b1 >> 2,
	          d2 = (b1 & 3) << 4 | b2 >> 4;
	      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
	      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
	    }
	    return buffer;
	  };
	}();
	function MessageHandler(sourceName, targetName, comObj) {
	  var _this = this;
	
	  this.sourceName = sourceName;
	  this.targetName = targetName;
	  this.comObj = comObj;
	  this.callbackIndex = 1;
	  this.postMessageTransfers = true;
	  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
	  var ah = this.actionHandler = Object.create(null);
	  this._onComObjOnMessage = function (event) {
	    var data = event.data;
	    if (data.targetName !== _this.sourceName) {
	      return;
	    }
	    if (data.isReply) {
	      var callbackId = data.callbackId;
	      if (data.callbackId in callbacksCapabilities) {
	        var callback = callbacksCapabilities[callbackId];
	        delete callbacksCapabilities[callbackId];
	        if ('error' in data) {
	          callback.reject(data.error);
	        } else {
	          callback.resolve(data.data);
	        }
	      } else {
	        error('Cannot resolve callback ' + callbackId);
	      }
	    } else if (data.action in ah) {
	      var action = ah[data.action];
	      if (data.callbackId) {
	        var sourceName = _this.sourceName;
	        var targetName = data.sourceName;
	        Promise.resolve().then(function () {
	          return action[0].call(action[1], data.data);
	        }).then(function (result) {
	          comObj.postMessage({
	            sourceName: sourceName,
	            targetName: targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            data: result
	          });
	        }, function (reason) {
	          if (reason instanceof Error) {
	            reason = reason + '';
	          }
	          comObj.postMessage({
	            sourceName: sourceName,
	            targetName: targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            error: reason
	          });
	        });
	      } else {
	        action[0].call(action[1], data.data);
	      }
	    } else {
	      error('Unknown action from worker: ' + data.action);
	    }
	  };
	  comObj.addEventListener('message', this._onComObjOnMessage);
	}
	MessageHandler.prototype = {
	  on: function on(actionName, handler, scope) {
	    var ah = this.actionHandler;
	    if (ah[actionName]) {
	      error('There is already an actionName called "' + actionName + '"');
	    }
	    ah[actionName] = [handler, scope];
	  },
	  send: function send(actionName, data, transfers) {
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data
	    };
	    this.postMessage(message, transfers);
	  },
	  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
	    var callbackId = this.callbackIndex++;
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data,
	      callbackId: callbackId
	    };
	    var capability = createPromiseCapability();
	    this.callbacksCapabilities[callbackId] = capability;
	    try {
	      this.postMessage(message, transfers);
	    } catch (e) {
	      capability.reject(e);
	    }
	    return capability.promise;
	  },
	  postMessage: function postMessage(message, transfers) {
	    if (transfers && this.postMessageTransfers) {
	      this.comObj.postMessage(message, transfers);
	    } else {
	      this.comObj.postMessage(message);
	    }
	  },
	  destroy: function destroy() {
	    this.comObj.removeEventListener('message', this._onComObjOnMessage);
	  }
	};
	function loadJpegStream(id, imageUrl, objs) {
	  var img = new Image();
	  img.onload = function loadJpegStream_onloadClosure() {
	    objs.resolve(id, img);
	  };
	  img.onerror = function loadJpegStream_onerrorClosure() {
	    objs.resolve(id, null);
	    warn('Error during JPEG image loading');
	  };
	  img.src = imageUrl;
	}
	exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
	exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
	exports.OPS = OPS;
	exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
	exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
	exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
	exports.AnnotationFieldFlag = AnnotationFieldFlag;
	exports.AnnotationFlag = AnnotationFlag;
	exports.AnnotationType = AnnotationType;
	exports.FontType = FontType;
	exports.ImageKind = ImageKind;
	exports.CMapCompressionType = CMapCompressionType;
	exports.InvalidPDFException = InvalidPDFException;
	exports.MessageHandler = MessageHandler;
	exports.MissingDataException = MissingDataException;
	exports.MissingPDFException = MissingPDFException;
	exports.NotImplementedException = NotImplementedException;
	exports.PageViewport = PageViewport;
	exports.PasswordException = PasswordException;
	exports.PasswordResponses = PasswordResponses;
	exports.StatTimer = StatTimer;
	exports.StreamType = StreamType;
	exports.TextRenderingMode = TextRenderingMode;
	exports.UnexpectedResponseException = UnexpectedResponseException;
	exports.UnknownErrorException = UnknownErrorException;
	exports.Util = Util;
	exports.XRefParseException = XRefParseException;
	exports.arrayByteLength = arrayByteLength;
	exports.arraysToBytes = arraysToBytes;
	exports.assert = assert;
	exports.bytesToString = bytesToString;
	exports.createBlob = createBlob;
	exports.createPromiseCapability = createPromiseCapability;
	exports.createObjectURL = createObjectURL;
	exports.deprecated = deprecated;
	exports.error = error;
	exports.getLookupTableFactory = getLookupTableFactory;
	exports.getVerbosityLevel = getVerbosityLevel;
	exports.globalScope = globalScope;
	exports.info = info;
	exports.isArray = isArray;
	exports.isArrayBuffer = isArrayBuffer;
	exports.isBool = isBool;
	exports.isEmptyObj = isEmptyObj;
	exports.isInt = isInt;
	exports.isNum = isNum;
	exports.isString = isString;
	exports.isSpace = isSpace;
	exports.isNodeJS = isNodeJS;
	exports.isSameOrigin = isSameOrigin;
	exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
	exports.isLittleEndian = isLittleEndian;
	exports.isEvalSupported = isEvalSupported;
	exports.loadJpegStream = loadJpegStream;
	exports.log2 = log2;
	exports.readInt8 = readInt8;
	exports.readUint16 = readUint16;
	exports.readUint32 = readUint32;
	exports.removeNullCharacters = removeNullCharacters;
	exports.setVerbosityLevel = setVerbosityLevel;
	exports.shadow = shadow;
	exports.string32 = string32;
	exports.stringToBytes = stringToBytes;
	exports.stringToPDFString = stringToPDFString;
	exports.stringToUTF8String = stringToUTF8String;
	exports.utf8StringToString = utf8StringToString;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, __w_pdfjs_require__(6)))
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.getDefaultSetting = exports.LinkTarget = exports.getFilenameFromUrl = exports.isValidUrl = exports.isExternalLinkTargetSet = exports.addLinkAttributes = exports.RenderingCancelledException = exports.CustomStyle = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
	function DOMCanvasFactory() {}
	DOMCanvasFactory.prototype = {
	  create: function DOMCanvasFactory_create(width, height) {
	    (0, _util.assert)(width > 0 && height > 0, 'invalid canvas size');
	    var canvas = document.createElement('canvas');
	    var context = canvas.getContext('2d');
	    canvas.width = width;
	    canvas.height = height;
	    return {
	      canvas: canvas,
	      context: context
	    };
	  },
	  reset: function DOMCanvasFactory_reset(canvasAndContextPair, width, height) {
	    (0, _util.assert)(canvasAndContextPair.canvas, 'canvas is not specified');
	    (0, _util.assert)(width > 0 && height > 0, 'invalid canvas size');
	    canvasAndContextPair.canvas.width = width;
	    canvasAndContextPair.canvas.height = height;
	  },
	  destroy: function DOMCanvasFactory_destroy(canvasAndContextPair) {
	    (0, _util.assert)(canvasAndContextPair.canvas, 'canvas is not specified');
	    canvasAndContextPair.canvas.width = 0;
	    canvasAndContextPair.canvas.height = 0;
	    canvasAndContextPair.canvas = null;
	    canvasAndContextPair.context = null;
	  }
	};
	var DOMCMapReaderFactory = function DOMCMapReaderFactoryClosure() {
	  function DOMCMapReaderFactory(params) {
	    this.baseUrl = params.baseUrl || null;
	    this.isCompressed = params.isCompressed || false;
	  }
	  DOMCMapReaderFactory.prototype = {
	    fetch: function fetch(params) {
	      var _this = this;
	
	      var name = params.name;
	      if (!name) {
	        return Promise.reject(new Error('CMap name must be specified.'));
	      }
	      return new Promise(function (resolve, reject) {
	        var url = _this.baseUrl + name + (_this.isCompressed ? '.bcmap' : '');
	        var request = new XMLHttpRequest();
	        request.open('GET', url, true);
	        if (_this.isCompressed) {
	          request.responseType = 'arraybuffer';
	        }
	        request.onreadystatechange = function () {
	          if (request.readyState !== XMLHttpRequest.DONE) {
	            return;
	          }
	          if (request.status === 200 || request.status === 0) {
	            var data;
	            if (_this.isCompressed && request.response) {
	              data = new Uint8Array(request.response);
	            } else if (!_this.isCompressed && request.responseText) {
	              data = (0, _util.stringToBytes)(request.responseText);
	            }
	            if (data) {
	              resolve({
	                cMapData: data,
	                compressionType: _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE
	              });
	              return;
	            }
	          }
	          reject(new Error('Unable to load ' + (_this.isCompressed ? 'binary ' : '') + 'CMap at: ' + url));
	        };
	        request.send(null);
	      });
	    }
	  };
	  return DOMCMapReaderFactory;
	}();
	var CustomStyle = function CustomStyleClosure() {
	  var prefixes = ['ms', 'Moz', 'Webkit', 'O'];
	  var _cache = Object.create(null);
	  function CustomStyle() {}
	  CustomStyle.getProp = function get(propName, element) {
	    if (arguments.length === 1 && typeof _cache[propName] === 'string') {
	      return _cache[propName];
	    }
	    element = element || document.documentElement;
	    var style = element.style,
	        prefixed,
	        uPropName;
	    if (typeof style[propName] === 'string') {
	      return _cache[propName] = propName;
	    }
	    uPropName = propName.charAt(0).toUpperCase() + propName.slice(1);
	    for (var i = 0, l = prefixes.length; i < l; i++) {
	      prefixed = prefixes[i] + uPropName;
	      if (typeof style[prefixed] === 'string') {
	        return _cache[propName] = prefixed;
	      }
	    }
	    return _cache[propName] = 'undefined';
	  };
	  CustomStyle.setProp = function set(propName, element, str) {
	    var prop = this.getProp(propName);
	    if (prop !== 'undefined') {
	      element.style[prop] = str;
	    }
	  };
	  return CustomStyle;
	}();
	var RenderingCancelledException = function RenderingCancelledException() {
	  function RenderingCancelledException(msg, type) {
	    this.message = msg;
	    this.type = type;
	  }
	  RenderingCancelledException.prototype = new Error();
	  RenderingCancelledException.prototype.name = 'RenderingCancelledException';
	  RenderingCancelledException.constructor = RenderingCancelledException;
	  return RenderingCancelledException;
	}();
	var LinkTarget = {
	  NONE: 0,
	  SELF: 1,
	  BLANK: 2,
	  PARENT: 3,
	  TOP: 4
	};
	var LinkTargetStringMap = ['', '_self', '_blank', '_parent', '_top'];
	function addLinkAttributes(link, params) {
	  var url = params && params.url;
	  link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : '';
	  if (url) {
	    var target = params.target;
	    if (typeof target === 'undefined') {
	      target = getDefaultSetting('externalLinkTarget');
	    }
	    link.target = LinkTargetStringMap[target];
	    var rel = params.rel;
	    if (typeof rel === 'undefined') {
	      rel = getDefaultSetting('externalLinkRel');
	    }
	    link.rel = rel;
	  }
	}
	function getFilenameFromUrl(url) {
	  var anchor = url.indexOf('#');
	  var query = url.indexOf('?');
	  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
	  return url.substring(url.lastIndexOf('/', end) + 1, end);
	}
	function getDefaultSetting(id) {
	  var globalSettings = _util.globalScope.PDFJS;
	  switch (id) {
	    case 'pdfBug':
	      return globalSettings ? globalSettings.pdfBug : false;
	    case 'disableAutoFetch':
	      return globalSettings ? globalSettings.disableAutoFetch : false;
	    case 'disableStream':
	      return globalSettings ? globalSettings.disableStream : false;
	    case 'disableRange':
	      return globalSettings ? globalSettings.disableRange : false;
	    case 'disableFontFace':
	      return globalSettings ? globalSettings.disableFontFace : false;
	    case 'disableCreateObjectURL':
	      return globalSettings ? globalSettings.disableCreateObjectURL : false;
	    case 'disableWebGL':
	      return globalSettings ? globalSettings.disableWebGL : true;
	    case 'cMapUrl':
	      return globalSettings ? globalSettings.cMapUrl : null;
	    case 'cMapPacked':
	      return globalSettings ? globalSettings.cMapPacked : false;
	    case 'postMessageTransfers':
	      return globalSettings ? globalSettings.postMessageTransfers : true;
	    case 'workerPort':
	      return globalSettings ? globalSettings.workerPort : null;
	    case 'workerSrc':
	      return globalSettings ? globalSettings.workerSrc : null;
	    case 'disableWorker':
	      return globalSettings ? globalSettings.disableWorker : false;
	    case 'maxImageSize':
	      return globalSettings ? globalSettings.maxImageSize : -1;
	    case 'imageResourcesPath':
	      return globalSettings ? globalSettings.imageResourcesPath : '';
	    case 'isEvalSupported':
	      return globalSettings ? globalSettings.isEvalSupported : true;
	    case 'externalLinkTarget':
	      if (!globalSettings) {
	        return LinkTarget.NONE;
	      }
	      switch (globalSettings.externalLinkTarget) {
	        case LinkTarget.NONE:
	        case LinkTarget.SELF:
	        case LinkTarget.BLANK:
	        case LinkTarget.PARENT:
	        case LinkTarget.TOP:
	          return globalSettings.externalLinkTarget;
	      }
	      (0, _util.warn)('PDFJS.externalLinkTarget is invalid: ' + globalSettings.externalLinkTarget);
	      globalSettings.externalLinkTarget = LinkTarget.NONE;
	      return LinkTarget.NONE;
	    case 'externalLinkRel':
	      return globalSettings ? globalSettings.externalLinkRel : DEFAULT_LINK_REL;
	    case 'enableStats':
	      return !!(globalSettings && globalSettings.enableStats);
	    case 'pdfjsNext':
	      return !!(globalSettings && globalSettings.pdfjsNext);
	    default:
	      throw new Error('Unknown default setting: ' + id);
	  }
	}
	function isExternalLinkTargetSet() {
	  var externalLinkTarget = getDefaultSetting('externalLinkTarget');
	  switch (externalLinkTarget) {
	    case LinkTarget.NONE:
	      return false;
	    case LinkTarget.SELF:
	    case LinkTarget.BLANK:
	    case LinkTarget.PARENT:
	    case LinkTarget.TOP:
	      return true;
	  }
	}
	function isValidUrl(url, allowRelative) {
	  (0, _util.deprecated)('isValidUrl(), please use createValidAbsoluteUrl() instead.');
	  var baseUrl = allowRelative ? 'http://example.com' : null;
	  return (0, _util.createValidAbsoluteUrl)(url, baseUrl) !== null;
	}
	exports.CustomStyle = CustomStyle;
	exports.RenderingCancelledException = RenderingCancelledException;
	exports.addLinkAttributes = addLinkAttributes;
	exports.isExternalLinkTargetSet = isExternalLinkTargetSet;
	exports.isValidUrl = isValidUrl;
	exports.getFilenameFromUrl = getFilenameFromUrl;
	exports.LinkTarget = LinkTarget;
	exports.getDefaultSetting = getDefaultSetting;
	exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
	exports.DOMCanvasFactory = DOMCanvasFactory;
	exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnnotationLayer = undefined;
	
	var _dom_utils = __w_pdfjs_require__(1);
	
	var _util = __w_pdfjs_require__(0);
	
	function AnnotationElementFactory() {}
	AnnotationElementFactory.prototype = {
	  create: function AnnotationElementFactory_create(parameters) {
	    var subtype = parameters.data.annotationType;
	    switch (subtype) {
	      case _util.AnnotationType.LINK:
	        return new LinkAnnotationElement(parameters);
	      case _util.AnnotationType.TEXT:
	        return new TextAnnotationElement(parameters);
	      case _util.AnnotationType.WIDGET:
	        var fieldType = parameters.data.fieldType;
	        switch (fieldType) {
	          case 'Tx':
	            return new TextWidgetAnnotationElement(parameters);
	          case 'Btn':
	            if (parameters.data.radioButton) {
	              return new RadioButtonWidgetAnnotationElement(parameters);
	            } else if (parameters.data.checkBox) {
	              return new CheckboxWidgetAnnotationElement(parameters);
	            }
	            (0, _util.warn)('Unimplemented button widget annotation: pushbutton');
	            break;
	          case 'Ch':
	            return new ChoiceWidgetAnnotationElement(parameters);
	        }
	        return new WidgetAnnotationElement(parameters);
	      case _util.AnnotationType.POPUP:
	        return new PopupAnnotationElement(parameters);
	      case _util.AnnotationType.LINE:
	        return new LineAnnotationElement(parameters);
	      case _util.AnnotationType.HIGHLIGHT:
	        return new HighlightAnnotationElement(parameters);
	      case _util.AnnotationType.UNDERLINE:
	        return new UnderlineAnnotationElement(parameters);
	      case _util.AnnotationType.SQUIGGLY:
	        return new SquigglyAnnotationElement(parameters);
	      case _util.AnnotationType.STRIKEOUT:
	        return new StrikeOutAnnotationElement(parameters);
	      case _util.AnnotationType.FILEATTACHMENT:
	        return new FileAttachmentAnnotationElement(parameters);
	      default:
	        return new AnnotationElement(parameters);
	    }
	  }
	};
	var AnnotationElement = function AnnotationElementClosure() {
	  function AnnotationElement(parameters, isRenderable, ignoreBorder) {
	    this.isRenderable = isRenderable || false;
	    this.data = parameters.data;
	    this.layer = parameters.layer;
	    this.page = parameters.page;
	    this.viewport = parameters.viewport;
	    this.linkService = parameters.linkService;
	    this.downloadManager = parameters.downloadManager;
	    this.imageResourcesPath = parameters.imageResourcesPath;
	    this.renderInteractiveForms = parameters.renderInteractiveForms;
	    if (isRenderable) {
	      this.container = this._createContainer(ignoreBorder);
	    }
	  }
	  AnnotationElement.prototype = {
	    _createContainer: function AnnotationElement_createContainer(ignoreBorder) {
	      var data = this.data,
	          page = this.page,
	          viewport = this.viewport;
	      var container = document.createElement('section');
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      container.setAttribute('data-annotation-id', data.id);
	      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
	      _dom_utils.CustomStyle.setProp('transform', container, 'matrix(' + viewport.transform.join(',') + ')');
	      _dom_utils.CustomStyle.setProp('transformOrigin', container, -rect[0] + 'px ' + -rect[1] + 'px');
	      if (!ignoreBorder && data.borderStyle.width > 0) {
	        container.style.borderWidth = data.borderStyle.width + 'px';
	        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
	          width = width - 2 * data.borderStyle.width;
	          height = height - 2 * data.borderStyle.width;
	        }
	        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
	        var verticalRadius = data.borderStyle.verticalCornerRadius;
	        if (horizontalRadius > 0 || verticalRadius > 0) {
	          var radius = horizontalRadius + 'px / ' + verticalRadius + 'px';
	          _dom_utils.CustomStyle.setProp('borderRadius', container, radius);
	        }
	        switch (data.borderStyle.style) {
	          case _util.AnnotationBorderStyleType.SOLID:
	            container.style.borderStyle = 'solid';
	            break;
	          case _util.AnnotationBorderStyleType.DASHED:
	            container.style.borderStyle = 'dashed';
	            break;
	          case _util.AnnotationBorderStyleType.BEVELED:
	            (0, _util.warn)('Unimplemented border style: beveled');
	            break;
	          case _util.AnnotationBorderStyleType.INSET:
	            (0, _util.warn)('Unimplemented border style: inset');
	            break;
	          case _util.AnnotationBorderStyleType.UNDERLINE:
	            container.style.borderBottomStyle = 'solid';
	            break;
	          default:
	            break;
	        }
	        if (data.color) {
	          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
	        } else {
	          container.style.borderWidth = 0;
	        }
	      }
	      container.style.left = rect[0] + 'px';
	      container.style.top = rect[1] + 'px';
	      container.style.width = width + 'px';
	      container.style.height = height + 'px';
	      return container;
	    },
	    _createPopup: function AnnotationElement_createPopup(container, trigger, data) {
	      if (!trigger) {
	        trigger = document.createElement('div');
	        trigger.style.height = container.style.height;
	        trigger.style.width = container.style.width;
	        container.appendChild(trigger);
	      }
	      var popupElement = new PopupElement({
	        container: container,
	        trigger: trigger,
	        color: data.color,
	        title: data.title,
	        contents: data.contents,
	        hideWrapper: true
	      });
	      var popup = popupElement.render();
	      popup.style.left = container.style.width;
	      container.appendChild(popup);
	    },
	    render: function AnnotationElement_render() {
	      throw new Error('Abstract method AnnotationElement.render called');
	    }
	  };
	  return AnnotationElement;
	}();
	var LinkAnnotationElement = function LinkAnnotationElementClosure() {
	  function LinkAnnotationElement(parameters) {
	    AnnotationElement.call(this, parameters, true);
	  }
	  _util.Util.inherit(LinkAnnotationElement, AnnotationElement, {
	    render: function LinkAnnotationElement_render() {
	      this.container.className = 'linkAnnotation';
	      var link = document.createElement('a');
	      (0, _dom_utils.addLinkAttributes)(link, {
	        url: this.data.url,
	        target: this.data.newWindow ? _dom_utils.LinkTarget.BLANK : undefined
	      });
	      if (!this.data.url) {
	        if (this.data.action) {
	          this._bindNamedAction(link, this.data.action);
	        } else {
	          this._bindLink(link, this.data.dest);
	        }
	      }
	      this.container.appendChild(link);
	      return this.container;
	    },
	    _bindLink: function _bindLink(link, destination) {
	      var _this = this;
	
	      link.href = this.linkService.getDestinationHash(destination);
	      link.onclick = function () {
	        if (destination) {
	          _this.linkService.navigateTo(destination);
	        }
	        return false;
	      };
	      if (destination) {
	        link.className = 'internalLink';
	      }
	    },
	    _bindNamedAction: function _bindNamedAction(link, action) {
	      var _this2 = this;
	
	      link.href = this.linkService.getAnchorUrl('');
	      link.onclick = function () {
	        _this2.linkService.executeNamedAction(action);
	        return false;
	      };
	      link.className = 'internalLink';
	    }
	  });
	  return LinkAnnotationElement;
	}();
	var TextAnnotationElement = function TextAnnotationElementClosure() {
	  function TextAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable);
	  }
	  _util.Util.inherit(TextAnnotationElement, AnnotationElement, {
	    render: function TextAnnotationElement_render() {
	      this.container.className = 'textAnnotation';
	      var image = document.createElement('img');
	      image.style.height = this.container.style.height;
	      image.style.width = this.container.style.width;
	      image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
	      image.alt = '[{{type}} Annotation]';
	      image.dataset.l10nId = 'text_annotation_type';
	      image.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, image, this.data);
	      }
	      this.container.appendChild(image);
	      return this.container;
	    }
	  });
	  return TextAnnotationElement;
	}();
	var WidgetAnnotationElement = function WidgetAnnotationElementClosure() {
	  function WidgetAnnotationElement(parameters, isRenderable) {
	    AnnotationElement.call(this, parameters, isRenderable);
	  }
	  _util.Util.inherit(WidgetAnnotationElement, AnnotationElement, {
	    render: function WidgetAnnotationElement_render() {
	      return this.container;
	    }
	  });
	  return WidgetAnnotationElement;
	}();
	var TextWidgetAnnotationElement = function TextWidgetAnnotationElementClosure() {
	  var TEXT_ALIGNMENT = ['left', 'center', 'right'];
	  function TextWidgetAnnotationElement(parameters) {
	    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
	    WidgetAnnotationElement.call(this, parameters, isRenderable);
	  }
	  _util.Util.inherit(TextWidgetAnnotationElement, WidgetAnnotationElement, {
	    render: function TextWidgetAnnotationElement_render() {
	      this.container.className = 'textWidgetAnnotation';
	      var element = null;
	      if (this.renderInteractiveForms) {
	        if (this.data.multiLine) {
	          element = document.createElement('textarea');
	          element.textContent = this.data.fieldValue;
	        } else {
	          element = document.createElement('input');
	          element.type = 'text';
	          element.setAttribute('value', this.data.fieldValue);
	        }
	        element.disabled = this.data.readOnly;
	        if (this.data.maxLen !== null) {
	          element.maxLength = this.data.maxLen;
	        }
	        if (this.data.comb) {
	          var fieldWidth = this.data.rect[2] - this.data.rect[0];
	          var combWidth = fieldWidth / this.data.maxLen;
	          element.classList.add('comb');
	          element.style.letterSpacing = 'calc(' + combWidth + 'px - 1ch)';
	        }
	      } else {
	        element = document.createElement('div');
	        element.textContent = this.data.fieldValue;
	        element.style.verticalAlign = 'middle';
	        element.style.display = 'table-cell';
	        var font = null;
	        if (this.data.fontRefName) {
	          font = this.page.commonObjs.getData(this.data.fontRefName);
	        }
	        this._setTextStyle(element, font);
	      }
	      if (this.data.textAlignment !== null) {
	        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
	      }
	      this.container.appendChild(element);
	      return this.container;
	    },
	    _setTextStyle: function TextWidgetAnnotationElement_setTextStyle(element, font) {
	      var style = element.style;
	      style.fontSize = this.data.fontSize + 'px';
	      style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr';
	      if (!font) {
	        return;
	      }
	      style.fontWeight = font.black ? font.bold ? '900' : 'bold' : font.bold ? 'bold' : 'normal';
	      style.fontStyle = font.italic ? 'italic' : 'normal';
	      var fontFamily = font.loadedName ? '"' + font.loadedName + '", ' : '';
	      var fallbackName = font.fallbackName || 'Helvetica, sans-serif';
	      style.fontFamily = fontFamily + fallbackName;
	    }
	  });
	  return TextWidgetAnnotationElement;
	}();
	var CheckboxWidgetAnnotationElement = function CheckboxWidgetAnnotationElementClosure() {
	  function CheckboxWidgetAnnotationElement(parameters) {
	    WidgetAnnotationElement.call(this, parameters, parameters.renderInteractiveForms);
	  }
	  _util.Util.inherit(CheckboxWidgetAnnotationElement, WidgetAnnotationElement, {
	    render: function CheckboxWidgetAnnotationElement_render() {
	      this.container.className = 'buttonWidgetAnnotation checkBox';
	      var element = document.createElement('input');
	      element.disabled = this.data.readOnly;
	      element.type = 'checkbox';
	      if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
	        element.setAttribute('checked', true);
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  });
	  return CheckboxWidgetAnnotationElement;
	}();
	var RadioButtonWidgetAnnotationElement = function RadioButtonWidgetAnnotationElementClosure() {
	  function RadioButtonWidgetAnnotationElement(parameters) {
	    WidgetAnnotationElement.call(this, parameters, parameters.renderInteractiveForms);
	  }
	  _util.Util.inherit(RadioButtonWidgetAnnotationElement, WidgetAnnotationElement, {
	    render: function RadioButtonWidgetAnnotationElement_render() {
	      this.container.className = 'buttonWidgetAnnotation radioButton';
	      var element = document.createElement('input');
	      element.disabled = this.data.readOnly;
	      element.type = 'radio';
	      element.name = this.data.fieldName;
	      if (this.data.fieldValue === this.data.buttonValue) {
	        element.setAttribute('checked', true);
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  });
	  return RadioButtonWidgetAnnotationElement;
	}();
	var ChoiceWidgetAnnotationElement = function ChoiceWidgetAnnotationElementClosure() {
	  function ChoiceWidgetAnnotationElement(parameters) {
	    WidgetAnnotationElement.call(this, parameters, parameters.renderInteractiveForms);
	  }
	  _util.Util.inherit(ChoiceWidgetAnnotationElement, WidgetAnnotationElement, {
	    render: function ChoiceWidgetAnnotationElement_render() {
	      this.container.className = 'choiceWidgetAnnotation';
	      var selectElement = document.createElement('select');
	      selectElement.disabled = this.data.readOnly;
	      if (!this.data.combo) {
	        selectElement.size = this.data.options.length;
	        if (this.data.multiSelect) {
	          selectElement.multiple = true;
	        }
	      }
	      for (var i = 0, ii = this.data.options.length; i < ii; i++) {
	        var option = this.data.options[i];
	        var optionElement = document.createElement('option');
	        optionElement.textContent = option.displayValue;
	        optionElement.value = option.exportValue;
	        if (this.data.fieldValue.indexOf(option.displayValue) >= 0) {
	          optionElement.setAttribute('selected', true);
	        }
	        selectElement.appendChild(optionElement);
	      }
	      this.container.appendChild(selectElement);
	      return this.container;
	    }
	  });
	  return ChoiceWidgetAnnotationElement;
	}();
	var PopupAnnotationElement = function PopupAnnotationElementClosure() {
	  var IGNORE_TYPES = ['Line'];
	  function PopupAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable);
	  }
	  _util.Util.inherit(PopupAnnotationElement, AnnotationElement, {
	    render: function PopupAnnotationElement_render() {
	      this.container.className = 'popupAnnotation';
	      if (IGNORE_TYPES.indexOf(this.data.parentType) >= 0) {
	        return this.container;
	      }
	      var selector = '[data-annotation-id="' + this.data.parentId + '"]';
	      var parentElement = this.layer.querySelector(selector);
	      if (!parentElement) {
	        return this.container;
	      }
	      var popup = new PopupElement({
	        container: this.container,
	        trigger: parentElement,
	        color: this.data.color,
	        title: this.data.title,
	        contents: this.data.contents
	      });
	      var parentLeft = parseFloat(parentElement.style.left);
	      var parentWidth = parseFloat(parentElement.style.width);
	      _dom_utils.CustomStyle.setProp('transformOrigin', this.container, -(parentLeft + parentWidth) + 'px -' + parentElement.style.top);
	      this.container.style.left = parentLeft + parentWidth + 'px';
	      this.container.appendChild(popup.render());
	      return this.container;
	    }
	  });
	  return PopupAnnotationElement;
	}();
	var PopupElement = function PopupElementClosure() {
	  var BACKGROUND_ENLIGHT = 0.7;
	  function PopupElement(parameters) {
	    this.container = parameters.container;
	    this.trigger = parameters.trigger;
	    this.color = parameters.color;
	    this.title = parameters.title;
	    this.contents = parameters.contents;
	    this.hideWrapper = parameters.hideWrapper || false;
	    this.pinned = false;
	  }
	  PopupElement.prototype = {
	    render: function PopupElement_render() {
	      var wrapper = document.createElement('div');
	      wrapper.className = 'popupWrapper';
	      this.hideElement = this.hideWrapper ? wrapper : this.container;
	      this.hideElement.setAttribute('hidden', true);
	      var popup = document.createElement('div');
	      popup.className = 'popup';
	      var color = this.color;
	      if (color) {
	        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
	        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
	        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
	        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
	      }
	      var contents = this._formatContents(this.contents);
	      var title = document.createElement('h1');
	      title.textContent = this.title;
	      this.trigger.addEventListener('click', this._toggle.bind(this));
	      this.trigger.addEventListener('mouseover', this._show.bind(this, false));
	      this.trigger.addEventListener('mouseout', this._hide.bind(this, false));
	      popup.addEventListener('click', this._hide.bind(this, true));
	      popup.appendChild(title);
	      popup.appendChild(contents);
	      wrapper.appendChild(popup);
	      return wrapper;
	    },
	    _formatContents: function PopupElement_formatContents(contents) {
	      var p = document.createElement('p');
	      var lines = contents.split(/(?:\r\n?|\n)/);
	      for (var i = 0, ii = lines.length; i < ii; ++i) {
	        var line = lines[i];
	        p.appendChild(document.createTextNode(line));
	        if (i < ii - 1) {
	          p.appendChild(document.createElement('br'));
	        }
	      }
	      return p;
	    },
	    _toggle: function PopupElement_toggle() {
	      if (this.pinned) {
	        this._hide(true);
	      } else {
	        this._show(true);
	      }
	    },
	    _show: function PopupElement_show(pin) {
	      if (pin) {
	        this.pinned = true;
	      }
	      if (this.hideElement.hasAttribute('hidden')) {
	        this.hideElement.removeAttribute('hidden');
	        this.container.style.zIndex += 1;
	      }
	    },
	    _hide: function PopupElement_hide(unpin) {
	      if (unpin) {
	        this.pinned = false;
	      }
	      if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
	        this.hideElement.setAttribute('hidden', true);
	        this.container.style.zIndex -= 1;
	      }
	    }
	  };
	  return PopupElement;
	}();
	var LineAnnotationElement = function LineAnnotationElementClosure() {
	  var SVG_NS = 'http://www.w3.org/2000/svg';
	  function LineAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable, true);
	  }
	  _util.Util.inherit(LineAnnotationElement, AnnotationElement, {
	    render: function LineAnnotationElement_render() {
	      this.container.className = 'lineAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = document.createElementNS(SVG_NS, 'svg:svg');
	      svg.setAttributeNS(null, 'version', '1.1');
	      svg.setAttributeNS(null, 'width', width + 'px');
	      svg.setAttributeNS(null, 'height', height + 'px');
	      svg.setAttributeNS(null, 'preserveAspectRatio', 'none');
	      svg.setAttributeNS(null, 'viewBox', '0 0 ' + width + ' ' + height);
	      var line = document.createElementNS(SVG_NS, 'svg:line');
	      line.setAttributeNS(null, 'x1', data.rect[2] - data.lineCoordinates[0]);
	      line.setAttributeNS(null, 'y1', data.rect[3] - data.lineCoordinates[1]);
	      line.setAttributeNS(null, 'x2', data.rect[2] - data.lineCoordinates[2]);
	      line.setAttributeNS(null, 'y2', data.rect[3] - data.lineCoordinates[3]);
	      line.setAttributeNS(null, 'stroke-width', data.borderStyle.width);
	      line.setAttributeNS(null, 'stroke', 'transparent');
	      svg.appendChild(line);
	      this.container.append(svg);
	      this._createPopup(this.container, line, this.data);
	      return this.container;
	    }
	  });
	  return LineAnnotationElement;
	}();
	var HighlightAnnotationElement = function HighlightAnnotationElementClosure() {
	  function HighlightAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable, true);
	  }
	  _util.Util.inherit(HighlightAnnotationElement, AnnotationElement, {
	    render: function HighlightAnnotationElement_render() {
	      this.container.className = 'highlightAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  });
	  return HighlightAnnotationElement;
	}();
	var UnderlineAnnotationElement = function UnderlineAnnotationElementClosure() {
	  function UnderlineAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable, true);
	  }
	  _util.Util.inherit(UnderlineAnnotationElement, AnnotationElement, {
	    render: function UnderlineAnnotationElement_render() {
	      this.container.className = 'underlineAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  });
	  return UnderlineAnnotationElement;
	}();
	var SquigglyAnnotationElement = function SquigglyAnnotationElementClosure() {
	  function SquigglyAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable, true);
	  }
	  _util.Util.inherit(SquigglyAnnotationElement, AnnotationElement, {
	    render: function SquigglyAnnotationElement_render() {
	      this.container.className = 'squigglyAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  });
	  return SquigglyAnnotationElement;
	}();
	var StrikeOutAnnotationElement = function StrikeOutAnnotationElementClosure() {
	  function StrikeOutAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable, true);
	  }
	  _util.Util.inherit(StrikeOutAnnotationElement, AnnotationElement, {
	    render: function StrikeOutAnnotationElement_render() {
	      this.container.className = 'strikeoutAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  });
	  return StrikeOutAnnotationElement;
	}();
	var FileAttachmentAnnotationElement = function FileAttachmentAnnotationElementClosure() {
	  function FileAttachmentAnnotationElement(parameters) {
	    AnnotationElement.call(this, parameters, true);
	    var file = this.data.file;
	    this.filename = (0, _dom_utils.getFilenameFromUrl)(file.filename);
	    this.content = file.content;
	    this.linkService.onFileAttachmentAnnotation({
	      id: (0, _util.stringToPDFString)(file.filename),
	      filename: file.filename,
	      content: file.content
	    });
	  }
	  _util.Util.inherit(FileAttachmentAnnotationElement, AnnotationElement, {
	    render: function FileAttachmentAnnotationElement_render() {
	      this.container.className = 'fileAttachmentAnnotation';
	      var trigger = document.createElement('div');
	      trigger.style.height = this.container.style.height;
	      trigger.style.width = this.container.style.width;
	      trigger.addEventListener('dblclick', this._download.bind(this));
	      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
	        this._createPopup(this.container, trigger, this.data);
	      }
	      this.container.appendChild(trigger);
	      return this.container;
	    },
	    _download: function FileAttachmentAnnotationElement_download() {
	      if (!this.downloadManager) {
	        (0, _util.warn)('Download cannot be started due to unavailable download manager');
	        return;
	      }
	      this.downloadManager.downloadData(this.content, this.filename, '');
	    }
	  });
	  return FileAttachmentAnnotationElement;
	}();
	var AnnotationLayer = function AnnotationLayerClosure() {
	  return {
	    render: function AnnotationLayer_render(parameters) {
	      var annotationElementFactory = new AnnotationElementFactory();
	      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
	        var data = parameters.annotations[i];
	        if (!data) {
	          continue;
	        }
	        var element = annotationElementFactory.create({
	          data: data,
	          layer: parameters.div,
	          page: parameters.page,
	          viewport: parameters.viewport,
	          linkService: parameters.linkService,
	          downloadManager: parameters.downloadManager,
	          imageResourcesPath: parameters.imageResourcesPath || (0, _dom_utils.getDefaultSetting)('imageResourcesPath'),
	          renderInteractiveForms: parameters.renderInteractiveForms || false
	        });
	        if (element.isRenderable) {
	          parameters.div.appendChild(element.render());
	        }
	      }
	    },
	    update: function AnnotationLayer_update(parameters) {
	      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
	        var data = parameters.annotations[i];
	        var element = parameters.div.querySelector('[data-annotation-id="' + data.id + '"]');
	        if (element) {
	          _dom_utils.CustomStyle.setProp('transform', element, 'matrix(' + parameters.viewport.transform.join(',') + ')');
	        }
	      }
	      parameters.div.removeAttribute('hidden');
	    }
	  };
	}();
	exports.AnnotationLayer = AnnotationLayer;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.build = exports.version = exports._UnsupportedManager = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.getDocument = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(1);
	
	var _font_loader = __w_pdfjs_require__(11);
	
	var _canvas = __w_pdfjs_require__(10);
	
	var _metadata = __w_pdfjs_require__(7);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_RANGE_CHUNK_SIZE = 65536;
	var isWorkerDisabled = false;
	var workerSrc;
	var isPostMessageTransfersDisabled = false;
	var pdfjsFilePath = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : null;
	var fakeWorkerFilesLoader = null;
	var useRequireEnsure = false;
	if (typeof __pdfjsdev_webpack__ === 'undefined') {
	  if (typeof window === 'undefined') {
	    isWorkerDisabled = true;
	    if (false) {
	      require.ensure = require('node-ensure');
	    }
	    useRequireEnsure = true;
	  } else if (true) {
	    useRequireEnsure = true;
	  }
	  if (typeof requirejs !== 'undefined' && requirejs.toUrl) {
	    workerSrc = requirejs.toUrl('pdfjs-dist/build/pdf.worker.js');
	  }
	  var dynamicLoaderSupported = typeof requirejs !== 'undefined' && requirejs.load;
	  fakeWorkerFilesLoader = useRequireEnsure ? function (callback) {
	    !/* require.ensure */(function () {
	      var worker = __webpack_require__(145);
	      callback(worker.WorkerMessageHandler);
	    }(__webpack_require__));
	  } : dynamicLoaderSupported ? function (callback) {
	    requirejs(['pdfjs-dist/build/pdf.worker'], function (worker) {
	      callback(worker.WorkerMessageHandler);
	    });
	  } : null;
	}
	function getDocument(src, pdfDataRangeTransport, passwordCallback, progressCallback) {
	  var task = new PDFDocumentLoadingTask();
	  if (arguments.length > 1) {
	    (0, _util.deprecated)('getDocument is called with pdfDataRangeTransport, ' + 'passwordCallback or progressCallback argument');
	  }
	  if (pdfDataRangeTransport) {
	    if (!(pdfDataRangeTransport instanceof PDFDataRangeTransport)) {
	      pdfDataRangeTransport = Object.create(pdfDataRangeTransport);
	      pdfDataRangeTransport.length = src.length;
	      pdfDataRangeTransport.initialData = src.initialData;
	      if (!pdfDataRangeTransport.abort) {
	        pdfDataRangeTransport.abort = function () {};
	      }
	    }
	    src = Object.create(src);
	    src.range = pdfDataRangeTransport;
	  }
	  task.onPassword = passwordCallback || null;
	  task.onProgress = progressCallback || null;
	  var source;
	  if (typeof src === 'string') {
	    source = { url: src };
	  } else if ((0, _util.isArrayBuffer)(src)) {
	    source = { data: src };
	  } else if (src instanceof PDFDataRangeTransport) {
	    source = { range: src };
	  } else {
	    if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) !== 'object') {
	      (0, _util.error)('Invalid parameter in getDocument, need either Uint8Array, ' + 'string or a parameter object');
	    }
	    if (!src.url && !src.data && !src.range) {
	      (0, _util.error)('Invalid parameter object: need either .data, .range or .url');
	    }
	    source = src;
	  }
	  var params = {};
	  var rangeTransport = null;
	  var worker = null;
	  for (var key in source) {
	    if (key === 'url' && typeof window !== 'undefined') {
	      params[key] = new URL(source[key], window.location).href;
	      continue;
	    } else if (key === 'range') {
	      rangeTransport = source[key];
	      continue;
	    } else if (key === 'worker') {
	      worker = source[key];
	      continue;
	    } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
	      var pdfBytes = source[key];
	      if (typeof pdfBytes === 'string') {
	        params[key] = (0, _util.stringToBytes)(pdfBytes);
	      } else if ((typeof pdfBytes === 'undefined' ? 'undefined' : _typeof(pdfBytes)) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
	        params[key] = new Uint8Array(pdfBytes);
	      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
	        params[key] = new Uint8Array(pdfBytes);
	      } else {
	        (0, _util.error)('Invalid PDF binary data: either typed array, string or ' + 'array-like object is expected in the data property.');
	      }
	      continue;
	    }
	    params[key] = source[key];
	  }
	  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
	  params.disableNativeImageDecoder = params.disableNativeImageDecoder === true;
	  params.ignoreErrors = params.stopAtErrors !== true;
	  var CMapReaderFactory = params.CMapReaderFactory || _dom_utils.DOMCMapReaderFactory;
	  if (!worker) {
	    var workerPort = (0, _dom_utils.getDefaultSetting)('workerPort');
	    worker = workerPort ? new PDFWorker(null, workerPort) : new PDFWorker();
	    task._worker = worker;
	  }
	  var docId = task.docId;
	  worker.promise.then(function () {
	    if (task.destroyed) {
	      throw new Error('Loading aborted');
	    }
	    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
	      if (task.destroyed) {
	        throw new Error('Loading aborted');
	      }
	      var messageHandler = new _util.MessageHandler(docId, workerId, worker.port);
	      var transport = new WorkerTransport(messageHandler, task, rangeTransport, CMapReaderFactory);
	      task._transport = transport;
	      messageHandler.send('Ready', null);
	    });
	  }).catch(task._capability.reject);
	  return task;
	}
	function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
	  if (worker.destroyed) {
	    return Promise.reject(new Error('Worker was destroyed'));
	  }
	  source.disableAutoFetch = (0, _dom_utils.getDefaultSetting)('disableAutoFetch');
	  source.disableStream = (0, _dom_utils.getDefaultSetting)('disableStream');
	  source.chunkedViewerLoading = !!pdfDataRangeTransport;
	  if (pdfDataRangeTransport) {
	    source.length = pdfDataRangeTransport.length;
	    source.initialData = pdfDataRangeTransport.initialData;
	  }
	  return worker.messageHandler.sendWithPromise('GetDocRequest', {
	    docId: docId,
	    source: source,
	    disableRange: (0, _dom_utils.getDefaultSetting)('disableRange'),
	    maxImageSize: (0, _dom_utils.getDefaultSetting)('maxImageSize'),
	    disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
	    disableCreateObjectURL: (0, _dom_utils.getDefaultSetting)('disableCreateObjectURL'),
	    postMessageTransfers: (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled,
	    docBaseUrl: source.docBaseUrl,
	    disableNativeImageDecoder: source.disableNativeImageDecoder,
	    ignoreErrors: source.ignoreErrors
	  }).then(function (workerId) {
	    if (worker.destroyed) {
	      throw new Error('Worker was destroyed');
	    }
	    return workerId;
	  });
	}
	var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
	  var nextDocumentId = 0;
	  function PDFDocumentLoadingTask() {
	    this._capability = (0, _util.createPromiseCapability)();
	    this._transport = null;
	    this._worker = null;
	    this.docId = 'd' + nextDocumentId++;
	    this.destroyed = false;
	    this.onPassword = null;
	    this.onProgress = null;
	    this.onUnsupportedFeature = null;
	  }
	  PDFDocumentLoadingTask.prototype = {
	    get promise() {
	      return this._capability.promise;
	    },
	    destroy: function destroy() {
	      var _this = this;
	
	      this.destroyed = true;
	      var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
	      return transportDestroyed.then(function () {
	        _this._transport = null;
	        if (_this._worker) {
	          _this._worker.destroy();
	          _this._worker = null;
	        }
	      });
	    },
	
	    then: function PDFDocumentLoadingTask_then(onFulfilled, onRejected) {
	      return this.promise.then.apply(this.promise, arguments);
	    }
	  };
	  return PDFDocumentLoadingTask;
	}();
	var PDFDataRangeTransport = function pdfDataRangeTransportClosure() {
	  function PDFDataRangeTransport(length, initialData) {
	    this.length = length;
	    this.initialData = initialData;
	    this._rangeListeners = [];
	    this._progressListeners = [];
	    this._progressiveReadListeners = [];
	    this._readyCapability = (0, _util.createPromiseCapability)();
	  }
	  PDFDataRangeTransport.prototype = {
	    addRangeListener: function PDFDataRangeTransport_addRangeListener(listener) {
	      this._rangeListeners.push(listener);
	    },
	    addProgressListener: function PDFDataRangeTransport_addProgressListener(listener) {
	      this._progressListeners.push(listener);
	    },
	    addProgressiveReadListener: function PDFDataRangeTransport_addProgressiveReadListener(listener) {
	      this._progressiveReadListeners.push(listener);
	    },
	    onDataRange: function PDFDataRangeTransport_onDataRange(begin, chunk) {
	      var listeners = this._rangeListeners;
	      for (var i = 0, n = listeners.length; i < n; ++i) {
	        listeners[i](begin, chunk);
	      }
	    },
	    onDataProgress: function PDFDataRangeTransport_onDataProgress(loaded) {
	      var _this2 = this;
	
	      this._readyCapability.promise.then(function () {
	        var listeners = _this2._progressListeners;
	        for (var i = 0, n = listeners.length; i < n; ++i) {
	          listeners[i](loaded);
	        }
	      });
	    },
	    onDataProgressiveRead: function PDFDataRangeTransport_onDataProgress(chunk) {
	      var _this3 = this;
	
	      this._readyCapability.promise.then(function () {
	        var listeners = _this3._progressiveReadListeners;
	        for (var i = 0, n = listeners.length; i < n; ++i) {
	          listeners[i](chunk);
	        }
	      });
	    },
	    transportReady: function PDFDataRangeTransport_transportReady() {
	      this._readyCapability.resolve();
	    },
	    requestDataRange: function PDFDataRangeTransport_requestDataRange(begin, end) {
	      throw new Error('Abstract method PDFDataRangeTransport.requestDataRange');
	    },
	    abort: function PDFDataRangeTransport_abort() {}
	  };
	  return PDFDataRangeTransport;
	}();
	var PDFDocumentProxy = function PDFDocumentProxyClosure() {
	  function PDFDocumentProxy(pdfInfo, transport, loadingTask) {
	    this.pdfInfo = pdfInfo;
	    this.transport = transport;
	    this.loadingTask = loadingTask;
	  }
	  PDFDocumentProxy.prototype = {
	    get numPages() {
	      return this.pdfInfo.numPages;
	    },
	    get fingerprint() {
	      return this.pdfInfo.fingerprint;
	    },
	    getPage: function PDFDocumentProxy_getPage(pageNumber) {
	      return this.transport.getPage(pageNumber);
	    },
	    getPageIndex: function PDFDocumentProxy_getPageIndex(ref) {
	      return this.transport.getPageIndex(ref);
	    },
	    getDestinations: function PDFDocumentProxy_getDestinations() {
	      return this.transport.getDestinations();
	    },
	    getDestination: function PDFDocumentProxy_getDestination(id) {
	      return this.transport.getDestination(id);
	    },
	    getPageLabels: function PDFDocumentProxy_getPageLabels() {
	      return this.transport.getPageLabels();
	    },
	    getAttachments: function PDFDocumentProxy_getAttachments() {
	      return this.transport.getAttachments();
	    },
	    getJavaScript: function PDFDocumentProxy_getJavaScript() {
	      return this.transport.getJavaScript();
	    },
	    getOutline: function PDFDocumentProxy_getOutline() {
	      return this.transport.getOutline();
	    },
	    getMetadata: function PDFDocumentProxy_getMetadata() {
	      return this.transport.getMetadata();
	    },
	    getData: function PDFDocumentProxy_getData() {
	      return this.transport.getData();
	    },
	    getDownloadInfo: function PDFDocumentProxy_getDownloadInfo() {
	      return this.transport.downloadInfoCapability.promise;
	    },
	    getStats: function PDFDocumentProxy_getStats() {
	      return this.transport.getStats();
	    },
	    cleanup: function PDFDocumentProxy_cleanup() {
	      this.transport.startCleanup();
	    },
	    destroy: function PDFDocumentProxy_destroy() {
	      return this.loadingTask.destroy();
	    }
	  };
	  return PDFDocumentProxy;
	}();
	var PDFPageProxy = function PDFPageProxyClosure() {
	  function PDFPageProxy(pageIndex, pageInfo, transport) {
	    this.pageIndex = pageIndex;
	    this.pageInfo = pageInfo;
	    this.transport = transport;
	    this.stats = new _util.StatTimer();
	    this.stats.enabled = (0, _dom_utils.getDefaultSetting)('enableStats');
	    this.commonObjs = transport.commonObjs;
	    this.objs = new PDFObjects();
	    this.cleanupAfterRender = false;
	    this.pendingCleanup = false;
	    this.intentStates = Object.create(null);
	    this.destroyed = false;
	  }
	  PDFPageProxy.prototype = {
	    get pageNumber() {
	      return this.pageIndex + 1;
	    },
	    get rotate() {
	      return this.pageInfo.rotate;
	    },
	    get ref() {
	      return this.pageInfo.ref;
	    },
	    get userUnit() {
	      return this.pageInfo.userUnit;
	    },
	    get view() {
	      return this.pageInfo.view;
	    },
	    getViewport: function PDFPageProxy_getViewport(scale, rotate) {
	      if (arguments.length < 2) {
	        rotate = this.rotate;
	      }
	      return new _util.PageViewport(this.view, scale, rotate, 0, 0);
	    },
	    getAnnotations: function PDFPageProxy_getAnnotations(params) {
	      var intent = params && params.intent || null;
	      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
	        this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, intent);
	        this.annotationsIntent = intent;
	      }
	      return this.annotationsPromise;
	    },
	    render: function PDFPageProxy_render(params) {
	      var _this4 = this;
	
	      var stats = this.stats;
	      stats.time('Overall');
	      this.pendingCleanup = false;
	      var renderingIntent = params.intent === 'print' ? 'print' : 'display';
	      var canvasFactory = params.canvasFactory || new _dom_utils.DOMCanvasFactory();
	      if (!this.intentStates[renderingIntent]) {
	        this.intentStates[renderingIntent] = Object.create(null);
	      }
	      var intentState = this.intentStates[renderingIntent];
	      if (!intentState.displayReadyCapability) {
	        intentState.receivingOperatorList = true;
	        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
	        intentState.operatorList = {
	          fnArray: [],
	          argsArray: [],
	          lastChunk: false
	        };
	        this.stats.time('Page Request');
	        this.transport.messageHandler.send('RenderPageRequest', {
	          pageIndex: this.pageNumber - 1,
	          intent: renderingIntent,
	          renderInteractiveForms: params.renderInteractiveForms === true
	        });
	      }
	      var complete = function complete(error) {
	        var i = intentState.renderTasks.indexOf(internalRenderTask);
	        if (i >= 0) {
	          intentState.renderTasks.splice(i, 1);
	        }
	        if (_this4.cleanupAfterRender) {
	          _this4.pendingCleanup = true;
	        }
	        _this4._tryCleanup();
	        if (error) {
	          internalRenderTask.capability.reject(error);
	        } else {
	          internalRenderTask.capability.resolve();
	        }
	        stats.timeEnd('Rendering');
	        stats.timeEnd('Overall');
	      };
	      var internalRenderTask = new InternalRenderTask(complete, params, this.objs, this.commonObjs, intentState.operatorList, this.pageNumber, canvasFactory);
	      internalRenderTask.useRequestAnimationFrame = renderingIntent !== 'print';
	      if (!intentState.renderTasks) {
	        intentState.renderTasks = [];
	      }
	      intentState.renderTasks.push(internalRenderTask);
	      var renderTask = internalRenderTask.task;
	      if (params.continueCallback) {
	        (0, _util.deprecated)('render is used with continueCallback parameter');
	        renderTask.onContinue = params.continueCallback;
	      }
	      intentState.displayReadyCapability.promise.then(function (transparency) {
	        if (_this4.pendingCleanup) {
	          complete();
	          return;
	        }
	        stats.time('Rendering');
	        internalRenderTask.initializeGraphics(transparency);
	        internalRenderTask.operatorListChanged();
	      }, complete);
	      return renderTask;
	    },
	    getOperatorList: function PDFPageProxy_getOperatorList() {
	      function operatorListChanged() {
	        if (intentState.operatorList.lastChunk) {
	          intentState.opListReadCapability.resolve(intentState.operatorList);
	          var i = intentState.renderTasks.indexOf(opListTask);
	          if (i >= 0) {
	            intentState.renderTasks.splice(i, 1);
	          }
	        }
	      }
	      var renderingIntent = 'oplist';
	      if (!this.intentStates[renderingIntent]) {
	        this.intentStates[renderingIntent] = Object.create(null);
	      }
	      var intentState = this.intentStates[renderingIntent];
	      var opListTask;
	      if (!intentState.opListReadCapability) {
	        opListTask = {};
	        opListTask.operatorListChanged = operatorListChanged;
	        intentState.receivingOperatorList = true;
	        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
	        intentState.renderTasks = [];
	        intentState.renderTasks.push(opListTask);
	        intentState.operatorList = {
	          fnArray: [],
	          argsArray: [],
	          lastChunk: false
	        };
	        this.transport.messageHandler.send('RenderPageRequest', {
	          pageIndex: this.pageIndex,
	          intent: renderingIntent
	        });
	      }
	      return intentState.opListReadCapability.promise;
	    },
	    getTextContent: function PDFPageProxy_getTextContent(params) {
	      params = params || {};
	      return this.transport.messageHandler.sendWithPromise('GetTextContent', {
	        pageIndex: this.pageNumber - 1,
	        normalizeWhitespace: params.normalizeWhitespace === true,
	        combineTextItems: params.disableCombineTextItems !== true
	      });
	    },
	    _destroy: function PDFPageProxy_destroy() {
	      this.destroyed = true;
	      this.transport.pageCache[this.pageIndex] = null;
	      var waitOn = [];
	      Object.keys(this.intentStates).forEach(function (intent) {
	        if (intent === 'oplist') {
	          return;
	        }
	        var intentState = this.intentStates[intent];
	        intentState.renderTasks.forEach(function (renderTask) {
	          var renderCompleted = renderTask.capability.promise.catch(function () {});
	          waitOn.push(renderCompleted);
	          renderTask.cancel();
	        });
	      }, this);
	      this.objs.clear();
	      this.annotationsPromise = null;
	      this.pendingCleanup = false;
	      return Promise.all(waitOn);
	    },
	    destroy: function destroy() {
	      (0, _util.deprecated)('page destroy method, use cleanup() instead');
	      this.cleanup();
	    },
	
	    cleanup: function PDFPageProxy_cleanup() {
	      this.pendingCleanup = true;
	      this._tryCleanup();
	    },
	    _tryCleanup: function PDFPageProxy_tryCleanup() {
	      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
	        var intentState = this.intentStates[intent];
	        return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
	      }, this)) {
	        return;
	      }
	      Object.keys(this.intentStates).forEach(function (intent) {
	        delete this.intentStates[intent];
	      }, this);
	      this.objs.clear();
	      this.annotationsPromise = null;
	      this.pendingCleanup = false;
	    },
	    _startRenderPage: function PDFPageProxy_startRenderPage(transparency, intent) {
	      var intentState = this.intentStates[intent];
	      if (intentState.displayReadyCapability) {
	        intentState.displayReadyCapability.resolve(transparency);
	      }
	    },
	    _renderPageChunk: function PDFPageProxy_renderPageChunk(operatorListChunk, intent) {
	      var intentState = this.intentStates[intent];
	      var i, ii;
	      for (i = 0, ii = operatorListChunk.length; i < ii; i++) {
	        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
	        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
	      }
	      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
	      for (i = 0; i < intentState.renderTasks.length; i++) {
	        intentState.renderTasks[i].operatorListChanged();
	      }
	      if (operatorListChunk.lastChunk) {
	        intentState.receivingOperatorList = false;
	        this._tryCleanup();
	      }
	    }
	  };
	  return PDFPageProxy;
	}();
	
	var LoopbackPort = function () {
	  function LoopbackPort(defer) {
	    _classCallCheck(this, LoopbackPort);
	
	    this._listeners = [];
	    this._defer = defer;
	    this._deferred = Promise.resolve(undefined);
	  }
	
	  _createClass(LoopbackPort, [{
	    key: 'postMessage',
	    value: function postMessage(obj, transfers) {
	      var _this5 = this;
	
	      function cloneValue(value) {
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
	          return value;
	        }
	        if (cloned.has(value)) {
	          return cloned.get(value);
	        }
	        var result;
	        var buffer;
	        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
	          var transferable = transfers && transfers.indexOf(buffer) >= 0;
	          if (value === buffer) {
	            result = value;
	          } else if (transferable) {
	            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
	          } else {
	            result = new value.constructor(value);
	          }
	          cloned.set(value, result);
	          return result;
	        }
	        result = (0, _util.isArray)(value) ? [] : {};
	        cloned.set(value, result);
	        for (var i in value) {
	          var desc,
	              p = value;
	          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
	            p = Object.getPrototypeOf(p);
	          }
	          if (typeof desc.value === 'undefined' || typeof desc.value === 'function') {
	            continue;
	          }
	          result[i] = cloneValue(desc.value);
	        }
	        return result;
	      }
	      if (!this._defer) {
	        this._listeners.forEach(function (listener) {
	          listener.call(this, { data: obj });
	        }, this);
	        return;
	      }
	      var cloned = new WeakMap();
	      var e = { data: cloneValue(obj) };
	      this._deferred.then(function () {
	        _this5._listeners.forEach(function (listener) {
	          listener.call(this, e);
	        }, _this5);
	      });
	    }
	  }, {
	    key: 'addEventListener',
	    value: function addEventListener(name, listener) {
	      this._listeners.push(listener);
	    }
	  }, {
	    key: 'removeEventListener',
	    value: function removeEventListener(name, listener) {
	      var i = this._listeners.indexOf(listener);
	      this._listeners.splice(i, 1);
	    }
	  }, {
	    key: 'terminate',
	    value: function terminate() {
	      this._listeners = [];
	    }
	  }]);
	
	  return LoopbackPort;
	}();
	
	var PDFWorker = function PDFWorkerClosure() {
	  var nextFakeWorkerId = 0;
	  function getWorkerSrc() {
	    if (typeof workerSrc !== 'undefined') {
	      return workerSrc;
	    }
	    if ((0, _dom_utils.getDefaultSetting)('workerSrc')) {
	      return (0, _dom_utils.getDefaultSetting)('workerSrc');
	    }
	    if (pdfjsFilePath) {
	      return pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2');
	    }
	    (0, _util.error)('No PDFJS.workerSrc specified');
	  }
	  var fakeWorkerFilesLoadedCapability;
	  function setupFakeWorkerGlobal() {
	    var WorkerMessageHandler;
	    if (fakeWorkerFilesLoadedCapability) {
	      return fakeWorkerFilesLoadedCapability.promise;
	    }
	    fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
	    var loader = fakeWorkerFilesLoader || function (callback) {
	      _util.Util.loadScript(getWorkerSrc(), function () {
	        callback(window.pdfjsDistBuildPdfWorker.WorkerMessageHandler);
	      });
	    };
	    loader(fakeWorkerFilesLoadedCapability.resolve);
	    return fakeWorkerFilesLoadedCapability.promise;
	  }
	  function createCDNWrapper(url) {
	    var wrapper = 'importScripts(\'' + url + '\');';
	    return URL.createObjectURL(new Blob([wrapper]));
	  }
	  function PDFWorker(name, port) {
	    this.name = name;
	    this.destroyed = false;
	    this._readyCapability = (0, _util.createPromiseCapability)();
	    this._port = null;
	    this._webWorker = null;
	    this._messageHandler = null;
	    if (port) {
	      this._initializeFromPort(port);
	      return;
	    }
	    this._initialize();
	  }
	  PDFWorker.prototype = {
	    get promise() {
	      return this._readyCapability.promise;
	    },
	    get port() {
	      return this._port;
	    },
	    get messageHandler() {
	      return this._messageHandler;
	    },
	    _initializeFromPort: function PDFWorker_initializeFromPort(port) {
	      this._port = port;
	      this._messageHandler = new _util.MessageHandler('main', 'worker', port);
	      this._messageHandler.on('ready', function () {});
	      this._readyCapability.resolve();
	    },
	    _initialize: function PDFWorker_initialize() {
	      var _this6 = this;
	
	      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker') && typeof Worker !== 'undefined') {
	        var workerSrc = getWorkerSrc();
	        try {
	          if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
	            workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href);
	          }
	          var worker = new Worker(workerSrc);
	          var messageHandler = new _util.MessageHandler('main', 'worker', worker);
	          var terminateEarly = function terminateEarly() {
	            worker.removeEventListener('error', onWorkerError);
	            messageHandler.destroy();
	            worker.terminate();
	            if (_this6.destroyed) {
	              _this6._readyCapability.reject(new Error('Worker was destroyed'));
	            } else {
	              _this6._setupFakeWorker();
	            }
	          };
	          var onWorkerError = function onWorkerError() {
	            if (!_this6._webWorker) {
	              terminateEarly();
	            }
	          };
	          worker.addEventListener('error', onWorkerError);
	          messageHandler.on('test', function (data) {
	            worker.removeEventListener('error', onWorkerError);
	            if (_this6.destroyed) {
	              terminateEarly();
	              return;
	            }
	            var supportTypedArray = data && data.supportTypedArray;
	            if (supportTypedArray) {
	              _this6._messageHandler = messageHandler;
	              _this6._port = worker;
	              _this6._webWorker = worker;
	              if (!data.supportTransfers) {
	                isPostMessageTransfersDisabled = true;
	              }
	              _this6._readyCapability.resolve();
	              messageHandler.send('configure', { verbosity: (0, _util.getVerbosityLevel)() });
	            } else {
	              _this6._setupFakeWorker();
	              messageHandler.destroy();
	              worker.terminate();
	            }
	          });
	          messageHandler.on('console_log', function (data) {
	            console.log.apply(console, data);
	          });
	          messageHandler.on('console_error', function (data) {
	            console.error.apply(console, data);
	          });
	          messageHandler.on('ready', function (data) {
	            worker.removeEventListener('error', onWorkerError);
	            if (_this6.destroyed) {
	              terminateEarly();
	              return;
	            }
	            try {
	              sendTest();
	            } catch (e) {
	              _this6._setupFakeWorker();
	            }
	          });
	          var sendTest = function sendTest() {
	            var postMessageTransfers = (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled;
	            var testObj = new Uint8Array([postMessageTransfers ? 255 : 0]);
	            try {
	              messageHandler.send('test', testObj, [testObj.buffer]);
	            } catch (ex) {
	              (0, _util.info)('Cannot use postMessage transfers');
	              testObj[0] = 0;
	              messageHandler.send('test', testObj);
	            }
	          };
	          sendTest();
	          return;
	        } catch (e) {
	          (0, _util.info)('The worker has been disabled.');
	        }
	      }
	      this._setupFakeWorker();
	    },
	    _setupFakeWorker: function PDFWorker_setupFakeWorker() {
	      var _this7 = this;
	
	      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker')) {
	        (0, _util.warn)('Setting up fake worker.');
	        isWorkerDisabled = true;
	      }
	      setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
	        if (_this7.destroyed) {
	          _this7._readyCapability.reject(new Error('Worker was destroyed'));
	          return;
	        }
	        var isTypedArraysPresent = Uint8Array !== Float32Array;
	        var port = new LoopbackPort(isTypedArraysPresent);
	        _this7._port = port;
	        var id = 'fake' + nextFakeWorkerId++;
	        var workerHandler = new _util.MessageHandler(id + '_worker', id, port);
	        WorkerMessageHandler.setup(workerHandler, port);
	        var messageHandler = new _util.MessageHandler(id, id + '_worker', port);
	        _this7._messageHandler = messageHandler;
	        _this7._readyCapability.resolve();
	      });
	    },
	    destroy: function PDFWorker_destroy() {
	      this.destroyed = true;
	      if (this._webWorker) {
	        this._webWorker.terminate();
	        this._webWorker = null;
	      }
	      this._port = null;
	      if (this._messageHandler) {
	        this._messageHandler.destroy();
	        this._messageHandler = null;
	      }
	    }
	  };
	  return PDFWorker;
	}();
	var WorkerTransport = function WorkerTransportClosure() {
	  function WorkerTransport(messageHandler, loadingTask, pdfDataRangeTransport, CMapReaderFactory) {
	    this.messageHandler = messageHandler;
	    this.loadingTask = loadingTask;
	    this.pdfDataRangeTransport = pdfDataRangeTransport;
	    this.commonObjs = new PDFObjects();
	    this.fontLoader = new _font_loader.FontLoader(loadingTask.docId);
	    this.CMapReaderFactory = new CMapReaderFactory({
	      baseUrl: (0, _dom_utils.getDefaultSetting)('cMapUrl'),
	      isCompressed: (0, _dom_utils.getDefaultSetting)('cMapPacked')
	    });
	    this.destroyed = false;
	    this.destroyCapability = null;
	    this._passwordCapability = null;
	    this.pageCache = [];
	    this.pagePromises = [];
	    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
	    this.setupMessageHandler();
	  }
	  WorkerTransport.prototype = {
	    destroy: function WorkerTransport_destroy() {
	      var _this8 = this;
	
	      if (this.destroyCapability) {
	        return this.destroyCapability.promise;
	      }
	      this.destroyed = true;
	      this.destroyCapability = (0, _util.createPromiseCapability)();
	      if (this._passwordCapability) {
	        this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'));
	      }
	      var waitOn = [];
	      this.pageCache.forEach(function (page) {
	        if (page) {
	          waitOn.push(page._destroy());
	        }
	      });
	      this.pageCache = [];
	      this.pagePromises = [];
	      var terminated = this.messageHandler.sendWithPromise('Terminate', null);
	      waitOn.push(terminated);
	      Promise.all(waitOn).then(function () {
	        _this8.fontLoader.clear();
	        if (_this8.pdfDataRangeTransport) {
	          _this8.pdfDataRangeTransport.abort();
	          _this8.pdfDataRangeTransport = null;
	        }
	        if (_this8.messageHandler) {
	          _this8.messageHandler.destroy();
	          _this8.messageHandler = null;
	        }
	        _this8.destroyCapability.resolve();
	      }, this.destroyCapability.reject);
	      return this.destroyCapability.promise;
	    },
	    setupMessageHandler: function WorkerTransport_setupMessageHandler() {
	      var messageHandler = this.messageHandler;
	      var loadingTask = this.loadingTask;
	      var pdfDataRangeTransport = this.pdfDataRangeTransport;
	      if (pdfDataRangeTransport) {
	        pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
	          messageHandler.send('OnDataRange', {
	            begin: begin,
	            chunk: chunk
	          });
	        });
	        pdfDataRangeTransport.addProgressListener(function (loaded) {
	          messageHandler.send('OnDataProgress', { loaded: loaded });
	        });
	        pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
	          messageHandler.send('OnDataRange', { chunk: chunk });
	        });
	        messageHandler.on('RequestDataRange', function transportDataRange(data) {
	          pdfDataRangeTransport.requestDataRange(data.begin, data.end);
	        }, this);
	      }
	      messageHandler.on('GetDoc', function transportDoc(data) {
	        var pdfInfo = data.pdfInfo;
	        this.numPages = data.pdfInfo.numPages;
	        var loadingTask = this.loadingTask;
	        var pdfDocument = new PDFDocumentProxy(pdfInfo, this, loadingTask);
	        this.pdfDocument = pdfDocument;
	        loadingTask._capability.resolve(pdfDocument);
	      }, this);
	      messageHandler.on('PasswordRequest', function transportPasswordRequest(exception) {
	        var _this9 = this;
	
	        this._passwordCapability = (0, _util.createPromiseCapability)();
	        if (loadingTask.onPassword) {
	          var updatePassword = function updatePassword(password) {
	            _this9._passwordCapability.resolve({ password: password });
	          };
	          loadingTask.onPassword(updatePassword, exception.code);
	        } else {
	          this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
	        }
	        return this._passwordCapability.promise;
	      }, this);
	      messageHandler.on('PasswordException', function transportPasswordException(exception) {
	        loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
	      }, this);
	      messageHandler.on('InvalidPDF', function transportInvalidPDF(exception) {
	        this.loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
	      }, this);
	      messageHandler.on('MissingPDF', function transportMissingPDF(exception) {
	        this.loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
	      }, this);
	      messageHandler.on('UnexpectedResponse', function transportUnexpectedResponse(exception) {
	        this.loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
	      }, this);
	      messageHandler.on('UnknownError', function transportUnknownError(exception) {
	        this.loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
	      }, this);
	      messageHandler.on('DataLoaded', function transportPage(data) {
	        this.downloadInfoCapability.resolve(data);
	      }, this);
	      messageHandler.on('PDFManagerReady', function transportPage(data) {
	        if (this.pdfDataRangeTransport) {
	          this.pdfDataRangeTransport.transportReady();
	        }
	      }, this);
	      messageHandler.on('StartRenderPage', function transportRender(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageIndex];
	        page.stats.timeEnd('Page Request');
	        page._startRenderPage(data.transparency, data.intent);
	      }, this);
	      messageHandler.on('RenderPageChunk', function transportRender(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageIndex];
	        page._renderPageChunk(data.operatorList, data.intent);
	      }, this);
	      messageHandler.on('commonobj', function transportObj(data) {
	        var _this10 = this;
	
	        if (this.destroyed) {
	          return;
	        }
	        var id = data[0];
	        var type = data[1];
	        if (this.commonObjs.hasData(id)) {
	          return;
	        }
	        switch (type) {
	          case 'Font':
	            var exportedData = data[2];
	            if ('error' in exportedData) {
	              var exportedError = exportedData.error;
	              (0, _util.warn)('Error during font loading: ' + exportedError);
	              this.commonObjs.resolve(id, exportedError);
	              break;
	            }
	            var fontRegistry = null;
	            if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _util.globalScope.FontInspector && _util.globalScope['FontInspector'].enabled) {
	              fontRegistry = {
	                registerFont: function registerFont(font, url) {
	                  _util.globalScope['FontInspector'].fontAdded(font, url);
	                }
	              };
	            }
	            var font = new _font_loader.FontFaceObject(exportedData, {
	              isEvalSuported: (0, _dom_utils.getDefaultSetting)('isEvalSupported'),
	              disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
	              fontRegistry: fontRegistry
	            });
	            var fontReady = function fontReady(fontObjs) {
	              _this10.commonObjs.resolve(id, font);
	            };
	            this.fontLoader.bind([font], fontReady);
	            break;
	          case 'FontPath':
	            this.commonObjs.resolve(id, data[2]);
	            break;
	          default:
	            (0, _util.error)('Got unknown common object type ' + type);
	        }
	      }, this);
	      messageHandler.on('obj', function transportObj(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var id = data[0];
	        var pageIndex = data[1];
	        var type = data[2];
	        var pageProxy = this.pageCache[pageIndex];
	        var imageData;
	        if (pageProxy.objs.hasData(id)) {
	          return;
	        }
	        switch (type) {
	          case 'JpegStream':
	            imageData = data[3];
	            (0, _util.loadJpegStream)(id, imageData, pageProxy.objs);
	            break;
	          case 'Image':
	            imageData = data[3];
	            pageProxy.objs.resolve(id, imageData);
	            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
	            if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
	              pageProxy.cleanupAfterRender = true;
	            }
	            break;
	          default:
	            (0, _util.error)('Got unknown object type ' + type);
	        }
	      }, this);
	      messageHandler.on('DocProgress', function transportDocProgress(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var loadingTask = this.loadingTask;
	        if (loadingTask.onProgress) {
	          loadingTask.onProgress({
	            loaded: data.loaded,
	            total: data.total
	          });
	        }
	      }, this);
	      messageHandler.on('PageError', function transportError(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageNum - 1];
	        var intentState = page.intentStates[data.intent];
	        if (intentState.displayReadyCapability) {
	          intentState.displayReadyCapability.reject(data.error);
	        } else {
	          (0, _util.error)(data.error);
	        }
	        if (intentState.operatorList) {
	          intentState.operatorList.lastChunk = true;
	          for (var i = 0; i < intentState.renderTasks.length; i++) {
	            intentState.renderTasks[i].operatorListChanged();
	          }
	        }
	      }, this);
	      messageHandler.on('UnsupportedFeature', function transportUnsupportedFeature(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var featureId = data.featureId;
	        var loadingTask = this.loadingTask;
	        if (loadingTask.onUnsupportedFeature) {
	          loadingTask.onUnsupportedFeature(featureId);
	        }
	        _UnsupportedManager.notify(featureId);
	      }, this);
	      messageHandler.on('JpegDecode', function (data) {
	        if (this.destroyed) {
	          return Promise.reject(new Error('Worker was destroyed'));
	        }
	        if (typeof document === 'undefined') {
	          return Promise.reject(new Error('"document" is not defined.'));
	        }
	        var imageUrl = data[0];
	        var components = data[1];
	        if (components !== 3 && components !== 1) {
	          return Promise.reject(new Error('Only 3 components or 1 component can be returned'));
	        }
	        return new Promise(function (resolve, reject) {
	          var img = new Image();
	          img.onload = function () {
	            var width = img.width;
	            var height = img.height;
	            var size = width * height;
	            var rgbaLength = size * 4;
	            var buf = new Uint8Array(size * components);
	            var tmpCanvas = document.createElement('canvas');
	            tmpCanvas.width = width;
	            tmpCanvas.height = height;
	            var tmpCtx = tmpCanvas.getContext('2d');
	            tmpCtx.drawImage(img, 0, 0);
	            var data = tmpCtx.getImageData(0, 0, width, height).data;
	            var i, j;
	            if (components === 3) {
	              for (i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
	                buf[j] = data[i];
	                buf[j + 1] = data[i + 1];
	                buf[j + 2] = data[i + 2];
	              }
	            } else if (components === 1) {
	              for (i = 0, j = 0; i < rgbaLength; i += 4, j++) {
	                buf[j] = data[i];
	              }
	            }
	            resolve({
	              data: buf,
	              width: width,
	              height: height
	            });
	          };
	          img.onerror = function () {
	            reject(new Error('JpegDecode failed to load image'));
	          };
	          img.src = imageUrl;
	        });
	      }, this);
	      messageHandler.on('FetchBuiltInCMap', function (data) {
	        if (this.destroyed) {
	          return Promise.reject(new Error('Worker was destroyed'));
	        }
	        return this.CMapReaderFactory.fetch({ name: data.name });
	      }, this);
	    },
	    getData: function WorkerTransport_getData() {
	      return this.messageHandler.sendWithPromise('GetData', null);
	    },
	    getPage: function WorkerTransport_getPage(pageNumber, capability) {
	      var _this11 = this;
	
	      if (!(0, _util.isInt)(pageNumber) || pageNumber <= 0 || pageNumber > this.numPages) {
	        return Promise.reject(new Error('Invalid page request'));
	      }
	      var pageIndex = pageNumber - 1;
	      if (pageIndex in this.pagePromises) {
	        return this.pagePromises[pageIndex];
	      }
	      var promise = this.messageHandler.sendWithPromise('GetPage', { pageIndex: pageIndex }).then(function (pageInfo) {
	        if (_this11.destroyed) {
	          throw new Error('Transport destroyed');
	        }
	        var page = new PDFPageProxy(pageIndex, pageInfo, _this11);
	        _this11.pageCache[pageIndex] = page;
	        return page;
	      });
	      this.pagePromises[pageIndex] = promise;
	      return promise;
	    },
	    getPageIndex: function WorkerTransport_getPageIndexByRef(ref) {
	      return this.messageHandler.sendWithPromise('GetPageIndex', { ref: ref }).catch(function (reason) {
	        return Promise.reject(new Error(reason));
	      });
	    },
	    getAnnotations: function WorkerTransport_getAnnotations(pageIndex, intent) {
	      return this.messageHandler.sendWithPromise('GetAnnotations', {
	        pageIndex: pageIndex,
	        intent: intent
	      });
	    },
	    getDestinations: function WorkerTransport_getDestinations() {
	      return this.messageHandler.sendWithPromise('GetDestinations', null);
	    },
	    getDestination: function WorkerTransport_getDestination(id) {
	      return this.messageHandler.sendWithPromise('GetDestination', { id: id });
	    },
	    getPageLabels: function WorkerTransport_getPageLabels() {
	      return this.messageHandler.sendWithPromise('GetPageLabels', null);
	    },
	    getAttachments: function WorkerTransport_getAttachments() {
	      return this.messageHandler.sendWithPromise('GetAttachments', null);
	    },
	    getJavaScript: function WorkerTransport_getJavaScript() {
	      return this.messageHandler.sendWithPromise('GetJavaScript', null);
	    },
	    getOutline: function WorkerTransport_getOutline() {
	      return this.messageHandler.sendWithPromise('GetOutline', null);
	    },
	    getMetadata: function WorkerTransport_getMetadata() {
	      return this.messageHandler.sendWithPromise('GetMetadata', null).then(function transportMetadata(results) {
	        return {
	          info: results[0],
	          metadata: results[1] ? new _metadata.Metadata(results[1]) : null
	        };
	      });
	    },
	    getStats: function WorkerTransport_getStats() {
	      return this.messageHandler.sendWithPromise('GetStats', null);
	    },
	    startCleanup: function WorkerTransport_startCleanup() {
	      var _this12 = this;
	
	      this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
	        for (var i = 0, ii = _this12.pageCache.length; i < ii; i++) {
	          var page = _this12.pageCache[i];
	          if (page) {
	            page.cleanup();
	          }
	        }
	        _this12.commonObjs.clear();
	        _this12.fontLoader.clear();
	      });
	    }
	  };
	  return WorkerTransport;
	}();
	var PDFObjects = function PDFObjectsClosure() {
	  function PDFObjects() {
	    this.objs = Object.create(null);
	  }
	  PDFObjects.prototype = {
	    ensureObj: function PDFObjects_ensureObj(objId) {
	      if (this.objs[objId]) {
	        return this.objs[objId];
	      }
	      var obj = {
	        capability: (0, _util.createPromiseCapability)(),
	        data: null,
	        resolved: false
	      };
	      this.objs[objId] = obj;
	      return obj;
	    },
	    get: function PDFObjects_get(objId, callback) {
	      if (callback) {
	        this.ensureObj(objId).capability.promise.then(callback);
	        return null;
	      }
	      var obj = this.objs[objId];
	      if (!obj || !obj.resolved) {
	        (0, _util.error)('Requesting object that isn\'t resolved yet ' + objId);
	      }
	      return obj.data;
	    },
	    resolve: function PDFObjects_resolve(objId, data) {
	      var obj = this.ensureObj(objId);
	      obj.resolved = true;
	      obj.data = data;
	      obj.capability.resolve(data);
	    },
	    isResolved: function PDFObjects_isResolved(objId) {
	      var objs = this.objs;
	      if (!objs[objId]) {
	        return false;
	      }
	      return objs[objId].resolved;
	    },
	    hasData: function PDFObjects_hasData(objId) {
	      return this.isResolved(objId);
	    },
	    getData: function PDFObjects_getData(objId) {
	      var objs = this.objs;
	      if (!objs[objId] || !objs[objId].resolved) {
	        return null;
	      }
	      return objs[objId].data;
	    },
	    clear: function PDFObjects_clear() {
	      this.objs = Object.create(null);
	    }
	  };
	  return PDFObjects;
	}();
	var RenderTask = function RenderTaskClosure() {
	  function RenderTask(internalRenderTask) {
	    this._internalRenderTask = internalRenderTask;
	    this.onContinue = null;
	  }
	  RenderTask.prototype = {
	    get promise() {
	      return this._internalRenderTask.capability.promise;
	    },
	    cancel: function RenderTask_cancel() {
	      this._internalRenderTask.cancel();
	    },
	    then: function RenderTask_then(onFulfilled, onRejected) {
	      return this.promise.then.apply(this.promise, arguments);
	    }
	  };
	  return RenderTask;
	}();
	var InternalRenderTask = function InternalRenderTaskClosure() {
	  function InternalRenderTask(callback, params, objs, commonObjs, operatorList, pageNumber, canvasFactory) {
	    this.callback = callback;
	    this.params = params;
	    this.objs = objs;
	    this.commonObjs = commonObjs;
	    this.operatorListIdx = null;
	    this.operatorList = operatorList;
	    this.pageNumber = pageNumber;
	    this.canvasFactory = canvasFactory;
	    this.running = false;
	    this.graphicsReadyCallback = null;
	    this.graphicsReady = false;
	    this.useRequestAnimationFrame = false;
	    this.cancelled = false;
	    this.capability = (0, _util.createPromiseCapability)();
	    this.task = new RenderTask(this);
	    this._continueBound = this._continue.bind(this);
	    this._scheduleNextBound = this._scheduleNext.bind(this);
	    this._nextBound = this._next.bind(this);
	  }
	  InternalRenderTask.prototype = {
	    initializeGraphics: function InternalRenderTask_initializeGraphics(transparency) {
	      if (this.cancelled) {
	        return;
	      }
	      if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _util.globalScope.StepperManager && _util.globalScope.StepperManager.enabled) {
	        this.stepper = _util.globalScope.StepperManager.create(this.pageNumber - 1);
	        this.stepper.init(this.operatorList);
	        this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
	      }
	      var params = this.params;
	      this.gfx = new _canvas.CanvasGraphics(params.canvasContext, this.commonObjs, this.objs, this.canvasFactory, params.imageLayer);
	      this.gfx.beginDrawing(params.transform, params.viewport, transparency);
	      this.operatorListIdx = 0;
	      this.graphicsReady = true;
	      if (this.graphicsReadyCallback) {
	        this.graphicsReadyCallback();
	      }
	    },
	    cancel: function InternalRenderTask_cancel() {
	      this.running = false;
	      this.cancelled = true;
	      if ((0, _dom_utils.getDefaultSetting)('pdfjsNext')) {
	        this.callback(new _dom_utils.RenderingCancelledException('Rendering cancelled, page ' + this.pageNumber, 'canvas'));
	      } else {
	        this.callback('cancelled');
	      }
	    },
	    operatorListChanged: function InternalRenderTask_operatorListChanged() {
	      if (!this.graphicsReady) {
	        if (!this.graphicsReadyCallback) {
	          this.graphicsReadyCallback = this._continueBound;
	        }
	        return;
	      }
	      if (this.stepper) {
	        this.stepper.updateOperatorList(this.operatorList);
	      }
	      if (this.running) {
	        return;
	      }
	      this._continue();
	    },
	    _continue: function InternalRenderTask__continue() {
	      this.running = true;
	      if (this.cancelled) {
	        return;
	      }
	      if (this.task.onContinue) {
	        this.task.onContinue(this._scheduleNextBound);
	      } else {
	        this._scheduleNext();
	      }
	    },
	    _scheduleNext: function InternalRenderTask__scheduleNext() {
	      if (this.useRequestAnimationFrame && typeof window !== 'undefined') {
	        window.requestAnimationFrame(this._nextBound);
	      } else {
	        Promise.resolve(undefined).then(this._nextBound);
	      }
	    },
	    _next: function InternalRenderTask__next() {
	      if (this.cancelled) {
	        return;
	      }
	      this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
	      if (this.operatorListIdx === this.operatorList.argsArray.length) {
	        this.running = false;
	        if (this.operatorList.lastChunk) {
	          this.gfx.endDrawing();
	          this.callback();
	        }
	      }
	    }
	  };
	  return InternalRenderTask;
	}();
	var _UnsupportedManager = function UnsupportedManagerClosure() {
	  var listeners = [];
	  return {
	    listen: function listen(cb) {
	      (0, _util.deprecated)('Global UnsupportedManager.listen is used: ' + ' use PDFDocumentLoadingTask.onUnsupportedFeature instead');
	      listeners.push(cb);
	    },
	    notify: function notify(featureId) {
	      for (var i = 0, ii = listeners.length; i < ii; i++) {
	        listeners[i](featureId);
	      }
	    }
	  };
	}();
	var version, build;
	{
	  exports.version = version = '1.8.331';
	  exports.build = build = '0dbc68a6';
	}
	exports.getDocument = getDocument;
	exports.LoopbackPort = LoopbackPort;
	exports.PDFDataRangeTransport = PDFDataRangeTransport;
	exports.PDFWorker = PDFWorker;
	exports.PDFDocumentProxy = PDFDocumentProxy;
	exports.PDFPageProxy = PDFPageProxy;
	exports._UnsupportedManager = _UnsupportedManager;
	exports.version = version;
	exports.build = build;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SVGGraphics = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var SVGGraphics = function SVGGraphics() {
	  throw new Error('Not implemented: SVGGraphics');
	};
	{
	  var SVG_DEFAULTS = {
	    fontStyle: 'normal',
	    fontWeight: 'normal',
	    fillColor: '#000000'
	  };
	  var convertImgDataToPng = function convertImgDataToPngClosure() {
	    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
	    var CHUNK_WRAPPER_SIZE = 12;
	    var crcTable = new Int32Array(256);
	    for (var i = 0; i < 256; i++) {
	      var c = i;
	      for (var h = 0; h < 8; h++) {
	        if (c & 1) {
	          c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
	        } else {
	          c = c >> 1 & 0x7fffffff;
	        }
	      }
	      crcTable[i] = c;
	    }
	    function crc32(data, start, end) {
	      var crc = -1;
	      for (var i = start; i < end; i++) {
	        var a = (crc ^ data[i]) & 0xff;
	        var b = crcTable[a];
	        crc = crc >>> 8 ^ b;
	      }
	      return crc ^ -1;
	    }
	    function writePngChunk(type, body, data, offset) {
	      var p = offset;
	      var len = body.length;
	      data[p] = len >> 24 & 0xff;
	      data[p + 1] = len >> 16 & 0xff;
	      data[p + 2] = len >> 8 & 0xff;
	      data[p + 3] = len & 0xff;
	      p += 4;
	      data[p] = type.charCodeAt(0) & 0xff;
	      data[p + 1] = type.charCodeAt(1) & 0xff;
	      data[p + 2] = type.charCodeAt(2) & 0xff;
	      data[p + 3] = type.charCodeAt(3) & 0xff;
	      p += 4;
	      data.set(body, p);
	      p += body.length;
	      var crc = crc32(data, offset + 4, p);
	      data[p] = crc >> 24 & 0xff;
	      data[p + 1] = crc >> 16 & 0xff;
	      data[p + 2] = crc >> 8 & 0xff;
	      data[p + 3] = crc & 0xff;
	    }
	    function adler32(data, start, end) {
	      var a = 1;
	      var b = 0;
	      for (var i = start; i < end; ++i) {
	        a = (a + (data[i] & 0xff)) % 65521;
	        b = (b + a) % 65521;
	      }
	      return b << 16 | a;
	    }
	    function encode(imgData, kind, forceDataSchema) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var bitDepth, colorType, lineSize;
	      var bytes = imgData.data;
	      switch (kind) {
	        case _util.ImageKind.GRAYSCALE_1BPP:
	          colorType = 0;
	          bitDepth = 1;
	          lineSize = width + 7 >> 3;
	          break;
	        case _util.ImageKind.RGB_24BPP:
	          colorType = 2;
	          bitDepth = 8;
	          lineSize = width * 3;
	          break;
	        case _util.ImageKind.RGBA_32BPP:
	          colorType = 6;
	          bitDepth = 8;
	          lineSize = width * 4;
	          break;
	        default:
	          throw new Error('invalid format');
	      }
	      var literals = new Uint8Array((1 + lineSize) * height);
	      var offsetLiterals = 0,
	          offsetBytes = 0;
	      var y, i;
	      for (y = 0; y < height; ++y) {
	        literals[offsetLiterals++] = 0;
	        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
	        offsetBytes += lineSize;
	        offsetLiterals += lineSize;
	      }
	      if (kind === _util.ImageKind.GRAYSCALE_1BPP) {
	        offsetLiterals = 0;
	        for (y = 0; y < height; y++) {
	          offsetLiterals++;
	          for (i = 0; i < lineSize; i++) {
	            literals[offsetLiterals++] ^= 0xFF;
	          }
	        }
	      }
	      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
	      var len = literals.length;
	      var maxBlockLength = 0xFFFF;
	      var deflateBlocks = Math.ceil(len / maxBlockLength);
	      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
	      var pi = 0;
	      idat[pi++] = 0x78;
	      idat[pi++] = 0x9c;
	      var pos = 0;
	      while (len > maxBlockLength) {
	        idat[pi++] = 0x00;
	        idat[pi++] = 0xff;
	        idat[pi++] = 0xff;
	        idat[pi++] = 0x00;
	        idat[pi++] = 0x00;
	        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
	        pi += maxBlockLength;
	        pos += maxBlockLength;
	        len -= maxBlockLength;
	      }
	      idat[pi++] = 0x01;
	      idat[pi++] = len & 0xff;
	      idat[pi++] = len >> 8 & 0xff;
	      idat[pi++] = ~len & 0xffff & 0xff;
	      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
	      idat.set(literals.subarray(pos), pi);
	      pi += literals.length - pos;
	      var adler = adler32(literals, 0, literals.length);
	      idat[pi++] = adler >> 24 & 0xff;
	      idat[pi++] = adler >> 16 & 0xff;
	      idat[pi++] = adler >> 8 & 0xff;
	      idat[pi++] = adler & 0xff;
	      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
	      var data = new Uint8Array(pngLength);
	      var offset = 0;
	      data.set(PNG_HEADER, offset);
	      offset += PNG_HEADER.length;
	      writePngChunk('IHDR', ihdr, data, offset);
	      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
	      writePngChunk('IDATA', idat, data, offset);
	      offset += CHUNK_WRAPPER_SIZE + idat.length;
	      writePngChunk('IEND', new Uint8Array(0), data, offset);
	      return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema);
	    }
	    return function convertImgDataToPng(imgData, forceDataSchema) {
	      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
	      return encode(imgData, kind, forceDataSchema);
	    };
	  }();
	  var SVGExtraState = function SVGExtraStateClosure() {
	    function SVGExtraState() {
	      this.fontSizeScale = 1;
	      this.fontWeight = SVG_DEFAULTS.fontWeight;
	      this.fontSize = 0;
	      this.textMatrix = _util.IDENTITY_MATRIX;
	      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	      this.leading = 0;
	      this.x = 0;
	      this.y = 0;
	      this.lineX = 0;
	      this.lineY = 0;
	      this.charSpacing = 0;
	      this.wordSpacing = 0;
	      this.textHScale = 1;
	      this.textRise = 0;
	      this.fillColor = SVG_DEFAULTS.fillColor;
	      this.strokeColor = '#000000';
	      this.fillAlpha = 1;
	      this.strokeAlpha = 1;
	      this.lineWidth = 1;
	      this.lineJoin = '';
	      this.lineCap = '';
	      this.miterLimit = 0;
	      this.dashArray = [];
	      this.dashPhase = 0;
	      this.dependencies = [];
	      this.activeClipUrl = null;
	      this.clipGroup = null;
	      this.maskId = '';
	    }
	    SVGExtraState.prototype = {
	      clone: function SVGExtraState_clone() {
	        return Object.create(this);
	      },
	      setCurrentPoint: function SVGExtraState_setCurrentPoint(x, y) {
	        this.x = x;
	        this.y = y;
	      }
	    };
	    return SVGExtraState;
	  }();
	  exports.SVGGraphics = SVGGraphics = function SVGGraphicsClosure() {
	    function opListToTree(opList) {
	      var opTree = [];
	      var tmp = [];
	      var opListLen = opList.length;
	      for (var x = 0; x < opListLen; x++) {
	        if (opList[x].fn === 'save') {
	          opTree.push({
	            'fnId': 92,
	            'fn': 'group',
	            'items': []
	          });
	          tmp.push(opTree);
	          opTree = opTree[opTree.length - 1].items;
	          continue;
	        }
	        if (opList[x].fn === 'restore') {
	          opTree = tmp.pop();
	        } else {
	          opTree.push(opList[x]);
	        }
	      }
	      return opTree;
	    }
	    function pf(value) {
	      if (value === (value | 0)) {
	        return value.toString();
	      }
	      var s = value.toFixed(10);
	      var i = s.length - 1;
	      if (s[i] !== '0') {
	        return s;
	      }
	      do {
	        i--;
	      } while (s[i] === '0');
	      return s.substr(0, s[i] === '.' ? i : i + 1);
	    }
	    function pm(m) {
	      if (m[4] === 0 && m[5] === 0) {
	        if (m[1] === 0 && m[2] === 0) {
	          if (m[0] === 1 && m[3] === 1) {
	            return '';
	          }
	          return 'scale(' + pf(m[0]) + ' ' + pf(m[3]) + ')';
	        }
	        if (m[0] === m[3] && m[1] === -m[2]) {
	          var a = Math.acos(m[0]) * 180 / Math.PI;
	          return 'rotate(' + pf(a) + ')';
	        }
	      } else {
	        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
	          return 'translate(' + pf(m[4]) + ' ' + pf(m[5]) + ')';
	        }
	      }
	      return 'matrix(' + pf(m[0]) + ' ' + pf(m[1]) + ' ' + pf(m[2]) + ' ' + pf(m[3]) + ' ' + pf(m[4]) + ' ' + pf(m[5]) + ')';
	    }
	    function SVGGraphics(commonObjs, objs, forceDataSchema) {
	      this.current = new SVGExtraState();
	      this.transformMatrix = _util.IDENTITY_MATRIX;
	      this.transformStack = [];
	      this.extraStack = [];
	      this.commonObjs = commonObjs;
	      this.objs = objs;
	      this.pendingEOFill = false;
	      this.embedFonts = false;
	      this.embeddedFonts = Object.create(null);
	      this.cssStyle = null;
	      this.forceDataSchema = !!forceDataSchema;
	    }
	    var NS = 'http://www.w3.org/2000/svg';
	    var XML_NS = 'http://www.w3.org/XML/1998/namespace';
	    var XLINK_NS = 'http://www.w3.org/1999/xlink';
	    var LINE_CAP_STYLES = ['butt', 'round', 'square'];
	    var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
	    var clipCount = 0;
	    var maskCount = 0;
	    SVGGraphics.prototype = {
	      save: function SVGGraphics_save() {
	        this.transformStack.push(this.transformMatrix);
	        var old = this.current;
	        this.extraStack.push(old);
	        this.current = old.clone();
	      },
	      restore: function SVGGraphics_restore() {
	        this.transformMatrix = this.transformStack.pop();
	        this.current = this.extraStack.pop();
	        this.tgrp = null;
	      },
	      group: function SVGGraphics_group(items) {
	        this.save();
	        this.executeOpTree(items);
	        this.restore();
	      },
	      loadDependencies: function SVGGraphics_loadDependencies(operatorList) {
	        var _this = this;
	
	        var fnArray = operatorList.fnArray;
	        var fnArrayLen = fnArray.length;
	        var argsArray = operatorList.argsArray;
	        for (var i = 0; i < fnArrayLen; i++) {
	          if (_util.OPS.dependency === fnArray[i]) {
	            var deps = argsArray[i];
	            for (var n = 0, nn = deps.length; n < nn; n++) {
	              var obj = deps[n];
	              var common = obj.substring(0, 2) === 'g_';
	              var promise;
	              if (common) {
	                promise = new Promise(function (resolve) {
	                  _this.commonObjs.get(obj, resolve);
	                });
	              } else {
	                promise = new Promise(function (resolve) {
	                  _this.objs.get(obj, resolve);
	                });
	              }
	              this.current.dependencies.push(promise);
	            }
	          }
	        }
	        return Promise.all(this.current.dependencies);
	      },
	      transform: function SVGGraphics_transform(a, b, c, d, e, f) {
	        var transformMatrix = [a, b, c, d, e, f];
	        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
	        this.tgrp = null;
	      },
	      getSVG: function SVGGraphics_getSVG(operatorList, viewport) {
	        var _this2 = this;
	
	        this.viewport = viewport;
	        var svgElement = this._initialize(viewport);
	        return this.loadDependencies(operatorList).then(function () {
	          _this2.transformMatrix = _util.IDENTITY_MATRIX;
	          var opTree = _this2.convertOpList(operatorList);
	          _this2.executeOpTree(opTree);
	          return svgElement;
	        });
	      },
	      convertOpList: function SVGGraphics_convertOpList(operatorList) {
	        var argsArray = operatorList.argsArray;
	        var fnArray = operatorList.fnArray;
	        var fnArrayLen = fnArray.length;
	        var REVOPS = [];
	        var opList = [];
	        for (var op in _util.OPS) {
	          REVOPS[_util.OPS[op]] = op;
	        }
	        for (var x = 0; x < fnArrayLen; x++) {
	          var fnId = fnArray[x];
	          opList.push({
	            'fnId': fnId,
	            'fn': REVOPS[fnId],
	            'args': argsArray[x]
	          });
	        }
	        return opListToTree(opList);
	      },
	      executeOpTree: function SVGGraphics_executeOpTree(opTree) {
	        var opTreeLen = opTree.length;
	        for (var x = 0; x < opTreeLen; x++) {
	          var fn = opTree[x].fn;
	          var fnId = opTree[x].fnId;
	          var args = opTree[x].args;
	          switch (fnId | 0) {
	            case _util.OPS.beginText:
	              this.beginText();
	              break;
	            case _util.OPS.setLeading:
	              this.setLeading(args);
	              break;
	            case _util.OPS.setLeadingMoveText:
	              this.setLeadingMoveText(args[0], args[1]);
	              break;
	            case _util.OPS.setFont:
	              this.setFont(args);
	              break;
	            case _util.OPS.showText:
	              this.showText(args[0]);
	              break;
	            case _util.OPS.showSpacedText:
	              this.showText(args[0]);
	              break;
	            case _util.OPS.endText:
	              this.endText();
	              break;
	            case _util.OPS.moveText:
	              this.moveText(args[0], args[1]);
	              break;
	            case _util.OPS.setCharSpacing:
	              this.setCharSpacing(args[0]);
	              break;
	            case _util.OPS.setWordSpacing:
	              this.setWordSpacing(args[0]);
	              break;
	            case _util.OPS.setHScale:
	              this.setHScale(args[0]);
	              break;
	            case _util.OPS.setTextMatrix:
	              this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.setLineWidth:
	              this.setLineWidth(args[0]);
	              break;
	            case _util.OPS.setLineJoin:
	              this.setLineJoin(args[0]);
	              break;
	            case _util.OPS.setLineCap:
	              this.setLineCap(args[0]);
	              break;
	            case _util.OPS.setMiterLimit:
	              this.setMiterLimit(args[0]);
	              break;
	            case _util.OPS.setFillRGBColor:
	              this.setFillRGBColor(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.setStrokeRGBColor:
	              this.setStrokeRGBColor(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.setDash:
	              this.setDash(args[0], args[1]);
	              break;
	            case _util.OPS.setGState:
	              this.setGState(args[0]);
	              break;
	            case _util.OPS.fill:
	              this.fill();
	              break;
	            case _util.OPS.eoFill:
	              this.eoFill();
	              break;
	            case _util.OPS.stroke:
	              this.stroke();
	              break;
	            case _util.OPS.fillStroke:
	              this.fillStroke();
	              break;
	            case _util.OPS.eoFillStroke:
	              this.eoFillStroke();
	              break;
	            case _util.OPS.clip:
	              this.clip('nonzero');
	              break;
	            case _util.OPS.eoClip:
	              this.clip('evenodd');
	              break;
	            case _util.OPS.paintSolidColorImageMask:
	              this.paintSolidColorImageMask();
	              break;
	            case _util.OPS.paintJpegXObject:
	              this.paintJpegXObject(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.paintImageXObject:
	              this.paintImageXObject(args[0]);
	              break;
	            case _util.OPS.paintInlineImageXObject:
	              this.paintInlineImageXObject(args[0]);
	              break;
	            case _util.OPS.paintImageMaskXObject:
	              this.paintImageMaskXObject(args[0]);
	              break;
	            case _util.OPS.paintFormXObjectBegin:
	              this.paintFormXObjectBegin(args[0], args[1]);
	              break;
	            case _util.OPS.paintFormXObjectEnd:
	              this.paintFormXObjectEnd();
	              break;
	            case _util.OPS.closePath:
	              this.closePath();
	              break;
	            case _util.OPS.closeStroke:
	              this.closeStroke();
	              break;
	            case _util.OPS.closeFillStroke:
	              this.closeFillStroke();
	              break;
	            case _util.OPS.nextLine:
	              this.nextLine();
	              break;
	            case _util.OPS.transform:
	              this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.constructPath:
	              this.constructPath(args[0], args[1]);
	              break;
	            case _util.OPS.endPath:
	              this.endPath();
	              break;
	            case 92:
	              this.group(opTree[x].items);
	              break;
	            default:
	              (0, _util.warn)('Unimplemented operator ' + fn);
	              break;
	          }
	        }
	      },
	      setWordSpacing: function SVGGraphics_setWordSpacing(wordSpacing) {
	        this.current.wordSpacing = wordSpacing;
	      },
	      setCharSpacing: function SVGGraphics_setCharSpacing(charSpacing) {
	        this.current.charSpacing = charSpacing;
	      },
	      nextLine: function SVGGraphics_nextLine() {
	        this.moveText(0, this.current.leading);
	      },
	      setTextMatrix: function SVGGraphics_setTextMatrix(a, b, c, d, e, f) {
	        var current = this.current;
	        this.current.textMatrix = this.current.lineMatrix = [a, b, c, d, e, f];
	        this.current.x = this.current.lineX = 0;
	        this.current.y = this.current.lineY = 0;
	        current.xcoords = [];
	        current.tspan = document.createElementNS(NS, 'svg:tspan');
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.txtElement = document.createElementNS(NS, 'svg:text');
	        current.txtElement.appendChild(current.tspan);
	      },
	      beginText: function SVGGraphics_beginText() {
	        this.current.x = this.current.lineX = 0;
	        this.current.y = this.current.lineY = 0;
	        this.current.textMatrix = _util.IDENTITY_MATRIX;
	        this.current.lineMatrix = _util.IDENTITY_MATRIX;
	        this.current.tspan = document.createElementNS(NS, 'svg:tspan');
	        this.current.txtElement = document.createElementNS(NS, 'svg:text');
	        this.current.txtgrp = document.createElementNS(NS, 'svg:g');
	        this.current.xcoords = [];
	      },
	      moveText: function SVGGraphics_moveText(x, y) {
	        var current = this.current;
	        this.current.x = this.current.lineX += x;
	        this.current.y = this.current.lineY += y;
	        current.xcoords = [];
	        current.tspan = document.createElementNS(NS, 'svg:tspan');
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	      },
	      showText: function SVGGraphics_showText(glyphs) {
	        var current = this.current;
	        var font = current.font;
	        var fontSize = current.fontSize;
	        if (fontSize === 0) {
	          return;
	        }
	        var charSpacing = current.charSpacing;
	        var wordSpacing = current.wordSpacing;
	        var fontDirection = current.fontDirection;
	        var textHScale = current.textHScale * fontDirection;
	        var glyphsLength = glyphs.length;
	        var vertical = font.vertical;
	        var widthAdvanceScale = fontSize * current.fontMatrix[0];
	        var x = 0,
	            i;
	        for (i = 0; i < glyphsLength; ++i) {
	          var glyph = glyphs[i];
	          if (glyph === null) {
	            x += fontDirection * wordSpacing;
	            continue;
	          } else if ((0, _util.isNum)(glyph)) {
	            x += -glyph * fontSize * 0.001;
	            continue;
	          }
	          current.xcoords.push(current.x + x * textHScale);
	          var width = glyph.width;
	          var character = glyph.fontChar;
	          var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	          var charWidth = width * widthAdvanceScale + spacing * fontDirection;
	          x += charWidth;
	          current.tspan.textContent += character;
	        }
	        if (vertical) {
	          current.y -= x * textHScale;
	        } else {
	          current.x += x * textHScale;
	        }
	        current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '));
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
	          current.tspan.setAttributeNS(null, 'font-style', current.fontStyle);
	        }
	        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
	          current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight);
	        }
	        if (current.fillColor !== SVG_DEFAULTS.fillColor) {
	          current.tspan.setAttributeNS(null, 'fill', current.fillColor);
	        }
	        current.txtElement.setAttributeNS(null, 'transform', pm(current.textMatrix) + ' scale(1, -1)');
	        current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve');
	        current.txtElement.appendChild(current.tspan);
	        current.txtgrp.appendChild(current.txtElement);
	        this._ensureTransformGroup().appendChild(current.txtElement);
	      },
	      setLeadingMoveText: function SVGGraphics_setLeadingMoveText(x, y) {
	        this.setLeading(-y);
	        this.moveText(x, y);
	      },
	      addFontStyle: function SVGGraphics_addFontStyle(fontObj) {
	        if (!this.cssStyle) {
	          this.cssStyle = document.createElementNS(NS, 'svg:style');
	          this.cssStyle.setAttributeNS(null, 'type', 'text/css');
	          this.defs.appendChild(this.cssStyle);
	        }
	        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
	        this.cssStyle.textContent += '@font-face { font-family: "' + fontObj.loadedName + '";' + ' src: url(' + url + '); }\n';
	      },
	      setFont: function SVGGraphics_setFont(details) {
	        var current = this.current;
	        var fontObj = this.commonObjs.get(details[0]);
	        var size = details[1];
	        this.current.font = fontObj;
	        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
	          this.addFontStyle(fontObj);
	          this.embeddedFonts[fontObj.loadedName] = fontObj;
	        }
	        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
	        var bold = fontObj.black ? fontObj.bold ? 'bolder' : 'bold' : fontObj.bold ? 'bold' : 'normal';
	        var italic = fontObj.italic ? 'italic' : 'normal';
	        if (size < 0) {
	          size = -size;
	          current.fontDirection = -1;
	        } else {
	          current.fontDirection = 1;
	        }
	        current.fontSize = size;
	        current.fontFamily = fontObj.loadedName;
	        current.fontWeight = bold;
	        current.fontStyle = italic;
	        current.tspan = document.createElementNS(NS, 'svg:tspan');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.xcoords = [];
	      },
	      endText: function SVGGraphics_endText() {},
	      setLineWidth: function SVGGraphics_setLineWidth(width) {
	        this.current.lineWidth = width;
	      },
	      setLineCap: function SVGGraphics_setLineCap(style) {
	        this.current.lineCap = LINE_CAP_STYLES[style];
	      },
	      setLineJoin: function SVGGraphics_setLineJoin(style) {
	        this.current.lineJoin = LINE_JOIN_STYLES[style];
	      },
	      setMiterLimit: function SVGGraphics_setMiterLimit(limit) {
	        this.current.miterLimit = limit;
	      },
	      setStrokeRGBColor: function SVGGraphics_setStrokeRGBColor(r, g, b) {
	        var color = _util.Util.makeCssRgb(r, g, b);
	        this.current.strokeColor = color;
	      },
	      setFillRGBColor: function SVGGraphics_setFillRGBColor(r, g, b) {
	        var color = _util.Util.makeCssRgb(r, g, b);
	        this.current.fillColor = color;
	        this.current.tspan = document.createElementNS(NS, 'svg:tspan');
	        this.current.xcoords = [];
	      },
	      setDash: function SVGGraphics_setDash(dashArray, dashPhase) {
	        this.current.dashArray = dashArray;
	        this.current.dashPhase = dashPhase;
	      },
	      constructPath: function SVGGraphics_constructPath(ops, args) {
	        var current = this.current;
	        var x = current.x,
	            y = current.y;
	        current.path = document.createElementNS(NS, 'svg:path');
	        var d = [];
	        var opLength = ops.length;
	        for (var i = 0, j = 0; i < opLength; i++) {
	          switch (ops[i] | 0) {
	            case _util.OPS.rectangle:
	              x = args[j++];
	              y = args[j++];
	              var width = args[j++];
	              var height = args[j++];
	              var xw = x + width;
	              var yh = y + height;
	              d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z');
	              break;
	            case _util.OPS.moveTo:
	              x = args[j++];
	              y = args[j++];
	              d.push('M', pf(x), pf(y));
	              break;
	            case _util.OPS.lineTo:
	              x = args[j++];
	              y = args[j++];
	              d.push('L', pf(x), pf(y));
	              break;
	            case _util.OPS.curveTo:
	              x = args[j + 4];
	              y = args[j + 5];
	              d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
	              j += 6;
	              break;
	            case _util.OPS.curveTo2:
	              x = args[j + 2];
	              y = args[j + 3];
	              d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
	              j += 4;
	              break;
	            case _util.OPS.curveTo3:
	              x = args[j + 2];
	              y = args[j + 3];
	              d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
	              j += 4;
	              break;
	            case _util.OPS.closePath:
	              d.push('Z');
	              break;
	          }
	        }
	        current.path.setAttributeNS(null, 'd', d.join(' '));
	        current.path.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit));
	        current.path.setAttributeNS(null, 'stroke-linecap', current.lineCap);
	        current.path.setAttributeNS(null, 'stroke-linejoin', current.lineJoin);
	        current.path.setAttributeNS(null, 'stroke-width', pf(current.lineWidth) + 'px');
	        current.path.setAttributeNS(null, 'stroke-dasharray', current.dashArray.map(pf).join(' '));
	        current.path.setAttributeNS(null, 'stroke-dashoffset', pf(current.dashPhase) + 'px');
	        current.path.setAttributeNS(null, 'fill', 'none');
	        this._ensureTransformGroup().appendChild(current.path);
	        current.element = current.path;
	        current.setCurrentPoint(x, y);
	      },
	      endPath: function SVGGraphics_endPath() {},
	      clip: function SVGGraphics_clip(type) {
	        var current = this.current;
	        var clipId = 'clippath' + clipCount;
	        clipCount++;
	        var clipPath = document.createElementNS(NS, 'svg:clipPath');
	        clipPath.setAttributeNS(null, 'id', clipId);
	        clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix));
	        var clipElement = current.element.cloneNode();
	        if (type === 'evenodd') {
	          clipElement.setAttributeNS(null, 'clip-rule', 'evenodd');
	        } else {
	          clipElement.setAttributeNS(null, 'clip-rule', 'nonzero');
	        }
	        clipPath.appendChild(clipElement);
	        this.defs.appendChild(clipPath);
	        if (current.activeClipUrl) {
	          current.clipGroup = null;
	          this.extraStack.forEach(function (prev) {
	            prev.clipGroup = null;
	          });
	        }
	        current.activeClipUrl = 'url(#' + clipId + ')';
	        this.tgrp = null;
	      },
	      closePath: function SVGGraphics_closePath() {
	        var current = this.current;
	        var d = current.path.getAttributeNS(null, 'd');
	        d += 'Z';
	        current.path.setAttributeNS(null, 'd', d);
	      },
	      setLeading: function SVGGraphics_setLeading(leading) {
	        this.current.leading = -leading;
	      },
	      setTextRise: function SVGGraphics_setTextRise(textRise) {
	        this.current.textRise = textRise;
	      },
	      setHScale: function SVGGraphics_setHScale(scale) {
	        this.current.textHScale = scale / 100;
	      },
	      setGState: function SVGGraphics_setGState(states) {
	        for (var i = 0, ii = states.length; i < ii; i++) {
	          var state = states[i];
	          var key = state[0];
	          var value = state[1];
	          switch (key) {
	            case 'LW':
	              this.setLineWidth(value);
	              break;
	            case 'LC':
	              this.setLineCap(value);
	              break;
	            case 'LJ':
	              this.setLineJoin(value);
	              break;
	            case 'ML':
	              this.setMiterLimit(value);
	              break;
	            case 'D':
	              this.setDash(value[0], value[1]);
	              break;
	            case 'Font':
	              this.setFont(value);
	              break;
	            default:
	              (0, _util.warn)('Unimplemented graphic state ' + key);
	              break;
	          }
	        }
	      },
	      fill: function SVGGraphics_fill() {
	        var current = this.current;
	        current.element.setAttributeNS(null, 'fill', current.fillColor);
	      },
	      stroke: function SVGGraphics_stroke() {
	        var current = this.current;
	        current.element.setAttributeNS(null, 'stroke', current.strokeColor);
	        current.element.setAttributeNS(null, 'fill', 'none');
	      },
	      eoFill: function SVGGraphics_eoFill() {
	        var current = this.current;
	        current.element.setAttributeNS(null, 'fill', current.fillColor);
	        current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
	      },
	      fillStroke: function SVGGraphics_fillStroke() {
	        this.stroke();
	        this.fill();
	      },
	      eoFillStroke: function SVGGraphics_eoFillStroke() {
	        this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
	        this.fillStroke();
	      },
	      closeStroke: function SVGGraphics_closeStroke() {
	        this.closePath();
	        this.stroke();
	      },
	      closeFillStroke: function SVGGraphics_closeFillStroke() {
	        this.closePath();
	        this.fillStroke();
	      },
	      paintSolidColorImageMask: function SVGGraphics_paintSolidColorImageMask() {
	        var current = this.current;
	        var rect = document.createElementNS(NS, 'svg:rect');
	        rect.setAttributeNS(null, 'x', '0');
	        rect.setAttributeNS(null, 'y', '0');
	        rect.setAttributeNS(null, 'width', '1px');
	        rect.setAttributeNS(null, 'height', '1px');
	        rect.setAttributeNS(null, 'fill', current.fillColor);
	        this._ensureTransformGroup().appendChild(rect);
	      },
	      paintJpegXObject: function SVGGraphics_paintJpegXObject(objId, w, h) {
	        var imgObj = this.objs.get(objId);
	        var imgEl = document.createElementNS(NS, 'svg:image');
	        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src);
	        imgEl.setAttributeNS(null, 'width', imgObj.width + 'px');
	        imgEl.setAttributeNS(null, 'height', imgObj.height + 'px');
	        imgEl.setAttributeNS(null, 'x', '0');
	        imgEl.setAttributeNS(null, 'y', pf(-h));
	        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / w) + ' ' + pf(-1 / h) + ')');
	        this._ensureTransformGroup().appendChild(imgEl);
	      },
	      paintImageXObject: function SVGGraphics_paintImageXObject(objId) {
	        var imgData = this.objs.get(objId);
	        if (!imgData) {
	          (0, _util.warn)('Dependent image isn\'t ready yet');
	          return;
	        }
	        this.paintInlineImageXObject(imgData);
	      },
	      paintInlineImageXObject: function SVGGraphics_paintInlineImageXObject(imgData, mask) {
	        var width = imgData.width;
	        var height = imgData.height;
	        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema);
	        var cliprect = document.createElementNS(NS, 'svg:rect');
	        cliprect.setAttributeNS(null, 'x', '0');
	        cliprect.setAttributeNS(null, 'y', '0');
	        cliprect.setAttributeNS(null, 'width', pf(width));
	        cliprect.setAttributeNS(null, 'height', pf(height));
	        this.current.element = cliprect;
	        this.clip('nonzero');
	        var imgEl = document.createElementNS(NS, 'svg:image');
	        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc);
	        imgEl.setAttributeNS(null, 'x', '0');
	        imgEl.setAttributeNS(null, 'y', pf(-height));
	        imgEl.setAttributeNS(null, 'width', pf(width) + 'px');
	        imgEl.setAttributeNS(null, 'height', pf(height) + 'px');
	        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / width) + ' ' + pf(-1 / height) + ')');
	        if (mask) {
	          mask.appendChild(imgEl);
	        } else {
	          this._ensureTransformGroup().appendChild(imgEl);
	        }
	      },
	      paintImageMaskXObject: function SVGGraphics_paintImageMaskXObject(imgData) {
	        var current = this.current;
	        var width = imgData.width;
	        var height = imgData.height;
	        var fillColor = current.fillColor;
	        current.maskId = 'mask' + maskCount++;
	        var mask = document.createElementNS(NS, 'svg:mask');
	        mask.setAttributeNS(null, 'id', current.maskId);
	        var rect = document.createElementNS(NS, 'svg:rect');
	        rect.setAttributeNS(null, 'x', '0');
	        rect.setAttributeNS(null, 'y', '0');
	        rect.setAttributeNS(null, 'width', pf(width));
	        rect.setAttributeNS(null, 'height', pf(height));
	        rect.setAttributeNS(null, 'fill', fillColor);
	        rect.setAttributeNS(null, 'mask', 'url(#' + current.maskId + ')');
	        this.defs.appendChild(mask);
	        this._ensureTransformGroup().appendChild(rect);
	        this.paintInlineImageXObject(imgData, mask);
	      },
	      paintFormXObjectBegin: function SVGGraphics_paintFormXObjectBegin(matrix, bbox) {
	        if ((0, _util.isArray)(matrix) && matrix.length === 6) {
	          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	        }
	        if ((0, _util.isArray)(bbox) && bbox.length === 4) {
	          var width = bbox[2] - bbox[0];
	          var height = bbox[3] - bbox[1];
	          var cliprect = document.createElementNS(NS, 'svg:rect');
	          cliprect.setAttributeNS(null, 'x', bbox[0]);
	          cliprect.setAttributeNS(null, 'y', bbox[1]);
	          cliprect.setAttributeNS(null, 'width', pf(width));
	          cliprect.setAttributeNS(null, 'height', pf(height));
	          this.current.element = cliprect;
	          this.clip('nonzero');
	          this.endPath();
	        }
	      },
	      paintFormXObjectEnd: function SVGGraphics_paintFormXObjectEnd() {},
	      _initialize: function SVGGraphics_initialize(viewport) {
	        var svg = document.createElementNS(NS, 'svg:svg');
	        svg.setAttributeNS(null, 'version', '1.1');
	        svg.setAttributeNS(null, 'width', viewport.width + 'px');
	        svg.setAttributeNS(null, 'height', viewport.height + 'px');
	        svg.setAttributeNS(null, 'preserveAspectRatio', 'none');
	        svg.setAttributeNS(null, 'viewBox', '0 0 ' + viewport.width + ' ' + viewport.height);
	        var definitions = document.createElementNS(NS, 'svg:defs');
	        svg.appendChild(definitions);
	        this.defs = definitions;
	        var rootGroup = document.createElementNS(NS, 'svg:g');
	        rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform));
	        svg.appendChild(rootGroup);
	        this.svg = rootGroup;
	        return svg;
	      },
	      _ensureClipGroup: function SVGGraphics_ensureClipGroup() {
	        if (!this.current.clipGroup) {
	          var clipGroup = document.createElementNS(NS, 'svg:g');
	          clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
	          this.svg.appendChild(clipGroup);
	          this.current.clipGroup = clipGroup;
	        }
	        return this.current.clipGroup;
	      },
	      _ensureTransformGroup: function SVGGraphics_ensureTransformGroup() {
	        if (!this.tgrp) {
	          this.tgrp = document.createElementNS(NS, 'svg:g');
	          this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix));
	          if (this.current.activeClipUrl) {
	            this._ensureClipGroup().appendChild(this.tgrp);
	          } else {
	            this.svg.appendChild(this.tgrp);
	          }
	        }
	        return this.tgrp;
	      }
	    };
	    return SVGGraphics;
	  }();
	}
	exports.SVGGraphics = SVGGraphics;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderTextLayer = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(1);
	
	var renderTextLayer = function renderTextLayerClosure() {
	  var MAX_TEXT_DIVS_TO_RENDER = 100000;
	  var NonWhitespaceRegexp = /\S/;
	  function isAllWhitespace(str) {
	    return !NonWhitespaceRegexp.test(str);
	  }
	  var styleBuf = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];
	  function appendText(task, geom, styles) {
	    var textDiv = document.createElement('div');
	    var textDivProperties = {
	      style: null,
	      angle: 0,
	      canvasWidth: 0,
	      isWhitespace: false,
	      originalTransform: null,
	      paddingBottom: 0,
	      paddingLeft: 0,
	      paddingRight: 0,
	      paddingTop: 0,
	      scale: 1
	    };
	    task._textDivs.push(textDiv);
	    if (isAllWhitespace(geom.str)) {
	      textDivProperties.isWhitespace = true;
	      task._textDivProperties.set(textDiv, textDivProperties);
	      return;
	    }
	    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
	    var angle = Math.atan2(tx[1], tx[0]);
	    var style = styles[geom.fontName];
	    if (style.vertical) {
	      angle += Math.PI / 2;
	    }
	    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
	    var fontAscent = fontHeight;
	    if (style.ascent) {
	      fontAscent = style.ascent * fontAscent;
	    } else if (style.descent) {
	      fontAscent = (1 + style.descent) * fontAscent;
	    }
	    var left;
	    var top;
	    if (angle === 0) {
	      left = tx[4];
	      top = tx[5] - fontAscent;
	    } else {
	      left = tx[4] + fontAscent * Math.sin(angle);
	      top = tx[5] - fontAscent * Math.cos(angle);
	    }
	    styleBuf[1] = left;
	    styleBuf[3] = top;
	    styleBuf[5] = fontHeight;
	    styleBuf[7] = style.fontFamily;
	    textDivProperties.style = styleBuf.join('');
	    textDiv.setAttribute('style', textDivProperties.style);
	    textDiv.textContent = geom.str;
	    if ((0, _dom_utils.getDefaultSetting)('pdfBug')) {
	      textDiv.dataset.fontName = geom.fontName;
	    }
	    if (angle !== 0) {
	      textDivProperties.angle = angle * (180 / Math.PI);
	    }
	    if (geom.str.length > 1) {
	      if (style.vertical) {
	        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
	      } else {
	        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
	      }
	    }
	    task._textDivProperties.set(textDiv, textDivProperties);
	    if (task._enhanceTextSelection) {
	      var angleCos = 1,
	          angleSin = 0;
	      if (angle !== 0) {
	        angleCos = Math.cos(angle);
	        angleSin = Math.sin(angle);
	      }
	      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
	      var divHeight = fontHeight;
	      var m, b;
	      if (angle !== 0) {
	        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
	        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
	      } else {
	        b = [left, top, left + divWidth, top + divHeight];
	      }
	      task._bounds.push({
	        left: b[0],
	        top: b[1],
	        right: b[2],
	        bottom: b[3],
	        div: textDiv,
	        size: [divWidth, divHeight],
	        m: m
	      });
	    }
	  }
	  function render(task) {
	    if (task._canceled) {
	      return;
	    }
	    var textLayerFrag = task._container;
	    var textDivs = task._textDivs;
	    var capability = task._capability;
	    var textDivsLength = textDivs.length;
	    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
	      task._renderingDone = true;
	      capability.resolve();
	      return;
	    }
	    var canvas = document.createElement('canvas');
	    canvas.mozOpaque = true;
	    var ctx = canvas.getContext('2d', { alpha: false });
	    var lastFontSize;
	    var lastFontFamily;
	    for (var i = 0; i < textDivsLength; i++) {
	      var textDiv = textDivs[i];
	      var textDivProperties = task._textDivProperties.get(textDiv);
	      if (textDivProperties.isWhitespace) {
	        continue;
	      }
	      var fontSize = textDiv.style.fontSize;
	      var fontFamily = textDiv.style.fontFamily;
	      if (fontSize !== lastFontSize || fontFamily !== lastFontFamily) {
	        ctx.font = fontSize + ' ' + fontFamily;
	        lastFontSize = fontSize;
	        lastFontFamily = fontFamily;
	      }
	      var width = ctx.measureText(textDiv.textContent).width;
	      textLayerFrag.appendChild(textDiv);
	      var transform = '';
	      if (textDivProperties.canvasWidth !== 0 && width > 0) {
	        textDivProperties.scale = textDivProperties.canvasWidth / width;
	        transform = 'scaleX(' + textDivProperties.scale + ')';
	      }
	      if (textDivProperties.angle !== 0) {
	        transform = 'rotate(' + textDivProperties.angle + 'deg) ' + transform;
	      }
	      if (transform !== '') {
	        textDivProperties.originalTransform = transform;
	        _dom_utils.CustomStyle.setProp('transform', textDiv, transform);
	      }
	      task._textDivProperties.set(textDiv, textDivProperties);
	    }
	    task._renderingDone = true;
	    capability.resolve();
	  }
	  function expand(task) {
	    var bounds = task._bounds;
	    var viewport = task._viewport;
	    var expanded = expandBounds(viewport.width, viewport.height, bounds);
	    for (var i = 0; i < expanded.length; i++) {
	      var div = bounds[i].div;
	      var divProperties = task._textDivProperties.get(div);
	      if (divProperties.angle === 0) {
	        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
	        divProperties.paddingTop = bounds[i].top - expanded[i].top;
	        divProperties.paddingRight = expanded[i].right - bounds[i].right;
	        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
	        task._textDivProperties.set(div, divProperties);
	        continue;
	      }
	      var e = expanded[i],
	          b = bounds[i];
	      var m = b.m,
	          c = m[0],
	          s = m[1];
	      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
	      var ts = new Float64Array(64);
	      points.forEach(function (p, i) {
	        var t = _util.Util.applyTransform(p, m);
	        ts[i + 0] = c && (e.left - t[0]) / c;
	        ts[i + 4] = s && (e.top - t[1]) / s;
	        ts[i + 8] = c && (e.right - t[0]) / c;
	        ts[i + 12] = s && (e.bottom - t[1]) / s;
	        ts[i + 16] = s && (e.left - t[0]) / -s;
	        ts[i + 20] = c && (e.top - t[1]) / c;
	        ts[i + 24] = s && (e.right - t[0]) / -s;
	        ts[i + 28] = c && (e.bottom - t[1]) / c;
	        ts[i + 32] = c && (e.left - t[0]) / -c;
	        ts[i + 36] = s && (e.top - t[1]) / -s;
	        ts[i + 40] = c && (e.right - t[0]) / -c;
	        ts[i + 44] = s && (e.bottom - t[1]) / -s;
	        ts[i + 48] = s && (e.left - t[0]) / s;
	        ts[i + 52] = c && (e.top - t[1]) / -c;
	        ts[i + 56] = s && (e.right - t[0]) / s;
	        ts[i + 60] = c && (e.bottom - t[1]) / -c;
	      });
	      var findPositiveMin = function findPositiveMin(ts, offset, count) {
	        var result = 0;
	        for (var i = 0; i < count; i++) {
	          var t = ts[offset++];
	          if (t > 0) {
	            result = result ? Math.min(t, result) : t;
	          }
	        }
	        return result;
	      };
	      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
	      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
	      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
	      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
	      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
	      task._textDivProperties.set(div, divProperties);
	    }
	  }
	  function expandBounds(width, height, boxes) {
	    var bounds = boxes.map(function (box, i) {
	      return {
	        x1: box.left,
	        y1: box.top,
	        x2: box.right,
	        y2: box.bottom,
	        index: i,
	        x1New: undefined,
	        x2New: undefined
	      };
	    });
	    expandBoundsLTR(width, bounds);
	    var expanded = new Array(boxes.length);
	    bounds.forEach(function (b) {
	      var i = b.index;
	      expanded[i] = {
	        left: b.x1New,
	        top: 0,
	        right: b.x2New,
	        bottom: 0
	      };
	    });
	    boxes.map(function (box, i) {
	      var e = expanded[i],
	          b = bounds[i];
	      b.x1 = box.top;
	      b.y1 = width - e.right;
	      b.x2 = box.bottom;
	      b.y2 = width - e.left;
	      b.index = i;
	      b.x1New = undefined;
	      b.x2New = undefined;
	    });
	    expandBoundsLTR(height, bounds);
	    bounds.forEach(function (b) {
	      var i = b.index;
	      expanded[i].top = b.x1New;
	      expanded[i].bottom = b.x2New;
	    });
	    return expanded;
	  }
	  function expandBoundsLTR(width, bounds) {
	    bounds.sort(function (a, b) {
	      return a.x1 - b.x1 || a.index - b.index;
	    });
	    var fakeBoundary = {
	      x1: -Infinity,
	      y1: -Infinity,
	      x2: 0,
	      y2: Infinity,
	      index: -1,
	      x1New: 0,
	      x2New: 0
	    };
	    var horizon = [{
	      start: -Infinity,
	      end: Infinity,
	      boundary: fakeBoundary
	    }];
	    bounds.forEach(function (boundary) {
	      var i = 0;
	      while (i < horizon.length && horizon[i].end <= boundary.y1) {
	        i++;
	      }
	      var j = horizon.length - 1;
	      while (j >= 0 && horizon[j].start >= boundary.y2) {
	        j--;
	      }
	      var horizonPart, affectedBoundary;
	      var q,
	          k,
	          maxXNew = -Infinity;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        var xNew;
	        if (affectedBoundary.x2 > boundary.x1) {
	          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
	        } else if (affectedBoundary.x2New === undefined) {
	          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
	        } else {
	          xNew = affectedBoundary.x2New;
	        }
	        if (xNew > maxXNew) {
	          maxXNew = xNew;
	        }
	      }
	      boundary.x1New = maxXNew;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        if (affectedBoundary.x2New === undefined) {
	          if (affectedBoundary.x2 > boundary.x1) {
	            if (affectedBoundary.index > boundary.index) {
	              affectedBoundary.x2New = affectedBoundary.x2;
	            }
	          } else {
	            affectedBoundary.x2New = maxXNew;
	          }
	        } else if (affectedBoundary.x2New > maxXNew) {
	          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
	        }
	      }
	      var changedHorizon = [],
	          lastBoundary = null;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
	        if (lastBoundary === useBoundary) {
	          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
	        } else {
	          changedHorizon.push({
	            start: horizonPart.start,
	            end: horizonPart.end,
	            boundary: useBoundary
	          });
	          lastBoundary = useBoundary;
	        }
	      }
	      if (horizon[i].start < boundary.y1) {
	        changedHorizon[0].start = boundary.y1;
	        changedHorizon.unshift({
	          start: horizon[i].start,
	          end: boundary.y1,
	          boundary: horizon[i].boundary
	        });
	      }
	      if (boundary.y2 < horizon[j].end) {
	        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
	        changedHorizon.push({
	          start: boundary.y2,
	          end: horizon[j].end,
	          boundary: horizon[j].boundary
	        });
	      }
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        if (affectedBoundary.x2New !== undefined) {
	          continue;
	        }
	        var used = false;
	        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
	          used = horizon[k].boundary === affectedBoundary;
	        }
	        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
	          used = horizon[k].boundary === affectedBoundary;
	        }
	        for (k = 0; !used && k < changedHorizon.length; k++) {
	          used = changedHorizon[k].boundary === affectedBoundary;
	        }
	        if (!used) {
	          affectedBoundary.x2New = maxXNew;
	        }
	      }
	      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
	    });
	    horizon.forEach(function (horizonPart) {
	      var affectedBoundary = horizonPart.boundary;
	      if (affectedBoundary.x2New === undefined) {
	        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
	      }
	    });
	  }
	  function TextLayerRenderTask(textContent, container, viewport, textDivs, enhanceTextSelection) {
	    this._textContent = textContent;
	    this._container = container;
	    this._viewport = viewport;
	    this._textDivs = textDivs || [];
	    this._textDivProperties = new WeakMap();
	    this._renderingDone = false;
	    this._canceled = false;
	    this._capability = (0, _util.createPromiseCapability)();
	    this._renderTimer = null;
	    this._bounds = [];
	    this._enhanceTextSelection = !!enhanceTextSelection;
	  }
	  TextLayerRenderTask.prototype = {
	    get promise() {
	      return this._capability.promise;
	    },
	    cancel: function TextLayer_cancel() {
	      this._canceled = true;
	      if (this._renderTimer !== null) {
	        clearTimeout(this._renderTimer);
	        this._renderTimer = null;
	      }
	      this._capability.reject('canceled');
	    },
	    _render: function TextLayer_render(timeout) {
	      var _this = this;
	
	      var textItems = this._textContent.items;
	      var textStyles = this._textContent.styles;
	      for (var i = 0, len = textItems.length; i < len; i++) {
	        appendText(this, textItems[i], textStyles);
	      }
	      if (!timeout) {
	        render(this);
	      } else {
	        this._renderTimer = setTimeout(function () {
	          render(_this);
	          _this._renderTimer = null;
	        }, timeout);
	      }
	    },
	    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
	      if (!this._enhanceTextSelection || !this._renderingDone) {
	        return;
	      }
	      if (this._bounds !== null) {
	        expand(this);
	        this._bounds = null;
	      }
	      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
	        var div = this._textDivs[i];
	        var divProperties = this._textDivProperties.get(div);
	        if (divProperties.isWhitespace) {
	          continue;
	        }
	        if (expandDivs) {
	          var transform = '',
	              padding = '';
	          if (divProperties.scale !== 1) {
	            transform = 'scaleX(' + divProperties.scale + ')';
	          }
	          if (divProperties.angle !== 0) {
	            transform = 'rotate(' + divProperties.angle + 'deg) ' + transform;
	          }
	          if (divProperties.paddingLeft !== 0) {
	            padding += ' padding-left: ' + divProperties.paddingLeft / divProperties.scale + 'px;';
	            transform += ' translateX(' + -divProperties.paddingLeft / divProperties.scale + 'px)';
	          }
	          if (divProperties.paddingTop !== 0) {
	            padding += ' padding-top: ' + divProperties.paddingTop + 'px;';
	            transform += ' translateY(' + -divProperties.paddingTop + 'px)';
	          }
	          if (divProperties.paddingRight !== 0) {
	            padding += ' padding-right: ' + divProperties.paddingRight / divProperties.scale + 'px;';
	          }
	          if (divProperties.paddingBottom !== 0) {
	            padding += ' padding-bottom: ' + divProperties.paddingBottom + 'px;';
	          }
	          if (padding !== '') {
	            div.setAttribute('style', divProperties.style + padding);
	          }
	          if (transform !== '') {
	            _dom_utils.CustomStyle.setProp('transform', div, transform);
	          }
	        } else {
	          div.style.padding = 0;
	          _dom_utils.CustomStyle.setProp('transform', div, divProperties.originalTransform || '');
	        }
	      }
	    }
	  };
	  function renderTextLayer(renderParameters) {
	    var task = new TextLayerRenderTask(renderParameters.textContent, renderParameters.container, renderParameters.viewport, renderParameters.textDivs, renderParameters.enhanceTextSelection);
	    task._render(renderParameters.timeout);
	    return task;
	  }
	  return renderTextLayer;
	}();
	exports.renderTextLayer = renderTextLayer;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var g;
	g = function () {
	  return this;
	}();
	try {
	  g = g || Function("return this")() || (1, eval)("this");
	} catch (e) {
	  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
	}
	module.exports = g;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Metadata = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	function fixMetadata(meta) {
	  return meta.replace(/>\\376\\377([^<]+)/g, function (all, codes) {
	    var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
	      return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
	    });
	    var chars = '';
	    for (var i = 0; i < bytes.length; i += 2) {
	      var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
	      chars += code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38 ? String.fromCharCode(code) : '&#x' + (0x10000 + code).toString(16).substring(1) + ';';
	    }
	    return '>' + chars;
	  });
	}
	function Metadata(meta) {
	  if (typeof meta === 'string') {
	    meta = fixMetadata(meta);
	    var parser = new DOMParser();
	    meta = parser.parseFromString(meta, 'application/xml');
	  } else if (!(meta instanceof Document)) {
	    (0, _util.error)('Metadata: Invalid metadata object');
	  }
	  this.metaDocument = meta;
	  this.metadata = Object.create(null);
	  this.parse();
	}
	Metadata.prototype = {
	  parse: function Metadata_parse() {
	    var doc = this.metaDocument;
	    var rdf = doc.documentElement;
	    if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
	      rdf = rdf.firstChild;
	      while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
	        rdf = rdf.nextSibling;
	      }
	    }
	    var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;
	    if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
	      return;
	    }
	    var children = rdf.childNodes,
	        desc,
	        entry,
	        name,
	        i,
	        ii,
	        length,
	        iLength;
	    for (i = 0, length = children.length; i < length; i++) {
	      desc = children[i];
	      if (desc.nodeName.toLowerCase() !== 'rdf:description') {
	        continue;
	      }
	      for (ii = 0, iLength = desc.childNodes.length; ii < iLength; ii++) {
	        if (desc.childNodes[ii].nodeName.toLowerCase() !== '#text') {
	          entry = desc.childNodes[ii];
	          name = entry.nodeName.toLowerCase();
	          this.metadata[name] = entry.textContent.trim();
	        }
	      }
	    }
	  },
	  get: function Metadata_get(name) {
	    return this.metadata[name] || null;
	  },
	  has: function Metadata_has(name) {
	    return typeof this.metadata[name] !== 'undefined';
	  }
	};
	exports.Metadata = Metadata;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebGLUtils = undefined;
	
	var _dom_utils = __w_pdfjs_require__(1);
	
	var _util = __w_pdfjs_require__(0);
	
	var WebGLUtils = function WebGLUtilsClosure() {
	  function loadShader(gl, code, shaderType) {
	    var shader = gl.createShader(shaderType);
	    gl.shaderSource(shader, code);
	    gl.compileShader(shader);
	    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
	    if (!compiled) {
	      var errorMsg = gl.getShaderInfoLog(shader);
	      throw new Error('Error during shader compilation: ' + errorMsg);
	    }
	    return shader;
	  }
	  function createVertexShader(gl, code) {
	    return loadShader(gl, code, gl.VERTEX_SHADER);
	  }
	  function createFragmentShader(gl, code) {
	    return loadShader(gl, code, gl.FRAGMENT_SHADER);
	  }
	  function createProgram(gl, shaders) {
	    var program = gl.createProgram();
	    for (var i = 0, ii = shaders.length; i < ii; ++i) {
	      gl.attachShader(program, shaders[i]);
	    }
	    gl.linkProgram(program);
	    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
	    if (!linked) {
	      var errorMsg = gl.getProgramInfoLog(program);
	      throw new Error('Error during program linking: ' + errorMsg);
	    }
	    return program;
	  }
	  function createTexture(gl, image, textureId) {
	    gl.activeTexture(textureId);
	    var texture = gl.createTexture();
	    gl.bindTexture(gl.TEXTURE_2D, texture);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
	    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
	    return texture;
	  }
	  var currentGL, currentCanvas;
	  function generateGL() {
	    if (currentGL) {
	      return;
	    }
	    currentCanvas = document.createElement('canvas');
	    currentGL = currentCanvas.getContext('webgl', { premultipliedalpha: false });
	  }
	  var smaskVertexShaderCode = '\
	  attribute vec2 a_position;                                    \
	  attribute vec2 a_texCoord;                                    \
	                                                                \
	  uniform vec2 u_resolution;                                    \
	                                                                \
	  varying vec2 v_texCoord;                                      \
	                                                                \
	  void main() {                                                 \
	    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
	                                                                \
	    v_texCoord = a_texCoord;                                    \
	  }                                                             ';
	  var smaskFragmentShaderCode = '\
	  precision mediump float;                                      \
	                                                                \
	  uniform vec4 u_backdrop;                                      \
	  uniform int u_subtype;                                        \
	  uniform sampler2D u_image;                                    \
	  uniform sampler2D u_mask;                                     \
	                                                                \
	  varying vec2 v_texCoord;                                      \
	                                                                \
	  void main() {                                                 \
	    vec4 imageColor = texture2D(u_image, v_texCoord);           \
	    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
	    if (u_backdrop.a > 0.0) {                                   \
	      maskColor.rgb = maskColor.rgb * maskColor.a +             \
	                      u_backdrop.rgb * (1.0 - maskColor.a);     \
	    }                                                           \
	    float lum;                                                  \
	    if (u_subtype == 0) {                                       \
	      lum = maskColor.a;                                        \
	    } else {                                                    \
	      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
	            maskColor.b * 0.11;                                 \
	    }                                                           \
	    imageColor.a *= lum;                                        \
	    imageColor.rgb *= imageColor.a;                             \
	    gl_FragColor = imageColor;                                  \
	  }                                                             ';
	  var smaskCache = null;
	  function initSmaskGL() {
	    var canvas, gl;
	    generateGL();
	    canvas = currentCanvas;
	    currentCanvas = null;
	    gl = currentGL;
	    currentGL = null;
	    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
	    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
	    var program = createProgram(gl, [vertexShader, fragmentShader]);
	    gl.useProgram(program);
	    var cache = {};
	    cache.gl = gl;
	    cache.canvas = canvas;
	    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
	    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
	    cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop');
	    cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype');
	    var texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
	    var texLayerLocation = gl.getUniformLocation(program, 'u_image');
	    var texMaskLocation = gl.getUniformLocation(program, 'u_mask');
	    var texCoordBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(texCoordLocation);
	    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.uniform1i(texLayerLocation, 0);
	    gl.uniform1i(texMaskLocation, 1);
	    smaskCache = cache;
	  }
	  function composeSMask(layer, mask, properties) {
	    var width = layer.width,
	        height = layer.height;
	    if (!smaskCache) {
	      initSmaskGL();
	    }
	    var cache = smaskCache,
	        canvas = cache.canvas,
	        gl = cache.gl;
	    canvas.width = width;
	    canvas.height = height;
	    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	    gl.uniform2f(cache.resolutionLocation, width, height);
	    if (properties.backdrop) {
	      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
	    } else {
	      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
	    }
	    gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0);
	    var texture = createTexture(gl, layer, gl.TEXTURE0);
	    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
	    var buffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.positionLocation);
	    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.clearColor(0, 0, 0, 0);
	    gl.enable(gl.BLEND);
	    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
	    gl.clear(gl.COLOR_BUFFER_BIT);
	    gl.drawArrays(gl.TRIANGLES, 0, 6);
	    gl.flush();
	    gl.deleteTexture(texture);
	    gl.deleteTexture(maskTexture);
	    gl.deleteBuffer(buffer);
	    return canvas;
	  }
	  var figuresVertexShaderCode = '\
	  attribute vec2 a_position;                                    \
	  attribute vec3 a_color;                                       \
	                                                                \
	  uniform vec2 u_resolution;                                    \
	  uniform vec2 u_scale;                                         \
	  uniform vec2 u_offset;                                        \
	                                                                \
	  varying vec4 v_color;                                         \
	                                                                \
	  void main() {                                                 \
	    vec2 position = (a_position + u_offset) * u_scale;          \
	    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
	                                                                \
	    v_color = vec4(a_color / 255.0, 1.0);                       \
	  }                                                             ';
	  var figuresFragmentShaderCode = '\
	  precision mediump float;                                      \
	                                                                \
	  varying vec4 v_color;                                         \
	                                                                \
	  void main() {                                                 \
	    gl_FragColor = v_color;                                     \
	  }                                                             ';
	  var figuresCache = null;
	  function initFiguresGL() {
	    var canvas, gl;
	    generateGL();
	    canvas = currentCanvas;
	    currentCanvas = null;
	    gl = currentGL;
	    currentGL = null;
	    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
	    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
	    var program = createProgram(gl, [vertexShader, fragmentShader]);
	    gl.useProgram(program);
	    var cache = {};
	    cache.gl = gl;
	    cache.canvas = canvas;
	    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
	    cache.scaleLocation = gl.getUniformLocation(program, 'u_scale');
	    cache.offsetLocation = gl.getUniformLocation(program, 'u_offset');
	    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
	    cache.colorLocation = gl.getAttribLocation(program, 'a_color');
	    figuresCache = cache;
	  }
	  function drawFigures(width, height, backgroundColor, figures, context) {
	    if (!figuresCache) {
	      initFiguresGL();
	    }
	    var cache = figuresCache,
	        canvas = cache.canvas,
	        gl = cache.gl;
	    canvas.width = width;
	    canvas.height = height;
	    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	    gl.uniform2f(cache.resolutionLocation, width, height);
	    var count = 0;
	    var i, ii, rows;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      switch (figures[i].type) {
	        case 'lattice':
	          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
	          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
	          break;
	        case 'triangles':
	          count += figures[i].coords.length;
	          break;
	      }
	    }
	    var coords = new Float32Array(count * 2);
	    var colors = new Uint8Array(count * 3);
	    var coordsMap = context.coords,
	        colorsMap = context.colors;
	    var pIndex = 0,
	        cIndex = 0;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      var figure = figures[i],
	          ps = figure.coords,
	          cs = figure.colors;
	      switch (figure.type) {
	        case 'lattice':
	          var cols = figure.verticesPerRow;
	          rows = ps.length / cols | 0;
	          for (var row = 1; row < rows; row++) {
	            var offset = row * cols + 1;
	            for (var col = 1; col < cols; col++, offset++) {
	              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
	              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
	              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
	              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
	              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
	              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
	              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
	              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
	              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
	              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
	              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
	              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
	              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
	              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
	              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
	              coords[pIndex + 6] = coords[pIndex + 2];
	              coords[pIndex + 7] = coords[pIndex + 3];
	              coords[pIndex + 8] = coords[pIndex + 4];
	              coords[pIndex + 9] = coords[pIndex + 5];
	              coords[pIndex + 10] = coordsMap[ps[offset]];
	              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
	              colors[cIndex + 9] = colors[cIndex + 3];
	              colors[cIndex + 10] = colors[cIndex + 4];
	              colors[cIndex + 11] = colors[cIndex + 5];
	              colors[cIndex + 12] = colors[cIndex + 6];
	              colors[cIndex + 13] = colors[cIndex + 7];
	              colors[cIndex + 14] = colors[cIndex + 8];
	              colors[cIndex + 15] = colorsMap[cs[offset]];
	              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
	              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
	              pIndex += 12;
	              cIndex += 18;
	            }
	          }
	          break;
	        case 'triangles':
	          for (var j = 0, jj = ps.length; j < jj; j++) {
	            coords[pIndex] = coordsMap[ps[j]];
	            coords[pIndex + 1] = coordsMap[ps[j] + 1];
	            colors[cIndex] = colorsMap[cs[j]];
	            colors[cIndex + 1] = colorsMap[cs[j] + 1];
	            colors[cIndex + 2] = colorsMap[cs[j] + 2];
	            pIndex += 2;
	            cIndex += 3;
	          }
	          break;
	      }
	    }
	    if (backgroundColor) {
	      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
	    } else {
	      gl.clearColor(0, 0, 0, 0);
	    }
	    gl.clear(gl.COLOR_BUFFER_BIT);
	    var coordsBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.positionLocation);
	    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
	    var colorsBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.colorLocation);
	    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
	    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
	    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
	    gl.drawArrays(gl.TRIANGLES, 0, count);
	    gl.flush();
	    gl.deleteBuffer(coordsBuffer);
	    gl.deleteBuffer(colorsBuffer);
	    return canvas;
	  }
	  function cleanup() {
	    if (smaskCache && smaskCache.canvas) {
	      smaskCache.canvas.width = 0;
	      smaskCache.canvas.height = 0;
	    }
	    if (figuresCache && figuresCache.canvas) {
	      figuresCache.canvas.width = 0;
	      figuresCache.canvas.height = 0;
	    }
	    smaskCache = null;
	    figuresCache = null;
	  }
	  return {
	    get isEnabled() {
	      if ((0, _dom_utils.getDefaultSetting)('disableWebGL')) {
	        return false;
	      }
	      var enabled = false;
	      try {
	        generateGL();
	        enabled = !!currentGL;
	      } catch (e) {}
	      return (0, _util.shadow)(this, 'isEnabled', enabled);
	    },
	    composeSMask: composeSMask,
	    drawFigures: drawFigures,
	    clear: cleanup
	  };
	}();
	exports.WebGLUtils = WebGLUtils;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFJS = exports.isWorker = exports.globalScope = undefined;
	
	var _api = __w_pdfjs_require__(3);
	
	var _dom_utils = __w_pdfjs_require__(1);
	
	var _util = __w_pdfjs_require__(0);
	
	var _annotation_layer = __w_pdfjs_require__(2);
	
	var _metadata = __w_pdfjs_require__(7);
	
	var _text_layer = __w_pdfjs_require__(5);
	
	var _svg = __w_pdfjs_require__(4);
	
	var isWorker = typeof window === 'undefined';
	if (!_util.globalScope.PDFJS) {
	  _util.globalScope.PDFJS = {};
	}
	var PDFJS = _util.globalScope.PDFJS;
	{
	  PDFJS.version = '1.8.331';
	  PDFJS.build = '0dbc68a6';
	}
	PDFJS.pdfBug = false;
	if (PDFJS.verbosity !== undefined) {
	  (0, _util.setVerbosityLevel)(PDFJS.verbosity);
	}
	delete PDFJS.verbosity;
	Object.defineProperty(PDFJS, 'verbosity', {
	  get: function get() {
	    return (0, _util.getVerbosityLevel)();
	  },
	  set: function set(level) {
	    (0, _util.setVerbosityLevel)(level);
	  },
	
	  enumerable: true,
	  configurable: true
	});
	PDFJS.VERBOSITY_LEVELS = _util.VERBOSITY_LEVELS;
	PDFJS.OPS = _util.OPS;
	PDFJS.UNSUPPORTED_FEATURES = _util.UNSUPPORTED_FEATURES;
	PDFJS.isValidUrl = _dom_utils.isValidUrl;
	PDFJS.shadow = _util.shadow;
	PDFJS.createBlob = _util.createBlob;
	PDFJS.createObjectURL = function PDFJS_createObjectURL(data, contentType) {
	  return (0, _util.createObjectURL)(data, contentType, PDFJS.disableCreateObjectURL);
	};
	Object.defineProperty(PDFJS, 'isLittleEndian', {
	  configurable: true,
	  get: function PDFJS_isLittleEndian() {
	    return (0, _util.shadow)(PDFJS, 'isLittleEndian', (0, _util.isLittleEndian)());
	  }
	});
	PDFJS.removeNullCharacters = _util.removeNullCharacters;
	PDFJS.PasswordResponses = _util.PasswordResponses;
	PDFJS.PasswordException = _util.PasswordException;
	PDFJS.UnknownErrorException = _util.UnknownErrorException;
	PDFJS.InvalidPDFException = _util.InvalidPDFException;
	PDFJS.MissingPDFException = _util.MissingPDFException;
	PDFJS.UnexpectedResponseException = _util.UnexpectedResponseException;
	PDFJS.Util = _util.Util;
	PDFJS.PageViewport = _util.PageViewport;
	PDFJS.createPromiseCapability = _util.createPromiseCapability;
	PDFJS.maxImageSize = PDFJS.maxImageSize === undefined ? -1 : PDFJS.maxImageSize;
	PDFJS.cMapUrl = PDFJS.cMapUrl === undefined ? null : PDFJS.cMapUrl;
	PDFJS.cMapPacked = PDFJS.cMapPacked === undefined ? false : PDFJS.cMapPacked;
	PDFJS.disableFontFace = PDFJS.disableFontFace === undefined ? false : PDFJS.disableFontFace;
	PDFJS.imageResourcesPath = PDFJS.imageResourcesPath === undefined ? '' : PDFJS.imageResourcesPath;
	PDFJS.disableWorker = PDFJS.disableWorker === undefined ? false : PDFJS.disableWorker;
	PDFJS.workerSrc = PDFJS.workerSrc === undefined ? null : PDFJS.workerSrc;
	PDFJS.workerPort = PDFJS.workerPort === undefined ? null : PDFJS.workerPort;
	PDFJS.disableRange = PDFJS.disableRange === undefined ? false : PDFJS.disableRange;
	PDFJS.disableStream = PDFJS.disableStream === undefined ? false : PDFJS.disableStream;
	PDFJS.disableAutoFetch = PDFJS.disableAutoFetch === undefined ? false : PDFJS.disableAutoFetch;
	PDFJS.pdfBug = PDFJS.pdfBug === undefined ? false : PDFJS.pdfBug;
	PDFJS.postMessageTransfers = PDFJS.postMessageTransfers === undefined ? true : PDFJS.postMessageTransfers;
	PDFJS.disableCreateObjectURL = PDFJS.disableCreateObjectURL === undefined ? false : PDFJS.disableCreateObjectURL;
	PDFJS.disableWebGL = PDFJS.disableWebGL === undefined ? true : PDFJS.disableWebGL;
	PDFJS.externalLinkTarget = PDFJS.externalLinkTarget === undefined ? _dom_utils.LinkTarget.NONE : PDFJS.externalLinkTarget;
	PDFJS.externalLinkRel = PDFJS.externalLinkRel === undefined ? _dom_utils.DEFAULT_LINK_REL : PDFJS.externalLinkRel;
	PDFJS.isEvalSupported = PDFJS.isEvalSupported === undefined ? true : PDFJS.isEvalSupported;
	PDFJS.pdfjsNext = PDFJS.pdfjsNext === undefined ? false : PDFJS.pdfjsNext;
	{
	  var savedOpenExternalLinksInNewWindow = PDFJS.openExternalLinksInNewWindow;
	  delete PDFJS.openExternalLinksInNewWindow;
	  Object.defineProperty(PDFJS, 'openExternalLinksInNewWindow', {
	    get: function get() {
	      return PDFJS.externalLinkTarget === _dom_utils.LinkTarget.BLANK;
	    },
	    set: function set(value) {
	      if (value) {
	        (0, _util.deprecated)('PDFJS.openExternalLinksInNewWindow, please use ' + '"PDFJS.externalLinkTarget = PDFJS.LinkTarget.BLANK" instead.');
	      }
	      if (PDFJS.externalLinkTarget !== _dom_utils.LinkTarget.NONE) {
	        (0, _util.warn)('PDFJS.externalLinkTarget is already initialized');
	        return;
	      }
	      PDFJS.externalLinkTarget = value ? _dom_utils.LinkTarget.BLANK : _dom_utils.LinkTarget.NONE;
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	  if (savedOpenExternalLinksInNewWindow) {
	    PDFJS.openExternalLinksInNewWindow = savedOpenExternalLinksInNewWindow;
	  }
	}
	PDFJS.getDocument = _api.getDocument;
	PDFJS.LoopbackPort = _api.LoopbackPort;
	PDFJS.PDFDataRangeTransport = _api.PDFDataRangeTransport;
	PDFJS.PDFWorker = _api.PDFWorker;
	PDFJS.hasCanvasTypedArrays = true;
	PDFJS.CustomStyle = _dom_utils.CustomStyle;
	PDFJS.LinkTarget = _dom_utils.LinkTarget;
	PDFJS.addLinkAttributes = _dom_utils.addLinkAttributes;
	PDFJS.getFilenameFromUrl = _dom_utils.getFilenameFromUrl;
	PDFJS.isExternalLinkTargetSet = _dom_utils.isExternalLinkTargetSet;
	PDFJS.AnnotationLayer = _annotation_layer.AnnotationLayer;
	PDFJS.renderTextLayer = _text_layer.renderTextLayer;
	PDFJS.Metadata = _metadata.Metadata;
	PDFJS.SVGGraphics = _svg.SVGGraphics;
	PDFJS.UnsupportedManager = _api._UnsupportedManager;
	exports.globalScope = _util.globalScope;
	exports.isWorker = isWorker;
	exports.PDFJS = PDFJS;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CanvasGraphics = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _pattern_helper = __w_pdfjs_require__(12);
	
	var _webgl = __w_pdfjs_require__(8);
	
	var MIN_FONT_SIZE = 16;
	var MAX_FONT_SIZE = 100;
	var MAX_GROUP_SIZE = 4096;
	var MIN_WIDTH_FACTOR = 0.65;
	var COMPILE_TYPE3_GLYPHS = true;
	var MAX_SIZE_TO_COMPILE = 1000;
	var FULL_CHUNK_HEIGHT = 16;
	var IsLittleEndianCached = {
	  get value() {
	    return (0, _util.shadow)(IsLittleEndianCached, 'value', (0, _util.isLittleEndian)());
	  }
	};
	function addContextCurrentTransform(ctx) {
	  if (!ctx.mozCurrentTransform) {
	    ctx._originalSave = ctx.save;
	    ctx._originalRestore = ctx.restore;
	    ctx._originalRotate = ctx.rotate;
	    ctx._originalScale = ctx.scale;
	    ctx._originalTranslate = ctx.translate;
	    ctx._originalTransform = ctx.transform;
	    ctx._originalSetTransform = ctx.setTransform;
	    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
	    ctx._transformStack = [];
	    Object.defineProperty(ctx, 'mozCurrentTransform', {
	      get: function getCurrentTransform() {
	        return this._transformMatrix;
	      }
	    });
	    Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
	      get: function getCurrentTransformInverse() {
	        var m = this._transformMatrix;
	        var a = m[0],
	            b = m[1],
	            c = m[2],
	            d = m[3],
	            e = m[4],
	            f = m[5];
	        var ad_bc = a * d - b * c;
	        var bc_ad = b * c - a * d;
	        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
	      }
	    });
	    ctx.save = function ctxSave() {
	      var old = this._transformMatrix;
	      this._transformStack.push(old);
	      this._transformMatrix = old.slice(0, 6);
	      this._originalSave();
	    };
	    ctx.restore = function ctxRestore() {
	      var prev = this._transformStack.pop();
	      if (prev) {
	        this._transformMatrix = prev;
	        this._originalRestore();
	      }
	    };
	    ctx.translate = function ctxTranslate(x, y) {
	      var m = this._transformMatrix;
	      m[4] = m[0] * x + m[2] * y + m[4];
	      m[5] = m[1] * x + m[3] * y + m[5];
	      this._originalTranslate(x, y);
	    };
	    ctx.scale = function ctxScale(x, y) {
	      var m = this._transformMatrix;
	      m[0] = m[0] * x;
	      m[1] = m[1] * x;
	      m[2] = m[2] * y;
	      m[3] = m[3] * y;
	      this._originalScale(x, y);
	    };
	    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
	      var m = this._transformMatrix;
	      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
	      ctx._originalTransform(a, b, c, d, e, f);
	    };
	    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
	      this._transformMatrix = [a, b, c, d, e, f];
	      ctx._originalSetTransform(a, b, c, d, e, f);
	    };
	    ctx.rotate = function ctxRotate(angle) {
	      var cosValue = Math.cos(angle);
	      var sinValue = Math.sin(angle);
	      var m = this._transformMatrix;
	      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
	      this._originalRotate(angle);
	    };
	  }
	}
	var CachedCanvases = function CachedCanvasesClosure() {
	  function CachedCanvases(canvasFactory) {
	    this.canvasFactory = canvasFactory;
	    this.cache = Object.create(null);
	  }
	  CachedCanvases.prototype = {
	    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
	      var canvasEntry;
	      if (this.cache[id] !== undefined) {
	        canvasEntry = this.cache[id];
	        this.canvasFactory.reset(canvasEntry, width, height);
	        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
	      } else {
	        canvasEntry = this.canvasFactory.create(width, height);
	        this.cache[id] = canvasEntry;
	      }
	      if (trackTransform) {
	        addContextCurrentTransform(canvasEntry.context);
	      }
	      return canvasEntry;
	    },
	    clear: function clear() {
	      for (var id in this.cache) {
	        var canvasEntry = this.cache[id];
	        this.canvasFactory.destroy(canvasEntry);
	        delete this.cache[id];
	      }
	    }
	  };
	  return CachedCanvases;
	}();
	function compileType3Glyph(imgData) {
	  var POINT_TO_PROCESS_LIMIT = 1000;
	  var width = imgData.width,
	      height = imgData.height;
	  var i,
	      j,
	      j0,
	      width1 = width + 1;
	  var points = new Uint8Array(width1 * (height + 1));
	  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
	  var lineSize = width + 7 & ~7,
	      data0 = imgData.data;
	  var data = new Uint8Array(lineSize * height),
	      pos = 0,
	      ii;
	  for (i = 0, ii = data0.length; i < ii; i++) {
	    var mask = 128,
	        elem = data0[i];
	    while (mask > 0) {
	      data[pos++] = elem & mask ? 0 : 255;
	      mask >>= 1;
	    }
	  }
	  var count = 0;
	  pos = 0;
	  if (data[pos] !== 0) {
	    points[0] = 1;
	    ++count;
	  }
	  for (j = 1; j < width; j++) {
	    if (data[pos] !== data[pos + 1]) {
	      points[j] = data[pos] ? 2 : 1;
	      ++count;
	    }
	    pos++;
	  }
	  if (data[pos] !== 0) {
	    points[j] = 2;
	    ++count;
	  }
	  for (i = 1; i < height; i++) {
	    pos = i * lineSize;
	    j0 = i * width1;
	    if (data[pos - lineSize] !== data[pos]) {
	      points[j0] = data[pos] ? 1 : 8;
	      ++count;
	    }
	    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
	    for (j = 1; j < width; j++) {
	      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
	      if (POINT_TYPES[sum]) {
	        points[j0 + j] = POINT_TYPES[sum];
	        ++count;
	      }
	      pos++;
	    }
	    if (data[pos - lineSize] !== data[pos]) {
	      points[j0 + j] = data[pos] ? 2 : 4;
	      ++count;
	    }
	    if (count > POINT_TO_PROCESS_LIMIT) {
	      return null;
	    }
	  }
	  pos = lineSize * (height - 1);
	  j0 = i * width1;
	  if (data[pos] !== 0) {
	    points[j0] = 8;
	    ++count;
	  }
	  for (j = 1; j < width; j++) {
	    if (data[pos] !== data[pos + 1]) {
	      points[j0 + j] = data[pos] ? 4 : 8;
	      ++count;
	    }
	    pos++;
	  }
	  if (data[pos] !== 0) {
	    points[j0 + j] = 4;
	    ++count;
	  }
	  if (count > POINT_TO_PROCESS_LIMIT) {
	    return null;
	  }
	  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
	  var outlines = [];
	  for (i = 0; count && i <= height; i++) {
	    var p = i * width1;
	    var end = p + width;
	    while (p < end && !points[p]) {
	      p++;
	    }
	    if (p === end) {
	      continue;
	    }
	    var coords = [p % width1, i];
	    var type = points[p],
	        p0 = p,
	        pp;
	    do {
	      var step = steps[type];
	      do {
	        p += step;
	      } while (!points[p]);
	      pp = points[p];
	      if (pp !== 5 && pp !== 10) {
	        type = pp;
	        points[p] = 0;
	      } else {
	        type = pp & 0x33 * type >> 4;
	        points[p] &= type >> 2 | type << 2;
	      }
	      coords.push(p % width1);
	      coords.push(p / width1 | 0);
	      --count;
	    } while (p0 !== p);
	    outlines.push(coords);
	    --i;
	  }
	  var drawOutline = function drawOutline(c) {
	    c.save();
	    c.scale(1 / width, -1 / height);
	    c.translate(0, -height);
	    c.beginPath();
	    for (var i = 0, ii = outlines.length; i < ii; i++) {
	      var o = outlines[i];
	      c.moveTo(o[0], o[1]);
	      for (var j = 2, jj = o.length; j < jj; j += 2) {
	        c.lineTo(o[j], o[j + 1]);
	      }
	    }
	    c.fill();
	    c.beginPath();
	    c.restore();
	  };
	  return drawOutline;
	}
	var CanvasExtraState = function CanvasExtraStateClosure() {
	  function CanvasExtraState(old) {
	    this.alphaIsShape = false;
	    this.fontSize = 0;
	    this.fontSizeScale = 1;
	    this.textMatrix = _util.IDENTITY_MATRIX;
	    this.textMatrixScale = 1;
	    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	    this.leading = 0;
	    this.x = 0;
	    this.y = 0;
	    this.lineX = 0;
	    this.lineY = 0;
	    this.charSpacing = 0;
	    this.wordSpacing = 0;
	    this.textHScale = 1;
	    this.textRenderingMode = _util.TextRenderingMode.FILL;
	    this.textRise = 0;
	    this.fillColor = '#000000';
	    this.strokeColor = '#000000';
	    this.patternFill = false;
	    this.fillAlpha = 1;
	    this.strokeAlpha = 1;
	    this.lineWidth = 1;
	    this.activeSMask = null;
	    this.resumeSMaskCtx = null;
	    this.old = old;
	  }
	  CanvasExtraState.prototype = {
	    clone: function CanvasExtraState_clone() {
	      return Object.create(this);
	    },
	    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
	      this.x = x;
	      this.y = y;
	    }
	  };
	  return CanvasExtraState;
	}();
	var CanvasGraphics = function CanvasGraphicsClosure() {
	  var EXECUTION_TIME = 15;
	  var EXECUTION_STEPS = 10;
	  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, imageLayer) {
	    this.ctx = canvasCtx;
	    this.current = new CanvasExtraState();
	    this.stateStack = [];
	    this.pendingClip = null;
	    this.pendingEOFill = false;
	    this.res = null;
	    this.xobjs = null;
	    this.commonObjs = commonObjs;
	    this.objs = objs;
	    this.canvasFactory = canvasFactory;
	    this.imageLayer = imageLayer;
	    this.groupStack = [];
	    this.processingType3 = null;
	    this.baseTransform = null;
	    this.baseTransformStack = [];
	    this.groupLevel = 0;
	    this.smaskStack = [];
	    this.smaskCounter = 0;
	    this.tempSMask = null;
	    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
	    if (canvasCtx) {
	      addContextCurrentTransform(canvasCtx);
	    }
	    this.cachedGetSinglePixelWidth = null;
	  }
	  function putBinaryImageData(ctx, imgData) {
	    if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
	      ctx.putImageData(imgData, 0, 0);
	      return;
	    }
	    var height = imgData.height,
	        width = imgData.width;
	    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
	    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
	    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
	    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
	    var srcPos = 0,
	        destPos;
	    var src = imgData.data;
	    var dest = chunkImgData.data;
	    var i, j, thisChunkHeight, elemsInThisChunk;
	    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
	      var srcLength = src.byteLength;
	      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
	      var dest32DataLength = dest32.length;
	      var fullSrcDiff = width + 7 >> 3;
	      var white = 0xFFFFFFFF;
	      var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;
	      for (i = 0; i < totalChunks; i++) {
	        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
	        destPos = 0;
	        for (j = 0; j < thisChunkHeight; j++) {
	          var srcDiff = srcLength - srcPos;
	          var k = 0;
	          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
	          var kEndUnrolled = kEnd & ~7;
	          var mask = 0;
	          var srcByte = 0;
	          for (; k < kEndUnrolled; k += 8) {
	            srcByte = src[srcPos++];
	            dest32[destPos++] = srcByte & 128 ? white : black;
	            dest32[destPos++] = srcByte & 64 ? white : black;
	            dest32[destPos++] = srcByte & 32 ? white : black;
	            dest32[destPos++] = srcByte & 16 ? white : black;
	            dest32[destPos++] = srcByte & 8 ? white : black;
	            dest32[destPos++] = srcByte & 4 ? white : black;
	            dest32[destPos++] = srcByte & 2 ? white : black;
	            dest32[destPos++] = srcByte & 1 ? white : black;
	          }
	          for (; k < kEnd; k++) {
	            if (mask === 0) {
	              srcByte = src[srcPos++];
	              mask = 128;
	            }
	            dest32[destPos++] = srcByte & mask ? white : black;
	            mask >>= 1;
	          }
	        }
	        while (destPos < dest32DataLength) {
	          dest32[destPos++] = 0;
	        }
	        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	      }
	    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
	      j = 0;
	      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
	      for (i = 0; i < fullChunks; i++) {
	        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
	        srcPos += elemsInThisChunk;
	        ctx.putImageData(chunkImgData, 0, j);
	        j += FULL_CHUNK_HEIGHT;
	      }
	      if (i < totalChunks) {
	        elemsInThisChunk = width * partialChunkHeight * 4;
	        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
	        ctx.putImageData(chunkImgData, 0, j);
	      }
	    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
	      thisChunkHeight = FULL_CHUNK_HEIGHT;
	      elemsInThisChunk = width * thisChunkHeight;
	      for (i = 0; i < totalChunks; i++) {
	        if (i >= fullChunks) {
	          thisChunkHeight = partialChunkHeight;
	          elemsInThisChunk = width * thisChunkHeight;
	        }
	        destPos = 0;
	        for (j = elemsInThisChunk; j--;) {
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = 255;
	        }
	        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	      }
	    } else {
	      (0, _util.error)('bad image kind: ' + imgData.kind);
	    }
	  }
	  function putBinaryImageMask(ctx, imgData) {
	    var height = imgData.height,
	        width = imgData.width;
	    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
	    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
	    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
	    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
	    var srcPos = 0;
	    var src = imgData.data;
	    var dest = chunkImgData.data;
	    for (var i = 0; i < totalChunks; i++) {
	      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
	      var destPos = 3;
	      for (var j = 0; j < thisChunkHeight; j++) {
	        var mask = 0;
	        for (var k = 0; k < width; k++) {
	          if (!mask) {
	            var elem = src[srcPos++];
	            mask = 128;
	          }
	          dest[destPos] = elem & mask ? 0 : 255;
	          destPos += 4;
	          mask >>= 1;
	        }
	      }
	      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	    }
	  }
	  function copyCtxState(sourceCtx, destCtx) {
	    var properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font'];
	    for (var i = 0, ii = properties.length; i < ii; i++) {
	      var property = properties[i];
	      if (sourceCtx[property] !== undefined) {
	        destCtx[property] = sourceCtx[property];
	      }
	    }
	    if (sourceCtx.setLineDash !== undefined) {
	      destCtx.setLineDash(sourceCtx.getLineDash());
	      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
	    }
	  }
	  function composeSMaskBackdrop(bytes, r0, g0, b0) {
	    var length = bytes.length;
	    for (var i = 3; i < length; i += 4) {
	      var alpha = bytes[i];
	      if (alpha === 0) {
	        bytes[i - 3] = r0;
	        bytes[i - 2] = g0;
	        bytes[i - 1] = b0;
	      } else if (alpha < 255) {
	        var alpha_ = 255 - alpha;
	        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
	        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
	        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
	      }
	    }
	  }
	  function composeSMaskAlpha(maskData, layerData, transferMap) {
	    var length = maskData.length;
	    var scale = 1 / 255;
	    for (var i = 3; i < length; i += 4) {
	      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
	      layerData[i] = layerData[i] * alpha * scale | 0;
	    }
	  }
	  function composeSMaskLuminosity(maskData, layerData, transferMap) {
	    var length = maskData.length;
	    for (var i = 3; i < length; i += 4) {
	      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
	      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
	    }
	  }
	  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
	    var hasBackdrop = !!backdrop;
	    var r0 = hasBackdrop ? backdrop[0] : 0;
	    var g0 = hasBackdrop ? backdrop[1] : 0;
	    var b0 = hasBackdrop ? backdrop[2] : 0;
	    var composeFn;
	    if (subtype === 'Luminosity') {
	      composeFn = composeSMaskLuminosity;
	    } else {
	      composeFn = composeSMaskAlpha;
	    }
	    var PIXELS_TO_PROCESS = 1048576;
	    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
	    for (var row = 0; row < height; row += chunkSize) {
	      var chunkHeight = Math.min(chunkSize, height - row);
	      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
	      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);
	      if (hasBackdrop) {
	        composeSMaskBackdrop(maskData.data, r0, g0, b0);
	      }
	      composeFn(maskData.data, layerData.data, transferMap);
	      maskCtx.putImageData(layerData, 0, row);
	    }
	  }
	  function composeSMask(ctx, smask, layerCtx) {
	    var mask = smask.canvas;
	    var maskCtx = smask.context;
	    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
	    var backdrop = smask.backdrop || null;
	    if (!smask.transferMap && _webgl.WebGLUtils.isEnabled) {
	      var composed = _webgl.WebGLUtils.composeSMask(layerCtx.canvas, mask, {
	        subtype: smask.subtype,
	        backdrop: backdrop
	      });
	      ctx.setTransform(1, 0, 0, 1, 0, 0);
	      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
	      return;
	    }
	    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
	    ctx.drawImage(mask, 0, 0);
	  }
	  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
	  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
	  var NORMAL_CLIP = {};
	  var EO_CLIP = {};
	  CanvasGraphics.prototype = {
	    beginDrawing: function CanvasGraphics_beginDrawing(transform, viewport, transparency) {
	      var width = this.ctx.canvas.width;
	      var height = this.ctx.canvas.height;
	      this.ctx.save();
	      this.ctx.fillStyle = 'rgb(255, 255, 255)';
	      this.ctx.fillRect(0, 0, width, height);
	      this.ctx.restore();
	      if (transparency) {
	        var transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true);
	        this.compositeCtx = this.ctx;
	        this.transparentCanvas = transparentCanvas.canvas;
	        this.ctx = transparentCanvas.context;
	        this.ctx.save();
	        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
	      }
	      this.ctx.save();
	      if (transform) {
	        this.ctx.transform.apply(this.ctx, transform);
	      }
	      this.ctx.transform.apply(this.ctx, viewport.transform);
	      this.baseTransform = this.ctx.mozCurrentTransform.slice();
	      if (this.imageLayer) {
	        this.imageLayer.beginLayout();
	      }
	    },
	    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
	      var argsArray = operatorList.argsArray;
	      var fnArray = operatorList.fnArray;
	      var i = executionStartIdx || 0;
	      var argsArrayLen = argsArray.length;
	      if (argsArrayLen === i) {
	        return i;
	      }
	      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function';
	      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
	      var steps = 0;
	      var commonObjs = this.commonObjs;
	      var objs = this.objs;
	      var fnId;
	      while (true) {
	        if (stepper !== undefined && i === stepper.nextBreakPoint) {
	          stepper.breakIt(i, continueCallback);
	          return i;
	        }
	        fnId = fnArray[i];
	        if (fnId !== _util.OPS.dependency) {
	          this[fnId].apply(this, argsArray[i]);
	        } else {
	          var deps = argsArray[i];
	          for (var n = 0, nn = deps.length; n < nn; n++) {
	            var depObjId = deps[n];
	            var common = depObjId[0] === 'g' && depObjId[1] === '_';
	            var objsPool = common ? commonObjs : objs;
	            if (!objsPool.isResolved(depObjId)) {
	              objsPool.get(depObjId, continueCallback);
	              return i;
	            }
	          }
	        }
	        i++;
	        if (i === argsArrayLen) {
	          return i;
	        }
	        if (chunkOperations && ++steps > EXECUTION_STEPS) {
	          if (Date.now() > endTime) {
	            continueCallback();
	            return i;
	          }
	          steps = 0;
	        }
	      }
	    },
	    endDrawing: function CanvasGraphics_endDrawing() {
	      if (this.current.activeSMask !== null) {
	        this.endSMaskGroup();
	      }
	      this.ctx.restore();
	      if (this.transparentCanvas) {
	        this.ctx = this.compositeCtx;
	        this.ctx.save();
	        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
	        this.ctx.drawImage(this.transparentCanvas, 0, 0);
	        this.ctx.restore();
	        this.transparentCanvas = null;
	      }
	      this.cachedCanvases.clear();
	      _webgl.WebGLUtils.clear();
	      if (this.imageLayer) {
	        this.imageLayer.endLayout();
	      }
	    },
	    setLineWidth: function CanvasGraphics_setLineWidth(width) {
	      this.current.lineWidth = width;
	      this.ctx.lineWidth = width;
	    },
	    setLineCap: function CanvasGraphics_setLineCap(style) {
	      this.ctx.lineCap = LINE_CAP_STYLES[style];
	    },
	    setLineJoin: function CanvasGraphics_setLineJoin(style) {
	      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
	    },
	    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
	      this.ctx.miterLimit = limit;
	    },
	    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
	      var ctx = this.ctx;
	      if (ctx.setLineDash !== undefined) {
	        ctx.setLineDash(dashArray);
	        ctx.lineDashOffset = dashPhase;
	      }
	    },
	    setRenderingIntent: function CanvasGraphics_setRenderingIntent(intent) {},
	    setFlatness: function CanvasGraphics_setFlatness(flatness) {},
	    setGState: function CanvasGraphics_setGState(states) {
	      for (var i = 0, ii = states.length; i < ii; i++) {
	        var state = states[i];
	        var key = state[0];
	        var value = state[1];
	        switch (key) {
	          case 'LW':
	            this.setLineWidth(value);
	            break;
	          case 'LC':
	            this.setLineCap(value);
	            break;
	          case 'LJ':
	            this.setLineJoin(value);
	            break;
	          case 'ML':
	            this.setMiterLimit(value);
	            break;
	          case 'D':
	            this.setDash(value[0], value[1]);
	            break;
	          case 'RI':
	            this.setRenderingIntent(value);
	            break;
	          case 'FL':
	            this.setFlatness(value);
	            break;
	          case 'Font':
	            this.setFont(value[0], value[1]);
	            break;
	          case 'CA':
	            this.current.strokeAlpha = state[1];
	            break;
	          case 'ca':
	            this.current.fillAlpha = state[1];
	            this.ctx.globalAlpha = state[1];
	            break;
	          case 'BM':
	            this.ctx.globalCompositeOperation = value;
	            break;
	          case 'SMask':
	            if (this.current.activeSMask) {
	              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
	                this.suspendSMaskGroup();
	              } else {
	                this.endSMaskGroup();
	              }
	            }
	            this.current.activeSMask = value ? this.tempSMask : null;
	            if (this.current.activeSMask) {
	              this.beginSMaskGroup();
	            }
	            this.tempSMask = null;
	            break;
	        }
	      }
	    },
	    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
	      var activeSMask = this.current.activeSMask;
	      var drawnWidth = activeSMask.canvas.width;
	      var drawnHeight = activeSMask.canvas.height;
	      var cacheId = 'smaskGroupAt' + this.groupLevel;
	      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
	      var currentCtx = this.ctx;
	      var currentTransform = currentCtx.mozCurrentTransform;
	      this.ctx.save();
	      var groupCtx = scratchCanvas.context;
	      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
	      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
	      groupCtx.transform.apply(groupCtx, currentTransform);
	      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
	      copyCtxState(currentCtx, groupCtx);
	      this.ctx = groupCtx;
	      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	    },
	    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.ctx;
	      this.groupLevel--;
	      this.ctx = this.groupStack.pop();
	      composeSMask(this.ctx, this.current.activeSMask, groupCtx);
	      this.ctx.restore();
	      this.ctx.save();
	      copyCtxState(groupCtx, this.ctx);
	      this.current.resumeSMaskCtx = groupCtx;
	      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
	      this.ctx.transform.apply(this.ctx, deltaTransform);
	      groupCtx.save();
	      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
	      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
	      groupCtx.restore();
	    },
	    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.current.resumeSMaskCtx;
	      var currentCtx = this.ctx;
	      this.ctx = groupCtx;
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	    },
	    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.ctx;
	      this.groupLevel--;
	      this.ctx = this.groupStack.pop();
	      composeSMask(this.ctx, this.current.activeSMask, groupCtx);
	      this.ctx.restore();
	      copyCtxState(groupCtx, this.ctx);
	      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
	      this.ctx.transform.apply(this.ctx, deltaTransform);
	    },
	    save: function CanvasGraphics_save() {
	      this.ctx.save();
	      var old = this.current;
	      this.stateStack.push(old);
	      this.current = old.clone();
	      this.current.resumeSMaskCtx = null;
	    },
	    restore: function CanvasGraphics_restore() {
	      if (this.current.resumeSMaskCtx) {
	        this.resumeSMaskGroup();
	      }
	      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
	        this.endSMaskGroup();
	      }
	      if (this.stateStack.length !== 0) {
	        this.current = this.stateStack.pop();
	        this.ctx.restore();
	        this.pendingClip = null;
	        this.cachedGetSinglePixelWidth = null;
	      }
	    },
	    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
	      this.ctx.transform(a, b, c, d, e, f);
	      this.cachedGetSinglePixelWidth = null;
	    },
	    constructPath: function CanvasGraphics_constructPath(ops, args) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var x = current.x,
	          y = current.y;
	      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
	        switch (ops[i] | 0) {
	          case _util.OPS.rectangle:
	            x = args[j++];
	            y = args[j++];
	            var width = args[j++];
	            var height = args[j++];
	            if (width === 0) {
	              width = this.getSinglePixelWidth();
	            }
	            if (height === 0) {
	              height = this.getSinglePixelWidth();
	            }
	            var xw = x + width;
	            var yh = y + height;
	            this.ctx.moveTo(x, y);
	            this.ctx.lineTo(xw, y);
	            this.ctx.lineTo(xw, yh);
	            this.ctx.lineTo(x, yh);
	            this.ctx.lineTo(x, y);
	            this.ctx.closePath();
	            break;
	          case _util.OPS.moveTo:
	            x = args[j++];
	            y = args[j++];
	            ctx.moveTo(x, y);
	            break;
	          case _util.OPS.lineTo:
	            x = args[j++];
	            y = args[j++];
	            ctx.lineTo(x, y);
	            break;
	          case _util.OPS.curveTo:
	            x = args[j + 4];
	            y = args[j + 5];
	            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
	            j += 6;
	            break;
	          case _util.OPS.curveTo2:
	            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
	            x = args[j + 2];
	            y = args[j + 3];
	            j += 4;
	            break;
	          case _util.OPS.curveTo3:
	            x = args[j + 2];
	            y = args[j + 3];
	            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
	            j += 4;
	            break;
	          case _util.OPS.closePath:
	            ctx.closePath();
	            break;
	        }
	      }
	      current.setCurrentPoint(x, y);
	    },
	    closePath: function CanvasGraphics_closePath() {
	      this.ctx.closePath();
	    },
	    stroke: function CanvasGraphics_stroke(consumePath) {
	      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
	      var ctx = this.ctx;
	      var strokeColor = this.current.strokeColor;
	      ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
	      ctx.globalAlpha = this.current.strokeAlpha;
	      if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
	        ctx.save();
	        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
	        ctx.stroke();
	        ctx.restore();
	      } else {
	        ctx.stroke();
	      }
	      if (consumePath) {
	        this.consumePath();
	      }
	      ctx.globalAlpha = this.current.fillAlpha;
	    },
	    closeStroke: function CanvasGraphics_closeStroke() {
	      this.closePath();
	      this.stroke();
	    },
	    fill: function CanvasGraphics_fill(consumePath) {
	      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
	      var ctx = this.ctx;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var needRestore = false;
	      if (isPatternFill) {
	        ctx.save();
	        if (this.baseTransform) {
	          ctx.setTransform.apply(ctx, this.baseTransform);
	        }
	        ctx.fillStyle = fillColor.getPattern(ctx, this);
	        needRestore = true;
	      }
	      if (this.pendingEOFill) {
	        ctx.fill('evenodd');
	        this.pendingEOFill = false;
	      } else {
	        ctx.fill();
	      }
	      if (needRestore) {
	        ctx.restore();
	      }
	      if (consumePath) {
	        this.consumePath();
	      }
	    },
	    eoFill: function CanvasGraphics_eoFill() {
	      this.pendingEOFill = true;
	      this.fill();
	    },
	    fillStroke: function CanvasGraphics_fillStroke() {
	      this.fill(false);
	      this.stroke(false);
	      this.consumePath();
	    },
	    eoFillStroke: function CanvasGraphics_eoFillStroke() {
	      this.pendingEOFill = true;
	      this.fillStroke();
	    },
	    closeFillStroke: function CanvasGraphics_closeFillStroke() {
	      this.closePath();
	      this.fillStroke();
	    },
	    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
	      this.pendingEOFill = true;
	      this.closePath();
	      this.fillStroke();
	    },
	    endPath: function CanvasGraphics_endPath() {
	      this.consumePath();
	    },
	    clip: function CanvasGraphics_clip() {
	      this.pendingClip = NORMAL_CLIP;
	    },
	    eoClip: function CanvasGraphics_eoClip() {
	      this.pendingClip = EO_CLIP;
	    },
	    beginText: function CanvasGraphics_beginText() {
	      this.current.textMatrix = _util.IDENTITY_MATRIX;
	      this.current.textMatrixScale = 1;
	      this.current.x = this.current.lineX = 0;
	      this.current.y = this.current.lineY = 0;
	    },
	    endText: function CanvasGraphics_endText() {
	      var paths = this.pendingTextPaths;
	      var ctx = this.ctx;
	      if (paths === undefined) {
	        ctx.beginPath();
	        return;
	      }
	      ctx.save();
	      ctx.beginPath();
	      for (var i = 0; i < paths.length; i++) {
	        var path = paths[i];
	        ctx.setTransform.apply(ctx, path.transform);
	        ctx.translate(path.x, path.y);
	        path.addToPath(ctx, path.fontSize);
	      }
	      ctx.restore();
	      ctx.clip();
	      ctx.beginPath();
	      delete this.pendingTextPaths;
	    },
	    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
	      this.current.charSpacing = spacing;
	    },
	    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
	      this.current.wordSpacing = spacing;
	    },
	    setHScale: function CanvasGraphics_setHScale(scale) {
	      this.current.textHScale = scale / 100;
	    },
	    setLeading: function CanvasGraphics_setLeading(leading) {
	      this.current.leading = -leading;
	    },
	    setFont: function CanvasGraphics_setFont(fontRefName, size) {
	      var fontObj = this.commonObjs.get(fontRefName);
	      var current = this.current;
	      if (!fontObj) {
	        (0, _util.error)('Can\'t find font for ' + fontRefName);
	      }
	      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
	      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
	        (0, _util.warn)('Invalid font matrix for font ' + fontRefName);
	      }
	      if (size < 0) {
	        size = -size;
	        current.fontDirection = -1;
	      } else {
	        current.fontDirection = 1;
	      }
	      this.current.font = fontObj;
	      this.current.fontSize = size;
	      if (fontObj.isType3Font) {
	        return;
	      }
	      var name = fontObj.loadedName || 'sans-serif';
	      var bold = fontObj.black ? '900' : fontObj.bold ? 'bold' : 'normal';
	      var italic = fontObj.italic ? 'italic' : 'normal';
	      var typeface = '"' + name + '", ' + fontObj.fallbackName;
	      var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
	      this.current.fontSizeScale = size / browserFontSize;
	      var rule = italic + ' ' + bold + ' ' + browserFontSize + 'px ' + typeface;
	      this.ctx.font = rule;
	    },
	    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
	      this.current.textRenderingMode = mode;
	    },
	    setTextRise: function CanvasGraphics_setTextRise(rise) {
	      this.current.textRise = rise;
	    },
	    moveText: function CanvasGraphics_moveText(x, y) {
	      this.current.x = this.current.lineX += x;
	      this.current.y = this.current.lineY += y;
	    },
	    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
	      this.setLeading(-y);
	      this.moveText(x, y);
	    },
	    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
	      this.current.textMatrix = [a, b, c, d, e, f];
	      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
	      this.current.x = this.current.lineX = 0;
	      this.current.y = this.current.lineY = 0;
	    },
	    nextLine: function CanvasGraphics_nextLine() {
	      this.moveText(0, this.current.leading);
	    },
	    paintChar: function CanvasGraphics_paintChar(character, x, y) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var font = current.font;
	      var textRenderingMode = current.textRenderingMode;
	      var fontSize = current.fontSize / current.fontSizeScale;
	      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
	      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
	      var addToPath;
	      if (font.disableFontFace || isAddToPathSet) {
	        addToPath = font.getPathGenerator(this.commonObjs, character);
	      }
	      if (font.disableFontFace) {
	        ctx.save();
	        ctx.translate(x, y);
	        ctx.beginPath();
	        addToPath(ctx, fontSize);
	        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.fill();
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.stroke();
	        }
	        ctx.restore();
	      } else {
	        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.fillText(character, x, y);
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.strokeText(character, x, y);
	        }
	      }
	      if (isAddToPathSet) {
	        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
	        paths.push({
	          transform: ctx.mozCurrentTransform,
	          x: x,
	          y: y,
	          fontSize: fontSize,
	          addToPath: addToPath
	        });
	      }
	    },
	    get isFontSubpixelAAEnabled() {
	      var ctx = this.canvasFactory.create(10, 10).context;
	      ctx.scale(1.5, 1);
	      ctx.fillText('I', 0, 10);
	      var data = ctx.getImageData(0, 0, 10, 10).data;
	      var enabled = false;
	      for (var i = 3; i < data.length; i += 4) {
	        if (data[i] > 0 && data[i] < 255) {
	          enabled = true;
	          break;
	        }
	      }
	      return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled);
	    },
	    showText: function CanvasGraphics_showText(glyphs) {
	      var current = this.current;
	      var font = current.font;
	      if (font.isType3Font) {
	        return this.showType3Text(glyphs);
	      }
	      var fontSize = current.fontSize;
	      if (fontSize === 0) {
	        return;
	      }
	      var ctx = this.ctx;
	      var fontSizeScale = current.fontSizeScale;
	      var charSpacing = current.charSpacing;
	      var wordSpacing = current.wordSpacing;
	      var fontDirection = current.fontDirection;
	      var textHScale = current.textHScale * fontDirection;
	      var glyphsLength = glyphs.length;
	      var vertical = font.vertical;
	      var spacingDir = vertical ? 1 : -1;
	      var defaultVMetrics = font.defaultVMetrics;
	      var widthAdvanceScale = fontSize * current.fontMatrix[0];
	      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace;
	      ctx.save();
	      ctx.transform.apply(ctx, current.textMatrix);
	      ctx.translate(current.x, current.y + current.textRise);
	      if (current.patternFill) {
	        ctx.fillStyle = current.fillColor.getPattern(ctx, this);
	      }
	      if (fontDirection > 0) {
	        ctx.scale(textHScale, -1);
	      } else {
	        ctx.scale(textHScale, 1);
	      }
	      var lineWidth = current.lineWidth;
	      var scale = current.textMatrixScale;
	      if (scale === 0 || lineWidth === 0) {
	        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          this.cachedGetSinglePixelWidth = null;
	          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
	        }
	      } else {
	        lineWidth /= scale;
	      }
	      if (fontSizeScale !== 1.0) {
	        ctx.scale(fontSizeScale, fontSizeScale);
	        lineWidth /= fontSizeScale;
	      }
	      ctx.lineWidth = lineWidth;
	      var x = 0,
	          i;
	      for (i = 0; i < glyphsLength; ++i) {
	        var glyph = glyphs[i];
	        if ((0, _util.isNum)(glyph)) {
	          x += spacingDir * glyph * fontSize / 1000;
	          continue;
	        }
	        var restoreNeeded = false;
	        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	        var character = glyph.fontChar;
	        var accent = glyph.accent;
	        var scaledX, scaledY, scaledAccentX, scaledAccentY;
	        var width = glyph.width;
	        if (vertical) {
	          var vmetric, vx, vy;
	          vmetric = glyph.vmetric || defaultVMetrics;
	          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
	          vx = -vx * widthAdvanceScale;
	          vy = vmetric[2] * widthAdvanceScale;
	          width = vmetric ? -vmetric[0] : width;
	          scaledX = vx / fontSizeScale;
	          scaledY = (x + vy) / fontSizeScale;
	        } else {
	          scaledX = x / fontSizeScale;
	          scaledY = 0;
	        }
	        if (font.remeasure && width > 0) {
	          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
	          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
	            var characterScaleX = width / measuredWidth;
	            restoreNeeded = true;
	            ctx.save();
	            ctx.scale(characterScaleX, 1);
	            scaledX /= characterScaleX;
	          } else if (width !== measuredWidth) {
	            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
	          }
	        }
	        if (glyph.isInFont || font.missingFile) {
	          if (simpleFillText && !accent) {
	            ctx.fillText(character, scaledX, scaledY);
	          } else {
	            this.paintChar(character, scaledX, scaledY);
	            if (accent) {
	              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
	              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
	              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY);
	            }
	          }
	        }
	        var charWidth = width * widthAdvanceScale + spacing * fontDirection;
	        x += charWidth;
	        if (restoreNeeded) {
	          ctx.restore();
	        }
	      }
	      if (vertical) {
	        current.y -= x * textHScale;
	      } else {
	        current.x += x * textHScale;
	      }
	      ctx.restore();
	    },
	    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var font = current.font;
	      var fontSize = current.fontSize;
	      var fontDirection = current.fontDirection;
	      var spacingDir = font.vertical ? 1 : -1;
	      var charSpacing = current.charSpacing;
	      var wordSpacing = current.wordSpacing;
	      var textHScale = current.textHScale * fontDirection;
	      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
	      var glyphsLength = glyphs.length;
	      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
	      var i, glyph, width, spacingLength;
	      if (isTextInvisible || fontSize === 0) {
	        return;
	      }
	      this.cachedGetSinglePixelWidth = null;
	      ctx.save();
	      ctx.transform.apply(ctx, current.textMatrix);
	      ctx.translate(current.x, current.y);
	      ctx.scale(textHScale, fontDirection);
	      for (i = 0; i < glyphsLength; ++i) {
	        glyph = glyphs[i];
	        if ((0, _util.isNum)(glyph)) {
	          spacingLength = spacingDir * glyph * fontSize / 1000;
	          this.ctx.translate(spacingLength, 0);
	          current.x += spacingLength * textHScale;
	          continue;
	        }
	        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	        var operatorList = font.charProcOperatorList[glyph.operatorListId];
	        if (!operatorList) {
	          (0, _util.warn)('Type3 character "' + glyph.operatorListId + '" is not available.');
	          continue;
	        }
	        this.processingType3 = glyph;
	        this.save();
	        ctx.scale(fontSize, fontSize);
	        ctx.transform.apply(ctx, fontMatrix);
	        this.executeOperatorList(operatorList);
	        this.restore();
	        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
	        width = transformed[0] * fontSize + spacing;
	        ctx.translate(width, 0);
	        current.x += width * textHScale;
	      }
	      ctx.restore();
	      this.processingType3 = null;
	    },
	    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
	    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
	      this.ctx.rect(llx, lly, urx - llx, ury - lly);
	      this.clip();
	      this.endPath();
	    },
	    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
	      var _this = this;
	
	      var pattern;
	      if (IR[0] === 'TilingPattern') {
	        var color = IR[1];
	        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
	        var canvasGraphicsFactory = {
	          createCanvasGraphics: function createCanvasGraphics(ctx) {
	            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory);
	          }
	        };
	        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
	      } else {
	        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
	      }
	      return pattern;
	    },
	    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
	      this.current.strokeColor = this.getColorN_Pattern(arguments);
	    },
	    setFillColorN: function CanvasGraphics_setFillColorN() {
	      this.current.fillColor = this.getColorN_Pattern(arguments);
	      this.current.patternFill = true;
	    },
	    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
	      var color = _util.Util.makeCssRgb(r, g, b);
	      this.ctx.strokeStyle = color;
	      this.current.strokeColor = color;
	    },
	    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
	      var color = _util.Util.makeCssRgb(r, g, b);
	      this.ctx.fillStyle = color;
	      this.current.fillColor = color;
	      this.current.patternFill = false;
	    },
	    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
	      var ctx = this.ctx;
	      this.save();
	      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
	      ctx.fillStyle = pattern.getPattern(ctx, this, true);
	      var inv = ctx.mozCurrentTransformInverse;
	      if (inv) {
	        var canvas = ctx.canvas;
	        var width = canvas.width;
	        var height = canvas.height;
	        var bl = _util.Util.applyTransform([0, 0], inv);
	        var br = _util.Util.applyTransform([0, height], inv);
	        var ul = _util.Util.applyTransform([width, 0], inv);
	        var ur = _util.Util.applyTransform([width, height], inv);
	        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
	        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
	        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
	        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
	        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
	      } else {
	        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
	      }
	      this.restore();
	    },
	    beginInlineImage: function CanvasGraphics_beginInlineImage() {
	      (0, _util.error)('Should not call beginInlineImage');
	    },
	    beginImageData: function CanvasGraphics_beginImageData() {
	      (0, _util.error)('Should not call beginImageData');
	    },
	    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
	      this.save();
	      this.baseTransformStack.push(this.baseTransform);
	      if ((0, _util.isArray)(matrix) && matrix.length === 6) {
	        this.transform.apply(this, matrix);
	      }
	      this.baseTransform = this.ctx.mozCurrentTransform;
	      if ((0, _util.isArray)(bbox) && bbox.length === 4) {
	        var width = bbox[2] - bbox[0];
	        var height = bbox[3] - bbox[1];
	        this.ctx.rect(bbox[0], bbox[1], width, height);
	        this.clip();
	        this.endPath();
	      }
	    },
	    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
	      this.restore();
	      this.baseTransform = this.baseTransformStack.pop();
	    },
	    beginGroup: function CanvasGraphics_beginGroup(group) {
	      this.save();
	      var currentCtx = this.ctx;
	      if (!group.isolated) {
	        (0, _util.info)('TODO: Support non-isolated groups.');
	      }
	      if (group.knockout) {
	        (0, _util.warn)('Knockout groups not supported.');
	      }
	      var currentTransform = currentCtx.mozCurrentTransform;
	      if (group.matrix) {
	        currentCtx.transform.apply(currentCtx, group.matrix);
	      }
	      (0, _util.assert)(group.bbox, 'Bounding box is required.');
	      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
	      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
	      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
	      var offsetX = Math.floor(bounds[0]);
	      var offsetY = Math.floor(bounds[1]);
	      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
	      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
	      var scaleX = 1,
	          scaleY = 1;
	      if (drawnWidth > MAX_GROUP_SIZE) {
	        scaleX = drawnWidth / MAX_GROUP_SIZE;
	        drawnWidth = MAX_GROUP_SIZE;
	      }
	      if (drawnHeight > MAX_GROUP_SIZE) {
	        scaleY = drawnHeight / MAX_GROUP_SIZE;
	        drawnHeight = MAX_GROUP_SIZE;
	      }
	      var cacheId = 'groupAt' + this.groupLevel;
	      if (group.smask) {
	        cacheId += '_smask_' + this.smaskCounter++ % 2;
	      }
	      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
	      var groupCtx = scratchCanvas.context;
	      groupCtx.scale(1 / scaleX, 1 / scaleY);
	      groupCtx.translate(-offsetX, -offsetY);
	      groupCtx.transform.apply(groupCtx, currentTransform);
	      if (group.smask) {
	        this.smaskStack.push({
	          canvas: scratchCanvas.canvas,
	          context: groupCtx,
	          offsetX: offsetX,
	          offsetY: offsetY,
	          scaleX: scaleX,
	          scaleY: scaleY,
	          subtype: group.smask.subtype,
	          backdrop: group.smask.backdrop,
	          transferMap: group.smask.transferMap || null,
	          startTransformInverse: null
	        });
	      } else {
	        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
	        currentCtx.translate(offsetX, offsetY);
	        currentCtx.scale(scaleX, scaleY);
	      }
	      copyCtxState(currentCtx, groupCtx);
	      this.ctx = groupCtx;
	      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	      this.current.activeSMask = null;
	    },
	    endGroup: function CanvasGraphics_endGroup(group) {
	      this.groupLevel--;
	      var groupCtx = this.ctx;
	      this.ctx = this.groupStack.pop();
	      if (this.ctx.imageSmoothingEnabled !== undefined) {
	        this.ctx.imageSmoothingEnabled = false;
	      } else {
	        this.ctx.mozImageSmoothingEnabled = false;
	      }
	      if (group.smask) {
	        this.tempSMask = this.smaskStack.pop();
	      } else {
	        this.ctx.drawImage(groupCtx.canvas, 0, 0);
	      }
	      this.restore();
	    },
	    beginAnnotations: function CanvasGraphics_beginAnnotations() {
	      this.save();
	      this.current = new CanvasExtraState();
	      if (this.baseTransform) {
	        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
	      }
	    },
	    endAnnotations: function CanvasGraphics_endAnnotations() {
	      this.restore();
	    },
	    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
	      this.save();
	      if ((0, _util.isArray)(rect) && rect.length === 4) {
	        var width = rect[2] - rect[0];
	        var height = rect[3] - rect[1];
	        this.ctx.rect(rect[0], rect[1], width, height);
	        this.clip();
	        this.endPath();
	      }
	      this.transform.apply(this, transform);
	      this.transform.apply(this, matrix);
	    },
	    endAnnotation: function CanvasGraphics_endAnnotation() {
	      this.restore();
	    },
	    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
	      var domImage = this.objs.get(objId);
	      if (!domImage) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      this.save();
	      var ctx = this.ctx;
	      ctx.scale(1 / w, -1 / h);
	      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);
	      if (this.imageLayer) {
	        var currentTransform = ctx.mozCurrentTransformInverse;
	        var position = this.getCanvasPosition(0, 0);
	        this.imageLayer.appendImage({
	          objId: objId,
	          left: position[0],
	          top: position[1],
	          width: w / currentTransform[0],
	          height: h / currentTransform[3]
	        });
	      }
	      this.restore();
	    },
	    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
	      var ctx = this.ctx;
	      var width = img.width,
	          height = img.height;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var glyph = this.processingType3;
	      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
	        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
	          glyph.compiled = compileType3Glyph({
	            data: img.data,
	            width: width,
	            height: height
	          });
	        } else {
	          glyph.compiled = null;
	        }
	      }
	      if (glyph && glyph.compiled) {
	        glyph.compiled(ctx);
	        return;
	      }
	      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	      var maskCtx = maskCanvas.context;
	      maskCtx.save();
	      putBinaryImageMask(maskCtx, img);
	      maskCtx.globalCompositeOperation = 'source-in';
	      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	      maskCtx.fillRect(0, 0, width, height);
	      maskCtx.restore();
	      this.paintInlineImageXObject(maskCanvas.canvas);
	    },
	    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	      var maskCtx = maskCanvas.context;
	      maskCtx.save();
	      putBinaryImageMask(maskCtx, imgData);
	      maskCtx.globalCompositeOperation = 'source-in';
	      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	      maskCtx.fillRect(0, 0, width, height);
	      maskCtx.restore();
	      var ctx = this.ctx;
	      for (var i = 0, ii = positions.length; i < ii; i += 2) {
	        ctx.save();
	        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
	        ctx.scale(1, -1);
	        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
	        ctx.restore();
	      }
	    },
	    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
	      var ctx = this.ctx;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      for (var i = 0, ii = images.length; i < ii; i++) {
	        var image = images[i];
	        var width = image.width,
	            height = image.height;
	        var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	        var maskCtx = maskCanvas.context;
	        maskCtx.save();
	        putBinaryImageMask(maskCtx, image);
	        maskCtx.globalCompositeOperation = 'source-in';
	        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	        maskCtx.fillRect(0, 0, width, height);
	        maskCtx.restore();
	        ctx.save();
	        ctx.transform.apply(ctx, image.transform);
	        ctx.scale(1, -1);
	        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
	        ctx.restore();
	      }
	    },
	    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
	      var imgData = this.objs.get(objId);
	      if (!imgData) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      this.paintInlineImageXObject(imgData);
	    },
	    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
	      var imgData = this.objs.get(objId);
	      if (!imgData) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      var width = imgData.width;
	      var height = imgData.height;
	      var map = [];
	      for (var i = 0, ii = positions.length; i < ii; i += 2) {
	        map.push({
	          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
	          x: 0,
	          y: 0,
	          w: width,
	          h: height
	        });
	      }
	      this.paintInlineImageXObjectGroup(imgData, map);
	    },
	    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var ctx = this.ctx;
	      this.save();
	      ctx.scale(1 / width, -1 / height);
	      var currentTransform = ctx.mozCurrentTransformInverse;
	      var a = currentTransform[0],
	          b = currentTransform[1];
	      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
	      var c = currentTransform[2],
	          d = currentTransform[3];
	      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
	      var imgToPaint, tmpCanvas;
	      if (imgData instanceof HTMLElement || !imgData.data) {
	        imgToPaint = imgData;
	      } else {
	        tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height);
	        var tmpCtx = tmpCanvas.context;
	        putBinaryImageData(tmpCtx, imgData);
	        imgToPaint = tmpCanvas.canvas;
	      }
	      var paintWidth = width,
	          paintHeight = height;
	      var tmpCanvasId = 'prescale1';
	      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
	        var newWidth = paintWidth,
	            newHeight = paintHeight;
	        if (widthScale > 2 && paintWidth > 1) {
	          newWidth = Math.ceil(paintWidth / 2);
	          widthScale /= paintWidth / newWidth;
	        }
	        if (heightScale > 2 && paintHeight > 1) {
	          newHeight = Math.ceil(paintHeight / 2);
	          heightScale /= paintHeight / newHeight;
	        }
	        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
	        tmpCtx = tmpCanvas.context;
	        tmpCtx.clearRect(0, 0, newWidth, newHeight);
	        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
	        imgToPaint = tmpCanvas.canvas;
	        paintWidth = newWidth;
	        paintHeight = newHeight;
	        tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1';
	      }
	      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);
	      if (this.imageLayer) {
	        var position = this.getCanvasPosition(0, -height);
	        this.imageLayer.appendImage({
	          imgData: imgData,
	          left: position[0],
	          top: position[1],
	          width: width / currentTransform[0],
	          height: height / currentTransform[3]
	        });
	      }
	      this.restore();
	    },
	    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
	      var ctx = this.ctx;
	      var w = imgData.width;
	      var h = imgData.height;
	      var tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h);
	      var tmpCtx = tmpCanvas.context;
	      putBinaryImageData(tmpCtx, imgData);
	      for (var i = 0, ii = map.length; i < ii; i++) {
	        var entry = map[i];
	        ctx.save();
	        ctx.transform.apply(ctx, entry.transform);
	        ctx.scale(1, -1);
	        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
	        if (this.imageLayer) {
	          var position = this.getCanvasPosition(entry.x, entry.y);
	          this.imageLayer.appendImage({
	            imgData: imgData,
	            left: position[0],
	            top: position[1],
	            width: w,
	            height: h
	          });
	        }
	        ctx.restore();
	      }
	    },
	    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
	      this.ctx.fillRect(0, 0, 1, 1);
	    },
	    paintXObject: function CanvasGraphics_paintXObject() {
	      (0, _util.warn)('Unsupported \'paintXObject\' command.');
	    },
	    markPoint: function CanvasGraphics_markPoint(tag) {},
	    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
	    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
	    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
	    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
	    beginCompat: function CanvasGraphics_beginCompat() {},
	    endCompat: function CanvasGraphics_endCompat() {},
	    consumePath: function CanvasGraphics_consumePath() {
	      var ctx = this.ctx;
	      if (this.pendingClip) {
	        if (this.pendingClip === EO_CLIP) {
	          ctx.clip('evenodd');
	        } else {
	          ctx.clip();
	        }
	        this.pendingClip = null;
	      }
	      ctx.beginPath();
	    },
	    getSinglePixelWidth: function CanvasGraphics_getSinglePixelWidth(scale) {
	      if (this.cachedGetSinglePixelWidth === null) {
	        this.ctx.save();
	        var inverse = this.ctx.mozCurrentTransformInverse;
	        this.ctx.restore();
	        this.cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
	      }
	      return this.cachedGetSinglePixelWidth;
	    },
	    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
	      var transform = this.ctx.mozCurrentTransform;
	      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
	    }
	  };
	  for (var op in _util.OPS) {
	    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
	  }
	  return CanvasGraphics;
	}();
	exports.CanvasGraphics = CanvasGraphics;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontLoader = exports.FontFaceObject = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	function FontLoader(docId) {
	  this.docId = docId;
	  this.styleElement = null;
	  this.nativeFontFaces = [];
	  this.loadTestFontId = 0;
	  this.loadingContext = {
	    requests: [],
	    nextRequestId: 0
	  };
	}
	FontLoader.prototype = {
	  insertRule: function fontLoaderInsertRule(rule) {
	    var styleElement = this.styleElement;
	    if (!styleElement) {
	      styleElement = this.styleElement = document.createElement('style');
	      styleElement.id = 'PDFJS_FONT_STYLE_TAG_' + this.docId;
	      document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement);
	    }
	    var styleSheet = styleElement.sheet;
	    styleSheet.insertRule(rule, styleSheet.cssRules.length);
	  },
	  clear: function fontLoaderClear() {
	    if (this.styleElement) {
	      this.styleElement.remove();
	      this.styleElement = null;
	    }
	    this.nativeFontFaces.forEach(function (nativeFontFace) {
	      document.fonts.delete(nativeFontFace);
	    });
	    this.nativeFontFaces.length = 0;
	  }
	};
	{
	  var getLoadTestFont = function getLoadTestFont() {
	    return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQ' + 'AABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwA' + 'AAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbm' + 'FtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAA' + 'AADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6A' + 'ABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAA' + 'MQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAA' + 'AAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAA' + 'AAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQ' + 'AAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMA' + 'AQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAA' + 'EAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAA' + 'AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAA' + 'AAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgc' + 'A/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWF' + 'hYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQA' + 'AAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAg' + 'ABAAAAAAAAAAAD6AAAAAAAAA==');
	  };
	  Object.defineProperty(FontLoader.prototype, 'loadTestFont', {
	    get: function get() {
	      return (0, _util.shadow)(this, 'loadTestFont', getLoadTestFont());
	    },
	
	    configurable: true
	  });
	  FontLoader.prototype.addNativeFontFace = function fontLoader_addNativeFontFace(nativeFontFace) {
	    this.nativeFontFaces.push(nativeFontFace);
	    document.fonts.add(nativeFontFace);
	  };
	  FontLoader.prototype.bind = function fontLoaderBind(fonts, callback) {
	    var rules = [];
	    var fontsToLoad = [];
	    var fontLoadPromises = [];
	    var getNativeFontPromise = function getNativeFontPromise(nativeFontFace) {
	      return nativeFontFace.loaded.catch(function (e) {
	        (0, _util.warn)('Failed to load font "' + nativeFontFace.family + '": ' + e);
	      });
	    };
	    var isFontLoadingAPISupported = FontLoader.isFontLoadingAPISupported && !FontLoader.isSyncFontLoadingSupported;
	    for (var i = 0, ii = fonts.length; i < ii; i++) {
	      var font = fonts[i];
	      if (font.attached || font.loading === false) {
	        continue;
	      }
	      font.attached = true;
	      if (isFontLoadingAPISupported) {
	        var nativeFontFace = font.createNativeFontFace();
	        if (nativeFontFace) {
	          this.addNativeFontFace(nativeFontFace);
	          fontLoadPromises.push(getNativeFontPromise(nativeFontFace));
	        }
	      } else {
	        var rule = font.createFontFaceRule();
	        if (rule) {
	          this.insertRule(rule);
	          rules.push(rule);
	          fontsToLoad.push(font);
	        }
	      }
	    }
	    var request = this.queueLoadingCallback(callback);
	    if (isFontLoadingAPISupported) {
	      Promise.all(fontLoadPromises).then(function () {
	        request.complete();
	      });
	    } else if (rules.length > 0 && !FontLoader.isSyncFontLoadingSupported) {
	      this.prepareFontLoadEvent(rules, fontsToLoad, request);
	    } else {
	      request.complete();
	    }
	  };
	  FontLoader.prototype.queueLoadingCallback = function FontLoader_queueLoadingCallback(callback) {
	    function LoadLoader_completeRequest() {
	      (0, _util.assert)(!request.end, 'completeRequest() cannot be called twice');
	      request.end = Date.now();
	      while (context.requests.length > 0 && context.requests[0].end) {
	        var otherRequest = context.requests.shift();
	        setTimeout(otherRequest.callback, 0);
	      }
	    }
	    var context = this.loadingContext;
	    var requestId = 'pdfjs-font-loading-' + context.nextRequestId++;
	    var request = {
	      id: requestId,
	      complete: LoadLoader_completeRequest,
	      callback: callback,
	      started: Date.now()
	    };
	    context.requests.push(request);
	    return request;
	  };
	  FontLoader.prototype.prepareFontLoadEvent = function fontLoaderPrepareFontLoadEvent(rules, fonts, request) {
	    function int32(data, offset) {
	      return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
	    }
	    function spliceString(s, offset, remove, insert) {
	      var chunk1 = s.substr(0, offset);
	      var chunk2 = s.substr(offset + remove);
	      return chunk1 + insert + chunk2;
	    }
	    var i, ii;
	    var canvas = document.createElement('canvas');
	    canvas.width = 1;
	    canvas.height = 1;
	    var ctx = canvas.getContext('2d');
	    var called = 0;
	    function isFontReady(name, callback) {
	      called++;
	      if (called > 30) {
	        (0, _util.warn)('Load test font never loaded.');
	        callback();
	        return;
	      }
	      ctx.font = '30px ' + name;
	      ctx.fillText('.', 0, 20);
	      var imageData = ctx.getImageData(0, 0, 1, 1);
	      if (imageData.data[3] > 0) {
	        callback();
	        return;
	      }
	      setTimeout(isFontReady.bind(null, name, callback));
	    }
	    var loadTestFontId = 'lt' + Date.now() + this.loadTestFontId++;
	    var data = this.loadTestFont;
	    var COMMENT_OFFSET = 976;
	    data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
	    var CFF_CHECKSUM_OFFSET = 16;
	    var XXXX_VALUE = 0x58585858;
	    var checksum = int32(data, CFF_CHECKSUM_OFFSET);
	    for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
	      checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
	    }
	    if (i < loadTestFontId.length) {
	      checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0;
	    }
	    data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
	    var url = 'url(data:font/opentype;base64,' + btoa(data) + ');';
	    var rule = '@font-face { font-family:"' + loadTestFontId + '";src:' + url + '}';
	    this.insertRule(rule);
	    var names = [];
	    for (i = 0, ii = fonts.length; i < ii; i++) {
	      names.push(fonts[i].loadedName);
	    }
	    names.push(loadTestFontId);
	    var div = document.createElement('div');
	    div.setAttribute('style', 'visibility: hidden;' + 'width: 10px; height: 10px;' + 'position: absolute; top: 0px; left: 0px;');
	    for (i = 0, ii = names.length; i < ii; ++i) {
	      var span = document.createElement('span');
	      span.textContent = 'Hi';
	      span.style.fontFamily = names[i];
	      div.appendChild(span);
	    }
	    document.body.appendChild(div);
	    isFontReady(loadTestFontId, function () {
	      document.body.removeChild(div);
	      request.complete();
	    });
	  };
	}
	{
	  FontLoader.isFontLoadingAPISupported = typeof document !== 'undefined' && !!document.fonts;
	}
	{
	  var isSyncFontLoadingSupported = function isSyncFontLoadingSupported() {
	    if (typeof navigator === 'undefined') {
	      return true;
	    }
	    var supported = false;
	    var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
	    if (m && m[1] >= 14) {
	      supported = true;
	    }
	    return supported;
	  };
	  Object.defineProperty(FontLoader, 'isSyncFontLoadingSupported', {
	    get: function get() {
	      return (0, _util.shadow)(FontLoader, 'isSyncFontLoadingSupported', isSyncFontLoadingSupported());
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	}
	var IsEvalSupportedCached = {
	  get value() {
	    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
	  }
	};
	var FontFaceObject = function FontFaceObjectClosure() {
	  function FontFaceObject(translatedData, options) {
	    this.compiledGlyphs = Object.create(null);
	    for (var i in translatedData) {
	      this[i] = translatedData[i];
	    }
	    this.options = options;
	  }
	  FontFaceObject.prototype = {
	    createNativeFontFace: function FontFaceObject_createNativeFontFace() {
	      if (!this.data) {
	        return null;
	      }
	      if (this.options.disableFontFace) {
	        this.disableFontFace = true;
	        return null;
	      }
	      var nativeFontFace = new FontFace(this.loadedName, this.data, {});
	      if (this.options.fontRegistry) {
	        this.options.fontRegistry.registerFont(this);
	      }
	      return nativeFontFace;
	    },
	    createFontFaceRule: function FontFaceObject_createFontFaceRule() {
	      if (!this.data) {
	        return null;
	      }
	      if (this.options.disableFontFace) {
	        this.disableFontFace = true;
	        return null;
	      }
	      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
	      var fontName = this.loadedName;
	      var url = 'url(data:' + this.mimetype + ';base64,' + btoa(data) + ');';
	      var rule = '@font-face { font-family:"' + fontName + '";src:' + url + '}';
	      if (this.options.fontRegistry) {
	        this.options.fontRegistry.registerFont(this, url);
	      }
	      return rule;
	    },
	    getPathGenerator: function FontFaceObject_getPathGenerator(objs, character) {
	      if (!(character in this.compiledGlyphs)) {
	        var cmds = objs.get(this.loadedName + '_path_' + character);
	        var current, i, len;
	        if (this.options.isEvalSupported && IsEvalSupportedCached.value) {
	          var args,
	              js = '';
	          for (i = 0, len = cmds.length; i < len; i++) {
	            current = cmds[i];
	            if (current.args !== undefined) {
	              args = current.args.join(',');
	            } else {
	              args = '';
	            }
	            js += 'c.' + current.cmd + '(' + args + ');\n';
	          }
	          this.compiledGlyphs[character] = new Function('c', 'size', js);
	        } else {
	          this.compiledGlyphs[character] = function (c, size) {
	            for (i = 0, len = cmds.length; i < len; i++) {
	              current = cmds[i];
	              if (current.cmd === 'scale') {
	                current.args = [size, -size];
	              }
	              c[current.cmd].apply(c, current.args);
	            }
	          };
	        }
	      }
	      return this.compiledGlyphs[character];
	    }
	  };
	  return FontFaceObject;
	}();
	exports.FontFaceObject = FontFaceObject;
	exports.FontLoader = FontLoader;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TilingPattern = exports.getShadingPatternFromIR = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _webgl = __w_pdfjs_require__(8);
	
	var ShadingIRs = {};
	ShadingIRs.RadialAxial = {
	  fromIR: function RadialAxial_fromIR(raw) {
	    var type = raw[1];
	    var colorStops = raw[2];
	    var p0 = raw[3];
	    var p1 = raw[4];
	    var r0 = raw[5];
	    var r1 = raw[6];
	    return {
	      type: 'Pattern',
	      getPattern: function RadialAxial_getPattern(ctx) {
	        var grad;
	        if (type === 'axial') {
	          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
	        } else if (type === 'radial') {
	          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
	        }
	        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
	          var c = colorStops[i];
	          grad.addColorStop(c[0], c[1]);
	        }
	        return grad;
	      }
	    };
	  }
	};
	var createMeshCanvas = function createMeshCanvasClosure() {
	  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
	    var coords = context.coords,
	        colors = context.colors;
	    var bytes = data.data,
	        rowSize = data.width * 4;
	    var tmp;
	    if (coords[p1 + 1] > coords[p2 + 1]) {
	      tmp = p1;
	      p1 = p2;
	      p2 = tmp;
	      tmp = c1;
	      c1 = c2;
	      c2 = tmp;
	    }
	    if (coords[p2 + 1] > coords[p3 + 1]) {
	      tmp = p2;
	      p2 = p3;
	      p3 = tmp;
	      tmp = c2;
	      c2 = c3;
	      c3 = tmp;
	    }
	    if (coords[p1 + 1] > coords[p2 + 1]) {
	      tmp = p1;
	      p1 = p2;
	      p2 = tmp;
	      tmp = c1;
	      c1 = c2;
	      c2 = tmp;
	    }
	    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
	    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
	    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
	    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
	    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
	    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
	    if (y1 >= y3) {
	      return;
	    }
	    var c1r = colors[c1],
	        c1g = colors[c1 + 1],
	        c1b = colors[c1 + 2];
	    var c2r = colors[c2],
	        c2g = colors[c2 + 1],
	        c2b = colors[c2 + 2];
	    var c3r = colors[c3],
	        c3g = colors[c3 + 1],
	        c3b = colors[c3 + 2];
	    var minY = Math.round(y1),
	        maxY = Math.round(y3);
	    var xa, car, cag, cab;
	    var xb, cbr, cbg, cbb;
	    var k;
	    for (var y = minY; y <= maxY; y++) {
	      if (y < y2) {
	        k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
	        xa = x1 - (x1 - x2) * k;
	        car = c1r - (c1r - c2r) * k;
	        cag = c1g - (c1g - c2g) * k;
	        cab = c1b - (c1b - c2b) * k;
	      } else {
	        k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
	        xa = x2 - (x2 - x3) * k;
	        car = c2r - (c2r - c3r) * k;
	        cag = c2g - (c2g - c3g) * k;
	        cab = c2b - (c2b - c3b) * k;
	      }
	      k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
	      xb = x1 - (x1 - x3) * k;
	      cbr = c1r - (c1r - c3r) * k;
	      cbg = c1g - (c1g - c3g) * k;
	      cbb = c1b - (c1b - c3b) * k;
	      var x1_ = Math.round(Math.min(xa, xb));
	      var x2_ = Math.round(Math.max(xa, xb));
	      var j = rowSize * y + x1_ * 4;
	      for (var x = x1_; x <= x2_; x++) {
	        k = (xa - x) / (xa - xb);
	        k = k < 0 ? 0 : k > 1 ? 1 : k;
	        bytes[j++] = car - (car - cbr) * k | 0;
	        bytes[j++] = cag - (cag - cbg) * k | 0;
	        bytes[j++] = cab - (cab - cbb) * k | 0;
	        bytes[j++] = 255;
	      }
	    }
	  }
	  function drawFigure(data, figure, context) {
	    var ps = figure.coords;
	    var cs = figure.colors;
	    var i, ii;
	    switch (figure.type) {
	      case 'lattice':
	        var verticesPerRow = figure.verticesPerRow;
	        var rows = Math.floor(ps.length / verticesPerRow) - 1;
	        var cols = verticesPerRow - 1;
	        for (i = 0; i < rows; i++) {
	          var q = i * verticesPerRow;
	          for (var j = 0; j < cols; j++, q++) {
	            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
	            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
	          }
	        }
	        break;
	      case 'triangles':
	        for (i = 0, ii = ps.length; i < ii; i += 3) {
	          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
	        }
	        break;
	      default:
	        (0, _util.error)('illigal figure');
	        break;
	    }
	  }
	  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases) {
	    var EXPECTED_SCALE = 1.1;
	    var MAX_PATTERN_SIZE = 3000;
	    var BORDER_SIZE = 2;
	    var offsetX = Math.floor(bounds[0]);
	    var offsetY = Math.floor(bounds[1]);
	    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
	    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
	    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
	    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
	    var scaleX = boundsWidth / width;
	    var scaleY = boundsHeight / height;
	    var context = {
	      coords: coords,
	      colors: colors,
	      offsetX: -offsetX,
	      offsetY: -offsetY,
	      scaleX: 1 / scaleX,
	      scaleY: 1 / scaleY
	    };
	    var paddedWidth = width + BORDER_SIZE * 2;
	    var paddedHeight = height + BORDER_SIZE * 2;
	    var canvas, tmpCanvas, i, ii;
	    if (_webgl.WebGLUtils.isEnabled) {
	      canvas = _webgl.WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
	      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
	      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
	      canvas = tmpCanvas.canvas;
	    } else {
	      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
	      var tmpCtx = tmpCanvas.context;
	      var data = tmpCtx.createImageData(width, height);
	      if (backgroundColor) {
	        var bytes = data.data;
	        for (i = 0, ii = bytes.length; i < ii; i += 4) {
	          bytes[i] = backgroundColor[0];
	          bytes[i + 1] = backgroundColor[1];
	          bytes[i + 2] = backgroundColor[2];
	          bytes[i + 3] = 255;
	        }
	      }
	      for (i = 0; i < figures.length; i++) {
	        drawFigure(data, figures[i], context);
	      }
	      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
	      canvas = tmpCanvas.canvas;
	    }
	    return {
	      canvas: canvas,
	      offsetX: offsetX - BORDER_SIZE * scaleX,
	      offsetY: offsetY - BORDER_SIZE * scaleY,
	      scaleX: scaleX,
	      scaleY: scaleY
	    };
	  }
	  return createMeshCanvas;
	}();
	ShadingIRs.Mesh = {
	  fromIR: function Mesh_fromIR(raw) {
	    var coords = raw[2];
	    var colors = raw[3];
	    var figures = raw[4];
	    var bounds = raw[5];
	    var matrix = raw[6];
	    var background = raw[8];
	    return {
	      type: 'Pattern',
	      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
	        var scale;
	        if (shadingFill) {
	          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
	        } else {
	          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
	          if (matrix) {
	            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);
	            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
	          }
	        }
	        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases);
	        if (!shadingFill) {
	          ctx.setTransform.apply(ctx, owner.baseTransform);
	          if (matrix) {
	            ctx.transform.apply(ctx, matrix);
	          }
	        }
	        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
	        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
	        return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat');
	      }
	    };
	  }
	};
	ShadingIRs.Dummy = {
	  fromIR: function Dummy_fromIR() {
	    return {
	      type: 'Pattern',
	      getPattern: function Dummy_fromIR_getPattern() {
	        return 'hotpink';
	      }
	    };
	  }
	};
	function getShadingPatternFromIR(raw) {
	  var shadingIR = ShadingIRs[raw[0]];
	  if (!shadingIR) {
	    (0, _util.error)('Unknown IR type: ' + raw[0]);
	  }
	  return shadingIR.fromIR(raw);
	}
	var TilingPattern = function TilingPatternClosure() {
	  var PaintType = {
	    COLORED: 1,
	    UNCOLORED: 2
	  };
	  var MAX_PATTERN_SIZE = 3000;
	  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
	    this.operatorList = IR[2];
	    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
	    this.bbox = _util.Util.normalizeRect(IR[4]);
	    this.xstep = IR[5];
	    this.ystep = IR[6];
	    this.paintType = IR[7];
	    this.tilingType = IR[8];
	    this.color = color;
	    this.canvasGraphicsFactory = canvasGraphicsFactory;
	    this.baseTransform = baseTransform;
	    this.type = 'Pattern';
	    this.ctx = ctx;
	  }
	  TilingPattern.prototype = {
	    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
	      var operatorList = this.operatorList;
	      var bbox = this.bbox;
	      var xstep = this.xstep;
	      var ystep = this.ystep;
	      var paintType = this.paintType;
	      var tilingType = this.tilingType;
	      var color = this.color;
	      var canvasGraphicsFactory = this.canvasGraphicsFactory;
	      (0, _util.info)('TilingType: ' + tilingType);
	      var x0 = bbox[0],
	          y0 = bbox[1],
	          x1 = bbox[2],
	          y1 = bbox[3];
	      var topLeft = [x0, y0];
	      var botRight = [x0 + xstep, y0 + ystep];
	      var width = botRight[0] - topLeft[0];
	      var height = botRight[1] - topLeft[1];
	      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
	      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
	      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
	      width = Math.min(Math.ceil(Math.abs(width * combinedScale[0])), MAX_PATTERN_SIZE);
	      height = Math.min(Math.ceil(Math.abs(height * combinedScale[1])), MAX_PATTERN_SIZE);
	      var tmpCanvas = owner.cachedCanvases.getCanvas('pattern', width, height, true);
	      var tmpCtx = tmpCanvas.context;
	      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
	      graphics.groupLevel = owner.groupLevel;
	      this.setFillAndStrokeStyleToContext(tmpCtx, paintType, color);
	      this.setScale(width, height, xstep, ystep);
	      this.transformToScale(graphics);
	      var tmpTranslate = [1, 0, 0, 1, -topLeft[0], -topLeft[1]];
	      graphics.transform.apply(graphics, tmpTranslate);
	      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
	      graphics.executeOperatorList(operatorList);
	      return tmpCanvas.canvas;
	    },
	    setScale: function TilingPattern_setScale(width, height, xstep, ystep) {
	      this.scale = [width / xstep, height / ystep];
	    },
	    transformToScale: function TilingPattern_transformToScale(graphics) {
	      var scale = this.scale;
	      var tmpScale = [scale[0], 0, 0, scale[1], 0, 0];
	      graphics.transform.apply(graphics, tmpScale);
	    },
	    scaleToContext: function TilingPattern_scaleToContext() {
	      var scale = this.scale;
	      this.ctx.scale(1 / scale[0], 1 / scale[1]);
	    },
	    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
	      if ((0, _util.isArray)(bbox) && bbox.length === 4) {
	        var bboxWidth = x1 - x0;
	        var bboxHeight = y1 - y0;
	        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
	        graphics.clip();
	        graphics.endPath();
	      }
	    },
	    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(context, paintType, color) {
	      switch (paintType) {
	        case PaintType.COLORED:
	          var ctx = this.ctx;
	          context.fillStyle = ctx.fillStyle;
	          context.strokeStyle = ctx.strokeStyle;
	          break;
	        case PaintType.UNCOLORED:
	          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);
	          context.fillStyle = cssColor;
	          context.strokeStyle = cssColor;
	          break;
	        default:
	          (0, _util.error)('Unsupported paint type: ' + paintType);
	      }
	    },
	    getPattern: function TilingPattern_getPattern(ctx, owner) {
	      var temporaryPatternCanvas = this.createPatternCanvas(owner);
	      ctx = this.ctx;
	      ctx.setTransform.apply(ctx, this.baseTransform);
	      ctx.transform.apply(ctx, this.matrix);
	      this.scaleToContext();
	      return ctx.createPattern(temporaryPatternCanvas, 'repeat');
	    }
	  };
	  return TilingPattern;
	}();
	exports.getShadingPatternFromIR = getShadingPatternFromIR;
	exports.TilingPattern = TilingPattern;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var pdfjsVersion = '1.8.331';
	var pdfjsBuild = '0dbc68a6';
	var pdfjsSharedUtil = __w_pdfjs_require__(0);
	var pdfjsDisplayGlobal = __w_pdfjs_require__(9);
	var pdfjsDisplayAPI = __w_pdfjs_require__(3);
	var pdfjsDisplayTextLayer = __w_pdfjs_require__(5);
	var pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(2);
	var pdfjsDisplayDOMUtils = __w_pdfjs_require__(1);
	var pdfjsDisplaySVG = __w_pdfjs_require__(4);
	exports.PDFJS = pdfjsDisplayGlobal.PDFJS;
	exports.build = pdfjsDisplayAPI.build;
	exports.version = pdfjsDisplayAPI.version;
	exports.getDocument = pdfjsDisplayAPI.getDocument;
	exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
	exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
	exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
	exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
	exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
	exports.CustomStyle = pdfjsDisplayDOMUtils.CustomStyle;
	exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
	exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
	exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
	exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
	exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
	exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
	exports.OPS = pdfjsSharedUtil.OPS;
	exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
	exports.isValidUrl = pdfjsDisplayDOMUtils.isValidUrl;
	exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
	exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
	exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
	exports.shadow = pdfjsSharedUtil.shadow;
	exports.createBlob = pdfjsSharedUtil.createBlob;
	exports.RenderingCancelledException = pdfjsDisplayDOMUtils.RenderingCancelledException;
	exports.getFilenameFromUrl = pdfjsDisplayDOMUtils.getFilenameFromUrl;
	exports.addLinkAttributes = pdfjsDisplayDOMUtils.addLinkAttributes;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
	  var globalScope = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : undefined;
	  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
	  var isAndroid = /Android/.test(userAgent);
	  var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
	  var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
	  var isChrome = userAgent.indexOf('Chrom') >= 0;
	  var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
	  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
	  var isIE = userAgent.indexOf('Trident') >= 0;
	  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
	  var isOpera = userAgent.indexOf('Opera') >= 0;
	  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
	  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
	  if (typeof PDFJS === 'undefined') {
	    globalScope.PDFJS = {};
	  }
	  PDFJS.compatibilityChecked = true;
	  (function checkTypedArrayCompatibility() {
	    if (typeof Uint8Array !== 'undefined') {
	      if (typeof Uint8Array.prototype.subarray === 'undefined') {
	        Uint8Array.prototype.subarray = function subarray(start, end) {
	          return new Uint8Array(this.slice(start, end));
	        };
	        Float32Array.prototype.subarray = function subarray(start, end) {
	          return new Float32Array(this.slice(start, end));
	        };
	      }
	      if (typeof Float64Array === 'undefined') {
	        globalScope.Float64Array = Float32Array;
	      }
	      return;
	    }
	    function subarray(start, end) {
	      return new TypedArray(this.slice(start, end));
	    }
	    function setArrayOffset(array, offset) {
	      if (arguments.length < 2) {
	        offset = 0;
	      }
	      for (var i = 0, n = array.length; i < n; ++i, ++offset) {
	        this[offset] = array[i] & 0xFF;
	      }
	    }
	    function Uint32ArrayView(buffer, length) {
	      this.buffer = buffer;
	      this.byteLength = buffer.length;
	      this.length = length;
	      ensureUint32ArrayViewProps(this.length);
	    }
	    Uint32ArrayView.prototype = Object.create(null);
	    var uint32ArrayViewSetters = 0;
	    function createUint32ArrayProp(index) {
	      return {
	        get: function get() {
	          var buffer = this.buffer,
	              offset = index << 2;
	          return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
	        },
	        set: function set(value) {
	          var buffer = this.buffer,
	              offset = index << 2;
	          buffer[offset] = value & 255;
	          buffer[offset + 1] = value >> 8 & 255;
	          buffer[offset + 2] = value >> 16 & 255;
	          buffer[offset + 3] = value >>> 24 & 255;
	        }
	      };
	    }
	    function ensureUint32ArrayViewProps(length) {
	      while (uint32ArrayViewSetters < length) {
	        Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
	        uint32ArrayViewSetters++;
	      }
	    }
	    function TypedArray(arg1) {
	      var result, i, n;
	      if (typeof arg1 === 'number') {
	        result = [];
	        for (i = 0; i < arg1; ++i) {
	          result[i] = 0;
	        }
	      } else if ('slice' in arg1) {
	        result = arg1.slice(0);
	      } else {
	        result = [];
	        for (i = 0, n = arg1.length; i < n; ++i) {
	          result[i] = arg1[i];
	        }
	      }
	      result.subarray = subarray;
	      result.buffer = result;
	      result.byteLength = result.length;
	      result.set = setArrayOffset;
	      if ((typeof arg1 === 'undefined' ? 'undefined' : _typeof(arg1)) === 'object' && arg1.buffer) {
	        result.buffer = arg1.buffer;
	      }
	      return result;
	    }
	    globalScope.Uint8Array = TypedArray;
	    globalScope.Int8Array = TypedArray;
	    globalScope.Int32Array = TypedArray;
	    globalScope.Uint16Array = TypedArray;
	    globalScope.Float32Array = TypedArray;
	    globalScope.Float64Array = TypedArray;
	    globalScope.Uint32Array = function () {
	      if (arguments.length === 3) {
	        if (arguments[1] !== 0) {
	          throw new Error('offset !== 0 is not supported');
	        }
	        return new Uint32ArrayView(arguments[0], arguments[2]);
	      }
	      return TypedArray.apply(this, arguments);
	    };
	  })();
	  (function canvasPixelArrayBuffer() {
	    if (!hasDOM || !window.CanvasPixelArray) {
	      return;
	    }
	    var cpaProto = window.CanvasPixelArray.prototype;
	    if ('buffer' in cpaProto) {
	      return;
	    }
	    Object.defineProperty(cpaProto, 'buffer', {
	      get: function get() {
	        return this;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	    Object.defineProperty(cpaProto, 'byteLength', {
	      get: function get() {
	        return this.length;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	  })();
	  (function normalizeURLObject() {
	    if (!globalScope.URL) {
	      globalScope.URL = globalScope.webkitURL;
	    }
	  })();
	  (function checkObjectDefinePropertyCompatibility() {
	    if (typeof Object.defineProperty !== 'undefined') {
	      var definePropertyPossible = true;
	      try {
	        if (hasDOM) {
	          Object.defineProperty(new Image(), 'id', { value: 'test' });
	        }
	        var Test = function Test() {};
	        Test.prototype = {
	          get id() {}
	        };
	        Object.defineProperty(new Test(), 'id', {
	          value: '',
	          configurable: true,
	          enumerable: true,
	          writable: false
	        });
	      } catch (e) {
	        definePropertyPossible = false;
	      }
	      if (definePropertyPossible) {
	        return;
	      }
	    }
	    Object.defineProperty = function objectDefineProperty(obj, name, def) {
	      delete obj[name];
	      if ('get' in def) {
	        obj.__defineGetter__(name, def['get']);
	      }
	      if ('set' in def) {
	        obj.__defineSetter__(name, def['set']);
	      }
	      if ('value' in def) {
	        obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
	          this.__defineGetter__(name, function objectDefinePropertyGetter() {
	            return value;
	          });
	          return value;
	        });
	        obj[name] = def.value;
	      }
	    };
	  })();
	  (function checkXMLHttpRequestResponseCompatibility() {
	    if (typeof XMLHttpRequest === 'undefined') {
	      return;
	    }
	    var xhrPrototype = XMLHttpRequest.prototype;
	    var xhr = new XMLHttpRequest();
	    if (!('overrideMimeType' in xhr)) {
	      Object.defineProperty(xhrPrototype, 'overrideMimeType', {
	        value: function xmlHttpRequestOverrideMimeType(mimeType) {}
	      });
	    }
	    if ('responseType' in xhr) {
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'responseType', {
	      get: function xmlHttpRequestGetResponseType() {
	        return this._responseType || 'text';
	      },
	      set: function xmlHttpRequestSetResponseType(value) {
	        if (value === 'text' || value === 'arraybuffer') {
	          this._responseType = value;
	          if (value === 'arraybuffer' && typeof this.overrideMimeType === 'function') {
	            this.overrideMimeType('text/plain; charset=x-user-defined');
	          }
	        }
	      }
	    });
	    if (typeof VBArray !== 'undefined') {
	      Object.defineProperty(xhrPrototype, 'response', {
	        get: function xmlHttpRequestResponseGet() {
	          if (this.responseType === 'arraybuffer') {
	            return new Uint8Array(new VBArray(this.responseBody).toArray());
	          }
	          return this.responseText;
	        }
	      });
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'response', {
	      get: function xmlHttpRequestResponseGet() {
	        if (this.responseType !== 'arraybuffer') {
	          return this.responseText;
	        }
	        var text = this.responseText;
	        var i,
	            n = text.length;
	        var result = new Uint8Array(n);
	        for (i = 0; i < n; ++i) {
	          result[i] = text.charCodeAt(i) & 0xFF;
	        }
	        return result.buffer;
	      }
	    });
	  })();
	  (function checkWindowBtoaCompatibility() {
	    if ('btoa' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.btoa = function (chars) {
	      var buffer = '';
	      var i, n;
	      for (i = 0, n = chars.length; i < n; i += 3) {
	        var b1 = chars.charCodeAt(i) & 0xFF;
	        var b2 = chars.charCodeAt(i + 1) & 0xFF;
	        var b3 = chars.charCodeAt(i + 2) & 0xFF;
	        var d1 = b1 >> 2,
	            d2 = (b1 & 3) << 4 | b2 >> 4;
	        var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	        var d4 = i + 2 < n ? b3 & 0x3F : 64;
	        buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
	      }
	      return buffer;
	    };
	  })();
	  (function checkWindowAtobCompatibility() {
	    if ('atob' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.atob = function (input) {
	      input = input.replace(/=+$/, '');
	      if (input.length % 4 === 1) {
	        throw new Error('bad atob input');
	      }
	      for (var bc = 0, bs, buffer, idx = 0, output = ''; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
	        buffer = digits.indexOf(buffer);
	      }
	      return output;
	    };
	  })();
	  (function checkFunctionPrototypeBindCompatibility() {
	    if (typeof Function.prototype.bind !== 'undefined') {
	      return;
	    }
	    Function.prototype.bind = function functionPrototypeBind(obj) {
	      var fn = this,
	          headArgs = Array.prototype.slice.call(arguments, 1);
	      var bound = function functionPrototypeBindBound() {
	        var args = headArgs.concat(Array.prototype.slice.call(arguments));
	        return fn.apply(obj, args);
	      };
	      return bound;
	    };
	  })();
	  (function checkDatasetProperty() {
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('dataset' in div) {
	      return;
	    }
	    Object.defineProperty(HTMLElement.prototype, 'dataset', {
	      get: function get() {
	        if (this._dataset) {
	          return this._dataset;
	        }
	        var dataset = {};
	        for (var j = 0, jj = this.attributes.length; j < jj; j++) {
	          var attribute = this.attributes[j];
	          if (attribute.name.substring(0, 5) !== 'data-') {
	            continue;
	          }
	          var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
	            return ch.toUpperCase();
	          });
	          dataset[key] = attribute.value;
	        }
	        Object.defineProperty(this, '_dataset', {
	          value: dataset,
	          writable: false,
	          enumerable: false
	        });
	        return dataset;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkClassListProperty() {
	    function changeList(element, itemName, add, remove) {
	      var s = element.className || '';
	      var list = s.split(/\s+/g);
	      if (list[0] === '') {
	        list.shift();
	      }
	      var index = list.indexOf(itemName);
	      if (index < 0 && add) {
	        list.push(itemName);
	      }
	      if (index >= 0 && remove) {
	        list.splice(index, 1);
	      }
	      element.className = list.join(' ');
	      return index >= 0;
	    }
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('classList' in div) {
	      return;
	    }
	    var classListPrototype = {
	      add: function add(name) {
	        changeList(this.element, name, true, false);
	      },
	      contains: function contains(name) {
	        return changeList(this.element, name, false, false);
	      },
	      remove: function remove(name) {
	        changeList(this.element, name, false, true);
	      },
	      toggle: function toggle(name) {
	        changeList(this.element, name, true, true);
	      }
	    };
	    Object.defineProperty(HTMLElement.prototype, 'classList', {
	      get: function get() {
	        if (this._classList) {
	          return this._classList;
	        }
	        var classList = Object.create(classListPrototype, {
	          element: {
	            value: this,
	            writable: false,
	            enumerable: true
	          }
	        });
	        Object.defineProperty(this, '_classList', {
	          value: classList,
	          writable: false,
	          enumerable: false
	        });
	        return classList;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkWorkerConsoleCompatibility() {
	    if (typeof importScripts === 'undefined' || 'console' in globalScope) {
	      return;
	    }
	    var consoleTimer = {};
	    var workerConsole = {
	      log: function log() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_log',
	          data: args
	        });
	      },
	      error: function error() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_error',
	          data: args
	        });
	      },
	      time: function time(name) {
	        consoleTimer[name] = Date.now();
	      },
	      timeEnd: function timeEnd(name) {
	        var time = consoleTimer[name];
	        if (!time) {
	          throw new Error('Unknown timer name ' + name);
	        }
	        this.log('Timer:', name, Date.now() - time);
	      }
	    };
	    globalScope.console = workerConsole;
	  })();
	  (function checkConsoleCompatibility() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!('console' in window)) {
	      window.console = {
	        log: function log() {},
	        error: function error() {},
	        warn: function warn() {}
	      };
	      return;
	    }
	    if (!('bind' in console.log)) {
	      console.log = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.log);
	      console.error = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.error);
	      console.warn = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.warn);
	      return;
	    }
	  })();
	  (function checkOnClickCompatibility() {
	    function ignoreIfTargetDisabled(event) {
	      if (isDisabled(event.target)) {
	        event.stopPropagation();
	      }
	    }
	    function isDisabled(node) {
	      return node.disabled || node.parentNode && isDisabled(node.parentNode);
	    }
	    if (isOpera) {
	      document.addEventListener('click', ignoreIfTargetDisabled, true);
	    }
	  })();
	  (function checkOnBlobSupport() {
	    if (isIE || isIOSChrome) {
	      PDFJS.disableCreateObjectURL = true;
	    }
	  })();
	  (function checkNavigatorLanguage() {
	    if (typeof navigator === 'undefined') {
	      return;
	    }
	    if ('language' in navigator) {
	      return;
	    }
	    PDFJS.locale = navigator.userLanguage || 'en-US';
	  })();
	  (function checkRangeRequests() {
	    if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
	      PDFJS.disableRange = true;
	      PDFJS.disableStream = true;
	    }
	  })();
	  (function checkHistoryManipulation() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!history.pushState || isAndroidPre3) {
	      PDFJS.disableHistory = true;
	    }
	  })();
	  (function checkSetPresenceInImageData() {
	    if (!hasDOM) {
	      return;
	    }
	    if (window.CanvasPixelArray) {
	      if (typeof window.CanvasPixelArray.prototype.set !== 'function') {
	        window.CanvasPixelArray.prototype.set = function (arr) {
	          for (var i = 0, ii = this.length; i < ii; i++) {
	            this[i] = arr[i];
	          }
	        };
	      }
	    } else {
	      var polyfill = false,
	          versionMatch;
	      if (isChrome) {
	        versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
	        polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
	      } else if (isAndroid) {
	        polyfill = isAndroidPre5;
	      } else if (isSafari) {
	        versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
	        polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
	      }
	      if (polyfill) {
	        var contextPrototype = window.CanvasRenderingContext2D.prototype;
	        var createImageData = contextPrototype.createImageData;
	        contextPrototype.createImageData = function (w, h) {
	          var imageData = createImageData.call(this, w, h);
	          imageData.data.set = function (arr) {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	              this[i] = arr[i];
	            }
	          };
	          return imageData;
	        };
	        contextPrototype = null;
	      }
	    }
	  })();
	  (function checkRequestAnimationFrame() {
	    function installFakeAnimationFrameFunctions() {
	      window.requestAnimationFrame = function (callback) {
	        return window.setTimeout(callback, 20);
	      };
	      window.cancelAnimationFrame = function (timeoutID) {
	        window.clearTimeout(timeoutID);
	      };
	    }
	    if (!hasDOM) {
	      return;
	    }
	    if (isIOS) {
	      installFakeAnimationFrameFunctions();
	      return;
	    }
	    if ('requestAnimationFrame' in window) {
	      return;
	    }
	    window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
	    if (window.requestAnimationFrame) {
	      return;
	    }
	    installFakeAnimationFrameFunctions();
	  })();
	  (function checkCanvasSizeLimitation() {
	    if (isIOS || isAndroid) {
	      PDFJS.maxCanvasPixels = 5242880;
	    }
	  })();
	  (function checkFullscreenSupport() {
	    if (!hasDOM) {
	      return;
	    }
	    if (isIE && window.parent !== window) {
	      PDFJS.disableFullscreen = true;
	    }
	  })();
	  (function checkCurrentScript() {
	    if (!hasDOM) {
	      return;
	    }
	    if ('currentScript' in document) {
	      return;
	    }
	    Object.defineProperty(document, 'currentScript', {
	      get: function get() {
	        var scripts = document.getElementsByTagName('script');
	        return scripts[scripts.length - 1];
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkInputTypeNumberAssign() {
	    if (!hasDOM) {
	      return;
	    }
	    var el = document.createElement('input');
	    try {
	      el.type = 'number';
	    } catch (ex) {
	      var inputProto = el.constructor.prototype;
	      var typeProperty = Object.getOwnPropertyDescriptor(inputProto, 'type');
	      Object.defineProperty(inputProto, 'type', {
	        get: function get() {
	          return typeProperty.get.call(this);
	        },
	        set: function set(value) {
	          typeProperty.set.call(this, value === 'number' ? 'text' : value);
	        },
	
	        enumerable: true,
	        configurable: true
	      });
	    }
	  })();
	  (function checkDocumentReadyState() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!document.attachEvent) {
	      return;
	    }
	    var documentProto = document.constructor.prototype;
	    var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, 'readyState');
	    Object.defineProperty(documentProto, 'readyState', {
	      get: function get() {
	        var value = readyStateProto.get.call(this);
	        return value === 'interactive' ? 'loading' : value;
	      },
	      set: function set(value) {
	        readyStateProto.set.call(this, value);
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkChildNodeRemove() {
	    if (!hasDOM) {
	      return;
	    }
	    if (typeof Element.prototype.remove !== 'undefined') {
	      return;
	    }
	    Element.prototype.remove = function () {
	      if (this.parentNode) {
	        this.parentNode.removeChild(this);
	      }
	    };
	  })();
	  (function checkPromise() {
	    if (globalScope.Promise) {
	      if (typeof globalScope.Promise.all !== 'function') {
	        globalScope.Promise.all = function (iterable) {
	          var count = 0,
	              results = [],
	              resolve,
	              reject;
	          var promise = new globalScope.Promise(function (resolve_, reject_) {
	            resolve = resolve_;
	            reject = reject_;
	          });
	          iterable.forEach(function (p, i) {
	            count++;
	            p.then(function (result) {
	              results[i] = result;
	              count--;
	              if (count === 0) {
	                resolve(results);
	              }
	            }, reject);
	          });
	          if (count === 0) {
	            resolve(results);
	          }
	          return promise;
	        };
	      }
	      if (typeof globalScope.Promise.resolve !== 'function') {
	        globalScope.Promise.resolve = function (value) {
	          return new globalScope.Promise(function (resolve) {
	            resolve(value);
	          });
	        };
	      }
	      if (typeof globalScope.Promise.reject !== 'function') {
	        globalScope.Promise.reject = function (reason) {
	          return new globalScope.Promise(function (resolve, reject) {
	            reject(reason);
	          });
	        };
	      }
	      if (typeof globalScope.Promise.prototype.catch !== 'function') {
	        globalScope.Promise.prototype.catch = function (onReject) {
	          return globalScope.Promise.prototype.then(undefined, onReject);
	        };
	      }
	      return;
	    }
	    var STATUS_PENDING = 0;
	    var STATUS_RESOLVED = 1;
	    var STATUS_REJECTED = 2;
	    var REJECTION_TIMEOUT = 500;
	    var HandlerManager = {
	      handlers: [],
	      running: false,
	      unhandledRejections: [],
	      pendingRejectionCheck: false,
	      scheduleHandlers: function scheduleHandlers(promise) {
	        if (promise._status === STATUS_PENDING) {
	          return;
	        }
	        this.handlers = this.handlers.concat(promise._handlers);
	        promise._handlers = [];
	        if (this.running) {
	          return;
	        }
	        this.running = true;
	        setTimeout(this.runHandlers.bind(this), 0);
	      },
	      runHandlers: function runHandlers() {
	        var RUN_TIMEOUT = 1;
	        var timeoutAt = Date.now() + RUN_TIMEOUT;
	        while (this.handlers.length > 0) {
	          var handler = this.handlers.shift();
	          var nextStatus = handler.thisPromise._status;
	          var nextValue = handler.thisPromise._value;
	          try {
	            if (nextStatus === STATUS_RESOLVED) {
	              if (typeof handler.onResolve === 'function') {
	                nextValue = handler.onResolve(nextValue);
	              }
	            } else if (typeof handler.onReject === 'function') {
	              nextValue = handler.onReject(nextValue);
	              nextStatus = STATUS_RESOLVED;
	              if (handler.thisPromise._unhandledRejection) {
	                this.removeUnhandeledRejection(handler.thisPromise);
	              }
	            }
	          } catch (ex) {
	            nextStatus = STATUS_REJECTED;
	            nextValue = ex;
	          }
	          handler.nextPromise._updateStatus(nextStatus, nextValue);
	          if (Date.now() >= timeoutAt) {
	            break;
	          }
	        }
	        if (this.handlers.length > 0) {
	          setTimeout(this.runHandlers.bind(this), 0);
	          return;
	        }
	        this.running = false;
	      },
	      addUnhandledRejection: function addUnhandledRejection(promise) {
	        this.unhandledRejections.push({
	          promise: promise,
	          time: Date.now()
	        });
	        this.scheduleRejectionCheck();
	      },
	      removeUnhandeledRejection: function removeUnhandeledRejection(promise) {
	        promise._unhandledRejection = false;
	        for (var i = 0; i < this.unhandledRejections.length; i++) {
	          if (this.unhandledRejections[i].promise === promise) {
	            this.unhandledRejections.splice(i);
	            i--;
	          }
	        }
	      },
	      scheduleRejectionCheck: function scheduleRejectionCheck() {
	        var _this = this;
	
	        if (this.pendingRejectionCheck) {
	          return;
	        }
	        this.pendingRejectionCheck = true;
	        setTimeout(function () {
	          _this.pendingRejectionCheck = false;
	          var now = Date.now();
	          for (var i = 0; i < _this.unhandledRejections.length; i++) {
	            if (now - _this.unhandledRejections[i].time > REJECTION_TIMEOUT) {
	              var unhandled = _this.unhandledRejections[i].promise._value;
	              var msg = 'Unhandled rejection: ' + unhandled;
	              if (unhandled.stack) {
	                msg += '\n' + unhandled.stack;
	              }
	              try {
	                throw new Error(msg);
	              } catch (_) {
	                console.warn(msg);
	              }
	              _this.unhandledRejections.splice(i);
	              i--;
	            }
	          }
	          if (_this.unhandledRejections.length) {
	            _this.scheduleRejectionCheck();
	          }
	        }, REJECTION_TIMEOUT);
	      }
	    };
	    var Promise = function Promise(resolver) {
	      this._status = STATUS_PENDING;
	      this._handlers = [];
	      try {
	        resolver.call(this, this._resolve.bind(this), this._reject.bind(this));
	      } catch (e) {
	        this._reject(e);
	      }
	    };
	    Promise.all = function Promise_all(promises) {
	      var resolveAll, rejectAll;
	      var deferred = new Promise(function (resolve, reject) {
	        resolveAll = resolve;
	        rejectAll = reject;
	      });
	      var unresolved = promises.length;
	      var results = [];
	      if (unresolved === 0) {
	        resolveAll(results);
	        return deferred;
	      }
	      function reject(reason) {
	        if (deferred._status === STATUS_REJECTED) {
	          return;
	        }
	        results = [];
	        rejectAll(reason);
	      }
	      for (var i = 0, ii = promises.length; i < ii; ++i) {
	        var promise = promises[i];
	        var resolve = function (i) {
	          return function (value) {
	            if (deferred._status === STATUS_REJECTED) {
	              return;
	            }
	            results[i] = value;
	            unresolved--;
	            if (unresolved === 0) {
	              resolveAll(results);
	            }
	          };
	        }(i);
	        if (Promise.isPromise(promise)) {
	          promise.then(resolve, reject);
	        } else {
	          resolve(promise);
	        }
	      }
	      return deferred;
	    };
	    Promise.isPromise = function Promise_isPromise(value) {
	      return value && typeof value.then === 'function';
	    };
	    Promise.resolve = function Promise_resolve(value) {
	      return new Promise(function (resolve) {
	        resolve(value);
	      });
	    };
	    Promise.reject = function Promise_reject(reason) {
	      return new Promise(function (resolve, reject) {
	        reject(reason);
	      });
	    };
	    Promise.prototype = {
	      _status: null,
	      _value: null,
	      _handlers: null,
	      _unhandledRejection: null,
	      _updateStatus: function Promise__updateStatus(status, value) {
	        if (this._status === STATUS_RESOLVED || this._status === STATUS_REJECTED) {
	          return;
	        }
	        if (status === STATUS_RESOLVED && Promise.isPromise(value)) {
	          value.then(this._updateStatus.bind(this, STATUS_RESOLVED), this._updateStatus.bind(this, STATUS_REJECTED));
	          return;
	        }
	        this._status = status;
	        this._value = value;
	        if (status === STATUS_REJECTED && this._handlers.length === 0) {
	          this._unhandledRejection = true;
	          HandlerManager.addUnhandledRejection(this);
	        }
	        HandlerManager.scheduleHandlers(this);
	      },
	      _resolve: function Promise_resolve(value) {
	        this._updateStatus(STATUS_RESOLVED, value);
	      },
	      _reject: function Promise_reject(reason) {
	        this._updateStatus(STATUS_REJECTED, reason);
	      },
	      then: function Promise_then(onResolve, onReject) {
	        var nextPromise = new Promise(function (resolve, reject) {
	          this.resolve = resolve;
	          this.reject = reject;
	        });
	        this._handlers.push({
	          thisPromise: this,
	          onResolve: onResolve,
	          onReject: onReject,
	          nextPromise: nextPromise
	        });
	        HandlerManager.scheduleHandlers(this);
	        return nextPromise;
	      },
	      catch: function Promise_catch(onReject) {
	        return this.then(undefined, onReject);
	      }
	    };
	    globalScope.Promise = Promise;
	  })();
	  (function checkWeakMap() {
	    if (globalScope.WeakMap) {
	      return;
	    }
	    var id = 0;
	    function WeakMap() {
	      this.id = '$weakmap' + id++;
	    }
	    WeakMap.prototype = {
	      has: function has(obj) {
	        return !!Object.getOwnPropertyDescriptor(obj, this.id);
	      },
	      get: function get(obj, defaultValue) {
	        return this.has(obj) ? obj[this.id] : defaultValue;
	      },
	      set: function set(obj, value) {
	        Object.defineProperty(obj, this.id, {
	          value: value,
	          enumerable: false,
	          configurable: true
	        });
	      },
	      delete: function _delete(obj) {
	        delete obj[this.id];
	      }
	    };
	    globalScope.WeakMap = WeakMap;
	  })();
	  (function checkURLConstructor() {
	    var hasWorkingUrl = false;
	    try {
	      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
	        var u = new URL('b', 'http://a');
	        u.pathname = 'c%20d';
	        hasWorkingUrl = u.href === 'http://a/c%20d';
	      }
	    } catch (e) {}
	    if (hasWorkingUrl) {
	      return;
	    }
	    var relative = Object.create(null);
	    relative['ftp'] = 21;
	    relative['file'] = 0;
	    relative['gopher'] = 70;
	    relative['http'] = 80;
	    relative['https'] = 443;
	    relative['ws'] = 80;
	    relative['wss'] = 443;
	    var relativePathDotMapping = Object.create(null);
	    relativePathDotMapping['%2e'] = '.';
	    relativePathDotMapping['.%2e'] = '..';
	    relativePathDotMapping['%2e.'] = '..';
	    relativePathDotMapping['%2e%2e'] = '..';
	    function isRelativeScheme(scheme) {
	      return relative[scheme] !== undefined;
	    }
	    function invalid() {
	      clear.call(this);
	      this._isInvalid = true;
	    }
	    function IDNAToASCII(h) {
	      if (h === '') {
	        invalid.call(this);
	      }
	      return h.toLowerCase();
	    }
	    function percentEscape(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    function percentEscapeQuery(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    var EOF,
	        ALPHA = /[a-zA-Z]/,
	        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
	    function parse(input, stateOverride, base) {
	      function err(message) {
	        errors.push(message);
	      }
	      var state = stateOverride || 'scheme start',
	          cursor = 0,
	          buffer = '',
	          seenAt = false,
	          seenBracket = false,
	          errors = [];
	      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
	        var c = input[cursor];
	        switch (state) {
	          case 'scheme start':
	            if (c && ALPHA.test(c)) {
	              buffer += c.toLowerCase();
	              state = 'scheme';
	            } else if (!stateOverride) {
	              buffer = '';
	              state = 'no scheme';
	              continue;
	            } else {
	              err('Invalid scheme.');
	              break loop;
	            }
	            break;
	          case 'scheme':
	            if (c && ALPHANUMERIC.test(c)) {
	              buffer += c.toLowerCase();
	            } else if (c === ':') {
	              this._scheme = buffer;
	              buffer = '';
	              if (stateOverride) {
	                break loop;
	              }
	              if (isRelativeScheme(this._scheme)) {
	                this._isRelative = true;
	              }
	              if (this._scheme === 'file') {
	                state = 'relative';
	              } else if (this._isRelative && base && base._scheme === this._scheme) {
	                state = 'relative or authority';
	              } else if (this._isRelative) {
	                state = 'authority first slash';
	              } else {
	                state = 'scheme data';
	              }
	            } else if (!stateOverride) {
	              buffer = '';
	              cursor = 0;
	              state = 'no scheme';
	              continue;
	            } else if (c === EOF) {
	              break loop;
	            } else {
	              err('Code point not allowed in scheme: ' + c);
	              break loop;
	            }
	            break;
	          case 'scheme data':
	            if (c === '?') {
	              this._query = '?';
	              state = 'query';
	            } else if (c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else {
	              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	                this._schemeData += percentEscape(c);
	              }
	            }
	            break;
	          case 'no scheme':
	            if (!base || !isRelativeScheme(base._scheme)) {
	              err('Missing scheme.');
	              invalid.call(this);
	            } else {
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative or authority':
	            if (c === '/' && input[cursor + 1] === '/') {
	              state = 'authority ignore slashes';
	            } else {
	              err('Expected /, got: ' + c);
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative':
	            this._isRelative = true;
	            if (this._scheme !== 'file') {
	              this._scheme = base._scheme;
	            }
	            if (c === EOF) {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._username = base._username;
	              this._password = base._password;
	              break loop;
	            } else if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              state = 'relative slash';
	            } else if (c === '?') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = '?';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'query';
	            } else if (c === '#') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._fragment = '#';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'fragment';
	            } else {
	              var nextC = input[cursor + 1];
	              var nextNextC = input[cursor + 2];
	              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	                this._path = base._path.slice();
	                this._path.pop();
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'relative slash':
	            if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              if (this._scheme === 'file') {
	                state = 'file host';
	              } else {
	                state = 'authority ignore slashes';
	              }
	            } else {
	              if (this._scheme !== 'file') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'authority first slash':
	            if (c === '/') {
	              state = 'authority second slash';
	            } else {
	              err('Expected \'/\', got: ' + c);
	              state = 'authority ignore slashes';
	              continue;
	            }
	            break;
	          case 'authority second slash':
	            state = 'authority ignore slashes';
	            if (c !== '/') {
	              err('Expected \'/\', got: ' + c);
	              continue;
	            }
	            break;
	          case 'authority ignore slashes':
	            if (c !== '/' && c !== '\\') {
	              state = 'authority';
	              continue;
	            } else {
	              err('Expected authority, got: ' + c);
	            }
	            break;
	          case 'authority':
	            if (c === '@') {
	              if (seenAt) {
	                err('@ already seen.');
	                buffer += '%40';
	              }
	              seenAt = true;
	              for (var i = 0; i < buffer.length; i++) {
	                var cp = buffer[i];
	                if (cp === '\t' || cp === '\n' || cp === '\r') {
	                  err('Invalid whitespace in authority.');
	                  continue;
	                }
	                if (cp === ':' && this._password === null) {
	                  this._password = '';
	                  continue;
	                }
	                var tempC = percentEscape(cp);
	                if (this._password !== null) {
	                  this._password += tempC;
	                } else {
	                  this._username += tempC;
	                }
	              }
	              buffer = '';
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              cursor -= buffer.length;
	              buffer = '';
	              state = 'host';
	              continue;
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'file host':
	            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
	                state = 'relative path';
	              } else if (buffer.length === 0) {
	                state = 'relative path start';
	              } else {
	                this._host = IDNAToASCII.call(this, buffer);
	                buffer = '';
	                state = 'relative path start';
	              }
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid whitespace in file host.');
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'host':
	          case 'hostname':
	            if (c === ':' && !seenBracket) {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'port';
	              if (stateOverride === 'hostname') {
	                break loop;
	              }
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'relative path start';
	              if (stateOverride) {
	                break loop;
	              }
	              continue;
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              if (c === '[') {
	                seenBracket = true;
	              } else if (c === ']') {
	                seenBracket = false;
	              }
	              buffer += c;
	            } else {
	              err('Invalid code point in host/hostname: ' + c);
	            }
	            break;
	          case 'port':
	            if (/[0-9]/.test(c)) {
	              buffer += c;
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
	              if (buffer !== '') {
	                var temp = parseInt(buffer, 10);
	                if (temp !== relative[this._scheme]) {
	                  this._port = temp + '';
	                }
	                buffer = '';
	              }
	              if (stateOverride) {
	                break loop;
	              }
	              state = 'relative path start';
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid code point in port: ' + c);
	            } else {
	              invalid.call(this);
	            }
	            break;
	          case 'relative path start':
	            if (c === '\\') {
	              err('\'\\\' not allowed in path.');
	            }
	            state = 'relative path';
	            if (c !== '/' && c !== '\\') {
	              continue;
	            }
	            break;
	          case 'relative path':
	            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
	              if (c === '\\') {
	                err('\\ not allowed in relative path.');
	              }
	              var tmp;
	              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
	                buffer = tmp;
	              }
	              if (buffer === '..') {
	                this._path.pop();
	                if (c !== '/' && c !== '\\') {
	                  this._path.push('');
	                }
	              } else if (buffer === '.' && c !== '/' && c !== '\\') {
	                this._path.push('');
	              } else if (buffer !== '.') {
	                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
	                  buffer = buffer[0] + ':';
	                }
	                this._path.push(buffer);
	              }
	              buffer = '';
	              if (c === '?') {
	                this._query = '?';
	                state = 'query';
	              } else if (c === '#') {
	                this._fragment = '#';
	                state = 'fragment';
	              }
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              buffer += percentEscape(c);
	            }
	            break;
	          case 'query':
	            if (!stateOverride && c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._query += percentEscapeQuery(c);
	            }
	            break;
	          case 'fragment':
	            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._fragment += c;
	            }
	            break;
	        }
	        cursor++;
	      }
	    }
	    function clear() {
	      this._scheme = '';
	      this._schemeData = '';
	      this._username = '';
	      this._password = null;
	      this._host = '';
	      this._port = '';
	      this._path = [];
	      this._query = '';
	      this._fragment = '';
	      this._isInvalid = false;
	      this._isRelative = false;
	    }
	    function JURL(url, base) {
	      if (base !== undefined && !(base instanceof JURL)) {
	        base = new JURL(String(base));
	      }
	      this._url = url;
	      clear.call(this);
	      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
	      parse.call(this, input, null, base);
	    }
	    JURL.prototype = {
	      toString: function toString() {
	        return this.href;
	      },
	
	      get href() {
	        if (this._isInvalid) {
	          return this._url;
	        }
	        var authority = '';
	        if (this._username !== '' || this._password !== null) {
	          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
	        }
	        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
	      },
	      set href(href) {
	        clear.call(this);
	        parse.call(this, href);
	      },
	      get protocol() {
	        return this._scheme + ':';
	      },
	      set protocol(protocol) {
	        if (this._isInvalid) {
	          return;
	        }
	        parse.call(this, protocol + ':', 'scheme start');
	      },
	      get host() {
	        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
	      },
	      set host(host) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, host, 'host');
	      },
	      get hostname() {
	        return this._host;
	      },
	      set hostname(hostname) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, hostname, 'hostname');
	      },
	      get port() {
	        return this._port;
	      },
	      set port(port) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, port, 'port');
	      },
	      get pathname() {
	        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
	      },
	      set pathname(pathname) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._path = [];
	        parse.call(this, pathname, 'relative path start');
	      },
	      get search() {
	        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
	      },
	      set search(search) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._query = '?';
	        if (search[0] === '?') {
	          search = search.slice(1);
	        }
	        parse.call(this, search, 'query');
	      },
	      get hash() {
	        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
	      },
	      set hash(hash) {
	        if (this._isInvalid) {
	          return;
	        }
	        this._fragment = '#';
	        if (hash[0] === '#') {
	          hash = hash.slice(1);
	        }
	        parse.call(this, hash, 'fragment');
	      },
	      get origin() {
	        var host;
	        if (this._isInvalid || !this._scheme) {
	          return '';
	        }
	        switch (this._scheme) {
	          case 'data':
	          case 'file':
	          case 'javascript':
	          case 'mailto':
	            return 'null';
	        }
	        host = this.host;
	        if (!host) {
	          return '';
	        }
	        return this._scheme + '://' + host;
	      }
	    };
	    var OriginalURL = globalScope.URL;
	    if (OriginalURL) {
	      JURL.createObjectURL = function (blob) {
	        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
	      };
	      JURL.revokeObjectURL = function (url) {
	        OriginalURL.revokeObjectURL(url);
	      };
	    }
	    globalScope.URL = JURL;
	  })();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __w_pdfjs_require__(6)))
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=pdf.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/* Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("pdfjs-dist/web/compatibility", [], factory);
		else if(typeof exports === 'object')
			exports["pdfjs-dist/web/compatibility"] = factory();
		else
			root["pdfjs-dist/web/compatibility"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 2);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
	  var globalScope = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : undefined;
	  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
	  var isAndroid = /Android/.test(userAgent);
	  var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
	  var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
	  var isChrome = userAgent.indexOf('Chrom') >= 0;
	  var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
	  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
	  var isIE = userAgent.indexOf('Trident') >= 0;
	  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
	  var isOpera = userAgent.indexOf('Opera') >= 0;
	  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
	  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
	  if (typeof PDFJS === 'undefined') {
	    globalScope.PDFJS = {};
	  }
	  PDFJS.compatibilityChecked = true;
	  (function checkTypedArrayCompatibility() {
	    if (typeof Uint8Array !== 'undefined') {
	      if (typeof Uint8Array.prototype.subarray === 'undefined') {
	        Uint8Array.prototype.subarray = function subarray(start, end) {
	          return new Uint8Array(this.slice(start, end));
	        };
	        Float32Array.prototype.subarray = function subarray(start, end) {
	          return new Float32Array(this.slice(start, end));
	        };
	      }
	      if (typeof Float64Array === 'undefined') {
	        globalScope.Float64Array = Float32Array;
	      }
	      return;
	    }
	    function subarray(start, end) {
	      return new TypedArray(this.slice(start, end));
	    }
	    function setArrayOffset(array, offset) {
	      if (arguments.length < 2) {
	        offset = 0;
	      }
	      for (var i = 0, n = array.length; i < n; ++i, ++offset) {
	        this[offset] = array[i] & 0xFF;
	      }
	    }
	    function Uint32ArrayView(buffer, length) {
	      this.buffer = buffer;
	      this.byteLength = buffer.length;
	      this.length = length;
	      ensureUint32ArrayViewProps(this.length);
	    }
	    Uint32ArrayView.prototype = Object.create(null);
	    var uint32ArrayViewSetters = 0;
	    function createUint32ArrayProp(index) {
	      return {
	        get: function get() {
	          var buffer = this.buffer,
	              offset = index << 2;
	          return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
	        },
	        set: function set(value) {
	          var buffer = this.buffer,
	              offset = index << 2;
	          buffer[offset] = value & 255;
	          buffer[offset + 1] = value >> 8 & 255;
	          buffer[offset + 2] = value >> 16 & 255;
	          buffer[offset + 3] = value >>> 24 & 255;
	        }
	      };
	    }
	    function ensureUint32ArrayViewProps(length) {
	      while (uint32ArrayViewSetters < length) {
	        Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
	        uint32ArrayViewSetters++;
	      }
	    }
	    function TypedArray(arg1) {
	      var result, i, n;
	      if (typeof arg1 === 'number') {
	        result = [];
	        for (i = 0; i < arg1; ++i) {
	          result[i] = 0;
	        }
	      } else if ('slice' in arg1) {
	        result = arg1.slice(0);
	      } else {
	        result = [];
	        for (i = 0, n = arg1.length; i < n; ++i) {
	          result[i] = arg1[i];
	        }
	      }
	      result.subarray = subarray;
	      result.buffer = result;
	      result.byteLength = result.length;
	      result.set = setArrayOffset;
	      if ((typeof arg1 === 'undefined' ? 'undefined' : _typeof(arg1)) === 'object' && arg1.buffer) {
	        result.buffer = arg1.buffer;
	      }
	      return result;
	    }
	    globalScope.Uint8Array = TypedArray;
	    globalScope.Int8Array = TypedArray;
	    globalScope.Int32Array = TypedArray;
	    globalScope.Uint16Array = TypedArray;
	    globalScope.Float32Array = TypedArray;
	    globalScope.Float64Array = TypedArray;
	    globalScope.Uint32Array = function () {
	      if (arguments.length === 3) {
	        if (arguments[1] !== 0) {
	          throw new Error('offset !== 0 is not supported');
	        }
	        return new Uint32ArrayView(arguments[0], arguments[2]);
	      }
	      return TypedArray.apply(this, arguments);
	    };
	  })();
	  (function canvasPixelArrayBuffer() {
	    if (!hasDOM || !window.CanvasPixelArray) {
	      return;
	    }
	    var cpaProto = window.CanvasPixelArray.prototype;
	    if ('buffer' in cpaProto) {
	      return;
	    }
	    Object.defineProperty(cpaProto, 'buffer', {
	      get: function get() {
	        return this;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	    Object.defineProperty(cpaProto, 'byteLength', {
	      get: function get() {
	        return this.length;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	  })();
	  (function normalizeURLObject() {
	    if (!globalScope.URL) {
	      globalScope.URL = globalScope.webkitURL;
	    }
	  })();
	  (function checkObjectDefinePropertyCompatibility() {
	    if (typeof Object.defineProperty !== 'undefined') {
	      var definePropertyPossible = true;
	      try {
	        if (hasDOM) {
	          Object.defineProperty(new Image(), 'id', { value: 'test' });
	        }
	        var Test = function Test() {};
	        Test.prototype = {
	          get id() {}
	        };
	        Object.defineProperty(new Test(), 'id', {
	          value: '',
	          configurable: true,
	          enumerable: true,
	          writable: false
	        });
	      } catch (e) {
	        definePropertyPossible = false;
	      }
	      if (definePropertyPossible) {
	        return;
	      }
	    }
	    Object.defineProperty = function objectDefineProperty(obj, name, def) {
	      delete obj[name];
	      if ('get' in def) {
	        obj.__defineGetter__(name, def['get']);
	      }
	      if ('set' in def) {
	        obj.__defineSetter__(name, def['set']);
	      }
	      if ('value' in def) {
	        obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
	          this.__defineGetter__(name, function objectDefinePropertyGetter() {
	            return value;
	          });
	          return value;
	        });
	        obj[name] = def.value;
	      }
	    };
	  })();
	  (function checkXMLHttpRequestResponseCompatibility() {
	    if (typeof XMLHttpRequest === 'undefined') {
	      return;
	    }
	    var xhrPrototype = XMLHttpRequest.prototype;
	    var xhr = new XMLHttpRequest();
	    if (!('overrideMimeType' in xhr)) {
	      Object.defineProperty(xhrPrototype, 'overrideMimeType', {
	        value: function xmlHttpRequestOverrideMimeType(mimeType) {}
	      });
	    }
	    if ('responseType' in xhr) {
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'responseType', {
	      get: function xmlHttpRequestGetResponseType() {
	        return this._responseType || 'text';
	      },
	      set: function xmlHttpRequestSetResponseType(value) {
	        if (value === 'text' || value === 'arraybuffer') {
	          this._responseType = value;
	          if (value === 'arraybuffer' && typeof this.overrideMimeType === 'function') {
	            this.overrideMimeType('text/plain; charset=x-user-defined');
	          }
	        }
	      }
	    });
	    if (typeof VBArray !== 'undefined') {
	      Object.defineProperty(xhrPrototype, 'response', {
	        get: function xmlHttpRequestResponseGet() {
	          if (this.responseType === 'arraybuffer') {
	            return new Uint8Array(new VBArray(this.responseBody).toArray());
	          }
	          return this.responseText;
	        }
	      });
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'response', {
	      get: function xmlHttpRequestResponseGet() {
	        if (this.responseType !== 'arraybuffer') {
	          return this.responseText;
	        }
	        var text = this.responseText;
	        var i,
	            n = text.length;
	        var result = new Uint8Array(n);
	        for (i = 0; i < n; ++i) {
	          result[i] = text.charCodeAt(i) & 0xFF;
	        }
	        return result.buffer;
	      }
	    });
	  })();
	  (function checkWindowBtoaCompatibility() {
	    if ('btoa' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.btoa = function (chars) {
	      var buffer = '';
	      var i, n;
	      for (i = 0, n = chars.length; i < n; i += 3) {
	        var b1 = chars.charCodeAt(i) & 0xFF;
	        var b2 = chars.charCodeAt(i + 1) & 0xFF;
	        var b3 = chars.charCodeAt(i + 2) & 0xFF;
	        var d1 = b1 >> 2,
	            d2 = (b1 & 3) << 4 | b2 >> 4;
	        var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	        var d4 = i + 2 < n ? b3 & 0x3F : 64;
	        buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
	      }
	      return buffer;
	    };
	  })();
	  (function checkWindowAtobCompatibility() {
	    if ('atob' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.atob = function (input) {
	      input = input.replace(/=+$/, '');
	      if (input.length % 4 === 1) {
	        throw new Error('bad atob input');
	      }
	      for (var bc = 0, bs, buffer, idx = 0, output = ''; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
	        buffer = digits.indexOf(buffer);
	      }
	      return output;
	    };
	  })();
	  (function checkFunctionPrototypeBindCompatibility() {
	    if (typeof Function.prototype.bind !== 'undefined') {
	      return;
	    }
	    Function.prototype.bind = function functionPrototypeBind(obj) {
	      var fn = this,
	          headArgs = Array.prototype.slice.call(arguments, 1);
	      var bound = function functionPrototypeBindBound() {
	        var args = headArgs.concat(Array.prototype.slice.call(arguments));
	        return fn.apply(obj, args);
	      };
	      return bound;
	    };
	  })();
	  (function checkDatasetProperty() {
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('dataset' in div) {
	      return;
	    }
	    Object.defineProperty(HTMLElement.prototype, 'dataset', {
	      get: function get() {
	        if (this._dataset) {
	          return this._dataset;
	        }
	        var dataset = {};
	        for (var j = 0, jj = this.attributes.length; j < jj; j++) {
	          var attribute = this.attributes[j];
	          if (attribute.name.substring(0, 5) !== 'data-') {
	            continue;
	          }
	          var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
	            return ch.toUpperCase();
	          });
	          dataset[key] = attribute.value;
	        }
	        Object.defineProperty(this, '_dataset', {
	          value: dataset,
	          writable: false,
	          enumerable: false
	        });
	        return dataset;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkClassListProperty() {
	    function changeList(element, itemName, add, remove) {
	      var s = element.className || '';
	      var list = s.split(/\s+/g);
	      if (list[0] === '') {
	        list.shift();
	      }
	      var index = list.indexOf(itemName);
	      if (index < 0 && add) {
	        list.push(itemName);
	      }
	      if (index >= 0 && remove) {
	        list.splice(index, 1);
	      }
	      element.className = list.join(' ');
	      return index >= 0;
	    }
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('classList' in div) {
	      return;
	    }
	    var classListPrototype = {
	      add: function add(name) {
	        changeList(this.element, name, true, false);
	      },
	      contains: function contains(name) {
	        return changeList(this.element, name, false, false);
	      },
	      remove: function remove(name) {
	        changeList(this.element, name, false, true);
	      },
	      toggle: function toggle(name) {
	        changeList(this.element, name, true, true);
	      }
	    };
	    Object.defineProperty(HTMLElement.prototype, 'classList', {
	      get: function get() {
	        if (this._classList) {
	          return this._classList;
	        }
	        var classList = Object.create(classListPrototype, {
	          element: {
	            value: this,
	            writable: false,
	            enumerable: true
	          }
	        });
	        Object.defineProperty(this, '_classList', {
	          value: classList,
	          writable: false,
	          enumerable: false
	        });
	        return classList;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkWorkerConsoleCompatibility() {
	    if (typeof importScripts === 'undefined' || 'console' in globalScope) {
	      return;
	    }
	    var consoleTimer = {};
	    var workerConsole = {
	      log: function log() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_log',
	          data: args
	        });
	      },
	      error: function error() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_error',
	          data: args
	        });
	      },
	      time: function time(name) {
	        consoleTimer[name] = Date.now();
	      },
	      timeEnd: function timeEnd(name) {
	        var time = consoleTimer[name];
	        if (!time) {
	          throw new Error('Unknown timer name ' + name);
	        }
	        this.log('Timer:', name, Date.now() - time);
	      }
	    };
	    globalScope.console = workerConsole;
	  })();
	  (function checkConsoleCompatibility() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!('console' in window)) {
	      window.console = {
	        log: function log() {},
	        error: function error() {},
	        warn: function warn() {}
	      };
	      return;
	    }
	    if (!('bind' in console.log)) {
	      console.log = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.log);
	      console.error = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.error);
	      console.warn = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.warn);
	      return;
	    }
	  })();
	  (function checkOnClickCompatibility() {
	    function ignoreIfTargetDisabled(event) {
	      if (isDisabled(event.target)) {
	        event.stopPropagation();
	      }
	    }
	    function isDisabled(node) {
	      return node.disabled || node.parentNode && isDisabled(node.parentNode);
	    }
	    if (isOpera) {
	      document.addEventListener('click', ignoreIfTargetDisabled, true);
	    }
	  })();
	  (function checkOnBlobSupport() {
	    if (isIE || isIOSChrome) {
	      PDFJS.disableCreateObjectURL = true;
	    }
	  })();
	  (function checkNavigatorLanguage() {
	    if (typeof navigator === 'undefined') {
	      return;
	    }
	    if ('language' in navigator) {
	      return;
	    }
	    PDFJS.locale = navigator.userLanguage || 'en-US';
	  })();
	  (function checkRangeRequests() {
	    if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
	      PDFJS.disableRange = true;
	      PDFJS.disableStream = true;
	    }
	  })();
	  (function checkHistoryManipulation() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!history.pushState || isAndroidPre3) {
	      PDFJS.disableHistory = true;
	    }
	  })();
	  (function checkSetPresenceInImageData() {
	    if (!hasDOM) {
	      return;
	    }
	    if (window.CanvasPixelArray) {
	      if (typeof window.CanvasPixelArray.prototype.set !== 'function') {
	        window.CanvasPixelArray.prototype.set = function (arr) {
	          for (var i = 0, ii = this.length; i < ii; i++) {
	            this[i] = arr[i];
	          }
	        };
	      }
	    } else {
	      var polyfill = false,
	          versionMatch;
	      if (isChrome) {
	        versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
	        polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
	      } else if (isAndroid) {
	        polyfill = isAndroidPre5;
	      } else if (isSafari) {
	        versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
	        polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
	      }
	      if (polyfill) {
	        var contextPrototype = window.CanvasRenderingContext2D.prototype;
	        var createImageData = contextPrototype.createImageData;
	        contextPrototype.createImageData = function (w, h) {
	          var imageData = createImageData.call(this, w, h);
	          imageData.data.set = function (arr) {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	              this[i] = arr[i];
	            }
	          };
	          return imageData;
	        };
	        contextPrototype = null;
	      }
	    }
	  })();
	  (function checkRequestAnimationFrame() {
	    function installFakeAnimationFrameFunctions() {
	      window.requestAnimationFrame = function (callback) {
	        return window.setTimeout(callback, 20);
	      };
	      window.cancelAnimationFrame = function (timeoutID) {
	        window.clearTimeout(timeoutID);
	      };
	    }
	    if (!hasDOM) {
	      return;
	    }
	    if (isIOS) {
	      installFakeAnimationFrameFunctions();
	      return;
	    }
	    if ('requestAnimationFrame' in window) {
	      return;
	    }
	    window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
	    if (window.requestAnimationFrame) {
	      return;
	    }
	    installFakeAnimationFrameFunctions();
	  })();
	  (function checkCanvasSizeLimitation() {
	    if (isIOS || isAndroid) {
	      PDFJS.maxCanvasPixels = 5242880;
	    }
	  })();
	  (function checkFullscreenSupport() {
	    if (!hasDOM) {
	      return;
	    }
	    if (isIE && window.parent !== window) {
	      PDFJS.disableFullscreen = true;
	    }
	  })();
	  (function checkCurrentScript() {
	    if (!hasDOM) {
	      return;
	    }
	    if ('currentScript' in document) {
	      return;
	    }
	    Object.defineProperty(document, 'currentScript', {
	      get: function get() {
	        var scripts = document.getElementsByTagName('script');
	        return scripts[scripts.length - 1];
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkInputTypeNumberAssign() {
	    if (!hasDOM) {
	      return;
	    }
	    var el = document.createElement('input');
	    try {
	      el.type = 'number';
	    } catch (ex) {
	      var inputProto = el.constructor.prototype;
	      var typeProperty = Object.getOwnPropertyDescriptor(inputProto, 'type');
	      Object.defineProperty(inputProto, 'type', {
	        get: function get() {
	          return typeProperty.get.call(this);
	        },
	        set: function set(value) {
	          typeProperty.set.call(this, value === 'number' ? 'text' : value);
	        },
	
	        enumerable: true,
	        configurable: true
	      });
	    }
	  })();
	  (function checkDocumentReadyState() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!document.attachEvent) {
	      return;
	    }
	    var documentProto = document.constructor.prototype;
	    var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, 'readyState');
	    Object.defineProperty(documentProto, 'readyState', {
	      get: function get() {
	        var value = readyStateProto.get.call(this);
	        return value === 'interactive' ? 'loading' : value;
	      },
	      set: function set(value) {
	        readyStateProto.set.call(this, value);
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkChildNodeRemove() {
	    if (!hasDOM) {
	      return;
	    }
	    if (typeof Element.prototype.remove !== 'undefined') {
	      return;
	    }
	    Element.prototype.remove = function () {
	      if (this.parentNode) {
	        this.parentNode.removeChild(this);
	      }
	    };
	  })();
	  (function checkPromise() {
	    if (globalScope.Promise) {
	      if (typeof globalScope.Promise.all !== 'function') {
	        globalScope.Promise.all = function (iterable) {
	          var count = 0,
	              results = [],
	              resolve,
	              reject;
	          var promise = new globalScope.Promise(function (resolve_, reject_) {
	            resolve = resolve_;
	            reject = reject_;
	          });
	          iterable.forEach(function (p, i) {
	            count++;
	            p.then(function (result) {
	              results[i] = result;
	              count--;
	              if (count === 0) {
	                resolve(results);
	              }
	            }, reject);
	          });
	          if (count === 0) {
	            resolve(results);
	          }
	          return promise;
	        };
	      }
	      if (typeof globalScope.Promise.resolve !== 'function') {
	        globalScope.Promise.resolve = function (value) {
	          return new globalScope.Promise(function (resolve) {
	            resolve(value);
	          });
	        };
	      }
	      if (typeof globalScope.Promise.reject !== 'function') {
	        globalScope.Promise.reject = function (reason) {
	          return new globalScope.Promise(function (resolve, reject) {
	            reject(reason);
	          });
	        };
	      }
	      if (typeof globalScope.Promise.prototype.catch !== 'function') {
	        globalScope.Promise.prototype.catch = function (onReject) {
	          return globalScope.Promise.prototype.then(undefined, onReject);
	        };
	      }
	      return;
	    }
	    var STATUS_PENDING = 0;
	    var STATUS_RESOLVED = 1;
	    var STATUS_REJECTED = 2;
	    var REJECTION_TIMEOUT = 500;
	    var HandlerManager = {
	      handlers: [],
	      running: false,
	      unhandledRejections: [],
	      pendingRejectionCheck: false,
	      scheduleHandlers: function scheduleHandlers(promise) {
	        if (promise._status === STATUS_PENDING) {
	          return;
	        }
	        this.handlers = this.handlers.concat(promise._handlers);
	        promise._handlers = [];
	        if (this.running) {
	          return;
	        }
	        this.running = true;
	        setTimeout(this.runHandlers.bind(this), 0);
	      },
	      runHandlers: function runHandlers() {
	        var RUN_TIMEOUT = 1;
	        var timeoutAt = Date.now() + RUN_TIMEOUT;
	        while (this.handlers.length > 0) {
	          var handler = this.handlers.shift();
	          var nextStatus = handler.thisPromise._status;
	          var nextValue = handler.thisPromise._value;
	          try {
	            if (nextStatus === STATUS_RESOLVED) {
	              if (typeof handler.onResolve === 'function') {
	                nextValue = handler.onResolve(nextValue);
	              }
	            } else if (typeof handler.onReject === 'function') {
	              nextValue = handler.onReject(nextValue);
	              nextStatus = STATUS_RESOLVED;
	              if (handler.thisPromise._unhandledRejection) {
	                this.removeUnhandeledRejection(handler.thisPromise);
	              }
	            }
	          } catch (ex) {
	            nextStatus = STATUS_REJECTED;
	            nextValue = ex;
	          }
	          handler.nextPromise._updateStatus(nextStatus, nextValue);
	          if (Date.now() >= timeoutAt) {
	            break;
	          }
	        }
	        if (this.handlers.length > 0) {
	          setTimeout(this.runHandlers.bind(this), 0);
	          return;
	        }
	        this.running = false;
	      },
	      addUnhandledRejection: function addUnhandledRejection(promise) {
	        this.unhandledRejections.push({
	          promise: promise,
	          time: Date.now()
	        });
	        this.scheduleRejectionCheck();
	      },
	      removeUnhandeledRejection: function removeUnhandeledRejection(promise) {
	        promise._unhandledRejection = false;
	        for (var i = 0; i < this.unhandledRejections.length; i++) {
	          if (this.unhandledRejections[i].promise === promise) {
	            this.unhandledRejections.splice(i);
	            i--;
	          }
	        }
	      },
	      scheduleRejectionCheck: function scheduleRejectionCheck() {
	        var _this = this;
	
	        if (this.pendingRejectionCheck) {
	          return;
	        }
	        this.pendingRejectionCheck = true;
	        setTimeout(function () {
	          _this.pendingRejectionCheck = false;
	          var now = Date.now();
	          for (var i = 0; i < _this.unhandledRejections.length; i++) {
	            if (now - _this.unhandledRejections[i].time > REJECTION_TIMEOUT) {
	              var unhandled = _this.unhandledRejections[i].promise._value;
	              var msg = 'Unhandled rejection: ' + unhandled;
	              if (unhandled.stack) {
	                msg += '\n' + unhandled.stack;
	              }
	              try {
	                throw new Error(msg);
	              } catch (_) {
	                console.warn(msg);
	              }
	              _this.unhandledRejections.splice(i);
	              i--;
	            }
	          }
	          if (_this.unhandledRejections.length) {
	            _this.scheduleRejectionCheck();
	          }
	        }, REJECTION_TIMEOUT);
	      }
	    };
	    var Promise = function Promise(resolver) {
	      this._status = STATUS_PENDING;
	      this._handlers = [];
	      try {
	        resolver.call(this, this._resolve.bind(this), this._reject.bind(this));
	      } catch (e) {
	        this._reject(e);
	      }
	    };
	    Promise.all = function Promise_all(promises) {
	      var resolveAll, rejectAll;
	      var deferred = new Promise(function (resolve, reject) {
	        resolveAll = resolve;
	        rejectAll = reject;
	      });
	      var unresolved = promises.length;
	      var results = [];
	      if (unresolved === 0) {
	        resolveAll(results);
	        return deferred;
	      }
	      function reject(reason) {
	        if (deferred._status === STATUS_REJECTED) {
	          return;
	        }
	        results = [];
	        rejectAll(reason);
	      }
	      for (var i = 0, ii = promises.length; i < ii; ++i) {
	        var promise = promises[i];
	        var resolve = function (i) {
	          return function (value) {
	            if (deferred._status === STATUS_REJECTED) {
	              return;
	            }
	            results[i] = value;
	            unresolved--;
	            if (unresolved === 0) {
	              resolveAll(results);
	            }
	          };
	        }(i);
	        if (Promise.isPromise(promise)) {
	          promise.then(resolve, reject);
	        } else {
	          resolve(promise);
	        }
	      }
	      return deferred;
	    };
	    Promise.isPromise = function Promise_isPromise(value) {
	      return value && typeof value.then === 'function';
	    };
	    Promise.resolve = function Promise_resolve(value) {
	      return new Promise(function (resolve) {
	        resolve(value);
	      });
	    };
	    Promise.reject = function Promise_reject(reason) {
	      return new Promise(function (resolve, reject) {
	        reject(reason);
	      });
	    };
	    Promise.prototype = {
	      _status: null,
	      _value: null,
	      _handlers: null,
	      _unhandledRejection: null,
	      _updateStatus: function Promise__updateStatus(status, value) {
	        if (this._status === STATUS_RESOLVED || this._status === STATUS_REJECTED) {
	          return;
	        }
	        if (status === STATUS_RESOLVED && Promise.isPromise(value)) {
	          value.then(this._updateStatus.bind(this, STATUS_RESOLVED), this._updateStatus.bind(this, STATUS_REJECTED));
	          return;
	        }
	        this._status = status;
	        this._value = value;
	        if (status === STATUS_REJECTED && this._handlers.length === 0) {
	          this._unhandledRejection = true;
	          HandlerManager.addUnhandledRejection(this);
	        }
	        HandlerManager.scheduleHandlers(this);
	      },
	      _resolve: function Promise_resolve(value) {
	        this._updateStatus(STATUS_RESOLVED, value);
	      },
	      _reject: function Promise_reject(reason) {
	        this._updateStatus(STATUS_REJECTED, reason);
	      },
	      then: function Promise_then(onResolve, onReject) {
	        var nextPromise = new Promise(function (resolve, reject) {
	          this.resolve = resolve;
	          this.reject = reject;
	        });
	        this._handlers.push({
	          thisPromise: this,
	          onResolve: onResolve,
	          onReject: onReject,
	          nextPromise: nextPromise
	        });
	        HandlerManager.scheduleHandlers(this);
	        return nextPromise;
	      },
	      catch: function Promise_catch(onReject) {
	        return this.then(undefined, onReject);
	      }
	    };
	    globalScope.Promise = Promise;
	  })();
	  (function checkWeakMap() {
	    if (globalScope.WeakMap) {
	      return;
	    }
	    var id = 0;
	    function WeakMap() {
	      this.id = '$weakmap' + id++;
	    }
	    WeakMap.prototype = {
	      has: function has(obj) {
	        return !!Object.getOwnPropertyDescriptor(obj, this.id);
	      },
	      get: function get(obj, defaultValue) {
	        return this.has(obj) ? obj[this.id] : defaultValue;
	      },
	      set: function set(obj, value) {
	        Object.defineProperty(obj, this.id, {
	          value: value,
	          enumerable: false,
	          configurable: true
	        });
	      },
	      delete: function _delete(obj) {
	        delete obj[this.id];
	      }
	    };
	    globalScope.WeakMap = WeakMap;
	  })();
	  (function checkURLConstructor() {
	    var hasWorkingUrl = false;
	    try {
	      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
	        var u = new URL('b', 'http://a');
	        u.pathname = 'c%20d';
	        hasWorkingUrl = u.href === 'http://a/c%20d';
	      }
	    } catch (e) {}
	    if (hasWorkingUrl) {
	      return;
	    }
	    var relative = Object.create(null);
	    relative['ftp'] = 21;
	    relative['file'] = 0;
	    relative['gopher'] = 70;
	    relative['http'] = 80;
	    relative['https'] = 443;
	    relative['ws'] = 80;
	    relative['wss'] = 443;
	    var relativePathDotMapping = Object.create(null);
	    relativePathDotMapping['%2e'] = '.';
	    relativePathDotMapping['.%2e'] = '..';
	    relativePathDotMapping['%2e.'] = '..';
	    relativePathDotMapping['%2e%2e'] = '..';
	    function isRelativeScheme(scheme) {
	      return relative[scheme] !== undefined;
	    }
	    function invalid() {
	      clear.call(this);
	      this._isInvalid = true;
	    }
	    function IDNAToASCII(h) {
	      if (h === '') {
	        invalid.call(this);
	      }
	      return h.toLowerCase();
	    }
	    function percentEscape(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    function percentEscapeQuery(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    var EOF,
	        ALPHA = /[a-zA-Z]/,
	        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
	    function parse(input, stateOverride, base) {
	      function err(message) {
	        errors.push(message);
	      }
	      var state = stateOverride || 'scheme start',
	          cursor = 0,
	          buffer = '',
	          seenAt = false,
	          seenBracket = false,
	          errors = [];
	      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
	        var c = input[cursor];
	        switch (state) {
	          case 'scheme start':
	            if (c && ALPHA.test(c)) {
	              buffer += c.toLowerCase();
	              state = 'scheme';
	            } else if (!stateOverride) {
	              buffer = '';
	              state = 'no scheme';
	              continue;
	            } else {
	              err('Invalid scheme.');
	              break loop;
	            }
	            break;
	          case 'scheme':
	            if (c && ALPHANUMERIC.test(c)) {
	              buffer += c.toLowerCase();
	            } else if (c === ':') {
	              this._scheme = buffer;
	              buffer = '';
	              if (stateOverride) {
	                break loop;
	              }
	              if (isRelativeScheme(this._scheme)) {
	                this._isRelative = true;
	              }
	              if (this._scheme === 'file') {
	                state = 'relative';
	              } else if (this._isRelative && base && base._scheme === this._scheme) {
	                state = 'relative or authority';
	              } else if (this._isRelative) {
	                state = 'authority first slash';
	              } else {
	                state = 'scheme data';
	              }
	            } else if (!stateOverride) {
	              buffer = '';
	              cursor = 0;
	              state = 'no scheme';
	              continue;
	            } else if (c === EOF) {
	              break loop;
	            } else {
	              err('Code point not allowed in scheme: ' + c);
	              break loop;
	            }
	            break;
	          case 'scheme data':
	            if (c === '?') {
	              this._query = '?';
	              state = 'query';
	            } else if (c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else {
	              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	                this._schemeData += percentEscape(c);
	              }
	            }
	            break;
	          case 'no scheme':
	            if (!base || !isRelativeScheme(base._scheme)) {
	              err('Missing scheme.');
	              invalid.call(this);
	            } else {
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative or authority':
	            if (c === '/' && input[cursor + 1] === '/') {
	              state = 'authority ignore slashes';
	            } else {
	              err('Expected /, got: ' + c);
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative':
	            this._isRelative = true;
	            if (this._scheme !== 'file') {
	              this._scheme = base._scheme;
	            }
	            if (c === EOF) {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._username = base._username;
	              this._password = base._password;
	              break loop;
	            } else if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              state = 'relative slash';
	            } else if (c === '?') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = '?';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'query';
	            } else if (c === '#') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._fragment = '#';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'fragment';
	            } else {
	              var nextC = input[cursor + 1];
	              var nextNextC = input[cursor + 2];
	              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	                this._path = base._path.slice();
	                this._path.pop();
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'relative slash':
	            if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              if (this._scheme === 'file') {
	                state = 'file host';
	              } else {
	                state = 'authority ignore slashes';
	              }
	            } else {
	              if (this._scheme !== 'file') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'authority first slash':
	            if (c === '/') {
	              state = 'authority second slash';
	            } else {
	              err('Expected \'/\', got: ' + c);
	              state = 'authority ignore slashes';
	              continue;
	            }
	            break;
	          case 'authority second slash':
	            state = 'authority ignore slashes';
	            if (c !== '/') {
	              err('Expected \'/\', got: ' + c);
	              continue;
	            }
	            break;
	          case 'authority ignore slashes':
	            if (c !== '/' && c !== '\\') {
	              state = 'authority';
	              continue;
	            } else {
	              err('Expected authority, got: ' + c);
	            }
	            break;
	          case 'authority':
	            if (c === '@') {
	              if (seenAt) {
	                err('@ already seen.');
	                buffer += '%40';
	              }
	              seenAt = true;
	              for (var i = 0; i < buffer.length; i++) {
	                var cp = buffer[i];
	                if (cp === '\t' || cp === '\n' || cp === '\r') {
	                  err('Invalid whitespace in authority.');
	                  continue;
	                }
	                if (cp === ':' && this._password === null) {
	                  this._password = '';
	                  continue;
	                }
	                var tempC = percentEscape(cp);
	                if (this._password !== null) {
	                  this._password += tempC;
	                } else {
	                  this._username += tempC;
	                }
	              }
	              buffer = '';
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              cursor -= buffer.length;
	              buffer = '';
	              state = 'host';
	              continue;
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'file host':
	            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
	                state = 'relative path';
	              } else if (buffer.length === 0) {
	                state = 'relative path start';
	              } else {
	                this._host = IDNAToASCII.call(this, buffer);
	                buffer = '';
	                state = 'relative path start';
	              }
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid whitespace in file host.');
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'host':
	          case 'hostname':
	            if (c === ':' && !seenBracket) {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'port';
	              if (stateOverride === 'hostname') {
	                break loop;
	              }
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'relative path start';
	              if (stateOverride) {
	                break loop;
	              }
	              continue;
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              if (c === '[') {
	                seenBracket = true;
	              } else if (c === ']') {
	                seenBracket = false;
	              }
	              buffer += c;
	            } else {
	              err('Invalid code point in host/hostname: ' + c);
	            }
	            break;
	          case 'port':
	            if (/[0-9]/.test(c)) {
	              buffer += c;
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
	              if (buffer !== '') {
	                var temp = parseInt(buffer, 10);
	                if (temp !== relative[this._scheme]) {
	                  this._port = temp + '';
	                }
	                buffer = '';
	              }
	              if (stateOverride) {
	                break loop;
	              }
	              state = 'relative path start';
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid code point in port: ' + c);
	            } else {
	              invalid.call(this);
	            }
	            break;
	          case 'relative path start':
	            if (c === '\\') {
	              err('\'\\\' not allowed in path.');
	            }
	            state = 'relative path';
	            if (c !== '/' && c !== '\\') {
	              continue;
	            }
	            break;
	          case 'relative path':
	            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
	              if (c === '\\') {
	                err('\\ not allowed in relative path.');
	              }
	              var tmp;
	              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
	                buffer = tmp;
	              }
	              if (buffer === '..') {
	                this._path.pop();
	                if (c !== '/' && c !== '\\') {
	                  this._path.push('');
	                }
	              } else if (buffer === '.' && c !== '/' && c !== '\\') {
	                this._path.push('');
	              } else if (buffer !== '.') {
	                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
	                  buffer = buffer[0] + ':';
	                }
	                this._path.push(buffer);
	              }
	              buffer = '';
	              if (c === '?') {
	                this._query = '?';
	                state = 'query';
	              } else if (c === '#') {
	                this._fragment = '#';
	                state = 'fragment';
	              }
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              buffer += percentEscape(c);
	            }
	            break;
	          case 'query':
	            if (!stateOverride && c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._query += percentEscapeQuery(c);
	            }
	            break;
	          case 'fragment':
	            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._fragment += c;
	            }
	            break;
	        }
	        cursor++;
	      }
	    }
	    function clear() {
	      this._scheme = '';
	      this._schemeData = '';
	      this._username = '';
	      this._password = null;
	      this._host = '';
	      this._port = '';
	      this._path = [];
	      this._query = '';
	      this._fragment = '';
	      this._isInvalid = false;
	      this._isRelative = false;
	    }
	    function JURL(url, base) {
	      if (base !== undefined && !(base instanceof JURL)) {
	        base = new JURL(String(base));
	      }
	      this._url = url;
	      clear.call(this);
	      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
	      parse.call(this, input, null, base);
	    }
	    JURL.prototype = {
	      toString: function toString() {
	        return this.href;
	      },
	
	      get href() {
	        if (this._isInvalid) {
	          return this._url;
	        }
	        var authority = '';
	        if (this._username !== '' || this._password !== null) {
	          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
	        }
	        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
	      },
	      set href(href) {
	        clear.call(this);
	        parse.call(this, href);
	      },
	      get protocol() {
	        return this._scheme + ':';
	      },
	      set protocol(protocol) {
	        if (this._isInvalid) {
	          return;
	        }
	        parse.call(this, protocol + ':', 'scheme start');
	      },
	      get host() {
	        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
	      },
	      set host(host) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, host, 'host');
	      },
	      get hostname() {
	        return this._host;
	      },
	      set hostname(hostname) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, hostname, 'hostname');
	      },
	      get port() {
	        return this._port;
	      },
	      set port(port) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, port, 'port');
	      },
	      get pathname() {
	        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
	      },
	      set pathname(pathname) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._path = [];
	        parse.call(this, pathname, 'relative path start');
	      },
	      get search() {
	        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
	      },
	      set search(search) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._query = '?';
	        if (search[0] === '?') {
	          search = search.slice(1);
	        }
	        parse.call(this, search, 'query');
	      },
	      get hash() {
	        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
	      },
	      set hash(hash) {
	        if (this._isInvalid) {
	          return;
	        }
	        this._fragment = '#';
	        if (hash[0] === '#') {
	          hash = hash.slice(1);
	        }
	        parse.call(this, hash, 'fragment');
	      },
	      get origin() {
	        var host;
	        if (this._isInvalid || !this._scheme) {
	          return '';
	        }
	        switch (this._scheme) {
	          case 'data':
	          case 'file':
	          case 'javascript':
	          case 'mailto':
	            return 'null';
	        }
	        host = this.host;
	        if (!host) {
	          return '';
	        }
	        return this._scheme + '://' + host;
	      }
	    };
	    var OriginalURL = globalScope.URL;
	    if (OriginalURL) {
	      JURL.createObjectURL = function (blob) {
	        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
	      };
	      JURL.revokeObjectURL = function (url) {
	        OriginalURL.revokeObjectURL(url);
	      };
	    }
	    globalScope.URL = JURL;
	  })();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var g;
	g = function () {
	  return this;
	}();
	try {
	  g = g || Function("return this")() || (1, eval)("this");
	} catch (e) {
	  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
	}
	module.exports = g;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	__webpack_require__(0);
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=compatibility.js.map

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(146);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(146);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(17);
	var invariant = __webpack_require__(2);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(17);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var ReactPropTypesSecret = __webpack_require__(325);
	var checkPropTypes = __webpack_require__(322);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 325 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	  Symbol.for &&
	  Symbol.for('react.element')) ||
	  0xeac7;
	
	var emptyFunction = __webpack_require__(17);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	var didWarnAboutMaps = false;
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function(match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	function traverseAllChildrenImpl(
	  children,
	  nameSoFar,
	  callback,
	  traverseContext
	) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (
	    children === null ||
	    type === 'string' ||
	    type === 'number' ||
	    // The following is inlined from ReactElement. This means we can optimize
	    // some checks. React Fiber also inlines this logic for similar purposes.
	    (type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE)
	  ) {
	    callback(
	      traverseContext,
	      children,
	      // If it's the only child, treat the name as if it was wrapped in an array
	      // so that it's consistent if the number of children grows.
	      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar
	    );
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(
	        child,
	        nextName,
	        callback,
	        traverseContext
	      );
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      if (false) {
	        // Warn about using Maps as children
	        if (iteratorFn === children.entries) {
	          warning(
	            didWarnAboutMaps,
	            'Using Maps as children is unsupported and will likely yield ' +
	              'unexpected results. Convert it to a sequence/iterable of keyed ' +
	              'ReactElements instead.'
	          );
	          didWarnAboutMaps = true;
	        }
	      }
	
	      var iterator = iteratorFn.call(children);
	      var step;
	      var ii = 0;
	      while (!(step = iterator.next()).done) {
	        child = step.value;
	        nextName = nextNamePrefix + getComponentKey(child, ii++);
	        subtreeCount += traverseAllChildrenImpl(
	          child,
	          nextName,
	          callback,
	          traverseContext
	        );
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' +
	          'instead or wrap the object using createFragment(object) from the ' +
	          'React add-ons.';
	      }
	      var childrenString = '' + children;
	      invariant(
	        false,
	        'Objects are not valid as a React child (found: %s).%s',
	        childrenString === '[object Object]'
	          ? 'object with keys {' + Object.keys(children).join(', ') + '}'
	          : childrenString,
	        addendum
	      );
	    }
	  }
	
	  return subtreeCount;
	}
	
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	function cloneAndReplaceKey(oldElement, newKey) {
	  return React.cloneElement(
	    oldElement,
	    { key: newKey },
	    oldElement.props !== undefined
	      ? oldElement.props.children
	      : undefined
	  );
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	var oneArgumentPooler = function(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var addPoolingTo = function addPoolingTo(
	  CopyConstructor,
	  pooler
	) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  invariant(
	    instance instanceof Klass,
	    'Trying to release an instance into a pool of a different type.'
	  );
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function() {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(
	      mappedChild,
	      result,
	      childKey,
	      emptyFunction.thatReturnsArgument
	    );
	  } else if (mappedChild != null) {
	    if (React.isValidElement(mappedChild)) {
	      mappedChild = cloneAndReplaceKey(
	        mappedChild,
	        // Keep both the (mapped) and old keys if they differ, just as
	        // traverseAllChildren used to do for objects as children
	        keyPrefix +
	          (mappedChild.key && (!child || child.key !== mappedChild.key)
	            ? escapeUserProvidedKey(mappedChild.key) + '/'
	            : '') +
	          childKey
	      );
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(
	    array,
	    escapedPrefix,
	    func,
	    context
	  );
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	var numericPropertyRegex = /^\d+$/;
	
	var warnedAboutNumeric = false;
	
	function createReactFragment(object) {
	  if (typeof object !== 'object' || !object || Array.isArray(object)) {
	    warning(
	      false,
	      'React.addons.createFragment only accepts a single object. Got: %s',
	      object
	    );
	    return object;
	  }
	  if (React.isValidElement(object)) {
	    warning(
	      false,
	      'React.addons.createFragment does not accept a ReactElement ' +
	        'without a wrapper object.'
	    );
	    return object;
	  }
	
	  invariant(
	    object.nodeType !== 1,
	    'React.addons.createFragment(...): Encountered an invalid child; DOM ' +
	      'elements are not valid children of React components.'
	  );
	
	  var result = [];
	
	  for (var key in object) {
	    if (false) {
	      if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
	        warning(
	          false,
	          'React.addons.createFragment(...): Child objects should have ' +
	            'non-numeric keys so ordering is preserved.'
	        );
	        warnedAboutNumeric = true;
	      }
	    }
	    mapIntoWithKeyPrefixInternal(
	      object[key],
	      result,
	      key,
	      emptyFunction.thatReturnsArgument
	    );
	  }
	
	  return result;
	}
	
	module.exports = createReactFragment;


/***/ },
/* 327 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(13);
	
	var focusNode = __webpack_require__(134);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(42);
	var ExecutionEnvironment = __webpack_require__(16);
	var FallbackCompositionState = __webpack_require__(336);
	var SyntheticCompositionEvent = __webpack_require__(373);
	var SyntheticInputEvent = __webpack_require__(376);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(147);
	var ExecutionEnvironment = __webpack_require__(16);
	var ReactInstrumentation = __webpack_require__(20);
	
	var camelizeStyleName = __webpack_require__(241);
	var dangerousStyleValue = __webpack_require__(382);
	var hyphenateStyleName = __webpack_require__(248);
	var memoizeStringOnly = __webpack_require__(252);
	var warning = __webpack_require__(3);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(41);
	var EventPropagators = __webpack_require__(42);
	var ExecutionEnvironment = __webpack_require__(16);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactUpdates = __webpack_require__(22);
	var SyntheticEvent = __webpack_require__(23);
	
	var getEventTarget = __webpack_require__(107);
	var isEventSupported = __webpack_require__(108);
	var isTextInputElement = __webpack_require__(163);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(39);
	var ExecutionEnvironment = __webpack_require__(16);
	
	var createNodesFromMarkup = __webpack_require__(244);
	var emptyFunction = __webpack_require__(17);
	var invariant = __webpack_require__(2);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 333 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(42);
	var ReactDOMComponentTree = __webpack_require__(13);
	var SyntheticMouseEvent = __webpack_require__(67);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 335 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = {
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	};
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes
	};
	
	module.exports = EventConstants;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(32);
	
	var getTextContentAccessor = __webpack_require__(161);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(40);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(43);
	
	var instantiateReactComponent = __webpack_require__(162);
	var KeyEscapeUtils = __webpack_require__(98);
	var shouldUpdateReactComponent = __webpack_require__(109);
	var traverseAllChildren = __webpack_require__(165);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"."}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(113);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(95);
	var ReactDOMIDOperations = __webpack_require__(346);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var React = __webpack_require__(33);
	var ReactComponentEnvironment = __webpack_require__(100);
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactErrorUtils = __webpack_require__(101);
	var ReactInstanceMap = __webpack_require__(57);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactNodeTypes = __webpack_require__(157);
	var ReactReconciler = __webpack_require__(43);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(53);
	var invariant = __webpack_require__(2);
	var shallowEqual = __webpack_require__(54);
	var shouldUpdateReactComponent = __webpack_require__(109);
	var warning = __webpack_require__(3);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactDefaultInjection = __webpack_require__(354);
	var ReactMount = __webpack_require__(156);
	var ReactReconciler = __webpack_require__(43);
	var ReactUpdates = __webpack_require__(22);
	var ReactVersion = __webpack_require__(367);
	
	var findDOMNode = __webpack_require__(383);
	var getHostComponentFromComposite = __webpack_require__(160);
	var renderSubtreeIntoContainer = __webpack_require__(390);
	var warning = __webpack_require__(3);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var AutoFocusUtils = __webpack_require__(328);
	var CSSPropertyOperations = __webpack_require__(330);
	var DOMLazyTree = __webpack_require__(39);
	var DOMNamespaces = __webpack_require__(96);
	var DOMProperty = __webpack_require__(40);
	var DOMPropertyOperations = __webpack_require__(149);
	var EventPluginHub = __webpack_require__(41);
	var EventPluginRegistry = __webpack_require__(97);
	var ReactBrowserEventEmitter = __webpack_require__(66);
	var ReactDOMComponentFlags = __webpack_require__(150);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactDOMInput = __webpack_require__(347);
	var ReactDOMOption = __webpack_require__(348);
	var ReactDOMSelect = __webpack_require__(151);
	var ReactDOMTextarea = __webpack_require__(351);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactMultiChild = __webpack_require__(360);
	var ReactServerRenderingTransaction = __webpack_require__(365);
	
	var emptyFunction = __webpack_require__(17);
	var escapeTextContentForBrowser = __webpack_require__(69);
	var invariant = __webpack_require__(2);
	var isEventSupported = __webpack_require__(108);
	var shallowEqual = __webpack_require__(54);
	var validateDOMNesting = __webpack_require__(110);
	var warning = __webpack_require__(3);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(110);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(39);
	var ReactDOMComponentTree = __webpack_require__(13);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 345 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(95);
	var ReactDOMComponentTree = __webpack_require__(13);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var DOMPropertyOperations = __webpack_require__(149);
	var LinkedValueUtils = __webpack_require__(99);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactUpdates = __webpack_require__(22);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        // eslint-disable-next-line
	        if (value != valueAsNumber) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	        // eslint-disable-next-line
	      } else if (value != node.value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var React = __webpack_require__(33);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactDOMSelect = __webpack_require__(151);
	
	var warning = __webpack_require__(3);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(16);
	
	var getNodeForCharacterOffset = __webpack_require__(387);
	var getTextContentAccessor = __webpack_require__(161);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var DOMChildrenOperations = __webpack_require__(95);
	var DOMLazyTree = __webpack_require__(39);
	var ReactDOMComponentTree = __webpack_require__(13);
	
	var escapeTextContentForBrowser = __webpack_require__(69);
	var invariant = __webpack_require__(2);
	var validateDOMNesting = __webpack_require__(110);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var LinkedValueUtils = __webpack_require__(99);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactUpdates = __webpack_require__(22);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactUpdates = __webpack_require__(22);
	var Transaction = __webpack_require__(68);
	
	var emptyFunction = __webpack_require__(17);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(327);
	var BeforeInputEventPlugin = __webpack_require__(329);
	var ChangeEventPlugin = __webpack_require__(331);
	var DefaultEventPluginOrder = __webpack_require__(333);
	var EnterLeaveEventPlugin = __webpack_require__(334);
	var HTMLDOMPropertyConfig = __webpack_require__(337);
	var ReactComponentBrowserEnvironment = __webpack_require__(339);
	var ReactDOMComponent = __webpack_require__(342);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactDOMEmptyComponent = __webpack_require__(344);
	var ReactDOMTreeTraversal = __webpack_require__(352);
	var ReactDOMTextComponent = __webpack_require__(350);
	var ReactDefaultBatchingStrategy = __webpack_require__(353);
	var ReactEventListener = __webpack_require__(357);
	var ReactInjection = __webpack_require__(358);
	var ReactReconcileTransaction = __webpack_require__(363);
	var SVGDOMPropertyConfig = __webpack_require__(368);
	var SelectEventPlugin = __webpack_require__(369);
	var SimpleEventPlugin = __webpack_require__(370);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 355 */
168,
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(41);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventListener = __webpack_require__(133);
	var ExecutionEnvironment = __webpack_require__(16);
	var PooledClass = __webpack_require__(32);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactUpdates = __webpack_require__(22);
	
	var getEventTarget = __webpack_require__(107);
	var getUnboundedScrollPosition = __webpack_require__(246);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(40);
	var EventPluginHub = __webpack_require__(41);
	var EventPluginUtils = __webpack_require__(65);
	var ReactComponentEnvironment = __webpack_require__(100);
	var ReactEmptyComponent = __webpack_require__(152);
	var ReactBrowserEventEmitter = __webpack_require__(66);
	var ReactHostComponent = __webpack_require__(154);
	var ReactUpdates = __webpack_require__(22);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(381);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactComponentEnvironment = __webpack_require__(100);
	var ReactInstanceMap = __webpack_require__(57);
	var ReactInstrumentation = __webpack_require__(20);
	
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactReconciler = __webpack_require__(43);
	var ReactChildReconciler = __webpack_require__(338);
	
	var emptyFunction = __webpack_require__(17);
	var flattenChildren = __webpack_require__(384);
	var invariant = __webpack_require__(2);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 362 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(148);
	var PooledClass = __webpack_require__(32);
	var ReactBrowserEventEmitter = __webpack_require__(66);
	var ReactInputSelection = __webpack_require__(155);
	var ReactInstrumentation = __webpack_require__(20);
	var Transaction = __webpack_require__(68);
	var ReactUpdateQueue = __webpack_require__(102);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(361);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(32);
	var Transaction = __webpack_require__(68);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactServerUpdateQueue = __webpack_require__(366);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(102);
	
	var warning = __webpack_require__(3);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 367 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ },
/* 368 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(42);
	var ExecutionEnvironment = __webpack_require__(16);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactInputSelection = __webpack_require__(155);
	var SyntheticEvent = __webpack_require__(23);
	
	var getActiveElement = __webpack_require__(135);
	var isTextInputElement = __webpack_require__(163);
	var shallowEqual = __webpack_require__(54);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventListener = __webpack_require__(133);
	var EventPropagators = __webpack_require__(42);
	var ReactDOMComponentTree = __webpack_require__(13);
	var SyntheticAnimationEvent = __webpack_require__(371);
	var SyntheticClipboardEvent = __webpack_require__(372);
	var SyntheticEvent = __webpack_require__(23);
	var SyntheticFocusEvent = __webpack_require__(375);
	var SyntheticKeyboardEvent = __webpack_require__(377);
	var SyntheticMouseEvent = __webpack_require__(67);
	var SyntheticDragEvent = __webpack_require__(374);
	var SyntheticTouchEvent = __webpack_require__(378);
	var SyntheticTransitionEvent = __webpack_require__(379);
	var SyntheticUIEvent = __webpack_require__(44);
	var SyntheticWheelEvent = __webpack_require__(380);
	
	var emptyFunction = __webpack_require__(17);
	var getEventCharCode = __webpack_require__(105);
	var invariant = __webpack_require__(2);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(23);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(23);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(23);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(67);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(44);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(23);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(44);
	
	var getEventCharCode = __webpack_require__(105);
	var getEventKey = __webpack_require__(385);
	var getEventModifierState = __webpack_require__(106);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(44);
	
	var getEventModifierState = __webpack_require__(106);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(23);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(67);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 381 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(147);
	var warning = __webpack_require__(3);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(13);
	var ReactInstanceMap = __webpack_require__(57);
	
	var getHostComponentFromComposite = __webpack_require__(160);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(98);
	var traverseAllChildren = __webpack_require__(165);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"."}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(113);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(105);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 386 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 387 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(16);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(69);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(156);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(117);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	exports.default = defineProperty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	function defineProperty(o, p, attr) {
	  return (0, _defineProperty2.default)(o, p, attr);
	}

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(12);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(11);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(59);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(118);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(14);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(116);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.withOptions = withOptions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(54);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _supports = __webpack_require__(393);
	
	var supports = _interopRequireWildcard(_supports);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	/* eslint-disable prefer-spread */
	
	function mergeDefaultEventOptions(options) {
	  return (0, _assign2.default)({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(supports.passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  if (supports.addEventListener) {
	    target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.attachEvent) {
	    // IE8+ Support
	    target.attachEvent('on' + eventName, function () {
	      callback.call(target);
	    });
	  }
	}
	
	function off(target, eventName, callback, options) {
	  if (supports.removeEventListener) {
	    target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.detachEvent) {
	    // IE8+ Support
	    target.detachEvent('on' + eventName, callback);
	  }
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);
	
	
	  (0, _keys2.default)(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? (0, _warning2.default)(options, 'react-event-listener: Should be specified options in withOptions.') : void 0;
	
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener = function (_Component) {
	  (0, _inherits3.default)(EventListener, _Component);
	
	  function EventListener() {
	    (0, _classCallCheck3.default)(this, EventListener);
	    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EventListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: 'applyListeners',
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	  return EventListener;
	}(_react.Component);
	
	 false ? EventListener.propTypes = {
	  /**
	   * You can provide a single child too.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * The DOM target to listen to.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
	} : void 0;
	exports.default = EventListener;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.passiveOption = exports.detachEvent = exports.attachEvent = exports.removeEventListener = exports.addEventListener = exports.canUseDOM = undefined;
	
	var _defineProperty = __webpack_require__(391);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inspired by https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/ExecutionEnvironment.js
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = canUseDOM && 'addEventListener' in window;
	var removeEventListener = exports.removeEventListener = canUseDOM && 'removeEventListener' in window;
	
	// IE8+ Support
	var attachEvent = exports.attachEvent = canUseDOM && 'attachEvent' in window;
	var detachEvent = exports.detachEvent = canUseDOM && 'detachEvent' in window;
	
	// Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	var passiveOption = exports.passiveOption = function () {
	  var cache = null;
	
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, (0, _defineProperty2.default)({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (e) {} // eslint-disable-line no-empty
	
	    cache = supportsPassiveOption;
	
	    return supportsPassiveOption;
	  }();
	}();

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(278);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _props3 = __webpack_require__(111);
	
	var _YouTube = __webpack_require__(402);
	
	var _YouTube2 = _interopRequireDefault(_YouTube);
	
	var _SoundCloud = __webpack_require__(397);
	
	var _SoundCloud2 = _interopRequireDefault(_SoundCloud);
	
	var _Vimeo = __webpack_require__(400);
	
	var _Vimeo2 = _interopRequireDefault(_Vimeo);
	
	var _Facebook = __webpack_require__(396);
	
	var _Facebook2 = _interopRequireDefault(_Facebook);
	
	var _FilePlayer = __webpack_require__(71);
	
	var _FilePlayer2 = _interopRequireDefault(_FilePlayer);
	
	var _Streamable = __webpack_require__(398);
	
	var _Streamable2 = _interopRequireDefault(_Streamable);
	
	var _Vidme = __webpack_require__(399);
	
	var _Vidme2 = _interopRequireDefault(_Vidme);
	
	var _Wistia = __webpack_require__(401);
	
	var _Wistia2 = _interopRequireDefault(_Wistia);
	
	var _DailyMotion = __webpack_require__(395);
	
	var _DailyMotion2 = _interopRequireDefault(_DailyMotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactPlayer = function (_Component) {
	  _inherits(ReactPlayer, _Component);
	
	  function ReactPlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactPlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.seekTo = function (fraction) {
	      if (_this.player) {
	        _this.player.seekTo(fraction);
	      }
	    }, _this.getDuration = function () {
	      if (!_this.player) return null;
	      return _this.player.getDuration();
	    }, _this.getCurrentTime = function () {
	      if (!_this.player) return null;
	      var duration = _this.player.getDuration();
	      var fractionPlayed = _this.player.getFractionPlayed();
	      if (duration === null || fractionPlayed === null) {
	        return null;
	      }
	      return fractionPlayed * duration;
	    }, _this.progress = function () {
	      if (_this.props.url && _this.player) {
	        var loaded = _this.player.getFractionLoaded() || 0;
	        var played = _this.player.getFractionPlayed() || 0;
	        var duration = _this.player.getDuration();
	        var progress = {};
	        if (loaded !== _this.prevLoaded) {
	          progress.loaded = loaded;
	          if (duration) {
	            progress.loadedSeconds = progress.loaded * duration;
	          }
	        }
	        if (played !== _this.prevPlayed) {
	          progress.played = played;
	          if (duration) {
	            progress.playedSeconds = progress.played * duration;
	          }
	        }
	        if (progress.loaded || progress.played) {
	          _this.props.onProgress(progress);
	        }
	        _this.prevLoaded = loaded;
	        _this.prevPlayed = played;
	      }
	      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency);
	    }, _this.ref = function (player) {
	      _this.player = player;
	    }, _this.renderPlayer = function (Player) {
	      var active = Player.canPlay(_this.props.url);
	
	      var _this$props = _this.props,
	          youtubeConfig = _this$props.youtubeConfig,
	          vimeoConfig = _this$props.vimeoConfig,
	          dailymotionConfig = _this$props.dailymotionConfig,
	          activeProps = _objectWithoutProperties(_this$props, ['youtubeConfig', 'vimeoConfig', 'dailymotionConfig']);
	
	      var props = active ? _extends({}, activeProps, { ref: _this.ref }) : {};
	      // Only youtube and vimeo config passed to
	      // inactive players due to preload behaviour
	      return _react2['default'].createElement(Player, _extends({
	        key: Player.displayName,
	        youtubeConfig: youtubeConfig,
	        vimeoConfig: vimeoConfig,
	        dailymotionConfig: dailymotionConfig
	      }, props));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReactPlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.progress();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.progressTimeout);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.url !== nextProps.url || this.props.playing !== nextProps.playing || this.props.volume !== nextProps.volume || this.props.playbackRate !== nextProps.playbackRate || this.props.height !== nextProps.height || this.props.width !== nextProps.width || this.props.hidden !== nextProps.hidden;
	    }
	  }, {
	    key: 'renderPlayers',
	    value: function renderPlayers() {
	      // Build array of players to render based on URL and preload config
	      var _props = this.props,
	          url = _props.url,
	          youtubeConfig = _props.youtubeConfig,
	          vimeoConfig = _props.vimeoConfig,
	          dailymotionConfig = _props.dailymotionConfig;
	
	      var players = [];
	      if (_YouTube2['default'].canPlay(url)) {
	        players.push(_YouTube2['default']);
	      } else if (_SoundCloud2['default'].canPlay(url)) {
	        players.push(_SoundCloud2['default']);
	      } else if (_Vimeo2['default'].canPlay(url)) {
	        players.push(_Vimeo2['default']);
	      } else if (_Facebook2['default'].canPlay(url)) {
	        players.push(_Facebook2['default']);
	      } else if (_DailyMotion2['default'].canPlay(url)) {
	        players.push(_DailyMotion2['default']);
	      } else if (_Streamable2['default'].canPlay(url)) {
	        players.push(_Streamable2['default']);
	      } else if (_Vidme2['default'].canPlay(url)) {
	        players.push(_Vidme2['default']);
	      } else if (_Wistia2['default'].canPlay(url)) {
	        players.push(_Wistia2['default']);
	      } else if (url) {
	        // Fall back to FilePlayer if nothing else can play the URL
	        players.push(_FilePlayer2['default']);
	      }
	      // Render additional players if preload config is set
	      if (!_YouTube2['default'].canPlay(url) && youtubeConfig.preload) {
	        players.push(_YouTube2['default']);
	      }
	      if (!_Vimeo2['default'].canPlay(url) && vimeoConfig.preload) {
	        players.push(_Vimeo2['default']);
	      }
	      if (!_DailyMotion2['default'].canPlay(url) && dailymotionConfig.preload) {
	        players.push(_DailyMotion2['default']);
	      }
	      return players.map(this.renderPlayer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          style = _props2.style,
	          width = _props2.width,
	          height = _props2.height;
	
	      var otherProps = (0, _lodash2['default'])(this.props, Object.keys(_props3.propTypes));
	      var players = this.renderPlayers();
	      return _react2['default'].createElement(
	        'div',
	        _extends({ style: _extends({}, style, { width: width, height: height }) }, otherProps),
	        players
	      );
	    }
	  }]);
	
	  return ReactPlayer;
	}(_react.Component);
	
	ReactPlayer.displayName = 'ReactPlayer';
	ReactPlayer.propTypes = _props3.propTypes;
	ReactPlayer.defaultProps = _props3.defaultProps;
	exports['default'] = ReactPlayer;
	module.exports = exports['default'];

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(55);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _Base2 = __webpack_require__(45);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _utils = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://api.dmcdn.net/all.js';
	var SDK_GLOBAL = 'DM';
	var SDK_GLOBAL_READY = 'dmAsyncInit';
	var MATCH_URL = /^.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/;
	var BLANK_VIDEO_URL = 'http://www.dailymotion.com/video/x522udb';
	var DEFAULT_PLAYER_VARS = {
	  autoplay: 0,
	  api: 1,
	  'endscreen-enable': false
	};
	
	var DailyMotion = function (_Base) {
	  _inherits(DailyMotion, _Base);
	
	  function DailyMotion() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DailyMotion);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DailyMotion.__proto__ || Object.getPrototypeOf(DailyMotion)).call.apply(_ref, [this].concat(args))), _this), _this.onDurationChange = function (event) {
	      var onDuration = _this.props.onDuration;
	
	      var duration = _this.getDuration();
	      onDuration(duration);
	    }, _this.onEnded = function () {
	      var _this$props = _this.props,
	          loop = _this$props.loop,
	          onEnded = _this$props.onEnded;
	
	      if (loop) {
	        _this.seekTo(0);
	      }
	      onEnded();
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DailyMotion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          url = _props.url,
	          dailymotionConfig = _props.dailymotionConfig;
	
	      if (!url && dailymotionConfig.preload) {
	        this.preloading = true;
	        this.load(BLANK_VIDEO_URL);
	      }
	      _get(DailyMotion.prototype.__proto__ || Object.getPrototypeOf(DailyMotion.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'getSDK',
	    value: function getSDK() {
	      if (window[SDK_GLOBAL] && window[SDK_GLOBAL].player) {
	        return Promise.resolve(window[SDK_GLOBAL]);
	      }
	      return new Promise(function (resolve, reject) {
	        var previousOnReady = window[SDK_GLOBAL_READY];
	        window[SDK_GLOBAL_READY] = function () {
	          if (previousOnReady) previousOnReady();
	          resolve(window[SDK_GLOBAL]);
	        };
	        (0, _loadScript2['default'])(SDK_URL, function (err) {
	          if (err) {
	            reject(err);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'parseId',
	    value: function parseId(url) {
	      var m = url.match(MATCH_URL);
	      return m[4] || m[2];
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          controls = _props2.controls,
	          dailymotionConfig = _props2.dailymotionConfig,
	          onError = _props2.onError,
	          playing = _props2.playing;
	
	      var id = this.parseId(url);
	      if (this.player) {
	        this.player.load(id, {
	          start: (0, _utils.parseStartTime)(url),
	          autoplay: playing
	        });
	        return;
	      }
	      if (this.loadingSDK) {
	        this.loadOnReady = url;
	        return;
	      }
	      this.loadingSDK = true;
	      this.getSDK().then(function (DM) {
	        var Player = DM.player;
	        _this2.player = new Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          video: id,
	          params: _extends({}, DEFAULT_PLAYER_VARS, {
	            controls: controls,
	            autoplay: _this2.props.playing,
	            start: (0, _utils.parseStartTime)(url),
	            origin: window.location.origin
	          }, dailymotionConfig.params),
	          events: {
	            apiready: function apiready() {
	              _this2.loadingSDK = false;
	            },
	            video_end: _this2.onEnded,
	            durationchange: _this2.onDurationChange,
	            pause: _this2.props.onPause,
	            playing: _this2.onPlay,
	            waiting: _this2.props.onBuffer,
	            loadedmetadata: _this2.onReady,
	            error: function error(event) {
	              return onError(event);
	            }
	          }
	        });
	      }, onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      if (!this.isReady || !this.player.play) return;
	      this.player.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (!this.isReady || !this.player.pause) return;
	      this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(DailyMotion.prototype.__proto__ || Object.getPrototypeOf(DailyMotion.prototype), 'seekTo', this).call(this, fraction);
	      if (!this.isReady || !this.player.seek) return;
	      this.player.seek(this.getDuration() * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      if (!this.isReady || !this.player.setVolume) return;
	      this.player.setVolume(fraction);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate() {
	      return null;
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady || !this.player.duration) return null;
	      return this.player.duration;
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady || !this.getDuration()) return null;
	      return this.player.currentTime / this.getDuration();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      if (!this.isReady || !this.getDuration() || !this.player.bufferedTime) return null;
	      return this.player.bufferedTime / this.getDuration();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%',
	        backgroundColor: 'black',
	        display: this.props.url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('div', { ref: this.ref })
	      );
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return DailyMotion;
	}(_Base3['default']);
	
	DailyMotion.displayName = 'DailyMotion';
	exports['default'] = DailyMotion;
	module.exports = exports['default'];

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(55);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _Base2 = __webpack_require__(45);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//connect.facebook.net/en_US/sdk.js';
	var SDK_GLOBAL = 'FB';
	var SDK_GLOBAL_READY = 'fbAsyncInit';
	var MATCH_URL = /^https:\/\/www\.facebook\.com\/([^/?].+\/)?video(s|\.php)[/?].*$/;
	var PLAYER_ID_PREFIX = 'facebook-player-';
	
	var YouTube = function (_Base) {
	  _inherits(YouTube, _Base);
	
	  function YouTube() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, YouTube);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.playerID = PLAYER_ID_PREFIX + randomString(), _this.onEnded = function () {
	      var _this$props = _this.props,
	          loop = _this$props.loop,
	          onEnded = _this$props.onEnded;
	
	      if (loop) {
	        _this.seekTo(0);
	      }
	      onEnded();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(YouTube, [{
	    key: 'getSDK',
	    value: function getSDK() {
	      if (window[SDK_GLOBAL]) {
	        return Promise.resolve(window[SDK_GLOBAL]);
	      }
	      return new Promise(function (resolve, reject) {
	        var previousOnReady = window[SDK_GLOBAL_READY];
	        window[SDK_GLOBAL_READY] = function () {
	          if (previousOnReady) previousOnReady();
	          resolve(window[SDK_GLOBAL]);
	        };
	        (0, _loadScript2['default'])(SDK_URL, function (err) {
	          if (err) reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      if (this.isReady) {
	        this.getSDK().then(function (FB) {
	          return FB.XFBML.parse();
	        });
	        return;
	      }
	      this.getSDK().then(function (FB) {
	        FB.init({
	          appId: _this2.props.facebookConfig.appId,
	          xfbml: true,
	          version: 'v2.5'
	        });
	        FB.Event.subscribe('xfbml.ready', function (msg) {
	          if (msg.type === 'video' && msg.id === _this2.playerID) {
	            _this2.player = msg.instance;
	            _this2.player.subscribe('startedPlaying', _this2.onPlay);
	            _this2.player.subscribe('paused', _this2.props.onPause);
	            _this2.player.subscribe('finishedPlaying', _this2.onEnded);
	            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);
	            _this2.player.subscribe('error', _this2.props.onError);
	            _this2.onReady();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      if (!this.isReady) return;
	      this.player.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (!this.isReady) return;
	      this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // No need to stop
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'seekTo', this).call(this, fraction);
	      if (!this.isReady) return;
	      this.player.seek(this.getDuration() * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      if (!this.isReady) return;
	      this.player.setVolume(fraction);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate() {
	      return null;
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady) return null;
	      return this.player.getDuration();
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady || !this.getDuration()) return null;
	      return this.player.getCurrentPosition() / this.getDuration();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%',
	        backgroundColor: 'black'
	      };
	      return _react2['default'].createElement('div', {
	        style: style,
	        id: this.playerID,
	        className: 'fb-video',
	        'data-href': this.props.url,
	        'data-allowfullscreen': 'true',
	        'data-controls': !this.props.controls ? 'false' : undefined
	      });
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return YouTube;
	}(_Base3['default']);
	
	// http://stackoverflow.com/a/38622545
	
	
	YouTube.displayName = 'Facebook';
	exports['default'] = YouTube;
	function randomString() {
	  return Math.random().toString(36).substr(2, 5);
	}
	module.exports = exports['default'];

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchJsonp = __webpack_require__(253);
	
	var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);
	
	var _FilePlayer2 = __webpack_require__(71);
	
	var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);
	
	var _props3 = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESOLVE_URL = '//api.soundcloud.com/resolve.json';
	var MATCH_URL = /^https?:\/\/(soundcloud.com|snd.sc)\/([a-z0-9-_]+\/[a-z0-9-_]+)$/;
	
	var songData = {}; // Cache song data requests
	
	var SoundCloud = function (_FilePlayer) {
	  _inherits(SoundCloud, _FilePlayer);
	
	  function SoundCloud() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SoundCloud);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      image: null
	    }, _this.clientId = _this.props.soundcloudConfig.clientId || _props3.defaultProps.soundcloudConfig.clientId, _this.ref = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SoundCloud, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return _get(SoundCloud.prototype.__proto__ || Object.getPrototypeOf(SoundCloud.prototype), 'shouldComponentUpdate', this).call(this, nextProps, nextState) || this.state.image !== nextState.image;
	    }
	  }, {
	    key: 'getSongData',
	    value: function getSongData(url) {
	      var _this2 = this;
	
	      if (songData[url]) {
	        return Promise.resolve(songData[url]);
	      }
	      return (0, _fetchJsonp2['default'])(RESOLVE_URL + '?url=' + url + '&client_id=' + this.clientId).then(function (response) {
	        if (response.ok) {
	          songData[url] = response.json();
	          return songData[url];
	        } else {
	          _this2.props.onError(new Error('SoundCloud track could not be resolved'));
	        }
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this3 = this;
	
	      var _props = this.props,
	          soundcloudConfig = _props.soundcloudConfig,
	          onError = _props.onError;
	
	      this.stop();
	      this.getSongData(url).then(function (data) {
	        if (!_this3.mounted) return;
	        if (!data.streamable) {
	          onError(new Error('SoundCloud track is not streamable'));
	          return;
	        }
	        var image = data.artwork_url || data.user.avatar_url;
	        if (image && soundcloudConfig.showArtwork) {
	          _this3.setState({ image: image.replace('-large', '-t500x500') });
	        }
	        _this3.player.src = data.stream_url + '?client_id=' + _this3.clientId;
	      }, onError);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          url = _props2.url,
	          loop = _props2.loop,
	          controls = _props2.controls;
	
	      var style = {
	        display: url ? 'block' : 'none',
	        height: '100%',
	        backgroundImage: this.state.image ? 'url(' + this.state.image + ')' : null,
	        backgroundSize: 'cover',
	        backgroundPosition: 'center'
	      };
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('audio', {
	          ref: this.ref,
	          type: 'audio/mpeg',
	          preload: 'auto',
	          style: {
	            width: '100%',
	            height: '100%'
	          },
	          controls: controls,
	          loop: loop
	        })
	      );
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return SoundCloud;
	}(_FilePlayer3['default']);
	
	SoundCloud.displayName = 'SoundCloud';
	exports['default'] = SoundCloud;
	module.exports = exports['default'];

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FilePlayer2 = __webpack_require__(71);
	
	var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESOLVE_URL = 'https://api.streamable.com/videos/';
	var MATCH_URL = /^https?:\/\/streamable.com\/([a-z0-9]+)$/;
	
	var cache = {}; // Cache song data requests
	
	var Streamable = function (_FilePlayer) {
	  _inherits(Streamable, _FilePlayer);
	
	  function Streamable() {
	    _classCallCheck(this, Streamable);
	
	    return _possibleConstructorReturn(this, (Streamable.__proto__ || Object.getPrototypeOf(Streamable)).apply(this, arguments));
	  }
	
	  _createClass(Streamable, [{
	    key: 'getData',
	    value: function getData(url) {
	      var onError = this.props.onError;
	
	      var id = url.match(MATCH_URL)[1];
	      if (cache[id]) {
	        return Promise.resolve(cache[id]);
	      }
	      return window.fetch(RESOLVE_URL + id).then(function (response) {
	        if (response.status === 200) {
	          cache[id] = response.json();
	          return cache[id];
	        } else {
	          onError(new Error('Streamable track could not be resolved'));
	        }
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var onError = this.props.onError;
	
	      this.stop();
	      this.getData(url).then(function (data) {
	        if (!_this2.mounted) return;
	        _this2.player.src = data.files.mp4.url;
	      }, onError);
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Streamable;
	}(_FilePlayer3['default']);
	
	Streamable.displayName = 'Streamable';
	exports['default'] = Streamable;
	module.exports = exports['default'];

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FilePlayer2 = __webpack_require__(71);
	
	var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESOLVE_URL = 'https://api.vid.me/videoByUrl/';
	var MATCH_URL = /^https?:\/\/vid.me\/([a-z0-9]+)$/i;
	
	var cache = {}; // Cache song data requests
	
	var Vidme = function (_FilePlayer) {
	  _inherits(Vidme, _FilePlayer);
	
	  function Vidme() {
	    _classCallCheck(this, Vidme);
	
	    return _possibleConstructorReturn(this, (Vidme.__proto__ || Object.getPrototypeOf(Vidme)).apply(this, arguments));
	  }
	
	  _createClass(Vidme, [{
	    key: 'getData',
	    value: function getData(url) {
	      var onError = this.props.onError;
	
	      var id = url.match(MATCH_URL)[1];
	      if (cache[id]) {
	        return Promise.resolve(cache[id]);
	      }
	      return window.fetch(RESOLVE_URL + id).then(function (response) {
	        if (response.status === 200) {
	          cache[id] = response.json();
	          return cache[id];
	        } else {
	          onError(new Error('Vidme track could not be resolved'));
	        }
	      });
	    }
	  }, {
	    key: 'getURL',
	    value: function getURL(_ref) {
	      var video = _ref.video;
	      var vidmeConfig = this.props.vidmeConfig;
	
	      if (vidmeConfig.format && video.formats && video.formats.length !== 0) {
	        var index = video.formats.findIndex(function (f) {
	          return f.type === vidmeConfig.format;
	        });
	        if (index !== -1) {
	          return video.formats[index].uri;
	        } else {
	          console.warn('Vidme format "' + vidmeConfig.format + '" was not found for ' + video.full_url);
	        }
	      }
	      return video.complete_url;
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var onError = this.props.onError;
	
	      this.stop();
	      this.getData(url).then(function (data) {
	        if (!_this2.mounted) return;
	        _this2.player.src = _this2.getURL(data);
	      }, onError);
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Vidme;
	}(_FilePlayer3['default']);
	
	Vidme.displayName = 'Vidme';
	exports['default'] = Vidme;
	module.exports = exports['default'];

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _loadScript = __webpack_require__(55);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _Base2 = __webpack_require__(45);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://player.vimeo.com/api/player.js';
	var SDK_GLOBAL = 'Vimeo';
	var MATCH_URL = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
	var BLANK_VIDEO_URL = 'https://vimeo.com/127250231';
	
	var DEFAULT_OPTIONS = {
	  autopause: false,
	  autoplay: false,
	  byline: false,
	  portrait: false,
	  title: false
	};
	
	var Vimeo = function (_Base) {
	  _inherits(Vimeo, _Base);
	
	  function Vimeo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Vimeo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Vimeo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          url = _props.url,
	          vimeoConfig = _props.vimeoConfig;
	
	      if (!url && vimeoConfig.preload) {
	        this.preloading = true;
	        this.load(BLANK_VIDEO_URL);
	      }
	      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'getSDK',
	    value: function getSDK() {
	      if (window[SDK_GLOBAL]) {
	        return Promise.resolve(window[SDK_GLOBAL]);
	      }
	      return new Promise(function (resolve, reject) {
	        (0, _loadScript2['default'])(SDK_URL, function (err) {
	          if (err) reject(err);else resolve(window[SDK_GLOBAL]);
	        });
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var id = url.match(MATCH_URL)[3];
	      this.duration = null;
	      if (this.isReady) {
	        this.player.loadVideo(id);
	        return;
	      }
	      if (this.loadingSDK) {
	        this.loadOnReady = url;
	        return;
	      }
	      this.loadingSDK = true;
	      this.getSDK().then(function (Vimeo) {
	        _this2.player = new Vimeo.Player(_this2.container, _extends({}, DEFAULT_OPTIONS, _this2.props.vimeoConfig.playerOptions, {
	          url: url,
	          loop: _this2.props.loop
	        }));
	        _this2.player.on('loaded', function () {
	          _this2.onReady();
	          var iframe = (0, _reactDom.findDOMNode)(_this2).querySelector('iframe');
	          iframe.style.width = '100%';
	          iframe.style.height = '100%';
	        });
	        _this2.player.on('play', function (_ref2) {
	          var duration = _ref2.duration;
	
	          _this2.duration = duration;
	          _this2.onPlay();
	        });
	        _this2.player.on('pause', _this2.props.onPause);
	        _this2.player.on('ended', _this2.props.onEnded);
	        _this2.player.on('error', _this2.props.onError);
	        _this2.player.on('timeupdate', function (_ref3) {
	          var percent = _ref3.percent;
	
	          _this2.fractionPlayed = percent;
	        });
	        _this2.player.on('progress', function (_ref4) {
	          var percent = _ref4.percent;
	
	          _this2.fractionLoaded = percent;
	        });
	      }, this.props.onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      if (!this.isReady) return;
	      this.player.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (!this.isReady) return;
	      this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!this.isReady) return;
	      this.player.unload();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'seekTo', this).call(this, fraction);
	      if (!this.isReady || !this.player.setCurrentTime) return;
	      this.player.setCurrentTime(this.duration * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.player.setVolume(fraction);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      return null;
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      return this.fractionPlayed || null;
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      return this.fractionLoaded || null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        height: '100%',
	        display: this.props.url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement('div', { style: style, ref: this.ref });
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Vimeo;
	}(_Base3['default']);
	
	Vimeo.displayName = 'Vimeo';
	exports['default'] = Vimeo;
	module.exports = exports['default'];

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(55);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _Base2 = __webpack_require__(45);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
	var SDK_GLOBAL = 'Wistia';
	var MATCH_URL = /^https?:\/\/(.+)?(wistia.com|wi.st)\/(medias|embed)\/(.*)$/;
	
	var Wistia = function (_Base) {
	  _inherits(Wistia, _Base);
	
	  function Wistia() {
	    _classCallCheck(this, Wistia);
	
	    return _possibleConstructorReturn(this, (Wistia.__proto__ || Object.getPrototypeOf(Wistia)).apply(this, arguments));
	  }
	
	  _createClass(Wistia, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onStart = _props.onStart,
	          onPause = _props.onPause,
	          onEnded = _props.onEnded;
	
	      this.loadingSDK = true;
	      this.getSDK().then(function () {
	        window._wq = window._wq || [];
	        window._wq.push({
	          id: _this2.getID(_this2.props.url),
	          onReady: function onReady(player) {
	            _this2.player = player;
	            _this2.player.bind('start', onStart);
	            _this2.player.bind('play', _this2.onPlay);
	            _this2.player.bind('pause', onPause);
	            _this2.player.bind('end', onEnded);
	            _this2.onReady();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'getSDK',
	    value: function getSDK() {
	      return new Promise(function (resolve, reject) {
	        if (window[SDK_GLOBAL]) {
	          resolve();
	        } else {
	          (0, _loadScript2['default'])(SDK_URL, function (err, script) {
	            if (err) reject(err);
	            resolve(script);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getID',
	    value: function getID(url) {
	      return url && url.match(MATCH_URL)[4];
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var id = this.getID(url);
	      if (this.isReady) {
	        this.player.replaceWith(id);
	        this.props.onReady();
	        this.onReady();
	      }
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      if (!this.isReady || !this.player) return;
	      this.player.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (!this.isReady || !this.player) return;
	      this.player && this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!this.isReady || !this.player) return;
	      this.player.pause();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(Wistia.prototype.__proto__ || Object.getPrototypeOf(Wistia.prototype), 'seekTo', this).call(this, fraction);
	      if (!this.isReady || !this.player) return;
	      this.player.time(this.getDuration() * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      if (!this.isReady || !this.player || !this.player.volume) return;
	      this.player.volume(fraction);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      if (!this.isReady || !this.player || !this.player.playbackRate) return;
	      this.player.playbackRate(rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady || !this.player || !this.player.duration) return;
	      return this.player.duration();
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady || !this.player || !this.player.percentWatched) return null;
	      return this.player.percentWatched();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var id = this.getID(this.props.url);
	      var className = 'wistia_embed wistia_async_' + id;
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: this.props.url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement('div', { className: className, style: style });
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Wistia;
	}(_Base3['default']);
	
	Wistia.displayName = 'Wistia';
	exports['default'] = Wistia;
	module.exports = exports['default'];

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(55);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _Base2 = __webpack_require__(45);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _utils = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://www.youtube.com/iframe_api';
	var SDK_GLOBAL = 'YT';
	var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
	var MATCH_URL = /^(?:https?:\/\/)?(?:www\.|m\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
	var BLANK_VIDEO_URL = 'https://www.youtube.com/watch?v=GlCmAC4MHek';
	var DEFAULT_PLAYER_VARS = {
	  autoplay: 0,
	  playsinline: 1,
	  showinfo: 0,
	  rel: 0,
	  iv_load_policy: 3
	};
	
	var YouTube = function (_Base) {
	  _inherits(YouTube, _Base);
	
	  function YouTube() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, YouTube);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.onStateChange = function (_ref2) {
	      var data = _ref2.data;
	      var _this$props = _this.props,
	          onPause = _this$props.onPause,
	          onBuffer = _this$props.onBuffer;
	      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
	          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
	          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
	          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
	          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
	          CUED = _window$SDK_GLOBAL$Pl.CUED;
	
	      if (data === PLAYING) _this.onPlay();
	      if (data === PAUSED) onPause();
	      if (data === BUFFERING) onBuffer();
	      if (data === ENDED) _this.onEnded();
	      if (data === CUED) _this.onReady();
	    }, _this.onEnded = function () {
	      var _this$props2 = _this.props,
	          loop = _this$props2.loop,
	          onEnded = _this$props2.onEnded;
	
	      if (loop) {
	        _this.seekTo(0);
	      }
	      onEnded();
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(YouTube, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          url = _props.url,
	          youtubeConfig = _props.youtubeConfig;
	
	      if (!url && youtubeConfig.preload) {
	        this.preloading = true;
	        this.load(BLANK_VIDEO_URL);
	      }
	      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'getSDK',
	    value: function getSDK() {
	      if (window[SDK_GLOBAL] && window[SDK_GLOBAL].loaded) {
	        return Promise.resolve(window[SDK_GLOBAL]);
	      }
	      return new Promise(function (resolve, reject) {
	        var previousOnReady = window[SDK_GLOBAL_READY];
	        window[SDK_GLOBAL_READY] = function () {
	          if (previousOnReady) previousOnReady();
	          resolve(window[SDK_GLOBAL]);
	        };
	        (0, _loadScript2['default'])(SDK_URL, function (err) {
	          if (err) reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          playsinline = _props2.playsinline,
	          controls = _props2.controls,
	          youtubeConfig = _props2.youtubeConfig,
	          _onError = _props2.onError;
	
	      var id = url && url.match(MATCH_URL)[1];
	      if (this.isReady) {
	        this.player.cueVideoById({
	          videoId: id,
	          startSeconds: (0, _utils.parseStartTime)(url)
	        });
	        return;
	      }
	      if (this.loadingSDK) {
	        this.loadOnReady = url;
	        return;
	      }
	      this.loadingSDK = true;
	      this.getSDK().then(function (YT) {
	        _this2.player = new YT.Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          videoId: id,
	          playerVars: _extends({}, DEFAULT_PLAYER_VARS, {
	            controls: controls ? 1 : 0,
	            start: (0, _utils.parseStartTime)(url),
	            origin: window.location.origin,
	            playsinline: playsinline
	          }, youtubeConfig.playerVars),
	          events: {
	            onReady: _this2.onReady,
	            onStateChange: _this2.onStateChange,
	            onError: function onError(event) {
	              return _onError(event.data);
	            }
	          }
	        });
	      }, _onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      if (!this.isReady || !this.player.playVideo) return;
	      this.player.playVideo();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (!this.isReady || !this.player.pauseVideo) return;
	      this.player.pauseVideo();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!this.isReady || !this.player.stopVideo) return;
	      if (!document.body.contains(this.player.getIframe())) return;
	      this.player.stopVideo();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'seekTo', this).call(this, fraction);
	      if (!this.isReady || !this.player.seekTo) return;
	      this.player.seekTo(this.getDuration() * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      if (!this.isReady || !this.player.setVolume) return;
	      this.player.setVolume(fraction * 100);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      if (!this.isReady || !this.player.setPlaybackRate) return;
	      this.player.setPlaybackRate(rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady || !this.player.getDuration) return null;
	      return this.player.getDuration();
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady || !this.getDuration()) return null;
	      return this.player.getCurrentTime() / this.getDuration();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      if (!this.isReady || !this.player.getVideoLoadedFraction) return null;
	      return this.player.getVideoLoadedFraction();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: this.props.url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('div', { ref: this.ref })
	      );
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return YouTube;
	}(_Base3['default']);
	
	YouTube.displayName = 'YouTube';
	exports['default'] = YouTube;
	module.exports = exports['default'];

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(321).enable();
	  window.Promise = __webpack_require__(320);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(404);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(6);


/***/ },
/* 404 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */
	
	"use strict";
	
	var EventConstants = __webpack_require__(335);
	var EventPluginUtils = __webpack_require__(65);
	var EventPropagators = __webpack_require__(42);
	var SyntheticUIEvent = __webpack_require__(44);
	var TouchEventUtils = __webpack_require__(406);
	var ViewportMetrics = __webpack_require__(103);
	
	var keyOf = __webpack_require__(251);
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;
	
	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    'topTouchCancel',
	    'topTouchEnd',
	    'topTouchStart',
	    'topTouchMove'
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}
	
	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;
	
	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};
	
	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}
	
	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}
	
	var touchEvents = [
	  'topTouchStart',
	  'topTouchCancel',
	  'topTouchEnd',
	  'topTouchMove',
	];
	
	var dependencies = [
	  'topMouseDown',
	  'topMouseMove',
	  'topMouseUp',
	].concat(touchEvents);
	
	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};
	
	var now = (function() {
	  if (Date.now) {
	    return Date.now;
	  } else {
	    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
	    return function () {
	      return +new Date;
	    }
	  }
	})();
	
	function createTapEventPlugin(shouldRejectClick) {
	  return {
	
	    tapMoveThreshold: tapMoveThreshold,
	
	    ignoreMouseThreshold: ignoreMouseThreshold,
	
	    eventTypes: eventTypes,
	
	    /**
	     * @param {string} topLevelType Record from `EventConstants`.
	     * @param {DOMEventTarget} targetInst The listening component root node.
	     * @param {object} nativeEvent Native browser event.
	     * @return {*} An accumulation of synthetic events.
	     * @see {EventPluginHub.extractEvents}
	     */
	    extractEvents: function(
	      topLevelType,
	      targetInst,
	      nativeEvent,
	      nativeEventTarget
	    ) {
	
	      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	        return null;
	      }
	
	      if (isTouch(topLevelType)) {
	        lastTouchEvent = now();
	      } else {
	        if (shouldRejectClick(lastTouchEvent, now())) {
	          return null;
	        }
	      }
	
	      var event = null;
	      var distance = getDistance(startCoords, nativeEvent);
	      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	        event = SyntheticUIEvent.getPooled(
	          eventTypes.touchTap,
	          targetInst,
	          nativeEvent,
	          nativeEventTarget
	        );
	      }
	      if (isStartish(topLevelType)) {
	        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	      } else if (isEndish(topLevelType)) {
	        startCoords.x = 0;
	        startCoords.y = 0;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	
	  };
	}
	
	module.exports = createTapEventPlugin;


/***/ },
/* 406 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;


/***/ },
/* 407 */
/***/ function(module, exports) {

	module.exports = function(lastTouchEvent, clickTimestamp) {
	  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
	    return true;
	  }
	};


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(2);
	var defaultClickRejectionStrategy = __webpack_require__(407);
	
	var alreadyInjected = false;
	
	module.exports = function injectTapEventPlugin (strategyOverrides) {
	  strategyOverrides = strategyOverrides || {}
	  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;
	
	  if (false) {
	    invariant(
	      !alreadyInjected,
	      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
	It is recommended to call injectTapEventPlugin() just before you call \
	ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
	itself, please contact the maintainer as it shouldn\'t be called in library code and \
	should be injected by the application.'
	    )
	  }
	
	  alreadyInjected = true;
	
	  __webpack_require__(41).injection.injectEventPluginsByName({
	    'TapEventPlugin':       __webpack_require__(405)(shouldRejectClick)
	  });
	};


/***/ },
/* 409 */
[436, 47],
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(409);
	var ReactElement = __webpack_require__(46);
	
	var emptyFunction = __webpack_require__(17);
	var traverseAllChildren = __webpack_require__(170);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47),
	    _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(112);
	var ReactElement = __webpack_require__(46);
	var ReactPropTypeLocationNames = __webpack_require__(413);
	var ReactNoopUpdateQueue = __webpack_require__(114);
	
	var emptyObject = __webpack_require__(53);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	var didWarnDeprecated = false;
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
	      didWarnDeprecated = true;
	    }
	
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(46);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(46),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(93);
	
	module.exports = factory(isValidElement);

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(112);
	var ReactNoopUpdateQueue = __webpack_require__(114);
	
	var emptyObject = __webpack_require__(53);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(419);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(33);
	var ReactTransitionChildMapping = __webpack_require__(416);
	
	var propTypesFactory = __webpack_require__(93);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var emptyFunction = __webpack_require__(17);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	
	var ReactTransitionGroup = function (_React$Component) {
	  _inherits(ReactTransitionGroup, _React$Component);
	
	  function ReactTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(_this.props.children)
	    }, _this.performAppear = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
	      } else {
	        _this._handleDoneAppearing(key);
	      }
	    }, _this._handleDoneAppearing = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performEnter = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
	      } else {
	        _this._handleDoneEntering(key);
	      }
	    }, _this._handleDoneEntering = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performLeave = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key);
	      }
	    }, _this._handleDoneLeaving = function (key) {
	      var component = _this.refs[key];
	
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.performEnter(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _assign({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactTransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  ReactTransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  };
	
	  ReactTransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  ReactTransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  };
	
	  ReactTransitionGroup.prototype.render = function render() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return ReactTransitionGroup;
	}(React.Component);
	
	ReactTransitionGroup.displayName = 'ReactTransitionGroup';
	ReactTransitionGroup.propTypes = {
	  component: PropTypes.any,
	  childFactory: PropTypes.func
	};
	ReactTransitionGroup.defaultProps = {
	  component: 'span',
	  childFactory: emptyFunction.thatReturnsArgument
	};
	
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 418 */
367,
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(167);
	var traverseAllChildren = __webpack_require__(170);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"."}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(113);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ },
/* 420 */
386,
/* 421 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactElement = __webpack_require__(46);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 423 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(429);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(427);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ },
/* 425 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ },
/* 426 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	};
	
	exports.default = isClassComponent;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(426);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && (("production") === 'production' || !Component.propTypes));
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _createHelper = __webpack_require__(171);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(424);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _class.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return _class;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(shouldUpdate, 'shouldUpdate');

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (!hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(425);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/certificate.ef2992a7.pdf";

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.4a59589e.png";

/***/ },
/* 433 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 434 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 435 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.c460d739.js